// Auto-generated from world-cities.db (admin1 + admin2 tables)
// DO NOT EDIT MANUALLY

export interface WorldRegion { code: string; suffix: string; name: string; }
export interface WorldDept { code: string; name: string; }

export const WORLD_REGIONS_BY_CC: Record<string, WorldRegion[]> = {
  "AD": [
    { code: "AD.02", suffix: "02", name: "Canillo" },
    { code: "AD.03", suffix: "03", name: "Encamp" },
    { code: "AD.04", suffix: "04", name: "La Massana" },
    { code: "AD.05", suffix: "05", name: "Ordino" },
    { code: "AD.06", suffix: "06", name: "Sant Julià de Loria" },
    { code: "AD.07", suffix: "07", name: "Andorra la Vella" },
    { code: "AD.08", suffix: "08", name: "Escaldes-Engordany" },
  ],
  "AE": [
    { code: "AE.01", suffix: "01", name: "Abu Dhabi" },
    { code: "AE.02", suffix: "02", name: "Ajman" },
    { code: "AE.03", suffix: "03", name: "Dubai" },
    { code: "AE.04", suffix: "04", name: "Fujairah" },
    { code: "AE.05", suffix: "05", name: "Raʼs al Khaymah" },
    { code: "AE.06", suffix: "06", name: "Sharjah" },
    { code: "AE.07", suffix: "07", name: "Umm al Qaywayn" },
  ],
  "AF": [
    { code: "AF.01", suffix: "01", name: "Badakhshan" },
    { code: "AF.02", suffix: "02", name: "Badghis" },
    { code: "AF.03", suffix: "03", name: "Baghlan" },
    { code: "AF.05", suffix: "05", name: "Bamyan" },
    { code: "AF.06", suffix: "06", name: "Farah" },
    { code: "AF.07", suffix: "07", name: "Faryab" },
    { code: "AF.08", suffix: "08", name: "Ghazni" },
    { code: "AF.09", suffix: "09", name: "Ghowr" },
    { code: "AF.10", suffix: "10", name: "Helmand" },
    { code: "AF.11", suffix: "11", name: "Herat" },
    { code: "AF.13", suffix: "13", name: "Kabul" },
    { code: "AF.14", suffix: "14", name: "Kapisa" },
    { code: "AF.17", suffix: "17", name: "Logar" },
    { code: "AF.18", suffix: "18", name: "Nangarhar" },
    { code: "AF.19", suffix: "19", name: "Nimroz" },
    { code: "AF.23", suffix: "23", name: "Kandahar" },
    { code: "AF.24", suffix: "24", name: "Kunduz" },
    { code: "AF.26", suffix: "26", name: "Takhar" },
    { code: "AF.27", suffix: "27", name: "Vardak" },
    { code: "AF.28", suffix: "28", name: "Zabul" },
    { code: "AF.29", suffix: "29", name: "Paktika" },
    { code: "AF.30", suffix: "30", name: "Balkh" },
    { code: "AF.31", suffix: "31", name: "Jowzjan" },
    { code: "AF.32", suffix: "32", name: "Samangan" },
    { code: "AF.33", suffix: "33", name: "Sar-e Pol" },
    { code: "AF.34", suffix: "34", name: "Kunar" },
    { code: "AF.35", suffix: "35", name: "Laghman" },
    { code: "AF.36", suffix: "36", name: "Paktia" },
    { code: "AF.37", suffix: "37", name: "Khowst" },
    { code: "AF.38", suffix: "38", name: "Nuristan" },
    { code: "AF.39", suffix: "39", name: "Oruzgan" },
    { code: "AF.40", suffix: "40", name: "Parwan" },
    { code: "AF.41", suffix: "41", name: "Daykundi" },
    { code: "AF.42", suffix: "42", name: "Panjshir" },
  ],
  "AG": [
    { code: "AG.01", suffix: "01", name: "Barbuda" },
    { code: "AG.03", suffix: "03", name: "Saint George" },
    { code: "AG.04", suffix: "04", name: "Saint John" },
    { code: "AG.05", suffix: "05", name: "Saint Mary" },
    { code: "AG.06", suffix: "06", name: "Saint Paul" },
    { code: "AG.07", suffix: "07", name: "Saint Peter" },
    { code: "AG.08", suffix: "08", name: "Saint Philip" },
    { code: "AG.09", suffix: "09", name: "Redonda" },
  ],
  "AI": [
    { code: "AI.11205389", suffix: "11205389", name: "Blowing Point" },
    { code: "AI.11205392", suffix: "11205392", name: "Sandy Ground" },
    { code: "AI.11205393", suffix: "11205393", name: "Sandy Hill" },
    { code: "AI.11205396", suffix: "11205396", name: "The Valley" },
    { code: "AI.11205433", suffix: "11205433", name: "East End" },
    { code: "AI.11205436", suffix: "11205436", name: "North Hill" },
    { code: "AI.11205437", suffix: "11205437", name: "West End" },
    { code: "AI.11205438", suffix: "11205438", name: "South Hill" },
    { code: "AI.11205439", suffix: "11205439", name: "The Quarter" },
    { code: "AI.11205440", suffix: "11205440", name: "North Side" },
    { code: "AI.11205441", suffix: "11205441", name: "Island Harbour" },
    { code: "AI.11205442", suffix: "11205442", name: "George Hill" },
    { code: "AI.11205443", suffix: "11205443", name: "Stoney Ground" },
    { code: "AI.11205444", suffix: "11205444", name: "The Farrington" },
  ],
  "AL": [
    { code: "AL.40", suffix: "40", name: "Berat" },
    { code: "AL.41", suffix: "41", name: "Dibër" },
    { code: "AL.42", suffix: "42", name: "Durrës" },
    { code: "AL.43", suffix: "43", name: "Elbasan" },
    { code: "AL.44", suffix: "44", name: "Fier" },
    { code: "AL.45", suffix: "45", name: "Gjirokastër" },
    { code: "AL.46", suffix: "46", name: "Korçë" },
    { code: "AL.47", suffix: "47", name: "Kukës" },
    { code: "AL.48", suffix: "48", name: "Lezhë" },
    { code: "AL.49", suffix: "49", name: "Shkodër" },
    { code: "AL.50", suffix: "50", name: "Tirana" },
    { code: "AL.51", suffix: "51", name: "Vlorë" },
  ],
  "AM": [
    { code: "AM.01", suffix: "01", name: "Aragatsotn" },
    { code: "AM.02", suffix: "02", name: "Ararat" },
    { code: "AM.03", suffix: "03", name: "Armavir" },
    { code: "AM.04", suffix: "04", name: "Gegharkunik" },
    { code: "AM.05", suffix: "05", name: "Kotayk" },
    { code: "AM.06", suffix: "06", name: "Lori" },
    { code: "AM.07", suffix: "07", name: "Shirak" },
    { code: "AM.08", suffix: "08", name: "Syunik" },
    { code: "AM.09", suffix: "09", name: "Tavush" },
    { code: "AM.10", suffix: "10", name: "Vayots Dzor" },
    { code: "AM.11", suffix: "11", name: "Yerevan" },
  ],
  "AO": [
    { code: "AO.01", suffix: "01", name: "Benguela" },
    { code: "AO.02", suffix: "02", name: "Bíe" },
    { code: "AO.03", suffix: "03", name: "Cabinda" },
    { code: "AO.04", suffix: "04", name: "Cuando Cobango" },
    { code: "AO.05", suffix: "05", name: "Cuanza Norte" },
    { code: "AO.06", suffix: "06", name: "Kwanza Sul" },
    { code: "AO.07", suffix: "07", name: "Cunene" },
    { code: "AO.08", suffix: "08", name: "Huambo" },
    { code: "AO.09", suffix: "09", name: "Huíla" },
    { code: "AO.12", suffix: "12", name: "Malanje" },
    { code: "AO.13", suffix: "13", name: "Namibe" },
    { code: "AO.14", suffix: "14", name: "Moxico" },
    { code: "AO.15", suffix: "15", name: "Uíge" },
    { code: "AO.16", suffix: "16", name: "Zaire" },
    { code: "AO.17", suffix: "17", name: "Luanda Norte" },
    { code: "AO.18", suffix: "18", name: "Lunda Sul" },
    { code: "AO.19", suffix: "19", name: "Bengo" },
    { code: "AO.20", suffix: "20", name: "Luanda" },
  ],
  "AR": [
    { code: "AR.01", suffix: "01", name: "Buenos Aires" },
    { code: "AR.02", suffix: "02", name: "Catamarca" },
    { code: "AR.03", suffix: "03", name: "Chaco" },
    { code: "AR.04", suffix: "04", name: "Chubut" },
    { code: "AR.05", suffix: "05", name: "Cordoba" },
    { code: "AR.06", suffix: "06", name: "Corrientes" },
    { code: "AR.07", suffix: "07", name: "Buenos Aires F.D." },
    { code: "AR.08", suffix: "08", name: "Entre Rios" },
    { code: "AR.09", suffix: "09", name: "Formosa" },
    { code: "AR.10", suffix: "10", name: "Jujuy" },
    { code: "AR.11", suffix: "11", name: "La Pampa" },
    { code: "AR.12", suffix: "12", name: "La Rioja" },
    { code: "AR.13", suffix: "13", name: "Mendoza" },
    { code: "AR.14", suffix: "14", name: "Misiones" },
    { code: "AR.15", suffix: "15", name: "Neuquen" },
    { code: "AR.16", suffix: "16", name: "Rio Negro" },
    { code: "AR.17", suffix: "17", name: "Salta" },
    { code: "AR.18", suffix: "18", name: "San Juan" },
    { code: "AR.19", suffix: "19", name: "San Luis" },
    { code: "AR.20", suffix: "20", name: "Santa Cruz" },
    { code: "AR.21", suffix: "21", name: "Santa Fe" },
    { code: "AR.22", suffix: "22", name: "Santiago del Estero" },
    { code: "AR.23", suffix: "23", name: "Tierra del Fuego" },
    { code: "AR.24", suffix: "24", name: "Tucuman" },
  ],
  "AS": [
    { code: "AS.010", suffix: "010", name: "Eastern District" },
    { code: "AS.020", suffix: "020", name: "Manu'a" },
    { code: "AS.030", suffix: "030", name: "Rose Island" },
    { code: "AS.040", suffix: "040", name: "Swains Island" },
    { code: "AS.050", suffix: "050", name: "Western District" },
  ],
  "AT": [
    { code: "AT.01", suffix: "01", name: "Burgenland" },
    { code: "AT.02", suffix: "02", name: "Carinthia" },
    { code: "AT.03", suffix: "03", name: "Lower Austria" },
    { code: "AT.04", suffix: "04", name: "Upper Austria" },
    { code: "AT.05", suffix: "05", name: "Salzburg" },
    { code: "AT.06", suffix: "06", name: "Styria" },
    { code: "AT.07", suffix: "07", name: "Tyrol" },
    { code: "AT.08", suffix: "08", name: "Vorarlberg" },
    { code: "AT.09", suffix: "09", name: "Vienna" },
  ],
  "AU": [
    { code: "AU.01", suffix: "01", name: "ACT" },
    { code: "AU.02", suffix: "02", name: "New South Wales" },
    { code: "AU.03", suffix: "03", name: "Northern Territory" },
    { code: "AU.04", suffix: "04", name: "Queensland" },
    { code: "AU.05", suffix: "05", name: "South Australia" },
    { code: "AU.06", suffix: "06", name: "Tasmania" },
    { code: "AU.07", suffix: "07", name: "Victoria" },
    { code: "AU.08", suffix: "08", name: "Western Australia" },
  ],
  "AX": [
    { code: "AX.211", suffix: "211", name: "Mariehamns stad" },
    { code: "AX.212", suffix: "212", name: "Ålands landsbygd" },
    { code: "AX.213", suffix: "213", name: "Ålands skärgård" },
  ],
  "AZ": [
    { code: "AZ.01", suffix: "01", name: "Abşeron" },
    { code: "AZ.02", suffix: "02", name: "Ağcabǝdi" },
    { code: "AZ.03", suffix: "03", name: "Ağdam" },
    { code: "AZ.04", suffix: "04", name: "Ağdaş" },
    { code: "AZ.05", suffix: "05", name: "Ağstafa" },
    { code: "AZ.06", suffix: "06", name: "Ağsu" },
    { code: "AZ.07", suffix: "07", name: "Shirvan" },
    { code: "AZ.08", suffix: "08", name: "Astara" },
    { code: "AZ.09", suffix: "09", name: "Baki" },
    { code: "AZ.10", suffix: "10", name: "Balakǝn" },
    { code: "AZ.11", suffix: "11", name: "Barda" },
    { code: "AZ.12", suffix: "12", name: "Beyləqan" },
    { code: "AZ.13", suffix: "13", name: "Bilǝsuvar" },
    { code: "AZ.14", suffix: "14", name: "Jabrayil" },
    { code: "AZ.15", suffix: "15", name: "Jalilabad" },
    { code: "AZ.16", suffix: "16", name: "Daşkǝsǝn" },
    { code: "AZ.17", suffix: "17", name: "Shabran" },
    { code: "AZ.18", suffix: "18", name: "Füzuli" },
    { code: "AZ.19", suffix: "19", name: "Gǝdǝbǝy" },
    { code: "AZ.20", suffix: "20", name: "Gǝncǝ" },
    { code: "AZ.21", suffix: "21", name: "Goranboy" },
    { code: "AZ.22", suffix: "22", name: "Göyçay" },
    { code: "AZ.23", suffix: "23", name: "Hacıqabul" },
    { code: "AZ.24", suffix: "24", name: "İmişli" },
    { code: "AZ.25", suffix: "25", name: "İsmayıllı" },
    { code: "AZ.26", suffix: "26", name: "Kalbajar" },
    { code: "AZ.27", suffix: "27", name: "Kürdǝmir" },
    { code: "AZ.28", suffix: "28", name: "Laçın" },
    { code: "AZ.29", suffix: "29", name: "Lənkəran" },
    { code: "AZ.30", suffix: "30", name: "Lankaran Sahari" },
    { code: "AZ.31", suffix: "31", name: "Lerik" },
    { code: "AZ.32", suffix: "32", name: "Masally" },
    { code: "AZ.33", suffix: "33", name: "Mingǝcevir" },
    { code: "AZ.34", suffix: "34", name: "Naftalan" },
    { code: "AZ.35", suffix: "35", name: "Nakhichevan" },
    { code: "AZ.36", suffix: "36", name: "Neftçala" },
    { code: "AZ.37", suffix: "37", name: "Oğuz" },
    { code: "AZ.38", suffix: "38", name: "Qǝbǝlǝ" },
    { code: "AZ.39", suffix: "39", name: "Qǝx" },
    { code: "AZ.40", suffix: "40", name: "Qazax" },
    { code: "AZ.41", suffix: "41", name: "Qobustan" },
    { code: "AZ.42", suffix: "42", name: "Quba" },
    { code: "AZ.43", suffix: "43", name: "Qubadlı" },
    { code: "AZ.44", suffix: "44", name: "Qusar" },
    { code: "AZ.45", suffix: "45", name: "Saatlı" },
    { code: "AZ.46", suffix: "46", name: "Sabirabad" },
    { code: "AZ.47", suffix: "47", name: "Shaki" },
    { code: "AZ.48", suffix: "48", name: "Shaki City" },
    { code: "AZ.49", suffix: "49", name: "Salyan" },
    { code: "AZ.50", suffix: "50", name: "Şamaxı" },
    { code: "AZ.51", suffix: "51", name: "Şǝmkir" },
    { code: "AZ.52", suffix: "52", name: "Samux" },
    { code: "AZ.53", suffix: "53", name: "Siyǝzǝn" },
    { code: "AZ.54", suffix: "54", name: "Sumqayit" },
    { code: "AZ.55", suffix: "55", name: "Shusha" },
    { code: "AZ.56", suffix: "56", name: "Shusha City" },
    { code: "AZ.57", suffix: "57", name: "Tǝrtǝr" },
    { code: "AZ.58", suffix: "58", name: "Tovuz" },
    { code: "AZ.59", suffix: "59", name: "Ucar" },
    { code: "AZ.60", suffix: "60", name: "Xaçmaz" },
    { code: "AZ.61", suffix: "61", name: "Xankǝndi" },
    { code: "AZ.62", suffix: "62", name: "Goygol Rayon" },
    { code: "AZ.63", suffix: "63", name: "Xızı" },
    { code: "AZ.64", suffix: "64", name: "Xocalı" },
    { code: "AZ.65", suffix: "65", name: "Khojavend" },
    { code: "AZ.66", suffix: "66", name: "Yardımlı" },
    { code: "AZ.67", suffix: "67", name: "Yevlax" },
    { code: "AZ.68", suffix: "68", name: "Yevlax City" },
    { code: "AZ.69", suffix: "69", name: "Zǝngilan" },
    { code: "AZ.70", suffix: "70", name: "Zaqatala" },
    { code: "AZ.71", suffix: "71", name: "Zərdab" },
  ],
  "BA": [
    { code: "BA.01", suffix: "01", name: "Federation of B&H" },
    { code: "BA.02", suffix: "02", name: "Srpska" },
    { code: "BA.BRC", suffix: "BRC", name: "Brčko" },
  ],
  "BB": [
    { code: "BB.01", suffix: "01", name: "Christ Church" },
    { code: "BB.02", suffix: "02", name: "Saint Andrew" },
    { code: "BB.03", suffix: "03", name: "Saint George" },
    { code: "BB.04", suffix: "04", name: "Saint James" },
    { code: "BB.05", suffix: "05", name: "Saint John" },
    { code: "BB.06", suffix: "06", name: "Saint Joseph" },
    { code: "BB.07", suffix: "07", name: "Saint Lucy" },
    { code: "BB.08", suffix: "08", name: "Saint Michael" },
    { code: "BB.09", suffix: "09", name: "Saint Peter" },
    { code: "BB.10", suffix: "10", name: "Saint Philip" },
    { code: "BB.11", suffix: "11", name: "Saint Thomas" },
  ],
  "BD": [
    { code: "BD.81", suffix: "81", name: "Dhaka" },
    { code: "BD.82", suffix: "82", name: "Khulna" },
    { code: "BD.83", suffix: "83", name: "Rajshahi Division" },
    { code: "BD.84", suffix: "84", name: "Chittagong" },
    { code: "BD.85", suffix: "85", name: "Barisāl" },
    { code: "BD.86", suffix: "86", name: "Sylhet" },
    { code: "BD.87", suffix: "87", name: "Rangpur Division" },
    { code: "BD.H", suffix: "H", name: "Mymensingh Division" },
  ],
  "BE": [
    { code: "BE.BRU", suffix: "BRU", name: "Brussels Capital" },
    { code: "BE.VLG", suffix: "VLG", name: "Flanders" },
    { code: "BE.WAL", suffix: "WAL", name: "Wallonia" },
  ],
  "BF": [
    { code: "BF.01", suffix: "01", name: "Boucle du Mouhoun" },
    { code: "BF.02", suffix: "02", name: "Cascades" },
    { code: "BF.03", suffix: "03", name: "Centre" },
    { code: "BF.04", suffix: "04", name: "Centre-Est" },
    { code: "BF.05", suffix: "05", name: "Centre-Nord" },
    { code: "BF.06", suffix: "06", name: "Centre-Ouest" },
    { code: "BF.07", suffix: "07", name: "Centre-Sud" },
    { code: "BF.08", suffix: "08", name: "Est" },
    { code: "BF.09", suffix: "09", name: "Hauts-Bassins" },
    { code: "BF.10", suffix: "10", name: "Nord" },
    { code: "BF.11", suffix: "11", name: "Plateau-Central" },
    { code: "BF.12", suffix: "12", name: "Sahel" },
    { code: "BF.13", suffix: "13", name: "Sud-Ouest" },
  ],
  "BG": [
    { code: "BG.38", suffix: "38", name: "Blagoevgrad" },
    { code: "BG.39", suffix: "39", name: "Burgas" },
    { code: "BG.40", suffix: "40", name: "Dobrich" },
    { code: "BG.41", suffix: "41", name: "Gabrovo" },
    { code: "BG.42", suffix: "42", name: "Sofia-Capital" },
    { code: "BG.43", suffix: "43", name: "Haskovo" },
    { code: "BG.44", suffix: "44", name: "Kardzhali" },
    { code: "BG.45", suffix: "45", name: "Kyustendil" },
    { code: "BG.46", suffix: "46", name: "Lovech" },
    { code: "BG.47", suffix: "47", name: "Montana" },
    { code: "BG.48", suffix: "48", name: "Pazardzhik" },
    { code: "BG.49", suffix: "49", name: "Pernik" },
    { code: "BG.50", suffix: "50", name: "Pleven" },
    { code: "BG.51", suffix: "51", name: "Plovdiv" },
    { code: "BG.52", suffix: "52", name: "Razgrad" },
    { code: "BG.53", suffix: "53", name: "Ruse" },
    { code: "BG.54", suffix: "54", name: "Shumen" },
    { code: "BG.55", suffix: "55", name: "Silistra" },
    { code: "BG.56", suffix: "56", name: "Sliven" },
    { code: "BG.57", suffix: "57", name: "Smolyan" },
    { code: "BG.58", suffix: "58", name: "Sofia" },
    { code: "BG.59", suffix: "59", name: "Stara Zagora" },
    { code: "BG.60", suffix: "60", name: "Targovishte" },
    { code: "BG.61", suffix: "61", name: "Varna" },
    { code: "BG.62", suffix: "62", name: "Veliko Tarnovo" },
    { code: "BG.63", suffix: "63", name: "Vidin" },
    { code: "BG.64", suffix: "64", name: "Vratsa" },
    { code: "BG.65", suffix: "65", name: "Yambol" },
  ],
  "BH": [
    { code: "BH.15", suffix: "15", name: "Muharraq" },
    { code: "BH.16", suffix: "16", name: "Manama" },
    { code: "BH.17", suffix: "17", name: "Southern Governorate" },
    { code: "BH.19", suffix: "19", name: "Northern" },
  ],
  "BI": [
    { code: "BI.09", suffix: "09", name: "Bubanza" },
    { code: "BI.10", suffix: "10", name: "Bururi" },
    { code: "BI.11", suffix: "11", name: "Cankuzo" },
    { code: "BI.12", suffix: "12", name: "Cibitoke" },
    { code: "BI.13", suffix: "13", name: "Gitega" },
    { code: "BI.14", suffix: "14", name: "Karuzi" },
    { code: "BI.15", suffix: "15", name: "Kayanza" },
    { code: "BI.16", suffix: "16", name: "Kirundo" },
    { code: "BI.17", suffix: "17", name: "Makamba" },
    { code: "BI.18", suffix: "18", name: "Muyinga" },
    { code: "BI.19", suffix: "19", name: "Ngozi" },
    { code: "BI.20", suffix: "20", name: "Rutana" },
    { code: "BI.21", suffix: "21", name: "Ruyigi" },
    { code: "BI.22", suffix: "22", name: "Muramvya" },
    { code: "BI.23", suffix: "23", name: "Mwaro" },
    { code: "BI.24", suffix: "24", name: "Bujumbura Mairie" },
    { code: "BI.25", suffix: "25", name: "Bujumbura Rural" },
    { code: "BI.26", suffix: "26", name: "Rumonge" },
  ],
  "BJ": [
    { code: "BJ.07", suffix: "07", name: "Alibori" },
    { code: "BJ.08", suffix: "08", name: "Atakora" },
    { code: "BJ.09", suffix: "09", name: "Atlantique" },
    { code: "BJ.10", suffix: "10", name: "Borgou" },
    { code: "BJ.11", suffix: "11", name: "Collines" },
    { code: "BJ.12", suffix: "12", name: "Kouffo" },
    { code: "BJ.13", suffix: "13", name: "Donga" },
    { code: "BJ.14", suffix: "14", name: "Littoral" },
    { code: "BJ.15", suffix: "15", name: "Mono" },
    { code: "BJ.16", suffix: "16", name: "Ouémé" },
    { code: "BJ.17", suffix: "17", name: "Plateau" },
    { code: "BJ.18", suffix: "18", name: "Zou" },
  ],
  "BM": [
    { code: "BM.01", suffix: "01", name: "Devonshire" },
    { code: "BM.02", suffix: "02", name: "Hamilton" },
    { code: "BM.03", suffix: "03", name: "Hamilton city" },
    { code: "BM.04", suffix: "04", name: "Paget" },
    { code: "BM.05", suffix: "05", name: "Pembroke" },
    { code: "BM.06", suffix: "06", name: "Saint George" },
    { code: "BM.07", suffix: "07", name: "Saint Georgeʼs" },
    { code: "BM.08", suffix: "08", name: "Sandys" },
    { code: "BM.09", suffix: "09", name: "Smithʼs" },
    { code: "BM.10", suffix: "10", name: "Southampton" },
    { code: "BM.11", suffix: "11", name: "Warwick" },
  ],
  "BN": [
    { code: "BN.01", suffix: "01", name: "Belait" },
    { code: "BN.02", suffix: "02", name: "Brunei-Muara District" },
    { code: "BN.03", suffix: "03", name: "Temburong" },
    { code: "BN.04", suffix: "04", name: "Tutong" },
  ],
  "BO": [
    { code: "BO.01", suffix: "01", name: "Chuquisaca" },
    { code: "BO.02", suffix: "02", name: "Cochabamba" },
    { code: "BO.03", suffix: "03", name: "El Beni" },
    { code: "BO.04", suffix: "04", name: "La Paz" },
    { code: "BO.05", suffix: "05", name: "Oruro" },
    { code: "BO.06", suffix: "06", name: "Pando" },
    { code: "BO.07", suffix: "07", name: "Potosí" },
    { code: "BO.08", suffix: "08", name: "Santa Cruz" },
    { code: "BO.09", suffix: "09", name: "Tarija" },
  ],
  "BQ": [
    { code: "BQ.BO", suffix: "BO", name: "Bonaire" },
    { code: "BQ.SB", suffix: "SB", name: "Saba" },
    { code: "BQ.SE", suffix: "SE", name: "Sint Eustatius" },
  ],
  "BR": [
    { code: "BR.01", suffix: "01", name: "Acre" },
    { code: "BR.02", suffix: "02", name: "Alagoas" },
    { code: "BR.03", suffix: "03", name: "Amapá" },
    { code: "BR.04", suffix: "04", name: "Amazonas" },
    { code: "BR.05", suffix: "05", name: "Bahia" },
    { code: "BR.06", suffix: "06", name: "Ceará" },
    { code: "BR.07", suffix: "07", name: "Federal District" },
    { code: "BR.08", suffix: "08", name: "Espírito Santo" },
    { code: "BR.11", suffix: "11", name: "Mato Grosso do Sul" },
    { code: "BR.13", suffix: "13", name: "Maranhão" },
    { code: "BR.14", suffix: "14", name: "Mato Grosso" },
    { code: "BR.15", suffix: "15", name: "Minas Gerais" },
    { code: "BR.16", suffix: "16", name: "Pará" },
    { code: "BR.17", suffix: "17", name: "Paraíba" },
    { code: "BR.18", suffix: "18", name: "Paraná" },
    { code: "BR.20", suffix: "20", name: "Piauí" },
    { code: "BR.21", suffix: "21", name: "Rio de Janeiro" },
    { code: "BR.22", suffix: "22", name: "Rio Grande do Norte" },
    { code: "BR.23", suffix: "23", name: "Rio Grande do Sul" },
    { code: "BR.24", suffix: "24", name: "Rondônia" },
    { code: "BR.25", suffix: "25", name: "Roraima" },
    { code: "BR.26", suffix: "26", name: "Santa Catarina" },
    { code: "BR.27", suffix: "27", name: "São Paulo" },
    { code: "BR.28", suffix: "28", name: "Sergipe" },
    { code: "BR.29", suffix: "29", name: "Goiás" },
    { code: "BR.30", suffix: "30", name: "Pernambuco" },
    { code: "BR.31", suffix: "31", name: "Tocantins" },
  ],
  "BS": [
    { code: "BS.05", suffix: "05", name: "Bimini" },
    { code: "BS.06", suffix: "06", name: "Cat Island" },
    { code: "BS.10", suffix: "10", name: "Exuma" },
    { code: "BS.13", suffix: "13", name: "Inagua" },
    { code: "BS.15", suffix: "15", name: "Long Island" },
    { code: "BS.16", suffix: "16", name: "Mayaguana" },
    { code: "BS.18", suffix: "18", name: "Ragged Island" },
    { code: "BS.22", suffix: "22", name: "Harbour Island" },
    { code: "BS.23", suffix: "23", name: "New Providence" },
    { code: "BS.24", suffix: "24", name: "Acklins" },
    { code: "BS.25", suffix: "25", name: "Freeport" },
    { code: "BS.32", suffix: "32", name: "Berry Islands" },
    { code: "BS.35", suffix: "35", name: "San Salvador" },
    { code: "BS.36", suffix: "36", name: "Black Point" },
    { code: "BS.37", suffix: "37", name: "Central Abaco" },
    { code: "BS.38", suffix: "38", name: "Central Andros" },
    { code: "BS.39", suffix: "39", name: "Central Eleuthera" },
    { code: "BS.40", suffix: "40", name: "Crooked Island and Long Cay" },
    { code: "BS.41", suffix: "41", name: "East Grand Bahama" },
    { code: "BS.42", suffix: "42", name: "Grand Cay" },
    { code: "BS.43", suffix: "43", name: "Hope Town" },
    { code: "BS.44", suffix: "44", name: "Mangrove Cay" },
    { code: "BS.45", suffix: "45", name: "Moore’s Island" },
    { code: "BS.46", suffix: "46", name: "North Abaco" },
    { code: "BS.47", suffix: "47", name: "North Andros" },
    { code: "BS.48", suffix: "48", name: "North Eleuthera" },
    { code: "BS.49", suffix: "49", name: "Rum Cay" },
    { code: "BS.50", suffix: "50", name: "South Abaco" },
    { code: "BS.51", suffix: "51", name: "South Andros" },
    { code: "BS.52", suffix: "52", name: "South Eleuthera" },
    { code: "BS.53", suffix: "53", name: "Spanish Wells" },
    { code: "BS.54", suffix: "54", name: "West Grand Bahama" },
  ],
  "BT": [
    { code: "BT.05", suffix: "05", name: "Bumthang" },
    { code: "BT.06", suffix: "06", name: "Chukha" },
    { code: "BT.07", suffix: "07", name: "Chirang" },
    { code: "BT.08", suffix: "08", name: "Dagana" },
    { code: "BT.09", suffix: "09", name: "Geylegphug" },
    { code: "BT.10", suffix: "10", name: "Haa" },
    { code: "BT.11", suffix: "11", name: "Lhuntse" },
    { code: "BT.12", suffix: "12", name: "Mongar" },
    { code: "BT.13", suffix: "13", name: "Paro" },
    { code: "BT.14", suffix: "14", name: "Pemagatshel" },
    { code: "BT.15", suffix: "15", name: "Punakha" },
    { code: "BT.16", suffix: "16", name: "Samchi" },
    { code: "BT.17", suffix: "17", name: "Samdrup Jongkhar" },
    { code: "BT.18", suffix: "18", name: "Shemgang" },
    { code: "BT.19", suffix: "19", name: "Tashigang" },
    { code: "BT.20", suffix: "20", name: "Thimphu" },
    { code: "BT.21", suffix: "21", name: "Tongsa" },
    { code: "BT.22", suffix: "22", name: "Wangdi Phodrang" },
    { code: "BT.23", suffix: "23", name: "Gasa" },
    { code: "BT.24", suffix: "24", name: "Trashi Yangste" },
  ],
  "BW": [
    { code: "BW.01", suffix: "01", name: "Central" },
    { code: "BW.03", suffix: "03", name: "Ghanzi" },
    { code: "BW.04", suffix: "04", name: "Kgalagadi" },
    { code: "BW.05", suffix: "05", name: "Kgatleng" },
    { code: "BW.06", suffix: "06", name: "Kweneng" },
    { code: "BW.08", suffix: "08", name: "North-East" },
    { code: "BW.09", suffix: "09", name: "South-East" },
    { code: "BW.10", suffix: "10", name: "Ngwaketsi" },
    { code: "BW.11", suffix: "11", name: "North-West" },
    { code: "BW.12", suffix: "12", name: "Chobe" },
    { code: "BW.13", suffix: "13", name: "City of Francistown" },
    { code: "BW.14", suffix: "14", name: "Gaborone" },
    { code: "BW.15", suffix: "15", name: "Jwaneng" },
    { code: "BW.16", suffix: "16", name: "Lobatse" },
    { code: "BW.17", suffix: "17", name: "Selibe Phikwe" },
    { code: "BW.18", suffix: "18", name: "Sowa Town" },
  ],
  "BY": [
    { code: "BY.01", suffix: "01", name: "Brest" },
    { code: "BY.02", suffix: "02", name: "Gomel Oblast" },
    { code: "BY.03", suffix: "03", name: "Grodnenskaya" },
    { code: "BY.04", suffix: "04", name: "Minsk City" },
    { code: "BY.05", suffix: "05", name: "Minsk" },
    { code: "BY.06", suffix: "06", name: "Mogilev" },
    { code: "BY.07", suffix: "07", name: "Vitebsk" },
  ],
  "BZ": [
    { code: "BZ.01", suffix: "01", name: "Belize" },
    { code: "BZ.02", suffix: "02", name: "Cayo" },
    { code: "BZ.03", suffix: "03", name: "Corozal" },
    { code: "BZ.04", suffix: "04", name: "Orange Walk" },
    { code: "BZ.05", suffix: "05", name: "Stann Creek" },
    { code: "BZ.06", suffix: "06", name: "Toledo" },
  ],
  "CA": [
    { code: "CA.01", suffix: "01", name: "Alberta" },
    { code: "CA.02", suffix: "02", name: "British Columbia" },
    { code: "CA.03", suffix: "03", name: "Manitoba" },
    { code: "CA.04", suffix: "04", name: "New Brunswick" },
    { code: "CA.05", suffix: "05", name: "Newfoundland and Labrador" },
    { code: "CA.07", suffix: "07", name: "Nova Scotia" },
    { code: "CA.08", suffix: "08", name: "Ontario" },
    { code: "CA.09", suffix: "09", name: "Prince Edward Island" },
    { code: "CA.10", suffix: "10", name: "Quebec" },
    { code: "CA.11", suffix: "11", name: "Saskatchewan" },
    { code: "CA.12", suffix: "12", name: "Yukon" },
    { code: "CA.13", suffix: "13", name: "Northwest Territories" },
    { code: "CA.14", suffix: "14", name: "Nunavut" },
  ],
  "CD": [
    { code: "CD.02", suffix: "02", name: "Équateur" },
    { code: "CD.04", suffix: "04", name: "Kasaï-Oriental" },
    { code: "CD.06", suffix: "06", name: "Kinshasa" },
    { code: "CD.08", suffix: "08", name: "Bas-Congo" },
    { code: "CD.10", suffix: "10", name: "Maniema" },
    { code: "CD.11", suffix: "11", name: "Nord Kivu" },
    { code: "CD.12", suffix: "12", name: "South Kivu" },
    { code: "CD.13", suffix: "13", name: "Bas-Uele" },
    { code: "CD.14", suffix: "14", name: "Haut-Katanga" },
    { code: "CD.15", suffix: "15", name: "Haut-Lomami" },
    { code: "CD.16", suffix: "16", name: "Haut-Uele" },
    { code: "CD.17", suffix: "17", name: "Ituri" },
    { code: "CD.18", suffix: "18", name: "Kasai" },
    { code: "CD.19", suffix: "19", name: "Kwango" },
    { code: "CD.20", suffix: "20", name: "Kwilu" },
    { code: "CD.21", suffix: "21", name: "Lomami" },
    { code: "CD.22", suffix: "22", name: "Lualaba" },
    { code: "CD.23", suffix: "23", name: "Kasai-Central" },
    { code: "CD.24", suffix: "24", name: "Mai-Ndombe" },
    { code: "CD.25", suffix: "25", name: "Mongala" },
    { code: "CD.26", suffix: "26", name: "Nord-Ubangi" },
    { code: "CD.27", suffix: "27", name: "Sankuru" },
    { code: "CD.28", suffix: "28", name: "Sud-Ubangi" },
    { code: "CD.29", suffix: "29", name: "Tanganyika" },
    { code: "CD.30", suffix: "30", name: "Tshopo" },
    { code: "CD.31", suffix: "31", name: "Tshuapa" },
  ],
  "CF": [
    { code: "CF.01", suffix: "01", name: "Bamingui-Bangoran" },
    { code: "CF.02", suffix: "02", name: "Basse-Kotto" },
    { code: "CF.03", suffix: "03", name: "Haute-Kotto" },
    { code: "CF.04", suffix: "04", name: "Mambéré-Kadéï" },
    { code: "CF.05", suffix: "05", name: "Haut-Mbomou" },
    { code: "CF.06", suffix: "06", name: "Kémo" },
    { code: "CF.07", suffix: "07", name: "Lobaye" },
    { code: "CF.08", suffix: "08", name: "Mbomou" },
    { code: "CF.09", suffix: "09", name: "Nana-Mambéré" },
    { code: "CF.11", suffix: "11", name: "Ouaka" },
    { code: "CF.12", suffix: "12", name: "Ouham" },
    { code: "CF.13", suffix: "13", name: "Ouham-Pendé" },
    { code: "CF.14", suffix: "14", name: "Vakaga" },
    { code: "CF.15", suffix: "15", name: "Nana-Grébizi" },
    { code: "CF.16", suffix: "16", name: "Sangha-Mbaéré" },
    { code: "CF.17", suffix: "17", name: "Ombella-M'Poko" },
    { code: "CF.18", suffix: "18", name: "Bangui" },
  ],
  "CG": [
    { code: "CG.01", suffix: "01", name: "Bouenza" },
    { code: "CG.04", suffix: "04", name: "Kouilou" },
    { code: "CG.05", suffix: "05", name: "Lékoumou" },
    { code: "CG.06", suffix: "06", name: "Likouala" },
    { code: "CG.07", suffix: "07", name: "Niari" },
    { code: "CG.08", suffix: "08", name: "Plateaux" },
    { code: "CG.10", suffix: "10", name: "Sangha" },
    { code: "CG.11", suffix: "11", name: "Pool" },
    { code: "CG.12", suffix: "12", name: "Brazzaville" },
    { code: "CG.13", suffix: "13", name: "Cuvette" },
    { code: "CG.14", suffix: "14", name: "Cuvette-Ouest" },
    { code: "CG.15", suffix: "15", name: "Pointe-Noire" },
  ],
  "CH": [
    { code: "CH.AG", suffix: "AG", name: "Aargau" },
    { code: "CH.AI", suffix: "AI", name: "Appenzell Innerrhoden" },
    { code: "CH.AR", suffix: "AR", name: "Appenzell Ausserrhoden" },
    { code: "CH.BE", suffix: "BE", name: "Bern" },
    { code: "CH.BL", suffix: "BL", name: "Basel-Landschaft" },
    { code: "CH.BS", suffix: "BS", name: "Basel-City" },
    { code: "CH.FR", suffix: "FR", name: "Fribourg" },
    { code: "CH.GE", suffix: "GE", name: "Geneva" },
    { code: "CH.GL", suffix: "GL", name: "Glarus" },
    { code: "CH.GR", suffix: "GR", name: "Grisons" },
    { code: "CH.JU", suffix: "JU", name: "Jura" },
    { code: "CH.LU", suffix: "LU", name: "Lucerne" },
    { code: "CH.NE", suffix: "NE", name: "Neuchâtel" },
    { code: "CH.NW", suffix: "NW", name: "Nidwalden" },
    { code: "CH.OW", suffix: "OW", name: "Obwalden" },
    { code: "CH.SG", suffix: "SG", name: "Saint Gallen" },
    { code: "CH.SH", suffix: "SH", name: "Schaffhausen" },
    { code: "CH.SO", suffix: "SO", name: "Solothurn" },
    { code: "CH.SZ", suffix: "SZ", name: "Schwyz" },
    { code: "CH.TG", suffix: "TG", name: "Thurgau" },
    { code: "CH.TI", suffix: "TI", name: "Ticino" },
    { code: "CH.UR", suffix: "UR", name: "Uri" },
    { code: "CH.VD", suffix: "VD", name: "Vaud" },
    { code: "CH.VS", suffix: "VS", name: "Valais" },
    { code: "CH.ZG", suffix: "ZG", name: "Zug" },
    { code: "CH.ZH", suffix: "ZH", name: "Zurich" },
  ],
  "CI": [
    { code: "CI.76", suffix: "76", name: "Bas-Sassandra" },
    { code: "CI.77", suffix: "77", name: "Denguélé" },
    { code: "CI.78", suffix: "78", name: "Montagnes" },
    { code: "CI.81", suffix: "81", name: "Lacs" },
    { code: "CI.82", suffix: "82", name: "Lagunes" },
    { code: "CI.87", suffix: "87", name: "Savanes" },
    { code: "CI.90", suffix: "90", name: "Vallée du Bandama" },
    { code: "CI.92", suffix: "92", name: "Zanzan" },
    { code: "CI.93", suffix: "93", name: "Abidjan" },
    { code: "CI.94", suffix: "94", name: "Comoé" },
    { code: "CI.95", suffix: "95", name: "Gôh-Djiboua" },
    { code: "CI.96", suffix: "96", name: "Sassandra-Marahoué" },
    { code: "CI.97", suffix: "97", name: "Woroba" },
    { code: "CI.98", suffix: "98", name: "Yamoussoukro" },
  ],
  "CK": [
    { code: "CK.11695124", suffix: "11695124", name: "Aitutaki" },
    { code: "CK.11695126", suffix: "11695126", name: "Atiu" },
    { code: "CK.11695127", suffix: "11695127", name: "Mangaia" },
    { code: "CK.11695384", suffix: "11695384", name: "Manihiki" },
    { code: "CK.11695385", suffix: "11695385", name: "Ma'uke" },
    { code: "CK.11695386", suffix: "11695386", name: "Mitiaro" },
    { code: "CK.11695387", suffix: "11695387", name: "Palmerston" },
    { code: "CK.11695388", suffix: "11695388", name: "Penrhyn" },
    { code: "CK.11695389", suffix: "11695389", name: "Pukapuka" },
    { code: "CK.11695390", suffix: "11695390", name: "Rakahanga" },
    { code: "CK.11695425", suffix: "11695425", name: "Rarotonga" },
  ],
  "CL": [
    { code: "CL.01", suffix: "01", name: "Valparaíso" },
    { code: "CL.02", suffix: "02", name: "Aysén" },
    { code: "CL.03", suffix: "03", name: "Antofagasta" },
    { code: "CL.04", suffix: "04", name: "Araucanía" },
    { code: "CL.05", suffix: "05", name: "Atacama" },
    { code: "CL.06", suffix: "06", name: "Biobío" },
    { code: "CL.07", suffix: "07", name: "Coquimbo Region" },
    { code: "CL.08", suffix: "08", name: "O'Higgins Region" },
    { code: "CL.10", suffix: "10", name: "Region of Magallanes" },
    { code: "CL.11", suffix: "11", name: "Maule Region" },
    { code: "CL.12", suffix: "12", name: "Santiago Metropolitan" },
    { code: "CL.14", suffix: "14", name: "Los Lagos Region" },
    { code: "CL.15", suffix: "15", name: "Tarapacá" },
    { code: "CL.16", suffix: "16", name: "Arica y Parinacota" },
    { code: "CL.17", suffix: "17", name: "Los Ríos Region" },
    { code: "CL.18", suffix: "18", name: "Ñuble" },
  ],
  "CM": [
    { code: "CM.04", suffix: "04", name: "East" },
    { code: "CM.05", suffix: "05", name: "Littoral" },
    { code: "CM.07", suffix: "07", name: "North-West" },
    { code: "CM.08", suffix: "08", name: "West" },
    { code: "CM.09", suffix: "09", name: "South-West" },
    { code: "CM.10", suffix: "10", name: "Adamaoua" },
    { code: "CM.11", suffix: "11", name: "Centre" },
    { code: "CM.12", suffix: "12", name: "Far North" },
    { code: "CM.13", suffix: "13", name: "North" },
    { code: "CM.14", suffix: "14", name: "South" },
  ],
  "CN": [
    { code: "CN.01", suffix: "01", name: "Anhui" },
    { code: "CN.02", suffix: "02", name: "Zhejiang" },
    { code: "CN.03", suffix: "03", name: "Jiangxi" },
    { code: "CN.04", suffix: "04", name: "Jiangsu" },
    { code: "CN.05", suffix: "05", name: "Jilin" },
    { code: "CN.06", suffix: "06", name: "Qinghai" },
    { code: "CN.07", suffix: "07", name: "Fujian" },
    { code: "CN.08", suffix: "08", name: "Heilongjiang" },
    { code: "CN.09", suffix: "09", name: "Henan" },
    { code: "CN.10", suffix: "10", name: "Hebei" },
    { code: "CN.11", suffix: "11", name: "Hunan" },
    { code: "CN.12", suffix: "12", name: "Hubei" },
    { code: "CN.13", suffix: "13", name: "Xinjiang" },
    { code: "CN.14", suffix: "14", name: "Tibet" },
    { code: "CN.15", suffix: "15", name: "Gansu" },
    { code: "CN.16", suffix: "16", name: "Guangxi" },
    { code: "CN.18", suffix: "18", name: "Guizhou" },
    { code: "CN.19", suffix: "19", name: "Liaoning" },
    { code: "CN.20", suffix: "20", name: "Inner Mongolia" },
    { code: "CN.21", suffix: "21", name: "Ningxia Hui Autonomous Region" },
    { code: "CN.22", suffix: "22", name: "Beijing" },
    { code: "CN.23", suffix: "23", name: "Shanghai" },
    { code: "CN.24", suffix: "24", name: "Shanxi" },
    { code: "CN.25", suffix: "25", name: "Shandong" },
    { code: "CN.26", suffix: "26", name: "Shaanxi" },
    { code: "CN.28", suffix: "28", name: "Tianjin" },
    { code: "CN.29", suffix: "29", name: "Yunnan" },
    { code: "CN.30", suffix: "30", name: "Guangdong" },
    { code: "CN.31", suffix: "31", name: "Hainan" },
    { code: "CN.32", suffix: "32", name: "Sichuan" },
    { code: "CN.33", suffix: "33", name: "Chongqing" },
  ],
  "CO": [
    { code: "CO.01", suffix: "01", name: "Amazonas" },
    { code: "CO.02", suffix: "02", name: "Antioquia" },
    { code: "CO.03", suffix: "03", name: "Arauca" },
    { code: "CO.04", suffix: "04", name: "Atlántico" },
    { code: "CO.08", suffix: "08", name: "Caquetá" },
    { code: "CO.09", suffix: "09", name: "Cauca" },
    { code: "CO.10", suffix: "10", name: "Cesar" },
    { code: "CO.11", suffix: "11", name: "Chocó" },
    { code: "CO.12", suffix: "12", name: "Córdoba" },
    { code: "CO.14", suffix: "14", name: "Guaviare" },
    { code: "CO.15", suffix: "15", name: "Guainía" },
    { code: "CO.16", suffix: "16", name: "Huila" },
    { code: "CO.17", suffix: "17", name: "La Guajira" },
    { code: "CO.19", suffix: "19", name: "Meta" },
    { code: "CO.20", suffix: "20", name: "Nariño" },
    { code: "CO.21", suffix: "21", name: "Norte de Santander" },
    { code: "CO.22", suffix: "22", name: "Putumayo" },
    { code: "CO.23", suffix: "23", name: "Quindío" },
    { code: "CO.24", suffix: "24", name: "Risaralda" },
    { code: "CO.25", suffix: "25", name: "San Andres y Providencia" },
    { code: "CO.26", suffix: "26", name: "Santander" },
    { code: "CO.27", suffix: "27", name: "Sucre" },
    { code: "CO.28", suffix: "28", name: "Tolima" },
    { code: "CO.29", suffix: "29", name: "Valle del Cauca" },
    { code: "CO.30", suffix: "30", name: "Vaupés" },
    { code: "CO.31", suffix: "31", name: "Vichada" },
    { code: "CO.32", suffix: "32", name: "Casanare" },
    { code: "CO.33", suffix: "33", name: "Cundinamarca" },
    { code: "CO.34", suffix: "34", name: "Bogota D.C." },
    { code: "CO.35", suffix: "35", name: "Bolívar" },
    { code: "CO.36", suffix: "36", name: "Boyacá" },
    { code: "CO.37", suffix: "37", name: "Caldas" },
    { code: "CO.38", suffix: "38", name: "Magdalena" },
  ],
  "CR": [
    { code: "CR.01", suffix: "01", name: "Alajuela" },
    { code: "CR.02", suffix: "02", name: "Cartago" },
    { code: "CR.03", suffix: "03", name: "Guanacaste" },
    { code: "CR.04", suffix: "04", name: "Heredia" },
    { code: "CR.06", suffix: "06", name: "Limón" },
    { code: "CR.07", suffix: "07", name: "Puntarenas" },
    { code: "CR.08", suffix: "08", name: "San José" },
  ],
  "CU": [
    { code: "CU.01", suffix: "01", name: "Pinar del Río" },
    { code: "CU.02", suffix: "02", name: "Havana" },
    { code: "CU.03", suffix: "03", name: "Matanzas" },
    { code: "CU.04", suffix: "04", name: "Isla de la Juventud" },
    { code: "CU.05", suffix: "05", name: "Camagüey" },
    { code: "CU.07", suffix: "07", name: "Ciego de Ávila" },
    { code: "CU.08", suffix: "08", name: "Cienfuegos" },
    { code: "CU.09", suffix: "09", name: "Granma" },
    { code: "CU.10", suffix: "10", name: "Guantánamo" },
    { code: "CU.12", suffix: "12", name: "Holguín" },
    { code: "CU.13", suffix: "13", name: "Las Tunas" },
    { code: "CU.14", suffix: "14", name: "Sancti Spíritus" },
    { code: "CU.15", suffix: "15", name: "Santiago de Cuba" },
    { code: "CU.16", suffix: "16", name: "Villa Clara" },
    { code: "CU.AR", suffix: "AR", name: "Artemisa" },
    { code: "CU.MA", suffix: "MA", name: "Mayabeque" },
  ],
  "CV": [
    { code: "CV.01", suffix: "01", name: "Boa Vista" },
    { code: "CV.02", suffix: "02", name: "Brava" },
    { code: "CV.04", suffix: "04", name: "Maio" },
    { code: "CV.05", suffix: "05", name: "Paul" },
    { code: "CV.07", suffix: "07", name: "Ribeira Grande" },
    { code: "CV.08", suffix: "08", name: "Sal" },
    { code: "CV.11", suffix: "11", name: "São Vicente" },
    { code: "CV.13", suffix: "13", name: "Mosteiros" },
    { code: "CV.14", suffix: "14", name: "Praia" },
    { code: "CV.15", suffix: "15", name: "Santa Catarina" },
    { code: "CV.16", suffix: "16", name: "Santa Cruz" },
    { code: "CV.17", suffix: "17", name: "São Domingos" },
    { code: "CV.18", suffix: "18", name: "São Filipe" },
    { code: "CV.19", suffix: "19", name: "São Miguel" },
    { code: "CV.20", suffix: "20", name: "Tarrafal" },
    { code: "CV.21", suffix: "21", name: "Porto Novo" },
    { code: "CV.22", suffix: "22", name: "Ribeira Brava" },
    { code: "CV.23", suffix: "23", name: "Ribeira Grande de Santiago" },
    { code: "CV.24", suffix: "24", name: "Santa Catarina do Fogo" },
    { code: "CV.25", suffix: "25", name: "São Lourenço dos Órgãos" },
    { code: "CV.26", suffix: "26", name: "São Salvador do Mundo" },
    { code: "CV.27", suffix: "27", name: "Tarrafal de São Nicolau" },
  ],
  "CY": [
    { code: "CY.01", suffix: "01", name: "Ammochostos" },
    { code: "CY.02", suffix: "02", name: "Keryneia" },
    { code: "CY.03", suffix: "03", name: "Larnaka" },
    { code: "CY.04", suffix: "04", name: "Nicosia" },
    { code: "CY.05", suffix: "05", name: "Limassol" },
    { code: "CY.06", suffix: "06", name: "Pafos" },
  ],
  "CZ": [
    { code: "CZ.52", suffix: "52", name: "Hlavní město Praha" },
    { code: "CZ.78", suffix: "78", name: "South Moravian" },
    { code: "CZ.79", suffix: "79", name: "Jihočeský kraj" },
    { code: "CZ.80", suffix: "80", name: "Vysočina" },
    { code: "CZ.81", suffix: "81", name: "Karlovarský kraj" },
    { code: "CZ.82", suffix: "82", name: "Královéhradecký kraj" },
    { code: "CZ.83", suffix: "83", name: "Liberecký kraj" },
    { code: "CZ.84", suffix: "84", name: "Olomoucký" },
    { code: "CZ.85", suffix: "85", name: "Moravskoslezský" },
    { code: "CZ.86", suffix: "86", name: "Pardubický" },
    { code: "CZ.87", suffix: "87", name: "Plzeňský kraj" },
    { code: "CZ.88", suffix: "88", name: "Central Bohemia" },
    { code: "CZ.89", suffix: "89", name: "Ústecký kraj" },
    { code: "CZ.90", suffix: "90", name: "Zlín" },
  ],
  "DE": [
    { code: "DE.01", suffix: "01", name: "Baden-Württemberg" },
    { code: "DE.02", suffix: "02", name: "Bavaria" },
    { code: "DE.03", suffix: "03", name: "Bremen" },
    { code: "DE.04", suffix: "04", name: "Hamburg" },
    { code: "DE.05", suffix: "05", name: "Hesse" },
    { code: "DE.06", suffix: "06", name: "Lower Saxony" },
    { code: "DE.07", suffix: "07", name: "North Rhine-Westphalia" },
    { code: "DE.08", suffix: "08", name: "Rheinland-Pfalz" },
    { code: "DE.09", suffix: "09", name: "Saarland" },
    { code: "DE.10", suffix: "10", name: "Schleswig-Holstein" },
    { code: "DE.11", suffix: "11", name: "Brandenburg" },
    { code: "DE.12", suffix: "12", name: "Mecklenburg-Vorpommern" },
    { code: "DE.13", suffix: "13", name: "Saxony" },
    { code: "DE.14", suffix: "14", name: "Saxony-Anhalt" },
    { code: "DE.15", suffix: "15", name: "Thuringia" },
    { code: "DE.16", suffix: "16", name: "Berlin" },
  ],
  "DJ": [
    { code: "DJ.01", suffix: "01", name: "Ali Sabieh" },
    { code: "DJ.04", suffix: "04", name: "Obock" },
    { code: "DJ.05", suffix: "05", name: "Tadjourah" },
    { code: "DJ.06", suffix: "06", name: "Dikhil" },
    { code: "DJ.07", suffix: "07", name: "Djibouti" },
    { code: "DJ.08", suffix: "08", name: "Arta" },
  ],
  "DK": [
    { code: "DK.17", suffix: "17", name: "Capital Region" },
    { code: "DK.18", suffix: "18", name: "Central Jutland" },
    { code: "DK.19", suffix: "19", name: "North Denmark" },
    { code: "DK.20", suffix: "20", name: "Zealand" },
    { code: "DK.21", suffix: "21", name: "South Denmark" },
  ],
  "DM": [
    { code: "DM.02", suffix: "02", name: "Saint Andrew" },
    { code: "DM.03", suffix: "03", name: "Saint David" },
    { code: "DM.04", suffix: "04", name: "Saint George" },
    { code: "DM.05", suffix: "05", name: "Saint John" },
    { code: "DM.06", suffix: "06", name: "Saint Joseph" },
    { code: "DM.07", suffix: "07", name: "Saint Luke" },
    { code: "DM.08", suffix: "08", name: "Saint Mark" },
    { code: "DM.09", suffix: "09", name: "Saint Patrick" },
    { code: "DM.10", suffix: "10", name: "Saint Paul" },
    { code: "DM.11", suffix: "11", name: "Saint Peter" },
  ],
  "DO": [
    { code: "DO.01", suffix: "01", name: "Azua" },
    { code: "DO.02", suffix: "02", name: "Baoruco" },
    { code: "DO.03", suffix: "03", name: "Barahona" },
    { code: "DO.04", suffix: "04", name: "Dajabón" },
    { code: "DO.06", suffix: "06", name: "Duarte" },
    { code: "DO.08", suffix: "08", name: "Espaillat" },
    { code: "DO.09", suffix: "09", name: "Independencia" },
    { code: "DO.10", suffix: "10", name: "La Altagracia" },
    { code: "DO.11", suffix: "11", name: "Elías Piña" },
    { code: "DO.12", suffix: "12", name: "La Romana" },
    { code: "DO.14", suffix: "14", name: "María Trinidad Sánchez" },
    { code: "DO.15", suffix: "15", name: "Monte Cristi" },
    { code: "DO.16", suffix: "16", name: "Pedernales" },
    { code: "DO.18", suffix: "18", name: "Puerto Plata" },
    { code: "DO.19", suffix: "19", name: "Hermanas Mirabal" },
    { code: "DO.20", suffix: "20", name: "Samaná" },
    { code: "DO.21", suffix: "21", name: "Sánchez Ramírez" },
    { code: "DO.23", suffix: "23", name: "San Juan" },
    { code: "DO.24", suffix: "24", name: "San Pedro de Macorís" },
    { code: "DO.25", suffix: "25", name: "Santiago" },
    { code: "DO.26", suffix: "26", name: "Santiago Rodríguez" },
    { code: "DO.27", suffix: "27", name: "Valverde" },
    { code: "DO.28", suffix: "28", name: "El Seíbo" },
    { code: "DO.29", suffix: "29", name: "Hato Mayor" },
    { code: "DO.30", suffix: "30", name: "La Vega" },
    { code: "DO.31", suffix: "31", name: "Monseñor Nouel" },
    { code: "DO.32", suffix: "32", name: "Monte Plata" },
    { code: "DO.33", suffix: "33", name: "San Cristóbal" },
    { code: "DO.34", suffix: "34", name: "Nacional" },
    { code: "DO.35", suffix: "35", name: "Peravia" },
    { code: "DO.36", suffix: "36", name: "San José de Ocoa" },
    { code: "DO.37", suffix: "37", name: "Santo Domingo" },
  ],
  "DZ": [
    { code: "DZ.01", suffix: "01", name: "Algiers" },
    { code: "DZ.03", suffix: "03", name: "Batna" },
    { code: "DZ.04", suffix: "04", name: "Constantine" },
    { code: "DZ.06", suffix: "06", name: "Medea" },
    { code: "DZ.07", suffix: "07", name: "Mostaganem" },
    { code: "DZ.09", suffix: "09", name: "Oran" },
    { code: "DZ.10", suffix: "10", name: "Saida" },
    { code: "DZ.12", suffix: "12", name: "Sétif" },
    { code: "DZ.13", suffix: "13", name: "Tiaret" },
    { code: "DZ.14", suffix: "14", name: "Tizi Ouzou" },
    { code: "DZ.15", suffix: "15", name: "Tlemcen" },
    { code: "DZ.18", suffix: "18", name: "Béjaïa" },
    { code: "DZ.19", suffix: "19", name: "Biskra" },
    { code: "DZ.20", suffix: "20", name: "Blida" },
    { code: "DZ.21", suffix: "21", name: "Bouira" },
    { code: "DZ.22", suffix: "22", name: "Djelfa" },
    { code: "DZ.23", suffix: "23", name: "Guelma" },
    { code: "DZ.24", suffix: "24", name: "Jijel" },
    { code: "DZ.25", suffix: "25", name: "Laghouat" },
    { code: "DZ.26", suffix: "26", name: "Mascara" },
    { code: "DZ.27", suffix: "27", name: "M'Sila" },
    { code: "DZ.29", suffix: "29", name: "Oum el Bouaghi" },
    { code: "DZ.30", suffix: "30", name: "Sidi Bel Abbès" },
    { code: "DZ.31", suffix: "31", name: "Skikda" },
    { code: "DZ.33", suffix: "33", name: "Tébessa" },
    { code: "DZ.34", suffix: "34", name: "Adrar" },
    { code: "DZ.35", suffix: "35", name: "Aïn Defla" },
    { code: "DZ.36", suffix: "36", name: "Aïn Témouchent" },
    { code: "DZ.37", suffix: "37", name: "Annaba" },
    { code: "DZ.38", suffix: "38", name: "Béchar" },
    { code: "DZ.39", suffix: "39", name: "Bordj Bou Arréridj" },
    { code: "DZ.40", suffix: "40", name: "Boumerdes" },
    { code: "DZ.41", suffix: "41", name: "Chlef" },
    { code: "DZ.42", suffix: "42", name: "El Bayadh" },
    { code: "DZ.43", suffix: "43", name: "El Oued" },
    { code: "DZ.44", suffix: "44", name: "El Tarf" },
    { code: "DZ.45", suffix: "45", name: "Ghardaia" },
    { code: "DZ.46", suffix: "46", name: "Illizi" },
    { code: "DZ.47", suffix: "47", name: "Khenchela" },
    { code: "DZ.48", suffix: "48", name: "Mila" },
    { code: "DZ.49", suffix: "49", name: "Naama" },
    { code: "DZ.50", suffix: "50", name: "Ouargla" },
    { code: "DZ.51", suffix: "51", name: "Relizane" },
    { code: "DZ.52", suffix: "52", name: "Souk Ahras" },
    { code: "DZ.53", suffix: "53", name: "Tamanrasset" },
    { code: "DZ.54", suffix: "54", name: "Tindouf" },
    { code: "DZ.55", suffix: "55", name: "Tipaza" },
    { code: "DZ.56", suffix: "56", name: "Tissemsilt" },
  ],
  "EC": [
    { code: "EC.01", suffix: "01", name: "Galápagos" },
    { code: "EC.02", suffix: "02", name: "Azuay" },
    { code: "EC.03", suffix: "03", name: "Bolívar" },
    { code: "EC.04", suffix: "04", name: "Cañar" },
    { code: "EC.05", suffix: "05", name: "Carchi" },
    { code: "EC.06", suffix: "06", name: "Chimborazo" },
    { code: "EC.07", suffix: "07", name: "Cotopaxi" },
    { code: "EC.08", suffix: "08", name: "El Oro" },
    { code: "EC.09", suffix: "09", name: "Esmeraldas" },
    { code: "EC.10", suffix: "10", name: "Guayas" },
    { code: "EC.11", suffix: "11", name: "Imbabura" },
    { code: "EC.12", suffix: "12", name: "Loja" },
    { code: "EC.13", suffix: "13", name: "Los Ríos" },
    { code: "EC.14", suffix: "14", name: "Manabí" },
    { code: "EC.15", suffix: "15", name: "Morona-Santiago" },
    { code: "EC.17", suffix: "17", name: "Pastaza" },
    { code: "EC.18", suffix: "18", name: "Pichincha" },
    { code: "EC.19", suffix: "19", name: "Tungurahua" },
    { code: "EC.20", suffix: "20", name: "Zamora-Chinchipe" },
    { code: "EC.22", suffix: "22", name: "Sucumbios" },
    { code: "EC.23", suffix: "23", name: "Napo" },
    { code: "EC.24", suffix: "24", name: "Orellana" },
    { code: "EC.25", suffix: "25", name: "Santa Elena" },
    { code: "EC.26", suffix: "26", name: "Santo Domingo de los Tsáchilas" },
  ],
  "EE": [
    { code: "EE.01", suffix: "01", name: "Harjumaa" },
    { code: "EE.02", suffix: "02", name: "Hiiumaa" },
    { code: "EE.03", suffix: "03", name: "Ida-Virumaa" },
    { code: "EE.04", suffix: "04", name: "Järvamaa" },
    { code: "EE.05", suffix: "05", name: "Jõgevamaa" },
    { code: "EE.07", suffix: "07", name: "Lääne" },
    { code: "EE.08", suffix: "08", name: "Lääne-Virumaa" },
    { code: "EE.11", suffix: "11", name: "Pärnumaa" },
    { code: "EE.12", suffix: "12", name: "Põlvamaa" },
    { code: "EE.13", suffix: "13", name: "Raplamaa" },
    { code: "EE.14", suffix: "14", name: "Saare" },
    { code: "EE.18", suffix: "18", name: "Tartu" },
    { code: "EE.19", suffix: "19", name: "Valgamaa" },
    { code: "EE.20", suffix: "20", name: "Viljandimaa" },
    { code: "EE.21", suffix: "21", name: "Võrumaa" },
  ],
  "EG": [
    { code: "EG.01", suffix: "01", name: "Dakahlia" },
    { code: "EG.02", suffix: "02", name: "Red Sea" },
    { code: "EG.03", suffix: "03", name: "Beheira" },
    { code: "EG.04", suffix: "04", name: "Faiyum" },
    { code: "EG.05", suffix: "05", name: "Gharbia" },
    { code: "EG.06", suffix: "06", name: "Alexandria" },
    { code: "EG.07", suffix: "07", name: "Ismailia" },
    { code: "EG.08", suffix: "08", name: "Giza" },
    { code: "EG.09", suffix: "09", name: "Monufia" },
    { code: "EG.10", suffix: "10", name: "Minya" },
    { code: "EG.11", suffix: "11", name: "Cairo" },
    { code: "EG.12", suffix: "12", name: "Qalyubia" },
    { code: "EG.13", suffix: "13", name: "New Valley" },
    { code: "EG.14", suffix: "14", name: "Sharqia" },
    { code: "EG.15", suffix: "15", name: "Suez" },
    { code: "EG.16", suffix: "16", name: "Aswan" },
    { code: "EG.17", suffix: "17", name: "Asyut" },
    { code: "EG.18", suffix: "18", name: "Beni Suweif" },
    { code: "EG.19", suffix: "19", name: "Port Said" },
    { code: "EG.20", suffix: "20", name: "Damietta" },
    { code: "EG.21", suffix: "21", name: "Kafr el-Sheikh" },
    { code: "EG.22", suffix: "22", name: "Matruh" },
    { code: "EG.23", suffix: "23", name: "Qena" },
    { code: "EG.24", suffix: "24", name: "Sohag" },
    { code: "EG.26", suffix: "26", name: "South Sinai" },
    { code: "EG.27", suffix: "27", name: "North Sinai" },
    { code: "EG.28", suffix: "28", name: "Luxor" },
  ],
  "ER": [
    { code: "ER.01", suffix: "01", name: "Anseba" },
    { code: "ER.02", suffix: "02", name: "Debub" },
    { code: "ER.03", suffix: "03", name: "Southern Red Sea" },
    { code: "ER.04", suffix: "04", name: "Gash-Barka" },
    { code: "ER.05", suffix: "05", name: "Maekel" },
    { code: "ER.06", suffix: "06", name: "Northern Red Sea" },
  ],
  "ES": [
    { code: "ES.07", suffix: "07", name: "Balearic Islands" },
    { code: "ES.27", suffix: "27", name: "La Rioja" },
    { code: "ES.29", suffix: "29", name: "Madrid" },
    { code: "ES.31", suffix: "31", name: "Murcia" },
    { code: "ES.32", suffix: "32", name: "Navarre" },
    { code: "ES.34", suffix: "34", name: "Asturias" },
    { code: "ES.39", suffix: "39", name: "Cantabria" },
    { code: "ES.51", suffix: "51", name: "Andalusia" },
    { code: "ES.52", suffix: "52", name: "Aragon" },
    { code: "ES.53", suffix: "53", name: "Canary Islands" },
    { code: "ES.54", suffix: "54", name: "Castille-La Mancha" },
    { code: "ES.55", suffix: "55", name: "Castille and León" },
    { code: "ES.56", suffix: "56", name: "Catalonia" },
    { code: "ES.57", suffix: "57", name: "Extremadura" },
    { code: "ES.58", suffix: "58", name: "Galicia" },
    { code: "ES.59", suffix: "59", name: "Basque Country" },
    { code: "ES.60", suffix: "60", name: "Valencia" },
    { code: "ES.CE", suffix: "CE", name: "Ceuta" },
    { code: "ES.ML", suffix: "ML", name: "Melilla" },
  ],
  "ET": [
    { code: "ET.44", suffix: "44", name: "Addis Ababa" },
    { code: "ET.45", suffix: "45", name: "Āfar" },
    { code: "ET.46", suffix: "46", name: "Amhara" },
    { code: "ET.47", suffix: "47", name: "Bīnshangul Gumuz" },
    { code: "ET.48", suffix: "48", name: "Dire Dawa" },
    { code: "ET.49", suffix: "49", name: "Gambela" },
    { code: "ET.50", suffix: "50", name: "Harari" },
    { code: "ET.51", suffix: "51", name: "Oromiya" },
    { code: "ET.52", suffix: "52", name: "Somali" },
    { code: "ET.53", suffix: "53", name: "Tigray" },
    { code: "ET.54", suffix: "54", name: "SNNPR" },
  ],
  "FI": [
    { code: "FI.01", suffix: "01", name: "Uusimaa" },
    { code: "FI.02", suffix: "02", name: "Southwest Finland" },
    { code: "FI.04", suffix: "04", name: "Satakunta" },
    { code: "FI.05", suffix: "05", name: "Kanta-Hame" },
    { code: "FI.06", suffix: "06", name: "Pirkanmaa" },
    { code: "FI.07", suffix: "07", name: "Päijät-Häme" },
    { code: "FI.08", suffix: "08", name: "Kymenlaakso" },
    { code: "FI.09", suffix: "09", name: "South Karelia" },
    { code: "FI.10", suffix: "10", name: "South Savo" },
    { code: "FI.11", suffix: "11", name: "Northern Savonia" },
    { code: "FI.12", suffix: "12", name: "North Karelia" },
    { code: "FI.13", suffix: "13", name: "Central Finland" },
    { code: "FI.14", suffix: "14", name: "Southern Ostrobothnia" },
    { code: "FI.15", suffix: "15", name: "Ostrobothnia" },
    { code: "FI.16", suffix: "16", name: "Central Ostrobothnia" },
    { code: "FI.17", suffix: "17", name: "Northern Ostrobothnia" },
    { code: "FI.18", suffix: "18", name: "Kainuu" },
    { code: "FI.19", suffix: "19", name: "Lapland" },
  ],
  "FJ": [
    { code: "FJ.01", suffix: "01", name: "Central" },
    { code: "FJ.02", suffix: "02", name: "Eastern" },
    { code: "FJ.03", suffix: "03", name: "Northern" },
    { code: "FJ.04", suffix: "04", name: "Rotuma" },
    { code: "FJ.05", suffix: "05", name: "Western" },
  ],
  "FM": [
    { code: "FM.01", suffix: "01", name: "Kosrae" },
    { code: "FM.02", suffix: "02", name: "Pohnpei" },
    { code: "FM.03", suffix: "03", name: "Chuuk" },
    { code: "FM.04", suffix: "04", name: "Yap" },
  ],
  "FO": [
    { code: "FO.NO", suffix: "NO", name: "Norðoyar" },
    { code: "FO.OS", suffix: "OS", name: "Eysturoy" },
    { code: "FO.SA", suffix: "SA", name: "Sandoy" },
    { code: "FO.ST", suffix: "ST", name: "Streymoy" },
    { code: "FO.SU", suffix: "SU", name: "Suðuroy" },
    { code: "FO.VG", suffix: "VG", name: "Vágar" },
  ],
  "FR": [
    { code: "FR.11", suffix: "11", name: "Île-de-France" },
    { code: "FR.24", suffix: "24", name: "Centre" },
    { code: "FR.27", suffix: "27", name: "Bourgogne-Franche-Comté" },
    { code: "FR.28", suffix: "28", name: "Normandy" },
    { code: "FR.32", suffix: "32", name: "Hauts-de-France" },
    { code: "FR.44", suffix: "44", name: "Grand Est" },
    { code: "FR.52", suffix: "52", name: "Pays de la Loire" },
    { code: "FR.53", suffix: "53", name: "Brittany" },
    { code: "FR.75", suffix: "75", name: "Nouvelle-Aquitaine" },
    { code: "FR.76", suffix: "76", name: "Occitanie" },
    { code: "FR.84", suffix: "84", name: "Auvergne-Rhône-Alpes" },
    { code: "FR.93", suffix: "93", name: "Provence-Alpes-Côte d'Azur" },
    { code: "FR.94", suffix: "94", name: "Corsica" },
  ],
  "GA": [
    { code: "GA.01", suffix: "01", name: "Estuaire" },
    { code: "GA.02", suffix: "02", name: "Haut-Ogooué" },
    { code: "GA.03", suffix: "03", name: "Moyen-Ogooué" },
    { code: "GA.04", suffix: "04", name: "Ngouni" },
    { code: "GA.05", suffix: "05", name: "Nyanga" },
    { code: "GA.06", suffix: "06", name: "Ogooué-Ivindo" },
    { code: "GA.07", suffix: "07", name: "Ogooué-Lolo" },
    { code: "GA.08", suffix: "08", name: "Ogooué-Maritime" },
    { code: "GA.09", suffix: "09", name: "Woleu-Ntem" },
  ],
  "GB": [
    { code: "GB.ENG", suffix: "ENG", name: "England" },
    { code: "GB.NIR", suffix: "NIR", name: "Northern Ireland" },
    { code: "GB.SCT", suffix: "SCT", name: "Scotland" },
    { code: "GB.WLS", suffix: "WLS", name: "Wales" },
  ],
  "GD": [
    { code: "GD.01", suffix: "01", name: "Saint Andrew" },
    { code: "GD.02", suffix: "02", name: "Saint David" },
    { code: "GD.03", suffix: "03", name: "Saint George" },
    { code: "GD.04", suffix: "04", name: "Saint John" },
    { code: "GD.05", suffix: "05", name: "Saint Mark" },
    { code: "GD.06", suffix: "06", name: "Saint Patrick" },
    { code: "GD.10", suffix: "10", name: "Carriacou and Petite Martinique" },
  ],
  "GE": [
    { code: "GE.02", suffix: "02", name: "Abkhazia" },
    { code: "GE.04", suffix: "04", name: "Ajaria" },
    { code: "GE.51", suffix: "51", name: "T'bilisi" },
    { code: "GE.65", suffix: "65", name: "Guria" },
    { code: "GE.66", suffix: "66", name: "Imereti" },
    { code: "GE.67", suffix: "67", name: "Kakheti" },
    { code: "GE.68", suffix: "68", name: "Kvemo Kartli" },
    { code: "GE.69", suffix: "69", name: "Mtskheta-Mtianeti" },
    { code: "GE.70", suffix: "70", name: "Racha-Lechkhumi and Kvemo Svaneti" },
    { code: "GE.71", suffix: "71", name: "Samegrelo and Zemo Svaneti" },
    { code: "GE.72", suffix: "72", name: "Samtskhe-Javakheti" },
    { code: "GE.73", suffix: "73", name: "Shida Kartli" },
  ],
  "GF": [
    { code: "GF.GF", suffix: "GF", name: "Guyane" },
  ],
  "GG": [
    { code: "GG.6417213", suffix: "6417213", name: "St Pierre du Bois" },
    { code: "GG.6417214", suffix: "6417214", name: "Torteval" },
    { code: "GG.6417215", suffix: "6417215", name: "Saint Saviour" },
    { code: "GG.6417223", suffix: "6417223", name: "Forest" },
    { code: "GG.6417224", suffix: "6417224", name: "St Martin" },
    { code: "GG.6417226", suffix: "6417226", name: "Saint Andrew" },
    { code: "GG.6417228", suffix: "6417228", name: "St Peter Port" },
    { code: "GG.6417229", suffix: "6417229", name: "Castel" },
    { code: "GG.6417230", suffix: "6417230", name: "Vale" },
    { code: "GG.6417233", suffix: "6417233", name: "St Sampson" },
    { code: "GG.8989934", suffix: "8989934", name: "Alderney" },
  ],
  "GH": [
    { code: "GH.01", suffix: "01", name: "Greater Accra" },
    { code: "GH.02", suffix: "02", name: "Ashanti" },
    { code: "GH.04", suffix: "04", name: "Central" },
    { code: "GH.05", suffix: "05", name: "Eastern" },
    { code: "GH.06", suffix: "06", name: "Northern" },
    { code: "GH.08", suffix: "08", name: "Volta" },
    { code: "GH.09", suffix: "09", name: "Western" },
    { code: "GH.10", suffix: "10", name: "Upper East" },
    { code: "GH.11", suffix: "11", name: "Upper West" },
    { code: "GH.12", suffix: "12", name: "Ahafo" },
    { code: "GH.13", suffix: "13", name: "Bono" },
    { code: "GH.14", suffix: "14", name: "Bono East" },
    { code: "GH.15", suffix: "15", name: "North East" },
    { code: "GH.16", suffix: "16", name: "Oti" },
    { code: "GH.17", suffix: "17", name: "Savannah" },
    { code: "GH.18", suffix: "18", name: "Western North" },
  ],
  "GL": [
    { code: "GL.04", suffix: "04", name: "Kujalleq" },
    { code: "GL.06", suffix: "06", name: "Qeqqata" },
    { code: "GL.07", suffix: "07", name: "Sermersooq" },
    { code: "GL.11839534", suffix: "11839534", name: "Qeqertalik" },
    { code: "GL.11839537", suffix: "11839537", name: "Avannaata" },
  ],
  "GM": [
    { code: "GM.01", suffix: "01", name: "Banjul" },
    { code: "GM.02", suffix: "02", name: "Lower River" },
    { code: "GM.03", suffix: "03", name: "Central River" },
    { code: "GM.04", suffix: "04", name: "Upper River" },
    { code: "GM.05", suffix: "05", name: "Western" },
    { code: "GM.07", suffix: "07", name: "North Bank" },
  ],
  "GN": [
    { code: "GN.04", suffix: "04", name: "Conakry" },
    { code: "GN.B", suffix: "B", name: "Boke" },
    { code: "GN.D", suffix: "D", name: "Kindia" },
    { code: "GN.F", suffix: "F", name: "Faranah" },
    { code: "GN.K", suffix: "K", name: "Kankan" },
    { code: "GN.L", suffix: "L", name: "Labe" },
    { code: "GN.M", suffix: "M", name: "Mamou" },
    { code: "GN.N", suffix: "N", name: "Nzerekore" },
  ],
  "GP": [
    { code: "GP.GP", suffix: "GP", name: "Guadeloupe" },
  ],
  "GQ": [
    { code: "GQ.03", suffix: "03", name: "Annobon" },
    { code: "GQ.04", suffix: "04", name: "Bioko Norte" },
    { code: "GQ.05", suffix: "05", name: "Bioko Sur" },
    { code: "GQ.06", suffix: "06", name: "Centro Sur" },
    { code: "GQ.07", suffix: "07", name: "Kié-Ntem" },
    { code: "GQ.08", suffix: "08", name: "Litoral" },
    { code: "GQ.09", suffix: "09", name: "Wele-Nzas" },
  ],
  "GR": [
    { code: "GR.736572", suffix: "736572", name: "Mount Athos" },
    { code: "GR.ESYE11", suffix: "ESYE11", name: "East Macedonia and Thrace" },
    { code: "GR.ESYE12", suffix: "ESYE12", name: "Central Macedonia" },
    { code: "GR.ESYE13", suffix: "ESYE13", name: "West Macedonia" },
    { code: "GR.ESYE14", suffix: "ESYE14", name: "Thessaly" },
    { code: "GR.ESYE21", suffix: "ESYE21", name: "Epirus" },
    { code: "GR.ESYE22", suffix: "ESYE22", name: "Ionian Islands" },
    { code: "GR.ESYE23", suffix: "ESYE23", name: "West Greece" },
    { code: "GR.ESYE24", suffix: "ESYE24", name: "Central Greece" },
    { code: "GR.ESYE25", suffix: "ESYE25", name: "Peloponnese" },
    { code: "GR.ESYE31", suffix: "ESYE31", name: "Attica" },
    { code: "GR.ESYE41", suffix: "ESYE41", name: "North Aegean" },
    { code: "GR.ESYE42", suffix: "ESYE42", name: "South Aegean" },
    { code: "GR.ESYE43", suffix: "ESYE43", name: "Crete" },
  ],
  "GT": [
    { code: "GT.01", suffix: "01", name: "Alta Verapaz" },
    { code: "GT.02", suffix: "02", name: "Baja Verapaz" },
    { code: "GT.03", suffix: "03", name: "Chimaltenango" },
    { code: "GT.04", suffix: "04", name: "Chiquimula" },
    { code: "GT.05", suffix: "05", name: "El Progreso" },
    { code: "GT.06", suffix: "06", name: "Escuintla" },
    { code: "GT.07", suffix: "07", name: "Guatemala" },
    { code: "GT.08", suffix: "08", name: "Huehuetenango" },
    { code: "GT.09", suffix: "09", name: "Izabal" },
    { code: "GT.10", suffix: "10", name: "Jalapa" },
    { code: "GT.11", suffix: "11", name: "Jutiapa" },
    { code: "GT.12", suffix: "12", name: "Petén" },
    { code: "GT.13", suffix: "13", name: "Quetzaltenango" },
    { code: "GT.14", suffix: "14", name: "Quiché" },
    { code: "GT.15", suffix: "15", name: "Retalhuleu" },
    { code: "GT.16", suffix: "16", name: "Sacatepéquez" },
    { code: "GT.17", suffix: "17", name: "San Marcos" },
    { code: "GT.18", suffix: "18", name: "Santa Rosa" },
    { code: "GT.19", suffix: "19", name: "Sololá" },
    { code: "GT.20", suffix: "20", name: "Suchitepeque" },
    { code: "GT.21", suffix: "21", name: "Totonicapán" },
    { code: "GT.22", suffix: "22", name: "Zacapa" },
  ],
  "GU": [
    { code: "GU.AH", suffix: "AH", name: "Agana Heights" },
    { code: "GU.AN", suffix: "AN", name: "Hagatna" },
    { code: "GU.AS", suffix: "AS", name: "Asan" },
    { code: "GU.AT", suffix: "AT", name: "Agat" },
    { code: "GU.BA", suffix: "BA", name: "Barrigada" },
    { code: "GU.CP", suffix: "CP", name: "Chalan Pago-Ordot" },
    { code: "GU.DD", suffix: "DD", name: "Dededo" },
    { code: "GU.IN", suffix: "IN", name: "Inarajan" },
    { code: "GU.MA", suffix: "MA", name: "Mangilao" },
    { code: "GU.ME", suffix: "ME", name: "Merizo" },
    { code: "GU.MT", suffix: "MT", name: "Mongmong-Toto-Maite" },
    { code: "GU.PI", suffix: "PI", name: "Piti" },
    { code: "GU.SJ", suffix: "SJ", name: "Sinajana" },
    { code: "GU.SR", suffix: "SR", name: "Santa Rita" },
    { code: "GU.TF", suffix: "TF", name: "Talofofo" },
    { code: "GU.TM", suffix: "TM", name: "Tamuning" },
    { code: "GU.UM", suffix: "UM", name: "Umatac" },
    { code: "GU.YG", suffix: "YG", name: "Yigo" },
    { code: "GU.YN", suffix: "YN", name: "Yona" },
  ],
  "GW": [
    { code: "GW.01", suffix: "01", name: "Bafatá" },
    { code: "GW.02", suffix: "02", name: "Quinara" },
    { code: "GW.04", suffix: "04", name: "Oio" },
    { code: "GW.05", suffix: "05", name: "Bolama" },
    { code: "GW.06", suffix: "06", name: "Cacheu" },
    { code: "GW.07", suffix: "07", name: "Tombali" },
    { code: "GW.10", suffix: "10", name: "Gabú" },
    { code: "GW.11", suffix: "11", name: "Bissau" },
    { code: "GW.12", suffix: "12", name: "Biombo" },
  ],
  "GY": [
    { code: "GY.10", suffix: "10", name: "Barima-Waini" },
    { code: "GY.11", suffix: "11", name: "Cuyuni-Mazaruni" },
    { code: "GY.12", suffix: "12", name: "Demerara-Mahaica" },
    { code: "GY.13", suffix: "13", name: "East Berbice-Corentyne" },
    { code: "GY.14", suffix: "14", name: "Essequibo Islands-West Demerara" },
    { code: "GY.15", suffix: "15", name: "Mahaica-Berbice" },
    { code: "GY.16", suffix: "16", name: "Pomeroon-Supenaam" },
    { code: "GY.17", suffix: "17", name: "Potaro-Siparuni" },
    { code: "GY.18", suffix: "18", name: "Upper Demerara-Berbice" },
    { code: "GY.19", suffix: "19", name: "Upper Takutu-Upper Essequibo" },
  ],
  "HK": [
    { code: "HK.HCW", suffix: "HCW", name: "Central and Western" },
    { code: "HK.HEA", suffix: "HEA", name: "Eastern" },
    { code: "HK.HSO", suffix: "HSO", name: "Southern" },
    { code: "HK.HWC", suffix: "HWC", name: "Wan Chai" },
    { code: "HK.KKC", suffix: "KKC", name: "Kowloon City" },
    { code: "HK.KKT", suffix: "KKT", name: "Kwun Tong" },
    { code: "HK.KSS", suffix: "KSS", name: "Sham Shui Po" },
    { code: "HK.KWT", suffix: "KWT", name: "Wong Tai Sin" },
    { code: "HK.KYT", suffix: "KYT", name: "Yau Tsim Mong" },
    { code: "HK.NIS", suffix: "NIS", name: "Islands" },
    { code: "HK.NKT", suffix: "NKT", name: "Kwai Tsing" },
    { code: "HK.NNO", suffix: "NNO", name: "North" },
    { code: "HK.NSK", suffix: "NSK", name: "Sai Kung" },
    { code: "HK.NST", suffix: "NST", name: "Sha Tin" },
    { code: "HK.NTM", suffix: "NTM", name: "Tuen Mun" },
    { code: "HK.NTP", suffix: "NTP", name: "Tai Po" },
    { code: "HK.NTW", suffix: "NTW", name: "Tsuen Wan" },
    { code: "HK.NYL", suffix: "NYL", name: "Yuen Long" },
  ],
  "HN": [
    { code: "HN.01", suffix: "01", name: "Atlántida" },
    { code: "HN.02", suffix: "02", name: "Choluteca" },
    { code: "HN.03", suffix: "03", name: "Colón" },
    { code: "HN.04", suffix: "04", name: "Comayagua" },
    { code: "HN.05", suffix: "05", name: "Copán" },
    { code: "HN.06", suffix: "06", name: "Cortés" },
    { code: "HN.07", suffix: "07", name: "El Paraíso" },
    { code: "HN.08", suffix: "08", name: "Francisco Morazán" },
    { code: "HN.09", suffix: "09", name: "Gracias a Dios" },
    { code: "HN.10", suffix: "10", name: "Intibucá" },
    { code: "HN.11", suffix: "11", name: "Bay Islands" },
    { code: "HN.12", suffix: "12", name: "La Paz" },
    { code: "HN.13", suffix: "13", name: "Lempira" },
    { code: "HN.14", suffix: "14", name: "Ocotepeque" },
    { code: "HN.15", suffix: "15", name: "Olancho" },
    { code: "HN.16", suffix: "16", name: "Santa Bárbara" },
    { code: "HN.17", suffix: "17", name: "Valle" },
    { code: "HN.18", suffix: "18", name: "Yoro" },
  ],
  "HR": [
    { code: "HR.01", suffix: "01", name: "Bjelovarsko-Bilogorska" },
    { code: "HR.02", suffix: "02", name: "Slavonski Brod-Posavina" },
    { code: "HR.03", suffix: "03", name: "Dubrovačko-Neretvanska" },
    { code: "HR.04", suffix: "04", name: "Istria" },
    { code: "HR.05", suffix: "05", name: "Karlovačka" },
    { code: "HR.06", suffix: "06", name: "Koprivničko-Križevačka" },
    { code: "HR.07", suffix: "07", name: "Krapinsko-Zagorska" },
    { code: "HR.08", suffix: "08", name: "Ličko-Senjska" },
    { code: "HR.09", suffix: "09", name: "Međimurska" },
    { code: "HR.10", suffix: "10", name: "Osječko-Baranjska" },
    { code: "HR.11", suffix: "11", name: "Požeško-Slavonska" },
    { code: "HR.12", suffix: "12", name: "Primorsko-Goranska" },
    { code: "HR.13", suffix: "13", name: "Šibensko-Kniniska" },
    { code: "HR.14", suffix: "14", name: "Sisačko-Moslavačka" },
    { code: "HR.15", suffix: "15", name: "Split-Dalmatia" },
    { code: "HR.16", suffix: "16", name: "Varaždinska" },
    { code: "HR.17", suffix: "17", name: "Virovitičk-Podravska" },
    { code: "HR.18", suffix: "18", name: "Vukovar-Sirmium" },
    { code: "HR.19", suffix: "19", name: "Zadarska" },
    { code: "HR.20", suffix: "20", name: "Zagrebačka" },
    { code: "HR.21", suffix: "21", name: "City of Zagreb" },
  ],
  "HT": [
    { code: "HT.03", suffix: "03", name: "Nord-Ouest" },
    { code: "HT.06", suffix: "06", name: "Artibonite" },
    { code: "HT.07", suffix: "07", name: "Centre" },
    { code: "HT.09", suffix: "09", name: "Nord" },
    { code: "HT.10", suffix: "10", name: "Nord-Est" },
    { code: "HT.11", suffix: "11", name: "Ouest" },
    { code: "HT.12", suffix: "12", name: "Sud" },
    { code: "HT.13", suffix: "13", name: "Sud-Est" },
    { code: "HT.14", suffix: "14", name: "GrandʼAnse" },
    { code: "HT.15", suffix: "15", name: "Nippes" },
  ],
  "HU": [
    { code: "HU.01", suffix: "01", name: "Bács-Kiskun" },
    { code: "HU.02", suffix: "02", name: "Baranya" },
    { code: "HU.03", suffix: "03", name: "Bekes" },
    { code: "HU.04", suffix: "04", name: "Borsod-Abaúj-Zemplén" },
    { code: "HU.05", suffix: "05", name: "Budapest" },
    { code: "HU.06", suffix: "06", name: "Csongrád" },
    { code: "HU.08", suffix: "08", name: "Fejér" },
    { code: "HU.09", suffix: "09", name: "Győr-Moson-Sopron" },
    { code: "HU.10", suffix: "10", name: "Hajdú-Bihar" },
    { code: "HU.11", suffix: "11", name: "Heves" },
    { code: "HU.12", suffix: "12", name: "Komárom-Esztergom" },
    { code: "HU.14", suffix: "14", name: "Nógrád" },
    { code: "HU.16", suffix: "16", name: "Pest" },
    { code: "HU.17", suffix: "17", name: "Somogy" },
    { code: "HU.18", suffix: "18", name: "Szabolcs-Szatmár-Bereg" },
    { code: "HU.20", suffix: "20", name: "Jász-Nagykun-Szolnok" },
    { code: "HU.21", suffix: "21", name: "Tolna" },
    { code: "HU.22", suffix: "22", name: "Vas" },
    { code: "HU.23", suffix: "23", name: "Veszprém" },
    { code: "HU.24", suffix: "24", name: "Zala" },
  ],
  "ID": [
    { code: "ID.01", suffix: "01", name: "Aceh" },
    { code: "ID.02", suffix: "02", name: "Bali" },
    { code: "ID.03", suffix: "03", name: "Bengkulu" },
    { code: "ID.04", suffix: "04", name: "Jakarta" },
    { code: "ID.05", suffix: "05", name: "Jambi" },
    { code: "ID.07", suffix: "07", name: "Central Java" },
    { code: "ID.08", suffix: "08", name: "East Java" },
    { code: "ID.10", suffix: "10", name: "Yogyakarta" },
    { code: "ID.11", suffix: "11", name: "West Kalimantan" },
    { code: "ID.12", suffix: "12", name: "South Kalimantan" },
    { code: "ID.13", suffix: "13", name: "Central Kalimantan" },
    { code: "ID.14", suffix: "14", name: "East Kalimantan" },
    { code: "ID.15", suffix: "15", name: "Lampung" },
    { code: "ID.17", suffix: "17", name: "West Nusa Tenggara" },
    { code: "ID.18", suffix: "18", name: "East Nusa Tenggara" },
    { code: "ID.21", suffix: "21", name: "Central Sulawesi" },
    { code: "ID.22", suffix: "22", name: "Southeast Sulawesi" },
    { code: "ID.24", suffix: "24", name: "West Sumatra" },
    { code: "ID.26", suffix: "26", name: "North Sumatra" },
    { code: "ID.28", suffix: "28", name: "Maluku" },
    { code: "ID.29", suffix: "29", name: "North Maluku" },
    { code: "ID.30", suffix: "30", name: "West Java" },
    { code: "ID.31", suffix: "31", name: "North Sulawesi" },
    { code: "ID.32", suffix: "32", name: "South Sumatra" },
    { code: "ID.33", suffix: "33", name: "Banten" },
    { code: "ID.34", suffix: "34", name: "Gorontalo" },
    { code: "ID.35", suffix: "35", name: "Bangka–Belitung Islands" },
    { code: "ID.36", suffix: "36", name: "Papua" },
    { code: "ID.37", suffix: "37", name: "Riau" },
    { code: "ID.38", suffix: "38", name: "South Sulawesi" },
    { code: "ID.39", suffix: "39", name: "West Papua" },
    { code: "ID.40", suffix: "40", name: "Riau Islands" },
    { code: "ID.41", suffix: "41", name: "West Sulawesi" },
    { code: "ID.42", suffix: "42", name: "North Kalimantan" },
  ],
  "IE": [
    { code: "IE.C", suffix: "C", name: "Connaught" },
    { code: "IE.L", suffix: "L", name: "Leinster" },
    { code: "IE.M", suffix: "M", name: "Munster" },
    { code: "IE.U", suffix: "U", name: "Ulster" },
  ],
  "IL": [
    { code: "IL.01", suffix: "01", name: "Southern District" },
    { code: "IL.02", suffix: "02", name: "Central District" },
    { code: "IL.03", suffix: "03", name: "Northern District" },
    { code: "IL.04", suffix: "04", name: "Haifa" },
    { code: "IL.05", suffix: "05", name: "Tel Aviv" },
    { code: "IL.06", suffix: "06", name: "Jerusalem" },
    { code: "IL.WE", suffix: "WE", name: "Judea and Samaria Area" },
  ],
  "IM": [
    { code: "IM.9782164", suffix: "9782164", name: "Andreas" },
    { code: "IM.9782165", suffix: "9782165", name: "Arbory" },
    { code: "IM.9782166", suffix: "9782166", name: "Ballaugh" },
    { code: "IM.9782167", suffix: "9782167", name: "Braddan" },
    { code: "IM.9782168", suffix: "9782168", name: "Bride" },
    { code: "IM.9782169", suffix: "9782169", name: "Castletown" },
    { code: "IM.9782170", suffix: "9782170", name: "Douglas" },
    { code: "IM.9782171", suffix: "9782171", name: "German" },
    { code: "IM.9782172", suffix: "9782172", name: "Jurby" },
    { code: "IM.9782173", suffix: "9782173", name: "Laxey" },
    { code: "IM.9782176", suffix: "9782176", name: "Lezayre" },
    { code: "IM.9782180", suffix: "9782180", name: "Lonan" },
    { code: "IM.9782182", suffix: "9782182", name: "Malew" },
    { code: "IM.9782183", suffix: "9782183", name: "Marown" },
    { code: "IM.9782184", suffix: "9782184", name: "Maughold" },
    { code: "IM.9782185", suffix: "9782185", name: "Michael" },
    { code: "IM.9782186", suffix: "9782186", name: "Onchan" },
    { code: "IM.9782187", suffix: "9782187", name: "Patrick" },
    { code: "IM.9782188", suffix: "9782188", name: "Peel" },
    { code: "IM.9782189", suffix: "9782189", name: "Port Erin" },
    { code: "IM.9782190", suffix: "9782190", name: "Port St Mary" },
    { code: "IM.9782191", suffix: "9782191", name: "Ramsey" },
    { code: "IM.9782192", suffix: "9782192", name: "Rushen" },
    { code: "IM.9782193", suffix: "9782193", name: "Santon" },
  ],
  "IN": [
    { code: "IN.01", suffix: "01", name: "Andaman and Nicobar" },
    { code: "IN.02", suffix: "02", name: "Andhra Pradesh" },
    { code: "IN.03", suffix: "03", name: "Assam" },
    { code: "IN.05", suffix: "05", name: "Chandigarh" },
    { code: "IN.06", suffix: "06", name: "Dadra and Nagar Haveli" },
    { code: "IN.07", suffix: "07", name: "Delhi" },
    { code: "IN.09", suffix: "09", name: "Gujarat" },
    { code: "IN.10", suffix: "10", name: "Haryana" },
    { code: "IN.11", suffix: "11", name: "Himachal Pradesh" },
    { code: "IN.12", suffix: "12", name: "Jammu and Kashmir" },
    { code: "IN.13", suffix: "13", name: "Kerala" },
    { code: "IN.14", suffix: "14", name: "Laccadives" },
    { code: "IN.16", suffix: "16", name: "Maharashtra" },
    { code: "IN.17", suffix: "17", name: "Manipur" },
    { code: "IN.18", suffix: "18", name: "Meghalaya" },
    { code: "IN.19", suffix: "19", name: "Karnataka" },
    { code: "IN.20", suffix: "20", name: "Nagaland" },
    { code: "IN.21", suffix: "21", name: "Odisha" },
    { code: "IN.22", suffix: "22", name: "Puducherry" },
    { code: "IN.23", suffix: "23", name: "Punjab" },
    { code: "IN.24", suffix: "24", name: "Rajasthan" },
    { code: "IN.25", suffix: "25", name: "Tamil Nadu" },
    { code: "IN.26", suffix: "26", name: "Tripura" },
    { code: "IN.28", suffix: "28", name: "West Bengal" },
    { code: "IN.29", suffix: "29", name: "Sikkim" },
    { code: "IN.30", suffix: "30", name: "Arunachal Pradesh" },
    { code: "IN.31", suffix: "31", name: "Mizoram" },
    { code: "IN.32", suffix: "32", name: "Daman and Diu" },
    { code: "IN.33", suffix: "33", name: "Goa" },
    { code: "IN.34", suffix: "34", name: "Bihar" },
    { code: "IN.35", suffix: "35", name: "Madhya Pradesh" },
    { code: "IN.36", suffix: "36", name: "Uttar Pradesh" },
    { code: "IN.37", suffix: "37", name: "Chhattisgarh" },
    { code: "IN.38", suffix: "38", name: "Jharkhand" },
    { code: "IN.39", suffix: "39", name: "Uttarakhand" },
    { code: "IN.40", suffix: "40", name: "Telangana" },
    { code: "IN.41", suffix: "41", name: "Ladakh" },
  ],
  "IQ": [
    { code: "IQ.01", suffix: "01", name: "Al Anbar" },
    { code: "IQ.02", suffix: "02", name: "Basra" },
    { code: "IQ.03", suffix: "03", name: "Al Muthanná" },
    { code: "IQ.04", suffix: "04", name: "Al Qādisīyah" },
    { code: "IQ.05", suffix: "05", name: "Sulaymaniyah" },
    { code: "IQ.06", suffix: "06", name: "Bābil" },
    { code: "IQ.07", suffix: "07", name: "Baghdad" },
    { code: "IQ.08", suffix: "08", name: "Dahūk" },
    { code: "IQ.09", suffix: "09", name: "Dhi Qar" },
    { code: "IQ.10", suffix: "10", name: "Diyālá" },
    { code: "IQ.11", suffix: "11", name: "Arbīl" },
    { code: "IQ.12", suffix: "12", name: "Karbalāʼ" },
    { code: "IQ.13", suffix: "13", name: "Kirkuk" },
    { code: "IQ.14", suffix: "14", name: "Maysan" },
    { code: "IQ.15", suffix: "15", name: "Nineveh" },
    { code: "IQ.16", suffix: "16", name: "Wāsiţ" },
    { code: "IQ.17", suffix: "17", name: "An Najaf" },
    { code: "IQ.18", suffix: "18", name: "Salah ad Din" },
  ],
  "IR": [
    { code: "IR.01", suffix: "01", name: "West Azerbaijan" },
    { code: "IR.03", suffix: "03", name: "Chaharmahal and Bakhtiari" },
    { code: "IR.04", suffix: "04", name: "Sistan and Baluchestan" },
    { code: "IR.05", suffix: "05", name: "Kohgiluyeh and Boyer-Ahmad" },
    { code: "IR.07", suffix: "07", name: "Fars" },
    { code: "IR.08", suffix: "08", name: "Gīlān" },
    { code: "IR.09", suffix: "09", name: "Hamadān" },
    { code: "IR.10", suffix: "10", name: "Ilam Province" },
    { code: "IR.11", suffix: "11", name: "Hormozgan" },
    { code: "IR.13", suffix: "13", name: "Kermānshāh" },
    { code: "IR.15", suffix: "15", name: "Khuzestan" },
    { code: "IR.16", suffix: "16", name: "Kordestān" },
    { code: "IR.22", suffix: "22", name: "Bushehr" },
    { code: "IR.23", suffix: "23", name: "Lorestān" },
    { code: "IR.25", suffix: "25", name: "Semnan" },
    { code: "IR.26", suffix: "26", name: "Tehrān" },
    { code: "IR.28", suffix: "28", name: "Isfahan" },
    { code: "IR.29", suffix: "29", name: "Kerman" },
    { code: "IR.32", suffix: "32", name: "Ardabīl" },
    { code: "IR.33", suffix: "33", name: "East Azerbaijan" },
    { code: "IR.34", suffix: "34", name: "Markazi" },
    { code: "IR.35", suffix: "35", name: "Māzandarān" },
    { code: "IR.36", suffix: "36", name: "Zanjan" },
    { code: "IR.37", suffix: "37", name: "Golestan" },
    { code: "IR.38", suffix: "38", name: "Qazvīn" },
    { code: "IR.39", suffix: "39", name: "Qom" },
    { code: "IR.40", suffix: "40", name: "Yazd" },
    { code: "IR.41", suffix: "41", name: "Khorāsān-e Jonūbī" },
    { code: "IR.42", suffix: "42", name: "Razavi Khorasan" },
    { code: "IR.43", suffix: "43", name: "North Khorasan" },
    { code: "IR.44", suffix: "44", name: "Alborz" },
  ],
  "IS": [
    { code: "IS.38", suffix: "38", name: "East" },
    { code: "IS.39", suffix: "39", name: "Capital Region" },
    { code: "IS.40", suffix: "40", name: "Northeast" },
    { code: "IS.41", suffix: "41", name: "Northwest" },
    { code: "IS.42", suffix: "42", name: "South" },
    { code: "IS.43", suffix: "43", name: "Southern Peninsula" },
    { code: "IS.44", suffix: "44", name: "Westfjords" },
    { code: "IS.45", suffix: "45", name: "West" },
  ],
  "IT": [
    { code: "IT.01", suffix: "01", name: "Abruzzo" },
    { code: "IT.02", suffix: "02", name: "Basilicata" },
    { code: "IT.03", suffix: "03", name: "Calabria" },
    { code: "IT.04", suffix: "04", name: "Campania" },
    { code: "IT.05", suffix: "05", name: "Emilia Romagna" },
    { code: "IT.06", suffix: "06", name: "Friuli Venezia Giulia" },
    { code: "IT.07", suffix: "07", name: "Lazio" },
    { code: "IT.08", suffix: "08", name: "Liguria" },
    { code: "IT.09", suffix: "09", name: "Lombardia" },
    { code: "IT.10", suffix: "10", name: "Marche" },
    { code: "IT.11", suffix: "11", name: "Molise" },
    { code: "IT.12", suffix: "12", name: "Piemonte" },
    { code: "IT.13", suffix: "13", name: "Puglia" },
    { code: "IT.14", suffix: "14", name: "Sardegna" },
    { code: "IT.15", suffix: "15", name: "Sicilia" },
    { code: "IT.16", suffix: "16", name: "Toscana" },
    { code: "IT.17", suffix: "17", name: "Trentino Alto Adige" },
    { code: "IT.18", suffix: "18", name: "Umbria" },
    { code: "IT.19", suffix: "19", name: "Valle D' Aosta" },
    { code: "IT.20", suffix: "20", name: "Veneto" },
  ],
  "JE": [
    { code: "JE.3237072", suffix: "3237072", name: "St Clement" },
    { code: "JE.3237073", suffix: "3237073", name: "St Saviour" },
    { code: "JE.3237200", suffix: "3237200", name: "St. Brelade" },
    { code: "JE.3237203", suffix: "3237203", name: "Grouville" },
    { code: "JE.3237212", suffix: "3237212", name: "St Mary" },
    { code: "JE.3237214", suffix: "3237214", name: "St Lawrence" },
    { code: "JE.3237221", suffix: "3237221", name: "St Peter" },
    { code: "JE.3237229", suffix: "3237229", name: "St Ouen" },
    { code: "JE.3237497", suffix: "3237497", name: "St John" },
    { code: "JE.3237530", suffix: "3237530", name: "Trinity" },
    { code: "JE.3237716", suffix: "3237716", name: "St Martîn" },
    { code: "JE.3237864", suffix: "3237864", name: "St Helier" },
  ],
  "JM": [
    { code: "JM.01", suffix: "01", name: "Clarendon" },
    { code: "JM.02", suffix: "02", name: "Hanover" },
    { code: "JM.04", suffix: "04", name: "Manchester" },
    { code: "JM.07", suffix: "07", name: "Portland" },
    { code: "JM.08", suffix: "08", name: "St. Andrew" },
    { code: "JM.09", suffix: "09", name: "St Ann" },
    { code: "JM.10", suffix: "10", name: "Saint Catherine" },
    { code: "JM.11", suffix: "11", name: "St. Elizabeth" },
    { code: "JM.12", suffix: "12", name: "St. James" },
    { code: "JM.13", suffix: "13", name: "St. Mary" },
    { code: "JM.14", suffix: "14", name: "St. Thomas" },
    { code: "JM.15", suffix: "15", name: "Trelawny" },
    { code: "JM.16", suffix: "16", name: "Westmoreland" },
    { code: "JM.17", suffix: "17", name: "Kingston" },
  ],
  "JO": [
    { code: "JO.02", suffix: "02", name: "Balqa" },
    { code: "JO.09", suffix: "09", name: "Karak" },
    { code: "JO.12", suffix: "12", name: "Tafielah" },
    { code: "JO.15", suffix: "15", name: "Mafraq" },
    { code: "JO.16", suffix: "16", name: "Amman" },
    { code: "JO.17", suffix: "17", name: "Zarqa" },
    { code: "JO.18", suffix: "18", name: "Irbid" },
    { code: "JO.19", suffix: "19", name: "Ma’an" },
    { code: "JO.20", suffix: "20", name: "Ajlun" },
    { code: "JO.21", suffix: "21", name: "Aqaba" },
    { code: "JO.22", suffix: "22", name: "Jerash" },
    { code: "JO.23", suffix: "23", name: "Madaba" },
  ],
  "JP": [
    { code: "JP.01", suffix: "01", name: "Aichi" },
    { code: "JP.02", suffix: "02", name: "Akita" },
    { code: "JP.03", suffix: "03", name: "Aomori" },
    { code: "JP.04", suffix: "04", name: "Chiba" },
    { code: "JP.05", suffix: "05", name: "Ehime" },
    { code: "JP.06", suffix: "06", name: "Fukui" },
    { code: "JP.07", suffix: "07", name: "Fukuoka" },
    { code: "JP.08", suffix: "08", name: "Fukushima" },
    { code: "JP.09", suffix: "09", name: "Gifu" },
    { code: "JP.10", suffix: "10", name: "Gunma" },
    { code: "JP.11", suffix: "11", name: "Hiroshima" },
    { code: "JP.12", suffix: "12", name: "Hokkaido" },
    { code: "JP.13", suffix: "13", name: "Hyōgo" },
    { code: "JP.14", suffix: "14", name: "Ibaraki" },
    { code: "JP.15", suffix: "15", name: "Ishikawa" },
    { code: "JP.16", suffix: "16", name: "Iwate" },
    { code: "JP.17", suffix: "17", name: "Kagawa" },
    { code: "JP.18", suffix: "18", name: "Kagoshima" },
    { code: "JP.19", suffix: "19", name: "Kanagawa" },
    { code: "JP.20", suffix: "20", name: "Kochi" },
    { code: "JP.21", suffix: "21", name: "Kumamoto" },
    { code: "JP.22", suffix: "22", name: "Kyoto" },
    { code: "JP.23", suffix: "23", name: "Mie" },
    { code: "JP.24", suffix: "24", name: "Miyagi" },
    { code: "JP.25", suffix: "25", name: "Miyazaki" },
    { code: "JP.26", suffix: "26", name: "Nagano" },
    { code: "JP.27", suffix: "27", name: "Nagasaki" },
    { code: "JP.28", suffix: "28", name: "Nara" },
    { code: "JP.29", suffix: "29", name: "Niigata" },
    { code: "JP.30", suffix: "30", name: "Oita" },
    { code: "JP.31", suffix: "31", name: "Okayama" },
    { code: "JP.32", suffix: "32", name: "Ōsaka" },
    { code: "JP.33", suffix: "33", name: "Saga" },
    { code: "JP.34", suffix: "34", name: "Saitama" },
    { code: "JP.35", suffix: "35", name: "Shiga" },
    { code: "JP.36", suffix: "36", name: "Shimane" },
    { code: "JP.37", suffix: "37", name: "Shizuoka" },
    { code: "JP.38", suffix: "38", name: "Tochigi" },
    { code: "JP.39", suffix: "39", name: "Tokushima" },
    { code: "JP.40", suffix: "40", name: "Tokyo" },
    { code: "JP.41", suffix: "41", name: "Tottori" },
    { code: "JP.42", suffix: "42", name: "Toyama" },
    { code: "JP.43", suffix: "43", name: "Wakayama" },
    { code: "JP.44", suffix: "44", name: "Yamagata" },
    { code: "JP.45", suffix: "45", name: "Yamaguchi" },
    { code: "JP.46", suffix: "46", name: "Yamanashi" },
    { code: "JP.47", suffix: "47", name: "Okinawa" },
  ],
  "KE": [
    { code: "KE.05", suffix: "05", name: "Nairobi Area" },
    { code: "KE.10", suffix: "10", name: "Baringo" },
    { code: "KE.11", suffix: "11", name: "Bomet" },
    { code: "KE.12", suffix: "12", name: "Bungoma" },
    { code: "KE.13", suffix: "13", name: "Busia" },
    { code: "KE.14", suffix: "14", name: "Elegeyo-Marakwet" },
    { code: "KE.15", suffix: "15", name: "Embu" },
    { code: "KE.16", suffix: "16", name: "Garissa" },
    { code: "KE.17", suffix: "17", name: "Homa Bay" },
    { code: "KE.18", suffix: "18", name: "Isiolo" },
    { code: "KE.19", suffix: "19", name: "Kajiado" },
    { code: "KE.20", suffix: "20", name: "Kakamega" },
    { code: "KE.21", suffix: "21", name: "Kericho" },
    { code: "KE.22", suffix: "22", name: "Kiambu" },
    { code: "KE.23", suffix: "23", name: "Kilifi" },
    { code: "KE.24", suffix: "24", name: "Kirinyaga" },
    { code: "KE.25", suffix: "25", name: "Kisii" },
    { code: "KE.26", suffix: "26", name: "Kisumu" },
    { code: "KE.27", suffix: "27", name: "Kitui" },
    { code: "KE.28", suffix: "28", name: "Kwale" },
    { code: "KE.29", suffix: "29", name: "Laikipia" },
    { code: "KE.30", suffix: "30", name: "Lamu" },
    { code: "KE.31", suffix: "31", name: "Machakos" },
    { code: "KE.32", suffix: "32", name: "Makueni" },
    { code: "KE.33", suffix: "33", name: "Mandera" },
    { code: "KE.34", suffix: "34", name: "Marsabit" },
    { code: "KE.35", suffix: "35", name: "Meru" },
    { code: "KE.36", suffix: "36", name: "Migori" },
    { code: "KE.37", suffix: "37", name: "Mombasa" },
    { code: "KE.38", suffix: "38", name: "Murang'A" },
    { code: "KE.39", suffix: "39", name: "Nakuru" },
    { code: "KE.40", suffix: "40", name: "Nandi" },
    { code: "KE.41", suffix: "41", name: "Narok" },
    { code: "KE.42", suffix: "42", name: "Nyamira" },
    { code: "KE.43", suffix: "43", name: "Nyandarua" },
    { code: "KE.44", suffix: "44", name: "Nyeri" },
    { code: "KE.45", suffix: "45", name: "Samburu" },
    { code: "KE.46", suffix: "46", name: "Siaya" },
    { code: "KE.47", suffix: "47", name: "Taita Taveta" },
    { code: "KE.48", suffix: "48", name: "Tana River" },
    { code: "KE.49", suffix: "49", name: "Tharaka - Nithi" },
    { code: "KE.50", suffix: "50", name: "Trans Nzoia" },
    { code: "KE.51", suffix: "51", name: "Turkana" },
    { code: "KE.52", suffix: "52", name: "Uasin Gishu" },
    { code: "KE.53", suffix: "53", name: "Vihiga" },
    { code: "KE.54", suffix: "54", name: "Wajir" },
    { code: "KE.55", suffix: "55", name: "West Pokot" },
  ],
  "KG": [
    { code: "KG.01", suffix: "01", name: "Bishkek" },
    { code: "KG.02", suffix: "02", name: "Chüy" },
    { code: "KG.03", suffix: "03", name: "Jalal-Abad" },
    { code: "KG.04", suffix: "04", name: "Naryn" },
    { code: "KG.06", suffix: "06", name: "Talas" },
    { code: "KG.07", suffix: "07", name: "Issyk-Kul" },
    { code: "KG.08", suffix: "08", name: "Osh" },
    { code: "KG.09", suffix: "09", name: "Batken" },
    { code: "KG.10", suffix: "10", name: "Osh City" },
  ],
  "KH": [
    { code: "KH.02", suffix: "02", name: "Kampong Cham" },
    { code: "KH.03", suffix: "03", name: "Kampong Chhnang" },
    { code: "KH.04", suffix: "04", name: "Kampong Speu" },
    { code: "KH.05", suffix: "05", name: "Kampong Thom" },
    { code: "KH.07", suffix: "07", name: "Kandal" },
    { code: "KH.08", suffix: "08", name: "Koh Kong" },
    { code: "KH.09", suffix: "09", name: "Kratie" },
    { code: "KH.10", suffix: "10", name: "Mondolkiri" },
    { code: "KH.12", suffix: "12", name: "Pursat" },
    { code: "KH.13", suffix: "13", name: "Preah Vihear" },
    { code: "KH.14", suffix: "14", name: "Prey Veng" },
    { code: "KH.17", suffix: "17", name: "Stung Treng" },
    { code: "KH.18", suffix: "18", name: "Svay Rieng" },
    { code: "KH.19", suffix: "19", name: "Takeo" },
    { code: "KH.21", suffix: "21", name: "Kampot" },
    { code: "KH.22", suffix: "22", name: "Phnom Penh" },
    { code: "KH.23", suffix: "23", name: "Ratanakiri" },
    { code: "KH.24", suffix: "24", name: "Siem Reap" },
    { code: "KH.25", suffix: "25", name: "Banteay Meanchey" },
    { code: "KH.26", suffix: "26", name: "Kep" },
    { code: "KH.27", suffix: "27", name: "Ŏtâr Méanchey" },
    { code: "KH.28", suffix: "28", name: "Preah Sihanouk" },
    { code: "KH.29", suffix: "29", name: "Battambang" },
    { code: "KH.30", suffix: "30", name: "Pailin" },
    { code: "KH.31", suffix: "31", name: "Tboung Khmum" },
  ],
  "KI": [
    { code: "KI.01", suffix: "01", name: "Gilbert Islands" },
    { code: "KI.02", suffix: "02", name: "Line Islands" },
    { code: "KI.03", suffix: "03", name: "Phoenix Islands" },
  ],
  "KM": [
    { code: "KM.01", suffix: "01", name: "Anjouan" },
    { code: "KM.02", suffix: "02", name: "Grande Comore" },
    { code: "KM.03", suffix: "03", name: "Mohéli" },
  ],
  "KN": [
    { code: "KN.01", suffix: "01", name: "Christ Church Nichola Town" },
    { code: "KN.02", suffix: "02", name: "Saint Anne Sandy Point" },
    { code: "KN.03", suffix: "03", name: "Saint George Basseterre" },
    { code: "KN.04", suffix: "04", name: "Saint George Gingerland" },
    { code: "KN.05", suffix: "05", name: "Saint James Windwa" },
    { code: "KN.06", suffix: "06", name: "Saint John Capesterre" },
    { code: "KN.07", suffix: "07", name: "Saint John Figtree" },
    { code: "KN.08", suffix: "08", name: "Saint Mary Cayon" },
    { code: "KN.09", suffix: "09", name: "Saint Paul Capesterre" },
    { code: "KN.10", suffix: "10", name: "Saint Paul Charlestown" },
    { code: "KN.11", suffix: "11", name: "Saint Peter Basseterre" },
    { code: "KN.12", suffix: "12", name: "Saint Thomas Lowland" },
    { code: "KN.13", suffix: "13", name: "Middle Island" },
    { code: "KN.15", suffix: "15", name: "Trinity Palmetto Point" },
  ],
  "KP": [
    { code: "KP.01", suffix: "01", name: "Chagang-do" },
    { code: "KP.03", suffix: "03", name: "Hamgyŏng-namdo" },
    { code: "KP.06", suffix: "06", name: "Hwanghae-namdo" },
    { code: "KP.07", suffix: "07", name: "Hwanghae-bukto" },
    { code: "KP.09", suffix: "09", name: "Kangwŏn-do" },
    { code: "KP.11", suffix: "11", name: "P'yŏngan-bukto" },
    { code: "KP.12", suffix: "12", name: "Pyongyang" },
    { code: "KP.13", suffix: "13", name: "Yanggang-do" },
    { code: "KP.15", suffix: "15", name: "South Pyongan" },
    { code: "KP.17", suffix: "17", name: "Hamgyŏng-bukto" },
    { code: "KP.18", suffix: "18", name: "Rason" },
  ],
  "KR": [
    { code: "KR.01", suffix: "01", name: "Jeju-do" },
    { code: "KR.03", suffix: "03", name: "Jeollabuk-do" },
    { code: "KR.05", suffix: "05", name: "North Chungcheong" },
    { code: "KR.06", suffix: "06", name: "Gangwon-do" },
    { code: "KR.10", suffix: "10", name: "Busan" },
    { code: "KR.11", suffix: "11", name: "Seoul" },
    { code: "KR.12", suffix: "12", name: "Incheon" },
    { code: "KR.13", suffix: "13", name: "Gyeonggi-do" },
    { code: "KR.14", suffix: "14", name: "Gyeongsangbuk-do" },
    { code: "KR.15", suffix: "15", name: "Daegu" },
    { code: "KR.16", suffix: "16", name: "Jeollanam-do" },
    { code: "KR.17", suffix: "17", name: "Chungcheongnam-do" },
    { code: "KR.18", suffix: "18", name: "Gwangju" },
    { code: "KR.19", suffix: "19", name: "Daejeon" },
    { code: "KR.20", suffix: "20", name: "Gyeongsangnam-do" },
    { code: "KR.21", suffix: "21", name: "Ulsan" },
    { code: "KR.22", suffix: "22", name: "Sejong-si" },
  ],
  "KW": [
    { code: "KW.02", suffix: "02", name: "Al Asimah" },
    { code: "KW.04", suffix: "04", name: "Al Aḩmadī" },
    { code: "KW.05", suffix: "05", name: "Al Jahrāʼ" },
    { code: "KW.07", suffix: "07", name: "Al Farwaniyah" },
    { code: "KW.08", suffix: "08", name: "Hawalli" },
    { code: "KW.09", suffix: "09", name: "Mubārak al Kabīr" },
  ],
  "KY": [
    { code: "KY.10346796", suffix: "10346796", name: "George Town" },
    { code: "KY.10375968", suffix: "10375968", name: "West Bay" },
    { code: "KY.10375969", suffix: "10375969", name: "Bodden Town" },
    { code: "KY.10375970", suffix: "10375970", name: "North Side" },
    { code: "KY.10375971", suffix: "10375971", name: "East End" },
    { code: "KY.10375972", suffix: "10375972", name: "Sister Island" },
  ],
  "KZ": [
    { code: "KZ.01", suffix: "01", name: "Almaty Oblysy" },
    { code: "KZ.02", suffix: "02", name: "Almaty" },
    { code: "KZ.03", suffix: "03", name: "Aqmola" },
    { code: "KZ.04", suffix: "04", name: "Aqtöbe" },
    { code: "KZ.05", suffix: "05", name: "Nur-Sultan" },
    { code: "KZ.06", suffix: "06", name: "Atyraū" },
    { code: "KZ.07", suffix: "07", name: "Batys Qazaqstan" },
    { code: "KZ.08", suffix: "08", name: "Baikonur" },
    { code: "KZ.09", suffix: "09", name: "Mangghystaū" },
    { code: "KZ.10", suffix: "10", name: "South Kazakhstan" },
    { code: "KZ.11", suffix: "11", name: "Pavlodar Region" },
    { code: "KZ.12", suffix: "12", name: "Karaganda" },
    { code: "KZ.13", suffix: "13", name: "Qostanay" },
    { code: "KZ.14", suffix: "14", name: "Qyzylorda" },
    { code: "KZ.15", suffix: "15", name: "East Kazakhstan" },
    { code: "KZ.1537272", suffix: "1537272", name: "Shymkent" },
    { code: "KZ.16", suffix: "16", name: "Soltüstik Qazaqstan" },
    { code: "KZ.17", suffix: "17", name: "Zhambyl" },
  ],
  "LA": [
    { code: "LA.01", suffix: "01", name: "Attapu" },
    { code: "LA.02", suffix: "02", name: "Champasak" },
    { code: "LA.03", suffix: "03", name: "Houaphan" },
    { code: "LA.07", suffix: "07", name: "Oudômxai" },
    { code: "LA.13", suffix: "13", name: "Xiagnabouli" },
    { code: "LA.14", suffix: "14", name: "Xiangkhoang" },
    { code: "LA.15", suffix: "15", name: "Khammouan" },
    { code: "LA.16", suffix: "16", name: "Loungnamtha" },
    { code: "LA.17", suffix: "17", name: "Louangphabang" },
    { code: "LA.18", suffix: "18", name: "Phôngsali" },
    { code: "LA.19", suffix: "19", name: "Salavan" },
    { code: "LA.20", suffix: "20", name: "Savannahkhét" },
    { code: "LA.22", suffix: "22", name: "Bokeo" },
    { code: "LA.23", suffix: "23", name: "Bolikhamsai" },
    { code: "LA.24", suffix: "24", name: "Vientiane Prefecture" },
    { code: "LA.26", suffix: "26", name: "Xékong" },
    { code: "LA.27", suffix: "27", name: "Vientiane" },
    { code: "LA.28", suffix: "28", name: "Xaisomboun" },
  ],
  "LB": [
    { code: "LB.04", suffix: "04", name: "Beyrouth" },
    { code: "LB.05", suffix: "05", name: "Mont-Liban" },
    { code: "LB.06", suffix: "06", name: "South Governorate" },
    { code: "LB.07", suffix: "07", name: "Nabatîyé" },
    { code: "LB.08", suffix: "08", name: "Béqaa" },
    { code: "LB.09", suffix: "09", name: "Liban-Nord" },
    { code: "LB.10", suffix: "10", name: "Aakkâr" },
    { code: "LB.11", suffix: "11", name: "Baalbek-Hermel" },
  ],
  "LC": [
    { code: "LC.01", suffix: "01", name: "Anse-la-Raye" },
    { code: "LC.03", suffix: "03", name: "Castries" },
    { code: "LC.04", suffix: "04", name: "Choiseul" },
    { code: "LC.05", suffix: "05", name: "Dennery" },
    { code: "LC.06", suffix: "06", name: "Gros-Islet" },
    { code: "LC.07", suffix: "07", name: "Laborie" },
    { code: "LC.08", suffix: "08", name: "Micoud" },
    { code: "LC.09", suffix: "09", name: "Soufrière" },
    { code: "LC.10", suffix: "10", name: "Vieux-Fort" },
    { code: "LC.12", suffix: "12", name: "Canaries" },
  ],
  "LI": [
    { code: "LI.01", suffix: "01", name: "Balzers" },
    { code: "LI.02", suffix: "02", name: "Eschen" },
    { code: "LI.03", suffix: "03", name: "Gamprin" },
    { code: "LI.04", suffix: "04", name: "Mauren" },
    { code: "LI.05", suffix: "05", name: "Planken" },
    { code: "LI.06", suffix: "06", name: "Ruggell" },
    { code: "LI.07", suffix: "07", name: "Schaan" },
    { code: "LI.08", suffix: "08", name: "Schellenberg" },
    { code: "LI.09", suffix: "09", name: "Triesen" },
    { code: "LI.10", suffix: "10", name: "Triesenberg" },
    { code: "LI.11", suffix: "11", name: "Vaduz" },
  ],
  "LK": [
    { code: "LK.29", suffix: "29", name: "Central" },
    { code: "LK.30", suffix: "30", name: "North Central" },
    { code: "LK.32", suffix: "32", name: "North Western" },
    { code: "LK.33", suffix: "33", name: "Sabaragamuwa" },
    { code: "LK.34", suffix: "34", name: "Southern" },
    { code: "LK.35", suffix: "35", name: "Uva" },
    { code: "LK.36", suffix: "36", name: "Western" },
    { code: "LK.37", suffix: "37", name: "Eastern Province" },
    { code: "LK.38", suffix: "38", name: "Northern Province" },
  ],
  "LR": [
    { code: "LR.01", suffix: "01", name: "Bong" },
    { code: "LR.09", suffix: "09", name: "Nimba" },
    { code: "LR.10", suffix: "10", name: "Sinoe" },
    { code: "LR.11", suffix: "11", name: "Grand Bassa" },
    { code: "LR.12", suffix: "12", name: "Grand Cape Mount" },
    { code: "LR.13", suffix: "13", name: "Maryland" },
    { code: "LR.14", suffix: "14", name: "Montserrado" },
    { code: "LR.15", suffix: "15", name: "Bomi" },
    { code: "LR.16", suffix: "16", name: "Grand Kru" },
    { code: "LR.17", suffix: "17", name: "Margibi" },
    { code: "LR.18", suffix: "18", name: "River Cess" },
    { code: "LR.19", suffix: "19", name: "Grand Gedeh" },
    { code: "LR.20", suffix: "20", name: "Lofa" },
    { code: "LR.21", suffix: "21", name: "Gbarpolu" },
    { code: "LR.22", suffix: "22", name: "River Gee" },
  ],
  "LS": [
    { code: "LS.10", suffix: "10", name: "Berea" },
    { code: "LS.11", suffix: "11", name: "Butha-Buthe" },
    { code: "LS.12", suffix: "12", name: "Leribe" },
    { code: "LS.13", suffix: "13", name: "Mafeteng" },
    { code: "LS.14", suffix: "14", name: "Maseru" },
    { code: "LS.15", suffix: "15", name: "Mohaleʼs Hoek" },
    { code: "LS.16", suffix: "16", name: "Mokhotlong" },
    { code: "LS.17", suffix: "17", name: "Qachaʼs Nek" },
    { code: "LS.18", suffix: "18", name: "Quthing" },
    { code: "LS.19", suffix: "19", name: "Thaba-Tseka" },
  ],
  "LT": [
    { code: "LT.56", suffix: "56", name: "Alytus" },
    { code: "LT.57", suffix: "57", name: "Kaunas" },
    { code: "LT.58", suffix: "58", name: "Klaipėda County" },
    { code: "LT.59", suffix: "59", name: "Marijampolė County" },
    { code: "LT.60", suffix: "60", name: "Panevėžys" },
    { code: "LT.61", suffix: "61", name: "Siauliai" },
    { code: "LT.62", suffix: "62", name: "Tauragė County" },
    { code: "LT.63", suffix: "63", name: "Telsiai" },
    { code: "LT.64", suffix: "64", name: "Utena" },
    { code: "LT.65", suffix: "65", name: "Vilnius" },
  ],
  "LU": [
    { code: "LU.CA", suffix: "CA", name: "Capellen" },
    { code: "LU.CL", suffix: "CL", name: "Clervaux" },
    { code: "LU.DI", suffix: "DI", name: "Diekirch" },
    { code: "LU.EC", suffix: "EC", name: "Echternach" },
    { code: "LU.ES", suffix: "ES", name: "Esch-sur-Alzette" },
    { code: "LU.GR", suffix: "GR", name: "Grevenmacher" },
    { code: "LU.LU", suffix: "LU", name: "Luxembourg" },
    { code: "LU.ME", suffix: "ME", name: "Mersch" },
    { code: "LU.RD", suffix: "RD", name: "Redange" },
    { code: "LU.RM", suffix: "RM", name: "Remich" },
    { code: "LU.VD", suffix: "VD", name: "Vianden" },
    { code: "LU.WI", suffix: "WI", name: "Wiltz" },
  ],
  "LV": [
    { code: "LV.01", suffix: "01", name: "Aizkraukles novads" },
    { code: "LV.02", suffix: "02", name: "Alūksnes Novads" },
    { code: "LV.03", suffix: "03", name: "Balvu Novads" },
    { code: "LV.04", suffix: "04", name: "Bauskas Rajons" },
    { code: "LV.05", suffix: "05", name: "Cēsu Rajons" },
    { code: "LV.06", suffix: "06", name: "Daugavpils" },
    { code: "LV.07", suffix: "07", name: "Daugavpils municipality" },
    { code: "LV.08", suffix: "08", name: "Dobeles novads" },
    { code: "LV.09", suffix: "09", name: "Gulbenes novads" },
    { code: "LV.10", suffix: "10", name: "Jēkabpils Municipality" },
    { code: "LV.11", suffix: "11", name: "Jelgava" },
    { code: "LV.12", suffix: "12", name: "Jelgavas novads" },
    { code: "LV.13", suffix: "13", name: "Jūrmala" },
    { code: "LV.14", suffix: "14", name: "Krāslavas novads" },
    { code: "LV.15", suffix: "15", name: "Kuldīgas novads" },
    { code: "LV.16", suffix: "16", name: "Liepāja" },
    { code: "LV.18", suffix: "18", name: "Limbažu novads" },
    { code: "LV.19", suffix: "19", name: "Ludzas novads" },
    { code: "LV.20", suffix: "20", name: "Madona Municipality" },
    { code: "LV.21", suffix: "21", name: "Ogre" },
    { code: "LV.22", suffix: "22", name: "Preiļu novads" },
    { code: "LV.23", suffix: "23", name: "Rēzekne" },
    { code: "LV.24", suffix: "24", name: "Rēzeknes Novads" },
    { code: "LV.25", suffix: "25", name: "Riga" },
    { code: "LV.27", suffix: "27", name: "Saldus Rajons" },
    { code: "LV.28", suffix: "28", name: "Talsi Municipality" },
    { code: "LV.29", suffix: "29", name: "Tukuma novads" },
    { code: "LV.30", suffix: "30", name: "Valka" },
    { code: "LV.31", suffix: "31", name: "Valmiera" },
    { code: "LV.32", suffix: "32", name: "Ventspils" },
    { code: "LV.33", suffix: "33", name: "Ventspils Rajons" },
    { code: "LV.34", suffix: "34", name: "Ādaži" },
    { code: "LV.35", suffix: "35", name: "Aglona" },
    { code: "LV.37", suffix: "37", name: "Aizpute" },
    { code: "LV.38", suffix: "38", name: "Aknīste" },
    { code: "LV.39", suffix: "39", name: "Aloja" },
    { code: "LV.40", suffix: "40", name: "Alsunga" },
    { code: "LV.42", suffix: "42", name: "Amatas" },
    { code: "LV.43", suffix: "43", name: "Apes" },
    { code: "LV.44", suffix: "44", name: "Auces" },
    { code: "LV.45", suffix: "45", name: "Babīte" },
    { code: "LV.46", suffix: "46", name: "Baldone" },
    { code: "LV.47", suffix: "47", name: "Baltinava" },
    { code: "LV.50", suffix: "50", name: "Beverīna" },
    { code: "LV.51", suffix: "51", name: "Brocēni" },
    { code: "LV.52", suffix: "52", name: "Burtnieki" },
    { code: "LV.53", suffix: "53", name: "Carnikava" },
    { code: "LV.55", suffix: "55", name: "Cesvaine" },
    { code: "LV.56", suffix: "56", name: "Cibla" },
    { code: "LV.57", suffix: "57", name: "Dagda" },
    { code: "LV.60", suffix: "60", name: "Dundaga" },
    { code: "LV.61", suffix: "61", name: "Durbe" },
    { code: "LV.62", suffix: "62", name: "Engure" },
    { code: "LV.63", suffix: "63", name: "Ērgļi" },
    { code: "LV.64", suffix: "64", name: "Garkalne" },
    { code: "LV.65", suffix: "65", name: "Grobiņa" },
    { code: "LV.67", suffix: "67", name: "Lecava" },
    { code: "LV.68", suffix: "68", name: "Ikšķile" },
    { code: "LV.69", suffix: "69", name: "Ilūkste" },
    { code: "LV.70", suffix: "70", name: "Inčukalns" },
    { code: "LV.71", suffix: "71", name: "Jaunjelgava" },
    { code: "LV.72", suffix: "72", name: "Jaunpiebalga" },
    { code: "LV.73", suffix: "73", name: "Jaunpils" },
    { code: "LV.74", suffix: "74", name: "Jēkabpils" },
    { code: "LV.77", suffix: "77", name: "Kandava" },
    { code: "LV.78", suffix: "78", name: "Karsava" },
    { code: "LV.79", suffix: "79", name: "Ķegums" },
    { code: "LV.80", suffix: "80", name: "Ķekava" },
    { code: "LV.81", suffix: "81", name: "Kocēni" },
    { code: "LV.82", suffix: "82", name: "Koknese" },
    { code: "LV.84", suffix: "84", name: "Krimulda" },
    { code: "LV.85", suffix: "85", name: "Krustpils" },
    { code: "LV.87", suffix: "87", name: "Lielvārde" },
    { code: "LV.88", suffix: "88", name: "Līgatne" },
    { code: "LV.90", suffix: "90", name: "Līvāni" },
    { code: "LV.91", suffix: "91", name: "Lubāna" },
    { code: "LV.94", suffix: "94", name: "Mālpils" },
    { code: "LV.95", suffix: "95", name: "Mārupe" },
    { code: "LV.96", suffix: "96", name: "Mazsalaca" },
    { code: "LV.97", suffix: "97", name: "Naukšēni" },
    { code: "LV.98", suffix: "98", name: "Nereta" },
    { code: "LV.99", suffix: "99", name: "Nīca" },
    { code: "LV.A2", suffix: "A2", name: "Olaine" },
    { code: "LV.A3", suffix: "A3", name: "Ozolnieku" },
    { code: "LV.A4", suffix: "A4", name: "Pārgaujas" },
    { code: "LV.A5", suffix: "A5", name: "Pāvilostas" },
    { code: "LV.A6", suffix: "A6", name: "Pļaviņu" },
    { code: "LV.A8", suffix: "A8", name: "Priekule" },
    { code: "LV.A9", suffix: "A9", name: "Priekuļi" },
    { code: "LV.B1", suffix: "B1", name: "Raunas" },
    { code: "LV.B3", suffix: "B3", name: "Riebiņu" },
    { code: "LV.B4", suffix: "B4", name: "Rojas" },
    { code: "LV.B5", suffix: "B5", name: "Ropažu" },
    { code: "LV.B6", suffix: "B6", name: "Rucavas" },
    { code: "LV.B7", suffix: "B7", name: "Rugāju" },
    { code: "LV.B8", suffix: "B8", name: "Rūjienas" },
    { code: "LV.B9", suffix: "B9", name: "Rundāles" },
    { code: "LV.C1", suffix: "C1", name: "Salacgrīvas" },
    { code: "LV.C2", suffix: "C2", name: "Salas" },
    { code: "LV.C3", suffix: "C3", name: "Salaspils" },
    { code: "LV.C5", suffix: "C5", name: "Saulkrastu" },
    { code: "LV.C6", suffix: "C6", name: "Sēja" },
    { code: "LV.C7", suffix: "C7", name: "Sigulda" },
    { code: "LV.C8", suffix: "C8", name: "Skrīveri" },
    { code: "LV.C9", suffix: "C9", name: "Skrunda" },
    { code: "LV.D1", suffix: "D1", name: "Smiltene" },
    { code: "LV.D2", suffix: "D2", name: "Stopiņi" },
    { code: "LV.D3", suffix: "D3", name: "Strenči" },
    { code: "LV.D5", suffix: "D5", name: "Tērvete" },
    { code: "LV.D7", suffix: "D7", name: "Vaiņode" },
    { code: "LV.E1", suffix: "E1", name: "Varakļāni" },
    { code: "LV.E2", suffix: "E2", name: "Vārkava" },
    { code: "LV.E3", suffix: "E3", name: "Vecpiebalga" },
    { code: "LV.E4", suffix: "E4", name: "Vecumnieki" },
    { code: "LV.E6", suffix: "E6", name: "Viesīte" },
    { code: "LV.E7", suffix: "E7", name: "Viļaka" },
    { code: "LV.E8", suffix: "E8", name: "Vilanu" },
    { code: "LV.E9", suffix: "E9", name: "Zilupes" },
    { code: "LV.F1", suffix: "F1", name: "Mesraga" },
  ],
  "LY": [
    { code: "LY.63", suffix: "63", name: "Al Jabal al Akhḑar" },
    { code: "LY.64", suffix: "64", name: "Al Jufrah" },
    { code: "LY.65", suffix: "65", name: "Al Kufrah" },
    { code: "LY.66", suffix: "66", name: "Al Marj" },
    { code: "LY.67", suffix: "67", name: "An Nuqāţ al Khams" },
    { code: "LY.68", suffix: "68", name: "Az Zāwiyah" },
    { code: "LY.69", suffix: "69", name: "Banghāzī" },
    { code: "LY.70", suffix: "70", name: "Darnah" },
    { code: "LY.71", suffix: "71", name: "Ghāt" },
    { code: "LY.72", suffix: "72", name: "Mişrātah" },
    { code: "LY.73", suffix: "73", name: "Murzuq" },
    { code: "LY.74", suffix: "74", name: "Nālūt" },
    { code: "LY.75", suffix: "75", name: "Sabhā" },
    { code: "LY.76", suffix: "76", name: "Surt" },
    { code: "LY.77", suffix: "77", name: "Tripoli" },
    { code: "LY.78", suffix: "78", name: "Ash Shāţiʼ" },
    { code: "LY.79", suffix: "79", name: "Al Buţnān" },
    { code: "LY.80", suffix: "80", name: "Jabal al Gharbi" },
    { code: "LY.81", suffix: "81", name: "Al Jafārah" },
    { code: "LY.82", suffix: "82", name: "Al Marqab" },
    { code: "LY.83", suffix: "83", name: "Al Wāḩāt" },
    { code: "LY.84", suffix: "84", name: "Wādī al Ḩayāt" },
  ],
  "MA": [
    { code: "MA.01", suffix: "01", name: "Tanger-Tetouan-Al Hoceima" },
    { code: "MA.02", suffix: "02", name: "Oriental" },
    { code: "MA.03", suffix: "03", name: "Fès-Meknès" },
    { code: "MA.04", suffix: "04", name: "Rabat-Salé-Kénitra" },
    { code: "MA.05", suffix: "05", name: "Béni Mellal-Khénifra" },
    { code: "MA.06", suffix: "06", name: "Casablanca-Settat" },
    { code: "MA.07", suffix: "07", name: "Marrakesh-Safi" },
    { code: "MA.08", suffix: "08", name: "Drâa-Tafilalet" },
    { code: "MA.09", suffix: "09", name: "Souss-Massa" },
    { code: "MA.10", suffix: "10", name: "Guelmim-Oued Noun" },
    { code: "MA.11", suffix: "11", name: "Laâyoune-Sakia El Hamra" },
    { code: "MA.12", suffix: "12", name: "Dakhla-Oued Ed-Dahab" },
  ],
  "MC": [
    { code: "MC.00", suffix: "00", name: "Monaco" },
  ],
  "MD": [
    { code: "MD.51", suffix: "51", name: "Găgăuzia" },
    { code: "MD.57", suffix: "57", name: "Chișinău Municipality" },
    { code: "MD.58", suffix: "58", name: "Transnistria" },
    { code: "MD.59", suffix: "59", name: "Anenii Noi" },
    { code: "MD.60", suffix: "60", name: "Bălţi" },
    { code: "MD.61", suffix: "61", name: "Basarabeasca" },
    { code: "MD.62", suffix: "62", name: "Bender Municipality" },
    { code: "MD.63", suffix: "63", name: "Briceni" },
    { code: "MD.64", suffix: "64", name: "Cahul" },
    { code: "MD.65", suffix: "65", name: "Cantemir" },
    { code: "MD.66", suffix: "66", name: "Călăraşi" },
    { code: "MD.67", suffix: "67", name: "Căuşeni" },
    { code: "MD.68", suffix: "68", name: "Cimişlia" },
    { code: "MD.69", suffix: "69", name: "Criuleni" },
    { code: "MD.70", suffix: "70", name: "Donduşeni" },
    { code: "MD.71", suffix: "71", name: "Drochia" },
    { code: "MD.72", suffix: "72", name: "Dubăsari" },
    { code: "MD.73", suffix: "73", name: "Raionul Edineţ" },
    { code: "MD.74", suffix: "74", name: "Fălești" },
    { code: "MD.75", suffix: "75", name: "Floreşti" },
    { code: "MD.76", suffix: "76", name: "Glodeni" },
    { code: "MD.77", suffix: "77", name: "Hînceşti" },
    { code: "MD.78", suffix: "78", name: "Ialoveni" },
    { code: "MD.79", suffix: "79", name: "Leova" },
    { code: "MD.80", suffix: "80", name: "Nisporeni" },
    { code: "MD.81", suffix: "81", name: "Raionul Ocniţa" },
    { code: "MD.82", suffix: "82", name: "Orhei" },
    { code: "MD.83", suffix: "83", name: "Rezina" },
    { code: "MD.84", suffix: "84", name: "Rîşcani" },
    { code: "MD.85", suffix: "85", name: "Sîngerei" },
    { code: "MD.86", suffix: "86", name: "Şoldăneşti" },
    { code: "MD.87", suffix: "87", name: "Raionul Soroca" },
    { code: "MD.88", suffix: "88", name: "Ştefan-Vodă" },
    { code: "MD.89", suffix: "89", name: "Strășeni" },
    { code: "MD.90", suffix: "90", name: "Taraclia" },
    { code: "MD.91", suffix: "91", name: "Teleneşti" },
    { code: "MD.92", suffix: "92", name: "Ungheni" },
  ],
  "ME": [
    { code: "ME.01", suffix: "01", name: "Andrijevica" },
    { code: "ME.02", suffix: "02", name: "Bar" },
    { code: "ME.03", suffix: "03", name: "Berane" },
    { code: "ME.04", suffix: "04", name: "Bijelo Polje" },
    { code: "ME.05", suffix: "05", name: "Budva" },
    { code: "ME.06", suffix: "06", name: "Cetinje" },
    { code: "ME.07", suffix: "07", name: "Danilovgrad" },
    { code: "ME.08", suffix: "08", name: "Herceg Novi" },
    { code: "ME.09", suffix: "09", name: "Opština Kolašin" },
    { code: "ME.10", suffix: "10", name: "Kotor" },
    { code: "ME.11", suffix: "11", name: "Mojkovac" },
    { code: "ME.12", suffix: "12", name: "Opština Nikšić" },
    { code: "ME.13", suffix: "13", name: "Opština Plav" },
    { code: "ME.14", suffix: "14", name: "Pljevlja" },
    { code: "ME.15", suffix: "15", name: "Opština Plužine" },
    { code: "ME.16", suffix: "16", name: "Podgorica" },
    { code: "ME.17", suffix: "17", name: "Opština Rožaje" },
    { code: "ME.18", suffix: "18", name: "Opština Šavnik" },
    { code: "ME.19", suffix: "19", name: "Tivat" },
    { code: "ME.20", suffix: "20", name: "Ulcinj" },
    { code: "ME.21", suffix: "21", name: "Opština Žabljak" },
    { code: "ME.22", suffix: "22", name: "Gusinje" },
    { code: "ME.23", suffix: "23", name: "Petnjica" },
    { code: "ME.24", suffix: "24", name: "Tuzi" },
  ],
  "MG": [
    { code: "MG.11", suffix: "11", name: "Analamanga" },
    { code: "MG.12", suffix: "12", name: "Vakinankaratra" },
    { code: "MG.13", suffix: "13", name: "Itasy" },
    { code: "MG.14", suffix: "14", name: "Bongolava" },
    { code: "MG.21", suffix: "21", name: "Upper Matsiatra" },
    { code: "MG.22", suffix: "22", name: "Amoron'i Mania" },
    { code: "MG.23", suffix: "23", name: "Vatovavy Fitovinany" },
    { code: "MG.24", suffix: "24", name: "Ihorombe" },
    { code: "MG.25", suffix: "25", name: "Atsimo-Atsinanana" },
    { code: "MG.31", suffix: "31", name: "Atsinanana" },
    { code: "MG.32", suffix: "32", name: "Analanjirofo" },
    { code: "MG.33", suffix: "33", name: "Alaotra Mangoro" },
    { code: "MG.41", suffix: "41", name: "Boeny" },
    { code: "MG.42", suffix: "42", name: "Sofia" },
    { code: "MG.43", suffix: "43", name: "Betsiboka" },
    { code: "MG.44", suffix: "44", name: "Melaky" },
    { code: "MG.51", suffix: "51", name: "Atsimo-Andrefana" },
    { code: "MG.52", suffix: "52", name: "Androy" },
    { code: "MG.53", suffix: "53", name: "Anosy" },
    { code: "MG.54", suffix: "54", name: "Menabe" },
    { code: "MG.71", suffix: "71", name: "Diana" },
    { code: "MG.72", suffix: "72", name: "Sava" },
  ],
  "MH": [
    { code: "MH.007", suffix: "007", name: "Ailinginae Atoll" },
    { code: "MH.010", suffix: "010", name: "Ailinglaplap Atoll" },
    { code: "MH.030", suffix: "030", name: "Ailuk Atoll" },
    { code: "MH.040", suffix: "040", name: "Arno Atoll" },
    { code: "MH.050", suffix: "050", name: "Aur Atoll" },
    { code: "MH.060", suffix: "060", name: "Bikar Atoll" },
    { code: "MH.070", suffix: "070", name: "Bikini Atoll" },
    { code: "MH.073", suffix: "073", name: "Bokak Atoll" },
    { code: "MH.080", suffix: "080", name: "Ebon Atoll" },
    { code: "MH.090", suffix: "090", name: "Enewetak Atoll" },
    { code: "MH.100", suffix: "100", name: "Erikub Atoll" },
    { code: "MH.110", suffix: "110", name: "Jabat Island" },
    { code: "MH.120", suffix: "120", name: "Jaluit Atoll" },
    { code: "MH.130", suffix: "130", name: "Jemo Island" },
    { code: "MH.140", suffix: "140", name: "Kili Island" },
    { code: "MH.150", suffix: "150", name: "Kwajalein Atoll" },
    { code: "MH.160", suffix: "160", name: "Lae Atoll" },
    { code: "MH.170", suffix: "170", name: "Lib Island" },
    { code: "MH.180", suffix: "180", name: "Likiep Atoll" },
    { code: "MH.190", suffix: "190", name: "Majuro Atoll" },
    { code: "MH.300", suffix: "300", name: "Maloelap Atoll" },
    { code: "MH.310", suffix: "310", name: "Mejit Island" },
    { code: "MH.320", suffix: "320", name: "Mili Atoll" },
    { code: "MH.330", suffix: "330", name: "Namdrik Atoll" },
    { code: "MH.340", suffix: "340", name: "Namu Atoll" },
    { code: "MH.350", suffix: "350", name: "Rongelap Atoll" },
    { code: "MH.360", suffix: "360", name: "Rongrik Atoll" },
    { code: "MH.385", suffix: "385", name: "Taka Atoll" },
    { code: "MH.390", suffix: "390", name: "Ujae Atoll" },
    { code: "MH.400", suffix: "400", name: "Ujelang" },
    { code: "MH.410", suffix: "410", name: "Utrik Atoll" },
    { code: "MH.420", suffix: "420", name: "Wotho Atoll" },
    { code: "MH.430", suffix: "430", name: "Wotje Atoll" },
  ],
  "MK": [
    { code: "MK.01", suffix: "01", name: "Arachinovo" },
    { code: "MK.04", suffix: "04", name: "Berovo" },
    { code: "MK.06", suffix: "06", name: "Bitola" },
    { code: "MK.08", suffix: "08", name: "Bogdanci" },
    { code: "MK.11", suffix: "11", name: "Bosilovo" },
    { code: "MK.12", suffix: "12", name: "Brvenica" },
    { code: "MK.18", suffix: "18", name: "Centar Zhupa" },
    { code: "MK.19", suffix: "19", name: "Češinovo-Obleševo" },
    { code: "MK.20", suffix: "20", name: "Chucher Sandevo" },
    { code: "MK.22", suffix: "22", name: "Delchevo" },
    { code: "MK.25", suffix: "25", name: "Demir Kapija" },
    { code: "MK.28", suffix: "28", name: "Dolneni" },
    { code: "MK.33", suffix: "33", name: "Gevgelija" },
    { code: "MK.35", suffix: "35", name: "Gradsko" },
    { code: "MK.36", suffix: "36", name: "Ilinden" },
    { code: "MK.40", suffix: "40", name: "Karbinci" },
    { code: "MK.43", suffix: "43", name: "Kichevo" },
    { code: "MK.46", suffix: "46", name: "Kochani" },
    { code: "MK.47", suffix: "47", name: "Konche" },
    { code: "MK.51", suffix: "51", name: "Kratovo" },
    { code: "MK.52", suffix: "52", name: "Kriva Palanka" },
    { code: "MK.53", suffix: "53", name: "Krivogashtani" },
    { code: "MK.54", suffix: "54", name: "Krushevo" },
    { code: "MK.59", suffix: "59", name: "Lipkovo" },
    { code: "MK.60", suffix: "60", name: "Lozovo" },
    { code: "MK.62", suffix: "62", name: "Makedonska Kamenica" },
    { code: "MK.69", suffix: "69", name: "Negotino" },
    { code: "MK.72", suffix: "72", name: "Novo Selo" },
    { code: "MK.78", suffix: "78", name: "Pehchevo" },
    { code: "MK.79", suffix: "79", name: "Petrovec" },
    { code: "MK.80", suffix: "80", name: "Plasnica" },
    { code: "MK.83", suffix: "83", name: "Probishtip" },
    { code: "MK.84", suffix: "84", name: "Radovish" },
    { code: "MK.85", suffix: "85", name: "Rankovce" },
    { code: "MK.86", suffix: "86", name: "Resen" },
    { code: "MK.87", suffix: "87", name: "Rosoman" },
    { code: "MK.92", suffix: "92", name: "Sopište" },
    { code: "MK.97", suffix: "97", name: "Staro Nagorichane" },
    { code: "MK.98", suffix: "98", name: "Shtip" },
    { code: "MK.A2", suffix: "A2", name: "Studenichani" },
    { code: "MK.A4", suffix: "A4", name: "Sveti Nikole" },
    { code: "MK.A5", suffix: "A5", name: "Tearce" },
    { code: "MK.A9", suffix: "A9", name: "Vasilevo" },
    { code: "MK.B3", suffix: "B3", name: "Vevchani" },
    { code: "MK.B4", suffix: "B4", name: "Vinica" },
    { code: "MK.B7", suffix: "B7", name: "Vrapchishte" },
    { code: "MK.C2", suffix: "C2", name: "Zelenikovo" },
    { code: "MK.C3", suffix: "C3", name: "Zhelino" },
    { code: "MK.C6", suffix: "C6", name: "Zrnovci" },
    { code: "MK.C7", suffix: "C7", name: "Bogovinje" },
    { code: "MK.C9", suffix: "C9", name: "Chashka" },
    { code: "MK.D2", suffix: "D2", name: "Debar" },
    { code: "MK.D3", suffix: "D3", name: "Demir Hisar" },
    { code: "MK.D4", suffix: "D4", name: "Gostivar" },
    { code: "MK.D5", suffix: "D5", name: "Jegunovce" },
    { code: "MK.D6", suffix: "D6", name: "Kavadarci" },
    { code: "MK.D7", suffix: "D7", name: "Kumanovo" },
    { code: "MK.D8", suffix: "D8", name: "Makedonski Brod" },
    { code: "MK.D9", suffix: "D9", name: "Mogila" },
    { code: "MK.E1", suffix: "E1", name: "Novaci" },
    { code: "MK.E2", suffix: "E2", name: "Ohrid" },
    { code: "MK.E3", suffix: "E3", name: "Prilep" },
    { code: "MK.E4", suffix: "E4", name: "Mavrovo and Rostuša" },
    { code: "MK.E5", suffix: "E5", name: "Dojran" },
    { code: "MK.E6", suffix: "E6", name: "Struga" },
    { code: "MK.E7", suffix: "E7", name: "Strumica" },
    { code: "MK.E8", suffix: "E8", name: "Tetovo" },
    { code: "MK.E9", suffix: "E9", name: "Valandovo" },
    { code: "MK.F1", suffix: "F1", name: "Veles" },
    { code: "MK.F5", suffix: "F5", name: "Debarca" },
    { code: "MK.F6", suffix: "F6", name: "Grad Skopje" },
  ],
  "ML": [
    { code: "ML.01", suffix: "01", name: "Bamako" },
    { code: "ML.03", suffix: "03", name: "Kayes" },
    { code: "ML.04", suffix: "04", name: "Mopti" },
    { code: "ML.05", suffix: "05", name: "Ségou" },
    { code: "ML.06", suffix: "06", name: "Sikasso" },
    { code: "ML.07", suffix: "07", name: "Koulikoro" },
    { code: "ML.08", suffix: "08", name: "Tombouctou" },
    { code: "ML.09", suffix: "09", name: "Gao" },
    { code: "ML.10", suffix: "10", name: "Kidal" },
    { code: "ML.12070575", suffix: "12070575", name: "Taoudénit" },
    { code: "ML.12070577", suffix: "12070577", name: "Ménaka" },
  ],
  "MM": [
    { code: "MM.01", suffix: "01", name: "Rakhine" },
    { code: "MM.02", suffix: "02", name: "Chin" },
    { code: "MM.03", suffix: "03", name: "Ayeyarwady" },
    { code: "MM.04", suffix: "04", name: "Kachin" },
    { code: "MM.05", suffix: "05", name: "Kayin" },
    { code: "MM.06", suffix: "06", name: "Kayah" },
    { code: "MM.08", suffix: "08", name: "Mandalay" },
    { code: "MM.10", suffix: "10", name: "Sagain" },
    { code: "MM.11", suffix: "11", name: "Shan" },
    { code: "MM.12", suffix: "12", name: "Tanintharyi" },
    { code: "MM.13", suffix: "13", name: "Mon" },
    { code: "MM.15", suffix: "15", name: "Magway" },
    { code: "MM.16", suffix: "16", name: "Bago" },
    { code: "MM.17", suffix: "17", name: "Rangoon" },
    { code: "MM.18", suffix: "18", name: "Nay Pyi Taw" },
  ],
  "MN": [
    { code: "MN.01", suffix: "01", name: "Arhangay" },
    { code: "MN.02", suffix: "02", name: "Bayanhongor" },
    { code: "MN.03", suffix: "03", name: "Bayan-Ölgiy" },
    { code: "MN.06", suffix: "06", name: "East Aimak" },
    { code: "MN.07", suffix: "07", name: "East Gobi Aymag" },
    { code: "MN.08", suffix: "08", name: "Middle Govĭ" },
    { code: "MN.09", suffix: "09", name: "Dzabkhan" },
    { code: "MN.10", suffix: "10", name: "Govĭ-Altay" },
    { code: "MN.11", suffix: "11", name: "Hentiy" },
    { code: "MN.12", suffix: "12", name: "Hovd" },
    { code: "MN.13", suffix: "13", name: "Hövsgöl" },
    { code: "MN.14", suffix: "14", name: "Ömnögovĭ" },
    { code: "MN.15", suffix: "15", name: "Övörhangay" },
    { code: "MN.16", suffix: "16", name: "Selenge" },
    { code: "MN.17", suffix: "17", name: "Sühbaatar" },
    { code: "MN.18", suffix: "18", name: "Central Aimak" },
    { code: "MN.19", suffix: "19", name: "Uvs" },
    { code: "MN.20", suffix: "20", name: "Ulaanbaatar" },
    { code: "MN.21", suffix: "21", name: "Bulgan" },
    { code: "MN.23", suffix: "23", name: "Darhan Uul" },
    { code: "MN.24", suffix: "24", name: "Govĭ-Sumber" },
    { code: "MN.25", suffix: "25", name: "Orhon" },
  ],
  "MO": [
    { code: "MO.11875154", suffix: "11875154", name: "Nossa Senhora de Fátima" },
    { code: "MO.11875155", suffix: "11875155", name: "Santo António" },
    { code: "MO.11875156", suffix: "11875156", name: "São Lázaro" },
    { code: "MO.11875157", suffix: "11875157", name: "Sé" },
    { code: "MO.11875158", suffix: "11875158", name: "São Lourenço" },
    { code: "MO.11875159", suffix: "11875159", name: "Nossa Senhora do Carmo" },
    { code: "MO.11875160", suffix: "11875160", name: "Cotai" },
    { code: "MO.11875161", suffix: "11875161", name: "São Francisco Xavier" },
  ],
  "MP": [
    { code: "MP.085", suffix: "085", name: "Northern Islands" },
    { code: "MP.100", suffix: "100", name: "Rota" },
    { code: "MP.110", suffix: "110", name: "Saipan" },
    { code: "MP.120", suffix: "120", name: "Tinian" },
  ],
  "MQ": [
    { code: "MQ.MQ", suffix: "MQ", name: "Martinique" },
  ],
  "MR": [
    { code: "MR.01", suffix: "01", name: "Hodh Ech Chargi" },
    { code: "MR.02", suffix: "02", name: "Hodh El Gharbi" },
    { code: "MR.03", suffix: "03", name: "Assaba" },
    { code: "MR.04", suffix: "04", name: "Gorgol" },
    { code: "MR.05", suffix: "05", name: "Brakna" },
    { code: "MR.06", suffix: "06", name: "Trarza" },
    { code: "MR.07", suffix: "07", name: "Adrar" },
    { code: "MR.08", suffix: "08", name: "Dakhlet Nouadhibou" },
    { code: "MR.09", suffix: "09", name: "Tagant" },
    { code: "MR.10", suffix: "10", name: "Guidimaka" },
    { code: "MR.11", suffix: "11", name: "Tiris Zemmour" },
    { code: "MR.12", suffix: "12", name: "Inchiri" },
    { code: "MR.13", suffix: "13", name: "Nouakchott Ouest" },
    { code: "MR.14", suffix: "14", name: "Nouakchott Nord" },
    { code: "MR.15", suffix: "15", name: "Nouakchott Sud" },
  ],
  "MS": [
    { code: "MS.01", suffix: "01", name: "Saint Anthony" },
    { code: "MS.02", suffix: "02", name: "Saint Georges" },
    { code: "MS.03", suffix: "03", name: "Saint Peter" },
  ],
  "MT": [
    { code: "MT.01", suffix: "01", name: "Attard" },
    { code: "MT.02", suffix: "02", name: "Balzan" },
    { code: "MT.03", suffix: "03", name: "Il-Birgu" },
    { code: "MT.04", suffix: "04", name: "Birkirkara" },
    { code: "MT.05", suffix: "05", name: "Birżebbuġa" },
    { code: "MT.06", suffix: "06", name: "Bormla" },
    { code: "MT.07", suffix: "07", name: "Dingli" },
    { code: "MT.08", suffix: "08", name: "Il-Fgura" },
    { code: "MT.09", suffix: "09", name: "Il-Furjana" },
    { code: "MT.10", suffix: "10", name: "Il-Fontana" },
    { code: "MT.11", suffix: "11", name: "Għajnsielem" },
    { code: "MT.12", suffix: "12", name: "L-Għarb" },
    { code: "MT.13", suffix: "13", name: "Ħal Għargħur" },
    { code: "MT.14", suffix: "14", name: "L-Għasri" },
    { code: "MT.15", suffix: "15", name: "Ħal Għaxaq" },
    { code: "MT.16", suffix: "16", name: "Il-Gudja" },
    { code: "MT.17", suffix: "17", name: "Il-Gżira" },
    { code: "MT.18", suffix: "18", name: "Il-Ħamrun" },
    { code: "MT.19", suffix: "19", name: "L-Iklin" },
    { code: "MT.20", suffix: "20", name: "L-Imdina" },
    { code: "MT.21", suffix: "21", name: "L-Imġarr" },
    { code: "MT.22", suffix: "22", name: "L-Imqabba" },
    { code: "MT.23", suffix: "23", name: "L-Imsida" },
    { code: "MT.24", suffix: "24", name: "Mtarfa" },
    { code: "MT.25", suffix: "25", name: "Senglea" },
    { code: "MT.26", suffix: "26", name: "Il-Kalkara" },
    { code: "MT.27", suffix: "27", name: "Ta’ Kerċem" },
    { code: "MT.28", suffix: "28", name: "Kirkop" },
    { code: "MT.29", suffix: "29", name: "Lija" },
    { code: "MT.30", suffix: "30", name: "Luqa" },
    { code: "MT.31", suffix: "31", name: "Il-Marsa" },
    { code: "MT.32", suffix: "32", name: "Marsaskala" },
    { code: "MT.33", suffix: "33", name: "Marsaxlokk" },
    { code: "MT.34", suffix: "34", name: "Il-Mellieħa" },
    { code: "MT.35", suffix: "35", name: "Il-Mosta" },
    { code: "MT.36", suffix: "36", name: "Il-Munxar" },
    { code: "MT.37", suffix: "37", name: "In-Nadur" },
    { code: "MT.38", suffix: "38", name: "In-Naxxar" },
    { code: "MT.39", suffix: "39", name: "Paola" },
    { code: "MT.40", suffix: "40", name: "Pembroke" },
    { code: "MT.41", suffix: "41", name: "Tal-Pietà" },
    { code: "MT.42", suffix: "42", name: "Il-Qala" },
    { code: "MT.43", suffix: "43", name: "Qormi" },
    { code: "MT.44", suffix: "44", name: "Il-Qrendi" },
    { code: "MT.45", suffix: "45", name: "Ir-Rabat" },
    { code: "MT.46", suffix: "46", name: "Victoria" },
    { code: "MT.47", suffix: "47", name: "Safi" },
    { code: "MT.48", suffix: "48", name: "Saint John" },
    { code: "MT.49", suffix: "49", name: "Saint Julian" },
    { code: "MT.50", suffix: "50", name: "Saint Lawrence" },
    { code: "MT.51", suffix: "51", name: "Saint Lucia" },
    { code: "MT.52", suffix: "52", name: "Saint Paul’s Bay" },
    { code: "MT.53", suffix: "53", name: "Saint Venera" },
    { code: "MT.54", suffix: "54", name: "Sannat" },
    { code: "MT.55", suffix: "55", name: "Is-Siġġiewi" },
    { code: "MT.56", suffix: "56", name: "Tas-Sliema" },
    { code: "MT.57", suffix: "57", name: "Is-Swieqi" },
    { code: "MT.58", suffix: "58", name: "Tarxien" },
    { code: "MT.59", suffix: "59", name: "Ta’ Xbiex" },
    { code: "MT.60", suffix: "60", name: "Valletta" },
    { code: "MT.61", suffix: "61", name: "Ix-Xagħra" },
    { code: "MT.62", suffix: "62", name: "Ix-Xewkija" },
    { code: "MT.63", suffix: "63", name: "Ix-Xgħajra" },
    { code: "MT.64", suffix: "64", name: "Ħaż-Żabbar" },
    { code: "MT.65", suffix: "65", name: "Ħaż-Żebbuġ" },
    { code: "MT.66", suffix: "66", name: "Iż-Żebbuġ" },
    { code: "MT.67", suffix: "67", name: "Iż-Żejtun" },
    { code: "MT.68", suffix: "68", name: "Iż-Żurrieq" },
  ],
  "MU": [
    { code: "MU.12", suffix: "12", name: "Black River" },
    { code: "MU.13", suffix: "13", name: "Flacq" },
    { code: "MU.14", suffix: "14", name: "Grand Port" },
    { code: "MU.15", suffix: "15", name: "Moka" },
    { code: "MU.16", suffix: "16", name: "Pamplemousses" },
    { code: "MU.17", suffix: "17", name: "Plaines Wilhems" },
    { code: "MU.18", suffix: "18", name: "Port Louis" },
    { code: "MU.19", suffix: "19", name: "Rivière du Rempart" },
    { code: "MU.20", suffix: "20", name: "Savanne" },
    { code: "MU.21", suffix: "21", name: "Agalega Islands" },
    { code: "MU.22", suffix: "22", name: "Cargados Carajos" },
    { code: "MU.23", suffix: "23", name: "Rodrigues" },
  ],
  "MV": [
    { code: "MV.01", suffix: "01", name: "Seenu" },
    { code: "MV.05", suffix: "05", name: "Laamu" },
    { code: "MV.10346475", suffix: "10346475", name: "Southern Ari Atoll" },
    { code: "MV.30", suffix: "30", name: "Northern Ari Atoll" },
    { code: "MV.31", suffix: "31", name: "Baa Atholhu" },
    { code: "MV.32", suffix: "32", name: "Dhaalu Atholhu" },
    { code: "MV.33", suffix: "33", name: "Faafu Atholhu" },
    { code: "MV.34", suffix: "34", name: "Gaafu Alifu Atholhu" },
    { code: "MV.35", suffix: "35", name: "Gaafu Dhaalu Atholhu" },
    { code: "MV.36", suffix: "36", name: "Haa Alifu Atholhu" },
    { code: "MV.37", suffix: "37", name: "Haa Dhaalu Atholhu" },
    { code: "MV.38", suffix: "38", name: "Kaafu Atoll" },
    { code: "MV.39", suffix: "39", name: "Lhaviyani Atholhu" },
    { code: "MV.40", suffix: "40", name: "Male" },
    { code: "MV.41", suffix: "41", name: "Meemu Atholhu" },
    { code: "MV.42", suffix: "42", name: "Gnyaviyani Atoll" },
    { code: "MV.43", suffix: "43", name: "Noonu Atoll" },
    { code: "MV.44", suffix: "44", name: "Raa Atoll" },
    { code: "MV.45", suffix: "45", name: "Shaviyani Atholhu" },
    { code: "MV.46", suffix: "46", name: "Thaa Atholhu" },
    { code: "MV.47", suffix: "47", name: "Vaavu Atholhu" },
  ],
  "MW": [
    { code: "MW.C", suffix: "C", name: "Central Region" },
    { code: "MW.N", suffix: "N", name: "Northern Region" },
    { code: "MW.S", suffix: "S", name: "Southern Region" },
  ],
  "MX": [
    { code: "MX.01", suffix: "01", name: "Aguascalientes" },
    { code: "MX.02", suffix: "02", name: "Baja California" },
    { code: "MX.03", suffix: "03", name: "Baja California Sur" },
    { code: "MX.04", suffix: "04", name: "Campeche" },
    { code: "MX.05", suffix: "05", name: "Chiapas" },
    { code: "MX.06", suffix: "06", name: "Chihuahua" },
    { code: "MX.07", suffix: "07", name: "Coahuila" },
    { code: "MX.08", suffix: "08", name: "Colima" },
    { code: "MX.09", suffix: "09", name: "Mexico City" },
    { code: "MX.10", suffix: "10", name: "Durango" },
    { code: "MX.11", suffix: "11", name: "Guanajuato" },
    { code: "MX.12", suffix: "12", name: "Guerrero" },
    { code: "MX.13", suffix: "13", name: "Hidalgo" },
    { code: "MX.14", suffix: "14", name: "Jalisco" },
    { code: "MX.15", suffix: "15", name: "México" },
    { code: "MX.16", suffix: "16", name: "Michoacán" },
    { code: "MX.17", suffix: "17", name: "Morelos" },
    { code: "MX.18", suffix: "18", name: "Nayarit" },
    { code: "MX.19", suffix: "19", name: "Nuevo León" },
    { code: "MX.20", suffix: "20", name: "Oaxaca" },
    { code: "MX.21", suffix: "21", name: "Puebla" },
    { code: "MX.22", suffix: "22", name: "Querétaro" },
    { code: "MX.23", suffix: "23", name: "Quintana Roo" },
    { code: "MX.24", suffix: "24", name: "San Luis Potosí" },
    { code: "MX.25", suffix: "25", name: "Sinaloa" },
    { code: "MX.26", suffix: "26", name: "Sonora" },
    { code: "MX.27", suffix: "27", name: "Tabasco" },
    { code: "MX.28", suffix: "28", name: "Tamaulipas" },
    { code: "MX.29", suffix: "29", name: "Tlaxcala" },
    { code: "MX.30", suffix: "30", name: "Veracruz" },
    { code: "MX.31", suffix: "31", name: "Yucatán" },
    { code: "MX.32", suffix: "32", name: "Zacatecas" },
  ],
  "MY": [
    { code: "MY.01", suffix: "01", name: "Johor" },
    { code: "MY.02", suffix: "02", name: "Kedah" },
    { code: "MY.03", suffix: "03", name: "Kelantan" },
    { code: "MY.04", suffix: "04", name: "Melaka" },
    { code: "MY.05", suffix: "05", name: "Negeri Sembilan" },
    { code: "MY.06", suffix: "06", name: "Pahang" },
    { code: "MY.07", suffix: "07", name: "Perak" },
    { code: "MY.08", suffix: "08", name: "Perlis" },
    { code: "MY.09", suffix: "09", name: "Penang" },
    { code: "MY.11", suffix: "11", name: "Sarawak" },
    { code: "MY.12", suffix: "12", name: "Selangor" },
    { code: "MY.13", suffix: "13", name: "Terengganu" },
    { code: "MY.14", suffix: "14", name: "Kuala Lumpur" },
    { code: "MY.15", suffix: "15", name: "Labuan" },
    { code: "MY.16", suffix: "16", name: "Sabah" },
    { code: "MY.17", suffix: "17", name: "Putrajaya" },
  ],
  "MZ": [
    { code: "MZ.01", suffix: "01", name: "Cabo Delgado" },
    { code: "MZ.02", suffix: "02", name: "Gaza" },
    { code: "MZ.03", suffix: "03", name: "Inhambane" },
    { code: "MZ.04", suffix: "04", name: "Maputo" },
    { code: "MZ.05", suffix: "05", name: "Sofala" },
    { code: "MZ.06", suffix: "06", name: "Nampula" },
    { code: "MZ.07", suffix: "07", name: "Niassa" },
    { code: "MZ.08", suffix: "08", name: "Tete" },
    { code: "MZ.09", suffix: "09", name: "Zambézia" },
    { code: "MZ.10", suffix: "10", name: "Manica" },
    { code: "MZ.11", suffix: "11", name: "Maputo City" },
  ],
  "NA": [
    { code: "NA.21", suffix: "21", name: "Khomas" },
    { code: "NA.28", suffix: "28", name: "Zambezi" },
    { code: "NA.29", suffix: "29", name: "Erongo" },
    { code: "NA.30", suffix: "30", name: "Hardap" },
    { code: "NA.31", suffix: "31", name: "Karas" },
    { code: "NA.32", suffix: "32", name: "Kunene" },
    { code: "NA.33", suffix: "33", name: "Ohangwena" },
    { code: "NA.35", suffix: "35", name: "Omaheke" },
    { code: "NA.36", suffix: "36", name: "Omusati" },
    { code: "NA.37", suffix: "37", name: "Oshana" },
    { code: "NA.38", suffix: "38", name: "Oshikoto" },
    { code: "NA.39", suffix: "39", name: "Otjozondjupa" },
    { code: "NA.40", suffix: "40", name: "Kavango East" },
    { code: "NA.41", suffix: "41", name: "Kavango West" },
  ],
  "NC": [
    { code: "NC.01", suffix: "01", name: "North Province" },
    { code: "NC.02", suffix: "02", name: "South Province" },
    { code: "NC.03", suffix: "03", name: "Loyalty Islands" },
  ],
  "NE": [
    { code: "NE.01", suffix: "01", name: "Agadez" },
    { code: "NE.02", suffix: "02", name: "Diffa" },
    { code: "NE.03", suffix: "03", name: "Dosso" },
    { code: "NE.04", suffix: "04", name: "Maradi" },
    { code: "NE.06", suffix: "06", name: "Tahoua" },
    { code: "NE.07", suffix: "07", name: "Zinder" },
    { code: "NE.08", suffix: "08", name: "Niamey" },
    { code: "NE.09", suffix: "09", name: "Tillabéri" },
  ],
  "NG": [
    { code: "NG.05", suffix: "05", name: "Lagos" },
    { code: "NG.11", suffix: "11", name: "FCT" },
    { code: "NG.16", suffix: "16", name: "Ogun" },
    { code: "NG.21", suffix: "21", name: "Akwa Ibom" },
    { code: "NG.22", suffix: "22", name: "Cross River" },
    { code: "NG.23", suffix: "23", name: "Kaduna" },
    { code: "NG.24", suffix: "24", name: "Katsina" },
    { code: "NG.25", suffix: "25", name: "Anambra" },
    { code: "NG.26", suffix: "26", name: "Benue" },
    { code: "NG.27", suffix: "27", name: "Borno" },
    { code: "NG.28", suffix: "28", name: "Imo" },
    { code: "NG.29", suffix: "29", name: "Kano" },
    { code: "NG.30", suffix: "30", name: "Kwara" },
    { code: "NG.31", suffix: "31", name: "Niger" },
    { code: "NG.32", suffix: "32", name: "Oyo" },
    { code: "NG.35", suffix: "35", name: "Adamawa" },
    { code: "NG.36", suffix: "36", name: "Delta" },
    { code: "NG.37", suffix: "37", name: "Edo" },
    { code: "NG.39", suffix: "39", name: "Jigawa" },
    { code: "NG.40", suffix: "40", name: "Kebbi" },
    { code: "NG.41", suffix: "41", name: "Kogi" },
    { code: "NG.42", suffix: "42", name: "Osun" },
    { code: "NG.43", suffix: "43", name: "Taraba" },
    { code: "NG.44", suffix: "44", name: "Yobe" },
    { code: "NG.45", suffix: "45", name: "Abia" },
    { code: "NG.46", suffix: "46", name: "Bauchi" },
    { code: "NG.47", suffix: "47", name: "Enugu" },
    { code: "NG.48", suffix: "48", name: "Ondo" },
    { code: "NG.49", suffix: "49", name: "Plateau" },
    { code: "NG.50", suffix: "50", name: "Rivers" },
    { code: "NG.51", suffix: "51", name: "Sokoto" },
    { code: "NG.52", suffix: "52", name: "Bayelsa" },
    { code: "NG.53", suffix: "53", name: "Ebonyi" },
    { code: "NG.54", suffix: "54", name: "Ekiti" },
    { code: "NG.55", suffix: "55", name: "Gombe" },
    { code: "NG.56", suffix: "56", name: "Nassarawa" },
    { code: "NG.57", suffix: "57", name: "Zamfara" },
  ],
  "NI": [
    { code: "NI.01", suffix: "01", name: "Boaco" },
    { code: "NI.02", suffix: "02", name: "Carazo" },
    { code: "NI.03", suffix: "03", name: "Chinandega" },
    { code: "NI.04", suffix: "04", name: "Chontales" },
    { code: "NI.05", suffix: "05", name: "Estelí" },
    { code: "NI.06", suffix: "06", name: "Granada" },
    { code: "NI.07", suffix: "07", name: "Jinotega" },
    { code: "NI.08", suffix: "08", name: "León" },
    { code: "NI.09", suffix: "09", name: "Madriz" },
    { code: "NI.10", suffix: "10", name: "Managua" },
    { code: "NI.11", suffix: "11", name: "Masaya" },
    { code: "NI.12", suffix: "12", name: "Matagalpa" },
    { code: "NI.13", suffix: "13", name: "Nueva Segovia" },
    { code: "NI.14", suffix: "14", name: "Río San Juan" },
    { code: "NI.15", suffix: "15", name: "Rivas" },
    { code: "NI.17", suffix: "17", name: "North Caribbean Coast" },
    { code: "NI.18", suffix: "18", name: "South Caribbean Coast" },
  ],
  "NL": [
    { code: "NL.01", suffix: "01", name: "Drenthe" },
    { code: "NL.02", suffix: "02", name: "Friesland" },
    { code: "NL.03", suffix: "03", name: "Gelderland" },
    { code: "NL.04", suffix: "04", name: "Groningen" },
    { code: "NL.05", suffix: "05", name: "Limburg" },
    { code: "NL.06", suffix: "06", name: "North Brabant" },
    { code: "NL.07", suffix: "07", name: "North Holland" },
    { code: "NL.09", suffix: "09", name: "Utrecht" },
    { code: "NL.10", suffix: "10", name: "Zeeland" },
    { code: "NL.11", suffix: "11", name: "South Holland" },
    { code: "NL.15", suffix: "15", name: "Overijssel" },
    { code: "NL.16", suffix: "16", name: "Flevoland" },
  ],
  "NO": [
    { code: "NO.08", suffix: "08", name: "Møre og Romsdal" },
    { code: "NO.09", suffix: "09", name: "Nordland" },
    { code: "NO.12", suffix: "12", name: "Oslo" },
    { code: "NO.14", suffix: "14", name: "Rogaland" },
    { code: "NO.21", suffix: "21", name: "Trøndelag" },
    { code: "NO.30", suffix: "30", name: "Viken" },
    { code: "NO.34", suffix: "34", name: "Innlandet" },
    { code: "NO.38", suffix: "38", name: "Vestfold og Telemark" },
    { code: "NO.42", suffix: "42", name: "Agder" },
    { code: "NO.46", suffix: "46", name: "Vestland" },
    { code: "NO.54", suffix: "54", name: "Troms og Finnmark" },
  ],
  "NP": [
    { code: "NP.1", suffix: "1", name: "Province 1" },
    { code: "NP.2", suffix: "2", name: "Province 2" },
    { code: "NP.3", suffix: "3", name: "Province 3" },
    { code: "NP.4", suffix: "4", name: "Province 4" },
    { code: "NP.5", suffix: "5", name: "Province 5" },
    { code: "NP.6", suffix: "6", name: "Karnali Pradesh" },
    { code: "NP.7", suffix: "7", name: "Sudurpashchim Pradesh" },
  ],
  "NR": [
    { code: "NR.01", suffix: "01", name: "Aiwo" },
    { code: "NR.02", suffix: "02", name: "Anabar" },
    { code: "NR.03", suffix: "03", name: "Anetan" },
    { code: "NR.04", suffix: "04", name: "Anibare" },
    { code: "NR.05", suffix: "05", name: "Baiti" },
    { code: "NR.06", suffix: "06", name: "Boe" },
    { code: "NR.07", suffix: "07", name: "Buada" },
    { code: "NR.08", suffix: "08", name: "Denigomodu" },
    { code: "NR.09", suffix: "09", name: "Ewa" },
    { code: "NR.10", suffix: "10", name: "Ijuw" },
    { code: "NR.11", suffix: "11", name: "Meneng" },
    { code: "NR.12", suffix: "12", name: "Nibok" },
    { code: "NR.13", suffix: "13", name: "Uaboe" },
    { code: "NR.14", suffix: "14", name: "Yaren" },
  ],
  "NZ": [
    { code: "NZ.10", suffix: "10", name: "Chatham Islands" },
    { code: "NZ.E7", suffix: "E7", name: "Auckland" },
    { code: "NZ.E8", suffix: "E8", name: "Bay of Plenty" },
    { code: "NZ.E9", suffix: "E9", name: "Canterbury" },
    { code: "NZ.F1", suffix: "F1", name: "Gisborne" },
    { code: "NZ.F2", suffix: "F2", name: "Hawke's Bay" },
    { code: "NZ.F3", suffix: "F3", name: "Manawatu-Wanganui" },
    { code: "NZ.F4", suffix: "F4", name: "Marlborough" },
    { code: "NZ.F5", suffix: "F5", name: "Nelson" },
    { code: "NZ.F6", suffix: "F6", name: "Northland" },
    { code: "NZ.F7", suffix: "F7", name: "Otago" },
    { code: "NZ.F8", suffix: "F8", name: "Southland" },
    { code: "NZ.F9", suffix: "F9", name: "Taranaki" },
    { code: "NZ.G1", suffix: "G1", name: "Waikato" },
    { code: "NZ.G2", suffix: "G2", name: "Wellington" },
    { code: "NZ.G3", suffix: "G3", name: "West Coast" },
    { code: "NZ.TAS", suffix: "TAS", name: "Tasman" },
  ],
  "OM": [
    { code: "OM.01", suffix: "01", name: "Ad Dakhiliyah" },
    { code: "OM.02", suffix: "02", name: "Al Batinah South" },
    { code: "OM.03", suffix: "03", name: "Al Wusţá" },
    { code: "OM.04", suffix: "04", name: "Southeastern Governorate" },
    { code: "OM.06", suffix: "06", name: "Muscat" },
    { code: "OM.07", suffix: "07", name: "Musandam" },
    { code: "OM.08", suffix: "08", name: "Dhofar" },
    { code: "OM.09", suffix: "09", name: "Az̧ Z̧āhirah" },
    { code: "OM.10", suffix: "10", name: "Al Buraimi" },
    { code: "OM.11", suffix: "11", name: "Al Batinah North" },
    { code: "OM.12", suffix: "12", name: "Northeastern Governorate" },
  ],
  "PA": [
    { code: "PA.01", suffix: "01", name: "Bocas del Toro" },
    { code: "PA.02", suffix: "02", name: "Chiriquí" },
    { code: "PA.03", suffix: "03", name: "Coclé" },
    { code: "PA.04", suffix: "04", name: "Colón" },
    { code: "PA.05", suffix: "05", name: "Darién" },
    { code: "PA.06", suffix: "06", name: "Herrera" },
    { code: "PA.07", suffix: "07", name: "Los Santos" },
    { code: "PA.08", suffix: "08", name: "Panamá" },
    { code: "PA.09", suffix: "09", name: "Guna Yala" },
    { code: "PA.10", suffix: "10", name: "Veraguas" },
    { code: "PA.11", suffix: "11", name: "Emberá" },
    { code: "PA.12", suffix: "12", name: "Ngöbe-Buglé" },
    { code: "PA.13", suffix: "13", name: "Panamá Oeste" },
  ],
  "PE": [
    { code: "PE.01", suffix: "01", name: "Amazonas" },
    { code: "PE.02", suffix: "02", name: "Ancash" },
    { code: "PE.03", suffix: "03", name: "Apurímac" },
    { code: "PE.04", suffix: "04", name: "Arequipa" },
    { code: "PE.05", suffix: "05", name: "Ayacucho" },
    { code: "PE.06", suffix: "06", name: "Cajamarca" },
    { code: "PE.07", suffix: "07", name: "Callao" },
    { code: "PE.08", suffix: "08", name: "Cusco" },
    { code: "PE.09", suffix: "09", name: "Huancavelica" },
    { code: "PE.10", suffix: "10", name: "Huanuco" },
    { code: "PE.11", suffix: "11", name: "Ica" },
    { code: "PE.12", suffix: "12", name: "Junin" },
    { code: "PE.13", suffix: "13", name: "La Libertad" },
    { code: "PE.14", suffix: "14", name: "Lambayeque" },
    { code: "PE.15", suffix: "15", name: "Lima region" },
    { code: "PE.16", suffix: "16", name: "Loreto" },
    { code: "PE.17", suffix: "17", name: "Madre de Dios" },
    { code: "PE.18", suffix: "18", name: "Moquegua" },
    { code: "PE.19", suffix: "19", name: "Pasco" },
    { code: "PE.20", suffix: "20", name: "Piura" },
    { code: "PE.21", suffix: "21", name: "Puno" },
    { code: "PE.22", suffix: "22", name: "San Martín" },
    { code: "PE.23", suffix: "23", name: "Tacna" },
    { code: "PE.24", suffix: "24", name: "Tumbes" },
    { code: "PE.25", suffix: "25", name: "Ucayali" },
    { code: "PE.LMA", suffix: "LMA", name: "Lima" },
  ],
  "PF": [
    { code: "PF.01", suffix: "01", name: "Îles du Vent" },
    { code: "PF.02", suffix: "02", name: "Leeward Islands" },
    { code: "PF.03", suffix: "03", name: "Îles Tuamotu-Gambier" },
    { code: "PF.04", suffix: "04", name: "Îles Marquises" },
    { code: "PF.05", suffix: "05", name: "Îles Australes" },
  ],
  "PG": [
    { code: "PG.01", suffix: "01", name: "Central Province" },
    { code: "PG.02", suffix: "02", name: "Gulf" },
    { code: "PG.03", suffix: "03", name: "Milne Bay" },
    { code: "PG.04", suffix: "04", name: "Northern Province" },
    { code: "PG.05", suffix: "05", name: "Southern Highlands" },
    { code: "PG.06", suffix: "06", name: "Western Province" },
    { code: "PG.07", suffix: "07", name: "Bougainville" },
    { code: "PG.08", suffix: "08", name: "Chimbu" },
    { code: "PG.09", suffix: "09", name: "Eastern Highlands" },
    { code: "PG.10", suffix: "10", name: "East New Britain" },
    { code: "PG.11", suffix: "11", name: "East Sepik" },
    { code: "PG.12", suffix: "12", name: "Madang" },
    { code: "PG.13", suffix: "13", name: "Manus" },
    { code: "PG.14", suffix: "14", name: "Morobe" },
    { code: "PG.15", suffix: "15", name: "New Ireland" },
    { code: "PG.16", suffix: "16", name: "Western Highlands" },
    { code: "PG.17", suffix: "17", name: "West New Britain" },
    { code: "PG.18", suffix: "18", name: "Sandaun" },
    { code: "PG.19", suffix: "19", name: "Enga" },
    { code: "PG.20", suffix: "20", name: "National Capital" },
    { code: "PG.21", suffix: "21", name: "Hela" },
    { code: "PG.22", suffix: "22", name: "Jiwaka" },
  ],
  "PH": [
    { code: "PH.01", suffix: "01", name: "Ilocos" },
    { code: "PH.02", suffix: "02", name: "Cagayan Valley" },
    { code: "PH.03", suffix: "03", name: "Central Luzon" },
    { code: "PH.05", suffix: "05", name: "Bicol" },
    { code: "PH.06", suffix: "06", name: "Western Visayas" },
    { code: "PH.07", suffix: "07", name: "Central Visayas" },
    { code: "PH.08", suffix: "08", name: "Eastern Visayas" },
    { code: "PH.09", suffix: "09", name: "Zamboanga Peninsula" },
    { code: "PH.10", suffix: "10", name: "Northern Mindanao" },
    { code: "PH.11", suffix: "11", name: "Davao" },
    { code: "PH.12", suffix: "12", name: "Soccsksargen" },
    { code: "PH.13", suffix: "13", name: "Caraga" },
    { code: "PH.14", suffix: "14", name: "Autonomous Region in Muslim Mindanao" },
    { code: "PH.15", suffix: "15", name: "Cordillera" },
    { code: "PH.40", suffix: "40", name: "Calabarzon" },
    { code: "PH.41", suffix: "41", name: "Mimaropa" },
    { code: "PH.NCR", suffix: "NCR", name: "Metro Manila" },
  ],
  "PK": [
    { code: "PK.02", suffix: "02", name: "Balochistan" },
    { code: "PK.03", suffix: "03", name: "Khyber Pakhtunkhwa" },
    { code: "PK.04", suffix: "04", name: "Punjab" },
    { code: "PK.05", suffix: "05", name: "Sindh" },
    { code: "PK.06", suffix: "06", name: "Azad Kashmir" },
    { code: "PK.07", suffix: "07", name: "Gilgit-Baltistan" },
    { code: "PK.08", suffix: "08", name: "Islamabad" },
  ],
  "PL": [
    { code: "PL.72", suffix: "72", name: "Lower Silesia" },
    { code: "PL.73", suffix: "73", name: "Kujawsko-Pomorskie" },
    { code: "PL.74", suffix: "74", name: "Łódź Voivodeship" },
    { code: "PL.75", suffix: "75", name: "Lublin" },
    { code: "PL.76", suffix: "76", name: "Lubusz" },
    { code: "PL.77", suffix: "77", name: "Lesser Poland" },
    { code: "PL.78", suffix: "78", name: "Mazovia" },
    { code: "PL.79", suffix: "79", name: "Opole Voivodeship" },
    { code: "PL.80", suffix: "80", name: "Subcarpathia" },
    { code: "PL.81", suffix: "81", name: "Podlasie" },
    { code: "PL.82", suffix: "82", name: "Pomerania" },
    { code: "PL.83", suffix: "83", name: "Silesia" },
    { code: "PL.84", suffix: "84", name: "Świętokrzyskie" },
    { code: "PL.85", suffix: "85", name: "Warmia-Masuria" },
    { code: "PL.86", suffix: "86", name: "Greater Poland" },
    { code: "PL.87", suffix: "87", name: "West Pomerania" },
  ],
  "PM": [
    { code: "PM.97501", suffix: "97501", name: "Miquelon-Langlade" },
    { code: "PM.97502", suffix: "97502", name: "Saint-Pierre" },
  ],
  "PR": [
    { code: "PR.001", suffix: "001", name: "Adjuntas" },
    { code: "PR.003", suffix: "003", name: "Aguada" },
    { code: "PR.005", suffix: "005", name: "Aguadilla" },
    { code: "PR.007", suffix: "007", name: "Aguas Buenas" },
    { code: "PR.009", suffix: "009", name: "Aibonito" },
    { code: "PR.011", suffix: "011", name: "Añasco" },
    { code: "PR.013", suffix: "013", name: "Arecibo" },
    { code: "PR.015", suffix: "015", name: "Arroyo" },
    { code: "PR.017", suffix: "017", name: "Barceloneta" },
    { code: "PR.019", suffix: "019", name: "Barranquitas" },
    { code: "PR.021", suffix: "021", name: "Bayamón" },
    { code: "PR.023", suffix: "023", name: "Cabo Rojo" },
    { code: "PR.025", suffix: "025", name: "Caguas" },
    { code: "PR.027", suffix: "027", name: "Camuy" },
    { code: "PR.029", suffix: "029", name: "Canóvanas" },
    { code: "PR.031", suffix: "031", name: "Carolina" },
    { code: "PR.033", suffix: "033", name: "Cataño" },
    { code: "PR.035", suffix: "035", name: "Cayey" },
    { code: "PR.037", suffix: "037", name: "Ceiba" },
    { code: "PR.039", suffix: "039", name: "Ciales" },
    { code: "PR.041", suffix: "041", name: "Cidra" },
    { code: "PR.043", suffix: "043", name: "Coamo" },
    { code: "PR.045", suffix: "045", name: "Comerío" },
    { code: "PR.047", suffix: "047", name: "Corozal" },
    { code: "PR.049", suffix: "049", name: "Culebra" },
    { code: "PR.051", suffix: "051", name: "Dorado" },
    { code: "PR.053", suffix: "053", name: "Fajardo" },
    { code: "PR.054", suffix: "054", name: "Florida" },
    { code: "PR.055", suffix: "055", name: "Guánica" },
    { code: "PR.057", suffix: "057", name: "Guayama" },
    { code: "PR.059", suffix: "059", name: "Guayanilla" },
    { code: "PR.061", suffix: "061", name: "Guaynabo" },
    { code: "PR.063", suffix: "063", name: "Gurabo" },
    { code: "PR.065", suffix: "065", name: "Hatillo" },
    { code: "PR.067", suffix: "067", name: "Hormigueros" },
    { code: "PR.069", suffix: "069", name: "Humacao" },
    { code: "PR.071", suffix: "071", name: "Isabela" },
    { code: "PR.073", suffix: "073", name: "Jayuya" },
    { code: "PR.075", suffix: "075", name: "Juana Díaz" },
    { code: "PR.077", suffix: "077", name: "Juncos" },
    { code: "PR.079", suffix: "079", name: "Lajas" },
    { code: "PR.081", suffix: "081", name: "Lares" },
    { code: "PR.083", suffix: "083", name: "Las Marías" },
    { code: "PR.085", suffix: "085", name: "Las Piedras" },
    { code: "PR.087", suffix: "087", name: "Loíza" },
    { code: "PR.089", suffix: "089", name: "Luquillo" },
    { code: "PR.091", suffix: "091", name: "Manatí" },
    { code: "PR.093", suffix: "093", name: "Maricao" },
    { code: "PR.095", suffix: "095", name: "Maunabo" },
    { code: "PR.097", suffix: "097", name: "Mayagüez" },
    { code: "PR.099", suffix: "099", name: "Moca" },
    { code: "PR.101", suffix: "101", name: "Morovis" },
    { code: "PR.103", suffix: "103", name: "Naguabo" },
    { code: "PR.105", suffix: "105", name: "Naranjito" },
    { code: "PR.107", suffix: "107", name: "Orocovis" },
    { code: "PR.109", suffix: "109", name: "Patillas" },
    { code: "PR.111", suffix: "111", name: "Peñuelas" },
    { code: "PR.113", suffix: "113", name: "Ponce" },
    { code: "PR.115", suffix: "115", name: "Quebradillas" },
    { code: "PR.117", suffix: "117", name: "Rincón" },
    { code: "PR.119", suffix: "119", name: "Río Grande" },
    { code: "PR.121", suffix: "121", name: "Sabana Grande" },
    { code: "PR.123", suffix: "123", name: "Salinas" },
    { code: "PR.125", suffix: "125", name: "San Germán" },
    { code: "PR.127", suffix: "127", name: "San Juan" },
    { code: "PR.129", suffix: "129", name: "San Lorenzo" },
    { code: "PR.131", suffix: "131", name: "San Sebastián" },
    { code: "PR.133", suffix: "133", name: "Santa Isabel" },
    { code: "PR.135", suffix: "135", name: "Toa Alta" },
    { code: "PR.137", suffix: "137", name: "Toa Baja" },
    { code: "PR.139", suffix: "139", name: "Trujillo Alto" },
    { code: "PR.141", suffix: "141", name: "Utuado" },
    { code: "PR.143", suffix: "143", name: "Vega Alta" },
    { code: "PR.145", suffix: "145", name: "Vega Baja" },
    { code: "PR.147", suffix: "147", name: "Vieques" },
    { code: "PR.149", suffix: "149", name: "Villalba" },
    { code: "PR.151", suffix: "151", name: "Yabucoa" },
    { code: "PR.153", suffix: "153", name: "Yauco" },
  ],
  "PS": [
    { code: "PS.GZ", suffix: "GZ", name: "Gaza Strip" },
    { code: "PS.WE", suffix: "WE", name: "West Bank" },
  ],
  "PT": [
    { code: "PT.02", suffix: "02", name: "Aveiro" },
    { code: "PT.03", suffix: "03", name: "Beja" },
    { code: "PT.04", suffix: "04", name: "Braga" },
    { code: "PT.05", suffix: "05", name: "Bragança" },
    { code: "PT.06", suffix: "06", name: "Castelo Branco" },
    { code: "PT.07", suffix: "07", name: "Coimbra" },
    { code: "PT.08", suffix: "08", name: "Évora" },
    { code: "PT.09", suffix: "09", name: "Faro" },
    { code: "PT.10", suffix: "10", name: "Madeira" },
    { code: "PT.11", suffix: "11", name: "Guarda" },
    { code: "PT.13", suffix: "13", name: "Leiria" },
    { code: "PT.14", suffix: "14", name: "Lisbon" },
    { code: "PT.16", suffix: "16", name: "Portalegre" },
    { code: "PT.17", suffix: "17", name: "Porto" },
    { code: "PT.18", suffix: "18", name: "Santarém" },
    { code: "PT.19", suffix: "19", name: "District of Setúbal" },
    { code: "PT.20", suffix: "20", name: "Viana do Castelo" },
    { code: "PT.21", suffix: "21", name: "Vila Real" },
    { code: "PT.22", suffix: "22", name: "Viseu" },
    { code: "PT.23", suffix: "23", name: "Azores" },
  ],
  "PW": [
    { code: "PW.01", suffix: "01", name: "Aimeliik" },
    { code: "PW.02", suffix: "02", name: "Airai" },
    { code: "PW.03", suffix: "03", name: "Angaur" },
    { code: "PW.04", suffix: "04", name: "Hatohobei" },
    { code: "PW.05", suffix: "05", name: "Kayangel" },
    { code: "PW.06", suffix: "06", name: "Koror" },
    { code: "PW.07", suffix: "07", name: "Melekeok" },
    { code: "PW.08", suffix: "08", name: "Ngaraard" },
    { code: "PW.09", suffix: "09", name: "Ngarchelong" },
    { code: "PW.10", suffix: "10", name: "Ngardmau" },
    { code: "PW.11", suffix: "11", name: "Ngatpang" },
    { code: "PW.12", suffix: "12", name: "Ngchesar" },
    { code: "PW.13", suffix: "13", name: "Ngaremlengui" },
    { code: "PW.14", suffix: "14", name: "Ngiwal" },
    { code: "PW.15", suffix: "15", name: "Peleliu" },
    { code: "PW.16", suffix: "16", name: "Sonsorol" },
  ],
  "PY": [
    { code: "PY.01", suffix: "01", name: "Alto Paraná" },
    { code: "PY.02", suffix: "02", name: "Amambay" },
    { code: "PY.04", suffix: "04", name: "Caaguazú" },
    { code: "PY.05", suffix: "05", name: "Caazapá" },
    { code: "PY.06", suffix: "06", name: "Central" },
    { code: "PY.07", suffix: "07", name: "Concepción" },
    { code: "PY.08", suffix: "08", name: "Cordillera" },
    { code: "PY.10", suffix: "10", name: "Guairá" },
    { code: "PY.11", suffix: "11", name: "Itapúa" },
    { code: "PY.12", suffix: "12", name: "Misiones" },
    { code: "PY.13", suffix: "13", name: "Ñeembucú" },
    { code: "PY.15", suffix: "15", name: "Paraguarí" },
    { code: "PY.16", suffix: "16", name: "Presidente Hayes" },
    { code: "PY.17", suffix: "17", name: "San Pedro" },
    { code: "PY.19", suffix: "19", name: "Canindeyú" },
    { code: "PY.22", suffix: "22", name: "Asunción" },
    { code: "PY.23", suffix: "23", name: "Alto Paraguay" },
    { code: "PY.24", suffix: "24", name: "Boquerón" },
  ],
  "QA": [
    { code: "QA.01", suffix: "01", name: "Baladīyat ad Dawḩah" },
    { code: "QA.04", suffix: "04", name: "Al Khor" },
    { code: "QA.06", suffix: "06", name: "Baladīyat ar Rayyān" },
    { code: "QA.08", suffix: "08", name: "Madīnat ash Shamāl" },
    { code: "QA.09", suffix: "09", name: "Baladīyat Umm Şalāl" },
    { code: "QA.10", suffix: "10", name: "Al Wakrah" },
    { code: "QA.13", suffix: "13", name: "Baladīyat az̧ Z̧a‘āyin" },
    { code: "QA.14", suffix: "14", name: "Al-Shahaniya" },
  ],
  "RE": [
    { code: "RE.RE", suffix: "RE", name: "Réunion" },
  ],
  "RO": [
    { code: "RO.01", suffix: "01", name: "Alba" },
    { code: "RO.02", suffix: "02", name: "Arad" },
    { code: "RO.03", suffix: "03", name: "Arges" },
    { code: "RO.04", suffix: "04", name: "Bacău" },
    { code: "RO.05", suffix: "05", name: "Bihor" },
    { code: "RO.06", suffix: "06", name: "Bistriţa-Năsăud" },
    { code: "RO.07", suffix: "07", name: "Botoşani" },
    { code: "RO.08", suffix: "08", name: "Brăila" },
    { code: "RO.09", suffix: "09", name: "Braşov" },
    { code: "RO.10", suffix: "10", name: "Bucureşti" },
    { code: "RO.11", suffix: "11", name: "Buzău" },
    { code: "RO.12", suffix: "12", name: "Caraş-Severin" },
    { code: "RO.13", suffix: "13", name: "Cluj" },
    { code: "RO.14", suffix: "14", name: "Constanța" },
    { code: "RO.15", suffix: "15", name: "Covasna" },
    { code: "RO.16", suffix: "16", name: "Dâmboviţa" },
    { code: "RO.17", suffix: "17", name: "Dolj" },
    { code: "RO.18", suffix: "18", name: "Galaţi" },
    { code: "RO.19", suffix: "19", name: "Gorj" },
    { code: "RO.20", suffix: "20", name: "Harghita" },
    { code: "RO.21", suffix: "21", name: "Hunedoara" },
    { code: "RO.22", suffix: "22", name: "Ialomiţa" },
    { code: "RO.23", suffix: "23", name: "Iaşi" },
    { code: "RO.25", suffix: "25", name: "Maramureş" },
    { code: "RO.26", suffix: "26", name: "Mehedinţi" },
    { code: "RO.27", suffix: "27", name: "Mureş" },
    { code: "RO.28", suffix: "28", name: "Neamţ" },
    { code: "RO.29", suffix: "29", name: "Olt" },
    { code: "RO.30", suffix: "30", name: "Prahova" },
    { code: "RO.31", suffix: "31", name: "Sălaj" },
    { code: "RO.32", suffix: "32", name: "Satu Mare" },
    { code: "RO.33", suffix: "33", name: "Sibiu" },
    { code: "RO.34", suffix: "34", name: "Suceava" },
    { code: "RO.35", suffix: "35", name: "Teleorman" },
    { code: "RO.36", suffix: "36", name: "Timiş" },
    { code: "RO.37", suffix: "37", name: "Tulcea" },
    { code: "RO.38", suffix: "38", name: "Vaslui" },
    { code: "RO.39", suffix: "39", name: "Vâlcea" },
    { code: "RO.40", suffix: "40", name: "Vrancea" },
    { code: "RO.41", suffix: "41", name: "Călăraşi" },
    { code: "RO.42", suffix: "42", name: "Giurgiu" },
    { code: "RO.43", suffix: "43", name: "Ilfov" },
  ],
  "RS": [
    { code: "RS.SE", suffix: "SE", name: "Central Serbia" },
    { code: "RS.VO", suffix: "VO", name: "Vojvodina" },
  ],
  "RU": [
    { code: "RU.01", suffix: "01", name: "Adygeya Republic" },
    { code: "RU.03", suffix: "03", name: "Altai" },
    { code: "RU.04", suffix: "04", name: "Altai Krai" },
    { code: "RU.05", suffix: "05", name: "Amur Oblast" },
    { code: "RU.06", suffix: "06", name: "Arkhangelskaya" },
    { code: "RU.07", suffix: "07", name: "Astrakhan" },
    { code: "RU.08", suffix: "08", name: "Bashkortostan Republic" },
    { code: "RU.09", suffix: "09", name: "Belgorod Oblast" },
    { code: "RU.10", suffix: "10", name: "Bryansk Oblast" },
    { code: "RU.11", suffix: "11", name: "Buryatiya Republic" },
    { code: "RU.12", suffix: "12", name: "Chechnya" },
    { code: "RU.13", suffix: "13", name: "Chelyabinsk" },
    { code: "RU.15", suffix: "15", name: "Chukotka" },
    { code: "RU.16", suffix: "16", name: "Chuvashia" },
    { code: "RU.17", suffix: "17", name: "Dagestan" },
    { code: "RU.19", suffix: "19", name: "Ingushetiya Republic" },
    { code: "RU.20", suffix: "20", name: "Irkutsk Oblast" },
    { code: "RU.21", suffix: "21", name: "Ivanovo" },
    { code: "RU.22", suffix: "22", name: "Kabardino-Balkariya Republic" },
    { code: "RU.23", suffix: "23", name: "Kaliningrad" },
    { code: "RU.24", suffix: "24", name: "Kalmykiya Republic" },
    { code: "RU.25", suffix: "25", name: "Kaluga" },
    { code: "RU.27", suffix: "27", name: "Karachayevo-Cherkesiya Republic" },
    { code: "RU.28", suffix: "28", name: "Karelia" },
    { code: "RU.29", suffix: "29", name: "Kemerovo Oblast" },
    { code: "RU.30", suffix: "30", name: "Khabarovsk" },
    { code: "RU.31", suffix: "31", name: "Khakasiya Republic" },
    { code: "RU.32", suffix: "32", name: "Khanty-Mansia" },
    { code: "RU.33", suffix: "33", name: "Kirov" },
    { code: "RU.34", suffix: "34", name: "Komi" },
    { code: "RU.37", suffix: "37", name: "Kostroma Oblast" },
    { code: "RU.38", suffix: "38", name: "Krasnodarskiy" },
    { code: "RU.40", suffix: "40", name: "Kurgan Oblast" },
    { code: "RU.41", suffix: "41", name: "Kursk" },
    { code: "RU.42", suffix: "42", name: "Leningradskaya Oblast'" },
    { code: "RU.43", suffix: "43", name: "Lipetsk Oblast" },
    { code: "RU.44", suffix: "44", name: "Magadan Oblast" },
    { code: "RU.45", suffix: "45", name: "Mariy-El Republic" },
    { code: "RU.46", suffix: "46", name: "Mordoviya Republic" },
    { code: "RU.47", suffix: "47", name: "Moscow Oblast" },
    { code: "RU.48", suffix: "48", name: "Moscow" },
    { code: "RU.49", suffix: "49", name: "Murmansk" },
    { code: "RU.50", suffix: "50", name: "Nenets" },
    { code: "RU.51", suffix: "51", name: "Nizhny Novgorod Oblast" },
    { code: "RU.52", suffix: "52", name: "Novgorod Oblast" },
    { code: "RU.53", suffix: "53", name: "Novosibirsk Oblast" },
    { code: "RU.54", suffix: "54", name: "Omsk" },
    { code: "RU.55", suffix: "55", name: "Orenburg Oblast" },
    { code: "RU.56", suffix: "56", name: "Orel Oblast" },
    { code: "RU.57", suffix: "57", name: "Penza" },
    { code: "RU.59", suffix: "59", name: "Primorskiy (Maritime) Kray" },
    { code: "RU.60", suffix: "60", name: "Pskov Oblast" },
    { code: "RU.61", suffix: "61", name: "Rostov" },
    { code: "RU.62", suffix: "62", name: "Ryazan Oblast" },
    { code: "RU.63", suffix: "63", name: "Sakha" },
    { code: "RU.64", suffix: "64", name: "Sakhalin Oblast" },
    { code: "RU.65", suffix: "65", name: "Samara Oblast" },
    { code: "RU.66", suffix: "66", name: "St.-Petersburg" },
    { code: "RU.67", suffix: "67", name: "Saratovskaya Oblast" },
    { code: "RU.68", suffix: "68", name: "North Ossetia" },
    { code: "RU.69", suffix: "69", name: "Smolensk" },
    { code: "RU.70", suffix: "70", name: "Stavropol’ Kray" },
    { code: "RU.71", suffix: "71", name: "Sverdlovsk" },
    { code: "RU.72", suffix: "72", name: "Tambov" },
    { code: "RU.73", suffix: "73", name: "Tatarstan Republic" },
    { code: "RU.75", suffix: "75", name: "Tomsk Oblast" },
    { code: "RU.76", suffix: "76", name: "Tula" },
    { code: "RU.77", suffix: "77", name: "Tver’ Oblast" },
    { code: "RU.78", suffix: "78", name: "Tyumen’ Oblast" },
    { code: "RU.79", suffix: "79", name: "Republic of Tyva" },
    { code: "RU.80", suffix: "80", name: "Udmurtiya Republic" },
    { code: "RU.81", suffix: "81", name: "Ulyanovsk" },
    { code: "RU.83", suffix: "83", name: "Vladimir" },
    { code: "RU.84", suffix: "84", name: "Volgograd Oblast" },
    { code: "RU.85", suffix: "85", name: "Vologda" },
    { code: "RU.86", suffix: "86", name: "Voronezj" },
    { code: "RU.87", suffix: "87", name: "Yamalo-Nenets" },
    { code: "RU.88", suffix: "88", name: "Jaroslavl" },
    { code: "RU.89", suffix: "89", name: "Jewish Autonomous Oblast" },
    { code: "RU.90", suffix: "90", name: "Perm" },
    { code: "RU.91", suffix: "91", name: "Krasnoyarskiy" },
    { code: "RU.92", suffix: "92", name: "Kamchatka" },
    { code: "RU.93", suffix: "93", name: "Transbaikal Territory" },
  ],
  "RW": [
    { code: "RW.11", suffix: "11", name: "Eastern Province" },
    { code: "RW.12", suffix: "12", name: "Kigali" },
    { code: "RW.13", suffix: "13", name: "Northern Province" },
    { code: "RW.14", suffix: "14", name: "Western Province" },
    { code: "RW.15", suffix: "15", name: "Southern Province" },
  ],
  "SA": [
    { code: "SA.02", suffix: "02", name: "Al Bahah" },
    { code: "SA.05", suffix: "05", name: "Al Madīnah al Munawwarah" },
    { code: "SA.06", suffix: "06", name: "Eastern Province" },
    { code: "SA.08", suffix: "08", name: "Al-Qassim" },
    { code: "SA.10", suffix: "10", name: "Ar Riyāḑ" },
    { code: "SA.11", suffix: "11", name: "'Asir" },
    { code: "SA.13", suffix: "13", name: "Ḩāʼil" },
    { code: "SA.14", suffix: "14", name: "Makkah" },
    { code: "SA.15", suffix: "15", name: "Northern Borders" },
    { code: "SA.16", suffix: "16", name: "Najran" },
    { code: "SA.17", suffix: "17", name: "Jizan" },
    { code: "SA.19", suffix: "19", name: "Tabuk" },
    { code: "SA.20", suffix: "20", name: "Al Jawf" },
  ],
  "SB": [
    { code: "SB.03", suffix: "03", name: "Malaita" },
    { code: "SB.06", suffix: "06", name: "Guadalcanal" },
    { code: "SB.07", suffix: "07", name: "Isabel" },
    { code: "SB.08", suffix: "08", name: "Makira" },
    { code: "SB.09", suffix: "09", name: "Temotu" },
    { code: "SB.10", suffix: "10", name: "Central Province" },
    { code: "SB.11", suffix: "11", name: "Western Province" },
    { code: "SB.12", suffix: "12", name: "Choiseul" },
    { code: "SB.13", suffix: "13", name: "Rennell and Bellona" },
    { code: "SB.14", suffix: "14", name: "Honiara" },
  ],
  "SC": [
    { code: "SC.01", suffix: "01", name: "Anse-aux-Pins" },
    { code: "SC.02", suffix: "02", name: "Anse Boileau" },
    { code: "SC.03", suffix: "03", name: "Anse Etoile" },
    { code: "SC.05", suffix: "05", name: "Anse Royale" },
    { code: "SC.06", suffix: "06", name: "Baie Lazare" },
    { code: "SC.07", suffix: "07", name: "Baie Sainte Anne" },
    { code: "SC.08", suffix: "08", name: "Beau Vallon" },
    { code: "SC.09", suffix: "09", name: "Bel Air" },
    { code: "SC.10", suffix: "10", name: "Bel Ombre" },
    { code: "SC.11", suffix: "11", name: "Cascade" },
    { code: "SC.11876017", suffix: "11876017", name: "Outer Islands" },
    { code: "SC.12", suffix: "12", name: "Glacis" },
    { code: "SC.14", suffix: "14", name: "Grand Anse Praslin" },
    { code: "SC.17", suffix: "17", name: "Mont Buxton" },
    { code: "SC.18", suffix: "18", name: "Mont Fleuri" },
    { code: "SC.19", suffix: "19", name: "Plaisance" },
    { code: "SC.20", suffix: "20", name: "Pointe Larue" },
    { code: "SC.22", suffix: "22", name: "Saint Louis" },
    { code: "SC.23", suffix: "23", name: "Takamaka" },
    { code: "SC.24", suffix: "24", name: "Grand Anse Mahe" },
    { code: "SC.25", suffix: "25", name: "Inner Islands" },
    { code: "SC.26", suffix: "26", name: "English River" },
    { code: "SC.27", suffix: "27", name: "Port Glaud" },
    { code: "SC.28", suffix: "28", name: "Au Cap" },
    { code: "SC.29", suffix: "29", name: "Les Mamelles" },
    { code: "SC.30", suffix: "30", name: "Roche Caiman" },
  ],
  "SD": [
    { code: "SD.29", suffix: "29", name: "Khartoum" },
    { code: "SD.36", suffix: "36", name: "Red Sea" },
    { code: "SD.38", suffix: "38", name: "Al Jazīrah" },
    { code: "SD.39", suffix: "39", name: "Al Qaḑārif" },
    { code: "SD.41", suffix: "41", name: "White Nile" },
    { code: "SD.42", suffix: "42", name: "Blue Nile" },
    { code: "SD.43", suffix: "43", name: "Northern State" },
    { code: "SD.47", suffix: "47", name: "Western Darfur" },
    { code: "SD.49", suffix: "49", name: "Southern Darfur" },
    { code: "SD.50", suffix: "50", name: "Southern Kordofan" },
    { code: "SD.52", suffix: "52", name: "Kassala" },
    { code: "SD.53", suffix: "53", name: "River Nile" },
    { code: "SD.55", suffix: "55", name: "Northern Darfur" },
    { code: "SD.56", suffix: "56", name: "North Kordofan" },
    { code: "SD.58", suffix: "58", name: "Sinnār" },
    { code: "SD.60", suffix: "60", name: "Eastern Darfur" },
    { code: "SD.61", suffix: "61", name: "Central Darfur" },
    { code: "SD.62", suffix: "62", name: "West Kordofan State" },
  ],
  "SE": [
    { code: "SE.02", suffix: "02", name: "Blekinge" },
    { code: "SE.03", suffix: "03", name: "Gävleborg" },
    { code: "SE.05", suffix: "05", name: "Gotland" },
    { code: "SE.06", suffix: "06", name: "Halland" },
    { code: "SE.07", suffix: "07", name: "Jämtland" },
    { code: "SE.08", suffix: "08", name: "Jönköping" },
    { code: "SE.09", suffix: "09", name: "Kalmar" },
    { code: "SE.10", suffix: "10", name: "Dalarna" },
    { code: "SE.12", suffix: "12", name: "Kronoberg" },
    { code: "SE.14", suffix: "14", name: "Norrbotten" },
    { code: "SE.15", suffix: "15", name: "Örebro" },
    { code: "SE.16", suffix: "16", name: "Östergötland" },
    { code: "SE.18", suffix: "18", name: "Södermanland" },
    { code: "SE.21", suffix: "21", name: "Uppsala" },
    { code: "SE.22", suffix: "22", name: "Värmland" },
    { code: "SE.23", suffix: "23", name: "Västerbotten" },
    { code: "SE.24", suffix: "24", name: "Västernorrland" },
    { code: "SE.25", suffix: "25", name: "Västmanland" },
    { code: "SE.26", suffix: "26", name: "Stockholm" },
    { code: "SE.27", suffix: "27", name: "Skåne" },
    { code: "SE.28", suffix: "28", name: "Västra Götaland" },
  ],
  "SH": [
    { code: "SH.01", suffix: "01", name: "Ascension" },
    { code: "SH.02", suffix: "02", name: "Saint Helena" },
    { code: "SH.03", suffix: "03", name: "Tristan da Cunha" },
  ],
  "SI": [
    { code: "SI.01", suffix: "01", name: "Ajdovščina" },
    { code: "SI.02", suffix: "02", name: "Beltinci" },
    { code: "SI.03", suffix: "03", name: "Bled" },
    { code: "SI.04", suffix: "04", name: "Bohinj" },
    { code: "SI.05", suffix: "05", name: "Borovnica" },
    { code: "SI.06", suffix: "06", name: "Bovec" },
    { code: "SI.07", suffix: "07", name: "Brda" },
    { code: "SI.08", suffix: "08", name: "Brežice" },
    { code: "SI.09", suffix: "09", name: "Brezovica" },
    { code: "SI.11", suffix: "11", name: "Celje" },
    { code: "SI.12", suffix: "12", name: "Cerklje na Gorenjskem" },
    { code: "SI.13", suffix: "13", name: "Cerknica" },
    { code: "SI.14", suffix: "14", name: "Cerkno" },
    { code: "SI.15", suffix: "15", name: "Črenšovci" },
    { code: "SI.16", suffix: "16", name: "Črna na Koroškem" },
    { code: "SI.17", suffix: "17", name: "Črnomelj" },
    { code: "SI.19", suffix: "19", name: "Divača" },
    { code: "SI.20", suffix: "20", name: "Dobrepolje" },
    { code: "SI.22", suffix: "22", name: "Dol pri Ljubljani" },
    { code: "SI.24", suffix: "24", name: "Dornava" },
    { code: "SI.25", suffix: "25", name: "Dravograd" },
    { code: "SI.26", suffix: "26", name: "Duplek" },
    { code: "SI.27", suffix: "27", name: "Gorenja Vas-Poljane" },
    { code: "SI.28", suffix: "28", name: "Gorišnica" },
    { code: "SI.29", suffix: "29", name: "Gornja Radgona" },
    { code: "SI.30", suffix: "30", name: "Gornji Grad" },
    { code: "SI.31", suffix: "31", name: "Gornji Petrovci" },
    { code: "SI.32", suffix: "32", name: "Grosuplje" },
    { code: "SI.34", suffix: "34", name: "Hrastnik" },
    { code: "SI.35", suffix: "35", name: "Hrpelje-Kozina" },
    { code: "SI.36", suffix: "36", name: "Idrija" },
    { code: "SI.37", suffix: "37", name: "Ig" },
    { code: "SI.38", suffix: "38", name: "Ilirska Bistrica" },
    { code: "SI.39", suffix: "39", name: "Ivančna Gorica" },
    { code: "SI.40", suffix: "40", name: "Izola-Isola" },
    { code: "SI.42", suffix: "42", name: "Juršinci" },
    { code: "SI.44", suffix: "44", name: "Kanal" },
    { code: "SI.45", suffix: "45", name: "Kidričevo" },
    { code: "SI.46", suffix: "46", name: "Kobarid" },
    { code: "SI.47", suffix: "47", name: "Kobilje" },
    { code: "SI.49", suffix: "49", name: "Komen" },
    { code: "SI.50", suffix: "50", name: "Koper-Capodistria" },
    { code: "SI.51", suffix: "51", name: "Kozje" },
    { code: "SI.52", suffix: "52", name: "Kranj" },
    { code: "SI.53", suffix: "53", name: "Kranjska Gora" },
    { code: "SI.54", suffix: "54", name: "Krško" },
    { code: "SI.55", suffix: "55", name: "Kungota" },
    { code: "SI.57", suffix: "57", name: "Laško" },
    { code: "SI.61", suffix: "61", name: "Ljubljana" },
    { code: "SI.62", suffix: "62", name: "Ljubno" },
    { code: "SI.64", suffix: "64", name: "Logatec" },
    { code: "SI.66", suffix: "66", name: "Loški Potok" },
    { code: "SI.68", suffix: "68", name: "Lukovica" },
    { code: "SI.71", suffix: "71", name: "Medvode" },
    { code: "SI.72", suffix: "72", name: "Mengeš" },
    { code: "SI.73", suffix: "73", name: "Metlika" },
    { code: "SI.74", suffix: "74", name: "Mežica" },
    { code: "SI.76", suffix: "76", name: "Mislinja" },
    { code: "SI.77", suffix: "77", name: "Moravče" },
    { code: "SI.78", suffix: "78", name: "Moravske Toplice" },
    { code: "SI.79", suffix: "79", name: "Mozirje" },
    { code: "SI.80", suffix: "80", name: "Murska Sobota" },
    { code: "SI.81", suffix: "81", name: "Muta" },
    { code: "SI.82", suffix: "82", name: "Naklo" },
    { code: "SI.83", suffix: "83", name: "Nazarje" },
    { code: "SI.84", suffix: "84", name: "Nova Gorica" },
    { code: "SI.86", suffix: "86", name: "Odranci" },
    { code: "SI.87", suffix: "87", name: "Ormož" },
    { code: "SI.88", suffix: "88", name: "Osilnica" },
    { code: "SI.89", suffix: "89", name: "Pesnica" },
    { code: "SI.91", suffix: "91", name: "Pivka" },
    { code: "SI.92", suffix: "92", name: "Podčetrtek" },
    { code: "SI.94", suffix: "94", name: "Postojna" },
    { code: "SI.97", suffix: "97", name: "Puconci" },
    { code: "SI.98", suffix: "98", name: "Rače-Fram" },
    { code: "SI.99", suffix: "99", name: "Radeče" },
    { code: "SI.A1", suffix: "A1", name: "Radenci" },
    { code: "SI.A2", suffix: "A2", name: "Radlje ob Dravi" },
    { code: "SI.A3", suffix: "A3", name: "Radovljica" },
    { code: "SI.A6", suffix: "A6", name: "Rogašovci" },
    { code: "SI.A7", suffix: "A7", name: "Rogaška Slatina" },
    { code: "SI.A8", suffix: "A8", name: "Rogatec" },
    { code: "SI.B1", suffix: "B1", name: "Semič" },
    { code: "SI.B2", suffix: "B2", name: "Šenčur" },
    { code: "SI.B3", suffix: "B3", name: "Šentilj" },
    { code: "SI.B4", suffix: "B4", name: "Šentjernej" },
    { code: "SI.B6", suffix: "B6", name: "Sevnica" },
    { code: "SI.B7", suffix: "B7", name: "Sežana" },
    { code: "SI.B8", suffix: "B8", name: "Škocjan" },
    { code: "SI.B9", suffix: "B9", name: "Škofja Loka" },
    { code: "SI.C1", suffix: "C1", name: "Škofljica" },
    { code: "SI.C2", suffix: "C2", name: "Slovenj Gradec" },
    { code: "SI.C4", suffix: "C4", name: "Slovenska Konjice" },
    { code: "SI.C5", suffix: "C5", name: "Šmarje pri Jelšah" },
    { code: "SI.C6", suffix: "C6", name: "Šmartno ob Paki" },
    { code: "SI.C7", suffix: "C7", name: "Šoštanj" },
    { code: "SI.C8", suffix: "C8", name: "Starše" },
    { code: "SI.C9", suffix: "C9", name: "Štore" },
    { code: "SI.D1", suffix: "D1", name: "Sveti Jurij" },
    { code: "SI.D2", suffix: "D2", name: "Tolmin" },
    { code: "SI.D3", suffix: "D3", name: "Trbovlje" },
    { code: "SI.D4", suffix: "D4", name: "Trebnje" },
    { code: "SI.D5", suffix: "D5", name: "Tržič" },
    { code: "SI.D6", suffix: "D6", name: "Turnišče" },
    { code: "SI.D7", suffix: "D7", name: "Velenje" },
    { code: "SI.D8", suffix: "D8", name: "Velike Lašče" },
    { code: "SI.E1", suffix: "E1", name: "Vipava" },
    { code: "SI.E2", suffix: "E2", name: "Vitanje" },
    { code: "SI.E3", suffix: "E3", name: "Vodice" },
    { code: "SI.E5", suffix: "E5", name: "Vrhnika" },
    { code: "SI.E6", suffix: "E6", name: "Vuzenica" },
    { code: "SI.E7", suffix: "E7", name: "Zagorje ob Savi" },
    { code: "SI.E9", suffix: "E9", name: "Zavrč" },
    { code: "SI.F1", suffix: "F1", name: "Železniki" },
    { code: "SI.F2", suffix: "F2", name: "Žiri" },
    { code: "SI.F3", suffix: "F3", name: "Zreče" },
    { code: "SI.F4", suffix: "F4", name: "Benedikt" },
    { code: "SI.F5", suffix: "F5", name: "Bistrica ob Sotli" },
    { code: "SI.F6", suffix: "F6", name: "Bloke" },
    { code: "SI.F7", suffix: "F7", name: "Braslovče" },
    { code: "SI.F8", suffix: "F8", name: "Cankova" },
    { code: "SI.F9", suffix: "F9", name: "Cerkvenjak" },
    { code: "SI.G1", suffix: "G1", name: "Destrnik" },
    { code: "SI.G2", suffix: "G2", name: "Dobje" },
    { code: "SI.G3", suffix: "G3", name: "Dobrna" },
    { code: "SI.G4", suffix: "G4", name: "Dobrova-Horjul-Polhov Gradec" },
    { code: "SI.G5", suffix: "G5", name: "Dobrovnik-Dobronak" },
    { code: "SI.G6", suffix: "G6", name: "Dolenjske Toplice" },
    { code: "SI.G7", suffix: "G7", name: "Domžale" },
    { code: "SI.G8", suffix: "G8", name: "Grad" },
    { code: "SI.G9", suffix: "G9", name: "Hajdina" },
    { code: "SI.H1", suffix: "H1", name: "Hoče-Slivnica" },
    { code: "SI.H2", suffix: "H2", name: "Hodoš-Hodos" },
    { code: "SI.H3", suffix: "H3", name: "Horjul" },
    { code: "SI.H4", suffix: "H4", name: "Jesenice" },
    { code: "SI.H5", suffix: "H5", name: "Jezersko" },
    { code: "SI.H6", suffix: "H6", name: "Kamnik" },
    { code: "SI.H7", suffix: "H7", name: "Kočevje" },
    { code: "SI.H8", suffix: "H8", name: "Komenda" },
    { code: "SI.H9", suffix: "H9", name: "Kostel" },
    { code: "SI.I1", suffix: "I1", name: "Križevci" },
    { code: "SI.I2", suffix: "I2", name: "Kuzma" },
    { code: "SI.I3", suffix: "I3", name: "Lenart" },
    { code: "SI.I4", suffix: "I4", name: "Lendava-Lendva" },
    { code: "SI.I5", suffix: "I5", name: "Litija" },
    { code: "SI.I6", suffix: "I6", name: "Ljutomer" },
    { code: "SI.I7", suffix: "I7", name: "Loška Dolina" },
    { code: "SI.I8", suffix: "I8", name: "Lovrenc na Pohorju" },
    { code: "SI.I9", suffix: "I9", name: "Luče" },
    { code: "SI.J1", suffix: "J1", name: "Majšperk" },
    { code: "SI.J2", suffix: "J2", name: "Maribor" },
    { code: "SI.J3", suffix: "J3", name: "Markovci" },
    { code: "SI.J4", suffix: "J4", name: "Miklavž na Dravskem Polju" },
    { code: "SI.J5", suffix: "J5", name: "Miren-Kostanjevica" },
    { code: "SI.J6", suffix: "J6", name: "Mirna Peč" },
    { code: "SI.J7", suffix: "J7", name: "Novo Mesto" },
    { code: "SI.J8", suffix: "J8", name: "Oplotnica" },
    { code: "SI.J9", suffix: "J9", name: "Piran-Pirano" },
    { code: "SI.K1", suffix: "K1", name: "Podlehnik" },
    { code: "SI.K2", suffix: "K2", name: "Podvelka" },
    { code: "SI.K3", suffix: "K3", name: "Polzela" },
    { code: "SI.K4", suffix: "K4", name: "Prebold" },
    { code: "SI.K5", suffix: "K5", name: "Preddvor" },
    { code: "SI.K6", suffix: "K6", name: "Prevalje" },
    { code: "SI.K7", suffix: "K7", name: "Ptuj" },
    { code: "SI.K8", suffix: "K8", name: "Ravne na Koroškem" },
    { code: "SI.K9", suffix: "K9", name: "Razkrižje" },
    { code: "SI.L1", suffix: "L1", name: "Ribnica" },
    { code: "SI.L2", suffix: "L2", name: "Ribnica na Pohorju" },
    { code: "SI.L3", suffix: "L3", name: "Ruše" },
    { code: "SI.L4", suffix: "L4", name: "Šalovci" },
    { code: "SI.L5", suffix: "L5", name: "Selnica ob Dravi" },
    { code: "SI.L6", suffix: "L6", name: "Šempeter-Vrtojba" },
    { code: "SI.L7", suffix: "L7", name: "Sentjur" },
    { code: "SI.L8", suffix: "L8", name: "Slovenska Bistrica" },
    { code: "SI.L9", suffix: "L9", name: "Šmartno pri Litiji" },
    { code: "SI.M1", suffix: "M1", name: "Sodražica" },
    { code: "SI.M2", suffix: "M2", name: "Solčava" },
    { code: "SI.M3", suffix: "M3", name: "Sveta Ana" },
    { code: "SI.M4", suffix: "M4", name: "Sveti Andraž v Slovenskih Goricah" },
    { code: "SI.M5", suffix: "M5", name: "Tabor" },
    { code: "SI.M6", suffix: "M6", name: "Tišina" },
    { code: "SI.M7", suffix: "M7", name: "Trnovska Vas" },
    { code: "SI.M8", suffix: "M8", name: "Trzin" },
    { code: "SI.M9", suffix: "M9", name: "Velika Polana" },
    { code: "SI.N1", suffix: "N1", name: "Veržej" },
    { code: "SI.N2", suffix: "N2", name: "Videm" },
    { code: "SI.N3", suffix: "N3", name: "Vojnik" },
    { code: "SI.N4", suffix: "N4", name: "Vransko" },
    { code: "SI.N5", suffix: "N5", name: "Žalec" },
    { code: "SI.N6", suffix: "N6", name: "Žetale" },
    { code: "SI.N7", suffix: "N7", name: "Žirovnica" },
    { code: "SI.N8", suffix: "N8", name: "Žužemberk" },
    { code: "SI.N9", suffix: "N9", name: "Apače" },
    { code: "SI.O1", suffix: "O1", name: "Cirkulane" },
    { code: "SI.O2", suffix: "O2", name: "Gorje" },
    { code: "SI.O3", suffix: "O3", name: "Kostanjevica na Krki" },
    { code: "SI.O4", suffix: "O4", name: "Log–Dragomer" },
    { code: "SI.O5", suffix: "O5", name: "Makole" },
    { code: "SI.O6", suffix: "O6", name: "Mirna" },
    { code: "SI.O7", suffix: "O7", name: "Mokronog-Trebelno" },
    { code: "SI.O8", suffix: "O8", name: "Poljčane" },
    { code: "SI.O9", suffix: "O9", name: "Rečica ob Savinji" },
    { code: "SI.P1", suffix: "P1", name: "Renče-Vogrsko" },
    { code: "SI.P2", suffix: "P2", name: "Šentrupert" },
    { code: "SI.P3", suffix: "P3", name: "Šmarješke Toplice" },
    { code: "SI.P4", suffix: "P4", name: "Središče ob Dravi" },
    { code: "SI.P5", suffix: "P5", name: "Straža" },
    { code: "SI.P6", suffix: "P6", name: "Sv. Trojica v Slov. Goricah" },
    { code: "SI.P7", suffix: "P7", name: "Sveti Jurij v Slovenskih Goricah" },
    { code: "SI.P8", suffix: "P8", name: "Sveti Tomaž" },
    { code: "SI.P9", suffix: "P9", name: "Ankaran" },
  ],
  "SJ": [
    { code: "SJ.21", suffix: "21", name: "Svalbard" },
    { code: "SJ.22", suffix: "22", name: "Jan Mayen" },
  ],
  "SK": [
    { code: "SK.01", suffix: "01", name: "Banskobystrický kraj" },
    { code: "SK.02", suffix: "02", name: "Bratislavský kraj" },
    { code: "SK.03", suffix: "03", name: "Košický kraj" },
    { code: "SK.04", suffix: "04", name: "Nitriansky kraj" },
    { code: "SK.05", suffix: "05", name: "Prešovský kraj" },
    { code: "SK.06", suffix: "06", name: "Trenčiansky kraj" },
    { code: "SK.07", suffix: "07", name: "Trnavský kraj" },
    { code: "SK.08", suffix: "08", name: "Žilinský kraj" },
  ],
  "SL": [
    { code: "SL.01", suffix: "01", name: "Eastern Province" },
    { code: "SL.02", suffix: "02", name: "Northern Province" },
    { code: "SL.03", suffix: "03", name: "Southern Province" },
    { code: "SL.04", suffix: "04", name: "Western Area" },
    { code: "SL.05", suffix: "05", name: "North West" },
  ],
  "SM": [
    { code: "SM.01", suffix: "01", name: "Acquaviva" },
    { code: "SM.02", suffix: "02", name: "Chiesanuova" },
    { code: "SM.03", suffix: "03", name: "Domagnano" },
    { code: "SM.04", suffix: "04", name: "Faetano" },
    { code: "SM.05", suffix: "05", name: "Fiorentino" },
    { code: "SM.06", suffix: "06", name: "Borgo Maggiore" },
    { code: "SM.07", suffix: "07", name: "San Marino" },
    { code: "SM.08", suffix: "08", name: "Montegiardino" },
    { code: "SM.09", suffix: "09", name: "Serravalle" },
  ],
  "SN": [
    { code: "SN.01", suffix: "01", name: "Dakar" },
    { code: "SN.03", suffix: "03", name: "Diourbel" },
    { code: "SN.05", suffix: "05", name: "Tambacounda" },
    { code: "SN.07", suffix: "07", name: "Thiès" },
    { code: "SN.09", suffix: "09", name: "Fatick" },
    { code: "SN.10", suffix: "10", name: "Kaolack" },
    { code: "SN.11", suffix: "11", name: "Kolda" },
    { code: "SN.12", suffix: "12", name: "Ziguinchor" },
    { code: "SN.13", suffix: "13", name: "Louga" },
    { code: "SN.14", suffix: "14", name: "Saint-Louis" },
    { code: "SN.15", suffix: "15", name: "Matam" },
    { code: "SN.16", suffix: "16", name: "Kaffrine" },
    { code: "SN.17", suffix: "17", name: "Kédougou" },
    { code: "SN.18", suffix: "18", name: "Sédhiou" },
  ],
  "SO": [
    { code: "SO.01", suffix: "01", name: "Bakool" },
    { code: "SO.02", suffix: "02", name: "Banaadir" },
    { code: "SO.03", suffix: "03", name: "Bari" },
    { code: "SO.04", suffix: "04", name: "Bay" },
    { code: "SO.05", suffix: "05", name: "Galguduud" },
    { code: "SO.06", suffix: "06", name: "Gedo" },
    { code: "SO.07", suffix: "07", name: "Hiiraan" },
    { code: "SO.08", suffix: "08", name: "Middle Juba" },
    { code: "SO.09", suffix: "09", name: "Lower Juba" },
    { code: "SO.10", suffix: "10", name: "Mudug" },
    { code: "SO.12", suffix: "12", name: "Sanaag" },
    { code: "SO.13", suffix: "13", name: "Middle Shabele" },
    { code: "SO.14", suffix: "14", name: "Lower Shabeelle" },
    { code: "SO.18", suffix: "18", name: "Nugaal" },
    { code: "SO.19", suffix: "19", name: "Togdheer" },
    { code: "SO.20", suffix: "20", name: "Woqooyi Galbeed" },
    { code: "SO.21", suffix: "21", name: "Awdal" },
    { code: "SO.22", suffix: "22", name: "Sool" },
  ],
  "SR": [
    { code: "SR.10", suffix: "10", name: "Brokopondo" },
    { code: "SR.11", suffix: "11", name: "Commewijne" },
    { code: "SR.12", suffix: "12", name: "Coronie" },
    { code: "SR.13", suffix: "13", name: "Marowijne" },
    { code: "SR.14", suffix: "14", name: "Nickerie" },
    { code: "SR.15", suffix: "15", name: "Para" },
    { code: "SR.16", suffix: "16", name: "Paramaribo" },
    { code: "SR.17", suffix: "17", name: "Saramacca" },
    { code: "SR.18", suffix: "18", name: "Sipaliwini" },
    { code: "SR.19", suffix: "19", name: "Wanica" },
  ],
  "SS": [
    { code: "SS.11550543", suffix: "11550543", name: "Aweil" },
    { code: "SS.11550544", suffix: "11550544", name: "Eastern Lakes" },
    { code: "SS.11550545", suffix: "11550545", name: "Gogrial" },
    { code: "SS.11550548", suffix: "11550548", name: "Lol" },
    { code: "SS.11550552", suffix: "11550552", name: "Amadi State" },
    { code: "SS.11550555", suffix: "11550555", name: "Yei River" },
    { code: "SS.11550558", suffix: "11550558", name: "Fashoda" },
    { code: "SS.11550562", suffix: "11550562", name: "Gok" },
    { code: "SS.11550563", suffix: "11550563", name: "Tonj" },
    { code: "SS.11550564", suffix: "11550564", name: "Twic" },
    { code: "SS.11550565", suffix: "11550565", name: "Wau" },
    { code: "SS.11550566", suffix: "11550566", name: "Gbudwe" },
    { code: "SS.11550567", suffix: "11550567", name: "Imatong" },
    { code: "SS.11550569", suffix: "11550569", name: "Juba" },
    { code: "SS.11550570", suffix: "11550570", name: "Maridi" },
    { code: "SS.11550571", suffix: "11550571", name: "Terekeka" },
    { code: "SS.11550573", suffix: "11550573", name: "Boma" },
    { code: "SS.11550574", suffix: "11550574", name: "Bieh" },
    { code: "SS.11550575", suffix: "11550575", name: "Central Upper Nile" },
    { code: "SS.11550576", suffix: "11550576", name: "Jonglei" },
    { code: "SS.11550577", suffix: "11550577", name: "Latjoor" },
    { code: "SS.11550578", suffix: "11550578", name: "Northern Liech" },
    { code: "SS.11550579", suffix: "11550579", name: "Southern Liech" },
    { code: "SS.11550580", suffix: "11550580", name: "Fangak" },
    { code: "SS.11550581", suffix: "11550581", name: "Western Lakes" },
    { code: "SS.11550582", suffix: "11550582", name: "Aweil East" },
    { code: "SS.11550588", suffix: "11550588", name: "Northern Upper Nile" },
    { code: "SS.11550589", suffix: "11550589", name: "Tambura" },
    { code: "SS.11550596", suffix: "11550596", name: "Kapoeta" },
    { code: "SS.367894", suffix: "367894", name: "Ruweng" },
    { code: "SS.9072661", suffix: "9072661", name: "Maiwut" },
    { code: "SS.9407085", suffix: "9407085", name: "Akobo" },
  ],
  "ST": [
    { code: "ST.01", suffix: "01", name: "Príncipe" },
    { code: "ST.02", suffix: "02", name: "São Tomé Island" },
  ],
  "SV": [
    { code: "SV.01", suffix: "01", name: "Ahuachapán" },
    { code: "SV.02", suffix: "02", name: "Cabañas" },
    { code: "SV.03", suffix: "03", name: "Chalatenango" },
    { code: "SV.04", suffix: "04", name: "Cuscatlán" },
    { code: "SV.05", suffix: "05", name: "La Libertad" },
    { code: "SV.06", suffix: "06", name: "La Paz" },
    { code: "SV.07", suffix: "07", name: "La Unión" },
    { code: "SV.08", suffix: "08", name: "Morazán" },
    { code: "SV.09", suffix: "09", name: "San Miguel" },
    { code: "SV.10", suffix: "10", name: "San Salvador" },
    { code: "SV.11", suffix: "11", name: "Santa Ana" },
    { code: "SV.12", suffix: "12", name: "San Vicente" },
    { code: "SV.13", suffix: "13", name: "Sonsonate" },
    { code: "SV.14", suffix: "14", name: "Usulután" },
  ],
  "SY": [
    { code: "SY.01", suffix: "01", name: "Al-Hasakah" },
    { code: "SY.02", suffix: "02", name: "Latakia" },
    { code: "SY.03", suffix: "03", name: "Quneitra" },
    { code: "SY.04", suffix: "04", name: "Ar-Raqqah" },
    { code: "SY.05", suffix: "05", name: "As-Suwayda" },
    { code: "SY.06", suffix: "06", name: "Daraa" },
    { code: "SY.07", suffix: "07", name: "Deir ez-Zor" },
    { code: "SY.08", suffix: "08", name: "Rif-dimashq" },
    { code: "SY.09", suffix: "09", name: "Aleppo" },
    { code: "SY.10", suffix: "10", name: "Hama" },
    { code: "SY.11", suffix: "11", name: "Homs" },
    { code: "SY.12", suffix: "12", name: "Idlib" },
    { code: "SY.13", suffix: "13", name: "Dimashq" },
    { code: "SY.14", suffix: "14", name: "Tartus" },
  ],
  "SZ": [
    { code: "SZ.01", suffix: "01", name: "Hhohho" },
    { code: "SZ.02", suffix: "02", name: "Lubombo" },
    { code: "SZ.03", suffix: "03", name: "Manzini" },
    { code: "SZ.04", suffix: "04", name: "Shiselweni" },
  ],
  "TD": [
    { code: "TD.01", suffix: "01", name: "Batha" },
    { code: "TD.02", suffix: "02", name: "Wadi Fira" },
    { code: "TD.05", suffix: "05", name: "Guéra" },
    { code: "TD.06", suffix: "06", name: "Kanem" },
    { code: "TD.07", suffix: "07", name: "Lac" },
    { code: "TD.08", suffix: "08", name: "Logone Occidental" },
    { code: "TD.09", suffix: "09", name: "Logone Oriental" },
    { code: "TD.12", suffix: "12", name: "Ouadaï" },
    { code: "TD.13", suffix: "13", name: "Salamat" },
    { code: "TD.14", suffix: "14", name: "Tandjilé" },
    { code: "TD.15", suffix: "15", name: "Chari-Baguirmi" },
    { code: "TD.16", suffix: "16", name: "Mayo-Kebbi Est" },
    { code: "TD.17", suffix: "17", name: "Moyen-Chari" },
    { code: "TD.18", suffix: "18", name: "Hadjer-Lamis" },
    { code: "TD.19", suffix: "19", name: "Mandoul" },
    { code: "TD.20", suffix: "20", name: "Mayo-Kebbi Ouest" },
    { code: "TD.21", suffix: "21", name: "N’Djaména" },
    { code: "TD.22", suffix: "22", name: "Barh el Gazel" },
    { code: "TD.23", suffix: "23", name: "Borkou" },
    { code: "TD.25", suffix: "25", name: "Sila" },
    { code: "TD.26", suffix: "26", name: "Tibesti" },
    { code: "TD.27", suffix: "27", name: "Ennedi-Est" },
    { code: "TD.28", suffix: "28", name: "Ennedi-Ouest" },
  ],
  "TF": [
    { code: "TF.01", suffix: "01", name: "Saint-Paul-et-Amsterdam" },
    { code: "TF.02", suffix: "02", name: "Crozet" },
    { code: "TF.03", suffix: "03", name: "Kerguelen" },
    { code: "TF.04", suffix: "04", name: "Terre-Adélie" },
    { code: "TF.05", suffix: "05", name: "Îles Éparses" },
  ],
  "TG": [
    { code: "TG.22", suffix: "22", name: "Centrale" },
    { code: "TG.23", suffix: "23", name: "Kara" },
    { code: "TG.24", suffix: "24", name: "Maritime" },
    { code: "TG.25", suffix: "25", name: "Plateaux" },
    { code: "TG.26", suffix: "26", name: "Savanes" },
  ],
  "TH": [
    { code: "TH.01", suffix: "01", name: "Mae Hong Son" },
    { code: "TH.02", suffix: "02", name: "Chiang Mai" },
    { code: "TH.03", suffix: "03", name: "Chiang Rai" },
    { code: "TH.04", suffix: "04", name: "Nan" },
    { code: "TH.05", suffix: "05", name: "Lamphun" },
    { code: "TH.06", suffix: "06", name: "Lampang" },
    { code: "TH.07", suffix: "07", name: "Phrae" },
    { code: "TH.08", suffix: "08", name: "Tak" },
    { code: "TH.09", suffix: "09", name: "Sukhothai" },
    { code: "TH.10", suffix: "10", name: "Uttaradit" },
    { code: "TH.11", suffix: "11", name: "Kamphaeng Phet" },
    { code: "TH.12", suffix: "12", name: "Phitsanulok" },
    { code: "TH.13", suffix: "13", name: "Phichit" },
    { code: "TH.14", suffix: "14", name: "Phetchabun" },
    { code: "TH.15", suffix: "15", name: "Uthai Thani" },
    { code: "TH.16", suffix: "16", name: "Nakhon Sawan" },
    { code: "TH.17", suffix: "17", name: "Nong Khai" },
    { code: "TH.18", suffix: "18", name: "Loei" },
    { code: "TH.20", suffix: "20", name: "Sakon Nakhon" },
    { code: "TH.22", suffix: "22", name: "Khon Kaen" },
    { code: "TH.23", suffix: "23", name: "Kalasin" },
    { code: "TH.24", suffix: "24", name: "Maha Sarakham" },
    { code: "TH.25", suffix: "25", name: "Roi Et" },
    { code: "TH.26", suffix: "26", name: "Chaiyaphum" },
    { code: "TH.27", suffix: "27", name: "Nakhon Ratchasima" },
    { code: "TH.28", suffix: "28", name: "Buriram" },
    { code: "TH.29", suffix: "29", name: "Surin" },
    { code: "TH.30", suffix: "30", name: "Si Sa Ket" },
    { code: "TH.31", suffix: "31", name: "Narathiwat" },
    { code: "TH.32", suffix: "32", name: "Chai Nat" },
    { code: "TH.33", suffix: "33", name: "Sing Buri" },
    { code: "TH.34", suffix: "34", name: "Lopburi" },
    { code: "TH.35", suffix: "35", name: "Ang Thong" },
    { code: "TH.36", suffix: "36", name: "Phra Nakhon Si Ayutthaya" },
    { code: "TH.37", suffix: "37", name: "Saraburi" },
    { code: "TH.38", suffix: "38", name: "Nonthaburi" },
    { code: "TH.39", suffix: "39", name: "Pathum Thani" },
    { code: "TH.40", suffix: "40", name: "Bangkok" },
    { code: "TH.41", suffix: "41", name: "Phayao" },
    { code: "TH.42", suffix: "42", name: "Samut Prakan" },
    { code: "TH.43", suffix: "43", name: "Nakhon Nayok" },
    { code: "TH.44", suffix: "44", name: "Chachoengsao" },
    { code: "TH.46", suffix: "46", name: "Chon Buri" },
    { code: "TH.47", suffix: "47", name: "Rayong" },
    { code: "TH.48", suffix: "48", name: "Chanthaburi" },
    { code: "TH.49", suffix: "49", name: "Trat" },
    { code: "TH.50", suffix: "50", name: "Kanchanaburi" },
    { code: "TH.51", suffix: "51", name: "Suphanburi" },
    { code: "TH.52", suffix: "52", name: "Ratchaburi" },
    { code: "TH.53", suffix: "53", name: "Nakhon Pathom" },
    { code: "TH.54", suffix: "54", name: "Samut Songkhram" },
    { code: "TH.55", suffix: "55", name: "Samut Sakhon" },
    { code: "TH.56", suffix: "56", name: "Phetchaburi" },
    { code: "TH.57", suffix: "57", name: "Prachuap Khiri Khan" },
    { code: "TH.58", suffix: "58", name: "Chumphon" },
    { code: "TH.59", suffix: "59", name: "Ranong" },
    { code: "TH.60", suffix: "60", name: "Surat Thani" },
    { code: "TH.61", suffix: "61", name: "Phang Nga" },
    { code: "TH.62", suffix: "62", name: "Phuket" },
    { code: "TH.63", suffix: "63", name: "Krabi" },
    { code: "TH.64", suffix: "64", name: "Nakhon Si Thammarat" },
    { code: "TH.65", suffix: "65", name: "Trang" },
    { code: "TH.66", suffix: "66", name: "Phatthalung" },
    { code: "TH.67", suffix: "67", name: "Satun" },
    { code: "TH.68", suffix: "68", name: "Songkhla" },
    { code: "TH.69", suffix: "69", name: "Pattani" },
    { code: "TH.70", suffix: "70", name: "Yala" },
    { code: "TH.72", suffix: "72", name: "Yasothon" },
    { code: "TH.73", suffix: "73", name: "Nakhon Phanom" },
    { code: "TH.74", suffix: "74", name: "Prachin Buri" },
    { code: "TH.75", suffix: "75", name: "Ubon Ratchathani" },
    { code: "TH.76", suffix: "76", name: "Udon Thani" },
    { code: "TH.77", suffix: "77", name: "Amnat Charoen" },
    { code: "TH.78", suffix: "78", name: "Mukdahan" },
    { code: "TH.79", suffix: "79", name: "Nong Bua Lam Phu" },
    { code: "TH.80", suffix: "80", name: "Sa Kaeo" },
    { code: "TH.81", suffix: "81", name: "Bueng Kan" },
  ],
  "TJ": [
    { code: "TJ.01", suffix: "01", name: "Gorno-Badakhshan" },
    { code: "TJ.02", suffix: "02", name: "Khatlon" },
    { code: "TJ.03", suffix: "03", name: "Sughd" },
    { code: "TJ.04", suffix: "04", name: "Dushanbe" },
    { code: "TJ.RR", suffix: "RR", name: "Republican Subordination" },
  ],
  "TK": [
    { code: "TK.A", suffix: "A", name: "Atafu" },
    { code: "TK.F", suffix: "F", name: "Fakaofo" },
    { code: "TK.N", suffix: "N", name: "Nukunonu" },
  ],
  "TL": [
    { code: "TL.AL", suffix: "AL", name: "Aileu" },
    { code: "TL.AN", suffix: "AN", name: "Ainaro" },
    { code: "TL.BA", suffix: "BA", name: "Baucau" },
    { code: "TL.BO", suffix: "BO", name: "Bobonaro" },
    { code: "TL.CO", suffix: "CO", name: "Cova Lima" },
    { code: "TL.DI", suffix: "DI", name: "Díli" },
    { code: "TL.ER", suffix: "ER", name: "Ermera" },
    { code: "TL.LA", suffix: "LA", name: "Lautém" },
    { code: "TL.LI", suffix: "LI", name: "Liquiçá" },
    { code: "TL.MF", suffix: "MF", name: "Manufahi" },
    { code: "TL.MT", suffix: "MT", name: "Manatuto" },
    { code: "TL.OE", suffix: "OE", name: "Oecusse" },
    { code: "TL.VI", suffix: "VI", name: "Viqueque" },
  ],
  "TM": [
    { code: "TM.01", suffix: "01", name: "Ahal" },
    { code: "TM.02", suffix: "02", name: "Balkan" },
    { code: "TM.03", suffix: "03", name: "Daşoguz" },
    { code: "TM.04", suffix: "04", name: "Lebap" },
    { code: "TM.05", suffix: "05", name: "Mary" },
    { code: "TM.S", suffix: "S", name: "Ashgabat" },
  ],
  "TN": [
    { code: "TN.02", suffix: "02", name: "Al Qaşrayn" },
    { code: "TN.03", suffix: "03", name: "Kairouan" },
    { code: "TN.06", suffix: "06", name: "Jundūbah" },
    { code: "TN.14", suffix: "14", name: "Kef" },
    { code: "TN.15", suffix: "15", name: "Al Mahdīyah" },
    { code: "TN.16", suffix: "16", name: "Al Munastīr" },
    { code: "TN.17", suffix: "17", name: "Bājah" },
    { code: "TN.18", suffix: "18", name: "Banzart" },
    { code: "TN.19", suffix: "19", name: "Nābul" },
    { code: "TN.22", suffix: "22", name: "Silyānah" },
    { code: "TN.23", suffix: "23", name: "Sūsah" },
    { code: "TN.27", suffix: "27", name: "Bin ‘Arūs" },
    { code: "TN.28", suffix: "28", name: "Madanīn" },
    { code: "TN.29", suffix: "29", name: "Qābis" },
    { code: "TN.30", suffix: "30", name: "Gafsa" },
    { code: "TN.31", suffix: "31", name: "Qibilī" },
    { code: "TN.32", suffix: "32", name: "Şafāqis" },
    { code: "TN.33", suffix: "33", name: "Sīdī Bū Zayd" },
    { code: "TN.34", suffix: "34", name: "Tataouine" },
    { code: "TN.35", suffix: "35", name: "Tawzar" },
    { code: "TN.36", suffix: "36", name: "Tūnis" },
    { code: "TN.37", suffix: "37", name: "Zaghwān" },
    { code: "TN.38", suffix: "38", name: "Ariana" },
    { code: "TN.39", suffix: "39", name: "Manouba" },
  ],
  "TO": [
    { code: "TO.01", suffix: "01", name: "Ha‘apai" },
    { code: "TO.02", suffix: "02", name: "Tongatapu" },
    { code: "TO.03", suffix: "03", name: "Vava‘u" },
    { code: "TO.EU", suffix: "EU", name: "ʻEua" },
    { code: "TO.NI", suffix: "NI", name: "Niuas" },
  ],
  "TR": [
    { code: "TR.02", suffix: "02", name: "Adıyaman" },
    { code: "TR.03", suffix: "03", name: "Afyonkarahisar" },
    { code: "TR.04", suffix: "04", name: "Ağrı" },
    { code: "TR.05", suffix: "05", name: "Amasya" },
    { code: "TR.07", suffix: "07", name: "Antalya" },
    { code: "TR.08", suffix: "08", name: "Artvin" },
    { code: "TR.09", suffix: "09", name: "Aydın" },
    { code: "TR.10", suffix: "10", name: "Balıkesir" },
    { code: "TR.11", suffix: "11", name: "Bilecik" },
    { code: "TR.12", suffix: "12", name: "Bingöl" },
    { code: "TR.13", suffix: "13", name: "Bitlis" },
    { code: "TR.14", suffix: "14", name: "Bolu" },
    { code: "TR.15", suffix: "15", name: "Burdur" },
    { code: "TR.16", suffix: "16", name: "Bursa" },
    { code: "TR.17", suffix: "17", name: "Canakkale" },
    { code: "TR.19", suffix: "19", name: "Çorum" },
    { code: "TR.20", suffix: "20", name: "Denizli" },
    { code: "TR.21", suffix: "21", name: "Diyarbakır" },
    { code: "TR.22", suffix: "22", name: "Edirne" },
    { code: "TR.23", suffix: "23", name: "Elazığ" },
    { code: "TR.24", suffix: "24", name: "Erzincan" },
    { code: "TR.25", suffix: "25", name: "Erzurum" },
    { code: "TR.26", suffix: "26", name: "Eskişehir" },
    { code: "TR.28", suffix: "28", name: "Giresun" },
    { code: "TR.31", suffix: "31", name: "Hatay" },
    { code: "TR.32", suffix: "32", name: "Mersin" },
    { code: "TR.33", suffix: "33", name: "Isparta" },
    { code: "TR.34", suffix: "34", name: "Istanbul" },
    { code: "TR.35", suffix: "35", name: "İzmir" },
    { code: "TR.37", suffix: "37", name: "Kastamonu" },
    { code: "TR.38", suffix: "38", name: "Kayseri" },
    { code: "TR.39", suffix: "39", name: "Kırklareli" },
    { code: "TR.40", suffix: "40", name: "Kırşehir" },
    { code: "TR.41", suffix: "41", name: "Kocaeli" },
    { code: "TR.43", suffix: "43", name: "Kütahya" },
    { code: "TR.44", suffix: "44", name: "Malatya" },
    { code: "TR.45", suffix: "45", name: "Manisa" },
    { code: "TR.46", suffix: "46", name: "Kahramanmaraş" },
    { code: "TR.48", suffix: "48", name: "Muğla" },
    { code: "TR.49", suffix: "49", name: "Muş" },
    { code: "TR.50", suffix: "50", name: "Nevşehir" },
    { code: "TR.52", suffix: "52", name: "Ordu" },
    { code: "TR.53", suffix: "53", name: "Rize" },
    { code: "TR.54", suffix: "54", name: "Sakarya" },
    { code: "TR.55", suffix: "55", name: "Samsun" },
    { code: "TR.57", suffix: "57", name: "Sinop" },
    { code: "TR.58", suffix: "58", name: "Sivas" },
    { code: "TR.59", suffix: "59", name: "Tekirdağ" },
    { code: "TR.60", suffix: "60", name: "Tokat" },
    { code: "TR.61", suffix: "61", name: "Trabzon" },
    { code: "TR.62", suffix: "62", name: "Tunceli" },
    { code: "TR.63", suffix: "63", name: "Şanlıurfa" },
    { code: "TR.64", suffix: "64", name: "Uşak" },
    { code: "TR.65", suffix: "65", name: "Van" },
    { code: "TR.66", suffix: "66", name: "Yozgat" },
    { code: "TR.68", suffix: "68", name: "Ankara" },
    { code: "TR.69", suffix: "69", name: "Gümüşhane" },
    { code: "TR.70", suffix: "70", name: "Hakkâri" },
    { code: "TR.71", suffix: "71", name: "Konya" },
    { code: "TR.72", suffix: "72", name: "Mardin" },
    { code: "TR.73", suffix: "73", name: "Niğde" },
    { code: "TR.74", suffix: "74", name: "Siirt" },
    { code: "TR.75", suffix: "75", name: "Aksaray" },
    { code: "TR.76", suffix: "76", name: "Batman" },
    { code: "TR.77", suffix: "77", name: "Bayburt" },
    { code: "TR.78", suffix: "78", name: "Karaman" },
    { code: "TR.79", suffix: "79", name: "Kırıkkale" },
    { code: "TR.80", suffix: "80", name: "Şırnak" },
    { code: "TR.81", suffix: "81", name: "Adana" },
    { code: "TR.82", suffix: "82", name: "Çankırı" },
    { code: "TR.83", suffix: "83", name: "Gaziantep" },
    { code: "TR.84", suffix: "84", name: "Kars" },
    { code: "TR.85", suffix: "85", name: "Zonguldak" },
    { code: "TR.86", suffix: "86", name: "Ardahan" },
    { code: "TR.87", suffix: "87", name: "Bartın" },
    { code: "TR.88", suffix: "88", name: "Iğdır" },
    { code: "TR.89", suffix: "89", name: "Karabük" },
    { code: "TR.90", suffix: "90", name: "Kilis" },
    { code: "TR.91", suffix: "91", name: "Osmaniye" },
    { code: "TR.92", suffix: "92", name: "Yalova" },
    { code: "TR.93", suffix: "93", name: "Düzce" },
  ],
  "TT": [
    { code: "TT.01", suffix: "01", name: "Borough of Arima" },
    { code: "TT.03", suffix: "03", name: "Mayaro" },
    { code: "TT.05", suffix: "05", name: "Port of Spain" },
    { code: "TT.10", suffix: "10", name: "San Fernando" },
    { code: "TT.11", suffix: "11", name: "Tobago" },
    { code: "TT.CHA", suffix: "CHA", name: "Chaguanas" },
    { code: "TT.CTT", suffix: "CTT", name: "Couva-Tabaquite-Talparo" },
    { code: "TT.DMN", suffix: "DMN", name: "Diego Martin" },
    { code: "TT.PED", suffix: "PED", name: "Penal/Debe" },
    { code: "TT.PRT", suffix: "PRT", name: "Princes Town" },
    { code: "TT.PTF", suffix: "PTF", name: "Point Fortin" },
    { code: "TT.SGE", suffix: "SGE", name: "Sangre Grande" },
    { code: "TT.SIP", suffix: "SIP", name: "Siparia" },
    { code: "TT.SJL", suffix: "SJL", name: "San Juan/Laventille" },
    { code: "TT.TUP", suffix: "TUP", name: "Tunapuna/Piarco" },
  ],
  "TV": [
    { code: "TV.FUN", suffix: "FUN", name: "Funafuti" },
    { code: "TV.NIT", suffix: "NIT", name: "Niutao" },
    { code: "TV.NKF", suffix: "NKF", name: "Nukufetau" },
    { code: "TV.NKL", suffix: "NKL", name: "Nukulaelae" },
    { code: "TV.NMA", suffix: "NMA", name: "Nanumea" },
    { code: "TV.NMG", suffix: "NMG", name: "Nanumanga" },
    { code: "TV.NUI", suffix: "NUI", name: "Nui" },
    { code: "TV.VAI", suffix: "VAI", name: "Vaitupu" },
  ],
  "TW": [
    { code: "TW.01", suffix: "01", name: "Fukien" },
    { code: "TW.02", suffix: "02", name: "Takao" },
    { code: "TW.03", suffix: "03", name: "Taipei" },
    { code: "TW.04", suffix: "04", name: "Taiwan" },
  ],
  "TZ": [
    { code: "TZ.02", suffix: "02", name: "Pwani" },
    { code: "TZ.03", suffix: "03", name: "Dodoma" },
    { code: "TZ.04", suffix: "04", name: "Iringa" },
    { code: "TZ.05", suffix: "05", name: "Kigoma" },
    { code: "TZ.06", suffix: "06", name: "Kilimanjaro" },
    { code: "TZ.07", suffix: "07", name: "Lindi" },
    { code: "TZ.08", suffix: "08", name: "Mara" },
    { code: "TZ.09", suffix: "09", name: "Mbeya" },
    { code: "TZ.10", suffix: "10", name: "Morogoro" },
    { code: "TZ.11", suffix: "11", name: "Mtwara" },
    { code: "TZ.12", suffix: "12", name: "Mwanza" },
    { code: "TZ.13", suffix: "13", name: "Pemba North" },
    { code: "TZ.14", suffix: "14", name: "Ruvuma" },
    { code: "TZ.15", suffix: "15", name: "Shinyanga" },
    { code: "TZ.16", suffix: "16", name: "Singida" },
    { code: "TZ.17", suffix: "17", name: "Tabora" },
    { code: "TZ.18", suffix: "18", name: "Tanga" },
    { code: "TZ.19", suffix: "19", name: "Kagera" },
    { code: "TZ.20", suffix: "20", name: "Pemba South" },
    { code: "TZ.21", suffix: "21", name: "Zanzibar Central/South" },
    { code: "TZ.22", suffix: "22", name: "Zanzibar North" },
    { code: "TZ.23", suffix: "23", name: "Dar es Salaam" },
    { code: "TZ.24", suffix: "24", name: "Rukwa" },
    { code: "TZ.25", suffix: "25", name: "Zanzibar Urban/West" },
    { code: "TZ.26", suffix: "26", name: "Arusha" },
    { code: "TZ.27", suffix: "27", name: "Manyara" },
    { code: "TZ.28", suffix: "28", name: "Geita" },
    { code: "TZ.29", suffix: "29", name: "Katavi" },
    { code: "TZ.30", suffix: "30", name: "Njombe" },
    { code: "TZ.31", suffix: "31", name: "Simiyu" },
    { code: "TZ.32", suffix: "32", name: "Songwe" },
  ],
  "UA": [
    { code: "UA.01", suffix: "01", name: "Cherkasy" },
    { code: "UA.02", suffix: "02", name: "Chernihiv" },
    { code: "UA.03", suffix: "03", name: "Chernivtsi Oblast'" },
    { code: "UA.04", suffix: "04", name: "Dnipropetrovsk" },
    { code: "UA.05", suffix: "05", name: "Donetsk" },
    { code: "UA.06", suffix: "06", name: "Ivano-Frankivsk" },
    { code: "UA.07", suffix: "07", name: "Kharkiv" },
    { code: "UA.08", suffix: "08", name: "Kherson" },
    { code: "UA.09", suffix: "09", name: "Khmelnytskyi" },
    { code: "UA.10", suffix: "10", name: "Kirovohrad" },
    { code: "UA.11", suffix: "11", name: "Crimea" },
    { code: "UA.12", suffix: "12", name: "Kyiv City" },
    { code: "UA.13", suffix: "13", name: "Kyiv" },
    { code: "UA.14", suffix: "14", name: "Luhansk" },
    { code: "UA.15", suffix: "15", name: "Lviv" },
    { code: "UA.16", suffix: "16", name: "Mykolaiv" },
    { code: "UA.17", suffix: "17", name: "Odesa" },
    { code: "UA.18", suffix: "18", name: "Poltava" },
    { code: "UA.19", suffix: "19", name: "Rivne" },
    { code: "UA.20", suffix: "20", name: "Sevastopol City" },
    { code: "UA.21", suffix: "21", name: "Sumy" },
    { code: "UA.22", suffix: "22", name: "Ternopil" },
    { code: "UA.23", suffix: "23", name: "Vinnyts'ka" },
    { code: "UA.24", suffix: "24", name: "Volyn" },
    { code: "UA.25", suffix: "25", name: "Transcarpathia" },
    { code: "UA.26", suffix: "26", name: "Zaporizhia" },
    { code: "UA.27", suffix: "27", name: "Zhytomyr" },
  ],
  "UG": [
    { code: "UG.C", suffix: "C", name: "Central Region" },
    { code: "UG.E", suffix: "E", name: "Eastern Region" },
    { code: "UG.N", suffix: "N", name: "Northern Region" },
    { code: "UG.W", suffix: "W", name: "Western Region" },
  ],
  "UM": [
    { code: "UM.050", suffix: "050", name: "Baker Island" },
    { code: "UM.100", suffix: "100", name: "Howland Island" },
    { code: "UM.150", suffix: "150", name: "Jarvis Island" },
    { code: "UM.200", suffix: "200", name: "Johnston Atoll" },
    { code: "UM.250", suffix: "250", name: "Kingman Reef" },
    { code: "UM.300", suffix: "300", name: "Midway Islands" },
    { code: "UM.350", suffix: "350", name: "Navassa Island" },
    { code: "UM.400", suffix: "400", name: "Palmyra Atoll" },
    { code: "UM.450", suffix: "450", name: "Wake Island" },
  ],
  "US": [
    { code: "US.AK", suffix: "AK", name: "Alaska" },
    { code: "US.AL", suffix: "AL", name: "Alabama" },
    { code: "US.AR", suffix: "AR", name: "Arkansas" },
    { code: "US.AZ", suffix: "AZ", name: "Arizona" },
    { code: "US.CA", suffix: "CA", name: "California" },
    { code: "US.CO", suffix: "CO", name: "Colorado" },
    { code: "US.CT", suffix: "CT", name: "Connecticut" },
    { code: "US.DC", suffix: "DC", name: "Washington, D.C." },
    { code: "US.DE", suffix: "DE", name: "Delaware" },
    { code: "US.FL", suffix: "FL", name: "Florida" },
    { code: "US.GA", suffix: "GA", name: "Georgia" },
    { code: "US.HI", suffix: "HI", name: "Hawaii" },
    { code: "US.IA", suffix: "IA", name: "Iowa" },
    { code: "US.ID", suffix: "ID", name: "Idaho" },
    { code: "US.IL", suffix: "IL", name: "Illinois" },
    { code: "US.IN", suffix: "IN", name: "Indiana" },
    { code: "US.KS", suffix: "KS", name: "Kansas" },
    { code: "US.KY", suffix: "KY", name: "Kentucky" },
    { code: "US.LA", suffix: "LA", name: "Louisiana" },
    { code: "US.MA", suffix: "MA", name: "Massachusetts" },
    { code: "US.MD", suffix: "MD", name: "Maryland" },
    { code: "US.ME", suffix: "ME", name: "Maine" },
    { code: "US.MI", suffix: "MI", name: "Michigan" },
    { code: "US.MN", suffix: "MN", name: "Minnesota" },
    { code: "US.MO", suffix: "MO", name: "Missouri" },
    { code: "US.MS", suffix: "MS", name: "Mississippi" },
    { code: "US.MT", suffix: "MT", name: "Montana" },
    { code: "US.NC", suffix: "NC", name: "North Carolina" },
    { code: "US.ND", suffix: "ND", name: "North Dakota" },
    { code: "US.NE", suffix: "NE", name: "Nebraska" },
    { code: "US.NH", suffix: "NH", name: "New Hampshire" },
    { code: "US.NJ", suffix: "NJ", name: "New Jersey" },
    { code: "US.NM", suffix: "NM", name: "New Mexico" },
    { code: "US.NV", suffix: "NV", name: "Nevada" },
    { code: "US.NY", suffix: "NY", name: "New York" },
    { code: "US.OH", suffix: "OH", name: "Ohio" },
    { code: "US.OK", suffix: "OK", name: "Oklahoma" },
    { code: "US.OR", suffix: "OR", name: "Oregon" },
    { code: "US.PA", suffix: "PA", name: "Pennsylvania" },
    { code: "US.RI", suffix: "RI", name: "Rhode Island" },
    { code: "US.SC", suffix: "SC", name: "South Carolina" },
    { code: "US.SD", suffix: "SD", name: "South Dakota" },
    { code: "US.TN", suffix: "TN", name: "Tennessee" },
    { code: "US.TX", suffix: "TX", name: "Texas" },
    { code: "US.UT", suffix: "UT", name: "Utah" },
    { code: "US.VA", suffix: "VA", name: "Virginia" },
    { code: "US.VT", suffix: "VT", name: "Vermont" },
    { code: "US.WA", suffix: "WA", name: "Washington" },
    { code: "US.WI", suffix: "WI", name: "Wisconsin" },
    { code: "US.WV", suffix: "WV", name: "West Virginia" },
    { code: "US.WY", suffix: "WY", name: "Wyoming" },
  ],
  "UY": [
    { code: "UY.01", suffix: "01", name: "Artigas" },
    { code: "UY.02", suffix: "02", name: "Canelones" },
    { code: "UY.03", suffix: "03", name: "Cerro Largo" },
    { code: "UY.04", suffix: "04", name: "Colonia" },
    { code: "UY.05", suffix: "05", name: "Durazno" },
    { code: "UY.06", suffix: "06", name: "Flores" },
    { code: "UY.07", suffix: "07", name: "Florida" },
    { code: "UY.08", suffix: "08", name: "Lavalleja" },
    { code: "UY.09", suffix: "09", name: "Maldonado" },
    { code: "UY.10", suffix: "10", name: "Montevideo" },
    { code: "UY.11", suffix: "11", name: "Paysandú" },
    { code: "UY.12", suffix: "12", name: "Río Negro" },
    { code: "UY.13", suffix: "13", name: "Rivera" },
    { code: "UY.14", suffix: "14", name: "Rocha" },
    { code: "UY.15", suffix: "15", name: "Salto" },
    { code: "UY.16", suffix: "16", name: "San José" },
    { code: "UY.17", suffix: "17", name: "Soriano" },
    { code: "UY.18", suffix: "18", name: "Tacuarembó" },
    { code: "UY.19", suffix: "19", name: "Treinta y Tres" },
  ],
  "UZ": [
    { code: "UZ.01", suffix: "01", name: "Andijon" },
    { code: "UZ.02", suffix: "02", name: "Bukhara" },
    { code: "UZ.03", suffix: "03", name: "Fergana" },
    { code: "UZ.05", suffix: "05", name: "Xorazm" },
    { code: "UZ.06", suffix: "06", name: "Namangan" },
    { code: "UZ.07", suffix: "07", name: "Navoiy" },
    { code: "UZ.08", suffix: "08", name: "Qashqadaryo" },
    { code: "UZ.09", suffix: "09", name: "Karakalpakstan" },
    { code: "UZ.10", suffix: "10", name: "Samarqand" },
    { code: "UZ.12", suffix: "12", name: "Surxondaryo" },
    { code: "UZ.13", suffix: "13", name: "Toshkent Shahri" },
    { code: "UZ.14", suffix: "14", name: "Toshkent" },
    { code: "UZ.15", suffix: "15", name: "Jizzax" },
    { code: "UZ.16", suffix: "16", name: "Sirdaryo" },
  ],
  "VC": [
    { code: "VC.01", suffix: "01", name: "Charlotte" },
    { code: "VC.02", suffix: "02", name: "Saint Andrew" },
    { code: "VC.03", suffix: "03", name: "Saint David" },
    { code: "VC.04", suffix: "04", name: "Saint George" },
    { code: "VC.05", suffix: "05", name: "Saint Patrick" },
    { code: "VC.06", suffix: "06", name: "Grenadines" },
  ],
  "VE": [
    { code: "VE.01", suffix: "01", name: "Amazonas" },
    { code: "VE.02", suffix: "02", name: "Anzoátegui" },
    { code: "VE.03", suffix: "03", name: "Apure" },
    { code: "VE.04", suffix: "04", name: "Aragua" },
    { code: "VE.05", suffix: "05", name: "Barinas" },
    { code: "VE.06", suffix: "06", name: "Bolívar" },
    { code: "VE.07", suffix: "07", name: "Carabobo" },
    { code: "VE.08", suffix: "08", name: "Cojedes" },
    { code: "VE.09", suffix: "09", name: "Delta Amacuro" },
    { code: "VE.11", suffix: "11", name: "Falcón" },
    { code: "VE.12", suffix: "12", name: "Guárico" },
    { code: "VE.13", suffix: "13", name: "Lara" },
    { code: "VE.14", suffix: "14", name: "Mérida" },
    { code: "VE.15", suffix: "15", name: "Miranda" },
    { code: "VE.16", suffix: "16", name: "Monagas" },
    { code: "VE.17", suffix: "17", name: "Nueva Esparta" },
    { code: "VE.18", suffix: "18", name: "Portuguesa" },
    { code: "VE.19", suffix: "19", name: "Sucre" },
    { code: "VE.20", suffix: "20", name: "Táchira" },
    { code: "VE.21", suffix: "21", name: "Trujillo" },
    { code: "VE.22", suffix: "22", name: "Yaracuy" },
    { code: "VE.23", suffix: "23", name: "Zulia" },
    { code: "VE.24", suffix: "24", name: "Dependencias Federales" },
    { code: "VE.25", suffix: "25", name: "Distrito Federal" },
    { code: "VE.26", suffix: "26", name: "Vargas" },
  ],
  "VI": [
    { code: "VI.010", suffix: "010", name: "Saint Croix Island" },
    { code: "VI.020", suffix: "020", name: "Saint John Island" },
    { code: "VI.030", suffix: "030", name: "Saint Thomas Island" },
  ],
  "VN": [
    { code: "VN.01", suffix: "01", name: "An Giang" },
    { code: "VN.03", suffix: "03", name: "Bến Tre" },
    { code: "VN.05", suffix: "05", name: "Cao Bằng" },
    { code: "VN.09", suffix: "09", name: "Đồng Tháp" },
    { code: "VN.13", suffix: "13", name: "Haiphong" },
    { code: "VN.20", suffix: "20", name: "Ho Chi Minh" },
    { code: "VN.21", suffix: "21", name: "Kiến Giang" },
    { code: "VN.23", suffix: "23", name: "Lâm Đồng" },
    { code: "VN.24", suffix: "24", name: "Long An" },
    { code: "VN.30", suffix: "30", name: "Quảng Ninh" },
    { code: "VN.32", suffix: "32", name: "Sơn La" },
    { code: "VN.33", suffix: "33", name: "Tây Ninh Province" },
    { code: "VN.34", suffix: "34", name: "Thanh Hóa" },
    { code: "VN.35", suffix: "35", name: "Thái Bình" },
    { code: "VN.37", suffix: "37", name: "Tiền Giang" },
    { code: "VN.39", suffix: "39", name: "Lạng Sơn" },
    { code: "VN.43", suffix: "43", name: "Đồng Nai" },
    { code: "VN.44", suffix: "44", name: "Hanoi" },
    { code: "VN.45", suffix: "45", name: "Bà Rịa-Vũng Tàu" },
    { code: "VN.46", suffix: "46", name: "Bình Định" },
    { code: "VN.47", suffix: "47", name: "Bình Thuận" },
    { code: "VN.49", suffix: "49", name: "Gia Lai" },
    { code: "VN.50", suffix: "50", name: "Hà Giang" },
    { code: "VN.52", suffix: "52", name: "Hà Tĩnh" },
    { code: "VN.53", suffix: "53", name: "Hòa Bình" },
    { code: "VN.54", suffix: "54", name: "Khánh Hòa" },
    { code: "VN.55", suffix: "55", name: "Kon Tum" },
    { code: "VN.58", suffix: "58", name: "Nghệ An" },
    { code: "VN.59", suffix: "59", name: "Ninh Bình" },
    { code: "VN.60", suffix: "60", name: "Ninh Thuận" },
    { code: "VN.61", suffix: "61", name: "Phú Yên" },
    { code: "VN.62", suffix: "62", name: "Quảng Bình" },
    { code: "VN.63", suffix: "63", name: "Quảng Ngãi Province" },
    { code: "VN.64", suffix: "64", name: "Quảng Trị" },
    { code: "VN.65", suffix: "65", name: "Sóc Trăng" },
    { code: "VN.66", suffix: "66", name: "Thừa Thiên-Huế" },
    { code: "VN.67", suffix: "67", name: "Trà Vinh" },
    { code: "VN.68", suffix: "68", name: "Tuyên Quang" },
    { code: "VN.69", suffix: "69", name: "Vĩnh Long" },
    { code: "VN.70", suffix: "70", name: "Yên Bái" },
    { code: "VN.71", suffix: "71", name: "Bắc Giang" },
    { code: "VN.72", suffix: "72", name: "Bắc Kạn" },
    { code: "VN.73", suffix: "73", name: "Bạc Liêu" },
    { code: "VN.74", suffix: "74", name: "Bắc Ninh" },
    { code: "VN.75", suffix: "75", name: "Bình Dương" },
    { code: "VN.76", suffix: "76", name: "Bình Phước" },
    { code: "VN.77", suffix: "77", name: "Cà Mau" },
    { code: "VN.78", suffix: "78", name: "Da Nang" },
    { code: "VN.79", suffix: "79", name: "Hải Dương" },
    { code: "VN.80", suffix: "80", name: "Hà Nam" },
    { code: "VN.81", suffix: "81", name: "Hưng Yên" },
    { code: "VN.82", suffix: "82", name: "Nam Định" },
    { code: "VN.83", suffix: "83", name: "Phú Thọ" },
    { code: "VN.84", suffix: "84", name: "Quảng Nam" },
    { code: "VN.85", suffix: "85", name: "Thái Nguyên" },
    { code: "VN.86", suffix: "86", name: "Vĩnh Phúc" },
    { code: "VN.87", suffix: "87", name: "Can Tho" },
    { code: "VN.88", suffix: "88", name: "Đắk Lắk" },
    { code: "VN.89", suffix: "89", name: "Lai Châu" },
    { code: "VN.90", suffix: "90", name: "Lào Cai" },
    { code: "VN.91", suffix: "91", name: "Ðắk Nông" },
    { code: "VN.92", suffix: "92", name: "Ðiện Biên" },
    { code: "VN.93", suffix: "93", name: "Hậu Giang" },
  ],
  "VU": [
    { code: "VU.07", suffix: "07", name: "Torba" },
    { code: "VU.13", suffix: "13", name: "Sanma" },
    { code: "VU.15", suffix: "15", name: "Tafea" },
    { code: "VU.16", suffix: "16", name: "Malampa" },
    { code: "VU.17", suffix: "17", name: "Penama" },
    { code: "VU.18", suffix: "18", name: "Shefa" },
  ],
  "WF": [
    { code: "WF.98611", suffix: "98611", name: "Alo" },
    { code: "WF.98612", suffix: "98612", name: "Sigave" },
    { code: "WF.98613", suffix: "98613", name: "Uvea" },
  ],
  "WS": [
    { code: "WS.01", suffix: "01", name: "A'ana" },
    { code: "WS.02", suffix: "02", name: "Aiga-i-le-Tai" },
    { code: "WS.03", suffix: "03", name: "Atua" },
    { code: "WS.04", suffix: "04", name: "Fa‘asaleleaga" },
    { code: "WS.05", suffix: "05", name: "Gaga‘emauga" },
    { code: "WS.06", suffix: "06", name: "Va‘a-o-Fonoti" },
    { code: "WS.07", suffix: "07", name: "Gagaifomauga" },
    { code: "WS.08", suffix: "08", name: "Palauli" },
    { code: "WS.09", suffix: "09", name: "Satupa‘itea" },
    { code: "WS.10", suffix: "10", name: "Tuamasaga" },
    { code: "WS.11", suffix: "11", name: "Vaisigano" },
  ],
  "XK": [
    { code: "XK.10096138", suffix: "10096138", name: "Ferizaj" },
    { code: "XK.10096859", suffix: "10096859", name: "Gjakova" },
    { code: "XK.10097357", suffix: "10097357", name: "Gjilan" },
    { code: "XK.10097358", suffix: "10097358", name: "Mitrovica" },
    { code: "XK.10097359", suffix: "10097359", name: "Pec" },
    { code: "XK.10097360", suffix: "10097360", name: "Pristina" },
    { code: "XK.10097361", suffix: "10097361", name: "Prizren" },
  ],
  "YE": [
    { code: "YE.01", suffix: "01", name: "Abyan" },
    { code: "YE.02", suffix: "02", name: "Aden" },
    { code: "YE.03", suffix: "03", name: "Al Mahrah" },
    { code: "YE.04", suffix: "04", name: "Ḩaḑramawt" },
    { code: "YE.05", suffix: "05", name: "Shabwah" },
    { code: "YE.08", suffix: "08", name: "Al Hudaydah" },
    { code: "YE.10", suffix: "10", name: "Al Maḩwīt" },
    { code: "YE.11", suffix: "11", name: "Dhamār" },
    { code: "YE.14", suffix: "14", name: "Ma’rib" },
    { code: "YE.15", suffix: "15", name: "Şa‘dah" },
    { code: "YE.16", suffix: "16", name: "Sanaa" },
    { code: "YE.18", suffix: "18", name: "Aḑ Ḑāli‘" },
    { code: "YE.19", suffix: "19", name: "Omran" },
    { code: "YE.20", suffix: "20", name: "Al Bayda" },
    { code: "YE.21", suffix: "21", name: "Al Jawf" },
    { code: "YE.22", suffix: "22", name: "Ḩajjah" },
    { code: "YE.23", suffix: "23", name: "Ibb" },
    { code: "YE.24", suffix: "24", name: "Laḩij" },
    { code: "YE.25", suffix: "25", name: "Ta‘izz" },
    { code: "YE.26", suffix: "26", name: "Amanat Al Asimah" },
    { code: "YE.27", suffix: "27", name: "Raymah" },
    { code: "YE.28", suffix: "28", name: "Soqatra" },
  ],
  "YT": [
    { code: "YT.97601", suffix: "97601", name: "Acoua" },
    { code: "YT.97602", suffix: "97602", name: "Bandraboua" },
    { code: "YT.97603", suffix: "97603", name: "Bandrele" },
    { code: "YT.97604", suffix: "97604", name: "Bouéni" },
    { code: "YT.97605", suffix: "97605", name: "Chiconi" },
    { code: "YT.97606", suffix: "97606", name: "Chirongui" },
    { code: "YT.97607", suffix: "97607", name: "Dembeni" },
    { code: "YT.97608", suffix: "97608", name: "Dzaoudzi" },
    { code: "YT.97609", suffix: "97609", name: "Kani-Kéli" },
    { code: "YT.97610", suffix: "97610", name: "Koungou" },
    { code: "YT.97611", suffix: "97611", name: "Mamoudzou" },
    { code: "YT.97612", suffix: "97612", name: "Mtsamboro" },
    { code: "YT.97613", suffix: "97613", name: "M'Tsangamouji" },
    { code: "YT.97614", suffix: "97614", name: "Ouangani" },
    { code: "YT.97615", suffix: "97615", name: "Pamandzi" },
    { code: "YT.97616", suffix: "97616", name: "Sada" },
    { code: "YT.97617", suffix: "97617", name: "Tsingoni" },
  ],
  "ZA": [
    { code: "ZA.02", suffix: "02", name: "KwaZulu-Natal" },
    { code: "ZA.03", suffix: "03", name: "Orange Free State" },
    { code: "ZA.05", suffix: "05", name: "Eastern Cape" },
    { code: "ZA.06", suffix: "06", name: "Gauteng" },
    { code: "ZA.07", suffix: "07", name: "Mpumalanga" },
    { code: "ZA.08", suffix: "08", name: "Northern Cape" },
    { code: "ZA.09", suffix: "09", name: "Limpopo" },
    { code: "ZA.10", suffix: "10", name: "North-West" },
    { code: "ZA.11", suffix: "11", name: "Western Cape" },
  ],
  "ZM": [
    { code: "ZM.01", suffix: "01", name: "Western" },
    { code: "ZM.02", suffix: "02", name: "Central" },
    { code: "ZM.03", suffix: "03", name: "Eastern" },
    { code: "ZM.04", suffix: "04", name: "Luapula" },
    { code: "ZM.05", suffix: "05", name: "Northern" },
    { code: "ZM.06", suffix: "06", name: "North-Western" },
    { code: "ZM.07", suffix: "07", name: "Southern" },
    { code: "ZM.08", suffix: "08", name: "Copperbelt" },
    { code: "ZM.09", suffix: "09", name: "Lusaka" },
    { code: "ZM.10", suffix: "10", name: "Muchinga" },
  ],
  "ZW": [
    { code: "ZW.01", suffix: "01", name: "Manicaland" },
    { code: "ZW.02", suffix: "02", name: "Midlands" },
    { code: "ZW.03", suffix: "03", name: "Mashonaland Central" },
    { code: "ZW.04", suffix: "04", name: "Mashonaland East" },
    { code: "ZW.05", suffix: "05", name: "Mashonaland West" },
    { code: "ZW.06", suffix: "06", name: "Matabeleland North" },
    { code: "ZW.07", suffix: "07", name: "Matabeleland South" },
    { code: "ZW.08", suffix: "08", name: "Masvingo" },
    { code: "ZW.09", suffix: "09", name: "Bulawayo" },
    { code: "ZW.10", suffix: "10", name: "Harare" },
  ],
};

export const WORLD_DEPTS_BY_REGION: Record<string, WorldDept[]> = {
  "AE.01": [
    { code: "AE.01.101", name: "Abu Dhabi Municipality" },
    { code: "AE.01.102", name: "Al Ain Municipality" },
    { code: "AE.01.103", name: "Al Dhafra" },
  ],
  "AE.02": [
    { code: "AE.02.401", name: "Ajman" },
    { code: "AE.02.402", name: "Manama" },
    { code: "AE.02.403", name: "Masfout" },
  ],
  "AE.03": [
    { code: "AE.03.201", name: "Dubai" },
  ],
  "AE.04": [
    { code: "AE.04.701", name: "Al Fujairah Municipality" },
    { code: "AE.04.702", name: "Dibba Al Fujairah Municipality" },
  ],
  "AE.05": [
    { code: "AE.05.601", name: "Ras Al Khaimah" },
  ],
  "AE.06": [
    { code: "AE.06.301", name: "Sharjah" },
    { code: "AE.06.302", name: "Dhaid" },
    { code: "AE.06.303", name: "Al Hamriyah" },
    { code: "AE.06.304", name: "Khor Fakkan" },
    { code: "AE.06.305", name: "Kalba" },
    { code: "AE.06.306", name: "Al Madam" },
    { code: "AE.06.307", name: "Dibba Al Hesn" },
    { code: "AE.06.308", name: "Al Batayih" },
    { code: "AE.06.309", name: "Milehah" },
  ],
  "AE.07": [
    { code: "AE.07.501", name: "Umm AL Quwain" },
  ],
  "AF.01": [
    { code: "AF.01.1101", name: "Faīẕābād" },
    { code: "AF.01.1102", name: "Kishim" },
    { code: "AF.01.1103", name: "Jurm" },
    { code: "AF.01.1104", name: "Kuran Wa Munjan" },
    { code: "AF.01.1105", name: "Zaybāk" },
    { code: "AF.01.1106", name: "Wākhān" },
    { code: "AF.01.1107", name: "Ishkāshim" },
    { code: "AF.01.1108", name: "Bahārak" },
    { code: "AF.01.1109", name: "Shighnan District" },
    { code: "AF.01.1110", name: "Darwāz-e Pā’īn" },
    { code: "AF.01.1111", name: "Khwāhān" },
    { code: "AF.01.1112", name: "Rāghistān" },
    { code: "AF.01.1113", name: "Shahr-e Buzurg" },
    { code: "AF.01.1114", name: "Arghanj Khwāh" },
    { code: "AF.01.1115", name: "Argō" },
    { code: "AF.01.1116", name: "Darāyim" },
    { code: "AF.01.1117", name: "Darwāz-e Bālā" },
    { code: "AF.01.1118", name: "Khāsh" },
    { code: "AF.01.1119", name: "Kōhistān" },
    { code: "AF.01.1120", name: "Kūf Āb" },
    { code: "AF.01.1121", name: "Shikī" },
    { code: "AF.01.1122", name: "Shuhadā" },
    { code: "AF.01.1123", name: "Tagāb" },
    { code: "AF.01.1124", name: "Tashkān" },
    { code: "AF.01.1125", name: "Wardūj" },
    { code: "AF.01.1126", name: "Yaftal-e Suflá" },
    { code: "AF.01.1127", name: "Yamgān" },
    { code: "AF.01.1128", name: "Yāwān" },
  ],
  "AF.02": [
    { code: "AF.02.1901", name: "Qal‘ah-ye Now" },
    { code: "AF.02.1902", name: "Āb-e Kamarī" },
    { code: "AF.02.1903", name: "Qādis" },
    { code: "AF.02.1904", name: "Jowand" },
    { code: "AF.02.1905", name: "Ghōrmāch" },
    { code: "AF.02.1906", name: "Murghāb" },
    { code: "AF.02.1907", name: "Muqur" },
  ],
  "AF.03": [
    { code: "AF.03.1301", name: "Puli Khumri" },
    { code: "AF.03.1302", name: "Pul-e Ḩişār" },
    { code: "AF.03.1303", name: "Dahanah-ye Ghōrī" },
    { code: "AF.03.1304", name: "Dōshī" },
    { code: "AF.03.1305", name: "Tālah wa Barfak" },
    { code: "AF.03.1306", name: "Khinjān" },
    { code: "AF.03.1307", name: "Andarāb" },
    { code: "AF.03.1308", name: "Khōst wa Firing" },
    { code: "AF.03.1309", name: "Nahrīn" },
    { code: "AF.03.1310", name: "Būrkah" },
    { code: "AF.03.1311", name: "Baghlān-e Jadīd" },
    { code: "AF.03.1312", name: "Deh-e Şalāḩ" },
    { code: "AF.03.1313", name: "Firing wa Ghārū" },
    { code: "AF.03.1314", name: "Guz̄argāh-e Nūr" },
    { code: "AF.03.1315", name: "Khwājah Hijrān" },
  ],
  "AF.05": [
    { code: "AF.05.2801", name: "Bamyan" },
    { code: "AF.05.2802", name: "Shibar" },
    { code: "AF.05.2803", name: "Kahmard" },
    { code: "AF.05.2804", name: "Yakāwlang" },
    { code: "AF.05.2805", name: "Panjāb" },
    { code: "AF.05.2806", name: "Waras̄" },
    { code: "AF.05.2807", name: "Sayghān" },
  ],
  "AF.06": [
    { code: "AF.06.2101", name: "Farah" },
    { code: "AF.06.2102", name: "Bakwāh" },
    { code: "AF.06.2103", name: "Gulistān" },
    { code: "AF.06.2104", name: "Pur Chaman" },
    { code: "AF.06.2105", name: "Bālā Bulūk" },
    { code: "AF.06.2106", name: "Khāk-e Safēd" },
    { code: "AF.06.2107", name: "Anār Darah" },
    { code: "AF.06.2108", name: "Qal‘ah-ye Kāh" },
    { code: "AF.06.2109", name: "Lāsh-e Juwayn" },
    { code: "AF.06.2110", name: "Shayb Kōh" },
    { code: "AF.06.2111", name: "Pusht-e Rōd" },
  ],
  "AF.07": [
    { code: "AF.07.1801", name: "Maīmanah" },
    { code: "AF.07.1802", name: "Pas̲h̲tūn Kōṯ" },
    { code: "AF.07.1803", name: "Almār" },
    { code: "AF.07.1804", name: "Qaīşār" },
    { code: "AF.07.1805", name: "Kōhistān" },
    { code: "AF.07.1806", name: "Bal Chirāgh" },
    { code: "AF.07.1807", name: "Gurzīwān" },
    { code: "AF.07.1808", name: "Shīrīn Tagāb" },
    { code: "AF.07.1809", name: "Dowlatābād" },
    { code: "AF.07.1810", name: "Qaram Qōl" },
    { code: "AF.07.1811", name: "Khān-e Chahār Bāgh" },
    { code: "AF.07.1812", name: "Andkhōy" },
    { code: "AF.07.1813", name: "Khwājah Sabz Pōsh" },
    { code: "AF.07.1814", name: "Qurghān" },
  ],
  "AF.08": [
    { code: "AF.08.601", name: "Ghaznī" },
    { code: "AF.08.602", name: "Bahrām-e Shahīd" },
    { code: "AF.08.603", name: "Khwājah ‘Omarī" },
    { code: "AF.08.604", name: "Nāwur" },
    { code: "AF.08.605", name: "Ajristān" },
    { code: "AF.08.606", name: "Mālistān" },
    { code: "AF.08.607", name: "Jāghūrī" },
    { code: "AF.08.608", name: "Muqêr" },
    { code: "AF.08.609", name: "Gēlān" },
    { code: "AF.08.610", name: "Nāwah" },
    { code: "AF.08.611", name: "Āb Band" },
    { code: "AF.08.612", name: "Gīrō" },
    { code: "AF.08.613", name: "Qarah Bāgh" },
    { code: "AF.08.614", name: "Andaṟ" },
    { code: "AF.08.615", name: "Deh Yak" },
    { code: "AF.08.616", name: "Zanakhān" },
    { code: "AF.08.617", name: "Rashīdān" },
    { code: "AF.08.618", name: "Wāghaz̧" },
    { code: "AF.08.619", name: "Walī Muḩammad Shahīd Khūgyāṉī" },
  ],
  "AF.09": [
    { code: "AF.09.2701", name: "Chaghcharān" },
    { code: "AF.09.2702", name: "Shahrak" },
    { code: "AF.09.2703", name: "Tūlak" },
    { code: "AF.09.2704", name: "Sāghar" },
    { code: "AF.09.2705", name: "Taywarah" },
    { code: "AF.09.2706", name: "Pasāband" },
    { code: "AF.09.2707", name: "La‘l wa Sar Jangal" },
    { code: "AF.09.2708", name: "Chahār Şadah" },
    { code: "AF.09.2709", name: "Dowlatyār" },
    { code: "AF.09.2710", name: "Dū Laīnah" },
  ],
  "AF.10": [
    { code: "AF.10.2301", name: "Lashkar Gāh" },
    { code: "AF.10.2302", name: "Nahr-e Sarāj" },
    { code: "AF.10.2303", name: "Kajakī" },
    { code: "AF.10.2304", name: "Mūsá Qal‘ah" },
    { code: "AF.10.2305", name: "Bāghrān" },
    { code: "AF.10.2306", name: "Naw Zad" },
    { code: "AF.10.2307", name: "Wāshēr" },
    { code: "AF.10.2308", name: "Nād ‘Alī" },
    { code: "AF.10.2309", name: "Nāwah-ye Bārakzaī" },
    { code: "AF.10.2310", name: "Dīshū" },
    { code: "AF.10.2311", name: "Garmsīr" },
    { code: "AF.10.2312", name: "Sangīn" },
    { code: "AF.10.2313", name: "Rēg-e Khān Neshīn" },
  ],
  "AF.11": [
    { code: "AF.11.2001", name: "Herat District" },
    { code: "AF.11.2002", name: "Injīl" },
    { code: "AF.11.2003", name: "Guz̄arah" },
    { code: "AF.11.2004", name: "Pas̲h̲tūn Zarghūn" },
    { code: "AF.11.2005", name: "Karukh" },
    { code: "AF.11.2006", name: "Kushk" },
    { code: "AF.11.2007", name: "Gulrān" },
    { code: "AF.11.2008", name: "Kuhsān" },
    { code: "AF.11.2009", name: "Ghōriyān" },
    { code: "AF.11.2010", name: "Zindah Jān" },
    { code: "AF.11.2011", name: "Adraskan" },
    { code: "AF.11.2012", name: "Ōbêh" },
    { code: "AF.11.2013", name: "Farsī" },
    { code: "AF.11.2014", name: "Shīnḏanḏ" },
    { code: "AF.11.2015", name: "Chisht-e Sharīf" },
    { code: "AF.11.2016", name: "Kushk-e Kuhnah" },
  ],
  "AF.13": [
    { code: "AF.13.101", name: "Kabul" },
    { code: "AF.13.102", name: "Deh-e Sabz" },
    { code: "AF.13.103", name: "Mīr Bachah Kōṯ" },
    { code: "AF.13.104", name: "Kalakān" },
    { code: "AF.13.105", name: "Qarah Bāgh" },
    { code: "AF.13.106", name: "Istālif" },
    { code: "AF.13.107", name: "Shakar Darah" },
    { code: "AF.13.108", name: "Paghmān" },
    { code: "AF.13.109", name: "Chahār Āsyāb" },
    { code: "AF.13.110", name: "Bagrāmī" },
    { code: "AF.13.111", name: "Khāk-e Jabār" },
    { code: "AF.13.112", name: "Surobi" },
    { code: "AF.13.113", name: "Gul Darah" },
    { code: "AF.13.114", name: "Mūsahī" },
    { code: "AF.13.115", name: "Farzah" },
  ],
  "AF.14": [
    { code: "AF.14.201", name: "Maḩmūd-e Rāqī" },
    { code: "AF.14.202", name: "Ḩişah-ye Awal-e Kōhistān" },
    { code: "AF.14.203", name: "Kōh Band" },
    { code: "AF.14.204", name: "Nijrāb" },
    { code: "AF.14.205", name: "Tagāb" },
    { code: "AF.14.206", name: "Alah Sāy" },
    { code: "AF.14.207", name: "Ḩişah-ye Duwum-e Kōhistān" },
  ],
  "AF.17": [
    { code: "AF.17.501", name: "Pul-e ‘Alam" },
    { code: "AF.17.502", name: "Charkh" },
    { code: "AF.17.503", name: "Barakī Barak" },
    { code: "AF.17.504", name: "Khōshī" },
    { code: "AF.17.505", name: "Muḩammad Āghah" },
    { code: "AF.17.506", name: "Azrah" },
    { code: "AF.17.507", name: "Kharwār" },
  ],
  "AF.18": [
    { code: "AF.18.801", name: "Jalālābād" },
    { code: "AF.18.802", name: "Surkh Rōd" },
    { code: "AF.18.803", name: "Ḩişārak" },
    { code: "AF.18.804", name: "Shērzād" },
    { code: "AF.18.805", name: "Khūgyāṉī" },
    { code: "AF.18.806", name: "Chaparhār" },
    { code: "AF.18.807", name: "Pachīr wa Āgām" },
    { code: "AF.18.808", name: "Deh Bālā" },
    { code: "AF.18.809", name: "Rōdāt" },
    { code: "AF.18.810", name: "Achīn" },
    { code: "AF.18.811", name: "Nāziyān" },
    { code: "AF.18.812", name: "Dur Bābā" },
    { code: "AF.18.813", name: "Shīnwār" },
    { code: "AF.18.814", name: "Mohmand Darah" },
    { code: "AF.18.815", name: "La‘lpūr" },
    { code: "AF.18.816", name: "Gōshtah" },
    { code: "AF.18.817", name: "Batī Kōṯ" },
    { code: "AF.18.818", name: "Kāmah" },
    { code: "AF.18.819", name: "Kūz Kunaṟ" },
    { code: "AF.18.820", name: "Darah-ye Nūr" },
    { code: "AF.18.821", name: "Bihsūd" },
    { code: "AF.18.822", name: "Kōṯ" },
  ],
  "AF.19": [
    { code: "AF.19.2201", name: "Zaranj" },
    { code: "AF.19.2202", name: "Kang" },
    { code: "AF.19.2203", name: "Chahār Burjak" },
    { code: "AF.19.2204", name: "Chakhansur" },
    { code: "AF.19.2205", name: "Khāsh Rōd" },
  ],
  "AF.23": [
    { code: "AF.23.2401", name: "Kandahar District" },
    { code: "AF.23.2402", name: "Dāmān" },
    { code: "AF.23.2403", name: "Shāh Walī Kōṯ" },
    { code: "AF.23.2404", name: "Arghandāb" },
    { code: "AF.23.2405", name: "Khākrēz" },
    { code: "AF.23.2406", name: "Ghōrak" },
    { code: "AF.23.2407", name: "Maywand" },
    { code: "AF.23.2408", name: "Panjwā’ī" },
    { code: "AF.23.2409", name: "Rēgistān" },
    { code: "AF.23.2410", name: "Shōrābak" },
    { code: "AF.23.2411", name: "Spīn Bōldak" },
    { code: "AF.23.2412", name: "Arghistān" },
    { code: "AF.23.2413", name: "Ma‘rūf" },
    { code: "AF.23.2414", name: "Myā Neshīn" },
    { code: "AF.23.2415", name: "Nēsh" },
    { code: "AF.23.2416", name: "Zhaṟêy" },
  ],
  "AF.24": [
    { code: "AF.24.1401", name: "Kunduz" },
    { code: "AF.24.1402", name: "Imām Şāḩib" },
    { code: "AF.24.1403", name: "Qal‘ah-ye Zāl" },
    { code: "AF.24.1404", name: "Chahar Dara" },
    { code: "AF.24.1405", name: "‘Alīābād" },
    { code: "AF.24.1406", name: "Khānābād" },
    { code: "AF.24.1407", name: "Dasht-e Archī" },
  ],
  "AF.26": [
    { code: "AF.26.1201", name: "Tāluqān" },
    { code: "AF.26.1202", name: "Bangī" },
    { code: "AF.26.1203", name: "Ishkamish" },
    { code: "AF.26.1204", name: "Chāl" },
    { code: "AF.26.1205", name: "Warsaj" },
    { code: "AF.26.1206", name: "Farkhār" },
    { code: "AF.26.1207", name: "Kalafgān" },
    { code: "AF.26.1208", name: "Rustāq" },
    { code: "AF.26.1209", name: "Chāh Āb" },
    { code: "AF.26.1210", name: "Yangī Qal‘ah" },
    { code: "AF.26.1211", name: "Darqad" },
    { code: "AF.26.1212", name: "Khwājah Ghār" },
    { code: "AF.26.1213", name: "Bahārak" },
    { code: "AF.26.1214", name: "Dasht-e Qal‘ah" },
    { code: "AF.26.1215", name: "Hazār Sumūch" },
    { code: "AF.26.1216", name: "Khwājah Bahāwuddīn" },
    { code: "AF.26.1217", name: "Namak Āb" },
  ],
  "AF.27": [
    { code: "AF.27.401", name: "Maīdān Shahr" },
    { code: "AF.27.402", name: "Jalrayz" },
    { code: "AF.27.403", name: "Ḩişah-ye Awal-e Bihsūd" },
    { code: "AF.27.404", name: "Markazi Bihsud" },
    { code: "AF.27.405", name: "Day Mirdad" },
    { code: "AF.27.406", name: "Chak-e Wardak" },
    { code: "AF.27.407", name: "Sayyidābād" },
    { code: "AF.27.408", name: "Nirkh" },
    { code: "AF.27.409", name: "Jaghatū" },
  ],
  "AF.28": [
    { code: "AF.28.2501", name: "Qalāt" },
    { code: "AF.28.2502", name: "Shāh Jōy" },
    { code: "AF.28.2503", name: "Arghandāb" },
    { code: "AF.28.2504", name: "Dāychōpān" },
    { code: "AF.28.2505", name: "Mīzān" },
    { code: "AF.28.2506", name: "Tarnêk wa Jaldak" },
    { code: "AF.28.2507", name: "Shīnkaī" },
    { code: "AF.28.2508", name: "Aṯghar" },
    { code: "AF.28.2509", name: "Shamulzaī" },
    { code: "AF.28.2510", name: "Kākar" },
    { code: "AF.28.2511", name: "Now Bahār" },
  ],
  "AF.29": [
    { code: "AF.29.2901", name: "Sharan" },
    { code: "AF.29.2902", name: "Zarghūn Shahr" },
    { code: "AF.29.2903", name: "Ḏīlah" },
    { code: "AF.29.2904", name: "Wāzah Khwāh" },
    { code: "AF.29.2905", name: "Wuṟ Mamay" },
    { code: "AF.29.2906", name: "Gōmal" },
    { code: "AF.29.2907", name: "Ōmnah" },
    { code: "AF.29.2908", name: "Saṟōbī" },
    { code: "AF.29.2909", name: "Bêrmal" },
    { code: "AF.29.2910", name: "Giyān" },
    { code: "AF.29.2911", name: "Urgun District" },
    { code: "AF.29.2912", name: "Zīṟūk" },
    { code: "AF.29.2913", name: "Nīkêh" },
    { code: "AF.29.2914", name: "Sar Rowẕah" },
    { code: "AF.29.2915", name: "Mutā Khān" },
    { code: "AF.29.2916", name: "Jānī Khēl" },
    { code: "AF.29.2917", name: "Têrwō" },
    { code: "AF.29.2918", name: "Yaḩyá Khēl" },
    { code: "AF.29.2919", name: "Yōsuf Khēl" },
  ],
  "AF.30": [
    { code: "AF.30.1601", name: "Mazār-e Sharīf" },
    { code: "AF.30.1602", name: "Nahri Shahi" },
    { code: "AF.30.1603", name: "Zārī" },
    { code: "AF.30.1604", name: "Shōr Tepah" },
    { code: "AF.30.1605", name: "Dowlatābād" },
    { code: "AF.30.1606", name: "Balkh District" },
    { code: "AF.30.1607", name: "Chahār Bōlak" },
    { code: "AF.30.1608", name: "Chimtāl" },
    { code: "AF.30.1609", name: "Sholgara" },
    { code: "AF.30.1610", name: "Kishindeh" },
    { code: "AF.30.1611", name: "Chahār Kent" },
    { code: "AF.30.1612", name: "Dehdādī" },
    { code: "AF.30.1613", name: "Kaldār" },
    { code: "AF.30.1614", name: "Khulm" },
    { code: "AF.30.1615", name: "Mārmul" },
  ],
  "AF.31": [
    { code: "AF.31.1701", name: "Shibirghān" },
    { code: "AF.31.1702", name: "Khwājah Dū Kōh" },
    { code: "AF.31.1703", name: "Darzāb" },
    { code: "AF.31.1704", name: "Mingajik" },
    { code: "AF.31.1705", name: "Qarqīn" },
    { code: "AF.31.1706", name: "Āqchah" },
    { code: "AF.31.1707", name: "Mardīān" },
    { code: "AF.31.1708", name: "Faīẕābād" },
    { code: "AF.31.1709", name: "Khamyāb" },
    { code: "AF.31.1710", name: "Khānaqāh" },
    { code: "AF.31.1711", name: "Qūsh Tepah" },
  ],
  "AF.32": [
    { code: "AF.32.1501", name: "Aībak" },
    { code: "AF.32.1502", name: "Ḩaẕrat-e Sulţān" },
    { code: "AF.32.1503", name: "Darah-ye Şūf-e Bālā" },
    { code: "AF.32.1504", name: "Darah-ye Şūf-e Pā’īn" },
    { code: "AF.32.1505", name: "Rūy Dūāb" },
    { code: "AF.32.1506", name: "Khuram wa Sār Bāgh" },
    { code: "AF.32.1507", name: "Fayrōz Nakhchīr" },
  ],
  "AF.33": [
    { code: "AF.33.3101", name: "Sar-e Pul" },
    { code: "AF.33.3102", name: "Sangchārak" },
    { code: "AF.33.3103", name: "Kōhistānāt" },
    { code: "AF.33.3104", name: "Balkhāb" },
    { code: "AF.33.3105", name: "Sōzmah Qal‘ah" },
    { code: "AF.33.3106", name: "Şayād" },
    { code: "AF.33.3107", name: "Gōsfandī" },
  ],
  "AF.34": [
    { code: "AF.34.1001", name: "Asadābād" },
    { code: "AF.34.1002", name: "Marawarah" },
    { code: "AF.34.1003", name: "Bar Kunaṟ" },
    { code: "AF.34.1004", name: "Dāngām" },
    { code: "AF.34.1005", name: "Nāṟay" },
    { code: "AF.34.1006", name: "Ghāzīābād" },
    { code: "AF.34.1007", name: "Shīgal wa Shêltan" },
    { code: "AF.34.1008", name: "Wuṯahpūr" },
    { code: "AF.34.1009", name: "Chapah Darah" },
    { code: "AF.34.1010", name: "Darah-ye Pēch" },
    { code: "AF.34.1011", name: "Narang" },
    { code: "AF.34.1012", name: "Tsowkêy" },
    { code: "AF.34.1013", name: "Nūrgal" },
    { code: "AF.34.1014", name: "Khāş Kunaṟ" },
    { code: "AF.34.1015", name: "Sirkanay" },
  ],
  "AF.35": [
    { code: "AF.35.901", name: "Mehtar Lām" },
    { code: "AF.35.902", name: "Qarghah’ī" },
    { code: "AF.35.903", name: "‘Alīngār" },
    { code: "AF.35.904", name: "Dowlat Shāh" },
    { code: "AF.35.905", name: "‘Alīsheng" },
  ],
  "AF.36": [
    { code: "AF.36.701", name: "Gardez" },
    { code: "AF.36.702", name: "Zurmat" },
    { code: "AF.36.703", name: "Shwāk" },
    { code: "AF.36.704", name: "Dzadrān" },
    { code: "AF.36.705", name: "Aḩmadābād" },
    { code: "AF.36.706", name: "Jānī Khēl" },
    { code: "AF.36.707", name: "Ḏanḏ Paṯān" },
    { code: "AF.36.708", name: "Tsamkanī" },
    { code: "AF.36.709", name: "Lajah Aḩmad Khēl" },
    { code: "AF.36.710", name: "Sayyid Karam" },
    { code: "AF.36.711", name: "Jājī" },
  ],
  "AF.37": [
    { code: "AF.37.3201", name: "Khōst" },
    { code: "AF.37.3202", name: "Jājī Maīdān" },
    { code: "AF.37.3203", name: "Tani" },
    { code: "AF.37.3204", name: "Spērah" },
    { code: "AF.37.3205", name: "Mūsá Khēl" },
    { code: "AF.37.3206", name: "Mandūzaī" },
    { code: "AF.37.3207", name: "Têrayzaī" },
    { code: "AF.37.3208", name: "Nādir Shāh Kōṯ" },
    { code: "AF.37.3209", name: "Şabarī" },
    { code: "AF.37.3210", name: "Bāk" },
    { code: "AF.37.3211", name: "Gurbuz" },
    { code: "AF.37.3212", name: "Qalandar" },
    { code: "AF.37.3213", name: "Shamul" },
  ],
  "AF.38": [
    { code: "AF.38.3001", name: "Pārūn" },
    { code: "AF.38.3002", name: "Kāmdēsh" },
    { code: "AF.38.3003", name: "Wāygal" },
    { code: "AF.38.3004", name: "Mandōl" },
    { code: "AF.38.3005", name: "Barg-e Matāl" },
    { code: "AF.38.3006", name: "Wāmā" },
    { code: "AF.38.3007", name: "Dū Āb" },
    { code: "AF.38.3008", name: "Nūrgarām" },
  ],
  "AF.39": [
    { code: "AF.39.2601", name: "Tarīn Kōṯ" },
    { code: "AF.39.2602", name: "Chōrah" },
    { code: "AF.39.2603", name: "Khāş Uruzgān" },
    { code: "AF.39.2604", name: "Shahīd-e Ḩasās" },
    { code: "AF.39.2605", name: "Deh Rāwud" },
  ],
  "AF.40": [
    { code: "AF.40.301", name: "Chārīkār" },
    { code: "AF.40.302", name: "Jabal us Sarāj" },
    { code: "AF.40.303", name: "Sālang" },
    { code: "AF.40.304", name: "Shīnwārī" },
    { code: "AF.40.305", name: "Siyāhgird Ghōrband" },
    { code: "AF.40.306", name: "Shaykh ‘Alī" },
    { code: "AF.40.307", name: "Surkhi Parsa" },
    { code: "AF.40.308", name: "Bagrām" },
    { code: "AF.40.309", name: "Kōh-e Şāfī" },
    { code: "AF.40.310", name: "Sayyid Khēl" },
  ],
  "AF.41": [
    { code: "AF.41.3401", name: "Nīlī" },
    { code: "AF.41.3402", name: "Gīzāb" },
    { code: "AF.41.3403", name: "Ishtarlay" },
    { code: "AF.41.3404", name: "Kajrān" },
    { code: "AF.41.3405", name: "Khadīr" },
    { code: "AF.41.3406", name: "Gaytī" },
    { code: "AF.41.3407", name: "Mīr Āmōr" },
    { code: "AF.41.3408", name: "Sang-e Takht" },
    { code: "AF.41.3409", name: "Shahristān" },
  ],
  "AF.42": [
    { code: "AF.42.3301", name: "Bāzārak" },
    { code: "AF.42.3302", name: "Darah" },
    { code: "AF.42.3303", name: "Khinj" },
    { code: "AF.42.3304", name: "Parīān" },
    { code: "AF.42.3305", name: "Shutul" },
    { code: "AF.42.3306", name: "‘Unābah" },
    { code: "AF.42.3307", name: "Rukhah" },
  ],
  "AL.40": [
    { code: "AL.40.01", name: "Rrethi i Beratit" },
    { code: "AL.40.10944368", name: "Bashkia Berat" },
    { code: "AL.40.10944369", name: "Bashkia Kuçovë" },
    { code: "AL.40.10944370", name: "Bashkia Poliçan" },
    { code: "AL.40.10944371", name: "Bashkia Skrapar" },
    { code: "AL.40.10944372", name: "Bashkia Ura Vajgurore" },
    { code: "AL.40.22", name: "Rrethi i Skraparit" },
    { code: "AL.40.34", name: "Rrethi i Kuçovës" },
  ],
  "AL.41": [
    { code: "AL.41.02", name: "Rrethi i Dibrës" },
    { code: "AL.41.10944373", name: "Bashkia Bulqizë" },
    { code: "AL.41.10944374", name: "Bashkia Dibër" },
    { code: "AL.41.10944375", name: "Bashkia Klos" },
    { code: "AL.41.10944376", name: "Bashkia Mat" },
    { code: "AL.41.15", name: "Rrethi i Matit" },
    { code: "AL.41.29", name: "Rrethi i Bulqizës" },
  ],
  "AL.42": [
    { code: "AL.42.03", name: "Durrës District" },
    { code: "AL.42.10", name: "Rrethi i Krujës" },
    { code: "AL.42.10944377", name: "Bashkia Durrës" },
    { code: "AL.42.10944378", name: "Bashkia Krujë" },
    { code: "AL.42.10944379", name: "Bashkia Shijak" },
  ],
  "AL.43": [
    { code: "AL.43.04", name: "Rrethi i Elbasanit" },
    { code: "AL.43.07", name: "Rrethi i Gramshit" },
    { code: "AL.43.10944380", name: "Bashkia Elbasan" },
    { code: "AL.43.10944381", name: "Bashkia Belsh" },
    { code: "AL.43.10944382", name: "Bashkia Cërrik" },
    { code: "AL.43.10944383", name: "Bashkia Gramsh" },
    { code: "AL.43.10944384", name: "Bashkia Librazhd" },
    { code: "AL.43.10944385", name: "Bashkia Peqin" },
    { code: "AL.43.10944386", name: "Bashkia Prrenjas" },
    { code: "AL.43.13", name: "Rrethi i Librazhdit" },
    { code: "AL.43.38", name: "Rrethi i Peqinit" },
  ],
  "AL.44": [
    { code: "AL.44.05", name: "Fier" },
    { code: "AL.44.10944387", name: "Bashkia Divjakë" },
    { code: "AL.44.10944388", name: "Bashkia Fier" },
    { code: "AL.44.10944390", name: "Bashkia Mallakastër" },
    { code: "AL.44.10944391", name: "Bashkia Patos" },
    { code: "AL.44.10944392", name: "Bashkia Roskovec" },
    { code: "AL.44.14", name: "Rrethi i Lushnjës" },
    { code: "AL.44.37", name: "Rrethi i Mallakastrës" },
  ],
  "AL.45": [
    { code: "AL.45.06", name: "Rrethi i Gjirokastrës" },
    { code: "AL.45.10944393", name: "Bashkia Dropull" },
    { code: "AL.45.10944394", name: "Bashkia Gjirokastër" },
    { code: "AL.45.10944395", name: "Bashkia Kelcyrë" },
    { code: "AL.45.10944396", name: "Bashkia Libohovë" },
    { code: "AL.45.10944397", name: "Bashkia Memaliaj" },
    { code: "AL.45.10944398", name: "Bashkia Përmet" },
    { code: "AL.45.10944399", name: "Bashkia Tepelenë" },
    { code: "AL.45.17", name: "Rrethi i Përmetit" },
    { code: "AL.45.23", name: "Rrethi i Tepelenës" },
  ],
  "AL.46": [
    { code: "AL.46.08", name: "Rrethi i Kolonjës" },
    { code: "AL.46.09", name: "Rrethi i Korçës" },
    { code: "AL.46.10944400", name: "Bashkia Devoll" },
    { code: "AL.46.10944401", name: "Bashkia Kolonjë" },
    { code: "AL.46.10944402", name: "Bashkia Korçë" },
    { code: "AL.46.10944403", name: "Bashkia Maliq" },
    { code: "AL.46.10944404", name: "Bashkia Pogradec" },
    { code: "AL.46.10944405", name: "Bashkia Pustec" },
    { code: "AL.46.18", name: "Rrethi i Pogradecit" },
    { code: "AL.46.31", name: "Rrethi i Devollit" },
  ],
  "AL.47": [
    { code: "AL.47.10944406", name: "Bashkia Has" },
    { code: "AL.47.10944407", name: "Bashkia Kukës" },
    { code: "AL.47.10944408", name: "Bashkia Tropojë" },
    { code: "AL.47.11", name: "Rrethi i Kukësit" },
    { code: "AL.47.26", name: "Rrethi i Tropojës" },
    { code: "AL.47.32", name: "Rrethi i Hasit" },
  ],
  "AL.48": [
    { code: "AL.48.10944409", name: "Bashkia Kurbin" },
    { code: "AL.48.10944410", name: "Bashkia Lezhë" },
    { code: "AL.48.10944411", name: "Bashkia Mirditë" },
    { code: "AL.48.12", name: "Lezhë" },
    { code: "AL.48.16", name: "Rrethi i Mirditës" },
    { code: "AL.48.35", name: "Rrethi i Kurbinit" },
  ],
  "AL.49": [
    { code: "AL.49.10944412", name: "Bashkia Fushë Arrës" },
    { code: "AL.49.10944413", name: "Bashkia Malësi e Madhe" },
    { code: "AL.49.10944414", name: "Bashkia Pukë" },
    { code: "AL.49.10944415", name: "Bashkia Shkodër" },
    { code: "AL.49.10944416", name: "Bashkia Vau i Dejës" },
    { code: "AL.49.19", name: "Rrethi i Pukës" },
    { code: "AL.49.21", name: "Rrethi i Shkodrës" },
    { code: "AL.49.36", name: "Rrethi i Malësia e Madhe" },
  ],
  "AL.50": [
    { code: "AL.50.10944417", name: "Bashkia Kamëz" },
    { code: "AL.50.10944418", name: "Bashkia Kavajë" },
    { code: "AL.50.10944419", name: "Bashkia Rrogozhinë" },
    { code: "AL.50.10944420", name: "Bashkia Tiranë" },
    { code: "AL.50.10944421", name: "Bashkia Vorë" },
    { code: "AL.50.28", name: "Rrethi i Tiranës" },
    { code: "AL.50.33", name: "Rrethi i Kavajës" },
  ],
  "AL.51": [
    { code: "AL.51.10944422", name: "Bashkia Delvinë" },
    { code: "AL.51.10944423", name: "Bashkia Finiq" },
    { code: "AL.51.10944424", name: "Bashkia Himarë" },
    { code: "AL.51.10944425", name: "Bashkia Konispol" },
    { code: "AL.51.10944426", name: "Bashkia Sarandë" },
    { code: "AL.51.10944427", name: "Bashkia Selenicë" },
    { code: "AL.51.10944428", name: "Bashkia Vlorë" },
    { code: "AL.51.20", name: "Rrethi i Sarandës" },
    { code: "AL.51.27", name: "Rrethi i Vlorës" },
    { code: "AL.51.30", name: "Rrethi i Delvinës" },
  ],
  "AM.01": [
    { code: "AM.01.7874001", name: "Achtarak" },
  ],
  "AM.04": [
    { code: "AM.04.616436", name: "Martuni" },
  ],
  "AM.08": [
    { code: "AM.08.174761", name: "Sisian" },
  ],
  "AM.10": [
    { code: "AM.10.174959", name: "Vayk'i Shrjan" },
  ],
  "AM.11": [
    { code: "AM.11.616200", name: "Spandaryanskiy Rayon" },
    { code: "AM.11.616205", name: "Arabkir" },
    { code: "AM.11.616233", name: "Shaumyanskiy Rayon" },
    { code: "AM.11.616323", name: "Ordzhonikidzevskiy Rayon" },
    { code: "AM.11.616485", name: "Leninskiy Rayon" },
    { code: "AM.11.616624", name: "Imeni Dvadtsati Shesti Komissarov Rayon" },
  ],
  "AO.01": [
    { code: "AO.01.10440258", name: "Catumbela" },
    { code: "AO.01.3347937", name: "Lobito" },
    { code: "AO.01.3348578", name: "Ganda" },
    { code: "AO.01.3349225", name: "Cubal" },
    { code: "AO.01.3349404", name: "Chongoroi" },
    { code: "AO.01.3351267", name: "Caimbambo" },
    { code: "AO.01.3351597", name: "Bocoio" },
    { code: "AO.01.3351661", name: "Benguela" },
    { code: "AO.01.3351758", name: "Município Balombo" },
    { code: "AO.01.3351785", name: "Baía Farta" },
  ],
  "AO.02": [
    { code: "AO.02.3346941", name: "Nharea" },
    { code: "AO.02.3348077", name: "Cuito" },
    { code: "AO.02.3349078", name: "Cunhinga" },
    { code: "AO.02.3349179", name: "Cuemba" },
    { code: "AO.02.3349514", name: "Chitembo" },
    { code: "AO.02.3349722", name: "Chinguar" },
    { code: "AO.02.3350370", name: "Catabola" },
    { code: "AO.02.3351012", name: "Município Camacupa" },
    { code: "AO.02.3351013", name: "Camacupa" },
    { code: "AO.02.3351882", name: "Andulo" },
    { code: "AO.02.9212598", name: "Barkeol" },
  ],
  "AO.03": [
    { code: "AO.03.2240660", name: "Cacongo" },
    { code: "AO.03.2243267", name: "Cabinda" },
    { code: "AO.03.2243457", name: "Buco Zau" },
    { code: "AO.03.2243645", name: "Belize" },
  ],
  "AO.04": [
    { code: "AO.04.3347005", name: "Nancova" },
    { code: "AO.04.3347352", name: "Menongue" },
    { code: "AO.04.3349148", name: "Cuito Cuanavale" },
    { code: "AO.04.3349195", name: "Cuchi" },
    { code: "AO.04.3349243", name: "Cuangar" },
    { code: "AO.04.3351214", name: "Calai" },
    { code: "AO.04.875819", name: "Rivungo" },
    { code: "AO.04.876017", name: "Mavinga" },
    { code: "AO.04.876291", name: "Dirico" },
  ],
  "AO.05": [
    { code: "AO.05.10450082", name: "Samba Cajú" },
    { code: "AO.05.2238485", name: "Quiculungo" },
    { code: "AO.05.2240384", name: "Lucala" },
    { code: "AO.05.2240905", name: "Ngonguembo" },
    { code: "AO.05.2240974", name: "Golungo Alto" },
    { code: "AO.05.2241967", name: "Cazengo Municipality" },
    { code: "AO.05.2242801", name: "Cambambe" },
    { code: "AO.05.2243535", name: "Bolongongo" },
    { code: "AO.05.2243811", name: "Banga" },
    { code: "AO.05.2243916", name: "Ambaca" },
  ],
  "AO.06": [
    { code: "AO.06.3345496", name: "Cela" },
    { code: "AO.06.3346014", name: "Sumbe" },
    { code: "AO.06.3346113", name: "Seles" },
    { code: "AO.06.3346558", name: "Quilenda" },
    { code: "AO.06.3346597", name: "Quibala" },
    { code: "AO.06.3346659", name: "Porto Amboim" },
    { code: "AO.06.3347070", name: "Mussende" },
    { code: "AO.06.3347989", name: "Libolo" },
    { code: "AO.06.3348792", name: "Ebo" },
    { code: "AO.06.3349321", name: "Conda" },
    { code: "AO.06.3350385", name: "Cassongue" },
    { code: "AO.06.3351905", name: "Amboim" },
  ],
  "AO.07": [
    { code: "AO.07.3346850", name: "Ombadja" },
    { code: "AO.07.3347028", name: "Namacunde" },
    { code: "AO.07.3348986", name: "Cuvelai" },
    { code: "AO.07.3349045", name: "Curoca" },
    { code: "AO.07.3349237", name: "Cuanhama" },
    { code: "AO.07.3351306", name: "Cahama" },
  ],
  "AO.08": [
    { code: "AO.08.3345667", name: "Ucuma" },
    { code: "AO.08.3345909", name: "Chinjenje" },
    { code: "AO.08.3345923", name: "Chicala Cholohanga" },
    { code: "AO.08.3347110", name: "Mungo" },
    { code: "AO.08.3347852", name: "Longonjo" },
    { code: "AO.08.3347879", name: "Londuimbali" },
    { code: "AO.08.3348093", name: "Cachiungo" },
    { code: "AO.08.3348311", name: "Huambo" },
    { code: "AO.08.3348773", name: "Ecunha" },
    { code: "AO.08.3351497", name: "Caála" },
    { code: "AO.08.3351782", name: "Bailundo" },
  ],
  "AO.09": [
    { code: "AO.09.10449850", name: "Cacula" },
    { code: "AO.09.3346496", name: "Quipungo" },
    { code: "AO.09.3346556", name: "Quilengues" },
    { code: "AO.09.3347423", name: "Matala" },
    { code: "AO.09.3347760", name: "Lubango" },
    { code: "AO.09.3348075", name: "Cuvango" },
    { code: "AO.09.3348165", name: "Jamba" },
    { code: "AO.09.3348286", name: "Humpata" },
    { code: "AO.09.3349647", name: "Chipindo" },
    { code: "AO.09.3349949", name: "Chicomba" },
    { code: "AO.09.3349996", name: "Chibia" },
    { code: "AO.09.3350009", name: "Gambos" },
    { code: "AO.09.3351021", name: "Caluquembe" },
    { code: "AO.09.3351379", name: "Caconda" },
  ],
  "AO.12": [
    { code: "AO.12.10402309", name: "Kiwaba Nzoji" },
    { code: "AO.12.2238814", name: "Quela" },
    { code: "AO.12.2239335", name: "Caculama" },
    { code: "AO.12.2239696", name: "Massango" },
    { code: "AO.12.2239711", name: "Marimba" },
    { code: "AO.12.2239859", name: "Malanje Municipality" },
    { code: "AO.12.2240685", name: "Cunda-Dia-Baze" },
    { code: "AO.12.2240688", name: "Kiwaba Nzoji" },
    { code: "AO.12.2242475", name: "Cahombo" },
    { code: "AO.12.2242997", name: "Calandula" },
    { code: "AO.12.2243120", name: "Cacuso" },
    { code: "AO.12.3346489", name: "Quirima" },
    { code: "AO.12.3347614", name: "Luquembo" },
    { code: "AO.12.3350771", name: "Cangandala" },
    { code: "AO.12.3350916", name: "Cambundi-Catembo" },
  ],
  "AO.13": [
    { code: "AO.13.3345516", name: "Virei" },
    { code: "AO.13.3345788", name: "Tômbwa" },
    { code: "AO.13.3347017", name: "Namibe" },
    { code: "AO.13.3351015", name: "Camucuio" },
    { code: "AO.13.3351646", name: "Bibala" },
  ],
  "AO.14": [
    { code: "AO.14.3347741", name: "Luchazes" },
    { code: "AO.14.875997", name: "Luena" },
    { code: "AO.14.876125", name: "Cameia" },
    { code: "AO.14.876129", name: "Bundas" },
    { code: "AO.14.876176", name: "Luau" },
    { code: "AO.14.876198", name: "Luacano" },
    { code: "AO.14.876232", name: "Léua" },
    { code: "AO.14.876631", name: "Camanongue" },
    { code: "AO.14.876723", name: "Alto Zambeze" },
  ],
  "AO.15": [
    { code: "AO.15.2236567", name: "Uige Municipality" },
    { code: "AO.15.2236985", name: "Songo" },
    { code: "AO.15.2237127", name: "Sanza Pombo" },
    { code: "AO.15.2237144", name: "Santa Cruz" },
    { code: "AO.15.2237499", name: "Quitexe Municipality" },
    { code: "AO.15.2238174", name: "Quimbele" },
    { code: "AO.15.2238826", name: "Puri" },
    { code: "AO.15.2239067", name: "Negage Municipality" },
    { code: "AO.15.2239352", name: "Mucaba" },
    { code: "AO.15.2239731", name: "Maquela do Zombo" },
    { code: "AO.15.2241498", name: "Damba" },
    { code: "AO.15.2243355", name: "Bungo" },
    { code: "AO.15.2243441", name: "Buengas" },
    { code: "AO.15.2243631", name: "Município Bembe" },
    { code: "AO.15.2243632", name: "Bembe" },
    { code: "AO.15.2243908", name: "Ambuila Municipality" },
    { code: "AO.15.2243921", name: "Cangola" },
  ],
  "AO.16": [
    { code: "AO.16.2236714", name: "Tomboco" },
    { code: "AO.16.2236966", name: "Soyo" },
    { code: "AO.16.2239000", name: "Nzeto" },
    { code: "AO.16.2239019", name: "Nóqui" },
    { code: "AO.16.2239519", name: "Mbanza Congo" },
    { code: "AO.16.2241620", name: "Cuimba" },
  ],
  "AO.17": [
    { code: "AO.17.145723", name: "Lucapa" },
    { code: "AO.17.145775", name: "Chitato" },
    { code: "AO.17.145897", name: "Cambulo" },
    { code: "AO.17.2236396", name: "Xá-Muteba" },
    { code: "AO.17.2240415", name: "Lubalo" },
    { code: "AO.17.2241628", name: "Cuilo" },
    { code: "AO.17.2241665", name: "Cuango" },
    { code: "AO.17.2242051", name: "Caungula" },
    { code: "AO.17.2242427", name: "Capenda Camulemba" },
  ],
  "AO.18": [
    { code: "AO.18.145530", name: "Saurimo" },
    { code: "AO.18.3351386", name: "Cacolo" },
    { code: "AO.18.875968", name: "Muconda" },
    { code: "AO.18.876307", name: "Dala" },
  ],
  "AO.19": [
    { code: "AO.19.2238950", name: "Município Pango Aluquém" },
    { code: "AO.19.2239093", name: "Nambuangongo Municipality" },
    { code: "AO.19.2241454", name: "Dembos" },
    { code: "AO.19.2241484", name: "Dande Municipality" },
    { code: "AO.19.2243420", name: "Bula Atumba" },
    { code: "AO.19.2243911", name: "Ambriz" },
  ],
  "AO.20": [
    { code: "AO.20.10401828", name: "Município Cazenga" },
    { code: "AO.20.10440865", name: "Belas" },
    { code: "AO.20.2236499", name: "Viana" },
    { code: "AO.20.2238564", name: "Quissama" },
    { code: "AO.20.2240445", name: "Luanda Municipality" },
    { code: "AO.20.2240756", name: "Icolo e Bengo" },
    { code: "AO.20.2243171", name: "Cacuaco Municipality" },
  ],
  "AR.01": [
    { code: "AR.01.06007", name: "Partido de Adolfo Alsina" },
    { code: "AR.01.06014", name: "Partido de Adolfo González Chaves" },
    { code: "AR.01.06021", name: "Partido de Alberti" },
    { code: "AR.01.06028", name: "Partido de Almirante Brown" },
    { code: "AR.01.06035", name: "Partido de Avellaneda" },
    { code: "AR.01.06042", name: "Partido de Ayacucho" },
    { code: "AR.01.06049", name: "Partido de Azul" },
    { code: "AR.01.06056", name: "Partido de Bahía Blanca" },
    { code: "AR.01.06063", name: "Partido de Balcarce" },
    { code: "AR.01.06070", name: "Partido de Baradero" },
    { code: "AR.01.06077", name: "Partido de Arrecifes" },
    { code: "AR.01.06084", name: "Partido de Benito Juárez" },
    { code: "AR.01.06091", name: "Partido de Berazategui" },
    { code: "AR.01.06098", name: "Partido de Berisso" },
    { code: "AR.01.06105", name: "Partido de Bolívar" },
    { code: "AR.01.06112", name: "Partido de Bragado" },
    { code: "AR.01.06119", name: "Partido de Brandsen" },
    { code: "AR.01.06126", name: "Partido de Campana" },
    { code: "AR.01.06134", name: "Partido de Canuelas" },
    { code: "AR.01.06140", name: "Partido de Capitán Sarmiento" },
    { code: "AR.01.06147", name: "Partido de Carlos Casares" },
    { code: "AR.01.06154", name: "Partido de Carlos Tejedor" },
    { code: "AR.01.06161", name: "Partido de Carmen de Areco" },
    { code: "AR.01.06168", name: "Partido de Castelli" },
    { code: "AR.01.06175", name: "Partido de Colón" },
    { code: "AR.01.06182", name: "Partido de Coronel Rosales" },
    { code: "AR.01.06189", name: "Partido de Coronel Dorrego" },
    { code: "AR.01.06196", name: "Partido de Coronel Pringles" },
    { code: "AR.01.06203", name: "Partido de Coronel Suárez" },
    { code: "AR.01.06210", name: "Partido de Chacabuco" },
    { code: "AR.01.06218", name: "Partido de Chascomús" },
    { code: "AR.01.06224", name: "Partido de Chivilcoy" },
    { code: "AR.01.06231", name: "Partido de Daireaux" },
    { code: "AR.01.06238", name: "Partido de Dolores" },
    { code: "AR.01.06245", name: "Partido de Ensenada" },
    { code: "AR.01.06252", name: "Partido de Escobar" },
    { code: "AR.01.06260", name: "Partido de Esteban Echeverría" },
    { code: "AR.01.06266", name: "Partido de Exaltación de la Cruz" },
    { code: "AR.01.06270", name: "Partido de Ezeiza" },
    { code: "AR.01.06274", name: "Partido de Florencio Varela" },
    { code: "AR.01.06277", name: "Partido de Florentino Ameghino" },
    { code: "AR.01.06280", name: "Partido de General Alvarado" },
    { code: "AR.01.06287", name: "Partido de General Alvear" },
    { code: "AR.01.06294", name: "Partido de General Arenales" },
    { code: "AR.01.06301", name: "Partido de General Belgrano" },
    { code: "AR.01.06308", name: "Partido de General Guido" },
    { code: "AR.01.06315", name: "Partido de General Madariaga" },
    { code: "AR.01.06322", name: "Partido de General La Madrid" },
    { code: "AR.01.06329", name: "Partido de General Las Heras" },
    { code: "AR.01.06336", name: "Partido de General Lavalle" },
    { code: "AR.01.06343", name: "Partido de General Paz" },
    { code: "AR.01.06351", name: "Partido de General Pinto" },
    { code: "AR.01.06357", name: "Partido de General Pueyrredón" },
    { code: "AR.01.06364", name: "Partido de General Rodríguez" },
    { code: "AR.01.06371", name: "Partido de General San Martín" },
    { code: "AR.01.06385", name: "Partido de General Viamonte" },
    { code: "AR.01.06392", name: "Partido de General Villegas" },
    { code: "AR.01.06399", name: "Partido de Guaminí" },
    { code: "AR.01.06406", name: "Partido de Hipólito Yrigoyen" },
    { code: "AR.01.06408", name: "Partido de Hurlingham" },
    { code: "AR.01.06410", name: "Partido de Ituzaingó" },
    { code: "AR.01.06412", name: "Partido de José C. Paz" },
    { code: "AR.01.06413", name: "Partido de Junín" },
    { code: "AR.01.06420", name: "Partido de La Costa" },
    { code: "AR.01.06427", name: "Partido de La Matanza" },
    { code: "AR.01.06434", name: "Partido de Lanús" },
    { code: "AR.01.06441", name: "Partido de La Plata" },
    { code: "AR.01.06448", name: "Partido de Laprida" },
    { code: "AR.01.06455", name: "Partido de Las Flores" },
    { code: "AR.01.06462", name: "Partido de Leandro N. Alem" },
    { code: "AR.01.06466", name: "Partido de Lezama" },
    { code: "AR.01.06469", name: "Partido de Lincoln" },
    { code: "AR.01.06476", name: "Partido de Lobería" },
    { code: "AR.01.06483", name: "Partido de Lobos" },
    { code: "AR.01.06490", name: "Partido de Lomas de Zamora" },
    { code: "AR.01.06497", name: "Partido de Luján" },
    { code: "AR.01.06505", name: "Partido de Magdalena" },
    { code: "AR.01.06511", name: "Partido de Maipú" },
    { code: "AR.01.06515", name: "Partido de Malvinas Argentinas" },
    { code: "AR.01.06518", name: "Partido de Mar Chiquita" },
    { code: "AR.01.06525", name: "Partido de Marcos Paz" },
    { code: "AR.01.06532", name: "Partido de Mercedes" },
    { code: "AR.01.06539", name: "Partido de Merlo" },
    { code: "AR.01.06547", name: "Partido de Monte" },
    { code: "AR.01.06553", name: "Partido de Monte Hermoso" },
    { code: "AR.01.06560", name: "Partido de Moreno" },
    { code: "AR.01.06568", name: "Partido de Morón" },
    { code: "AR.01.06574", name: "Partido de Navarro" },
    { code: "AR.01.06581", name: "Partido de Necochea" },
    { code: "AR.01.06588", name: "Partido de Nueve de Julio" },
    { code: "AR.01.06595", name: "Partido de Olavarría" },
    { code: "AR.01.06602", name: "Partido de Patagones" },
    { code: "AR.01.06609", name: "Partido de Pehuajó" },
    { code: "AR.01.06616", name: "Partido de Pellegrini" },
    { code: "AR.01.06623", name: "Partido de Pergamino" },
    { code: "AR.01.06630", name: "Partido de Pila" },
    { code: "AR.01.06638", name: "Partido de Pilar" },
    { code: "AR.01.06644", name: "Partido de Pinamar" },
    { code: "AR.01.06648", name: "Partido de Presidente Perón" },
    { code: "AR.01.06651", name: "Partido de Puan" },
    { code: "AR.01.06655", name: "Partido de Punta Indio" },
    { code: "AR.01.06658", name: "Partido de Quilmes" },
    { code: "AR.01.06665", name: "Partido de Ramallo" },
    { code: "AR.01.06672", name: "Partido de Rauch" },
    { code: "AR.01.06679", name: "Partido de Rivadavia" },
    { code: "AR.01.06686", name: "Partido de Rojas" },
    { code: "AR.01.06693", name: "Partido de Roque Pérez" },
    { code: "AR.01.06700", name: "Partido de Saavedra" },
    { code: "AR.01.06707", name: "Partido de Saladillo" },
    { code: "AR.01.06714", name: "Partido de Salto" },
    { code: "AR.01.06721", name: "Partido de Salliqueló" },
    { code: "AR.01.06728", name: "Partido de San Andrés de Giles" },
    { code: "AR.01.06735", name: "San Antonio de Areco" },
    { code: "AR.01.06742", name: "Partido de San Cayetano" },
    { code: "AR.01.06749", name: "Partido de San Fernando" },
    { code: "AR.01.06756", name: "Partido de San Isidro" },
    { code: "AR.01.06760", name: "Partido de San Miguel" },
    { code: "AR.01.06763", name: "Partido de San Nicolás" },
    { code: "AR.01.06770", name: "Partido de San Pedro" },
    { code: "AR.01.06778", name: "Partido de San Vicente" },
    { code: "AR.01.06784", name: "Partido de Suipacha" },
    { code: "AR.01.06791", name: "Partido de Tandil" },
    { code: "AR.01.06798", name: "Partido de Tapalqué" },
    { code: "AR.01.06805", name: "Partido de Tigre" },
    { code: "AR.01.06812", name: "Partido de Tordillo" },
    { code: "AR.01.06819", name: "Partido de Tornquist" },
    { code: "AR.01.06826", name: "Partido de Trenque Lauquen" },
    { code: "AR.01.06833", name: "Partido de Tres Arroyos" },
    { code: "AR.01.06840", name: "Partido de Tres de Febrero" },
    { code: "AR.01.06847", name: "Partido de Tres Lomas" },
    { code: "AR.01.06854", name: "Partido de Veinticinco de Mayo" },
    { code: "AR.01.06861", name: "Partido de Vicente López" },
    { code: "AR.01.06868", name: "Partido de Villa Gesell" },
    { code: "AR.01.06875", name: "Partido de Villarino" },
    { code: "AR.01.06882", name: "Partido de Zárate" },
  ],
  "AR.02": [
    { code: "AR.02.10007", name: "Departamento de Ambato" },
    { code: "AR.02.10014", name: "Departamento de Ancasti" },
    { code: "AR.02.10021", name: "Departamento de Andalgalá" },
    { code: "AR.02.10028", name: "Departamento de Antofagasta de la Sierra" },
    { code: "AR.02.10035", name: "Departamento de Belén" },
    { code: "AR.02.10042", name: "Departamento de Capayán" },
    { code: "AR.02.10049", name: "Departamento de Capital" },
    { code: "AR.02.10056", name: "Departamento de El Alto" },
    { code: "AR.02.10063", name: "Departamento de Fray Mamerto Esquiú" },
    { code: "AR.02.10070", name: "Departamento de La Paz" },
    { code: "AR.02.10077", name: "Departamento de Paclín" },
    { code: "AR.02.10084", name: "Departamento de Pomán" },
    { code: "AR.02.10091", name: "Departamento de Santa María" },
    { code: "AR.02.10098", name: "Departamento de Santa Rosa" },
    { code: "AR.02.10105", name: "Departamento de Tinogasta" },
    { code: "AR.02.10112", name: "Departamento de Valle Viejo" },
  ],
  "AR.03": [
    { code: "AR.03.22007", name: "Departamento de Almirante Brown" },
    { code: "AR.03.22014", name: "Departamento de Bermejo" },
    { code: "AR.03.22021", name: "Departamento de Comandante Fernández" },
    { code: "AR.03.22028", name: "Chacabuco" },
    { code: "AR.03.22036", name: "Departamento de Doce de Octubre" },
    { code: "AR.03.22039", name: "Departamento de Dos de Abril" },
    { code: "AR.03.22043", name: "Fray Justo Santa María de Oro" },
    { code: "AR.03.22049", name: "Departamento de General Belgrano" },
    { code: "AR.03.22056", name: "Departamento de General Donovan" },
    { code: "AR.03.22063", name: "Departamento de General Güemes" },
    { code: "AR.03.22070", name: "Departamento de Independencia" },
    { code: "AR.03.22077", name: "Departamento de Libertad" },
    { code: "AR.03.22084", name: "Departamento de Libertador General San Martín" },
    { code: "AR.03.22091", name: "Departamento de Maipú" },
    { code: "AR.03.22098", name: "Departamento de Mayor Luis J. Fontana" },
    { code: "AR.03.22105", name: "Departamento de Nueve de Julio" },
    { code: "AR.03.22112", name: "Departamento de O’Higgins" },
    { code: "AR.03.22119", name: "Departamento de Presidencia de la Plaza" },
    { code: "AR.03.22126", name: "Departamento del Primero de Mayo" },
    { code: "AR.03.22133", name: "Departamento de Quitilipi" },
    { code: "AR.03.22140", name: "Departamento de San Fernando" },
    { code: "AR.03.22147", name: "Departamento de San Lorenzo" },
    { code: "AR.03.22154", name: "Departamento de Sargento Cabral" },
    { code: "AR.03.22161", name: "Departamento de Tapenagá" },
    { code: "AR.03.22168", name: "Veinticinco de Mayo" },
  ],
  "AR.04": [
    { code: "AR.04.26007", name: "Departamento de Biedma" },
    { code: "AR.04.26014", name: "Departamento de Cushamen" },
    { code: "AR.04.26021", name: "Departamento de Escalante" },
    { code: "AR.04.26028", name: "Departamento de Florentino Ameghino" },
    { code: "AR.04.26035", name: "Departamento de Futaleufú" },
    { code: "AR.04.26042", name: "Departamento de Gaimán" },
    { code: "AR.04.26049", name: "Departamento de Gastre" },
    { code: "AR.04.26056", name: "Departamento de Languiñeo" },
    { code: "AR.04.26063", name: "Departamento de Mártires" },
    { code: "AR.04.26070", name: "Departamento de Paso de Indios" },
    { code: "AR.04.26077", name: "Departamento de Rawson" },
    { code: "AR.04.26084", name: "Departamento de Río Senguerr" },
    { code: "AR.04.26091", name: "Departamento de Sarmiento" },
    { code: "AR.04.26098", name: "Departamento de Tehuelches" },
    { code: "AR.04.26105", name: "Departamento de Telsen" },
  ],
  "AR.05": [
    { code: "AR.05.14007", name: "Departamento de Calamuchita" },
    { code: "AR.05.14014", name: "Departamento de Capital" },
    { code: "AR.05.14021", name: "Departamento de Colón" },
    { code: "AR.05.14028", name: "Departamento de Cruz del Eje" },
    { code: "AR.05.14035", name: "Departamento de General Roca" },
    { code: "AR.05.14042", name: "Departamento de General San Martín" },
    { code: "AR.05.14049", name: "Departamento de Ischilín" },
    { code: "AR.05.14056", name: "Departamento de Juárez Celman" },
    { code: "AR.05.14063", name: "Departamento de Marcos Juárez" },
    { code: "AR.05.14070", name: "Departamento de Minas" },
    { code: "AR.05.14077", name: "Departamento de Pocho" },
    { code: "AR.05.14084", name: "Departamento de Presidente Roque Sáenz Peña" },
    { code: "AR.05.14091", name: "Departamento de Punilla" },
    { code: "AR.05.14098", name: "Departamento de Río Cuarto" },
    { code: "AR.05.14105", name: "Departamento de Río Primero" },
    { code: "AR.05.14112", name: "Departamento de Río Seco" },
    { code: "AR.05.14119", name: "Departamento de Río Segundo" },
    { code: "AR.05.14126", name: "Departamento de San Alberto" },
    { code: "AR.05.14133", name: "Departamento de San Javier" },
    { code: "AR.05.14140", name: "Departamento de San Justo" },
    { code: "AR.05.14147", name: "Departamento de Santa María" },
    { code: "AR.05.14154", name: "Departamento de Sobremonte" },
    { code: "AR.05.14161", name: "Departamento de Tercero Arriba" },
    { code: "AR.05.14168", name: "Departamento de Totoral" },
    { code: "AR.05.14175", name: "Departamento de Tulumba" },
    { code: "AR.05.14182", name: "Departamento de Unión" },
  ],
  "AR.06": [
    { code: "AR.06.18007", name: "Departamento de Bella Vista" },
    { code: "AR.06.18014", name: "Departamento de Berón de Astrada" },
    { code: "AR.06.18021", name: "Departamento de Capital" },
    { code: "AR.06.18028", name: "Departamento de Concepción" },
    { code: "AR.06.18035", name: "Departamento de Curuzú Cuatiá" },
    { code: "AR.06.18042", name: "Departamento de Empedrado" },
    { code: "AR.06.18049", name: "Departamento de Esquina" },
    { code: "AR.06.18056", name: "Departamento de General Alvear" },
    { code: "AR.06.18063", name: "Departamento de General Paz" },
    { code: "AR.06.18070", name: "Departamento de Goya" },
    { code: "AR.06.18077", name: "Departamento de Itatí" },
    { code: "AR.06.18084", name: "Departamento de Ituzaingó" },
    { code: "AR.06.18091", name: "Departamento de Lavalle" },
    { code: "AR.06.18098", name: "Departamento de Mburucuyá" },
    { code: "AR.06.18105", name: "Departamento de Mercedes" },
    { code: "AR.06.18112", name: "Departamento de Monte Caseros" },
    { code: "AR.06.18119", name: "Departamento de Paso de los Libres" },
    { code: "AR.06.18126", name: "Departamento de Saladas" },
    { code: "AR.06.18133", name: "Departamento de San Cosme" },
    { code: "AR.06.18140", name: "Departamento de San Luis del Palmar" },
    { code: "AR.06.18147", name: "Departamento de San Martín" },
    { code: "AR.06.18154", name: "Departamento de San Miguel" },
    { code: "AR.06.18161", name: "Departamento de San Roque" },
    { code: "AR.06.18168", name: "Departamento de Santo Tomé" },
    { code: "AR.06.18175", name: "Departamento de Sauce" },
  ],
  "AR.07": [
    { code: "AR.07.02001", name: "Comuna 1" },
    { code: "AR.07.02002", name: "Comuna 2" },
    { code: "AR.07.02003", name: "Comuna 3" },
    { code: "AR.07.02004", name: "Comuna 4" },
    { code: "AR.07.02005", name: "Comuna 5" },
    { code: "AR.07.02006", name: "Comuna 6" },
    { code: "AR.07.02007", name: "Comuna 7" },
    { code: "AR.07.02008", name: "Comuna 8" },
    { code: "AR.07.02009", name: "Comuna 9" },
    { code: "AR.07.02010", name: "Comuna 10" },
    { code: "AR.07.02011", name: "Comuna 11" },
    { code: "AR.07.02012", name: "Comuna 12" },
    { code: "AR.07.02013", name: "Comuna 13" },
    { code: "AR.07.02014", name: "Comuna 14" },
    { code: "AR.07.02015", name: "Comuna 15" },
  ],
  "AR.08": [
    { code: "AR.08.30008", name: "Departamento de Colón" },
    { code: "AR.08.30015", name: "Departamento de Concordia" },
    { code: "AR.08.30021", name: "Departamento de Diamante" },
    { code: "AR.08.30028", name: "Departamento de Federación" },
    { code: "AR.08.30035", name: "Departamento de Federal" },
    { code: "AR.08.30042", name: "Departamento de Feliciano" },
    { code: "AR.08.30049", name: "Departamento de Gualeguay" },
    { code: "AR.08.30056", name: "Departamento de Gualeguaychú" },
    { code: "AR.08.30063", name: "Departamento de Islas del Ibicuy" },
    { code: "AR.08.30070", name: "Departamento de La Paz" },
    { code: "AR.08.30077", name: "Departamento de Nogoyá" },
    { code: "AR.08.30084", name: "Departamento de Paraná" },
    { code: "AR.08.30088", name: "Departamento de San Salvador" },
    { code: "AR.08.30091", name: "Departamento de Tala" },
    { code: "AR.08.30098", name: "Departamento de Uruguay" },
    { code: "AR.08.30105", name: "Departamento de Victoria" },
    { code: "AR.08.30113", name: "Departamento de Villaguay" },
  ],
  "AR.09": [
    { code: "AR.09.34007", name: "Departamento de Bermejo" },
    { code: "AR.09.34014", name: "Departamento de Formosa" },
    { code: "AR.09.34021", name: "Departamento de Laishí" },
    { code: "AR.09.34028", name: "Departamento de Matacos" },
    { code: "AR.09.34035", name: "Departamento de Patiño" },
    { code: "AR.09.34042", name: "Departamento de Pilagás" },
    { code: "AR.09.34049", name: "Departamento de Pilcomayo" },
    { code: "AR.09.34056", name: "Departamento de Pirané" },
    { code: "AR.09.34063", name: "Departamento de Ramón Lista" },
  ],
  "AR.10": [
    { code: "AR.10.38007", name: "Departamento de Cochinoca" },
    { code: "AR.10.38014", name: "Departamento de El Carmen" },
    { code: "AR.10.38021", name: "Departamento de Doctor Manuel Belgrano" },
    { code: "AR.10.38028", name: "Departamento de Humahuaca" },
    { code: "AR.10.38035", name: "Departamento de Ledesma" },
    { code: "AR.10.38042", name: "Departamento de Palpalá" },
    { code: "AR.10.38049", name: "Departamento de Rinconada" },
    { code: "AR.10.38056", name: "Departamento de San Antonio" },
    { code: "AR.10.38063", name: "Departamento de San Pedro" },
    { code: "AR.10.38070", name: "Departamento de Santa Bárbara" },
    { code: "AR.10.38077", name: "Departamento de Santa Catalina" },
    { code: "AR.10.38084", name: "Departamento de Susques" },
    { code: "AR.10.38094", name: "Departamento de Tilcara" },
    { code: "AR.10.38098", name: "Departamento de Tumbaya" },
    { code: "AR.10.38105", name: "Departamento de Valle Grande" },
    { code: "AR.10.38112", name: "Departamento de Yaví" },
  ],
  "AR.11": [
    { code: "AR.11.42007", name: "Departamento de Atreucó" },
    { code: "AR.11.42014", name: "Departamento de Caleu-Caleu" },
    { code: "AR.11.42021", name: "Departamento de Capital" },
    { code: "AR.11.42028", name: "Departamento de Catriló" },
    { code: "AR.11.42035", name: "Departamento de Conhelo" },
    { code: "AR.11.42042", name: "Departamento de Curacó" },
    { code: "AR.11.42049", name: "Departamento de Chalileo" },
    { code: "AR.11.42056", name: "Departamento de Chapaleufú" },
    { code: "AR.11.42063", name: "Departamento de Chical-Có" },
    { code: "AR.11.42070", name: "Departamento de Guatraché" },
    { code: "AR.11.42077", name: "Departamento de Hucal" },
    { code: "AR.11.42084", name: "Departamento de Lihuel-Calel" },
    { code: "AR.11.42091", name: "Departamento de Limay Mahuida" },
    { code: "AR.11.42098", name: "Departamento de Loventué" },
    { code: "AR.11.42105", name: "Departamento de Maracó" },
    { code: "AR.11.42112", name: "Departamento de Puelén" },
    { code: "AR.11.42119", name: "Departamento de Quemú Quemú" },
    { code: "AR.11.42126", name: "Departamento de Rancul" },
    { code: "AR.11.42133", name: "Departamento de Realicó" },
    { code: "AR.11.42140", name: "Departamento de Toay" },
    { code: "AR.11.42147", name: "Departamento de Trenel" },
    { code: "AR.11.42154", name: "Departamento de Utracán" },
  ],
  "AR.12": [
    { code: "AR.12.46007", name: "Departamento de Arauco" },
    { code: "AR.12.46014", name: "Departamento de Capital" },
    { code: "AR.12.46021", name: "Departamento de Castro Barros" },
    { code: "AR.12.46028", name: "Departamento de Coronel Felipe Varela" },
    { code: "AR.12.46035", name: "Departamento de Chamical" },
    { code: "AR.12.46042", name: "Departamento de Chilecito" },
    { code: "AR.12.46049", name: "Departamento de Famatina" },
    { code: "AR.12.46056", name: "Departamento de General Angel Peñaloza" },
    { code: "AR.12.46063", name: "Departamento de General Belgrano" },
    { code: "AR.12.46070", name: "Departamento de General Juan F. Quiroga" },
    { code: "AR.12.46077", name: "Departamento de General Lamadrid" },
    { code: "AR.12.46084", name: "Departamento de General Ocampo" },
    { code: "AR.12.46091", name: "Departamento de General San Martín" },
    { code: "AR.12.46098", name: "Departamento de Vinchina" },
    { code: "AR.12.46105", name: "Departamento de Independencia" },
    { code: "AR.12.46112", name: "Departamento de Rosario Vera Peñaloza" },
    { code: "AR.12.46119", name: "Departamento de San Blas de los Sauces" },
    { code: "AR.12.46126", name: "Departamento de Sanagasta" },
  ],
  "AR.13": [
    { code: "AR.13.50007", name: "Departamento de Capital" },
    { code: "AR.13.50014", name: "Departamento de General Alvear" },
    { code: "AR.13.50021", name: "Departamento de Godoy Cruz" },
    { code: "AR.13.50028", name: "Departamento de Guaymallén" },
    { code: "AR.13.50035", name: "Departamento de Junín" },
    { code: "AR.13.50042", name: "Departamento de La Paz" },
    { code: "AR.13.50049", name: "Departamento de Las Heras" },
    { code: "AR.13.50056", name: "Departamento de Lavalle" },
    { code: "AR.13.50063", name: "Departamento de Luján" },
    { code: "AR.13.50070", name: "Departamento de Maipú" },
    { code: "AR.13.50077", name: "Departamento de Malargüe" },
    { code: "AR.13.50084", name: "Departamento de Rivadavia" },
    { code: "AR.13.50091", name: "Departamento de San Carlos" },
    { code: "AR.13.50098", name: "Departamento de San Martín" },
    { code: "AR.13.50105", name: "Departamento de San Rafael" },
    { code: "AR.13.50112", name: "Departamento de Santa Rosa" },
    { code: "AR.13.50119", name: "Departamento de Tunuyán" },
    { code: "AR.13.50126", name: "Departamento de Tupungato" },
  ],
  "AR.14": [
    { code: "AR.14.54007", name: "Departamento de Apóstoles" },
    { code: "AR.14.54014", name: "Departamento de Cainguás" },
    { code: "AR.14.54021", name: "Departamento de Candelaria" },
    { code: "AR.14.54028", name: "Departamento de Capital" },
    { code: "AR.14.54035", name: "Departamento de Concepción de la Sierra" },
    { code: "AR.14.54042", name: "Departamento de Eldorado" },
    { code: "AR.14.54049", name: "Departamento de General Manuel Belgrano" },
    { code: "AR.14.54056", name: "Departamento de Guaraní" },
    { code: "AR.14.54063", name: "Departamento de Iguazú" },
    { code: "AR.14.54070", name: "Departamento de Leandro N. Alem" },
    { code: "AR.14.54077", name: "Departamento de Libertador General San Martín" },
    { code: "AR.14.54084", name: "Departamento de Montecarlo" },
    { code: "AR.14.54091", name: "Departamento de Oberá" },
    { code: "AR.14.54098", name: "Departamento de San Ignacio" },
    { code: "AR.14.54105", name: "Departamento de San Javier" },
    { code: "AR.14.54112", name: "Departamento de San Pedro" },
    { code: "AR.14.54119", name: "Departamento de Veinticinco de Mayo" },
  ],
  "AR.15": [
    { code: "AR.15.58007", name: "Departamento de Aluminé" },
    { code: "AR.15.58014", name: "Departamento de Añelo" },
    { code: "AR.15.58021", name: "Departamento de Catán-Lil" },
    { code: "AR.15.58028", name: "Departamento de Collón-Curá" },
    { code: "AR.15.58035", name: "Departamento de Confluencia" },
    { code: "AR.15.58042", name: "Departamento de Chos-Malal" },
    { code: "AR.15.58049", name: "Departamento de Huiliches" },
    { code: "AR.15.58056", name: "Departamento de Lácar" },
    { code: "AR.15.58063", name: "Departamento de Loncopué" },
    { code: "AR.15.58070", name: "Departamento de Los Lagos" },
    { code: "AR.15.58077", name: "Departamento de Minas" },
    { code: "AR.15.58084", name: "Departamento de Ñorquín" },
    { code: "AR.15.58091", name: "Departamento de Pehuenches" },
    { code: "AR.15.58098", name: "Departamento de Picún Leufú" },
    { code: "AR.15.58105", name: "Departamento de Picunches" },
    { code: "AR.15.58112", name: "Departamento de Zapala" },
  ],
  "AR.16": [
    { code: "AR.16.62007", name: "Departamento de Adolfo Alsina" },
    { code: "AR.16.62014", name: "Departamento de Avellaneda" },
    { code: "AR.16.62021", name: "Departamento de Bariloche" },
    { code: "AR.16.62028", name: "Departamento de Conesa" },
    { code: "AR.16.62035", name: "Departamento de El Cuy" },
    { code: "AR.16.62042", name: "Departamento de General Roca" },
    { code: "AR.16.62049", name: "Departamento de Nueve de Julio" },
    { code: "AR.16.62056", name: "Departamento de Ñorquincó" },
    { code: "AR.16.62063", name: "Departamento de Pichi Mahuida" },
    { code: "AR.16.62070", name: "Departamento de Pilcaniyeu" },
    { code: "AR.16.62077", name: "Departamento de San Antonio" },
    { code: "AR.16.62084", name: "Departamento de Valcheta" },
    { code: "AR.16.62091", name: "Departamento de Veinticinco de Mayo" },
  ],
  "AR.17": [
    { code: "AR.17.66007", name: "Departamento de Anta" },
    { code: "AR.17.66014", name: "Departamento de Cachí" },
    { code: "AR.17.66021", name: "Cafayate" },
    { code: "AR.17.66028", name: "Departamento Capital" },
    { code: "AR.17.66035", name: "Departamento de Cerrillos" },
    { code: "AR.17.66042", name: "Departamento de Chicoana" },
    { code: "AR.17.66049", name: "Departamento de General Güemes" },
    { code: "AR.17.66056", name: "Departamento de General José de San Martín" },
    { code: "AR.17.66063", name: "Departamento de Guachipas" },
    { code: "AR.17.66070", name: "Departamento de Iruya" },
    { code: "AR.17.66077", name: "La Caldera" },
    { code: "AR.17.66084", name: "La Candelaria" },
    { code: "AR.17.66091", name: "Departamento de La Poma" },
    { code: "AR.17.66098", name: "Departamento de La Viña" },
    { code: "AR.17.66105", name: "Departamento de Los Andes" },
    { code: "AR.17.66112", name: "Departamento de Metán" },
    { code: "AR.17.66119", name: "Departamento de Molinos" },
    { code: "AR.17.66126", name: "Departamento de Orán" },
    { code: "AR.17.66133", name: "Departamento de Rivadavia" },
    { code: "AR.17.66140", name: "Departamento de Rosario de la Frontera" },
    { code: "AR.17.66147", name: "Departamento de Rosario de Lerma" },
    { code: "AR.17.66154", name: "Departamento de San Carlos" },
    { code: "AR.17.66161", name: "Departamento de Santa Victoria" },
  ],
  "AR.18": [
    { code: "AR.18.70007", name: "Departamento de Albardón" },
    { code: "AR.18.70014", name: "Departamento de Angaco" },
    { code: "AR.18.70021", name: "Departamento de Calingasta" },
    { code: "AR.18.70028", name: "Departamento de Capital" },
    { code: "AR.18.70035", name: "Departamento de Caucete" },
    { code: "AR.18.70042", name: "Departamento de Chimbas" },
    { code: "AR.18.70049", name: "Departamento de Iglesia" },
    { code: "AR.18.70056", name: "Departamento de Jáchal" },
    { code: "AR.18.70063", name: "Departamento de Nueve de Julio" },
    { code: "AR.18.70070", name: "Departamento de Pocito" },
    { code: "AR.18.70077", name: "Departamento de Rawson" },
    { code: "AR.18.70084", name: "Departamento de Rivadavia" },
    { code: "AR.18.70091", name: "Departamento de San Martín" },
    { code: "AR.18.70098", name: "Departamento de Santa Lucía" },
    { code: "AR.18.70105", name: "Departamento de Sarmiento" },
    { code: "AR.18.70112", name: "Departamento de Ullúm" },
    { code: "AR.18.70119", name: "Departamento de Valle Fértil" },
    { code: "AR.18.70126", name: "Departamento de Veinticinco de Mayo" },
    { code: "AR.18.70133", name: "Departamento de Zonda" },
  ],
  "AR.19": [
    { code: "AR.19.74007", name: "Departamento de Ayacucho" },
    { code: "AR.19.74014", name: "Departamento de Belgrano" },
    { code: "AR.19.74021", name: "Coronel Pringles" },
    { code: "AR.19.74028", name: "Departamento de Chacabuco" },
    { code: "AR.19.74035", name: "Departamento de General Pedernera" },
    { code: "AR.19.74042", name: "Departamento de Gobernador Vicente Dupuy" },
    { code: "AR.19.74049", name: "Departamento de Junín" },
    { code: "AR.19.74056", name: "Juan Martín de Pueyrredón" },
    { code: "AR.19.74063", name: "Departamento de Libertador General San Martín" },
  ],
  "AR.20": [
    { code: "AR.20.78007", name: "Departamento de Corpen Aike" },
    { code: "AR.20.78014", name: "Departamento de Deseado" },
    { code: "AR.20.78021", name: "Departamento de Güer Aike" },
    { code: "AR.20.78028", name: "Departamento de Lago Argentino" },
    { code: "AR.20.78035", name: "Departamento de Lago Buenos Aires" },
    { code: "AR.20.78042", name: "Departamento de Magallanes" },
    { code: "AR.20.78049", name: "Departamento de Río Chico" },
  ],
  "AR.21": [
    { code: "AR.21.82007", name: "Departamento de Belgrano" },
    { code: "AR.21.82014", name: "Departamento de Caseros" },
    { code: "AR.21.82021", name: "Departamento de Castellanos" },
    { code: "AR.21.82028", name: "Departamento de Constitución" },
    { code: "AR.21.82035", name: "Garay Department" },
    { code: "AR.21.82042", name: "General López Department" },
    { code: "AR.21.82049", name: "General Obligado Department" },
    { code: "AR.21.82056", name: "Iriondo Department" },
    { code: "AR.21.82063", name: "Departamento de La Capital" },
    { code: "AR.21.82070", name: "Las Colonias Department" },
    { code: "AR.21.82077", name: "Departamento de Nueve de Julio" },
    { code: "AR.21.82084", name: "Rosario Department" },
    { code: "AR.21.82091", name: "Departamento de San Cristóbal" },
    { code: "AR.21.82098", name: "Departamento de San Javier" },
    { code: "AR.21.82105", name: "San Jerónimo Department" },
    { code: "AR.21.82112", name: "Departamento de San Justo" },
    { code: "AR.21.82119", name: "Departamento de San Lorenzo" },
    { code: "AR.21.82126", name: "Departamento de San Martín" },
    { code: "AR.21.82133", name: "Departamento de Vera" },
  ],
  "AR.22": [
    { code: "AR.22.86007", name: "Departamento de Aguirre" },
    { code: "AR.22.86014", name: "Departamento de Alberdi" },
    { code: "AR.22.86021", name: "Departamento de Atamisqui" },
    { code: "AR.22.86028", name: "Departamento de Avellaneda" },
    { code: "AR.22.86035", name: "Departamento de Banda" },
    { code: "AR.22.86042", name: "Departamento de Belgrano" },
    { code: "AR.22.86049", name: "Departamento de Capital" },
    { code: "AR.22.86056", name: "Departamento de Copo" },
    { code: "AR.22.86063", name: "Departamento de Choya" },
    { code: "AR.22.86070", name: "Departamento de Figueroa" },
    { code: "AR.22.86077", name: "Departamento de General Taboada" },
    { code: "AR.22.86084", name: "Departamento de Guasayán" },
    { code: "AR.22.86091", name: "Departamento de Jiménez" },
    { code: "AR.22.86098", name: "Departamento de Juan F. Ibarra" },
    { code: "AR.22.86105", name: "Departamento de Loreto" },
    { code: "AR.22.86112", name: "Departamento de Mitre" },
    { code: "AR.22.86119", name: "Departamento de Moreno" },
    { code: "AR.22.86126", name: "Departamento de Ojo de Agua" },
    { code: "AR.22.86133", name: "Departamento de Pellegrini" },
    { code: "AR.22.86140", name: "Departamento de Quebrachos" },
    { code: "AR.22.86147", name: "Departamento de Río Hondo" },
    { code: "AR.22.86154", name: "Departamento de Rivadavia" },
    { code: "AR.22.86161", name: "Departamento de Robles" },
    { code: "AR.22.86168", name: "Departamento de Salavina" },
    { code: "AR.22.86175", name: "Departamento de San Martín" },
    { code: "AR.22.86182", name: "Departamento de Sarmiento" },
    { code: "AR.22.86189", name: "Departamento de Silípica" },
  ],
  "AR.23": [
    { code: "AR.23.94007", name: "Departamento de Río Grande" },
    { code: "AR.23.94011", name: "Tolhuin" },
    { code: "AR.23.94014", name: "Departamento de Ushuaia" },
    { code: "AR.23.94021", name: "Islas del Atlántico Sur" },
    { code: "AR.23.94028", name: "Antártida Argentina" },
  ],
  "AR.24": [
    { code: "AR.24.90007", name: "Departamento de Burruyacú" },
    { code: "AR.24.90014", name: "Departamento de Cruz Alta" },
    { code: "AR.24.90021", name: "Departamento de Chicligasta" },
    { code: "AR.24.90028", name: "Departamento de Famaillá" },
    { code: "AR.24.90035", name: "Departamento de Graneros" },
    { code: "AR.24.90042", name: "Departamento de Juan B. Alberdi" },
    { code: "AR.24.90049", name: "Departamento de La Cocha" },
    { code: "AR.24.90056", name: "Departamento de Leales" },
    { code: "AR.24.90063", name: "Departamento de Lules" },
    { code: "AR.24.90070", name: "Departamento de Monteros" },
    { code: "AR.24.90077", name: "Departamento de Río Chico" },
    { code: "AR.24.90084", name: "Departamento de Capital" },
    { code: "AR.24.90091", name: "Departamento de Simoca" },
    { code: "AR.24.90098", name: "Departamento de Tafí del Valle" },
    { code: "AR.24.90105", name: "Departamento de Tafí Viejo" },
    { code: "AR.24.90112", name: "Departamento de Trancas" },
    { code: "AR.24.90119", name: "Departamento de Yerba Buena" },
  ],
  "AS.010": [
    { code: "AS.010.5881191", name: "Sā‘ole County" },
    { code: "AS.010.5881213", name: "Sua County" },
    { code: "AS.010.5881281", name: "Itu‘aū County" },
    { code: "AS.010.5881500", name: "Mauputasi County" },
    { code: "AS.010.7267973", name: "Vaifanua County" },
  ],
  "AS.020": [
    { code: "AS.020.7267965", name: "Faleasao County" },
    { code: "AS.020.8181800", name: "Fitiuta County" },
    { code: "AS.020.8181801", name: "Ta'u County" },
    { code: "AS.020.8181803", name: "Olosega County" },
    { code: "AS.020.8198683", name: "Ofu County" },
  ],
  "AS.050": [
    { code: "AS.050.5881074", name: "Tuālāuta County" },
    { code: "AS.050.5881085", name: "Tūalātai County" },
    { code: "AS.050.5881380", name: "Leālātaua County" },
    { code: "AS.050.5881381", name: "Leāsina County" },
  ],
  "AT.01": [
    { code: "AT.01.101", name: "Eisenstadt Stadt" },
    { code: "AT.01.102", name: "Rust Stadt" },
    { code: "AT.01.103", name: "Eisenstadt-Umgebung" },
    { code: "AT.01.104", name: "Politischer Bezirk Güssing" },
    { code: "AT.01.105", name: "Politischer Bezirk Jennersdorf" },
    { code: "AT.01.106", name: "Politischer Bezirk Mattersburg" },
    { code: "AT.01.107", name: "Politischer Bezirk Neusiedl am See" },
    { code: "AT.01.108", name: "Politischer Bezirk Oberpullendorf" },
    { code: "AT.01.109", name: "Politischer Bezirk Oberwart" },
  ],
  "AT.02": [
    { code: "AT.02.201", name: "Klagenfurt am Wörthersee" },
    { code: "AT.02.202", name: "Villach Stadt" },
    { code: "AT.02.203", name: "Politischer Bezirk Hermagor" },
    { code: "AT.02.204", name: "Politischer Bezirk Klagenfurt Land" },
    { code: "AT.02.205", name: "Politischer Bezirk Sankt Veit an der Glan" },
    { code: "AT.02.206", name: "Politischer Bezirk Spittal an der Drau" },
    { code: "AT.02.207", name: "Politischer Bezirk Villach Land" },
    { code: "AT.02.208", name: "Politischer Bezirk Völkermarkt" },
    { code: "AT.02.209", name: "Politischer Bezirk Wolfsberg" },
    { code: "AT.02.210", name: "Politischer Bezirk Feldkirchen" },
  ],
  "AT.03": [
    { code: "AT.03.301", name: "Krems an der Donau Stadt" },
    { code: "AT.03.302", name: "Sankt Pölten Stadt" },
    { code: "AT.03.303", name: "Waidhofen an der Ybbs Stadt" },
    { code: "AT.03.304", name: "Wiener Neustadt Stadt" },
    { code: "AT.03.305", name: "Politischer Bezirk Amstetten" },
    { code: "AT.03.306", name: "Politischer Bezirk Baden" },
    { code: "AT.03.307", name: "Politischer Bezirk Bruck an der Leitha" },
    { code: "AT.03.308", name: "Politischer Bezirk Gänserndorf" },
    { code: "AT.03.309", name: "Politischer Bezirk Gmünd" },
    { code: "AT.03.310", name: "Politischer Bezirk Hollabrunn" },
    { code: "AT.03.311", name: "Politischer Bezirk Horn" },
    { code: "AT.03.312", name: "Politischer Bezirk Korneuburg" },
    { code: "AT.03.313", name: "Politischer Bezirk Krems" },
    { code: "AT.03.314", name: "Politischer Bezirk Lilienfeld" },
    { code: "AT.03.315", name: "Politischer Bezirk Melk" },
    { code: "AT.03.316", name: "Politischer Bezirk Mistelbach" },
    { code: "AT.03.317", name: "Politischer Bezirk Mödling" },
    { code: "AT.03.318", name: "Politischer Bezirk Neunkirchen" },
    { code: "AT.03.319", name: "Politischer Bezirk Sankt Pölten" },
    { code: "AT.03.320", name: "Politischer Bezirk Scheibbs" },
    { code: "AT.03.321", name: "Politischer Bezirk Tulln" },
    { code: "AT.03.322", name: "Politischer Bezirk Waidhofen an der Thaya" },
    { code: "AT.03.323", name: "Politischer Bezirk Wiener Neustadt" },
    { code: "AT.03.325", name: "Politischer Bezirk Zwettl" },
  ],
  "AT.04": [
    { code: "AT.04.401", name: "Linz Stadt" },
    { code: "AT.04.402", name: "Steyr Stadt" },
    { code: "AT.04.403", name: "Wels Stadt" },
    { code: "AT.04.404", name: "Politischer Bezirk Braunau am Inn" },
    { code: "AT.04.405", name: "Politischer Bezirk Eferding" },
    { code: "AT.04.406", name: "Politischer Bezirk Freistadt" },
    { code: "AT.04.407", name: "Politischer Bezirk Gmunden" },
    { code: "AT.04.408", name: "Politischer Bezirk Grieskirchen" },
    { code: "AT.04.409", name: "Politischer Bezirk Kirchdorf an der Krems" },
    { code: "AT.04.410", name: "Politischer Bezirk Linz-Land" },
    { code: "AT.04.411", name: "Politischer Bezirk Perg" },
    { code: "AT.04.412", name: "Politischer Bezirk Ried im Innkreis" },
    { code: "AT.04.413", name: "Politischer Bezirk Rohrbach" },
    { code: "AT.04.414", name: "Politischer Bezirk Schärding" },
    { code: "AT.04.415", name: "Politischer Bezirk Steyr-Land" },
    { code: "AT.04.416", name: "Politischer Bezirk Urfahr-Umgebung" },
    { code: "AT.04.417", name: "Politischer Bezirk Vöcklabruck" },
    { code: "AT.04.418", name: "Wels-Land" },
  ],
  "AT.05": [
    { code: "AT.05.501", name: "Salzburg Stadt" },
    { code: "AT.05.502", name: "Politischer Bezirk Hallein" },
    { code: "AT.05.503", name: "Politischer Bezirk Salzburg-Umgebung" },
    { code: "AT.05.504", name: "Politischer Bezirk Sankt Johann im Pongau" },
    { code: "AT.05.505", name: "Politischer Bezirk Tamsweg" },
    { code: "AT.05.506", name: "Politischer Bezirk Zell am See" },
  ],
  "AT.06": [
    { code: "AT.06.601", name: "Graz Stadt" },
    { code: "AT.06.603", name: "Politischer Bezirk Deutschlandsberg" },
    { code: "AT.06.606", name: "Politischer Bezirk Graz-Umgebung" },
    { code: "AT.06.610", name: "Politischer Bezirk Leibnitz" },
    { code: "AT.06.611", name: "Politischer Bezirk Leoben" },
    { code: "AT.06.612", name: "Politischer Bezirk Liezen" },
    { code: "AT.06.614", name: "Politischer Bezirk Murau" },
    { code: "AT.06.616", name: "Politischer Bezirk Voitsberg" },
    { code: "AT.06.617", name: "Politischer Bezirk Weiz" },
    { code: "AT.06.620", name: "Politischer Bezirk Murtal" },
    { code: "AT.06.621", name: "Politischer Bezirk Bruck-Mürzzuschlag" },
    { code: "AT.06.622", name: "Politischer Bezirk Hartberg-Fürstenfeld" },
    { code: "AT.06.623", name: "Politischer Bezirk Südoststeiermark" },
  ],
  "AT.07": [
    { code: "AT.07.701", name: "Innsbruck Stadt" },
    { code: "AT.07.702", name: "Politischer Bezirk Imst" },
    { code: "AT.07.703", name: "Politischer Bezirk Innsbruck Land" },
    { code: "AT.07.704", name: "Politischer Bezirk Kitzbühel" },
    { code: "AT.07.705", name: "Politischer Bezirk Kufstein" },
    { code: "AT.07.706", name: "Politischer Bezirk Landeck" },
    { code: "AT.07.707", name: "Politischer Bezirk Lienz" },
    { code: "AT.07.708", name: "Politischer Bezirk Reutte" },
    { code: "AT.07.709", name: "Politischer Bezirk Schwaz" },
  ],
  "AT.08": [
    { code: "AT.08.801", name: "Politischer Bezirk Bludenz" },
    { code: "AT.08.802", name: "Politischer Bezirk Bregenz" },
    { code: "AT.08.803", name: "Politischer Bezirk Dornbirn" },
    { code: "AT.08.804", name: "Politischer Bezirk Feldkirch" },
  ],
  "AT.09": [
    { code: "AT.09.900", name: "Wien Stadt" },
  ],
  "AU.02": [
    { code: "AU.02.10050", name: "Albury Municipality" },
    { code: "AU.02.10130", name: "Armidale Regional" },
    { code: "AU.02.10250", name: "Ballina" },
    { code: "AU.02.10300", name: "Balranald" },
    { code: "AU.02.10470", name: "Bathurst Regional" },
    { code: "AU.02.10550", name: "Bega Valley" },
    { code: "AU.02.10600", name: "Bellingen" },
    { code: "AU.02.10650", name: "Berrigan" },
    { code: "AU.02.10750", name: "Blacktown" },
    { code: "AU.02.10800", name: "Bland" },
    { code: "AU.02.10850", name: "Blayney" },
    { code: "AU.02.10900", name: "Blue Mountains Municipality" },
    { code: "AU.02.10950", name: "Bogan" },
    { code: "AU.02.11100", name: "Botany Bay" },
    { code: "AU.02.11150", name: "Bourke" },
    { code: "AU.02.11200", name: "Brewarrina" },
    { code: "AU.02.11250", name: "Broken Hill Municipality" },
    { code: "AU.02.11300", name: "Burwood" },
    { code: "AU.02.11350", name: "Byron Shire" },
    { code: "AU.02.11400", name: "Cabonne" },
    { code: "AU.02.11450", name: "Camden" },
    { code: "AU.02.11500", name: "Campbelltown Municipality" },
    { code: "AU.02.11520", name: "Canada Bay" },
    { code: "AU.02.11570", name: "Canterbury-Bankstown" },
    { code: "AU.02.11600", name: "Carrathool" },
    { code: "AU.02.11650", name: "Central Coast" },
    { code: "AU.02.11700", name: "Central Darling" },
    { code: "AU.02.11720", name: "Cessnock" },
    { code: "AU.02.11730", name: "Clarence Valley" },
    { code: "AU.02.11750", name: "Cobar" },
    { code: "AU.02.11800", name: "Coffs Harbour" },
    { code: "AU.02.12000", name: "Coolamon" },
    { code: "AU.02.12150", name: "Coonamble" },
    { code: "AU.02.12350", name: "Cowra" },
    { code: "AU.02.12380", name: "Cumberland" },
    { code: "AU.02.12700", name: "Dungog" },
    { code: "AU.02.12730", name: "Edward River" },
    { code: "AU.02.12750", name: "Eurobodalla" },
    { code: "AU.02.12850", name: "Fairfield" },
    { code: "AU.02.12870", name: "Federation" },
    { code: "AU.02.12900", name: "Forbes" },
    { code: "AU.02.12930", name: "Georges River" },
    { code: "AU.02.12950", name: "Gilgandra" },
    { code: "AU.02.13010", name: "Glen Innes Severn" },
    { code: "AU.02.13310", name: "Goulburn Mulwaree" },
    { code: "AU.02.13340", name: "Greater Hume Shire" },
    { code: "AU.02.13450", name: "Griffith" },
    { code: "AU.02.13510", name: "Gundagai" },
    { code: "AU.02.13550", name: "Gunnedah" },
    { code: "AU.02.13660", name: "Gwydir" },
    { code: "AU.02.13800", name: "Hawkesbury" },
    { code: "AU.02.13850", name: "Hay" },
    { code: "AU.02.13910", name: "Hilltops" },
    { code: "AU.02.14000", name: "Hornsby Shire" },
    { code: "AU.02.14100", name: "Hunters Hill" },
    { code: "AU.02.14170", name: "Inner West" },
    { code: "AU.02.14200", name: "Inverell" },
    { code: "AU.02.14300", name: "Junee" },
    { code: "AU.02.14350", name: "Kempsey" },
    { code: "AU.02.14400", name: "Kiama" },
    { code: "AU.02.14500", name: "Ku-ring-gai" },
    { code: "AU.02.14550", name: "Kyogle" },
    { code: "AU.02.14600", name: "Lachlan" },
    { code: "AU.02.14650", name: "Lake Macquarie Shire" },
    { code: "AU.02.14700", name: "Lane Cove" },
    { code: "AU.02.14750", name: "Leeton" },
    { code: "AU.02.14850", name: "Lismore Municipality" },
    { code: "AU.02.14870", name: "Lithgow" },
    { code: "AU.02.14900", name: "Liverpool" },
    { code: "AU.02.14920", name: "Liverpool Plains" },
    { code: "AU.02.14950", name: "Lockhart" },
    { code: "AU.02.15050", name: "Maitland Municipality" },
    { code: "AU.02.15240", name: "Mid-Coast" },
    { code: "AU.02.15270", name: "Mid-Western Regional" },
    { code: "AU.02.15300", name: "Moree Plains" },
    { code: "AU.02.15350", name: "Mosman" },
    { code: "AU.02.15520", name: "Murray River" },
    { code: "AU.02.15560", name: "Murrumbidgee" },
    { code: "AU.02.15650", name: "Muswellbrook" },
    { code: "AU.02.15700", name: "Nambucca Shire" },
    { code: "AU.02.15750", name: "Narrabri" },
    { code: "AU.02.15800", name: "Narrandera" },
    { code: "AU.02.15850", name: "Narromine" },
    { code: "AU.02.15900", name: "Newcastle" },
    { code: "AU.02.15950", name: "North Sydney" },
    { code: "AU.02.15990", name: "Northern Beaches" },
    { code: "AU.02.16100", name: "Oberon" },
    { code: "AU.02.16150", name: "Orange Municipality" },
    { code: "AU.02.16200", name: "Parkes" },
    { code: "AU.02.16260", name: "Parramatta" },
    { code: "AU.02.16350", name: "Penrith Municipality" },
    { code: "AU.02.16380", name: "Port Macquarie-Hastings" },
    { code: "AU.02.16400", name: "Port Stephens Shire" },
    { code: "AU.02.16490", name: "Queanbeyan-Palerang Regional" },
    { code: "AU.02.16550", name: "Randwick" },
    { code: "AU.02.16610", name: "Richmond Valley" },
    { code: "AU.02.16650", name: "Rockdale" },
    { code: "AU.02.16700", name: "Ryde" },
    { code: "AU.02.16900", name: "Shellharbour" },
    { code: "AU.02.16950", name: "Shoalhaven Shire" },
    { code: "AU.02.17000", name: "Singleton" },
    { code: "AU.02.17040", name: "Snowy Monaro Regional" },
    { code: "AU.02.17080", name: "Snowy Valleys" },
    { code: "AU.02.17100", name: "Strathfield" },
    { code: "AU.02.17150", name: "Sutherland Shire" },
    { code: "AU.02.17200", name: "City of Sydney" },
    { code: "AU.02.17310", name: "Tamworth Municipality" },
    { code: "AU.02.17350", name: "Temora Municipality" },
    { code: "AU.02.17400", name: "Tenterfield Municipality" },
    { code: "AU.02.17420", name: "The Hills Shire" },
    { code: "AU.02.17550", name: "Tweed" },
    { code: "AU.02.17620", name: "Upper Hunter Shire" },
    { code: "AU.02.17640", name: "Upper Lachlan Shire" },
    { code: "AU.02.17650", name: "Uralla" },
    { code: "AU.02.17750", name: "Wagga Wagga" },
    { code: "AU.02.17850", name: "Walcha" },
    { code: "AU.02.17900", name: "Walgett" },
    { code: "AU.02.17950", name: "Warren Shire" },
    { code: "AU.02.18020", name: "Warrumbungle Shire" },
    { code: "AU.02.18050", name: "Waverley" },
    { code: "AU.02.18100", name: "Weddin" },
    { code: "AU.02.18200", name: "Wentworth" },
    { code: "AU.02.18230", name: "Western Plains Regional" },
    { code: "AU.02.18250", name: "Willoughby" },
    { code: "AU.02.18350", name: "Wingecarribee" },
    { code: "AU.02.18400", name: "Wollondilly" },
    { code: "AU.02.18450", name: "Wollongong" },
    { code: "AU.02.18500", name: "Woollahra" },
    { code: "AU.02.18710", name: "Yass Valley" },
  ],
  "AU.03": [
    { code: "AU.03.70200", name: "Alice Springs" },
    { code: "AU.03.70420", name: "Barkly" },
    { code: "AU.03.70540", name: "Belyuen" },
    { code: "AU.03.70620", name: "Central Desert" },
    { code: "AU.03.70700", name: "Coomalie" },
    { code: "AU.03.71000", name: "Darwin" },
    { code: "AU.03.71300", name: "East Arnhem" },
    { code: "AU.03.72200", name: "Katherine" },
    { code: "AU.03.72300", name: "Litchfield" },
    { code: "AU.03.72330", name: "MacDonnell" },
    { code: "AU.03.72800", name: "Palmerston" },
    { code: "AU.03.73600", name: "Roper Gulf" },
    { code: "AU.03.74050", name: "Tiwi Islands" },
    { code: "AU.03.74550", name: "Victoria Daly" },
    { code: "AU.03.74560", name: "Wagait" },
    { code: "AU.03.74660", name: "West Arnhem" },
    { code: "AU.03.74680", name: "West Daly" },
  ],
  "AU.04": [
    { code: "AU.04.30250", name: "Aurukun" },
    { code: "AU.04.30300", name: "Balonne Shire" },
    { code: "AU.04.30370", name: "Banana" },
    { code: "AU.04.30410", name: "Barcaldine" },
    { code: "AU.04.30450", name: "Barcoo" },
    { code: "AU.04.30760", name: "Blackall Tambo" },
    { code: "AU.04.30900", name: "Boulia" },
    { code: "AU.04.31000", name: "Brisbane" },
    { code: "AU.04.31750", name: "Bulloo" },
    { code: "AU.04.31820", name: "Bundaberg" },
    { code: "AU.04.31900", name: "Burdekin" },
    { code: "AU.04.31950", name: "Burke" },
    { code: "AU.04.32080", name: "Cairns" },
    { code: "AU.04.32250", name: "Carpentaria" },
    { code: "AU.04.32260", name: "Cassowary Coast" },
    { code: "AU.04.32270", name: "Central Highlands" },
    { code: "AU.04.32310", name: "Charters Towers" },
    { code: "AU.04.32330", name: "Cherbourg" },
    { code: "AU.04.32450", name: "Cloncurry" },
    { code: "AU.04.32500", name: "Cook Shire" },
    { code: "AU.04.32600", name: "Croydon" },
    { code: "AU.04.32750", name: "Diamantina" },
    { code: "AU.04.32770", name: "Doomadgee" },
    { code: "AU.04.32810", name: "Douglas" },
    { code: "AU.04.33100", name: "Etheridge" },
    { code: "AU.04.33200", name: "Flinders" },
    { code: "AU.04.33220", name: "Fraser Coast" },
    { code: "AU.04.33360", name: "Gladstone" },
    { code: "AU.04.33430", name: "Gold Coast" },
    { code: "AU.04.33610", name: "Goondiwindi" },
    { code: "AU.04.33620", name: "Gympie Regional Council" },
    { code: "AU.04.33800", name: "Hinchinbrook" },
    { code: "AU.04.33830", name: "Hope Vale" },
    { code: "AU.04.33960", name: "Ipswich" },
    { code: "AU.04.33980", name: "Isaac" },
    { code: "AU.04.34420", name: "Kowanyama" },
    { code: "AU.04.34530", name: "Livingstone" },
    { code: "AU.04.34570", name: "Lockhart River" },
    { code: "AU.04.34580", name: "Lockyer Valley" },
    { code: "AU.04.34590", name: "Logan" },
    { code: "AU.04.34710", name: "Longreach" },
    { code: "AU.04.34770", name: "Mackay" },
    { code: "AU.04.34800", name: "McKinlay" },
    { code: "AU.04.34830", name: "Mapoon" },
    { code: "AU.04.34860", name: "Maranoa" },
    { code: "AU.04.34880", name: "Mareeba" },
    { code: "AU.04.35010", name: "Moreton Bay" },
    { code: "AU.04.35250", name: "Mornington" },
    { code: "AU.04.35300", name: "Mount Isa" },
    { code: "AU.04.35600", name: "Murweh" },
    { code: "AU.04.35670", name: "Napranum" },
    { code: "AU.04.35740", name: "Noosa" },
    { code: "AU.04.35760", name: "North Burnett" },
    { code: "AU.04.35780", name: "Northern Peninsula Area" },
    { code: "AU.04.35790", name: "Palm Island" },
    { code: "AU.04.35800", name: "Paroo" },
    { code: "AU.04.36070", name: "Pormpuraaw" },
    { code: "AU.04.36150", name: "Quilpie" },
    { code: "AU.04.36250", name: "Redland" },
    { code: "AU.04.36300", name: "Richmond" },
    { code: "AU.04.36370", name: "Rockhampton" },
    { code: "AU.04.36510", name: "Scenic Rim" },
    { code: "AU.04.36580", name: "Somerset" },
    { code: "AU.04.36630", name: "South Burnett" },
    { code: "AU.04.36660", name: "Southern Downs" },
    { code: "AU.04.36720", name: "Sunshine Coast" },
    { code: "AU.04.36820", name: "Tablelands" },
    { code: "AU.04.36910", name: "Toowoomba" },
    { code: "AU.04.36950", name: "Torres" },
    { code: "AU.04.36960", name: "Torres Strait Island Region" },
    { code: "AU.04.37010", name: "Townsville" },
    { code: "AU.04.37300", name: "Weipa" },
    { code: "AU.04.37310", name: "Western Downs" },
    { code: "AU.04.37340", name: "Whitsunday" },
    { code: "AU.04.37400", name: "Winton" },
    { code: "AU.04.37550", name: "Woorabinda" },
    { code: "AU.04.37570", name: "Wujal Wujal" },
    { code: "AU.04.37600", name: "Yarrabah" },
  ],
  "AU.05": [
    { code: "AU.05.40070", name: "Adelaide" },
    { code: "AU.05.40120", name: "Adelaide Hills" },
    { code: "AU.05.40220", name: "Alexandrina" },
    { code: "AU.05.40250", name: "Anangu Pitjantjatjara" },
    { code: "AU.05.40310", name: "Barossa" },
    { code: "AU.05.40430", name: "Barunga West" },
    { code: "AU.05.40520", name: "Berri and Barmera" },
    { code: "AU.05.40700", name: "Burnside" },
    { code: "AU.05.40910", name: "Campbelltown" },
    { code: "AU.05.41010", name: "Ceduna" },
    { code: "AU.05.41060", name: "Charles Sturt" },
    { code: "AU.05.41140", name: "Clare and Gilbert Valleys" },
    { code: "AU.05.41190", name: "Cleve" },
    { code: "AU.05.41330", name: "Coober Pedy" },
    { code: "AU.05.41560", name: "Copper Coast" },
    { code: "AU.05.41750", name: "Elliston" },
    { code: "AU.05.41830", name: "Flinders Ranges" },
    { code: "AU.05.41960", name: "Franklin Harbour" },
    { code: "AU.05.42030", name: "Gawler" },
    { code: "AU.05.42110", name: "Goyder" },
    { code: "AU.05.42250", name: "Grant" },
    { code: "AU.05.42600", name: "Holdfast Bay" },
    { code: "AU.05.42750", name: "Kangaroo Island" },
    { code: "AU.05.43080", name: "Karoonda East Murray" },
    { code: "AU.05.43220", name: "Kimba" },
    { code: "AU.05.43360", name: "Kingston" },
    { code: "AU.05.43650", name: "Light" },
    { code: "AU.05.43710", name: "Lower Eyre Peninsula" },
    { code: "AU.05.43790", name: "Loxton Waikerie" },
    { code: "AU.05.43920", name: "Mallala" },
    { code: "AU.05.44000", name: "Maralinga Tjarutja" },
    { code: "AU.05.44060", name: "Marion" },
    { code: "AU.05.44210", name: "Mid Murray" },
    { code: "AU.05.44340", name: "Mitcham" },
    { code: "AU.05.44550", name: "Mount Barker" },
    { code: "AU.05.44620", name: "Mount Gambier" },
    { code: "AU.05.44830", name: "Mount Remarkable" },
    { code: "AU.05.45040", name: "Murray Bridge" },
    { code: "AU.05.45090", name: "Naracoorte and Lucindale" },
    { code: "AU.05.45120", name: "Northern Areas" },
    { code: "AU.05.45290", name: "Norwood Payneham St Peters" },
    { code: "AU.05.45340", name: "Onkaparinga" },
    { code: "AU.05.45400", name: "Orroroo/Carrieton" },
    { code: "AU.05.45540", name: "Peterborough" },
    { code: "AU.05.45680", name: "Playford" },
    { code: "AU.05.45890", name: "Port Adelaide Enfield" },
    { code: "AU.05.46090", name: "Port Augusta" },
    { code: "AU.05.46300", name: "Port Lincoln" },
    { code: "AU.05.46450", name: "Port Pirie City and Dists" },
    { code: "AU.05.46510", name: "Prospect" },
    { code: "AU.05.46670", name: "Renmark Paringa" },
    { code: "AU.05.46860", name: "Robe" },
    { code: "AU.05.46970", name: "Roxby Downs" },
    { code: "AU.05.47140", name: "Salisbury" },
    { code: "AU.05.47290", name: "Southern Mallee" },
    { code: "AU.05.47490", name: "Streaky Bay" },
    { code: "AU.05.47630", name: "Tatiara" },
    { code: "AU.05.47700", name: "Tea Tree Gully" },
    { code: "AU.05.47800", name: "The Coorong" },
    { code: "AU.05.47910", name: "Tumby Bay" },
    { code: "AU.05.47980", name: "Unley" },
    { code: "AU.05.48050", name: "Victor Harbor" },
    { code: "AU.05.48130", name: "Wakefield" },
    { code: "AU.05.48260", name: "Walkerville" },
    { code: "AU.05.48340", name: "Wattle Range" },
    { code: "AU.05.48410", name: "City of West Torrens" },
    { code: "AU.05.48540", name: "Whyalla" },
    { code: "AU.05.48640", name: "Wudinna" },
    { code: "AU.05.48750", name: "Yankalilla" },
    { code: "AU.05.48830", name: "Yorke Peninsula" },
  ],
  "AU.06": [
    { code: "AU.06.60210", name: "Break O'Day" },
    { code: "AU.06.60410", name: "Brighton" },
    { code: "AU.06.60610", name: "Burnie" },
    { code: "AU.06.60810", name: "Central Coast" },
    { code: "AU.06.61010", name: "Central Highlands" },
    { code: "AU.06.61210", name: "Circular Head" },
    { code: "AU.06.61410", name: "Clarence" },
    { code: "AU.06.61510", name: "Derwent Valley" },
    { code: "AU.06.61610", name: "Devonport" },
    { code: "AU.06.61810", name: "Dorset" },
    { code: "AU.06.62010", name: "Flinders" },
    { code: "AU.06.62210", name: "George Town" },
    { code: "AU.06.62410", name: "Glamorgan/Spring Bay" },
    { code: "AU.06.62610", name: "Glenorchy" },
    { code: "AU.06.62810", name: "Hobart" },
    { code: "AU.06.63010", name: "Huon Valley" },
    { code: "AU.06.63210", name: "Kentish" },
    { code: "AU.06.63410", name: "King Island" },
    { code: "AU.06.63610", name: "Kingborough" },
    { code: "AU.06.63810", name: "Latrobe" },
    { code: "AU.06.64010", name: "Launceston" },
    { code: "AU.06.64210", name: "Meander Valley" },
    { code: "AU.06.64610", name: "Northern Midlands" },
    { code: "AU.06.64810", name: "Sorell" },
    { code: "AU.06.65010", name: "Southern Midlands" },
    { code: "AU.06.65210", name: "Tasman Peninsula" },
    { code: "AU.06.65410", name: "Waratah/Wynyard" },
    { code: "AU.06.65610", name: "West Coast" },
    { code: "AU.06.65810", name: "West Tamar" },
  ],
  "AU.07": [
    { code: "AU.07.20110", name: "Alpine" },
    { code: "AU.07.20260", name: "Ararat" },
    { code: "AU.07.20570", name: "Ballarat" },
    { code: "AU.07.20660", name: "Banyule" },
    { code: "AU.07.20740", name: "Bass Coast" },
    { code: "AU.07.20830", name: "Baw Baw" },
    { code: "AU.07.20910", name: "Bayside" },
    { code: "AU.07.21010", name: "Benalla" },
    { code: "AU.07.21110", name: "Boroondara" },
    { code: "AU.07.21180", name: "Brimbank" },
    { code: "AU.07.21270", name: "Buloke" },
    { code: "AU.07.21370", name: "Campaspe" },
    { code: "AU.07.21450", name: "Cardinia" },
    { code: "AU.07.21610", name: "Casey" },
    { code: "AU.07.21670", name: "Central Goldfields" },
    { code: "AU.07.21750", name: "Colac Otway" },
    { code: "AU.07.21830", name: "Corangamite" },
    { code: "AU.07.21890", name: "Darebin" },
    { code: "AU.07.22110", name: "East Gippsland" },
    { code: "AU.07.22170", name: "Frankston" },
    { code: "AU.07.22250", name: "Gannawarra" },
    { code: "AU.07.22310", name: "Glen Eira" },
    { code: "AU.07.22410", name: "Glenelg" },
    { code: "AU.07.22490", name: "Golden Plains" },
    { code: "AU.07.22620", name: "Greater Bendigo" },
    { code: "AU.07.22670", name: "Greater Dandenong" },
    { code: "AU.07.22750", name: "Greater Geelong" },
    { code: "AU.07.22830", name: "Greater Shepparton" },
    { code: "AU.07.22910", name: "Hepburn" },
    { code: "AU.07.22980", name: "Hindmarsh" },
    { code: "AU.07.23110", name: "Hobsons Bay" },
    { code: "AU.07.23190", name: "Horsham" },
    { code: "AU.07.23270", name: "Hume" },
    { code: "AU.07.23350", name: "Indigo" },
    { code: "AU.07.23430", name: "Kingston" },
    { code: "AU.07.23670", name: "Knox" },
    { code: "AU.07.23810", name: "Latrobe" },
    { code: "AU.07.23940", name: "Loddon" },
    { code: "AU.07.24130", name: "Macedon Ranges" },
    { code: "AU.07.24210", name: "Manningham" },
    { code: "AU.07.24250", name: "Mansfield" },
    { code: "AU.07.24330", name: "Maribyrnong" },
    { code: "AU.07.24410", name: "Maroondah" },
    { code: "AU.07.24600", name: "Melbourne" },
    { code: "AU.07.24650", name: "Melton" },
    { code: "AU.07.24780", name: "Mildura" },
    { code: "AU.07.24850", name: "Mitchell" },
    { code: "AU.07.24900", name: "Moira" },
    { code: "AU.07.24970", name: "Monash" },
    { code: "AU.07.25060", name: "Moonee Valley" },
    { code: "AU.07.25150", name: "Moorabool" },
    { code: "AU.07.25250", name: "Moreland" },
    { code: "AU.07.25340", name: "Mornington Peninsula" },
    { code: "AU.07.25430", name: "Mount Alexander" },
    { code: "AU.07.25490", name: "Moyne" },
    { code: "AU.07.25620", name: "Murrindindi" },
    { code: "AU.07.25710", name: "Nillumbik" },
    { code: "AU.07.25810", name: "Northern Grampians" },
    { code: "AU.07.25900", name: "Port Phillip" },
    { code: "AU.07.25990", name: "Pyrenees" },
    { code: "AU.07.26080", name: "Queenscliffe" },
    { code: "AU.07.26170", name: "South Gippsland" },
    { code: "AU.07.26260", name: "Southern Grampians" },
    { code: "AU.07.26350", name: "Stonnington" },
    { code: "AU.07.26430", name: "Strathbogie" },
    { code: "AU.07.26490", name: "Surf Coast" },
    { code: "AU.07.26610", name: "Swan Hill" },
    { code: "AU.07.26670", name: "Towong" },
    { code: "AU.07.26700", name: "Wangaratta" },
    { code: "AU.07.26730", name: "Warrnambool" },
    { code: "AU.07.26810", name: "Wellington" },
    { code: "AU.07.26890", name: "West Wimmera" },
    { code: "AU.07.26980", name: "Whitehorse" },
    { code: "AU.07.27070", name: "Whittlesea" },
    { code: "AU.07.27170", name: "Wodonga" },
    { code: "AU.07.27260", name: "Wyndham" },
    { code: "AU.07.27350", name: "Yarra" },
    { code: "AU.07.27450", name: "Yarra Ranges" },
    { code: "AU.07.27630", name: "Yarriambiack" },
  ],
  "AU.08": [
    { code: "AU.08.50080", name: "Albany" },
    { code: "AU.08.50210", name: "Armadale" },
    { code: "AU.08.50250", name: "Ashburton" },
    { code: "AU.08.50280", name: "Augusta-Margaret River Shire" },
    { code: "AU.08.50350", name: "Bassendean" },
    { code: "AU.08.50420", name: "Bayswater" },
    { code: "AU.08.50490", name: "Belmont" },
    { code: "AU.08.50560", name: "Beverley" },
    { code: "AU.08.50630", name: "Boddington" },
    { code: "AU.08.50770", name: "Boyup Brook" },
    { code: "AU.08.50840", name: "Bridgetown-Greenbushes" },
    { code: "AU.08.50910", name: "Brookton" },
    { code: "AU.08.50980", name: "Broome" },
    { code: "AU.08.51080", name: "Broomehill-Tambellup" },
    { code: "AU.08.51120", name: "Bruce Rock" },
    { code: "AU.08.51190", name: "Bunbury" },
    { code: "AU.08.51260", name: "Busselton" },
    { code: "AU.08.51310", name: "Cambridge" },
    { code: "AU.08.51330", name: "Canning" },
    { code: "AU.08.51400", name: "Capel" },
    { code: "AU.08.51470", name: "Carnamah" },
    { code: "AU.08.51540", name: "Carnarvon" },
    { code: "AU.08.51610", name: "Chapman Valley" },
    { code: "AU.08.51680", name: "Chittering" },
    { code: "AU.08.51750", name: "Claremont" },
    { code: "AU.08.51820", name: "City of Cockburn" },
    { code: "AU.08.51890", name: "Collie" },
    { code: "AU.08.51960", name: "Coolgardie" },
    { code: "AU.08.52030", name: "Coorow" },
    { code: "AU.08.52100", name: "Corrigin" },
    { code: "AU.08.52170", name: "Cottesloe" },
    { code: "AU.08.52240", name: "Cranbrook" },
    { code: "AU.08.52310", name: "Cuballing" },
    { code: "AU.08.52380", name: "Cue" },
    { code: "AU.08.52450", name: "Cunderdin" },
    { code: "AU.08.52520", name: "Dalwallinu" },
    { code: "AU.08.52590", name: "Dandaragan" },
    { code: "AU.08.52660", name: "Dardanup" },
    { code: "AU.08.52730", name: "Denmark" },
    { code: "AU.08.52800", name: "Derby-West Kimberley" },
    { code: "AU.08.52870", name: "Donnybrook-Balingup" },
    { code: "AU.08.52940", name: "Dowerin" },
    { code: "AU.08.53010", name: "Dumbleyung Shire" },
    { code: "AU.08.53080", name: "Dundas" },
    { code: "AU.08.53150", name: "East Fremantle" },
    { code: "AU.08.53220", name: "East Pilbara" },
    { code: "AU.08.53290", name: "Esperance Shire" },
    { code: "AU.08.53360", name: "Exmouth" },
    { code: "AU.08.53430", name: "Fremantle" },
    { code: "AU.08.53570", name: "Gingin" },
    { code: "AU.08.53640", name: "Gnowangerup" },
    { code: "AU.08.53710", name: "Goomalling" },
    { code: "AU.08.53780", name: "Gosnells" },
    { code: "AU.08.53800", name: "Greater Geraldton" },
    { code: "AU.08.53920", name: "Halls Creek" },
    { code: "AU.08.53990", name: "Harvey" },
    { code: "AU.08.54060", name: "Irwin" },
    { code: "AU.08.54130", name: "Jerramungup" },
    { code: "AU.08.54170", name: "Joondalup" },
    { code: "AU.08.54200", name: "Kalamunda" },
    { code: "AU.08.54280", name: "Kalgoorlie/Boulder" },
    { code: "AU.08.54310", name: "Karratha" },
    { code: "AU.08.54340", name: "Katanning" },
    { code: "AU.08.54410", name: "Kellerberrin" },
    { code: "AU.08.54480", name: "Kent Shire" },
    { code: "AU.08.54550", name: "Kojonup" },
    { code: "AU.08.54620", name: "Kondinin" },
    { code: "AU.08.54690", name: "Koorda" },
    { code: "AU.08.54760", name: "Kulin" },
    { code: "AU.08.54830", name: "Kwinana" },
    { code: "AU.08.54900", name: "Lake Grace" },
    { code: "AU.08.54970", name: "Laverton" },
    { code: "AU.08.55040", name: "Leonora" },
    { code: "AU.08.55110", name: "Mandurah" },
    { code: "AU.08.55180", name: "Manjimup" },
    { code: "AU.08.55250", name: "Meekatharra" },
    { code: "AU.08.55320", name: "Melville" },
    { code: "AU.08.55390", name: "Menzies" },
    { code: "AU.08.55460", name: "Merredin" },
    { code: "AU.08.55530", name: "Mingenew" },
    { code: "AU.08.55600", name: "Moora" },
    { code: "AU.08.55670", name: "Morawa" },
    { code: "AU.08.55740", name: "Mosman Park" },
    { code: "AU.08.55810", name: "Mount Magnet" },
    { code: "AU.08.55880", name: "Mount Marshall" },
    { code: "AU.08.55950", name: "Mukinbudin" },
    { code: "AU.08.56090", name: "Mundaring" },
    { code: "AU.08.56160", name: "Murchison" },
    { code: "AU.08.56230", name: "Murray" },
    { code: "AU.08.56300", name: "Nannup" },
    { code: "AU.08.56370", name: "Narembeen" },
    { code: "AU.08.56460", name: "Narrogin" },
    { code: "AU.08.56580", name: "Nedlands" },
    { code: "AU.08.56620", name: "Ngaanyatjarraku" },
    { code: "AU.08.56730", name: "Northam" },
    { code: "AU.08.56790", name: "Northampton Shire" },
    { code: "AU.08.56860", name: "Nungarin" },
    { code: "AU.08.56930", name: "Peppermint Grove" },
    { code: "AU.08.57000", name: "Perenjori" },
    { code: "AU.08.57080", name: "City of Perth" },
    { code: "AU.08.57140", name: "Pingelly" },
    { code: "AU.08.57210", name: "Plantagenet Shire" },
    { code: "AU.08.57280", name: "Port Hedland" },
    { code: "AU.08.57350", name: "Quairading" },
    { code: "AU.08.57420", name: "Ravensthorpe" },
    { code: "AU.08.57490", name: "Rockingham" },
    { code: "AU.08.57630", name: "Sandstone" },
    { code: "AU.08.57700", name: "Serpentine-Jarrahdale" },
    { code: "AU.08.57770", name: "Shark Bay" },
    { code: "AU.08.57840", name: "South Perth" },
    { code: "AU.08.57910", name: "Stirling" },
    { code: "AU.08.57980", name: "Subiaco" },
    { code: "AU.08.58050", name: "Swan" },
    { code: "AU.08.58190", name: "Tammin" },
    { code: "AU.08.58260", name: "Three Springs" },
    { code: "AU.08.58330", name: "Toodyay" },
    { code: "AU.08.58400", name: "Trayning" },
    { code: "AU.08.58470", name: "Upper Gascoyne" },
    { code: "AU.08.58510", name: "Victoria Park" },
    { code: "AU.08.58540", name: "Victoria Plains" },
    { code: "AU.08.58570", name: "Vincent" },
    { code: "AU.08.58610", name: "Wagin" },
    { code: "AU.08.58680", name: "Wandering" },
    { code: "AU.08.58760", name: "Wanneroo" },
    { code: "AU.08.58820", name: "Waroona" },
    { code: "AU.08.58890", name: "West Arthur" },
    { code: "AU.08.59030", name: "Westonia" },
    { code: "AU.08.59100", name: "Wickepin" },
    { code: "AU.08.59170", name: "Williams" },
    { code: "AU.08.59250", name: "Wiluna" },
    { code: "AU.08.59310", name: "Wongan-Ballidu" },
    { code: "AU.08.59320", name: "Woodanilling" },
    { code: "AU.08.59330", name: "Wyalkatchem" },
    { code: "AU.08.59340", name: "Wyndham-East Kimberley" },
    { code: "AU.08.59350", name: "Yalgoo" },
    { code: "AU.08.59360", name: "Yilgarn" },
    { code: "AU.08.59370", name: "York" },
  ],
  "AX.211": [
    { code: "AX.211.478", name: "Mariehamn" },
  ],
  "AX.212": [
    { code: "AX.212.043", name: "Eckerö" },
    { code: "AX.212.060", name: "Finström" },
    { code: "AX.212.065", name: "Geta" },
    { code: "AX.212.076", name: "Hammarland" },
    { code: "AX.212.170", name: "Jomala" },
    { code: "AX.212.417", name: "Lemland" },
    { code: "AX.212.438", name: "Lumparland" },
    { code: "AX.212.736", name: "Saltvik" },
    { code: "AX.212.771", name: "Sund" },
  ],
  "AX.213": [
    { code: "AX.213.035", name: "Brändö" },
    { code: "AX.213.062", name: "Föglö" },
    { code: "AX.213.295", name: "Kumlinge" },
    { code: "AX.213.318", name: "Kökar" },
    { code: "AX.213.766", name: "Sottunga" },
    { code: "AX.213.941", name: "Vårdö" },
  ],
  "AZ.01": [
    { code: "AZ.01.585638", name: "Leninskiy Rayon" },
    { code: "AZ.01.585882", name: "Kirovskiy Rayon" },
  ],
  "AZ.09": [
    { code: "AZ.09.585039", name: "Shaumyanovskiy Rayon" },
    { code: "AZ.09.585320", name: "Ordzhonikidzevskiy Rayon))" },
    { code: "AZ.09.585328", name: "Oktyabr'skiy Rayon" },
    { code: "AZ.09.585358", name: "Nizaminskiy Rayon" },
    { code: "AZ.09.586209", name: "Qaradağ Rayonu" },
    { code: "AZ.09.586342", name: "Imeni Dvadtsati Shesti Bakinskikh Komissarov Rayon" },
    { code: "AZ.09.7669203", name: "Khatai raion" },
    { code: "AZ.09.8572651", name: "Nizami Rayonu" },
  ],
  "AZ.21": [
    { code: "AZ.21.585038", name: "Shaumyan Rayon" },
  ],
  "AZ.35": [
    { code: "AZ.35.147212", name: "Shahbuz Rayon" },
    { code: "AZ.35.147365", name: "Ordubad Rayon" },
    { code: "AZ.35.147997", name: "Sharur Rayon" },
    { code: "AZ.35.148132", name: "Julfa Rayon" },
    { code: "AZ.35.148412", name: "Nakhchivan City" },
    { code: "AZ.35.409387", name: "Sadarak Rayon" },
    { code: "AZ.35.7669114", name: "Babek Rayon" },
    { code: "AZ.35.8014931", name: "Kangarli Rayon" },
    { code: "AZ.35.8411069", name: "Nakhchivan" },
  ],
  "AZ.57": [
    { code: "AZ.57.585509", name: "Mirbǝşir Rayonu" },
  ],
  "BA.01": [
    { code: "BA.01.3343704", name: "Unsko-Sanski Kanton" },
    { code: "BA.01.3343706", name: "Posavski Kanton" },
    { code: "BA.01.3343716", name: "Tuzlanski Kanton" },
    { code: "BA.01.3343722", name: "Zeničko-Dobojski Kanton" },
    { code: "BA.01.3343726", name: "Bosansko-Podrinjski Kanton Goražde" },
    { code: "BA.01.3343731", name: "Srednjobosanski Kanton" },
    { code: "BA.01.3343733", name: "Hercegovačko-Neretvanski Kanton" },
    { code: "BA.01.3343736", name: "Zapadnohercegovački Kanton" },
    { code: "BA.01.3343737", name: "Kanton Sarajevo" },
    { code: "BA.01.3343740", name: "Kanton 10" },
    { code: "BA.01.7648659", name: "Neretvljanski" },
  ],
  "BA.02": [
    { code: "BA.02.11169977", name: "Grad Istočno Sarajevo" },
    { code: "BA.02.11170599", name: "Stanari" },
    { code: "BA.02.3194943", name: "Modriča" },
    { code: "BA.02.3294539", name: "Opština Bileća" },
    { code: "BA.02.3294540", name: "Ljubinje" },
    { code: "BA.02.3294558", name: "Gacko" },
    { code: "BA.02.3294561", name: "Opština Nevesinje" },
    { code: "BA.02.3294564", name: "Kalinovik" },
    { code: "BA.02.3294565", name: "Foča" },
    { code: "BA.02.3294566", name: "Opština Čajniče" },
    { code: "BA.02.3294770", name: "Rudo" },
    { code: "BA.02.3294772", name: "Opština Višegrad" },
    { code: "BA.02.3294773", name: "Opština Pale" },
    { code: "BA.02.3294774", name: "Rogatica" },
    { code: "BA.02.3294829", name: "Srebrenica" },
    { code: "BA.02.3294830", name: "Han Pijesak" },
    { code: "BA.02.3294839", name: "Vlasenica" },
    { code: "BA.02.3294865", name: "Opština Teslić" },
    { code: "BA.02.3294871", name: "Opština Kotor Varoš" },
    { code: "BA.02.3294873", name: "Lopare" },
    { code: "BA.02.3294874", name: "Opština Ugljevik" },
    { code: "BA.02.3294889", name: "Opština Čelinac" },
    { code: "BA.02.3294893", name: "Banja Luka" },
    { code: "BA.02.3294894", name: "Doboj" },
    { code: "BA.02.3294896", name: "Bijeljina" },
    { code: "BA.02.3294904", name: "Prnjavor" },
    { code: "BA.02.3294906", name: "Opština Laktaši" },
    { code: "BA.02.3294909", name: "Prijedor" },
    { code: "BA.02.3294910", name: "Derventa" },
    { code: "BA.02.3294911", name: "Opština Modriča" },
    { code: "BA.02.3294912", name: "Srbac" },
    { code: "BA.02.3294915", name: "Opština Novi Grad" },
    { code: "BA.02.3294916", name: "Opština Šamac" },
    { code: "BA.02.3294917", name: "Opština Gradiška" },
    { code: "BA.02.3294918", name: "Opstina Brod" },
    { code: "BA.02.3344087", name: "Opština Krupa na Uni" },
    { code: "BA.02.3344088", name: "Opština Kozarska Dubica" },
    { code: "BA.02.3344089", name: "Opština Oštra Luka" },
    { code: "BA.02.3344090", name: "Opština Vukosavlje" },
    { code: "BA.02.3344091", name: "Općina Donji Žabar" },
    { code: "BA.02.3344092", name: "Opština Pelagićevo" },
    { code: "BA.02.3344093", name: "Općina Kneževo" },
    { code: "BA.02.3344094", name: "Opština Mrkonjić Grad" },
    { code: "BA.02.3344095", name: "Opština Šipovo" },
    { code: "BA.02.3344096", name: "Opština Petrovac" },
    { code: "BA.02.3344097", name: "Istočni Drvar" },
    { code: "BA.02.3344098", name: "Opština Ribnik" },
    { code: "BA.02.3344099", name: "Mrkonjic Grad Jug Opcina" },
    { code: "BA.02.3344100", name: "Zvornik" },
    { code: "BA.02.3344101", name: "Opština Osmaci" },
    { code: "BA.02.3344102", name: "Opština Šekovići" },
    { code: "BA.02.3344103", name: "Bratunac" },
    { code: "BA.02.3344104", name: "Opština Sokolac" },
    { code: "BA.02.3344105", name: "Novo Goražde" },
    { code: "BA.02.3344106", name: "Istočni Stari Grad" },
    { code: "BA.02.3344107", name: "Istočno Novo Sarajevo" },
    { code: "BA.02.3344108", name: "Istočna Ilidža" },
    { code: "BA.02.3344109", name: "Opština Trnovo" },
    { code: "BA.02.3344110", name: "Opština Berkovići" },
    { code: "BA.02.3344111", name: "Istočni Mostar" },
    { code: "BA.02.3344112", name: "Jezero" },
    { code: "BA.02.3344113", name: "Opština Kupres" },
    { code: "BA.02.3344114", name: "Kostajnica" },
    { code: "BA.02.3344115", name: "Opština Petrovo" },
    { code: "BA.02.3344117", name: "Trebinje" },
    { code: "BA.02.3344118", name: "Opština Milići" },
    { code: "BA.02.3344119", name: "Skelani Opština" },
  ],
  "BD.81": [
    { code: "BD.81.3026", name: "Dhaka" },
    { code: "BD.81.3029", name: "Faridpur" },
    { code: "BD.81.3033", name: "Gazipur" },
    { code: "BD.81.3035", name: "Gopalganj" },
    { code: "BD.81.3048", name: "Kishoregonj" },
    { code: "BD.81.3054", name: "Madaripur" },
    { code: "BD.81.3056", name: "Manikganj" },
    { code: "BD.81.3059", name: "Munshiganj" },
    { code: "BD.81.3067", name: "Narayanganj" },
    { code: "BD.81.3068", name: "Narsingdi" },
    { code: "BD.81.3082", name: "Rajbari" },
    { code: "BD.81.3086", name: "Shariatpur" },
    { code: "BD.81.3093", name: "Tangail" },
  ],
  "BD.82": [
    { code: "BD.82.4001", name: "Bagerhat" },
    { code: "BD.82.4018", name: "Chuadanga" },
    { code: "BD.82.4041", name: "Jessore" },
    { code: "BD.82.4044", name: "Jhenaidah" },
    { code: "BD.82.4047", name: "Khulna" },
    { code: "BD.82.4050", name: "Kushtia" },
    { code: "BD.82.4055", name: "Magura" },
    { code: "BD.82.4057", name: "Meherpur" },
    { code: "BD.82.4065", name: "Narail" },
    { code: "BD.82.4087", name: "Satkhira" },
  ],
  "BD.83": [
    { code: "BD.83.5010", name: "Bogra" },
    { code: "BD.83.5038", name: "Joypurhat" },
    { code: "BD.83.5064", name: "Naogaon" },
    { code: "BD.83.5069", name: "Natore" },
    { code: "BD.83.5070", name: "Chapai Nababganj" },
    { code: "BD.83.5076", name: "Pabna" },
    { code: "BD.83.5081", name: "Rajshahi" },
    { code: "BD.83.5088", name: "Sirajganj" },
  ],
  "BD.84": [
    { code: "BD.84.2003", name: "Bandarban" },
    { code: "BD.84.2012", name: "Brahmanbaria" },
    { code: "BD.84.2013", name: "Chandpur" },
    { code: "BD.84.2015", name: "Chittagong" },
    { code: "BD.84.2019", name: "Comilla" },
    { code: "BD.84.2022", name: "Cox's Bazar" },
    { code: "BD.84.2030", name: "Feni" },
    { code: "BD.84.2046", name: "Khagrachhari" },
    { code: "BD.84.2051", name: "Lakshmipur" },
    { code: "BD.84.2075", name: "Noakhali" },
    { code: "BD.84.2084", name: "Rangamati" },
  ],
  "BD.85": [
    { code: "BD.85.1004", name: "Barguna" },
    { code: "BD.85.1006", name: "Barisal" },
    { code: "BD.85.1009", name: "Bhola" },
    { code: "BD.85.1042", name: "Jhalokati" },
    { code: "BD.85.1078", name: "Patuakhali" },
    { code: "BD.85.1079", name: "Pirojpur" },
  ],
  "BD.86": [
    { code: "BD.86.6036", name: "Habiganj" },
    { code: "BD.86.6058", name: "Maulvibazar" },
    { code: "BD.86.6090", name: "Sunamganj" },
    { code: "BD.86.6091", name: "Sylhet" },
  ],
  "BD.87": [
    { code: "BD.87.5527", name: "Dinajpur" },
    { code: "BD.87.5532", name: "Gaibandha" },
    { code: "BD.87.5549", name: "Kurigram" },
    { code: "BD.87.5552", name: "Lalmonirhat District" },
    { code: "BD.87.5573", name: "Nilphamari Zila" },
    { code: "BD.87.5577", name: "Panchagarh" },
    { code: "BD.87.5585", name: "Rangpur" },
    { code: "BD.87.5594", name: "Thakurgaon" },
  ],
  "BD.H": [
    { code: "BD.H.3039", name: "Jamalpur" },
    { code: "BD.H.3061", name: "Mymensingh" },
    { code: "BD.H.3072", name: "Netrakona" },
    { code: "BD.H.3089", name: "Sherpur" },
  ],
  "BE.BRU": [
    { code: "BE.BRU.BRU", name: "Bruxelles-Capitale" },
  ],
  "BE.VLG": [
    { code: "BE.VLG.VAN", name: "Provincie Antwerpen" },
    { code: "BE.VLG.VBR", name: "Provincie Vlaams-Brabant" },
    { code: "BE.VLG.VLI", name: "Provincie Limburg" },
    { code: "BE.VLG.VOV", name: "Provincie Oost-Vlaanderen" },
    { code: "BE.VLG.VWV", name: "Provincie West-Vlaanderen" },
  ],
  "BE.WAL": [
    { code: "BE.WAL.WBR", name: "Province du Brabant Wallon" },
    { code: "BE.WAL.WHT", name: "Province du Hainaut" },
    { code: "BE.WAL.WLG", name: "Province de Liège" },
    { code: "BE.WAL.WLX", name: "Province du Luxembourg" },
    { code: "BE.WAL.WNA", name: "Province de Namur" },
  ],
  "BF.01": [
    { code: "BF.01.45", name: "Province des Balé" },
    { code: "BF.01.46", name: "Province des Banwa" },
    { code: "BF.01.58", name: "Province de la Kossi" },
    { code: "BF.01.63", name: "Province du Mouhoun" },
    { code: "BF.01.66", name: "Province du Nayala" },
    { code: "BF.01.73", name: "Province du Sourou" },
  ],
  "BF.02": [
    { code: "BF.02.55", name: "Province de la Comoé" },
    { code: "BF.02.61", name: "Province de la Léraba" },
  ],
  "BF.03": [
    { code: "BF.03.53", name: "Kadiogo Province" },
  ],
  "BF.04": [
    { code: "BF.04.28", name: "Kouritenga Province" },
    { code: "BF.04.49", name: "Province du Boulgou" },
    { code: "BF.04.59", name: "Province du Koulpélogo" },
  ],
  "BF.05": [
    { code: "BF.05.15", name: "Province du Bam" },
    { code: "BF.05.64", name: "Province du Namentenga" },
    { code: "BF.05.70", name: "Province du Sanmatenga" },
  ],
  "BF.06": [
    { code: "BF.06.19", name: "Province du Boulkiemdé" },
    { code: "BF.06.36", name: "Province du Sanguié" },
    { code: "BF.06.72", name: "Province de la Sissili" },
    { code: "BF.06.77", name: "Province du Ziro" },
  ],
  "BF.07": [
    { code: "BF.07.44", name: "Zoundweogo Province" },
    { code: "BF.07.47", name: "Bazega Province" },
    { code: "BF.07.65", name: "Nahouri Province" },
  ],
  "BF.08": [
    { code: "BF.08.21", name: "Gnagna Province" },
    { code: "BF.08.42", name: "Province de la Tapoa" },
    { code: "BF.08.50", name: "Province du Gourma" },
    { code: "BF.08.56", name: "Province de la Komandjoari" },
    { code: "BF.08.57", name: "Province de la Kompienga" },
  ],
  "BF.09": [
    { code: "BF.09.51", name: "Province du Houet" },
    { code: "BF.09.54", name: "Province du Kénédougou" },
    { code: "BF.09.74", name: "Province du Tuy" },
  ],
  "BF.10": [
    { code: "BF.10.34", name: "Province du Passoré" },
    { code: "BF.10.62", name: "Province du Loroum" },
    { code: "BF.10.76", name: "Province du Yatenga" },
    { code: "BF.10.78", name: "Province du Zondoma" },
  ],
  "BF.11": [
    { code: "BF.11.20", name: "Province du Ganzourgou" },
    { code: "BF.11.60", name: "Province du Kourwéogo" },
    { code: "BF.11.68", name: "Oubritenga" },
  ],
  "BF.12": [
    { code: "BF.12.33", name: "Province de l’Oudalan" },
    { code: "BF.12.40", name: "Province du Soum" },
    { code: "BF.12.71", name: "Province du Séno" },
    { code: "BF.12.75", name: "Province du Yagha" },
  ],
  "BF.13": [
    { code: "BF.13.48", name: "Province de la Bougouriba" },
    { code: "BF.13.52", name: "Province du Ioba" },
    { code: "BF.13.67", name: "Province du Noumbièl" },
    { code: "BF.13.69", name: "Province du Poni" },
  ],
  "BG.38": [
    { code: "BG.38.BLG01", name: "Obshtina Bansko" },
    { code: "BG.38.BLG02", name: "Obshtina Belitsa" },
    { code: "BG.38.BLG03", name: "Obshtina Blagoevgrad" },
    { code: "BG.38.BLG11", name: "Obshtina Gotse Delchev" },
    { code: "BG.38.BLG13", name: "Obshtina Garmen" },
    { code: "BG.38.BLG28", name: "Obshtina Kresna" },
    { code: "BG.38.BLG33", name: "Obshtina Petrich" },
    { code: "BG.38.BLG37", name: "Obshtina Razlog" },
    { code: "BG.38.BLG40", name: "Obshtina Sandanski" },
    { code: "BG.38.BLG42", name: "Obshtina Satovcha" },
    { code: "BG.38.BLG44", name: "Obshtina Simitli" },
    { code: "BG.38.BLG49", name: "Obshtina Strumyani" },
    { code: "BG.38.BLG52", name: "Hadzhidimovo" },
    { code: "BG.38.BLG53", name: "Obshtina Yakoruda" },
  ],
  "BG.39": [
    { code: "BG.39.BGS01", name: "Obshtina Aytos" },
    { code: "BG.39.BGS04", name: "Obshtina Burgas" },
    { code: "BG.39.BGS06", name: "Obshtina Sredets" },
    { code: "BG.39.BGS08", name: "Obshtina Kameno" },
    { code: "BG.39.BGS09", name: "Obshtina Karnobat" },
    { code: "BG.39.BGS12", name: "Obshtina Malko Tarnovo" },
    { code: "BG.39.BGS13", name: "Obshtina Tsarevo" },
    { code: "BG.39.BGS15", name: "Obshtina Nesebar" },
    { code: "BG.39.BGS17", name: "Obshtina Pomorie" },
    { code: "BG.39.BGS18", name: "Obshtina Ruen" },
    { code: "BG.39.BGS21", name: "Obshtina Sozopol" },
    { code: "BG.39.BGS23", name: "Obshtina Sungurlare" },
    { code: "BG.39.BGS27", name: "Obshtina Primorsko" },
  ],
  "BG.40": [
    { code: "BG.40.DOB03", name: "Obshtina Balchik" },
    { code: "BG.40.DOB12", name: "Obshtina General Toshevo" },
    { code: "BG.40.DOB15", name: "Obshtina Dobrich-Selska" },
    { code: "BG.40.DOB17", name: "Obshtina Kavarna" },
    { code: "BG.40.DOB20", name: "Obshtina Krushari" },
    { code: "BG.40.DOB27", name: "Obshtina Tervel" },
    { code: "BG.40.DOB28", name: "Obshtina Dobrich" },
    { code: "BG.40.DOB29", name: "Obshtina Shabla" },
  ],
  "BG.41": [
    { code: "BG.41.GAB05", name: "Obshtina Gabrovo" },
    { code: "BG.41.GAB12", name: "Obshtina Dryanovo" },
    { code: "BG.41.GAB29", name: "Obshtina Sevlievo" },
    { code: "BG.41.GAB35", name: "Obshtina Tryavna" },
  ],
  "BG.42": [
    { code: "BG.42.SOF46", name: "Stolichna Obshtina" },
  ],
  "BG.43": [
    { code: "BG.43.HKV09", name: "Obshtina Dimitrovgrad" },
    { code: "BG.43.HKV11", name: "Obshtina Ivaylovgrad" },
    { code: "BG.43.HKV17", name: "Obshtina Lyubimets" },
    { code: "BG.43.HKV18", name: "Obshtina Madzharovo" },
    { code: "BG.43.HKV19", name: "Obshtina Mineralni Bani" },
    { code: "BG.43.HKV28", name: "Obshtina Svilengrad" },
    { code: "BG.43.HKV29", name: "Obshtina Simeonovgrad" },
    { code: "BG.43.HKV30", name: "Obshtina Stambolovo" },
    { code: "BG.43.HKV32", name: "Obshtina Topolovgrad" },
    { code: "BG.43.HKV33", name: "Obshtina Harmanli" },
    { code: "BG.43.HKV34", name: "Obshtina Haskovo" },
  ],
  "BG.44": [
    { code: "BG.44.KRZ02", name: "Obshtina Ardino" },
    { code: "BG.44.KRZ08", name: "Obshtina Dzhebel" },
    { code: "BG.44.KRZ14", name: "Obshtina Kirkovo" },
    { code: "BG.44.KRZ15", name: "Obshtina Krumovgrad" },
    { code: "BG.44.KRZ16", name: "Obshtina Kardzhali" },
    { code: "BG.44.KRZ21", name: "Obshtina Momchilgrad" },
    { code: "BG.44.KRZ35", name: "Obshtina Chernoochene" },
  ],
  "BG.45": [
    { code: "BG.45.KNL04", name: "Obshtina Bobov Dol" },
    { code: "BG.45.KNL05", name: "Obshtina Boboshevo" },
    { code: "BG.45.KNL27", name: "Obshtina Kocherinovo" },
    { code: "BG.45.KNL29", name: "Obshtina Kyustendil" },
    { code: "BG.45.KNL31", name: "Obshtina Nevestino" },
    { code: "BG.45.KNL38", name: "Obshtina Rila" },
    { code: "BG.45.KNL41", name: "Obshtina Sapareva Banya" },
    { code: "BG.45.KNL48", name: "Obshtina Dupnitsa" },
    { code: "BG.45.KNL50", name: "Obshtina Treklyano" },
  ],
  "BG.46": [
    { code: "BG.46.LOV02", name: "Obshtina Apriltsi" },
    { code: "BG.46.LOV17", name: "Obshtina Letnitsa" },
    { code: "BG.46.LOV18", name: "Obshtina Lovech" },
    { code: "BG.46.LOV19", name: "Obshtina Lukovit" },
    { code: "BG.46.LOV33", name: "Obshtina Teteven" },
    { code: "BG.46.LOV34", name: "Obshtina Troyan" },
    { code: "BG.46.LOV36", name: "Obshtina Ugarchin" },
    { code: "BG.46.LOV38", name: "Obshtina Yablanitsa" },
  ],
  "BG.47": [
    { code: "BG.47.MON02", name: "Obshtina Berkovitsa" },
    { code: "BG.47.MON04", name: "Obshtina Boychinovtsi" },
    { code: "BG.47.MON07", name: "Obshtina Brusartsi" },
    { code: "BG.47.MON11", name: "Obshtina Valchedram" },
    { code: "BG.47.MON12", name: "Obshtina Varshets" },
    { code: "BG.47.MON14", name: "Obshtina Georgi Damyanovo" },
    { code: "BG.47.MON24", name: "Obshtina Lom" },
    { code: "BG.47.MON26", name: "Obshtina Medkovets" },
    { code: "BG.47.MON29", name: "Obshtina Montana" },
    { code: "BG.47.MON36", name: "Obshtina Chiprovtsi" },
    { code: "BG.47.MON38", name: "Obshtina Yakimovo" },
  ],
  "BG.48": [
    { code: "BG.48.PAZ03", name: "Obshtina Batak" },
    { code: "BG.48.PAZ04", name: "Obshtina Belovo" },
    { code: "BG.48.PAZ06", name: "Obshtina Bratsigovo" },
    { code: "BG.48.PAZ08", name: "Obshtina Velingrad" },
    { code: "BG.48.PAZ14", name: "Obshtina Lesichovo" },
    { code: "BG.48.PAZ19", name: "Obshtina Pazardzhik" },
    { code: "BG.48.PAZ20", name: "Obshtina Panagyurishte" },
    { code: "BG.48.PAZ21", name: "Obshtina Peshtera" },
    { code: "BG.48.PAZ24", name: "Obshtina Rakitovo" },
    { code: "BG.48.PAZ29", name: "Obshtina Septemvri" },
    { code: "BG.48.PAZ32", name: "Obshtina Strelcha" },
    { code: "BG.48.PAZ39", name: "Sarnitsa Obshtina" },
  ],
  "BG.49": [
    { code: "BG.49.PER08", name: "Obshtina Breznik" },
    { code: "BG.49.PER19", name: "Obshtina Zemen" },
    { code: "BG.49.PER22", name: "Obshtina Kovachevtsi" },
    { code: "BG.49.PER32", name: "Obshtina Pernik" },
    { code: "BG.49.PER36", name: "Obshtina Radomir" },
    { code: "BG.49.PER51", name: "Tran" },
  ],
  "BG.50": [
    { code: "BG.50.PVN03", name: "Obshtina Belene" },
    { code: "BG.50.PVN08", name: "Obshtina Gulyantsi" },
    { code: "BG.50.PVN10", name: "Obshtina Dolna Mitropolia" },
    { code: "BG.50.PVN11", name: "Obshtina Dolni Dabnik" },
    { code: "BG.50.PVN16", name: "Obshtina Levski" },
    { code: "BG.50.PVN21", name: "Obshtina Nikopol" },
    { code: "BG.50.PVN23", name: "Obshtina Iskar" },
    { code: "BG.50.PVN24", name: "Obshtina Pleven" },
    { code: "BG.50.PVN27", name: "Obshtina Pordim" },
    { code: "BG.50.PVN37", name: "Obshtina Cherven Bryag" },
    { code: "BG.50.PVN39", name: "Obshtina Knezha" },
  ],
  "BG.51": [
    { code: "BG.51.PDV01", name: "Obshtina Asenovgrad" },
    { code: "BG.51.PDV07", name: "Obshtina Brezovo" },
    { code: "BG.51.PDV12", name: "Obshtina Kaloyanovo" },
    { code: "BG.51.PDV13", name: "Obshtina Karlovo" },
    { code: "BG.51.PDV15", name: "Obshtina Laki" },
    { code: "BG.51.PDV17", name: "Obshtina Maritsa" },
    { code: "BG.51.PDV22", name: "Obshtina Plovdiv" },
    { code: "BG.51.PDV23", name: "Obshtina Parvomay" },
    { code: "BG.51.PDV25", name: "Obshtina Rakovski" },
    { code: "BG.51.PDV26", name: "Obshtina Rodopi" },
    { code: "BG.51.PDV28", name: "Obshtina Sadovo" },
    { code: "BG.51.PDV33", name: "Obshtina Saedinenie" },
    { code: "BG.51.PDV37", name: "Obshtina Hisarya" },
    { code: "BG.51.PDV39", name: "Obshtina Krichim" },
    { code: "BG.51.PDV40", name: "Obshtina Perushtitsa" },
    { code: "BG.51.PDV41", name: "Obshtina Stamboliyski" },
    { code: "BG.51.PDV42", name: "Obshtina Kuklen" },
    { code: "BG.51.PDV43", name: "Obshtina Sopot" },
  ],
  "BG.52": [
    { code: "BG.52.RAZ11", name: "Obshtina Zavet" },
    { code: "BG.52.RAZ14", name: "Obshtina Isperih" },
    { code: "BG.52.RAZ16", name: "Obshtina Kubrat" },
    { code: "BG.52.RAZ17", name: "Obshtina Loznitsa" },
    { code: "BG.52.RAZ26", name: "Obshtina Razgrad" },
    { code: "BG.52.RAZ29", name: "Obshtina Samuil" },
    { code: "BG.52.RAZ36", name: "Obshtina Tsar Kaloyan" },
  ],
  "BG.53": [
    { code: "BG.53.RSE03", name: "Obshtina Borovo" },
    { code: "BG.53.RSE04", name: "Obshtina Byala" },
    { code: "BG.53.RSE05", name: "Obshtina Vetovo" },
    { code: "BG.53.RSE08", name: "Obshtina Dve Mogili" },
    { code: "BG.53.RSE13", name: "Obshtina Ivanovo" },
    { code: "BG.53.RSE27", name: "Obshtina Ruse" },
    { code: "BG.53.RSE33", name: "Obshtina Slivo Pole" },
    { code: "BG.53.RSE37", name: "Obshtina Tsenovo" },
  ],
  "BG.54": [
    { code: "BG.54.SHU07", name: "Obshtina Venets" },
    { code: "BG.54.SHU10", name: "Obshtina Varbitsa" },
    { code: "BG.54.SHU11", name: "Obshtina Hitrino" },
    { code: "BG.54.SHU18", name: "Obshtina Kaolinovo" },
    { code: "BG.54.SHU19", name: "Obshtina Kaspichan" },
    { code: "BG.54.SHU21", name: "Obshtina Nikola-Kozlevo" },
    { code: "BG.54.SHU22", name: "Obshtina Novi Pazar" },
    { code: "BG.54.SHU23", name: "Obshtina Veliki Preslav" },
    { code: "BG.54.SHU25", name: "Obshtina Smyadovo" },
    { code: "BG.54.SHU30", name: "Obshtina Shumen" },
  ],
  "BG.55": [
    { code: "BG.55.SLS01", name: "Obshtina Alfatar" },
    { code: "BG.55.SLS07", name: "Obshtina Glavinitsa" },
    { code: "BG.55.SLS10", name: "Obshtina Dulovo" },
    { code: "BG.55.SLS15", name: "Obshtina Kaynardzha" },
    { code: "BG.55.SLS31", name: "Obshtina Silistra" },
    { code: "BG.55.SLS32", name: "Obshtina Sitovo" },
    { code: "BG.55.SLS34", name: "Obshtina Tutrakan" },
  ],
  "BG.56": [
    { code: "BG.56.SLV11", name: "Obshtina Kotel" },
    { code: "BG.56.SLV16", name: "Obshtina Nova Zagora" },
    { code: "BG.56.SLV20", name: "Obshtina Sliven" },
    { code: "BG.56.SLV24", name: "Obshtina Tvarditsa" },
  ],
  "BG.57": [
    { code: "BG.57.SML02", name: "Obshtina Banite" },
    { code: "BG.57.SML05", name: "Obshtina Borino" },
    { code: "BG.57.SML09", name: "Obshtina Devin" },
    { code: "BG.57.SML10", name: "Obshtina Dospat" },
    { code: "BG.57.SML11", name: "Obshtina Zlatograd" },
    { code: "BG.57.SML16", name: "Obshtina Madan" },
    { code: "BG.57.SML18", name: "Obshtina Nedelino" },
    { code: "BG.57.SML27", name: "Obshtina Rudozem" },
    { code: "BG.57.SML31", name: "Obshtina Smolyan" },
    { code: "BG.57.SML38", name: "Obshtina Chepelare" },
  ],
  "BG.58": [
    { code: "BG.58.SFO06", name: "Obshtina Bozhurishte" },
    { code: "BG.58.SFO07", name: "Obshtina Botevgrad" },
    { code: "BG.58.SFO09", name: "Obshtina Godech" },
    { code: "BG.58.SFO10", name: "Obshtina Gorna Malina" },
    { code: "BG.58.SFO16", name: "Obshtina Dragoman" },
    { code: "BG.58.SFO17", name: "Obshtina Elin Pelin" },
    { code: "BG.58.SFO18", name: "Obshtina Etropole" },
    { code: "BG.58.SFO20", name: "Ihtiman" },
    { code: "BG.58.SFO24", name: "Obshtina Koprivshtitsa" },
    { code: "BG.58.SFO25", name: "Obshtina Kostenets" },
    { code: "BG.58.SFO26", name: "Obshtina Kostinbrod" },
    { code: "BG.58.SFO34", name: "Obshtina Pravets" },
    { code: "BG.58.SFO39", name: "Obshtina Samokov" },
    { code: "BG.58.SFO43", name: "Obshtina Svoge" },
    { code: "BG.58.SFO45", name: "Obshtina Slivnitsa" },
    { code: "BG.58.SFO47", name: "Obshtina Zlatitsa" },
    { code: "BG.58.SFO54", name: "Obshtina Anton" },
    { code: "BG.58.SFO55", name: "Obshtina Pirdop" },
    { code: "BG.58.SFO56", name: "Obshtina Mirkovo" },
    { code: "BG.58.SFO57", name: "Obshtina Chavdar" },
    { code: "BG.58.SFO58", name: "Obshtina Chelopech" },
    { code: "BG.58.SFO59", name: "Obshtina Dolna Banya" },
  ],
  "BG.59": [
    { code: "BG.59.SZR04", name: "Obshtina Bratya Daskalovi" },
    { code: "BG.59.SZR07", name: "Obshtina Galabovo" },
    { code: "BG.59.SZR12", name: "Obshtina Kazanlŭk" },
    { code: "BG.59.SZR22", name: "Obshtina Maglizh" },
    { code: "BG.59.SZR23", name: "Obshtina Opan" },
    { code: "BG.59.SZR24", name: "Obshtina Pavel Banya" },
    { code: "BG.59.SZR27", name: "Obshtina Radnevo" },
    { code: "BG.59.SZR31", name: "Obshtina Stara Zagora" },
    { code: "BG.59.SZR36", name: "Obshtina Chirpan" },
    { code: "BG.59.SZR37", name: "Obshtina Gurkovo" },
    { code: "BG.59.SZR38", name: "Obshtina Nikolaevo" },
  ],
  "BG.60": [
    { code: "BG.60.TGV02", name: "Obshtina Antonovo" },
    { code: "BG.60.TGV22", name: "Obshtina Omurtag" },
    { code: "BG.60.TGV23", name: "Obshtina Opaka" },
    { code: "BG.60.TGV24", name: "Obshtina Popovo" },
    { code: "BG.60.TGV35", name: "Obshtina Targovishte" },
  ],
  "BG.61": [
    { code: "BG.61.VAR01", name: "Obshtina Avren" },
    { code: "BG.61.VAR02", name: "Obshtina Aksakovo" },
    { code: "BG.61.VAR04", name: "Obshtina Beloslav" },
    { code: "BG.61.VAR05", name: "Obshtina Byala" },
    { code: "BG.61.VAR06", name: "Obshtina Varna" },
    { code: "BG.61.VAR08", name: "Obshtina Vetrino" },
    { code: "BG.61.VAR09", name: "Obshtina Valchidol" },
    { code: "BG.61.VAR13", name: "Obshtina Dolni Chiflik" },
    { code: "BG.61.VAR14", name: "Obshtina Devnya" },
    { code: "BG.61.VAR16", name: "Obshtina Dalgopol" },
    { code: "BG.61.VAR24", name: "Obshtina Provadia" },
    { code: "BG.61.VAR26", name: "Obshtina Suvorovo" },
  ],
  "BG.62": [
    { code: "BG.62.VTR04", name: "Obshtina Veliko Tŭrnovo" },
    { code: "BG.62.VTR06", name: "Obshtina Gorna Oryahovitsa" },
    { code: "BG.62.VTR13", name: "Obshtina Elena" },
    { code: "BG.62.VTR14", name: "Obshtina Zlataritsa" },
    { code: "BG.62.VTR20", name: "Obshtina Lyaskovets" },
    { code: "BG.62.VTR22", name: "Obshtina Pavlikeni" },
    { code: "BG.62.VTR26", name: "Obshtina Polski Trambesh" },
    { code: "BG.62.VTR28", name: "Obshtina Svishtov" },
    { code: "BG.62.VTR31", name: "Obshtina Strazhitsa" },
    { code: "BG.62.VTR32", name: "Obshtina Suhindol" },
  ],
  "BG.63": [
    { code: "BG.63.VID01", name: "Obshtina Belogradchik" },
    { code: "BG.63.VID03", name: "Obshtina Boynitsa" },
    { code: "BG.63.VID06", name: "Obshtina Bregovo" },
    { code: "BG.63.VID09", name: "Obshtina Vidin" },
    { code: "BG.63.VID15", name: "Obshtina Gramada" },
    { code: "BG.63.VID16", name: "Obshtina Dimovo" },
    { code: "BG.63.VID22", name: "Obshtina Kula" },
    { code: "BG.63.VID25", name: "Obshtina Makresh" },
    { code: "BG.63.VID30", name: "Obshtina Novo Selo" },
    { code: "BG.63.VID33", name: "Obshtina Ruzhintsi" },
    { code: "BG.63.VID37", name: "Obshtina Chuprene" },
  ],
  "BG.64": [
    { code: "BG.64.VRC05", name: "Obshtina Borovan" },
    { code: "BG.64.VRC08", name: "Obshtina Byala Slatina" },
    { code: "BG.64.VRC10", name: "Obshtina Vratsa" },
    { code: "BG.64.VRC20", name: "Obshtina Kozloduy" },
    { code: "BG.64.VRC21", name: "Obshtina Krivodol" },
    { code: "BG.64.VRC27", name: "Obshtina Mezdra" },
    { code: "BG.64.VRC28", name: "Obshtina Mizia" },
    { code: "BG.64.VRC31", name: "Obshtina Oryahovo" },
    { code: "BG.64.VRC32", name: "Obshtina Roman" },
    { code: "BG.64.VRC35", name: "Obshtina Hayredin" },
  ],
  "BG.65": [
    { code: "BG.65.JAM03", name: "Obshtina Bolyarovo" },
    { code: "BG.65.JAM07", name: "Obshtina Elhovo" },
    { code: "BG.65.JAM22", name: "Obshtina Straldzha" },
    { code: "BG.65.JAM25", name: "Obshtina Tundzha" },
    { code: "BG.65.JAM26", name: "Obshtina Yambol" },
  ],
  "BI.09": [
    { code: "BI.09.7670587", name: "Bubanza" },
    { code: "BI.09.8303259", name: "Commune of Gihanga" },
    { code: "BI.09.9072887", name: "Commune of Mpanda" },
    { code: "BI.09.9072888", name: "Commune of Musigati" },
    { code: "BI.09.9171822", name: "Rugazi" },
  ],
  "BI.10": [
    { code: "BI.10.7670605", name: "Mugamba" },
    { code: "BI.10.9157454", name: "Commune of Matana" },
    { code: "BI.10.9171804", name: "Bururi" },
    { code: "BI.10.9171811", name: "Vyanda" },
    { code: "BI.10.9171812", name: "Songa" },
    { code: "BI.10.9171840", name: "Rutovu" },
  ],
  "BI.11": [
    { code: "BI.11.7670593", name: "Cendajuru" },
    { code: "BI.11.9072894", name: "Commune of Cankuzo" },
    { code: "BI.11.9171816", name: "Mishiha" },
    { code: "BI.11.9171834", name: "Kigamba" },
    { code: "BI.11.9171837", name: "Gisagara" },
  ],
  "BI.12": [
    { code: "BI.12.7670588", name: "Bukinanvana" },
    { code: "BI.12.7670604", name: "Mabayi" },
    { code: "BI.12.7670607", name: "Murwi" },
    { code: "BI.12.7670613", name: "Commune of Rugombo" },
    { code: "BI.12.8334579", name: "Commune of Buganda" },
    { code: "BI.12.9072889", name: "Commune of Mugina" },
  ],
  "BI.13": [
    { code: "BI.13.424739", name: "Makebuko" },
    { code: "BI.13.7670589", name: "Buraza" },
    { code: "BI.13.7670597", name: "Gitega" },
    { code: "BI.13.7670823", name: "Mutaho" },
    { code: "BI.13.7670931", name: "Giheta" },
    { code: "BI.13.7670933", name: "Bugendana" },
    { code: "BI.13.7874080", name: "Ryansoro" },
    { code: "BI.13.8692994", name: "Commune of Itaba" },
    { code: "BI.13.9171842", name: "Nyanrusange" },
    { code: "BI.13.9171843", name: "Gishubi" },
    { code: "BI.13.9171845", name: "Bukirasazi" },
  ],
  "BI.14": [
    { code: "BI.14.7670611", name: "Nyabikere" },
    { code: "BI.14.9171852", name: "Shombo" },
    { code: "BI.14.9171861", name: "Gitaramuka" },
    { code: "BI.14.9171866", name: "Bugenyuzi" },
    { code: "BI.14.9171872", name: "Gihogazi" },
    { code: "BI.14.9171878", name: "Mutumba" },
    { code: "BI.14.9171879", name: "Buhiga" },
  ],
  "BI.15": [
    { code: "BI.15.7670599", name: "Kabarore" },
    { code: "BI.15.7670600", name: "Kayanza" },
    { code: "BI.15.7732510", name: "Muruta" },
    { code: "BI.15.8692984", name: "Butaganzwa" },
    { code: "BI.15.9072885", name: "Commune of Matongo" },
    { code: "BI.15.9171817", name: "Rango" },
    { code: "BI.15.9171830", name: "Gatara" },
    { code: "BI.15.9171831", name: "Gahombo" },
    { code: "BI.15.9171868", name: "Muhanga" },
  ],
  "BI.16": [
    { code: "BI.16.7670591", name: "Busoni" },
    { code: "BI.16.7670618", name: "Vumbi" },
    { code: "BI.16.9072886", name: "Commune of Kirundo" },
    { code: "BI.16.9072890", name: "Commune of Bwambarangwe" },
    { code: "BI.16.9171827", name: "Bugabira" },
    { code: "BI.16.9171870", name: "Ntega" },
    { code: "BI.16.9171886", name: "Gitobe" },
  ],
  "BI.17": [
    { code: "BI.17.7670603", name: "Mabanda" },
    { code: "BI.17.9072891", name: "Commune of Makamba" },
    { code: "BI.17.9171810", name: "Vugizo" },
    { code: "BI.17.9171820", name: "Kayogoro" },
    { code: "BI.17.9171823", name: "Kibago" },
    { code: "BI.17.9171854", name: "Nyanza-Lac" },
  ],
  "BI.18": [
    { code: "BI.18.7670595", name: "Gashoho" },
    { code: "BI.18.7670598", name: "Giteranyi" },
    { code: "BI.18.7670609", name: "Muyinga" },
    { code: "BI.18.9171829", name: "Butihinda" },
    { code: "BI.18.9171832", name: "Buhinyuza" },
    { code: "BI.18.9171882", name: "Mwakiro" },
    { code: "BI.18.9171884", name: "Gasorwe" },
  ],
  "BI.19": [
    { code: "BI.19.7670590", name: "Busiga" },
    { code: "BI.19.7670594", name: "Gashikanwa" },
    { code: "BI.19.7670614", name: "Ruhororo" },
    { code: "BI.19.7670617", name: "Tangara" },
    { code: "BI.19.7670822", name: "Ngozi" },
    { code: "BI.19.9171858", name: "Mwumba" },
    { code: "BI.19.9171863", name: "Nyamurenza" },
    { code: "BI.19.9171867", name: "Marangara" },
    { code: "BI.19.9171874", name: "Kiremba" },
  ],
  "BI.20": [
    { code: "BI.20.9072892", name: "Commune of Rutana" },
    { code: "BI.20.9171819", name: "Bukemba" },
    { code: "BI.20.9171833", name: "Musongati" },
    { code: "BI.20.9171836", name: "Gitanga" },
    { code: "BI.20.9171847", name: "Mpinga-Kayove" },
    { code: "BI.20.9171849", name: "Giharo" },
  ],
  "BI.21": [
    { code: "BI.21.11819937", name: "Butaganzwa" },
    { code: "BI.21.7670616", name: "Ruyigi" },
    { code: "BI.21.9171841", name: "Gisuru" },
    { code: "BI.21.9171844", name: "Kinyinya" },
    { code: "BI.21.9171851", name: "Nyabitsinda" },
    { code: "BI.21.9171856", name: "Butezi" },
    { code: "BI.21.9171859", name: "Bweru" },
  ],
  "BI.22": [
    { code: "BI.22.7670602", name: "Kiganda" },
    { code: "BI.22.7670615", name: "Rutegama" },
    { code: "BI.22.9171818", name: "Bukeye" },
    { code: "BI.22.9171826", name: "Mbuye" },
    { code: "BI.22.9179822", name: "Muramvya" },
  ],
  "BI.23": [
    { code: "BI.23.7670596", name: "Gisozi" },
    { code: "BI.23.7670601", name: "Kayokwe" },
    { code: "BI.23.7670610", name: "Nyabihanga" },
    { code: "BI.23.9171802", name: "Ndava" },
    { code: "BI.23.9171813", name: "Rusaka" },
    { code: "BI.23.9171814", name: "Bisoro" },
  ],
  "BI.24": [
    { code: "BI.24.11819935", name: "Cibitoke" },
    { code: "BI.24.7670612", name: "Commune of Rohero" },
    { code: "BI.24.7670922", name: "Buterere" },
    { code: "BI.24.7670925", name: "Kamenge" },
    { code: "BI.24.7670926", name: "Kinama" },
    { code: "BI.24.7670927", name: "Gihosha" },
    { code: "BI.24.7670928", name: "Musaga" },
    { code: "BI.24.8335224", name: "Ngagara" },
    { code: "BI.24.8335225", name: "Commune of Buyenzi" },
    { code: "BI.24.9171881", name: "Nyakabiga" },
    { code: "BI.24.9171883", name: "Bwiza" },
    { code: "BI.24.9171888", name: "Kanyosha" },
    { code: "BI.24.9171890", name: "Kinindo" },
  ],
  "BI.25": [
    { code: "BI.25.7670608", name: "Commune of Mutimbuzi" },
    { code: "BI.25.9171805", name: "Kanyosha1" },
    { code: "BI.25.9171806", name: "Kabezi" },
    { code: "BI.25.9171807", name: "Mukike" },
    { code: "BI.25.9171808", name: "Mutambu" },
    { code: "BI.25.9171809", name: "Nyabiraba" },
    { code: "BI.25.9171815", name: "Mugongomanga" },
    { code: "BI.25.9171821", name: "Isale" },
    { code: "BI.25.9171825", name: "Mubimbi" },
  ],
  "BI.26": [
    { code: "BI.26.7670592", name: "Buyengero" },
    { code: "BI.26.7670606", name: "Muhuta" },
    { code: "BI.26.9158023", name: "Commune of Rumonge" },
    { code: "BI.26.9171803", name: "Bugarama" },
    { code: "BI.26.9881326", name: "Commune of Burambi" },
  ],
  "BJ.07": [
    { code: "BJ.07.10344468", name: "Ségbana" },
    { code: "BJ.07.10344469", name: "Gogounou" },
    { code: "BJ.07.7668935", name: "Commune of Banikoara" },
    { code: "BJ.07.7874155", name: "Karimama" },
    { code: "BJ.07.7874170", name: "Malanville" },
    { code: "BJ.07.7911056", name: "Kandi" },
  ],
  "BJ.08": [
    { code: "BJ.08.10344466", name: "Cobly" },
    { code: "BJ.08.10344467", name: "Boukoumbé" },
    { code: "BJ.08.7668910", name: "Kouande" },
    { code: "BJ.08.7668916", name: "Pehonko" },
    { code: "BJ.08.7668918", name: "Kerou" },
    { code: "BJ.08.7669273", name: "Natitingou" },
    { code: "BJ.08.7874156", name: "Tanguieta" },
    { code: "BJ.08.7874157", name: "Toukountouna" },
    { code: "BJ.08.7874158", name: "Materi" },
  ],
  "BJ.09": [
    { code: "BJ.09.7668936", name: "Commune of Ouidah" },
    { code: "BJ.09.7668937", name: "Commune of Kpomasse" },
    { code: "BJ.09.7668938", name: "Commune of Tori-Bossito" },
    { code: "BJ.09.7874152", name: "Commune of Abomey-Calavi" },
    { code: "BJ.09.7874154", name: "Commune of So-Ava" },
    { code: "BJ.09.8260655", name: "Commune of Allada" },
    { code: "BJ.09.8260656", name: "Commune of Toffo" },
    { code: "BJ.09.8260657", name: "Commune of Ze" },
  ],
  "BJ.10": [
    { code: "BJ.10.7669265", name: "Commune of Tchaourou" },
    { code: "BJ.10.7669268", name: "Commune of Parakou" },
    { code: "BJ.10.7669269", name: "Ndali" },
    { code: "BJ.10.7669270", name: "Bembereke" },
    { code: "BJ.10.7669349", name: "Kalalè" },
    { code: "BJ.10.7669352", name: "Pèrèrè" },
    { code: "BJ.10.7669355", name: "Nikki" },
    { code: "BJ.10.7669357", name: "Sinendé" },
  ],
  "BJ.11": [
    { code: "BJ.11.7874167", name: "Commune of Glazoue" },
    { code: "BJ.11.8260647", name: "Commune of Bante" },
    { code: "BJ.11.8260648", name: "Commune of Dassa-Zoume" },
    { code: "BJ.11.8260649", name: "Commune of Ouesse" },
    { code: "BJ.11.8260650", name: "Commune of Savalou" },
    { code: "BJ.11.8260651", name: "Commune of Save" },
  ],
  "BJ.12": [
    { code: "BJ.12.10344472", name: "Aplahoué" },
    { code: "BJ.12.10344473", name: "Djakotomey" },
    { code: "BJ.12.10344474", name: "Klouékanmè" },
    { code: "BJ.12.10344475", name: "Lalo" },
    { code: "BJ.12.10344476", name: "Toviklin" },
    { code: "BJ.12.2391090", name: "Dogbo Tota" },
  ],
  "BJ.13": [
    { code: "BJ.13.10344470", name: "Bassila" },
    { code: "BJ.13.7669263", name: "Ouake" },
    { code: "BJ.13.7669275", name: "Copargo" },
    { code: "BJ.13.8260658", name: "Commune of Djougou" },
  ],
  "BJ.14": [
    { code: "BJ.14.7874113", name: "Cotonou" },
  ],
  "BJ.15": [
    { code: "BJ.15.7668924", name: "Lokossa" },
    { code: "BJ.15.7668926", name: "Commune of Athieme" },
    { code: "BJ.15.8335018", name: "Commune of Houeyogbe" },
    { code: "BJ.15.8335019", name: "Commune of Bopa" },
    { code: "BJ.15.9166075", name: "Grand-Popo" },
    { code: "BJ.15.9166076", name: "Comé" },
  ],
  "BJ.16": [
    { code: "BJ.16.7668892", name: "Commune of Adjohoun" },
    { code: "BJ.16.7668898", name: "Bonou" },
    { code: "BJ.16.7668900", name: "Dangbo" },
    { code: "BJ.16.7668939", name: "Porto-Novo" },
    { code: "BJ.16.7668940", name: "Aguégués" },
    { code: "BJ.16.7668941", name: "Seme-Kpodji" },
    { code: "BJ.16.8693304", name: "Adjara" },
    { code: "BJ.16.9063965", name: "Akpro-Misserete" },
    { code: "BJ.16.9063966", name: "Avrankou" },
  ],
  "BJ.17": [
    { code: "BJ.17.7670840", name: "Commune of Ketou" },
    { code: "BJ.17.7670841", name: "Commune of Pobe" },
    { code: "BJ.17.8334580", name: "Commune of Sakete" },
    { code: "BJ.17.8335162", name: "Adjaouere" },
    { code: "BJ.17.9063970", name: "Ifangni" },
  ],
  "BJ.18": [
    { code: "BJ.18.7668907", name: "Commune of Cove" },
    { code: "BJ.18.7668908", name: "Commune of Ouinhi" },
    { code: "BJ.18.7668909", name: "Commune of Zangnanado" },
    { code: "BJ.18.7668931", name: "Commune of Bohicon" },
    { code: "BJ.18.7668932", name: "Commune of Za-Kpota" },
    { code: "BJ.18.7668934", name: "Commune of Zogbodome" },
    { code: "BJ.18.8260652", name: "Commune of Abomey" },
    { code: "BJ.18.8260653", name: "Commune of Agbangnizoun" },
    { code: "BJ.18.8260654", name: "Commune of Djidja" },
  ],
  "BN.02": [
    { code: "BN.02.11821300", name: "Gadong A" },
    { code: "BN.02.11821301", name: "Gadong B" },
    { code: "BN.02.11821302", name: "Berakas A" },
    { code: "BN.02.11821303", name: "Berakas B" },
    { code: "BN.02.11821304", name: "Serasa" },
    { code: "BN.02.11821305", name: "Mentiri" },
    { code: "BN.02.11821306", name: "Kota Batu" },
    { code: "BN.02.11821307", name: "Lumapas" },
    { code: "BN.02.11821309", name: "Sengkurong" },
    { code: "BN.02.11821310", name: "Pengkalan Batu" },
    { code: "BN.02.11821313", name: "Kianggeh" },
    { code: "BN.02.11821315", name: "Tamoi" },
    { code: "BN.02.11821317", name: "Burong Pingai Ayer" },
    { code: "BN.02.11821318", name: "Peramu" },
    { code: "BN.02.11821319", name: "Saba" },
    { code: "BN.02.11821320", name: "Sungai Kedayan" },
    { code: "BN.02.11821322", name: "Sungai Kebun" },
  ],
  "BN.04": [
    { code: "BN.04.10630196", name: "Kiudang" },
  ],
  "BO.01": [
    { code: "BO.01.0101", name: "Provincia Oropeza" },
    { code: "BO.01.0102", name: "Provincia Azurduy" },
    { code: "BO.01.0103", name: "Provincia Zudáñez" },
    { code: "BO.01.0104", name: "Provincia Tomina" },
    { code: "BO.01.0105", name: "Provincia Hernando Siles" },
    { code: "BO.01.0106", name: "Provincia Yamparáez" },
    { code: "BO.01.0107", name: "Provincia Nor Cinti" },
    { code: "BO.01.0108", name: "Provincia Belisario Boeto" },
    { code: "BO.01.0109", name: "Provincia Sud Cinti" },
    { code: "BO.01.0110", name: "Provincia Luis Calvo" },
  ],
  "BO.02": [
    { code: "BO.02.0301", name: "Provincia Cercado" },
    { code: "BO.02.0302", name: "Provincia Campero" },
    { code: "BO.02.0303", name: "Provincia Ayopaya" },
    { code: "BO.02.0304", name: "Provincia Esteban Arce" },
    { code: "BO.02.0305", name: "Provincia Arani" },
    { code: "BO.02.0306", name: "Provincia Arque" },
    { code: "BO.02.0307", name: "Provincia Capinota" },
    { code: "BO.02.0308", name: "Provincia Germán Jordán" },
    { code: "BO.02.0309", name: "Provincia Quillacollo" },
    { code: "BO.02.0310", name: "Provincia Chaparé" },
    { code: "BO.02.0311", name: "Provincia Tapacarí" },
    { code: "BO.02.0312", name: "Provincia Carrasco" },
    { code: "BO.02.0313", name: "Provincia Mizque" },
    { code: "BO.02.0314", name: "Provincia Punata" },
    { code: "BO.02.7576102", name: "Bolivar" },
    { code: "BO.02.8335405", name: "Tiraque Province" },
  ],
  "BO.03": [
    { code: "BO.03.0801", name: "Provincia Cercado" },
    { code: "BO.03.0802", name: "Provincia Vaca Diez" },
    { code: "BO.03.0804", name: "Provincia Yacuma" },
    { code: "BO.03.0805", name: "Provincia Moxos" },
    { code: "BO.03.0806", name: "Provincia Marbán" },
    { code: "BO.03.0807", name: "Provincia Mamoré" },
    { code: "BO.03.0808", name: "Provincia Iténez" },
    { code: "BO.03.3915596", name: "Provincia General José Ballivián" },
  ],
  "BO.04": [
    { code: "BO.04.0201", name: "Provincia Murillo" },
    { code: "BO.04.0202", name: "Provincia Omasuyos" },
    { code: "BO.04.0203", name: "Provincia Pacajes" },
    { code: "BO.04.0204", name: "Provincia Camacho" },
    { code: "BO.04.0205", name: "Provincia Muñecas" },
    { code: "BO.04.0206", name: "Provincia Larecaja" },
    { code: "BO.04.0207", name: "Provincia Franz Tamayo" },
    { code: "BO.04.0208", name: "Provincia Ingavi" },
    { code: "BO.04.0209", name: "Provincia Loayza" },
    { code: "BO.04.0210", name: "Provincia Inquisivi" },
    { code: "BO.04.0211", name: "Provincia Sud Yungas" },
    { code: "BO.04.0212", name: "Provincia Los Andes" },
    { code: "BO.04.0213", name: "Provincia Aroma" },
    { code: "BO.04.0214", name: "Provincia Nor Yungas" },
    { code: "BO.04.0215", name: "Provincia Iturralde" },
    { code: "BO.04.0216", name: "Provincia Bautista Saavedra" },
    { code: "BO.04.0217", name: "Provincia Manco Kapac" },
    { code: "BO.04.0218", name: "Provincia Gualberto Villarroel" },
    { code: "BO.04.11184247", name: "Caranavi" },
    { code: "BO.04.11184248", name: "José Manuel Pando" },
  ],
  "BO.05": [
    { code: "BO.05.0401", name: "Provincia Cercado" },
    { code: "BO.05.0402", name: "Provincia Avaroa" },
    { code: "BO.05.0404", name: "Provincia Sajama" },
    { code: "BO.05.0405", name: "Sud Carangas Province" },
    { code: "BO.05.0406", name: "Provincia Poopó" },
    { code: "BO.05.0407", name: "Provincia Pantaleón Dalence" },
    { code: "BO.05.0408", name: "Provincia Ladislao Cabrera" },
    { code: "BO.05.0410", name: "Provincia Saucari" },
    { code: "BO.05.0411", name: "Provincia Tomás Barron" },
    { code: "BO.05.0413", name: "Provincia San Pedro de Totora" },
    { code: "BO.05.10400355", name: "Nor Carangas Province" },
    { code: "BO.05.10400859", name: "Sebastian Pagador Province" },
    { code: "BO.05.11184249", name: "Puerto de Mejillones" },
    { code: "BO.05.11184250", name: "Litoral de Atacama" },
    { code: "BO.05.3922026", name: "Provincia Carangas" },
    { code: "BO.05.3923586", name: "Provincia Sabaya" },
  ],
  "BO.06": [
    { code: "BO.06.0901", name: "Provincia Nicolás Suárez" },
    { code: "BO.06.0902", name: "Provincia Manuripi" },
    { code: "BO.06.0903", name: "Provincia Madre de Dios" },
    { code: "BO.06.0904", name: "Provincia Abuná" },
    { code: "BO.06.3915598", name: "Provincia General Federico Román" },
  ],
  "BO.07": [
    { code: "BO.07.0501", name: "Provincia Tomás Frías" },
    { code: "BO.07.0502", name: "Provincia Rafael Bustillo" },
    { code: "BO.07.0503", name: "Provincia Saavedra" },
    { code: "BO.07.0504", name: "Provincia Chayanta" },
    { code: "BO.07.0505", name: "Provincia Charcas" },
    { code: "BO.07.0506", name: "Provincia Nor Chichas" },
    { code: "BO.07.0507", name: "Provincia Alonzo de Ibáñez" },
    { code: "BO.07.0508", name: "Provincia Sud Chichas" },
    { code: "BO.07.0509", name: "Provincia Nor Lípez" },
    { code: "BO.07.0510", name: "Provincia Sud Lípez" },
    { code: "BO.07.0512", name: "Provincia Quijarro" },
    { code: "BO.07.0514", name: "Provincia Daniel Campos" },
    { code: "BO.07.0515", name: "Provincia Modesto Omiste" },
    { code: "BO.07.11184251", name: "Enrique Baldivieso" },
    { code: "BO.07.3911502", name: "Provincia Linares" },
    { code: "BO.07.3915603", name: "Provincia General Bilbao" },
  ],
  "BO.08": [
    { code: "BO.08.0701", name: "Provincia Andrés Ibáñez" },
    { code: "BO.08.0702", name: "Provincia Warnes" },
    { code: "BO.08.0703", name: "Provincia Velasco" },
    { code: "BO.08.0704", name: "Provincia Ichilo" },
    { code: "BO.08.0705", name: "Provincia Chiquitos" },
    { code: "BO.08.0706", name: "Provincia Sara" },
    { code: "BO.08.0707", name: "Provincia Cordillera" },
    { code: "BO.08.0708", name: "Provincia Vallegrande" },
    { code: "BO.08.0709", name: "Provincia Florida" },
    { code: "BO.08.0711", name: "Provincia Ñuflo de Chávez" },
    { code: "BO.08.0712", name: "Provincia Ángel Sandoval" },
    { code: "BO.08.0713", name: "Provincia Manuel María Caballero" },
    { code: "BO.08.11184252", name: "German Busch" },
    { code: "BO.08.11184253", name: "Guarayos" },
    { code: "BO.08.3904660", name: "Provincia Santiesteban" },
  ],
  "BO.09": [
    { code: "BO.09.0601", name: "Provincia Cercado" },
    { code: "BO.09.0602", name: "Provincia Arce" },
    { code: "BO.09.0603", name: "Provincia Gran Chaco" },
    { code: "BO.09.0604", name: "Provincia Avilez" },
    { code: "BO.09.0605", name: "Provincia Méndez" },
    { code: "BO.09.0606", name: "Provincia O’Connor" },
  ],
  "BR.01": [
    { code: "BR.01.1200013", name: "Acrelândia" },
    { code: "BR.01.1200054", name: "Assis Brasil" },
    { code: "BR.01.1200104", name: "Brasiléia" },
    { code: "BR.01.1200138", name: "Bujari" },
    { code: "BR.01.1200179", name: "Capixaba" },
    { code: "BR.01.1200203", name: "Cruzeiro do Sul" },
    { code: "BR.01.1200252", name: "Epitaciolândia" },
    { code: "BR.01.1200302", name: "Feijó" },
    { code: "BR.01.1200328", name: "Jordão" },
    { code: "BR.01.1200336", name: "Mâncio Lima" },
    { code: "BR.01.1200344", name: "Manoel Urbano" },
    { code: "BR.01.1200351", name: "Marechal Thaumaturgo" },
    { code: "BR.01.1200385", name: "Plácido de Castro" },
    { code: "BR.01.1200393", name: "Porto Walter" },
    { code: "BR.01.1200401", name: "Rio Branco" },
    { code: "BR.01.1200427", name: "Rodrigues Alves" },
    { code: "BR.01.1200435", name: "Santa Rosa do Purus" },
    { code: "BR.01.1200450", name: "Senador Guiomard" },
    { code: "BR.01.1200500", name: "Sena Madureira" },
    { code: "BR.01.1200609", name: "Tarauacá" },
    { code: "BR.01.1200708", name: "Xapuri" },
    { code: "BR.01.1200807", name: "Porto Acre" },
  ],
  "BR.02": [
    { code: "BR.02.2700102", name: "Água Branca" },
    { code: "BR.02.2700201", name: "Anadia" },
    { code: "BR.02.2700300", name: "Arapiraca" },
    { code: "BR.02.2700409", name: "Atalaia" },
    { code: "BR.02.2700508", name: "Barra de Santo Antônio" },
    { code: "BR.02.2700607", name: "Barra de São Miguel" },
    { code: "BR.02.2700706", name: "Batalha" },
    { code: "BR.02.2700805", name: "Belém" },
    { code: "BR.02.2700904", name: "Belo Monte" },
    { code: "BR.02.2701001", name: "Boca da Mata" },
    { code: "BR.02.2701100", name: "Branquinha" },
    { code: "BR.02.2701209", name: "Cacimbinhas" },
    { code: "BR.02.2701308", name: "Cajueiro" },
    { code: "BR.02.2701357", name: "Campestre" },
    { code: "BR.02.2701407", name: "Campo Alegre" },
    { code: "BR.02.2701506", name: "Campo Grande" },
    { code: "BR.02.2701605", name: "Canapi" },
    { code: "BR.02.2701704", name: "Capela" },
    { code: "BR.02.2701803", name: "Carneiros" },
    { code: "BR.02.2701902", name: "Chã Preta" },
    { code: "BR.02.2702009", name: "Coité do Nóia" },
    { code: "BR.02.2702108", name: "Colônia Leopoldina" },
    { code: "BR.02.2702207", name: "Coqueiro Seco" },
    { code: "BR.02.2702306", name: "Coruripe" },
    { code: "BR.02.2702355", name: "Craíbas" },
    { code: "BR.02.2702405", name: "Delmiro Gouveia" },
    { code: "BR.02.2702504", name: "Dois Riachos" },
    { code: "BR.02.2702553", name: "Estrela de Alagoas" },
    { code: "BR.02.2702603", name: "Feira Grande" },
    { code: "BR.02.2702702", name: "Feliz Deserto" },
    { code: "BR.02.2702801", name: "Flexeiras" },
    { code: "BR.02.2702900", name: "Girau do Ponciano" },
    { code: "BR.02.2703007", name: "Ibateguara" },
    { code: "BR.02.2703106", name: "Igaci" },
    { code: "BR.02.2703205", name: "Igreja Nova" },
    { code: "BR.02.2703304", name: "Inhapi" },
    { code: "BR.02.2703403", name: "Jacaré dos Homens" },
    { code: "BR.02.2703502", name: "Jacuípe" },
    { code: "BR.02.2703601", name: "Japaratinga" },
    { code: "BR.02.2703700", name: "Jaramataia" },
    { code: "BR.02.2703759", name: "Jequiá da Praia" },
    { code: "BR.02.2703809", name: "Joaquim Gomes" },
    { code: "BR.02.2703908", name: "Jundiá" },
    { code: "BR.02.2704005", name: "Junqueiro" },
    { code: "BR.02.2704104", name: "Lagoa da Canoa" },
    { code: "BR.02.2704203", name: "Limoeiro de Anadia" },
    { code: "BR.02.2704302", name: "Maceió" },
    { code: "BR.02.2704401", name: "Major Isidoro" },
    { code: "BR.02.2704500", name: "Maragogi" },
    { code: "BR.02.2704609", name: "Maravilha" },
    { code: "BR.02.2704708", name: "Marechal Deodoro" },
    { code: "BR.02.2704807", name: "Maribondo" },
    { code: "BR.02.2704906", name: "Mar Vermelho" },
    { code: "BR.02.2705002", name: "Mata Grande" },
    { code: "BR.02.2705101", name: "Matriz de Camaragibe" },
    { code: "BR.02.2705200", name: "Messias" },
    { code: "BR.02.2705309", name: "Minador do Negrão" },
    { code: "BR.02.2705408", name: "Monteirópolis" },
    { code: "BR.02.2705507", name: "Murici" },
    { code: "BR.02.2705606", name: "Novo Lino" },
    { code: "BR.02.2705705", name: "Olho d'Água das Flores" },
    { code: "BR.02.2705804", name: "Olho d'Água do Casado" },
    { code: "BR.02.2705903", name: "Olho d'Água Grande" },
    { code: "BR.02.2706000", name: "Olivença" },
    { code: "BR.02.2706109", name: "Ouro Branco" },
    { code: "BR.02.2706208", name: "Palestina" },
    { code: "BR.02.2706307", name: "Palmeira dos Índios" },
    { code: "BR.02.2706406", name: "Pão de Açúcar" },
    { code: "BR.02.2706422", name: "Pariconha" },
    { code: "BR.02.2706448", name: "Paripueira" },
    { code: "BR.02.2706505", name: "Passo de Camaragibe" },
    { code: "BR.02.2706604", name: "Paulo Jacinto" },
    { code: "BR.02.2706703", name: "Penedo" },
    { code: "BR.02.2706802", name: "Piaçabuçu" },
    { code: "BR.02.2706901", name: "Pilar" },
    { code: "BR.02.2707008", name: "Pindoba" },
    { code: "BR.02.2707107", name: "Piranhas" },
    { code: "BR.02.2707206", name: "Poço das Trincheiras" },
    { code: "BR.02.2707305", name: "Porto Calvo" },
    { code: "BR.02.2707404", name: "Porto de Pedras" },
    { code: "BR.02.2707503", name: "Porto Real do Colégio" },
    { code: "BR.02.2707602", name: "Quebrangulo" },
    { code: "BR.02.2707701", name: "Rio Largo" },
    { code: "BR.02.2707800", name: "Roteiro" },
    { code: "BR.02.2707909", name: "Santa Luzia do Norte" },
    { code: "BR.02.2708006", name: "Santana do Ipanema" },
    { code: "BR.02.2708105", name: "Santana do Mundaú" },
    { code: "BR.02.2708204", name: "São Brás" },
    { code: "BR.02.2708303", name: "São José da Laje" },
    { code: "BR.02.2708402", name: "São José da Tapera" },
    { code: "BR.02.2708501", name: "São Luís do Quitunde" },
    { code: "BR.02.2708600", name: "São Miguel dos Campos" },
    { code: "BR.02.2708709", name: "São Miguel dos Milagres" },
    { code: "BR.02.2708808", name: "São Sebastião" },
    { code: "BR.02.2708907", name: "Satuba" },
    { code: "BR.02.2708956", name: "Senador Rui Palmeira" },
    { code: "BR.02.2709004", name: "Tanque d'Arca" },
    { code: "BR.02.2709103", name: "Taquarana" },
    { code: "BR.02.2709152", name: "Teotônio Vilela" },
    { code: "BR.02.2709202", name: "Traipu" },
    { code: "BR.02.2709301", name: "União dos Palmares" },
    { code: "BR.02.2709400", name: "Viçosa" },
  ],
  "BR.03": [
    { code: "BR.03.1600055", name: "Serra do Navio" },
    { code: "BR.03.1600105", name: "Amapá" },
    { code: "BR.03.1600154", name: "Pedra Branca do Amapari" },
    { code: "BR.03.1600204", name: "Calçoene" },
    { code: "BR.03.1600212", name: "Cutias" },
    { code: "BR.03.1600238", name: "Ferreira Gomes" },
    { code: "BR.03.1600253", name: "Itaubal" },
    { code: "BR.03.1600279", name: "Laranjal do Jari" },
    { code: "BR.03.1600303", name: "Macapá" },
    { code: "BR.03.1600402", name: "Mazagão" },
    { code: "BR.03.1600501", name: "Oiapoque" },
    { code: "BR.03.1600535", name: "Porto Grande" },
    { code: "BR.03.1600550", name: "Pracuúba" },
    { code: "BR.03.1600600", name: "Santana" },
    { code: "BR.03.1600709", name: "Tartarugalzinho" },
    { code: "BR.03.1600808", name: "Vitória do Jari" },
  ],
  "BR.04": [
    { code: "BR.04.1300029", name: "Alvarães" },
    { code: "BR.04.1300060", name: "Amaturá" },
    { code: "BR.04.1300086", name: "Anamã" },
    { code: "BR.04.1300102", name: "Anori" },
    { code: "BR.04.1300144", name: "Apuí" },
    { code: "BR.04.1300201", name: "Atalaia do Norte" },
    { code: "BR.04.1300300", name: "Autazes" },
    { code: "BR.04.1300409", name: "Barcelos" },
    { code: "BR.04.1300508", name: "Barreirinha" },
    { code: "BR.04.1300607", name: "Benjamin Constant" },
    { code: "BR.04.1300631", name: "Beruri" },
    { code: "BR.04.1300680", name: "Boa Vista do Ramos" },
    { code: "BR.04.1300706", name: "Boca do Acre" },
    { code: "BR.04.1300805", name: "Borba" },
    { code: "BR.04.1300839", name: "Caapiranga" },
    { code: "BR.04.1300904", name: "Canutama" },
    { code: "BR.04.1301001", name: "Carauari" },
    { code: "BR.04.1301100", name: "Careiro" },
    { code: "BR.04.1301159", name: "Careiro da Várzea" },
    { code: "BR.04.1301209", name: "Coari" },
    { code: "BR.04.1301308", name: "Codajás" },
    { code: "BR.04.1301407", name: "Eirunepé" },
    { code: "BR.04.1301506", name: "Envira" },
    { code: "BR.04.1301605", name: "Fonte Boa" },
    { code: "BR.04.1301654", name: "Guajará" },
    { code: "BR.04.1301704", name: "Humaitá" },
    { code: "BR.04.1301803", name: "Ipixuna" },
    { code: "BR.04.1301852", name: "Iranduba" },
    { code: "BR.04.1301902", name: "Itacoatiara" },
    { code: "BR.04.1301951", name: "Itamarati" },
    { code: "BR.04.1302009", name: "Itapiranga" },
    { code: "BR.04.1302108", name: "Japurá" },
    { code: "BR.04.1302207", name: "Juruá" },
    { code: "BR.04.1302306", name: "Jutaí" },
    { code: "BR.04.1302405", name: "Lábrea" },
    { code: "BR.04.1302504", name: "Manacapuru" },
    { code: "BR.04.1302553", name: "Manaquiri" },
    { code: "BR.04.1302603", name: "Manaus" },
    { code: "BR.04.1302702", name: "Manicoré" },
    { code: "BR.04.1302801", name: "Maraã" },
    { code: "BR.04.1302900", name: "Maués" },
    { code: "BR.04.1303007", name: "Nhamundá" },
    { code: "BR.04.1303106", name: "Nova Olinda do Norte" },
    { code: "BR.04.1303205", name: "Novo Airão" },
    { code: "BR.04.1303304", name: "Novo Aripuanã" },
    { code: "BR.04.1303403", name: "Parintins" },
    { code: "BR.04.1303502", name: "Pauini" },
    { code: "BR.04.1303536", name: "Presidente Figueiredo" },
    { code: "BR.04.1303569", name: "Rio Preto da Eva" },
    { code: "BR.04.1303601", name: "Santa Isabel do Rio Negro" },
    { code: "BR.04.1303700", name: "Santo Antônio do Içá" },
    { code: "BR.04.1303809", name: "São Gabriel da Cachoeira" },
    { code: "BR.04.1303908", name: "São Paulo de Olivença" },
    { code: "BR.04.1303957", name: "São Sebastião do Uatumã" },
    { code: "BR.04.1304005", name: "Silves" },
    { code: "BR.04.1304062", name: "Tabatinga" },
    { code: "BR.04.1304104", name: "Tapauá" },
    { code: "BR.04.1304203", name: "Tefé" },
    { code: "BR.04.1304237", name: "Tonantins" },
    { code: "BR.04.1304260", name: "Uarini" },
    { code: "BR.04.1304302", name: "Urucará" },
    { code: "BR.04.1304401", name: "Urucurituba" },
  ],
  "BR.05": [
    { code: "BR.05.2900108", name: "Abaíra" },
    { code: "BR.05.2900207", name: "Abaré" },
    { code: "BR.05.2900306", name: "Acajutiba" },
    { code: "BR.05.2900355", name: "Adustina" },
    { code: "BR.05.2900405", name: "Água Fria" },
    { code: "BR.05.2900504", name: "Érico Cardoso" },
    { code: "BR.05.2900603", name: "Aiquara" },
    { code: "BR.05.2900702", name: "Alagoinhas" },
    { code: "BR.05.2900801", name: "Alcobaça" },
    { code: "BR.05.2900900", name: "Almadina" },
    { code: "BR.05.2901007", name: "Amargosa" },
    { code: "BR.05.2901106", name: "Amélia Rodrigues" },
    { code: "BR.05.2901155", name: "América Dourada" },
    { code: "BR.05.2901205", name: "Anagé" },
    { code: "BR.05.2901304", name: "Andaraí" },
    { code: "BR.05.2901353", name: "Andorinha" },
    { code: "BR.05.2901403", name: "Angical" },
    { code: "BR.05.2901502", name: "Anguera" },
    { code: "BR.05.2901601", name: "Antas" },
    { code: "BR.05.2901700", name: "Antônio Cardoso" },
    { code: "BR.05.2901809", name: "Antônio Gonçalves" },
    { code: "BR.05.2901908", name: "Aporá" },
    { code: "BR.05.2901957", name: "Apuarema" },
    { code: "BR.05.2902005", name: "Aracatu" },
    { code: "BR.05.2902054", name: "Araçás" },
    { code: "BR.05.2902104", name: "Araci" },
    { code: "BR.05.2902203", name: "Aramari" },
    { code: "BR.05.2902252", name: "Arataca" },
    { code: "BR.05.2902302", name: "Aratuípe" },
    { code: "BR.05.2902401", name: "Aurelino Leal" },
    { code: "BR.05.2902500", name: "Baianópolis" },
    { code: "BR.05.2902609", name: "Baixa Grande" },
    { code: "BR.05.2902658", name: "Banzaê" },
    { code: "BR.05.2902708", name: "Barra" },
    { code: "BR.05.2902807", name: "Barra da Estiva" },
    { code: "BR.05.2902906", name: "Barra do Choça" },
    { code: "BR.05.2903003", name: "Barra do Mendes" },
    { code: "BR.05.2903102", name: "Barra do Rocha" },
    { code: "BR.05.2903201", name: "Barreiras" },
    { code: "BR.05.2903235", name: "Barro Alto" },
    { code: "BR.05.2903276", name: "Barrocas" },
    { code: "BR.05.2903300", name: "Barro Preto" },
    { code: "BR.05.2903409", name: "Belmonte" },
    { code: "BR.05.2903508", name: "Belo Campo" },
    { code: "BR.05.2903607", name: "Biritinga" },
    { code: "BR.05.2903706", name: "Boa Nova" },
    { code: "BR.05.2903805", name: "Boa Vista do Tupim" },
    { code: "BR.05.2903904", name: "Bom Jesus da Lapa" },
    { code: "BR.05.2903953", name: "Bom Jesus da Serra" },
    { code: "BR.05.2904001", name: "Boninal" },
    { code: "BR.05.2904050", name: "Bonito" },
    { code: "BR.05.2904100", name: "Boquira" },
    { code: "BR.05.2904209", name: "Botuporã" },
    { code: "BR.05.2904308", name: "Brejões" },
    { code: "BR.05.2904407", name: "Brejolândia" },
    { code: "BR.05.2904506", name: "Brotas de Macaúbas" },
    { code: "BR.05.2904605", name: "Brumado" },
    { code: "BR.05.2904704", name: "Buerarema" },
    { code: "BR.05.2904753", name: "Buritirama" },
    { code: "BR.05.2904803", name: "Caatiba" },
    { code: "BR.05.2904852", name: "Cabaceiras do Paraguaçu" },
    { code: "BR.05.2904902", name: "Cachoeira" },
    { code: "BR.05.2905008", name: "Caculé" },
    { code: "BR.05.2905107", name: "Caém" },
    { code: "BR.05.2905156", name: "Caetanos" },
    { code: "BR.05.2905206", name: "Caetité" },
    { code: "BR.05.2905305", name: "Cafarnaum" },
    { code: "BR.05.2905404", name: "Cairu" },
    { code: "BR.05.2905503", name: "Caldeirão Grande" },
    { code: "BR.05.2905602", name: "Camacan" },
    { code: "BR.05.2905701", name: "Camaçari" },
    { code: "BR.05.2905800", name: "Camamu" },
    { code: "BR.05.2905909", name: "Campo Alegre de Lourdes" },
    { code: "BR.05.2906006", name: "Campo Formoso" },
    { code: "BR.05.2906105", name: "Canápolis" },
    { code: "BR.05.2906204", name: "Canarana" },
    { code: "BR.05.2906303", name: "Canavieiras" },
    { code: "BR.05.2906402", name: "Candeal" },
    { code: "BR.05.2906501", name: "Candeias" },
    { code: "BR.05.2906600", name: "Candiba" },
    { code: "BR.05.2906709", name: "Cândido Sales" },
    { code: "BR.05.2906808", name: "Cansanção" },
    { code: "BR.05.2906824", name: "Canudos" },
    { code: "BR.05.2906857", name: "Capela do Alto Alegre" },
    { code: "BR.05.2906873", name: "Capim Grosso" },
    { code: "BR.05.2906899", name: "Caraíbas" },
    { code: "BR.05.2906907", name: "Caravelas" },
    { code: "BR.05.2907004", name: "Cardeal da Silva" },
    { code: "BR.05.2907103", name: "Carinhanha" },
    { code: "BR.05.2907202", name: "Casa Nova" },
    { code: "BR.05.2907301", name: "Castro Alves" },
    { code: "BR.05.2907400", name: "Catolândia" },
    { code: "BR.05.2907509", name: "Catu" },
    { code: "BR.05.2907558", name: "Caturama" },
    { code: "BR.05.2907608", name: "Central" },
    { code: "BR.05.2907707", name: "Chorrochó" },
    { code: "BR.05.2907806", name: "Cícero Dantas" },
    { code: "BR.05.2907905", name: "Cipó" },
    { code: "BR.05.2908002", name: "Coaraci" },
    { code: "BR.05.2908101", name: "Cocos" },
    { code: "BR.05.2908200", name: "Conceição da Feira" },
    { code: "BR.05.2908309", name: "Conceição do Almeida" },
    { code: "BR.05.2908408", name: "Conceição do Coité" },
    { code: "BR.05.2908507", name: "Conceição do Jacuípe" },
    { code: "BR.05.2908606", name: "Conde" },
    { code: "BR.05.2908705", name: "Condeúba" },
    { code: "BR.05.2908804", name: "Contendas do Sincorá" },
    { code: "BR.05.2908903", name: "Coração de Maria" },
    { code: "BR.05.2909000", name: "Cordeiros" },
    { code: "BR.05.2909109", name: "Coribe" },
    { code: "BR.05.2909208", name: "Coronel João Sá" },
    { code: "BR.05.2909307", name: "Correntina" },
    { code: "BR.05.2909406", name: "Cotegipe" },
    { code: "BR.05.2909505", name: "Cravolândia" },
    { code: "BR.05.2909604", name: "Crisópolis" },
    { code: "BR.05.2909703", name: "Cristópolis" },
    { code: "BR.05.2909802", name: "Cruz das Almas" },
    { code: "BR.05.2909901", name: "Curaçá" },
    { code: "BR.05.2910008", name: "Dário Meira" },
    { code: "BR.05.2910057", name: "Dias d'Ávila" },
    { code: "BR.05.2910107", name: "Dom Basílio" },
    { code: "BR.05.2910206", name: "Dom Macedo Costa" },
    { code: "BR.05.2910305", name: "Elísio Medrado" },
    { code: "BR.05.2910404", name: "Encruzilhada" },
    { code: "BR.05.2910503", name: "Entre Rios" },
    { code: "BR.05.2910602", name: "Esplanada" },
    { code: "BR.05.2910701", name: "Euclides da Cunha" },
    { code: "BR.05.2910727", name: "Eunápolis" },
    { code: "BR.05.2910750", name: "Fátima" },
    { code: "BR.05.2910776", name: "Feira da Mata" },
    { code: "BR.05.2910800", name: "Feira de Santana" },
    { code: "BR.05.2910859", name: "Filadélfia" },
    { code: "BR.05.2910909", name: "Firmino Alves" },
    { code: "BR.05.2911006", name: "Floresta Azul" },
    { code: "BR.05.2911105", name: "Formosa do Rio Preto" },
    { code: "BR.05.2911204", name: "Gandu" },
    { code: "BR.05.2911253", name: "Gavião" },
    { code: "BR.05.2911303", name: "Gentio do Ouro" },
    { code: "BR.05.2911402", name: "Glória" },
    { code: "BR.05.2911501", name: "Gongogi" },
    { code: "BR.05.2911600", name: "Governador Mangabeira" },
    { code: "BR.05.2911659", name: "Guajeru" },
    { code: "BR.05.2911709", name: "Guanambi" },
    { code: "BR.05.2911808", name: "Guaratinga" },
    { code: "BR.05.2911857", name: "Heliópolis" },
    { code: "BR.05.2911907", name: "Iaçu" },
    { code: "BR.05.2912004", name: "Ibiassucê" },
    { code: "BR.05.2912103", name: "Ibicaraí" },
    { code: "BR.05.2912202", name: "Ibicoara" },
    { code: "BR.05.2912301", name: "Ibicuí" },
    { code: "BR.05.2912400", name: "Ibipeba" },
    { code: "BR.05.2912509", name: "Ibipitanga" },
    { code: "BR.05.2912608", name: "Ibiquera" },
    { code: "BR.05.2912707", name: "Ibirapitanga" },
    { code: "BR.05.2912806", name: "Ibirapuã" },
    { code: "BR.05.2912905", name: "Ibirataia" },
    { code: "BR.05.2913002", name: "Ibitiara" },
    { code: "BR.05.2913101", name: "Ibititá" },
    { code: "BR.05.2913200", name: "Ibotirama" },
    { code: "BR.05.2913309", name: "Ichu" },
    { code: "BR.05.2913408", name: "Igaporã" },
    { code: "BR.05.2913457", name: "Igrapiúna" },
    { code: "BR.05.2913507", name: "Iguaí" },
    { code: "BR.05.2913606", name: "Ilhéus" },
    { code: "BR.05.2913705", name: "Inhambupe" },
    { code: "BR.05.2913804", name: "Ipecaetá" },
    { code: "BR.05.2913903", name: "Ipiaú" },
    { code: "BR.05.2914000", name: "Ipirá" },
    { code: "BR.05.2914109", name: "Ipupiara" },
    { code: "BR.05.2914208", name: "Irajuba" },
    { code: "BR.05.2914307", name: "Iramaia" },
    { code: "BR.05.2914406", name: "Iraquara" },
    { code: "BR.05.2914505", name: "Irará" },
    { code: "BR.05.2914604", name: "Irecê" },
    { code: "BR.05.2914653", name: "Itabela" },
    { code: "BR.05.2914703", name: "Itaberaba" },
    { code: "BR.05.2914802", name: "Itabuna" },
    { code: "BR.05.2914901", name: "Itacaré" },
    { code: "BR.05.2915007", name: "Itaeté" },
    { code: "BR.05.2915106", name: "Itagi" },
    { code: "BR.05.2915205", name: "Itagibá" },
    { code: "BR.05.2915304", name: "Itagimirim" },
    { code: "BR.05.2915353", name: "Itaguaçu da Bahia" },
    { code: "BR.05.2915403", name: "Itaju do Colônia" },
    { code: "BR.05.2915502", name: "Itajuípe" },
    { code: "BR.05.2915601", name: "Itamaraju" },
    { code: "BR.05.2915700", name: "Itamari" },
    { code: "BR.05.2915809", name: "Itambé" },
    { code: "BR.05.2915908", name: "Itanagra" },
    { code: "BR.05.2916005", name: "Itanhém" },
    { code: "BR.05.2916104", name: "Itaparica" },
    { code: "BR.05.2916203", name: "Itapé" },
    { code: "BR.05.2916302", name: "Itapebi" },
    { code: "BR.05.2916401", name: "Itapetinga" },
    { code: "BR.05.2916500", name: "Itapicuru" },
    { code: "BR.05.2916609", name: "Itapitanga" },
    { code: "BR.05.2916708", name: "Itaquara" },
    { code: "BR.05.2916807", name: "Itarantim" },
    { code: "BR.05.2916856", name: "Itatim" },
    { code: "BR.05.2916906", name: "Itiruçu" },
    { code: "BR.05.2917003", name: "Itiúba" },
    { code: "BR.05.2917102", name: "Itororó" },
    { code: "BR.05.2917201", name: "Ituaçu" },
    { code: "BR.05.2917300", name: "Ituberá" },
    { code: "BR.05.2917334", name: "Iuiu" },
    { code: "BR.05.2917359", name: "Jaborandi" },
    { code: "BR.05.2917409", name: "Jacaraci" },
    { code: "BR.05.2917508", name: "Jacobina" },
    { code: "BR.05.2917607", name: "Jaguaquara" },
    { code: "BR.05.2917706", name: "Jaguarari" },
    { code: "BR.05.2917805", name: "Jaguaripe" },
    { code: "BR.05.2917904", name: "Jandaíra" },
    { code: "BR.05.2918001", name: "Jequié" },
    { code: "BR.05.2918100", name: "Jeremoabo" },
    { code: "BR.05.2918209", name: "Jiquiriçá" },
    { code: "BR.05.2918308", name: "Jitaúna" },
    { code: "BR.05.2918357", name: "João Dourado" },
    { code: "BR.05.2918407", name: "Juazeiro" },
    { code: "BR.05.2918456", name: "Jucuruçu" },
    { code: "BR.05.2918506", name: "Jussara" },
    { code: "BR.05.2918555", name: "Jussari" },
    { code: "BR.05.2918605", name: "Jussiape" },
    { code: "BR.05.2918704", name: "Lafaiete Coutinho" },
    { code: "BR.05.2918753", name: "Lagoa Real" },
    { code: "BR.05.2918803", name: "Laje" },
    { code: "BR.05.2918902", name: "Lajedão" },
    { code: "BR.05.2919009", name: "Lajedinho" },
    { code: "BR.05.2919058", name: "Lajedo do Tabocal" },
    { code: "BR.05.2919108", name: "Lamarão" },
    { code: "BR.05.2919157", name: "Lapão" },
    { code: "BR.05.2919207", name: "Lauro de Freitas" },
    { code: "BR.05.2919306", name: "Lençóis" },
    { code: "BR.05.2919405", name: "Licínio de Almeida" },
    { code: "BR.05.2919504", name: "Livramento de Nossa Senhora" },
    { code: "BR.05.2919553", name: "Luís Eduardo Magalhães" },
    { code: "BR.05.2919603", name: "Macajuba" },
    { code: "BR.05.2919702", name: "Macarani" },
    { code: "BR.05.2919801", name: "Macaúbas" },
    { code: "BR.05.2919900", name: "Macururé" },
    { code: "BR.05.2919926", name: "Madre de Deus" },
    { code: "BR.05.2919959", name: "Maetinga" },
    { code: "BR.05.2920007", name: "Maiquinique" },
    { code: "BR.05.2920106", name: "Mairi" },
    { code: "BR.05.2920205", name: "Malhada" },
    { code: "BR.05.2920304", name: "Malhada de Pedras" },
    { code: "BR.05.2920403", name: "Manoel Vitorino" },
    { code: "BR.05.2920452", name: "Mansidão" },
    { code: "BR.05.2920502", name: "Maracás" },
    { code: "BR.05.2920601", name: "Maragogipe" },
    { code: "BR.05.2920700", name: "Maraú" },
    { code: "BR.05.2920809", name: "Marcionílio Souza" },
    { code: "BR.05.2920908", name: "Mascote" },
    { code: "BR.05.2921005", name: "Mata de São João" },
    { code: "BR.05.2921054", name: "Matina" },
    { code: "BR.05.2921104", name: "Medeiros Neto" },
    { code: "BR.05.2921203", name: "Miguel Calmon" },
    { code: "BR.05.2921302", name: "Milagres" },
    { code: "BR.05.2921401", name: "Mirangaba" },
    { code: "BR.05.2921450", name: "Mirante" },
    { code: "BR.05.2921500", name: "Monte Santo" },
    { code: "BR.05.2921609", name: "Morpará" },
    { code: "BR.05.2921708", name: "Morro do Chapéu" },
    { code: "BR.05.2921807", name: "Mortugaba" },
    { code: "BR.05.2921906", name: "Mucugê" },
    { code: "BR.05.2922003", name: "Mucuri" },
    { code: "BR.05.2922052", name: "Mulungu do Morro" },
    { code: "BR.05.2922102", name: "Mundo Novo" },
    { code: "BR.05.2922201", name: "Muniz Ferreira" },
    { code: "BR.05.2922250", name: "Muquém do São Francisco" },
    { code: "BR.05.2922300", name: "Muritiba" },
    { code: "BR.05.2922409", name: "Mutuípe" },
    { code: "BR.05.2922508", name: "Nazaré" },
    { code: "BR.05.2922607", name: "Nilo Peçanha" },
    { code: "BR.05.2922656", name: "Nordestina" },
    { code: "BR.05.2922706", name: "Nova Canaã" },
    { code: "BR.05.2922730", name: "Nova Fátima" },
    { code: "BR.05.2922755", name: "Nova Ibiá" },
    { code: "BR.05.2922805", name: "Nova Itarana" },
    { code: "BR.05.2922854", name: "Nova Redenção" },
    { code: "BR.05.2922904", name: "Nova Soure" },
    { code: "BR.05.2923001", name: "Nova Viçosa" },
    { code: "BR.05.2923035", name: "Novo Horizonte" },
    { code: "BR.05.2923050", name: "Novo Triunfo" },
    { code: "BR.05.2923100", name: "Olindina" },
    { code: "BR.05.2923209", name: "Oliveira dos Brejinhos" },
    { code: "BR.05.2923308", name: "Ouriçangas" },
    { code: "BR.05.2923357", name: "Ourolândia" },
    { code: "BR.05.2923407", name: "Palmas de Monte Alto" },
    { code: "BR.05.2923506", name: "Palmeiras" },
    { code: "BR.05.2923605", name: "Paramirim" },
    { code: "BR.05.2923704", name: "Paratinga" },
    { code: "BR.05.2923803", name: "Paripiranga" },
    { code: "BR.05.2923902", name: "Pau Brasil" },
    { code: "BR.05.2924009", name: "Paulo Afonso" },
    { code: "BR.05.2924058", name: "Pé de Serra" },
    { code: "BR.05.2924108", name: "Pedrão" },
    { code: "BR.05.2924207", name: "Pedro Alexandre" },
    { code: "BR.05.2924306", name: "Piatã" },
    { code: "BR.05.2924405", name: "Pilão Arcado" },
    { code: "BR.05.2924504", name: "Pindaí" },
    { code: "BR.05.2924603", name: "Pindobaçu" },
    { code: "BR.05.2924652", name: "Pintadas" },
    { code: "BR.05.2924678", name: "Piraí do Norte" },
    { code: "BR.05.2924702", name: "Piripá" },
    { code: "BR.05.2924801", name: "Piritiba" },
    { code: "BR.05.2924900", name: "Planaltino" },
    { code: "BR.05.2925006", name: "Planalto" },
    { code: "BR.05.2925105", name: "Poções" },
    { code: "BR.05.2925204", name: "Pojuca" },
    { code: "BR.05.2925253", name: "Ponto Novo" },
    { code: "BR.05.2925303", name: "Porto Seguro" },
    { code: "BR.05.2925402", name: "Potiraguá" },
    { code: "BR.05.2925501", name: "Prado" },
    { code: "BR.05.2925600", name: "Presidente Dutra" },
    { code: "BR.05.2925709", name: "Presidente Jânio Quadros" },
    { code: "BR.05.2925758", name: "Presidente Tancredo Neves" },
    { code: "BR.05.2925808", name: "Queimadas" },
    { code: "BR.05.2925907", name: "Quijingue" },
    { code: "BR.05.2925931", name: "Quixabeira" },
    { code: "BR.05.2925956", name: "Rafael Jambeiro" },
    { code: "BR.05.2926004", name: "Remanso" },
    { code: "BR.05.2926103", name: "Retirolândia" },
    { code: "BR.05.2926202", name: "Riachão das Neves" },
    { code: "BR.05.2926301", name: "Riachão do Jacuípe" },
    { code: "BR.05.2926400", name: "Riacho de Santana" },
    { code: "BR.05.2926509", name: "Ribeira do Amparo" },
    { code: "BR.05.2926608", name: "Ribeira do Pombal" },
    { code: "BR.05.2926657", name: "Ribeirão do Largo" },
    { code: "BR.05.2926707", name: "Rio de Contas" },
    { code: "BR.05.2926806", name: "Rio do Antônio" },
    { code: "BR.05.2926905", name: "Rio do Pires" },
    { code: "BR.05.2927002", name: "Rio Real" },
    { code: "BR.05.2927101", name: "Rodelas" },
    { code: "BR.05.2927200", name: "Ruy Barbosa" },
    { code: "BR.05.2927309", name: "Salinas da Margarida" },
    { code: "BR.05.2927408", name: "Salvador" },
    { code: "BR.05.2927507", name: "Santa Bárbara" },
    { code: "BR.05.2927606", name: "Santa Brígida" },
    { code: "BR.05.2927705", name: "Santa Cruz Cabrália" },
    { code: "BR.05.2927804", name: "Santa Cruz da Vitória" },
    { code: "BR.05.2927903", name: "Santa Inês" },
    { code: "BR.05.2928000", name: "Santaluz" },
    { code: "BR.05.2928059", name: "Santa Luzia" },
    { code: "BR.05.2928109", name: "Santa Maria da Vitória" },
    { code: "BR.05.2928208", name: "Santana" },
    { code: "BR.05.2928307", name: "Santanópolis" },
    { code: "BR.05.2928406", name: "Santa Rita de Cássia" },
    { code: "BR.05.2928505", name: "Santa Terezinha" },
    { code: "BR.05.2928604", name: "Santo Amaro" },
    { code: "BR.05.2928703", name: "Santo Antônio de Jesus" },
    { code: "BR.05.2928802", name: "Santo Estêvão" },
    { code: "BR.05.2928901", name: "São Desidério" },
    { code: "BR.05.2928950", name: "São Domingos" },
    { code: "BR.05.2929008", name: "São Félix" },
    { code: "BR.05.2929057", name: "São Félix do Coribe" },
    { code: "BR.05.2929107", name: "São Felipe" },
    { code: "BR.05.2929206", name: "São Francisco do Conde" },
    { code: "BR.05.2929255", name: "São Gabriel" },
    { code: "BR.05.2929305", name: "São Gonçalo dos Campos" },
    { code: "BR.05.2929354", name: "São José da Vitória" },
    { code: "BR.05.2929370", name: "São José do Jacuípe" },
    { code: "BR.05.2929404", name: "São Miguel das Matas" },
    { code: "BR.05.2929503", name: "São Sebastião do Passé" },
    { code: "BR.05.2929602", name: "Sapeaçu" },
    { code: "BR.05.2929701", name: "Sátiro Dias" },
    { code: "BR.05.2929750", name: "Saubara" },
    { code: "BR.05.2929800", name: "Saúde" },
    { code: "BR.05.2929909", name: "Seabra" },
    { code: "BR.05.2930006", name: "Sebastião Laranjeiras" },
    { code: "BR.05.2930105", name: "Senhor do Bonfim" },
    { code: "BR.05.2930154", name: "Serra do Ramalho" },
    { code: "BR.05.2930204", name: "Sento Sé" },
    { code: "BR.05.2930303", name: "Serra Dourada" },
    { code: "BR.05.2930402", name: "Serra Preta" },
    { code: "BR.05.2930501", name: "Serrinha" },
    { code: "BR.05.2930600", name: "Serrolândia" },
    { code: "BR.05.2930709", name: "Simões Filho" },
    { code: "BR.05.2930758", name: "Sítio do Mato" },
    { code: "BR.05.2930766", name: "Sítio do Quinto" },
    { code: "BR.05.2930774", name: "Sobradinho" },
    { code: "BR.05.2930808", name: "Souto Soares" },
    { code: "BR.05.2930907", name: "Tabocas do Brejo Velho" },
    { code: "BR.05.2931004", name: "Tanhaçu" },
    { code: "BR.05.2931053", name: "Tanque Novo" },
    { code: "BR.05.2931103", name: "Tanquinho" },
    { code: "BR.05.2931202", name: "Taperoá" },
    { code: "BR.05.2931301", name: "Tapiramutá" },
    { code: "BR.05.2931350", name: "Teixeira de Freitas" },
    { code: "BR.05.2931400", name: "Teodoro Sampaio" },
    { code: "BR.05.2931509", name: "Teofilândia" },
    { code: "BR.05.2931608", name: "Teolândia" },
    { code: "BR.05.2931707", name: "Terra Nova" },
    { code: "BR.05.2931806", name: "Tremedal" },
    { code: "BR.05.2931905", name: "Tucano" },
    { code: "BR.05.2932002", name: "Uauá" },
    { code: "BR.05.2932101", name: "Ubaíra" },
    { code: "BR.05.2932200", name: "Ubaitaba" },
    { code: "BR.05.2932309", name: "Ubatã" },
    { code: "BR.05.2932408", name: "Uibaí" },
    { code: "BR.05.2932457", name: "Umburanas" },
    { code: "BR.05.2932507", name: "Una" },
    { code: "BR.05.2932606", name: "Urandi" },
    { code: "BR.05.2932705", name: "Uruçuca" },
    { code: "BR.05.2932804", name: "Utinga" },
    { code: "BR.05.2932903", name: "Valença" },
    { code: "BR.05.2933000", name: "Valente" },
    { code: "BR.05.2933059", name: "Várzea da Roça" },
    { code: "BR.05.2933109", name: "Várzea do Poço" },
    { code: "BR.05.2933158", name: "Várzea Nova" },
    { code: "BR.05.2933174", name: "Varzedo" },
    { code: "BR.05.2933208", name: "Vera Cruz" },
    { code: "BR.05.2933257", name: "Vereda" },
    { code: "BR.05.2933307", name: "Vitória da Conquista" },
    { code: "BR.05.2933406", name: "Wagner" },
    { code: "BR.05.2933455", name: "Wanderley" },
    { code: "BR.05.2933505", name: "Wenceslau Guimarães" },
    { code: "BR.05.2933604", name: "Xique-Xique" },
  ],
  "BR.06": [
    { code: "BR.06.2300101", name: "Abaiara" },
    { code: "BR.06.2300150", name: "Acarape" },
    { code: "BR.06.2300200", name: "Acaraú" },
    { code: "BR.06.2300309", name: "Acopiara" },
    { code: "BR.06.2300408", name: "Aiuaba" },
    { code: "BR.06.2300507", name: "Alcântaras" },
    { code: "BR.06.2300606", name: "Altaneira" },
    { code: "BR.06.2300705", name: "Alto Santo" },
    { code: "BR.06.2300754", name: "Amontada" },
    { code: "BR.06.2300804", name: "Antonina do Norte" },
    { code: "BR.06.2300903", name: "Apuiarés" },
    { code: "BR.06.2301000", name: "Aquiraz" },
    { code: "BR.06.2301109", name: "Aracati" },
    { code: "BR.06.2301208", name: "Aracoiaba" },
    { code: "BR.06.2301257", name: "Ararendá" },
    { code: "BR.06.2301307", name: "Araripe" },
    { code: "BR.06.2301406", name: "Aratuba" },
    { code: "BR.06.2301505", name: "Arneiroz" },
    { code: "BR.06.2301604", name: "Assaré" },
    { code: "BR.06.2301703", name: "Aurora" },
    { code: "BR.06.2301802", name: "Baixio" },
    { code: "BR.06.2301851", name: "Banabuiú" },
    { code: "BR.06.2301901", name: "Barbalha" },
    { code: "BR.06.2301950", name: "Barreira" },
    { code: "BR.06.2302008", name: "Barro" },
    { code: "BR.06.2302057", name: "Barroquinha" },
    { code: "BR.06.2302107", name: "Baturité" },
    { code: "BR.06.2302206", name: "Beberibe" },
    { code: "BR.06.2302305", name: "Bela Cruz" },
    { code: "BR.06.2302404", name: "Boa Viagem" },
    { code: "BR.06.2302503", name: "Brejo Santo" },
    { code: "BR.06.2302602", name: "Camocim" },
    { code: "BR.06.2302701", name: "Campos Sales" },
    { code: "BR.06.2302800", name: "Canindé" },
    { code: "BR.06.2302909", name: "Capistrano" },
    { code: "BR.06.2303006", name: "Caridade" },
    { code: "BR.06.2303105", name: "Cariré" },
    { code: "BR.06.2303204", name: "Caririaçu" },
    { code: "BR.06.2303303", name: "Cariús" },
    { code: "BR.06.2303402", name: "Carnaubal" },
    { code: "BR.06.2303501", name: "Cascavel" },
    { code: "BR.06.2303600", name: "Catarina" },
    { code: "BR.06.2303659", name: "Catunda" },
    { code: "BR.06.2303709", name: "Caucaia" },
    { code: "BR.06.2303808", name: "Cedro" },
    { code: "BR.06.2303907", name: "Chaval" },
    { code: "BR.06.2303931", name: "Choró" },
    { code: "BR.06.2303956", name: "Chorozinho" },
    { code: "BR.06.2304004", name: "Coreaú" },
    { code: "BR.06.2304103", name: "Crateús" },
    { code: "BR.06.2304202", name: "Crato" },
    { code: "BR.06.2304236", name: "Croatá" },
    { code: "BR.06.2304251", name: "Cruz" },
    { code: "BR.06.2304269", name: "Deputado Irapuan Pinheiro" },
    { code: "BR.06.2304277", name: "Ererê" },
    { code: "BR.06.2304285", name: "Eusébio" },
    { code: "BR.06.2304301", name: "Farias Brito" },
    { code: "BR.06.2304350", name: "Forquilha" },
    { code: "BR.06.2304400", name: "Fortaleza" },
    { code: "BR.06.2304459", name: "Fortim" },
    { code: "BR.06.2304509", name: "Frecheirinha" },
    { code: "BR.06.2304608", name: "General Sampaio" },
    { code: "BR.06.2304657", name: "Graça" },
    { code: "BR.06.2304707", name: "Granja" },
    { code: "BR.06.2304806", name: "Granjeiro" },
    { code: "BR.06.2304905", name: "Groaíras" },
    { code: "BR.06.2304954", name: "Guaiúba" },
    { code: "BR.06.2305001", name: "Guaraciaba do Norte" },
    { code: "BR.06.2305100", name: "Guaramiranga" },
    { code: "BR.06.2305209", name: "Hidrolândia" },
    { code: "BR.06.2305233", name: "Horizonte" },
    { code: "BR.06.2305266", name: "Ibaretama" },
    { code: "BR.06.2305308", name: "Ibiapina" },
    { code: "BR.06.2305332", name: "Ibicuitinga" },
    { code: "BR.06.2305357", name: "Icapuí" },
    { code: "BR.06.2305407", name: "Icó" },
    { code: "BR.06.2305506", name: "Iguatu" },
    { code: "BR.06.2305605", name: "Independência" },
    { code: "BR.06.2305654", name: "Ipaporanga" },
    { code: "BR.06.2305704", name: "Ipaumirim" },
    { code: "BR.06.2305803", name: "Ipu" },
    { code: "BR.06.2305902", name: "Ipueiras" },
    { code: "BR.06.2306009", name: "Iracema" },
    { code: "BR.06.2306108", name: "Irauçuba" },
    { code: "BR.06.2306207", name: "Itaiçaba" },
    { code: "BR.06.2306256", name: "Itaitinga" },
    { code: "BR.06.2306306", name: "Itapajé" },
    { code: "BR.06.2306405", name: "Itapipoca" },
    { code: "BR.06.2306504", name: "Itapiúna" },
    { code: "BR.06.2306553", name: "Itarema" },
    { code: "BR.06.2306603", name: "Itatira" },
    { code: "BR.06.2306702", name: "Jaguaretama" },
    { code: "BR.06.2306801", name: "Jaguaribara" },
    { code: "BR.06.2306900", name: "Jaguaribe" },
    { code: "BR.06.2307007", name: "Jaguaruana" },
    { code: "BR.06.2307106", name: "Jardim" },
    { code: "BR.06.2307205", name: "Jati" },
    { code: "BR.06.2307254", name: "Jijoca de Jericoacoara" },
    { code: "BR.06.2307304", name: "Juazeiro do Norte" },
    { code: "BR.06.2307403", name: "Jucás" },
    { code: "BR.06.2307502", name: "Lavras da Mangabeira" },
    { code: "BR.06.2307601", name: "Limoeiro do Norte" },
    { code: "BR.06.2307635", name: "Madalena" },
    { code: "BR.06.2307650", name: "Maracanaú" },
    { code: "BR.06.2307700", name: "Maranguape" },
    { code: "BR.06.2307809", name: "Marco" },
    { code: "BR.06.2307908", name: "Martinópole" },
    { code: "BR.06.2308005", name: "Massapê" },
    { code: "BR.06.2308104", name: "Mauriti" },
    { code: "BR.06.2308203", name: "Meruoca" },
    { code: "BR.06.2308302", name: "Milagres" },
    { code: "BR.06.2308351", name: "Milhã" },
    { code: "BR.06.2308377", name: "Miraíma" },
    { code: "BR.06.2308401", name: "Missão Velha" },
    { code: "BR.06.2308500", name: "Mombaça" },
    { code: "BR.06.2308609", name: "Monsenhor Tabosa" },
    { code: "BR.06.2308708", name: "Morada Nova" },
    { code: "BR.06.2308807", name: "Moraújo" },
    { code: "BR.06.2308906", name: "Morrinhos" },
    { code: "BR.06.2309003", name: "Mucambo" },
    { code: "BR.06.2309102", name: "Mulungu" },
    { code: "BR.06.2309201", name: "Nova Olinda" },
    { code: "BR.06.2309300", name: "Nova Russas" },
    { code: "BR.06.2309409", name: "Novo Oriente" },
    { code: "BR.06.2309458", name: "Ocara" },
    { code: "BR.06.2309508", name: "Orós" },
    { code: "BR.06.2309607", name: "Pacajus" },
    { code: "BR.06.2309706", name: "Pacatuba" },
    { code: "BR.06.2309805", name: "Pacoti" },
    { code: "BR.06.2309904", name: "Pacujá" },
    { code: "BR.06.2310001", name: "Palhano" },
    { code: "BR.06.2310100", name: "Palmácia" },
    { code: "BR.06.2310209", name: "Paracuru" },
    { code: "BR.06.2310258", name: "Paraipaba" },
    { code: "BR.06.2310308", name: "Parambu" },
    { code: "BR.06.2310407", name: "Paramoti" },
    { code: "BR.06.2310506", name: "Pedra Branca" },
    { code: "BR.06.2310605", name: "Penaforte" },
    { code: "BR.06.2310704", name: "Pentecoste" },
    { code: "BR.06.2310803", name: "Pereiro" },
    { code: "BR.06.2310852", name: "Pindoretama" },
    { code: "BR.06.2310902", name: "Piquet Carneiro" },
    { code: "BR.06.2310951", name: "Pires Ferreira" },
    { code: "BR.06.2311009", name: "Poranga" },
    { code: "BR.06.2311108", name: "Porteiras" },
    { code: "BR.06.2311207", name: "Potengi" },
    { code: "BR.06.2311231", name: "Potiretama" },
    { code: "BR.06.2311264", name: "Quiterianópolis" },
    { code: "BR.06.2311306", name: "Quixadá" },
    { code: "BR.06.2311355", name: "Quixelô" },
    { code: "BR.06.2311405", name: "Quixeramobim" },
    { code: "BR.06.2311504", name: "Quixeré" },
    { code: "BR.06.2311603", name: "Redenção" },
    { code: "BR.06.2311702", name: "Reriutaba" },
    { code: "BR.06.2311801", name: "Russas" },
    { code: "BR.06.2311900", name: "Saboeiro" },
    { code: "BR.06.2311959", name: "Salitre" },
    { code: "BR.06.2312007", name: "Santana do Acaraú" },
    { code: "BR.06.2312106", name: "Santana do Cariri" },
    { code: "BR.06.2312205", name: "Santa Quitéria" },
    { code: "BR.06.2312304", name: "São Benedito" },
    { code: "BR.06.2312403", name: "São Gonçalo do Amarante" },
    { code: "BR.06.2312502", name: "São João do Jaguaribe" },
    { code: "BR.06.2312601", name: "São Luís do Curu" },
    { code: "BR.06.2312700", name: "Senador Pompeu" },
    { code: "BR.06.2312809", name: "Senador Sá" },
    { code: "BR.06.2312908", name: "Sobral" },
    { code: "BR.06.2313005", name: "Solonópole" },
    { code: "BR.06.2313104", name: "Tabuleiro do Norte" },
    { code: "BR.06.2313203", name: "Tamboril" },
    { code: "BR.06.2313252", name: "Tarrafas" },
    { code: "BR.06.2313302", name: "Tauá" },
    { code: "BR.06.2313351", name: "Tejuçuoca" },
    { code: "BR.06.2313401", name: "Tianguá" },
    { code: "BR.06.2313500", name: "Trairi" },
    { code: "BR.06.2313559", name: "Tururu" },
    { code: "BR.06.2313609", name: "Ubajara" },
    { code: "BR.06.2313708", name: "Umari" },
    { code: "BR.06.2313757", name: "Umirim" },
    { code: "BR.06.2313807", name: "Uruburetama" },
    { code: "BR.06.2313906", name: "Uruoca" },
    { code: "BR.06.2313955", name: "Varjota" },
    { code: "BR.06.2314003", name: "Várzea Alegre" },
    { code: "BR.06.2314102", name: "Viçosa do Ceará" },
  ],
  "BR.07": [
    { code: "BR.07.5300108", name: "Brasília" },
  ],
  "BR.08": [
    { code: "BR.08.3200102", name: "Afonso Cláudio" },
    { code: "BR.08.3200136", name: "Águia Branca" },
    { code: "BR.08.3200169", name: "Água Doce do Norte" },
    { code: "BR.08.3200201", name: "Alegre" },
    { code: "BR.08.3200300", name: "Alfredo Chaves" },
    { code: "BR.08.3200359", name: "Alto Rio Novo" },
    { code: "BR.08.3200409", name: "Anchieta" },
    { code: "BR.08.3200508", name: "Apiacá" },
    { code: "BR.08.3200607", name: "Aracruz" },
    { code: "BR.08.3200706", name: "Atílio Vivacqua" },
    { code: "BR.08.3200805", name: "Baixo Guandu" },
    { code: "BR.08.3200904", name: "Barra de São Francisco" },
    { code: "BR.08.3201001", name: "Boa Esperança" },
    { code: "BR.08.3201100", name: "Bom Jesus do Norte" },
    { code: "BR.08.3201159", name: "Brejetuba" },
    { code: "BR.08.3201209", name: "Cachoeiro de Itapemirim" },
    { code: "BR.08.3201308", name: "Cariacica" },
    { code: "BR.08.3201407", name: "Castelo" },
    { code: "BR.08.3201506", name: "Colatina" },
    { code: "BR.08.3201605", name: "Conceição da Barra" },
    { code: "BR.08.3201704", name: "Conceição do Castelo" },
    { code: "BR.08.3201803", name: "Divino de São Lourenço" },
    { code: "BR.08.3201902", name: "Domingos Martins" },
    { code: "BR.08.3202009", name: "Dores do Rio Preto" },
    { code: "BR.08.3202108", name: "Ecoporanga" },
    { code: "BR.08.3202207", name: "Fundão" },
    { code: "BR.08.3202256", name: "Governador Lindenberg" },
    { code: "BR.08.3202306", name: "Guaçuí" },
    { code: "BR.08.3202405", name: "Guarapari" },
    { code: "BR.08.3202454", name: "Ibatiba" },
    { code: "BR.08.3202504", name: "Ibiraçu" },
    { code: "BR.08.3202553", name: "Ibitirama" },
    { code: "BR.08.3202603", name: "Iconha" },
    { code: "BR.08.3202652", name: "Irupi" },
    { code: "BR.08.3202702", name: "Itaguaçu" },
    { code: "BR.08.3202801", name: "Itapemirim" },
    { code: "BR.08.3202900", name: "Itarana" },
    { code: "BR.08.3203007", name: "Iúna" },
    { code: "BR.08.3203056", name: "Jaguaré" },
    { code: "BR.08.3203106", name: "Jerônimo Monteiro" },
    { code: "BR.08.3203130", name: "João Neiva" },
    { code: "BR.08.3203163", name: "Laranja da Terra" },
    { code: "BR.08.3203205", name: "Linhares" },
    { code: "BR.08.3203304", name: "Mantenópolis" },
    { code: "BR.08.3203320", name: "Marataízes" },
    { code: "BR.08.3203346", name: "Marechal Floriano" },
    { code: "BR.08.3203353", name: "Marilândia" },
    { code: "BR.08.3203403", name: "Mimoso do Sul" },
    { code: "BR.08.3203502", name: "Montanha" },
    { code: "BR.08.3203601", name: "Mucurici" },
    { code: "BR.08.3203700", name: "Muniz Freire" },
    { code: "BR.08.3203809", name: "Muqui" },
    { code: "BR.08.3203908", name: "Nova Venécia" },
    { code: "BR.08.3204005", name: "Pancas" },
    { code: "BR.08.3204054", name: "Pedro Canário" },
    { code: "BR.08.3204104", name: "Pinheiros" },
    { code: "BR.08.3204203", name: "Piúma" },
    { code: "BR.08.3204252", name: "Ponto Belo" },
    { code: "BR.08.3204302", name: "Presidente Kennedy" },
    { code: "BR.08.3204351", name: "Rio Bananal" },
    { code: "BR.08.3204401", name: "Rio Novo do Sul" },
    { code: "BR.08.3204500", name: "Santa Leopoldina" },
    { code: "BR.08.3204559", name: "Santa Maria de Jetibá" },
    { code: "BR.08.3204609", name: "Santa Teresa" },
    { code: "BR.08.3204658", name: "São Domingos do Norte" },
    { code: "BR.08.3204708", name: "São Gabriel da Palha" },
    { code: "BR.08.3204807", name: "São José do Calçado" },
    { code: "BR.08.3204906", name: "São Mateus" },
    { code: "BR.08.3204955", name: "São Roque do Canaã" },
    { code: "BR.08.3205002", name: "Serra" },
    { code: "BR.08.3205010", name: "Sooretama" },
    { code: "BR.08.3205036", name: "Vargem Alta" },
    { code: "BR.08.3205069", name: "Venda Nova do Imigrante" },
    { code: "BR.08.3205101", name: "Viana" },
    { code: "BR.08.3205150", name: "Vila Pavão" },
    { code: "BR.08.3205176", name: "Vila Valério" },
    { code: "BR.08.3205200", name: "Vila Velha" },
    { code: "BR.08.3205309", name: "Vitória" },
  ],
  "BR.11": [
    { code: "BR.11.5000203", name: "Água Clara" },
    { code: "BR.11.5000252", name: "Alcinópolis" },
    { code: "BR.11.5000609", name: "Amambai" },
    { code: "BR.11.5000708", name: "Anastácio" },
    { code: "BR.11.5000807", name: "Anaurilândia" },
    { code: "BR.11.5000856", name: "Angélica" },
    { code: "BR.11.5000906", name: "Antônio João" },
    { code: "BR.11.5001003", name: "Aparecida do Taboado" },
    { code: "BR.11.5001102", name: "Aquidauana" },
    { code: "BR.11.5001243", name: "Aral Moreira" },
    { code: "BR.11.5001508", name: "Bandeirantes" },
    { code: "BR.11.5001904", name: "Bataguassu" },
    { code: "BR.11.5002001", name: "Batayporã" },
    { code: "BR.11.5002100", name: "Bela Vista" },
    { code: "BR.11.5002159", name: "Bodoquena" },
    { code: "BR.11.5002209", name: "Bonito" },
    { code: "BR.11.5002308", name: "Brasilândia" },
    { code: "BR.11.5002407", name: "Caarapó" },
    { code: "BR.11.5002605", name: "Camapuã" },
    { code: "BR.11.5002704", name: "Campo Grande" },
    { code: "BR.11.5002803", name: "Caracol" },
    { code: "BR.11.5002902", name: "Cassilândia" },
    { code: "BR.11.5002951", name: "Chapadão do Sul" },
    { code: "BR.11.5003108", name: "Corguinho" },
    { code: "BR.11.5003157", name: "Coronel Sapucaia" },
    { code: "BR.11.5003207", name: "Corumbá" },
    { code: "BR.11.5003256", name: "Costa Rica" },
    { code: "BR.11.5003306", name: "Coxim" },
    { code: "BR.11.5003454", name: "Deodápolis" },
    { code: "BR.11.5003488", name: "Dois Irmãos do Buriti" },
    { code: "BR.11.5003504", name: "Douradina" },
    { code: "BR.11.5003702", name: "Dourados" },
    { code: "BR.11.5003751", name: "Eldorado" },
    { code: "BR.11.5003801", name: "Fátima do Sul" },
    { code: "BR.11.5003900", name: "Figueirão" },
    { code: "BR.11.5004007", name: "Glória de Dourados" },
    { code: "BR.11.5004106", name: "Guia Lopes da Laguna" },
    { code: "BR.11.5004304", name: "Iguatemi" },
    { code: "BR.11.5004403", name: "Inocência" },
    { code: "BR.11.5004502", name: "Itaporã" },
    { code: "BR.11.5004601", name: "Itaquiraí" },
    { code: "BR.11.5004700", name: "Ivinhema" },
    { code: "BR.11.5004809", name: "Japorã" },
    { code: "BR.11.5004908", name: "Jaraguari" },
    { code: "BR.11.5005004", name: "Jardim" },
    { code: "BR.11.5005103", name: "Jateí" },
    { code: "BR.11.5005152", name: "Juti" },
    { code: "BR.11.5005202", name: "Ladário" },
    { code: "BR.11.5005251", name: "Laguna Carapã" },
    { code: "BR.11.5005400", name: "Maracaju" },
    { code: "BR.11.5005608", name: "Miranda" },
    { code: "BR.11.5005681", name: "Mundo Novo" },
    { code: "BR.11.5005707", name: "Naviraí" },
    { code: "BR.11.5005806", name: "Nioaque" },
    { code: "BR.11.5006002", name: "Nova Alvorada do Sul" },
    { code: "BR.11.5006200", name: "Nova Andradina" },
    { code: "BR.11.5006259", name: "Novo Horizonte do Sul" },
    { code: "BR.11.5006275", name: "Paraíso das Águas" },
    { code: "BR.11.5006309", name: "Paranaíba" },
    { code: "BR.11.5006358", name: "Paranhos" },
    { code: "BR.11.5006408", name: "Pedro Gomes" },
    { code: "BR.11.5006606", name: "Ponta Porã" },
    { code: "BR.11.5006903", name: "Porto Murtinho" },
    { code: "BR.11.5007109", name: "Ribas do Rio Pardo" },
    { code: "BR.11.5007208", name: "Rio Brilhante" },
    { code: "BR.11.5007307", name: "Rio Negro" },
    { code: "BR.11.5007406", name: "Rio Verde de Mato Grosso" },
    { code: "BR.11.5007505", name: "Rochedo" },
    { code: "BR.11.5007554", name: "Santa Rita do Pardo" },
    { code: "BR.11.5007695", name: "São Gabriel do Oeste" },
    { code: "BR.11.5007703", name: "Sete Quedas" },
    { code: "BR.11.5007802", name: "Selvíria" },
    { code: "BR.11.5007901", name: "Sidrolândia" },
    { code: "BR.11.5007935", name: "Sonora" },
    { code: "BR.11.5007950", name: "Tacuru" },
    { code: "BR.11.5007976", name: "Taquarussu" },
    { code: "BR.11.5008008", name: "Terenos" },
    { code: "BR.11.5008305", name: "Três Lagoas" },
    { code: "BR.11.5008404", name: "Vicentina" },
  ],
  "BR.13": [
    { code: "BR.13.2100055", name: "Açailândia" },
    { code: "BR.13.2100105", name: "Afonso Cunha" },
    { code: "BR.13.2100154", name: "Água Doce do Maranhão" },
    { code: "BR.13.2100204", name: "Alcântara" },
    { code: "BR.13.2100303", name: "Aldeias Altas" },
    { code: "BR.13.2100402", name: "Altamira do Maranhão" },
    { code: "BR.13.2100436", name: "Alto Alegre do Maranhão" },
    { code: "BR.13.2100477", name: "Alto Alegre do Pindaré" },
    { code: "BR.13.2100501", name: "Alto Parnaíba" },
    { code: "BR.13.2100550", name: "Amapá do Maranhão" },
    { code: "BR.13.2100600", name: "Amarante do Maranhão" },
    { code: "BR.13.2100709", name: "Anajatuba" },
    { code: "BR.13.2100808", name: "Anapurus" },
    { code: "BR.13.2100832", name: "Apicum-Açu" },
    { code: "BR.13.2100873", name: "Araguanã" },
    { code: "BR.13.2100907", name: "Araioses" },
    { code: "BR.13.2100956", name: "Arame" },
    { code: "BR.13.2101004", name: "Arari" },
    { code: "BR.13.2101103", name: "Axixá" },
    { code: "BR.13.2101202", name: "Bacabal" },
    { code: "BR.13.2101251", name: "Bacabeira" },
    { code: "BR.13.2101301", name: "Bacuri" },
    { code: "BR.13.2101350", name: "Bacurituba" },
    { code: "BR.13.2101400", name: "Balsas" },
    { code: "BR.13.2101509", name: "Barão de Grajaú" },
    { code: "BR.13.2101608", name: "Barra do Corda" },
    { code: "BR.13.2101707", name: "Barreirinhas" },
    { code: "BR.13.2101731", name: "Belágua" },
    { code: "BR.13.2101772", name: "Bela Vista do Maranhão" },
    { code: "BR.13.2101806", name: "Benedito Leite" },
    { code: "BR.13.2101905", name: "Bequimão" },
    { code: "BR.13.2101939", name: "Bernardo do Mearim" },
    { code: "BR.13.2101970", name: "Boa Vista do Gurupi" },
    { code: "BR.13.2102002", name: "Bom Jardim" },
    { code: "BR.13.2102036", name: "Bom Jesus das Selvas" },
    { code: "BR.13.2102077", name: "Bom Lugar" },
    { code: "BR.13.2102101", name: "Brejo" },
    { code: "BR.13.2102150", name: "Brejo de Areia" },
    { code: "BR.13.2102200", name: "Buriti" },
    { code: "BR.13.2102309", name: "Buriti Bravo" },
    { code: "BR.13.2102325", name: "Buriticupu" },
    { code: "BR.13.2102358", name: "Buritirana" },
    { code: "BR.13.2102374", name: "Cachoeira Grande" },
    { code: "BR.13.2102408", name: "Cajapió" },
    { code: "BR.13.2102507", name: "Cajari" },
    { code: "BR.13.2102556", name: "Campestre do Maranhão" },
    { code: "BR.13.2102606", name: "Cândido Mendes" },
    { code: "BR.13.2102705", name: "Cantanhede" },
    { code: "BR.13.2102754", name: "Capinzal do Norte" },
    { code: "BR.13.2102804", name: "Carolina" },
    { code: "BR.13.2102903", name: "Carutapera" },
    { code: "BR.13.2103000", name: "Caxias" },
    { code: "BR.13.2103109", name: "Cedral" },
    { code: "BR.13.2103125", name: "Central do Maranhão" },
    { code: "BR.13.2103158", name: "Centro do Guilherme" },
    { code: "BR.13.2103174", name: "Centro Novo do Maranhão" },
    { code: "BR.13.2103208", name: "Chapadinha" },
    { code: "BR.13.2103257", name: "Cidelândia" },
    { code: "BR.13.2103307", name: "Codó" },
    { code: "BR.13.2103406", name: "Coelho Neto" },
    { code: "BR.13.2103505", name: "Colinas" },
    { code: "BR.13.2103554", name: "Conceição do Lago-Açu" },
    { code: "BR.13.2103604", name: "Coroatá" },
    { code: "BR.13.2103703", name: "Cururupu" },
    { code: "BR.13.2103752", name: "Davinópolis" },
    { code: "BR.13.2103802", name: "Dom Pedro" },
    { code: "BR.13.2103901", name: "Duque Bacelar" },
    { code: "BR.13.2104008", name: "Esperantinópolis" },
    { code: "BR.13.2104057", name: "Estreito" },
    { code: "BR.13.2104073", name: "Feira Nova do Maranhão" },
    { code: "BR.13.2104081", name: "Fernando Falcão" },
    { code: "BR.13.2104099", name: "Formosa da Serra Negra" },
    { code: "BR.13.2104107", name: "Fortaleza dos Nogueiras" },
    { code: "BR.13.2104206", name: "Fortuna" },
    { code: "BR.13.2104305", name: "Godofredo Viana" },
    { code: "BR.13.2104404", name: "Gonçalves Dias" },
    { code: "BR.13.2104503", name: "Governador Archer" },
    { code: "BR.13.2104552", name: "Governador Edison Lobão" },
    { code: "BR.13.2104602", name: "Governador Eugênio Barros" },
    { code: "BR.13.2104628", name: "Governador Luiz Rocha" },
    { code: "BR.13.2104651", name: "Governador Newton Bello" },
    { code: "BR.13.2104677", name: "Governador Nunes Freire" },
    { code: "BR.13.2104701", name: "Graça Aranha" },
    { code: "BR.13.2104800", name: "Grajaú" },
    { code: "BR.13.2104909", name: "Guimarães" },
    { code: "BR.13.2105005", name: "Humberto de Campos" },
    { code: "BR.13.2105104", name: "Icatu" },
    { code: "BR.13.2105153", name: "Igarapé do Meio" },
    { code: "BR.13.2105203", name: "Igarapé Grande" },
    { code: "BR.13.2105302", name: "Imperatriz" },
    { code: "BR.13.2105351", name: "Itaipava do Grajaú" },
    { code: "BR.13.2105401", name: "Itapecuru Mirim" },
    { code: "BR.13.2105427", name: "Itinga do Maranhão" },
    { code: "BR.13.2105450", name: "Jatobá" },
    { code: "BR.13.2105476", name: "Jenipapo dos Vieiras" },
    { code: "BR.13.2105500", name: "João Lisboa" },
    { code: "BR.13.2105609", name: "Joselândia" },
    { code: "BR.13.2105658", name: "Junco do Maranhão" },
    { code: "BR.13.2105708", name: "Lago da Pedra" },
    { code: "BR.13.2105807", name: "Lago do Junco" },
    { code: "BR.13.2105906", name: "Lago Verde" },
    { code: "BR.13.2105922", name: "Lagoa do Mato" },
    { code: "BR.13.2105948", name: "Lago dos Rodrigues" },
    { code: "BR.13.2105963", name: "Lagoa Grande do Maranhão" },
    { code: "BR.13.2105989", name: "Lajeado Novo" },
    { code: "BR.13.2106003", name: "Lima Campos" },
    { code: "BR.13.2106102", name: "Loreto" },
    { code: "BR.13.2106201", name: "Luís Domingues" },
    { code: "BR.13.2106300", name: "Magalhães de Almeida" },
    { code: "BR.13.2106326", name: "Maracaçumé" },
    { code: "BR.13.2106359", name: "Marajá do Sena" },
    { code: "BR.13.2106375", name: "Maranhãozinho" },
    { code: "BR.13.2106409", name: "Mata Roma" },
    { code: "BR.13.2106508", name: "Matinha" },
    { code: "BR.13.2106607", name: "Matões" },
    { code: "BR.13.2106631", name: "Matões do Norte" },
    { code: "BR.13.2106672", name: "Milagres do Maranhão" },
    { code: "BR.13.2106706", name: "Mirador" },
    { code: "BR.13.2106755", name: "Miranda do Norte" },
    { code: "BR.13.2106805", name: "Mirinzal" },
    { code: "BR.13.2106904", name: "Monção" },
    { code: "BR.13.2107001", name: "Montes Altos" },
    { code: "BR.13.2107100", name: "Morros" },
    { code: "BR.13.2107209", name: "Nina Rodrigues" },
    { code: "BR.13.2107258", name: "Nova Colinas" },
    { code: "BR.13.2107308", name: "Nova Iorque" },
    { code: "BR.13.2107357", name: "Nova Olinda do Maranhão" },
    { code: "BR.13.2107407", name: "Olho d'Água das Cunhãs" },
    { code: "BR.13.2107456", name: "Olinda Nova do Maranhão" },
    { code: "BR.13.2107506", name: "Paço do Lumiar" },
    { code: "BR.13.2107605", name: "Palmeirândia" },
    { code: "BR.13.2107704", name: "Paraibano" },
    { code: "BR.13.2107803", name: "Parnarama" },
    { code: "BR.13.2107902", name: "Passagem Franca" },
    { code: "BR.13.2108009", name: "Pastos Bons" },
    { code: "BR.13.2108058", name: "Paulino Neves" },
    { code: "BR.13.2108108", name: "Paulo Ramos" },
    { code: "BR.13.2108207", name: "Pedreiras" },
    { code: "BR.13.2108256", name: "Pedro do Rosário" },
    { code: "BR.13.2108306", name: "Penalva" },
    { code: "BR.13.2108405", name: "Peri Mirim" },
    { code: "BR.13.2108454", name: "Peritoró" },
    { code: "BR.13.2108504", name: "Pindaré-Mirim" },
    { code: "BR.13.2108603", name: "Pinheiro" },
    { code: "BR.13.2108702", name: "Pio XII" },
    { code: "BR.13.2108801", name: "Pirapemas" },
    { code: "BR.13.2108900", name: "Poção de Pedras" },
    { code: "BR.13.2109007", name: "Porto Franco" },
    { code: "BR.13.2109056", name: "Porto Rico do Maranhão" },
    { code: "BR.13.2109106", name: "Presidente Dutra" },
    { code: "BR.13.2109205", name: "Presidente Juscelino" },
    { code: "BR.13.2109239", name: "Presidente Médici" },
    { code: "BR.13.2109270", name: "Presidente Sarney" },
    { code: "BR.13.2109304", name: "Presidente Vargas" },
    { code: "BR.13.2109403", name: "Primeira Cruz" },
    { code: "BR.13.2109452", name: "Raposa" },
    { code: "BR.13.2109502", name: "Riachão" },
    { code: "BR.13.2109551", name: "Ribamar Fiquene" },
    { code: "BR.13.2109601", name: "Rosário" },
    { code: "BR.13.2109700", name: "Sambaíba" },
    { code: "BR.13.2109759", name: "Santa Filomena do Maranhão" },
    { code: "BR.13.2109809", name: "Santa Helena" },
    { code: "BR.13.2109908", name: "Santa Inês" },
    { code: "BR.13.2110005", name: "Santa Luzia" },
    { code: "BR.13.2110039", name: "Santa Luzia do Paruá" },
    { code: "BR.13.2110104", name: "Santa Quitéria do Maranhão" },
    { code: "BR.13.2110203", name: "Santa Rita" },
    { code: "BR.13.2110237", name: "Santana do Maranhão" },
    { code: "BR.13.2110278", name: "Santo Amaro do Maranhão" },
    { code: "BR.13.2110302", name: "Santo Antônio dos Lopes" },
    { code: "BR.13.2110401", name: "São Benedito do Rio Preto" },
    { code: "BR.13.2110500", name: "São Bento" },
    { code: "BR.13.2110609", name: "São Bernardo" },
    { code: "BR.13.2110658", name: "São Domingos do Azeitão" },
    { code: "BR.13.2110708", name: "São Domingos do Maranhão" },
    { code: "BR.13.2110807", name: "São Félix de Balsas" },
    { code: "BR.13.2110856", name: "São Francisco do Brejão" },
    { code: "BR.13.2110906", name: "São Francisco do Maranhão" },
    { code: "BR.13.2111003", name: "São João Batista" },
    { code: "BR.13.2111029", name: "São João do Carú" },
    { code: "BR.13.2111052", name: "São João do Paraíso" },
    { code: "BR.13.2111078", name: "São João do Soter" },
    { code: "BR.13.2111102", name: "São João dos Patos" },
    { code: "BR.13.2111201", name: "São José de Ribamar" },
    { code: "BR.13.2111250", name: "São José dos Basílios" },
    { code: "BR.13.2111300", name: "São Luís" },
    { code: "BR.13.2111409", name: "São Luís Gonzaga do Maranhão" },
    { code: "BR.13.2111508", name: "São Mateus do Maranhão" },
    { code: "BR.13.2111532", name: "São Pedro da Água Branca" },
    { code: "BR.13.2111573", name: "São Pedro dos Crentes" },
    { code: "BR.13.2111607", name: "São Raimundo das Mangabeiras" },
    { code: "BR.13.2111631", name: "São Raimundo do Doca Bezerra" },
    { code: "BR.13.2111672", name: "São Roberto" },
    { code: "BR.13.2111706", name: "São Vicente Ferrer" },
    { code: "BR.13.2111722", name: "Satubinha" },
    { code: "BR.13.2111748", name: "Senador Alexandre Costa" },
    { code: "BR.13.2111763", name: "Senador La Rocque" },
    { code: "BR.13.2111789", name: "Serrano do Maranhão" },
    { code: "BR.13.2111805", name: "Sítio Novo" },
    { code: "BR.13.2111904", name: "Sucupira do Norte" },
    { code: "BR.13.2111953", name: "Sucupira do Riachão" },
    { code: "BR.13.2112001", name: "Tasso Fragoso" },
    { code: "BR.13.2112100", name: "Timbiras" },
    { code: "BR.13.2112209", name: "Timon" },
    { code: "BR.13.2112233", name: "Trizidela do Vale" },
    { code: "BR.13.2112274", name: "Tufilândia" },
    { code: "BR.13.2112308", name: "Tuntum" },
    { code: "BR.13.2112407", name: "Turiaçu" },
    { code: "BR.13.2112456", name: "Turilândia" },
    { code: "BR.13.2112506", name: "Tutóia" },
    { code: "BR.13.2112605", name: "Urbano Santos" },
    { code: "BR.13.2112704", name: "Vargem Grande" },
    { code: "BR.13.2112803", name: "Viana" },
    { code: "BR.13.2112852", name: "Vila Nova dos Martírios" },
    { code: "BR.13.2112902", name: "Vitória do Mearim" },
    { code: "BR.13.2113009", name: "Vitorino Freire" },
    { code: "BR.13.2114007", name: "Zé Doca" },
  ],
  "BR.14": [
    { code: "BR.14.5100102", name: "Acorizal" },
    { code: "BR.14.5100201", name: "Água Boa" },
    { code: "BR.14.5100250", name: "Alta Floresta" },
    { code: "BR.14.5100300", name: "Alto Araguaia" },
    { code: "BR.14.5100359", name: "Alto Boa Vista" },
    { code: "BR.14.5100409", name: "Alto Garças" },
    { code: "BR.14.5100508", name: "Alto Paraguai" },
    { code: "BR.14.5100607", name: "Alto Taquari" },
    { code: "BR.14.5100805", name: "Apiacás" },
    { code: "BR.14.5101001", name: "Araguaiana" },
    { code: "BR.14.5101209", name: "Araguainha" },
    { code: "BR.14.5101258", name: "Araputanga" },
    { code: "BR.14.5101308", name: "Arenápolis" },
    { code: "BR.14.5101407", name: "Aripuanã" },
    { code: "BR.14.5101605", name: "Barão de Melgaço" },
    { code: "BR.14.5101704", name: "Barra do Bugres" },
    { code: "BR.14.5101803", name: "Barra do Garças" },
    { code: "BR.14.5101852", name: "Bom Jesus do Araguaia" },
    { code: "BR.14.5101902", name: "Brasnorte" },
    { code: "BR.14.5102504", name: "Cáceres" },
    { code: "BR.14.5102603", name: "Campinápolis" },
    { code: "BR.14.5102637", name: "Campo Novo do Parecis" },
    { code: "BR.14.5102678", name: "Campo Verde" },
    { code: "BR.14.5102686", name: "Campos de Júlio" },
    { code: "BR.14.5102694", name: "CanaBrava do Norte" },
    { code: "BR.14.5102702", name: "Canarana" },
    { code: "BR.14.5102793", name: "Carlinda" },
    { code: "BR.14.5102850", name: "Castanheira" },
    { code: "BR.14.5103007", name: "Chapada dos Guimarães" },
    { code: "BR.14.5103056", name: "Cláudia" },
    { code: "BR.14.5103106", name: "Cocalinho" },
    { code: "BR.14.5103205", name: "Colíder" },
    { code: "BR.14.5103254", name: "Colniza" },
    { code: "BR.14.5103304", name: "Comodoro" },
    { code: "BR.14.5103353", name: "Confresa" },
    { code: "BR.14.5103361", name: "Conquista D'oeste" },
    { code: "BR.14.5103379", name: "Cotriguaçu" },
    { code: "BR.14.5103403", name: "Cuiabá" },
    { code: "BR.14.5103437", name: "Curvelândia" },
    { code: "BR.14.5103452", name: "Denise" },
    { code: "BR.14.5103502", name: "Diamantino" },
    { code: "BR.14.5103601", name: "Dom Aquino" },
    { code: "BR.14.5103700", name: "Feliz Natal" },
    { code: "BR.14.5103809", name: "Figueirópolis d'Oeste" },
    { code: "BR.14.5103858", name: "Gaúcha do Norte" },
    { code: "BR.14.5103908", name: "General Carneiro" },
    { code: "BR.14.5103957", name: "Glória d'Oeste" },
    { code: "BR.14.5104104", name: "Guarantã do Norte" },
    { code: "BR.14.5104203", name: "Guiratinga" },
    { code: "BR.14.5104500", name: "Indiavaí" },
    { code: "BR.14.5104526", name: "Ipiranga do Norte" },
    { code: "BR.14.5104542", name: "Itanhangá" },
    { code: "BR.14.5104559", name: "Itaúba" },
    { code: "BR.14.5104609", name: "Itiquira" },
    { code: "BR.14.5104807", name: "Jaciara" },
    { code: "BR.14.5104906", name: "Jangada" },
    { code: "BR.14.5105002", name: "Jauru" },
    { code: "BR.14.5105101", name: "Juara" },
    { code: "BR.14.5105150", name: "Juína" },
    { code: "BR.14.5105176", name: "Juruena" },
    { code: "BR.14.5105200", name: "Juscimeira" },
    { code: "BR.14.5105234", name: "Lambari d'Oeste" },
    { code: "BR.14.5105259", name: "Lucas do Rio Verde" },
    { code: "BR.14.5105309", name: "Luciara" },
    { code: "BR.14.5105507", name: "Vila Bela da Santíssima Trindade" },
    { code: "BR.14.5105580", name: "Marcelândia" },
    { code: "BR.14.5105606", name: "Matupá" },
    { code: "BR.14.5105622", name: "Mirassol d'Oeste" },
    { code: "BR.14.5105903", name: "Nobres" },
    { code: "BR.14.5106000", name: "Nortelândia" },
    { code: "BR.14.5106109", name: "Nossa Senhora do Livramento" },
    { code: "BR.14.5106158", name: "Nova Bandeirantes" },
    { code: "BR.14.5106174", name: "Nova Nazaré" },
    { code: "BR.14.5106182", name: "Nova Lacerda" },
    { code: "BR.14.5106190", name: "Nova Santa Helena" },
    { code: "BR.14.5106208", name: "Nova Brasilândia" },
    { code: "BR.14.5106216", name: "Nova Canaã do Norte" },
    { code: "BR.14.5106224", name: "Nova Mutum" },
    { code: "BR.14.5106232", name: "Nova Olímpia" },
    { code: "BR.14.5106240", name: "Nova Ubiratã" },
    { code: "BR.14.5106257", name: "Nova Xavantina" },
    { code: "BR.14.5106265", name: "Novo Mundo" },
    { code: "BR.14.5106273", name: "Novo Horizonte do Norte" },
    { code: "BR.14.5106281", name: "Novo São Joaquim" },
    { code: "BR.14.5106299", name: "Paranaíta" },
    { code: "BR.14.5106307", name: "Paranatinga" },
    { code: "BR.14.5106315", name: "Novo Santo Antônio" },
    { code: "BR.14.5106372", name: "Pedra Preta" },
    { code: "BR.14.5106422", name: "Peixoto de Azevedo" },
    { code: "BR.14.5106455", name: "Planalto da Serra" },
    { code: "BR.14.5106505", name: "Poconé" },
    { code: "BR.14.5106653", name: "Pontal do Araguaia" },
    { code: "BR.14.5106703", name: "Ponte Branca" },
    { code: "BR.14.5106752", name: "Pontes e Lacerda" },
    { code: "BR.14.5106778", name: "Porto Alegre do Norte" },
    { code: "BR.14.5106802", name: "Porto dos Gaúchos" },
    { code: "BR.14.5106828", name: "Porto Esperidião" },
    { code: "BR.14.5106851", name: "Porto Estrela" },
    { code: "BR.14.5107008", name: "Poxoréu" },
    { code: "BR.14.5107040", name: "Primavera do Leste" },
    { code: "BR.14.5107065", name: "Querência" },
    { code: "BR.14.5107107", name: "São José dos Quatro Marcos" },
    { code: "BR.14.5107156", name: "Reserva do Cabaçal" },
    { code: "BR.14.5107180", name: "Ribeirão Cascalheira" },
    { code: "BR.14.5107198", name: "Ribeirãozinho" },
    { code: "BR.14.5107206", name: "Rio Branco" },
    { code: "BR.14.5107248", name: "Santa Carmem" },
    { code: "BR.14.5107263", name: "Santo Afonso" },
    { code: "BR.14.5107297", name: "São José do Povo" },
    { code: "BR.14.5107305", name: "São José do Rio Claro" },
    { code: "BR.14.5107354", name: "São José do Xingu" },
    { code: "BR.14.5107404", name: "São Pedro da Cipa" },
    { code: "BR.14.5107578", name: "Rondolândia" },
    { code: "BR.14.5107602", name: "Rondonópolis" },
    { code: "BR.14.5107701", name: "Rosário Oeste" },
    { code: "BR.14.5107743", name: "Santa Cruz do Xingu" },
    { code: "BR.14.5107750", name: "Salto do Céu" },
    { code: "BR.14.5107768", name: "Santa Rita do Trivelato" },
    { code: "BR.14.5107776", name: "Santa Terezinha" },
    { code: "BR.14.5107792", name: "Santo Antônio do Leste" },
    { code: "BR.14.5107800", name: "Santo Antônio do Leverger" },
    { code: "BR.14.5107859", name: "São Félix do Araguaia" },
    { code: "BR.14.5107875", name: "Sapezal" },
    { code: "BR.14.5107883", name: "Serra Nova Dourada" },
    { code: "BR.14.5107909", name: "Sinop" },
    { code: "BR.14.5107925", name: "Sorriso" },
    { code: "BR.14.5107941", name: "Tabaporã" },
    { code: "BR.14.5107958", name: "Tangará da Serra" },
    { code: "BR.14.5108006", name: "Tapurah" },
    { code: "BR.14.5108055", name: "Terra Nova do Norte" },
    { code: "BR.14.5108105", name: "Tesouro" },
    { code: "BR.14.5108204", name: "Torixoréu" },
    { code: "BR.14.5108303", name: "União do Sul" },
    { code: "BR.14.5108352", name: "Vale de São Domingos" },
    { code: "BR.14.5108402", name: "Várzea Grande" },
    { code: "BR.14.5108501", name: "Vera" },
    { code: "BR.14.5108600", name: "Vila Rica" },
    { code: "BR.14.5108808", name: "Nova Guarita" },
    { code: "BR.14.5108857", name: "Nova Marilândia" },
    { code: "BR.14.5108907", name: "Nova Maringá" },
    { code: "BR.14.5108956", name: "Nova Monte Verde" },
  ],
  "BR.15": [
    { code: "BR.15.3100104", name: "Abadia dos Dourados" },
    { code: "BR.15.3100203", name: "Abaeté" },
    { code: "BR.15.3100302", name: "Abre Campo" },
    { code: "BR.15.3100401", name: "Acaiaca" },
    { code: "BR.15.3100500", name: "Açucena" },
    { code: "BR.15.3100609", name: "Água Boa" },
    { code: "BR.15.3100708", name: "Água Comprida" },
    { code: "BR.15.3100807", name: "Aguanil" },
    { code: "BR.15.3100906", name: "Águas Formosas" },
    { code: "BR.15.3101003", name: "Águas Vermelhas" },
    { code: "BR.15.3101102", name: "Aimorés" },
    { code: "BR.15.3101201", name: "Aiuruoca" },
    { code: "BR.15.3101300", name: "Alagoa" },
    { code: "BR.15.3101409", name: "Albertina" },
    { code: "BR.15.3101508", name: "Além Paraíba" },
    { code: "BR.15.3101607", name: "Alfenas" },
    { code: "BR.15.3101631", name: "Alfredo Vasconcelos" },
    { code: "BR.15.3101706", name: "Almenara" },
    { code: "BR.15.3101805", name: "Alpercata" },
    { code: "BR.15.3101904", name: "Alpinópolis" },
    { code: "BR.15.3102001", name: "Alterosa" },
    { code: "BR.15.3102050", name: "Alto Caparaó" },
    { code: "BR.15.3102100", name: "Alto Rio Doce" },
    { code: "BR.15.3102209", name: "Alvarenga" },
    { code: "BR.15.3102308", name: "Alvinópolis" },
    { code: "BR.15.3102407", name: "Alvorada de Minas" },
    { code: "BR.15.3102506", name: "Amparo da Serra" },
    { code: "BR.15.3102605", name: "Andradas" },
    { code: "BR.15.3102704", name: "Cachoeira de Pajeú" },
    { code: "BR.15.3102803", name: "Andrelândia" },
    { code: "BR.15.3102852", name: "Angelândia" },
    { code: "BR.15.3102902", name: "Antônio Carlos" },
    { code: "BR.15.3103009", name: "Antônio Dias" },
    { code: "BR.15.3103108", name: "Antônio Prado de Minas" },
    { code: "BR.15.3103207", name: "Araçaí" },
    { code: "BR.15.3103306", name: "Aracitaba" },
    { code: "BR.15.3103405", name: "Araçuaí" },
    { code: "BR.15.3103504", name: "Araguari" },
    { code: "BR.15.3103603", name: "Arantina" },
    { code: "BR.15.3103702", name: "Araponga" },
    { code: "BR.15.3103751", name: "Araporã" },
    { code: "BR.15.3103801", name: "Arapuá" },
    { code: "BR.15.3103900", name: "Araújos" },
    { code: "BR.15.3104007", name: "Araxá" },
    { code: "BR.15.3104106", name: "Arceburgo" },
    { code: "BR.15.3104205", name: "Arcos" },
    { code: "BR.15.3104304", name: "Areado" },
    { code: "BR.15.3104403", name: "Argirita" },
    { code: "BR.15.3104452", name: "Aricanduva" },
    { code: "BR.15.3104502", name: "Arinos" },
    { code: "BR.15.3104601", name: "Astolfo Dutra" },
    { code: "BR.15.3104700", name: "Ataléia" },
    { code: "BR.15.3104809", name: "Augusto de Lima" },
    { code: "BR.15.3104908", name: "Baependi" },
    { code: "BR.15.3105004", name: "Baldim" },
    { code: "BR.15.3105103", name: "Bambuí" },
    { code: "BR.15.3105202", name: "Bandeira" },
    { code: "BR.15.3105301", name: "Bandeira do Sul" },
    { code: "BR.15.3105400", name: "Barão de Cocais" },
    { code: "BR.15.3105509", name: "Barão de Monte Alto" },
    { code: "BR.15.3105608", name: "Barbacena" },
    { code: "BR.15.3105707", name: "Barra Longa" },
    { code: "BR.15.3105905", name: "Barroso" },
    { code: "BR.15.3106002", name: "Bela Vista de Minas" },
    { code: "BR.15.3106101", name: "Belmiro Braga" },
    { code: "BR.15.3106200", name: "Belo Horizonte" },
    { code: "BR.15.3106309", name: "Belo Oriente" },
    { code: "BR.15.3106408", name: "Belo Vale" },
    { code: "BR.15.3106507", name: "Berilo" },
    { code: "BR.15.3106606", name: "Bertópolis" },
    { code: "BR.15.3106655", name: "Berizal" },
    { code: "BR.15.3106705", name: "Betim" },
    { code: "BR.15.3106804", name: "Bias Fortes" },
    { code: "BR.15.3106903", name: "Bicas" },
    { code: "BR.15.3107000", name: "Biquinhas" },
    { code: "BR.15.3107109", name: "Boa Esperança" },
    { code: "BR.15.3107208", name: "Bocaina de Minas" },
    { code: "BR.15.3107307", name: "Bocaiúva" },
    { code: "BR.15.3107406", name: "Bom Despacho" },
    { code: "BR.15.3107505", name: "Bom Jardim de Minas" },
    { code: "BR.15.3107604", name: "Bom Jesus da Penha" },
    { code: "BR.15.3107703", name: "Bom Jesus do Amparo" },
    { code: "BR.15.3107802", name: "Bom Jesus do Galho" },
    { code: "BR.15.3107901", name: "Bom Repouso" },
    { code: "BR.15.3108008", name: "Bom Sucesso" },
    { code: "BR.15.3108107", name: "Bonfim" },
    { code: "BR.15.3108206", name: "Bonfinópolis de Minas" },
    { code: "BR.15.3108255", name: "Bonito de Minas" },
    { code: "BR.15.3108305", name: "Borda da Mata" },
    { code: "BR.15.3108404", name: "Botelhos" },
    { code: "BR.15.3108503", name: "Botumirim" },
    { code: "BR.15.3108552", name: "Brasilândia de Minas" },
    { code: "BR.15.3108602", name: "Brasília de Minas" },
    { code: "BR.15.3108701", name: "Brás Pires" },
    { code: "BR.15.3108800", name: "Braúnas" },
    { code: "BR.15.3108909", name: "Brazópolis" },
    { code: "BR.15.3109006", name: "Brumadinho" },
    { code: "BR.15.3109105", name: "Bueno Brandão" },
    { code: "BR.15.3109204", name: "Buenópolis" },
    { code: "BR.15.3109253", name: "Bugre" },
    { code: "BR.15.3109303", name: "Buritis" },
    { code: "BR.15.3109402", name: "Buritizeiro" },
    { code: "BR.15.3109451", name: "Cabeceira Grande" },
    { code: "BR.15.3109501", name: "Cabo Verde" },
    { code: "BR.15.3109600", name: "Cachoeira da Prata" },
    { code: "BR.15.3109709", name: "Cachoeira de Minas" },
    { code: "BR.15.3109808", name: "Cachoeira Dourada" },
    { code: "BR.15.3109907", name: "Caetanópolis" },
    { code: "BR.15.3110004", name: "Caeté" },
    { code: "BR.15.3110103", name: "Caiana" },
    { code: "BR.15.3110202", name: "Cajuri" },
    { code: "BR.15.3110301", name: "Caldas" },
    { code: "BR.15.3110400", name: "Camacho" },
    { code: "BR.15.3110509", name: "Camanducaia" },
    { code: "BR.15.3110608", name: "Cambuí" },
    { code: "BR.15.3110707", name: "Cambuquira" },
    { code: "BR.15.3110806", name: "Campanário" },
    { code: "BR.15.3110905", name: "Campanha" },
    { code: "BR.15.3111002", name: "Campestre" },
    { code: "BR.15.3111101", name: "Campina Verde" },
    { code: "BR.15.3111150", name: "Campo Azul" },
    { code: "BR.15.3111200", name: "Campo Belo" },
    { code: "BR.15.3111309", name: "Campo do Meio" },
    { code: "BR.15.3111408", name: "Campo Florido" },
    { code: "BR.15.3111507", name: "Campos Altos" },
    { code: "BR.15.3111606", name: "Campos Gerais" },
    { code: "BR.15.3111705", name: "Canaã" },
    { code: "BR.15.3111804", name: "Canápolis" },
    { code: "BR.15.3111903", name: "Cana Verde" },
    { code: "BR.15.3112000", name: "Candeias" },
    { code: "BR.15.3112059", name: "Cantagalo" },
    { code: "BR.15.3112109", name: "Caparaó" },
    { code: "BR.15.3112208", name: "Capela Nova" },
    { code: "BR.15.3112307", name: "Capelinha" },
    { code: "BR.15.3112406", name: "Capetinga" },
    { code: "BR.15.3112505", name: "Capim Branco" },
    { code: "BR.15.3112604", name: "Capinópolis" },
    { code: "BR.15.3112653", name: "Capitão Andrade" },
    { code: "BR.15.3112703", name: "Capitão Enéas" },
    { code: "BR.15.3112802", name: "Capitólio" },
    { code: "BR.15.3112901", name: "Caputira" },
    { code: "BR.15.3113008", name: "Caraí" },
    { code: "BR.15.3113107", name: "Caranaíba" },
    { code: "BR.15.3113206", name: "Carandaí" },
    { code: "BR.15.3113305", name: "Carangola" },
    { code: "BR.15.3113404", name: "Caratinga" },
    { code: "BR.15.3113503", name: "Carbonita" },
    { code: "BR.15.3113602", name: "Careaçu" },
    { code: "BR.15.3113701", name: "Carlos Chagas" },
    { code: "BR.15.3113800", name: "Carmésia" },
    { code: "BR.15.3113909", name: "Carmo da Cachoeira" },
    { code: "BR.15.3114006", name: "Carmo da Mata" },
    { code: "BR.15.3114105", name: "Carmo de Minas" },
    { code: "BR.15.3114204", name: "Carmo do Cajuru" },
    { code: "BR.15.3114303", name: "Carmo do Paranaíba" },
    { code: "BR.15.3114402", name: "Carmo do Rio Claro" },
    { code: "BR.15.3114501", name: "Carmópolis de Minas" },
    { code: "BR.15.3114550", name: "Carneirinho" },
    { code: "BR.15.3114600", name: "Carrancas" },
    { code: "BR.15.3114709", name: "Carvalhópolis" },
    { code: "BR.15.3114808", name: "Carvalhos" },
    { code: "BR.15.3114907", name: "Casa Grande" },
    { code: "BR.15.3115003", name: "Cascalho Rico" },
    { code: "BR.15.3115102", name: "Cássia" },
    { code: "BR.15.3115201", name: "Conceição da Barra de Minas" },
    { code: "BR.15.3115300", name: "Cataguases" },
    { code: "BR.15.3115359", name: "Catas Altas" },
    { code: "BR.15.3115409", name: "Catas Altas da Noruega" },
    { code: "BR.15.3115458", name: "Catuji" },
    { code: "BR.15.3115474", name: "Catuti" },
    { code: "BR.15.3115508", name: "Caxambu" },
    { code: "BR.15.3115607", name: "Cedro do Abaeté" },
    { code: "BR.15.3115706", name: "Central de Minas" },
    { code: "BR.15.3115805", name: "Centralina" },
    { code: "BR.15.3115904", name: "Chácara" },
    { code: "BR.15.3116001", name: "Chalé" },
    { code: "BR.15.3116100", name: "Chapada do Norte" },
    { code: "BR.15.3116159", name: "Chapada Gaúcha" },
    { code: "BR.15.3116209", name: "Chiador" },
    { code: "BR.15.3116308", name: "Cipotânea" },
    { code: "BR.15.3116407", name: "Claraval" },
    { code: "BR.15.3116506", name: "Claro dos Poções" },
    { code: "BR.15.3116605", name: "Cláudio" },
    { code: "BR.15.3116704", name: "Coimbra" },
    { code: "BR.15.3116803", name: "Coluna" },
    { code: "BR.15.3116902", name: "Comendador Gomes" },
    { code: "BR.15.3117009", name: "Comercinho" },
    { code: "BR.15.3117108", name: "Conceição da Aparecida" },
    { code: "BR.15.3117207", name: "Conceição das Pedras" },
    { code: "BR.15.3117306", name: "Conceição das Alagoas" },
    { code: "BR.15.3117405", name: "Conceição de Ipanema" },
    { code: "BR.15.3117504", name: "Conceição do Mato Dentro" },
    { code: "BR.15.3117603", name: "Conceição do Pará" },
    { code: "BR.15.3117702", name: "Conceição do Rio Verde" },
    { code: "BR.15.3117801", name: "Conceição dos Ouros" },
    { code: "BR.15.3117836", name: "Cônego Marinho" },
    { code: "BR.15.3117876", name: "Confins" },
    { code: "BR.15.3117900", name: "Congonhal" },
    { code: "BR.15.3118007", name: "Congonhas" },
    { code: "BR.15.3118106", name: "Congonhas do Norte" },
    { code: "BR.15.3118205", name: "Conquista" },
    { code: "BR.15.3118304", name: "Conselheiro Lafaiete" },
    { code: "BR.15.3118403", name: "Conselheiro Pena" },
    { code: "BR.15.3118502", name: "Consolação" },
    { code: "BR.15.3118601", name: "Contagem" },
    { code: "BR.15.3118700", name: "Coqueiral" },
    { code: "BR.15.3118809", name: "Coração de Jesus" },
    { code: "BR.15.3118908", name: "Cordisburgo" },
    { code: "BR.15.3119005", name: "Cordislândia" },
    { code: "BR.15.3119104", name: "Corinto" },
    { code: "BR.15.3119203", name: "Coroaci" },
    { code: "BR.15.3119302", name: "Coromandel" },
    { code: "BR.15.3119401", name: "Coronel Fabriciano" },
    { code: "BR.15.3119500", name: "Coronel Murta" },
    { code: "BR.15.3119609", name: "Coronel Pacheco" },
    { code: "BR.15.3119708", name: "Coronel Xavier Chaves" },
    { code: "BR.15.3119807", name: "Córrego Danta" },
    { code: "BR.15.3119906", name: "Córrego do Bom Jesus" },
    { code: "BR.15.3119955", name: "Córrego Fundo" },
    { code: "BR.15.3120003", name: "Córrego Novo" },
    { code: "BR.15.3120102", name: "Couto de Magalhães de Minas" },
    { code: "BR.15.3120151", name: "Crisólita" },
    { code: "BR.15.3120201", name: "Cristais" },
    { code: "BR.15.3120300", name: "Cristália" },
    { code: "BR.15.3120409", name: "Cristiano Otoni" },
    { code: "BR.15.3120508", name: "Cristina" },
    { code: "BR.15.3120607", name: "Crucilândia" },
    { code: "BR.15.3120706", name: "Cruzeiro da Fortaleza" },
    { code: "BR.15.3120805", name: "Cruzília" },
    { code: "BR.15.3120839", name: "Cuparaque" },
    { code: "BR.15.3120870", name: "Curral de Dentro" },
    { code: "BR.15.3120904", name: "Curvelo" },
    { code: "BR.15.3121001", name: "Datas" },
    { code: "BR.15.3121100", name: "Delfim Moreira" },
    { code: "BR.15.3121209", name: "Delfinópolis" },
    { code: "BR.15.3121258", name: "Delta" },
    { code: "BR.15.3121308", name: "Descoberto" },
    { code: "BR.15.3121407", name: "Desterro de Entre Rios" },
    { code: "BR.15.3121506", name: "Desterro do Melo" },
    { code: "BR.15.3121605", name: "Diamantina" },
    { code: "BR.15.3121704", name: "Diogo de Vasconcelos" },
    { code: "BR.15.3121803", name: "Dionísio" },
    { code: "BR.15.3121902", name: "Divinésia" },
    { code: "BR.15.3122009", name: "Divino" },
    { code: "BR.15.3122108", name: "Divino das Laranjeiras" },
    { code: "BR.15.3122207", name: "Divinolândia de Minas" },
    { code: "BR.15.3122306", name: "Divinópolis" },
    { code: "BR.15.3122355", name: "Divisa Alegre" },
    { code: "BR.15.3122405", name: "Divisa Nova" },
    { code: "BR.15.3122454", name: "Divisópolis" },
    { code: "BR.15.3122470", name: "Dom Bosco" },
    { code: "BR.15.3122504", name: "Dom Cavati" },
    { code: "BR.15.3122603", name: "Dom Joaquim" },
    { code: "BR.15.3122702", name: "Dom Silvério" },
    { code: "BR.15.3122801", name: "Dom Viçoso" },
    { code: "BR.15.3122900", name: "Dona Eusébia" },
    { code: "BR.15.3123007", name: "Dores de Campos" },
    { code: "BR.15.3123106", name: "Dores de Guanhães" },
    { code: "BR.15.3123205", name: "Dores do Indaiá" },
    { code: "BR.15.3123304", name: "Dores do Turvo" },
    { code: "BR.15.3123403", name: "Doresópolis" },
    { code: "BR.15.3123502", name: "Douradoquara" },
    { code: "BR.15.3123528", name: "Durandé" },
    { code: "BR.15.3123601", name: "Elói Mendes" },
    { code: "BR.15.3123700", name: "Engenheiro Caldas" },
    { code: "BR.15.3123809", name: "Engenheiro Navarro" },
    { code: "BR.15.3123858", name: "Entre Folhas" },
    { code: "BR.15.3123908", name: "Entre Rios de Minas" },
    { code: "BR.15.3124005", name: "Ervália" },
    { code: "BR.15.3124104", name: "Esmeraldas" },
    { code: "BR.15.3124203", name: "Espera Feliz" },
    { code: "BR.15.3124302", name: "Espinosa" },
    { code: "BR.15.3124401", name: "Espírito Santo do Dourado" },
    { code: "BR.15.3124500", name: "Estiva" },
    { code: "BR.15.3124609", name: "Estrela Dalva" },
    { code: "BR.15.3124708", name: "Estrela do Indaiá" },
    { code: "BR.15.3124807", name: "Estrela do Sul" },
    { code: "BR.15.3124906", name: "Eugenópolis" },
    { code: "BR.15.3125002", name: "Ewbank da Câmara" },
    { code: "BR.15.3125101", name: "Extrema" },
    { code: "BR.15.3125200", name: "Fama" },
    { code: "BR.15.3125309", name: "Faria Lemos" },
    { code: "BR.15.3125408", name: "Felício dos Santos" },
    { code: "BR.15.3125507", name: "São Gonçalo do Rio Preto" },
    { code: "BR.15.3125606", name: "Felisburgo" },
    { code: "BR.15.3125705", name: "Felixlândia" },
    { code: "BR.15.3125804", name: "Fernandes Tourinho" },
    { code: "BR.15.3125903", name: "Ferros" },
    { code: "BR.15.3125952", name: "Fervedouro" },
    { code: "BR.15.3126000", name: "Florestal" },
    { code: "BR.15.3126109", name: "Formiga" },
    { code: "BR.15.3126208", name: "Formoso" },
    { code: "BR.15.3126307", name: "Fortaleza de Minas" },
    { code: "BR.15.3126406", name: "Fortuna de Minas" },
    { code: "BR.15.3126505", name: "Francisco Badaró" },
    { code: "BR.15.3126604", name: "Francisco Dumont" },
    { code: "BR.15.3126703", name: "Francisco Sá" },
    { code: "BR.15.3126752", name: "Franciscópolis" },
    { code: "BR.15.3126802", name: "Frei Gaspar" },
    { code: "BR.15.3126901", name: "Frei Inocêncio" },
    { code: "BR.15.3126950", name: "Frei Lagonegro" },
    { code: "BR.15.3127008", name: "Fronteira" },
    { code: "BR.15.3127057", name: "Fronteira dos Vales" },
    { code: "BR.15.3127073", name: "Fruta de Leite" },
    { code: "BR.15.3127107", name: "Frutal" },
    { code: "BR.15.3127206", name: "Funilândia" },
    { code: "BR.15.3127305", name: "Galiléia" },
    { code: "BR.15.3127339", name: "Gameleiras" },
    { code: "BR.15.3127354", name: "Glaucilândia" },
    { code: "BR.15.3127370", name: "Goiabeira" },
    { code: "BR.15.3127388", name: "Goianá" },
    { code: "BR.15.3127404", name: "Gonçalves" },
    { code: "BR.15.3127503", name: "Gonzaga" },
    { code: "BR.15.3127602", name: "Gouveia" },
    { code: "BR.15.3127701", name: "Governador Valadares" },
    { code: "BR.15.3127800", name: "Grão Mogol" },
    { code: "BR.15.3127909", name: "Grupiara" },
    { code: "BR.15.3128006", name: "Guanhães" },
    { code: "BR.15.3128105", name: "Guapé" },
    { code: "BR.15.3128204", name: "Guaraciaba" },
    { code: "BR.15.3128253", name: "Guaraciama" },
    { code: "BR.15.3128303", name: "Guaranésia" },
    { code: "BR.15.3128402", name: "Guarani" },
    { code: "BR.15.3128501", name: "Guarará" },
    { code: "BR.15.3128600", name: "Guarda-Mor" },
    { code: "BR.15.3128709", name: "Guaxupé" },
    { code: "BR.15.3128808", name: "Guidoval" },
    { code: "BR.15.3128907", name: "Guimarânia" },
    { code: "BR.15.3129004", name: "Guiricema" },
    { code: "BR.15.3129103", name: "Gurinhatã" },
    { code: "BR.15.3129202", name: "Heliodora" },
    { code: "BR.15.3129301", name: "Iapu" },
    { code: "BR.15.3129400", name: "Ibertioga" },
    { code: "BR.15.3129509", name: "Ibiá" },
    { code: "BR.15.3129608", name: "Ibiaí" },
    { code: "BR.15.3129657", name: "Ibiracatu" },
    { code: "BR.15.3129707", name: "Ibiraci" },
    { code: "BR.15.3129806", name: "Ibirité" },
    { code: "BR.15.3129905", name: "Ibitiúra de Minas" },
    { code: "BR.15.3130002", name: "Ibituruna" },
    { code: "BR.15.3130051", name: "Icaraí de Minas" },
    { code: "BR.15.3130101", name: "Igarapé" },
    { code: "BR.15.3130200", name: "Igaratinga" },
    { code: "BR.15.3130309", name: "Iguatama" },
    { code: "BR.15.3130408", name: "Ijaci" },
    { code: "BR.15.3130507", name: "Ilicínea" },
    { code: "BR.15.3130556", name: "Imbé de Minas" },
    { code: "BR.15.3130606", name: "Inconfidentes" },
    { code: "BR.15.3130655", name: "Indaiabira" },
    { code: "BR.15.3130705", name: "Indianópolis" },
    { code: "BR.15.3130804", name: "Ingaí" },
    { code: "BR.15.3130903", name: "Inhapim" },
    { code: "BR.15.3131000", name: "Inhaúma" },
    { code: "BR.15.3131109", name: "Inimutaba" },
    { code: "BR.15.3131158", name: "Ipaba" },
    { code: "BR.15.3131208", name: "Ipanema" },
    { code: "BR.15.3131307", name: "Ipatinga" },
    { code: "BR.15.3131406", name: "Ipiaçu" },
    { code: "BR.15.3131505", name: "Ipuiúna" },
    { code: "BR.15.3131604", name: "Iraí de Minas" },
    { code: "BR.15.3131703", name: "Itabira" },
    { code: "BR.15.3131802", name: "Itabirinha" },
    { code: "BR.15.3131901", name: "Itabirito" },
    { code: "BR.15.3132008", name: "Itacambira" },
    { code: "BR.15.3132107", name: "Itacarambi" },
    { code: "BR.15.3132206", name: "Itaguara" },
    { code: "BR.15.3132305", name: "Itaipé" },
    { code: "BR.15.3132404", name: "Itajubá" },
    { code: "BR.15.3132503", name: "Itamarandiba" },
    { code: "BR.15.3132602", name: "Itamarati de Minas" },
    { code: "BR.15.3132701", name: "Itambacuri" },
    { code: "BR.15.3132800", name: "Itambé do Mato Dentro" },
    { code: "BR.15.3132909", name: "Itamogi" },
    { code: "BR.15.3133006", name: "Itamonte" },
    { code: "BR.15.3133105", name: "Itanhandu" },
    { code: "BR.15.3133204", name: "Itanhomi" },
    { code: "BR.15.3133303", name: "Itaobim" },
    { code: "BR.15.3133402", name: "Itapagipe" },
    { code: "BR.15.3133501", name: "Itapecerica" },
    { code: "BR.15.3133600", name: "Itapeva" },
    { code: "BR.15.3133709", name: "Itatiaiuçu" },
    { code: "BR.15.3133758", name: "Itaú de Minas" },
    { code: "BR.15.3133808", name: "Itaúna" },
    { code: "BR.15.3133907", name: "Itaverava" },
    { code: "BR.15.3134004", name: "Itinga" },
    { code: "BR.15.3134103", name: "Itueta" },
    { code: "BR.15.3134202", name: "Ituiutaba" },
    { code: "BR.15.3134301", name: "Itumirim" },
    { code: "BR.15.3134400", name: "Iturama" },
    { code: "BR.15.3134509", name: "Itutinga" },
    { code: "BR.15.3134608", name: "Jaboticatubas" },
    { code: "BR.15.3134707", name: "Jacinto" },
    { code: "BR.15.3134806", name: "Jacuí" },
    { code: "BR.15.3134905", name: "Jacutinga" },
    { code: "BR.15.3135001", name: "Jaguaraçu" },
    { code: "BR.15.3135050", name: "Jaíba" },
    { code: "BR.15.3135076", name: "Jampruca" },
    { code: "BR.15.3135100", name: "Janaúba" },
    { code: "BR.15.3135209", name: "Januária" },
    { code: "BR.15.3135308", name: "Japaraíba" },
    { code: "BR.15.3135357", name: "Japonvar" },
    { code: "BR.15.3135407", name: "Jeceaba" },
    { code: "BR.15.3135456", name: "Jenipapo de Minas" },
    { code: "BR.15.3135506", name: "Jequeri" },
    { code: "BR.15.3135605", name: "Jequitaí" },
    { code: "BR.15.3135704", name: "Jequitibá" },
    { code: "BR.15.3135803", name: "Jequitinhonha" },
    { code: "BR.15.3135902", name: "Jesuânia" },
    { code: "BR.15.3136009", name: "Joaíma" },
    { code: "BR.15.3136108", name: "Joanésia" },
    { code: "BR.15.3136207", name: "João Monlevade" },
    { code: "BR.15.3136306", name: "João Pinheiro" },
    { code: "BR.15.3136405", name: "Joaquim Felício" },
    { code: "BR.15.3136504", name: "Jordânia" },
    { code: "BR.15.3136520", name: "José Gonçalves de Minas" },
    { code: "BR.15.3136553", name: "José Raydan" },
    { code: "BR.15.3136579", name: "Josenópolis" },
    { code: "BR.15.3136603", name: "Nova União" },
    { code: "BR.15.3136652", name: "Juatuba" },
    { code: "BR.15.3136702", name: "Juiz de Fora" },
    { code: "BR.15.3136801", name: "Juramento" },
    { code: "BR.15.3136900", name: "Juruaia" },
    { code: "BR.15.3136959", name: "Juvenília" },
    { code: "BR.15.3137007", name: "Ladainha" },
    { code: "BR.15.3137106", name: "Lagamar" },
    { code: "BR.15.3137205", name: "Lagoa da Prata" },
    { code: "BR.15.3137304", name: "Lagoa dos Patos" },
    { code: "BR.15.3137403", name: "Lagoa Dourada" },
    { code: "BR.15.3137502", name: "Lagoa Formosa" },
    { code: "BR.15.3137536", name: "Lagoa Grande" },
    { code: "BR.15.3137601", name: "Lagoa Santa" },
    { code: "BR.15.3137700", name: "Lajinha" },
    { code: "BR.15.3137809", name: "Lambari" },
    { code: "BR.15.3137908", name: "Lamim" },
    { code: "BR.15.3138005", name: "Laranjal" },
    { code: "BR.15.3138104", name: "Lassance" },
    { code: "BR.15.3138203", name: "Lavras" },
    { code: "BR.15.3138302", name: "Leandro Ferreira" },
    { code: "BR.15.3138351", name: "Leme do Prado" },
    { code: "BR.15.3138401", name: "Leopoldina" },
    { code: "BR.15.3138500", name: "Liberdade" },
    { code: "BR.15.3138609", name: "Lima Duarte" },
    { code: "BR.15.3138625", name: "Limeira do Oeste" },
    { code: "BR.15.3138658", name: "Lontra" },
    { code: "BR.15.3138674", name: "Luisburgo" },
    { code: "BR.15.3138682", name: "Luislândia" },
    { code: "BR.15.3138708", name: "Luminárias" },
    { code: "BR.15.3138807", name: "Luz" },
    { code: "BR.15.3138906", name: "Machacalis" },
    { code: "BR.15.3139003", name: "Machado" },
    { code: "BR.15.3139102", name: "Madre de Deus de Minas" },
    { code: "BR.15.3139201", name: "Malacacheta" },
    { code: "BR.15.3139250", name: "Mamonas" },
    { code: "BR.15.3139300", name: "Manga" },
    { code: "BR.15.3139409", name: "Manhuaçu" },
    { code: "BR.15.3139508", name: "Manhumirim" },
    { code: "BR.15.3139607", name: "Mantena" },
    { code: "BR.15.3139706", name: "Maravilhas" },
    { code: "BR.15.3139805", name: "Mar de Espanha" },
    { code: "BR.15.3139904", name: "Maria da Fé" },
    { code: "BR.15.3140001", name: "Mariana" },
    { code: "BR.15.3140100", name: "Marilac" },
    { code: "BR.15.3140159", name: "Mário Campos" },
    { code: "BR.15.3140209", name: "Maripá de Minas" },
    { code: "BR.15.3140308", name: "Marliéria" },
    { code: "BR.15.3140407", name: "Marmelópolis" },
    { code: "BR.15.3140506", name: "Martinho Campos" },
    { code: "BR.15.3140530", name: "Martins Soares" },
    { code: "BR.15.3140555", name: "Mata Verde" },
    { code: "BR.15.3140605", name: "Materlândia" },
    { code: "BR.15.3140704", name: "Mateus Leme" },
    { code: "BR.15.3140803", name: "Matias Barbosa" },
    { code: "BR.15.3140852", name: "Matias Cardoso" },
    { code: "BR.15.3140902", name: "Matipó" },
    { code: "BR.15.3141009", name: "Mato Verde" },
    { code: "BR.15.3141108", name: "Matozinhos" },
    { code: "BR.15.3141207", name: "Matutina" },
    { code: "BR.15.3141306", name: "Medeiros" },
    { code: "BR.15.3141405", name: "Medina" },
    { code: "BR.15.3141504", name: "Mendes Pimentel" },
    { code: "BR.15.3141603", name: "Mercês" },
    { code: "BR.15.3141702", name: "Mesquita" },
    { code: "BR.15.3141801", name: "Minas Novas" },
    { code: "BR.15.3141900", name: "Minduri" },
    { code: "BR.15.3142007", name: "Mirabela" },
    { code: "BR.15.3142106", name: "Miradouro" },
    { code: "BR.15.3142205", name: "Miraí" },
    { code: "BR.15.3142254", name: "Miravânia" },
    { code: "BR.15.3142304", name: "Moeda" },
    { code: "BR.15.3142403", name: "Moema" },
    { code: "BR.15.3142502", name: "Monjolos" },
    { code: "BR.15.3142601", name: "Monsenhor Paulo" },
    { code: "BR.15.3142700", name: "Montalvânia" },
    { code: "BR.15.3142809", name: "Monte Alegre de Minas" },
    { code: "BR.15.3142908", name: "Monte Azul" },
    { code: "BR.15.3143005", name: "Monte Belo" },
    { code: "BR.15.3143104", name: "Monte Carmelo" },
    { code: "BR.15.3143153", name: "Monte Formoso" },
    { code: "BR.15.3143203", name: "Monte Santo de Minas" },
    { code: "BR.15.3143302", name: "Montes Claros" },
    { code: "BR.15.3143401", name: "Monte Sião" },
    { code: "BR.15.3143450", name: "Montezuma" },
    { code: "BR.15.3143500", name: "Morada Nova de Minas" },
    { code: "BR.15.3143609", name: "Morro da Garça" },
    { code: "BR.15.3143708", name: "Morro do Pilar" },
    { code: "BR.15.3143807", name: "Munhoz" },
    { code: "BR.15.3143906", name: "Muriaé" },
    { code: "BR.15.3144003", name: "Mutum" },
    { code: "BR.15.3144102", name: "Muzambinho" },
    { code: "BR.15.3144201", name: "Nacip Raydan" },
    { code: "BR.15.3144300", name: "Nanuque" },
    { code: "BR.15.3144359", name: "Naque" },
    { code: "BR.15.3144375", name: "Natalândia" },
    { code: "BR.15.3144409", name: "Natércia" },
    { code: "BR.15.3144508", name: "Nazareno" },
    { code: "BR.15.3144607", name: "Nepomuceno" },
    { code: "BR.15.3144656", name: "Ninheira" },
    { code: "BR.15.3144672", name: "Nova Belém" },
    { code: "BR.15.3144706", name: "Nova Era" },
    { code: "BR.15.3144805", name: "Nova Lima" },
    { code: "BR.15.3144904", name: "Nova Módica" },
    { code: "BR.15.3145000", name: "Nova Ponte" },
    { code: "BR.15.3145059", name: "Nova Porteirinha" },
    { code: "BR.15.3145109", name: "Nova Resende" },
    { code: "BR.15.3145208", name: "Nova Serrana" },
    { code: "BR.15.3145307", name: "Novo Cruzeiro" },
    { code: "BR.15.3145356", name: "Novo Oriente de Minas" },
    { code: "BR.15.3145372", name: "Novorizonte" },
    { code: "BR.15.3145406", name: "Olaria" },
    { code: "BR.15.3145455", name: "Olhos-d'Água" },
    { code: "BR.15.3145505", name: "Olímpio Noronha" },
    { code: "BR.15.3145604", name: "Oliveira" },
    { code: "BR.15.3145703", name: "Oliveira Fortes" },
    { code: "BR.15.3145802", name: "Onça de Pitangui" },
    { code: "BR.15.3145851", name: "Oratórios" },
    { code: "BR.15.3145877", name: "Orizânia" },
    { code: "BR.15.3145901", name: "Ouro Branco" },
    { code: "BR.15.3146008", name: "Ouro Fino" },
    { code: "BR.15.3146107", name: "Ouro Preto" },
    { code: "BR.15.3146206", name: "Ouro Verde de Minas" },
    { code: "BR.15.3146255", name: "Padre Carvalho" },
    { code: "BR.15.3146305", name: "Padre Paraíso" },
    { code: "BR.15.3146404", name: "Paineiras" },
    { code: "BR.15.3146503", name: "Pains" },
    { code: "BR.15.3146552", name: "Pai Pedro" },
    { code: "BR.15.3146602", name: "Paiva" },
    { code: "BR.15.3146701", name: "Palma" },
    { code: "BR.15.3146750", name: "Palmópolis" },
    { code: "BR.15.3146909", name: "Papagaios" },
    { code: "BR.15.3147006", name: "Paracatu" },
    { code: "BR.15.3147105", name: "Pará de Minas" },
    { code: "BR.15.3147204", name: "Paraguaçu" },
    { code: "BR.15.3147303", name: "Paraisópolis" },
    { code: "BR.15.3147402", name: "Paraopeba" },
    { code: "BR.15.3147501", name: "Passabém" },
    { code: "BR.15.3147600", name: "Passa Quatro" },
    { code: "BR.15.3147709", name: "Passa Tempo" },
    { code: "BR.15.3147808", name: "Passa-Vinte" },
    { code: "BR.15.3147907", name: "Passos" },
    { code: "BR.15.3147956", name: "Patis" },
    { code: "BR.15.3148004", name: "Patos de Minas" },
    { code: "BR.15.3148103", name: "Patrocínio" },
    { code: "BR.15.3148202", name: "Patrocínio do Muriaé" },
    { code: "BR.15.3148301", name: "Paula Cândido" },
    { code: "BR.15.3148400", name: "Paulistas" },
    { code: "BR.15.3148509", name: "Pavão" },
    { code: "BR.15.3148608", name: "Peçanha" },
    { code: "BR.15.3148707", name: "Pedra Azul" },
    { code: "BR.15.3148756", name: "Pedra Bonita" },
    { code: "BR.15.3148806", name: "Pedra do Anta" },
    { code: "BR.15.3148905", name: "Pedra do Indaiá" },
    { code: "BR.15.3149002", name: "Pedra Dourada" },
    { code: "BR.15.3149101", name: "Pedralva" },
    { code: "BR.15.3149150", name: "Pedras de Maria da Cruz" },
    { code: "BR.15.3149200", name: "Pedrinópolis" },
    { code: "BR.15.3149309", name: "Pedro Leopoldo" },
    { code: "BR.15.3149408", name: "Pedro Teixeira" },
    { code: "BR.15.3149507", name: "Pequeri" },
    { code: "BR.15.3149606", name: "Pequi" },
    { code: "BR.15.3149705", name: "Perdigão" },
    { code: "BR.15.3149804", name: "Perdizes" },
    { code: "BR.15.3149903", name: "Perdões" },
    { code: "BR.15.3149952", name: "Periquito" },
    { code: "BR.15.3150000", name: "Pescador" },
    { code: "BR.15.3150109", name: "Piau" },
    { code: "BR.15.3150158", name: "Piedade de Caratinga" },
    { code: "BR.15.3150208", name: "Piedade de Ponte Nova" },
    { code: "BR.15.3150307", name: "Piedade do Rio Grande" },
    { code: "BR.15.3150406", name: "Piedade dos Gerais" },
    { code: "BR.15.3150505", name: "Pimenta" },
    { code: "BR.15.3150539", name: "Pingo-d'Água" },
    { code: "BR.15.3150570", name: "Pintópolis" },
    { code: "BR.15.3150604", name: "Piracema" },
    { code: "BR.15.3150703", name: "Pirajuba" },
    { code: "BR.15.3150802", name: "Piranga" },
    { code: "BR.15.3150901", name: "Piranguçu" },
    { code: "BR.15.3151008", name: "Piranguinho" },
    { code: "BR.15.3151107", name: "Pirapetinga" },
    { code: "BR.15.3151206", name: "Pirapora" },
    { code: "BR.15.3151305", name: "Piraúba" },
    { code: "BR.15.3151404", name: "Pitangui" },
    { code: "BR.15.3151503", name: "Piumhi" },
    { code: "BR.15.3151602", name: "Planura" },
    { code: "BR.15.3151701", name: "Poço Fundo" },
    { code: "BR.15.3151800", name: "Poços de Caldas" },
    { code: "BR.15.3151909", name: "Pocrane" },
    { code: "BR.15.3152006", name: "Pompéu" },
    { code: "BR.15.3152105", name: "Ponte Nova" },
    { code: "BR.15.3152131", name: "Ponto Chique" },
    { code: "BR.15.3152170", name: "Ponto dos Volantes" },
    { code: "BR.15.3152204", name: "Porteirinha" },
    { code: "BR.15.3152303", name: "Porto Firme" },
    { code: "BR.15.3152402", name: "Poté" },
    { code: "BR.15.3152501", name: "Pouso Alegre" },
    { code: "BR.15.3152600", name: "Pouso Alto" },
    { code: "BR.15.3152709", name: "Prados" },
    { code: "BR.15.3152808", name: "Prata" },
    { code: "BR.15.3152907", name: "Pratápolis" },
    { code: "BR.15.3153004", name: "Pratinha" },
    { code: "BR.15.3153103", name: "Presidente Bernardes" },
    { code: "BR.15.3153202", name: "Presidente Juscelino" },
    { code: "BR.15.3153301", name: "Presidente Kubitschek" },
    { code: "BR.15.3153400", name: "Presidente Olegário" },
    { code: "BR.15.3153509", name: "Alto Jequitibá" },
    { code: "BR.15.3153608", name: "Prudente de Morais" },
    { code: "BR.15.3153707", name: "Quartel Geral" },
    { code: "BR.15.3153806", name: "Queluzito" },
    { code: "BR.15.3153905", name: "Raposos" },
    { code: "BR.15.3154002", name: "Raul Soares" },
    { code: "BR.15.3154101", name: "Recreio" },
    { code: "BR.15.3154150", name: "Reduto" },
    { code: "BR.15.3154200", name: "Resende Costa" },
    { code: "BR.15.3154309", name: "Resplendor" },
    { code: "BR.15.3154408", name: "Ressaquinha" },
    { code: "BR.15.3154457", name: "Riachinho" },
    { code: "BR.15.3154507", name: "Riacho dos Machados" },
    { code: "BR.15.3154606", name: "Ribeirão das Neves" },
    { code: "BR.15.3154705", name: "Ribeirão Vermelho" },
    { code: "BR.15.3154804", name: "Rio Acima" },
    { code: "BR.15.3154903", name: "Rio Casca" },
    { code: "BR.15.3155009", name: "Rio Doce" },
    { code: "BR.15.3155108", name: "Rio do Prado" },
    { code: "BR.15.3155207", name: "Rio Espera" },
    { code: "BR.15.3155306", name: "Rio Manso" },
    { code: "BR.15.3155405", name: "Rio Novo" },
    { code: "BR.15.3155504", name: "Rio Paranaíba" },
    { code: "BR.15.3155603", name: "Rio Pardo de Minas" },
    { code: "BR.15.3155702", name: "Rio Piracicaba" },
    { code: "BR.15.3155801", name: "Rio Pomba" },
    { code: "BR.15.3155900", name: "Rio Preto" },
    { code: "BR.15.3156007", name: "Rio Vermelho" },
    { code: "BR.15.3156106", name: "Ritápolis" },
    { code: "BR.15.3156205", name: "Rochedo de Minas" },
    { code: "BR.15.3156304", name: "Rodeiro" },
    { code: "BR.15.3156403", name: "Romaria" },
    { code: "BR.15.3156452", name: "Rosário da Limeira" },
    { code: "BR.15.3156502", name: "Rubelita" },
    { code: "BR.15.3156601", name: "Rubim" },
    { code: "BR.15.3156700", name: "Sabará" },
    { code: "BR.15.3156809", name: "Sabinópolis" },
    { code: "BR.15.3156908", name: "Sacramento" },
    { code: "BR.15.3157005", name: "Salinas" },
    { code: "BR.15.3157104", name: "Salto da Divisa" },
    { code: "BR.15.3157203", name: "Santa Bárbara" },
    { code: "BR.15.3157252", name: "Santa Bárbara do Leste" },
    { code: "BR.15.3157278", name: "Santa Bárbara do Monte Verde" },
    { code: "BR.15.3157302", name: "Santa Bárbara do Tugúrio" },
    { code: "BR.15.3157336", name: "Santa Cruz de Minas" },
    { code: "BR.15.3157377", name: "Santa Cruz de Salinas" },
    { code: "BR.15.3157401", name: "Santa Cruz do Escalvado" },
    { code: "BR.15.3157500", name: "Santa Efigênia de Minas" },
    { code: "BR.15.3157609", name: "Santa Fé de Minas" },
    { code: "BR.15.3157658", name: "Santa Helena de Minas" },
    { code: "BR.15.3157708", name: "Santa Juliana" },
    { code: "BR.15.3157807", name: "Santa Luzia" },
    { code: "BR.15.3157906", name: "Santa Margarida" },
    { code: "BR.15.3158003", name: "Santa Maria de Itabira" },
    { code: "BR.15.3158102", name: "Santa Maria do Salto" },
    { code: "BR.15.3158201", name: "Santa Maria do Suaçuí" },
    { code: "BR.15.3158300", name: "Santana da Vargem" },
    { code: "BR.15.3158409", name: "Santana de Cataguases" },
    { code: "BR.15.3158508", name: "Santana de Pirapama" },
    { code: "BR.15.3158607", name: "Santana do Deserto" },
    { code: "BR.15.3158706", name: "Santana do Garambéu" },
    { code: "BR.15.3158805", name: "Santana do Jacaré" },
    { code: "BR.15.3158904", name: "Santana do Manhuaçu" },
    { code: "BR.15.3158953", name: "Santana do Paraíso" },
    { code: "BR.15.3159001", name: "Santana do Riacho" },
    { code: "BR.15.3159100", name: "Santana dos Montes" },
    { code: "BR.15.3159209", name: "Santa Rita de Caldas" },
    { code: "BR.15.3159308", name: "Santa Rita de Jacutinga" },
    { code: "BR.15.3159357", name: "Santa Rita de Minas" },
    { code: "BR.15.3159407", name: "Santa Rita de Ibitipoca" },
    { code: "BR.15.3159506", name: "Santa Rita do Itueto" },
    { code: "BR.15.3159605", name: "Santa Rita do Sapucaí" },
    { code: "BR.15.3159704", name: "Santa Rosa da Serra" },
    { code: "BR.15.3159803", name: "Santa Vitória" },
    { code: "BR.15.3159902", name: "Santo Antônio do Amparo" },
    { code: "BR.15.3160009", name: "Santo Antônio do Aventureiro" },
    { code: "BR.15.3160108", name: "Santo Antônio do Grama" },
    { code: "BR.15.3160207", name: "Santo Antônio do Itambé" },
    { code: "BR.15.3160306", name: "Santo Antônio do Jacinto" },
    { code: "BR.15.3160405", name: "Santo Antônio do Monte" },
    { code: "BR.15.3160454", name: "Santo Antônio do Retiro" },
    { code: "BR.15.3160504", name: "Santo Antônio do Rio Abaixo" },
    { code: "BR.15.3160603", name: "Santo Hipólito" },
    { code: "BR.15.3160702", name: "Santos Dumont" },
    { code: "BR.15.3160801", name: "São Bento Abade" },
    { code: "BR.15.3160900", name: "São Brás do Suaçuí" },
    { code: "BR.15.3160959", name: "São Domingos das Dores" },
    { code: "BR.15.3161007", name: "São Domingos do Prata" },
    { code: "BR.15.3161056", name: "São Félix de Minas" },
    { code: "BR.15.3161106", name: "São Francisco" },
    { code: "BR.15.3161205", name: "São Francisco de Paula" },
    { code: "BR.15.3161304", name: "São Francisco de Sales" },
    { code: "BR.15.3161403", name: "São Francisco do Glória" },
    { code: "BR.15.3161502", name: "São Geraldo" },
    { code: "BR.15.3161601", name: "São Geraldo da Piedade" },
    { code: "BR.15.3161650", name: "São Geraldo do Baixio" },
    { code: "BR.15.3161700", name: "São Gonçalo do Abaeté" },
    { code: "BR.15.3161809", name: "São Gonçalo do Pará" },
    { code: "BR.15.3161908", name: "São Gonçalo do Rio Abaixo" },
    { code: "BR.15.3162005", name: "São Gonçalo do Sapucaí" },
    { code: "BR.15.3162104", name: "São Gotardo" },
    { code: "BR.15.3162203", name: "São João Batista do Glória" },
    { code: "BR.15.3162252", name: "São João da Lagoa" },
    { code: "BR.15.3162302", name: "São João da Mata" },
    { code: "BR.15.3162401", name: "São João da Ponte" },
    { code: "BR.15.3162450", name: "São João das Missões" },
    { code: "BR.15.3162500", name: "São João del Rei" },
    { code: "BR.15.3162559", name: "São João do Manhuaçu" },
    { code: "BR.15.3162575", name: "São João do Manteninha" },
    { code: "BR.15.3162609", name: "São João do Oriente" },
    { code: "BR.15.3162658", name: "São João do Pacuí" },
    { code: "BR.15.3162708", name: "São João do Paraíso" },
    { code: "BR.15.3162807", name: "São João Evangelista" },
    { code: "BR.15.3162906", name: "São João Nepomuceno" },
    { code: "BR.15.3162922", name: "São Joaquim de Bicas" },
    { code: "BR.15.3162948", name: "São José da Barra" },
    { code: "BR.15.3162955", name: "São José da Lapa" },
    { code: "BR.15.3163003", name: "São José da Safira" },
    { code: "BR.15.3163102", name: "São José da Varginha" },
    { code: "BR.15.3163201", name: "São José do Alegre" },
    { code: "BR.15.3163300", name: "São José do Divino" },
    { code: "BR.15.3163409", name: "São José do Goiabal" },
    { code: "BR.15.3163508", name: "São José do Jacuri" },
    { code: "BR.15.3163607", name: "São José do Mantimento" },
    { code: "BR.15.3163706", name: "São Lourenço" },
    { code: "BR.15.3163805", name: "São Miguel do Anta" },
    { code: "BR.15.3163904", name: "São Pedro da União" },
    { code: "BR.15.3164001", name: "São Pedro dos Ferros" },
    { code: "BR.15.3164100", name: "São Pedro do Suaçuí" },
    { code: "BR.15.3164209", name: "São Romão" },
    { code: "BR.15.3164308", name: "São Roque de Minas" },
    { code: "BR.15.3164407", name: "São Sebastião da Bela Vista" },
    { code: "BR.15.3164431", name: "São Sebastião da Vargem Alegre" },
    { code: "BR.15.3164472", name: "São Sebastião do Anta" },
    { code: "BR.15.3164506", name: "São Sebastião do Maranhão" },
    { code: "BR.15.3164605", name: "São Sebastião do Oeste" },
    { code: "BR.15.3164704", name: "São Sebastião do Paraíso" },
    { code: "BR.15.3164803", name: "São Sebastião do Rio Preto" },
    { code: "BR.15.3164902", name: "São Sebastião do Rio Verde" },
    { code: "BR.15.3165008", name: "São Tiago" },
    { code: "BR.15.3165107", name: "São Tomás de Aquino" },
    { code: "BR.15.3165206", name: "São Thomé das Letras" },
    { code: "BR.15.3165305", name: "São Vicente de Minas" },
    { code: "BR.15.3165404", name: "Sapucaí-Mirim" },
    { code: "BR.15.3165503", name: "Sardoá" },
    { code: "BR.15.3165537", name: "Sarzedo" },
    { code: "BR.15.3165552", name: "Setubinha" },
    { code: "BR.15.3165560", name: "Sem-Peixe" },
    { code: "BR.15.3165578", name: "Senador Amaral" },
    { code: "BR.15.3165602", name: "Senador Cortes" },
    { code: "BR.15.3165701", name: "Senador Firmino" },
    { code: "BR.15.3165800", name: "Senador José Bento" },
    { code: "BR.15.3165909", name: "Senador Modestino Gonçalves" },
    { code: "BR.15.3166006", name: "Senhora de Oliveira" },
    { code: "BR.15.3166105", name: "Senhora do Porto" },
    { code: "BR.15.3166204", name: "Senhora dos Remédios" },
    { code: "BR.15.3166303", name: "Sericita" },
    { code: "BR.15.3166402", name: "Seritinga" },
    { code: "BR.15.3166501", name: "Serra Azul de Minas" },
    { code: "BR.15.3166600", name: "Serra da Saudade" },
    { code: "BR.15.3166709", name: "Serra dos Aimorés" },
    { code: "BR.15.3166808", name: "Serra do Salitre" },
    { code: "BR.15.3166907", name: "Serrania" },
    { code: "BR.15.3166956", name: "Serranópolis de Minas" },
    { code: "BR.15.3167004", name: "Serranos" },
    { code: "BR.15.3167103", name: "Serro" },
    { code: "BR.15.3167202", name: "Sete Lagoas" },
    { code: "BR.15.3167301", name: "Silveirânia" },
    { code: "BR.15.3167400", name: "Silvianópolis" },
    { code: "BR.15.3167509", name: "Simão Pereira" },
    { code: "BR.15.3167608", name: "Simonésia" },
    { code: "BR.15.3167707", name: "Sobrália" },
    { code: "BR.15.3167806", name: "Soledade de Minas" },
    { code: "BR.15.3167905", name: "Tabuleiro" },
    { code: "BR.15.3168002", name: "Taiobeiras" },
    { code: "BR.15.3168051", name: "Taparuba" },
    { code: "BR.15.3168101", name: "Tapira" },
    { code: "BR.15.3168200", name: "Tapiraí" },
    { code: "BR.15.3168309", name: "Taquaraçu de Minas" },
    { code: "BR.15.3168408", name: "Tarumirim" },
    { code: "BR.15.3168507", name: "Teixeiras" },
    { code: "BR.15.3168606", name: "Teófilo Otoni" },
    { code: "BR.15.3168705", name: "Timóteo" },
    { code: "BR.15.3168804", name: "Tiradentes" },
    { code: "BR.15.3168903", name: "Tiros" },
    { code: "BR.15.3169000", name: "Tocantins" },
    { code: "BR.15.3169059", name: "Tocos do Moji" },
    { code: "BR.15.3169109", name: "Toledo" },
    { code: "BR.15.3169208", name: "Tombos" },
    { code: "BR.15.3169307", name: "Três Corações" },
    { code: "BR.15.3169356", name: "Três Marias" },
    { code: "BR.15.3169406", name: "Três Pontas" },
    { code: "BR.15.3169505", name: "Tumiritinga" },
    { code: "BR.15.3169604", name: "Tupaciguara" },
    { code: "BR.15.3169703", name: "Turmalina" },
    { code: "BR.15.3169802", name: "Turvolândia" },
    { code: "BR.15.3169901", name: "Ubá" },
    { code: "BR.15.3170008", name: "Ubaí" },
    { code: "BR.15.3170057", name: "Ubaporanga" },
    { code: "BR.15.3170107", name: "Uberaba" },
    { code: "BR.15.3170206", name: "Uberlândia" },
    { code: "BR.15.3170305", name: "Umburatiba" },
    { code: "BR.15.3170404", name: "Unaí" },
    { code: "BR.15.3170438", name: "União de Minas" },
    { code: "BR.15.3170479", name: "Uruana de Minas" },
    { code: "BR.15.3170503", name: "Urucânia" },
    { code: "BR.15.3170529", name: "Urucuia" },
    { code: "BR.15.3170578", name: "Vargem Alegre" },
    { code: "BR.15.3170602", name: "Vargem Bonita" },
    { code: "BR.15.3170651", name: "Vargem Grande do Rio Pardo" },
    { code: "BR.15.3170701", name: "Varginha" },
    { code: "BR.15.3170750", name: "Varjão de MInas" },
    { code: "BR.15.3170800", name: "Várzea da Palma" },
    { code: "BR.15.3170909", name: "Varzelândia" },
    { code: "BR.15.3171006", name: "Vazante" },
    { code: "BR.15.3171030", name: "Verdelândia" },
    { code: "BR.15.3171071", name: "Veredinha" },
    { code: "BR.15.3171105", name: "Veríssimo" },
    { code: "BR.15.3171154", name: "Vermelho Novo" },
    { code: "BR.15.3171204", name: "Vespasiano" },
    { code: "BR.15.3171303", name: "Viçosa" },
    { code: "BR.15.3171402", name: "Vieiras" },
    { code: "BR.15.3171501", name: "Mathias Lobato" },
    { code: "BR.15.3171600", name: "Virgem da Lapa" },
    { code: "BR.15.3171709", name: "Virgínia" },
    { code: "BR.15.3171808", name: "Virginópolis" },
    { code: "BR.15.3171907", name: "Virgolândia" },
    { code: "BR.15.3172004", name: "Visconde do Rio Branco" },
    { code: "BR.15.3172103", name: "Volta Grande" },
    { code: "BR.15.3172202", name: "Wenceslau Braz" },
  ],
  "BR.16": [
    { code: "BR.16.1500107", name: "Abaetetuba" },
    { code: "BR.16.1500131", name: "Abel Figueiredo" },
    { code: "BR.16.1500206", name: "Acará" },
    { code: "BR.16.1500305", name: "Afuá" },
    { code: "BR.16.1500347", name: "Água Azul do Norte" },
    { code: "BR.16.1500404", name: "Alenquer" },
    { code: "BR.16.1500503", name: "Almeirim" },
    { code: "BR.16.1500602", name: "Altamira" },
    { code: "BR.16.1500701", name: "Anajás" },
    { code: "BR.16.1500800", name: "Ananindeua" },
    { code: "BR.16.1500859", name: "Anapu" },
    { code: "BR.16.1500909", name: "Augusto Corrêa" },
    { code: "BR.16.1500958", name: "Aurora do Pará" },
    { code: "BR.16.1501006", name: "Aveiro" },
    { code: "BR.16.1501105", name: "Bagre" },
    { code: "BR.16.1501204", name: "Baião" },
    { code: "BR.16.1501253", name: "Bannach" },
    { code: "BR.16.1501303", name: "Barcarena" },
    { code: "BR.16.1501402", name: "Belém" },
    { code: "BR.16.1501451", name: "Belterra" },
    { code: "BR.16.1501501", name: "Benevides" },
    { code: "BR.16.1501576", name: "Bom Jesus do Tocantins" },
    { code: "BR.16.1501600", name: "Bonito" },
    { code: "BR.16.1501709", name: "Bragança" },
    { code: "BR.16.1501725", name: "Brasil Novo" },
    { code: "BR.16.1501758", name: "Brejo Grande do Araguaia" },
    { code: "BR.16.1501782", name: "Breu Branco" },
    { code: "BR.16.1501808", name: "Breves" },
    { code: "BR.16.1501907", name: "Bujaru" },
    { code: "BR.16.1501956", name: "Cachoeira do Piriá" },
    { code: "BR.16.1502004", name: "Cachoeira do Arari" },
    { code: "BR.16.1502103", name: "Cametá" },
    { code: "BR.16.1502152", name: "Canaã dos Carajás" },
    { code: "BR.16.1502202", name: "Capanema" },
    { code: "BR.16.1502301", name: "Capitão Poço" },
    { code: "BR.16.1502400", name: "Castanhal" },
    { code: "BR.16.1502509", name: "Chaves" },
    { code: "BR.16.1502608", name: "Colares" },
    { code: "BR.16.1502707", name: "Conceição do Araguaia" },
    { code: "BR.16.1502756", name: "Concórdia do Pará" },
    { code: "BR.16.1502764", name: "Cumaru do Norte" },
    { code: "BR.16.1502772", name: "Curionópolis" },
    { code: "BR.16.1502806", name: "Curralinho" },
    { code: "BR.16.1502855", name: "Curuá" },
    { code: "BR.16.1502905", name: "Curuçá" },
    { code: "BR.16.1502939", name: "Dom Eliseu" },
    { code: "BR.16.1502954", name: "Eldorado do Carajás" },
    { code: "BR.16.1503002", name: "Faro" },
    { code: "BR.16.1503044", name: "Floresta do Araguaia" },
    { code: "BR.16.1503077", name: "Garrafão do Norte" },
    { code: "BR.16.1503093", name: "Goianésia do Pará" },
    { code: "BR.16.1503101", name: "Gurupá" },
    { code: "BR.16.1503200", name: "Igarapé-Açu" },
    { code: "BR.16.1503309", name: "Igarapé-Miri" },
    { code: "BR.16.1503408", name: "Inhangapi" },
    { code: "BR.16.1503457", name: "Ipixuna do Pará" },
    { code: "BR.16.1503507", name: "Irituia" },
    { code: "BR.16.1503606", name: "Itaituba" },
    { code: "BR.16.1503705", name: "Itupiranga" },
    { code: "BR.16.1503754", name: "Jacareacanga" },
    { code: "BR.16.1503804", name: "Jacundá" },
    { code: "BR.16.1503903", name: "Juruti" },
    { code: "BR.16.1504000", name: "Limoeiro do Ajuru" },
    { code: "BR.16.1504059", name: "Mãe do Rio" },
    { code: "BR.16.1504109", name: "Magalhães Barata" },
    { code: "BR.16.1504208", name: "Marabá" },
    { code: "BR.16.1504307", name: "Maracanã" },
    { code: "BR.16.1504406", name: "Marapanim" },
    { code: "BR.16.1504422", name: "Marituba" },
    { code: "BR.16.1504455", name: "Medicilândia" },
    { code: "BR.16.1504505", name: "Melgaço" },
    { code: "BR.16.1504604", name: "Mocajuba" },
    { code: "BR.16.1504703", name: "Moju" },
    { code: "BR.16.1504752", name: "Mojuí Dos Campos" },
    { code: "BR.16.1504802", name: "Monte Alegre" },
    { code: "BR.16.1504901", name: "Muaná" },
    { code: "BR.16.1504950", name: "Nova Esperança do Piriá" },
    { code: "BR.16.1504976", name: "Nova Ipixuna" },
    { code: "BR.16.1505007", name: "Nova Timboteua" },
    { code: "BR.16.1505031", name: "Novo Progresso" },
    { code: "BR.16.1505064", name: "Novo Repartimento" },
    { code: "BR.16.1505106", name: "Óbidos" },
    { code: "BR.16.1505205", name: "Oeiras do Pará" },
    { code: "BR.16.1505304", name: "Oriximiná" },
    { code: "BR.16.1505403", name: "Ourém" },
    { code: "BR.16.1505437", name: "Ourilândia do Norte" },
    { code: "BR.16.1505486", name: "Pacajá" },
    { code: "BR.16.1505494", name: "Palestina do Pará" },
    { code: "BR.16.1505502", name: "Paragominas" },
    { code: "BR.16.1505536", name: "Parauapebas" },
    { code: "BR.16.1505551", name: "Pau d'Arco" },
    { code: "BR.16.1505601", name: "Peixe-Boi" },
    { code: "BR.16.1505635", name: "Piçarra" },
    { code: "BR.16.1505650", name: "Placas" },
    { code: "BR.16.1505700", name: "Ponta de Pedras" },
    { code: "BR.16.1505809", name: "Portel" },
    { code: "BR.16.1505908", name: "Porto de Moz" },
    { code: "BR.16.1506005", name: "Prainha" },
    { code: "BR.16.1506104", name: "Primavera" },
    { code: "BR.16.1506112", name: "Quatipuru" },
    { code: "BR.16.1506138", name: "Redenção" },
    { code: "BR.16.1506161", name: "Rio Maria" },
    { code: "BR.16.1506187", name: "Rondon do Pará" },
    { code: "BR.16.1506195", name: "Rurópolis" },
    { code: "BR.16.1506203", name: "Salinópolis" },
    { code: "BR.16.1506302", name: "Salvaterra" },
    { code: "BR.16.1506351", name: "Santa Bárbara do Pará" },
    { code: "BR.16.1506401", name: "Santa Cruz do Arari" },
    { code: "BR.16.1506500", name: "Santa Izabel do Pará" },
    { code: "BR.16.1506559", name: "Santa Luzia do Pará" },
    { code: "BR.16.1506583", name: "Santa Maria das Barreiras" },
    { code: "BR.16.1506609", name: "Santa Maria do Pará" },
    { code: "BR.16.1506708", name: "Santana do Araguaia" },
    { code: "BR.16.1506807", name: "Santarém" },
    { code: "BR.16.1506906", name: "Santarém Novo" },
    { code: "BR.16.1507003", name: "Santo Antônio do Tauá" },
    { code: "BR.16.1507102", name: "São Caetano de Odivelas" },
    { code: "BR.16.1507151", name: "São Domingos do Araguaia" },
    { code: "BR.16.1507201", name: "São Domingos do Capim" },
    { code: "BR.16.1507300", name: "São Félix do Xingu" },
    { code: "BR.16.1507409", name: "São Francisco do Pará" },
    { code: "BR.16.1507458", name: "São Geraldo do Araguaia" },
    { code: "BR.16.1507466", name: "São João da Ponta" },
    { code: "BR.16.1507474", name: "São João de Pirabas" },
    { code: "BR.16.1507508", name: "São João do Araguaia" },
    { code: "BR.16.1507607", name: "São Miguel do Guamá" },
    { code: "BR.16.1507706", name: "São Sebastião da Boa Vista" },
    { code: "BR.16.1507755", name: "Sapucaia" },
    { code: "BR.16.1507805", name: "Senador José Porfírio" },
    { code: "BR.16.1507904", name: "Soure" },
    { code: "BR.16.1507953", name: "Tailândia" },
    { code: "BR.16.1507961", name: "Terra Alta" },
    { code: "BR.16.1507979", name: "Terra Santa" },
    { code: "BR.16.1508001", name: "Tomé-Açu" },
    { code: "BR.16.1508035", name: "Tracuateua" },
    { code: "BR.16.1508050", name: "Trairão" },
    { code: "BR.16.1508084", name: "Tucumã" },
    { code: "BR.16.1508100", name: "Tucuruí" },
    { code: "BR.16.1508126", name: "Ulianópolis" },
    { code: "BR.16.1508159", name: "Uruará" },
    { code: "BR.16.1508209", name: "Vigia" },
    { code: "BR.16.1508308", name: "Viseu" },
    { code: "BR.16.1508357", name: "Vitória do Xingu" },
    { code: "BR.16.1508407", name: "Xinguara" },
  ],
  "BR.17": [
    { code: "BR.17.2500106", name: "Água Branca" },
    { code: "BR.17.2500205", name: "Aguiar" },
    { code: "BR.17.2500304", name: "Alagoa Grande" },
    { code: "BR.17.2500403", name: "Alagoa Nova" },
    { code: "BR.17.2500502", name: "Alagoinha" },
    { code: "BR.17.2500536", name: "Alcantil" },
    { code: "BR.17.2500577", name: "Algodão de Jandaíra" },
    { code: "BR.17.2500601", name: "Alhandra" },
    { code: "BR.17.2500700", name: "São João do Rio do Peixe" },
    { code: "BR.17.2500734", name: "Amparo" },
    { code: "BR.17.2500775", name: "Aparecida" },
    { code: "BR.17.2500809", name: "Araçagi" },
    { code: "BR.17.2500908", name: "Arara" },
    { code: "BR.17.2501005", name: "Araruna" },
    { code: "BR.17.2501104", name: "Areia" },
    { code: "BR.17.2501153", name: "Areia de Baraúnas" },
    { code: "BR.17.2501203", name: "Areial" },
    { code: "BR.17.2501302", name: "Aroeiras" },
    { code: "BR.17.2501351", name: "Assunção" },
    { code: "BR.17.2501401", name: "Baía da Traição" },
    { code: "BR.17.2501500", name: "Bananeiras" },
    { code: "BR.17.2501534", name: "Baraúna" },
    { code: "BR.17.2501575", name: "Barra de Santana" },
    { code: "BR.17.2501609", name: "Barra de Santa Rosa" },
    { code: "BR.17.2501708", name: "Barra de São Miguel" },
    { code: "BR.17.2501807", name: "Bayeux" },
    { code: "BR.17.2501906", name: "Belém" },
    { code: "BR.17.2502003", name: "Belém do Brejo do Cruz" },
    { code: "BR.17.2502052", name: "Bernardino Batista" },
    { code: "BR.17.2502102", name: "Boa Ventura" },
    { code: "BR.17.2502151", name: "Boa Vista" },
    { code: "BR.17.2502201", name: "Bom Jesus" },
    { code: "BR.17.2502300", name: "Bom Sucesso" },
    { code: "BR.17.2502409", name: "Bonito de Santa Fé" },
    { code: "BR.17.2502508", name: "Boqueirão" },
    { code: "BR.17.2502607", name: "Igaracy" },
    { code: "BR.17.2502706", name: "Borborema" },
    { code: "BR.17.2502805", name: "Brejo do Cruz" },
    { code: "BR.17.2502904", name: "Brejo dos Santos" },
    { code: "BR.17.2503001", name: "Caaporã" },
    { code: "BR.17.2503100", name: "Cabaceiras" },
    { code: "BR.17.2503209", name: "Cabedelo" },
    { code: "BR.17.2503308", name: "Cachoeira dos Índios" },
    { code: "BR.17.2503407", name: "Cacimba de Areia" },
    { code: "BR.17.2503506", name: "Cacimba de Dentro" },
    { code: "BR.17.2503555", name: "Cacimbas" },
    { code: "BR.17.2503605", name: "Caiçara" },
    { code: "BR.17.2503704", name: "Cajazeiras" },
    { code: "BR.17.2503753", name: "Cajazeirinhas" },
    { code: "BR.17.2503803", name: "Caldas Brandão" },
    { code: "BR.17.2503902", name: "Camalaú" },
    { code: "BR.17.2504009", name: "Campina Grande" },
    { code: "BR.17.2504033", name: "Capim" },
    { code: "BR.17.2504074", name: "Caraúbas" },
    { code: "BR.17.2504108", name: "Carrapateira" },
    { code: "BR.17.2504157", name: "Casserengue" },
    { code: "BR.17.2504207", name: "Catingueira" },
    { code: "BR.17.2504306", name: "Catolé do Rocha" },
    { code: "BR.17.2504355", name: "Caturité" },
    { code: "BR.17.2504405", name: "Conceição" },
    { code: "BR.17.2504504", name: "Condado" },
    { code: "BR.17.2504603", name: "Conde" },
    { code: "BR.17.2504702", name: "Congo" },
    { code: "BR.17.2504801", name: "Coremas" },
    { code: "BR.17.2504850", name: "Coxixola" },
    { code: "BR.17.2504900", name: "Cruz do Espírito Santo" },
    { code: "BR.17.2505006", name: "Cubati" },
    { code: "BR.17.2505105", name: "Cuité" },
    { code: "BR.17.2505204", name: "Cuitegi" },
    { code: "BR.17.2505238", name: "Cuité de Mamanguape" },
    { code: "BR.17.2505279", name: "Curral de Cima" },
    { code: "BR.17.2505303", name: "Curral Velho" },
    { code: "BR.17.2505352", name: "Damião" },
    { code: "BR.17.2505402", name: "Desterro" },
    { code: "BR.17.2505501", name: "Vista Serrana" },
    { code: "BR.17.2505600", name: "Diamante" },
    { code: "BR.17.2505709", name: "Dona Inês" },
    { code: "BR.17.2505808", name: "Duas Estradas" },
    { code: "BR.17.2505907", name: "Emas" },
    { code: "BR.17.2506004", name: "Esperança" },
    { code: "BR.17.2506103", name: "Fagundes" },
    { code: "BR.17.2506202", name: "Frei Martinho" },
    { code: "BR.17.2506251", name: "Gado Bravo" },
    { code: "BR.17.2506301", name: "Guarabira" },
    { code: "BR.17.2506400", name: "Gurinhém" },
    { code: "BR.17.2506509", name: "Gurjão" },
    { code: "BR.17.2506608", name: "Ibiara" },
    { code: "BR.17.2506707", name: "Imaculada" },
    { code: "BR.17.2506806", name: "Ingá" },
    { code: "BR.17.2506905", name: "Itabaiana" },
    { code: "BR.17.2507002", name: "Itaporanga" },
    { code: "BR.17.2507101", name: "Itapororoca" },
    { code: "BR.17.2507200", name: "Itatuba" },
    { code: "BR.17.2507309", name: "Jacaraú" },
    { code: "BR.17.2507408", name: "Jericó" },
    { code: "BR.17.2507507", name: "João Pessoa" },
    { code: "BR.17.2507606", name: "Juarez Távora" },
    { code: "BR.17.2507705", name: "Juazeirinho" },
    { code: "BR.17.2507804", name: "Junco do Seridó" },
    { code: "BR.17.2507903", name: "Juripiranga" },
    { code: "BR.17.2508000", name: "Juru" },
    { code: "BR.17.2508109", name: "Lagoa" },
    { code: "BR.17.2508208", name: "Lagoa de Dentro" },
    { code: "BR.17.2508307", name: "Lagoa Seca" },
    { code: "BR.17.2508406", name: "Lastro" },
    { code: "BR.17.2508505", name: "Livramento" },
    { code: "BR.17.2508554", name: "Logradouro" },
    { code: "BR.17.2508604", name: "Lucena" },
    { code: "BR.17.2508703", name: "Mãe d'Água" },
    { code: "BR.17.2508802", name: "Malta" },
    { code: "BR.17.2508901", name: "Mamanguape" },
    { code: "BR.17.2509008", name: "Manaíra" },
    { code: "BR.17.2509057", name: "Marcação" },
    { code: "BR.17.2509107", name: "Mari" },
    { code: "BR.17.2509156", name: "Marizópolis" },
    { code: "BR.17.2509206", name: "Massaranduba" },
    { code: "BR.17.2509305", name: "Mataraca" },
    { code: "BR.17.2509339", name: "Matinhas" },
    { code: "BR.17.2509370", name: "Mato Grosso" },
    { code: "BR.17.2509396", name: "Maturéia" },
    { code: "BR.17.2509404", name: "Mogeiro" },
    { code: "BR.17.2509503", name: "Montadas" },
    { code: "BR.17.2509602", name: "Monte Horebe" },
    { code: "BR.17.2509701", name: "Monteiro" },
    { code: "BR.17.2509800", name: "Mulungu" },
    { code: "BR.17.2509909", name: "Natuba" },
    { code: "BR.17.2510006", name: "Nazarezinho" },
    { code: "BR.17.2510105", name: "Nova Floresta" },
    { code: "BR.17.2510204", name: "Nova Olinda" },
    { code: "BR.17.2510303", name: "Nova Palmeira" },
    { code: "BR.17.2510402", name: "Olho d'Água" },
    { code: "BR.17.2510501", name: "Olivedos" },
    { code: "BR.17.2510600", name: "Ouro Velho" },
    { code: "BR.17.2510659", name: "Parari" },
    { code: "BR.17.2510709", name: "Passagem" },
    { code: "BR.17.2510808", name: "Patos" },
    { code: "BR.17.2510907", name: "Paulista" },
    { code: "BR.17.2511004", name: "Pedra Branca" },
    { code: "BR.17.2511103", name: "Pedra Lavrada" },
    { code: "BR.17.2511202", name: "Pedras de Fogo" },
    { code: "BR.17.2511301", name: "Piancó" },
    { code: "BR.17.2511400", name: "Picuí" },
    { code: "BR.17.2511509", name: "Pilar" },
    { code: "BR.17.2511608", name: "Pilões" },
    { code: "BR.17.2511707", name: "Pilõezinhos" },
    { code: "BR.17.2511806", name: "Pirpirituba" },
    { code: "BR.17.2511905", name: "Pitimbu" },
    { code: "BR.17.2512002", name: "Pocinhos" },
    { code: "BR.17.2512036", name: "Poço Dantas" },
    { code: "BR.17.2512077", name: "Poço de José de Moura" },
    { code: "BR.17.2512101", name: "Pombal" },
    { code: "BR.17.2512200", name: "Prata" },
    { code: "BR.17.2512309", name: "Princesa Isabel" },
    { code: "BR.17.2512408", name: "Puxinanã" },
    { code: "BR.17.2512507", name: "Queimadas" },
    { code: "BR.17.2512606", name: "Quixaba" },
    { code: "BR.17.2512705", name: "Remígio" },
    { code: "BR.17.2512721", name: "Pedro Régis" },
    { code: "BR.17.2512747", name: "Riachão" },
    { code: "BR.17.2512754", name: "Riachão do Bacamarte" },
    { code: "BR.17.2512762", name: "Riachão do Poço" },
    { code: "BR.17.2512788", name: "Riacho de Santo Antônio" },
    { code: "BR.17.2512804", name: "Riacho dos Cavalos" },
    { code: "BR.17.2512903", name: "Rio Tinto" },
    { code: "BR.17.2513000", name: "Salgadinho" },
    { code: "BR.17.2513109", name: "Salgado de São Félix" },
    { code: "BR.17.2513158", name: "Santa Cecília" },
    { code: "BR.17.2513208", name: "Santa Cruz" },
    { code: "BR.17.2513307", name: "Santa Helena" },
    { code: "BR.17.2513356", name: "Santa Inês" },
    { code: "BR.17.2513406", name: "Santa Luzia" },
    { code: "BR.17.2513505", name: "Santana de Mangueira" },
    { code: "BR.17.2513604", name: "Santana dos Garrotes" },
    { code: "BR.17.2513653", name: "Joca Claudino" },
    { code: "BR.17.2513703", name: "Santa Rita" },
    { code: "BR.17.2513802", name: "Santa Teresinha" },
    { code: "BR.17.2513851", name: "Santo André" },
    { code: "BR.17.2513901", name: "São Bento" },
    { code: "BR.17.2513927", name: "São Bentinho" },
    { code: "BR.17.2513943", name: "São Domingos do Cariri" },
    { code: "BR.17.2513968", name: "São Domingos" },
    { code: "BR.17.2513984", name: "São Francisco" },
    { code: "BR.17.2514008", name: "São João do Cariri" },
    { code: "BR.17.2514107", name: "São João do Tigre" },
    { code: "BR.17.2514206", name: "São José da Lagoa Tapada" },
    { code: "BR.17.2514305", name: "São José de Caiana" },
    { code: "BR.17.2514404", name: "São José de Espinharas" },
    { code: "BR.17.2514453", name: "São José dos Ramos" },
    { code: "BR.17.2514503", name: "São José de Piranhas" },
    { code: "BR.17.2514552", name: "São José de Princesa" },
    { code: "BR.17.2514602", name: "São José do Bonfim" },
    { code: "BR.17.2514651", name: "São José do Brejo do Cruz" },
    { code: "BR.17.2514701", name: "São José do Sabugi" },
    { code: "BR.17.2514800", name: "São José dos Cordeiros" },
    { code: "BR.17.2514909", name: "São Mamede" },
    { code: "BR.17.2515005", name: "São Miguel de Taipu" },
    { code: "BR.17.2515104", name: "São Sebastião de Lagoa de Roça" },
    { code: "BR.17.2515203", name: "São Sebastião do Umbuzeiro" },
    { code: "BR.17.2515302", name: "Sapé" },
    { code: "BR.17.2515401", name: "São Vicente do Seridó" },
    { code: "BR.17.2515500", name: "Serra Branca" },
    { code: "BR.17.2515609", name: "Serra da Raiz" },
    { code: "BR.17.2515708", name: "Serra Grande" },
    { code: "BR.17.2515807", name: "Serra Redonda" },
    { code: "BR.17.2515906", name: "Serraria" },
    { code: "BR.17.2515930", name: "Sertãozinho" },
    { code: "BR.17.2515971", name: "Sobrado" },
    { code: "BR.17.2516003", name: "Solânea" },
    { code: "BR.17.2516102", name: "Soledade" },
    { code: "BR.17.2516151", name: "Sossêgo" },
    { code: "BR.17.2516201", name: "Sousa" },
    { code: "BR.17.2516300", name: "Sumé" },
    { code: "BR.17.2516409", name: "Tacima" },
    { code: "BR.17.2516508", name: "Taperoá" },
    { code: "BR.17.2516607", name: "Tavares" },
    { code: "BR.17.2516706", name: "Teixeira" },
    { code: "BR.17.2516755", name: "Tenório" },
    { code: "BR.17.2516805", name: "Triunfo" },
    { code: "BR.17.2516904", name: "Uiraúna" },
    { code: "BR.17.2517001", name: "Umbuzeiro" },
    { code: "BR.17.2517100", name: "Várzea" },
    { code: "BR.17.2517209", name: "Vieirópolis" },
    { code: "BR.17.2517407", name: "Zabelê" },
  ],
  "BR.18": [
    { code: "BR.18.4100103", name: "Abatiá" },
    { code: "BR.18.4100202", name: "Adrianópolis" },
    { code: "BR.18.4100301", name: "Agudos do Sul" },
    { code: "BR.18.4100400", name: "Almirante Tamandaré" },
    { code: "BR.18.4100459", name: "Altamira do Paraná" },
    { code: "BR.18.4100509", name: "Altônia" },
    { code: "BR.18.4100608", name: "Alto Paraná" },
    { code: "BR.18.4100707", name: "Alto Piquiri" },
    { code: "BR.18.4100806", name: "Alvorada do Sul" },
    { code: "BR.18.4100905", name: "Amaporã" },
    { code: "BR.18.4101002", name: "Ampére" },
    { code: "BR.18.4101051", name: "Anahy" },
    { code: "BR.18.4101101", name: "Andirá" },
    { code: "BR.18.4101150", name: "Ângulo" },
    { code: "BR.18.4101200", name: "Antonina" },
    { code: "BR.18.4101309", name: "Antônio Olinto" },
    { code: "BR.18.4101408", name: "Apucarana" },
    { code: "BR.18.4101507", name: "Arapongas" },
    { code: "BR.18.4101606", name: "Arapoti" },
    { code: "BR.18.4101655", name: "Arapuã" },
    { code: "BR.18.4101705", name: "Araruna" },
    { code: "BR.18.4101804", name: "Araucária" },
    { code: "BR.18.4101853", name: "Ariranha do Ivaí" },
    { code: "BR.18.4101903", name: "Assaí" },
    { code: "BR.18.4102000", name: "Assis Chateaubriand" },
    { code: "BR.18.4102109", name: "Astorga" },
    { code: "BR.18.4102208", name: "Atalaia" },
    { code: "BR.18.4102307", name: "Balsa Nova" },
    { code: "BR.18.4102406", name: "Bandeirantes" },
    { code: "BR.18.4102505", name: "Barbosa Ferraz" },
    { code: "BR.18.4102604", name: "Barracão" },
    { code: "BR.18.4102703", name: "Barra do Jacaré" },
    { code: "BR.18.4102752", name: "Bela Vista da Caroba" },
    { code: "BR.18.4102802", name: "Bela Vista do Paraíso" },
    { code: "BR.18.4102901", name: "Bituruna" },
    { code: "BR.18.4103008", name: "Boa Esperança" },
    { code: "BR.18.4103024", name: "Boa Esperança do Iguaçu" },
    { code: "BR.18.4103040", name: "Boa Ventura de São Roque" },
    { code: "BR.18.4103057", name: "Boa Vista da Aparecida" },
    { code: "BR.18.4103107", name: "Bocaiúva do Sul" },
    { code: "BR.18.4103156", name: "Bom Jesus do Sul" },
    { code: "BR.18.4103206", name: "Bom Sucesso" },
    { code: "BR.18.4103222", name: "Bom Sucesso do Sul" },
    { code: "BR.18.4103305", name: "Borrazópolis" },
    { code: "BR.18.4103354", name: "Braganey" },
    { code: "BR.18.4103370", name: "Brasilândia do Sul" },
    { code: "BR.18.4103404", name: "Cafeara" },
    { code: "BR.18.4103453", name: "Cafelândia" },
    { code: "BR.18.4103479", name: "Cafezal do Sul" },
    { code: "BR.18.4103503", name: "Califórnia" },
    { code: "BR.18.4103602", name: "Cambará" },
    { code: "BR.18.4103701", name: "Cambé" },
    { code: "BR.18.4103800", name: "Cambira" },
    { code: "BR.18.4103909", name: "Campina da Lagoa" },
    { code: "BR.18.4103958", name: "Campina do Simão" },
    { code: "BR.18.4104006", name: "Campina Grande do Sul" },
    { code: "BR.18.4104055", name: "Campo Bonito" },
    { code: "BR.18.4104105", name: "Campo do Tenente" },
    { code: "BR.18.4104204", name: "Campo Largo" },
    { code: "BR.18.4104253", name: "Campo Magro" },
    { code: "BR.18.4104303", name: "Campo Mourão" },
    { code: "BR.18.4104402", name: "Cândido de Abreu" },
    { code: "BR.18.4104428", name: "Candói" },
    { code: "BR.18.4104451", name: "Cantagalo" },
    { code: "BR.18.4104501", name: "Capanema" },
    { code: "BR.18.4104600", name: "Capitão Leônidas Marques" },
    { code: "BR.18.4104659", name: "Carambeí" },
    { code: "BR.18.4104709", name: "Carlópolis" },
    { code: "BR.18.4104808", name: "Cascavel" },
    { code: "BR.18.4104907", name: "Castro" },
    { code: "BR.18.4105003", name: "Catanduvas" },
    { code: "BR.18.4105102", name: "Centenário do Sul" },
    { code: "BR.18.4105201", name: "Cerro Azul" },
    { code: "BR.18.4105300", name: "Céu Azul" },
    { code: "BR.18.4105409", name: "Chopinzinho" },
    { code: "BR.18.4105508", name: "Cianorte" },
    { code: "BR.18.4105607", name: "Cidade Gaúcha" },
    { code: "BR.18.4105706", name: "Clevelândia" },
    { code: "BR.18.4105805", name: "Colombo" },
    { code: "BR.18.4105904", name: "Colorado" },
    { code: "BR.18.4106001", name: "Congonhinhas" },
    { code: "BR.18.4106100", name: "Conselheiro Mairinck" },
    { code: "BR.18.4106209", name: "Contenda" },
    { code: "BR.18.4106308", name: "Corbélia" },
    { code: "BR.18.4106407", name: "Cornélio Procópio" },
    { code: "BR.18.4106456", name: "Coronel Domingos Soares" },
    { code: "BR.18.4106506", name: "Coronel Vivida" },
    { code: "BR.18.4106555", name: "Corumbataí do Sul" },
    { code: "BR.18.4106571", name: "Cruzeiro do Iguaçu" },
    { code: "BR.18.4106605", name: "Cruzeiro do Oeste" },
    { code: "BR.18.4106704", name: "Cruzeiro do Sul" },
    { code: "BR.18.4106803", name: "Cruz Machado" },
    { code: "BR.18.4106852", name: "Cruzmaltina" },
    { code: "BR.18.4106902", name: "Curitiba" },
    { code: "BR.18.4107009", name: "Curiúva" },
    { code: "BR.18.4107108", name: "Diamante do Norte" },
    { code: "BR.18.4107124", name: "Diamante do Sul" },
    { code: "BR.18.4107157", name: "Diamante d'Oeste" },
    { code: "BR.18.4107207", name: "Dois Vizinhos" },
    { code: "BR.18.4107256", name: "Douradina" },
    { code: "BR.18.4107306", name: "Doutor Camargo" },
    { code: "BR.18.4107405", name: "Enéas Marques" },
    { code: "BR.18.4107504", name: "Engenheiro Beltrão" },
    { code: "BR.18.4107520", name: "Esperança Nova" },
    { code: "BR.18.4107538", name: "Entre Rios do Oeste" },
    { code: "BR.18.4107546", name: "Espigão Alto do Iguaçu" },
    { code: "BR.18.4107553", name: "Farol" },
    { code: "BR.18.4107603", name: "Faxinal" },
    { code: "BR.18.4107652", name: "Fazenda Rio Grande" },
    { code: "BR.18.4107702", name: "Fênix" },
    { code: "BR.18.4107736", name: "Fernandes Pinheiro" },
    { code: "BR.18.4107751", name: "Figueira" },
    { code: "BR.18.4107801", name: "Floraí" },
    { code: "BR.18.4107850", name: "Flor da Serra do Sul" },
    { code: "BR.18.4107900", name: "Floresta" },
    { code: "BR.18.4108007", name: "Florestópolis" },
    { code: "BR.18.4108106", name: "Flórida" },
    { code: "BR.18.4108205", name: "Formosa do Oeste" },
    { code: "BR.18.4108304", name: "Foz do Iguaçu" },
    { code: "BR.18.4108320", name: "Francisco Alves" },
    { code: "BR.18.4108403", name: "Francisco Beltrão" },
    { code: "BR.18.4108452", name: "Foz do Jordão" },
    { code: "BR.18.4108502", name: "General Carneiro" },
    { code: "BR.18.4108551", name: "Godoy Moreira" },
    { code: "BR.18.4108601", name: "Goioerê" },
    { code: "BR.18.4108650", name: "Goioxim" },
    { code: "BR.18.4108700", name: "Grandes Rios" },
    { code: "BR.18.4108809", name: "Guaíra" },
    { code: "BR.18.4108908", name: "Guairaçá" },
    { code: "BR.18.4108957", name: "Guamiranga" },
    { code: "BR.18.4109005", name: "Guapirama" },
    { code: "BR.18.4109104", name: "Guaporema" },
    { code: "BR.18.4109203", name: "Guaraci" },
    { code: "BR.18.4109302", name: "Guaraniaçu" },
    { code: "BR.18.4109401", name: "Guarapuava" },
    { code: "BR.18.4109500", name: "Guaraqueçaba" },
    { code: "BR.18.4109609", name: "Guaratuba" },
    { code: "BR.18.4109658", name: "Honório Serpa" },
    { code: "BR.18.4109708", name: "Ibaiti" },
    { code: "BR.18.4109757", name: "Ibema" },
    { code: "BR.18.4109807", name: "Ibiporã" },
    { code: "BR.18.4109906", name: "Icaraíma" },
    { code: "BR.18.4110003", name: "Iguaraçu" },
    { code: "BR.18.4110052", name: "Iguatu" },
    { code: "BR.18.4110078", name: "Imbaú" },
    { code: "BR.18.4110102", name: "Imbituva" },
    { code: "BR.18.4110201", name: "Inácio Martins" },
    { code: "BR.18.4110300", name: "Inajá" },
    { code: "BR.18.4110409", name: "Indianópolis" },
    { code: "BR.18.4110508", name: "Ipiranga" },
    { code: "BR.18.4110607", name: "Iporã" },
    { code: "BR.18.4110656", name: "Iracema do Oeste" },
    { code: "BR.18.4110706", name: "Irati" },
    { code: "BR.18.4110805", name: "Iretama" },
    { code: "BR.18.4110904", name: "Itaguajé" },
    { code: "BR.18.4110953", name: "Itaipulândia" },
    { code: "BR.18.4111001", name: "Itambaracá" },
    { code: "BR.18.4111100", name: "Itambé" },
    { code: "BR.18.4111209", name: "Itapejara d'Oeste" },
    { code: "BR.18.4111258", name: "Itaperuçu" },
    { code: "BR.18.4111308", name: "Itaúna do Sul" },
    { code: "BR.18.4111407", name: "Ivaí" },
    { code: "BR.18.4111506", name: "Ivaiporã" },
    { code: "BR.18.4111555", name: "Ivaté" },
    { code: "BR.18.4111605", name: "Ivatuba" },
    { code: "BR.18.4111704", name: "Jaboti" },
    { code: "BR.18.4111803", name: "Jacarezinho" },
    { code: "BR.18.4111902", name: "Jaguapitã" },
    { code: "BR.18.4112009", name: "Jaguariaíva" },
    { code: "BR.18.4112108", name: "Jandaia do Sul" },
    { code: "BR.18.4112207", name: "Janiópolis" },
    { code: "BR.18.4112306", name: "Japira" },
    { code: "BR.18.4112405", name: "Japurá" },
    { code: "BR.18.4112504", name: "Jardim Alegre" },
    { code: "BR.18.4112603", name: "Jardim Olinda" },
    { code: "BR.18.4112702", name: "Jataizinho" },
    { code: "BR.18.4112751", name: "Jesuítas" },
    { code: "BR.18.4112801", name: "Joaquim Távora" },
    { code: "BR.18.4112900", name: "Jundiaí do Sul" },
    { code: "BR.18.4112959", name: "Juranda" },
    { code: "BR.18.4113007", name: "Jussara" },
    { code: "BR.18.4113106", name: "Kaloré" },
    { code: "BR.18.4113205", name: "Lapa" },
    { code: "BR.18.4113254", name: "Laranjal" },
    { code: "BR.18.4113304", name: "Laranjeiras do Sul" },
    { code: "BR.18.4113403", name: "Leópolis" },
    { code: "BR.18.4113429", name: "Lidianópolis" },
    { code: "BR.18.4113452", name: "Lindoeste" },
    { code: "BR.18.4113502", name: "Loanda" },
    { code: "BR.18.4113601", name: "Lobato" },
    { code: "BR.18.4113700", name: "Londrina" },
    { code: "BR.18.4113734", name: "Luiziana" },
    { code: "BR.18.4113759", name: "Lunardelli" },
    { code: "BR.18.4113809", name: "Lupionópolis" },
    { code: "BR.18.4113908", name: "Mallet" },
    { code: "BR.18.4114005", name: "Mamborê" },
    { code: "BR.18.4114104", name: "Mandaguaçu" },
    { code: "BR.18.4114203", name: "Mandaguari" },
    { code: "BR.18.4114302", name: "Mandirituba" },
    { code: "BR.18.4114351", name: "Manfrinópolis" },
    { code: "BR.18.4114401", name: "Mangueirinha" },
    { code: "BR.18.4114500", name: "Manoel Ribas" },
    { code: "BR.18.4114609", name: "Marechal Cândido Rondon" },
    { code: "BR.18.4114708", name: "Maria Helena" },
    { code: "BR.18.4114807", name: "Marialva" },
    { code: "BR.18.4114906", name: "Marilândia do Sul" },
    { code: "BR.18.4115002", name: "Marilena" },
    { code: "BR.18.4115101", name: "Mariluz" },
    { code: "BR.18.4115200", name: "Maringá" },
    { code: "BR.18.4115309", name: "Mariópolis" },
    { code: "BR.18.4115358", name: "Maripá" },
    { code: "BR.18.4115408", name: "Marmeleiro" },
    { code: "BR.18.4115457", name: "Marquinho" },
    { code: "BR.18.4115507", name: "Marumbi" },
    { code: "BR.18.4115606", name: "Matelândia" },
    { code: "BR.18.4115705", name: "Matinhos" },
    { code: "BR.18.4115739", name: "Mato Rico" },
    { code: "BR.18.4115754", name: "Mauá da Serra" },
    { code: "BR.18.4115804", name: "Medianeira" },
    { code: "BR.18.4115853", name: "Mercedes" },
    { code: "BR.18.4115903", name: "Mirador" },
    { code: "BR.18.4116000", name: "Miraselva" },
    { code: "BR.18.4116059", name: "Missal" },
    { code: "BR.18.4116109", name: "Moreira Sales" },
    { code: "BR.18.4116208", name: "Morretes" },
    { code: "BR.18.4116307", name: "Munhoz de Melo" },
    { code: "BR.18.4116406", name: "Nossa Senhora das Graças" },
    { code: "BR.18.4116505", name: "Nova Aliança do Ivaí" },
    { code: "BR.18.4116604", name: "Nova América da Colina" },
    { code: "BR.18.4116703", name: "Nova Aurora" },
    { code: "BR.18.4116802", name: "Nova Cantu" },
    { code: "BR.18.4116901", name: "Nova Esperança" },
    { code: "BR.18.4116950", name: "Nova Esperança do Sudoeste" },
    { code: "BR.18.4117008", name: "Nova Fátima" },
    { code: "BR.18.4117057", name: "Nova Laranjeiras" },
    { code: "BR.18.4117107", name: "Nova Londrina" },
    { code: "BR.18.4117206", name: "Nova Olímpia" },
    { code: "BR.18.4117214", name: "Nova Santa Bárbara" },
    { code: "BR.18.4117222", name: "Nova Santa Rosa" },
    { code: "BR.18.4117255", name: "Nova Prata do Iguaçu" },
    { code: "BR.18.4117271", name: "Nova Tebas" },
    { code: "BR.18.4117297", name: "Novo Itacolomi" },
    { code: "BR.18.4117305", name: "Ortigueira" },
    { code: "BR.18.4117404", name: "Ourizona" },
    { code: "BR.18.4117453", name: "Ouro Verde do Oeste" },
    { code: "BR.18.4117503", name: "Paiçandu" },
    { code: "BR.18.4117602", name: "Palmas" },
    { code: "BR.18.4117701", name: "Palmeira" },
    { code: "BR.18.4117800", name: "Palmital" },
    { code: "BR.18.4117909", name: "Palotina" },
    { code: "BR.18.4118006", name: "Paraíso do Norte" },
    { code: "BR.18.4118105", name: "Paranacity" },
    { code: "BR.18.4118204", name: "Paranaguá" },
    { code: "BR.18.4118303", name: "Paranapoema" },
    { code: "BR.18.4118402", name: "Paranavaí" },
    { code: "BR.18.4118451", name: "Pato Bragado" },
    { code: "BR.18.4118501", name: "Pato Branco" },
    { code: "BR.18.4118600", name: "Paula Freitas" },
    { code: "BR.18.4118709", name: "Paulo Frontin" },
    { code: "BR.18.4118808", name: "Peabiru" },
    { code: "BR.18.4118857", name: "Perobal" },
    { code: "BR.18.4118907", name: "Pérola" },
    { code: "BR.18.4119004", name: "Pérola d'Oeste" },
    { code: "BR.18.4119103", name: "Piên" },
    { code: "BR.18.4119152", name: "Pinhais" },
    { code: "BR.18.4119202", name: "Pinhalão" },
    { code: "BR.18.4119251", name: "Pinhal de São Bento" },
    { code: "BR.18.4119301", name: "Pinhão" },
    { code: "BR.18.4119400", name: "Piraí do Sul" },
    { code: "BR.18.4119509", name: "Piraquara" },
    { code: "BR.18.4119608", name: "Pitanga" },
    { code: "BR.18.4119657", name: "Pitangueiras" },
    { code: "BR.18.4119707", name: "Planaltina do Paraná" },
    { code: "BR.18.4119806", name: "Planalto" },
    { code: "BR.18.4119905", name: "Ponta Grossa" },
    { code: "BR.18.4119954", name: "Pontal do Paraná" },
    { code: "BR.18.4120002", name: "Porecatu" },
    { code: "BR.18.4120101", name: "Porto Amazonas" },
    { code: "BR.18.4120150", name: "Porto Barreiro" },
    { code: "BR.18.4120200", name: "Porto Rico" },
    { code: "BR.18.4120309", name: "Porto Vitória" },
    { code: "BR.18.4120333", name: "Prado Ferreira" },
    { code: "BR.18.4120358", name: "Pranchita" },
    { code: "BR.18.4120408", name: "Presidente Castelo Branco" },
    { code: "BR.18.4120507", name: "Primeiro de Maio" },
    { code: "BR.18.4120606", name: "Prudentópolis" },
    { code: "BR.18.4120655", name: "Quarto Centenário" },
    { code: "BR.18.4120705", name: "Quatiguá" },
    { code: "BR.18.4120804", name: "Quatro Barras" },
    { code: "BR.18.4120853", name: "Quatro Pontes" },
    { code: "BR.18.4120903", name: "Quedas do Iguaçu" },
    { code: "BR.18.4121000", name: "Querência do Norte" },
    { code: "BR.18.4121109", name: "Quinta do Sol" },
    { code: "BR.18.4121208", name: "Quitandinha" },
    { code: "BR.18.4121257", name: "Ramilândia" },
    { code: "BR.18.4121307", name: "Rancho Alegre" },
    { code: "BR.18.4121356", name: "Rancho Alegre d'Oeste" },
    { code: "BR.18.4121406", name: "Realeza" },
    { code: "BR.18.4121505", name: "Rebouças" },
    { code: "BR.18.4121604", name: "Renascença" },
    { code: "BR.18.4121703", name: "Reserva" },
    { code: "BR.18.4121752", name: "Reserva do Iguaçu" },
    { code: "BR.18.4121802", name: "Ribeirão Claro" },
    { code: "BR.18.4121901", name: "Ribeirão do Pinhal" },
    { code: "BR.18.4122008", name: "Rio Azul" },
    { code: "BR.18.4122107", name: "Rio Bom" },
    { code: "BR.18.4122156", name: "Rio Bonito do Iguaçu" },
    { code: "BR.18.4122172", name: "Rio Branco do Ivaí" },
    { code: "BR.18.4122206", name: "Rio Branco do Sul" },
    { code: "BR.18.4122305", name: "Rio Negro" },
    { code: "BR.18.4122404", name: "Rolândia" },
    { code: "BR.18.4122503", name: "Roncador" },
    { code: "BR.18.4122602", name: "Rondon" },
    { code: "BR.18.4122651", name: "Rosário do Ivaí" },
    { code: "BR.18.4122701", name: "Sabáudia" },
    { code: "BR.18.4122800", name: "Salgado Filho" },
    { code: "BR.18.4122909", name: "Salto do Itararé" },
    { code: "BR.18.4123006", name: "Salto do Lontra" },
    { code: "BR.18.4123105", name: "Santa Amélia" },
    { code: "BR.18.4123204", name: "Santa Cecília do Pavão" },
    { code: "BR.18.4123303", name: "Santa Cruz de Monte Castelo" },
    { code: "BR.18.4123402", name: "Santa Fé" },
    { code: "BR.18.4123501", name: "Santa Helena" },
    { code: "BR.18.4123600", name: "Santa Inês" },
    { code: "BR.18.4123709", name: "Santa Isabel do Ivaí" },
    { code: "BR.18.4123808", name: "Santa Izabel do Oeste" },
    { code: "BR.18.4123824", name: "Santa Lúcia" },
    { code: "BR.18.4123857", name: "Santa Maria do Oeste" },
    { code: "BR.18.4123907", name: "Santa Mariana" },
    { code: "BR.18.4123956", name: "Santa Mônica" },
    { code: "BR.18.4124004", name: "Santana do Itararé" },
    { code: "BR.18.4124020", name: "Santa Tereza do Oeste" },
    { code: "BR.18.4124053", name: "Santa Terezinha de Itaipu" },
    { code: "BR.18.4124103", name: "Santo Antônio da Platina" },
    { code: "BR.18.4124202", name: "Santo Antônio do Caiuá" },
    { code: "BR.18.4124301", name: "Santo Antônio do Paraíso" },
    { code: "BR.18.4124400", name: "Santo Antônio do Sudoeste" },
    { code: "BR.18.4124509", name: "Santo Inácio" },
    { code: "BR.18.4124608", name: "São Carlos do Ivaí" },
    { code: "BR.18.4124707", name: "São Jerônimo da Serra" },
    { code: "BR.18.4124806", name: "São João" },
    { code: "BR.18.4124905", name: "São João do Caiuá" },
    { code: "BR.18.4125001", name: "São João do Ivaí" },
    { code: "BR.18.4125100", name: "São João do Triunfo" },
    { code: "BR.18.4125209", name: "São Jorge d'Oeste" },
    { code: "BR.18.4125308", name: "São Jorge do Ivaí" },
    { code: "BR.18.4125357", name: "São Jorge do Patrocínio" },
    { code: "BR.18.4125407", name: "São José da Boa Vista" },
    { code: "BR.18.4125456", name: "São José das Palmeiras" },
    { code: "BR.18.4125506", name: "São José dos Pinhais" },
    { code: "BR.18.4125555", name: "São Manoel do Paraná" },
    { code: "BR.18.4125605", name: "São Mateus do Sul" },
    { code: "BR.18.4125704", name: "São Miguel do Iguaçu" },
    { code: "BR.18.4125753", name: "São Pedro do Iguaçu" },
    { code: "BR.18.4125803", name: "São Pedro do Ivaí" },
    { code: "BR.18.4125902", name: "São Pedro do Paraná" },
    { code: "BR.18.4126009", name: "São Sebastião da Amoreira" },
    { code: "BR.18.4126108", name: "São Tomé" },
    { code: "BR.18.4126207", name: "Sapopema" },
    { code: "BR.18.4126256", name: "Sarandi" },
    { code: "BR.18.4126272", name: "Saudade do Iguaçu" },
    { code: "BR.18.4126306", name: "Sengés" },
    { code: "BR.18.4126355", name: "Serranópolis do Iguaçu" },
    { code: "BR.18.4126405", name: "Sertaneja" },
    { code: "BR.18.4126504", name: "Sertanópolis" },
    { code: "BR.18.4126603", name: "Siqueira Campos" },
    { code: "BR.18.4126652", name: "Sulina" },
    { code: "BR.18.4126678", name: "Tamarana" },
    { code: "BR.18.4126702", name: "Tamboara" },
    { code: "BR.18.4126801", name: "Tapejara" },
    { code: "BR.18.4126900", name: "Tapira" },
    { code: "BR.18.4127007", name: "Teixeira Soares" },
    { code: "BR.18.4127106", name: "Telêmaco Borba" },
    { code: "BR.18.4127205", name: "Terra Boa" },
    { code: "BR.18.4127304", name: "Terra Rica" },
    { code: "BR.18.4127403", name: "Terra Roxa" },
    { code: "BR.18.4127502", name: "Tibagi" },
    { code: "BR.18.4127601", name: "Tijucas do Sul" },
    { code: "BR.18.4127700", name: "Toledo" },
    { code: "BR.18.4127809", name: "Tomazina" },
    { code: "BR.18.4127858", name: "Três Barras do Paraná" },
    { code: "BR.18.4127882", name: "Tunas do Paraná" },
    { code: "BR.18.4127908", name: "Tuneiras do Oeste" },
    { code: "BR.18.4127957", name: "Tupãssi" },
    { code: "BR.18.4127965", name: "Turvo" },
    { code: "BR.18.4128005", name: "Ubiratã" },
    { code: "BR.18.4128104", name: "Umuarama" },
    { code: "BR.18.4128203", name: "União da Vitória" },
    { code: "BR.18.4128302", name: "Uniflor" },
    { code: "BR.18.4128401", name: "Uraí" },
    { code: "BR.18.4128500", name: "Wenceslau Braz" },
    { code: "BR.18.4128534", name: "Ventania" },
    { code: "BR.18.4128559", name: "Vera Cruz do Oeste" },
    { code: "BR.18.4128609", name: "Verê" },
    { code: "BR.18.4128625", name: "Alto Paraíso" },
    { code: "BR.18.4128633", name: "Doutor Ulysses" },
    { code: "BR.18.4128658", name: "Virmond" },
    { code: "BR.18.4128708", name: "Vitorino" },
    { code: "BR.18.4128807", name: "Xambrê" },
  ],
  "BR.20": [
    { code: "BR.20.2200053", name: "Acauã" },
    { code: "BR.20.2200103", name: "Agricolândia" },
    { code: "BR.20.2200202", name: "Água Branca" },
    { code: "BR.20.2200251", name: "Alagoinha do Piauí" },
    { code: "BR.20.2200277", name: "Alegrete do Piauí" },
    { code: "BR.20.2200301", name: "Alto Longá" },
    { code: "BR.20.2200400", name: "Altos" },
    { code: "BR.20.2200459", name: "Alvorada do Gurguéia" },
    { code: "BR.20.2200509", name: "Amarante" },
    { code: "BR.20.2200608", name: "Angical do Piauí" },
    { code: "BR.20.2200707", name: "Anísio de Abreu" },
    { code: "BR.20.2200806", name: "Antônio Almeida" },
    { code: "BR.20.2200905", name: "Aroazes" },
    { code: "BR.20.2200954", name: "Aroeiras do Itaim" },
    { code: "BR.20.2201002", name: "Arraial" },
    { code: "BR.20.2201051", name: "Assunção do Piauí" },
    { code: "BR.20.2201101", name: "Avelino Lopes" },
    { code: "BR.20.2201150", name: "Baixa Grande do Ribeiro" },
    { code: "BR.20.2201176", name: "Barra d'Alcântara" },
    { code: "BR.20.2201200", name: "Barras" },
    { code: "BR.20.2201309", name: "Barreiras do Piauí" },
    { code: "BR.20.2201408", name: "Barro Duro" },
    { code: "BR.20.2201507", name: "Batalha" },
    { code: "BR.20.2201556", name: "Bela Vista do Piauí" },
    { code: "BR.20.2201572", name: "Belém do Piauí" },
    { code: "BR.20.2201606", name: "Beneditinos" },
    { code: "BR.20.2201705", name: "Bertolínia" },
    { code: "BR.20.2201739", name: "Betânia do Piauí" },
    { code: "BR.20.2201770", name: "Boa Hora" },
    { code: "BR.20.2201804", name: "Bocaina" },
    { code: "BR.20.2201903", name: "Bom Jesus" },
    { code: "BR.20.2201919", name: "Bom Princípio do Piauí" },
    { code: "BR.20.2201929", name: "Bonfim do Piauí" },
    { code: "BR.20.2201945", name: "Boqueirão do Piauí" },
    { code: "BR.20.2201960", name: "Brasileira" },
    { code: "BR.20.2201988", name: "Brejo do Piauí" },
    { code: "BR.20.2202000", name: "Buriti dos Lopes" },
    { code: "BR.20.2202026", name: "Buriti dos Montes" },
    { code: "BR.20.2202059", name: "Cabeceiras do Piauí" },
    { code: "BR.20.2202075", name: "Cajazeiras do Piauí" },
    { code: "BR.20.2202083", name: "Cajueiro da Praia" },
    { code: "BR.20.2202091", name: "Caldeirão Grande do Piauí" },
    { code: "BR.20.2202109", name: "Campinas do Piauí" },
    { code: "BR.20.2202117", name: "Campo Alegre do Fidalgo" },
    { code: "BR.20.2202133", name: "Campo Grande do Piauí" },
    { code: "BR.20.2202174", name: "Campo Largo do Piauí" },
    { code: "BR.20.2202208", name: "Campo Maior" },
    { code: "BR.20.2202251", name: "Canavieira" },
    { code: "BR.20.2202307", name: "Canto do Buriti" },
    { code: "BR.20.2202406", name: "Capitão de Campos" },
    { code: "BR.20.2202455", name: "Capitão Gervásio Oliveira" },
    { code: "BR.20.2202505", name: "Caracol" },
    { code: "BR.20.2202539", name: "Caraúbas do Piauí" },
    { code: "BR.20.2202554", name: "Caridade do Piauí" },
    { code: "BR.20.2202604", name: "Castelo do Piauí" },
    { code: "BR.20.2202653", name: "Caxingó" },
    { code: "BR.20.2202703", name: "Cocal" },
    { code: "BR.20.2202711", name: "Cocal de Telha" },
    { code: "BR.20.2202729", name: "Cocal dos Alves" },
    { code: "BR.20.2202737", name: "Coivaras" },
    { code: "BR.20.2202752", name: "Colônia do Gurguéia" },
    { code: "BR.20.2202778", name: "Colônia do Piauí" },
    { code: "BR.20.2202802", name: "Conceição do Canindé" },
    { code: "BR.20.2202851", name: "Coronel José Dias" },
    { code: "BR.20.2202901", name: "Corrente" },
    { code: "BR.20.2203008", name: "Cristalândia do Piauí" },
    { code: "BR.20.2203107", name: "Cristino Castro" },
    { code: "BR.20.2203206", name: "Curimatá" },
    { code: "BR.20.2203230", name: "Currais" },
    { code: "BR.20.2203255", name: "Curralinhos" },
    { code: "BR.20.2203271", name: "Curral Novo do Piauí" },
    { code: "BR.20.2203305", name: "Demerval Lobão" },
    { code: "BR.20.2203354", name: "Dirceu Arcoverde" },
    { code: "BR.20.2203404", name: "Dom Expedito Lopes" },
    { code: "BR.20.2203420", name: "Domingos Mourão" },
    { code: "BR.20.2203453", name: "Dom Inocêncio" },
    { code: "BR.20.2203503", name: "Elesbão Veloso" },
    { code: "BR.20.2203602", name: "Eliseu Martins" },
    { code: "BR.20.2203701", name: "Esperantina" },
    { code: "BR.20.2203750", name: "Fartura do Piauí" },
    { code: "BR.20.2203800", name: "Flores do Piauí" },
    { code: "BR.20.2203859", name: "Floresta do Piauí" },
    { code: "BR.20.2203909", name: "Floriano" },
    { code: "BR.20.2204006", name: "Francinópolis" },
    { code: "BR.20.2204105", name: "Francisco Ayres" },
    { code: "BR.20.2204154", name: "Francisco Macedo" },
    { code: "BR.20.2204204", name: "Francisco Santos" },
    { code: "BR.20.2204303", name: "Fronteiras" },
    { code: "BR.20.2204352", name: "Geminiano" },
    { code: "BR.20.2204402", name: "Gilbués" },
    { code: "BR.20.2204501", name: "Guadalupe" },
    { code: "BR.20.2204550", name: "Guaribas" },
    { code: "BR.20.2204600", name: "Hugo Napoleão" },
    { code: "BR.20.2204659", name: "Ilha Grande" },
    { code: "BR.20.2204709", name: "Inhuma" },
    { code: "BR.20.2204808", name: "Ipiranga do Piauí" },
    { code: "BR.20.2204907", name: "Isaías Coelho" },
    { code: "BR.20.2205003", name: "Itainópolis" },
    { code: "BR.20.2205102", name: "Itaueira" },
    { code: "BR.20.2205151", name: "Jacobina do Piauí" },
    { code: "BR.20.2205201", name: "Jaicós" },
    { code: "BR.20.2205250", name: "Jardim do Mulato" },
    { code: "BR.20.2205276", name: "Jatobá do Piauí" },
    { code: "BR.20.2205300", name: "Jerumenha" },
    { code: "BR.20.2205359", name: "João Costa" },
    { code: "BR.20.2205409", name: "Joaquim Pires" },
    { code: "BR.20.2205458", name: "Joca Marques" },
    { code: "BR.20.2205508", name: "José de Freitas" },
    { code: "BR.20.2205516", name: "Juazeiro do Piauí" },
    { code: "BR.20.2205524", name: "Júlio Borges" },
    { code: "BR.20.2205532", name: "Jurema" },
    { code: "BR.20.2205540", name: "Lagoinha do Piauí" },
    { code: "BR.20.2205557", name: "Lagoa Alegre" },
    { code: "BR.20.2205565", name: "Lagoa do Barro do Piauí" },
    { code: "BR.20.2205573", name: "Lagoa de São Francisco" },
    { code: "BR.20.2205581", name: "Lagoa do Piauí" },
    { code: "BR.20.2205599", name: "Lagoa do Sítio" },
    { code: "BR.20.2205607", name: "Landri Sales" },
    { code: "BR.20.2205706", name: "Luís Correia" },
    { code: "BR.20.2205805", name: "Luzilândia" },
    { code: "BR.20.2205854", name: "Madeiro" },
    { code: "BR.20.2205904", name: "Manoel Emídio" },
    { code: "BR.20.2205953", name: "Marcolândia" },
    { code: "BR.20.2206001", name: "Marcos Parente" },
    { code: "BR.20.2206050", name: "Massapê do Piauí" },
    { code: "BR.20.2206100", name: "Matias Olímpio" },
    { code: "BR.20.2206209", name: "Miguel Alves" },
    { code: "BR.20.2206308", name: "Miguel Leão" },
    { code: "BR.20.2206357", name: "Milton Brandão" },
    { code: "BR.20.2206407", name: "Monsenhor Gil" },
    { code: "BR.20.2206506", name: "Monsenhor Hipólito" },
    { code: "BR.20.2206605", name: "Monte Alegre do Piauí" },
    { code: "BR.20.2206654", name: "Morro Cabeça no Tempo" },
    { code: "BR.20.2206670", name: "Morro do Chapéu do Piauí" },
    { code: "BR.20.2206696", name: "Murici dos Portelas" },
    { code: "BR.20.2206704", name: "Nazaré do Piauí" },
    { code: "BR.20.2206720", name: "Nazária" },
    { code: "BR.20.2206753", name: "Nossa Senhora de Nazaré" },
    { code: "BR.20.2206803", name: "Nossa Senhora dos Remédios" },
    { code: "BR.20.2206902", name: "Novo Oriente do Piauí" },
    { code: "BR.20.2206951", name: "Novo Santo Antônio" },
    { code: "BR.20.2207009", name: "Oeiras" },
    { code: "BR.20.2207108", name: "Olho d'Água do Piauí" },
    { code: "BR.20.2207207", name: "Padre Marcos" },
    { code: "BR.20.2207306", name: "Paes Landim" },
    { code: "BR.20.2207355", name: "Pajeú do Piauí" },
    { code: "BR.20.2207405", name: "Palmeira do Piauí" },
    { code: "BR.20.2207504", name: "Palmeirais" },
    { code: "BR.20.2207553", name: "Paquetá" },
    { code: "BR.20.2207603", name: "Parnaguá" },
    { code: "BR.20.2207702", name: "Parnaíba" },
    { code: "BR.20.2207751", name: "Passagem Franca do Piauí" },
    { code: "BR.20.2207777", name: "Patos do Piauí" },
    { code: "BR.20.2207793", name: "Pau D'arco do Piauí" },
    { code: "BR.20.2207801", name: "Paulistana" },
    { code: "BR.20.2207850", name: "Pavussu" },
    { code: "BR.20.2207900", name: "Pedro II" },
    { code: "BR.20.2207934", name: "Pedro Laurentino" },
    { code: "BR.20.2207959", name: "Nova Santa Rita" },
    { code: "BR.20.2208007", name: "Picos" },
    { code: "BR.20.2208106", name: "Pimenteiras" },
    { code: "BR.20.2208205", name: "Pio IX" },
    { code: "BR.20.2208304", name: "Piracuruca" },
    { code: "BR.20.2208403", name: "Piripiri" },
    { code: "BR.20.2208502", name: "Porto" },
    { code: "BR.20.2208551", name: "Porto Alegre do Piauí" },
    { code: "BR.20.2208601", name: "Prata do Piauí" },
    { code: "BR.20.2208650", name: "Queimada Nova" },
    { code: "BR.20.2208700", name: "Redenção do Gurguéia" },
    { code: "BR.20.2208809", name: "Regeneração" },
    { code: "BR.20.2208858", name: "Riacho Frio" },
    { code: "BR.20.2208874", name: "Ribeira do Piauí" },
    { code: "BR.20.2208908", name: "Ribeiro Gonçalves" },
    { code: "BR.20.2209005", name: "Rio Grande do Piauí" },
    { code: "BR.20.2209104", name: "Santa Cruz do Piauí" },
    { code: "BR.20.2209153", name: "Santa Cruz dos Milagres" },
    { code: "BR.20.2209203", name: "Santa Filomena" },
    { code: "BR.20.2209302", name: "Santa Luz" },
    { code: "BR.20.2209351", name: "Santana do Piauí" },
    { code: "BR.20.2209377", name: "Santa Rosa do Piauí" },
    { code: "BR.20.2209401", name: "Santo Antônio de Lisboa" },
    { code: "BR.20.2209450", name: "Santo Antônio dos Milagres" },
    { code: "BR.20.2209500", name: "Santo Inácio do Piauí" },
    { code: "BR.20.2209559", name: "São Braz do Piauí" },
    { code: "BR.20.2209609", name: "São Félix do Piauí" },
    { code: "BR.20.2209658", name: "São Francisco de Assis do Piauí" },
    { code: "BR.20.2209708", name: "São Francisco do Piauí" },
    { code: "BR.20.2209757", name: "São Gonçalo do Gurguéia" },
    { code: "BR.20.2209807", name: "São Gonçalo do Piauí" },
    { code: "BR.20.2209856", name: "São João da Canabrava" },
    { code: "BR.20.2209872", name: "São João da Fronteira" },
    { code: "BR.20.2209906", name: "São João da Serra" },
    { code: "BR.20.2209955", name: "São João da Varjota" },
    { code: "BR.20.2209971", name: "São João do Arraial" },
    { code: "BR.20.2210003", name: "São João do Piauí" },
    { code: "BR.20.2210052", name: "São José do Divino" },
    { code: "BR.20.2210102", name: "São José do Peixe" },
    { code: "BR.20.2210201", name: "São José do Piauí" },
    { code: "BR.20.2210300", name: "São Julião" },
    { code: "BR.20.2210359", name: "São Lourenço do Piauí" },
    { code: "BR.20.2210375", name: "São Luis do Piauí" },
    { code: "BR.20.2210383", name: "São Miguel da Baixa Grande" },
    { code: "BR.20.2210391", name: "São Miguel do Fidalgo" },
    { code: "BR.20.2210409", name: "São Miguel do Tapuio" },
    { code: "BR.20.2210508", name: "São Pedro do Piauí" },
    { code: "BR.20.2210607", name: "São Raimundo Nonato" },
    { code: "BR.20.2210623", name: "Sebastião Barros" },
    { code: "BR.20.2210631", name: "Sebastião Leal" },
    { code: "BR.20.2210656", name: "Sigefredo Pacheco" },
    { code: "BR.20.2210706", name: "Simões" },
    { code: "BR.20.2210805", name: "Simplício Mendes" },
    { code: "BR.20.2210904", name: "Socorro do Piauí" },
    { code: "BR.20.2210938", name: "Sussuapara" },
    { code: "BR.20.2210953", name: "Tamboril do Piauí" },
    { code: "BR.20.2210979", name: "Tanque do Piauí" },
    { code: "BR.20.2211001", name: "Teresina" },
    { code: "BR.20.2211100", name: "União" },
    { code: "BR.20.2211209", name: "Uruçuí" },
    { code: "BR.20.2211308", name: "Valença do Piauí" },
    { code: "BR.20.2211357", name: "Várzea Branca" },
    { code: "BR.20.2211407", name: "Várzea Grande" },
    { code: "BR.20.2211506", name: "Vera Mendes" },
    { code: "BR.20.2211605", name: "Vila Nova do Piauí" },
    { code: "BR.20.2211704", name: "Wall Ferraz" },
  ],
  "BR.21": [
    { code: "BR.21.3300100", name: "Angra dos Reis" },
    { code: "BR.21.3300159", name: "Aperibé" },
    { code: "BR.21.3300209", name: "Araruama" },
    { code: "BR.21.3300225", name: "Areal" },
    { code: "BR.21.3300233", name: "Armação dos Búzios" },
    { code: "BR.21.3300258", name: "Arraial do Cabo" },
    { code: "BR.21.3300308", name: "Barra do Piraí" },
    { code: "BR.21.3300407", name: "Barra Mansa" },
    { code: "BR.21.3300456", name: "Belford Roxo" },
    { code: "BR.21.3300506", name: "Bom Jardim" },
    { code: "BR.21.3300605", name: "Bom Jesus do Itabapoana" },
    { code: "BR.21.3300704", name: "Cabo Frio" },
    { code: "BR.21.3300803", name: "Cachoeiras de Macacu" },
    { code: "BR.21.3300902", name: "Cambuci" },
    { code: "BR.21.3300936", name: "Carapebus" },
    { code: "BR.21.3300951", name: "Comendador Levy Gasparian" },
    { code: "BR.21.3301009", name: "Campos dos Goytacazes" },
    { code: "BR.21.3301108", name: "Cantagalo" },
    { code: "BR.21.3301157", name: "Cardoso Moreira" },
    { code: "BR.21.3301207", name: "Carmo" },
    { code: "BR.21.3301306", name: "Casimiro de Abreu" },
    { code: "BR.21.3301405", name: "Conceição de Macabu" },
    { code: "BR.21.3301504", name: "Cordeiro" },
    { code: "BR.21.3301603", name: "Duas Barras" },
    { code: "BR.21.3301702", name: "Duque de Caxias" },
    { code: "BR.21.3301801", name: "Engenheiro Paulo de Frontin" },
    { code: "BR.21.3301850", name: "Guapimirim" },
    { code: "BR.21.3301876", name: "Iguaba Grande" },
    { code: "BR.21.3301900", name: "Itaboraí" },
    { code: "BR.21.3302007", name: "Itaguaí" },
    { code: "BR.21.3302056", name: "Italva" },
    { code: "BR.21.3302106", name: "Itaocara" },
    { code: "BR.21.3302205", name: "Itaperuna" },
    { code: "BR.21.3302254", name: "Itatiaia" },
    { code: "BR.21.3302270", name: "Japeri" },
    { code: "BR.21.3302304", name: "Laje do Muriaé" },
    { code: "BR.21.3302403", name: "Macaé" },
    { code: "BR.21.3302452", name: "Macuco" },
    { code: "BR.21.3302502", name: "Magé" },
    { code: "BR.21.3302601", name: "Mangaratiba" },
    { code: "BR.21.3302700", name: "Maricá" },
    { code: "BR.21.3302809", name: "Mendes" },
    { code: "BR.21.3302858", name: "Mesquita" },
    { code: "BR.21.3302908", name: "Miguel Pereira" },
    { code: "BR.21.3303005", name: "Miracema" },
    { code: "BR.21.3303104", name: "Natividade" },
    { code: "BR.21.3303203", name: "Nilópolis" },
    { code: "BR.21.3303302", name: "Niterói" },
    { code: "BR.21.3303401", name: "Nova Friburgo" },
    { code: "BR.21.3303500", name: "Nova Iguaçu" },
    { code: "BR.21.3303609", name: "Paracambi" },
    { code: "BR.21.3303708", name: "Paraíba do Sul" },
    { code: "BR.21.3303807", name: "Paraty" },
    { code: "BR.21.3303856", name: "Paty do Alferes" },
    { code: "BR.21.3303906", name: "Petrópolis" },
    { code: "BR.21.3303955", name: "Pinheiral" },
    { code: "BR.21.3304003", name: "Piraí" },
    { code: "BR.21.3304102", name: "Porciúncula" },
    { code: "BR.21.3304110", name: "Porto Real" },
    { code: "BR.21.3304128", name: "Quatis" },
    { code: "BR.21.3304144", name: "Queimados" },
    { code: "BR.21.3304151", name: "Quissamã" },
    { code: "BR.21.3304201", name: "Resende" },
    { code: "BR.21.3304300", name: "Rio Bonito" },
    { code: "BR.21.3304409", name: "Rio Claro" },
    { code: "BR.21.3304508", name: "Rio das Flores" },
    { code: "BR.21.3304524", name: "Rio das Ostras" },
    { code: "BR.21.3304557", name: "Rio de Janeiro" },
    { code: "BR.21.3304607", name: "Santa Maria Madalena" },
    { code: "BR.21.3304706", name: "Santo Antônio de Pádua" },
    { code: "BR.21.3304755", name: "São Francisco de Itabapoana" },
    { code: "BR.21.3304805", name: "São Fidélis" },
    { code: "BR.21.3304904", name: "São Gonçalo" },
    { code: "BR.21.3305000", name: "São João da Barra" },
    { code: "BR.21.3305109", name: "São João de Meriti" },
    { code: "BR.21.3305133", name: "São José de Ubá" },
    { code: "BR.21.3305158", name: "São José do Vale do Rio Preto" },
    { code: "BR.21.3305208", name: "São Pedro da Aldeia" },
    { code: "BR.21.3305307", name: "São Sebastião do Alto" },
    { code: "BR.21.3305406", name: "Sapucaia" },
    { code: "BR.21.3305505", name: "Saquarema" },
    { code: "BR.21.3305554", name: "Seropédica" },
    { code: "BR.21.3305604", name: "Silva Jardim" },
    { code: "BR.21.3305703", name: "Sumidouro" },
    { code: "BR.21.3305752", name: "Tanguá" },
    { code: "BR.21.3305802", name: "Teresópolis" },
    { code: "BR.21.3305901", name: "Trajano de Moraes" },
    { code: "BR.21.3306008", name: "Três Rios" },
    { code: "BR.21.3306107", name: "Valença" },
    { code: "BR.21.3306156", name: "Varre-Sai" },
    { code: "BR.21.3306206", name: "Vassouras" },
    { code: "BR.21.3306305", name: "Volta Redonda" },
  ],
  "BR.22": [
    { code: "BR.22.2400109", name: "Acari" },
    { code: "BR.22.2400208", name: "Açu" },
    { code: "BR.22.2400307", name: "Afonso Bezerra" },
    { code: "BR.22.2400406", name: "Água Nova" },
    { code: "BR.22.2400505", name: "Alexandria" },
    { code: "BR.22.2400604", name: "Almino Afonso" },
    { code: "BR.22.2400703", name: "Alto do Rodrigues" },
    { code: "BR.22.2400802", name: "Angicos" },
    { code: "BR.22.2400901", name: "Antônio Martins" },
    { code: "BR.22.2401008", name: "Apodi" },
    { code: "BR.22.2401107", name: "Areia Branca" },
    { code: "BR.22.2401206", name: "Arês" },
    { code: "BR.22.2401305", name: "Augusto Severo" },
    { code: "BR.22.2401404", name: "Baía Formosa" },
    { code: "BR.22.2401453", name: "Baraúna" },
    { code: "BR.22.2401503", name: "Barcelona" },
    { code: "BR.22.2401602", name: "Bento Fernandes" },
    { code: "BR.22.2401651", name: "Bodó" },
    { code: "BR.22.2401701", name: "Bom Jesus" },
    { code: "BR.22.2401800", name: "Brejinho" },
    { code: "BR.22.2401859", name: "Caiçara do Norte" },
    { code: "BR.22.2401909", name: "Caiçara do Rio do Vento" },
    { code: "BR.22.2402006", name: "Caicó" },
    { code: "BR.22.2402105", name: "Campo Redondo" },
    { code: "BR.22.2402204", name: "Canguaretama" },
    { code: "BR.22.2402303", name: "Caraúbas" },
    { code: "BR.22.2402402", name: "Carnaúba dos Dantas" },
    { code: "BR.22.2402501", name: "Carnaubais" },
    { code: "BR.22.2402600", name: "Ceará-Mirim" },
    { code: "BR.22.2402709", name: "Cerro Corá" },
    { code: "BR.22.2402808", name: "Coronel Ezequiel" },
    { code: "BR.22.2402907", name: "Coronel João Pessoa" },
    { code: "BR.22.2403004", name: "Cruzeta" },
    { code: "BR.22.2403103", name: "Currais Novos" },
    { code: "BR.22.2403202", name: "Doutor Severiano" },
    { code: "BR.22.2403251", name: "Parnamirim" },
    { code: "BR.22.2403301", name: "Encanto" },
    { code: "BR.22.2403400", name: "Equador" },
    { code: "BR.22.2403509", name: "Espírito Santo" },
    { code: "BR.22.2403608", name: "Extremoz" },
    { code: "BR.22.2403707", name: "Felipe Guerra" },
    { code: "BR.22.2403756", name: "Fernando Pedroza" },
    { code: "BR.22.2403806", name: "Florânia" },
    { code: "BR.22.2403905", name: "Francisco Dantas" },
    { code: "BR.22.2404002", name: "Frutuoso Gomes" },
    { code: "BR.22.2404101", name: "Galinhos" },
    { code: "BR.22.2404200", name: "Goianinha" },
    { code: "BR.22.2404309", name: "Governador Dix-Sept Rosado" },
    { code: "BR.22.2404408", name: "Grossos" },
    { code: "BR.22.2404507", name: "Guamaré" },
    { code: "BR.22.2404606", name: "Ielmo Marinho" },
    { code: "BR.22.2404705", name: "Ipanguaçu" },
    { code: "BR.22.2404804", name: "Ipueira" },
    { code: "BR.22.2404853", name: "Itajá" },
    { code: "BR.22.2404903", name: "Itaú" },
    { code: "BR.22.2405009", name: "Jaçanã" },
    { code: "BR.22.2405108", name: "Jandaíra" },
    { code: "BR.22.2405207", name: "Janduís" },
    { code: "BR.22.2405306", name: "Januário Cicco" },
    { code: "BR.22.2405405", name: "Japi" },
    { code: "BR.22.2405504", name: "Jardim de Angicos" },
    { code: "BR.22.2405603", name: "Jardim de Piranhas" },
    { code: "BR.22.2405702", name: "Jardim do Seridó" },
    { code: "BR.22.2405801", name: "João Câmara" },
    { code: "BR.22.2405900", name: "João Dias" },
    { code: "BR.22.2406007", name: "José da Penha" },
    { code: "BR.22.2406106", name: "Jucurutu" },
    { code: "BR.22.2406155", name: "Jundiá" },
    { code: "BR.22.2406205", name: "Lagoa d'Anta" },
    { code: "BR.22.2406304", name: "Lagoa de Pedras" },
    { code: "BR.22.2406403", name: "Lagoa de Velhos" },
    { code: "BR.22.2406502", name: "Lagoa Nova" },
    { code: "BR.22.2406601", name: "Lagoa Salgada" },
    { code: "BR.22.2406700", name: "Lajes" },
    { code: "BR.22.2406809", name: "Lajes Pintadas" },
    { code: "BR.22.2406908", name: "Lucrécia" },
    { code: "BR.22.2407005", name: "Luís Gomes" },
    { code: "BR.22.2407104", name: "Macaíba" },
    { code: "BR.22.2407203", name: "Macau" },
    { code: "BR.22.2407252", name: "Major Sales" },
    { code: "BR.22.2407302", name: "Marcelino Vieira" },
    { code: "BR.22.2407401", name: "Martins" },
    { code: "BR.22.2407500", name: "Maxaranguape" },
    { code: "BR.22.2407609", name: "Messias Targino" },
    { code: "BR.22.2407708", name: "Montanhas" },
    { code: "BR.22.2407807", name: "Monte Alegre" },
    { code: "BR.22.2407906", name: "Monte das Gameleiras" },
    { code: "BR.22.2408003", name: "Mossoró" },
    { code: "BR.22.2408102", name: "Natal" },
    { code: "BR.22.2408201", name: "Nísia Floresta" },
    { code: "BR.22.2408300", name: "Nova Cruz" },
    { code: "BR.22.2408409", name: "Olho-d'Água do Borges" },
    { code: "BR.22.2408508", name: "Ouro Branco" },
    { code: "BR.22.2408607", name: "Paraná" },
    { code: "BR.22.2408706", name: "Paraú" },
    { code: "BR.22.2408805", name: "Parazinho" },
    { code: "BR.22.2408904", name: "Parelhas" },
    { code: "BR.22.2408953", name: "Rio do Fogo" },
    { code: "BR.22.2409100", name: "Passa e Fica" },
    { code: "BR.22.2409209", name: "Passagem" },
    { code: "BR.22.2409308", name: "Patu" },
    { code: "BR.22.2409332", name: "Santa Maria" },
    { code: "BR.22.2409407", name: "Pau dos Ferros" },
    { code: "BR.22.2409506", name: "Pedra Grande" },
    { code: "BR.22.2409605", name: "Pedra Preta" },
    { code: "BR.22.2409704", name: "Pedro Avelino" },
    { code: "BR.22.2409803", name: "Pedro Velho" },
    { code: "BR.22.2409902", name: "Pendências" },
    { code: "BR.22.2410009", name: "Pilões" },
    { code: "BR.22.2410108", name: "Poço Branco" },
    { code: "BR.22.2410207", name: "Portalegre" },
    { code: "BR.22.2410256", name: "Porto do Mangue" },
    { code: "BR.22.2410306", name: "Serra Caiada" },
    { code: "BR.22.2410405", name: "Pureza" },
    { code: "BR.22.2410504", name: "Rafael Fernandes" },
    { code: "BR.22.2410603", name: "Rafael Godeiro" },
    { code: "BR.22.2410702", name: "Riacho da Cruz" },
    { code: "BR.22.2410801", name: "Riacho de Santana" },
    { code: "BR.22.2410900", name: "Riachuelo" },
    { code: "BR.22.2411007", name: "Rodolfo Fernandes" },
    { code: "BR.22.2411056", name: "Tibau" },
    { code: "BR.22.2411106", name: "Ruy Barbosa" },
    { code: "BR.22.2411205", name: "Santa Cruz" },
    { code: "BR.22.2411403", name: "Santana do Matos" },
    { code: "BR.22.2411429", name: "Santana do Seridó" },
    { code: "BR.22.2411502", name: "Santo Antônio" },
    { code: "BR.22.2411601", name: "São Bento do Norte" },
    { code: "BR.22.2411700", name: "São Bento do Trairí" },
    { code: "BR.22.2411809", name: "São Fernando" },
    { code: "BR.22.2411908", name: "São Francisco do Oeste" },
    { code: "BR.22.2412005", name: "São Gonçalo do Amarante" },
    { code: "BR.22.2412104", name: "São João do Sabugi" },
    { code: "BR.22.2412203", name: "São José de Mipibu" },
    { code: "BR.22.2412302", name: "São José do Campestre" },
    { code: "BR.22.2412401", name: "São José do Seridó" },
    { code: "BR.22.2412500", name: "São Miguel" },
    { code: "BR.22.2412559", name: "São Miguel do Gostoso" },
    { code: "BR.22.2412609", name: "São Paulo do Potengi" },
    { code: "BR.22.2412708", name: "São Pedro" },
    { code: "BR.22.2412807", name: "São Rafael" },
    { code: "BR.22.2412906", name: "São Tomé" },
    { code: "BR.22.2413003", name: "São Vicente" },
    { code: "BR.22.2413102", name: "Senador Elói de Souza" },
    { code: "BR.22.2413201", name: "Senador Georgino Avelino" },
    { code: "BR.22.2413300", name: "Serra de São Bento" },
    { code: "BR.22.2413359", name: "Serra do Mel" },
    { code: "BR.22.2413409", name: "Serra Negra do Norte" },
    { code: "BR.22.2413508", name: "Serrinha" },
    { code: "BR.22.2413557", name: "Serrinha dos Pintos" },
    { code: "BR.22.2413607", name: "Severiano Melo" },
    { code: "BR.22.2413706", name: "Sítio Novo" },
    { code: "BR.22.2413805", name: "Taboleiro Grande" },
    { code: "BR.22.2413904", name: "Taipu" },
    { code: "BR.22.2414001", name: "Tangará" },
    { code: "BR.22.2414100", name: "Tenente Ananias" },
    { code: "BR.22.2414159", name: "Tenente Laurentino Cruz" },
    { code: "BR.22.2414209", name: "Tibau do Sul" },
    { code: "BR.22.2414308", name: "Timbaúba dos Batistas" },
    { code: "BR.22.2414407", name: "Touros" },
    { code: "BR.22.2414456", name: "Triunfo Potiguar" },
    { code: "BR.22.2414506", name: "Umarizal" },
    { code: "BR.22.2414605", name: "Upanema" },
    { code: "BR.22.2414704", name: "Várzea" },
    { code: "BR.22.2414753", name: "Venha-Ver" },
    { code: "BR.22.2414803", name: "Vera Cruz" },
    { code: "BR.22.2414902", name: "Viçosa" },
    { code: "BR.22.2415008", name: "Vila Flor" },
  ],
  "BR.23": [
    { code: "BR.23.4300034", name: "Aceguá" },
    { code: "BR.23.4300059", name: "Água Santa" },
    { code: "BR.23.4300109", name: "Agudo" },
    { code: "BR.23.4300208", name: "Ajuricaba" },
    { code: "BR.23.4300307", name: "Alecrim" },
    { code: "BR.23.4300406", name: "Alegrete" },
    { code: "BR.23.4300455", name: "Alegria" },
    { code: "BR.23.4300471", name: "Almirante Tamandaré do Sul" },
    { code: "BR.23.4300505", name: "Alpestre" },
    { code: "BR.23.4300554", name: "Alto Alegre" },
    { code: "BR.23.4300570", name: "Alto Feliz" },
    { code: "BR.23.4300604", name: "Alvorada" },
    { code: "BR.23.4300638", name: "Amaral Ferrador" },
    { code: "BR.23.4300646", name: "Ametista do Sul" },
    { code: "BR.23.4300661", name: "André da Rocha" },
    { code: "BR.23.4300703", name: "Anta Gorda" },
    { code: "BR.23.4300802", name: "Antônio Prado" },
    { code: "BR.23.4300851", name: "Arambaré" },
    { code: "BR.23.4300877", name: "Araricá" },
    { code: "BR.23.4300901", name: "Aratiba" },
    { code: "BR.23.4301008", name: "Arroio do Meio" },
    { code: "BR.23.4301057", name: "Arroio do Sal" },
    { code: "BR.23.4301073", name: "Arroio do Padre" },
    { code: "BR.23.4301107", name: "Arroio dos Ratos" },
    { code: "BR.23.4301206", name: "Arroio do Tigre" },
    { code: "BR.23.4301305", name: "Arroio Grande" },
    { code: "BR.23.4301404", name: "Arvorezinha" },
    { code: "BR.23.4301503", name: "Augusto Pestana" },
    { code: "BR.23.4301552", name: "Áurea" },
    { code: "BR.23.4301602", name: "Bagé" },
    { code: "BR.23.4301636", name: "Balneário Pinhal" },
    { code: "BR.23.4301651", name: "Barão" },
    { code: "BR.23.4301701", name: "Barão de Cotegipe" },
    { code: "BR.23.4301750", name: "Barão do Triunfo" },
    { code: "BR.23.4301800", name: "Barracão" },
    { code: "BR.23.4301859", name: "Barra do Guarita" },
    { code: "BR.23.4301875", name: "Barra do Quaraí" },
    { code: "BR.23.4301909", name: "Barra do Ribeiro" },
    { code: "BR.23.4301925", name: "Barra do Rio Azul" },
    { code: "BR.23.4301958", name: "Barra Funda" },
    { code: "BR.23.4302006", name: "Barros Cassal" },
    { code: "BR.23.4302055", name: "Benjamin Constant do Sul" },
    { code: "BR.23.4302105", name: "Bento Gonçalves" },
    { code: "BR.23.4302154", name: "Boa Vista das Missões" },
    { code: "BR.23.4302204", name: "Boa Vista do Buricá" },
    { code: "BR.23.4302220", name: "Boa Vista do Cadeado" },
    { code: "BR.23.4302238", name: "Boa Vista do Incra" },
    { code: "BR.23.4302253", name: "Boa Vista do Sul" },
    { code: "BR.23.4302303", name: "Bom Jesus" },
    { code: "BR.23.4302352", name: "Bom Princípio" },
    { code: "BR.23.4302378", name: "Bom Progresso" },
    { code: "BR.23.4302402", name: "Bom Retiro do Sul" },
    { code: "BR.23.4302451", name: "Boqueirão do Leão" },
    { code: "BR.23.4302501", name: "Bossoroca" },
    { code: "BR.23.4302584", name: "Bozano" },
    { code: "BR.23.4302600", name: "Braga" },
    { code: "BR.23.4302659", name: "Brochier" },
    { code: "BR.23.4302709", name: "Butiá" },
    { code: "BR.23.4302808", name: "Caçapava do Sul" },
    { code: "BR.23.4302907", name: "Cacequi" },
    { code: "BR.23.4303004", name: "Cachoeira do Sul" },
    { code: "BR.23.4303103", name: "Cachoeirinha" },
    { code: "BR.23.4303202", name: "Cacique Doble" },
    { code: "BR.23.4303301", name: "Caibaté" },
    { code: "BR.23.4303400", name: "Caiçara" },
    { code: "BR.23.4303509", name: "Camaquã" },
    { code: "BR.23.4303558", name: "Camargo" },
    { code: "BR.23.4303608", name: "Cambará do Sul" },
    { code: "BR.23.4303673", name: "Campestre da Serra" },
    { code: "BR.23.4303707", name: "Campina das Missões" },
    { code: "BR.23.4303806", name: "Campinas do Sul" },
    { code: "BR.23.4303905", name: "Campo Bom" },
    { code: "BR.23.4304002", name: "Campo Novo" },
    { code: "BR.23.4304101", name: "Campos Borges" },
    { code: "BR.23.4304200", name: "Candelária" },
    { code: "BR.23.4304309", name: "Cândido Godói" },
    { code: "BR.23.4304358", name: "Candiota" },
    { code: "BR.23.4304408", name: "Canela" },
    { code: "BR.23.4304507", name: "Canguçu" },
    { code: "BR.23.4304606", name: "Canoas" },
    { code: "BR.23.4304614", name: "Canudos do Vale" },
    { code: "BR.23.4304622", name: "Capão Bonito do Sul" },
    { code: "BR.23.4304630", name: "Capão da Canoa" },
    { code: "BR.23.4304655", name: "Capão do Cipó" },
    { code: "BR.23.4304663", name: "Capão do Leão" },
    { code: "BR.23.4304671", name: "Capivari do Sul" },
    { code: "BR.23.4304689", name: "Capela de Santana" },
    { code: "BR.23.4304697", name: "Capitão" },
    { code: "BR.23.4304705", name: "Carazinho" },
    { code: "BR.23.4304713", name: "Caraá" },
    { code: "BR.23.4304804", name: "Carlos Barbosa" },
    { code: "BR.23.4304853", name: "Carlos Gomes" },
    { code: "BR.23.4304903", name: "Casca" },
    { code: "BR.23.4304952", name: "Caseiros" },
    { code: "BR.23.4305009", name: "Catuípe" },
    { code: "BR.23.4305108", name: "Caxias do Sul" },
    { code: "BR.23.4305116", name: "Centenário" },
    { code: "BR.23.4305124", name: "Cerrito" },
    { code: "BR.23.4305132", name: "Cerro Branco" },
    { code: "BR.23.4305157", name: "Cerro Grande" },
    { code: "BR.23.4305173", name: "Cerro Grande do Sul" },
    { code: "BR.23.4305207", name: "Cerro Largo" },
    { code: "BR.23.4305306", name: "Chapada" },
    { code: "BR.23.4305355", name: "Charqueadas" },
    { code: "BR.23.4305371", name: "Charrua" },
    { code: "BR.23.4305405", name: "Chiapetta" },
    { code: "BR.23.4305439", name: "Chuí" },
    { code: "BR.23.4305447", name: "Chuvisca" },
    { code: "BR.23.4305454", name: "Cidreira" },
    { code: "BR.23.4305504", name: "Ciríaco" },
    { code: "BR.23.4305587", name: "Colinas" },
    { code: "BR.23.4305603", name: "Colorado" },
    { code: "BR.23.4305702", name: "Condor" },
    { code: "BR.23.4305801", name: "Constantina" },
    { code: "BR.23.4305835", name: "Coqueiro Baixo" },
    { code: "BR.23.4305850", name: "Coqueiros do Sul" },
    { code: "BR.23.4305871", name: "Coronel Barros" },
    { code: "BR.23.4305900", name: "Coronel Bicaco" },
    { code: "BR.23.4305934", name: "Coronel Pilar" },
    { code: "BR.23.4305959", name: "Cotiporã" },
    { code: "BR.23.4305975", name: "Coxilha" },
    { code: "BR.23.4306007", name: "Crissiumal" },
    { code: "BR.23.4306056", name: "Cristal" },
    { code: "BR.23.4306072", name: "Cristal do Sul" },
    { code: "BR.23.4306106", name: "Cruz Alta" },
    { code: "BR.23.4306130", name: "Cruzaltense" },
    { code: "BR.23.4306205", name: "Cruzeiro do Sul" },
    { code: "BR.23.4306304", name: "David Canabarro" },
    { code: "BR.23.4306320", name: "Derrubadas" },
    { code: "BR.23.4306353", name: "Dezesseis de Novembro" },
    { code: "BR.23.4306379", name: "Dilermando de Aguiar" },
    { code: "BR.23.4306403", name: "Dois Irmãos" },
    { code: "BR.23.4306429", name: "Dois Irmãos das Missões" },
    { code: "BR.23.4306452", name: "Dois Lajeados" },
    { code: "BR.23.4306502", name: "Dom Feliciano" },
    { code: "BR.23.4306551", name: "Dom Pedro de Alcântara" },
    { code: "BR.23.4306601", name: "Dom Pedrito" },
    { code: "BR.23.4306700", name: "Dona Francisca" },
    { code: "BR.23.4306734", name: "Doutor Maurício Cardoso" },
    { code: "BR.23.4306759", name: "Doutor Ricardo" },
    { code: "BR.23.4306767", name: "Eldorado do Sul" },
    { code: "BR.23.4306809", name: "Encantado" },
    { code: "BR.23.4306908", name: "Encruzilhada do Sul" },
    { code: "BR.23.4306924", name: "Engenho Velho" },
    { code: "BR.23.4306932", name: "Entre-Ijuís" },
    { code: "BR.23.4306957", name: "Entre Rios do Sul" },
    { code: "BR.23.4306973", name: "Erebango" },
    { code: "BR.23.4307005", name: "Erechim" },
    { code: "BR.23.4307054", name: "Ernestina" },
    { code: "BR.23.4307104", name: "Herval" },
    { code: "BR.23.4307203", name: "Erval Grande" },
    { code: "BR.23.4307302", name: "Erval Seco" },
    { code: "BR.23.4307401", name: "Esmeralda" },
    { code: "BR.23.4307450", name: "Esperança do Sul" },
    { code: "BR.23.4307500", name: "Espumoso" },
    { code: "BR.23.4307559", name: "Estação" },
    { code: "BR.23.4307609", name: "Estância Velha" },
    { code: "BR.23.4307708", name: "Esteio" },
    { code: "BR.23.4307807", name: "Estrela" },
    { code: "BR.23.4307815", name: "Estrela Velha" },
    { code: "BR.23.4307831", name: "Eugênio de Castro" },
    { code: "BR.23.4307864", name: "Fagundes Varela" },
    { code: "BR.23.4307906", name: "Farroupilha" },
    { code: "BR.23.4308003", name: "Faxinal do Soturno" },
    { code: "BR.23.4308052", name: "Faxinalzinho" },
    { code: "BR.23.4308078", name: "Fazenda Vilanova" },
    { code: "BR.23.4308102", name: "Feliz" },
    { code: "BR.23.4308201", name: "Flores da Cunha" },
    { code: "BR.23.4308250", name: "Floriano Peixoto" },
    { code: "BR.23.4308300", name: "Fontoura Xavier" },
    { code: "BR.23.4308409", name: "Formigueiro" },
    { code: "BR.23.4308433", name: "Forquetinha" },
    { code: "BR.23.4308458", name: "Fortaleza dos Valos" },
    { code: "BR.23.4308508", name: "Frederico Westphalen" },
    { code: "BR.23.4308607", name: "Garibaldi" },
    { code: "BR.23.4308656", name: "Garruchos" },
    { code: "BR.23.4308706", name: "Gaurama" },
    { code: "BR.23.4308805", name: "General Câmara" },
    { code: "BR.23.4308854", name: "Gentil" },
    { code: "BR.23.4308904", name: "Getúlio Vargas" },
    { code: "BR.23.4309001", name: "Giruá" },
    { code: "BR.23.4309050", name: "Glorinha" },
    { code: "BR.23.4309100", name: "Gramado" },
    { code: "BR.23.4309126", name: "Gramado dos Loureiros" },
    { code: "BR.23.4309159", name: "Gramado Xavier" },
    { code: "BR.23.4309209", name: "Gravataí" },
    { code: "BR.23.4309258", name: "Guabiju" },
    { code: "BR.23.4309308", name: "Guaíba" },
    { code: "BR.23.4309407", name: "Guaporé" },
    { code: "BR.23.4309506", name: "Guarani das Missões" },
    { code: "BR.23.4309555", name: "Harmonia" },
    { code: "BR.23.4309571", name: "Herveiras" },
    { code: "BR.23.4309605", name: "Horizontina" },
    { code: "BR.23.4309654", name: "Hulha Negra" },
    { code: "BR.23.4309704", name: "Humaitá" },
    { code: "BR.23.4309753", name: "Ibarama" },
    { code: "BR.23.4309803", name: "Ibiaçá" },
    { code: "BR.23.4309902", name: "Ibiraiaras" },
    { code: "BR.23.4309951", name: "Ibirapuitã" },
    { code: "BR.23.4310009", name: "Ibirubá" },
    { code: "BR.23.4310108", name: "Igrejinha" },
    { code: "BR.23.4310207", name: "Ijuí" },
    { code: "BR.23.4310306", name: "Ilópolis" },
    { code: "BR.23.4310330", name: "Imbé" },
    { code: "BR.23.4310363", name: "Imigrante" },
    { code: "BR.23.4310405", name: "Independência" },
    { code: "BR.23.4310413", name: "Inhacorá" },
    { code: "BR.23.4310439", name: "Ipê" },
    { code: "BR.23.4310462", name: "Ipiranga do Sul" },
    { code: "BR.23.4310504", name: "Iraí" },
    { code: "BR.23.4310538", name: "Itaara" },
    { code: "BR.23.4310553", name: "Itacurubi" },
    { code: "BR.23.4310579", name: "Itapuca" },
    { code: "BR.23.4310603", name: "Itaqui" },
    { code: "BR.23.4310652", name: "Itati" },
    { code: "BR.23.4310702", name: "Itatiba do Sul" },
    { code: "BR.23.4310751", name: "Ivorá" },
    { code: "BR.23.4310801", name: "Ivoti" },
    { code: "BR.23.4310850", name: "Jaboticaba" },
    { code: "BR.23.4310876", name: "Jacuizinho" },
    { code: "BR.23.4310900", name: "Jacutinga" },
    { code: "BR.23.4311007", name: "Jaguarão" },
    { code: "BR.23.4311106", name: "Jaguari" },
    { code: "BR.23.4311122", name: "Jaquirana" },
    { code: "BR.23.4311130", name: "Jari" },
    { code: "BR.23.4311155", name: "Jóia" },
    { code: "BR.23.4311205", name: "Júlio de Castilhos" },
    { code: "BR.23.4311239", name: "Lagoa Bonita do Sul" },
    { code: "BR.23.4311254", name: "Lagoão" },
    { code: "BR.23.4311270", name: "Lagoa dos Três Cantos" },
    { code: "BR.23.4311304", name: "Lagoa Vermelha" },
    { code: "BR.23.4311403", name: "Lajeado" },
    { code: "BR.23.4311429", name: "Lajeado do Bugre" },
    { code: "BR.23.4311502", name: "Lavras do Sul" },
    { code: "BR.23.4311601", name: "Liberato Salzano" },
    { code: "BR.23.4311627", name: "Lindolfo Collor" },
    { code: "BR.23.4311643", name: "Linha Nova" },
    { code: "BR.23.4311700", name: "Machadinho" },
    { code: "BR.23.4311718", name: "Maçambará" },
    { code: "BR.23.4311734", name: "Mampituba" },
    { code: "BR.23.4311759", name: "Manoel Viana" },
    { code: "BR.23.4311775", name: "Maquiné" },
    { code: "BR.23.4311791", name: "Maratá" },
    { code: "BR.23.4311809", name: "Marau" },
    { code: "BR.23.4311908", name: "Marcelino Ramos" },
    { code: "BR.23.4311981", name: "Mariana Pimentel" },
    { code: "BR.23.4312005", name: "Mariano Moro" },
    { code: "BR.23.4312054", name: "Marques de Souza" },
    { code: "BR.23.4312104", name: "Mata" },
    { code: "BR.23.4312138", name: "Mato Castelhano" },
    { code: "BR.23.4312153", name: "Mato Leitão" },
    { code: "BR.23.4312179", name: "Mato Queimado" },
    { code: "BR.23.4312203", name: "Maximiliano de Almeida" },
    { code: "BR.23.4312252", name: "Minas do Leão" },
    { code: "BR.23.4312302", name: "Miraguaí" },
    { code: "BR.23.4312351", name: "Montauri" },
    { code: "BR.23.4312377", name: "Monte Alegre dos Campos" },
    { code: "BR.23.4312385", name: "Monte Belo do Sul" },
    { code: "BR.23.4312401", name: "Montenegro" },
    { code: "BR.23.4312427", name: "Mormaço" },
    { code: "BR.23.4312443", name: "Morrinhos do Sul" },
    { code: "BR.23.4312450", name: "Morro Redondo" },
    { code: "BR.23.4312476", name: "Morro Reuter" },
    { code: "BR.23.4312500", name: "Mostardas" },
    { code: "BR.23.4312609", name: "Muçum" },
    { code: "BR.23.4312617", name: "Muitos Capões" },
    { code: "BR.23.4312625", name: "Muliterno" },
    { code: "BR.23.4312658", name: "Não-Me-Toque" },
    { code: "BR.23.4312674", name: "Nicolau Vergueiro" },
    { code: "BR.23.4312708", name: "Nonoai" },
    { code: "BR.23.4312757", name: "Nova Alvorada" },
    { code: "BR.23.4312807", name: "Nova Araçá" },
    { code: "BR.23.4312906", name: "Nova Bassano" },
    { code: "BR.23.4312955", name: "Nova Boa Vista" },
    { code: "BR.23.4313003", name: "Nova Bréscia" },
    { code: "BR.23.4313011", name: "Nova Candelária" },
    { code: "BR.23.4313037", name: "Nova Esperança do Sul" },
    { code: "BR.23.4313060", name: "Nova Hartz" },
    { code: "BR.23.4313086", name: "Nova Pádua" },
    { code: "BR.23.4313102", name: "Nova Palma" },
    { code: "BR.23.4313201", name: "Nova Petrópolis" },
    { code: "BR.23.4313300", name: "Nova Prata" },
    { code: "BR.23.4313334", name: "Nova Ramada" },
    { code: "BR.23.4313359", name: "Nova Roma do Sul" },
    { code: "BR.23.4313375", name: "Nova Santa Rita" },
    { code: "BR.23.4313391", name: "Novo Cabrais" },
    { code: "BR.23.4313409", name: "Novo Hamburgo" },
    { code: "BR.23.4313425", name: "Novo Machado" },
    { code: "BR.23.4313441", name: "Novo Tiradentes" },
    { code: "BR.23.4313466", name: "Novo Xingu" },
    { code: "BR.23.4313490", name: "Novo Barreiro" },
    { code: "BR.23.4313508", name: "Osório" },
    { code: "BR.23.4313607", name: "Paim Filho" },
    { code: "BR.23.4313656", name: "Palmares do Sul" },
    { code: "BR.23.4313706", name: "Palmeira das Missões" },
    { code: "BR.23.4313805", name: "Palmitinho" },
    { code: "BR.23.4313904", name: "Panambi" },
    { code: "BR.23.4313953", name: "Pantano Grande" },
    { code: "BR.23.4314001", name: "Paraí" },
    { code: "BR.23.4314027", name: "Paraíso do Sul" },
    { code: "BR.23.4314035", name: "Pareci Novo" },
    { code: "BR.23.4314050", name: "Parobé" },
    { code: "BR.23.4314068", name: "Passa Sete" },
    { code: "BR.23.4314076", name: "Passo do Sobrado" },
    { code: "BR.23.4314100", name: "Passo Fundo" },
    { code: "BR.23.4314134", name: "Paulo Bento" },
    { code: "BR.23.4314159", name: "Paverama" },
    { code: "BR.23.4314175", name: "Pedras Altas" },
    { code: "BR.23.4314209", name: "Pedro Osório" },
    { code: "BR.23.4314308", name: "Pejuçara" },
    { code: "BR.23.4314407", name: "Pelotas" },
    { code: "BR.23.4314423", name: "Picada Café" },
    { code: "BR.23.4314456", name: "Pinhal" },
    { code: "BR.23.4314464", name: "Pinhal da Serra" },
    { code: "BR.23.4314472", name: "Pinhal Grande" },
    { code: "BR.23.4314498", name: "Pinheirinho do Vale" },
    { code: "BR.23.4314506", name: "Pinheiro Machado" },
    { code: "BR.23.4314548", name: "Pinto Bandeira" },
    { code: "BR.23.4314555", name: "Pirapó" },
    { code: "BR.23.4314605", name: "Piratini" },
    { code: "BR.23.4314704", name: "Planalto" },
    { code: "BR.23.4314753", name: "Poço das Antas" },
    { code: "BR.23.4314779", name: "Pontão" },
    { code: "BR.23.4314787", name: "Ponte Preta" },
    { code: "BR.23.4314803", name: "Portão" },
    { code: "BR.23.4314902", name: "Porto Alegre" },
    { code: "BR.23.4315008", name: "Porto Lucena" },
    { code: "BR.23.4315057", name: "Porto Mauá" },
    { code: "BR.23.4315073", name: "Porto Vera Cruz" },
    { code: "BR.23.4315107", name: "Porto Xavier" },
    { code: "BR.23.4315131", name: "Pouso Novo" },
    { code: "BR.23.4315149", name: "Presidente Lucena" },
    { code: "BR.23.4315156", name: "Progresso" },
    { code: "BR.23.4315172", name: "Protásio Alves" },
    { code: "BR.23.4315206", name: "Putinga" },
    { code: "BR.23.4315305", name: "Quaraí" },
    { code: "BR.23.4315313", name: "Quatro Irmãos" },
    { code: "BR.23.4315321", name: "Quevedos" },
    { code: "BR.23.4315354", name: "Quinze de Novembro" },
    { code: "BR.23.4315404", name: "Redentora" },
    { code: "BR.23.4315453", name: "Relvado" },
    { code: "BR.23.4315503", name: "Restinga Sêca" },
    { code: "BR.23.4315552", name: "Rio dos Índios" },
    { code: "BR.23.4315602", name: "Rio Grande" },
    { code: "BR.23.4315701", name: "Rio Pardo" },
    { code: "BR.23.4315750", name: "Riozinho" },
    { code: "BR.23.4315800", name: "Roca Sales" },
    { code: "BR.23.4315909", name: "Rodeio Bonito" },
    { code: "BR.23.4315958", name: "Rolador" },
    { code: "BR.23.4316006", name: "Rolante" },
    { code: "BR.23.4316105", name: "Ronda Alta" },
    { code: "BR.23.4316204", name: "Rondinha" },
    { code: "BR.23.4316303", name: "Roque Gonzales" },
    { code: "BR.23.4316402", name: "Rosário do Sul" },
    { code: "BR.23.4316428", name: "Sagrada Família" },
    { code: "BR.23.4316436", name: "Saldanha Marinho" },
    { code: "BR.23.4316451", name: "Salto do Jacuí" },
    { code: "BR.23.4316477", name: "Salvador das Missões" },
    { code: "BR.23.4316501", name: "Salvador do Sul" },
    { code: "BR.23.4316600", name: "Sananduva" },
    { code: "BR.23.4316709", name: "Santa Bárbara do Sul" },
    { code: "BR.23.4316733", name: "Santa Cecília do Sul" },
    { code: "BR.23.4316758", name: "Santa Clara do Sul" },
    { code: "BR.23.4316808", name: "Santa Cruz do Sul" },
    { code: "BR.23.4316907", name: "Santa Maria" },
    { code: "BR.23.4316956", name: "Santa Maria do Herval" },
    { code: "BR.23.4316972", name: "Santa Margarida do Sul" },
    { code: "BR.23.4317004", name: "Santana da Boa Vista" },
    { code: "BR.23.4317103", name: "Sant'Ana do Livramento" },
    { code: "BR.23.4317202", name: "Santa Rosa" },
    { code: "BR.23.4317251", name: "Santa Tereza" },
    { code: "BR.23.4317301", name: "Santa Vitória do Palmar" },
    { code: "BR.23.4317400", name: "Santiago" },
    { code: "BR.23.4317509", name: "Santo Ângelo" },
    { code: "BR.23.4317558", name: "Santo Antônio do Palma" },
    { code: "BR.23.4317608", name: "Santo Antônio da Patrulha" },
    { code: "BR.23.4317707", name: "Santo Antônio das Missões" },
    { code: "BR.23.4317756", name: "Santo Antônio do Planalto" },
    { code: "BR.23.4317806", name: "Santo Augusto" },
    { code: "BR.23.4317905", name: "Santo Cristo" },
    { code: "BR.23.4317954", name: "Santo Expedito do Sul" },
    { code: "BR.23.4318002", name: "São Borja" },
    { code: "BR.23.4318051", name: "São Domingos do Sul" },
    { code: "BR.23.4318101", name: "São Francisco de Assis" },
    { code: "BR.23.4318200", name: "São Francisco de Paula" },
    { code: "BR.23.4318309", name: "São Gabriel" },
    { code: "BR.23.4318408", name: "São Jerônimo" },
    { code: "BR.23.4318424", name: "São João da Urtiga" },
    { code: "BR.23.4318432", name: "São João do Polêsine" },
    { code: "BR.23.4318440", name: "São Jorge" },
    { code: "BR.23.4318457", name: "São José das Missões" },
    { code: "BR.23.4318465", name: "São José do Herval" },
    { code: "BR.23.4318481", name: "São José do Hortêncio" },
    { code: "BR.23.4318499", name: "São José do Inhacorá" },
    { code: "BR.23.4318507", name: "São José do Norte" },
    { code: "BR.23.4318606", name: "São José do Ouro" },
    { code: "BR.23.4318614", name: "São José do Sul" },
    { code: "BR.23.4318622", name: "São José dos Ausentes" },
    { code: "BR.23.4318705", name: "São Leopoldo" },
    { code: "BR.23.4318804", name: "São Lourenço do Sul" },
    { code: "BR.23.4318903", name: "São Luiz Gonzaga" },
    { code: "BR.23.4319000", name: "São Marcos" },
    { code: "BR.23.4319109", name: "São Martinho" },
    { code: "BR.23.4319125", name: "São Martinho da Serra" },
    { code: "BR.23.4319158", name: "São Miguel das Missões" },
    { code: "BR.23.4319208", name: "São Nicolau" },
    { code: "BR.23.4319307", name: "São Paulo das Missões" },
    { code: "BR.23.4319356", name: "São Pedro da Serra" },
    { code: "BR.23.4319364", name: "São Pedro das Missões" },
    { code: "BR.23.4319372", name: "São Pedro do Butiá" },
    { code: "BR.23.4319406", name: "São Pedro do Sul" },
    { code: "BR.23.4319505", name: "São Sebastião do Caí" },
    { code: "BR.23.4319604", name: "São Sepé" },
    { code: "BR.23.4319703", name: "São Valentim" },
    { code: "BR.23.4319711", name: "São Valentim do Sul" },
    { code: "BR.23.4319737", name: "São Valério do Sul" },
    { code: "BR.23.4319752", name: "São Vendelino" },
    { code: "BR.23.4319802", name: "São Vicente do Sul" },
    { code: "BR.23.4319901", name: "Sapiranga" },
    { code: "BR.23.4320008", name: "Sapucaia do Sul" },
    { code: "BR.23.4320107", name: "Sarandi" },
    { code: "BR.23.4320206", name: "Seberi" },
    { code: "BR.23.4320230", name: "Sede Nova" },
    { code: "BR.23.4320263", name: "Segredo" },
    { code: "BR.23.4320305", name: "Selbach" },
    { code: "BR.23.4320321", name: "Senador Salgado Filho" },
    { code: "BR.23.4320354", name: "Sentinela do Sul" },
    { code: "BR.23.4320404", name: "Serafina Corrêa" },
    { code: "BR.23.4320453", name: "Sério" },
    { code: "BR.23.4320503", name: "Sertão" },
    { code: "BR.23.4320552", name: "Sertão Santana" },
    { code: "BR.23.4320578", name: "Sete de Setembro" },
    { code: "BR.23.4320602", name: "Severiano de Almeida" },
    { code: "BR.23.4320651", name: "Silveira Martins" },
    { code: "BR.23.4320677", name: "Sinimbu" },
    { code: "BR.23.4320701", name: "Sobradinho" },
    { code: "BR.23.4320800", name: "Soledade" },
    { code: "BR.23.4320859", name: "Tabaí" },
    { code: "BR.23.4320909", name: "Tapejara" },
    { code: "BR.23.4321006", name: "Tapera" },
    { code: "BR.23.4321105", name: "Tapes" },
    { code: "BR.23.4321204", name: "Taquara" },
    { code: "BR.23.4321303", name: "Taquari" },
    { code: "BR.23.4321329", name: "Taquaruçu do Sul" },
    { code: "BR.23.4321352", name: "Tavares" },
    { code: "BR.23.4321402", name: "Tenente Portela" },
    { code: "BR.23.4321436", name: "Terra de Areia" },
    { code: "BR.23.4321451", name: "Teutônia" },
    { code: "BR.23.4321469", name: "Tio Hugo" },
    { code: "BR.23.4321477", name: "Tiradentes do Sul" },
    { code: "BR.23.4321493", name: "Toropi" },
    { code: "BR.23.4321501", name: "Torres" },
    { code: "BR.23.4321600", name: "Tramandaí" },
    { code: "BR.23.4321626", name: "Travesseiro" },
    { code: "BR.23.4321634", name: "Três Arroios" },
    { code: "BR.23.4321667", name: "Três Cachoeiras" },
    { code: "BR.23.4321709", name: "Três Coroas" },
    { code: "BR.23.4321808", name: "Três de Maio" },
    { code: "BR.23.4321832", name: "Três Forquilhas" },
    { code: "BR.23.4321857", name: "Três Palmeiras" },
    { code: "BR.23.4321907", name: "Três Passos" },
    { code: "BR.23.4321956", name: "Trindade do Sul" },
    { code: "BR.23.4322004", name: "Triunfo" },
    { code: "BR.23.4322103", name: "Tucunduva" },
    { code: "BR.23.4322152", name: "Tunas" },
    { code: "BR.23.4322186", name: "Tupanci do Sul" },
    { code: "BR.23.4322202", name: "Tupanciretã" },
    { code: "BR.23.4322251", name: "Tupandi" },
    { code: "BR.23.4322301", name: "Tuparendi" },
    { code: "BR.23.4322327", name: "Turuçu" },
    { code: "BR.23.4322343", name: "Ubiretama" },
    { code: "BR.23.4322350", name: "União da Serra" },
    { code: "BR.23.4322376", name: "Unistalda" },
    { code: "BR.23.4322400", name: "Uruguaiana" },
    { code: "BR.23.4322509", name: "Vacaria" },
    { code: "BR.23.4322525", name: "Vale Verde" },
    { code: "BR.23.4322533", name: "Vale do Sol" },
    { code: "BR.23.4322541", name: "Vale Real" },
    { code: "BR.23.4322558", name: "Vanini" },
    { code: "BR.23.4322608", name: "Venâncio Aires" },
    { code: "BR.23.4322707", name: "Vera Cruz" },
    { code: "BR.23.4322806", name: "Veranópolis" },
    { code: "BR.23.4322855", name: "Vespasiano Corrêa" },
    { code: "BR.23.4322905", name: "Viadutos" },
    { code: "BR.23.4323002", name: "Viamão" },
    { code: "BR.23.4323101", name: "Vicente Dutra" },
    { code: "BR.23.4323200", name: "Victor Graeff" },
    { code: "BR.23.4323309", name: "Vila Flores" },
    { code: "BR.23.4323358", name: "Vila Lângaro" },
    { code: "BR.23.4323408", name: "Vila Maria" },
    { code: "BR.23.4323457", name: "Vila Nova do Sul" },
    { code: "BR.23.4323507", name: "Vista Alegre" },
    { code: "BR.23.4323606", name: "Vista Alegre do Prata" },
    { code: "BR.23.4323705", name: "Vista Gaúcha" },
    { code: "BR.23.4323754", name: "Vitória das Missões" },
    { code: "BR.23.4323770", name: "Westfália" },
    { code: "BR.23.4323804", name: "Xangri-lá" },
  ],
  "BR.24": [
    { code: "BR.24.1100015", name: "Alta Floresta d'Oeste" },
    { code: "BR.24.1100023", name: "Ariquemes" },
    { code: "BR.24.1100031", name: "Cabixi" },
    { code: "BR.24.1100049", name: "Cacoal" },
    { code: "BR.24.1100056", name: "Cerejeiras" },
    { code: "BR.24.1100064", name: "Colorado do Oeste" },
    { code: "BR.24.1100072", name: "Corumbiara" },
    { code: "BR.24.1100080", name: "Costa Marques" },
    { code: "BR.24.1100098", name: "Espigão d'Oeste" },
    { code: "BR.24.1100106", name: "Guajará-Mirim" },
    { code: "BR.24.1100114", name: "Jaru" },
    { code: "BR.24.1100122", name: "Ji-Paraná" },
    { code: "BR.24.1100130", name: "Machadinho d'Oeste" },
    { code: "BR.24.1100148", name: "Nova Brasilândia d'Oeste" },
    { code: "BR.24.1100155", name: "Ouro Preto do Oeste" },
    { code: "BR.24.1100189", name: "Pimenta Bueno" },
    { code: "BR.24.1100205", name: "Porto Velho" },
    { code: "BR.24.1100254", name: "Presidente Médici" },
    { code: "BR.24.1100262", name: "Rio Crespo" },
    { code: "BR.24.1100288", name: "Rolim de Moura" },
    { code: "BR.24.1100296", name: "Santa Luzia d'Oeste" },
    { code: "BR.24.1100304", name: "Vilhena" },
    { code: "BR.24.1100320", name: "São Miguel do Guaporé" },
    { code: "BR.24.1100338", name: "Nova Mamoré" },
    { code: "BR.24.1100346", name: "Alvorada d'Oeste" },
    { code: "BR.24.1100379", name: "Alto Alegre dos Parecis" },
    { code: "BR.24.1100403", name: "Alto Paraíso" },
    { code: "BR.24.1100452", name: "Buritis" },
    { code: "BR.24.1100502", name: "Novo Horizonte do Oeste" },
    { code: "BR.24.1100601", name: "Cacaulândia" },
    { code: "BR.24.1100700", name: "Campo Novo de Rondônia" },
    { code: "BR.24.1100809", name: "Candeias do Jamari" },
    { code: "BR.24.1100908", name: "Castanheiras" },
    { code: "BR.24.1100924", name: "Chupinguaia" },
    { code: "BR.24.1100940", name: "Cujubim" },
    { code: "BR.24.1101005", name: "Governador Jorge Teixeira" },
    { code: "BR.24.1101104", name: "Itapuã do Oeste" },
    { code: "BR.24.1101203", name: "Ministro Andreazza" },
    { code: "BR.24.1101302", name: "Mirante da Serra" },
    { code: "BR.24.1101401", name: "Monte Negro" },
    { code: "BR.24.1101435", name: "Nova União" },
    { code: "BR.24.1101450", name: "Parecis" },
    { code: "BR.24.1101468", name: "Pimenteiras do Oeste" },
    { code: "BR.24.1101476", name: "Primavera de Rondônia" },
    { code: "BR.24.1101484", name: "São Felipe d'Oeste" },
    { code: "BR.24.1101492", name: "São Francisco do Guaporé" },
    { code: "BR.24.1101500", name: "Seringueiras" },
    { code: "BR.24.1101559", name: "Teixeirópolis" },
    { code: "BR.24.1101609", name: "Theobroma" },
    { code: "BR.24.1101708", name: "Urupá" },
    { code: "BR.24.1101757", name: "Vale do Anari" },
    { code: "BR.24.1101807", name: "Vale do Paraíso" },
  ],
  "BR.25": [
    { code: "BR.25.1400027", name: "Amajari" },
    { code: "BR.25.1400050", name: "Alto Alegre" },
    { code: "BR.25.1400100", name: "Boa Vista" },
    { code: "BR.25.1400159", name: "Bonfim" },
    { code: "BR.25.1400175", name: "Cantá" },
    { code: "BR.25.1400209", name: "Caracaraí" },
    { code: "BR.25.1400233", name: "Caroebe" },
    { code: "BR.25.1400282", name: "Iracema" },
    { code: "BR.25.1400308", name: "Mucajaí" },
    { code: "BR.25.1400407", name: "Normandia" },
    { code: "BR.25.1400456", name: "Pacaraima" },
    { code: "BR.25.1400472", name: "Rorainópolis" },
    { code: "BR.25.1400506", name: "São João da Baliza" },
    { code: "BR.25.1400605", name: "São Luiz" },
    { code: "BR.25.1400704", name: "Uiramutã" },
  ],
  "BR.26": [
    { code: "BR.26.4200051", name: "Abdon Batista" },
    { code: "BR.26.4200101", name: "Abelardo Luz" },
    { code: "BR.26.4200200", name: "Agrolândia" },
    { code: "BR.26.4200309", name: "Agronômica" },
    { code: "BR.26.4200408", name: "Água Doce" },
    { code: "BR.26.4200507", name: "Águas de Chapecó" },
    { code: "BR.26.4200556", name: "Águas Frias" },
    { code: "BR.26.4200606", name: "Águas Mornas" },
    { code: "BR.26.4200705", name: "Alfredo Wagner" },
    { code: "BR.26.4200754", name: "Alto Bela Vista" },
    { code: "BR.26.4200804", name: "Anchieta" },
    { code: "BR.26.4200903", name: "Angelina" },
    { code: "BR.26.4201000", name: "Anita Garibaldi" },
    { code: "BR.26.4201109", name: "Anitápolis" },
    { code: "BR.26.4201208", name: "Antônio Carlos" },
    { code: "BR.26.4201257", name: "Apiúna" },
    { code: "BR.26.4201273", name: "Arabutã" },
    { code: "BR.26.4201307", name: "Araquari" },
    { code: "BR.26.4201406", name: "Araranguá" },
    { code: "BR.26.4201505", name: "Armazém" },
    { code: "BR.26.4201604", name: "Arroio Trinta" },
    { code: "BR.26.4201653", name: "Arvoredo" },
    { code: "BR.26.4201703", name: "Ascurra" },
    { code: "BR.26.4201802", name: "Atalanta" },
    { code: "BR.26.4201901", name: "Aurora" },
    { code: "BR.26.4201950", name: "Balneário Arroio do Silva" },
    { code: "BR.26.4202008", name: "Balneário Camboriú" },
    { code: "BR.26.4202057", name: "Balneário Barra do Sul" },
    { code: "BR.26.4202073", name: "Balneário Gaivota" },
    { code: "BR.26.4202081", name: "Bandeirante" },
    { code: "BR.26.4202099", name: "Barra Bonita" },
    { code: "BR.26.4202107", name: "Barra Velha" },
    { code: "BR.26.4202131", name: "Bela Vista do Toldo" },
    { code: "BR.26.4202156", name: "Belmonte" },
    { code: "BR.26.4202206", name: "Benedito Novo" },
    { code: "BR.26.4202305", name: "Biguaçu" },
    { code: "BR.26.4202404", name: "Blumenau" },
    { code: "BR.26.4202438", name: "Bocaina do Sul" },
    { code: "BR.26.4202453", name: "Bombinhas" },
    { code: "BR.26.4202503", name: "Bom Jardim da Serra" },
    { code: "BR.26.4202537", name: "Bom Jesus" },
    { code: "BR.26.4202578", name: "Bom Jesus do Oeste" },
    { code: "BR.26.4202602", name: "Bom Retiro" },
    { code: "BR.26.4202701", name: "Botuverá" },
    { code: "BR.26.4202800", name: "Braço do Norte" },
    { code: "BR.26.4202859", name: "Braço do Trombudo" },
    { code: "BR.26.4202875", name: "Brunópolis" },
    { code: "BR.26.4202909", name: "Brusque" },
    { code: "BR.26.4203006", name: "Caçador" },
    { code: "BR.26.4203105", name: "Caibi" },
    { code: "BR.26.4203154", name: "Calmon" },
    { code: "BR.26.4203204", name: "Camboriú" },
    { code: "BR.26.4203253", name: "Capão Alto" },
    { code: "BR.26.4203303", name: "Campo Alegre" },
    { code: "BR.26.4203402", name: "Campo Belo do Sul" },
    { code: "BR.26.4203501", name: "Campo Erê" },
    { code: "BR.26.4203600", name: "Campos Novos" },
    { code: "BR.26.4203709", name: "Canelinha" },
    { code: "BR.26.4203808", name: "Canoinhas" },
    { code: "BR.26.4203907", name: "Capinzal" },
    { code: "BR.26.4203956", name: "Capivari de Baixo" },
    { code: "BR.26.4204004", name: "Catanduvas" },
    { code: "BR.26.4204103", name: "Caxambu do Sul" },
    { code: "BR.26.4204152", name: "Celso Ramos" },
    { code: "BR.26.4204178", name: "Cerro Negro" },
    { code: "BR.26.4204194", name: "Chapadão do Lageado" },
    { code: "BR.26.4204202", name: "Chapecó" },
    { code: "BR.26.4204251", name: "Cocal do Sul" },
    { code: "BR.26.4204301", name: "Concórdia" },
    { code: "BR.26.4204350", name: "Cordilheira Alta" },
    { code: "BR.26.4204400", name: "Coronel Freitas" },
    { code: "BR.26.4204459", name: "Coronel Martins" },
    { code: "BR.26.4204509", name: "Corupá" },
    { code: "BR.26.4204558", name: "Correia Pinto" },
    { code: "BR.26.4204608", name: "Criciúma" },
    { code: "BR.26.4204707", name: "Cunha Porã" },
    { code: "BR.26.4204756", name: "Cunhataí" },
    { code: "BR.26.4204806", name: "Curitibanos" },
    { code: "BR.26.4204905", name: "Descanso" },
    { code: "BR.26.4205001", name: "Dionísio Cerqueira" },
    { code: "BR.26.4205100", name: "Dona Emma" },
    { code: "BR.26.4205159", name: "Doutor Pedrinho" },
    { code: "BR.26.4205175", name: "Entre Rios" },
    { code: "BR.26.4205191", name: "Ermo" },
    { code: "BR.26.4205209", name: "Erval Velho" },
    { code: "BR.26.4205308", name: "Faxinal dos Guedes" },
    { code: "BR.26.4205357", name: "Flor do Sertão" },
    { code: "BR.26.4205407", name: "Florianópolis" },
    { code: "BR.26.4205431", name: "Formosa do Sul" },
    { code: "BR.26.4205456", name: "Forquilhinha" },
    { code: "BR.26.4205506", name: "Fraiburgo" },
    { code: "BR.26.4205555", name: "Frei Rogério" },
    { code: "BR.26.4205605", name: "Galvão" },
    { code: "BR.26.4205704", name: "Garopaba" },
    { code: "BR.26.4205803", name: "Garuva" },
    { code: "BR.26.4205902", name: "Gaspar" },
    { code: "BR.26.4206009", name: "Governador Celso Ramos" },
    { code: "BR.26.4206108", name: "Grão Pará" },
    { code: "BR.26.4206207", name: "Gravatal" },
    { code: "BR.26.4206306", name: "Guabiruba" },
    { code: "BR.26.4206405", name: "Guaraciaba" },
    { code: "BR.26.4206504", name: "Guaramirim" },
    { code: "BR.26.4206603", name: "Guarujá do Sul" },
    { code: "BR.26.4206652", name: "Guatambú" },
    { code: "BR.26.4206702", name: "Herval d'Oeste" },
    { code: "BR.26.4206751", name: "Ibiam" },
    { code: "BR.26.4206801", name: "Ibicaré" },
    { code: "BR.26.4206900", name: "Ibirama" },
    { code: "BR.26.4207007", name: "Içara" },
    { code: "BR.26.4207106", name: "Ilhota" },
    { code: "BR.26.4207205", name: "Imaruí" },
    { code: "BR.26.4207304", name: "Imbituba" },
    { code: "BR.26.4207403", name: "Imbuia" },
    { code: "BR.26.4207502", name: "Indaial" },
    { code: "BR.26.4207577", name: "Iomerê" },
    { code: "BR.26.4207601", name: "Ipira" },
    { code: "BR.26.4207650", name: "Iporã do Oeste" },
    { code: "BR.26.4207684", name: "Ipuaçu" },
    { code: "BR.26.4207700", name: "Ipumirim" },
    { code: "BR.26.4207759", name: "Iraceminha" },
    { code: "BR.26.4207809", name: "Irani" },
    { code: "BR.26.4207858", name: "Irati" },
    { code: "BR.26.4207908", name: "Irineópolis" },
    { code: "BR.26.4208005", name: "Itá" },
    { code: "BR.26.4208104", name: "Itaiópolis" },
    { code: "BR.26.4208203", name: "Itajaí" },
    { code: "BR.26.4208302", name: "Itapema" },
    { code: "BR.26.4208401", name: "Itapiranga" },
    { code: "BR.26.4208450", name: "Itapoá" },
    { code: "BR.26.4208500", name: "Ituporanga" },
    { code: "BR.26.4208609", name: "Jaborá" },
    { code: "BR.26.4208708", name: "Jacinto Machado" },
    { code: "BR.26.4208807", name: "Jaguaruna" },
    { code: "BR.26.4208906", name: "Jaraguá do Sul" },
    { code: "BR.26.4208955", name: "Jardinópolis" },
    { code: "BR.26.4209003", name: "Joaçaba" },
    { code: "BR.26.4209102", name: "Joinville" },
    { code: "BR.26.4209151", name: "José Boiteux" },
    { code: "BR.26.4209177", name: "Jupiá" },
    { code: "BR.26.4209201", name: "Lacerdópolis" },
    { code: "BR.26.4209300", name: "Lages" },
    { code: "BR.26.4209409", name: "Laguna" },
    { code: "BR.26.4209458", name: "Lajeado Grande" },
    { code: "BR.26.4209508", name: "Laurentino" },
    { code: "BR.26.4209607", name: "Lauro Müller" },
    { code: "BR.26.4209706", name: "Lebon Régis" },
    { code: "BR.26.4209805", name: "Leoberto Leal" },
    { code: "BR.26.4209854", name: "Lindóia do Sul" },
    { code: "BR.26.4209904", name: "Lontras" },
    { code: "BR.26.4210001", name: "Luiz Alves" },
    { code: "BR.26.4210035", name: "Luzerna" },
    { code: "BR.26.4210050", name: "Macieira" },
    { code: "BR.26.4210100", name: "Mafra" },
    { code: "BR.26.4210209", name: "Major Gercino" },
    { code: "BR.26.4210308", name: "Major Vieira" },
    { code: "BR.26.4210407", name: "Maracajá" },
    { code: "BR.26.4210506", name: "Maravilha" },
    { code: "BR.26.4210555", name: "Marema" },
    { code: "BR.26.4210605", name: "Massaranduba" },
    { code: "BR.26.4210704", name: "Matos Costa" },
    { code: "BR.26.4210803", name: "Meleiro" },
    { code: "BR.26.4210852", name: "Mirim Doce" },
    { code: "BR.26.4210902", name: "Modelo" },
    { code: "BR.26.4211009", name: "Mondaí" },
    { code: "BR.26.4211058", name: "Monte Carlo" },
    { code: "BR.26.4211108", name: "Monte Castelo" },
    { code: "BR.26.4211207", name: "Morro da Fumaça" },
    { code: "BR.26.4211256", name: "Morro Grande" },
    { code: "BR.26.4211306", name: "Navegantes" },
    { code: "BR.26.4211405", name: "Nova Erechim" },
    { code: "BR.26.4211454", name: "Nova Itaberaba" },
    { code: "BR.26.4211504", name: "Nova Trento" },
    { code: "BR.26.4211603", name: "Nova Veneza" },
    { code: "BR.26.4211652", name: "Novo Horizonte" },
    { code: "BR.26.4211702", name: "Orleans" },
    { code: "BR.26.4211751", name: "Otacílio Costa" },
    { code: "BR.26.4211801", name: "Ouro" },
    { code: "BR.26.4211850", name: "Ouro Verde" },
    { code: "BR.26.4211876", name: "Paial" },
    { code: "BR.26.4211892", name: "Painel" },
    { code: "BR.26.4211900", name: "Palhoça" },
    { code: "BR.26.4212007", name: "Palma Sola" },
    { code: "BR.26.4212056", name: "Palmeira" },
    { code: "BR.26.4212106", name: "Palmitos" },
    { code: "BR.26.4212205", name: "Papanduva" },
    { code: "BR.26.4212239", name: "Paraíso" },
    { code: "BR.26.4212254", name: "Passo de Torres" },
    { code: "BR.26.4212270", name: "Passos Maia" },
    { code: "BR.26.4212304", name: "Paulo Lopes" },
    { code: "BR.26.4212403", name: "Pedras Grandes" },
    { code: "BR.26.4212502", name: "Penha" },
    { code: "BR.26.4212601", name: "Peritiba" },
    { code: "BR.26.4212650", name: "Pescaria Brava" },
    { code: "BR.26.4212700", name: "Petrolândia" },
    { code: "BR.26.4212809", name: "Balneário Piçarras" },
    { code: "BR.26.4212908", name: "Pinhalzinho" },
    { code: "BR.26.4213005", name: "Pinheiro Preto" },
    { code: "BR.26.4213104", name: "Piratuba" },
    { code: "BR.26.4213153", name: "Planalto Alegre" },
    { code: "BR.26.4213203", name: "Pomerode" },
    { code: "BR.26.4213302", name: "Ponte Alta" },
    { code: "BR.26.4213351", name: "Ponte Alta do Norte" },
    { code: "BR.26.4213401", name: "Ponte Serrada" },
    { code: "BR.26.4213500", name: "Porto Belo" },
    { code: "BR.26.4213609", name: "Porto União" },
    { code: "BR.26.4213708", name: "Pouso Redondo" },
    { code: "BR.26.4213807", name: "Praia Grande" },
    { code: "BR.26.4213906", name: "Presidente Castello Branco" },
    { code: "BR.26.4214003", name: "Presidente Getúlio" },
    { code: "BR.26.4214102", name: "Presidente Nereu" },
    { code: "BR.26.4214151", name: "Princesa" },
    { code: "BR.26.4214201", name: "Quilombo" },
    { code: "BR.26.4214300", name: "Rancho Queimado" },
    { code: "BR.26.4214409", name: "Rio das Antas" },
    { code: "BR.26.4214508", name: "Rio do Campo" },
    { code: "BR.26.4214607", name: "Rio do Oeste" },
    { code: "BR.26.4214706", name: "Rio dos Cedros" },
    { code: "BR.26.4214805", name: "Rio do Sul" },
    { code: "BR.26.4214904", name: "Rio Fortuna" },
    { code: "BR.26.4215000", name: "Rio Negrinho" },
    { code: "BR.26.4215059", name: "Rio Rufino" },
    { code: "BR.26.4215075", name: "Riqueza" },
    { code: "BR.26.4215109", name: "Rodeio" },
    { code: "BR.26.4215208", name: "Romelândia" },
    { code: "BR.26.4215307", name: "Salete" },
    { code: "BR.26.4215356", name: "Saltinho" },
    { code: "BR.26.4215406", name: "Salto Veloso" },
    { code: "BR.26.4215455", name: "Sangão" },
    { code: "BR.26.4215505", name: "Santa Cecília" },
    { code: "BR.26.4215554", name: "Santa Helena" },
    { code: "BR.26.4215604", name: "Santa Rosa de Lima" },
    { code: "BR.26.4215653", name: "Santa Rosa do Sul" },
    { code: "BR.26.4215679", name: "Santa Terezinha" },
    { code: "BR.26.4215687", name: "Santa Terezinha do Progresso" },
    { code: "BR.26.4215695", name: "Santiago do Sul" },
    { code: "BR.26.4215703", name: "Santo Amaro da Imperatriz" },
    { code: "BR.26.4215752", name: "São Bernardino" },
    { code: "BR.26.4215802", name: "São Bento do Sul" },
    { code: "BR.26.4215901", name: "São Bonifácio" },
    { code: "BR.26.4216008", name: "São Carlos" },
    { code: "BR.26.4216057", name: "São Cristóvão do Sul" },
    { code: "BR.26.4216107", name: "São Domingos" },
    { code: "BR.26.4216206", name: "São Francisco do Sul" },
    { code: "BR.26.4216255", name: "São João do Oeste" },
    { code: "BR.26.4216305", name: "São João Batista" },
    { code: "BR.26.4216354", name: "São João do Itaperiú" },
    { code: "BR.26.4216404", name: "São João do Sul" },
    { code: "BR.26.4216503", name: "São Joaquim" },
    { code: "BR.26.4216602", name: "São José" },
    { code: "BR.26.4216701", name: "São José do Cedro" },
    { code: "BR.26.4216800", name: "São José do Cerrito" },
    { code: "BR.26.4216909", name: "São Lourenço do Oeste" },
    { code: "BR.26.4217006", name: "São Ludgero" },
    { code: "BR.26.4217105", name: "São Martinho" },
    { code: "BR.26.4217154", name: "São Miguel da Boa Vista" },
    { code: "BR.26.4217204", name: "São Miguel do Oeste" },
    { code: "BR.26.4217253", name: "São Pedro de Alcântara" },
    { code: "BR.26.4217303", name: "Saudades" },
    { code: "BR.26.4217402", name: "Schroeder" },
    { code: "BR.26.4217501", name: "Seara" },
    { code: "BR.26.4217550", name: "Serra Alta" },
    { code: "BR.26.4217600", name: "Siderópolis" },
    { code: "BR.26.4217709", name: "Sombrio" },
    { code: "BR.26.4217758", name: "Sul Brasil" },
    { code: "BR.26.4217808", name: "Taió" },
    { code: "BR.26.4217907", name: "Tangará" },
    { code: "BR.26.4217956", name: "Tigrinhos" },
    { code: "BR.26.4218004", name: "Tijucas" },
    { code: "BR.26.4218103", name: "Timbé do Sul" },
    { code: "BR.26.4218202", name: "Timbó" },
    { code: "BR.26.4218251", name: "Timbó Grande" },
    { code: "BR.26.4218301", name: "Três Barras" },
    { code: "BR.26.4218350", name: "Treviso" },
    { code: "BR.26.4218400", name: "Treze de Maio" },
    { code: "BR.26.4218509", name: "Treze Tílias" },
    { code: "BR.26.4218608", name: "Trombudo Central" },
    { code: "BR.26.4218707", name: "Tubarão" },
    { code: "BR.26.4218756", name: "Tunápolis" },
    { code: "BR.26.4218806", name: "Turvo" },
    { code: "BR.26.4218855", name: "União do Oeste" },
    { code: "BR.26.4218905", name: "Urubici" },
    { code: "BR.26.4218954", name: "Urupema" },
    { code: "BR.26.4219002", name: "Urussanga" },
    { code: "BR.26.4219101", name: "Vargeão" },
    { code: "BR.26.4219150", name: "Vargem" },
    { code: "BR.26.4219176", name: "Vargem Bonita" },
    { code: "BR.26.4219200", name: "Vidal Ramos" },
    { code: "BR.26.4219309", name: "Videira" },
    { code: "BR.26.4219358", name: "Vitor Meireles" },
    { code: "BR.26.4219408", name: "Witmarsum" },
    { code: "BR.26.4219507", name: "Xanxerê" },
    { code: "BR.26.4219606", name: "Xavantina" },
    { code: "BR.26.4219705", name: "Xaxim" },
    { code: "BR.26.4219853", name: "Zortéa" },
    { code: "BR.26.4220000", name: "Balneário Rincão" },
  ],
  "BR.27": [
    { code: "BR.27.3500105", name: "Adamantina" },
    { code: "BR.27.3500204", name: "Adolfo" },
    { code: "BR.27.3500303", name: "Aguaí" },
    { code: "BR.27.3500402", name: "Águas da Prata" },
    { code: "BR.27.3500501", name: "Águas de Lindóia" },
    { code: "BR.27.3500550", name: "Águas de Santa Bárbara" },
    { code: "BR.27.3500600", name: "Águas de São Pedro" },
    { code: "BR.27.3500709", name: "Agudos" },
    { code: "BR.27.3500758", name: "Alambari" },
    { code: "BR.27.3500808", name: "Alfredo Marcondes" },
    { code: "BR.27.3500907", name: "Altair" },
    { code: "BR.27.3501004", name: "Altinópolis" },
    { code: "BR.27.3501103", name: "Alto Alegre" },
    { code: "BR.27.3501152", name: "Alumínio" },
    { code: "BR.27.3501202", name: "Álvares Florence" },
    { code: "BR.27.3501301", name: "Álvares Machado" },
    { code: "BR.27.3501400", name: "Álvaro de Carvalho" },
    { code: "BR.27.3501509", name: "Alvinlândia" },
    { code: "BR.27.3501608", name: "Americana" },
    { code: "BR.27.3501707", name: "Américo Brasiliense" },
    { code: "BR.27.3501806", name: "Américo de Campos" },
    { code: "BR.27.3501905", name: "Amparo" },
    { code: "BR.27.3502002", name: "Analândia" },
    { code: "BR.27.3502101", name: "Andradina" },
    { code: "BR.27.3502200", name: "Angatuba" },
    { code: "BR.27.3502309", name: "Anhembi" },
    { code: "BR.27.3502408", name: "Anhumas" },
    { code: "BR.27.3502507", name: "Aparecida" },
    { code: "BR.27.3502606", name: "Aparecida d'Oeste" },
    { code: "BR.27.3502705", name: "Apiaí" },
    { code: "BR.27.3502754", name: "Araçariguama" },
    { code: "BR.27.3502804", name: "Araçatuba" },
    { code: "BR.27.3502903", name: "Araçoiaba da Serra" },
    { code: "BR.27.3503000", name: "Aramina" },
    { code: "BR.27.3503109", name: "Arandu" },
    { code: "BR.27.3503158", name: "Arapeí" },
    { code: "BR.27.3503208", name: "Araraquara" },
    { code: "BR.27.3503307", name: "Araras" },
    { code: "BR.27.3503356", name: "Arco-Íris" },
    { code: "BR.27.3503406", name: "Arealva" },
    { code: "BR.27.3503505", name: "Areias" },
    { code: "BR.27.3503604", name: "Areiópolis" },
    { code: "BR.27.3503703", name: "Ariranha" },
    { code: "BR.27.3503802", name: "Artur Nogueira" },
    { code: "BR.27.3503901", name: "Arujá" },
    { code: "BR.27.3503950", name: "Aspásia" },
    { code: "BR.27.3504008", name: "Assis" },
    { code: "BR.27.3504107", name: "Atibaia" },
    { code: "BR.27.3504206", name: "Auriflama" },
    { code: "BR.27.3504305", name: "Avaí" },
    { code: "BR.27.3504404", name: "Avanhandava" },
    { code: "BR.27.3504503", name: "Avaré" },
    { code: "BR.27.3504602", name: "Bady Bassitt" },
    { code: "BR.27.3504701", name: "Balbinos" },
    { code: "BR.27.3504800", name: "Bálsamo" },
    { code: "BR.27.3504909", name: "Bananal" },
    { code: "BR.27.3505005", name: "Barão de Antonina" },
    { code: "BR.27.3505104", name: "Barbosa" },
    { code: "BR.27.3505203", name: "Bariri" },
    { code: "BR.27.3505302", name: "Barra Bonita" },
    { code: "BR.27.3505351", name: "Barra do Chapéu" },
    { code: "BR.27.3505401", name: "Barra do Turvo" },
    { code: "BR.27.3505500", name: "Barretos" },
    { code: "BR.27.3505609", name: "Barrinha" },
    { code: "BR.27.3505708", name: "Barueri" },
    { code: "BR.27.3505807", name: "Bastos" },
    { code: "BR.27.3505906", name: "Batatais" },
    { code: "BR.27.3506003", name: "Bauru" },
    { code: "BR.27.3506102", name: "Bebedouro" },
    { code: "BR.27.3506201", name: "Bento de Abreu" },
    { code: "BR.27.3506300", name: "Bernardino de Campos" },
    { code: "BR.27.3506359", name: "Bertioga" },
    { code: "BR.27.3506409", name: "Bilac" },
    { code: "BR.27.3506508", name: "Birigui" },
    { code: "BR.27.3506607", name: "Biritiba-Mirim" },
    { code: "BR.27.3506706", name: "Boa Esperança do Sul" },
    { code: "BR.27.3506805", name: "Bocaina" },
    { code: "BR.27.3506904", name: "Bofete" },
    { code: "BR.27.3507001", name: "Boituva" },
    { code: "BR.27.3507100", name: "Bom Jesus dos Perdões" },
    { code: "BR.27.3507159", name: "Bom Sucesso de Itararé" },
    { code: "BR.27.3507209", name: "Borá" },
    { code: "BR.27.3507308", name: "Boracéia" },
    { code: "BR.27.3507407", name: "Borborema" },
    { code: "BR.27.3507456", name: "Borebi" },
    { code: "BR.27.3507506", name: "Botucatu" },
    { code: "BR.27.3507605", name: "Bragança Paulista" },
    { code: "BR.27.3507704", name: "Braúna" },
    { code: "BR.27.3507753", name: "Brejo Alegre" },
    { code: "BR.27.3507803", name: "Brodowski" },
    { code: "BR.27.3507902", name: "Brotas" },
    { code: "BR.27.3508009", name: "Buri" },
    { code: "BR.27.3508108", name: "Buritama" },
    { code: "BR.27.3508207", name: "Buritizal" },
    { code: "BR.27.3508306", name: "Cabrália Paulista" },
    { code: "BR.27.3508405", name: "Cabreúva" },
    { code: "BR.27.3508504", name: "Caçapava" },
    { code: "BR.27.3508603", name: "Cachoeira Paulista" },
    { code: "BR.27.3508702", name: "Caconde" },
    { code: "BR.27.3508801", name: "Cafelândia" },
    { code: "BR.27.3508900", name: "Caiabu" },
    { code: "BR.27.3509007", name: "Caieiras" },
    { code: "BR.27.3509106", name: "Caiuá" },
    { code: "BR.27.3509205", name: "Cajamar" },
    { code: "BR.27.3509254", name: "Cajati" },
    { code: "BR.27.3509304", name: "Cajobi" },
    { code: "BR.27.3509403", name: "Cajuru" },
    { code: "BR.27.3509452", name: "Campina do Monte Alegre" },
    { code: "BR.27.3509502", name: "Campinas" },
    { code: "BR.27.3509601", name: "Campo Limpo Paulista" },
    { code: "BR.27.3509700", name: "Campos do Jordão" },
    { code: "BR.27.3509809", name: "Campos Novos Paulista" },
    { code: "BR.27.3509908", name: "Cananéia" },
    { code: "BR.27.3509957", name: "Canas" },
    { code: "BR.27.3510005", name: "Cândido Mota" },
    { code: "BR.27.3510104", name: "Cândido Rodrigues" },
    { code: "BR.27.3510153", name: "Canitar" },
    { code: "BR.27.3510203", name: "Capão Bonito" },
    { code: "BR.27.3510302", name: "Capela do Alto" },
    { code: "BR.27.3510401", name: "Capivari" },
    { code: "BR.27.3510500", name: "Caraguatatuba" },
    { code: "BR.27.3510609", name: "Carapicuíba" },
    { code: "BR.27.3510708", name: "Cardoso" },
    { code: "BR.27.3510807", name: "Casa Branca" },
    { code: "BR.27.3510906", name: "Cássia dos Coqueiros" },
    { code: "BR.27.3511003", name: "Castilho" },
    { code: "BR.27.3511102", name: "Catanduva" },
    { code: "BR.27.3511201", name: "Catiguá" },
    { code: "BR.27.3511300", name: "Cedral" },
    { code: "BR.27.3511409", name: "Cerqueira César" },
    { code: "BR.27.3511508", name: "Cerquilho" },
    { code: "BR.27.3511607", name: "Cesário Lange" },
    { code: "BR.27.3511706", name: "Charqueada" },
    { code: "BR.27.3511904", name: "Clementina" },
    { code: "BR.27.3512001", name: "Colina" },
    { code: "BR.27.3512100", name: "Colômbia" },
    { code: "BR.27.3512209", name: "Conchal" },
    { code: "BR.27.3512308", name: "Conchas" },
    { code: "BR.27.3512407", name: "Cordeirópolis" },
    { code: "BR.27.3512506", name: "Coroados" },
    { code: "BR.27.3512605", name: "Coronel Macedo" },
    { code: "BR.27.3512704", name: "Corumbataí" },
    { code: "BR.27.3512803", name: "Cosmópolis" },
    { code: "BR.27.3512902", name: "Cosmorama" },
    { code: "BR.27.3513009", name: "Cotia" },
    { code: "BR.27.3513108", name: "Cravinhos" },
    { code: "BR.27.3513207", name: "Cristais Paulista" },
    { code: "BR.27.3513306", name: "Cruzália" },
    { code: "BR.27.3513405", name: "Cruzeiro" },
    { code: "BR.27.3513504", name: "Cubatão" },
    { code: "BR.27.3513603", name: "Cunha" },
    { code: "BR.27.3513702", name: "Descalvado" },
    { code: "BR.27.3513801", name: "Diadema" },
    { code: "BR.27.3513850", name: "Dirce Reis" },
    { code: "BR.27.3513900", name: "Divinolândia" },
    { code: "BR.27.3514007", name: "Dobrada" },
    { code: "BR.27.3514106", name: "Dois Córregos" },
    { code: "BR.27.3514205", name: "Dolcinópolis" },
    { code: "BR.27.3514304", name: "Dourado" },
    { code: "BR.27.3514403", name: "Dracena" },
    { code: "BR.27.3514502", name: "Duartina" },
    { code: "BR.27.3514601", name: "Dumont" },
    { code: "BR.27.3514700", name: "Echaporã" },
    { code: "BR.27.3514809", name: "Eldorado" },
    { code: "BR.27.3514908", name: "Elias Fausto" },
    { code: "BR.27.3514924", name: "Elisiário" },
    { code: "BR.27.3514957", name: "Embaúba" },
    { code: "BR.27.3515004", name: "Embu das Artes" },
    { code: "BR.27.3515103", name: "Embu-Guaçu" },
    { code: "BR.27.3515129", name: "Emilianópolis" },
    { code: "BR.27.3515152", name: "Engenheiro Coelho" },
    { code: "BR.27.3515186", name: "Espírito Santo do Pinhal" },
    { code: "BR.27.3515194", name: "Espírito Santo do Turvo" },
    { code: "BR.27.3515202", name: "Estrela d'Oeste" },
    { code: "BR.27.3515301", name: "Estrela do Norte" },
    { code: "BR.27.3515350", name: "Euclides da Cunha Paulista" },
    { code: "BR.27.3515400", name: "Fartura" },
    { code: "BR.27.3515509", name: "Fernandópolis" },
    { code: "BR.27.3515608", name: "Fernando Prestes" },
    { code: "BR.27.3515657", name: "Fernão" },
    { code: "BR.27.3515707", name: "Ferraz de Vasconcelos" },
    { code: "BR.27.3515806", name: "Flora Rica" },
    { code: "BR.27.3515905", name: "Floreal" },
    { code: "BR.27.3516002", name: "Flórida Paulista" },
    { code: "BR.27.3516101", name: "Florínea" },
    { code: "BR.27.3516200", name: "Franca" },
    { code: "BR.27.3516309", name: "Francisco Morato" },
    { code: "BR.27.3516408", name: "Franco da Rocha" },
    { code: "BR.27.3516507", name: "Gabriel Monteiro" },
    { code: "BR.27.3516606", name: "Gália" },
    { code: "BR.27.3516705", name: "Garça" },
    { code: "BR.27.3516804", name: "Gastão Vidigal" },
    { code: "BR.27.3516853", name: "Gavião Peixoto" },
    { code: "BR.27.3516903", name: "General Salgado" },
    { code: "BR.27.3517000", name: "Getulina" },
    { code: "BR.27.3517109", name: "Glicério" },
    { code: "BR.27.3517208", name: "Guaiçara" },
    { code: "BR.27.3517307", name: "Guaimbê" },
    { code: "BR.27.3517406", name: "Guaíra" },
    { code: "BR.27.3517505", name: "Guapiaçu" },
    { code: "BR.27.3517604", name: "Guapiara" },
    { code: "BR.27.3517703", name: "Guará" },
    { code: "BR.27.3517802", name: "Guaraçaí" },
    { code: "BR.27.3517901", name: "Guaraci" },
    { code: "BR.27.3518008", name: "Guarani d'Oeste" },
    { code: "BR.27.3518107", name: "Guarantã" },
    { code: "BR.27.3518206", name: "Guararapes" },
    { code: "BR.27.3518305", name: "Guararema" },
    { code: "BR.27.3518404", name: "Guaratinguetá" },
    { code: "BR.27.3518503", name: "Guareí" },
    { code: "BR.27.3518602", name: "Guariba" },
    { code: "BR.27.3518701", name: "Guarujá" },
    { code: "BR.27.3518800", name: "Guarulhos" },
    { code: "BR.27.3518859", name: "Guatapará" },
    { code: "BR.27.3518909", name: "Guzolândia" },
    { code: "BR.27.3519006", name: "Herculândia" },
    { code: "BR.27.3519055", name: "Holambra" },
    { code: "BR.27.3519071", name: "Hortolândia" },
    { code: "BR.27.3519105", name: "Iacanga" },
    { code: "BR.27.3519204", name: "Iacri" },
    { code: "BR.27.3519253", name: "Iaras" },
    { code: "BR.27.3519303", name: "Ibaté" },
    { code: "BR.27.3519402", name: "Ibirá" },
    { code: "BR.27.3519501", name: "Ibirarema" },
    { code: "BR.27.3519600", name: "Ibitinga" },
    { code: "BR.27.3519709", name: "Ibiúna" },
    { code: "BR.27.3519808", name: "Icém" },
    { code: "BR.27.3519907", name: "Iepê" },
    { code: "BR.27.3520004", name: "Igaraçu do Tietê" },
    { code: "BR.27.3520103", name: "Igarapava" },
    { code: "BR.27.3520202", name: "Igaratá" },
    { code: "BR.27.3520301", name: "Iguape" },
    { code: "BR.27.3520400", name: "Ilhabela" },
    { code: "BR.27.3520426", name: "Ilha Comprida" },
    { code: "BR.27.3520442", name: "Ilha Solteira" },
    { code: "BR.27.3520509", name: "Indaiatuba" },
    { code: "BR.27.3520608", name: "Indiana" },
    { code: "BR.27.3520707", name: "Indiaporã" },
    { code: "BR.27.3520806", name: "Inúbia Paulista" },
    { code: "BR.27.3520905", name: "Ipaussu" },
    { code: "BR.27.3521002", name: "Iperó" },
    { code: "BR.27.3521101", name: "Ipeúna" },
    { code: "BR.27.3521150", name: "Ipiguá" },
    { code: "BR.27.3521200", name: "Iporanga" },
    { code: "BR.27.3521309", name: "Ipuã" },
    { code: "BR.27.3521408", name: "Iracemápolis" },
    { code: "BR.27.3521507", name: "Irapuã" },
    { code: "BR.27.3521606", name: "Irapuru" },
    { code: "BR.27.3521705", name: "Itaberá" },
    { code: "BR.27.3521804", name: "Itaí" },
    { code: "BR.27.3521903", name: "Itajobi" },
    { code: "BR.27.3522000", name: "Itaju" },
    { code: "BR.27.3522109", name: "Itanhaém" },
    { code: "BR.27.3522158", name: "Itaoca" },
    { code: "BR.27.3522208", name: "Itapecerica da Serra" },
    { code: "BR.27.3522307", name: "Itapetininga" },
    { code: "BR.27.3522406", name: "Itapeva" },
    { code: "BR.27.3522505", name: "Itapevi" },
    { code: "BR.27.3522604", name: "Itapira" },
    { code: "BR.27.3522653", name: "Itapirapuã Paulista" },
    { code: "BR.27.3522703", name: "Itápolis" },
    { code: "BR.27.3522802", name: "Itaporanga" },
    { code: "BR.27.3522901", name: "Itapuí" },
    { code: "BR.27.3523008", name: "Itapura" },
    { code: "BR.27.3523107", name: "Itaquaquecetuba" },
    { code: "BR.27.3523206", name: "Itararé" },
    { code: "BR.27.3523305", name: "Itariri" },
    { code: "BR.27.3523404", name: "Itatiba" },
    { code: "BR.27.3523503", name: "Itatinga" },
    { code: "BR.27.3523602", name: "Itirapina" },
    { code: "BR.27.3523701", name: "Itirapuã" },
    { code: "BR.27.3523800", name: "Itobi" },
    { code: "BR.27.3523909", name: "Itu" },
    { code: "BR.27.3524006", name: "Itupeva" },
    { code: "BR.27.3524105", name: "Ituverava" },
    { code: "BR.27.3524204", name: "Jaborandi" },
    { code: "BR.27.3524303", name: "Jaboticabal" },
    { code: "BR.27.3524402", name: "Jacareí" },
    { code: "BR.27.3524501", name: "Jaci" },
    { code: "BR.27.3524600", name: "Jacupiranga" },
    { code: "BR.27.3524709", name: "Jaguariúna" },
    { code: "BR.27.3524808", name: "Jales" },
    { code: "BR.27.3524907", name: "Jambeiro" },
    { code: "BR.27.3525003", name: "Jandira" },
    { code: "BR.27.3525102", name: "Jardinópolis" },
    { code: "BR.27.3525201", name: "Jarinu" },
    { code: "BR.27.3525300", name: "Jaú" },
    { code: "BR.27.3525409", name: "Jeriquara" },
    { code: "BR.27.3525508", name: "Joanópolis" },
    { code: "BR.27.3525607", name: "João Ramalho" },
    { code: "BR.27.3525706", name: "José Bonifácio" },
    { code: "BR.27.3525805", name: "Júlio Mesquita" },
    { code: "BR.27.3525854", name: "Jumirim" },
    { code: "BR.27.3525904", name: "Jundiaí" },
    { code: "BR.27.3526001", name: "Junqueirópolis" },
    { code: "BR.27.3526100", name: "Juquiá" },
    { code: "BR.27.3526209", name: "Juquitiba" },
    { code: "BR.27.3526308", name: "Lagoinha" },
    { code: "BR.27.3526407", name: "Laranjal Paulista" },
    { code: "BR.27.3526506", name: "Lavínia" },
    { code: "BR.27.3526605", name: "Lavrinhas" },
    { code: "BR.27.3526704", name: "Leme" },
    { code: "BR.27.3526803", name: "Lençóis Paulista" },
    { code: "BR.27.3526902", name: "Limeira" },
    { code: "BR.27.3527009", name: "Lindóia" },
    { code: "BR.27.3527108", name: "Lins" },
    { code: "BR.27.3527207", name: "Lorena" },
    { code: "BR.27.3527256", name: "Lourdes" },
    { code: "BR.27.3527306", name: "Louveira" },
    { code: "BR.27.3527405", name: "Lucélia" },
    { code: "BR.27.3527504", name: "Lucianópolis" },
    { code: "BR.27.3527603", name: "Luís Antônio" },
    { code: "BR.27.3527702", name: "Luiziânia" },
    { code: "BR.27.3527801", name: "Lupércio" },
    { code: "BR.27.3527900", name: "Lutécia" },
    { code: "BR.27.3528007", name: "Macatuba" },
    { code: "BR.27.3528106", name: "Macaubal" },
    { code: "BR.27.3528205", name: "Macedônia" },
    { code: "BR.27.3528304", name: "Magda" },
    { code: "BR.27.3528403", name: "Mairinque" },
    { code: "BR.27.3528502", name: "Mairiporã" },
    { code: "BR.27.3528601", name: "Manduri" },
    { code: "BR.27.3528700", name: "Marabá Paulista" },
    { code: "BR.27.3528809", name: "Maracaí" },
    { code: "BR.27.3528858", name: "Marapoama" },
    { code: "BR.27.3528908", name: "Mariápolis" },
    { code: "BR.27.3529005", name: "Marília" },
    { code: "BR.27.3529104", name: "Marinópolis" },
    { code: "BR.27.3529203", name: "Martinópolis" },
    { code: "BR.27.3529302", name: "Matão" },
    { code: "BR.27.3529401", name: "Mauá" },
    { code: "BR.27.3529500", name: "Mendonça" },
    { code: "BR.27.3529609", name: "Meridiano" },
    { code: "BR.27.3529658", name: "Mesópolis" },
    { code: "BR.27.3529708", name: "Miguelópolis" },
    { code: "BR.27.3529807", name: "Mineiros do Tietê" },
    { code: "BR.27.3529906", name: "Miracatu" },
    { code: "BR.27.3530003", name: "Mira Estrela" },
    { code: "BR.27.3530102", name: "Mirandópolis" },
    { code: "BR.27.3530201", name: "Mirante do Paranapanema" },
    { code: "BR.27.3530300", name: "Mirassol" },
    { code: "BR.27.3530409", name: "Mirassolândia" },
    { code: "BR.27.3530508", name: "Mococa" },
    { code: "BR.27.3530607", name: "Mogi das Cruzes" },
    { code: "BR.27.3530706", name: "Mogi Guaçu" },
    { code: "BR.27.3530805", name: "Mogi Mirim" },
    { code: "BR.27.3530904", name: "Mombuca" },
    { code: "BR.27.3531001", name: "Monções" },
    { code: "BR.27.3531100", name: "Mongaguá" },
    { code: "BR.27.3531209", name: "Monte Alegre do Sul" },
    { code: "BR.27.3531308", name: "Monte Alto" },
    { code: "BR.27.3531407", name: "Monte Aprazível" },
    { code: "BR.27.3531506", name: "Monte Azul Paulista" },
    { code: "BR.27.3531605", name: "Monte Castelo" },
    { code: "BR.27.3531704", name: "Monteiro Lobato" },
    { code: "BR.27.3531803", name: "Monte Mor" },
    { code: "BR.27.3531902", name: "Morro Agudo" },
    { code: "BR.27.3532009", name: "Morungaba" },
    { code: "BR.27.3532058", name: "Motuca" },
    { code: "BR.27.3532108", name: "Murutinga do Sul" },
    { code: "BR.27.3532157", name: "Nantes" },
    { code: "BR.27.3532207", name: "Narandiba" },
    { code: "BR.27.3532306", name: "Natividade da Serra" },
    { code: "BR.27.3532405", name: "Nazaré Paulista" },
    { code: "BR.27.3532504", name: "Neves Paulista" },
    { code: "BR.27.3532603", name: "Nhandeara" },
    { code: "BR.27.3532702", name: "Nipoã" },
    { code: "BR.27.3532801", name: "Nova Aliança" },
    { code: "BR.27.3532827", name: "Nova Campina" },
    { code: "BR.27.3532843", name: "Nova Canaã Paulista" },
    { code: "BR.27.3532868", name: "Nova Castilho" },
    { code: "BR.27.3532900", name: "Nova Europa" },
    { code: "BR.27.3533007", name: "Nova Granada" },
    { code: "BR.27.3533106", name: "Nova Guataporanga" },
    { code: "BR.27.3533205", name: "Nova Independência" },
    { code: "BR.27.3533254", name: "Novais" },
    { code: "BR.27.3533304", name: "Nova Luzitânia" },
    { code: "BR.27.3533403", name: "Nova Odessa" },
    { code: "BR.27.3533502", name: "Novo Horizonte" },
    { code: "BR.27.3533601", name: "Nuporanga" },
    { code: "BR.27.3533700", name: "Ocauçu" },
    { code: "BR.27.3533809", name: "Óleo" },
    { code: "BR.27.3533908", name: "Olímpia" },
    { code: "BR.27.3534005", name: "Onda Verde" },
    { code: "BR.27.3534104", name: "Oriente" },
    { code: "BR.27.3534203", name: "Orindiúva" },
    { code: "BR.27.3534302", name: "Orlândia" },
    { code: "BR.27.3534401", name: "Osasco" },
    { code: "BR.27.3534500", name: "Oscar Bressane" },
    { code: "BR.27.3534609", name: "Osvaldo Cruz" },
    { code: "BR.27.3534708", name: "Ourinhos" },
    { code: "BR.27.3534757", name: "Ouroeste" },
    { code: "BR.27.3534807", name: "Ouro Verde" },
    { code: "BR.27.3534906", name: "Pacaembu" },
    { code: "BR.27.3535002", name: "Palestina" },
    { code: "BR.27.3535101", name: "Palmares Paulista" },
    { code: "BR.27.3535200", name: "Palmeira d'Oeste" },
    { code: "BR.27.3535309", name: "Palmital" },
    { code: "BR.27.3535408", name: "Panorama" },
    { code: "BR.27.3535507", name: "Paraguaçu Paulista" },
    { code: "BR.27.3535606", name: "Paraibuna" },
    { code: "BR.27.3535705", name: "Paraíso" },
    { code: "BR.27.3535804", name: "Paranapanema" },
    { code: "BR.27.3535903", name: "Paranapuã" },
    { code: "BR.27.3536000", name: "Parapuã" },
    { code: "BR.27.3536109", name: "Pardinho" },
    { code: "BR.27.3536208", name: "Pariquera-Açu" },
    { code: "BR.27.3536257", name: "Parisi" },
    { code: "BR.27.3536307", name: "Patrocínio Paulista" },
    { code: "BR.27.3536406", name: "Paulicéia" },
    { code: "BR.27.3536505", name: "Paulínia" },
    { code: "BR.27.3536570", name: "Paulistânia" },
    { code: "BR.27.3536604", name: "Paulo de Faria" },
    { code: "BR.27.3536703", name: "Pederneiras" },
    { code: "BR.27.3536802", name: "Pedra Bela" },
    { code: "BR.27.3536901", name: "Pedranópolis" },
    { code: "BR.27.3537008", name: "Pedregulho" },
    { code: "BR.27.3537107", name: "Pedreira" },
    { code: "BR.27.3537156", name: "Pedrinhas Paulista" },
    { code: "BR.27.3537206", name: "Pedro de Toledo" },
    { code: "BR.27.3537305", name: "Penápolis" },
    { code: "BR.27.3537404", name: "Pereira Barreto" },
    { code: "BR.27.3537503", name: "Pereiras" },
    { code: "BR.27.3537602", name: "Peruíbe" },
    { code: "BR.27.3537701", name: "Piacatu" },
    { code: "BR.27.3537800", name: "Piedade" },
    { code: "BR.27.3537909", name: "Pilar do Sul" },
    { code: "BR.27.3538006", name: "Pindamonhangaba" },
    { code: "BR.27.3538105", name: "Pindorama" },
    { code: "BR.27.3538204", name: "Pinhalzinho" },
    { code: "BR.27.3538303", name: "Piquerobi" },
    { code: "BR.27.3538501", name: "Piquete" },
    { code: "BR.27.3538600", name: "Piracaia" },
    { code: "BR.27.3538709", name: "Piracicaba" },
    { code: "BR.27.3538808", name: "Piraju" },
    { code: "BR.27.3538907", name: "Pirajuí" },
    { code: "BR.27.3539004", name: "Pirangi" },
    { code: "BR.27.3539103", name: "Pirapora do Bom Jesus" },
    { code: "BR.27.3539202", name: "Pirapozinho" },
    { code: "BR.27.3539301", name: "Pirassununga" },
    { code: "BR.27.3539400", name: "Piratininga" },
    { code: "BR.27.3539509", name: "Pitangueiras" },
    { code: "BR.27.3539608", name: "Planalto" },
    { code: "BR.27.3539707", name: "Platina" },
    { code: "BR.27.3539806", name: "Poá" },
    { code: "BR.27.3539905", name: "Poloni" },
    { code: "BR.27.3540002", name: "Pompéia" },
    { code: "BR.27.3540101", name: "Pongaí" },
    { code: "BR.27.3540200", name: "Pontal" },
    { code: "BR.27.3540259", name: "Pontalinda" },
    { code: "BR.27.3540309", name: "Pontes Gestal" },
    { code: "BR.27.3540408", name: "Populina" },
    { code: "BR.27.3540507", name: "Porangaba" },
    { code: "BR.27.3540606", name: "Porto Feliz" },
    { code: "BR.27.3540705", name: "Porto Ferreira" },
    { code: "BR.27.3540754", name: "Potim" },
    { code: "BR.27.3540804", name: "Potirendaba" },
    { code: "BR.27.3540853", name: "Pracinha" },
    { code: "BR.27.3540903", name: "Pradópolis" },
    { code: "BR.27.3541000", name: "Praia Grande" },
    { code: "BR.27.3541059", name: "Pratânia" },
    { code: "BR.27.3541109", name: "Presidente Alves" },
    { code: "BR.27.3541208", name: "Presidente Bernardes" },
    { code: "BR.27.3541307", name: "Presidente Epitácio" },
    { code: "BR.27.3541406", name: "Presidente Prudente" },
    { code: "BR.27.3541505", name: "Presidente Venceslau" },
    { code: "BR.27.3541604", name: "Promissão" },
    { code: "BR.27.3541653", name: "Quadra" },
    { code: "BR.27.3541703", name: "Quatá" },
    { code: "BR.27.3541802", name: "Queiroz" },
    { code: "BR.27.3541901", name: "Queluz" },
    { code: "BR.27.3542008", name: "Quintana" },
    { code: "BR.27.3542107", name: "Rafard" },
    { code: "BR.27.3542206", name: "Rancharia" },
    { code: "BR.27.3542305", name: "Redenção da Serra" },
    { code: "BR.27.3542404", name: "Regente Feijó" },
    { code: "BR.27.3542503", name: "Reginópolis" },
    { code: "BR.27.3542602", name: "Registro" },
    { code: "BR.27.3542701", name: "Restinga" },
    { code: "BR.27.3542800", name: "Ribeira" },
    { code: "BR.27.3542909", name: "Ribeirão Bonito" },
    { code: "BR.27.3543006", name: "Ribeirão Branco" },
    { code: "BR.27.3543105", name: "Ribeirão Corrente" },
    { code: "BR.27.3543204", name: "Ribeirão do Sul" },
    { code: "BR.27.3543238", name: "Ribeirão dos Índios" },
    { code: "BR.27.3543253", name: "Ribeirão Grande" },
    { code: "BR.27.3543303", name: "Ribeirão Pires" },
    { code: "BR.27.3543402", name: "Ribeirão Preto" },
    { code: "BR.27.3543501", name: "Riversul" },
    { code: "BR.27.3543600", name: "Rifaina" },
    { code: "BR.27.3543709", name: "Rincão" },
    { code: "BR.27.3543808", name: "Rinópolis" },
    { code: "BR.27.3543907", name: "Rio Claro" },
    { code: "BR.27.3544004", name: "Rio das Pedras" },
    { code: "BR.27.3544103", name: "Rio Grande da Serra" },
    { code: "BR.27.3544202", name: "Riolândia" },
    { code: "BR.27.3544251", name: "Rosana" },
    { code: "BR.27.3544301", name: "Roseira" },
    { code: "BR.27.3544400", name: "Rubiácea" },
    { code: "BR.27.3544509", name: "Rubinéia" },
    { code: "BR.27.3544608", name: "Sabino" },
    { code: "BR.27.3544707", name: "Sagres" },
    { code: "BR.27.3544806", name: "Sales" },
    { code: "BR.27.3544905", name: "Sales Oliveira" },
    { code: "BR.27.3545001", name: "Salesópolis" },
    { code: "BR.27.3545100", name: "Salmourão" },
    { code: "BR.27.3545159", name: "Saltinho" },
    { code: "BR.27.3545209", name: "Salto" },
    { code: "BR.27.3545308", name: "Salto de Pirapora" },
    { code: "BR.27.3545407", name: "Salto Grande" },
    { code: "BR.27.3545506", name: "Sandovalina" },
    { code: "BR.27.3545605", name: "Santa Adélia" },
    { code: "BR.27.3545704", name: "Santa Albertina" },
    { code: "BR.27.3545803", name: "Santa Bárbara d'Oeste" },
    { code: "BR.27.3546009", name: "Santa Branca" },
    { code: "BR.27.3546108", name: "Santa Clara d'Oeste" },
    { code: "BR.27.3546207", name: "Santa Cruz da Conceição" },
    { code: "BR.27.3546256", name: "Santa Cruz da Esperança" },
    { code: "BR.27.3546306", name: "Santa Cruz das Palmeiras" },
    { code: "BR.27.3546405", name: "Santa Cruz do Rio Pardo" },
    { code: "BR.27.3546504", name: "Santa Ernestina" },
    { code: "BR.27.3546603", name: "Santa Fé do Sul" },
    { code: "BR.27.3546702", name: "Santa Gertrudes" },
    { code: "BR.27.3546801", name: "Santa Isabel" },
    { code: "BR.27.3546900", name: "Santa Lúcia" },
    { code: "BR.27.3547007", name: "Santa Maria da Serra" },
    { code: "BR.27.3547106", name: "Santa Mercedes" },
    { code: "BR.27.3547205", name: "Santana da Ponte Pensa" },
    { code: "BR.27.3547304", name: "Santana de Parnaíba" },
    { code: "BR.27.3547403", name: "Santa Rita d'Oeste" },
    { code: "BR.27.3547502", name: "Santa Rita do Passa Quatro" },
    { code: "BR.27.3547601", name: "Santa Rosa de Viterbo" },
    { code: "BR.27.3547650", name: "Santa Salete" },
    { code: "BR.27.3547700", name: "Santo Anastácio" },
    { code: "BR.27.3547809", name: "Santo André" },
    { code: "BR.27.3547908", name: "Santo Antônio da Alegria" },
    { code: "BR.27.3548005", name: "Santo Antônio de Posse" },
    { code: "BR.27.3548054", name: "Santo Antônio do Aracanguá" },
    { code: "BR.27.3548104", name: "Santo Antônio do Jardim" },
    { code: "BR.27.3548203", name: "Santo Antônio do Pinhal" },
    { code: "BR.27.3548302", name: "Santo Expedito" },
    { code: "BR.27.3548401", name: "Santópolis do Aguapeí" },
    { code: "BR.27.3548500", name: "Santos" },
    { code: "BR.27.3548609", name: "São Bento do Sapucaí" },
    { code: "BR.27.3548708", name: "São Bernardo do Campo" },
    { code: "BR.27.3548807", name: "São Caetano do Sul" },
    { code: "BR.27.3548906", name: "São Carlos" },
    { code: "BR.27.3549003", name: "São Francisco" },
    { code: "BR.27.3549102", name: "São João da Boa Vista" },
    { code: "BR.27.3549201", name: "São João das Duas Pontes" },
    { code: "BR.27.3549250", name: "São João de Iracema" },
    { code: "BR.27.3549300", name: "São João do Pau d'Alho" },
    { code: "BR.27.3549409", name: "São Joaquim da Barra" },
    { code: "BR.27.3549508", name: "São José da Bela Vista" },
    { code: "BR.27.3549607", name: "São José do Barreiro" },
    { code: "BR.27.3549706", name: "São José do Rio Pardo" },
    { code: "BR.27.3549805", name: "São José do Rio Preto" },
    { code: "BR.27.3549904", name: "São José dos Campos" },
    { code: "BR.27.3549953", name: "São Lourenço da Serra" },
    { code: "BR.27.3550001", name: "São Luiz do Paraitinga" },
    { code: "BR.27.3550100", name: "São Manuel" },
    { code: "BR.27.3550209", name: "São Miguel Arcanjo" },
    { code: "BR.27.3550308", name: "São Paulo" },
    { code: "BR.27.3550407", name: "São Pedro" },
    { code: "BR.27.3550506", name: "São Pedro do Turvo" },
    { code: "BR.27.3550605", name: "São Roque" },
    { code: "BR.27.3550704", name: "São Sebastião" },
    { code: "BR.27.3550803", name: "São Sebastião da Grama" },
    { code: "BR.27.3550902", name: "São Simão" },
    { code: "BR.27.3551009", name: "São Vicente" },
    { code: "BR.27.3551108", name: "Sarapuí" },
    { code: "BR.27.3551207", name: "Sarutaiá" },
    { code: "BR.27.3551306", name: "Sebastianópolis do Sul" },
    { code: "BR.27.3551405", name: "Serra Azul" },
    { code: "BR.27.3551504", name: "Serrana" },
    { code: "BR.27.3551603", name: "Serra Negra" },
    { code: "BR.27.3551702", name: "Sertãozinho" },
    { code: "BR.27.3551801", name: "Sete Barras" },
    { code: "BR.27.3551900", name: "Severínia" },
    { code: "BR.27.3552007", name: "Silveiras" },
    { code: "BR.27.3552106", name: "Socorro" },
    { code: "BR.27.3552205", name: "Sorocaba" },
    { code: "BR.27.3552304", name: "Sud Mennucci" },
    { code: "BR.27.3552403", name: "Sumaré" },
    { code: "BR.27.3552502", name: "Suzano" },
    { code: "BR.27.3552551", name: "Suzanápolis" },
    { code: "BR.27.3552601", name: "Tabapuã" },
    { code: "BR.27.3552700", name: "Tabatinga" },
    { code: "BR.27.3552809", name: "Taboão da Serra" },
    { code: "BR.27.3552908", name: "Taciba" },
    { code: "BR.27.3553005", name: "Taguaí" },
    { code: "BR.27.3553104", name: "Taiaçu" },
    { code: "BR.27.3553203", name: "Taiúva" },
    { code: "BR.27.3553302", name: "Tambaú" },
    { code: "BR.27.3553401", name: "Tanabi" },
    { code: "BR.27.3553500", name: "Tapiraí" },
    { code: "BR.27.3553609", name: "Tapiratiba" },
    { code: "BR.27.3553658", name: "Taquaral" },
    { code: "BR.27.3553708", name: "Taquaritinga" },
    { code: "BR.27.3553807", name: "Taquarituba" },
    { code: "BR.27.3553856", name: "Taquarivaí" },
    { code: "BR.27.3553906", name: "Tarabai" },
    { code: "BR.27.3553955", name: "Tarumã" },
    { code: "BR.27.3554003", name: "Tatuí" },
    { code: "BR.27.3554102", name: "Taubaté" },
    { code: "BR.27.3554201", name: "Tejupá" },
    { code: "BR.27.3554300", name: "Teodoro Sampaio" },
    { code: "BR.27.3554409", name: "Terra Roxa" },
    { code: "BR.27.3554508", name: "Tietê" },
    { code: "BR.27.3554607", name: "Timburi" },
    { code: "BR.27.3554656", name: "Torre de Pedra" },
    { code: "BR.27.3554706", name: "Torrinha" },
    { code: "BR.27.3554755", name: "Trabiju" },
    { code: "BR.27.3554805", name: "Tremembé" },
    { code: "BR.27.3554904", name: "Três Fronteiras" },
    { code: "BR.27.3554953", name: "Tuiuti" },
    { code: "BR.27.3555000", name: "Tupã" },
    { code: "BR.27.3555109", name: "Tupi Paulista" },
    { code: "BR.27.3555208", name: "Turiúba" },
    { code: "BR.27.3555307", name: "Turmalina" },
    { code: "BR.27.3555356", name: "Ubarana" },
    { code: "BR.27.3555406", name: "Ubatuba" },
    { code: "BR.27.3555505", name: "Ubirajara" },
    { code: "BR.27.3555604", name: "Uchoa" },
    { code: "BR.27.3555703", name: "União Paulista" },
    { code: "BR.27.3555802", name: "Urânia" },
    { code: "BR.27.3555901", name: "Uru" },
    { code: "BR.27.3556008", name: "Urupês" },
    { code: "BR.27.3556107", name: "Valentim Gentil" },
    { code: "BR.27.3556206", name: "Valinhos" },
    { code: "BR.27.3556305", name: "Valparaíso" },
    { code: "BR.27.3556354", name: "Vargem" },
    { code: "BR.27.3556404", name: "Vargem Grande do Sul" },
    { code: "BR.27.3556453", name: "Vargem Grande Paulista" },
    { code: "BR.27.3556503", name: "Várzea Paulista" },
    { code: "BR.27.3556602", name: "Vera Cruz" },
    { code: "BR.27.3556701", name: "Vinhedo" },
    { code: "BR.27.3556800", name: "Viradouro" },
    { code: "BR.27.3556909", name: "Vista Alegre do Alto" },
    { code: "BR.27.3556958", name: "Vitória Brasil" },
    { code: "BR.27.3557006", name: "Votorantim" },
    { code: "BR.27.3557105", name: "Votuporanga" },
    { code: "BR.27.3557154", name: "Zacarias" },
    { code: "BR.27.3557204", name: "Chavantes" },
    { code: "BR.27.3557303", name: "Estiva Gerbi" },
  ],
  "BR.28": [
    { code: "BR.28.2800100", name: "Amparo de São Francisco" },
    { code: "BR.28.2800209", name: "Aquidabã" },
    { code: "BR.28.2800308", name: "Aracaju" },
    { code: "BR.28.2800407", name: "Arauá" },
    { code: "BR.28.2800506", name: "Areia Branca" },
    { code: "BR.28.2800605", name: "Barra dos Coqueiros" },
    { code: "BR.28.2800670", name: "Boquim" },
    { code: "BR.28.2800704", name: "Brejo Grande" },
    { code: "BR.28.2801009", name: "Campo do Brito" },
    { code: "BR.28.2801108", name: "Canhoba" },
    { code: "BR.28.2801207", name: "Canindé de São Francisco" },
    { code: "BR.28.2801306", name: "Capela" },
    { code: "BR.28.2801405", name: "Carira" },
    { code: "BR.28.2801504", name: "Carmópolis" },
    { code: "BR.28.2801603", name: "Cedro de São João" },
    { code: "BR.28.2801702", name: "Cristinápolis" },
    { code: "BR.28.2801900", name: "Cumbe" },
    { code: "BR.28.2802007", name: "Divina Pastora" },
    { code: "BR.28.2802106", name: "Estância" },
    { code: "BR.28.2802205", name: "Feira Nova" },
    { code: "BR.28.2802304", name: "Frei Paulo" },
    { code: "BR.28.2802403", name: "Gararu" },
    { code: "BR.28.2802502", name: "General Maynard" },
    { code: "BR.28.2802601", name: "Gracho Cardoso" },
    { code: "BR.28.2802700", name: "Ilha das Flores" },
    { code: "BR.28.2802809", name: "Indiaroba" },
    { code: "BR.28.2802908", name: "Itabaiana" },
    { code: "BR.28.2803005", name: "Itabaianinha" },
    { code: "BR.28.2803104", name: "Itabi" },
    { code: "BR.28.2803203", name: "Itaporanga d'Ajuda" },
    { code: "BR.28.2803302", name: "Japaratuba" },
    { code: "BR.28.2803401", name: "Japoatã" },
    { code: "BR.28.2803500", name: "Lagarto" },
    { code: "BR.28.2803609", name: "Laranjeiras" },
    { code: "BR.28.2803708", name: "Macambira" },
    { code: "BR.28.2803807", name: "Malhada dos Bois" },
    { code: "BR.28.2803906", name: "Malhador" },
    { code: "BR.28.2804003", name: "Maruim" },
    { code: "BR.28.2804102", name: "Moita Bonita" },
    { code: "BR.28.2804201", name: "Monte Alegre de Sergipe" },
    { code: "BR.28.2804300", name: "Muribeca" },
    { code: "BR.28.2804409", name: "Neópolis" },
    { code: "BR.28.2804458", name: "Nossa Senhora Aparecida" },
    { code: "BR.28.2804508", name: "Nossa Senhora da Glória" },
    { code: "BR.28.2804607", name: "Nossa Senhora das Dores" },
    { code: "BR.28.2804706", name: "Nossa Senhora de Lourdes" },
    { code: "BR.28.2804805", name: "Nossa Senhora do Socorro" },
    { code: "BR.28.2804904", name: "Pacatuba" },
    { code: "BR.28.2805000", name: "Pedra Mole" },
    { code: "BR.28.2805109", name: "Pedrinhas" },
    { code: "BR.28.2805208", name: "Pinhão" },
    { code: "BR.28.2805307", name: "Pirambu" },
    { code: "BR.28.2805406", name: "Poço Redondo" },
    { code: "BR.28.2805505", name: "Poço Verde" },
    { code: "BR.28.2805604", name: "Porto da Folha" },
    { code: "BR.28.2805703", name: "Propriá" },
    { code: "BR.28.2805802", name: "Riachão do Dantas" },
    { code: "BR.28.2805901", name: "Riachuelo" },
    { code: "BR.28.2806008", name: "Ribeirópolis" },
    { code: "BR.28.2806107", name: "Rosário do Catete" },
    { code: "BR.28.2806206", name: "Salgado" },
    { code: "BR.28.2806305", name: "Santa Luzia do Itanhy" },
    { code: "BR.28.2806404", name: "Santana do São Francisco" },
    { code: "BR.28.2806503", name: "Santa Rosa de Lima" },
    { code: "BR.28.2806602", name: "Santo Amaro das Brotas" },
    { code: "BR.28.2806701", name: "São Cristóvão" },
    { code: "BR.28.2806800", name: "São Domingos" },
    { code: "BR.28.2806909", name: "São Francisco" },
    { code: "BR.28.2807006", name: "São Miguel do Aleixo" },
    { code: "BR.28.2807105", name: "Simão Dias" },
    { code: "BR.28.2807204", name: "Siriri" },
    { code: "BR.28.2807303", name: "Telha" },
    { code: "BR.28.2807402", name: "Tobias Barreto" },
    { code: "BR.28.2807501", name: "Tomar do Geru" },
    { code: "BR.28.2807600", name: "Umbaúba" },
  ],
  "BR.29": [
    { code: "BR.29.5200050", name: "Abadia de Goiás" },
    { code: "BR.29.5200100", name: "Abadiânia" },
    { code: "BR.29.5200134", name: "Acreúna" },
    { code: "BR.29.5200159", name: "Adelândia" },
    { code: "BR.29.5200175", name: "Água Fria de Goiás" },
    { code: "BR.29.5200209", name: "Água Limpa" },
    { code: "BR.29.5200258", name: "Águas Lindas de Goiás" },
    { code: "BR.29.5200308", name: "Alexânia" },
    { code: "BR.29.5200506", name: "Aloândia" },
    { code: "BR.29.5200555", name: "Alto Horizonte" },
    { code: "BR.29.5200605", name: "Alto Paraíso de Goiás" },
    { code: "BR.29.5200803", name: "Alvorada do Norte" },
    { code: "BR.29.5200829", name: "Amaralina" },
    { code: "BR.29.5200852", name: "Americano do Brasil" },
    { code: "BR.29.5200902", name: "Amorinópolis" },
    { code: "BR.29.5201108", name: "Anápolis" },
    { code: "BR.29.5201207", name: "Anhanguera" },
    { code: "BR.29.5201306", name: "Anicuns" },
    { code: "BR.29.5201405", name: "Aparecida de Goiânia" },
    { code: "BR.29.5201454", name: "Aparecida do Rio Doce" },
    { code: "BR.29.5201504", name: "Aporé" },
    { code: "BR.29.5201603", name: "Araçu" },
    { code: "BR.29.5201702", name: "Aragarças" },
    { code: "BR.29.5201801", name: "Aragoiânia" },
    { code: "BR.29.5202155", name: "Araguapaz" },
    { code: "BR.29.5202353", name: "Arenópolis" },
    { code: "BR.29.5202502", name: "Aruanã" },
    { code: "BR.29.5202601", name: "Aurilândia" },
    { code: "BR.29.5202809", name: "Avelinópolis" },
    { code: "BR.29.5203104", name: "Baliza" },
    { code: "BR.29.5203203", name: "Barro Alto" },
    { code: "BR.29.5203302", name: "Bela Vista de Goiás" },
    { code: "BR.29.5203401", name: "Bom Jardim de Goiás" },
    { code: "BR.29.5203500", name: "Bom Jesus de Goiás" },
    { code: "BR.29.5203559", name: "Bonfinópolis" },
    { code: "BR.29.5203575", name: "Bonópolis" },
    { code: "BR.29.5203609", name: "Brazabrantes" },
    { code: "BR.29.5203807", name: "Britânia" },
    { code: "BR.29.5203906", name: "Buriti Alegre" },
    { code: "BR.29.5203939", name: "Buriti de Goiás" },
    { code: "BR.29.5203962", name: "Buritinópolis" },
    { code: "BR.29.5204003", name: "Cabeceiras" },
    { code: "BR.29.5204102", name: "Cachoeira Alta" },
    { code: "BR.29.5204201", name: "Cachoeira de Goiás" },
    { code: "BR.29.5204250", name: "Cachoeira Dourada" },
    { code: "BR.29.5204300", name: "Caçu" },
    { code: "BR.29.5204409", name: "Caiapônia" },
    { code: "BR.29.5204508", name: "Caldas Novas" },
    { code: "BR.29.5204557", name: "Caldazinha" },
    { code: "BR.29.5204607", name: "Campestre de Goiás" },
    { code: "BR.29.5204656", name: "Campinaçu" },
    { code: "BR.29.5204706", name: "Campinorte" },
    { code: "BR.29.5204805", name: "Campo Alegre de Goiás" },
    { code: "BR.29.5204854", name: "Campo Limpo de Goiás" },
    { code: "BR.29.5204904", name: "Campos Belos" },
    { code: "BR.29.5204953", name: "Campos Verdes" },
    { code: "BR.29.5205000", name: "Carmo do Rio Verde" },
    { code: "BR.29.5205059", name: "Castelândia" },
    { code: "BR.29.5205109", name: "Catalão" },
    { code: "BR.29.5205208", name: "Caturaí" },
    { code: "BR.29.5205307", name: "Cavalcante" },
    { code: "BR.29.5205406", name: "Ceres" },
    { code: "BR.29.5205455", name: "Cezarina" },
    { code: "BR.29.5205471", name: "Chapadão do Céu" },
    { code: "BR.29.5205497", name: "Cidade Ocidental" },
    { code: "BR.29.5205513", name: "Cocalzinho de Goiás" },
    { code: "BR.29.5205521", name: "Colinas do Sul" },
    { code: "BR.29.5205703", name: "Córrego do Ouro" },
    { code: "BR.29.5205802", name: "Corumbá de Goiás" },
    { code: "BR.29.5205901", name: "Corumbaíba" },
    { code: "BR.29.5206206", name: "Cristalina" },
    { code: "BR.29.5206305", name: "Cristianópolis" },
    { code: "BR.29.5206404", name: "Crixás" },
    { code: "BR.29.5206503", name: "Cromínia" },
    { code: "BR.29.5206602", name: "Cumari" },
    { code: "BR.29.5206701", name: "Damianópolis" },
    { code: "BR.29.5206800", name: "Damolândia" },
    { code: "BR.29.5206909", name: "Davinópolis" },
    { code: "BR.29.5207105", name: "Diorama" },
    { code: "BR.29.5207253", name: "Doverlândia" },
    { code: "BR.29.5207352", name: "Edealina" },
    { code: "BR.29.5207402", name: "Edéia" },
    { code: "BR.29.5207501", name: "Estrela do Norte" },
    { code: "BR.29.5207535", name: "Faina" },
    { code: "BR.29.5207600", name: "Fazenda Nova" },
    { code: "BR.29.5207808", name: "Firminópolis" },
    { code: "BR.29.5207907", name: "Flores de Goiás" },
    { code: "BR.29.5208004", name: "Formosa" },
    { code: "BR.29.5208103", name: "Formoso" },
    { code: "BR.29.5208152", name: "Gameleira de Goiás" },
    { code: "BR.29.5208301", name: "Divinópolis de Goiás" },
    { code: "BR.29.5208400", name: "Goianápolis" },
    { code: "BR.29.5208509", name: "Goiandira" },
    { code: "BR.29.5208608", name: "Goianésia" },
    { code: "BR.29.5208707", name: "Goiânia" },
    { code: "BR.29.5208806", name: "Goianira" },
    { code: "BR.29.5208905", name: "Goiás" },
    { code: "BR.29.5209101", name: "Goiatuba" },
    { code: "BR.29.5209150", name: "Gouvelândia" },
    { code: "BR.29.5209200", name: "Guapó" },
    { code: "BR.29.5209291", name: "Guaraíta" },
    { code: "BR.29.5209408", name: "Guarani de Goiás" },
    { code: "BR.29.5209457", name: "Guarinos" },
    { code: "BR.29.5209606", name: "Heitoraí" },
    { code: "BR.29.5209705", name: "Hidrolândia" },
    { code: "BR.29.5209804", name: "Hidrolina" },
    { code: "BR.29.5209903", name: "Iaciara" },
    { code: "BR.29.5209937", name: "Inaciolândia" },
    { code: "BR.29.5209952", name: "Indiara" },
    { code: "BR.29.5210000", name: "Inhumas" },
    { code: "BR.29.5210109", name: "Ipameri" },
    { code: "BR.29.5210158", name: "Ipiranga de Goiás" },
    { code: "BR.29.5210208", name: "Iporá" },
    { code: "BR.29.5210307", name: "Israelândia" },
    { code: "BR.29.5210406", name: "Itaberaí" },
    { code: "BR.29.5210562", name: "Itaguari" },
    { code: "BR.29.5210604", name: "Itaguaru" },
    { code: "BR.29.5210802", name: "Itajá" },
    { code: "BR.29.5210901", name: "Itapaci" },
    { code: "BR.29.5211008", name: "Itapirapuã" },
    { code: "BR.29.5211206", name: "Itapuranga" },
    { code: "BR.29.5211305", name: "Itarumã" },
    { code: "BR.29.5211404", name: "Itauçu" },
    { code: "BR.29.5211503", name: "Itumbiara" },
    { code: "BR.29.5211602", name: "Ivolândia" },
    { code: "BR.29.5211701", name: "Jandaia" },
    { code: "BR.29.5211800", name: "Jaraguá" },
    { code: "BR.29.5211909", name: "Jataí" },
    { code: "BR.29.5212006", name: "Jaupaci" },
    { code: "BR.29.5212055", name: "Jesúpolis" },
    { code: "BR.29.5212105", name: "Joviânia" },
    { code: "BR.29.5212204", name: "Jussara" },
    { code: "BR.29.5212253", name: "Lagoa Santa" },
    { code: "BR.29.5212303", name: "Leopoldo de Bulhões" },
    { code: "BR.29.5212501", name: "Luziânia" },
    { code: "BR.29.5212600", name: "Mairipotaba" },
    { code: "BR.29.5212709", name: "Mambaí" },
    { code: "BR.29.5212808", name: "Mara Rosa" },
    { code: "BR.29.5212907", name: "Marzagão" },
    { code: "BR.29.5212956", name: "Matrinchã" },
    { code: "BR.29.5213004", name: "Maurilândia" },
    { code: "BR.29.5213053", name: "Mimoso de Goiás" },
    { code: "BR.29.5213087", name: "Minaçu" },
    { code: "BR.29.5213103", name: "Mineiros" },
    { code: "BR.29.5213400", name: "Moiporá" },
    { code: "BR.29.5213509", name: "Monte Alegre de Goiás" },
    { code: "BR.29.5213707", name: "Montes Claros de Goiás" },
    { code: "BR.29.5213756", name: "Montividiu" },
    { code: "BR.29.5213772", name: "Montividiu do Norte" },
    { code: "BR.29.5213806", name: "Morrinhos" },
    { code: "BR.29.5213855", name: "Morro Agudo de Goiás" },
    { code: "BR.29.5213905", name: "Mossâmedes" },
    { code: "BR.29.5214002", name: "Mozarlândia" },
    { code: "BR.29.5214051", name: "Mundo Novo" },
    { code: "BR.29.5214101", name: "Mutunópolis" },
    { code: "BR.29.5214408", name: "Nazário" },
    { code: "BR.29.5214507", name: "Nerópolis" },
    { code: "BR.29.5214606", name: "Niquelândia" },
    { code: "BR.29.5214705", name: "Nova América" },
    { code: "BR.29.5214804", name: "Nova Aurora" },
    { code: "BR.29.5214838", name: "Nova Crixás" },
    { code: "BR.29.5214861", name: "Nova Glória" },
    { code: "BR.29.5214879", name: "Nova Iguaçu de Goiás" },
    { code: "BR.29.5214903", name: "Nova Roma" },
    { code: "BR.29.5215009", name: "Nova Veneza" },
    { code: "BR.29.5215207", name: "Novo Brasil" },
    { code: "BR.29.5215231", name: "Novo Gama" },
    { code: "BR.29.5215256", name: "Novo Planalto" },
    { code: "BR.29.5215306", name: "Orizona" },
    { code: "BR.29.5215405", name: "Ouro Verde de Goiás" },
    { code: "BR.29.5215504", name: "Ouvidor" },
    { code: "BR.29.5215603", name: "Padre Bernardo" },
    { code: "BR.29.5215652", name: "Palestina de Goiás" },
    { code: "BR.29.5215702", name: "Palmeiras de Goiás" },
    { code: "BR.29.5215801", name: "Palmelo" },
    { code: "BR.29.5215900", name: "Palminópolis" },
    { code: "BR.29.5216007", name: "Panamá" },
    { code: "BR.29.5216304", name: "Paranaiguara" },
    { code: "BR.29.5216403", name: "Paraúna" },
    { code: "BR.29.5216452", name: "Perolândia" },
    { code: "BR.29.5216809", name: "Petrolina de Goiás" },
    { code: "BR.29.5216908", name: "Pilar de Goiás" },
    { code: "BR.29.5217104", name: "Piracanjuba" },
    { code: "BR.29.5217203", name: "Piranhas" },
    { code: "BR.29.5217302", name: "Pirenópolis" },
    { code: "BR.29.5217401", name: "Pires do Rio" },
    { code: "BR.29.5217609", name: "Planaltina" },
    { code: "BR.29.5217708", name: "Pontalina" },
    { code: "BR.29.5218003", name: "Porangatu" },
    { code: "BR.29.5218052", name: "Porteirão" },
    { code: "BR.29.5218102", name: "Portelândia" },
    { code: "BR.29.5218300", name: "Posse" },
    { code: "BR.29.5218391", name: "Professor Jamil" },
    { code: "BR.29.5218508", name: "Quirinópolis" },
    { code: "BR.29.5218607", name: "Rialma" },
    { code: "BR.29.5218706", name: "Rianápolis" },
    { code: "BR.29.5218789", name: "Rio Quente" },
    { code: "BR.29.5218805", name: "Rio Verde" },
    { code: "BR.29.5218904", name: "Rubiataba" },
    { code: "BR.29.5219001", name: "Sanclerlândia" },
    { code: "BR.29.5219100", name: "Santa Bárbara de Goiás" },
    { code: "BR.29.5219209", name: "Santa Cruz de Goiás" },
    { code: "BR.29.5219258", name: "Santa Fé de Goiás" },
    { code: "BR.29.5219308", name: "Santa Helena de Goiás" },
    { code: "BR.29.5219357", name: "Santa Isabel" },
    { code: "BR.29.5219407", name: "Santa Rita do Araguaia" },
    { code: "BR.29.5219456", name: "Santa Rita do Novo Destino" },
    { code: "BR.29.5219506", name: "Santa Rosa de Goiás" },
    { code: "BR.29.5219605", name: "Santa Tereza de Goiás" },
    { code: "BR.29.5219704", name: "Santa Terezinha de Goiás" },
    { code: "BR.29.5219712", name: "Santo Antônio da Barra" },
    { code: "BR.29.5219738", name: "Santo Antônio de Goiás" },
    { code: "BR.29.5219753", name: "Santo Antônio do Descoberto" },
    { code: "BR.29.5219803", name: "São Domingos" },
    { code: "BR.29.5219902", name: "São Francisco de Goiás" },
    { code: "BR.29.5220009", name: "São João d'Aliança" },
    { code: "BR.29.5220058", name: "São João da Paraúna" },
    { code: "BR.29.5220108", name: "São Luís de Montes Belos" },
    { code: "BR.29.5220157", name: "São Luiz do Norte" },
    { code: "BR.29.5220207", name: "São Miguel do Araguaia" },
    { code: "BR.29.5220264", name: "São Miguel do Passa Quatro" },
    { code: "BR.29.5220280", name: "São Patrício" },
    { code: "BR.29.5220405", name: "São Simão" },
    { code: "BR.29.5220454", name: "Senador Canedo" },
    { code: "BR.29.5220504", name: "Serranópolis" },
    { code: "BR.29.5220603", name: "Silvânia" },
    { code: "BR.29.5220686", name: "Simolândia" },
    { code: "BR.29.5220702", name: "Sítio d'Abadia" },
    { code: "BR.29.5221007", name: "Taquaral de Goiás" },
    { code: "BR.29.5221080", name: "Teresina de Goiás" },
    { code: "BR.29.5221197", name: "Terezópolis de Goiás" },
    { code: "BR.29.5221304", name: "Três Ranchos" },
    { code: "BR.29.5221403", name: "Trindade" },
    { code: "BR.29.5221452", name: "Trombas" },
    { code: "BR.29.5221502", name: "Turvânia" },
    { code: "BR.29.5221551", name: "Turvelândia" },
    { code: "BR.29.5221577", name: "Uirapuru" },
    { code: "BR.29.5221601", name: "Uruaçu" },
    { code: "BR.29.5221700", name: "Uruana" },
    { code: "BR.29.5221809", name: "Urutaí" },
    { code: "BR.29.5221858", name: "Valparaíso de Goiás" },
    { code: "BR.29.5221908", name: "Varjão" },
    { code: "BR.29.5222005", name: "Vianópolis" },
    { code: "BR.29.5222054", name: "Vicentinópolis" },
    { code: "BR.29.5222203", name: "Vila Boa" },
    { code: "BR.29.5222302", name: "Vila Propício" },
  ],
  "BR.30": [
    { code: "BR.30.2600054", name: "Abreu e Lima" },
    { code: "BR.30.2600104", name: "Afogados da Ingazeira" },
    { code: "BR.30.2600203", name: "Afrânio" },
    { code: "BR.30.2600302", name: "Agrestina" },
    { code: "BR.30.2600401", name: "Água Preta" },
    { code: "BR.30.2600500", name: "Águas Belas" },
    { code: "BR.30.2600609", name: "Alagoinha" },
    { code: "BR.30.2600708", name: "Aliança" },
    { code: "BR.30.2600807", name: "Altinho" },
    { code: "BR.30.2600906", name: "Amaraji" },
    { code: "BR.30.2601003", name: "Angelim" },
    { code: "BR.30.2601052", name: "Araçoiaba" },
    { code: "BR.30.2601102", name: "Araripina" },
    { code: "BR.30.2601201", name: "Arcoverde" },
    { code: "BR.30.2601300", name: "Barra de Guabiraba" },
    { code: "BR.30.2601409", name: "Barreiros" },
    { code: "BR.30.2601508", name: "Belém de Maria" },
    { code: "BR.30.2601607", name: "Belém do São Francisco" },
    { code: "BR.30.2601706", name: "Belo Jardim" },
    { code: "BR.30.2601805", name: "Betânia" },
    { code: "BR.30.2601904", name: "Bezerros" },
    { code: "BR.30.2602001", name: "Bodocó" },
    { code: "BR.30.2602100", name: "Bom Conselho" },
    { code: "BR.30.2602209", name: "Bom Jardim" },
    { code: "BR.30.2602308", name: "Bonito" },
    { code: "BR.30.2602407", name: "Brejão" },
    { code: "BR.30.2602506", name: "Brejinho" },
    { code: "BR.30.2602605", name: "Brejo da Madre de Deus" },
    { code: "BR.30.2602704", name: "Buenos Aires" },
    { code: "BR.30.2602803", name: "Buíque" },
    { code: "BR.30.2602902", name: "Cabo de Santo Agostinho" },
    { code: "BR.30.2603009", name: "Cabrobó" },
    { code: "BR.30.2603108", name: "Cachoeirinha" },
    { code: "BR.30.2603207", name: "Caetés" },
    { code: "BR.30.2603306", name: "Calçado" },
    { code: "BR.30.2603405", name: "Calumbi" },
    { code: "BR.30.2603454", name: "Camaragibe" },
    { code: "BR.30.2603504", name: "Camocim de São Félix" },
    { code: "BR.30.2603603", name: "Camutanga" },
    { code: "BR.30.2603702", name: "Canhotinho" },
    { code: "BR.30.2603801", name: "Capoeiras" },
    { code: "BR.30.2603900", name: "Carnaíba" },
    { code: "BR.30.2603926", name: "Carnaubeira da Penha" },
    { code: "BR.30.2604007", name: "Carpina" },
    { code: "BR.30.2604106", name: "Caruaru" },
    { code: "BR.30.2604155", name: "Casinhas" },
    { code: "BR.30.2604205", name: "Catende" },
    { code: "BR.30.2604304", name: "Cedro" },
    { code: "BR.30.2604403", name: "Chã de Alegria" },
    { code: "BR.30.2604502", name: "Chã Grande" },
    { code: "BR.30.2604601", name: "Condado" },
    { code: "BR.30.2604700", name: "Correntes" },
    { code: "BR.30.2604809", name: "Cortês" },
    { code: "BR.30.2604908", name: "Cumaru" },
    { code: "BR.30.2605004", name: "Cupira" },
    { code: "BR.30.2605103", name: "Custódia" },
    { code: "BR.30.2605152", name: "Dormentes" },
    { code: "BR.30.2605202", name: "Escada" },
    { code: "BR.30.2605301", name: "Exu" },
    { code: "BR.30.2605400", name: "Feira Nova" },
    { code: "BR.30.2605459", name: "Fernando de Noronha" },
    { code: "BR.30.2605509", name: "Ferreiros" },
    { code: "BR.30.2605608", name: "Flores" },
    { code: "BR.30.2605707", name: "Floresta" },
    { code: "BR.30.2605806", name: "Frei Miguelinho" },
    { code: "BR.30.2605905", name: "Gameleira" },
    { code: "BR.30.2606002", name: "Garanhuns" },
    { code: "BR.30.2606101", name: "Glória do Goitá" },
    { code: "BR.30.2606200", name: "Goiana" },
    { code: "BR.30.2606309", name: "Granito" },
    { code: "BR.30.2606408", name: "Gravatá" },
    { code: "BR.30.2606507", name: "Iati" },
    { code: "BR.30.2606606", name: "Ibimirim" },
    { code: "BR.30.2606705", name: "Ibirajuba" },
    { code: "BR.30.2606804", name: "Igarassu" },
    { code: "BR.30.2606903", name: "Iguaracy" },
    { code: "BR.30.2607000", name: "Inajá" },
    { code: "BR.30.2607109", name: "Ingazeira" },
    { code: "BR.30.2607208", name: "Ipojuca" },
    { code: "BR.30.2607307", name: "Ipubi" },
    { code: "BR.30.2607406", name: "Itacuruba" },
    { code: "BR.30.2607505", name: "Itaíba" },
    { code: "BR.30.2607604", name: "Ilha de Itamaracá" },
    { code: "BR.30.2607653", name: "Itambé" },
    { code: "BR.30.2607703", name: "Itapetim" },
    { code: "BR.30.2607752", name: "Itapissuma" },
    { code: "BR.30.2607802", name: "Itaquitinga" },
    { code: "BR.30.2607901", name: "Jaboatão dos Guararapes" },
    { code: "BR.30.2607950", name: "Jaqueira" },
    { code: "BR.30.2608008", name: "Jataúba" },
    { code: "BR.30.2608057", name: "Jatobá" },
    { code: "BR.30.2608107", name: "João Alfredo" },
    { code: "BR.30.2608206", name: "Joaquim Nabuco" },
    { code: "BR.30.2608255", name: "Jucati" },
    { code: "BR.30.2608305", name: "Jupi" },
    { code: "BR.30.2608404", name: "Jurema" },
    { code: "BR.30.2608453", name: "Lagoa do Carro" },
    { code: "BR.30.2608503", name: "Lagoa de Itaenga" },
    { code: "BR.30.2608602", name: "Lagoa do Ouro" },
    { code: "BR.30.2608701", name: "Lagoa dos Gatos" },
    { code: "BR.30.2608750", name: "Lagoa Grande" },
    { code: "BR.30.2608800", name: "Lajedo" },
    { code: "BR.30.2608909", name: "Limoeiro" },
    { code: "BR.30.2609006", name: "Macaparana" },
    { code: "BR.30.2609105", name: "Machados" },
    { code: "BR.30.2609154", name: "Manari" },
    { code: "BR.30.2609204", name: "Maraial" },
    { code: "BR.30.2609303", name: "Mirandiba" },
    { code: "BR.30.2609402", name: "Moreno" },
    { code: "BR.30.2609501", name: "Nazaré da Mata" },
    { code: "BR.30.2609600", name: "Olinda" },
    { code: "BR.30.2609709", name: "Orobó" },
    { code: "BR.30.2609808", name: "Orocó" },
    { code: "BR.30.2609907", name: "Ouricuri" },
    { code: "BR.30.2610004", name: "Palmares" },
    { code: "BR.30.2610103", name: "Palmeirina" },
    { code: "BR.30.2610202", name: "Panelas" },
    { code: "BR.30.2610301", name: "Paranatama" },
    { code: "BR.30.2610400", name: "Parnamirim" },
    { code: "BR.30.2610509", name: "Passira" },
    { code: "BR.30.2610608", name: "Paudalho" },
    { code: "BR.30.2610707", name: "Paulista" },
    { code: "BR.30.2610806", name: "Pedra" },
    { code: "BR.30.2610905", name: "Pesqueira" },
    { code: "BR.30.2611002", name: "Petrolândia" },
    { code: "BR.30.2611101", name: "Petrolina" },
    { code: "BR.30.2611200", name: "Poção" },
    { code: "BR.30.2611309", name: "Pombos" },
    { code: "BR.30.2611408", name: "Primavera" },
    { code: "BR.30.2611507", name: "Quipapá" },
    { code: "BR.30.2611533", name: "Quixaba" },
    { code: "BR.30.2611606", name: "Recife" },
    { code: "BR.30.2611705", name: "Riacho das Almas" },
    { code: "BR.30.2611804", name: "Ribeirão" },
    { code: "BR.30.2611903", name: "Rio Formoso" },
    { code: "BR.30.2612000", name: "Sairé" },
    { code: "BR.30.2612109", name: "Salgadinho" },
    { code: "BR.30.2612208", name: "Salgueiro" },
    { code: "BR.30.2612307", name: "Saloá" },
    { code: "BR.30.2612406", name: "Sanharó" },
    { code: "BR.30.2612455", name: "Santa Cruz" },
    { code: "BR.30.2612471", name: "Santa Cruz da Baixa Verde" },
    { code: "BR.30.2612505", name: "Santa Cruz do Capibaribe" },
    { code: "BR.30.2612554", name: "Santa Filomena" },
    { code: "BR.30.2612604", name: "Santa Maria da Boa Vista" },
    { code: "BR.30.2612703", name: "Santa Maria do Cambucá" },
    { code: "BR.30.2612802", name: "Santa Terezinha" },
    { code: "BR.30.2612901", name: "São Benedito do Sul" },
    { code: "BR.30.2613008", name: "São Bento do Una" },
    { code: "BR.30.2613107", name: "São Caitano" },
    { code: "BR.30.2613206", name: "São João" },
    { code: "BR.30.2613305", name: "São Joaquim do Monte" },
    { code: "BR.30.2613404", name: "São José da Coroa Grande" },
    { code: "BR.30.2613503", name: "São José do Belmonte" },
    { code: "BR.30.2613602", name: "São José do Egito" },
    { code: "BR.30.2613701", name: "São Lourenço da Mata" },
    { code: "BR.30.2613800", name: "São Vicente Férrer" },
    { code: "BR.30.2613909", name: "Serra Talhada" },
    { code: "BR.30.2614006", name: "Serrita" },
    { code: "BR.30.2614105", name: "Sertânia" },
    { code: "BR.30.2614204", name: "Sirinhaém" },
    { code: "BR.30.2614303", name: "Moreilândia" },
    { code: "BR.30.2614402", name: "Solidão" },
    { code: "BR.30.2614501", name: "Surubim" },
    { code: "BR.30.2614600", name: "Tabira" },
    { code: "BR.30.2614709", name: "Tacaimbó" },
    { code: "BR.30.2614808", name: "Tacaratu" },
    { code: "BR.30.2614857", name: "Tamandaré" },
    { code: "BR.30.2615003", name: "Taquaritinga do Norte" },
    { code: "BR.30.2615102", name: "Terezinha" },
    { code: "BR.30.2615201", name: "Terra Nova" },
    { code: "BR.30.2615300", name: "Timbaúba" },
    { code: "BR.30.2615409", name: "Toritama" },
    { code: "BR.30.2615508", name: "Tracunhaém" },
    { code: "BR.30.2615607", name: "Trindade" },
    { code: "BR.30.2615706", name: "Triunfo" },
    { code: "BR.30.2615805", name: "Tupanatinga" },
    { code: "BR.30.2615904", name: "Tuparetama" },
    { code: "BR.30.2616001", name: "Venturosa" },
    { code: "BR.30.2616100", name: "Verdejante" },
    { code: "BR.30.2616183", name: "Vertente do Lério" },
    { code: "BR.30.2616209", name: "Vertentes" },
    { code: "BR.30.2616308", name: "Vicência" },
    { code: "BR.30.2616407", name: "Vitória de Santo Antão" },
    { code: "BR.30.2616506", name: "Xexéu" },
  ],
  "BR.31": [
    { code: "BR.31.1700251", name: "Abreulândia" },
    { code: "BR.31.1700301", name: "Aguiarnópolis" },
    { code: "BR.31.1700350", name: "Aliança do Tocantins" },
    { code: "BR.31.1700400", name: "Almas" },
    { code: "BR.31.1700707", name: "Alvorada" },
    { code: "BR.31.1701002", name: "Ananás" },
    { code: "BR.31.1701051", name: "Angico" },
    { code: "BR.31.1701101", name: "Aparecida do Rio Negro" },
    { code: "BR.31.1701309", name: "Aragominas" },
    { code: "BR.31.1701903", name: "Araguacema" },
    { code: "BR.31.1702000", name: "Araguaçu" },
    { code: "BR.31.1702109", name: "Araguaína" },
    { code: "BR.31.1702158", name: "Araguanã" },
    { code: "BR.31.1702208", name: "Araguatins" },
    { code: "BR.31.1702307", name: "Arapoema" },
    { code: "BR.31.1702406", name: "Arraias" },
    { code: "BR.31.1702554", name: "Augustinópolis" },
    { code: "BR.31.1702703", name: "Aurora do Tocantins" },
    { code: "BR.31.1702901", name: "Axixá do Tocantins" },
    { code: "BR.31.1703008", name: "Babaçulândia" },
    { code: "BR.31.1703057", name: "Bandeirantes do Tocantins" },
    { code: "BR.31.1703073", name: "Barra do Ouro" },
    { code: "BR.31.1703107", name: "Barrolândia" },
    { code: "BR.31.1703206", name: "Bernardo Sayão" },
    { code: "BR.31.1703305", name: "Bom Jesus do Tocantins" },
    { code: "BR.31.1703602", name: "Brasilândia do Tocantins" },
    { code: "BR.31.1703701", name: "Brejinho de Nazaré" },
    { code: "BR.31.1703800", name: "Buriti do Tocantins" },
    { code: "BR.31.1703826", name: "Cachoeirinha" },
    { code: "BR.31.1703842", name: "Campos Lindos" },
    { code: "BR.31.1703867", name: "Cariri do Tocantins" },
    { code: "BR.31.1703883", name: "Carmolândia" },
    { code: "BR.31.1703891", name: "Carrasco Bonito" },
    { code: "BR.31.1703909", name: "Caseara" },
    { code: "BR.31.1704105", name: "Centenário" },
    { code: "BR.31.1704600", name: "Chapada de Areia" },
    { code: "BR.31.1705102", name: "Chapada da Natividade" },
    { code: "BR.31.1705508", name: "Colinas do Tocantins" },
    { code: "BR.31.1705557", name: "Combinado" },
    { code: "BR.31.1705607", name: "Conceição do Tocantins" },
    { code: "BR.31.1706001", name: "Couto Magalhães" },
    { code: "BR.31.1706100", name: "Cristalândia" },
    { code: "BR.31.1706258", name: "Crixás do Tocantins" },
    { code: "BR.31.1706506", name: "Darcinópolis" },
    { code: "BR.31.1707009", name: "Dianópolis" },
    { code: "BR.31.1707108", name: "Divinópolis do Tocantins" },
    { code: "BR.31.1707207", name: "Dois Irmãos do Tocantins" },
    { code: "BR.31.1707306", name: "Dueré" },
    { code: "BR.31.1707405", name: "Esperantina" },
    { code: "BR.31.1707553", name: "Fátima" },
    { code: "BR.31.1707652", name: "Figueirópolis" },
    { code: "BR.31.1707702", name: "Filadélfia" },
    { code: "BR.31.1708205", name: "Formoso do Araguaia" },
    { code: "BR.31.1708254", name: "Fortaleza do Tabocão" },
    { code: "BR.31.1708304", name: "Goianorte" },
    { code: "BR.31.1709005", name: "Goiatins" },
    { code: "BR.31.1709302", name: "Guaraí" },
    { code: "BR.31.1709500", name: "Gurupi" },
    { code: "BR.31.1709807", name: "Ipueiras" },
    { code: "BR.31.1710508", name: "Itacajá" },
    { code: "BR.31.1710706", name: "Itaguatins" },
    { code: "BR.31.1710904", name: "Itapiratins" },
    { code: "BR.31.1711100", name: "Itaporã do Tocantins" },
    { code: "BR.31.1711506", name: "Jaú do Tocantins" },
    { code: "BR.31.1711803", name: "Juarina" },
    { code: "BR.31.1711902", name: "Lagoa da Confusão" },
    { code: "BR.31.1711951", name: "Lagoa do Tocantins" },
    { code: "BR.31.1712009", name: "Lajeado" },
    { code: "BR.31.1712157", name: "Lavandeira" },
    { code: "BR.31.1712405", name: "Lizarda" },
    { code: "BR.31.1712454", name: "Luzinópolis" },
    { code: "BR.31.1712504", name: "Marianópolis do Tocantins" },
    { code: "BR.31.1712702", name: "Mateiros" },
    { code: "BR.31.1712801", name: "Maurilândia do Tocantins" },
    { code: "BR.31.1713205", name: "Miracema do Tocantins" },
    { code: "BR.31.1713304", name: "Miranorte" },
    { code: "BR.31.1713601", name: "Monte do Carmo" },
    { code: "BR.31.1713700", name: "Monte Santo do Tocantins" },
    { code: "BR.31.1713809", name: "Palmeiras do Tocantins" },
    { code: "BR.31.1713957", name: "Muricilândia" },
    { code: "BR.31.1714203", name: "Natividade" },
    { code: "BR.31.1714302", name: "Nazaré" },
    { code: "BR.31.1714880", name: "Nova Olinda" },
    { code: "BR.31.1715002", name: "Nova Rosalândia" },
    { code: "BR.31.1715101", name: "Novo Acordo" },
    { code: "BR.31.1715150", name: "Novo Alegre" },
    { code: "BR.31.1715259", name: "Novo Jardim" },
    { code: "BR.31.1715507", name: "Oliveira de Fátima" },
    { code: "BR.31.1715705", name: "Palmeirante" },
    { code: "BR.31.1715754", name: "Palmeirópolis" },
    { code: "BR.31.1716109", name: "Paraíso do Tocantins" },
    { code: "BR.31.1716208", name: "Paranã" },
    { code: "BR.31.1716307", name: "Pau d'Arco" },
    { code: "BR.31.1716505", name: "Pedro Afonso" },
    { code: "BR.31.1716604", name: "Peixe" },
    { code: "BR.31.1716653", name: "Pequizeiro" },
    { code: "BR.31.1716703", name: "Colméia" },
    { code: "BR.31.1717008", name: "Pindorama do Tocantins" },
    { code: "BR.31.1717206", name: "Piraquê" },
    { code: "BR.31.1717503", name: "Pium" },
    { code: "BR.31.1717800", name: "Ponte Alta do Bom Jesus" },
    { code: "BR.31.1717909", name: "Ponte Alta do Tocantins" },
    { code: "BR.31.1718006", name: "Porto Alegre do Tocantins" },
    { code: "BR.31.1718204", name: "Porto Nacional" },
    { code: "BR.31.1718303", name: "Praia Norte" },
    { code: "BR.31.1718402", name: "Presidente Kennedy" },
    { code: "BR.31.1718451", name: "Pugmil" },
    { code: "BR.31.1718501", name: "Recursolândia" },
    { code: "BR.31.1718550", name: "Riachinho" },
    { code: "BR.31.1718659", name: "Rio da Conceição" },
    { code: "BR.31.1718709", name: "Rio dos Bois" },
    { code: "BR.31.1718758", name: "Rio Sono" },
    { code: "BR.31.1718808", name: "Sampaio" },
    { code: "BR.31.1718840", name: "Sandolândia" },
    { code: "BR.31.1718865", name: "Santa Fé do Araguaia" },
    { code: "BR.31.1718881", name: "Santa Maria do Tocantins" },
    { code: "BR.31.1718899", name: "Santa Rita do Tocantins" },
    { code: "BR.31.1718907", name: "Santa Rosa do Tocantins" },
    { code: "BR.31.1719004", name: "Santa Tereza do Tocantins" },
    { code: "BR.31.1720002", name: "Santa Terezinha do Tocantins" },
    { code: "BR.31.1720101", name: "São Bento do Tocantins" },
    { code: "BR.31.1720150", name: "São Félix do Tocantins" },
    { code: "BR.31.1720200", name: "São Miguel do Tocantins" },
    { code: "BR.31.1720259", name: "São Salvador do Tocantins" },
    { code: "BR.31.1720309", name: "São Sebastião do Tocantins" },
    { code: "BR.31.1720499", name: "São Valério" },
    { code: "BR.31.1720655", name: "Silvanópolis" },
    { code: "BR.31.1720804", name: "Sítio Novo do Tocantins" },
    { code: "BR.31.1720853", name: "Sucupira" },
    { code: "BR.31.1720903", name: "Taguatinga" },
    { code: "BR.31.1720937", name: "Taipas do Tocantins" },
    { code: "BR.31.1720978", name: "Talismã" },
    { code: "BR.31.1721000", name: "Palmas" },
    { code: "BR.31.1721109", name: "Tocantínia" },
    { code: "BR.31.1721208", name: "Tocantinópolis" },
    { code: "BR.31.1721257", name: "Tupirama" },
    { code: "BR.31.1721307", name: "Tupiratins" },
    { code: "BR.31.1722081", name: "Wanderlândia" },
    { code: "BR.31.1722107", name: "Xambioá" },
  ],
  "BT.06": [
    { code: "BT.06.7647113", name: "Phuentsholing" },
    { code: "BT.06.7647116", name: "Bongo" },
    { code: "BT.06.7647631", name: "Chabchha" },
  ],
  "BT.07": [
    { code: "BT.07.7647804", name: "Kikhorthang" },
    { code: "BT.07.7647805", name: "Beteni" },
  ],
  "BT.08": [
    { code: "BT.08.7646448", name: "Tsangkha" },
    { code: "BT.08.7646449", name: "Lajab" },
    { code: "BT.08.7646456", name: "Drukgyegang" },
    { code: "BT.08.7647632", name: "Khiphisa" },
  ],
  "BT.13": [
    { code: "BT.13.7647816", name: "Mewang" },
  ],
  "BT.14": [
    { code: "BT.14.7646634", name: "Khar" },
    { code: "BT.14.7646635", name: "Chongshing" },
    { code: "BT.14.7646636", name: "Yurung" },
  ],
  "BT.18": [
    { code: "BT.18.7647112", name: "Nangkor" },
    { code: "BT.18.7647118", name: "Goshing" },
    { code: "BT.18.7647122", name: "Bardo" },
    { code: "BT.18.7647813", name: "Trong" },
  ],
  "BT.19": [
    { code: "BT.19.1252424", name: "Tashigang" },
    { code: "BT.19.7647111", name: "Radi" },
    { code: "BT.19.7647125", name: "Lumang" },
    { code: "BT.19.7647130", name: "Thrimshing" },
  ],
  "BT.20": [
    { code: "BT.20.11287732", name: "Lingzhi Gewog" },
  ],
  "BT.21": [
    { code: "BT.21.7647633", name: "Nubi" },
    { code: "BT.21.7647634", name: "Bjakteng" },
  ],
  "BT.22": [
    { code: "BT.22.7646447", name: "Dangchu" },
    { code: "BT.22.7647808", name: "Ruepaisa" },
    { code: "BT.22.7647809", name: "Nahi" },
  ],
  "BW.01": [
    { code: "BW.01.11819282", name: "Tutume" },
    { code: "BW.01.11819291", name: "Bobonong" },
    { code: "BW.01.11819294", name: "Tuli" },
    { code: "BW.01.11819295", name: "Lethlakane" },
    { code: "BW.01.7670706", name: "Mahalapye" },
    { code: "BW.01.7670708", name: "Machaneng" },
    { code: "BW.01.7670709", name: "Serowe" },
    { code: "BW.01.7670710", name: "Palapye" },
  ],
  "BW.03": [
    { code: "BW.03.11819300", name: "Ghanzi" },
  ],
  "BW.04": [
    { code: "BW.04.11819283", name: "Tshabong" },
    { code: "BW.04.11819286", name: "Gemsbok" },
    { code: "BW.04.11819290", name: "Hukunsti" },
  ],
  "BW.05": [
    { code: "BW.05.7670705", name: "Kgatleng" },
  ],
  "BW.06": [
    { code: "BW.06.11819293", name: "Kweneng North" },
    { code: "BW.06.11819298", name: "Kweneng South" },
  ],
  "BW.08": [
    { code: "BW.08.11819299", name: "Masungu" },
  ],
  "BW.09": [
    { code: "BW.09.11819287", name: "South East" },
    { code: "BW.09.7670702", name: "Gaborone" },
  ],
  "BW.10": [
    { code: "BW.10.11819288", name: "Barolong" },
    { code: "BW.10.11819289", name: "Ngwaketse Central" },
    { code: "BW.10.11819292", name: "Ngwaketse South" },
    { code: "BW.10.11819297", name: "Ngwaketse North" },
  ],
  "BW.11": [
    { code: "BW.11.11819284", name: "Ngamiland East" },
    { code: "BW.11.11819296", name: "Ngamiland West" },
  ],
  "BW.12": [
    { code: "BW.12.11819285", name: "Chobe" },
  ],
  "BY.01": [
    { code: "BY.01.618911", name: "Zhabinkawski Rayon" },
    { code: "BY.01.621276", name: "Stolinski Rayon" },
    { code: "BY.01.622998", name: "Pruzhanski Rayon" },
    { code: "BY.01.623548", name: "Pinski Rayon" },
    { code: "BY.01.625538", name: "Malarytski Rayon" },
    { code: "BY.01.625765", name: "Lyakhavitski Rayon" },
    { code: "BY.01.625820", name: "Luninyetski Rayon" },
    { code: "BY.01.627146", name: "Kobrynski Rayon" },
    { code: "BY.01.627709", name: "Kamyanyetski Rayon" },
    { code: "BY.01.627799", name: "Ivatsevitski Rayon" },
    { code: "BY.01.627807", name: "Ivanawski Rayon" },
    { code: "BY.01.628532", name: "Hantsavitski Rayon" },
    { code: "BY.01.628882", name: "Drahichynski Rayon" },
    { code: "BY.01.629630", name: "Brestski Rayon" },
    { code: "BY.01.630155", name: "Byarozawski Rayon" },
    { code: "BY.01.630420", name: "Baranovichskiy Rayon" },
    { code: "BY.01.828881", name: "Horad Brest" },
    { code: "BY.01.828883", name: "Horad Baranavichy" },
  ],
  "BY.02": [
    { code: "BY.02.618803", name: "Zhlobinski Rayon" },
    { code: "BY.02.618814", name: "Zhytkavitski Rayon" },
    { code: "BY.02.619597", name: "Yel’ski Rayon" },
    { code: "BY.02.620212", name: "Vyetkawski Rayon" },
    { code: "BY.02.621073", name: "Svyetlahorski Rayon" },
    { code: "BY.02.622738", name: "Rahachowski Rayon" },
    { code: "BY.02.622799", name: "Rechytski Rayon" },
    { code: "BY.02.623580", name: "Pyetrykawski Rayon" },
    { code: "BY.02.624197", name: "Aktsyabrski Rayon" },
    { code: "BY.02.624798", name: "Narawlyanski Rayon" },
    { code: "BY.02.624894", name: "Mazyrski Rayon" },
    { code: "BY.02.625906", name: "Loyewski Rayon" },
    { code: "BY.02.626189", name: "Lyel’chytski Rayon" },
    { code: "BY.02.626914", name: "Karmyanski Rayon" },
    { code: "BY.02.627360", name: "Khoynitski Rayon" },
    { code: "BY.02.627748", name: "Kalinkavitski Rayon" },
    { code: "BY.02.628280", name: "Homyel’ski Rayon" },
    { code: "BY.02.629017", name: "Dobrushski Rayon" },
    { code: "BY.02.629389", name: "Chacherski Rayon" },
    { code: "BY.02.629562", name: "Buda-Kashalyowski Rayon" },
    { code: "BY.02.629645", name: "Brahinski Rayon" },
    { code: "BY.02.828879", name: "Uvarovichskiy Rayon" },
    { code: "BY.02.828892", name: "Horad Homyel’" },
    { code: "BY.02.828894", name: "Horad Dobrush" },
    { code: "BY.02.828895", name: "Horad Zhlobin" },
    { code: "BY.02.828897", name: "Horad Kalinkavichy" },
    { code: "BY.02.828898", name: "Horad Mazyr" },
    { code: "BY.02.828900", name: "Horad Rahachow" },
    { code: "BY.02.828901", name: "Horad Svyetlahorsk" },
  ],
  "BY.03": [
    { code: "BY.03.618930", name: "Zel’venskiy Rayon" },
    { code: "BY.03.619978", name: "Voranawski Rayon" },
    { code: "BY.03.620067", name: "Vawkavyski Rayon" },
    { code: "BY.03.621044", name: "Svislatski Rayon" },
    { code: "BY.03.621711", name: "Smarhonski Rayon" },
    { code: "BY.03.621752", name: "Slonimskiy Rayon" },
    { code: "BY.03.622114", name: "Shchuchynski Rayon" },
    { code: "BY.03.623940", name: "Astravyetski Rayon" },
    { code: "BY.03.624062", name: "Ashmyanski Rayon" },
    { code: "BY.03.624498", name: "Novogrudskiy Rayon" },
    { code: "BY.03.624920", name: "Mastowski Rayon" },
    { code: "BY.03.626079", name: "Lidski Rayon" },
    { code: "BY.03.626938", name: "Karelitski Rayon" },
    { code: "BY.03.627794", name: "Iwyewski Rayon" },
    { code: "BY.03.628034", name: "Grodnenskiy Rayon" },
    { code: "BY.03.628657", name: "Dzyatlawski Rayon" },
    { code: "BY.03.630208", name: "Byerastavitski Rayon" },
    { code: "BY.03.828847", name: "Horad Hrodna" },
    { code: "BY.03.828902", name: "Horad Vawkavysk" },
    { code: "BY.03.828903", name: "Horad Lida" },
    { code: "BY.03.828904", name: "Horad Navahrudak" },
    { code: "BY.03.828905", name: "Horad Slonim" },
    { code: "BY.03.828906", name: "Horad Smarhon’" },
  ],
  "BY.04": [
    { code: "BY.04.619008", name: "Zavodski Rayon" },
    { code: "BY.04.620745", name: "Tsentral’ny Rayon" },
    { code: "BY.04.621599", name: "Savyetski Rayon" },
    { code: "BY.04.623628", name: "Pyershamayski Rayon" },
    { code: "BY.04.623778", name: "Partyzanski Rayon" },
    { code: "BY.04.624196", name: "Kastrychnitski Rayon" },
    { code: "BY.04.624936", name: "Maskowski Rayon" },
    { code: "BY.04.626161", name: "Lyeninski Rayon" },
    { code: "BY.04.628577", name: "Frunzyenski Rayon" },
  ],
  "BY.05": [
    { code: "BY.05.620025", name: "Valozhynski Rayon" },
    { code: "BY.05.620178", name: "Vilyeyski Rayon" },
    { code: "BY.05.620482", name: "Uzdzyenski Rayon" },
    { code: "BY.05.621281", name: "Stawbtsowski Rayon" },
    { code: "BY.05.621460", name: "Staradarozhski Rayon" },
    { code: "BY.05.621664", name: "Salihorski Rayon" },
    { code: "BY.05.621728", name: "Smalyavitski Rayon" },
    { code: "BY.05.621740", name: "Slutski Rayon" },
    { code: "BY.05.622968", name: "Pukhavichy Raion" },
    { code: "BY.05.624699", name: "Nyasvizhski Rayon" },
    { code: "BY.05.624858", name: "Myadzyel’ski Rayon" },
    { code: "BY.05.625025", name: "Maladzyechanski Rayon" },
    { code: "BY.05.625140", name: "Minski Rayon" },
    { code: "BY.05.625717", name: "Lyubanski Rayon" },
    { code: "BY.05.625971", name: "Lahoyski Rayon" },
    { code: "BY.05.626463", name: "Krupski Rayon" },
    { code: "BY.05.626951", name: "Kapyl’ski Rayon" },
    { code: "BY.05.627213", name: "Klyetski Rayon" },
    { code: "BY.05.628641", name: "Dzyarzhynski Rayon" },
    { code: "BY.05.629270", name: "Chervyen’ski Rayon" },
    { code: "BY.05.629799", name: "Barysawski Rayon" },
    { code: "BY.05.630193", name: "Byarezinski Rayon" },
    { code: "BY.05.828907", name: "Barysaw" },
    { code: "BY.05.828908", name: "Horad Vilyeyka" },
    { code: "BY.05.828910", name: "Horad Dzyarzhynsk" },
    { code: "BY.05.828913", name: "Horad Zaslawye" },
    { code: "BY.05.828914", name: "Horad Maladzyechna" },
    { code: "BY.05.828915", name: "Horad Slutsk" },
    { code: "BY.05.828916", name: "Horad Salihorsk" },
    { code: "BY.05.829413", name: "Molodechnenskij Rajon" },
  ],
  "BY.06": [
    { code: "BY.06.621846", name: "Slawharadski Rayon" },
    { code: "BY.06.622033", name: "Shklowski Rayon" },
    { code: "BY.06.624028", name: "Asipovitski Rayon" },
    { code: "BY.06.624891", name: "Mstsislawski Rayon" },
    { code: "BY.06.625072", name: "Mahilyowski Rayon" },
    { code: "BY.06.626490", name: "Kruhlyanski Rayon" },
    { code: "BY.06.626545", name: "Krychawski Rayon" },
    { code: "BY.06.626626", name: "Krasnapol’ski Rayon" },
    { code: "BY.06.626807", name: "Kastsyukovitski Rayon" },
    { code: "BY.06.627199", name: "Klimavitski Rayon" },
    { code: "BY.06.627204", name: "Klichawski Rayon" },
    { code: "BY.06.627271", name: "Kirawski Rayon" },
    { code: "BY.06.627380", name: "Khotsimski Rayon" },
    { code: "BY.06.628237", name: "Horatski Rayon" },
    { code: "BY.06.628386", name: "Hluski Rayon" },
    { code: "BY.06.629346", name: "Cherykawski Rayon" },
    { code: "BY.06.629396", name: "Chavuski Rayon" },
    { code: "BY.06.629443", name: "Bykhawski Rayon" },
    { code: "BY.06.630046", name: "Babruyski Rayon" },
    { code: "BY.06.630244", name: "Byalynitski Rayon" },
    { code: "BY.06.7874038", name: "Kirawsk" },
    { code: "BY.06.828843", name: "Drybinski Rayon" },
    { code: "BY.06.828917", name: "Mahilyow" },
    { code: "BY.06.828919", name: "Horad Asipovichy" },
  ],
  "BY.07": [
    { code: "BY.07.620133", name: "Vitsyebski Rayon" },
    { code: "BY.07.620254", name: "Vyerkhnyadzvinski Rayon" },
    { code: "BY.07.620539", name: "Ushatski Rayon" },
    { code: "BY.07.620831", name: "Talachynski Rayon" },
    { code: "BY.07.621985", name: "Shumilinski Rayon" },
    { code: "BY.07.622178", name: "Sharkawshchynski Rayon" },
    { code: "BY.07.622261", name: "Syennyenski Rayon" },
    { code: "BY.07.622691", name: "Rasonski Rayon" },
    { code: "BY.07.623176", name: "Pastawski Rayon" },
    { code: "BY.07.623283", name: "Polatski Rayon" },
    { code: "BY.07.624077", name: "Arshanski Rayon" },
    { code: "BY.07.625131", name: "Myorski Rayon" },
    { code: "BY.07.626065", name: "Lyoznyenski Rayon" },
    { code: "BY.07.626141", name: "Lyepyel’ski Rayon" },
    { code: "BY.07.628152", name: "Haradotski Rayon" },
    { code: "BY.07.628404", name: "Hlybotski Rayon" },
    { code: "BY.07.628789", name: "Dubrovyenski Rayon" },
    { code: "BY.07.629003", name: "Dokshytski Rayon" },
    { code: "BY.07.629398", name: "Chashnitski Rayon" },
    { code: "BY.07.629639", name: "Braslawski Rayon" },
    { code: "BY.07.630135", name: "Byeshankovitski Rayon" },
    { code: "BY.07.828887", name: "Horad Vitsyebsk" },
    { code: "BY.07.828888", name: "Horad Lyepyel’" },
    { code: "BY.07.828889", name: "Horad Navapolatsk" },
    { code: "BY.07.828891", name: "Horad Polatsk" },
  ],
  "BZ.04": [
    { code: "BZ.04.6942862", name: "Hopelchén" },
  ],
  "BZ.05": [
    { code: "BZ.05.9252696", name: "Dangriga" },
  ],
  "CA.01": [
    { code: "CA.01.4801003", name: "Cypress County" },
    { code: "CA.01.4801006", name: "Medicine Hat" },
    { code: "CA.01.4801008", name: "County of Forty Mile No. 8" },
    { code: "CA.01.4801009", name: "Foremost" },
    { code: "CA.01.4801014", name: "Bow Island" },
    { code: "CA.01.4801018", name: "Redcliff" },
    { code: "CA.01.4802001", name: "County of Warner No. 5" },
    { code: "CA.01.4802002", name: "Coutts" },
    { code: "CA.01.4802004", name: "Milk River" },
    { code: "CA.01.4802006", name: "Warner" },
    { code: "CA.01.4802008", name: "Raymond" },
    { code: "CA.01.4802009", name: "Stirling" },
    { code: "CA.01.4802011", name: "County of Lethbridge No. 26" },
    { code: "CA.01.4802012", name: "Lethbridge" },
    { code: "CA.01.4802013", name: "Coalhurst" },
    { code: "CA.01.4802014", name: "Nobleford" },
    { code: "CA.01.4802016", name: "Barons" },
    { code: "CA.01.4802018", name: "Picture Butte" },
    { code: "CA.01.4802019", name: "Coaldale" },
    { code: "CA.01.4802021", name: "Municipal District of Taber" },
    { code: "CA.01.4802022", name: "Taber" },
    { code: "CA.01.4802023", name: "Barnwell" },
    { code: "CA.01.4802029", name: "Vauxhall" },
    { code: "CA.01.4802031", name: "County of Newell No. 4" },
    { code: "CA.01.4802034", name: "Brooks" },
    { code: "CA.01.4802036", name: "Duchess" },
    { code: "CA.01.4802038", name: "Rosemary" },
    { code: "CA.01.4802039", name: "Bassano" },
    { code: "CA.01.4803001", name: "Cardston County" },
    { code: "CA.01.4803002", name: "Magrath" },
    { code: "CA.01.4803003", name: "Improvement District No. 4" },
    { code: "CA.01.4803004", name: "Cardston" },
    { code: "CA.01.4803006", name: "Glenwood" },
    { code: "CA.01.4803008", name: "Hill Spring" },
    { code: "CA.01.4803011", name: "Municipal District of Pincher Creek No. 9" },
    { code: "CA.01.4803014", name: "Pincher Creek" },
    { code: "CA.01.4803016", name: "Cowley" },
    { code: "CA.01.4803018", name: "Municipal District of Willow Creek No. 26" },
    { code: "CA.01.4803019", name: "Fort Macleod" },
    { code: "CA.01.4803021", name: "Granum" },
    { code: "CA.01.4803022", name: "Claresholm" },
    { code: "CA.01.4803024", name: "Stavely" },
    { code: "CA.01.4803026", name: "Nanton" },
    { code: "CA.01.4804001", name: "Municipal District of Acadia No. 34" },
    { code: "CA.01.4804004", name: "Special Area No. 2" },
    { code: "CA.01.4804006", name: "Empress" },
    { code: "CA.01.4804011", name: "Hanna" },
    { code: "CA.01.4804012", name: "Special Area No. 3" },
    { code: "CA.01.4804014", name: "Oyen" },
    { code: "CA.01.4804016", name: "Cereal" },
    { code: "CA.01.4804019", name: "Youngstown" },
    { code: "CA.01.4804020", name: "Special Area No. 4" },
    { code: "CA.01.4804021", name: "Veteran" },
    { code: "CA.01.4804022", name: "Consort" },
    { code: "CA.01.4805001", name: "Vulcan County" },
    { code: "CA.01.4805002", name: "Carmangay" },
    { code: "CA.01.4805004", name: "Champion" },
    { code: "CA.01.4805006", name: "Vulcan" },
    { code: "CA.01.4805008", name: "Lomond" },
    { code: "CA.01.4805009", name: "Milo" },
    { code: "CA.01.4805011", name: "Arrowwood" },
    { code: "CA.01.4805012", name: "Wheatland County" },
    { code: "CA.01.4805018", name: "Strathmore" },
    { code: "CA.01.4805019", name: "Hussar" },
    { code: "CA.01.4805021", name: "Standard" },
    { code: "CA.01.4805022", name: "Rockyford" },
    { code: "CA.01.4805026", name: "Drumheller" },
    { code: "CA.01.4805031", name: "Starland County" },
    { code: "CA.01.4805034", name: "Delia" },
    { code: "CA.01.4805036", name: "Munson" },
    { code: "CA.01.4805038", name: "Morrin" },
    { code: "CA.01.4805041", name: "Kneehill County" },
    { code: "CA.01.4805042", name: "Carbon" },
    { code: "CA.01.4805044", name: "Acme" },
    { code: "CA.01.4805046", name: "Linden" },
    { code: "CA.01.4805048", name: "Three Hills" },
    { code: "CA.01.4805049", name: "Trochu" },
    { code: "CA.01.4806001", name: "Municipal District of Foothills No. 31" },
    { code: "CA.01.4806006", name: "High River" },
    { code: "CA.01.4806008", name: "Longview" },
    { code: "CA.01.4806009", name: "Turner Valley" },
    { code: "CA.01.4806011", name: "Black Diamond" },
    { code: "CA.01.4806012", name: "Okotoks" },
    { code: "CA.01.4806014", name: "Municipal District of Rocky View No. 44" },
    { code: "CA.01.4806016", name: "Calgary" },
    { code: "CA.01.4806017", name: "Chestermere" },
    { code: "CA.01.4806019", name: "Cochrane" },
    { code: "CA.01.4806021", name: "Airdrie" },
    { code: "CA.01.4806022", name: "Irricana" },
    { code: "CA.01.4806024", name: "Beiseker" },
    { code: "CA.01.4806026", name: "Crossfield" },
    { code: "CA.01.4806028", name: "Mountain View County" },
    { code: "CA.01.4806029", name: "Carstairs" },
    { code: "CA.01.4806031", name: "Cremona" },
    { code: "CA.01.4806032", name: "Didsbury" },
    { code: "CA.01.4806034", name: "Olds" },
    { code: "CA.01.4806036", name: "Sundre" },
    { code: "CA.01.4807001", name: "Municipal District of Provost No. 52" },
    { code: "CA.01.4807002", name: "Provost" },
    { code: "CA.01.4807004", name: "Czar" },
    { code: "CA.01.4807006", name: "Hughenden" },
    { code: "CA.01.4807008", name: "Amisk" },
    { code: "CA.01.4807011", name: "County of Paintearth No. 18" },
    { code: "CA.01.4807012", name: "Coronation" },
    { code: "CA.01.4807014", name: "Castor" },
    { code: "CA.01.4807016", name: "Halkirk" },
    { code: "CA.01.4807019", name: "County of Stettler No. 6" },
    { code: "CA.01.4807021", name: "Big Valley" },
    { code: "CA.01.4807022", name: "Gadsby" },
    { code: "CA.01.4807024", name: "Botha" },
    { code: "CA.01.4807026", name: "Stettler" },
    { code: "CA.01.4807027", name: "White Sands" },
    { code: "CA.01.4807028", name: "Rochon Sands" },
    { code: "CA.01.4807029", name: "Donalda" },
    { code: "CA.01.4807031", name: "Flagstaff County" },
    { code: "CA.01.4807032", name: "Alliance" },
    { code: "CA.01.4807036", name: "Forestburg" },
    { code: "CA.01.4807038", name: "Heisler" },
    { code: "CA.01.4807039", name: "Daysland" },
    { code: "CA.01.4807042", name: "Killam" },
    { code: "CA.01.4807044", name: "Sedgewick" },
    { code: "CA.01.4807046", name: "Lougheed" },
    { code: "CA.01.4807048", name: "Hardisty" },
    { code: "CA.01.4807049", name: "Municipal District of Wainwright No. 61" },
    { code: "CA.01.4807051", name: "Chauvin" },
    { code: "CA.01.4807052", name: "Edgerton" },
    { code: "CA.01.4807054", name: "Wainwright" },
    { code: "CA.01.4807056", name: "Irma" },
    { code: "CA.01.4808001", name: "Red Deer County" },
    { code: "CA.01.4808002", name: "Elnora" },
    { code: "CA.01.4808004", name: "Delburne" },
    { code: "CA.01.4808005", name: "Jarvis Bay" },
    { code: "CA.01.4808006", name: "Bowden" },
    { code: "CA.01.4808008", name: "Innisfail" },
    { code: "CA.01.4808009", name: "Penhold" },
    { code: "CA.01.4808011", name: "Red Deer" },
    { code: "CA.01.4808012", name: "Sylvan Lake" },
    { code: "CA.01.4808013", name: "Norglenwold" },
    { code: "CA.01.4808022", name: "Lacombe County" },
    { code: "CA.01.4808023", name: "Birchcliff" },
    { code: "CA.01.4808024", name: "Eckville" },
    { code: "CA.01.4808025", name: "Half Moon Bay" },
    { code: "CA.01.4808026", name: "Bentley" },
    { code: "CA.01.4808027", name: "Sunbreaker Cove" },
    { code: "CA.01.4808028", name: "Gull Lake" },
    { code: "CA.01.4808029", name: "Blackfalds" },
    { code: "CA.01.4808031", name: "Lacombe" },
    { code: "CA.01.4808032", name: "Clive" },
    { code: "CA.01.4808034", name: "Alix" },
    { code: "CA.01.4808038", name: "Ponoka County" },
    { code: "CA.01.4808039", name: "Ponoka" },
    { code: "CA.01.4808042", name: "Parkland Beach" },
    { code: "CA.01.4808044", name: "Rimbey" },
    { code: "CA.01.4809002", name: "Clearwater County" },
    { code: "CA.01.4809005", name: "Burnstick Lake" },
    { code: "CA.01.4809010", name: "Caroline" },
    { code: "CA.01.4809015", name: "Rocky Mountain House" },
    { code: "CA.01.4810001", name: "County of Camrose No. 22" },
    { code: "CA.01.4810002", name: "Bashaw" },
    { code: "CA.01.4810003", name: "Rosalind" },
    { code: "CA.01.4810004", name: "Ferintosh" },
    { code: "CA.01.4810006", name: "Edberg" },
    { code: "CA.01.4810009", name: "Bawlf" },
    { code: "CA.01.4810011", name: "Camrose" },
    { code: "CA.01.4810012", name: "Bittern Lake" },
    { code: "CA.01.4810014", name: "Hay Lakes" },
    { code: "CA.01.4810016", name: "Beaver County" },
    { code: "CA.01.4810018", name: "Tofield" },
    { code: "CA.01.4810019", name: "Ryley" },
    { code: "CA.01.4810021", name: "Holden" },
    { code: "CA.01.4810022", name: "Viking" },
    { code: "CA.01.4810026", name: "County of Minburn No. 27" },
    { code: "CA.01.4810028", name: "Vegreville" },
    { code: "CA.01.4810031", name: "Innisfree" },
    { code: "CA.01.4810034", name: "Mannville" },
    { code: "CA.01.4810036", name: "County of Vermilion River No. 24" },
    { code: "CA.01.4810038", name: "Paradise Valley" },
    { code: "CA.01.4810039", name: "Lloydminster" },
    { code: "CA.01.4810041", name: "Kitscoty" },
    { code: "CA.01.4810042", name: "Vermilion" },
    { code: "CA.01.4810044", name: "Marwayne" },
    { code: "CA.01.4810046", name: "Dewberry" },
    { code: "CA.01.4810048", name: "County of Two Hills No. 21" },
    { code: "CA.01.4810051", name: "Myrnam" },
    { code: "CA.01.4810052", name: "Two Hills" },
    { code: "CA.01.4810056", name: "Willingdon" },
    { code: "CA.01.4810058", name: "Lamont County" },
    { code: "CA.01.4810059", name: "Andrew" },
    { code: "CA.01.4810061", name: "Mundare" },
    { code: "CA.01.4810062", name: "Chipman" },
    { code: "CA.01.4810064", name: "Lamont" },
    { code: "CA.01.4810066", name: "Bruderheim" },
    { code: "CA.01.4810068", name: "Improvement District No. 13" },
    { code: "CA.01.4811001", name: "County of Wetaskiwin No. 10" },
    { code: "CA.01.4811002", name: "Wetaskiwin" },
    { code: "CA.01.4811003", name: "Argentia Beach" },
    { code: "CA.01.4811004", name: "Grandview" },
    { code: "CA.01.4811005", name: "Poplar Bay" },
    { code: "CA.01.4811006", name: "Crystal Springs" },
    { code: "CA.01.4811007", name: "Norris Beach" },
    { code: "CA.01.4811008", name: "Ma-Me-O Beach" },
    { code: "CA.01.4811009", name: "Silver Beach" },
    { code: "CA.01.4811011", name: "Millet" },
    { code: "CA.01.4811012", name: "Leduc County" },
    { code: "CA.01.4811013", name: "Beaumont" },
    { code: "CA.01.4811016", name: "Leduc" },
    { code: "CA.01.4811018", name: "Devon" },
    { code: "CA.01.4811019", name: "Calmar" },
    { code: "CA.01.4811020", name: "Sundance Beach" },
    { code: "CA.01.4811021", name: "Thorsby" },
    { code: "CA.01.4811022", name: "Itaska Beach" },
    { code: "CA.01.4811023", name: "Golden Days" },
    { code: "CA.01.4811024", name: "Warburg" },
    { code: "CA.01.4811026", name: "Breton" },
    { code: "CA.01.4811031", name: "Drayton Valley" },
    { code: "CA.01.4811032", name: "Brazeau County" },
    { code: "CA.01.4811034", name: "Parkland County" },
    { code: "CA.01.4811038", name: "Seba Beach" },
    { code: "CA.01.4811039", name: "Betula Beach" },
    { code: "CA.01.4811041", name: "Point Alison" },
    { code: "CA.01.4811042", name: "Lakeview" },
    { code: "CA.01.4811044", name: "Kapasiwin" },
    { code: "CA.01.4811045", name: "Wabamun" },
    { code: "CA.01.4811046", name: "Spring Lake" },
    { code: "CA.01.4811048", name: "Stony Plain" },
    { code: "CA.01.4811049", name: "Spruce Grove" },
    { code: "CA.01.4811052", name: "Strathcona County" },
    { code: "CA.01.4811056", name: "Fort Saskatchewan" },
    { code: "CA.01.4811059", name: "Sturgeon County" },
    { code: "CA.01.4811061", name: "Edmonton" },
    { code: "CA.01.4811062", name: "St. Albert" },
    { code: "CA.01.4811064", name: "Gibbons" },
    { code: "CA.01.4811065", name: "Redwater" },
    { code: "CA.01.4811066", name: "Bon Accord" },
    { code: "CA.01.4811068", name: "Morinville" },
    { code: "CA.01.4811069", name: "Legal" },
    { code: "CA.01.4812002", name: "Cold Lake" },
    { code: "CA.01.4812004", name: "Municipal District of Bonnyville No. 87" },
    { code: "CA.01.4812009", name: "Bonnyville" },
    { code: "CA.01.4812011", name: "Bonnyville Beach" },
    { code: "CA.01.4812012", name: "Glendon" },
    { code: "CA.01.4812013", name: "Pelican Narrows" },
    { code: "CA.01.4812014", name: "County of St. Paul No. 19" },
    { code: "CA.01.4812016", name: "Elk Point" },
    { code: "CA.01.4812018", name: "St. Paul" },
    { code: "CA.01.4812020", name: "Horseshoe Bay" },
    { code: "CA.01.4812022", name: "Smoky Lake County" },
    { code: "CA.01.4812024", name: "Vilna" },
    { code: "CA.01.4812026", name: "Waskatenau" },
    { code: "CA.01.4812029", name: "Smoky Lake" },
    { code: "CA.01.4812037", name: "Lac la Biche County" },
    { code: "CA.01.4812038", name: "Improvement District No. 349" },
    { code: "CA.01.4813001", name: "Lac Ste. Anne County" },
    { code: "CA.01.4813002", name: "Mayerthorpe" },
    { code: "CA.01.4813003", name: "Nakamun Park" },
    { code: "CA.01.4813005", name: "Val Quentin" },
    { code: "CA.01.4813006", name: "West Cove" },
    { code: "CA.01.4813007", name: "Yellowstone" },
    { code: "CA.01.4813008", name: "Ross Haven" },
    { code: "CA.01.4813009", name: "Castle Island" },
    { code: "CA.01.4813010", name: "Silver Sands" },
    { code: "CA.01.4813011", name: "Sunset Point" },
    { code: "CA.01.4813012", name: "Alberta Beach" },
    { code: "CA.01.4813013", name: "Birch Cove" },
    { code: "CA.01.4813014", name: "Onoway" },
    { code: "CA.01.4813015", name: "South View" },
    { code: "CA.01.4813016", name: "Sandy Beach" },
    { code: "CA.01.4813017", name: "Sunrise Beach" },
    { code: "CA.01.4813018", name: "County of Barrhead No. 11" },
    { code: "CA.01.4813019", name: "Barrhead" },
    { code: "CA.01.4813028", name: "Municipal District of Westlock No. 92" },
    { code: "CA.01.4813029", name: "Woodlands County" },
    { code: "CA.01.4813030", name: "Whitecourt" },
    { code: "CA.01.4813031", name: "Westlock" },
    { code: "CA.01.4813032", name: "Clyde" },
    { code: "CA.01.4813033", name: "Larkspur" },
    { code: "CA.01.4813036", name: "County of Thorhild No. 7" },
    { code: "CA.01.4813044", name: "County of Athabasca No. 12" },
    { code: "CA.01.4813045", name: "Mewatha Beach" },
    { code: "CA.01.4813046", name: "Boyle" },
    { code: "CA.01.4813047", name: "Sunset Beach" },
    { code: "CA.01.4813048", name: "Athabasca" },
    { code: "CA.01.4813049", name: "Island Lake" },
    { code: "CA.01.4813051", name: "Island Lake South" },
    { code: "CA.01.4813053", name: "Bondiss" },
    { code: "CA.01.4813055", name: "South Baptiste" },
    { code: "CA.01.4813057", name: "West Baptiste" },
    { code: "CA.01.4813061", name: "Whispering Hills" },
    { code: "CA.01.4814003", name: "Yellowhead County" },
    { code: "CA.01.4814019", name: "Hinton" },
    { code: "CA.01.4814024", name: "Edson" },
    { code: "CA.01.4814028", name: "Improvement District No. 25" },
    { code: "CA.01.4815007", name: "Crowsnest Pass" },
    { code: "CA.01.4815013", name: "Kananaskis Improvement District" },
    { code: "CA.01.4815015", name: "Municipal District of Bighorn No. 8" },
    { code: "CA.01.4815023", name: "Canmore" },
    { code: "CA.01.4815027", name: "Ghost Lake" },
    { code: "CA.01.4815030", name: "Waiparous" },
    { code: "CA.01.4815032", name: "Improvement District No. 9" },
    { code: "CA.01.4815033", name: "Jasper" },
    { code: "CA.01.4815035", name: "Banff" },
    { code: "CA.01.4815037", name: "Improvement District No. 12" },
    { code: "CA.01.4815045", name: "Municipal District of Ranchland No. 66" },
    { code: "CA.01.4816037", name: "Wood Buffalo" },
    { code: "CA.01.4816051", name: "Improvement District No. 24" },
    { code: "CA.01.4817021", name: "High Prairie" },
    { code: "CA.01.4817024", name: "Swan Hills" },
    { code: "CA.01.4817026", name: "Northern Sunrise County" },
    { code: "CA.01.4817027", name: "Municipal District of Big Lakes No. 125" },
    { code: "CA.01.4817029", name: "Slave Lake" },
    { code: "CA.01.4817031", name: "Municipal District of Opportunity No. 17" },
    { code: "CA.01.4817033", name: "Municipal District of Lesser Slave River No. 124" },
    { code: "CA.01.4817039", name: "Nampa" },
    { code: "CA.01.4817062", name: "Municipal District of Clear Hills No. 21" },
    { code: "CA.01.4817064", name: "Hines Creek" },
    { code: "CA.01.4817076", name: "Municipal District of Northern Lights No. 22" },
    { code: "CA.01.4817078", name: "Manning" },
    { code: "CA.01.4817093", name: "High Level" },
    { code: "CA.01.4817095", name: "Mackenzie County" },
    { code: "CA.01.4817097", name: "Rainbow Lake" },
    { code: "CA.01.4818002", name: "Fox Creek" },
    { code: "CA.01.4818005", name: "Grande Cache" },
    { code: "CA.01.4818015", name: "Municipal District of Greenview No. 16" },
    { code: "CA.01.4818018", name: "Valleyview" },
    { code: "CA.01.4819006", name: "County of Grande Prairie No. 1" },
    { code: "CA.01.4819008", name: "Hythe" },
    { code: "CA.01.4819009", name: "Beaverlodge" },
    { code: "CA.01.4819011", name: "Wembley" },
    { code: "CA.01.4819012", name: "Grande Prairie" },
    { code: "CA.01.4819014", name: "Sexsmith" },
    { code: "CA.01.4819038", name: "Peace River" },
    { code: "CA.01.4819041", name: "Municipal District of Smoky River No. 130" },
    { code: "CA.01.4819042", name: "McLennan" },
    { code: "CA.01.4819044", name: "Donnelly" },
    { code: "CA.01.4819046", name: "Falher" },
    { code: "CA.01.4819048", name: "Girouxville" },
    { code: "CA.01.4819049", name: "Birch Hills County" },
    { code: "CA.01.4819054", name: "Municipal District of Spirit River No. 133" },
    { code: "CA.01.4819056", name: "Rycroft" },
    { code: "CA.01.4819058", name: "Spirit River" },
    { code: "CA.01.4819059", name: "Saddle Hills County" },
    { code: "CA.01.4819066", name: "Municipal District of Fairview No. 136" },
    { code: "CA.01.4819068", name: "Fairview" },
    { code: "CA.01.4819071", name: "Municipal District of Peace No. 135" },
    { code: "CA.01.4819072", name: "Berwyn" },
    { code: "CA.01.4819074", name: "Grimshaw" },
  ],
  "CA.02": [
    { code: "CA.02.5901", name: "Regional District of East Kootenay" },
    { code: "CA.02.5903", name: "Regional District of Central Kootenay" },
    { code: "CA.02.5905", name: "Regional District of Kootenay-Boundary" },
    { code: "CA.02.5907", name: "Regional District of Okanagan-Similkameen" },
    { code: "CA.02.5909", name: "Fraser Valley Regional District" },
    { code: "CA.02.5915", name: "Metro Vancouver Regional District" },
    { code: "CA.02.5917", name: "Capital Regional District" },
    { code: "CA.02.5919", name: "Cowichan Valley Regional District" },
    { code: "CA.02.5921", name: "Regional District of Nanaimo" },
    { code: "CA.02.5923", name: "Regional District of Alberni-Clayoquot" },
    { code: "CA.02.5924", name: "Strathcona Regional District" },
    { code: "CA.02.5926", name: "Comox Valley Regional District" },
    { code: "CA.02.5927", name: "Powell River Regional District" },
    { code: "CA.02.5929", name: "Sunshine Coast Regional District" },
    { code: "CA.02.5931", name: "Squamish-Lillooet Regional District" },
    { code: "CA.02.5933", name: "Thompson-Nicola Regional District" },
    { code: "CA.02.5935", name: "Regional District of Central Okanagan" },
    { code: "CA.02.5937", name: "Regional District of North Okanagan" },
    { code: "CA.02.5939", name: "Columbia-Shuswap Regional District" },
    { code: "CA.02.5941", name: "Cariboo Regional District" },
    { code: "CA.02.5943", name: "Regional District of Mount Waddington" },
    { code: "CA.02.5945", name: "Central Coast Regional District" },
    { code: "CA.02.5947", name: "Skeena-Queen Charlotte Regional District" },
    { code: "CA.02.5949", name: "Regional District of Kitimat-Stikine" },
    { code: "CA.02.5951", name: "Regional District of Bulkley-Nechako" },
    { code: "CA.02.5953", name: "Regional District of Fraser-Fort George" },
    { code: "CA.02.5955", name: "Peace River Regional District" },
    { code: "CA.02.5957", name: "Stikine Region" },
    { code: "CA.02.5959", name: "Northern Rockies Regional Municipality" },
  ],
  "CA.03": [
    { code: "CA.03.11153049", name: "Yellowhead" },
    { code: "CA.03.12088765", name: "Ellice-Archie" },
    { code: "CA.03.12088766", name: "Wallace-Woodworth" },
    { code: "CA.03.12088767", name: "Lakeshore" },
    { code: "CA.03.12088768", name: "Prairie Lakes" },
    { code: "CA.03.12088769", name: "Oakview" },
    { code: "CA.03.12088770", name: "Riding Mountain West" },
    { code: "CA.03.5883398", name: "Alexander" },
    { code: "CA.03.5884145", name: "Alonsa" },
    { code: "CA.03.5886869", name: "Argyle" },
    { code: "CA.03.5887047", name: "Armstrong" },
    { code: "CA.03.5909350", name: "Brokenhead" },
    { code: "CA.03.5917773", name: "Cartier" },
    { code: "CA.03.5925083", name: "Coldwell" },
    { code: "CA.03.5928075", name: "Cornwallis" },
    { code: "CA.03.5935342", name: "Dauphin" },
    { code: "CA.03.5938127", name: "De Salaberry" },
    { code: "CA.03.5943543", name: "Dufferin" },
    { code: "CA.03.5946153", name: "East St. Paul" },
    { code: "CA.03.5948173", name: "Elton" },
    { code: "CA.03.5950217", name: "Ethelbert" },
    { code: "CA.03.5953379", name: "Fisher" },
    { code: "CA.03.5961067", name: "Gilbert Plains" },
    { code: "CA.03.5961416", name: "Gimli" },
    { code: "CA.03.5964094", name: "Grahamdale" },
    { code: "CA.03.5964715", name: "Grandview" },
    { code: "CA.03.5966926", name: "Grey" },
    { code: "CA.03.5969882", name: "Hamiota" },
    { code: "CA.03.5970302", name: "Hanover" },
    { code: "CA.03.5972962", name: "Headingley" },
    { code: "CA.03.5990627", name: "Kelsey" },
    { code: "CA.03.5994865", name: "La Broquerie" },
    { code: "CA.03.6014442", name: "Lac du Bonnet" },
    { code: "CA.03.6060360", name: "Lorne" },
    { code: "CA.03.6060804", name: "Louise" },
    { code: "CA.03.6062676", name: "Macdonald" },
    { code: "CA.03.6069089", name: "McCreary" },
    { code: "CA.03.6076808", name: "Montcalm" },
    { code: "CA.03.6078726", name: "Morris" },
    { code: "CA.03.6079284", name: "Mossey River" },
    { code: "CA.03.6090358", name: "North Norfolk" },
    { code: "CA.03.6100811", name: "Pembina" },
    { code: "CA.03.6105291", name: "Piney" },
    { code: "CA.03.6105529", name: "Pipestone" },
    { code: "CA.03.6111530", name: "Portage la Prairie" },
    { code: "CA.03.6121677", name: "Reynolds" },
    { code: "CA.03.6121732", name: "Rhineland" },
    { code: "CA.03.6122576", name: "Ritchot" },
    { code: "CA.03.6125861", name: "Cartwright–Roblin" },
    { code: "CA.03.6126541", name: "Rockwood" },
    { code: "CA.03.6127181", name: "Roland" },
    { code: "CA.03.6127585", name: "Rosedale" },
    { code: "CA.03.6127818", name: "Rossburn" },
    { code: "CA.03.6127874", name: "Rosser" },
    { code: "CA.03.6147482", name: "Sifton" },
    { code: "CA.03.6154185", name: "Springfield" },
    { code: "CA.03.6155131", name: "St. Andrews" },
    { code: "CA.03.6155186", name: "Stanley" },
    { code: "CA.03.6155764", name: "St. Clements" },
    { code: "CA.03.6155865", name: "Ste. Anne" },
    { code: "CA.03.6156288", name: "Ste. Rose" },
    { code: "CA.03.6156605", name: "St. François Xavier" },
    { code: "CA.03.6156971", name: "St. Laurent" },
    { code: "CA.03.6158376", name: "Stuartburn" },
    { code: "CA.03.6160992", name: "Taché" },
    { code: "CA.03.6165405", name: "Thompson" },
    { code: "CA.03.6170648", name: "Killarney-Turtle Mountain" },
    { code: "CA.03.6174040", name: "Victoria" },
    { code: "CA.03.6174050", name: "Victoria Beach" },
    { code: "CA.03.6179507", name: "West St. Paul" },
    { code: "CA.03.6180469", name: "Whitehead" },
    { code: "CA.03.6180732", name: "Whitemouth" },
    { code: "CA.03.6184198", name: "Woodlands" },
  ],
  "CA.04": [
    { code: "CA.04.1301", name: "Saint John County" },
    { code: "CA.04.1302", name: "Charlotte County" },
    { code: "CA.04.1303", name: "Sunbury County" },
    { code: "CA.04.1304", name: "Queens County" },
    { code: "CA.04.1305", name: "Kings County" },
    { code: "CA.04.1306", name: "Albert County" },
    { code: "CA.04.1307", name: "Westmorland County" },
    { code: "CA.04.1308", name: "Kent County" },
    { code: "CA.04.1309", name: "Northumberland County" },
    { code: "CA.04.1310", name: "York County" },
    { code: "CA.04.1311", name: "Carleton County" },
    { code: "CA.04.1312", name: "Victoria County" },
    { code: "CA.04.1313", name: "Madawaska County" },
    { code: "CA.04.1314", name: "Restigouche" },
    { code: "CA.04.1315", name: "Gloucester County" },
  ],
  "CA.07": [
    { code: "CA.07.1201", name: "Shelburne County" },
    { code: "CA.07.1202", name: "Yarmouth County" },
    { code: "CA.07.1203", name: "Digby County" },
    { code: "CA.07.1204", name: "Queens County" },
    { code: "CA.07.1205", name: "Annapolis County" },
    { code: "CA.07.1206", name: "Lunenburg County" },
    { code: "CA.07.1207", name: "Kings County" },
    { code: "CA.07.1208", name: "Hants" },
    { code: "CA.07.1209", name: "Halifax Regional Municipality" },
    { code: "CA.07.1210", name: "Colchester" },
    { code: "CA.07.1211", name: "Cumberland County" },
    { code: "CA.07.1212", name: "Pictou County" },
    { code: "CA.07.1213", name: "Guysborough County" },
    { code: "CA.07.1214", name: "Antigonish County" },
    { code: "CA.07.1215", name: "Inverness County" },
    { code: "CA.07.1216", name: "Richmond County" },
    { code: "CA.07.1217", name: "Cape Breton County" },
    { code: "CA.07.1218", name: "Victoria County" },
  ],
  "CA.08": [
    { code: "CA.08.3501", name: "United Counties of Stormont, Dundas and Glengarry" },
    { code: "CA.08.3502", name: "Comtés unis de Prescott et Russell" },
    { code: "CA.08.3506", name: "Ottawa" },
    { code: "CA.08.3507", name: "United Counties of Leeds and Grenville" },
    { code: "CA.08.3509", name: "Lanark County" },
    { code: "CA.08.3510", name: "Frontenac County" },
    { code: "CA.08.3511", name: "Lennox and Addington County" },
    { code: "CA.08.3512", name: "Hastings County" },
    { code: "CA.08.3513", name: "Prince Edward County" },
    { code: "CA.08.3514", name: "Northumberland County" },
    { code: "CA.08.3515", name: "Peterborough County" },
    { code: "CA.08.3516", name: "Kawartha Lakes" },
    { code: "CA.08.3518", name: "Durham" },
    { code: "CA.08.3519", name: "York" },
    { code: "CA.08.3520", name: "Toronto county" },
    { code: "CA.08.3521", name: "Peel" },
    { code: "CA.08.3522", name: "Dufferin County" },
    { code: "CA.08.3523", name: "Wellington County" },
    { code: "CA.08.3524", name: "Halton" },
    { code: "CA.08.3525", name: "Hamilton" },
    { code: "CA.08.3526", name: "Regional Municipality of Niagara" },
    { code: "CA.08.3528", name: "Haldimand County" },
    { code: "CA.08.3529", name: "Brant" },
    { code: "CA.08.3530", name: "Regional Municipality of Waterloo" },
    { code: "CA.08.3531", name: "Perth County" },
    { code: "CA.08.3532", name: "Oxford County" },
    { code: "CA.08.3534", name: "Elgin County" },
    { code: "CA.08.3536", name: "Chatham-Kent" },
    { code: "CA.08.3537", name: "Essex County" },
    { code: "CA.08.3538", name: "Lambton County" },
    { code: "CA.08.3539", name: "Middlesex County" },
    { code: "CA.08.3540", name: "Huron County" },
    { code: "CA.08.3541", name: "Bruce County" },
    { code: "CA.08.3542", name: "Grey County" },
    { code: "CA.08.3543", name: "Simcoe County" },
    { code: "CA.08.3544", name: "District Municipality of Muskoka" },
    { code: "CA.08.3546", name: "Haliburton County" },
    { code: "CA.08.3547", name: "Renfrew County" },
    { code: "CA.08.3548", name: "Nipissing District" },
    { code: "CA.08.3549", name: "Parry Sound District" },
    { code: "CA.08.3551", name: "Manitoulin District" },
    { code: "CA.08.3552", name: "Sudbury" },
    { code: "CA.08.3553", name: "Sudbury" },
    { code: "CA.08.3554", name: "Timiskaming District" },
    { code: "CA.08.3556", name: "Cochrane District" },
    { code: "CA.08.3557", name: "Algoma" },
    { code: "CA.08.3558", name: "Thunder Bay District" },
    { code: "CA.08.3559", name: "Rainy River District" },
    { code: "CA.08.3560", name: "Kenora District" },
  ],
  "CA.09": [
    { code: "CA.09.1101", name: "Kings County" },
    { code: "CA.09.1102", name: "Queens County" },
    { code: "CA.09.1103", name: "Prince County" },
  ],
  "CA.10": [
    { code: "CA.10.01", name: "Bas-Saint-Laurent" },
    { code: "CA.10.02", name: "Saguenay/Lac-Saint-Jean" },
    { code: "CA.10.03", name: "Capitale-Nationale" },
    { code: "CA.10.04", name: "Mauricie" },
    { code: "CA.10.05", name: "Estrie" },
    { code: "CA.10.06", name: "Montréal" },
    { code: "CA.10.07", name: "Outaouais" },
    { code: "CA.10.08", name: "Abitibi-Témiscamingue" },
    { code: "CA.10.09", name: "Côte-Nord" },
    { code: "CA.10.10", name: "Nord-du-Québec" },
    { code: "CA.10.11", name: "Gaspésie-Îles-de-la-Madeleine" },
    { code: "CA.10.12", name: "Chaudière-Appalaches" },
    { code: "CA.10.13", name: "Laval" },
    { code: "CA.10.14", name: "Lanaudière" },
    { code: "CA.10.15", name: "Laurentides" },
    { code: "CA.10.16", name: "Montérégie" },
    { code: "CA.10.17", name: "Centre-du-Québec" },
  ],
  "CA.13": [
    { code: "CA.13.11995136", name: "Inuvik Region" },
    { code: "CA.13.11995137", name: "North Slave Region" },
    { code: "CA.13.11995138", name: "Sahtu Region" },
    { code: "CA.13.11995139", name: "South Slave Region" },
    { code: "CA.13.11995140", name: "Dehcho Region" },
  ],
  "CD.01": [
    { code: "CD.01.7731962", name: "Plateaux" },
  ],
  "CD.02": [
    { code: "CD.02.10376945", name: "Tshuapa District" },
    { code: "CD.02.10402604", name: "Nord-Ubangi District" },
    { code: "CD.02.14", name: "Equateur" },
    { code: "CD.02.2310762", name: "Ville de Zongo" },
    { code: "CD.02.2312894", name: "Ville de Mbandaka" },
    { code: "CD.02.32", name: "Nord Ubangi" },
    { code: "CD.02.36", name: "Sud Ubangi" },
    { code: "CD.02.9212657", name: "Akula" },
  ],
  "CD.03": [
    { code: "CD.03.8335010", name: "Kananga City" },
    { code: "CD.03.9179202", name: "Mutumba District" },
  ],
  "CD.04": [
    { code: "CD.04.19", name: "Kabinda" },
    { code: "CD.04.209226", name: "Mbuji-Mayi City" },
    { code: "CD.04.38", name: "Tshilenge District" },
  ],
  "CD.05": [
    { code: "CD.05.23", name: "Kolwezi" },
    { code: "CD.05.9165800", name: "Lubumbashi (city)" },
    { code: "CD.05.9179186", name: "Kalemie Ville" },
    { code: "CD.05.9179188", name: "Kipushi Ville" },
    { code: "CD.05.9179189", name: "Kongolo Ville" },
    { code: "CD.05.9179191", name: "Kambove Ville" },
    { code: "CD.05.9179195", name: "Likasi" },
    { code: "CD.05.9179199", name: "Mutumba District" },
    { code: "CD.05.9179562", name: "Kasaji" },
    { code: "CD.05.9179907", name: "Manono" },
    { code: "CD.05.923173", name: "Sous-Région du Haut-Shaba" },
  ],
  "CD.06": [
    { code: "CD.06.10400552", name: "Funa" },
    { code: "CD.06.10861174", name: "Mont Amba District" },
    { code: "CD.06.21", name: "Kinshasa Urban" },
    { code: "CD.06.22", name: "Kinshasa rural" },
    { code: "CD.06.9166122", name: "Lukunga District" },
    { code: "CD.06.9166123", name: "Tshangu District" },
    { code: "CD.06.9179198", name: "Makala District" },
  ],
  "CD.08": [
    { code: "CD.08.10", name: "Bas Fleuve District" },
    { code: "CD.08.12", name: "Boma (city)" },
    { code: "CD.08.13", name: "Cataractes District" },
    { code: "CD.08.2316119", name: "Sous-Région des Catarates" },
    { code: "CD.08.2316701", name: "Ville de Boma" },
    { code: "CD.08.2317281", name: "Sous-Région du Bas-Fleuve" },
    { code: "CD.08.27", name: "Lukaya" },
    { code: "CD.08.7731981", name: "Matadi (city)" },
  ],
  "CD.09": [
    { code: "CD.09.7910143", name: "Tumba" },
  ],
  "CD.10": [
    { code: "CD.10.30", name: "Maniema" },
    { code: "CD.10.9179465", name: "Maniema" },
  ],
  "CD.11": [
    { code: "CD.11.211067", name: "Lubero" },
    { code: "CD.11.216279", name: "Goma" },
    { code: "CD.11.219056", name: "Beni" },
    { code: "CD.11.33", name: "North Kivu" },
    { code: "CD.11.8260598", name: "Nyirangongo" },
    { code: "CD.11.8260604", name: "Butembo" },
    { code: "CD.11.8260605", name: "Oicha" },
    { code: "CD.11.9179534", name: "Masisi Territory" },
    { code: "CD.11.9179537", name: "Rutshuru Territory" },
  ],
  "CD.12": [
    { code: "CD.12.35", name: "South Kivu" },
    { code: "CD.12.9179197", name: "Bukavu" },
    { code: "CD.12.9179463", name: "Kalehe" },
    { code: "CD.12.9179476", name: "Mwenga" },
    { code: "CD.12.9179483", name: "Fizi" },
    { code: "CD.12.9179531", name: "Kabare" },
  ],
  "CD.13": [
    { code: "CD.13.220287", name: "Ango" },
  ],
  "CD.14": [
    { code: "CD.14.16", name: "Haut Katanga" },
  ],
  "CD.15": [
    { code: "CD.15.15", name: "Haut Lomami" },
  ],
  "CD.18": [
    { code: "CD.18.8335011", name: "Tshikapa City" },
  ],
  "CD.20": [
    { code: "CD.20.2317497", name: "Bagata" },
  ],
  "CD.22": [
    { code: "CD.22.922772", name: "Kolwezi City" },
  ],
  "CD.23": [
    { code: "CD.23.9179898", name: "Ville de Kananga" },
  ],
  "CD.30": [
    { code: "CD.30.212726", name: "Ville de Kisangani" },
  ],
  "CF.01": [
    { code: "CF.01.9143459", name: "Bamingui" },
    { code: "CF.01.9143460", name: "Ndélé" },
  ],
  "CF.02": [
    { code: "CF.02.7731890", name: "Kembe" },
    { code: "CF.02.7731891", name: "Mobaye" },
    { code: "CF.02.7731892", name: "Zangba" },
    { code: "CF.02.7732066", name: "Alindao" },
    { code: "CF.02.7732076", name: "Mingala" },
  ],
  "CF.03": [
    { code: "CF.03.9143465", name: "Bria" },
    { code: "CF.03.9143466", name: "Ouadda" },
    { code: "CF.03.9143475", name: "Yalinga" },
  ],
  "CF.04": [
    { code: "CF.04.2387494", name: "Sous-Préfecture de Carnot" },
    { code: "CF.04.7732685", name: "Berberati" },
    { code: "CF.04.7732916", name: "Gamboula" },
    { code: "CF.04.7732917", name: "Gadzi" },
    { code: "CF.04.9143476", name: "Amada-Gaza" },
    { code: "CF.04.9143488", name: "Dédé-Mokouba" },
    { code: "CF.04.9143489", name: "Sosso-Nakombo" },
  ],
  "CF.05": [
    { code: "CF.05.9143461", name: "Bambouti" },
    { code: "CF.05.9143462", name: "Djéma" },
    { code: "CF.05.9143463", name: "Obo" },
    { code: "CF.05.9143464", name: "Zémio" },
  ],
  "CF.06": [
    { code: "CF.06.7731894", name: "Ndjoukou" },
    { code: "CF.06.7732483", name: "Sibut" },
    { code: "CF.06.9143484", name: "Dékoa" },
    { code: "CF.06.9143485", name: "Mala" },
  ],
  "CF.07": [
    { code: "CF.07.7731898", name: "Mongoumba" },
    { code: "CF.07.7732068", name: "Mbaiki" },
    { code: "CF.07.9143467", name: "Boda" },
    { code: "CF.07.9143486", name: "Boganangone" },
    { code: "CF.07.9143487", name: "Boganda" },
  ],
  "CF.08": [
    { code: "CF.08.7731888", name: "Ouango" },
    { code: "CF.08.7731889", name: "Gambo" },
    { code: "CF.08.7732064", name: "Bangassou" },
    { code: "CF.08.7732690", name: "Bakouma" },
    { code: "CF.08.9143468", name: "Rafai" },
  ],
  "CF.09": [
    { code: "CF.09.2390511", name: "Baboua Sub-Prefecture" },
    { code: "CF.09.7732085", name: "Bouar Sub-Prefecture" },
    { code: "CF.09.7732103", name: "Baoro Sub-Prefecture" },
    { code: "CF.09.9143482", name: "Abba" },
  ],
  "CF.11": [
    { code: "CF.11.7731893", name: "Kouango" },
    { code: "CF.11.7732062", name: "Bambari" },
    { code: "CF.11.7732067", name: "Ippy" },
    { code: "CF.11.7732377", name: "Grimari" },
    { code: "CF.11.9143471", name: "Bakala" },
  ],
  "CF.12": [
    { code: "CF.12.7732115", name: "Bossangoa" },
    { code: "CF.12.9143472", name: "Batangafo" },
    { code: "CF.12.9143477", name: "Bouca" },
    { code: "CF.12.9143478", name: "Kabo" },
    { code: "CF.12.9143479", name: "Markounda" },
    { code: "CF.12.9143480", name: "Nana-Bakassa" },
    { code: "CF.12.9143481", name: "Nangha Boguila" },
  ],
  "CF.13": [
    { code: "CF.13.8299286", name: "Bozoum Sub-Prefecture" },
    { code: "CF.13.9143483", name: "Bossemtélé" },
    { code: "CF.13.9143491", name: "Bocaranga" },
    { code: "CF.13.9143492", name: "Koui" },
    { code: "CF.13.9143493", name: "Ngaoundaye" },
    { code: "CF.13.9143494", name: "Paoua" },
  ],
  "CF.14": [
    { code: "CF.14.9143458", name: "Birao" },
    { code: "CF.14.9143495", name: "Ouanda-Djallé" },
  ],
  "CF.15": [
    { code: "CF.15.9143469", name: "Kaga-Bandoro" },
    { code: "CF.15.9143470", name: "Mbrès" },
  ],
  "CF.16": [
    { code: "CF.16.7731904", name: "Nola" },
    { code: "CF.16.7731905", name: "Bayanga" },
    { code: "CF.16.9143473", name: "Bambio" },
  ],
  "CF.17": [
    { code: "CF.17.7731895", name: "Damara" },
    { code: "CF.17.7731896", name: "Bimbo Sub-Prefecture" },
    { code: "CF.17.7732372", name: "Yaloke Sub-Prefecture" },
    { code: "CF.17.7732723", name: "Bossembele Sub-Prefecture" },
    { code: "CF.17.8299285", name: "Boali Sub-Prefecture" },
    { code: "CF.17.9143490", name: "Bogangolo" },
  ],
  "CF.18": [
    { code: "CF.18.7731897", name: "Bangui Sub-Prefecture" },
  ],
  "CG.01": [
    { code: "CG.01.11996192", name: "Mfouati" },
    { code: "CG.01.11996207", name: "Boko-Songho" },
    { code: "CG.01.11996223", name: "Tsiaki" },
    { code: "CG.01.11996225", name: "Kingoue" },
    { code: "CG.01.11996227", name: "Yamba" },
    { code: "CG.01.11996229", name: "Mabombo" },
    { code: "CG.01.8051158", name: "Mouyondzi" },
    { code: "CG.01.8051166", name: "Madingou" },
    { code: "CG.01.8051167", name: "Nkayi" },
    { code: "CG.01.8051168", name: "Loudima" },
  ],
  "CG.04": [
    { code: "CG.04.11996203", name: "Nzambi" },
    { code: "CG.04.11996206", name: "Hinda" },
    { code: "CG.04.11996233", name: "Tchiamba-Nzassi" },
    { code: "CG.04.7870561", name: "Madingo-Kayes" },
    { code: "CG.04.7870563", name: "Kakamoeka" },
    { code: "CG.04.7870579", name: "Mvouti" },
  ],
  "CG.05": [
    { code: "CG.05.11996221", name: "Mayeye" },
    { code: "CG.05.7870607", name: "Bambama" },
    { code: "CG.05.7870608", name: "Komono" },
    { code: "CG.05.7870613", name: "Sibiti" },
    { code: "CG.05.7870614", name: "Zanaga" },
  ],
  "CG.06": [
    { code: "CG.06.11996188", name: "Enyelle" },
    { code: "CG.06.11996189", name: "Bouanila" },
    { code: "CG.06.11996209", name: "Epena" },
    { code: "CG.06.11996236", name: "Betou" },
    { code: "CG.06.11996238", name: "Liranga" },
    { code: "CG.06.7731899", name: "Dongou" },
    { code: "CG.06.7731900", name: "Impfondo" },
  ],
  "CG.07": [
    { code: "CG.07.11996200", name: "Mbinda" },
    { code: "CG.07.11996210", name: "Moungoundou-Sud" },
    { code: "CG.07.11996213", name: "Nyanga" },
    { code: "CG.07.11996214", name: "Banba" },
    { code: "CG.07.11996215", name: "Londela-Kayes" },
    { code: "CG.07.11996231", name: "Moutamba" },
    { code: "CG.07.11996232", name: "Moungoundou-Nord" },
    { code: "CG.07.11996234", name: "Yaya" },
    { code: "CG.07.11996235", name: "Makabana" },
    { code: "CG.07.7870640", name: "Divenie" },
    { code: "CG.07.7870641", name: "Kibangou" },
    { code: "CG.07.7870642", name: "Kimongo" },
    { code: "CG.07.7870646", name: "Louvakou" },
    { code: "CG.07.7870650", name: "Mayoko" },
  ],
  "CG.08": [
    { code: "CG.08.11996190", name: "Mbon" },
    { code: "CG.08.11996198", name: "Allembe" },
    { code: "CG.08.11996199", name: "Ngo" },
    { code: "CG.08.11996211", name: "Makotimpoko" },
    { code: "CG.08.11996217", name: "Ollombo" },
    { code: "CG.08.11996218", name: "Ongogni" },
    { code: "CG.08.11996219", name: "Mpouya" },
    { code: "CG.08.7731998", name: "Gamboma" },
    { code: "CG.08.7731999", name: "Djambala" },
    { code: "CG.08.7870660", name: "Abala" },
    { code: "CG.08.7870663", name: "Lekana" },
  ],
  "CG.10": [
    { code: "CG.10.11996194", name: "Pikounda" },
    { code: "CG.10.11996197", name: "Ngbala" },
    { code: "CG.10.11996228", name: "Mokeko" },
    { code: "CG.10.7731851", name: "Souanke" },
    { code: "CG.10.7731852", name: "Sembe" },
    { code: "CG.10.7731853", name: "Ouesso" },
  ],
  "CG.11": [
    { code: "CG.11.11996204", name: "Louingui" },
    { code: "CG.11.11996208", name: "Kimba" },
    { code: "CG.11.11996216", name: "Goma-Tsetse" },
    { code: "CG.11.11996222", name: "Ignie" },
    { code: "CG.11.11996224", name: "Vindza" },
    { code: "CG.11.11996226", name: "Loumo" },
    { code: "CG.11.11996230", name: "Mbandza-Ndounga" },
    { code: "CG.11.2257174", name: "Mindouli" },
    { code: "CG.11.2257531", name: "Mayama" },
    { code: "CG.11.7732000", name: "Ngabe" },
    { code: "CG.11.7732002", name: "Kinkala" },
    { code: "CG.11.7732003", name: "Boko" },
    { code: "CG.11.7873913", name: "Kindamba" },
  ],
  "CG.12": [
    { code: "CG.12.11996220", name: "Brazzaville" },
  ],
  "CG.13": [
    { code: "CG.13.11996202", name: "Oyo" },
    { code: "CG.13.11996205", name: "Ntokou" },
    { code: "CG.13.11996212", name: "Ngoko" },
    { code: "CG.13.11996237", name: "Tchikapika" },
    { code: "CG.13.7731907", name: "Mossaka" },
    { code: "CG.13.7870297", name: "Boundji" },
    { code: "CG.13.7870298", name: "Loukolela" },
    { code: "CG.13.7870306", name: "Makoua" },
    { code: "CG.13.7870312", name: "Owando" },
  ],
  "CG.14": [
    { code: "CG.14.11996191", name: "Kelle" },
    { code: "CG.14.11996193", name: "Mbomo" },
    { code: "CG.14.11996195", name: "Etoumbi" },
    { code: "CG.14.11996196", name: "Mbama" },
    { code: "CG.14.11996201", name: "Ewo" },
    { code: "CG.14.8051157", name: "Okoyo" },
  ],
  "CG.15": [
    { code: "CG.15.8051169", name: "Pointe-Noire" },
  ],
  "CH.AG": [
    { code: "CH.AG.1901", name: "Bezirk Aarau" },
    { code: "CH.AG.1902", name: "Bezirk Baden" },
    { code: "CH.AG.1903", name: "Bezirk Bremgarten" },
    { code: "CH.AG.1904", name: "Bezirk Brugg" },
    { code: "CH.AG.1905", name: "Bezirk Kulm" },
    { code: "CH.AG.1906", name: "Bezirk Laufenburg" },
    { code: "CH.AG.1907", name: "Bezirk Lenzburg" },
    { code: "CH.AG.1908", name: "Bezirk Muri" },
    { code: "CH.AG.1909", name: "Bezirk Rheinfelden" },
    { code: "CH.AG.1910", name: "Bezirk Zofingen" },
    { code: "CH.AG.1911", name: "Bezirk Zurzach" },
  ],
  "CH.AI": [
    { code: "CH.AI.1600", name: "Appenzell Inner Rhodes" },
  ],
  "CH.AR": [
    { code: "CH.AR.1501", name: "Bezirk Hinterland" },
    { code: "CH.AR.1502", name: "Bezirk Mittelland" },
    { code: "CH.AR.1503", name: "Bezirk Vorderland" },
  ],
  "CH.BE": [
    { code: "CH.BE.241", name: "Jura bernois" },
    { code: "CH.BE.242", name: "Biel/Bienne District" },
    { code: "CH.BE.243", name: "Seeland District" },
    { code: "CH.BE.244", name: "Oberaargau" },
    { code: "CH.BE.245", name: "Emmental District" },
    { code: "CH.BE.246", name: "Bern-Mittelland District" },
    { code: "CH.BE.247", name: "Thun District" },
    { code: "CH.BE.248", name: "Obersimmental-Saanen District" },
    { code: "CH.BE.249", name: "Frutigen-Niedersimmental District" },
    { code: "CH.BE.250", name: "Interlaken-Oberhasli District" },
  ],
  "CH.BL": [
    { code: "CH.BL.1301", name: "Bezirk Arlesheim" },
    { code: "CH.BL.1302", name: "Bezirk Laufen" },
    { code: "CH.BL.1303", name: "Bezirk Liestal" },
    { code: "CH.BL.1304", name: "Bezirk Sissach" },
    { code: "CH.BL.1305", name: "Bezirk Waldenburg" },
  ],
  "CH.BS": [
    { code: "CH.BS.1200", name: "Basel-Stadt" },
  ],
  "CH.FR": [
    { code: "CH.FR.1001", name: "Broye District" },
    { code: "CH.FR.1002", name: "Glâne District" },
    { code: "CH.FR.1003", name: "Gruyère District" },
    { code: "CH.FR.1004", name: "Sarine District" },
    { code: "CH.FR.1005", name: "Lake District" },
    { code: "CH.FR.1006", name: "Sense District" },
    { code: "CH.FR.1007", name: "Veveyse District" },
  ],
  "CH.GE": [
    { code: "CH.GE.2500", name: "Geneva" },
  ],
  "CH.GL": [
    { code: "CH.GL.800", name: "Glarus" },
  ],
  "CH.GR": [
    { code: "CH.GR.1841", name: "Region Albula" },
    { code: "CH.GR.1842", name: "Region Bernina" },
    { code: "CH.GR.1843", name: "Region Engiadina Bassa / Val Müstair" },
    { code: "CH.GR.1844", name: "Region Imboden" },
    { code: "CH.GR.1845", name: "Region Landquart" },
    { code: "CH.GR.1846", name: "Region Maloja" },
    { code: "CH.GR.1847", name: "Region Moesa" },
    { code: "CH.GR.1848", name: "Region Plessur" },
    { code: "CH.GR.1849", name: "Region Prättigau / Davos" },
    { code: "CH.GR.1850", name: "Region Surselva" },
    { code: "CH.GR.1851", name: "Region Viamala" },
  ],
  "CH.JU": [
    { code: "CH.JU.2601", name: "Delémont District" },
    { code: "CH.JU.2602", name: "Franches-Montagnes District" },
    { code: "CH.JU.2603", name: "Porrentruy District" },
  ],
  "CH.LU": [
    { code: "CH.LU.311", name: "Lucerne-Stadt District" },
    { code: "CH.LU.312", name: "Lucerne-Land District" },
    { code: "CH.LU.313", name: "Hochdorf District" },
    { code: "CH.LU.314", name: "Sursee District" },
    { code: "CH.LU.315", name: "Willisau District" },
    { code: "CH.LU.316", name: "Entlebuch District" },
  ],
  "CH.NE": [
    { code: "CH.NE.2401", name: "Boudry District" },
    { code: "CH.NE.2402", name: "La Chaux-de-Fonds District" },
    { code: "CH.NE.2403", name: "Le Locle District" },
    { code: "CH.NE.2404", name: "Neuchâtel District" },
    { code: "CH.NE.2405", name: "Val-de-Ruz District" },
    { code: "CH.NE.2406", name: "Val-de-Travers District" },
  ],
  "CH.NW": [
    { code: "CH.NW.700", name: "Nidwalden" },
  ],
  "CH.OW": [
    { code: "CH.OW.600", name: "Obwalden" },
  ],
  "CH.SG": [
    { code: "CH.SG.1721", name: "Wahlkreis St. Gallen" },
    { code: "CH.SG.1722", name: "Wahlkreis Rorschach" },
    { code: "CH.SG.1723", name: "Wahlkreis Rheintal" },
    { code: "CH.SG.1724", name: "Wahlkreis Werdenberg" },
    { code: "CH.SG.1725", name: "Wahlkreis Sarganserland" },
    { code: "CH.SG.1726", name: "Wahlkreis See-Gaster" },
    { code: "CH.SG.1727", name: "Wahlkreis Toggenburg" },
    { code: "CH.SG.1728", name: "Wahlkreis Wil" },
  ],
  "CH.SH": [
    { code: "CH.SH.1401", name: "Bezirk Oberklettgau" },
    { code: "CH.SH.1402", name: "Bezirk Reiat" },
    { code: "CH.SH.1403", name: "Bezirk Schaffhausen" },
    { code: "CH.SH.1404", name: "Bezirk Schleitheim" },
    { code: "CH.SH.1405", name: "Bezirk Stein" },
    { code: "CH.SH.1406", name: "Bezirk Unterklettgau" },
  ],
  "CH.SO": [
    { code: "CH.SO.1101", name: "Bezirk Gäu" },
    { code: "CH.SO.1102", name: "Bezirk Thal" },
    { code: "CH.SO.1103", name: "Bezirk Bucheggberg" },
    { code: "CH.SO.1104", name: "Bezirk Dorneck" },
    { code: "CH.SO.1105", name: "Bezirk Gösgen" },
    { code: "CH.SO.1106", name: "Bezirk Wasseramt" },
    { code: "CH.SO.1107", name: "Bezirk Lebern" },
    { code: "CH.SO.1108", name: "Bezirk Olten" },
    { code: "CH.SO.1109", name: "Bezirk Solothurn" },
    { code: "CH.SO.1110", name: "Bezirk Thierstein" },
  ],
  "CH.SZ": [
    { code: "CH.SZ.501", name: "Bezirk Einsiedeln" },
    { code: "CH.SZ.502", name: "Bezirk Gersau" },
    { code: "CH.SZ.503", name: "Bezirk Höfe" },
    { code: "CH.SZ.504", name: "Bezirk Küssnacht" },
    { code: "CH.SZ.505", name: "Bezirk March" },
    { code: "CH.SZ.506", name: "Bezirk Schwyz" },
  ],
  "CH.TG": [
    { code: "CH.TG.2011", name: "Bezirk Arbon" },
    { code: "CH.TG.2012", name: "Bezirk Frauenfeld" },
    { code: "CH.TG.2013", name: "Bezirk Kreuzlingen" },
    { code: "CH.TG.2014", name: "Bezirk Münchwilen" },
    { code: "CH.TG.2015", name: "Bezirk Weinfelden" },
  ],
  "CH.TI": [
    { code: "CH.TI.2101", name: "Bellinzona District" },
    { code: "CH.TI.2102", name: "Blenio District" },
    { code: "CH.TI.2103", name: "Leventina District" },
    { code: "CH.TI.2104", name: "Locarno District" },
    { code: "CH.TI.2105", name: "Lugano District" },
    { code: "CH.TI.2106", name: "Mendrisio District" },
    { code: "CH.TI.2107", name: "Riviera District" },
    { code: "CH.TI.2108", name: "Vallemaggia District" },
  ],
  "CH.UR": [
    { code: "CH.UR.400", name: "Uri" },
  ],
  "CH.VD": [
    { code: "CH.VD.2221", name: "Aigle District" },
    { code: "CH.VD.2222", name: "Broye-Vully District" },
    { code: "CH.VD.2223", name: "Gros-de-Vaud District" },
    { code: "CH.VD.2224", name: "Jura-Nord vaudois District" },
    { code: "CH.VD.2225", name: "Lausanne District" },
    { code: "CH.VD.2226", name: "Lavaux-Oron District" },
    { code: "CH.VD.2227", name: "Morges District" },
    { code: "CH.VD.2228", name: "Nyon District" },
    { code: "CH.VD.2229", name: "Ouest Lausannois District" },
    { code: "CH.VD.2230", name: "Riviera-Pays-d'Enhaut District" },
  ],
  "CH.VS": [
    { code: "CH.VS.2301", name: "Brig District" },
    { code: "CH.VS.2302", name: "Conthey District" },
    { code: "CH.VS.2303", name: "Entremont District" },
    { code: "CH.VS.2304", name: "Goms District" },
    { code: "CH.VS.2305", name: "Hérens District" },
    { code: "CH.VS.2306", name: "Leuk District" },
    { code: "CH.VS.2307", name: "Martigny District" },
    { code: "CH.VS.2308", name: "Monthey District" },
    { code: "CH.VS.2309", name: "Raron District" },
    { code: "CH.VS.2310", name: "Saint-Maurice District" },
    { code: "CH.VS.2311", name: "Sierre District" },
    { code: "CH.VS.2312", name: "Sion District" },
    { code: "CH.VS.2313", name: "Visp District" },
  ],
  "CH.ZG": [
    { code: "CH.ZG.900", name: "Zug" },
  ],
  "CH.ZH": [
    { code: "CH.ZH.101", name: "Bezirk Affoltern" },
    { code: "CH.ZH.102", name: "Bezirk Andelfingen" },
    { code: "CH.ZH.103", name: "Bezirk Bülach" },
    { code: "CH.ZH.104", name: "Bezirk Dielsdorf" },
    { code: "CH.ZH.105", name: "Bezirk Hinwil" },
    { code: "CH.ZH.106", name: "Bezirk Horgen" },
    { code: "CH.ZH.107", name: "Bezirk Meilen" },
    { code: "CH.ZH.108", name: "Bezirk Pfäffikon" },
    { code: "CH.ZH.109", name: "Bezirk Uster" },
    { code: "CH.ZH.110", name: "Bezirk Winterthur" },
    { code: "CH.ZH.111", name: "Bezirk Dietikon" },
    { code: "CH.ZH.112", name: "Bezirk Zürich" },
  ],
  "CI.76": [
    { code: "CI.76.11153075", name: "Gbôklé" },
    { code: "CI.76.11153076", name: "Nawa" },
    { code: "CI.76.11153077", name: "San-Pédro" },
  ],
  "CI.77": [
    { code: "CI.77.11153080", name: "Folon" },
    { code: "CI.77.11153082", name: "Kabadougou" },
  ],
  "CI.78": [
    { code: "CI.78.11153163", name: "Cavally" },
    { code: "CI.78.11153164", name: "Guémon" },
    { code: "CI.78.11153165", name: "Tonkpi" },
  ],
  "CI.81": [
    { code: "CI.81.11153154", name: "Bélier" },
    { code: "CI.81.11153155", name: "Iffou" },
    { code: "CI.81.11153156", name: "Moronou" },
    { code: "CI.81.11153158", name: "N'Zi" },
  ],
  "CI.82": [
    { code: "CI.82.11153160", name: "Agnéby-Tiassa" },
    { code: "CI.82.11153161", name: "Grands-Ponts" },
    { code: "CI.82.11362033", name: "Région de La Mé" },
  ],
  "CI.87": [
    { code: "CI.87.11153168", name: "Bagoué" },
    { code: "CI.87.11153169", name: "Poro" },
    { code: "CI.87.11153177", name: "Tchologo" },
  ],
  "CI.90": [
    { code: "CI.90.11153170", name: "Gbêkê" },
    { code: "CI.90.11153171", name: "Hambol" },
  ],
  "CI.92": [
    { code: "CI.92.11153175", name: "Bounkani" },
    { code: "CI.92.11153176", name: "Gontougo" },
  ],
  "CI.93": [
    { code: "CI.93.11996449", name: "Abidjan" },
  ],
  "CI.94": [
    { code: "CI.94.11153078", name: "Indénié-Djuablin" },
    { code: "CI.94.11153079", name: "Sud-Comoé" },
  ],
  "CI.95": [
    { code: "CI.95.11153083", name: "Gôh" },
    { code: "CI.95.11153153", name: "Lôh-Djiboua" },
  ],
  "CI.96": [
    { code: "CI.96.11153166", name: "Haut-Sassandra" },
    { code: "CI.96.11153167", name: "Marahoué" },
  ],
  "CI.97": [
    { code: "CI.97.11153172", name: "Béré" },
    { code: "CI.97.11153174", name: "Worodougou" },
    { code: "CI.97.2597334", name: "Bafing" },
  ],
  "CI.98": [
    { code: "CI.98.11153154", name: "Yamoussoukro" },
  ],
  "CK.11695124": [
    { code: "CK.11695124.4035518", name: "Tautu District" },
    { code: "CK.11695124.4036514", name: "Vaitupa District" },
    { code: "CK.11695124.4036515", name: "Anaunga District" },
    { code: "CK.11695124.4036516", name: "Avanui District" },
    { code: "CK.11695124.4036517", name: "Amuri District" },
    { code: "CK.11695124.4036518", name: "Arutanga District" },
    { code: "CK.11695124.4036519", name: "Vaipae District" },
  ],
  "CL.01": [
    { code: "CL.01.51", name: "Provincia de Valparaíso" },
    { code: "CL.01.52", name: "Provincia de Isla de Pascua" },
    { code: "CL.01.53", name: "Provincia de Los Andes" },
    { code: "CL.01.54", name: "Petorca Province" },
    { code: "CL.01.55", name: "Provincia de Quillota" },
    { code: "CL.01.56", name: "San Antonio Province" },
    { code: "CL.01.57", name: "Provincia de San Felipe de Aconcagua" },
    { code: "CL.01.58", name: "Provincia de Marga Marga" },
  ],
  "CL.02": [
    { code: "CL.02.111", name: "Provincia de Coyhaique" },
    { code: "CL.02.112", name: "Provincia de Aisén" },
    { code: "CL.02.113", name: "Provincia Capitán Prat" },
    { code: "CL.02.114", name: "Provincia General Carrera" },
  ],
  "CL.03": [
    { code: "CL.03.21", name: "Provincia de Antofagasta" },
    { code: "CL.03.22", name: "Provincia de El Loa" },
    { code: "CL.03.23", name: "Provincia de Tocopilla" },
  ],
  "CL.04": [
    { code: "CL.04.91", name: "Provincia de Cautín" },
    { code: "CL.04.92", name: "Provincia de Malleco" },
  ],
  "CL.05": [
    { code: "CL.05.31", name: "Provincia de Copiapó" },
    { code: "CL.05.32", name: "Provincia de Chañaral" },
    { code: "CL.05.33", name: "Provincia de Huasco" },
  ],
  "CL.06": [
    { code: "CL.06.81", name: "Provincia de Concepción" },
    { code: "CL.06.82", name: "Provincia de Arauco" },
    { code: "CL.06.83", name: "Provincia de Biobío" },
  ],
  "CL.07": [
    { code: "CL.07.41", name: "Provincia de Elqui" },
    { code: "CL.07.42", name: "Provincia de Choapa" },
    { code: "CL.07.43", name: "Provincia de Limarí" },
  ],
  "CL.08": [
    { code: "CL.08.61", name: "Provincia de Cachapoal" },
    { code: "CL.08.62", name: "Provincia de Cardenal Caro" },
    { code: "CL.08.63", name: "Provincia de Colchagua" },
  ],
  "CL.10": [
    { code: "CL.10.121", name: "Provincia de Magallanes" },
    { code: "CL.10.122", name: "Provincia Antártica Chilena" },
    { code: "CL.10.123", name: "Provincia de Tierra del Fuego" },
    { code: "CL.10.124", name: "Provincia de Última Esperanza" },
  ],
  "CL.11": [
    { code: "CL.11.71", name: "Provincia de Talca" },
    { code: "CL.11.72", name: "Provincia de Cauquenes" },
    { code: "CL.11.73", name: "Provincia de Curicó" },
    { code: "CL.11.74", name: "Provincia de Linares" },
  ],
  "CL.12": [
    { code: "CL.12.131", name: "Provincia de Santiago" },
    { code: "CL.12.132", name: "Provincia de Cordillera" },
    { code: "CL.12.133", name: "Provincia de Chacabuco" },
    { code: "CL.12.134", name: "Provincia de Maipo" },
    { code: "CL.12.135", name: "Provincia de Melipilla" },
    { code: "CL.12.136", name: "Provincia de Talagante" },
  ],
  "CL.14": [
    { code: "CL.14.101", name: "Provincia de Llanquihue" },
    { code: "CL.14.102", name: "Provincia de Chiloé" },
    { code: "CL.14.103", name: "Provincia de Osorno" },
    { code: "CL.14.104", name: "Provincia de Palena" },
  ],
  "CL.15": [
    { code: "CL.15.11", name: "Provincia de Iquique" },
    { code: "CL.15.14", name: "Provincia del Tamarugal" },
  ],
  "CL.16": [
    { code: "CL.16.151", name: "Provincia de Arica" },
    { code: "CL.16.152", name: "Provincia de Parinacota" },
  ],
  "CL.17": [
    { code: "CL.17.141", name: "Provincia de Valdivia" },
    { code: "CL.17.142", name: "Provincia del Ranco" },
  ],
  "CL.18": [
    { code: "CL.18.161", name: "Provincia de Diguillín" },
    { code: "CL.18.162", name: "Provincia de Itata" },
    { code: "CL.18.163", name: "Provincia de Punilla" },
  ],
  "CM.04": [
    { code: "CM.04.2229251", name: "Département du Lom-et-Djérem" },
    { code: "CM.04.2230606", name: "Département de la Kadeï" },
    { code: "CM.04.2230815", name: "Departement du Haut-Nyong" },
    { code: "CM.04.2233500", name: "Département de la Boumba-Ngoko" },
  ],
  "CM.05": [
    { code: "CM.05.2221059", name: "Département du Wouri" },
    { code: "CM.05.2222269", name: "Département de la Sanaga-Maritime" },
    { code: "CM.05.2224165", name: "Département du Nkam" },
    { code: "CM.05.2225744", name: "Département du Mungo" },
  ],
  "CM.07": [
    { code: "CM.07.10289311", name: "Ngo-Ketunjia" },
    { code: "CM.07.2226140", name: "Momo Division" },
    { code: "CM.07.2226830", name: "Mezam Division" },
    { code: "CM.07.2226947", name: "Metchum Division" },
    { code: "CM.07.2232640", name: "Donga and Mantung Division" },
    { code: "CM.07.2233408", name: "Bui Division" },
    { code: "CM.07.9224959", name: "Boyo" },
  ],
  "CM.08": [
    { code: "CM.08.2225334", name: "Département du Ndé" },
    { code: "CM.08.2226712", name: "Département de Mifi" },
    { code: "CM.08.2227064", name: "Département de la Ménoua" },
    { code: "CM.08.2230816", name: "Département du Haut-Nkam" },
    { code: "CM.08.2234988", name: "Département de Bamboutos" },
    { code: "CM.08.9224961", name: "Hauts-Plateaux" },
    { code: "CM.08.9224964", name: "Koung-Khi" },
    { code: "CM.08.9224965", name: "Noun" },
  ],
  "CM.09": [
    { code: "CM.09.2225280", name: "Ndian Division" },
    { code: "CM.09.2227197", name: "Meme Division" },
    { code: "CM.09.2228442", name: "Manyu Division" },
    { code: "CM.09.2231710", name: "Fako Division" },
    { code: "CM.09.8505106", name: "Koupé-Manengouba" },
    { code: "CM.09.9224975", name: "Lebialem" },
  ],
  "CM.10": [
    { code: "CM.10.7670946", name: "Djerem" },
    { code: "CM.10.7670947", name: "Faro-et-Deo" },
    { code: "CM.10.7670948", name: "Vina" },
    { code: "CM.10.8299279", name: "Mbere Department" },
    { code: "CM.10.9224946", name: "Mayo-Banyo" },
  ],
  "CM.11": [
    { code: "CM.11.2223327", name: "Département du Nyong-et-Soo" },
    { code: "CM.11.2223329", name: "Département du Nyong-et-Mfoumou" },
    { code: "CM.11.2223330", name: "Département du Nyong-et-Kéllé" },
    { code: "CM.11.2229546", name: "Département de la Lékié" },
    { code: "CM.11.2230817", name: "Département de la Haute-Sanaga" },
    { code: "CM.11.7730793", name: "Mbam-et-Kim" },
    { code: "CM.11.7731690", name: "Méfou-et-Afamba" },
    { code: "CM.11.8693008", name: "Mfoundi" },
    { code: "CM.11.9165815", name: "Mefou-et-Akono" },
    { code: "CM.11.9224948", name: "Mbam-Et-Inoubou" },
  ],
  "CM.12": [
    { code: "CM.12.2228217", name: "Département du Mayo Danaï" },
    { code: "CM.12.2229291", name: "Département du Logone-et-Chari" },
    { code: "CM.12.2233122", name: "Département du Diamaré" },
    { code: "CM.12.7932539", name: "Departement du Mayo-Kani" },
    { code: "CM.12.9224949", name: "Mayo-Sava" },
    { code: "CM.12.9224951", name: "Mayo-Tsanaga" },
  ],
  "CM.13": [
    { code: "CM.13.2234396", name: "Département de la Bénoué" },
    { code: "CM.13.8740150", name: "Mayo-Rey" },
    { code: "CM.13.8740152", name: "Mayo-Louti" },
    { code: "CM.13.9228189", name: "Faro Department" },
  ],
  "CM.14": [
    { code: "CM.14.2229760", name: "Département de l'Océan" },
    { code: "CM.14.2232969", name: "Département du Dja-et-Lobo" },
    { code: "CM.14.9230015", name: "Mvila" },
    { code: "CM.14.9239012", name: "Vallée-du-Ntem" },
  ],
  "CN.01": [
    { code: "CN.01.3401", name: "Hefei Shi" },
    { code: "CN.01.3402", name: "Wuhu Shi" },
    { code: "CN.01.3403", name: "Bengbu Shi" },
    { code: "CN.01.3404", name: "Huainan Shi" },
    { code: "CN.01.3405", name: "Ma’anshan Shi" },
    { code: "CN.01.3406", name: "Huaibei Shi" },
    { code: "CN.01.3407", name: "Tongling Shi" },
    { code: "CN.01.3408", name: "Anqing Shi" },
    { code: "CN.01.3410", name: "Huangshan Shi" },
    { code: "CN.01.3411", name: "Chuzhou Shi" },
    { code: "CN.01.3412", name: "Fuyang Shi" },
    { code: "CN.01.3413", name: "Suzhou Shi" },
    { code: "CN.01.3415", name: "Lu’an Shi" },
    { code: "CN.01.3416", name: "Bozhou" },
    { code: "CN.01.3417", name: "Chizhou Shi" },
    { code: "CN.01.3418", name: "Xuancheng Shi" },
  ],
  "CN.02": [
    { code: "CN.02.3301", name: "Hangzhou Shi" },
    { code: "CN.02.3302", name: "Ningbo Shi" },
    { code: "CN.02.3303", name: "Wenzhou Shi" },
    { code: "CN.02.3304", name: "Jiaxing Shi" },
    { code: "CN.02.3305", name: "Huzhou Shi" },
    { code: "CN.02.3306", name: "Shaoxing Shi" },
    { code: "CN.02.3307", name: "Jinhua Shi" },
    { code: "CN.02.3308", name: "Quzhou Shi" },
    { code: "CN.02.3309", name: "Zhoushan Shi" },
    { code: "CN.02.3310", name: "Taizhou Shi" },
    { code: "CN.02.3311", name: "Lishui Shi" },
  ],
  "CN.03": [
    { code: "CN.03.3601", name: "Nanchang Shi" },
    { code: "CN.03.3602", name: "Jingdezhen Shi" },
    { code: "CN.03.3603", name: "Pingxiang Shi" },
    { code: "CN.03.3604", name: "Jiujiang Shi" },
    { code: "CN.03.3605", name: "Xinyu" },
    { code: "CN.03.3606", name: "Yingtan Shi" },
    { code: "CN.03.3607", name: "Ganzhou Shi" },
    { code: "CN.03.3608", name: "Ji’an Shi" },
    { code: "CN.03.3609", name: "Yichun Shi" },
    { code: "CN.03.3610", name: "Fuzhou Shi" },
    { code: "CN.03.3611", name: "Shangrao Shi" },
  ],
  "CN.04": [
    { code: "CN.04.3201", name: "Nanjing Shi" },
    { code: "CN.04.3202", name: "Wuxi Shi" },
    { code: "CN.04.3203", name: "Xuzhou" },
    { code: "CN.04.3204", name: "Changzhou Shi" },
    { code: "CN.04.3205", name: "Suzhou Shi" },
    { code: "CN.04.3206", name: "Nantong Shi" },
    { code: "CN.04.3207", name: "Lianyungang Shi" },
    { code: "CN.04.3208", name: "Huai’an Shi" },
    { code: "CN.04.3209", name: "Yancheng Shi" },
    { code: "CN.04.3210", name: "Yangzhou Shi" },
    { code: "CN.04.3211", name: "Zhenjiang Shi" },
    { code: "CN.04.3212", name: "Taizhou Shi" },
    { code: "CN.04.3213", name: "Suqian Shi" },
  ],
  "CN.05": [
    { code: "CN.05.2201", name: "Changchun Shi" },
    { code: "CN.05.2202", name: "Jilin Shi" },
    { code: "CN.05.2203", name: "Siping Shi" },
    { code: "CN.05.2204", name: "Liaoyuan Shi" },
    { code: "CN.05.2205", name: "Tonghua Shi" },
    { code: "CN.05.2206", name: "Baishan Shi" },
    { code: "CN.05.2207", name: "Songyuan Shi" },
    { code: "CN.05.2208", name: "Baicheng Shi" },
    { code: "CN.05.2224", name: "Yanbian Chaoxianzu Zizhizhou" },
  ],
  "CN.06": [
    { code: "CN.06.6301", name: "Xining Shi" },
    { code: "CN.06.6302", name: "Haidong Diqu" },
    { code: "CN.06.6322", name: "Haibei Tibetan Autonomous Prefecture" },
    { code: "CN.06.6323", name: "Huangnan Zangzu Zizhizhou" },
    { code: "CN.06.6325", name: "Hainan Zangzu Zizhizhou" },
    { code: "CN.06.6326", name: "Golog Tibetan Autonomous Prefecture" },
    { code: "CN.06.6327", name: "Yushu Zangzu Zizhizhou" },
    { code: "CN.06.6328", name: "Haixi Mengguzu Zangzu Zizhizhou" },
  ],
  "CN.07": [
    { code: "CN.07.3501", name: "Fuzhou Shi" },
    { code: "CN.07.3502", name: "Xiamen Shi" },
    { code: "CN.07.3503", name: "Putian Shi" },
    { code: "CN.07.3504", name: "Sanming Shi" },
    { code: "CN.07.3505", name: "Quanzhou Shi" },
    { code: "CN.07.3506", name: "Zhangzhou Shi" },
    { code: "CN.07.3507", name: "Nanping Shi" },
    { code: "CN.07.3508", name: "Longyan Shi" },
    { code: "CN.07.3509", name: "Ningde Shi" },
  ],
  "CN.08": [
    { code: "CN.08.2301", name: "Harbin Shi" },
    { code: "CN.08.2302", name: "Qiqihar Shi" },
    { code: "CN.08.2303", name: "Jixi Shi" },
    { code: "CN.08.2304", name: "Hegang Shi" },
    { code: "CN.08.2305", name: "Shuangyashan Shi" },
    { code: "CN.08.2306", name: "Daqing Shi" },
    { code: "CN.08.2307", name: "Yichun Shi" },
    { code: "CN.08.2308", name: "Jiamusi Shi" },
    { code: "CN.08.2309", name: "Qitaihe Shi" },
    { code: "CN.08.2310", name: "Mudanjiang Shi" },
    { code: "CN.08.2311", name: "Heihe Shi" },
    { code: "CN.08.2312", name: "Suihua Shi" },
    { code: "CN.08.2327", name: "Dahingganling Diqu" },
  ],
  "CN.09": [
    { code: "CN.09.4101", name: "Zhengzhou Shi" },
    { code: "CN.09.4102", name: "Kaifeng Shi" },
    { code: "CN.09.4103", name: "Luoyang Shi" },
    { code: "CN.09.4104", name: "Pingdingshan Shi" },
    { code: "CN.09.4105", name: "Anyang Shi" },
    { code: "CN.09.4106", name: "Hebi Shi" },
    { code: "CN.09.4107", name: "Xinxiang Shi" },
    { code: "CN.09.4108", name: "Jiaozuo Shi" },
    { code: "CN.09.4109", name: "Puyang Shi" },
    { code: "CN.09.4110", name: "Xuchang Shi" },
    { code: "CN.09.4111", name: "Luohe Shi" },
    { code: "CN.09.4112", name: "Sanmenxia Shi" },
    { code: "CN.09.4113", name: "Nanyang Shi" },
    { code: "CN.09.4114", name: "Shangqiu Shi" },
    { code: "CN.09.4115", name: "Xinyang Shi" },
    { code: "CN.09.4116", name: "Zhoukou Shi" },
    { code: "CN.09.4117", name: "Zhumadian Shi" },
  ],
  "CN.10": [
    { code: "CN.10.1301", name: "Shijiazhuang Shi" },
    { code: "CN.10.1302", name: "Tangshan Shi" },
    { code: "CN.10.1303", name: "Qinhuangdao Shi" },
    { code: "CN.10.1304", name: "Handan Shi" },
    { code: "CN.10.1305", name: "Xingtai County" },
    { code: "CN.10.1306", name: "Baoding Shi" },
    { code: "CN.10.1307", name: "Zhangjiakou Shi" },
    { code: "CN.10.1308", name: "Chengde Prefecture" },
    { code: "CN.10.1309", name: "Cangzhou Shi" },
    { code: "CN.10.1310", name: "Langfang Shi" },
    { code: "CN.10.1311", name: "Hengshui Shi" },
  ],
  "CN.11": [
    { code: "CN.11.4301", name: "Changsha Shi" },
    { code: "CN.11.4302", name: "Zhuzhou Shi" },
    { code: "CN.11.4303", name: "Xiangtan Shi" },
    { code: "CN.11.4304", name: "Hengyang Shi" },
    { code: "CN.11.4305", name: "Shaoyang County" },
    { code: "CN.11.4306", name: "Yueyang Shi" },
    { code: "CN.11.4307", name: "Changde Shi" },
    { code: "CN.11.4308", name: "Zhangjiajie Shi" },
    { code: "CN.11.4309", name: "Yiyang Shi" },
    { code: "CN.11.4310", name: "Prefecture of Chenzhou" },
    { code: "CN.11.4311", name: "Yongzhou" },
    { code: "CN.11.4312", name: "Huaihua Prefecture" },
    { code: "CN.11.4313", name: "Loudi Shi" },
    { code: "CN.11.4331", name: "Xiangxi Tujiazu Miaozu Zizhizhou" },
  ],
  "CN.12": [
    { code: "CN.12.1795614", name: "Shennongjia" },
    { code: "CN.12.4201", name: "Wuhan Shi" },
    { code: "CN.12.4202", name: "Huangshi Shi" },
    { code: "CN.12.4203", name: "Shiyan Shi" },
    { code: "CN.12.4205", name: "Yichangshi" },
    { code: "CN.12.4206", name: "Xiangyang" },
    { code: "CN.12.4207", name: "Ezhou Shi" },
    { code: "CN.12.4208", name: "Jingmen Shi" },
    { code: "CN.12.4209", name: "Xiaogan" },
    { code: "CN.12.4210", name: "Jingzhou Shi" },
    { code: "CN.12.4211", name: "Huanggang Shi" },
    { code: "CN.12.4212", name: "Xianning Prefecture" },
    { code: "CN.12.4213", name: "Suizhou Shi" },
    { code: "CN.12.4228", name: "Enshi Tujiazu Miaozu Zizhizhou" },
  ],
  "CN.13": [
    { code: "CN.13.6501", name: "Urumqi Shi" },
    { code: "CN.13.6502", name: "Karamay Shi" },
    { code: "CN.13.6504", name: "Turpan Diqu" },
    { code: "CN.13.6505", name: "Kumul Diqu" },
    { code: "CN.13.6523", name: "Changji Huizu Zizhizhou" },
    { code: "CN.13.6527", name: "Bortala Mongol Zizhizhou" },
    { code: "CN.13.6528", name: "Bayingolin Mongol Zizhizhou" },
    { code: "CN.13.6529", name: "Aksu Diqu" },
    { code: "CN.13.6530", name: "Kizilsu Kirgiz Zizhizhou" },
    { code: "CN.13.6531", name: "Kaxgar Diqu" },
    { code: "CN.13.6532", name: "Hotan Diqu" },
    { code: "CN.13.6540", name: "Ili Kazak Zizhizhou" },
    { code: "CN.13.6542", name: "Tacheng Diqu" },
    { code: "CN.13.6543", name: "Altay Diqu" },
    { code: "CN.13.8080762", name: "Tumxuk" },
  ],
  "CN.14": [
    { code: "CN.14.5401", name: "Lhasa Shi" },
    { code: "CN.14.5402", name: "Rikaze Diqu" },
    { code: "CN.14.5403", name: "Qamdo Shi" },
    { code: "CN.14.5404", name: "Nyingchi Prefecture" },
    { code: "CN.14.5405", name: "Shannan Diqu" },
    { code: "CN.14.5406", name: "Nagqu Diqu" },
    { code: "CN.14.5425", name: "Ngari Diqu" },
  ],
  "CN.15": [
    { code: "CN.15.6201", name: "Lanzhou Shi" },
    { code: "CN.15.6202", name: "Jiayuguan Shi" },
    { code: "CN.15.6203", name: "Jinchang Shi" },
    { code: "CN.15.6204", name: "Baiyin Prefecture" },
    { code: "CN.15.6205", name: "Tianshui Shi" },
    { code: "CN.15.6206", name: "Wuwei Shi" },
    { code: "CN.15.6207", name: "Zhangye Shi" },
    { code: "CN.15.6208", name: "Pingliang Shi" },
    { code: "CN.15.6209", name: "Jiuquan Shi" },
    { code: "CN.15.6210", name: "Qingyang Shi" },
    { code: "CN.15.6211", name: "Dingxi Shi" },
    { code: "CN.15.6212", name: "Longnan Shi" },
    { code: "CN.15.6229", name: "Linxia Huizu Zizhizhou" },
    { code: "CN.15.6230", name: "Gannan Zangzu Zizhizhou" },
  ],
  "CN.16": [
    { code: "CN.16.4501", name: "Nanning Shi" },
    { code: "CN.16.4502", name: "Liuzhou Shi" },
    { code: "CN.16.4503", name: "Guilin Shi" },
    { code: "CN.16.4504", name: "Wuzhou Shi" },
    { code: "CN.16.4505", name: "Beihai Shi" },
    { code: "CN.16.4506", name: "Fangchenggang Shi" },
    { code: "CN.16.4507", name: "Qinzhou Shi" },
    { code: "CN.16.4508", name: "Guigang Shi" },
    { code: "CN.16.4509", name: "Yulin Shi" },
    { code: "CN.16.4510", name: "Baise Shi" },
    { code: "CN.16.4511", name: "Hezhou Shi" },
    { code: "CN.16.4512", name: "Hechi Shi" },
    { code: "CN.16.4513", name: "Laibin Shi" },
    { code: "CN.16.4514", name: "Chongzuo Shi" },
  ],
  "CN.18": [
    { code: "CN.18.5201", name: "Guiyang Shi" },
    { code: "CN.18.5202", name: "Lupanshui Shi" },
    { code: "CN.18.5203", name: "Zunyi Shi" },
    { code: "CN.18.5204", name: "Anshun Shi" },
    { code: "CN.18.5205", name: "Bijie Diqu" },
    { code: "CN.18.5206", name: "Tongren Diqu" },
    { code: "CN.18.5223", name: "Qianxinan Buyei and Miao Autonomous Prefecture" },
    { code: "CN.18.5226", name: "Qiandongnan Miao and Dong Autonomous Prefecture" },
    { code: "CN.18.5227", name: "Qiannan Bouyeizu Miaozu Zizhizhou" },
  ],
  "CN.19": [
    { code: "CN.19.2101", name: "Shenyang Shi" },
    { code: "CN.19.2102", name: "Dalian Shi" },
    { code: "CN.19.2103", name: "Anshan Shi" },
    { code: "CN.19.2104", name: "Fushun Shi" },
    { code: "CN.19.2105", name: "Benxi Shi" },
    { code: "CN.19.2106", name: "Dandong Shi" },
    { code: "CN.19.2107", name: "Jinzhou Shi" },
    { code: "CN.19.2108", name: "Yingkou" },
    { code: "CN.19.2109", name: "Fuxin Shi" },
    { code: "CN.19.2110", name: "Liaoyang Shi" },
    { code: "CN.19.2111", name: "Panjin Shi" },
    { code: "CN.19.2112", name: "Tieling Shi" },
    { code: "CN.19.2113", name: "Chaoyang Shi" },
    { code: "CN.19.2114", name: "Huludao Shi" },
  ],
  "CN.20": [
    { code: "CN.20.1501", name: "Hohhot Shi" },
    { code: "CN.20.1502", name: "Baotou Shi" },
    { code: "CN.20.1503", name: "Wuhai Shi" },
    { code: "CN.20.1504", name: "Chifeng Shi" },
    { code: "CN.20.1505", name: "Tongliao Shi" },
    { code: "CN.20.1506", name: "Ordos Shi" },
    { code: "CN.20.1507", name: "Hulunbuir Region" },
    { code: "CN.20.1508", name: "Bayannur Shi" },
    { code: "CN.20.1509", name: "Wulanchabu Shi" },
    { code: "CN.20.1522", name: "Hinggan Meng" },
    { code: "CN.20.1525", name: "Xilin Gol Meng" },
    { code: "CN.20.1529", name: "Alxa Meng" },
  ],
  "CN.21": [
    { code: "CN.21.6401", name: "Yinchuan Shi" },
    { code: "CN.21.6402", name: "Shizuishan Shi" },
    { code: "CN.21.6403", name: "Wuzhong Shi" },
    { code: "CN.21.6404", name: "Guyuan Shi" },
    { code: "CN.21.6405", name: "Zhongwei Shi" },
  ],
  "CN.22": [
    { code: "CN.22.11876380", name: "Beijing" },
  ],
  "CN.24": [
    { code: "CN.24.1401", name: "Taiyuan Shi" },
    { code: "CN.24.1402", name: "Datong Shi" },
    { code: "CN.24.1403", name: "Yangquan Shi" },
    { code: "CN.24.1404", name: "Changzhi Shi" },
    { code: "CN.24.1405", name: "Jincheng Shi" },
    { code: "CN.24.1406", name: "Shuozhou Shi" },
    { code: "CN.24.1407", name: "Jinzhong Shi" },
    { code: "CN.24.1408", name: "Yuncheng Shi" },
    { code: "CN.24.1409", name: "Xinzhou Shi" },
    { code: "CN.24.1410", name: "Linfen Shi" },
    { code: "CN.24.1411", name: "Lüliang" },
  ],
  "CN.25": [
    { code: "CN.25.3701", name: "Jinan Shi" },
    { code: "CN.25.3702", name: "Qingdao Shi" },
    { code: "CN.25.3703", name: "Zibo Shi" },
    { code: "CN.25.3704", name: "Zaozhuang Shi" },
    { code: "CN.25.3705", name: "Dongying Shi" },
    { code: "CN.25.3706", name: "Yantai Shi" },
    { code: "CN.25.3707", name: "Weifang Shi" },
    { code: "CN.25.3708", name: "Jining Shi" },
    { code: "CN.25.3709", name: "Tai’an Shi" },
    { code: "CN.25.3710", name: "Weihai Shi" },
    { code: "CN.25.3711", name: "Rizhao Shi" },
    { code: "CN.25.3712", name: "Laiwu Shi" },
    { code: "CN.25.3713", name: "Linyi Shi" },
    { code: "CN.25.3714", name: "Dezhou Shi" },
    { code: "CN.25.3715", name: "Liaocheng Shi" },
    { code: "CN.25.3716", name: "Binzhou Shi" },
    { code: "CN.25.3717", name: "Heze Shi" },
  ],
  "CN.26": [
    { code: "CN.26.6101", name: "Xi’an Shi" },
    { code: "CN.26.6102", name: "Tongchuan Shi" },
    { code: "CN.26.6103", name: "Baoji Shi" },
    { code: "CN.26.6104", name: "Xianyang Shi" },
    { code: "CN.26.6105", name: "Weinan Shi" },
    { code: "CN.26.6106", name: "Yan’an Shi" },
    { code: "CN.26.6107", name: "Hanzhong Shi" },
    { code: "CN.26.6108", name: "Yulin Shi" },
    { code: "CN.26.6109", name: "Ankang Shi" },
    { code: "CN.26.6110", name: "Shangluo Shi" },
  ],
  "CN.29": [
    { code: "CN.29.5301", name: "Kunming Shi" },
    { code: "CN.29.5303", name: "Qujing Shi" },
    { code: "CN.29.5304", name: "Yuxi Shi" },
    { code: "CN.29.5305", name: "Baoshan Shi" },
    { code: "CN.29.5306", name: "Zhaotong Shi" },
    { code: "CN.29.5307", name: "Lijiang Shi" },
    { code: "CN.29.5308", name: "Pu'er City" },
    { code: "CN.29.5309", name: "Lincang Shi" },
    { code: "CN.29.5323", name: "Chuxiong Yizu Zizhizhou" },
    { code: "CN.29.5325", name: "Honghe Hanizu Yizu Zizhizhou" },
    { code: "CN.29.5326", name: "Wenshan Zhuangzu Miaozu Zizhizhou" },
    { code: "CN.29.5328", name: "Xishuangbanna Daizu Zizhizhou" },
    { code: "CN.29.5329", name: "Dali Baizu Zizhizhou" },
    { code: "CN.29.5331", name: "Dehong Daizu Jingpozu Zizhizhou" },
    { code: "CN.29.5333", name: "Nujiang Lisuzu Zizhizhou" },
    { code: "CN.29.5334", name: "Dêqên Tibetan Autonomous Prefecture" },
  ],
  "CN.30": [
    { code: "CN.30.4401", name: "Guangzhou Shi" },
    { code: "CN.30.4402", name: "Shaoguan Shi" },
    { code: "CN.30.4403", name: "Shenzhen" },
    { code: "CN.30.4404", name: "Zhuhai Shi" },
    { code: "CN.30.4405", name: "Shantou Shi" },
    { code: "CN.30.4406", name: "Foshan Shi" },
    { code: "CN.30.4407", name: "Jiangmen Shi" },
    { code: "CN.30.4408", name: "Zhanjiang Shi" },
    { code: "CN.30.4409", name: "Maoming Shi" },
    { code: "CN.30.4412", name: "Zhaoqing Shi" },
    { code: "CN.30.4413", name: "Huizhou Shi" },
    { code: "CN.30.4414", name: "Meizhou Shi" },
    { code: "CN.30.4415", name: "Shanwei Shi" },
    { code: "CN.30.4416", name: "Heyuan Shi" },
    { code: "CN.30.4417", name: "Yangjiang Shi" },
    { code: "CN.30.4418", name: "Qingyuan Shi" },
    { code: "CN.30.4419", name: "Dongguan Shi" },
    { code: "CN.30.4420", name: "Zhongshan Prefecture" },
    { code: "CN.30.4451", name: "Chaozhou Shi" },
    { code: "CN.30.4452", name: "Jieyang Shi" },
    { code: "CN.30.4453", name: "Yunfu Shi" },
  ],
  "CN.31": [
    { code: "CN.31.1791778", name: "Wanning Shi" },
    { code: "CN.31.1797544", name: "Qionghai County" },
    { code: "CN.31.4601", name: "Haikou Shi" },
    { code: "CN.31.4602", name: "Sanya Shi" },
    { code: "CN.31.4603", name: "Sansha" },
    { code: "CN.31.4604", name: "Danzhou Shi" },
  ],
  "CN.32": [
    { code: "CN.32.5101", name: "Chengdu Shi" },
    { code: "CN.32.5103", name: "Zigong Shi" },
    { code: "CN.32.5104", name: "Panzhihua Shi" },
    { code: "CN.32.5105", name: "Luzhou Shi" },
    { code: "CN.32.5106", name: "Deyang Shi" },
    { code: "CN.32.5107", name: "Mianyang Shi" },
    { code: "CN.32.5108", name: "Guangyuan Shi" },
    { code: "CN.32.5109", name: "Suining Shi" },
    { code: "CN.32.5110", name: "Neijiang Shi" },
    { code: "CN.32.5111", name: "Leshan Shi" },
    { code: "CN.32.5113", name: "Nanchong Shi" },
    { code: "CN.32.5114", name: "Meishan Shi" },
    { code: "CN.32.5115", name: "Yibin Shi" },
    { code: "CN.32.5116", name: "Guang’an Shi" },
    { code: "CN.32.5117", name: "Dazhou Shi" },
    { code: "CN.32.5118", name: "Ya’an Shi" },
    { code: "CN.32.5119", name: "Bazhong Shi" },
    { code: "CN.32.5120", name: "Ziyang Shi" },
    { code: "CN.32.5132", name: "Aba Zangzu Qiangzu Zizhizhou" },
    { code: "CN.32.5133", name: "Garzê Zangzu Zizhizhou" },
    { code: "CN.32.5134", name: "Liangshan Yizu Zizhizhou" },
  ],
  "CN.33": [
    { code: "CN.33.1791088", name: "Wulong District" },
    { code: "CN.33.1791746", name: "Wanzhou District" },
    { code: "CN.33.1795834", name: "Shapingba District" },
    { code: "CN.33.1803986", name: "Liangping District" },
    { code: "CN.33.1816835", name: "Yuzhong District" },
    { code: "CN.33.8739734", name: "Chongqing" },
    { code: "CN.33.9166037", name: "Wuxi County" },
  ],
  "CO.01": [
    { code: "CO.01.91001", name: "Leticia" },
    { code: "CO.01.91263", name: "El Encanto" },
    { code: "CO.01.91405", name: "La Chorrera" },
    { code: "CO.01.91407", name: "La Pedrera" },
    { code: "CO.01.91430", name: "La Victoria" },
    { code: "CO.01.91460", name: "Miriti - Paraná" },
    { code: "CO.01.91530", name: "Puerto Alegría" },
    { code: "CO.01.91536", name: "Puerto Arica" },
    { code: "CO.01.91540", name: "Puerto Nariño" },
    { code: "CO.01.91669", name: "Puerto Santander" },
    { code: "CO.01.91798", name: "Tarapacá" },
  ],
  "CO.02": [
    { code: "CO.02.05001", name: "Medellín" },
    { code: "CO.02.05002", name: "Abejorral" },
    { code: "CO.02.05004", name: "Abriaquí" },
    { code: "CO.02.05021", name: "Alejandría" },
    { code: "CO.02.05030", name: "Amagá" },
    { code: "CO.02.05031", name: "Amalfi" },
    { code: "CO.02.05034", name: "Andes" },
    { code: "CO.02.05036", name: "Angelópolis" },
    { code: "CO.02.05038", name: "Angostura" },
    { code: "CO.02.05040", name: "Anorí" },
    { code: "CO.02.05042", name: "Santafé de Antioquia" },
    { code: "CO.02.05044", name: "Anza" },
    { code: "CO.02.05045", name: "Apartadó" },
    { code: "CO.02.05051", name: "Arboletes" },
    { code: "CO.02.05055", name: "Argelia" },
    { code: "CO.02.05059", name: "Armenia" },
    { code: "CO.02.05079", name: "Barbosa" },
    { code: "CO.02.05086", name: "Belmira" },
    { code: "CO.02.05088", name: "Bello" },
    { code: "CO.02.05091", name: "Betania" },
    { code: "CO.02.05093", name: "Betulia" },
    { code: "CO.02.05101", name: "Ciudad Bolívar" },
    { code: "CO.02.05107", name: "Briceño" },
    { code: "CO.02.05113", name: "Buriticá" },
    { code: "CO.02.05120", name: "Cáceres" },
    { code: "CO.02.05125", name: "Caicedo" },
    { code: "CO.02.05129", name: "Caldas" },
    { code: "CO.02.05134", name: "Campamento" },
    { code: "CO.02.05138", name: "Cañasgordas" },
    { code: "CO.02.05142", name: "Caracolí" },
    { code: "CO.02.05145", name: "Caramanta" },
    { code: "CO.02.05147", name: "Carepa" },
    { code: "CO.02.05148", name: "El Carmen de Viboral" },
    { code: "CO.02.05150", name: "Carolina" },
    { code: "CO.02.05154", name: "Caucasia" },
    { code: "CO.02.05172", name: "Chigorodó" },
    { code: "CO.02.05190", name: "Cisneros" },
    { code: "CO.02.05197", name: "Cocorná" },
    { code: "CO.02.05206", name: "Concepción" },
    { code: "CO.02.05209", name: "Concordia" },
    { code: "CO.02.05212", name: "Copacabana" },
    { code: "CO.02.05234", name: "Dabeiba" },
    { code: "CO.02.05237", name: "Don Matías" },
    { code: "CO.02.05240", name: "Ebéjico" },
    { code: "CO.02.05250", name: "El Bagre" },
    { code: "CO.02.05264", name: "Entrerrios" },
    { code: "CO.02.05266", name: "Envigado" },
    { code: "CO.02.05282", name: "Fredonia" },
    { code: "CO.02.05284", name: "Frontino" },
    { code: "CO.02.05306", name: "Giraldo" },
    { code: "CO.02.05308", name: "Girardota" },
    { code: "CO.02.05310", name: "Gómez Plata" },
    { code: "CO.02.05313", name: "Granada" },
    { code: "CO.02.05315", name: "Guadalupe" },
    { code: "CO.02.05318", name: "Guarne" },
    { code: "CO.02.05321", name: "Guatapé" },
    { code: "CO.02.05347", name: "Heliconia" },
    { code: "CO.02.05353", name: "Hispania" },
    { code: "CO.02.05360", name: "Itagui" },
    { code: "CO.02.05361", name: "Ituango" },
    { code: "CO.02.05364", name: "Jardín" },
    { code: "CO.02.05368", name: "Jericó" },
    { code: "CO.02.05376", name: "La Ceja" },
    { code: "CO.02.05380", name: "La Estrella" },
    { code: "CO.02.05390", name: "La Pintada" },
    { code: "CO.02.05400", name: "La Unión" },
    { code: "CO.02.05411", name: "Liborina" },
    { code: "CO.02.05425", name: "Maceo" },
    { code: "CO.02.05440", name: "Marinilla" },
    { code: "CO.02.05467", name: "Montebello" },
    { code: "CO.02.05475", name: "Murindó" },
    { code: "CO.02.05480", name: "Mutatá" },
    { code: "CO.02.05483", name: "Nariño" },
    { code: "CO.02.05490", name: "Necoclí" },
    { code: "CO.02.05495", name: "Nechí" },
    { code: "CO.02.05501", name: "Olaya" },
    { code: "CO.02.05541", name: "Peñol" },
    { code: "CO.02.05543", name: "Peque" },
    { code: "CO.02.05576", name: "Pueblorrico" },
    { code: "CO.02.05579", name: "Puerto Berrío" },
    { code: "CO.02.05585", name: "Puerto Nare" },
    { code: "CO.02.05591", name: "Puerto Triunfo" },
    { code: "CO.02.05604", name: "Remedios" },
    { code: "CO.02.05607", name: "Retiro" },
    { code: "CO.02.05615", name: "Rionegro" },
    { code: "CO.02.05628", name: "Sabanalarga" },
    { code: "CO.02.05631", name: "Sabaneta" },
    { code: "CO.02.05642", name: "Salgar" },
    { code: "CO.02.05647", name: "San Andrés de Cuerquía" },
    { code: "CO.02.05649", name: "San Carlos" },
    { code: "CO.02.05652", name: "San Francisco" },
    { code: "CO.02.05656", name: "San Jerónimo" },
    { code: "CO.02.05658", name: "San José de La Montaña" },
    { code: "CO.02.05659", name: "San Juan de Urabá" },
    { code: "CO.02.05660", name: "San Luis" },
    { code: "CO.02.05664", name: "Municipio de San Pedro de los Milagros" },
    { code: "CO.02.05665", name: "San Pedro de Uraba" },
    { code: "CO.02.05667", name: "San Rafael" },
    { code: "CO.02.05670", name: "San Roque" },
    { code: "CO.02.05674", name: "San Vicente Ferrer" },
    { code: "CO.02.05679", name: "Santa Bárbara" },
    { code: "CO.02.05686", name: "Santa Rosa de Osos" },
    { code: "CO.02.05690", name: "Santo Domingo" },
    { code: "CO.02.05697", name: "El Santuario" },
    { code: "CO.02.05736", name: "Segovia" },
    { code: "CO.02.05756", name: "Sonson" },
    { code: "CO.02.05761", name: "Sopetrán" },
    { code: "CO.02.05789", name: "Támesis" },
    { code: "CO.02.05790", name: "Tarazá" },
    { code: "CO.02.05792", name: "Tarso" },
    { code: "CO.02.05809", name: "Titiribí" },
    { code: "CO.02.05819", name: "Toledo" },
    { code: "CO.02.05837", name: "Turbo" },
    { code: "CO.02.05842", name: "Uramita" },
    { code: "CO.02.05847", name: "Urrao" },
    { code: "CO.02.05854", name: "Valdivia" },
    { code: "CO.02.05856", name: "Valparaíso" },
    { code: "CO.02.05858", name: "Vegachí" },
    { code: "CO.02.05861", name: "Venecia" },
    { code: "CO.02.05873", name: "Vigía del Fuerte" },
    { code: "CO.02.05885", name: "Yalí" },
    { code: "CO.02.05887", name: "Yarumal" },
    { code: "CO.02.05890", name: "Yolombó" },
    { code: "CO.02.05893", name: "Yondó" },
    { code: "CO.02.05895", name: "Zaragoza" },
  ],
  "CO.03": [
    { code: "CO.03.81001", name: "Arauca" },
    { code: "CO.03.81065", name: "Arauquita" },
    { code: "CO.03.81220", name: "Cravo Norte" },
    { code: "CO.03.81300", name: "Fortul" },
    { code: "CO.03.81591", name: "Puerto Rondón" },
    { code: "CO.03.81736", name: "Saravena" },
    { code: "CO.03.81794", name: "Tame" },
  ],
  "CO.04": [
    { code: "CO.04.08001", name: "Barranquilla" },
    { code: "CO.04.08078", name: "Baranoa" },
    { code: "CO.04.08137", name: "Campo de La Cruz" },
    { code: "CO.04.08141", name: "Candelaria" },
    { code: "CO.04.08296", name: "Galapa" },
    { code: "CO.04.08372", name: "Juan de Acosta" },
    { code: "CO.04.08421", name: "Luruaco" },
    { code: "CO.04.08433", name: "Malambo" },
    { code: "CO.04.08436", name: "Manatí" },
    { code: "CO.04.08520", name: "Palmar de Varela" },
    { code: "CO.04.08549", name: "Piojó" },
    { code: "CO.04.08558", name: "Polonuevo" },
    { code: "CO.04.08560", name: "Ponedera" },
    { code: "CO.04.08573", name: "Puerto Colombia" },
    { code: "CO.04.08606", name: "Repelón" },
    { code: "CO.04.08634", name: "Sabanagrande" },
    { code: "CO.04.08638", name: "Sabanalarga" },
    { code: "CO.04.08675", name: "Santa Lucía" },
    { code: "CO.04.08685", name: "Santo Tomás" },
    { code: "CO.04.08758", name: "Soledad" },
    { code: "CO.04.08770", name: "Suan" },
    { code: "CO.04.08832", name: "Tubará" },
    { code: "CO.04.08849", name: "Usiacurí" },
  ],
  "CO.08": [
    { code: "CO.08.18001", name: "Florencia" },
    { code: "CO.08.18029", name: "Albania" },
    { code: "CO.08.18094", name: "Belén de Los Andaquies" },
    { code: "CO.08.18150", name: "Cartagena del Chairá" },
    { code: "CO.08.18205", name: "Curillo" },
    { code: "CO.08.18247", name: "El Doncello" },
    { code: "CO.08.18256", name: "El Paujil" },
    { code: "CO.08.18410", name: "La Montañita" },
    { code: "CO.08.18460", name: "Milán" },
    { code: "CO.08.18479", name: "Morelia" },
    { code: "CO.08.18592", name: "Puerto Rico" },
    { code: "CO.08.18610", name: "San José del Fragua" },
    { code: "CO.08.18753", name: "San Vicente del Caguán" },
    { code: "CO.08.18756", name: "Solano" },
    { code: "CO.08.18785", name: "Solita" },
    { code: "CO.08.18860", name: "Valparaíso" },
  ],
  "CO.09": [
    { code: "CO.09.19001", name: "Popayán" },
    { code: "CO.09.19022", name: "Almaguer" },
    { code: "CO.09.19050", name: "Argelia" },
    { code: "CO.09.19075", name: "Balboa" },
    { code: "CO.09.19100", name: "Bolívar" },
    { code: "CO.09.19110", name: "Buenos Aires" },
    { code: "CO.09.19130", name: "Cajibío" },
    { code: "CO.09.19137", name: "Caldono" },
    { code: "CO.09.19142", name: "Caloto" },
    { code: "CO.09.19212", name: "Corinto" },
    { code: "CO.09.19256", name: "El Tambo" },
    { code: "CO.09.19290", name: "Florencia" },
    { code: "CO.09.19300", name: "Guachene" },
    { code: "CO.09.19318", name: "Guapi" },
    { code: "CO.09.19355", name: "Inzá" },
    { code: "CO.09.19364", name: "Jambaló" },
    { code: "CO.09.19392", name: "La Sierra" },
    { code: "CO.09.19397", name: "La Vega" },
    { code: "CO.09.19418", name: "Municipio de López de Micay" },
    { code: "CO.09.19450", name: "Mercaderes" },
    { code: "CO.09.19455", name: "Miranda" },
    { code: "CO.09.19473", name: "Morales" },
    { code: "CO.09.19513", name: "Padilla" },
    { code: "CO.09.19517", name: "Paez" },
    { code: "CO.09.19532", name: "Patía" },
    { code: "CO.09.19533", name: "Piamonte" },
    { code: "CO.09.19548", name: "Piendamó" },
    { code: "CO.09.19573", name: "Puerto Tejada" },
    { code: "CO.09.19585", name: "Puracé" },
    { code: "CO.09.19622", name: "Rosas" },
    { code: "CO.09.19693", name: "San Sebastián" },
    { code: "CO.09.19698", name: "Santander de Quilichao" },
    { code: "CO.09.19701", name: "Santa Rosa" },
    { code: "CO.09.19743", name: "Silvia" },
    { code: "CO.09.19760", name: "Sotara" },
    { code: "CO.09.19780", name: "Suárez" },
    { code: "CO.09.19785", name: "Sucre" },
    { code: "CO.09.19807", name: "Timbío" },
    { code: "CO.09.19809", name: "Timbiquí" },
    { code: "CO.09.19821", name: "Toribio" },
    { code: "CO.09.19824", name: "Totoró" },
    { code: "CO.09.19845", name: "Villa Rica" },
  ],
  "CO.10": [
    { code: "CO.10.20001", name: "Valledupar" },
    { code: "CO.10.20011", name: "Aguachica" },
    { code: "CO.10.20013", name: "Agustín Codazzi" },
    { code: "CO.10.20032", name: "Astrea" },
    { code: "CO.10.20045", name: "Becerril" },
    { code: "CO.10.20060", name: "Bosconia" },
    { code: "CO.10.20175", name: "Chimichagua" },
    { code: "CO.10.20178", name: "Chiriguaná" },
    { code: "CO.10.20228", name: "Curumaní" },
    { code: "CO.10.20238", name: "El Copey" },
    { code: "CO.10.20250", name: "El Paso" },
    { code: "CO.10.20295", name: "Gamarra" },
    { code: "CO.10.20310", name: "González" },
    { code: "CO.10.20383", name: "La Gloria" },
    { code: "CO.10.20400", name: "La Jagua de Ibirico" },
    { code: "CO.10.20443", name: "Manaure" },
    { code: "CO.10.20517", name: "Pailitas" },
    { code: "CO.10.20550", name: "Pelaya" },
    { code: "CO.10.20570", name: "Pueblo Bello" },
    { code: "CO.10.20614", name: "Río de Oro" },
    { code: "CO.10.20621", name: "La Paz" },
    { code: "CO.10.20710", name: "San Alberto" },
    { code: "CO.10.20750", name: "San Diego" },
    { code: "CO.10.20770", name: "San Martín" },
    { code: "CO.10.20787", name: "Tamalameque" },
  ],
  "CO.11": [
    { code: "CO.11.27001", name: "Quibdó" },
    { code: "CO.11.27006", name: "Acandí" },
    { code: "CO.11.27025", name: "Alto Baudo" },
    { code: "CO.11.27050", name: "Atrato" },
    { code: "CO.11.27073", name: "Bagadó" },
    { code: "CO.11.27075", name: "Bahía Solano" },
    { code: "CO.11.27077", name: "Bajo Baudó" },
    { code: "CO.11.27099", name: "Bojaya" },
    { code: "CO.11.27135", name: "El Cantón del San Pablo" },
    { code: "CO.11.27150", name: "Carmen del Darien" },
    { code: "CO.11.27160", name: "Cértegui" },
    { code: "CO.11.27205", name: "Condoto" },
    { code: "CO.11.27245", name: "El Carmen de Atrato" },
    { code: "CO.11.27250", name: "El Litoral del San Juan" },
    { code: "CO.11.27361", name: "Istmina" },
    { code: "CO.11.27372", name: "Juradó" },
    { code: "CO.11.27413", name: "Lloró" },
    { code: "CO.11.27425", name: "Medio Atrato" },
    { code: "CO.11.27430", name: "Medio Baudó" },
    { code: "CO.11.27450", name: "Medio San Juan" },
    { code: "CO.11.27491", name: "Nóvita" },
    { code: "CO.11.27495", name: "Nuquí" },
    { code: "CO.11.27580", name: "Río Iro" },
    { code: "CO.11.27600", name: "Río Quito" },
    { code: "CO.11.27615", name: "Riosucio" },
    { code: "CO.11.27660", name: "San José del Palmar" },
    { code: "CO.11.27745", name: "Sipí" },
    { code: "CO.11.27787", name: "Tadó" },
    { code: "CO.11.27800", name: "Unguía" },
    { code: "CO.11.27810", name: "Unión Panamericana" },
  ],
  "CO.12": [
    { code: "CO.12.23001", name: "Montería" },
    { code: "CO.12.23068", name: "Ayapel" },
    { code: "CO.12.23079", name: "Buenavista" },
    { code: "CO.12.23090", name: "Canalete" },
    { code: "CO.12.23162", name: "Cereté" },
    { code: "CO.12.23168", name: "Chimá" },
    { code: "CO.12.23182", name: "Chinú" },
    { code: "CO.12.23189", name: "Ciénaga de Oro" },
    { code: "CO.12.23300", name: "Cotorra" },
    { code: "CO.12.23350", name: "La Apartada" },
    { code: "CO.12.23417", name: "Lorica" },
    { code: "CO.12.23419", name: "Los Córdobas" },
    { code: "CO.12.23464", name: "Momil" },
    { code: "CO.12.23466", name: "Montelíbano" },
    { code: "CO.12.23500", name: "Moñitos" },
    { code: "CO.12.23555", name: "Planeta Rica" },
    { code: "CO.12.23570", name: "Pueblo Nuevo" },
    { code: "CO.12.23574", name: "Puerto Escondido" },
    { code: "CO.12.23580", name: "Puerto Libertador" },
    { code: "CO.12.23586", name: "Purísima" },
    { code: "CO.12.23660", name: "Sahagún" },
    { code: "CO.12.23670", name: "San Andrés Sotavento" },
    { code: "CO.12.23672", name: "San Antero" },
    { code: "CO.12.23675", name: "San Bernardo del Viento" },
    { code: "CO.12.23678", name: "San Carlos" },
    { code: "CO.12.23682", name: "San Jose De Ure" },
    { code: "CO.12.23686", name: "San Pelayo" },
    { code: "CO.12.23807", name: "Tierralta" },
    { code: "CO.12.23815", name: "Tuchin" },
    { code: "CO.12.23855", name: "Valencia" },
  ],
  "CO.14": [
    { code: "CO.14.95001", name: "San José del Guaviare" },
    { code: "CO.14.95015", name: "Calamar" },
    { code: "CO.14.95025", name: "El Retorno" },
    { code: "CO.14.95200", name: "Miraflores" },
  ],
  "CO.15": [
    { code: "CO.15.94001", name: "Inírida" },
    { code: "CO.15.94343", name: "Barranco Minas" },
    { code: "CO.15.94663", name: "Mapiripana" },
    { code: "CO.15.94883", name: "San Felipe" },
    { code: "CO.15.94884", name: "Puerto Colombia" },
    { code: "CO.15.94885", name: "La Guadalupe" },
    { code: "CO.15.94886", name: "Cacahual" },
    { code: "CO.15.94887", name: "Pana Pana" },
    { code: "CO.15.94888", name: "Morichal" },
  ],
  "CO.16": [
    { code: "CO.16.41001", name: "Neiva" },
    { code: "CO.16.41006", name: "Acevedo" },
    { code: "CO.16.41013", name: "Agrado" },
    { code: "CO.16.41016", name: "Aipe" },
    { code: "CO.16.41020", name: "Algeciras" },
    { code: "CO.16.41026", name: "Altamira" },
    { code: "CO.16.41078", name: "Baraya" },
    { code: "CO.16.41132", name: "Campoalegre" },
    { code: "CO.16.41206", name: "Colombia" },
    { code: "CO.16.41244", name: "Elías" },
    { code: "CO.16.41298", name: "Garzón" },
    { code: "CO.16.41306", name: "Gigante" },
    { code: "CO.16.41319", name: "Guadalupe" },
    { code: "CO.16.41349", name: "Hobo" },
    { code: "CO.16.41357", name: "Municipio de Íquira" },
    { code: "CO.16.41359", name: "Isnos" },
    { code: "CO.16.41378", name: "La Argentina" },
    { code: "CO.16.41396", name: "La Plata" },
    { code: "CO.16.41483", name: "Nátaga" },
    { code: "CO.16.41503", name: "Oporapa" },
    { code: "CO.16.41518", name: "Paicol" },
    { code: "CO.16.41524", name: "Palermo" },
    { code: "CO.16.41530", name: "Palestina" },
    { code: "CO.16.41548", name: "Pital" },
    { code: "CO.16.41551", name: "Pitalito" },
    { code: "CO.16.41615", name: "Rivera" },
    { code: "CO.16.41660", name: "Saladoblanco" },
    { code: "CO.16.41668", name: "San Agustín" },
    { code: "CO.16.41676", name: "Santa María" },
    { code: "CO.16.41770", name: "Suaza" },
    { code: "CO.16.41791", name: "Tarqui" },
    { code: "CO.16.41797", name: "Tesalia" },
    { code: "CO.16.41799", name: "Tello" },
    { code: "CO.16.41801", name: "Teruel" },
    { code: "CO.16.41807", name: "Timaná" },
    { code: "CO.16.41872", name: "Villavieja" },
    { code: "CO.16.41885", name: "Yaguará" },
  ],
  "CO.17": [
    { code: "CO.17.44001", name: "Riohacha" },
    { code: "CO.17.44035", name: "Albania" },
    { code: "CO.17.44078", name: "Barrancas" },
    { code: "CO.17.44090", name: "Dibulla" },
    { code: "CO.17.44098", name: "Distracción" },
    { code: "CO.17.44110", name: "El Molino" },
    { code: "CO.17.44279", name: "Fonseca" },
    { code: "CO.17.44378", name: "Hatonuevo" },
    { code: "CO.17.44420", name: "La Jagua del Pilar" },
    { code: "CO.17.44430", name: "Maicao" },
    { code: "CO.17.44560", name: "Manaure" },
    { code: "CO.17.44650", name: "San Juan del Cesar" },
    { code: "CO.17.44847", name: "Uribia" },
    { code: "CO.17.44855", name: "Urumita" },
    { code: "CO.17.44874", name: "Villanueva" },
  ],
  "CO.19": [
    { code: "CO.19.50001", name: "Villavicencio" },
    { code: "CO.19.50006", name: "Acacías" },
    { code: "CO.19.50110", name: "Barranca de Upía" },
    { code: "CO.19.50124", name: "Cabuyaro" },
    { code: "CO.19.50150", name: "Castilla la Nueva" },
    { code: "CO.19.50223", name: "Cubarral" },
    { code: "CO.19.50226", name: "Cumaral" },
    { code: "CO.19.50245", name: "El Calvario" },
    { code: "CO.19.50251", name: "El Castillo" },
    { code: "CO.19.50270", name: "El Dorado" },
    { code: "CO.19.50287", name: "Fuente de Oro" },
    { code: "CO.19.50313", name: "Granada" },
    { code: "CO.19.50318", name: "Guamal" },
    { code: "CO.19.50325", name: "Mapiripán" },
    { code: "CO.19.50330", name: "Mesetas" },
    { code: "CO.19.50350", name: "La Macarena" },
    { code: "CO.19.50370", name: "Uribe" },
    { code: "CO.19.50400", name: "Lejanías" },
    { code: "CO.19.50450", name: "Puerto Concordia" },
    { code: "CO.19.50568", name: "Puerto Gaitán" },
    { code: "CO.19.50573", name: "Puerto López" },
    { code: "CO.19.50577", name: "Puerto Lleras" },
    { code: "CO.19.50590", name: "Puerto Rico" },
    { code: "CO.19.50606", name: "Restrepo" },
    { code: "CO.19.50680", name: "San Carlos de Guaroa" },
    { code: "CO.19.50683", name: "San Juan de Arama" },
    { code: "CO.19.50686", name: "San Juanito" },
    { code: "CO.19.50689", name: "San Martín" },
    { code: "CO.19.50711", name: "Vistahermosa" },
  ],
  "CO.20": [
    { code: "CO.20.52001", name: "Pasto" },
    { code: "CO.20.52019", name: "Albán" },
    { code: "CO.20.52022", name: "Aldana" },
    { code: "CO.20.52036", name: "Ancuyá" },
    { code: "CO.20.52051", name: "Arboleda" },
    { code: "CO.20.52079", name: "Barbacoas" },
    { code: "CO.20.52083", name: "Belén" },
    { code: "CO.20.52110", name: "Buesaco" },
    { code: "CO.20.52203", name: "Colón" },
    { code: "CO.20.52207", name: "Consaca" },
    { code: "CO.20.52210", name: "Contadero" },
    { code: "CO.20.52215", name: "Córdoba" },
    { code: "CO.20.52224", name: "Cuaspud" },
    { code: "CO.20.52227", name: "Cumbal" },
    { code: "CO.20.52233", name: "Cumbitara" },
    { code: "CO.20.52240", name: "Chachagüí" },
    { code: "CO.20.52250", name: "El Charco" },
    { code: "CO.20.52254", name: "El Peñol" },
    { code: "CO.20.52256", name: "El Rosario" },
    { code: "CO.20.52258", name: "El Tablón de Gómez" },
    { code: "CO.20.52260", name: "El Tambo" },
    { code: "CO.20.52287", name: "Funes" },
    { code: "CO.20.52317", name: "Guachucal" },
    { code: "CO.20.52320", name: "Guaitarilla" },
    { code: "CO.20.52323", name: "Gualmatán" },
    { code: "CO.20.52352", name: "Iles" },
    { code: "CO.20.52354", name: "Imués" },
    { code: "CO.20.52356", name: "Ipiales" },
    { code: "CO.20.52378", name: "La Cruz" },
    { code: "CO.20.52381", name: "La Florida" },
    { code: "CO.20.52385", name: "La Llanada" },
    { code: "CO.20.52390", name: "La Tola" },
    { code: "CO.20.52399", name: "La Unión" },
    { code: "CO.20.52405", name: "Leiva" },
    { code: "CO.20.52411", name: "Linares" },
    { code: "CO.20.52418", name: "Los Andes" },
    { code: "CO.20.52427", name: "Magüi" },
    { code: "CO.20.52435", name: "Mallama" },
    { code: "CO.20.52473", name: "Mosquera" },
    { code: "CO.20.52480", name: "Nariño" },
    { code: "CO.20.52490", name: "Olaya Herrera" },
    { code: "CO.20.52506", name: "Ospina" },
    { code: "CO.20.52520", name: "Francisco Pizarro" },
    { code: "CO.20.52540", name: "Policarpa" },
    { code: "CO.20.52560", name: "Potosí" },
    { code: "CO.20.52565", name: "Providencia" },
    { code: "CO.20.52573", name: "Puerres" },
    { code: "CO.20.52585", name: "Pupiales" },
    { code: "CO.20.52612", name: "Ricaurte" },
    { code: "CO.20.52621", name: "Roberto Payán" },
    { code: "CO.20.52678", name: "Samaniego" },
    { code: "CO.20.52683", name: "Sandoná" },
    { code: "CO.20.52685", name: "San Bernardo" },
    { code: "CO.20.52687", name: "San Lorenzo" },
    { code: "CO.20.52693", name: "San Pablo" },
    { code: "CO.20.52694", name: "San Pedro de Cartago" },
    { code: "CO.20.52696", name: "Santa Bárbara" },
    { code: "CO.20.52699", name: "Santacruz" },
    { code: "CO.20.52720", name: "Sapuyes" },
    { code: "CO.20.52786", name: "Taminango" },
    { code: "CO.20.52788", name: "Tangua" },
    { code: "CO.20.52835", name: "San Andres de Tumaco" },
    { code: "CO.20.52838", name: "Túquerres" },
    { code: "CO.20.52885", name: "Yacuanquer" },
  ],
  "CO.21": [
    { code: "CO.21.54001", name: "Cúcuta" },
    { code: "CO.21.54003", name: "Abrego" },
    { code: "CO.21.54051", name: "Arboledas" },
    { code: "CO.21.54099", name: "Bochalema" },
    { code: "CO.21.54109", name: "Bucarasica" },
    { code: "CO.21.54125", name: "Cácota" },
    { code: "CO.21.54128", name: "Cachirá" },
    { code: "CO.21.54172", name: "Chinácota" },
    { code: "CO.21.54174", name: "Chitagá" },
    { code: "CO.21.54206", name: "Convención" },
    { code: "CO.21.54223", name: "Cucutilla" },
    { code: "CO.21.54239", name: "Durania" },
    { code: "CO.21.54245", name: "El Carmen" },
    { code: "CO.21.54250", name: "El Tarra" },
    { code: "CO.21.54261", name: "El Zulia" },
    { code: "CO.21.54313", name: "Gramalote" },
    { code: "CO.21.54344", name: "Hacarí" },
    { code: "CO.21.54347", name: "Herrán" },
    { code: "CO.21.54377", name: "Labateca" },
    { code: "CO.21.54385", name: "La Esperanza" },
    { code: "CO.21.54398", name: "La Playa" },
    { code: "CO.21.54405", name: "Los Patios" },
    { code: "CO.21.54418", name: "Lourdes" },
    { code: "CO.21.54480", name: "Mutiscua" },
    { code: "CO.21.54498", name: "Ocaña" },
    { code: "CO.21.54518", name: "Pamplona" },
    { code: "CO.21.54520", name: "Pamplonita" },
    { code: "CO.21.54553", name: "Puerto Santander" },
    { code: "CO.21.54599", name: "Ragonvalia" },
    { code: "CO.21.54660", name: "Salazar" },
    { code: "CO.21.54670", name: "San Calixto" },
    { code: "CO.21.54673", name: "San Cayetano" },
    { code: "CO.21.54680", name: "Santiago" },
    { code: "CO.21.54720", name: "Sardinata" },
    { code: "CO.21.54743", name: "Silos" },
    { code: "CO.21.54800", name: "Teorama" },
    { code: "CO.21.54810", name: "Tibú" },
    { code: "CO.21.54820", name: "Toledo" },
    { code: "CO.21.54871", name: "Villa Caro" },
    { code: "CO.21.54874", name: "Villa del Rosario" },
  ],
  "CO.22": [
    { code: "CO.22.86001", name: "Mocoa" },
    { code: "CO.22.86219", name: "Colón" },
    { code: "CO.22.86320", name: "Orito" },
    { code: "CO.22.86568", name: "Puerto Asís" },
    { code: "CO.22.86569", name: "Puerto Caicedo" },
    { code: "CO.22.86571", name: "Puerto Guzmán" },
    { code: "CO.22.86573", name: "Leguízamo" },
    { code: "CO.22.86749", name: "Sibundoy" },
    { code: "CO.22.86755", name: "San Francisco" },
    { code: "CO.22.86757", name: "San Miguel" },
    { code: "CO.22.86760", name: "Santiago" },
    { code: "CO.22.86865", name: "Valle del Guamuez" },
    { code: "CO.22.86885", name: "Villagarzón" },
  ],
  "CO.23": [
    { code: "CO.23.63001", name: "Armenia" },
    { code: "CO.23.63111", name: "Buenavista" },
    { code: "CO.23.63130", name: "Calarca" },
    { code: "CO.23.63190", name: "Circasia" },
    { code: "CO.23.63212", name: "Córdoba" },
    { code: "CO.23.63272", name: "Filandia" },
    { code: "CO.23.63302", name: "Génova" },
    { code: "CO.23.63401", name: "La Tebaida" },
    { code: "CO.23.63470", name: "Montenegro" },
    { code: "CO.23.63548", name: "Pijao" },
    { code: "CO.23.63594", name: "Quimbaya" },
    { code: "CO.23.63690", name: "Salento" },
  ],
  "CO.24": [
    { code: "CO.24.66001", name: "Pereira" },
    { code: "CO.24.66045", name: "Apía" },
    { code: "CO.24.66075", name: "Balboa" },
    { code: "CO.24.66088", name: "Belén de Umbría" },
    { code: "CO.24.66170", name: "Dosquebradas" },
    { code: "CO.24.66318", name: "Guática" },
    { code: "CO.24.66383", name: "La Celia" },
    { code: "CO.24.66400", name: "La Virginia" },
    { code: "CO.24.66440", name: "Marsella" },
    { code: "CO.24.66456", name: "Mistrató" },
    { code: "CO.24.66572", name: "Pueblo Rico" },
    { code: "CO.24.66594", name: "Quinchía" },
    { code: "CO.24.66682", name: "Santa Rosa de Cabal" },
    { code: "CO.24.66687", name: "Santuario" },
  ],
  "CO.25": [
    { code: "CO.25.88001", name: "San Andrés" },
    { code: "CO.25.88564", name: "Providencia" },
  ],
  "CO.26": [
    { code: "CO.26.68001", name: "Bucaramanga" },
    { code: "CO.26.68013", name: "Aguada" },
    { code: "CO.26.68020", name: "Albania" },
    { code: "CO.26.68051", name: "Aratoca" },
    { code: "CO.26.68077", name: "Barbosa" },
    { code: "CO.26.68079", name: "Barichara" },
    { code: "CO.26.68081", name: "Barrancabermeja" },
    { code: "CO.26.68092", name: "Betulia" },
    { code: "CO.26.68101", name: "Bolívar" },
    { code: "CO.26.68121", name: "Cabrera" },
    { code: "CO.26.68132", name: "California" },
    { code: "CO.26.68147", name: "Capitanejo" },
    { code: "CO.26.68152", name: "Carcasí" },
    { code: "CO.26.68160", name: "Cepitá" },
    { code: "CO.26.68162", name: "Cerrito" },
    { code: "CO.26.68167", name: "Charalá" },
    { code: "CO.26.68169", name: "Charta" },
    { code: "CO.26.68176", name: "Chima" },
    { code: "CO.26.68179", name: "Chipatá" },
    { code: "CO.26.68190", name: "Cimitarra" },
    { code: "CO.26.68207", name: "Concepción" },
    { code: "CO.26.68209", name: "Confines" },
    { code: "CO.26.68211", name: "Contratación" },
    { code: "CO.26.68217", name: "Coromoro" },
    { code: "CO.26.68229", name: "Curití" },
    { code: "CO.26.68235", name: "El Carmen de Chucurí" },
    { code: "CO.26.68245", name: "El Guacamayo" },
    { code: "CO.26.68250", name: "El Peñón" },
    { code: "CO.26.68255", name: "El Playón" },
    { code: "CO.26.68264", name: "Encino" },
    { code: "CO.26.68266", name: "Enciso" },
    { code: "CO.26.68271", name: "Florián" },
    { code: "CO.26.68276", name: "Floridablanca" },
    { code: "CO.26.68296", name: "Galán" },
    { code: "CO.26.68298", name: "Gambita" },
    { code: "CO.26.68307", name: "Girón" },
    { code: "CO.26.68318", name: "Guaca" },
    { code: "CO.26.68320", name: "Guadalupe" },
    { code: "CO.26.68322", name: "Guapotá" },
    { code: "CO.26.68324", name: "Guavatá" },
    { code: "CO.26.68327", name: "Güepsa" },
    { code: "CO.26.68344", name: "Hato" },
    { code: "CO.26.68368", name: "Jesús María" },
    { code: "CO.26.68370", name: "Jordán" },
    { code: "CO.26.68377", name: "La Belleza" },
    { code: "CO.26.68385", name: "Landázuri" },
    { code: "CO.26.68397", name: "La Paz" },
    { code: "CO.26.68406", name: "Lebríja" },
    { code: "CO.26.68418", name: "Los Santos" },
    { code: "CO.26.68425", name: "Macaravita" },
    { code: "CO.26.68432", name: "Málaga" },
    { code: "CO.26.68444", name: "Matanza" },
    { code: "CO.26.68464", name: "Mogotes" },
    { code: "CO.26.68468", name: "Molagavita" },
    { code: "CO.26.68498", name: "Ocamonte" },
    { code: "CO.26.68500", name: "Oiba" },
    { code: "CO.26.68502", name: "Onzaga" },
    { code: "CO.26.68522", name: "Palmar" },
    { code: "CO.26.68524", name: "Palmas del Socorro" },
    { code: "CO.26.68533", name: "Páramo" },
    { code: "CO.26.68547", name: "Piedecuesta" },
    { code: "CO.26.68549", name: "Pinchote" },
    { code: "CO.26.68572", name: "Puente Nacional" },
    { code: "CO.26.68573", name: "Puerto Parra" },
    { code: "CO.26.68575", name: "Puerto Wilches" },
    { code: "CO.26.68615", name: "Rionegro" },
    { code: "CO.26.68655", name: "Sabana de Torres" },
    { code: "CO.26.68669", name: "San Andrés" },
    { code: "CO.26.68673", name: "San Benito" },
    { code: "CO.26.68679", name: "San Gil" },
    { code: "CO.26.68682", name: "San Joaquín" },
    { code: "CO.26.68684", name: "San José de Miranda" },
    { code: "CO.26.68686", name: "San Miguel" },
    { code: "CO.26.68689", name: "San Vicente de Chucurí" },
    { code: "CO.26.68705", name: "Santa Bárbara" },
    { code: "CO.26.68720", name: "Santa Helena del Opón" },
    { code: "CO.26.68745", name: "Simacota" },
    { code: "CO.26.68755", name: "Socorro" },
    { code: "CO.26.68770", name: "Suaita" },
    { code: "CO.26.68773", name: "Sucre" },
    { code: "CO.26.68780", name: "Suratá" },
    { code: "CO.26.68820", name: "Tona" },
    { code: "CO.26.68855", name: "Valle de San José" },
    { code: "CO.26.68861", name: "Vélez" },
    { code: "CO.26.68867", name: "Vetas" },
    { code: "CO.26.68872", name: "Villanueva" },
    { code: "CO.26.68895", name: "Zapatoca" },
  ],
  "CO.27": [
    { code: "CO.27.70001", name: "Sincelejo" },
    { code: "CO.27.70110", name: "Buenavista" },
    { code: "CO.27.70124", name: "Caimito" },
    { code: "CO.27.70204", name: "Coloso" },
    { code: "CO.27.70215", name: "Corozal" },
    { code: "CO.27.70221", name: "Coveñas" },
    { code: "CO.27.70230", name: "Chalán" },
    { code: "CO.27.70233", name: "El Roble" },
    { code: "CO.27.70235", name: "Galeras" },
    { code: "CO.27.70265", name: "Guaranda" },
    { code: "CO.27.70400", name: "La Unión" },
    { code: "CO.27.70418", name: "Los Palmitos" },
    { code: "CO.27.70429", name: "Majagual" },
    { code: "CO.27.70473", name: "Morroa" },
    { code: "CO.27.70508", name: "Ovejas" },
    { code: "CO.27.70523", name: "Palmito" },
    { code: "CO.27.70670", name: "Sampués" },
    { code: "CO.27.70678", name: "San Benito Abad" },
    { code: "CO.27.70702", name: "San Juan de Betulia" },
    { code: "CO.27.70708", name: "San Marcos" },
    { code: "CO.27.70713", name: "San Onofre" },
    { code: "CO.27.70717", name: "San Pedro" },
    { code: "CO.27.70742", name: "San Luis de Sincé" },
    { code: "CO.27.70771", name: "Sucre" },
    { code: "CO.27.70820", name: "Santiago de Tolú" },
    { code: "CO.27.70823", name: "Tolú Viejo" },
  ],
  "CO.28": [
    { code: "CO.28.73001", name: "Ibagué" },
    { code: "CO.28.73024", name: "Alpujarra" },
    { code: "CO.28.73026", name: "Alvarado" },
    { code: "CO.28.73030", name: "Ambalema" },
    { code: "CO.28.73043", name: "Anzoátegui" },
    { code: "CO.28.73055", name: "Armero" },
    { code: "CO.28.73067", name: "Ataco" },
    { code: "CO.28.73124", name: "Cajamarca" },
    { code: "CO.28.73148", name: "Carmen de Apicalá" },
    { code: "CO.28.73152", name: "Casabianca" },
    { code: "CO.28.73168", name: "Chaparral" },
    { code: "CO.28.73200", name: "Coello" },
    { code: "CO.28.73217", name: "Coyaima" },
    { code: "CO.28.73226", name: "Cunday" },
    { code: "CO.28.73236", name: "Dolores" },
    { code: "CO.28.73268", name: "Espinal" },
    { code: "CO.28.73270", name: "Falan" },
    { code: "CO.28.73275", name: "Flandes" },
    { code: "CO.28.73283", name: "Fresno" },
    { code: "CO.28.73319", name: "Guamo" },
    { code: "CO.28.73347", name: "Herveo" },
    { code: "CO.28.73349", name: "Honda" },
    { code: "CO.28.73352", name: "Icononzo" },
    { code: "CO.28.73408", name: "Lérida" },
    { code: "CO.28.73411", name: "Líbano" },
    { code: "CO.28.73443", name: "Municipio de San Sebastián de Mariquita" },
    { code: "CO.28.73449", name: "Melgar" },
    { code: "CO.28.73461", name: "Murillo" },
    { code: "CO.28.73483", name: "Natagaima" },
    { code: "CO.28.73504", name: "Ortega" },
    { code: "CO.28.73520", name: "Palocabildo" },
    { code: "CO.28.73547", name: "Piedras" },
    { code: "CO.28.73555", name: "Planadas" },
    { code: "CO.28.73563", name: "Prado" },
    { code: "CO.28.73585", name: "Purificación" },
    { code: "CO.28.73616", name: "Rioblanco" },
    { code: "CO.28.73622", name: "Roncesvalles" },
    { code: "CO.28.73624", name: "Rovira" },
    { code: "CO.28.73671", name: "Saldaña" },
    { code: "CO.28.73675", name: "San Antonio" },
    { code: "CO.28.73678", name: "San Luis" },
    { code: "CO.28.73686", name: "Santa Isabel" },
    { code: "CO.28.73770", name: "Suárez" },
    { code: "CO.28.73854", name: "Valle de San Juan" },
    { code: "CO.28.73861", name: "Venadillo" },
    { code: "CO.28.73870", name: "Villahermosa" },
    { code: "CO.28.73873", name: "Villarrica" },
  ],
  "CO.29": [
    { code: "CO.29.76001", name: "Cali" },
    { code: "CO.29.76020", name: "Alcalá" },
    { code: "CO.29.76036", name: "Andalucía" },
    { code: "CO.29.76041", name: "Ansermanuevo" },
    { code: "CO.29.76054", name: "Argelia" },
    { code: "CO.29.76100", name: "Bolívar" },
    { code: "CO.29.76109", name: "Buenaventura" },
    { code: "CO.29.76111", name: "Guadalajara de Buga" },
    { code: "CO.29.76113", name: "Bugalagrande" },
    { code: "CO.29.76122", name: "Caicedonia" },
    { code: "CO.29.76126", name: "Calima" },
    { code: "CO.29.76130", name: "Candelaria" },
    { code: "CO.29.76147", name: "Cartago" },
    { code: "CO.29.76233", name: "Dagua" },
    { code: "CO.29.76243", name: "El Águila" },
    { code: "CO.29.76246", name: "El Cairo" },
    { code: "CO.29.76248", name: "El Cerrito" },
    { code: "CO.29.76250", name: "El Dovio" },
    { code: "CO.29.76275", name: "Florida" },
    { code: "CO.29.76306", name: "Ginebra" },
    { code: "CO.29.76318", name: "Guacarí" },
    { code: "CO.29.76364", name: "Jamundí" },
    { code: "CO.29.76377", name: "La Cumbre" },
    { code: "CO.29.76400", name: "La Unión" },
    { code: "CO.29.76403", name: "La Victoria" },
    { code: "CO.29.76497", name: "Obando" },
    { code: "CO.29.76520", name: "Palmira" },
    { code: "CO.29.76563", name: "Pradera" },
    { code: "CO.29.76606", name: "Restrepo" },
    { code: "CO.29.76616", name: "Riofrío" },
    { code: "CO.29.76622", name: "Roldanillo" },
    { code: "CO.29.76670", name: "San Pedro" },
    { code: "CO.29.76736", name: "Sevilla" },
    { code: "CO.29.76823", name: "Toro" },
    { code: "CO.29.76828", name: "Trujillo" },
    { code: "CO.29.76834", name: "Tuluá" },
    { code: "CO.29.76845", name: "Ulloa" },
    { code: "CO.29.76863", name: "Versalles" },
    { code: "CO.29.76869", name: "Vijes" },
    { code: "CO.29.76890", name: "Yotoco" },
    { code: "CO.29.76892", name: "Yumbo" },
    { code: "CO.29.76895", name: "Zarzal" },
  ],
  "CO.30": [
    { code: "CO.30.97001", name: "Mitú" },
    { code: "CO.30.97161", name: "Caruru" },
    { code: "CO.30.97511", name: "Pacoa" },
    { code: "CO.30.97666", name: "Taraira" },
    { code: "CO.30.97777", name: "Papunaua" },
    { code: "CO.30.97889", name: "Yavaraté" },
  ],
  "CO.31": [
    { code: "CO.31.99001", name: "Puerto Carreño" },
    { code: "CO.31.99524", name: "La Primavera" },
    { code: "CO.31.99624", name: "Santa Rosalía" },
    { code: "CO.31.99773", name: "Cumaribo" },
  ],
  "CO.32": [
    { code: "CO.32.85001", name: "Yopal" },
    { code: "CO.32.85010", name: "Aguazul" },
    { code: "CO.32.85015", name: "Chameza" },
    { code: "CO.32.85125", name: "Hato Corozal" },
    { code: "CO.32.85136", name: "La Salina" },
    { code: "CO.32.85139", name: "Maní" },
    { code: "CO.32.85162", name: "Monterrey" },
    { code: "CO.32.85225", name: "Nunchía" },
    { code: "CO.32.85230", name: "Orocué" },
    { code: "CO.32.85250", name: "Paz de Ariporo" },
    { code: "CO.32.85263", name: "Pore" },
    { code: "CO.32.85279", name: "Recetor" },
    { code: "CO.32.85300", name: "Sabanalarga" },
    { code: "CO.32.85315", name: "Sácama" },
    { code: "CO.32.85325", name: "San Luis de Palenque" },
    { code: "CO.32.85400", name: "Támara" },
    { code: "CO.32.85410", name: "Tauramena" },
    { code: "CO.32.85430", name: "Trinidad" },
    { code: "CO.32.85440", name: "Villanueva" },
  ],
  "CO.33": [
    { code: "CO.33.25001", name: "Agua de Dios" },
    { code: "CO.33.25019", name: "Albán" },
    { code: "CO.33.25035", name: "Anapoima" },
    { code: "CO.33.25040", name: "Anolaima" },
    { code: "CO.33.25053", name: "Arbeláez" },
    { code: "CO.33.25086", name: "Beltrán" },
    { code: "CO.33.25095", name: "Bituima" },
    { code: "CO.33.25099", name: "Bojacá" },
    { code: "CO.33.25120", name: "Cabrera" },
    { code: "CO.33.25123", name: "Cachipay" },
    { code: "CO.33.25126", name: "Cajicá" },
    { code: "CO.33.25148", name: "Caparrapí" },
    { code: "CO.33.25151", name: "Caqueza" },
    { code: "CO.33.25154", name: "Carmen de Carupa" },
    { code: "CO.33.25168", name: "Chaguaní" },
    { code: "CO.33.25175", name: "Chía" },
    { code: "CO.33.25178", name: "Chipaque" },
    { code: "CO.33.25181", name: "Choachí" },
    { code: "CO.33.25183", name: "Chocontá" },
    { code: "CO.33.25200", name: "Cogua" },
    { code: "CO.33.25214", name: "Cota" },
    { code: "CO.33.25224", name: "Cucunubá" },
    { code: "CO.33.25245", name: "El Colegio" },
    { code: "CO.33.25258", name: "El Peñón" },
    { code: "CO.33.25260", name: "El Rosal" },
    { code: "CO.33.25269", name: "Facatativá" },
    { code: "CO.33.25279", name: "Fomeque" },
    { code: "CO.33.25281", name: "Fosca" },
    { code: "CO.33.25286", name: "Funza" },
    { code: "CO.33.25288", name: "Fúquene" },
    { code: "CO.33.25290", name: "Fusagasugá" },
    { code: "CO.33.25293", name: "Gachala" },
    { code: "CO.33.25295", name: "Gachancipá" },
    { code: "CO.33.25297", name: "Gachetá" },
    { code: "CO.33.25299", name: "Gama" },
    { code: "CO.33.25307", name: "Girardot" },
    { code: "CO.33.25312", name: "Granada" },
    { code: "CO.33.25317", name: "Guachetá" },
    { code: "CO.33.25320", name: "Guaduas" },
    { code: "CO.33.25322", name: "Guasca" },
    { code: "CO.33.25324", name: "Guataquí" },
    { code: "CO.33.25326", name: "Guatavita" },
    { code: "CO.33.25328", name: "Guayabal de Siquima" },
    { code: "CO.33.25335", name: "Guayabetal" },
    { code: "CO.33.25339", name: "Gutiérrez" },
    { code: "CO.33.25368", name: "Jerusalén" },
    { code: "CO.33.25372", name: "Junín" },
    { code: "CO.33.25377", name: "La Calera" },
    { code: "CO.33.25386", name: "La Mesa" },
    { code: "CO.33.25394", name: "La Palma" },
    { code: "CO.33.25398", name: "La Peña" },
    { code: "CO.33.25402", name: "La Vega" },
    { code: "CO.33.25407", name: "Lenguazaque" },
    { code: "CO.33.25426", name: "Macheta" },
    { code: "CO.33.25430", name: "Madrid" },
    { code: "CO.33.25436", name: "Manta" },
    { code: "CO.33.25438", name: "Medina" },
    { code: "CO.33.25473", name: "Mosquera" },
    { code: "CO.33.25483", name: "Nariño" },
    { code: "CO.33.25486", name: "Nemocón" },
    { code: "CO.33.25488", name: "Nilo" },
    { code: "CO.33.25489", name: "Nimaima" },
    { code: "CO.33.25491", name: "Nocaima" },
    { code: "CO.33.25506", name: "Venecia" },
    { code: "CO.33.25513", name: "Pacho" },
    { code: "CO.33.25518", name: "Paime" },
    { code: "CO.33.25524", name: "Pandi" },
    { code: "CO.33.25530", name: "Paratebueno" },
    { code: "CO.33.25535", name: "Pasca" },
    { code: "CO.33.25572", name: "Puerto Salgar" },
    { code: "CO.33.25580", name: "Pulí" },
    { code: "CO.33.25592", name: "Quebradanegra" },
    { code: "CO.33.25594", name: "Quetame" },
    { code: "CO.33.25596", name: "Quipile" },
    { code: "CO.33.25599", name: "Apulo" },
    { code: "CO.33.25612", name: "Ricaurte" },
    { code: "CO.33.25645", name: "San Antonio del Tequendama" },
    { code: "CO.33.25649", name: "San Bernardo" },
    { code: "CO.33.25653", name: "San Cayetano" },
    { code: "CO.33.25658", name: "San Francisco" },
    { code: "CO.33.25662", name: "San Juan de Río Seco" },
    { code: "CO.33.25718", name: "Sasaima" },
    { code: "CO.33.25736", name: "Sesquilé" },
    { code: "CO.33.25740", name: "Sibaté" },
    { code: "CO.33.25743", name: "Silvania" },
    { code: "CO.33.25745", name: "Simijaca" },
    { code: "CO.33.25754", name: "Soacha" },
    { code: "CO.33.25758", name: "Sopó" },
    { code: "CO.33.25769", name: "Subachoque" },
    { code: "CO.33.25772", name: "Suesca" },
    { code: "CO.33.25777", name: "Supatá" },
    { code: "CO.33.25779", name: "Susa" },
    { code: "CO.33.25781", name: "Sutatausa" },
    { code: "CO.33.25785", name: "Tabio" },
    { code: "CO.33.25793", name: "Tausa" },
    { code: "CO.33.25797", name: "Tena" },
    { code: "CO.33.25799", name: "Tenjo" },
    { code: "CO.33.25805", name: "Tibacuy" },
    { code: "CO.33.25807", name: "Tibirita" },
    { code: "CO.33.25815", name: "Tocaima" },
    { code: "CO.33.25817", name: "Tocancipá" },
    { code: "CO.33.25823", name: "Topaipí" },
    { code: "CO.33.25839", name: "Ubalá" },
    { code: "CO.33.25841", name: "Ubaque" },
    { code: "CO.33.25843", name: "Villa de San Diego de Ubate" },
    { code: "CO.33.25845", name: "Une" },
    { code: "CO.33.25851", name: "Útica" },
    { code: "CO.33.25862", name: "Vergara" },
    { code: "CO.33.25867", name: "Vianí" },
    { code: "CO.33.25871", name: "Villagómez" },
    { code: "CO.33.25873", name: "Villapinzón" },
    { code: "CO.33.25875", name: "Villeta" },
    { code: "CO.33.25878", name: "Viotá" },
    { code: "CO.33.25885", name: "Yacopí" },
    { code: "CO.33.25898", name: "Zipacón" },
    { code: "CO.33.25899", name: "Zipaquirá" },
  ],
  "CO.34": [
    { code: "CO.34.11001", name: "Bogotá  D.C." },
  ],
  "CO.35": [
    { code: "CO.35.13001", name: "Municipio de Cartagena de Indias" },
    { code: "CO.35.13006", name: "Achí" },
    { code: "CO.35.13030", name: "Altos del Rosario" },
    { code: "CO.35.13042", name: "Arenal" },
    { code: "CO.35.13052", name: "Arjona" },
    { code: "CO.35.13062", name: "Arroyohondo" },
    { code: "CO.35.13074", name: "Barranco de Loba" },
    { code: "CO.35.13140", name: "Calamar" },
    { code: "CO.35.13160", name: "Cantagallo" },
    { code: "CO.35.13188", name: "Cicuco" },
    { code: "CO.35.13212", name: "Córdoba" },
    { code: "CO.35.13222", name: "Clemencia" },
    { code: "CO.35.13244", name: "El Carmen de Bolívar" },
    { code: "CO.35.13248", name: "El Guamo" },
    { code: "CO.35.13268", name: "El Peñón" },
    { code: "CO.35.13300", name: "Hatillo de Loba" },
    { code: "CO.35.13430", name: "Magangué" },
    { code: "CO.35.13433", name: "Mahates" },
    { code: "CO.35.13440", name: "Margarita" },
    { code: "CO.35.13442", name: "Municipio de María la Baja" },
    { code: "CO.35.13458", name: "Montecristo" },
    { code: "CO.35.13468", name: "Mompós" },
    { code: "CO.35.13473", name: "Morales" },
    { code: "CO.35.13490", name: "Norosi" },
    { code: "CO.35.13549", name: "Pinillos" },
    { code: "CO.35.13580", name: "Regidor" },
    { code: "CO.35.13600", name: "Río Viejo" },
    { code: "CO.35.13620", name: "San Cristóbal" },
    { code: "CO.35.13647", name: "San Estanislao" },
    { code: "CO.35.13650", name: "San Fernando" },
    { code: "CO.35.13654", name: "San Jacinto" },
    { code: "CO.35.13655", name: "San Jacinto del Cauca" },
    { code: "CO.35.13657", name: "San Juan Nepomuceno" },
    { code: "CO.35.13667", name: "San Martín de Loba" },
    { code: "CO.35.13670", name: "San Pablo" },
    { code: "CO.35.13673", name: "Santa Catalina" },
    { code: "CO.35.13683", name: "Santa Rosa" },
    { code: "CO.35.13688", name: "Santa Rosa del Sur" },
    { code: "CO.35.13744", name: "Simití" },
    { code: "CO.35.13760", name: "Soplaviento" },
    { code: "CO.35.13780", name: "Talaigua Nuevo" },
    { code: "CO.35.13810", name: "Tiquisio" },
    { code: "CO.35.13836", name: "Turbaco" },
    { code: "CO.35.13838", name: "Turbaná" },
    { code: "CO.35.13873", name: "Villanueva" },
    { code: "CO.35.13894", name: "Zambrano" },
  ],
  "CO.36": [
    { code: "CO.36.15001", name: "Tunja" },
    { code: "CO.36.15022", name: "Almeida" },
    { code: "CO.36.15047", name: "Aquitania" },
    { code: "CO.36.15051", name: "Arcabuco" },
    { code: "CO.36.15087", name: "Belén" },
    { code: "CO.36.15090", name: "Berbeo" },
    { code: "CO.36.15092", name: "Betéitiva" },
    { code: "CO.36.15097", name: "Boavita" },
    { code: "CO.36.15104", name: "Boyacá" },
    { code: "CO.36.15106", name: "Briceño" },
    { code: "CO.36.15109", name: "Buenavista" },
    { code: "CO.36.15114", name: "Busbanzá" },
    { code: "CO.36.15131", name: "Caldas" },
    { code: "CO.36.15135", name: "Campohermoso" },
    { code: "CO.36.15162", name: "Cerinza" },
    { code: "CO.36.15172", name: "Chinavita" },
    { code: "CO.36.15176", name: "Chiquinquirá" },
    { code: "CO.36.15180", name: "Chiscas" },
    { code: "CO.36.15183", name: "Chita" },
    { code: "CO.36.15185", name: "Chitaraque" },
    { code: "CO.36.15187", name: "Chivatá" },
    { code: "CO.36.15189", name: "Ciénega" },
    { code: "CO.36.15204", name: "Cómbita" },
    { code: "CO.36.15212", name: "Coper" },
    { code: "CO.36.15215", name: "Corrales" },
    { code: "CO.36.15218", name: "Covarachía" },
    { code: "CO.36.15223", name: "Cubará" },
    { code: "CO.36.15224", name: "Cucaita" },
    { code: "CO.36.15226", name: "Cuítiva" },
    { code: "CO.36.15232", name: "Chíquiza" },
    { code: "CO.36.15236", name: "Chivor" },
    { code: "CO.36.15238", name: "Duitama" },
    { code: "CO.36.15244", name: "El Cocuy" },
    { code: "CO.36.15248", name: "El Espino" },
    { code: "CO.36.15272", name: "Firavitoba" },
    { code: "CO.36.15276", name: "Floresta" },
    { code: "CO.36.15293", name: "Gachantivá" },
    { code: "CO.36.15296", name: "Gameza" },
    { code: "CO.36.15299", name: "Garagoa" },
    { code: "CO.36.15317", name: "Guacamayas" },
    { code: "CO.36.15322", name: "Guateque" },
    { code: "CO.36.15325", name: "Guayatá" },
    { code: "CO.36.15332", name: "Güicán" },
    { code: "CO.36.15362", name: "Iza" },
    { code: "CO.36.15367", name: "Jenesano" },
    { code: "CO.36.15368", name: "Jericó" },
    { code: "CO.36.15377", name: "Labranzagrande" },
    { code: "CO.36.15380", name: "La Capilla" },
    { code: "CO.36.15401", name: "La Victoria" },
    { code: "CO.36.15403", name: "La Uvita" },
    { code: "CO.36.15407", name: "Villa de Leyva" },
    { code: "CO.36.15425", name: "Macanal" },
    { code: "CO.36.15442", name: "Maripí" },
    { code: "CO.36.15455", name: "Miraflores" },
    { code: "CO.36.15464", name: "Mongua" },
    { code: "CO.36.15466", name: "Monguí" },
    { code: "CO.36.15469", name: "Moniquirá" },
    { code: "CO.36.15476", name: "Motavita" },
    { code: "CO.36.15480", name: "Muzo" },
    { code: "CO.36.15491", name: "Nobsa" },
    { code: "CO.36.15494", name: "Nuevo Colón" },
    { code: "CO.36.15500", name: "Oicatá" },
    { code: "CO.36.15507", name: "Otanche" },
    { code: "CO.36.15511", name: "Pachavita" },
    { code: "CO.36.15514", name: "Páez" },
    { code: "CO.36.15516", name: "Paipa" },
    { code: "CO.36.15518", name: "Pajarito" },
    { code: "CO.36.15522", name: "Panqueba" },
    { code: "CO.36.15531", name: "Pauna" },
    { code: "CO.36.15533", name: "Paya" },
    { code: "CO.36.15537", name: "Paz de Río" },
    { code: "CO.36.15542", name: "Pesca" },
    { code: "CO.36.15550", name: "Pisba" },
    { code: "CO.36.15572", name: "Puerto Boyacá" },
    { code: "CO.36.15580", name: "Quípama" },
    { code: "CO.36.15599", name: "Ramiriquí" },
    { code: "CO.36.15600", name: "Ráquira" },
    { code: "CO.36.15621", name: "Rondón" },
    { code: "CO.36.15632", name: "Saboyá" },
    { code: "CO.36.15638", name: "Sáchica" },
    { code: "CO.36.15646", name: "Samacá" },
    { code: "CO.36.15660", name: "San Eduardo" },
    { code: "CO.36.15664", name: "San José de Pare" },
    { code: "CO.36.15667", name: "San Luis de Gaceno" },
    { code: "CO.36.15673", name: "San Mateo" },
    { code: "CO.36.15676", name: "San Miguel de Sema" },
    { code: "CO.36.15681", name: "San Pablo de Borbur" },
    { code: "CO.36.15686", name: "Santana" },
    { code: "CO.36.15690", name: "Santa María" },
    { code: "CO.36.15693", name: "Santa Rosa de Viterbo" },
    { code: "CO.36.15696", name: "Santa Sofía" },
    { code: "CO.36.15720", name: "Sativanorte" },
    { code: "CO.36.15723", name: "Sativasur" },
    { code: "CO.36.15740", name: "Siachoque" },
    { code: "CO.36.15753", name: "Soatá" },
    { code: "CO.36.15755", name: "Socotá" },
    { code: "CO.36.15757", name: "Socha" },
    { code: "CO.36.15759", name: "Sogamoso" },
    { code: "CO.36.15761", name: "Somondoco" },
    { code: "CO.36.15762", name: "Sora" },
    { code: "CO.36.15763", name: "Sotaquirá" },
    { code: "CO.36.15764", name: "Soracá" },
    { code: "CO.36.15774", name: "Susacón" },
    { code: "CO.36.15776", name: "Sutamarchán" },
    { code: "CO.36.15778", name: "Sutatenza" },
    { code: "CO.36.15790", name: "Tasco" },
    { code: "CO.36.15798", name: "Tenza" },
    { code: "CO.36.15804", name: "Tibaná" },
    { code: "CO.36.15806", name: "Tibasosa" },
    { code: "CO.36.15808", name: "Tinjacá" },
    { code: "CO.36.15810", name: "Tipacoque" },
    { code: "CO.36.15814", name: "Toca" },
    { code: "CO.36.15816", name: "Togüí" },
    { code: "CO.36.15820", name: "Tópaga" },
    { code: "CO.36.15822", name: "Tota" },
    { code: "CO.36.15832", name: "Tununguá" },
    { code: "CO.36.15835", name: "Turmequé" },
    { code: "CO.36.15837", name: "Tuta" },
    { code: "CO.36.15839", name: "Tutazá" },
    { code: "CO.36.15842", name: "Umbita" },
    { code: "CO.36.15861", name: "Ventaquemada" },
    { code: "CO.36.15879", name: "Viracachá" },
    { code: "CO.36.15897", name: "Zetaquira" },
  ],
  "CO.37": [
    { code: "CO.37.17001", name: "Manizales" },
    { code: "CO.37.17013", name: "Aguadas" },
    { code: "CO.37.17042", name: "Anserma" },
    { code: "CO.37.17050", name: "Aranzazu" },
    { code: "CO.37.17088", name: "Belalcázar" },
    { code: "CO.37.17174", name: "Chinchiná" },
    { code: "CO.37.17272", name: "Filadelfia" },
    { code: "CO.37.17380", name: "La Dorada" },
    { code: "CO.37.17388", name: "La Merced" },
    { code: "CO.37.17433", name: "Manzanares" },
    { code: "CO.37.17442", name: "Marmato" },
    { code: "CO.37.17444", name: "Marquetalia" },
    { code: "CO.37.17446", name: "Marulanda" },
    { code: "CO.37.17486", name: "Neira" },
    { code: "CO.37.17495", name: "Norcasia" },
    { code: "CO.37.17513", name: "Pácora" },
    { code: "CO.37.17524", name: "Palestina" },
    { code: "CO.37.17541", name: "Pensilvania" },
    { code: "CO.37.17614", name: "Riosucio" },
    { code: "CO.37.17616", name: "Risaralda" },
    { code: "CO.37.17653", name: "Salamina" },
    { code: "CO.37.17662", name: "Samaná" },
    { code: "CO.37.17665", name: "San José" },
    { code: "CO.37.17777", name: "Supía" },
    { code: "CO.37.17867", name: "Victoria" },
    { code: "CO.37.17873", name: "Villamaría" },
    { code: "CO.37.17877", name: "Viterbo" },
  ],
  "CO.38": [
    { code: "CO.38.47001", name: "Santa Marta" },
    { code: "CO.38.47030", name: "Algarrobo" },
    { code: "CO.38.47053", name: "Aracataca" },
    { code: "CO.38.47058", name: "Ariguaní" },
    { code: "CO.38.47161", name: "Cerro San Antonio" },
    { code: "CO.38.47170", name: "Chibolo" },
    { code: "CO.38.47189", name: "Ciénaga" },
    { code: "CO.38.47205", name: "Concordia" },
    { code: "CO.38.47245", name: "El Banco" },
    { code: "CO.38.47258", name: "El Piñon" },
    { code: "CO.38.47268", name: "El Retén" },
    { code: "CO.38.47288", name: "Fundación" },
    { code: "CO.38.47318", name: "Guamal" },
    { code: "CO.38.47460", name: "Nueva Granada" },
    { code: "CO.38.47541", name: "Pedraza" },
    { code: "CO.38.47545", name: "Pijiño del Carmen" },
    { code: "CO.38.47551", name: "Pivijay" },
    { code: "CO.38.47555", name: "Plato" },
    { code: "CO.38.47570", name: "Puebloviejo" },
    { code: "CO.38.47605", name: "Remolino" },
    { code: "CO.38.47660", name: "Sabanas de San Angel" },
    { code: "CO.38.47675", name: "Salamina" },
    { code: "CO.38.47692", name: "San Sebastián de Buenavista" },
    { code: "CO.38.47703", name: "San Zenón" },
    { code: "CO.38.47707", name: "Santa Ana" },
    { code: "CO.38.47720", name: "Santa Bárbara de Pinto" },
    { code: "CO.38.47745", name: "Sitionuevo" },
    { code: "CO.38.47798", name: "Tenerife" },
    { code: "CO.38.47960", name: "Zapayán" },
    { code: "CO.38.47980", name: "Zona Bananera" },
  ],
  "CR.01": [
    { code: "CR.01.201", name: "Alajuela" },
    { code: "CR.01.202", name: "San Ramón" },
    { code: "CR.01.203", name: "Grecia" },
    { code: "CR.01.204", name: "San Mateo" },
    { code: "CR.01.205", name: "Atenas" },
    { code: "CR.01.206", name: "Naranjo" },
    { code: "CR.01.207", name: "Palmares" },
    { code: "CR.01.208", name: "Poás" },
    { code: "CR.01.209", name: "Orotina" },
    { code: "CR.01.210", name: "San Carlos" },
    { code: "CR.01.211", name: "Zarcero" },
    { code: "CR.01.212", name: "Valverde Vega" },
    { code: "CR.01.213", name: "Upala" },
    { code: "CR.01.214", name: "Los Chiles" },
    { code: "CR.01.215", name: "Guatuso" },
    { code: "CR.01.216", name: "Río Cuarto" },
  ],
  "CR.02": [
    { code: "CR.02.301", name: "Cartago" },
    { code: "CR.02.302", name: "Paraíso" },
    { code: "CR.02.303", name: "La Unión" },
    { code: "CR.02.304", name: "Jiménez" },
    { code: "CR.02.305", name: "Turrialba" },
    { code: "CR.02.306", name: "Alvarado" },
    { code: "CR.02.307", name: "Oreamuno" },
    { code: "CR.02.308", name: "El Guarco" },
  ],
  "CR.03": [
    { code: "CR.03.501", name: "Liberia" },
    { code: "CR.03.502", name: "Nicoya" },
    { code: "CR.03.503", name: "Santa Cruz" },
    { code: "CR.03.504", name: "Bagaces" },
    { code: "CR.03.505", name: "Carrillo" },
    { code: "CR.03.506", name: "Cañas" },
    { code: "CR.03.507", name: "Abangares" },
    { code: "CR.03.508", name: "Tilarán" },
    { code: "CR.03.509", name: "Nandayure" },
    { code: "CR.03.510", name: "La Cruz" },
    { code: "CR.03.511", name: "Hojancha" },
  ],
  "CR.04": [
    { code: "CR.04.401", name: "Heredia" },
    { code: "CR.04.402", name: "Barva" },
    { code: "CR.04.403", name: "Santo Domingo" },
    { code: "CR.04.404", name: "Santa Bárbara" },
    { code: "CR.04.405", name: "San Rafael" },
    { code: "CR.04.406", name: "San Isidro" },
    { code: "CR.04.407", name: "Belén" },
    { code: "CR.04.408", name: "Flores" },
    { code: "CR.04.409", name: "San Pablo" },
    { code: "CR.04.410", name: "Sarapiquí" },
  ],
  "CR.06": [
    { code: "CR.06.701", name: "Limón" },
    { code: "CR.06.702", name: "Pococí" },
    { code: "CR.06.703", name: "Siquirres" },
    { code: "CR.06.704", name: "Talamanca" },
    { code: "CR.06.705", name: "Matina" },
    { code: "CR.06.706", name: "Guácimo" },
  ],
  "CR.07": [
    { code: "CR.07.601", name: "Puntarenas" },
    { code: "CR.07.602", name: "Esparza" },
    { code: "CR.07.603", name: "Buenos Aires" },
    { code: "CR.07.604", name: "Montes de Oro" },
    { code: "CR.07.605", name: "Osa" },
    { code: "CR.07.606", name: "Quepos" },
    { code: "CR.07.607", name: "Golfito" },
    { code: "CR.07.608", name: "Coto Brus" },
    { code: "CR.07.609", name: "Parrita" },
    { code: "CR.07.610", name: "Corredores" },
    { code: "CR.07.611", name: "Garabito" },
  ],
  "CR.08": [
    { code: "CR.08.101", name: "San José" },
    { code: "CR.08.102", name: "Escazú" },
    { code: "CR.08.103", name: "Desamparados" },
    { code: "CR.08.104", name: "Puriscal" },
    { code: "CR.08.105", name: "Tarrazú" },
    { code: "CR.08.106", name: "Aserrí" },
    { code: "CR.08.107", name: "Mora" },
    { code: "CR.08.108", name: "Goicoechea" },
    { code: "CR.08.109", name: "Santa Ana" },
    { code: "CR.08.110", name: "Alajuelita" },
    { code: "CR.08.111", name: "Vázquez de Coronado" },
    { code: "CR.08.112", name: "Acosta" },
    { code: "CR.08.113", name: "Tibás" },
    { code: "CR.08.114", name: "Moravia" },
    { code: "CR.08.115", name: "Montes de Oca" },
    { code: "CR.08.116", name: "Turrubares" },
    { code: "CR.08.117", name: "Dota" },
    { code: "CR.08.118", name: "Curridabat" },
    { code: "CR.08.119", name: "Pérez Zeledón" },
    { code: "CR.08.120", name: "León Cortés" },
  ],
  "CU.01": [
    { code: "CU.01.2101", name: "Sandino" },
    { code: "CU.01.2102", name: "Municipio de Mantua" },
    { code: "CU.01.2103", name: "Minas De Matahambre" },
    { code: "CU.01.2104", name: "Municipio de Viñales" },
    { code: "CU.01.2105", name: "Municipio de La Palma" },
    { code: "CU.01.2106", name: "Municipio de Los Palacios" },
    { code: "CU.01.2107", name: "Municipio de Consolación del Sur" },
    { code: "CU.01.2108", name: "Municipio de Pinar del Río" },
    { code: "CU.01.2109", name: "Municipio de San Luis" },
    { code: "CU.01.2110", name: "Municipio de San Juan y Martínez" },
    { code: "CU.01.2111", name: "Municipio de Guane" },
  ],
  "CU.02": [
    { code: "CU.02.2301", name: "Playa" },
    { code: "CU.02.2302", name: "Plaza De La Revolucion" },
    { code: "CU.02.2303", name: "Centro Habana" },
    { code: "CU.02.2304", name: "La Habana Vieja" },
    { code: "CU.02.2305", name: "Municipio de Regla" },
    { code: "CU.02.2306", name: "La Habana Del Este" },
    { code: "CU.02.2307", name: "Municipio de Guanabacoa" },
    { code: "CU.02.2308", name: "San Miguel Del Padron" },
    { code: "CU.02.2309", name: "Diez De Octubre" },
    { code: "CU.02.2310", name: "Cerro" },
    { code: "CU.02.2311", name: "Municipio de Marianao" },
    { code: "CU.02.2312", name: "La Lisa" },
    { code: "CU.02.2313", name: "Boyeros" },
    { code: "CU.02.2314", name: "Arroyo Naranjo" },
    { code: "CU.02.2315", name: "Cotorro" },
  ],
  "CU.03": [
    { code: "CU.03.2501", name: "Municipio de Matanzas" },
    { code: "CU.03.2502", name: "Municipio de Cárdenas" },
    { code: "CU.03.2503", name: "Municipio de Martí" },
    { code: "CU.03.2504", name: "Municipio de Colón" },
    { code: "CU.03.2505", name: "Municipio de Perico" },
    { code: "CU.03.2506", name: "Municipio de Jovellanos" },
    { code: "CU.03.2507", name: "Municipio de Pedro Betancourt" },
    { code: "CU.03.2508", name: "Limonar" },
    { code: "CU.03.2509", name: "Municipio de Unión de Reyes" },
    { code: "CU.03.2510", name: "Cienaga De Zapata" },
    { code: "CU.03.2511", name: "Municipio de Jagüey Grande" },
    { code: "CU.03.2512", name: "Calimete" },
    { code: "CU.03.2513", name: "Municipio de Los Arabos" },
  ],
  "CU.05": [
    { code: "CU.05.3001", name: "Carlos Manuel De Cespedes" },
    { code: "CU.05.3002", name: "Municipio de Esmeralda" },
    { code: "CU.05.3003", name: "Sierra De Cubitas" },
    { code: "CU.05.3004", name: "Minas" },
    { code: "CU.05.3005", name: "Municipio de Nuevitas" },
    { code: "CU.05.3006", name: "Municipio de Guáimaro" },
    { code: "CU.05.3007", name: "Sibanicu" },
    { code: "CU.05.3008", name: "Municipio de Camagüey" },
    { code: "CU.05.3009", name: "Municipio de Florida" },
    { code: "CU.05.3010", name: "Vertientes" },
    { code: "CU.05.3011", name: "Jimaguayu" },
    { code: "CU.05.3012", name: "Najasa" },
    { code: "CU.05.3013", name: "Municipio de Santa Cruz del Sur" },
  ],
  "CU.07": [
    { code: "CU.07.2901", name: "Municipio de Chambas" },
    { code: "CU.07.2902", name: "Municipio de Morón" },
    { code: "CU.07.2903", name: "Bolivia" },
    { code: "CU.07.2904", name: "Primero De Enero" },
    { code: "CU.07.2905", name: "Municipio de Ciro Redondo" },
    { code: "CU.07.2906", name: "Florencia" },
    { code: "CU.07.2907", name: "Majagua" },
    { code: "CU.07.2908", name: "Municipio de Ciego de Ávila" },
    { code: "CU.07.2909", name: "Venezuela" },
    { code: "CU.07.2910", name: "Municipio de Baraguá" },
  ],
  "CU.08": [
    { code: "CU.08.2701", name: "Municipio de Aguada de Pasajeros" },
    { code: "CU.08.2702", name: "Municipio de Rodas" },
    { code: "CU.08.2703", name: "Municipio de Palmira" },
    { code: "CU.08.2704", name: "Municipio de Santa Isabel de las Lajas" },
    { code: "CU.08.2705", name: "Municipio de Cruces" },
    { code: "CU.08.2706", name: "Cumanayagua" },
    { code: "CU.08.2707", name: "Municipio de Cienfuegos" },
    { code: "CU.08.2708", name: "Municipio de Abreus" },
  ],
  "CU.09": [
    { code: "CU.09.3301", name: "Municipio de Río Cauto" },
    { code: "CU.09.3302", name: "Cauto Cristo" },
    { code: "CU.09.3303", name: "Municipio de Jiguaní" },
    { code: "CU.09.3304", name: "Municipio de Bayamo" },
    { code: "CU.09.3305", name: "Yara" },
    { code: "CU.09.3306", name: "Municipio de Manzanillo" },
    { code: "CU.09.3307", name: "Municipio de Campechuela" },
    { code: "CU.09.3308", name: "Media Luna" },
    { code: "CU.09.3309", name: "Municipio de Niquero" },
    { code: "CU.09.3310", name: "Pilon" },
    { code: "CU.09.3311", name: "Bartolome Maso" },
    { code: "CU.09.3312", name: "Buey Arriba" },
    { code: "CU.09.3313", name: "Guisa" },
  ],
  "CU.10": [
    { code: "CU.10.3501", name: "El Salvador" },
    { code: "CU.10.3502", name: "Manuel Tames" },
    { code: "CU.10.3503", name: "Municipio de Yateras" },
    { code: "CU.10.3504", name: "Municipio de Baracoa" },
    { code: "CU.10.3505", name: "Maisi" },
    { code: "CU.10.3506", name: "Imias" },
    { code: "CU.10.3507", name: "San Antonio Del Sur" },
    { code: "CU.10.3508", name: "Caimanera" },
    { code: "CU.10.3509", name: "Municipio de Guantánamo" },
    { code: "CU.10.3510", name: "Niceto Perez" },
  ],
  "CU.12": [
    { code: "CU.12.3201", name: "Municipio de Gibara" },
    { code: "CU.12.3202", name: "Rafael Freyre" },
    { code: "CU.12.3203", name: "Municipio de Banes" },
    { code: "CU.12.3204", name: "Municipio de Antilla" },
    { code: "CU.12.3205", name: "Baguanos" },
    { code: "CU.12.3206", name: "Municipio de Holguín" },
    { code: "CU.12.3207", name: "Municipio de Calixto Garcia" },
    { code: "CU.12.3208", name: "Cacocum" },
    { code: "CU.12.3209", name: "Urbano Noris" },
    { code: "CU.12.3210", name: "Cueto" },
    { code: "CU.12.3211", name: "Municipio de Mayarí" },
    { code: "CU.12.3212", name: "Frank Pais" },
    { code: "CU.12.3213", name: "Municipio de Sagua de Tánamo" },
    { code: "CU.12.3214", name: "Moa" },
  ],
  "CU.13": [
    { code: "CU.13.3101", name: "Municipio de Manatí" },
    { code: "CU.13.3102", name: "Municipio de Puerto Padre" },
    { code: "CU.13.3103", name: "Municipio de Jesús Menéndez" },
    { code: "CU.13.3104", name: "Majibacoa" },
    { code: "CU.13.3105", name: "Municipio de Las Tunas" },
    { code: "CU.13.3106", name: "Municipio de Jobabo" },
    { code: "CU.13.3107", name: "Colombia" },
    { code: "CU.13.3108", name: "Amancio" },
  ],
  "CU.14": [
    { code: "CU.14.2801", name: "Municipio de Yaguajay" },
    { code: "CU.14.2802", name: "Municipio de Jatibonico" },
    { code: "CU.14.2803", name: "Taguasco" },
    { code: "CU.14.2804", name: "Municipio de Cabaiguán" },
    { code: "CU.14.2805", name: "Municipio de Fomento" },
    { code: "CU.14.2806", name: "Municipio de Trinidad" },
    { code: "CU.14.2807", name: "Municipio de Sancti Spíritus" },
    { code: "CU.14.2808", name: "La Sierpe" },
  ],
  "CU.15": [
    { code: "CU.15.3401", name: "Contramaestre" },
    { code: "CU.15.3402", name: "Mella" },
    { code: "CU.15.3403", name: "Municipio de San Luis" },
    { code: "CU.15.3404", name: "Segundo Frente" },
    { code: "CU.15.3405", name: "Songo - La Maya" },
    { code: "CU.15.3406", name: "Municipio de Santiago de Cuba" },
    { code: "CU.15.3407", name: "Municipio de Palma Soriano" },
    { code: "CU.15.3408", name: "Tercer Frente" },
    { code: "CU.15.3409", name: "Guama" },
  ],
  "CU.16": [
    { code: "CU.16.2601", name: "Municipio de Corralillo" },
    { code: "CU.16.2602", name: "Municipio de Quemado de Güines" },
    { code: "CU.16.2603", name: "Municipio de Sagua la Grande" },
    { code: "CU.16.2604", name: "Municipio de Encrucijada" },
    { code: "CU.16.2605", name: "Municipio de Camajuaní" },
    { code: "CU.16.2606", name: "Municipio de Caibarién" },
    { code: "CU.16.2607", name: "Remedios" },
    { code: "CU.16.2608", name: "Municipio de Placetas" },
    { code: "CU.16.2609", name: "Municipio de Santa Clara" },
    { code: "CU.16.2610", name: "Municipio de Cifuentes" },
    { code: "CU.16.2611", name: "Municipio de Santo Domingo" },
    { code: "CU.16.2612", name: "Municipio de Ranchuelo" },
    { code: "CU.16.2613", name: "Manicaragua" },
  ],
  "CU.AR": [
    { code: "CU.AR.2201", name: "Bahia Honda" },
    { code: "CU.AR.2202", name: "Municipio de Mariel" },
    { code: "CU.AR.2203", name: "Municipio de Guanajay" },
    { code: "CU.AR.2204", name: "Municipio de Caimito" },
    { code: "CU.AR.2205", name: "Municipio de Bauta" },
    { code: "CU.AR.2206", name: "Municipio de San Antonio de los Baños" },
    { code: "CU.AR.2207", name: "Municipio de Güira de Melena" },
    { code: "CU.AR.2208", name: "Municipio de Alquízar" },
    { code: "CU.AR.2209", name: "Municipio de Artemisa" },
    { code: "CU.AR.2210", name: "Municipio de Candelaria" },
    { code: "CU.AR.2211", name: "Municipio de San Cristóbal" },
  ],
  "CU.MA": [
    { code: "CU.MA.2401", name: "Municipio de Bejucal" },
    { code: "CU.MA.2402", name: "Municipio de San José de las Lajas" },
    { code: "CU.MA.2403", name: "Municipio de Jaruco" },
    { code: "CU.MA.2404", name: "Municipio de Santa Cruz del Norte" },
    { code: "CU.MA.2405", name: "Municipio de Madruga" },
    { code: "CU.MA.2406", name: "Municipio de Nueva Paz" },
    { code: "CU.MA.2407", name: "Municipio de San Nicolás" },
    { code: "CU.MA.2408", name: "Municipio de Güines" },
    { code: "CU.MA.2409", name: "Municipio de Melena del Sur" },
    { code: "CU.MA.2410", name: "Municipio de Batabanó" },
    { code: "CU.MA.2411", name: "Municipio de Quivicán" },
  ],
  "CV.01": [
    { code: "CV.01.11996041", name: "Santa Isabel" },
    { code: "CV.01.11996049", name: "Sao Joao Baptista" },
  ],
  "CV.02": [
    { code: "CV.02.11429279", name: "São João Baptista" },
    { code: "CV.02.11468093", name: "Nossa Senhora do Monte" },
  ],
  "CV.04": [
    { code: "CV.04.7669150", name: "Nossa Senhora da Luz" },
  ],
  "CV.05": [
    { code: "CV.05.11996043", name: "Santo Antonio das Pombas" },
  ],
  "CV.07": [
    { code: "CV.07.11468013", name: "Nossa Senhora do Rosário" },
    { code: "CV.07.11468615", name: "Santo Crucifixo" },
    { code: "CV.07.11996038", name: "Nossa Senhora do Livramento" },
    { code: "CV.07.11996045", name: "Sao Pedro Apostolo" },
  ],
  "CV.08": [
    { code: "CV.08.11996036", name: "Nossa Senhora das Dores" },
  ],
  "CV.11": [
    { code: "CV.11.11996047", name: "Nossa Senhora da Luz" },
  ],
  "CV.13": [
    { code: "CV.13.11996037", name: "Nossa Senhora da Ajuda" },
  ],
  "CV.14": [
    { code: "CV.14.11996057", name: "Nossa Senhora da Graca" },
  ],
  "CV.15": [
    { code: "CV.15.11996052", name: "Santa Catarina" },
  ],
  "CV.16": [
    { code: "CV.16.11996053", name: "Santiago Maior" },
  ],
  "CV.17": [
    { code: "CV.17.11468611", name: "Sao Nicolau Tolentino" },
    { code: "CV.17.11996046", name: "Nossa Senhora da Luz" },
  ],
  "CV.18": [
    { code: "CV.18.11429194", name: "Nossa Senhora da Conceicao" },
    { code: "CV.18.11996051", name: "Sao Lourenco" },
  ],
  "CV.19": [
    { code: "CV.19.11996056", name: "Sao Miguel Arcanjo" },
  ],
  "CV.20": [
    { code: "CV.20.11996054", name: "Santo Amaro Abade" },
  ],
  "CV.21": [
    { code: "CV.21.11996042", name: "Santo Andre" },
    { code: "CV.21.11996050", name: "Sao Joao Baptista" },
  ],
  "CV.22": [
    { code: "CV.22.11996035", name: "Nossa Senhora da Lapa" },
    { code: "CV.22.11996039", name: "Nossa Senhora do Rosario" },
  ],
  "CV.23": [
    { code: "CV.23.11996058", name: "Santissimo Nome de Jesus" },
    { code: "CV.23.11996059", name: "Sao Joao Baptista" },
  ],
  "CV.24": [
    { code: "CV.24.11996040", name: "Santa Catarina do Fogo" },
  ],
  "CV.25": [
    { code: "CV.25.11996055", name: "Sao Lourenco Dos Orgaos" },
  ],
  "CV.26": [
    { code: "CV.26.11996044", name: "Sao Salvador do Mundo" },
  ],
  "CV.27": [
    { code: "CV.27.11996048", name: "Sao Francisco de Assis" },
  ],
  "CY.01": [
    { code: "CY.01.10201393", name: "Ammóchostos" },
    { code: "CY.01.10201394", name: "Agía Nápa" },
    { code: "CY.01.10201395", name: "Paralímni" },
    { code: "CY.01.10201396", name: "Derýneia" },
    { code: "CY.01.10201397", name: "Sotíra" },
    { code: "CY.01.10201398", name: "Liopétri" },
    { code: "CY.01.10201399", name: "Frénaros" },
    { code: "CY.01.10201436", name: "Avgórou" },
    { code: "CY.01.10201437", name: "Áchna" },
    { code: "CY.01.10201438", name: "Makrásyka" },
    { code: "CY.01.10201439", name: "Kalopsída" },
    { code: "CY.01.10201531", name: "Acherítou" },
    { code: "CY.01.10201532", name: "Égkomi" },
    { code: "CY.01.10201533", name: "Ágios Sérgios" },
    { code: "CY.01.10201534", name: "Stýlloi" },
    { code: "CY.01.10201535", name: "Limniá" },
    { code: "CY.01.10201536", name: "Alóda" },
    { code: "CY.01.10201537", name: "Spatharikó" },
    { code: "CY.01.10201538", name: "Arnadí" },
    { code: "CY.01.10201539", name: "Ágios Geórgios" },
    { code: "CY.01.10201540", name: "Perivólia" },
    { code: "CY.01.10201541", name: "Sýgkrasi" },
    { code: "CY.01.10201542", name: "Lápathos" },
    { code: "CY.01.10201543", name: "Tríkomo" },
    { code: "CY.01.10201544", name: "Koúklia" },
    { code: "CY.01.10201545", name: "Kontéa" },
    { code: "CY.01.10201546", name: "Lýsi" },
    { code: "CY.01.10201547", name: "Vatilí" },
    { code: "CY.01.10201548", name: "Strongylós" },
    { code: "CY.01.10201549", name: "Sínta" },
    { code: "CY.01.10201550", name: "Gaïdourás" },
    { code: "CY.01.10201551", name: "Prastió" },
    { code: "CY.01.10201552", name: "Pyrgá" },
    { code: "CY.01.10201553", name: "Mousoulíta" },
    { code: "CY.01.10201554", name: "Santaláris" },
    { code: "CY.01.10201555", name: "Marátha" },
    { code: "CY.01.10201556", name: "Peristeróna" },
    { code: "CY.01.10201557", name: "Pigí" },
    { code: "CY.01.10201558", name: "Génagra" },
    { code: "CY.01.10201559", name: "Miliá" },
    { code: "CY.01.10201560", name: "Gýpsou" },
    { code: "CY.01.10201561", name: "Lefkónoiko" },
    { code: "CY.01.10201562", name: "Psyllátos" },
    { code: "CY.01.10201563", name: "Knódara" },
    { code: "CY.01.10201564", name: "Goúfes" },
    { code: "CY.01.10201565", name: "Áskeia" },
    { code: "CY.01.10201566", name: "Afánteia" },
    { code: "CY.01.10201567", name: "Angastína" },
    { code: "CY.01.10201568", name: "Marathóvounos" },
    { code: "CY.01.10201569", name: "Vitsáda" },
    { code: "CY.01.10201570", name: "Kíados" },
    { code: "CY.01.10201571", name: "Kornókipos" },
    { code: "CY.01.10201572", name: "Ágios Charíton" },
    { code: "CY.01.10201573", name: "Trypiméni" },
    { code: "CY.01.10201574", name: "Ártemi" },
    { code: "CY.01.10201575", name: "Ágios Nikólaos" },
    { code: "CY.01.10201576", name: "Platáni" },
    { code: "CY.01.10201577", name: "Akanthoú" },
    { code: "CY.01.10201578", name: "Meloúnta" },
    { code: "CY.01.10201579", name: "Ágios Iákovos" },
    { code: "CY.01.10201580", name: "Ágios Andrónikos" },
    { code: "CY.01.10201581", name: "Mándres" },
    { code: "CY.01.10201582", name: "Árdana" },
    { code: "CY.01.10201583", name: "Flamoúdi" },
    { code: "CY.01.10201584", name: "Bogázi" },
    { code: "CY.01.10201585", name: "Monargá" },
    { code: "CY.01.10201586", name: "Ágios Ilías" },
    { code: "CY.01.10201587", name: "Gastriá" },
    { code: "CY.01.10201588", name: "Avgolída" },
    { code: "CY.01.10201589", name: "Patríki" },
    { code: "CY.01.10201590", name: "Geráni" },
    { code: "CY.01.10201591", name: "Óvgoros" },
    { code: "CY.01.10201592", name: "Davlós" },
    { code: "CY.01.10201593", name: "Ágios Theódoros" },
    { code: "CY.01.10201594", name: "Vokolída" },
    { code: "CY.01.10201595", name: "Távrou" },
    { code: "CY.01.10201596", name: "Ágios Efstáthios" },
    { code: "CY.01.10201597", name: "Livádia" },
    { code: "CY.01.10201598", name: "Krídeia" },
    { code: "CY.01.10201599", name: "Kómi" },
    { code: "CY.01.10201600", name: "Galáteia" },
    { code: "CY.01.10201601", name: "Eptakómi" },
    { code: "CY.01.10201602", name: "Kóma tou Gialoú" },
    { code: "CY.01.10201603", name: "Néta" },
    { code: "CY.01.10201604", name: "Vothýlakas" },
    { code: "CY.01.10201605", name: "Lythrágkomi" },
    { code: "CY.01.10201606", name: "Vasíli" },
    { code: "CY.01.10201607", name: "Leonárisso" },
    { code: "CY.01.10201608", name: "Platanissós" },
    { code: "CY.01.10201609", name: "Koilánemos" },
    { code: "CY.01.10201610", name: "Ágios Andrónikos" },
    { code: "CY.01.10201611", name: "Ágios Symeón" },
    { code: "CY.01.10201612", name: "Melánarga" },
    { code: "CY.01.10201613", name: "Aigialoúsa" },
    { code: "CY.01.10201614", name: "Agía Triás" },
    { code: "CY.01.10201616", name: "Koróveia" },
    { code: "CY.01.10201617", name: "Galinóporni" },
    { code: "CY.01.10201618", name: "Rizokárpaso" },
    { code: "CY.01.11951811", name: "Ammochostos Municipality" },
  ],
  "CY.02": [
    { code: "CY.02.10197997", name: "Kerýneia" },
    { code: "CY.02.10197998", name: "Páno Díkomo" },
    { code: "CY.02.10197999", name: "Káto Díkomo" },
    { code: "CY.02.10198000", name: "Koutsovéntis" },
    { code: "CY.02.10198001", name: "Vounó" },
    { code: "CY.02.10198002", name: "Sicharí" },
    { code: "CY.02.10198003", name: "Fóta" },
    { code: "CY.02.10198004", name: "Kriní" },
    { code: "CY.02.10198005", name: "Pilerí" },
    { code: "CY.02.10198006", name: "Kiomourtzoú" },
    { code: "CY.02.10200789", name: "Agírda" },
    { code: "CY.02.10200790", name: "Ágios Ermólaos" },
    { code: "CY.02.10200791", name: "Sýsklipos" },
    { code: "CY.02.10200792", name: "Konteménos" },
    { code: "CY.02.10200793", name: "Asómatos" },
    { code: "CY.02.10200794", name: "Kampylí" },
    { code: "CY.02.10200795", name: "Karpáseia" },
    { code: "CY.02.10200796", name: "Mýrtou" },
    { code: "CY.02.10200797", name: "Diórios" },
    { code: "CY.02.10200798", name: "Agía Eiríni" },
    { code: "CY.02.10200799", name: "Kormakítis" },
    { code: "CY.02.10200800", name: "Liverá" },
    { code: "CY.02.10200801", name: "Kalograía" },
    { code: "CY.02.10200802", name: "Ágios Amvrósios" },
    { code: "CY.02.10200803", name: "Chárkeia" },
    { code: "CY.02.10201371", name: "Trápeza" },
    { code: "CY.02.10201372", name: "Klepíni" },
    { code: "CY.02.10201373", name: "Ágios Epíktitos" },
    { code: "CY.02.10201374", name: "Bélapaïs" },
    { code: "CY.02.10201375", name: "Kazáfani" },
    { code: "CY.02.10201376", name: "Thérmeia" },
    { code: "CY.02.10201377", name: "Karákoumi" },
    { code: "CY.02.10201378", name: "Témplos" },
    { code: "CY.02.10201379", name: "Kármi" },
    { code: "CY.02.10201380", name: "Ftéricha" },
    { code: "CY.02.10201381", name: "Trimíthi" },
    { code: "CY.02.10201382", name: "Palaiósofos" },
    { code: "CY.02.10201383", name: "Motídes" },
    { code: "CY.02.10201384", name: "Eliá" },
    { code: "CY.02.10201385", name: "Karavás" },
    { code: "CY.02.10201386", name: "Ágios Geórgios" },
    { code: "CY.02.10201387", name: "Agridáki" },
    { code: "CY.02.10201388", name: "Lárnakas Lapíthou" },
    { code: "CY.02.10201389", name: "Lápithos" },
    { code: "CY.02.10201390", name: "Vasíleia" },
    { code: "CY.02.10201391", name: "Pánagra" },
    { code: "CY.02.10201392", name: "Órga" },
    { code: "CY.02.11952704", name: "Kyrenia Municipality" },
  ],
  "CY.03": [
    { code: "CY.03.10346885", name: "Lárnaka" },
    { code: "CY.03.10346886", name: "Aradíppou" },
    { code: "CY.03.10346887", name: "Dromolaxiá" },
    { code: "CY.03.10346888", name: "Meneoú" },
    { code: "CY.03.10346889", name: "Kelliá" },
    { code: "CY.03.10346890", name: "Troúlloi" },
    { code: "CY.03.10346891", name: "Voróklini" },
    { code: "CY.03.10346892", name: "Avdelleró" },
    { code: "CY.03.10346893", name: "Pýla" },
    { code: "CY.03.10346894", name: "Xylotýmvou" },
    { code: "CY.03.10346895", name: "Ormídeia" },
    { code: "CY.03.10346896", name: "Xylofágou" },
    { code: "CY.03.10346897", name: "Pérgamos" },
    { code: "CY.03.10346898", name: "Kíti" },
    { code: "CY.03.10346899", name: "Tersefánou" },
    { code: "CY.03.10346900", name: "Softádes" },
    { code: "CY.03.10346901", name: "Mazotós" },
    { code: "CY.03.10346902", name: "Alaminós" },
    { code: "CY.03.10346903", name: "Anafotída" },
    { code: "CY.03.10346904", name: "Kórnos" },
    { code: "CY.03.10346905", name: "Aplánta" },
    { code: "CY.03.10346907", name: "Kivisíli" },
    { code: "CY.03.10346908", name: "Alethrikó" },
    { code: "CY.03.10346909", name: "Klavdiá" },
    { code: "CY.03.10346910", name: "Anglisídes" },
    { code: "CY.03.10346911", name: "Menógeia" },
    { code: "CY.03.10346912", name: "Petrofáni" },
    { code: "CY.03.10346913", name: "Athiénou" },
    { code: "CY.03.10346914", name: "Meloúseia" },
    { code: "CY.03.10346915", name: "Tremetousiá" },
    { code: "CY.03.10346916", name: "Ársos" },
    { code: "CY.03.10346917", name: "Agía Ánna" },
    { code: "CY.03.10346918", name: "Mosfilotí" },
    { code: "CY.03.10346919", name: "Psevdás" },
    { code: "CY.03.10346920", name: "Delíkipos" },
    { code: "CY.03.10346921", name: "Kóchi" },
    { code: "CY.03.10346922", name: "Zýgi" },
    { code: "CY.03.10346923", name: "Marí" },
    { code: "CY.03.10346924", name: "Kalavasós" },
    { code: "CY.03.10346925", name: "Tóchni" },
    { code: "CY.03.10346926", name: "Choirokoitía" },
    { code: "CY.03.10346927", name: "Psematisménos" },
    { code: "CY.03.10346928", name: "Maróni" },
    { code: "CY.03.10346929", name: "Skarínou" },
    { code: "CY.03.10346930", name: "Kofínou" },
    { code: "CY.03.10346931", name: "Káto Léfkara" },
    { code: "CY.03.10346932", name: "Páno Léfkara" },
    { code: "CY.03.10346933", name: "Káto Drys" },
    { code: "CY.03.10346934", name: "Vávla" },
    { code: "CY.03.10346935", name: "Lágeia" },
    { code: "CY.03.10346936", name: "Orá" },
    { code: "CY.03.10346937", name: "Melíni" },
    { code: "CY.03.10346938", name: "Odoú" },
    { code: "CY.03.10346939", name: "Ágioi Vavatsiniás" },
    { code: "CY.03.10346940", name: "Vavatsiniá" },
  ],
  "CY.04": [
    { code: "CY.04.10182652", name: "Lefkosía" },
    { code: "CY.04.10182655", name: "Ágios Dométios" },
    { code: "CY.04.10182743", name: "Égkomi" },
    { code: "CY.04.10182744", name: "Stróvolos" },
    { code: "CY.04.10182745", name: "Aglantziá" },
    { code: "CY.04.10182746", name: "Ortákioi" },
    { code: "CY.04.10190038", name: "Tráchonas" },
    { code: "CY.04.10190040", name: "Lakatámia" },
    { code: "CY.04.10190049", name: "Synoikismós Anthoúpolis" },
    { code: "CY.04.10190059", name: "Latsiá" },
    { code: "CY.04.10190060", name: "Géri" },
    { code: "CY.04.10190061", name: "Siá" },
    { code: "CY.04.10190555", name: "Mathiátis" },
    { code: "CY.04.10190556", name: "Alámpra" },
    { code: "CY.04.10190575", name: "Agía Varvára" },
    { code: "CY.04.10190576", name: "Kotsiátis" },
    { code: "CY.04.10190577", name: "Nísou" },
    { code: "CY.04.10190578", name: "Péra Chorió" },
    { code: "CY.04.10190579", name: "Dáli" },
    { code: "CY.04.10190580", name: "Lýmpia" },
    { code: "CY.04.10190581", name: "Lythrodóntas" },
    { code: "CY.04.10190582", name: "Louroukína" },
    { code: "CY.04.10190583", name: "Potamiá" },
    { code: "CY.04.10190584", name: "Ágios Sozómenos" },
    { code: "CY.04.10190585", name: "Pyrógi" },
    { code: "CY.04.10190586", name: "Margó" },
    { code: "CY.04.10190587", name: "Agiá" },
    { code: "CY.04.10190588", name: "Týmvou" },
    { code: "CY.04.10190589", name: "Móra" },
    { code: "CY.04.10190590", name: "Mia Miliá" },
    { code: "CY.04.10190591", name: "Mándres" },
    { code: "CY.04.10190592", name: "Palaíkythro" },
    { code: "CY.04.10190593", name: "Éxo Metóchi" },
    { code: "CY.04.10190594", name: "Epichó" },
    { code: "CY.04.10191329", name: "Vóni" },
    { code: "CY.04.10191956", name: "Trachóni" },
    { code: "CY.04.10191957", name: "Néo Chorió" },
    { code: "CY.04.10191958", name: "Kythréa" },
    { code: "CY.04.10191959", name: "Béïkioï" },
    { code: "CY.04.10191962", name: "Pétra tou Digení" },
    { code: "CY.04.10191964", name: "Kalyvákia" },
    { code: "CY.04.10191966", name: "Kouroú Monastíri" },
    { code: "CY.04.10191968", name: "Kampí" },
    { code: "CY.04.10191970", name: "Farmakás" },
    { code: "CY.04.10192043", name: "Aplíki" },
    { code: "CY.04.10192045", name: "Lazaniás" },
    { code: "CY.04.10192046", name: "Goúrri" },
    { code: "CY.04.10192050", name: "Fikárdou" },
    { code: "CY.04.10192083", name: "Ágios Epifánios" },
    { code: "CY.04.10192085", name: "Kaló Chorió" },
    { code: "CY.04.10192087", name: "Maloúnta" },
    { code: "CY.04.10192089", name: "Klírou" },
    { code: "CY.04.10192091", name: "Aredioú" },
    { code: "CY.04.10192092", name: "Ágios Ioánnis" },
    { code: "CY.04.10192096", name: "Agrokipiá" },
    { code: "CY.04.10192097", name: "Mitseró" },
    { code: "CY.04.10192099", name: "Kapédes" },
    { code: "CY.04.10192119", name: "Katalióntas" },
    { code: "CY.04.10192121", name: "Analióntas" },
    { code: "CY.04.10192261", name: "Kampiá" },
    { code: "CY.04.10192262", name: "Margí" },
    { code: "CY.04.10192264", name: "Tséri" },
    { code: "CY.04.10192265", name: "Politikó" },
    { code: "CY.04.10192266", name: "Péra" },
    { code: "CY.04.10192267", name: "Episkopeió" },
    { code: "CY.04.10192514", name: "Psimolófou" },
    { code: "CY.04.10192516", name: "Ergátes" },
    { code: "CY.04.10192517", name: "Anágeia" },
    { code: "CY.04.10192519", name: "Páno Defterá" },
    { code: "CY.04.10192520", name: "Káto Defterá" },
    { code: "CY.04.10192524", name: "Ágioi Trimithiás" },
    { code: "CY.04.10192525", name: "Palaiométocho" },
    { code: "CY.04.10192529", name: "Déneia" },
    { code: "CY.04.10192531", name: "Kokkinotrimithiá" },
    { code: "CY.04.10193037", name: "Ágioi Iliófotoi" },
    { code: "CY.04.10193038", name: "Káto Moní" },
    { code: "CY.04.10193039", name: "Oroúnta" },
    { code: "CY.04.10193040", name: "Páno Koutrafás" },
    { code: "CY.04.10193041", name: "Káto Koutrafás" },
    { code: "CY.04.10193042", name: "Potámi" },
    { code: "CY.04.10193043", name: "Mórfou" },
    { code: "CY.04.10193044", name: "Páno Zódeia" },
    { code: "CY.04.10193217", name: "Mámmari" },
    { code: "CY.04.10193219", name: "Gerólakkos" },
    { code: "CY.04.10193226", name: "Agía Marína" },
    { code: "CY.04.10193228", name: "Skylloúra" },
    { code: "CY.04.10193232", name: "Ágios Vasíleios" },
    { code: "CY.04.10193234", name: "Dýo Potamoí" },
    { code: "CY.04.10193242", name: "Kanlí" },
    { code: "CY.04.10193244", name: "Kióneli" },
    { code: "CY.04.10193249", name: "Palaichóri Mórfou" },
    { code: "CY.04.10193250", name: "Askás" },
    { code: "CY.04.10193253", name: "Álona" },
    { code: "CY.04.10193254", name: "Fterikoúdi" },
    { code: "CY.04.10193255", name: "Polýstypos" },
    { code: "CY.04.10193623", name: "Lagouderá" },
    { code: "CY.04.10193624", name: "Saránti" },
    { code: "CY.04.10193625", name: "Livádia" },
    { code: "CY.04.10193626", name: "Alithinoú" },
    { code: "CY.04.10193627", name: "Platanistása" },
    { code: "CY.04.10193628", name: "Palaichóri" },
    { code: "CY.04.10193629", name: "Xyliátos" },
    { code: "CY.04.10193630", name: "Ágios Geórgios" },
    { code: "CY.04.10193632", name: "Nikitári" },
    { code: "CY.04.10193633", name: "Vyzakiá" },
    { code: "CY.04.10193946", name: "Agía Marína" },
    { code: "CY.04.10194035", name: "Káto Zódeia" },
    { code: "CY.04.10194862", name: "Kaló Chorió Kapoúti" },
    { code: "CY.04.10194863", name: "Akáki" },
    { code: "CY.04.10194864", name: "Peristeróna" },
    { code: "CY.04.10194865", name: "Astromerítis" },
    { code: "CY.04.10194866", name: "Avlóna" },
    { code: "CY.04.10194867", name: "Katokopiá" },
    { code: "CY.04.10194868", name: "Argáki" },
    { code: "CY.04.10194869", name: "Másari" },
    { code: "CY.04.10194870", name: "Fylliá" },
    { code: "CY.04.10194871", name: "Méniko" },
    { code: "CY.04.10194872", name: "Kyrá" },
    { code: "CY.04.10194873", name: "Spília" },
    { code: "CY.04.10194874", name: "Agía Eiríni" },
    { code: "CY.04.10194875", name: "Kannávia" },
    { code: "CY.04.10194894", name: "Kaziverá" },
    { code: "CY.04.10194895", name: "Prastió" },
    { code: "CY.04.10194896", name: "Nikítas" },
    { code: "CY.04.10194897", name: "Syrianochóri" },
    { code: "CY.04.10194915", name: "Kakopetriá" },
    { code: "CY.04.10194916", name: "Ágios Theódoros" },
    { code: "CY.04.10194917", name: "Galáta" },
    { code: "CY.04.10194918", name: "Sináoros" },
    { code: "CY.04.10194919", name: "Kaliána" },
    { code: "CY.04.10195114", name: "Temvriá" },
    { code: "CY.04.10195115", name: "Korákou" },
    { code: "CY.04.10195116", name: "Evrýchou" },
    { code: "CY.04.10195118", name: "Flásou" },
    { code: "CY.04.10195120", name: "Ágios Epifánios" },
    { code: "CY.04.10195121", name: "Linoú" },
    { code: "CY.04.10195122", name: "Katýdata" },
    { code: "CY.04.10195124", name: "Skouriótissa" },
    { code: "CY.04.10195125", name: "Pedoulás" },
    { code: "CY.04.10195126", name: "Mylikoúri" },
    { code: "CY.04.10195127", name: "Moutoutllás" },
    { code: "CY.04.10195128", name: "Oíkos" },
    { code: "CY.04.10195129", name: "Kalopanagiótis" },
    { code: "CY.04.10195130", name: "Gerakiés" },
    { code: "CY.04.10195156", name: "Tsakístra" },
    { code: "CY.04.10195157", name: "Kámpos" },
    { code: "CY.04.10195158", name: "Ágios Nikólaos" },
    { code: "CY.04.10195159", name: "Ágios Geórgios" },
    { code: "CY.04.10195160", name: "Pétra" },
    { code: "CY.04.10195161", name: "Kaló Chorió" },
    { code: "CY.04.10195162", name: "Léfka" },
    { code: "CY.04.10195163", name: "Ampelikoú" },
    { code: "CY.04.10195164", name: "Peristeronári" },
    { code: "CY.04.10195165", name: "Eliá" },
    { code: "CY.04.10195166", name: "Karavostási" },
    { code: "CY.04.10195167", name: "Pentágeia" },
    { code: "CY.04.10195168", name: "Angolémi" },
    { code: "CY.04.10195169", name: "Varíseia" },
    { code: "CY.04.10195171", name: "Galiní" },
    { code: "CY.04.10195172", name: "Xeróvounos" },
    { code: "CY.04.10195173", name: "Loutrós" },
    { code: "CY.04.10195174", name: "Ágios Ioánnis Selémani" },
    { code: "CY.04.10195175", name: "Ammadiés" },
    { code: "CY.04.10195176", name: "Páno Pýrgos" },
    { code: "CY.04.10195177", name: "Káto Pýrgos" },
    { code: "CY.04.10195178", name: "Selládi tou Áppi kai Ágio Georgoúdi" },
    { code: "CY.04.10195179", name: "Alévga" },
    { code: "CY.04.10195180", name: "Pigénia" },
    { code: "CY.04.10195181", name: "Pachýammos" },
    { code: "CY.04.10195182", name: "Kókkina" },
    { code: "CY.04.10195183", name: "Fródisia" },
    { code: "CY.04.10195184", name: "Ágios Theódoros" },
    { code: "CY.04.10195185", name: "Mansoúra" },
    { code: "CY.04.10195186", name: "Mosfíli" },
    { code: "CY.04.11920109", name: "Nicosia Municipality" },
  ],
  "CY.05": [
    { code: "CY.05.10346941", name: "Lemesós" },
    { code: "CY.05.10346942", name: "Mésa Geitoniá" },
    { code: "CY.05.10346943", name: "Ágios Athanásios" },
    { code: "CY.05.10346944", name: "Germasógeia" },
    { code: "CY.05.10346945", name: "Páno Polemídia" },
    { code: "CY.05.10346946", name: "Ýpsonas" },
    { code: "CY.05.10346947", name: "Káto Polemídia" },
    { code: "CY.05.10346948", name: "Palódeia" },
    { code: "CY.05.10346949", name: "Paramýtha" },
    { code: "CY.05.10346950", name: "Spitáli" },
    { code: "CY.05.10346951", name: "Fasoúla" },
    { code: "CY.05.10346952", name: "Mathikolóni" },
    { code: "CY.05.10346953", name: "Gerása" },
    { code: "CY.05.10346954", name: "Apsioú" },
    { code: "CY.05.10346955", name: "Apesiá" },
    { code: "CY.05.10346956", name: "Korfí" },
    { code: "CY.05.10346957", name: "Limnátis" },
    { code: "CY.05.10346958", name: "Kapileió" },
    { code: "CY.05.10346959", name: "Mouttagiáka" },
    { code: "CY.05.10346960", name: "Armenochóri" },
    { code: "CY.05.10346961", name: "Foinikária" },
    { code: "CY.05.10346962", name: "Akroúnta" },
    { code: "CY.05.10346963", name: "Ágios Týchon" },
    { code: "CY.05.10346964", name: "Parekklisiá" },
    { code: "CY.05.10346965", name: "Pentákomo" },
    { code: "CY.05.10346966", name: "Monagroúlli" },
    { code: "CY.05.10346967", name: "Asgáta" },
    { code: "CY.05.10346968", name: "Vása" },
    { code: "CY.05.10346969", name: "Sanída" },
    { code: "CY.05.10346970", name: "Klonári" },
    { code: "CY.05.10346971", name: "Víkla" },
    { code: "CY.05.10346972", name: "Kelláki" },
    { code: "CY.05.10346973", name: "Akapnoú" },
    { code: "CY.05.10346974", name: "Eptagóneia" },
    { code: "CY.05.10346975", name: "Dieróna" },
    { code: "CY.05.10346976", name: "Arakapás" },
    { code: "CY.05.10346977", name: "Ágios Pávlos" },
    { code: "CY.05.10346978", name: "Ágios Konstantínos" },
    { code: "CY.05.10346979", name: "Sykópetra" },
    { code: "CY.05.10346980", name: "Louvarás" },
    { code: "CY.05.10346981", name: "Zoopigí" },
    { code: "CY.05.10346982", name: "Akrotíri" },
    { code: "CY.05.10346983", name: "Tserkézoi" },
    { code: "CY.05.10346984", name: "Kolóssi" },
    { code: "CY.05.10346985", name: "Erími" },
    { code: "CY.05.10346986", name: "Episkopí" },
    { code: "CY.05.10346987", name: "Kantoú" },
    { code: "CY.05.10346988", name: "Sotíra" },
    { code: "CY.05.10346989", name: "Paramáli" },
    { code: "CY.05.10346990", name: "Avdímou" },
    { code: "CY.05.10346991", name: "Platanísteia" },
    { code: "CY.05.10346992", name: "Ágios Tomás" },
    { code: "CY.05.10346993", name: "Aléktora" },
    { code: "CY.05.10346994", name: "Anógyra" },
    { code: "CY.05.10346995", name: "Pissoúri" },
    { code: "CY.05.10346996", name: "Soúni-Zanakiá" },
    { code: "CY.05.10346997", name: "Álassa" },
    { code: "CY.05.10346998", name: "Káto Kivídes" },
    { code: "CY.05.10346999", name: "Páno Kivídes" },
    { code: "CY.05.10347000", name: "Ágios Therápon" },
    { code: "CY.05.10347001", name: "Lófou" },
    { code: "CY.05.10347002", name: "Páchna" },
    { code: "CY.05.10347003", name: "Dorós" },
    { code: "CY.05.10347004", name: "Láneia" },
    { code: "CY.05.10347005", name: "Silíkou" },
    { code: "CY.05.10347006", name: "Monágri" },
    { code: "CY.05.10347007", name: "Trimíklini" },
    { code: "CY.05.10347008", name: "Ágios Mámas" },
    { code: "CY.05.10347009", name: "Kouká" },
    { code: "CY.05.10347010", name: "Moniátis" },
    { code: "CY.05.10347011", name: "Dorá" },
    { code: "CY.05.10347012", name: "Gerovása" },
    { code: "CY.05.10347013", name: "Ársos" },
    { code: "CY.05.10347014", name: "Kissoúsa" },
    { code: "CY.05.10347015", name: "Maliá" },
    { code: "CY.05.10347016", name: "Vása" },
    { code: "CY.05.10347017", name: "Vouní" },
    { code: "CY.05.10347018", name: "Péra Pedí" },
    { code: "CY.05.10347019", name: "Mandriá" },
    { code: "CY.05.10347020", name: "Potamioú" },
    { code: "CY.05.10347021", name: "Ómodos" },
    { code: "CY.05.10347022", name: "Koiláni" },
    { code: "CY.05.10347023", name: "Ágios Dimítrios" },
    { code: "CY.05.10347024", name: "Palaiómylos" },
    { code: "CY.05.10347025", name: "Pródromos" },
    { code: "CY.05.10347026", name: "Kaminária" },
    { code: "CY.05.10347027", name: "Treis Eliés" },
    { code: "CY.05.10347028", name: "Lemíthou" },
    { code: "CY.05.10347029", name: "Káto Plátres" },
    { code: "CY.05.10347030", name: "Páno Plátres" },
    { code: "CY.05.10347031", name: "Foiní" },
    { code: "CY.05.10347032", name: "Amíantos" },
    { code: "CY.05.10347033", name: "Káto Mýlos" },
    { code: "CY.05.10347034", name: "Potamítissa" },
    { code: "CY.05.10347035", name: "Dýmes" },
    { code: "CY.05.10347036", name: "Peléndri" },
    { code: "CY.05.10347037", name: "Agrós" },
    { code: "CY.05.10347038", name: "Agrídia" },
    { code: "CY.05.10347039", name: "Chandriá" },
    { code: "CY.05.10347040", name: "Kyperoúnta" },
  ],
  "CY.06": [
    { code: "CY.06.10347041", name: "Páfos" },
    { code: "CY.06.10347042", name: "Geroskípou Municipality" },
    { code: "CY.06.10347043", name: "Koniá" },
    { code: "CY.06.10347044", name: "Agía Marinoúda" },
    { code: "CY.06.10347045", name: "Achéleia" },
    { code: "CY.06.10347046", name: "Chlórakas" },
    { code: "CY.06.10347047", name: "Lémpa" },
    { code: "CY.06.10347048", name: "Émpa" },
    { code: "CY.06.10347049", name: "Tremithoúsa" },
    { code: "CY.06.10347050", name: "Mésa Chorió" },
    { code: "CY.06.10347051", name: "Mesógi" },
    { code: "CY.06.10347052", name: "Tála" },
    { code: "CY.06.10347053", name: "Kissónerga" },
    { code: "CY.06.10347054", name: "Koúklia" },
    { code: "CY.06.10347055", name: "Mandriá" },
    { code: "CY.06.10347056", name: "Nikókleia" },
    { code: "CY.06.10347057", name: "Souskioú" },
    { code: "CY.06.10347058", name: "Tími" },
    { code: "CY.06.10347059", name: "Anaríta" },
    { code: "CY.06.10347060", name: "Foínikas" },
    { code: "CY.06.10347061", name: "Marathoúnta" },
    { code: "CY.06.10347062", name: "Ármou" },
    { code: "CY.06.10347064", name: "Episkopí" },
    { code: "CY.06.10347065", name: "Natá" },
    { code: "CY.06.10347066", name: "Cholétria" },
    { code: "CY.06.10347067", name: "Axýlou" },
    { code: "CY.06.10347068", name: "Eledió" },
    { code: "CY.06.10347069", name: "Tsáda" },
    { code: "CY.06.10347070", name: "Koíli" },
    { code: "CY.06.10347071", name: "Stroumpí" },
    { code: "CY.06.10347072", name: "Polémi" },
    { code: "CY.06.10347073", name: "Kallépeia" },
    { code: "CY.06.10347074", name: "Letýmvou" },
    { code: "CY.06.10347075", name: "Pitargoú" },
    { code: "CY.06.10347076", name: "Koúrdaka" },
    { code: "CY.06.10347077", name: "Lemóna" },
    { code: "CY.06.10347078", name: "Choúlou" },
    { code: "CY.06.10347079", name: "Akoursós" },
    { code: "CY.06.10347080", name: "Káthikas" },
    { code: "CY.06.10347081", name: "Pégeia" },
    { code: "CY.06.10347082", name: "Páno Archimandríta" },
    { code: "CY.06.10347083", name: "Fasoúla" },
    { code: "CY.06.10347084", name: "Moúsere" },
    { code: "CY.06.10347085", name: "Máronas" },
    { code: "CY.06.10347086", name: "Mamónia" },
    { code: "CY.06.10347087", name: "Stavrokónnou" },
    { code: "CY.06.10347088", name: "Trachypédoula" },
    { code: "CY.06.10347089", name: "Kelokédara" },
    { code: "CY.06.10347090", name: "Salamioú" },
    { code: "CY.06.10347091", name: "Kidási" },
    { code: "CY.06.10347092", name: "Kédares" },
    { code: "CY.06.10347093", name: "Mésana" },
    { code: "CY.06.10347094", name: "Praitóri" },
    { code: "CY.06.10347095", name: "Filoúsa" },
    { code: "CY.06.10347096", name: "Armínou" },
    { code: "CY.06.10347097", name: "Amargéti" },
    { code: "CY.06.10347098", name: "Pentaliá" },
    { code: "CY.06.10347099", name: "Fáleia" },
    { code: "CY.06.10347100", name: "Galatariá" },
    { code: "CY.06.10347101", name: "Koilíneia" },
    { code: "CY.06.10347102", name: "Vrétsia" },
    { code: "CY.06.10347103", name: "Statós-Ágios Fótios" },
    { code: "CY.06.10347104", name: "Lapithioú" },
    { code: "CY.06.10347105", name: "Mamoúntali" },
    { code: "CY.06.10347106", name: "Páno Panagiá" },
    { code: "CY.06.10347107", name: "Asprogiá" },
    { code: "CY.06.10347108", name: "Psathí" },
    { code: "CY.06.10347109", name: "Ágios Dimitrianós" },
    { code: "CY.06.10347110", name: "Kannavioú-Melamioú" },
    { code: "CY.06.10347111", name: "Thriniá" },
    { code: "CY.06.10347112", name: "Krítou Maróttou" },
    { code: "CY.06.10347113", name: "Fýti" },
    { code: "CY.06.10347114", name: "Lása" },
    { code: "CY.06.10347115", name: "Drýmou" },
    { code: "CY.06.10347116", name: "Símou" },
    { code: "CY.06.10347117", name: "Anadioú" },
    { code: "CY.06.10347118", name: "Sárama" },
    { code: "CY.06.10347119", name: "Evrétou" },
    { code: "CY.06.10347120", name: "Trimithoúsa" },
    { code: "CY.06.10347121", name: "Filoúsa" },
    { code: "CY.06.10347122", name: "Kiós" },
    { code: "CY.06.10347123", name: "Zachariá" },
    { code: "CY.06.10347124", name: "Meládeia" },
    { code: "CY.06.10347125", name: "Mélandra" },
    { code: "CY.06.10347126", name: "Lysós" },
    { code: "CY.06.10347127", name: "Thelétra" },
    { code: "CY.06.10347128", name: "Giólou" },
    { code: "CY.06.10347129", name: "Páno Akourdáleia" },
    { code: "CY.06.10347130", name: "Milioú" },
    { code: "CY.06.10347131", name: "Káto Akourdáleia" },
    { code: "CY.06.10347132", name: "Téra" },
    { code: "CY.06.10347133", name: "Krítou Téra" },
    { code: "CY.06.10347134", name: "Skoúlli" },
    { code: "CY.06.10347135", name: "Chóli" },
    { code: "CY.06.10347136", name: "Loukroúnou" },
    { code: "CY.06.10347137", name: "Karamoullídes" },
    { code: "CY.06.10347138", name: "Chrysochoú" },
    { code: "CY.06.10347139", name: "Pólis" },
    { code: "CY.06.10347140", name: "Néo Chorió" },
    { code: "CY.06.10347141", name: "Goudí" },
    { code: "CY.06.10347142", name: "Káto Aródes" },
    { code: "CY.06.10347143", name: "Páno Aródes" },
    { code: "CY.06.10347144", name: "Íneia" },
    { code: "CY.06.10347145", name: "Droúseia" },
    { code: "CY.06.10347146", name: "Fásli" },
    { code: "CY.06.10347147", name: "Androlíkou" },
    { code: "CY.06.10347148", name: "Pelathoúsa" },
    { code: "CY.06.10347149", name: "Kynoúsa" },
    { code: "CY.06.10347150", name: "Makoúnta" },
    { code: "CY.06.10347151", name: "Argáka" },
    { code: "CY.06.10347152", name: "Gialiá" },
    { code: "CY.06.10347153", name: "Néa Dímmata" },
    { code: "CY.06.10347154", name: "Pomós" },
    { code: "CY.06.10347155", name: "Stení" },
    { code: "CY.06.10347156", name: "Ágios Isídoros" },
    { code: "CY.06.10347157", name: "Livádi" },
  ],
  "CZ.52": [
    { code: "CZ.52.8378769", name: "Praha 1" },
    { code: "CZ.52.8378770", name: "Praha 2" },
    { code: "CZ.52.8378771", name: "Praha 3" },
    { code: "CZ.52.8378772", name: "Praha 4" },
    { code: "CZ.52.8378773", name: "Praha 5" },
    { code: "CZ.52.8378774", name: "Praha 6" },
    { code: "CZ.52.8378775", name: "Praha 7" },
    { code: "CZ.52.8378776", name: "Praha 8" },
    { code: "CZ.52.8378777", name: "Praha 9" },
    { code: "CZ.52.8378778", name: "Praha 10" },
    { code: "CZ.52.8378779", name: "Praha 11" },
    { code: "CZ.52.8378780", name: "Praha 12" },
    { code: "CZ.52.8378781", name: "Praha 13" },
    { code: "CZ.52.8378782", name: "Praha 14" },
    { code: "CZ.52.8378784", name: "Praha 15" },
    { code: "CZ.52.8378785", name: "Praha 16" },
    { code: "CZ.52.8378787", name: "Praha 17" },
    { code: "CZ.52.8378788", name: "Praha 18" },
    { code: "CZ.52.8378789", name: "Praha 19" },
    { code: "CZ.52.8378790", name: "Praha 20" },
    { code: "CZ.52.8378792", name: "Praha 21" },
    { code: "CZ.52.8378793", name: "Praha 22" },
  ],
  "CZ.78": [
    { code: "CZ.78.0641", name: "Okres Blansko" },
    { code: "CZ.78.0642", name: "Město Brno" },
    { code: "CZ.78.0643", name: "Okres Brno-venkov" },
    { code: "CZ.78.0644", name: "Okres Břeclav" },
    { code: "CZ.78.0645", name: "Okres Hodonín" },
    { code: "CZ.78.0646", name: "Okres Vyškov" },
    { code: "CZ.78.0647", name: "Okres Znojmo" },
  ],
  "CZ.79": [
    { code: "CZ.79.0311", name: "Okres České Budějovice" },
    { code: "CZ.79.0312", name: "Okres Český Krumlov" },
    { code: "CZ.79.0313", name: "Okres Jindřichův Hradec" },
    { code: "CZ.79.0314", name: "Okres Písek" },
    { code: "CZ.79.0315", name: "Okres Prachatice" },
    { code: "CZ.79.0316", name: "Okres Strakonice" },
    { code: "CZ.79.0317", name: "Okres Tábor" },
  ],
  "CZ.80": [
    { code: "CZ.80.0631", name: "Okres Havlíčkův Brod" },
    { code: "CZ.80.0632", name: "Okres Jihlava" },
    { code: "CZ.80.0633", name: "Okres Pelhřimov" },
    { code: "CZ.80.0634", name: "Okres Třebíč" },
    { code: "CZ.80.0635", name: "Okres Žďár nad Sázavou" },
  ],
  "CZ.81": [
    { code: "CZ.81.0411", name: "Okres Cheb" },
    { code: "CZ.81.0412", name: "Okres Karlovy Vary" },
    { code: "CZ.81.0413", name: "Okres Sokolov" },
  ],
  "CZ.82": [
    { code: "CZ.82.0521", name: "Okres Hradec Králové" },
    { code: "CZ.82.0522", name: "Okres Jičín" },
    { code: "CZ.82.0523", name: "Okres Náchod" },
    { code: "CZ.82.0524", name: "Okres Rychnov nad Kněžnou" },
    { code: "CZ.82.0525", name: "Okres Trutnov" },
  ],
  "CZ.83": [
    { code: "CZ.83.0511", name: "Okres Česká Lípa" },
    { code: "CZ.83.0512", name: "Okres Jablonec nad Nisou" },
    { code: "CZ.83.0513", name: "Okres Liberec" },
    { code: "CZ.83.0514", name: "Okres Semily" },
  ],
  "CZ.84": [
    { code: "CZ.84.0711", name: "Okres Jeseník" },
    { code: "CZ.84.0712", name: "Okres Olomouc" },
    { code: "CZ.84.0713", name: "Okres Prostějov" },
    { code: "CZ.84.0714", name: "Okres Přerov" },
    { code: "CZ.84.0715", name: "Okres Šumperk" },
  ],
  "CZ.85": [
    { code: "CZ.85.0801", name: "Okres Bruntál" },
    { code: "CZ.85.0802", name: "Okres Frýdek-Místek" },
    { code: "CZ.85.0803", name: "Okres Karviná" },
    { code: "CZ.85.0804", name: "Okres Nový Jičín" },
    { code: "CZ.85.0805", name: "Okres Opava" },
    { code: "CZ.85.0806", name: "Okres Ostrava-město" },
  ],
  "CZ.86": [
    { code: "CZ.86.0531", name: "Okres Chrudim" },
    { code: "CZ.86.0532", name: "Okres Pardubice" },
    { code: "CZ.86.0533", name: "Okres Svitavy" },
    { code: "CZ.86.0534", name: "Okres Ústí nad Orlicí" },
  ],
  "CZ.87": [
    { code: "CZ.87.0321", name: "Okres Domažlice" },
    { code: "CZ.87.0322", name: "Okres Klatovy" },
    { code: "CZ.87.0323", name: "Okres Plzeň-město" },
    { code: "CZ.87.0324", name: "Okres Plzeň-jih" },
    { code: "CZ.87.0325", name: "Okres Plzeň-sever" },
    { code: "CZ.87.0326", name: "Okres Rokycany" },
    { code: "CZ.87.0327", name: "Okres Tachov" },
  ],
  "CZ.88": [
    { code: "CZ.88.0201", name: "Okres Benešov" },
    { code: "CZ.88.0202", name: "Okres Beroun" },
    { code: "CZ.88.0203", name: "Okres Kladno" },
    { code: "CZ.88.0204", name: "Okres Kolín" },
    { code: "CZ.88.0205", name: "Okres Kutná Hora" },
    { code: "CZ.88.0206", name: "Okres Mělník" },
    { code: "CZ.88.0207", name: "Okres Mladá Boleslav" },
    { code: "CZ.88.0208", name: "Okres Nymburk" },
    { code: "CZ.88.0209", name: "Okres Praha-východ" },
    { code: "CZ.88.020A", name: "Okres Praha-západ" },
    { code: "CZ.88.020B", name: "Okres Příbram" },
    { code: "CZ.88.020C", name: "Okres Rakovník" },
  ],
  "CZ.89": [
    { code: "CZ.89.0421", name: "Okres Děčín" },
    { code: "CZ.89.0422", name: "Okres Chomutov" },
    { code: "CZ.89.0423", name: "Okres Litoměřice" },
    { code: "CZ.89.0424", name: "Okres Louny" },
    { code: "CZ.89.0425", name: "Okres Most" },
    { code: "CZ.89.0426", name: "Okres Teplice" },
    { code: "CZ.89.0427", name: "Okres Ústí nad Labem" },
  ],
  "CZ.90": [
    { code: "CZ.90.0721", name: "Okres Kroměříž" },
    { code: "CZ.90.0722", name: "Okres Uherské Hradiště" },
    { code: "CZ.90.0723", name: "Okres Vsetín" },
    { code: "CZ.90.0724", name: "Okres Zlín" },
  ],
  "DE.01": [
    { code: "DE.01.081", name: "Regierungsbezirk Stuttgart" },
    { code: "DE.01.082", name: "Karlsruhe Region" },
    { code: "DE.01.083", name: "Freiburg Region" },
    { code: "DE.01.084", name: "Tübingen Region" },
  ],
  "DE.02": [
    { code: "DE.02.091", name: "Upper Bavaria" },
    { code: "DE.02.092", name: "Lower Bavaria" },
    { code: "DE.02.093", name: "Upper Palatinate" },
    { code: "DE.02.094", name: "Upper Franconia" },
    { code: "DE.02.095", name: "Regierungsbezirk Mittelfranken" },
    { code: "DE.02.096", name: "Regierungsbezirk Unterfranken" },
    { code: "DE.02.097", name: "Swabia" },
  ],
  "DE.05": [
    { code: "DE.05.064", name: "Regierungsbezirk Darmstadt" },
    { code: "DE.05.065", name: "Regierungsbezirk Gießen" },
    { code: "DE.05.066", name: "Regierungsbezirk Kassel" },
  ],
  "DE.07": [
    { code: "DE.07.051", name: "Düsseldorf District" },
    { code: "DE.07.053", name: "Regierungsbezirk Köln" },
    { code: "DE.07.055", name: "Regierungsbezirk Münster" },
    { code: "DE.07.057", name: "Regierungsbezirk Detmold" },
    { code: "DE.07.059", name: "Regierungsbezirk Arnsberg" },
  ],
  "DJ.04": [
    { code: "DJ.04.7910461", name: "Obock" },
  ],
  "DJ.06": [
    { code: "DJ.06.9611302", name: "Yoboki" },
    { code: "DJ.06.9611312", name: "As Eyla" },
  ],
  "DK.17": [
    { code: "DK.17.101", name: "København" },
    { code: "DK.17.147", name: "Frederiksberg Kommune" },
    { code: "DK.17.151", name: "Ballerup Kommune" },
    { code: "DK.17.153", name: "Brøndby Kommune" },
    { code: "DK.17.155", name: "Dragør Kommune" },
    { code: "DK.17.157", name: "Gentofte Kommune" },
    { code: "DK.17.159", name: "Gladsaxe Municipality" },
    { code: "DK.17.161", name: "Glostrup Kommune" },
    { code: "DK.17.163", name: "Herlev Kommune" },
    { code: "DK.17.165", name: "Albertslund Kommune" },
    { code: "DK.17.167", name: "Hvidovre Kommune" },
    { code: "DK.17.169", name: "Høje-Taastrup Kommune" },
    { code: "DK.17.173", name: "Lyngby-Tårbæk Kommune" },
    { code: "DK.17.175", name: "Rødovre Kommune" },
    { code: "DK.17.183", name: "Ishøj Kommune" },
    { code: "DK.17.185", name: "Tårnby Kommune" },
    { code: "DK.17.187", name: "Vallensbæk Kommune" },
    { code: "DK.17.190", name: "Furesø Kommune" },
    { code: "DK.17.201", name: "Allerød Kommune" },
    { code: "DK.17.210", name: "Fredensborg Kommune" },
    { code: "DK.17.217", name: "Helsingør Kommune" },
    { code: "DK.17.219", name: "Hillerød Kommune" },
    { code: "DK.17.223", name: "Hørsholm Kommune" },
    { code: "DK.17.230", name: "Rudersdal Kommune" },
    { code: "DK.17.240", name: "Egedal Kommune" },
    { code: "DK.17.250", name: "Frederikssund Kommune" },
    { code: "DK.17.260", name: "Halsnæs Kommune" },
    { code: "DK.17.270", name: "Gribskov Kommune" },
    { code: "DK.17.400", name: "Bornholm Kommune" },
    { code: "DK.17.411", name: "Christiansø" },
  ],
  "DK.18": [
    { code: "DK.18.615", name: "Horsens Kommune" },
    { code: "DK.18.657", name: "Herning Kommune" },
    { code: "DK.18.661", name: "Holstebro Kommune" },
    { code: "DK.18.665", name: "Lemvig Kommune" },
    { code: "DK.18.671", name: "Struer Kommune" },
    { code: "DK.18.706", name: "Syddjurs Kommune" },
    { code: "DK.18.707", name: "Norddjurs Kommune" },
    { code: "DK.18.710", name: "Favrskov Kommune" },
    { code: "DK.18.727", name: "Odder Kommune" },
    { code: "DK.18.730", name: "Randers Kommune" },
    { code: "DK.18.740", name: "Silkeborg Kommune" },
    { code: "DK.18.741", name: "Samsø Kommune" },
    { code: "DK.18.746", name: "Skanderborg Kommune" },
    { code: "DK.18.751", name: "Århus Kommune" },
    { code: "DK.18.756", name: "Ikast-Brande Kommune" },
    { code: "DK.18.760", name: "Ringkøbing-Skjern Kommune" },
    { code: "DK.18.766", name: "Hedensted Kommune" },
    { code: "DK.18.779", name: "Skive Kommune" },
    { code: "DK.18.791", name: "Viborg Kommune" },
  ],
  "DK.19": [
    { code: "DK.19.773", name: "Morsø Kommune" },
    { code: "DK.19.787", name: "Thisted Kommune" },
    { code: "DK.19.810", name: "Brønderslev Kommune" },
    { code: "DK.19.813", name: "Frederikshavn Kommune" },
    { code: "DK.19.820", name: "Vesthimmerland Kommune" },
    { code: "DK.19.825", name: "Læso Kommune" },
    { code: "DK.19.840", name: "Rebild Kommune" },
    { code: "DK.19.846", name: "Mariagerfjord Kommune" },
    { code: "DK.19.849", name: "Jammerbugt Kommune" },
    { code: "DK.19.851", name: "Ålborg Kommune" },
    { code: "DK.19.860", name: "Hjørring Kommune" },
  ],
  "DK.20": [
    { code: "DK.20.253", name: "Greve Kommune" },
    { code: "DK.20.259", name: "Køge Kommune" },
    { code: "DK.20.265", name: "Roskilde Kommune" },
    { code: "DK.20.269", name: "Solrød Kommune" },
    { code: "DK.20.306", name: "Odsherred Kommune" },
    { code: "DK.20.316", name: "Holbæk Kommune" },
    { code: "DK.20.320", name: "Faxe Kommune" },
    { code: "DK.20.326", name: "Kalundborg Kommune" },
    { code: "DK.20.329", name: "Ringsted Kommune" },
    { code: "DK.20.330", name: "Slagelse Kommune" },
    { code: "DK.20.336", name: "Stevns Kommune" },
    { code: "DK.20.340", name: "Sorø Kommune" },
    { code: "DK.20.350", name: "Lejre Kommune" },
    { code: "DK.20.360", name: "Lolland Kommune" },
    { code: "DK.20.370", name: "Næstved Kommune" },
    { code: "DK.20.376", name: "Guldborgsund Kommune" },
    { code: "DK.20.390", name: "Vordingborg Kommune" },
  ],
  "DK.21": [
    { code: "DK.21.410", name: "Middelfart Kommune" },
    { code: "DK.21.420", name: "Assens Kommune" },
    { code: "DK.21.430", name: "Faaborg-Midtfyn Kommune" },
    { code: "DK.21.440", name: "Kerteminde Kommune" },
    { code: "DK.21.450", name: "Nyborg Kommune" },
    { code: "DK.21.461", name: "Odense Kommune" },
    { code: "DK.21.479", name: "Svendborg Kommune" },
    { code: "DK.21.480", name: "Nordfyns Kommune" },
    { code: "DK.21.482", name: "Langeland Kommune" },
    { code: "DK.21.492", name: "Ærø Kommune" },
    { code: "DK.21.510", name: "Haderslev Kommune" },
    { code: "DK.21.530", name: "Billund Kommune" },
    { code: "DK.21.540", name: "Sønderborg Kommune" },
    { code: "DK.21.550", name: "Tønder Kommune" },
    { code: "DK.21.561", name: "Esbjerg Kommune" },
    { code: "DK.21.563", name: "Fanø Kommune" },
    { code: "DK.21.573", name: "Varde Kommune" },
    { code: "DK.21.575", name: "Vejen Kommune" },
    { code: "DK.21.580", name: "Aabenraa Kommune" },
    { code: "DK.21.607", name: "Fredericia Kommune" },
    { code: "DK.21.621", name: "Kolding Kommune" },
    { code: "DK.21.630", name: "Vejle Kommune" },
  ],
  "DO.01": [
    { code: "DO.01.0201", name: "Azua" },
    { code: "DO.01.0202", name: "Las Charcas" },
    { code: "DO.01.0203", name: "Las Yayas De Viajama" },
    { code: "DO.01.0204", name: "Padre Las Casas" },
    { code: "DO.01.0205", name: "Peralta" },
    { code: "DO.01.0206", name: "Sabana Yegua" },
    { code: "DO.01.0207", name: "Pueblo Viejo" },
    { code: "DO.01.0208", name: "Tábara Arriba" },
    { code: "DO.01.0209", name: "Guayabal" },
    { code: "DO.01.0210", name: "Estebanía" },
  ],
  "DO.02": [
    { code: "DO.02.0301", name: "Neiba" },
    { code: "DO.02.0302", name: "Galván" },
    { code: "DO.02.0303", name: "Tamayo" },
    { code: "DO.02.0304", name: "Villa Jaragua" },
    { code: "DO.02.0305", name: "Los Ríos" },
  ],
  "DO.03": [
    { code: "DO.03.0401", name: "Barahona" },
    { code: "DO.03.0402", name: "Cabral" },
    { code: "DO.03.0403", name: "Enriquillo" },
    { code: "DO.03.0404", name: "Paraíso" },
    { code: "DO.03.0405", name: "Vicente Noble" },
    { code: "DO.03.0406", name: "El Peñón" },
    { code: "DO.03.0407", name: "La Ciénaga" },
    { code: "DO.03.0408", name: "Fundación" },
    { code: "DO.03.0409", name: "Las Salinas" },
    { code: "DO.03.0410", name: "Polo" },
    { code: "DO.03.0411", name: "Jaquimeyes" },
  ],
  "DO.04": [
    { code: "DO.04.0501", name: "Dajabón" },
    { code: "DO.04.0502", name: "Loma de Cabrera" },
    { code: "DO.04.0503", name: "Partido" },
    { code: "DO.04.0504", name: "Restauración" },
    { code: "DO.04.0505", name: "El Pino" },
  ],
  "DO.06": [
    { code: "DO.06.0601", name: "San Francisco de Macorís" },
    { code: "DO.06.0602", name: "Arenoso" },
    { code: "DO.06.0603", name: "Castillo" },
    { code: "DO.06.0604", name: "Pimentel" },
    { code: "DO.06.0605", name: "Villa Riva" },
    { code: "DO.06.0606", name: "Las Guáranas" },
    { code: "DO.06.0607", name: "Eugenio María De Hostos" },
  ],
  "DO.08": [
    { code: "DO.08.0901", name: "Moca" },
    { code: "DO.08.0902", name: "Cayetano Germosén" },
    { code: "DO.08.0903", name: "Gaspar Hernández" },
    { code: "DO.08.0904", name: "Jamao Al Norte" },
  ],
  "DO.09": [
    { code: "DO.09.1001", name: "Jimaní" },
    { code: "DO.09.1002", name: "Duvergé" },
    { code: "DO.09.1003", name: "La Descubierta" },
    { code: "DO.09.1004", name: "Postrer Río" },
    { code: "DO.09.1005", name: "Cristóbal" },
    { code: "DO.09.1006", name: "Mella" },
  ],
  "DO.10": [
    { code: "DO.10.1101", name: "Higüey" },
    { code: "DO.10.1102", name: "San Rafael del Yuma" },
  ],
  "DO.11": [
    { code: "DO.11.0701", name: "Comendador" },
    { code: "DO.11.0702", name: "Bánica" },
    { code: "DO.11.0703", name: "El Llano" },
    { code: "DO.11.0704", name: "Hondo Valle" },
    { code: "DO.11.0705", name: "Pedro Santana" },
    { code: "DO.11.0706", name: "Juan Santiago" },
  ],
  "DO.12": [
    { code: "DO.12.1201", name: "La Romana" },
    { code: "DO.12.1202", name: "Guaymate" },
    { code: "DO.12.1203", name: "Villa Hermosa" },
  ],
  "DO.14": [
    { code: "DO.14.1401", name: "Nagua" },
    { code: "DO.14.1402", name: "Cabrera" },
    { code: "DO.14.1403", name: "El Factor" },
    { code: "DO.14.1404", name: "Río San Juan" },
  ],
  "DO.15": [
    { code: "DO.15.1501", name: "Monte Cristi" },
    { code: "DO.15.1502", name: "Castañuelas" },
    { code: "DO.15.1503", name: "Guayubín" },
    { code: "DO.15.1504", name: "Las Matas de Santa Cruz" },
    { code: "DO.15.1505", name: "Pepillo Salcedo" },
    { code: "DO.15.1506", name: "Villa Vásquez" },
  ],
  "DO.16": [
    { code: "DO.16.1601", name: "Pedernales" },
    { code: "DO.16.1602", name: "Oviedo" },
  ],
  "DO.18": [
    { code: "DO.18.1801", name: "Puerto Plata" },
    { code: "DO.18.1802", name: "Altamira" },
    { code: "DO.18.1803", name: "Guananico" },
    { code: "DO.18.1804", name: "Imbert" },
    { code: "DO.18.1805", name: "Los Hidalgos" },
    { code: "DO.18.1806", name: "Luperón" },
    { code: "DO.18.1807", name: "Sosúa" },
    { code: "DO.18.1808", name: "Villa Isabela" },
    { code: "DO.18.1809", name: "Villa Montellano" },
  ],
  "DO.19": [
    { code: "DO.19.1901", name: "Salcedo" },
    { code: "DO.19.1902", name: "Tenares" },
    { code: "DO.19.1903", name: "Villa Tapia" },
  ],
  "DO.20": [
    { code: "DO.20.2001", name: "Samaná Municipality" },
    { code: "DO.20.2002", name: "Sánchez" },
    { code: "DO.20.2003", name: "Las Terrenas" },
  ],
  "DO.21": [
    { code: "DO.21.2401", name: "Cotuí" },
    { code: "DO.21.2402", name: "Cevicos" },
    { code: "DO.21.2403", name: "Fantino" },
    { code: "DO.21.2404", name: "La Mata" },
  ],
  "DO.23": [
    { code: "DO.23.2201", name: "San Juan de la Maguana" },
    { code: "DO.23.2202", name: "Bohechío" },
    { code: "DO.23.2203", name: "El Cercado" },
    { code: "DO.23.2204", name: "Juan De Herrera" },
    { code: "DO.23.2205", name: "Las Matas de Farfán" },
    { code: "DO.23.2206", name: "Vallejuelo" },
  ],
  "DO.24": [
    { code: "DO.24.2301", name: "San Pedro de Macorís" },
    { code: "DO.24.2302", name: "Los Llanos" },
    { code: "DO.24.2303", name: "Ramón Santana" },
    { code: "DO.24.2304", name: "Consuelo" },
    { code: "DO.24.2305", name: "Quisqueya" },
    { code: "DO.24.2306", name: "Guayacanes" },
  ],
  "DO.25": [
    { code: "DO.25.2501", name: "Santiago de los Caballeros" },
    { code: "DO.25.2502", name: "Bisonó" },
    { code: "DO.25.2503", name: "Santo Tomás de Jánico" },
    { code: "DO.25.2504", name: "Licey al Medio" },
    { code: "DO.25.2505", name: "San José de Las Matas" },
    { code: "DO.25.2506", name: "Tamboril" },
    { code: "DO.25.2507", name: "Villa González" },
    { code: "DO.25.2508", name: "Puñal" },
    { code: "DO.25.2509", name: "Sabana Iglesia" },
  ],
  "DO.26": [
    { code: "DO.26.2601", name: "San Ignacio de Sabaneta" },
    { code: "DO.26.2602", name: "Villa Los Almácigos" },
    { code: "DO.26.2603", name: "Monción" },
  ],
  "DO.27": [
    { code: "DO.27.2701", name: "Mao" },
    { code: "DO.27.2702", name: "Esperanza" },
    { code: "DO.27.2703", name: "Laguna Salada" },
  ],
  "DO.28": [
    { code: "DO.28.0801", name: "El Seibo" },
    { code: "DO.28.0802", name: "Miches" },
  ],
  "DO.29": [
    { code: "DO.29.3001", name: "Hato Mayor" },
    { code: "DO.29.3002", name: "Sabana de La Mar" },
    { code: "DO.29.3003", name: "El Valle" },
  ],
  "DO.30": [
    { code: "DO.30.1301", name: "La Vega" },
    { code: "DO.30.1302", name: "Constanza" },
    { code: "DO.30.1303", name: "Jarabacoa" },
    { code: "DO.30.1304", name: "Jima Abajo" },
  ],
  "DO.31": [
    { code: "DO.31.2801", name: "Bonao" },
    { code: "DO.31.2802", name: "Maimón" },
    { code: "DO.31.2803", name: "Piedra Blanca" },
  ],
  "DO.32": [
    { code: "DO.32.2901", name: "Monte Plata" },
    { code: "DO.32.2902", name: "Bayaguana" },
    { code: "DO.32.2903", name: "Sabana Grande de Boyá" },
    { code: "DO.32.2904", name: "Yamasá" },
    { code: "DO.32.2905", name: "Peralvillo" },
  ],
  "DO.33": [
    { code: "DO.33.2101", name: "San Cristóbal" },
    { code: "DO.33.2102", name: "Sabana Grande De Palenque" },
    { code: "DO.33.2103", name: "Bajos de Haina" },
    { code: "DO.33.2104", name: "Cambita Garabitos" },
    { code: "DO.33.2105", name: "Villa Altagracia" },
    { code: "DO.33.2106", name: "Yaguate" },
    { code: "DO.33.2107", name: "San Gregorio De Nigua" },
    { code: "DO.33.2108", name: "Los Cacaos" },
  ],
  "DO.34": [
    { code: "DO.34.0101", name: "Santo Domingo De Guzmán" },
  ],
  "DO.35": [
    { code: "DO.35.1701", name: "Baní" },
    { code: "DO.35.1702", name: "Nizao" },
  ],
  "DO.36": [
    { code: "DO.36.3101", name: "San José de Ocoa" },
    { code: "DO.36.3102", name: "Sabana Larga" },
    { code: "DO.36.3103", name: "Rancho Arriba" },
  ],
  "DO.37": [
    { code: "DO.37.3201", name: "Santo Domingo Este" },
    { code: "DO.37.3202", name: "Santo Domingo Oeste" },
    { code: "DO.37.3203", name: "Santo Domingo Norte" },
    { code: "DO.37.3204", name: "Boca Chica" },
    { code: "DO.37.3205", name: "San Antonio De Guerra" },
    { code: "DO.37.3206", name: "Los Alcarrizos" },
    { code: "DO.37.3207", name: "Pedro Brand" },
  ],
  "DZ.01": [
    { code: "DZ.01.2500886", name: "Daïra de Dar el Beïda" },
  ],
  "DZ.03": [
    { code: "DZ.03.2487880", name: "Daïra de Merouana" },
    { code: "DZ.03.2505570", name: "Daïra de Batna" },
    { code: "DZ.03.2505627", name: "Daïra de Barika" },
    { code: "DZ.03.2506402", name: "Daïra d’Arris" },
  ],
  "DZ.04": [
    { code: "DZ.04.2501150", name: "Daïra de Constantine" },
  ],
  "DZ.06": [
    { code: "DZ.06.2478972", name: "Daïra de Tablat" },
    { code: "DZ.06.2491321", name: "Daïra de Ksar el Boukhari" },
  ],
  "DZ.07": [
    { code: "DZ.07.2481182", name: "Daïra de Sidi Ali" },
  ],
  "DZ.09": [
    { code: "DZ.09.2485924", name: "Daïra d’Oran" },
  ],
  "DZ.10": [
    { code: "DZ.10.2482569", name: "Daïra de Saïda" },
    { code: "DZ.10.2490096", name: "Daïra de Mascara" },
  ],
  "DZ.12": [
    { code: "DZ.12.2498390", name: "Daïra d’El Eulma" },
    { code: "DZ.12.2503153", name: "Daïra de Bougaa" },
    { code: "DZ.12.2507978", name: "Aïn Oulmene" },
    { code: "DZ.12.2508142", name: "Daïra d’‘Aïn el Kebira" },
  ],
  "DZ.13": [
    { code: "DZ.13.2476895", name: "Daïra de Tiaret daira de meghila" },
    { code: "DZ.13.2496230", name: "Daïra de Frenda" },
  ],
  "DZ.14": [
    { code: "DZ.14.2475742", name: "Daïra de Tizi Ouzou" },
    { code: "DZ.14.2491040", name: "Daïra de L’Arbaa Naït Irathen" },
    { code: "DZ.14.2499101", name: "Daïra de Draa el Mizan" },
    { code: "DZ.14.2506041", name: "Daïra d’Azazga" },
  ],
  "DZ.15": [
    { code: "DZ.15.2475685", name: "Daïra de Tlemcen" },
    { code: "DZ.15.2482209", name: "Daïra de Sebdou" },
    { code: "DZ.15.2490582", name: "Daïra de Maghnia" },
    { code: "DZ.15.2496040", name: "Daïra de Ghazaouet" },
  ],
  "DZ.18": [
    { code: "DZ.18.2481254", name: "Daïra de Sidi Aïch" },
    { code: "DZ.18.2505327", name: "Daïra de Bejaïa" },
    { code: "DZ.18.2507644", name: "Daïra d’Akbou" },
  ],
  "DZ.19": [
    { code: "DZ.19.2503824", name: "Daïra de Biskra" },
  ],
  "DZ.21": [
    { code: "DZ.21.2502955", name: "Daïra de Bouira" },
  ],
  "DZ.22": [
    { code: "DZ.22.2500015", name: "Daïra de Djelfa" },
    { code: "DZ.22.2507970", name: "Daïra d’‘Aïn Oussera" },
  ],
  "DZ.23": [
    { code: "DZ.23.2477459", name: "Daïra de Tébessa" },
    { code: "DZ.23.2495660", name: "Daïra de Guelma" },
  ],
  "DZ.24": [
    { code: "DZ.24.2492911", name: "Daïra de Jijel" },
    { code: "DZ.24.2497507", name: "Daïra d’El Milia" },
  ],
  "DZ.25": [
    { code: "DZ.25.2491189", name: "Daïra de Laghouat" },
    { code: "DZ.25.2508735", name: "Daïra d’Aflou" },
  ],
  "DZ.26": [
    { code: "DZ.26.2476698", name: "Daïra de Tighennif" },
    { code: "DZ.26.2487291", name: "Daïra de Mohammadia" },
  ],
  "DZ.27": [
    { code: "DZ.27.2479159", name: "Daïra de Sour el Ghozlane" },
    { code: "DZ.27.2486687", name: "Daïra de M’Sila" },
    { code: "DZ.27.2502382", name: "Daïra de Bou Saâda" },
  ],
  "DZ.29": [
    { code: "DZ.29.2508001", name: "Daïra d’Aïn M’lila" },
    { code: "DZ.29.2508284", name: "Daïra d’‘Aïn Beïda" },
  ],
  "DZ.30": [
    { code: "DZ.30.11204640", name: "Ben Badis District" },
    { code: "DZ.30.2477275", name: "Daïra de Télagh" },
    { code: "DZ.30.2481003", name: "Daïra de Sidi Bel Abbès" },
  ],
  "DZ.31": [
    { code: "DZ.31.2479533", name: "Daïra de Skikda" },
    { code: "DZ.31.2501159", name: "Daïra de Collo" },
  ],
  "DZ.33": [
    { code: "DZ.33.2498664", name: "Daïra d’El Aouinet" },
  ],
  "DZ.34": [
    { code: "DZ.34.10303657", name: "Charouine" },
    { code: "DZ.34.2476401", name: "Daïra de Timimoun" },
    { code: "DZ.34.2508809", name: "Daïra d’Adrar" },
  ],
  "DZ.35": [
    { code: "DZ.35.2487442", name: "Daïra de Miliana" },
  ],
  "DZ.36": [
    { code: "DZ.36.2504579", name: "Daïra de Beni Saf" },
  ],
  "DZ.37": [
    { code: "DZ.37.11205653", name: "Annaba District" },
  ],
  "DZ.38": [
    { code: "DZ.38.2504753", name: "Daïra de Beni Abbes" },
    { code: "DZ.38.2505528", name: "Daïra de Béchar" },
  ],
  "DZ.39": [
    { code: "DZ.39.2481698", name: "Daïra de Sétif" },
  ],
  "DZ.40": [
    { code: "DZ.40.2491132", name: "Daïra de Lakhdaria" },
    { code: "DZ.40.2503639", name: "Daïra de Bordj Menaïel" },
  ],
  "DZ.41": [
    { code: "DZ.41.2477145", name: "Daïra de Ténès" },
    { code: "DZ.41.2498609", name: "Daïra d’El Asnam" },
  ],
  "DZ.43": [
    { code: "DZ.43.11204522", name: "El M'Ghair District" },
  ],
  "DZ.44": [
    { code: "DZ.44.11204517", name: "Dréan District" },
    { code: "DZ.44.2497985", name: "Daïra d’El Kala" },
    { code: "DZ.44.2506996", name: "Daïra d’Annaba" },
  ],
  "DZ.45": [
    { code: "DZ.45.11203916", name: "El Ménia District" },
    { code: "DZ.45.2498303", name: "Daïra d’El Golea" },
    { code: "DZ.45.8293555", name: "Bukombe District" },
  ],
  "DZ.46": [
    { code: "DZ.46.2500273", name: "Daïra de Djanet" },
  ],
  "DZ.48": [
    { code: "DZ.48.11204560", name: "Chelghoum Laïd District" },
  ],
  "DZ.49": [
    { code: "DZ.49.2489863", name: "Daïra de Mecheria" },
    { code: "DZ.49.2507940", name: "Daïra d’‘Aïn Sefra" },
  ],
  "DZ.50": [
    { code: "DZ.50.2475473", name: "Daïra de Touggourt" },
    { code: "DZ.50.2485797", name: "Daïra d’Ouargla" },
  ],
  "DZ.51": [
    { code: "DZ.51.2485580", name: "Daïra d’Oued Ghiou" },
    { code: "DZ.51.2487132", name: "Daïra de Mostaganem" },
  ],
  "DZ.53": [
    { code: "DZ.53.2478218", name: "Daïra de Tamanrasset" },
    { code: "DZ.53.2493220", name: "In Salah District" },
    { code: "DZ.53.8693062", name: "In Guezzam" },
  ],
  "DZ.55": [
    { code: "DZ.55.2501438", name: "Daïra de Cherchell" },
    { code: "DZ.55.2503767", name: "Daïra de Blida" },
    { code: "DZ.55.2507473", name: "Daïra d’Alger-Sahel" },
  ],
  "DZ.56": [
    { code: "DZ.56.2476913", name: "Daïra de Theniet el Had" },
  ],
  "EC.01": [
    { code: "EC.01.2001", name: "Cantón San Cristóbal" },
    { code: "EC.01.2002", name: "Cantón Isabela" },
    { code: "EC.01.2003", name: "Cantón Santa Cruz" },
  ],
  "EC.02": [
    { code: "EC.02.0101", name: "Cantón Cuenca" },
    { code: "EC.02.0102", name: "Cantón Girón" },
    { code: "EC.02.0103", name: "Cantón Gualaceo" },
    { code: "EC.02.0104", name: "Cantón Nabón" },
    { code: "EC.02.0105", name: "Cantón Paute" },
    { code: "EC.02.0106", name: "Pucara" },
    { code: "EC.02.0107", name: "Cantón San Fernando" },
    { code: "EC.02.0108", name: "Cantón Santa Isabel" },
    { code: "EC.02.0109", name: "Cantón Sigsig" },
    { code: "EC.02.0110", name: "Oña" },
    { code: "EC.02.0111", name: "Chordeleg" },
    { code: "EC.02.0112", name: "El Pan" },
    { code: "EC.02.0113", name: "Sevilla De Oro" },
    { code: "EC.02.0114", name: "Guachapala" },
    { code: "EC.02.0115", name: "Camilo Ponce Enríquez" },
  ],
  "EC.03": [
    { code: "EC.03.0201", name: "Cantón Guaranda" },
    { code: "EC.03.0202", name: "Cantón Chillanes" },
    { code: "EC.03.0203", name: "Cantón Chimbo" },
    { code: "EC.03.0204", name: "Canton Echeandia" },
    { code: "EC.03.0205", name: "Cantón San Miguel" },
    { code: "EC.03.0206", name: "Canton Caluma" },
    { code: "EC.03.0207", name: "Canton Las Naves" },
  ],
  "EC.04": [
    { code: "EC.04.0301", name: "Cantón Azogues" },
    { code: "EC.04.0302", name: "Cantón Biblián" },
    { code: "EC.04.0303", name: "Cantón Cañar" },
    { code: "EC.04.0304", name: "La Troncal" },
    { code: "EC.04.0305", name: "Canton El Tambo" },
    { code: "EC.04.0306", name: "Déleg" },
    { code: "EC.04.0307", name: "Suscal" },
  ],
  "EC.05": [
    { code: "EC.05.0401", name: "Cantón Tulcán" },
    { code: "EC.05.0402", name: "Canton Bolivar" },
    { code: "EC.05.0403", name: "Cantón Espejo" },
    { code: "EC.05.0404", name: "Cantón Mira" },
    { code: "EC.05.0405", name: "Cantón Montúfar" },
    { code: "EC.05.0406", name: "San Pedro De Huaca" },
  ],
  "EC.06": [
    { code: "EC.06.0601", name: "Cantón Riobamba" },
    { code: "EC.06.0602", name: "Cantón Alausí" },
    { code: "EC.06.0603", name: "Cantón Colta" },
    { code: "EC.06.0604", name: "Chambo" },
    { code: "EC.06.0605", name: "Cantón Chunchi" },
    { code: "EC.06.0606", name: "Cantón Guamote" },
    { code: "EC.06.0607", name: "Cantón Guano" },
    { code: "EC.06.0608", name: "Pallatanga" },
    { code: "EC.06.0609", name: "Penipe" },
    { code: "EC.06.0610", name: "Cumanda" },
  ],
  "EC.07": [
    { code: "EC.07.0501", name: "Cantón Latacunga" },
    { code: "EC.07.0502", name: "La Maná" },
    { code: "EC.07.0503", name: "Cantón Pangua" },
    { code: "EC.07.0504", name: "Cantón Pujilí" },
    { code: "EC.07.0505", name: "Cantón Salcedo" },
    { code: "EC.07.0506", name: "Saquisilí" },
    { code: "EC.07.0507", name: "Cantón Sigchos" },
  ],
  "EC.08": [
    { code: "EC.08.0701", name: "Cantón Machala" },
    { code: "EC.08.0702", name: "Cantón Arenillas" },
    { code: "EC.08.0703", name: "Atahualpa" },
    { code: "EC.08.0704", name: "Balsas" },
    { code: "EC.08.0705", name: "Chilla" },
    { code: "EC.08.0706", name: "Cantón Guabo" },
    { code: "EC.08.0707", name: "Cantón Huaquillas" },
    { code: "EC.08.0708", name: "Marcabelí" },
    { code: "EC.08.0709", name: "Cantón Pasaje" },
    { code: "EC.08.0710", name: "Cantón Piñas" },
    { code: "EC.08.0711", name: "Cantón Portovelo" },
    { code: "EC.08.0712", name: "Cantón Santa Rosa" },
    { code: "EC.08.0713", name: "Cantón Zaruma" },
    { code: "EC.08.0714", name: "Las Lajas" },
  ],
  "EC.09": [
    { code: "EC.09.0801", name: "Cantón Esmeraldas" },
    { code: "EC.09.0802", name: "Cantón Eloy Alfaro" },
    { code: "EC.09.0803", name: "Cantón Muisne" },
    { code: "EC.09.0804", name: "Cantón Quinindé" },
    { code: "EC.09.0805", name: "Cantón San Lorenzo" },
    { code: "EC.09.0806", name: "Atacames" },
    { code: "EC.09.0807", name: "Rio Verde" },
  ],
  "EC.10": [
    { code: "EC.10.0901", name: "Cantón Guayaquil" },
    { code: "EC.10.0902", name: "Alfredo Baquerizo Moreno (Juján)" },
    { code: "EC.10.0903", name: "Balao" },
    { code: "EC.10.0904", name: "Cantón Balzar" },
    { code: "EC.10.0905", name: "Canton Colimes" },
    { code: "EC.10.0906", name: "Cantón Daule" },
    { code: "EC.10.0907", name: "Durán" },
    { code: "EC.10.0908", name: "Cantón El Empalme" },
    { code: "EC.10.0909", name: "El Triunfo" },
    { code: "EC.10.0910", name: "Cantón Milagro" },
    { code: "EC.10.0911", name: "Cantón Naranjal" },
    { code: "EC.10.0912", name: "Cantón Naranjito" },
    { code: "EC.10.0913", name: "Palestina" },
    { code: "EC.10.0914", name: "Pedro Carbo" },
    { code: "EC.10.0916", name: "Cantón Samborondón" },
    { code: "EC.10.0918", name: "Santa Lucía" },
    { code: "EC.10.0919", name: "Cantón Salitre" },
    { code: "EC.10.0920", name: "Cantón Yaguachi" },
    { code: "EC.10.0921", name: "Playas" },
    { code: "EC.10.0922", name: "Simón Bolívar" },
    { code: "EC.10.0923", name: "Coronel Marcelino Maridueña" },
    { code: "EC.10.0924", name: "Lomas De Sargentillo" },
    { code: "EC.10.0925", name: "Nobol" },
    { code: "EC.10.0927", name: "General Antonio Elizalde" },
    { code: "EC.10.0928", name: "Isidro Ayora" },
  ],
  "EC.11": [
    { code: "EC.11.1001", name: "Ibarra" },
    { code: "EC.11.1002", name: "Cantón Antonio Ante" },
    { code: "EC.11.1003", name: "Cantón Cotacachi" },
    { code: "EC.11.1004", name: "Cantón Otavalo" },
    { code: "EC.11.1005", name: "Cantón Pimampiro" },
    { code: "EC.11.1006", name: "San Miguel de Urcuqui Canton" },
  ],
  "EC.12": [
    { code: "EC.12.1101", name: "Cantón Loja" },
    { code: "EC.12.1102", name: "Cantón Calvas" },
    { code: "EC.12.1103", name: "Cantón Catamayo" },
    { code: "EC.12.1104", name: "Cantón Celica" },
    { code: "EC.12.1105", name: "Chaguarpamba" },
    { code: "EC.12.1106", name: "Cantón Espindola" },
    { code: "EC.12.1107", name: "Cantón Gonzanamá" },
    { code: "EC.12.1108", name: "Cantón Macará" },
    { code: "EC.12.1109", name: "Cantón Paltas" },
    { code: "EC.12.1110", name: "Cantón Puyango" },
    { code: "EC.12.1111", name: "Cantón Saraguro" },
    { code: "EC.12.1112", name: "Cantón Sozoranga" },
    { code: "EC.12.1113", name: "Zapotillo" },
    { code: "EC.12.1114", name: "Pindal" },
    { code: "EC.12.1115", name: "Quilanga" },
    { code: "EC.12.1116", name: "Olmedo" },
  ],
  "EC.13": [
    { code: "EC.13.1201", name: "Cantón Babahoyo" },
    { code: "EC.13.1202", name: "Cantón Baba" },
    { code: "EC.13.1203", name: "Montalvo" },
    { code: "EC.13.1204", name: "Cantón Puebloviejo" },
    { code: "EC.13.1205", name: "Cantón Quevedo" },
    { code: "EC.13.1206", name: "Cantón Urdaneta" },
    { code: "EC.13.1207", name: "Cantón Ventanas" },
    { code: "EC.13.1208", name: "Cantón Vinces" },
    { code: "EC.13.1209", name: "Palenque" },
    { code: "EC.13.1210", name: "Cantón Buena Fe" },
    { code: "EC.13.1211", name: "Cantón Valencia" },
    { code: "EC.13.1212", name: "Mocache" },
    { code: "EC.13.1213", name: "Quinsaloma" },
  ],
  "EC.14": [
    { code: "EC.14.1301", name: "Cantón Portoviejo" },
    { code: "EC.14.1302", name: "Cantón Bolívar" },
    { code: "EC.14.1303", name: "Cantón Chone" },
    { code: "EC.14.1304", name: "Cantón El Carmen" },
    { code: "EC.14.1305", name: "Flavio Alfaro" },
    { code: "EC.14.1306", name: "Cantón Jipijapa" },
    { code: "EC.14.1307", name: "Cantón Junín" },
    { code: "EC.14.1308", name: "Cantón Manta" },
    { code: "EC.14.1309", name: "Cantón Montecristi" },
    { code: "EC.14.1310", name: "Cantón Paján" },
    { code: "EC.14.1311", name: "Pichincha" },
    { code: "EC.14.1312", name: "Cantón Rocafuerte" },
    { code: "EC.14.1313", name: "Cantón Santa Ana" },
    { code: "EC.14.1314", name: "Cantón Sucre" },
    { code: "EC.14.1315", name: "Tosagua" },
    { code: "EC.14.1316", name: "Cantón Veinticuatro de Mayo" },
    { code: "EC.14.1317", name: "Canton Pedernales" },
    { code: "EC.14.1318", name: "Olmedo" },
    { code: "EC.14.1319", name: "Puerto López" },
    { code: "EC.14.1320", name: "Jama" },
    { code: "EC.14.1321", name: "Jaramijó" },
    { code: "EC.14.1322", name: "San Vicente" },
  ],
  "EC.15": [
    { code: "EC.15.1401", name: "Cantón Morona" },
    { code: "EC.15.1402", name: "Cantón Gualaquiza" },
    { code: "EC.15.1403", name: "Cantón Limón Indanza" },
    { code: "EC.15.1404", name: "Cantón Palora" },
    { code: "EC.15.1405", name: "Santiago de Méndez" },
    { code: "EC.15.1406", name: "Cantón Sucúa" },
    { code: "EC.15.1407", name: "Huamboya" },
    { code: "EC.15.1408", name: "San Juan Bosco" },
    { code: "EC.15.1409", name: "Taisha" },
    { code: "EC.15.1410", name: "Logroño" },
    { code: "EC.15.1411", name: "Pablo Sexto" },
    { code: "EC.15.1412", name: "Tiwintza" },
  ],
  "EC.17": [
    { code: "EC.17.1601", name: "Cantón Pastaza" },
    { code: "EC.17.1602", name: "Cantón Mera" },
    { code: "EC.17.1603", name: "Santa Clara" },
    { code: "EC.17.1604", name: "Arajuno" },
  ],
  "EC.18": [
    { code: "EC.18.1701", name: "Cantón Quito" },
    { code: "EC.18.1702", name: "Cantón Cayambe" },
    { code: "EC.18.1703", name: "Cantón Mejía" },
    { code: "EC.18.1704", name: "Cantón Pedro Moncayo" },
    { code: "EC.18.1705", name: "Cantón Rumiñahui" },
    { code: "EC.18.1707", name: "San Miguel De Los Bancos" },
    { code: "EC.18.1708", name: "Canton Pedro Vicente Maldonado" },
    { code: "EC.18.1709", name: "Puerto Quito" },
  ],
  "EC.19": [
    { code: "EC.19.1801", name: "Cantón Ambato" },
    { code: "EC.19.1802", name: "Cantón Baños" },
    { code: "EC.19.1803", name: "Cevallos" },
    { code: "EC.19.1804", name: "Mocha" },
    { code: "EC.19.1805", name: "Cantón Patate" },
    { code: "EC.19.1806", name: "Cantón Quero" },
    { code: "EC.19.1807", name: "Cantón Pelileo" },
    { code: "EC.19.1808", name: "Cantón Píllaro" },
    { code: "EC.19.1809", name: "Tisaleo" },
  ],
  "EC.20": [
    { code: "EC.20.1901", name: "Cantón Zamora" },
    { code: "EC.20.1902", name: "Cantón Chinchipe" },
    { code: "EC.20.1903", name: "Nangaritza" },
    { code: "EC.20.1904", name: "Cantón Yacuambi" },
    { code: "EC.20.1905", name: "Cantón Yantzaza" },
    { code: "EC.20.1906", name: "El Pangui" },
    { code: "EC.20.1907", name: "Centinela Del Cóndor" },
    { code: "EC.20.1908", name: "Palanda" },
    { code: "EC.20.1909", name: "Paquisha" },
  ],
  "EC.22": [
    { code: "EC.22.2101", name: "Cantón Lago Agrio" },
    { code: "EC.22.2102", name: "Gonzalo Pizarro" },
    { code: "EC.22.2103", name: "Cantón Putumayo" },
    { code: "EC.22.2104", name: "Shushufindi" },
    { code: "EC.22.2105", name: "Cantón Sucumbíos" },
    { code: "EC.22.2106", name: "Cascales" },
    { code: "EC.22.2107", name: "Cuyabeno" },
  ],
  "EC.23": [
    { code: "EC.23.1501", name: "Cantón Tena" },
    { code: "EC.23.1503", name: "Cantón Archidona" },
    { code: "EC.23.1504", name: "Cantón Chaco" },
    { code: "EC.23.1507", name: "Cantón Quijos" },
    { code: "EC.23.1509", name: "Carlos Julio Arosemena Tola" },
  ],
  "EC.24": [
    { code: "EC.24.2201", name: "Francisco de Orellana Canton" },
    { code: "EC.24.2202", name: "Cantón Aguarico" },
    { code: "EC.24.2203", name: "La Joya De Los Sachas" },
    { code: "EC.24.2204", name: "Loreto Canton" },
  ],
  "EC.25": [
    { code: "EC.25.2401", name: "Cantón Santa Elena" },
    { code: "EC.25.2402", name: "La Libertad" },
    { code: "EC.25.2403", name: "Cantón Salinas" },
  ],
  "EC.26": [
    { code: "EC.26.2301", name: "Cantón Santo Domingo de los Colorados" },
    { code: "EC.26.2302", name: "La Concordia" },
  ],
  "EE.01": [
    { code: "EE.01.0141", name: "Anija vald" },
    { code: "EE.01.0198", name: "Harku vald" },
    { code: "EE.01.0245", name: "Jõelähtme vald" },
    { code: "EE.01.0296", name: "Keila linn" },
    { code: "EE.01.0304", name: "Kiili vald" },
    { code: "EE.01.0338", name: "Kose vald" },
    { code: "EE.01.0353", name: "Kuusalu vald" },
    { code: "EE.01.0424", name: "Loksa linn" },
    { code: "EE.01.0431", name: "Lääne-Harju vald" },
    { code: "EE.01.0446", name: "Maardu linn" },
    { code: "EE.01.0651", name: "Raasiku vald" },
    { code: "EE.01.0653", name: "Rae vald" },
    { code: "EE.01.0718", name: "Saku vald" },
    { code: "EE.01.0726", name: "Saue vald" },
    { code: "EE.01.0784", name: "Tallinn" },
    { code: "EE.01.0890", name: "Viimsi vald" },
  ],
  "EE.02": [
    { code: "EE.02.0205", name: "Hiiumaa vald" },
  ],
  "EE.03": [
    { code: "EE.03.0130", name: "Alutaguse vald" },
    { code: "EE.03.0251", name: "Jõhvi vald" },
    { code: "EE.03.0321", name: "Kohtla-Järve linn" },
    { code: "EE.03.0442", name: "Lüganuse vald" },
    { code: "EE.03.0511", name: "Narva linn" },
    { code: "EE.03.0514", name: "Narva-Jõesuu linn" },
    { code: "EE.03.0735", name: "Sillamäe linn" },
    { code: "EE.03.0803", name: "Toila vald" },
  ],
  "EE.04": [
    { code: "EE.04.0255", name: "Järva vald" },
    { code: "EE.04.0567", name: "Paide linn" },
    { code: "EE.04.0834", name: "Türi vald" },
  ],
  "EE.05": [
    { code: "EE.05.0247", name: "Jõgeva vald" },
    { code: "EE.05.0486", name: "Mustvee vald" },
    { code: "EE.05.0618", name: "Põltsamaa vald" },
  ],
  "EE.07": [
    { code: "EE.07.0184", name: "Haapsalu linn" },
    { code: "EE.07.0441", name: "Lääne-Nigula vald" },
    { code: "EE.07.0907", name: "Vormsi vald" },
  ],
  "EE.08": [
    { code: "EE.08.0191", name: "Haljala vald" },
    { code: "EE.08.0272", name: "Kadrina vald" },
    { code: "EE.08.0661", name: "Rakvere vald" },
    { code: "EE.08.0663", name: "Rakvere linn" },
    { code: "EE.08.0792", name: "Tapa vald" },
    { code: "EE.08.0901", name: "Vinni vald" },
    { code: "EE.08.0903", name: "Viru-Nigula vald" },
    { code: "EE.08.0928", name: "Väike-Maarja vald" },
  ],
  "EE.11": [
    { code: "EE.11.0214", name: "Häädemeeste vald" },
    { code: "EE.11.0303", name: "Kihnu vald" },
    { code: "EE.11.0430", name: "Lääneranna vald" },
    { code: "EE.11.0624", name: "Pärnu linn" },
    { code: "EE.11.0638", name: "Põhja-Pärnumaa vald" },
    { code: "EE.11.0712", name: "Saarde vald" },
    { code: "EE.11.0809", name: "Tori vald" },
  ],
  "EE.12": [
    { code: "EE.12.0284", name: "Kanepi vald" },
    { code: "EE.12.0622", name: "Põlva vald" },
    { code: "EE.12.0708", name: "Räpina vald" },
  ],
  "EE.13": [
    { code: "EE.13.0293", name: "Kehtna vald" },
    { code: "EE.13.0317", name: "Kohila vald" },
    { code: "EE.13.0503", name: "Märjamaa vald" },
    { code: "EE.13.0668", name: "Rapla vald" },
  ],
  "EE.14": [
    { code: "EE.14.0478", name: "Muhu vald" },
    { code: "EE.14.0689", name: "Ruhnu vald" },
    { code: "EE.14.0714", name: "Saaremaa vald" },
  ],
  "EE.18": [
    { code: "EE.18.0171", name: "Elva vald" },
    { code: "EE.18.0283", name: "Kambja vald" },
    { code: "EE.18.0291", name: "Kastre vald" },
    { code: "EE.18.0432", name: "Luunja vald" },
    { code: "EE.18.0528", name: "Nõo vald" },
    { code: "EE.18.0586", name: "Peipsiääre vald" },
    { code: "EE.18.0793", name: "Tartu linn" },
    { code: "EE.18.0796", name: "Tartu vald" },
  ],
  "EE.19": [
    { code: "EE.19.0557", name: "Otepää vald" },
    { code: "EE.19.0824", name: "Tõrva vald" },
    { code: "EE.19.0855", name: "Valga vald" },
  ],
  "EE.20": [
    { code: "EE.20.0480", name: "Mulgi vald" },
    { code: "EE.20.0615", name: "Põhja-Sakala vald" },
    { code: "EE.20.0897", name: "Viljandi linn" },
    { code: "EE.20.0899", name: "Viljandi vald" },
  ],
  "EE.21": [
    { code: "EE.21.0142", name: "Antsla vald" },
    { code: "EE.21.0698", name: "Rõuge vald" },
    { code: "EE.21.0732", name: "Setomaa vald" },
    { code: "EE.21.0917", name: "Võru vald" },
    { code: "EE.21.0919", name: "Võru linn" },
  ],
  "EG.01": [
    { code: "EG.01.352180", name: "Markaz Mīt Ghamr" },
    { code: "EG.01.358171", name: "Markaz Dikirnis" },
    { code: "EG.01.358824", name: "Markaz Bilqās" },
    { code: "EG.01.360756", name: "Markaz al Manzilah" },
    { code: "EG.01.360763", name: "Markaz al Manşūrah" },
    { code: "EG.01.361701", name: "Markaz Ajā" },
    { code: "EG.01.7910872", name: "Bahr El Bakr" },
    { code: "EG.01.7910974", name: "Mit Yazid" },
    { code: "EG.01.8559274", name: "Markaz Minyat An Naşr" },
  ],
  "EG.03": [
    { code: "EG.03.10430542", name: "Markaz Idkū" },
    { code: "EG.03.10645705", name: "Markaz ar Raḩmānīyah" },
    { code: "EG.03.350200", name: "Markaz Rashīd" },
    { code: "EG.03.354773", name: "Markaz Kafr ad Dawwār" },
    { code: "EG.03.355416", name: "Markaz Ītāy al Bārūd" },
    { code: "EG.03.355999", name: "Markaz Ḩawsh ‘Īsá" },
    { code: "EG.03.358446", name: "Markaz Damanhūr" },
    { code: "EG.03.360821", name: "Markaz al Maḩmūdīyah" },
    { code: "EG.03.361828", name: "Markaz ad Dilinjāt" },
    { code: "EG.03.362550", name: "Markaz Abū Ḩummuş" },
    { code: "EG.03.362880", name: "Markaz Abū al Maţāmīr" },
  ],
  "EG.04": [
    { code: "EG.04.347541", name: "Markaz Ţāmiyah" },
    { code: "EG.04.355419", name: "Markaz Iţsā" },
    { code: "EG.04.355647", name: "Markaz Ibshawāy" },
    { code: "EG.04.361322", name: "Markaz al Fayyūm" },
  ],
  "EG.05": [
    { code: "EG.05.346029", name: "Markaz Ziftá" },
    { code: "EG.05.347496", name: "Markaz Ţanţā" },
    { code: "EG.05.350373", name: "Markaz Quţūr" },
    { code: "EG.05.358969", name: "Markaz Basyūn" },
    { code: "EG.05.359850", name: "Markaz as Sanţah" },
    { code: "EG.05.360830", name: "Markaz al Maḩallah al Kubrá" },
    { code: "EG.05.8561528", name: "Markaz Sammanūd" },
  ],
  "EG.06": [
    { code: "EG.06.11205726", name: "Al Muntazah" },
    { code: "EG.06.352720", name: "Markaz Maryūţ" },
  ],
  "EG.07": [
    { code: "EG.07.10371148", name: "Markaz al Ismā‘īlīyah" },
    { code: "EG.07.10371149", name: "Markaz al Qanţarah Sharq" },
    { code: "EG.07.10371150", name: "Markaz Fāyid" },
    { code: "EG.07.350768", name: "Markaz al Qanţarah Gharb" },
  ],
  "EG.08": [
    { code: "EG.08.355547", name: "Markaz Imbābah" },
    { code: "EG.08.360479", name: "Markaz al Wāḩāt al Baḩrīyah" },
    { code: "EG.08.360996", name: "Markaz al Jīzah" },
    { code: "EG.08.361474", name: "Markaz al Badrashayn" },
    { code: "EG.08.361497", name: "Markaz al ‘Ayyāţ" },
    { code: "EG.08.8146219", name: "Markaz Awsīm" },
    { code: "EG.08.9179486", name: "Walikale" },
  ],
  "EG.09": [
    { code: "EG.09.10371118", name: "Markaz Birkat as Sab‘" },
    { code: "EG.09.345955", name: "Markaz al Bājūr" },
    { code: "EG.09.350368", name: "Markaz Quwaysinā" },
    { code: "EG.09.359954", name: "Markaz ash Shuhadā’" },
    { code: "EG.09.360047", name: "Markaz Ashmūn" },
  ],
  "EG.10": [
    { code: "EG.10.349716", name: "Markaz Samālūţ" },
    { code: "EG.10.352626", name: "Markaz Maţāy" },
    { code: "EG.10.352950", name: "Markaz Mallawī" },
    { code: "EG.10.358273", name: "Markaz Dayr Mawās" },
    { code: "EG.10.359211", name: "Markaz Banī Mazār" },
    { code: "EG.10.360687", name: "Markaz al Minyā" },
    { code: "EG.10.361099", name: "Markaz al ‘Idwah" },
    { code: "EG.10.362276", name: "Markaz Qurqāş" },
  ],
  "EG.11": [
    { code: "EG.11.11204016", name: "Al Marj" },
    { code: "EG.11.359901", name: "Markaz aş Şaff" },
    { code: "EG.11.360929", name: "Markaz al Khānkah" },
    { code: "EG.11.7910874", name: "Mostafa El Serwy" },
  ],
  "EG.12": [
    { code: "EG.12.350787", name: "Markaz Qalyūb" },
    { code: "EG.12.359279", name: "Markaz Banhā" },
    { code: "EG.12.7732632", name: "Mostorod" },
    { code: "EG.12.8061368", name: "Markaz Kafr Shukr" },
  ],
  "EG.13": [
    { code: "EG.13.12060332", name: "Shurtah al-Farafirah" },
    { code: "EG.13.12060333", name: "Baris Shurtah" },
    { code: "EG.13.360478", name: "Markaz al Wāḩāt al Khārijah" },
    { code: "EG.13.360480", name: "Markaz al Wāḩāt ad Dākhilah" },
  ],
  "EG.14": [
    { code: "EG.14.10371147", name: "Markaz at Tall al Kabīr" },
    { code: "EG.14.352351", name: "Markaz Minyā al Qamḩ" },
    { code: "EG.14.355938", name: "Markaz Hihyā" },
    { code: "EG.14.358094", name: "Markaz Diyarb Najm" },
    { code: "EG.14.358838", name: "Markaz Bilbays" },
    { code: "EG.14.359494", name: "Markaz az Zaqāzīq" },
    { code: "EG.14.361127", name: "Markaz al Ḩusaynīyah" },
    { code: "EG.14.362484", name: "Markaz Abū Kabīr" },
    { code: "EG.14.362612", name: "Markaz Abū Ḩammād" },
    { code: "EG.14.7910679", name: "Bahr El Bakar" },
  ],
  "EG.16": [
    { code: "EG.16.346518", name: "Markaz ‘Unaybah" },
    { code: "EG.16.355633", name: "Markaz Idfū" },
    { code: "EG.16.359788", name: "Markaz Aswān" },
  ],
  "EG.17": [
    { code: "EG.17.10371124", name: "Markaz al Fatḩ" },
    { code: "EG.17.10371125", name: "Markaz al Ghanāyim" },
    { code: "EG.17.10371126", name: "Markaz as Sāḩil" },
    { code: "EG.17.358267", name: "Markaz Dayrūţ" },
    { code: "EG.17.359782", name: "Markaz Asyūţ" },
    { code: "EG.17.360527", name: "Markaz al Qūşīyah" },
    { code: "EG.17.361479", name: "Markaz al Badārī" },
    { code: "EG.17.362003", name: "Markaz Abū Tīj" },
  ],
  "EG.18": [
    { code: "EG.18.10371146", name: "Markaz Nāşir" },
    { code: "EG.18.347750", name: "Markaz Sumusţā al Waqf" },
    { code: "EG.18.355594", name: "Markaz Ihnāsiyā al Madīnah" },
    { code: "EG.18.358599", name: "Markaz Būsh" },
    { code: "EG.18.358869", name: "Markaz Bibā" },
    { code: "EG.18.359172", name: "Markaz Banī Suwayf" },
    { code: "EG.18.360466", name: "Markaz al Wāsiţá" },
    { code: "EG.18.361330", name: "Markaz al Fashn" },
  ],
  "EG.20": [
    { code: "EG.20.356943", name: "Markaz Fāriskūr" },
    { code: "EG.20.8559275", name: "Markaz az Zarqā" },
    { code: "EG.20.8594167", name: "Markaz Kafr Sa‘d" },
  ],
  "EG.21": [
    { code: "EG.21.10371122", name: "Markaz ar Riyāḑ" },
    { code: "EG.21.10371123", name: "Markaz Muţūbas" },
    { code: "EG.21.348095", name: "Markaz Sīdī Sālim" },
    { code: "EG.21.350795", name: "Markaz Qallīn" },
    { code: "EG.21.354501", name: "Markaz Kafr ash Shaykh" },
    { code: "EG.21.356805", name: "Markaz Fuwwah" },
    { code: "EG.21.358107", name: "Markaz Disūq" },
    { code: "EG.21.358725", name: "Markaz Biyalā" },
    { code: "EG.21.361358", name: "Markaz al Burullus" },
    { code: "EG.21.7772238", name: "Markaz al Ḩāmūl" },
    { code: "EG.21.7911002", name: "Kafr El Sheikh" },
  ],
  "EG.22": [
    { code: "EG.22.352605", name: "Markaz Maţrūḩ" },
  ],
  "EG.23": [
    { code: "EG.23.350547", name: "Markaz Qinā" },
    { code: "EG.23.351433", name: "Markaz Naj‘ Ḩammādī" },
    { code: "EG.23.355447", name: "Markaz Isnā" },
    { code: "EG.23.358114", name: "Markaz Dishnā" },
    { code: "EG.23.360166", name: "Markaz Armant" },
    { code: "EG.23.361994", name: "Markaz Abū Tisht" },
  ],
  "EG.24": [
    { code: "EG.24.10371119", name: "Markaz Juhaynah al Gharbīyah" },
    { code: "EG.24.10371120", name: "Markaz Dār as Salām" },
    { code: "EG.24.347795", name: "Markaz Sūhāj" },
    { code: "EG.24.355025", name: "Markaz Jirjā" },
    { code: "EG.24.359588", name: "Markaz Awlād Ţawq Sharq" },
    { code: "EG.24.360699", name: "Markaz al Munsha’ah" },
    { code: "EG.24.360749", name: "Markaz al Marāghah" },
    { code: "EG.24.361436", name: "Markaz al Balyanā" },
    { code: "EG.24.361660", name: "Markaz Akhmīm" },
  ],
  "EG.26": [
    { code: "EG.26.10371116", name: "Markaz Aţfīḩ" },
  ],
  "EG.27": [
    { code: "EG.27.8601177", name: "Markaz al ‘Arīsh" },
    { code: "EG.27.8601178", name: "Markaz ash Shaykh Zuwayd" },
    { code: "EG.27.8601179", name: "Markaz Rafaḩ" },
    { code: "EG.27.8601180", name: "Markaz Bi’r al ‘Abd" },
  ],
  "EG.28": [
    { code: "EG.28.360503", name: "Markaz al Uqşur" },
  ],
  "ER.01": [
    { code: "ER.01.10627798", name: "Geleb Subregion" },
    { code: "ER.01.9166029", name: "Adi Tekelezan Subregion" },
    { code: "ER.01.9166032", name: "Asmat" },
    { code: "ER.01.9166033", name: "Elabered Subregion" },
    { code: "ER.01.9166038", name: "Hagaz Subregion" },
    { code: "ER.01.9166039", name: "Halhal Subregion" },
    { code: "ER.01.9166040", name: "Habero Subregion" },
    { code: "ER.01.9166042", name: "Kerkebet" },
    { code: "ER.01.9166043", name: "Keren Subregion" },
    { code: "ER.01.9166044", name: "Sela Subregion" },
  ],
  "ER.02": [
    { code: "ER.02.10114297", name: "Mai-Mne Subregion" },
    { code: "ER.02.10177514", name: "Areza Subregion" },
    { code: "ER.02.328827", name: "Serayē Āwraja" },
    { code: "ER.02.344451", name: "Ākale Guzay Āwraja" },
    { code: "ER.02.9166054", name: "Dekemhare Subregion" },
    { code: "ER.02.9166055", name: "Mendefera Subregion" },
    { code: "ER.02.9166056", name: "Senafe Subregion" },
  ],
  "ER.03": [
    { code: "ER.03.10375723", name: "Central Denkalya Subregion" },
    { code: "ER.03.413928", name: "Denkel Āwraja" },
    { code: "ER.03.9166057", name: "Southern Denkalya Subregion" },
  ],
  "ER.04": [
    { code: "ER.04.10172859", name: "Logo Anseba" },
    { code: "ER.04.10177504", name: "Teseney Subregion" },
    { code: "ER.04.10177509", name: "Haykota Subregion" },
    { code: "ER.04.10177510", name: "Gogne Subregion" },
    { code: "ER.04.10177511", name: "Mogolo Subregion" },
    { code: "ER.04.10177512", name: "Mensura Subregion" },
    { code: "ER.04.10177513", name: "Shambuko Subregion" },
    { code: "ER.04.335174", name: "Hamasēn Āwraja" },
    { code: "ER.04.413927", name: "Barka Āwraja" },
    { code: "ER.04.9165822", name: "Dghe" },
    { code: "ER.04.9166045", name: "Akurdet Subregion" },
    { code: "ER.04.9166046", name: "Barentu Subregion" },
  ],
  "ER.05": [
    { code: "ER.05.9166015", name: "Berikh" },
    { code: "ER.05.9166018", name: "Ghala Nefhi" },
    { code: "ER.05.9166024", name: "Serejaka" },
    { code: "ER.05.9166027", name: "South Eastern Subregion" },
    { code: "ER.05.9166028", name: "South Western Subregion" },
  ],
  "ER.06": [
    { code: "ER.06.10628668", name: "Ghelaelo" },
    { code: "ER.06.10628671", name: "Foro Sub-Region" },
    { code: "ER.06.329423", name: "Sahil Āwraja" },
    { code: "ER.06.413929", name: "Semhar Āwraja" },
    { code: "ER.06.413930", name: "Senhit Āwraja" },
    { code: "ER.06.9165816", name: "Af'abet" },
    { code: "ER.06.9166034", name: "North Eastern Subregion" },
    { code: "ER.06.9166047", name: "Dahlak Subregion" },
    { code: "ER.06.9166048", name: "Ghinda Subregion" },
    { code: "ER.06.9166050", name: "Massawa Subregion" },
    { code: "ER.06.9166052", name: "Nakfa Subregion" },
  ],
  "ES.07": [
    { code: "ES.07.PM", name: "Illes Balears" },
  ],
  "ES.27": [
    { code: "ES.27.LO", name: "Provincia de La Rioja" },
  ],
  "ES.29": [
    { code: "ES.29.M", name: "Provincia de Madrid" },
  ],
  "ES.31": [
    { code: "ES.31.MU", name: "Murcia" },
  ],
  "ES.32": [
    { code: "ES.32.NA", name: "Provincia de Navarra" },
  ],
  "ES.34": [
    { code: "ES.34.O", name: "Province of Asturias" },
  ],
  "ES.39": [
    { code: "ES.39.S", name: "Provincia de Cantabria" },
  ],
  "ES.51": [
    { code: "ES.51.AL", name: "Almería" },
    { code: "ES.51.CA", name: "Provincia de Cádiz" },
    { code: "ES.51.CO", name: "Province of Córdoba" },
    { code: "ES.51.GR", name: "Provincia de Granada" },
    { code: "ES.51.H", name: "Provincia de Huelva" },
    { code: "ES.51.J", name: "Provincia de Jaén" },
    { code: "ES.51.MA", name: "Provincia de Málaga" },
    { code: "ES.51.SE", name: "Provincia de Sevilla" },
  ],
  "ES.52": [
    { code: "ES.52.HU", name: "Provincia de Huesca" },
    { code: "ES.52.TE", name: "Provincia de Teruel" },
    { code: "ES.52.Z", name: "Provincia de Zaragoza" },
  ],
  "ES.53": [
    { code: "ES.53.GC", name: "Provincia de Las Palmas" },
    { code: "ES.53.TF", name: "Provincia de Santa Cruz de Tenerife" },
  ],
  "ES.54": [
    { code: "ES.54.AB", name: "Provincia de Albacete" },
    { code: "ES.54.CR", name: "Provincia de Ciudad Real" },
    { code: "ES.54.CU", name: "Provincia de Cuenca" },
    { code: "ES.54.GU", name: "Provincia de Guadalajara" },
    { code: "ES.54.TO", name: "Province of Toledo" },
  ],
  "ES.55": [
    { code: "ES.55.AV", name: "Provincia de Ávila" },
    { code: "ES.55.BU", name: "Provincia de Burgos" },
    { code: "ES.55.LE", name: "Provincia de León" },
    { code: "ES.55.P", name: "Provincia de Palencia" },
    { code: "ES.55.SA", name: "Provincia de Salamanca" },
    { code: "ES.55.SG", name: "Provincia de Segovia" },
    { code: "ES.55.SO", name: "Provincia de Soria" },
    { code: "ES.55.VA", name: "Provincia de Valladolid" },
    { code: "ES.55.ZA", name: "Provincia de Zamora" },
  ],
  "ES.56": [
    { code: "ES.56.B", name: "Província de Barcelona" },
    { code: "ES.56.GI", name: "Província de Girona" },
    { code: "ES.56.L", name: "Província de Lleida" },
    { code: "ES.56.T", name: "Província de Tarragona" },
  ],
  "ES.57": [
    { code: "ES.57.BA", name: "Provincia de Badajoz" },
    { code: "ES.57.CC", name: "Provincia de Cáceres" },
  ],
  "ES.58": [
    { code: "ES.58.C", name: "Provincia da Coruña" },
    { code: "ES.58.LU", name: "Provincia de Lugo" },
    { code: "ES.58.OR", name: "Provincia de Ourense" },
    { code: "ES.58.PO", name: "Provincia de Pontevedra" },
  ],
  "ES.59": [
    { code: "ES.59.BI", name: "Bizkaia" },
    { code: "ES.59.SS", name: "Gipuzkoa" },
    { code: "ES.59.VI", name: "Araba / Álava" },
  ],
  "ES.60": [
    { code: "ES.60.A", name: "Provincia de Alicante" },
    { code: "ES.60.CS", name: "Província de Castelló" },
    { code: "ES.60.V", name: "Província de València" },
  ],
  "ES.CE": [
    { code: "ES.CE.CE", name: "Ceuta" },
  ],
  "ES.ML": [
    { code: "ES.ML.ME", name: "Melilla" },
  ],
  "ET.44": [
    { code: "ET.44.11750840", name: "Kolfe Keranyo" },
    { code: "ET.44.11750841", name: "Akaki Kaliti" },
    { code: "ET.44.11750842", name: "Nefas Silk Lafto" },
    { code: "ET.44.11750843", name: "Bole" },
    { code: "ET.44.11750844", name: "Yeka" },
    { code: "ET.44.11750845", name: "Kirkos" },
    { code: "ET.44.11750846", name: "Gulele" },
    { code: "ET.44.11750847", name: "Arada" },
    { code: "ET.44.11750848", name: "Addis Ketema" },
    { code: "ET.44.11750849", name: "Lideta" },
    { code: "ET.44.7733020", name: "Addis Ababa Zone 1" },
    { code: "ET.44.7733021", name: "Addis Ababa Zone 2" },
    { code: "ET.44.7733022", name: "Addis Ababa Zone 3" },
    { code: "ET.44.7733023", name: "Addis Ababa Zone 6" },
    { code: "ET.44.8051210", name: "Addis Ababa Zone 5" },
  ],
  "ET.45": [
    { code: "ET.45.7646394", name: "Pemba District" },
    { code: "ET.45.7732968", name: "Administrative Zone 3" },
    { code: "ET.45.8643576", name: "Administrative Zone 1" },
    { code: "ET.45.8643583", name: "Administrative Zone 2" },
    { code: "ET.45.8643588", name: "Administrative Zone 4" },
    { code: "ET.45.8643592", name: "Administrative Zone 5" },
  ],
  "ET.46": [
    { code: "ET.46.11750807", name: "North Gonder" },
    { code: "ET.46.11750808", name: "Wag Himra" },
    { code: "ET.46.11750809", name: "West Gojam" },
    { code: "ET.46.11750810", name: "East Gojam" },
    { code: "ET.46.11750811", name: "South Gonder" },
    { code: "ET.46.11750812", name: "Oromiya" },
    { code: "ET.46.7670722", name: "West Gojjam Zone" },
    { code: "ET.46.7670724", name: "East Gojjam Zone" },
    { code: "ET.46.7670725", name: "Awi" },
    { code: "ET.46.7670726", name: "North Gondar Zone" },
    { code: "ET.46.7732961", name: "South Wollo Zone" },
    { code: "ET.46.7869861", name: "South Gondar Zone" },
    { code: "ET.46.7869862", name: "North Wollo Zone" },
    { code: "ET.46.8051207", name: "North Shewa Zone" },
    { code: "ET.46.8051209", name: "Wag Hemra Zone" },
    { code: "ET.46.9165721", name: "Oromia Zone" },
  ],
  "ET.47": [
    { code: "ET.47.10303651", name: "Kamashi Zone" },
    { code: "ET.47.11750813", name: "Kemashi" },
    { code: "ET.47.330790", name: "Metekel Āwraja" },
    { code: "ET.47.343291", name: "Asosa" },
    { code: "ET.47.7874607", name: "Metekel" },
  ],
  "ET.49": [
    { code: "ET.49.11750817", name: "Nuer" },
    { code: "ET.49.11750818", name: "Agnuak" },
    { code: "ET.49.11750819", name: "Mezhenger" },
    { code: "ET.49.7732967", name: "Administrative Zone 1" },
  ],
  "ET.50": [
    { code: "ET.50.11750838", name: "Harari" },
  ],
  "ET.51": [
    { code: "ET.51.11750827", name: "Kellem Wellega" },
    { code: "ET.51.11750828", name: "Ilubabor" },
    { code: "ET.51.11750829", name: "Horo Guduru" },
    { code: "ET.51.11750830", name: "West Harerge" },
    { code: "ET.51.11750831", name: "East Harerge" },
    { code: "ET.51.11750837", name: "Southwest Shuwa" },
    { code: "ET.51.11750850", name: "West Arsi" },
    { code: "ET.51.333766", name: "Jimma Zone" },
    { code: "ET.51.343450", name: "Arsi Zone" },
    { code: "ET.51.7648477", name: "Misraq Shewa" },
    { code: "ET.51.7670714", name: "North Shewa Zone" },
    { code: "ET.51.7670715", name: "West Shewa Zone" },
    { code: "ET.51.7670717", name: "South West Shewa" },
    { code: "ET.51.7670720", name: "East Shewa Zone" },
    { code: "ET.51.7670721", name: "East Wellega Zone" },
    { code: "ET.51.7732039", name: "Borena Zone" },
    { code: "ET.51.7732965", name: "Illubabor Zone" },
    { code: "ET.51.7732966", name: "West Wellega Zone" },
    { code: "ET.51.7732969", name: "West Harerghe Zone" },
    { code: "ET.51.7732970", name: "East Harerghe Zone" },
    { code: "ET.51.7839144", name: "Bale" },
    { code: "ET.51.8299785", name: "Guji Zone" },
    { code: "ET.51.8606578", name: "Gimbichu" },
  ],
  "ET.52": [
    { code: "ET.52.10376670", name: "Dollo" },
    { code: "ET.52.10395468", name: "Gode Zone" },
    { code: "ET.52.10399848", name: "Degehabur Zone" },
    { code: "ET.52.10400171", name: "Fafan" },
    { code: "ET.52.11750832", name: "Siti" },
    { code: "ET.52.11750833", name: "Nogob" },
    { code: "ET.52.11750834", name: "Doolo" },
    { code: "ET.52.11750835", name: "Korahe" },
    { code: "ET.52.11750836", name: "Shabelle" },
    { code: "ET.52.338829", name: "Dire Dawa Zone" },
    { code: "ET.52.7732971", name: "Shinile Zone" },
    { code: "ET.52.8643822", name: "Liben zone" },
    { code: "ET.52.9410038", name: "Afder Zone" },
  ],
  "ET.53": [
    { code: "ET.53.11153778", name: "Southeastern Tigray Zone" },
    { code: "ET.53.11750806", name: "Western" },
    { code: "ET.53.7667868", name: "Southern Tigray Zone" },
    { code: "ET.53.7869875", name: "Central Tigray Zone" },
    { code: "ET.53.7869879", name: "Eastern Tigray Zone" },
    { code: "ET.53.7869945", name: "North Western Tigray" },
    { code: "ET.53.8643579", name: "Mekelle" },
    { code: "ET.53.8643826", name: "Mi'irabawi Zone" },
  ],
  "ET.54": [
    { code: "ET.54.10377041", name: "South Omo Zone" },
    { code: "ET.54.11750820", name: "Sheka Zone" },
    { code: "ET.54.11750821", name: "Konta" },
    { code: "ET.54.11750822", name: "Dawro" },
    { code: "ET.54.11750824", name: "Segen Peoples" },
    { code: "ET.54.11750825", name: "Gedio" },
    { code: "ET.54.11750826", name: "Selti" },
    { code: "ET.54.326423", name: "Wolayita Zone" },
    { code: "ET.54.331677", name: "Bench Maji Zone" },
    { code: "ET.54.333384", name: "Hadiya Zone" },
    { code: "ET.54.333465", name: "Kaffa Zone" },
    { code: "ET.54.341021", name: "Guraghe Zone" },
    { code: "ET.54.7667869", name: "Alaba Special Wereda" },
    { code: "ET.54.7667870", name: "Kembata Alaba Tembaro Zone" },
    { code: "ET.54.7670680", name: "Yem" },
    { code: "ET.54.7670728", name: "Siltie Zone" },
    { code: "ET.54.7670729", name: "Dawuro" },
    { code: "ET.54.7670732", name: "Gedeo Zone" },
    { code: "ET.54.7729829", name: "South Omo" },
    { code: "ET.54.8260659", name: "Keficho Shekicho Zone" },
    { code: "ET.54.8299784", name: "Sidama Zone" },
    { code: "ET.54.9159975", name: "Gamo Gofa Zone" },
    { code: "ET.54.9410112", name: "Basketo Special Woreda" },
    { code: "ET.54.9410266", name: "Amaro Special Woreda" },
    { code: "ET.54.9410393", name: "Dirashe Special Woreda" },
    { code: "ET.54.9410442", name: "Konso Special Woreda" },
    { code: "ET.54.9410501", name: "Burji Special Woreda" },
  ],
  "FI.01": [
    { code: "FI.01.011", name: "Helsinki" },
    { code: "FI.01.014", name: "Raaseporin" },
    { code: "FI.01.015", name: "Porvoo" },
    { code: "FI.01.016", name: "Loviisa" },
  ],
  "FI.02": [
    { code: "FI.02.021", name: "Åboland-Turunmaa" },
    { code: "FI.02.022", name: "Salo" },
    { code: "FI.02.023", name: "Turku" },
    { code: "FI.02.024", name: "Vakka-Suomi" },
    { code: "FI.02.025", name: "Loimaa" },
  ],
  "FI.04": [
    { code: "FI.04.041", name: "Rauma" },
    { code: "FI.04.043", name: "Pori" },
    { code: "FI.04.044", name: "Pohjois-Satakunta" },
  ],
  "FI.05": [
    { code: "FI.05.051", name: "Hämeenlinna" },
    { code: "FI.05.052", name: "Riihimäki" },
    { code: "FI.05.053", name: "Forssa" },
  ],
  "FI.06": [
    { code: "FI.06.061", name: "Luoteis-Pirkanmaa" },
    { code: "FI.06.063", name: "Etelä-Pirkanmaa" },
    { code: "FI.06.064", name: "Tampere" },
    { code: "FI.06.068", name: "Lounais-Pirkanmaa" },
    { code: "FI.06.069", name: "Ylä-Pirkanmaa" },
  ],
  "FI.07": [
    { code: "FI.07.071", name: "Lahti" },
  ],
  "FI.08": [
    { code: "FI.08.081", name: "Kouvola" },
    { code: "FI.08.082", name: "Kotka-Hamina" },
  ],
  "FI.09": [
    { code: "FI.09.091", name: "Lappeenranta" },
    { code: "FI.09.093", name: "Imatra" },
  ],
  "FI.10": [
    { code: "FI.10.101", name: "Mikkeli" },
    { code: "FI.10.103", name: "Savonlinna" },
    { code: "FI.10.105", name: "Pieksämäki" },
  ],
  "FI.11": [
    { code: "FI.11.111", name: "Ylä-Savo" },
    { code: "FI.11.112", name: "Kuopio" },
    { code: "FI.11.113", name: "Koillis-Savo" },
    { code: "FI.11.114", name: "Varkaus" },
    { code: "FI.11.115", name: "Sisä-Savo" },
  ],
  "FI.12": [
    { code: "FI.12.122", name: "Joensuu" },
    { code: "FI.12.124", name: "Keski-Karjala" },
    { code: "FI.12.125", name: "Pielisen Karjala" },
  ],
  "FI.13": [
    { code: "FI.13.131", name: "Jyväskylä" },
    { code: "FI.13.132", name: "Joutsa" },
    { code: "FI.13.133", name: "Keuruu" },
    { code: "FI.13.134", name: "Jämsä" },
    { code: "FI.13.135", name: "Äänekoski" },
    { code: "FI.13.138", name: "Saarijärvi-Viitasaari" },
  ],
  "FI.14": [
    { code: "FI.14.141", name: "Suupohja" },
    { code: "FI.14.142", name: "Seinäjoki" },
    { code: "FI.14.144", name: "Kuusiokunnat" },
    { code: "FI.14.146", name: "Järviseutu" },
  ],
  "FI.15": [
    { code: "FI.15.151", name: "Kyrönmaa" },
    { code: "FI.15.152", name: "Vaasa" },
    { code: "FI.15.153", name: "Sydösterbotten" },
    { code: "FI.15.154", name: "Jakobstadsregionen" },
  ],
  "FI.16": [
    { code: "FI.16.161", name: "Kaustinen" },
    { code: "FI.16.162", name: "Kokkola" },
  ],
  "FI.17": [
    { code: "FI.17.171", name: "Oulu" },
    { code: "FI.17.173", name: "Oulunkaari" },
    { code: "FI.17.174", name: "Raahe" },
    { code: "FI.17.175", name: "Haapavesi-Siikalatva" },
    { code: "FI.17.176", name: "Nivala-Haapajärvi" },
    { code: "FI.17.177", name: "Ylivieska" },
    { code: "FI.17.178", name: "Koillismaa" },
  ],
  "FI.18": [
    { code: "FI.18.181", name: "Kehys-Kainuu" },
    { code: "FI.18.182", name: "Kajaani" },
  ],
  "FI.19": [
    { code: "FI.19.191", name: "Rovaniemi" },
    { code: "FI.19.192", name: "Kemi-Tornio" },
    { code: "FI.19.193", name: "Torniolaakso" },
    { code: "FI.19.194", name: "Itä-Lappi" },
    { code: "FI.19.196", name: "Tunturi-Lappi" },
    { code: "FI.19.197", name: "Pohjois-Lappi" },
  ],
  "FJ.01": [
    { code: "FJ.01.09", name: "Naitasiri Province" },
    { code: "FJ.01.10", name: "Namosi Province" },
    { code: "FJ.01.12", name: "Rewa Province" },
    { code: "FJ.01.13", name: "Serua Province" },
    { code: "FJ.01.14", name: "Tailevu Province" },
  ],
  "FJ.02": [
    { code: "FJ.02.04", name: "Kadavu Province" },
    { code: "FJ.02.05", name: "Lau Province" },
    { code: "FJ.02.06", name: "Lomaiviti Province" },
  ],
  "FJ.03": [
    { code: "FJ.03.02", name: "Bua Province" },
    { code: "FJ.03.03", name: "Cakaudrove Province" },
    { code: "FJ.03.07", name: "Macuata Province" },
  ],
  "FJ.04": [
    { code: "FJ.04.15", name: "Rotuma" },
  ],
  "FJ.05": [
    { code: "FJ.05.01", name: "Ba Province" },
    { code: "FJ.05.08", name: "Nandronga and Navosa Province" },
    { code: "FJ.05.11", name: "Ra Province" },
  ],
  "FM.01": [
    { code: "FM.01.LE", name: "Lelu Municipality" },
    { code: "FM.01.MA", name: "Malem Municipality" },
    { code: "FM.01.TA", name: "Tafunsak Municipality" },
    { code: "FM.01.UT", name: "Utwe Municipality" },
  ],
  "FM.02": [
    { code: "FM.02.KL", name: "Kolonia Municipality" },
    { code: "FM.02.KP", name: "Kapingamarangi Municipality" },
    { code: "FM.02.KT", name: "Kitti Municipality" },
    { code: "FM.02.MA", name: "Madolenihm Municipality" },
    { code: "FM.02.MO", name: "Mokil Municipality" },
    { code: "FM.02.NE", name: "Nett Municipality" },
    { code: "FM.02.NG", name: "Sapwuahfik Municipality" },
    { code: "FM.02.NU", name: "Nukuoro Municipality" },
    { code: "FM.02.OR", name: "Oroluk Municipality" },
    { code: "FM.02.PI", name: "Pingelap Municipality" },
    { code: "FM.02.SO", name: "Sokehs Municipality" },
    { code: "FM.02.UH", name: "U Municipality" },
  ],
  "FM.03": [
    { code: "FM.03.DU", name: "Tonoas Municipality" },
    { code: "FM.03.EO", name: "Eot Municipality" },
    { code: "FM.03.ET", name: "Ettal Municipality" },
    { code: "FM.03.FB", name: "Fanapanges Municipality" },
    { code: "FM.03.FF", name: "Fefen Municipality" },
    { code: "FM.03.FN", name: "Fananu Municipality" },
    { code: "FM.03.FO", name: "Fonoton Municipality" },
    { code: "FM.03.KU", name: "Kuttu Municipality" },
    { code: "FM.03.LO", name: "Losap Municipality" },
    { code: "FM.03.LU", name: "Lekinioch Municipality" },
    { code: "FM.03.MA", name: "Makur Municipality" },
    { code: "FM.03.MC", name: "Moch Municipality" },
    { code: "FM.03.MN", name: "Weno Municipality" },
    { code: "FM.03.MU", name: "Murilo Municipality" },
    { code: "FM.03.NA", name: "Nema Municipality" },
    { code: "FM.03.NL", name: "Namoluk Municipality" },
    { code: "FM.03.NW", name: "Nomwin Municipality" },
    { code: "FM.03.ON", name: "Wonei Municipality" },
    { code: "FM.03.OO", name: "Onou Municipality" },
    { code: "FM.03.OP", name: "Oneop Municipality" },
    { code: "FM.03.OR", name: "Unanu Municipality" },
    { code: "FM.03.PA", name: "Paata-Tupunion Municipality" },
    { code: "FM.03.PI", name: "Piis-Panewu Municipality" },
    { code: "FM.03.PK", name: "Houk Municipality" },
    { code: "FM.03.PL", name: "Piis-Emwar Municipality" },
    { code: "FM.03.PN", name: "Pwene Municipality" },
    { code: "FM.03.PP", name: "Pollap Municipality" },
    { code: "FM.03.PR", name: "Parem Municipality" },
    { code: "FM.03.PS", name: "Piherarh Municipality" },
    { code: "FM.03.PW", name: "Polowat Municipality" },
    { code: "FM.03.RO", name: "Ramanum Municipality" },
    { code: "FM.03.RU", name: "Ruo Municipality" },
    { code: "FM.03.SA", name: "Satowan Municipality" },
    { code: "FM.03.TA", name: "Ta Municipality" },
    { code: "FM.03.TL", name: "Tolensom Municipality" },
    { code: "FM.03.TM", name: "Tamatam Municipality" },
    { code: "FM.03.TS", name: "Siis Municipality" },
    { code: "FM.03.UD", name: "Udot-Fonuweisom Municipality" },
    { code: "FM.03.UL", name: "Onoun Municipality" },
    { code: "FM.03.UM", name: "Uman-Fonuweisom Municipality" },
  ],
  "FM.04": [
    { code: "FM.04.DA", name: "Dalipebinaw Municipality" },
    { code: "FM.04.EL", name: "Elato Municipality" },
    { code: "FM.04.ER", name: "Eauripik Municipality" },
    { code: "FM.04.FF", name: "Fanif Municipality" },
    { code: "FM.04.FP", name: "Faraulep Municipality" },
    { code: "FM.04.FS", name: "Fais Municipality" },
    { code: "FM.04.GG", name: "Gagil Municipality" },
    { code: "FM.04.GI", name: "Gaferut Municipality" },
    { code: "FM.04.GL", name: "Gilman Municipality" },
    { code: "FM.04.IF", name: "Ifalik Municipality" },
    { code: "FM.04.KA", name: "Kanifay Municipality" },
    { code: "FM.04.LA", name: "Lamotrek Municipality" },
    { code: "FM.04.MA", name: "Maap Municipality" },
    { code: "FM.04.NG", name: "Ngulu Municipality" },
    { code: "FM.04.RL", name: "Rull Municipality" },
    { code: "FM.04.RM", name: "Rumung Municipality" },
    { code: "FM.04.SA", name: "Satawal Municipality" },
    { code: "FM.04.SO", name: "Sorol Municipality" },
    { code: "FM.04.TO", name: "Tomil Municipality" },
    { code: "FM.04.UL", name: "Ulithi Municipality" },
    { code: "FM.04.WE", name: "Weloy Municipality" },
    { code: "FM.04.WO", name: "Woleai Municipality" },
  ],
  "FO.NO": [
    { code: "FO.NO.1", name: "Fugloy" },
    { code: "FO.NO.3", name: "Viðareiði" },
    { code: "FO.NO.4", name: "Hvannasund" },
    { code: "FO.NO.5", name: "Klaksvik" },
    { code: "FO.NO.6", name: "Kunoy" },
  ],
  "FO.OS": [
    { code: "FO.OS.12", name: "Eystur" },
    { code: "FO.OS.14", name: "Runavík" },
    { code: "FO.OS.15", name: "Nes" },
    { code: "FO.OS.17", name: "Sjóvar" },
    { code: "FO.OS.19", name: "Eiði" },
  ],
  "FO.SA": [
    { code: "FO.SA.39", name: "Sandur" },
    { code: "FO.SA.40", name: "Skopun" },
    { code: "FO.SA.41", name: "Skálavík" },
    { code: "FO.SA.42", name: "Húsavík" },
    { code: "FO.SA.43", name: "Skúvoy" },
  ],
  "FO.ST": [
    { code: "FO.ST.11", name: "Fuglafjørður" },
    { code: "FO.ST.18", name: "Sunda" },
    { code: "FO.ST.27", name: "Kvívík" },
    { code: "FO.ST.28", name: "Vestmanna" },
    { code: "FO.ST.29", name: "Tórshavn" },
  ],
  "FO.SU": [
    { code: "FO.SU.44", name: "Hvalbøur" },
    { code: "FO.SU.45", name: "Tvøroyri" },
    { code: "FO.SU.46", name: "Fámjin" },
    { code: "FO.SU.47", name: "Hov" },
    { code: "FO.SU.48", name: "Porkeri" },
    { code: "FO.SU.49", name: "Vágur" },
    { code: "FO.SU.50", name: "Sunnbøur" },
  ],
  "FO.VG": [
    { code: "FO.VG.34", name: "Vága Municipality" },
    { code: "FO.VG.36", name: "Sørvágur" },
  ],
  "FR.11": [
    { code: "FR.11.75", name: "Paris" },
    { code: "FR.11.77", name: "Seine-et-Marne" },
    { code: "FR.11.78", name: "Yvelines" },
    { code: "FR.11.91", name: "Essonne" },
    { code: "FR.11.92", name: "Hauts-de-Seine" },
    { code: "FR.11.93", name: "Seine-Saint-Denis" },
    { code: "FR.11.94", name: "Val-de-Marne" },
    { code: "FR.11.95", name: "Val d'Oise" },
  ],
  "FR.24": [
    { code: "FR.24.18", name: "Cher" },
    { code: "FR.24.28", name: "Eure-et-Loir" },
    { code: "FR.24.36", name: "Indre" },
    { code: "FR.24.37", name: "Indre-et-Loire" },
    { code: "FR.24.41", name: "Loir-et-Cher" },
    { code: "FR.24.45", name: "Loiret" },
  ],
  "FR.27": [
    { code: "FR.27.21", name: "Cote d'Or" },
    { code: "FR.27.25", name: "Doubs" },
    { code: "FR.27.39", name: "Jura" },
    { code: "FR.27.58", name: "Nièvre" },
    { code: "FR.27.70", name: "Haute-Saône" },
    { code: "FR.27.71", name: "Saône-et-Loire" },
    { code: "FR.27.89", name: "Yonne" },
    { code: "FR.27.90", name: "Territoire de Belfort" },
  ],
  "FR.28": [
    { code: "FR.28.14", name: "Calvados" },
    { code: "FR.28.27", name: "Eure" },
    { code: "FR.28.50", name: "Manche" },
    { code: "FR.28.61", name: "Orne" },
    { code: "FR.28.76", name: "Seine-Maritime" },
  ],
  "FR.32": [
    { code: "FR.32.02", name: "Aisne" },
    { code: "FR.32.59", name: "North" },
    { code: "FR.32.60", name: "Oise" },
    { code: "FR.32.62", name: "Pas-de-Calais" },
    { code: "FR.32.80", name: "Somme" },
  ],
  "FR.44": [
    { code: "FR.44.08", name: "Ardennes" },
    { code: "FR.44.10", name: "Aube" },
    { code: "FR.44.51", name: "Marne" },
    { code: "FR.44.52", name: "Haute-Marne" },
    { code: "FR.44.54", name: "Meurthe et Moselle" },
    { code: "FR.44.55", name: "Meuse" },
    { code: "FR.44.57", name: "Moselle" },
    { code: "FR.44.67", name: "Bas-Rhin" },
    { code: "FR.44.68", name: "Haut-Rhin" },
    { code: "FR.44.88", name: "Vosges" },
  ],
  "FR.52": [
    { code: "FR.52.44", name: "Loire-Atlantique" },
    { code: "FR.52.49", name: "Maine-et-Loire" },
    { code: "FR.52.53", name: "Mayenne" },
    { code: "FR.52.72", name: "Sarthe" },
    { code: "FR.52.85", name: "Vendée" },
  ],
  "FR.53": [
    { code: "FR.53.22", name: "Côtes-d'Armor" },
    { code: "FR.53.29", name: "Finistère" },
    { code: "FR.53.35", name: "Ille-et-Vilaine" },
    { code: "FR.53.56", name: "Morbihan" },
  ],
  "FR.75": [
    { code: "FR.75.16", name: "Charente" },
    { code: "FR.75.17", name: "Charente-Maritime" },
    { code: "FR.75.19", name: "Corrèze" },
    { code: "FR.75.23", name: "Creuse" },
    { code: "FR.75.24", name: "Dordogne" },
    { code: "FR.75.33", name: "Gironde" },
    { code: "FR.75.40", name: "Landes" },
    { code: "FR.75.47", name: "Lot-et-Garonne" },
    { code: "FR.75.64", name: "Pyrénées-Atlantiques" },
    { code: "FR.75.79", name: "Deux-Sèvres" },
    { code: "FR.75.86", name: "Vienne" },
    { code: "FR.75.87", name: "Haute-Vienne" },
  ],
  "FR.76": [
    { code: "FR.76.09", name: "Ariège" },
    { code: "FR.76.11", name: "Aude" },
    { code: "FR.76.12", name: "Aveyron" },
    { code: "FR.76.30", name: "Gard" },
    { code: "FR.76.31", name: "Upper Garonne" },
    { code: "FR.76.32", name: "Gers" },
    { code: "FR.76.34", name: "Hérault" },
    { code: "FR.76.46", name: "Lot" },
    { code: "FR.76.48", name: "Lozère" },
    { code: "FR.76.65", name: "Hautes-Pyrénées" },
    { code: "FR.76.66", name: "Pyrénées-Orientales" },
    { code: "FR.76.81", name: "Tarn" },
    { code: "FR.76.82", name: "Tarn-et-Garonne" },
  ],
  "FR.84": [
    { code: "FR.84.01", name: "Ain" },
    { code: "FR.84.03", name: "Allier" },
    { code: "FR.84.07", name: "Ardèche" },
    { code: "FR.84.15", name: "Cantal" },
    { code: "FR.84.26", name: "Drôme" },
    { code: "FR.84.38", name: "Isère" },
    { code: "FR.84.42", name: "Loire" },
    { code: "FR.84.43", name: "Haute-Loire" },
    { code: "FR.84.63", name: "Puy-de-Dôme" },
    { code: "FR.84.69", name: "Rhône" },
    { code: "FR.84.73", name: "Savoy" },
    { code: "FR.84.74", name: "Haute-Savoie" },
  ],
  "FR.93": [
    { code: "FR.93.04", name: "Alpes-de-Haute-Provence" },
    { code: "FR.93.05", name: "Hautes-Alpes" },
    { code: "FR.93.06", name: "Alpes-Maritimes" },
    { code: "FR.93.13", name: "Bouches-du-Rhône" },
    { code: "FR.93.83", name: "Var" },
    { code: "FR.93.84", name: "Vaucluse" },
  ],
  "FR.94": [
    { code: "FR.94.2A", name: "South Corsica" },
    { code: "FR.94.2B", name: "Upper Corsica" },
  ],
  "GA.01": [
    { code: "GA.01.11996079", name: "Noya" },
    { code: "GA.01.8260630", name: "Commune of Libreville" },
    { code: "GA.01.8260631", name: "Komo-Mondah Department" },
    { code: "GA.01.8260632", name: "Komo Department" },
  ],
  "GA.02": [
    { code: "GA.02.11996062", name: "Ogooue-Letili" },
    { code: "GA.02.11996063", name: "Djouori-Agnili" },
    { code: "GA.02.11996067", name: "Lekoni-Lekori" },
    { code: "GA.02.11996069", name: "Djoue" },
    { code: "GA.02.11996070", name: "Bayi-Brikolo" },
    { code: "GA.02.11996075", name: "Lekabi-Lewolo" },
    { code: "GA.02.11996078", name: "Sebe-Brikolo" },
    { code: "GA.02.7870333", name: "Plateaux Department" },
    { code: "GA.02.7870395", name: "Mpassa Department" },
    { code: "GA.02.8260627", name: "Leboumbi-Leyou Department" },
    { code: "GA.02.8260634", name: "Lekoko Department" },
  ],
  "GA.03": [
    { code: "GA.03.11204018", name: "Ogooue et des Lacs" },
    { code: "GA.03.7870425", name: "Abanga-Bigné Department" },
  ],
  "GA.04": [
    { code: "GA.04.11996064", name: "Louetsi-Bibaka" },
    { code: "GA.04.11996065", name: "Boumi-Louetsi" },
    { code: "GA.04.11996076", name: "Mougalaba" },
    { code: "GA.04.7870328", name: "Douya-Onoye Department" },
    { code: "GA.04.7870330", name: "Ndolou Department" },
    { code: "GA.04.7870428", name: "Ogoulou Department" },
    { code: "GA.04.8260610", name: "Tsamba-Magotsi Department" },
    { code: "GA.04.8260628", name: "Dola Department" },
    { code: "GA.04.8260629", name: "Louetsi-Wano Department" },
  ],
  "GA.05": [
    { code: "GA.05.11996061", name: "Douigni" },
    { code: "GA.05.11996074", name: "Mongo" },
    { code: "GA.05.11996077", name: "Doutsila" },
    { code: "GA.05.7870325", name: "Basse-Banio Department" },
    { code: "GA.05.7870326", name: "Mougoutsi Department" },
    { code: "GA.05.7870411", name: "Haute-Banio Department" },
  ],
  "GA.06": [
    { code: "GA.06.11204107", name: "Zadie" },
    { code: "GA.06.11996071", name: "Mvoung" },
    { code: "GA.06.11996080", name: "Ivindo" },
    { code: "GA.06.7870426", name: "Lope Department" },
  ],
  "GA.07": [
    { code: "GA.07.11996066", name: "Lombo-Bouenguidi" },
    { code: "GA.07.11996068", name: "Offoue-Onoye" },
    { code: "GA.07.7870427", name: "Lolo Bouenguidi Department" },
    { code: "GA.07.8260626", name: "Mouloundou Department" },
  ],
  "GA.08": [
    { code: "GA.08.7870327", name: "Ndougou Department" },
    { code: "GA.08.7870331", name: "Étimboué Department" },
    { code: "GA.08.8224678", name: "Bendje" },
  ],
  "GA.09": [
    { code: "GA.09.11204310", name: "Woleu" },
    { code: "GA.09.11204504", name: "Okano Department" },
    { code: "GA.09.11204591", name: "Ntem Department" },
    { code: "GA.09.11996072", name: "Haut-Komo" },
    { code: "GA.09.11996073", name: "Haut-Ntem" },
  ],
  "GB.ENG": [
    { code: "GB.ENG.A3", name: "Barnsley" },
    { code: "GB.ENG.A4", name: "Bath and North East Somerset" },
    { code: "GB.ENG.A7", name: "City and Borough of Birmingham" },
    { code: "GB.ENG.A8", name: "Blackburn with Darwen" },
    { code: "GB.ENG.A9", name: "Blackpool" },
    { code: "GB.ENG.B1", name: "Borough of Bolton" },
    { code: "GB.ENG.B2", name: "Bournemouth" },
    { code: "GB.ENG.B3", name: "Bracknell Forest" },
    { code: "GB.ENG.B4", name: "Bradford" },
    { code: "GB.ENG.B6", name: "Brighton and Hove" },
    { code: "GB.ENG.B7", name: "City of Bristol" },
    { code: "GB.ENG.B9", name: "Buckinghamshire" },
    { code: "GB.ENG.C1", name: "Borough of Bury" },
    { code: "GB.ENG.C2", name: "Calderdale" },
    { code: "GB.ENG.C3", name: "Cambridgeshire" },
    { code: "GB.ENG.C6", name: "Cornwall" },
    { code: "GB.ENG.C7", name: "Coventry" },
    { code: "GB.ENG.C9", name: "Cumbria" },
    { code: "GB.ENG.D1", name: "Darlington" },
    { code: "GB.ENG.D2", name: "Derby" },
    { code: "GB.ENG.D3", name: "Derbyshire" },
    { code: "GB.ENG.D4", name: "Devon" },
    { code: "GB.ENG.D5", name: "Doncaster" },
    { code: "GB.ENG.D6", name: "Dorset" },
    { code: "GB.ENG.D7", name: "Dudley" },
    { code: "GB.ENG.D8", name: "County Durham" },
    { code: "GB.ENG.E1", name: "East Riding of Yorkshire" },
    { code: "GB.ENG.E2", name: "East Sussex" },
    { code: "GB.ENG.E4", name: "Essex" },
    { code: "GB.ENG.E5", name: "Gateshead" },
    { code: "GB.ENG.E6", name: "Gloucestershire" },
    { code: "GB.ENG.E9", name: "Borough of Halton" },
    { code: "GB.ENG.F2", name: "Hampshire" },
    { code: "GB.ENG.F5", name: "Hartlepool" },
    { code: "GB.ENG.F7", name: "Herefordshire" },
    { code: "GB.ENG.F8", name: "Hertfordshire" },
    { code: "GB.ENG.G2", name: "Isle of Wight" },
    { code: "GB.ENG.G5", name: "Kent" },
    { code: "GB.ENG.G6", name: "City of Kingston upon Hull" },
    { code: "GB.ENG.G8", name: "Kirklees" },
    { code: "GB.ENG.G9", name: "Knowsley" },
    { code: "GB.ENG.GLA", name: "Greater London" },
    { code: "GB.ENG.H2", name: "Lancashire" },
    { code: "GB.ENG.H3", name: "City and Borough of Leeds" },
    { code: "GB.ENG.H4", name: "City of Leicester" },
    { code: "GB.ENG.H5", name: "Leicestershire" },
    { code: "GB.ENG.H7", name: "Lincolnshire" },
    { code: "GB.ENG.H8", name: "Liverpool" },
    { code: "GB.ENG.I1", name: "Luton" },
    { code: "GB.ENG.I2", name: "Manchester" },
    { code: "GB.ENG.I3", name: "Medway" },
    { code: "GB.ENG.I5", name: "Middlesbrough" },
    { code: "GB.ENG.I6", name: "Milton Keynes" },
    { code: "GB.ENG.I7", name: "Newcastle upon Tyne" },
    { code: "GB.ENG.I9", name: "Norfolk" },
    { code: "GB.ENG.J2", name: "North East Lincolnshire" },
    { code: "GB.ENG.J3", name: "North Lincolnshire" },
    { code: "GB.ENG.J4", name: "North Somerset" },
    { code: "GB.ENG.J5", name: "Borough of North Tyneside" },
    { code: "GB.ENG.J6", name: "Northumberland" },
    { code: "GB.ENG.J7", name: "North Yorkshire" },
    { code: "GB.ENG.J8", name: "Nottingham" },
    { code: "GB.ENG.J9", name: "Nottinghamshire" },
    { code: "GB.ENG.K1", name: "Borough of Oldham" },
    { code: "GB.ENG.K2", name: "Oxfordshire" },
    { code: "GB.ENG.K3", name: "Peterborough" },
    { code: "GB.ENG.K4", name: "Plymouth" },
    { code: "GB.ENG.K5", name: "Poole" },
    { code: "GB.ENG.K6", name: "Portsmouth" },
    { code: "GB.ENG.K7", name: "Reading" },
    { code: "GB.ENG.K9", name: "Redcar and Cleveland" },
    { code: "GB.ENG.L2", name: "Borough of Rochdale" },
    { code: "GB.ENG.L3", name: "Rotherham" },
    { code: "GB.ENG.L4", name: "District of Rutland" },
    { code: "GB.ENG.L5", name: "City and Borough of Salford" },
    { code: "GB.ENG.L6", name: "Shropshire" },
    { code: "GB.ENG.L7", name: "Sandwell" },
    { code: "GB.ENG.L8", name: "Sefton" },
    { code: "GB.ENG.L9", name: "Sheffield" },
    { code: "GB.ENG.M1", name: "Slough" },
    { code: "GB.ENG.M2", name: "Solihull" },
    { code: "GB.ENG.M3", name: "Somerset" },
    { code: "GB.ENG.M4", name: "Southampton" },
    { code: "GB.ENG.M5", name: "Southend-on-Sea" },
    { code: "GB.ENG.M6", name: "South Gloucestershire" },
    { code: "GB.ENG.M7", name: "South Tyneside" },
    { code: "GB.ENG.M9", name: "Staffordshire" },
    { code: "GB.ENG.N1", name: "St. Helens" },
    { code: "GB.ENG.N2", name: "Borough of Stockport" },
    { code: "GB.ENG.N3", name: "Stockton-on-Tees" },
    { code: "GB.ENG.N4", name: "Stoke-on-Trent" },
    { code: "GB.ENG.N5", name: "Suffolk" },
    { code: "GB.ENG.N6", name: "Sunderland" },
    { code: "GB.ENG.N7", name: "Surrey" },
    { code: "GB.ENG.N9", name: "Borough of Swindon" },
    { code: "GB.ENG.NNH", name: "North Northamptonshire" },
    { code: "GB.ENG.O1", name: "Borough of Tameside" },
    { code: "GB.ENG.O2", name: "Telford and Wrekin" },
    { code: "GB.ENG.O3", name: "Borough of Thurrock" },
    { code: "GB.ENG.O4", name: "Borough of Torbay" },
    { code: "GB.ENG.O6", name: "Trafford" },
    { code: "GB.ENG.O7", name: "City and Borough of Wakefield" },
    { code: "GB.ENG.O8", name: "Walsall" },
    { code: "GB.ENG.P2", name: "Warrington" },
    { code: "GB.ENG.P3", name: "Warwickshire" },
    { code: "GB.ENG.P4", name: "West Berkshire" },
    { code: "GB.ENG.P6", name: "West Sussex" },
    { code: "GB.ENG.P7", name: "Borough of Wigan" },
    { code: "GB.ENG.P8", name: "Wiltshire" },
    { code: "GB.ENG.P9", name: "Royal Borough of Windsor and Maidenhead" },
    { code: "GB.ENG.Q1", name: "Metropolitan Borough of Wirral" },
    { code: "GB.ENG.Q2", name: "Wokingham" },
    { code: "GB.ENG.Q3", name: "Wolverhampton" },
    { code: "GB.ENG.Q4", name: "Worcestershire" },
    { code: "GB.ENG.Q5", name: "City of York" },
    { code: "GB.ENG.WNH", name: "West Northamptonshire" },
    { code: "GB.ENG.Z5", name: "Bedford" },
    { code: "GB.ENG.Z6", name: "Central Bedfordshire" },
    { code: "GB.ENG.Z7", name: "Cheshire East" },
    { code: "GB.ENG.Z8", name: "Cheshire West and Chester" },
    { code: "GB.ENG.Z9", name: "Isles of Scilly" },
  ],
  "GB.NIR": [
    { code: "GB.NIR.N09000001", name: "Antrim and Newtownabbey" },
    { code: "GB.NIR.N09000002", name: "Armagh City Banbridge and Craigavon" },
    { code: "GB.NIR.N09000003", name: "City of Belfast" },
    { code: "GB.NIR.N09000004", name: "Causeway Coast and Glens" },
    { code: "GB.NIR.N09000005", name: "Derry City and Strabane" },
    { code: "GB.NIR.N09000006", name: "Fermanagh and Omagh" },
    { code: "GB.NIR.N09000007", name: "Lisburn and Castlereagh" },
    { code: "GB.NIR.N09000008", name: "Mid and East Antrim" },
    { code: "GB.NIR.N09000009", name: "Mid Ulster" },
    { code: "GB.NIR.N09000010", name: "Newry Mourne and Down" },
    { code: "GB.NIR.N09000011", name: "Ards and North Down" },
  ],
  "GB.SCT": [
    { code: "GB.SCT.T5", name: "Aberdeen City" },
    { code: "GB.SCT.T6", name: "Aberdeenshire" },
    { code: "GB.SCT.T7", name: "Angus" },
    { code: "GB.SCT.T8", name: "Argyll and Bute" },
    { code: "GB.SCT.T9", name: "The Scottish Borders" },
    { code: "GB.SCT.U1", name: "Clackmannanshire" },
    { code: "GB.SCT.U2", name: "Dumfries and Galloway" },
    { code: "GB.SCT.U3", name: "Dundee City" },
    { code: "GB.SCT.U4", name: "East Ayrshire" },
    { code: "GB.SCT.U5", name: "East Dunbartonshire" },
    { code: "GB.SCT.U6", name: "East Lothian" },
    { code: "GB.SCT.U7", name: "East Renfrewshire" },
    { code: "GB.SCT.U8", name: "City of Edinburgh" },
    { code: "GB.SCT.U9", name: "Falkirk" },
    { code: "GB.SCT.V1", name: "Fife" },
    { code: "GB.SCT.V2", name: "Glasgow City" },
    { code: "GB.SCT.V3", name: "Highland" },
    { code: "GB.SCT.V4", name: "Inverclyde" },
    { code: "GB.SCT.V5", name: "Midlothian" },
    { code: "GB.SCT.V6", name: "Moray" },
    { code: "GB.SCT.V7", name: "North Ayrshire" },
    { code: "GB.SCT.V8", name: "North Lanarkshire" },
    { code: "GB.SCT.V9", name: "Orkney Islands" },
    { code: "GB.SCT.W1", name: "Perth and Kinross" },
    { code: "GB.SCT.W2", name: "Renfrewshire" },
    { code: "GB.SCT.W3", name: "Shetland Islands" },
    { code: "GB.SCT.W4", name: "South Ayrshire" },
    { code: "GB.SCT.W5", name: "South Lanarkshire" },
    { code: "GB.SCT.W6", name: "Stirling" },
    { code: "GB.SCT.W7", name: "West Dunbartonshire" },
    { code: "GB.SCT.W8", name: "Eilean Siar" },
    { code: "GB.SCT.W9", name: "West Lothian" },
  ],
  "GB.WLS": [
    { code: "GB.WLS.X1", name: "Anglesey" },
    { code: "GB.WLS.X2", name: "Blaenau Gwent" },
    { code: "GB.WLS.X3", name: "Bridgend county borough" },
    { code: "GB.WLS.X4", name: "Caerphilly County Borough" },
    { code: "GB.WLS.X5", name: "Cardiff" },
    { code: "GB.WLS.X6", name: "County of Ceredigion" },
    { code: "GB.WLS.X7", name: "Carmarthenshire" },
    { code: "GB.WLS.X8", name: "Conwy" },
    { code: "GB.WLS.X9", name: "Denbighshire" },
    { code: "GB.WLS.Y1", name: "County of Flintshire" },
    { code: "GB.WLS.Y2", name: "Gwynedd" },
    { code: "GB.WLS.Y3", name: "Merthyr Tydfil County Borough" },
    { code: "GB.WLS.Y4", name: "Monmouthshire" },
    { code: "GB.WLS.Y5", name: "Neath Port Talbot" },
    { code: "GB.WLS.Y6", name: "Newport" },
    { code: "GB.WLS.Y7", name: "Pembrokeshire" },
    { code: "GB.WLS.Y8", name: "Sir Powys" },
    { code: "GB.WLS.Y9", name: "Rhondda Cynon Taf" },
    { code: "GB.WLS.Z1", name: "City and County of Swansea" },
    { code: "GB.WLS.Z2", name: "Torfaen County Borough" },
    { code: "GB.WLS.Z3", name: "Vale of Glamorgan" },
    { code: "GB.WLS.Z4", name: "Wrexham" },
  ],
  "GE.00": [
    { code: "GE.00.614519", name: "Gldanskiy Rayon" },
  ],
  "GE.02": [
    { code: "GE.02.611818", name: "Sukhumi District" },
    { code: "GE.02.612651", name: "Ochamchira District" },
    { code: "GE.02.614378", name: "Gulripshi district" },
    { code: "GE.02.614407", name: "Gudauta District" },
    { code: "GE.02.614611", name: "Gali District" },
    { code: "GE.02.9021892", name: "Gagra District" },
    { code: "GE.02.9883703", name: "Tkvarcheli district" },
  ],
  "GE.04": [
    { code: "GE.04.613761", name: "K’obulet’is Raioni" },
    { code: "GE.04.613970", name: "Khelvachauri Municipality" },
    { code: "GE.04.9093838", name: "Kedis Munitsip’alit’et’i" },
    { code: "GE.04.9093934", name: "Kobuletis Munitsip’alit’et’i" },
    { code: "GE.04.9165838", name: "Batumi" },
  ],
  "GE.65": [
    { code: "GE.65.612535", name: "Ozurget’is Raioni" },
    { code: "GE.65.613310", name: "Lanchkhutis Munitsip’alit’et’i" },
    { code: "GE.65.615117", name: "Chokhat’auris Munitsip’alit’et’i" },
    { code: "GE.65.7668994", name: "Chokhatauri" },
  ],
  "GE.66": [
    { code: "GE.66.610865", name: "Zest’aponis Munitsip’alit’et’i" },
    { code: "GE.66.611214", name: "Vanis Munitsip’alit’et’i" },
    { code: "GE.66.611681", name: "Terjolis Munitsip’alit’et’i" },
    { code: "GE.66.612124", name: "Samtredia" },
    { code: "GE.66.613054", name: "Baghdatis Munitsip’alit’et’i" },
    { code: "GE.66.613900", name: "Khonis Munitsip’alit’et’i" },
    { code: "GE.66.614003", name: "Kharagaulis Raioni" },
    { code: "GE.66.615631", name: "Tsqaltubo" },
    { code: "GE.66.7667511", name: "Khoni" },
    { code: "GE.66.7667553", name: "Baghdati" },
    { code: "GE.66.7667754", name: "Sachkhere" },
    { code: "GE.66.828308", name: "K’alak’i Chiat’ura" },
    { code: "GE.66.828310", name: "Kalaki Kutaisi" },
    { code: "GE.66.828313", name: "K’alak’i Tqibuli" },
  ],
  "GE.67": [
    { code: "GE.67.611448", name: "Dedoplists’q’aros Munitsip’alit’et’i" },
    { code: "GE.67.611901", name: "Sighnaghis Munitsip’alit’et’i" },
    { code: "GE.67.612231", name: "Sagarejos Munitsip’alit’et’i" },
    { code: "GE.67.613341", name: "Lagodekhi" },
    { code: "GE.67.613582", name: "Q’varlis Munitsip’alit’et’i" },
    { code: "GE.67.614356", name: "Gurjaanis Munitsip’alit’et’i" },
    { code: "GE.67.615843", name: "Akhmet’is Munitsip’alit’et’i" },
    { code: "GE.67.7667580", name: "Gurjaani" },
    { code: "GE.67.7667581", name: "Telavi" },
    { code: "GE.67.7667701", name: "Qvareli" },
    { code: "GE.67.7667710", name: "Sagarejo" },
    { code: "GE.67.7667711", name: "Sighnaghi" },
    { code: "GE.67.7667712", name: "Dedoplis Tskaro" },
  ],
  "GE.68": [
    { code: "GE.68.611547", name: "Ts’alk’is Munitsip’alit’et’i" },
    { code: "GE.68.611676", name: "Tetrits’q’alos Munitsip’alit’et’i" },
    { code: "GE.68.613073", name: "Marneulis Munitsip’alit’et’i" },
    { code: "GE.68.614573", name: "Gardabnis Munitsip’alit’et’i" },
    { code: "GE.68.614889", name: "Dmanisis Munitsip’alit’et’i" },
    { code: "GE.68.615418", name: "Bolnisis Munitsip’alit’et’i" },
    { code: "GE.68.7667577", name: "Gardabani" },
    { code: "GE.68.7667578", name: "Marneuli" },
    { code: "GE.68.7667683", name: "Tetri Tsqaro" },
    { code: "GE.68.7667714", name: "Tsalka" },
    { code: "GE.68.7729903", name: "Dmanisi" },
    { code: "GE.68.828312", name: "Kalaki Rustavi" },
  ],
  "GE.69": [
    { code: "GE.69.611668", name: "Tianetis Munitsip’alit’et’i" },
    { code: "GE.69.612889", name: "Mtskhetis Munitsip’alit’et’i" },
    { code: "GE.69.613233", name: "Akhalgoris Munitsip’alit’et’i" },
    { code: "GE.69.614086", name: "Q’azbegis Munitsip’alit’et‘i" },
    { code: "GE.69.614841", name: "Dushetis Munitsip’alit’et’i" },
    { code: "GE.69.7667575", name: "Dusheti" },
    { code: "GE.69.7667694", name: "Akhalgori" },
    { code: "GE.69.7667696", name: "Kazbegi" },
    { code: "GE.69.7668882", name: "Mtskheta" },
  ],
  "GE.70": [
    { code: "GE.70.611068", name: "Zavodskoy Rayon" },
    { code: "GE.70.611565", name: "Tsageris Munitsip’alit’et’i" },
    { code: "GE.70.612422", name: "Pervomayskiy Rayon" },
    { code: "GE.70.612571", name: "Ordzhonikidzevskiy Rayon" },
    { code: "GE.70.612590", name: "Onis Munitsip’alit’et’i" },
    { code: "GE.70.612612", name: "Oktyabr'skiy Rayon" },
    { code: "GE.70.613225", name: "Lent’ekhis Munitsip’alit’et’i" },
    { code: "GE.70.613811", name: "Kirovskiy Rayon" },
    { code: "GE.70.614171", name: "Kalininskiy Rayon" },
    { code: "GE.70.614278", name: "Imeni Dvadtsati Shesti Komissarov Rayon" },
    { code: "GE.70.615775", name: "Ambrolauris Munitsip’alit’et’i" },
    { code: "GE.70.7667685", name: "Tsageri" },
    { code: "GE.70.7667690", name: "Lentekhi" },
  ],
  "GE.71": [
    { code: "GE.71.610823", name: "Zugdidis Munitsip’alit’et’i" },
    { code: "GE.71.611552", name: "Ts’alenjikhis Munitsip’alit’et’i" },
    { code: "GE.71.612051", name: "Senakis Raioni" },
    { code: "GE.71.612985", name: "Mest’iis Munitsip’alit’et’i" },
    { code: "GE.71.613064", name: "Mart’vilis Munitsip’alit’et’i" },
    { code: "GE.71.613915", name: "Khobis Munitsip’alit’et’i" },
    { code: "GE.71.615141", name: "Chkhorots’q’us Munitsip’alit’et’i" },
    { code: "GE.71.616020", name: "Abasha" },
    { code: "GE.71.7667559", name: "Mestia" },
    { code: "GE.71.7667563", name: "Chkhorotsqu" },
    { code: "GE.71.7667572", name: "Martvili" },
    { code: "GE.71.7667584", name: "Poti" },
    { code: "GE.71.7668970", name: "Tsalenjikha" },
    { code: "GE.71.828311", name: "Kalaki Poti" },
  ],
  "GE.72": [
    { code: "GE.72.615400", name: "Borjomis Munitsip’alit’et’i" },
    { code: "GE.72.615428", name: "Ninots’mindis Munitsip’alit’et’i" },
    { code: "GE.72.615659", name: "Asp’indzis Munitsip’alit’et’i" },
    { code: "GE.72.615856", name: "Akhaltsikhis Munitsip’alit’et’i" },
    { code: "GE.72.615891", name: "Akhalkalakis Munitsip’alit’et’i" },
    { code: "GE.72.615972", name: "Adigeni Municipality" },
    { code: "GE.72.7667662", name: "Ninotsminda" },
  ],
  "GE.73": [
    { code: "GE.73.10285963", name: "Tskhinvali District" },
    { code: "GE.73.613987", name: "Khashuris Raioni" },
    { code: "GE.73.614103", name: "Kaspis Raioni" },
    { code: "GE.73.614130", name: "Kareli" },
    { code: "GE.73.614450", name: "Goris Munitsip’alit’et’i" },
    { code: "GE.73.614792", name: "Javis Munitsip’alit’et’i" },
  ],
  "GF.GF": [
    { code: "GF.GF.973", name: "Guyane" },
  ],
  "GH.01": [
    { code: "GH.01.301", name: "Ga South" },
    { code: "GH.01.302", name: "Ga West" },
    { code: "GH.01.303", name: "Ga East" },
    { code: "GH.01.304", name: "Accra" },
    { code: "GH.01.305", name: "Adenta" },
    { code: "GH.01.306", name: "Ledzekuku-Krowor" },
    { code: "GH.01.307", name: "Ashaiman" },
    { code: "GH.01.308", name: "Tema Metropolitan District" },
    { code: "GH.01.309", name: "Shai Osudoku District" },
    { code: "GH.01.310", name: "Ada East" },
    { code: "GH.01.311", name: "Ga Central Municipal Assembly" },
    { code: "GH.01.312", name: "La Dade Kotopon" },
    { code: "GH.01.313", name: "La Nkwantanang Madina" },
    { code: "GH.01.314", name: "Kpone Katamanso" },
    { code: "GH.01.315", name: "Ningo Prampram" },
    { code: "GH.01.316", name: "Ada West" },
  ],
  "GH.02": [
    { code: "GH.02.601", name: "Atwima Mponua" },
    { code: "GH.02.602", name: "Amansie West" },
    { code: "GH.02.603", name: "Amansie Central" },
    { code: "GH.02.604", name: "Adansi South" },
    { code: "GH.02.605", name: "Obuasi" },
    { code: "GH.02.606", name: "Adansi North" },
    { code: "GH.02.607", name: "Bekwai" },
    { code: "GH.02.608", name: "Bosome Freho" },
    { code: "GH.02.609", name: "Asante Akim South District" },
    { code: "GH.02.610", name: "Asante Akim Central Municipal" },
    { code: "GH.02.611", name: "Ejisu Juaben" },
    { code: "GH.02.612", name: "Bosomtwe" },
    { code: "GH.02.613", name: "Atwima Kwanwoma" },
    { code: "GH.02.614", name: "Kumasi" },
    { code: "GH.02.615", name: "Atwima Nwabiagya" },
    { code: "GH.02.616", name: "Ahafo Ano South" },
    { code: "GH.02.617", name: "Ahafo Ano North" },
    { code: "GH.02.618", name: "Offinso Municipal District" },
    { code: "GH.02.619", name: "Afigya-Kwabre District" },
    { code: "GH.02.620", name: "Kwabre District" },
    { code: "GH.02.621", name: "Sekyere South" },
    { code: "GH.02.622", name: "Mampong" },
    { code: "GH.02.623", name: "Sekyere East" },
    { code: "GH.02.624", name: "Sekyere Afram Plains" },
    { code: "GH.02.625", name: "Sekyere Central" },
    { code: "GH.02.626", name: "Ejura Sekyedumase" },
    { code: "GH.02.627", name: "Offinso North" },
    { code: "GH.02.628", name: "Asokore Mampong Municipal" },
    { code: "GH.02.629", name: "Asante Akim North" },
    { code: "GH.02.630", name: "Sekyere Afram Plains North" },
  ],
  "GH.04": [
    { code: "GH.04.201", name: "Komenda/Edina/Eguafo/Abirem" },
    { code: "GH.04.202", name: "Cape Coast" },
    { code: "GH.04.203", name: "Abura/Asebu/Kwamankese" },
    { code: "GH.04.204", name: "Mfatseman" },
    { code: "GH.04.205", name: "Ajumako/Enyan/Essiam" },
    { code: "GH.04.206", name: "Gomoa West" },
    { code: "GH.04.207", name: "Effutu" },
    { code: "GH.04.208", name: "Gomoa East" },
    { code: "GH.04.209", name: "Awutu Senya" },
    { code: "GH.04.210", name: "Agona East" },
    { code: "GH.04.211", name: "Agona West" },
    { code: "GH.04.212", name: "Asikuma/Odoben/Brakwa" },
    { code: "GH.04.213", name: "Assin South" },
    { code: "GH.04.214", name: "Assin North" },
    { code: "GH.04.215", name: "Twifo Ati-Morkwa" },
    { code: "GH.04.216", name: "Upper Denkyira East" },
    { code: "GH.04.217", name: "Upper Denkyira West" },
    { code: "GH.04.218", name: "Twifo Hemang Lower Denkyira" },
    { code: "GH.04.219", name: "Ekumfi" },
    { code: "GH.04.220", name: "Awutu Senya East Municipal" },
  ],
  "GH.05": [
    { code: "GH.05.501", name: "Birim South" },
    { code: "GH.05.502", name: "Birim Central" },
    { code: "GH.05.503", name: "West Akim" },
    { code: "GH.05.504", name: "Suhum/Kraboa/Coaltar" },
    { code: "GH.05.505", name: "Nsawam Adoagyiri" },
    { code: "GH.05.506", name: "Akuapim North" },
    { code: "GH.05.507", name: "New Juaben" },
    { code: "GH.05.508", name: "Yilo Krobo" },
    { code: "GH.05.509", name: "Lower Manya Krobo" },
    { code: "GH.05.510", name: "Asuogyaman" },
    { code: "GH.05.511", name: "Upper Manya Krobo" },
    { code: "GH.05.512", name: "Fanteakwa" },
    { code: "GH.05.513", name: "East Akim" },
    { code: "GH.05.514", name: "Kwaebibirem" },
    { code: "GH.05.515", name: "Akyemansa" },
    { code: "GH.05.516", name: "Birim North" },
    { code: "GH.05.517", name: "Atiwa" },
    { code: "GH.05.518", name: "Kwahu West" },
    { code: "GH.05.519", name: "Kwahu South" },
    { code: "GH.05.520", name: "Kwahu East" },
    { code: "GH.05.521", name: "Kwahu North" },
    { code: "GH.05.522", name: "Upper West Akim" },
    { code: "GH.05.523", name: "Akuapim South" },
    { code: "GH.05.524", name: "Ayensuano" },
    { code: "GH.05.525", name: "Denkyembour" },
    { code: "GH.05.526", name: "Kwahu Afram Plains South" },
  ],
  "GH.06": [
    { code: "GH.06.806", name: "Kpandai" },
    { code: "GH.06.807", name: "Nanumba South" },
    { code: "GH.06.808", name: "Nanumba North" },
    { code: "GH.06.809", name: "Zabzugu/Tatale" },
    { code: "GH.06.810", name: "Yendi" },
    { code: "GH.06.811", name: "Tamale" },
    { code: "GH.06.812", name: "Tolon/Kumbungu" },
    { code: "GH.06.813", name: "Savelugu/Nanton" },
    { code: "GH.06.814", name: "Karaga" },
    { code: "GH.06.815", name: "Gushiegu" },
    { code: "GH.06.816", name: "Saboba" },
    { code: "GH.06.822", name: "Kumbumgu" },
    { code: "GH.06.823", name: "Sagnerigu" },
    { code: "GH.06.824", name: "Mion" },
    { code: "GH.06.825", name: "Tatale" },
  ],
  "GH.08": [
    { code: "GH.08.401", name: "South Tongu District" },
    { code: "GH.08.402", name: "Keta" },
    { code: "GH.08.403", name: "Ketu South District" },
    { code: "GH.08.404", name: "Ketu North District" },
    { code: "GH.08.405", name: "Akatsi South" },
    { code: "GH.08.406", name: "Central Tongu" },
    { code: "GH.08.407", name: "Agotime Ziope" },
    { code: "GH.08.408", name: "Ho" },
    { code: "GH.08.409", name: "South Dayi" },
    { code: "GH.08.410", name: "Kpando" },
    { code: "GH.08.411", name: "Hohoe" },
    { code: "GH.08.419", name: "North Tongu" },
    { code: "GH.08.420", name: "Akatsi District" },
    { code: "GH.08.421", name: "Adaklu" },
    { code: "GH.08.422", name: "Ho West" },
    { code: "GH.08.423", name: "Afadzato South" },
    { code: "GH.08.424", name: "North Dayi" },
  ],
  "GH.09": [
    { code: "GH.09.101", name: "Jomoro" },
    { code: "GH.09.102", name: "Ellembelle" },
    { code: "GH.09.103", name: "Nzema East" },
    { code: "GH.09.104", name: "Ahanta West" },
    { code: "GH.09.105", name: "Secondi Takoradi" },
    { code: "GH.09.106", name: "Shama" },
    { code: "GH.09.107", name: "Mpohor/Wassa East" },
    { code: "GH.09.108", name: "Tarkwa Nsuaem" },
    { code: "GH.09.109", name: "Prestea-Huni Valley" },
    { code: "GH.09.110", name: "Wassa Amenfi East" },
    { code: "GH.09.111", name: "Wassa Amenfi West" },
    { code: "GH.09.118", name: "Mpohor" },
    { code: "GH.09.119", name: "Wassa Amenfi Central" },
  ],
  "GH.10": [
    { code: "GH.10.901", name: "North Builsa District" },
    { code: "GH.10.902", name: "Kassena Nankana West" },
    { code: "GH.10.903", name: "Kassena Nankana" },
    { code: "GH.10.904", name: "Bolgatanga Municipal District" },
    { code: "GH.10.905", name: "Talensi-Nabdam" },
    { code: "GH.10.906", name: "Bongo District" },
    { code: "GH.10.907", name: "Bawku West" },
    { code: "GH.10.908", name: "Garu-Tempane" },
    { code: "GH.10.909", name: "Bawku Municipal District" },
    { code: "GH.10.910", name: "Builsa South" },
    { code: "GH.10.911", name: "Nabdam" },
    { code: "GH.10.912", name: "Binduri District" },
    { code: "GH.10.913", name: "Pusiga" },
  ],
  "GH.11": [
    { code: "GH.11.1001", name: "Wa West" },
    { code: "GH.11.1002", name: "Wa" },
    { code: "GH.11.1003", name: "Wa East" },
    { code: "GH.11.1004", name: "Sissala East" },
    { code: "GH.11.1005", name: "Nadowli" },
    { code: "GH.11.1006", name: "Jirapa" },
    { code: "GH.11.1007", name: "Sissala West" },
    { code: "GH.11.1008", name: "Lambussie Karni" },
    { code: "GH.11.1009", name: "Lawra" },
    { code: "GH.11.1010", name: "Daffiama Bussie Issa District" },
    { code: "GH.11.1011", name: "Nandom" },
  ],
  "GH.12": [
    { code: "GH.12.701", name: "Asunafo South" },
    { code: "GH.12.702", name: "Asunafo North" },
    { code: "GH.12.703", name: "Asutifi" },
    { code: "GH.12.706", name: "Tano South" },
    { code: "GH.12.707", name: "Tano North" },
    { code: "GH.12.723", name: "Asutifi South" },
  ],
  "GH.13": [
    { code: "GH.13.704", name: "Dormaa" },
    { code: "GH.13.705", name: "Dormaa East" },
    { code: "GH.13.708", name: "Sunyani" },
    { code: "GH.13.709", name: "Sunyani West" },
    { code: "GH.13.710", name: "Berekum" },
    { code: "GH.13.711", name: "Jaman South" },
    { code: "GH.13.712", name: "Jaman North" },
    { code: "GH.13.713", name: "Tain" },
    { code: "GH.13.714", name: "Wenchi" },
    { code: "GH.13.724", name: "Dormaa West" },
    { code: "GH.13.726", name: "Banda" },
  ],
  "GH.14": [
    { code: "GH.14.715", name: "Techiman Municipal" },
    { code: "GH.14.716", name: "Nkoranza South" },
    { code: "GH.14.717", name: "Nkoranza North District" },
    { code: "GH.14.718", name: "Atebubu-Amantin District" },
    { code: "GH.14.719", name: "Sene" },
    { code: "GH.14.720", name: "Pru" },
    { code: "GH.14.721", name: "Kintampo South District" },
    { code: "GH.14.722", name: "Kintampo North Municipal District" },
    { code: "GH.14.725", name: "Techiman Municipal District" },
    { code: "GH.14.727", name: "Sene East" },
  ],
  "GH.15": [
    { code: "GH.15.817", name: "Chereponi" },
    { code: "GH.15.818", name: "Bunkpurugu-Yunyoo" },
    { code: "GH.15.819", name: "East Mamprusi" },
    { code: "GH.15.820", name: "West Mamprusi" },
    { code: "GH.15.826", name: "Mamprugo Moaduri District" },
  ],
  "GH.16": [
    { code: "GH.16.412", name: "Biakoye" },
    { code: "GH.16.413", name: "Jasikan" },
    { code: "GH.16.414", name: "Kadjebi" },
    { code: "GH.16.415", name: "Krachi East" },
    { code: "GH.16.416", name: "Krachi West" },
    { code: "GH.16.417", name: "Nkwanta South" },
    { code: "GH.16.418", name: "Nkwanta North" },
    { code: "GH.16.425", name: "Krachi Nchumuru" },
  ],
  "GH.17": [
    { code: "GH.17.801", name: "Bole" },
    { code: "GH.17.802", name: "Sawla-Tuna-Kalba" },
    { code: "GH.17.803", name: "West Gonja" },
    { code: "GH.17.804", name: "Central Gonja" },
    { code: "GH.17.805", name: "East Gonja" },
    { code: "GH.17.821", name: "North Gonja" },
  ],
  "GH.18": [
    { code: "GH.18.112", name: "Aowin/Suaman" },
    { code: "GH.18.113", name: "Sefwi Akontobra" },
    { code: "GH.18.114", name: "Sefwi-Wiawso" },
    { code: "GH.18.115", name: "Bibiani/Ahwiaso/Bekwai" },
    { code: "GH.18.116", name: "Juaboso" },
    { code: "GH.18.117", name: "Bia" },
    { code: "GH.18.120", name: "Suaman" },
    { code: "GH.18.121", name: "Bodi" },
    { code: "GH.18.122", name: "Bia East" },
  ],
  "GL.04": [
    { code: "GL.04.3420847", name: "Qaqortoq Municipality" },
    { code: "GL.04.3421723", name: "Narsaq Municipality" },
    { code: "GL.04.3421767", name: "Nanortalik Municipality" },
  ],
  "GM.01": [
    { code: "GM.01.2413107", name: "Kanifing" },
    { code: "GM.01.2593772", name: "Kombo Saint Mary District" },
  ],
  "GM.02": [
    { code: "GM.02.2412885", name: "Kiang West District" },
    { code: "GM.02.2412886", name: "Kiang East" },
    { code: "GM.02.2412887", name: "Kiang Central" },
    { code: "GM.02.2413266", name: "Jarra West" },
    { code: "GM.02.2413267", name: "Jarra East" },
    { code: "GM.02.2413268", name: "Jarra Central" },
  ],
  "GM.03": [
    { code: "GM.03.10299957", name: "Janjanbureh" },
    { code: "GM.03.2411710", name: "Upper Saloum" },
    { code: "GM.03.2412201", name: "Sami District" },
    { code: "GM.03.2412420", name: "Nianija District" },
    { code: "GM.03.2412421", name: "Niani" },
    { code: "GM.03.2412422", name: "Niamina West District" },
    { code: "GM.03.2412423", name: "Niamina East District" },
    { code: "GM.03.2412424", name: "Niamina Dankunku District" },
    { code: "GM.03.2412715", name: "Lower Saloum" },
    { code: "GM.03.2413461", name: "Fulladu West" },
  ],
  "GM.04": [
    { code: "GM.04.2411671", name: "Wuli" },
    { code: "GM.04.2412176", name: "Sandu" },
    { code: "GM.04.2413088", name: "Kantora" },
    { code: "GM.04.2413462", name: "Fulladu East" },
  ],
  "GM.05": [
    { code: "GM.05.2412849", name: "Kombo South District" },
    { code: "GM.05.2412850", name: "Kombo North District" },
    { code: "GM.05.2412851", name: "Kombo East District" },
    { code: "GM.05.2412852", name: "Kombo Central District" },
    { code: "GM.05.2413477", name: "Foni Kansala" },
    { code: "GM.05.2413478", name: "Foni Jarrol" },
    { code: "GM.05.2413479", name: "Foni Brefet" },
    { code: "GM.05.2413480", name: "Foni Bondali" },
    { code: "GM.05.2413481", name: "Foni Bintang-Karenai" },
  ],
  "GM.07": [
    { code: "GM.07.2411712", name: "Upper Niumi District" },
    { code: "GM.07.2411714", name: "Upper Baddibu" },
    { code: "GM.07.2412717", name: "Lower Niumi District" },
    { code: "GM.07.2412718", name: "Lower Baddibu District" },
    { code: "GM.07.2413213", name: "Jokadu" },
    { code: "GM.07.2413640", name: "Dappo" },
    { code: "GM.07.2413641", name: "Dappo" },
    { code: "GM.07.2413686", name: "Central Baddibu" },
  ],
  "GN.04": [
    { code: "GN.04.8335012", name: "Conakry Special Zone" },
  ],
  "GN.B": [
    { code: "GN.B.02", name: "Boffa" },
    { code: "GN.B.03", name: "Boke Prefecture" },
    { code: "GN.B.11", name: "Fria" },
    { code: "GN.B.12", name: "Gaoual Prefecture" },
    { code: "GN.B.18", name: "Koundara Prefecture" },
  ],
  "GN.D": [
    { code: "GN.D.10", name: "Préfecture de Forécariah" },
    { code: "GN.D.16", name: "Kindia" },
    { code: "GN.D.27", name: "Telimele Prefecture" },
    { code: "GN.D.30", name: "Coyah" },
    { code: "GN.D.31", name: "Préfecture de Dubréka" },
  ],
  "GN.F": [
    { code: "GN.F.05", name: "Dabola" },
    { code: "GN.F.07", name: "Dinguiraye Prefecture" },
    { code: "GN.F.09", name: "Faranah Prefecture" },
    { code: "GN.F.17", name: "Kissidougou" },
  ],
  "GN.K": [
    { code: "GN.K.15", name: "Kerouane Prefecture" },
    { code: "GN.K.19", name: "Kouroussa" },
    { code: "GN.K.32", name: "Kankan Prefecture" },
    { code: "GN.K.37", name: "Mandiana Prefecture" },
    { code: "GN.K.39", name: "Siguiri Prefecture" },
  ],
  "GN.L": [
    { code: "GN.L.22", name: "Mali Prefecture" },
    { code: "GN.L.28", name: "Tougue Prefecture" },
    { code: "GN.L.33", name: "Koubia" },
    { code: "GN.L.34", name: "Labe Prefecture" },
    { code: "GN.L.35", name: "Lelouma Prefecture" },
  ],
  "GN.M": [
    { code: "GN.M.06", name: "Dalaba" },
    { code: "GN.M.23", name: "Mamou Prefecture" },
    { code: "GN.M.25", name: "Pita" },
  ],
  "GN.N": [
    { code: "GN.N.01", name: "Beyla Prefecture" },
    { code: "GN.N.13", name: "Préfecture de Guékédou" },
    { code: "GN.N.21", name: "Macenta" },
    { code: "GN.N.29", name: "Yomou" },
    { code: "GN.N.36", name: "Lola" },
    { code: "GN.N.38", name: "Nzerekore Prefecture" },
  ],
  "GP.GP": [
    { code: "GP.GP.971", name: "Guadeloupe" },
  ],
  "GQ.03": [
    { code: "GQ.03.11237875", name: "Mabana" },
    { code: "GQ.03.11237876", name: "San Antonio de Palé" },
  ],
  "GQ.04": [
    { code: "GQ.04.11237873", name: "Rebola" },
    { code: "GQ.04.11237874", name: "Malabo" },
    { code: "GQ.04.11237879", name: "Baney" },
  ],
  "GQ.05": [
    { code: "GQ.05.11237871", name: "Riaba" },
    { code: "GQ.05.11237872", name: "Luba" },
  ],
  "GQ.06": [
    { code: "GQ.06.11237870", name: "Bicurga" },
    { code: "GQ.06.11237880", name: "Nkimi" },
    { code: "GQ.06.2306702", name: "Sevilla de Niefang" },
    { code: "GQ.06.2308997", name: "Evinayong" },
    { code: "GQ.06.2310534", name: "Acurenam" },
  ],
  "GQ.07": [
    { code: "GQ.07.11237868", name: "Nsang" },
    { code: "GQ.07.11237869", name: "Ncue" },
    { code: "GQ.07.11237877", name: "Bidjabidjan" },
    { code: "GQ.07.11237881", name: "Nsork-Nzomo" },
    { code: "GQ.07.2308017", name: "Micomeseng" },
    { code: "GQ.07.2309335", name: "Ebebiyín" },
  ],
  "GQ.08": [
    { code: "GQ.08.11237864", name: "Río Campo" },
    { code: "GQ.08.11237865", name: "Corisco" },
    { code: "GQ.08.11237866", name: "Bitica" },
    { code: "GQ.08.11237867", name: "Machinda" },
    { code: "GQ.08.2306841", name: "Cogo" },
    { code: "GQ.08.2308276", name: "Distrito de Mbini" },
    { code: "GQ.08.2310047", name: "Bata" },
  ],
  "GQ.09": [
    { code: "GQ.09.11237860", name: "Ayene" },
    { code: "GQ.09.11237861", name: "Mengomeyén" },
    { code: "GQ.09.11237862", name: "Aconibe" },
    { code: "GQ.09.11237863", name: "Ciudad Nueva Oyala" },
    { code: "GQ.09.2306544", name: "Añisoc" },
    { code: "GQ.09.2307161", name: "Nsoc" },
    { code: "GQ.09.2307796", name: "Mongomo" },
  ],
  "GR.ESYE11": [
    { code: "GR.ESYE11.01", name: "Nomós Évrou" },
    { code: "GR.ESYE11.02", name: "Nomós Rodópis" },
    { code: "GR.ESYE11.03", name: "Nomós Xánthis" },
    { code: "GR.ESYE11.04", name: "Nomós Drámas" },
    { code: "GR.ESYE11.14", name: "Nomós Kaválas" },
  ],
  "GR.ESYE12": [
    { code: "GR.ESYE12.05", name: "Nomós Serrón" },
    { code: "GR.ESYE12.06", name: "Nomós Kilkís" },
    { code: "GR.ESYE12.07", name: "Nomós Péllis" },
    { code: "GR.ESYE12.12", name: "Nomós Imathías" },
    { code: "GR.ESYE12.13", name: "Nomós Thessaloníkis" },
    { code: "GR.ESYE12.15", name: "Nomós Chalkidikís" },
    { code: "GR.ESYE12.16", name: "Nomós Pierías" },
  ],
  "GR.ESYE13": [
    { code: "GR.ESYE13.08", name: "Nomós Florínis" },
    { code: "GR.ESYE13.09", name: "Nomós Kastoriás" },
    { code: "GR.ESYE13.10", name: "Nomós Grevenón" },
    { code: "GR.ESYE13.11", name: "Nomós Kozánis" },
  ],
  "GR.ESYE14": [
    { code: "GR.ESYE14.21", name: "Nomós Larísis" },
    { code: "GR.ESYE14.22", name: "Trikala" },
    { code: "GR.ESYE14.23", name: "Nomós Kardhítsas" },
    { code: "GR.ESYE14.24", name: "Nomós Magnisías" },
  ],
  "GR.ESYE21": [
    { code: "GR.ESYE21.17", name: "Nomós Ioannínon" },
    { code: "GR.ESYE21.18", name: "Nomós Thesprotías" },
    { code: "GR.ESYE21.19", name: "Nomós Prevézis" },
    { code: "GR.ESYE21.20", name: "Nomós Ártas" },
  ],
  "GR.ESYE22": [
    { code: "GR.ESYE22.25", name: "Nomós Kerkýras" },
    { code: "GR.ESYE22.26", name: "Lefkada" },
    { code: "GR.ESYE22.27", name: "Nomós Kefallinías" },
    { code: "GR.ESYE22.28", name: "Nomós Zakýnthou" },
  ],
  "GR.ESYE23": [
    { code: "GR.ESYE23.31", name: "Nomós Aitolías kai Akarnanías" },
    { code: "GR.ESYE23.38", name: "Nomós Achaḯas" },
    { code: "GR.ESYE23.39", name: "Nomós Ileías" },
  ],
  "GR.ESYE24": [
    { code: "GR.ESYE24.29", name: "Nomós Fthiótidos" },
    { code: "GR.ESYE24.30", name: "Nomós Evrytanías" },
    { code: "GR.ESYE24.32", name: "Nomós Fokídos" },
    { code: "GR.ESYE24.33", name: "Nomós Voiotías" },
    { code: "GR.ESYE24.34", name: "Nomós Evvoías" },
  ],
  "GR.ESYE25": [
    { code: "GR.ESYE25.36", name: "Nomós Argolídos" },
    { code: "GR.ESYE25.37", name: "Nomós Korinthías" },
    { code: "GR.ESYE25.40", name: "Nomós Messinías" },
    { code: "GR.ESYE25.41", name: "Nomós Arkadías" },
    { code: "GR.ESYE25.42", name: "Nomós Lakonías" },
  ],
  "GR.ESYE31": [
    { code: "GR.ESYE31.35", name: "Nomós Attikís" },
    { code: "GR.ESYE31.96", name: "Nomós Piraiós" },
    { code: "GR.ESYE31.98", name: "Nomarchía Anatolikís Attikís" },
    { code: "GR.ESYE31.99", name: "Nomarchía Athínas" },
  ],
  "GR.ESYE41": [
    { code: "GR.ESYE41.48", name: "Nomós Sámou" },
    { code: "GR.ESYE41.50", name: "Chios" },
    { code: "GR.ESYE41.51", name: "Lesbos" },
  ],
  "GR.ESYE42": [
    { code: "GR.ESYE42.47", name: "Dodecanese" },
    { code: "GR.ESYE42.49", name: "Nomós Kykládon" },
  ],
  "GR.ESYE43": [
    { code: "GR.ESYE43.43", name: "Nomós Chaniás" },
    { code: "GR.ESYE43.44", name: "Nomós Rethýmnis" },
    { code: "GR.ESYE43.45", name: "Nomós Irakleíou" },
    { code: "GR.ESYE43.46", name: "Nomós Lasithíou" },
  ],
  "GT.01": [
    { code: "GT.01.3588205", name: "Municipio de Tucurú" },
    { code: "GT.01.3588553", name: "Municipio de Tamahú" },
    { code: "GT.01.3588602", name: "Municipio de Tactic" },
    { code: "GT.01.3588857", name: "Municipio de Senahú" },
    { code: "GT.01.3589394", name: "Municipio de Santa Cruz Verapaz" },
    { code: "GT.01.3589642", name: "Municipio de San Pedro Carchá" },
    { code: "GT.01.3589916", name: "Municipio de San Juan Chamelco" },
    { code: "GT.01.3590315", name: "Municipio de San Cristóbal Verapaz" },
    { code: "GT.01.3591675", name: "Municipio de Panzós" },
    { code: "GT.01.3594314", name: "Municipio de Lanquín" },
    { code: "GT.01.3598116", name: "Municipio de Cobán" },
    { code: "GT.01.3598414", name: "Municipio de Chisec" },
    { code: "GT.01.3598824", name: "Municipio de Chahal" },
    { code: "GT.01.3599264", name: "Municipio de Cahabón" },
    { code: "GT.01.9166134", name: "Municipio de Fray Bartolome de las Casas" },
    { code: "GT.01.9253725", name: "Raxruja" },
    { code: "GT.01.9253762", name: "Santa Catarina La Tinta" },
    { code: "GT.01.9975220", name: "Municipio de Santa Catalina la Tinta" },
    { code: "GT.01.9975224", name: "Municipio de Raxruhá" },
  ],
  "GT.02": [
    { code: "GT.02.3589729", name: "Municipio de San Miguel Chicaj" },
    { code: "GT.02.3590106", name: "Municipio de San Jerónimo" },
    { code: "GT.02.3590615", name: "Municipio de Salamá" },
    { code: "GT.02.3590923", name: "Municipio de Rabinal" },
    { code: "GT.02.3591027", name: "Municipio de Purulhá" },
    { code: "GT.02.3595630", name: "Municipio de Granados" },
    { code: "GT.02.3597300", name: "Municipio de El Chol" },
    { code: "GT.02.3597836", name: "Municipio de Cubulco" },
  ],
  "GT.03": [
    { code: "GT.03.3587541", name: "Municipio de Zaragoza" },
    { code: "GT.03.3587635", name: "Municipio de Yepocapa" },
    { code: "GT.03.3588475", name: "Municipio de Tecpán Guatemala" },
    { code: "GT.03.3589407", name: "Municipio de Santa Cruz Balanyá" },
    { code: "GT.03.3589479", name: "Municipio de Santa Apolonia" },
    { code: "GT.03.3589779", name: "Municipio de San Martín Jilotepeque" },
    { code: "GT.03.3589974", name: "Municipio de San José Poaquil" },
    { code: "GT.03.3590528", name: "Municipio de San Andrés Itzapa" },
    { code: "GT.03.3591209", name: "Municipio de Pochuta" },
    { code: "GT.03.3591511", name: "Municipio de Patzún" },
    { code: "GT.03.3591521", name: "Municipio de Patzicía" },
    { code: "GT.03.3591628", name: "Municipio de Parramos" },
    { code: "GT.03.3596040", name: "Municipio de El Tejar" },
    { code: "GT.03.3598032", name: "Municipio de Comalapa" },
    { code: "GT.03.3598570", name: "Municipio de Chimaltenango" },
    { code: "GT.03.3600007", name: "Municipio de Acatenango" },
    { code: "GT.03.9253822", name: "San Juan Comalapa" },
  ],
  "GT.04": [
    { code: "GT.04.3589902", name: "Municipio de San Juan la Ermita" },
    { code: "GT.04.3590016", name: "Municipio de San José La Arada" },
    { code: "GT.04.3590124", name: "Municipio de San Jacinto" },
    { code: "GT.04.3590972", name: "Municipio de Quezaltepeque" },
    { code: "GT.04.3592034", name: "Municipio de Olopa" },
    { code: "GT.04.3595180", name: "Municipio de Jocotán" },
    { code: "GT.04.3595363", name: "Municipio de Ipala" },
    { code: "GT.04.3595780", name: "Municipio de Esquipulas" },
    { code: "GT.04.3597984", name: "Municipio de Concepción Las Minas" },
    { code: "GT.04.3598463", name: "Municipio de Chiquimula" },
    { code: "GT.04.3599180", name: "Municipio de Camotán" },
  ],
  "GT.05": [
    { code: "GT.05.3589553", name: "Municipio de Sansare" },
    { code: "GT.05.3590324", name: "Municipio de San Cristóbal Acasaguastlán" },
    { code: "GT.05.3590405", name: "Municipio de Sanarate" },
    { code: "GT.05.3590447", name: "Municipio de San Antonio La Paz" },
    { code: "GT.05.3590546", name: "Municipio de San Agustín Acasaguastlán" },
    { code: "GT.05.3592348", name: "Municipio de Morazán" },
    { code: "GT.05.3596410", name: "Municipio de El Progreso" },
    { code: "GT.05.3596938", name: "Municipio de El Jícaro" },
    { code: "GT.05.9253734", name: "San Cristobal Acasguastlan" },
    { code: "GT.05.9253768", name: "Municipio de Guastatoya" },
  ],
  "GT.06": [
    { code: "GT.06.12017928", name: "Sipacate" },
    { code: "GT.06.3588341", name: "Município de Tiquisate" },
    { code: "GT.06.3588719", name: "Municipio de Siquinalá" },
    { code: "GT.06.3589034", name: "Municipio de San Vicente Pacaya" },
    { code: "GT.06.3589288", name: "Municipio de Santa Lucía Cotzumalguapa" },
    { code: "GT.06.3590059", name: "Municipio de San José" },
    { code: "GT.06.3591830", name: "Municipio de Palín" },
    { code: "GT.06.3592142", name: "Municipio de Nueva Concepción" },
    { code: "GT.06.3592641", name: "Municipio de Masagua" },
    { code: "GT.06.3594574", name: "Municipio de La Gomera" },
    { code: "GT.06.3594750", name: "Municipio de La Democracia" },
    { code: "GT.06.3595254", name: "Municipio de Iztapa" },
    { code: "GT.06.3595553", name: "Municipio de Guanagazapa" },
    { code: "GT.06.3595801", name: "Municipio de Escuintla" },
  ],
  "GT.07": [
    { code: "GT.07.3587901", name: "Municipio de Villa Nueva" },
    { code: "GT.07.3587922", name: "Municipio de Villa Canales" },
    { code: "GT.07.3589451", name: "Municipio de Santa Catarina Pinula" },
    { code: "GT.07.3589568", name: "Municipio de San Raymundo" },
    { code: "GT.07.3589625", name: "Municipio de San Pedro Sacatepéquez" },
    { code: "GT.07.3589645", name: "Municipio de San Pedro Ayampuc" },
    { code: "GT.07.3589884", name: "Municipio de San Juan Sacatepéquez" },
    { code: "GT.07.3589976", name: "Municipio de San José Pinula" },
    { code: "GT.07.3590033", name: "Municipio de San José del Golfo" },
    { code: "GT.07.3591414", name: "Municipio de Petapa" },
    { code: "GT.07.3591849", name: "Municipio de Palencia" },
    { code: "GT.07.3592517", name: "Municipio de Mixco" },
    { code: "GT.07.3595529", name: "Municipio de Guatemala" },
    { code: "GT.07.3595713", name: "Municipio de Fraijanes" },
    { code: "GT.07.3598276", name: "Municipio de Chuarrancho" },
    { code: "GT.07.3598528", name: "Municipio de Chinautla" },
    { code: "GT.07.3599732", name: "Municipio de Amatitlán" },
    { code: "GT.07.9253756", name: "Lago de Amatitlan" },
  ],
  "GT.08": [
    { code: "GT.08.12017929", name: "Petatán" },
    { code: "GT.08.3588307", name: "Municipio de Todos Santos Cuchumatán" },
    { code: "GT.08.3588473", name: "Municipio de Tectitán" },
    { code: "GT.08.3588693", name: "San Pedro Soloma" },
    { code: "GT.08.3589102", name: "Municipio de Santiago Chimaltenango" },
    { code: "GT.08.3589354", name: "Municipio de Santa Eulalia" },
    { code: "GT.08.3589464", name: "Municipio de Santa Bárbara" },
    { code: "GT.08.3589497", name: "Municipio de Santa Ana Huista" },
    { code: "GT.08.3589540", name: "Municipio de San Sebastián Huehuetenango" },
    { code: "GT.08.3589542", name: "Municipio de San Sebastián Coatán" },
    { code: "GT.08.3589578", name: "Municipio de San Rafael Petzal" },
    { code: "GT.08.3589594", name: "Municipio de San Rafael La Independencia" },
    { code: "GT.08.3589631", name: "Municipio de San Pedro Necta" },
    { code: "GT.08.3589733", name: "Municipio de San Miguel Acatán" },
    { code: "GT.08.3589769", name: "Municipio de San Mateo Ixtatán" },
    { code: "GT.08.3589899", name: "Municipio de San Juan Ixcoy" },
    { code: "GT.08.3589924", name: "Municipio de San Juan Atitán" },
    { code: "GT.08.3590187", name: "Municipio de San Gaspar Ixchil" },
    { code: "GT.08.3590457", name: "Municipio de San Antonio Huista" },
    { code: "GT.08.3592216", name: "Municipio de Nentón" },
    { code: "GT.08.3592750", name: "Municipio de Malacatancito" },
    { code: "GT.08.3594419", name: "Municipio de La Libertad" },
    { code: "GT.08.3594749", name: "Municipio de La Democracia" },
    { code: "GT.08.3595247", name: "Municipio de Jacaltenango" },
    { code: "GT.08.3595281", name: "San Ildefonso Ixtahuacán" },
    { code: "GT.08.3595414", name: "Municipio de Huehuetenango" },
    { code: "GT.08.3597800", name: "Municipio de Cuilco" },
    { code: "GT.08.3598001", name: "Municipio de Concepción Huista" },
    { code: "GT.08.3598040", name: "Municipio de Colotenango" },
    { code: "GT.08.3598691", name: "Municipio de Chiantla" },
    { code: "GT.08.3599574", name: "Municipio de Barillas" },
    { code: "GT.08.3599911", name: "Municipio de Aguacatán" },
    { code: "GT.08.9253724", name: "Municipio de Union Cantinil" },
    { code: "GT.08.9975174", name: "Municipio de Unión Cantinil" },
    { code: "GT.08.9975223", name: "Municipo de San Ildefonso Ixtahuacan" },
  ],
  "GT.09": [
    { code: "GT.09.3591061", name: "Municipio de Puerto Barrios" },
    { code: "GT.09.3592361", name: "Municipio de Morales" },
    { code: "GT.09.3593233", name: "Municipio de Los Amates" },
    { code: "GT.09.3593375", name: "Municipio de Lívingston" },
    { code: "GT.09.3597077", name: "Municipio de El Estor" },
  ],
  "GT.10": [
    { code: "GT.10.3589628", name: "Municipio de San Pedro Pinula" },
    { code: "GT.10.3589811", name: "Municipio de San Manuel Chaparrón" },
    { code: "GT.10.3589821", name: "Municipio de San Luis Jilotepeque" },
    { code: "GT.10.3590354", name: "Municipio de San Carlos Alzatate" },
    { code: "GT.10.3592476", name: "Municipio de Monjas" },
    { code: "GT.10.3592634", name: "Municipio de Mataquescuintla" },
    { code: "GT.10.3595235", name: "Municipio de Jalapa" },
  ],
  "GT.11": [
    { code: "GT.11.3587545", name: "Municipio de Zapotitlán" },
    { code: "GT.11.3587591", name: "Municipio de Yupiltepeque" },
    { code: "GT.11.3589455", name: "Municipio de Santa Catarina Mita" },
    { code: "GT.11.3590052", name: "Municipio de San José Acatempa" },
    { code: "GT.11.3590986", name: "Municipio de Quesada" },
    { code: "GT.11.3591617", name: "Municipio de Pasaco" },
    { code: "GT.11.3592320", name: "Municipio de Moyuta" },
    { code: "GT.11.3595065", name: "Municipio de Jutiapa" },
    { code: "GT.11.3595222", name: "Municipio de Jerez" },
    { code: "GT.11.3595231", name: "Municipio de Jalpatagua" },
    { code: "GT.11.3596411", name: "Municipio de El Progreso" },
    { code: "GT.11.3597674", name: "Municipio de El Adelanto" },
    { code: "GT.11.3597965", name: "Municipio de Conguaco" },
    { code: "GT.11.3598030", name: "Municipio de Comapa" },
    { code: "GT.11.3599631", name: "Municipio de Atescatempa" },
    { code: "GT.11.3599638", name: "Municipio de Asunción Mita" },
    { code: "GT.11.3599963", name: "Municipio de Agua Blanca" },
  ],
  "GT.12": [
    { code: "GT.12.3588983", name: "Municipio de Sayaxché" },
    { code: "GT.12.3589501", name: "Municipio de Santa Ana" },
    { code: "GT.12.3589835", name: "Municipio de San Luis" },
    { code: "GT.12.3590058", name: "Municipio de San José" },
    { code: "GT.12.3590233", name: "Municipio de San Francisco" },
    { code: "GT.12.3590386", name: "Municipio de San Benito" },
    { code: "GT.12.3590534", name: "Municipio de San Andrés" },
    { code: "GT.12.3591180", name: "Municipio de Poptún" },
    { code: "GT.12.3592595", name: "Municipio de Melchor de Mencos" },
    { code: "GT.12.3594418", name: "Municipio de La Libertad" },
    { code: "GT.12.3595722", name: "Municipio de Flores" },
    { code: "GT.12.3597716", name: "Municipio de Dolores" },
    { code: "GT.12.9253824", name: "Las Cruces" },
    { code: "GT.12.9975229", name: "Municipio de El Chal" },
  ],
  "GT.13": [
    { code: "GT.13.3587508", name: "Municipio de Zunil" },
    { code: "GT.13.3588761", name: "Municipio de Sibilia" },
    { code: "GT.13.3589705", name: "Municipio de San Miguel Sigüilá" },
    { code: "GT.13.3589772", name: "Municipio de San Mateo" },
    { code: "GT.13.3589777", name: "Municipio de San Martín Sacatepéquez" },
    { code: "GT.13.3590210", name: "Municipio de San Francisco La Unión" },
    { code: "GT.13.3590346", name: "Municipio de San Carlos Sija" },
    { code: "GT.13.3590604", name: "Municipio de Salcajá" },
    { code: "GT.13.3590977", name: "Municipio de Quetzaltenango" },
    { code: "GT.13.3591840", name: "Municipio de Palestina de los Altos" },
    { code: "GT.13.3591996", name: "Municipio de San Juan Ostuncalco" },
    { code: "GT.13.3592040", name: "Municipio de Olintepeque" },
    { code: "GT.13.3594666", name: "Municipio de La Esperanza" },
    { code: "GT.13.3595404", name: "Municipio de Huitán" },
    { code: "GT.13.3595670", name: "Municipio de Génova" },
    { code: "GT.13.3595720", name: "Municipio de Flores Costa Cuca" },
    { code: "GT.13.3596634", name: "Municipio de El Palmar" },
    { code: "GT.13.3597992", name: "Municipio de Concepción Chiquirichapa" },
    { code: "GT.13.3598072", name: "Municipio de Colomba" },
    { code: "GT.13.3598121", name: "Municipio de Coatepeque" },
    { code: "GT.13.3599066", name: "Municipio de Cantel" },
    { code: "GT.13.3599252", name: "Municipio de Cajolá" },
    { code: "GT.13.3599286", name: "Municipio de Cabricán" },
    { code: "GT.13.3599791", name: "Municipio de Almolonga" },
    { code: "GT.13.9975221", name: "Municipo de San Juan Ostuncalco" },
  ],
  "GT.14": [
    { code: "GT.14.3588042", name: "Municipio de Uspantán" },
    { code: "GT.14.3589403", name: "Municipio de Santa Cruz del Quiché" },
    { code: "GT.14.3589639", name: "Municipio de San Pedro Jocopilas" },
    { code: "GT.14.3589912", name: "Municipio de San Juan Cotzal" },
    { code: "GT.14.3590394", name: "Municipio de San Bartolomé Jocotenango" },
    { code: "GT.14.3590455", name: "Municipio de San Antonio Ilotenango" },
    { code: "GT.14.3590525", name: "Municipio de San Andrés Sajcabajá" },
    { code: "GT.14.3590689", name: "Municipio de Sacapulas" },
    { code: "GT.14.3591516", name: "Municipio de Patzité" },
    { code: "GT.14.3592236", name: "Municipio de Nebaj" },
    { code: "GT.14.3595147", name: "Municipio de Joyabaj" },
    { code: "GT.14.3597771", name: "Municipio de Cunén" },
    { code: "GT.14.3598512", name: "Municipio de Chinique" },
    { code: "GT.14.3598654", name: "Municipio de Chichicastenango" },
    { code: "GT.14.3598658", name: "Municipio de Chiché" },
    { code: "GT.14.3598803", name: "Municipio de Chajul" },
    { code: "GT.14.3599093", name: "Municipio de Canillá" },
    { code: "GT.14.9166161", name: "Municipio de Ixcan" },
    { code: "GT.14.9166182", name: "Municipio de Chicaman" },
    { code: "GT.14.9253733", name: "Municipio de Zacualpa" },
    { code: "GT.14.9253735", name: "Municipio de Pachalum" },
  ],
  "GT.15": [
    { code: "GT.15.3589399", name: "Municipio de Santa Cruz Muluá" },
    { code: "GT.15.3589545", name: "Municipio de San Sebastián" },
    { code: "GT.15.3589775", name: "Municipio de San Martín Zapotitlán" },
    { code: "GT.15.3590281", name: "Municipio de San Felipe" },
    { code: "GT.15.3590521", name: "Municipio de San Andrés Villa Seca" },
    { code: "GT.15.3590856", name: "Municipio de Retalhuleu" },
    { code: "GT.15.3592104", name: "Municipio de Nuevo San Carlos" },
    { code: "GT.15.3597586", name: "Municipio de El Asintal" },
    { code: "GT.15.3598786", name: "Municipio de Champerico" },
  ],
  "GT.16": [
    { code: "GT.16.3588652", name: "Municipio de Sumpango" },
    { code: "GT.16.3589071", name: "Municipio de Santo Domingo Xenacoj" },
    { code: "GT.16.3589100", name: "Municipio de Santiago Sacatepéquez" },
    { code: "GT.16.3589251", name: "Municipio de Santa María de Jesús" },
    { code: "GT.16.3589284", name: "Municipio de Santa Lucía Milpas Altas" },
    { code: "GT.16.3589459", name: "Municipio de Santa Catarina Barahona" },
    { code: "GT.16.3589726", name: "Municipio de San Miguel Dueñas" },
    { code: "GT.16.3589851", name: "Municipio de San Lucas Sacatepéquez" },
    { code: "GT.16.3590392", name: "Municipio de San Bartolomé Milpas Altas" },
    { code: "GT.16.3590474", name: "Municipio de San Antonio Aguas Calientes" },
    { code: "GT.16.3591573", name: "Municipio de Pastores" },
    { code: "GT.16.3592769", name: "Municipio de Magdalena Milpas Altas" },
    { code: "GT.16.3595170", name: "Municipio de Jocotenango" },
    { code: "GT.16.3598127", name: "Municipio de Ciudad Vieja" },
    { code: "GT.16.3599698", name: "Municipio de Antigua Guatemala" },
    { code: "GT.16.3599786", name: "Municipio de Alotenango" },
  ],
  "GT.17": [
    { code: "GT.17.3588459", name: "Municipio de Tejutla" },
    { code: "GT.17.3588587", name: "Municipio de Tajumulco" },
    { code: "GT.17.3588609", name: "Municipio de Tacaná" },
    { code: "GT.17.3588725", name: "Municipio de Sipacapa" },
    { code: "GT.17.3588759", name: "Municipio de Sibinal" },
    { code: "GT.17.3589576", name: "Municipio de San Rafael Pie de la Cuesta" },
    { code: "GT.17.3589624", name: "Municipio de San Pedro Sacatepéquez" },
    { code: "GT.17.3589673", name: "Municipio de San Pablo" },
    { code: "GT.17.3589719", name: "Municipio de San Miguel Ixtahuacán" },
    { code: "GT.17.3589799", name: "Municipio de San Marcos" },
    { code: "GT.17.3589860", name: "Municipio de San Lorenzo" },
    { code: "GT.17.3589984", name: "Municipio de San José Ojetenam" },
    { code: "GT.17.3590322", name: "Municipio de San Cristóbal Cucho" },
    { code: "GT.17.3590418", name: "Municipio de San Antonio Sacatepéquez" },
    { code: "GT.17.3590807", name: "Municipio de Río Blanco" },
    { code: "GT.17.3591884", name: "Municipio de Pajapita" },
    { code: "GT.17.3592084", name: "Municipio de Ocós" },
    { code: "GT.17.3592107", name: "Municipio de Nuevo Progreso" },
    { code: "GT.17.3592752", name: "Municipio de Malacatán" },
    { code: "GT.17.3594137", name: "Municipio de La Reforma" },
    { code: "GT.17.3595328", name: "Municipio de Ixchiguán" },
    { code: "GT.17.3595777", name: "Municipio de Esquipulas Palo Gordo" },
    { code: "GT.17.3595928", name: "Municipio de El Tumbador" },
    { code: "GT.17.3596243", name: "Municipio de El Rodeo" },
    { code: "GT.17.3596386", name: "Municipio de El Quetzal" },
    { code: "GT.17.3597975", name: "Municipio de Concepción Tutuapa" },
    { code: "GT.17.3598023", name: "Municipio de Comitancillo" },
    { code: "GT.17.3598956", name: "Municipio de Catarina" },
    { code: "GT.17.3599614", name: "Municipio de Ayutla" },
    { code: "GT.17.9975227", name: "Municipio de La Blanca" },
  ],
  "GT.18": [
    { code: "GT.18.3588490", name: "Municipio de Taxisco" },
    { code: "GT.18.3589158", name: "Municipio de Santa Rosa de Lima" },
    { code: "GT.18.3589248", name: "Municipio de Santa María Ixhuatán" },
    { code: "GT.18.3589397", name: "Municipio de Santa Cruz Naranjo" },
    { code: "GT.18.3589588", name: "Municipio de San Rafael Las Flores" },
    { code: "GT.18.3589879", name: "Municipio de San Juan Tecuaco" },
    { code: "GT.18.3591091", name: "Municipio de Pueblo Nuevo Viñas" },
    { code: "GT.18.3592017", name: "Municipio de Oratorio" },
    { code: "GT.18.3592125", name: "Municipio de Nueva Santa Rosa" },
    { code: "GT.18.3595502", name: "Municipio de Guazacapán" },
    { code: "GT.18.3597803", name: "Municipio de Cuilapa" },
    { code: "GT.18.3598459", name: "Municipio de Chiquimulilla" },
    { code: "GT.18.3598967", name: "Municipio de Casillas" },
    { code: "GT.18.3599580", name: "Municipio de Barberena" },
  ],
  "GT.19": [
    { code: "GT.19.3588695", name: "Municipio de Sololá" },
    { code: "GT.19.3589104", name: "Municipio de Santiago Atitlán" },
    { code: "GT.19.3589246", name: "Municipio de Santa María Visitación" },
    { code: "GT.19.3589281", name: "Municipio de Santa Lucía Utatlán" },
    { code: "GT.19.3589401", name: "Municipio de Santa Cruz La Laguna" },
    { code: "GT.19.3589432", name: "Municipio de Santa Clara La Laguna" },
    { code: "GT.19.3589453", name: "Municipio de Santa Catarina Palopó" },
    { code: "GT.19.3589457", name: "Municipio de Santa Catarina Ixtahuacán" },
    { code: "GT.19.3589636", name: "Municipio de San Pedro La Laguna" },
    { code: "GT.19.3589668", name: "Municipio de San Pablo La Laguna" },
    { code: "GT.19.3589794", name: "Municipio de San Marcos La Laguna" },
    { code: "GT.19.3589849", name: "Municipio de San Lucas Tolimán" },
    { code: "GT.19.3589895", name: "Municipio de San Juan La Laguna" },
    { code: "GT.19.3590040", name: "Municipio de San José Chacayá" },
    { code: "GT.19.3590423", name: "Municipio de San Antonio Palopó" },
    { code: "GT.19.3590523", name: "Municipio de San Andrés Semetabaj" },
    { code: "GT.19.3591748", name: "Municipio de Panajachel" },
    { code: "GT.19.3592285", name: "Municipio de Nahualá" },
    { code: "GT.19.3598002", name: "Municipio de Concepción" },
    { code: "GT.19.9253744", name: "Lago de Atitlan" },
  ],
  "GT.20": [
    { code: "GT.20.3587505", name: "Municipio de Zunilito" },
    { code: "GT.20.3589061", name: "Municipio de Santo Tomás La Unión" },
    { code: "GT.20.3589073", name: "Municipio de Santo Domingo Suchitepéquez" },
    { code: "GT.20.3589465", name: "Municipio de Santa Bárbara" },
    { code: "GT.20.3589670", name: "Municipio de San Pablo Jocopilas" },
    { code: "GT.20.3589708", name: "Municipio de San Miguel Panán" },
    { code: "GT.20.3589861", name: "Municipio de San Lorenzo" },
    { code: "GT.20.3589920", name: "Municipio de San Juan Bautista" },
    { code: "GT.20.3590028", name: "Municipio de San José El Ídolo" },
    { code: "GT.20.3590192", name: "Municipio de San Gabriel" },
    { code: "GT.20.3590196", name: "Municipio de San Francisco Zapotitlán" },
    { code: "GT.20.3590382", name: "Municipio de San Bernardino" },
    { code: "GT.20.3590411", name: "Municipio de San Antonio Suchitepéquez" },
    { code: "GT.20.3590566", name: "Municipio de Samayac" },
    { code: "GT.20.3590802", name: "Municipio de Río Bravo" },
    { code: "GT.20.3591096", name: "Municipio de Pueblo Nuevo" },
    { code: "GT.20.3591540", name: "Municipio de Patulul" },
    { code: "GT.20.3592608", name: "Municipio de Mazatenango" },
    { code: "GT.20.3597749", name: "Municipio de Cuyotenango" },
    { code: "GT.20.3598677", name: "Municipio de Chicacao" },
    { code: "GT.20.9975225", name: "La Máquina" },
  ],
  "GT.21": [
    { code: "GT.21.3588255", name: "Municipio de Totonicapán" },
    { code: "GT.21.3589255", name: "Municipio de Santa María Chiquimula" },
    { code: "GT.21.3589286", name: "Municipio de Santa Lucía La Reforma" },
    { code: "GT.21.3590218", name: "Municipio de San Francisco El Alto" },
    { code: "GT.21.3590317", name: "Municipio de San Cristóbal Totonicapán" },
    { code: "GT.21.3590397", name: "Municipio de San Bartolo Aguas Calientes" },
    { code: "GT.21.3590519", name: "Municipio de San Andrés Xecul" },
    { code: "GT.21.3592482", name: "Municipio de Momostenango" },
  ],
  "GT.22": [
    { code: "GT.22.3587585", name: "Municipio de Zacapa" },
    { code: "GT.22.3588039", name: "Municipio de Usumatlán" },
    { code: "GT.22.3588468", name: "Municipio de Teculután" },
    { code: "GT.22.3590305", name: "Municipio de San Diego" },
    { code: "GT.22.3590786", name: "Municipio de Río Hondo" },
    { code: "GT.22.3593488", name: "Municipio de La Unión" },
    { code: "GT.22.3595402", name: "Municipio de Huité" },
    { code: "GT.22.3595559", name: "Municipio de Gualán" },
    { code: "GT.22.3595755", name: "Municipio de Estanzuela" },
    { code: "GT.22.3599294", name: "Municipio de Cabañas" },
    { code: "GT.22.9975228", name: "Municipio de San Jorge" },
  ],
  "GW.01": [
    { code: "GW.01.11995994", name: "Bambadinca" },
    { code: "GW.01.8335054", name: "Xitole Sector" },
    { code: "GW.01.8335071", name: "Gamamundo Sector" },
    { code: "GW.01.8335072", name: "Galomaro Sector" },
    { code: "GW.01.8335074", name: "Bafata Sector" },
    { code: "GW.01.8335076", name: "Contuboel Sector" },
  ],
  "GW.02": [
    { code: "GW.02.10376583", name: "Empada" },
    { code: "GW.02.10376960", name: "Tite" },
    { code: "GW.02.7909708", name: "Fulacunda" },
    { code: "GW.02.7909709", name: "Buba" },
  ],
  "GW.04": [
    { code: "GW.04.8335049", name: "Mansaba Sector" },
    { code: "GW.04.8335050", name: "Bissora Sector" },
    { code: "GW.04.8335051", name: "Nhacra Sector" },
    { code: "GW.04.8335052", name: "Farim Sector" },
    { code: "GW.04.8335070", name: "Mansoa" },
  ],
  "GW.05": [
    { code: "GW.05.11995995", name: "Bolama" },
    { code: "GW.05.11996000", name: "Uno" },
    { code: "GW.05.7909710", name: "Bubaque" },
    { code: "GW.05.7911005", name: "Caravela" },
  ],
  "GW.06": [
    { code: "GW.06.7909700", name: "Sao Domingos" },
    { code: "GW.06.7909702", name: "Cacheu Sector" },
    { code: "GW.06.7932380", name: "Bigene Sector" },
    { code: "GW.06.8335055", name: "Caio Sector" },
    { code: "GW.06.8335068", name: "Canchungo Sector" },
    { code: "GW.06.8335069", name: "Bula" },
  ],
  "GW.07": [
    { code: "GW.07.11996001", name: "Catio" },
    { code: "GW.07.11996002", name: "Komo" },
    { code: "GW.07.7909706", name: "Bedanda" },
    { code: "GW.07.7909713", name: "Quebo" },
    { code: "GW.07.7911001", name: "Cacine" },
  ],
  "GW.10": [
    { code: "GW.10.11995997", name: "Pirada" },
    { code: "GW.10.11995998", name: "Pitche" },
    { code: "GW.10.11995999", name: "Boe" },
    { code: "GW.10.8335053", name: "Sonaco Sector" },
    { code: "GW.10.8335075", name: "Gabu Sector" },
  ],
  "GW.11": [
    { code: "GW.11.11996003", name: "Sector Autonomo de Bissau" },
  ],
  "GW.12": [
    { code: "GW.12.11995996", name: "Safim" },
    { code: "GW.12.8335038", name: "Prabis Sector" },
    { code: "GW.12.8335043", name: "Quinhamel Sector" },
  ],
  "HN.01": [
    { code: "HN.01.0101", name: "La Ceiba" },
    { code: "HN.01.0102", name: "El Porvenir" },
    { code: "HN.01.0103", name: "Esparta" },
    { code: "HN.01.0104", name: "Jutiapa" },
    { code: "HN.01.0105", name: "La Masica" },
    { code: "HN.01.0106", name: "San Francisco" },
    { code: "HN.01.0107", name: "Tela" },
    { code: "HN.01.0108", name: "Arizona" },
  ],
  "HN.02": [
    { code: "HN.02.0601", name: "Choluteca" },
    { code: "HN.02.0602", name: "Apacilagua" },
    { code: "HN.02.0603", name: "Concepción de María" },
    { code: "HN.02.0604", name: "Duyure" },
    { code: "HN.02.0605", name: "El Corpus" },
    { code: "HN.02.0606", name: "El Triunfo" },
    { code: "HN.02.0607", name: "Marcovia" },
    { code: "HN.02.0608", name: "Morolica" },
    { code: "HN.02.0609", name: "Namasigüe" },
    { code: "HN.02.0610", name: "Orocuina" },
    { code: "HN.02.0611", name: "Pespire" },
    { code: "HN.02.0612", name: "San Antonio de Flores" },
    { code: "HN.02.0613", name: "San Isidro" },
    { code: "HN.02.0614", name: "San José" },
    { code: "HN.02.0615", name: "San Marcos de Colón" },
    { code: "HN.02.0616", name: "Santa Ana de Yusguare" },
  ],
  "HN.03": [
    { code: "HN.03.0201", name: "Trujillo" },
    { code: "HN.03.0202", name: "Balfate" },
    { code: "HN.03.0203", name: "Iriona" },
    { code: "HN.03.0204", name: "Limón" },
    { code: "HN.03.0205", name: "Municipio de Sabá" },
    { code: "HN.03.0206", name: "Santa Fe" },
    { code: "HN.03.0207", name: "Santa Rosa de Aguán" },
    { code: "HN.03.0208", name: "Sonaguera" },
    { code: "HN.03.0209", name: "Tocoa" },
    { code: "HN.03.0210", name: "Bonito Oriental" },
  ],
  "HN.04": [
    { code: "HN.04.0301", name: "Comayagua" },
    { code: "HN.04.0302", name: "Ajuterique" },
    { code: "HN.04.0303", name: "El Rosario" },
    { code: "HN.04.0304", name: "Esquías" },
    { code: "HN.04.0305", name: "Humuya" },
    { code: "HN.04.0306", name: "La Libertad" },
    { code: "HN.04.0307", name: "Lamaní" },
    { code: "HN.04.0308", name: "La Trinidad" },
    { code: "HN.04.0309", name: "Lejamaní" },
    { code: "HN.04.0310", name: "Meámbar" },
    { code: "HN.04.0311", name: "Minas de Oro" },
    { code: "HN.04.0312", name: "Ojos de Agua" },
    { code: "HN.04.0313", name: "San Jerónimo" },
    { code: "HN.04.0314", name: "San José de Comayagua" },
    { code: "HN.04.0315", name: "San José del Potrero" },
    { code: "HN.04.0316", name: "San Luis" },
    { code: "HN.04.0317", name: "San Sebastián" },
    { code: "HN.04.0318", name: "Siguatepeque" },
    { code: "HN.04.0319", name: "Villa de San Antonio" },
    { code: "HN.04.0320", name: "Las Lajas" },
    { code: "HN.04.0321", name: "Taulabé" },
  ],
  "HN.05": [
    { code: "HN.05.0401", name: "Santa Rosa de Copán" },
    { code: "HN.05.0402", name: "Cabañas" },
    { code: "HN.05.0403", name: "Concepción" },
    { code: "HN.05.0404", name: "Copán Ruinas" },
    { code: "HN.05.0405", name: "Corquín" },
    { code: "HN.05.0406", name: "Cucuyagua" },
    { code: "HN.05.0407", name: "Dolores" },
    { code: "HN.05.0408", name: "Dulce Nombre" },
    { code: "HN.05.0409", name: "El Paraíso" },
    { code: "HN.05.0410", name: "Florida" },
    { code: "HN.05.0411", name: "La Jigua" },
    { code: "HN.05.0412", name: "La Unión" },
    { code: "HN.05.0413", name: "Nueva Arcadia" },
    { code: "HN.05.0414", name: "San Agustín" },
    { code: "HN.05.0415", name: "San Antonio" },
    { code: "HN.05.0416", name: "San Jerónimo" },
    { code: "HN.05.0417", name: "San José" },
    { code: "HN.05.0418", name: "San Juan de Opoa" },
    { code: "HN.05.0419", name: "San Nicolás" },
    { code: "HN.05.0420", name: "San Pedro de Copán" },
    { code: "HN.05.0421", name: "Santa Rita" },
    { code: "HN.05.0422", name: "Trinidad de Copán" },
    { code: "HN.05.0423", name: "Veracruz" },
  ],
  "HN.06": [
    { code: "HN.06.0501", name: "San Pedro Sula" },
    { code: "HN.06.0502", name: "Choloma" },
    { code: "HN.06.0503", name: "Omoa" },
    { code: "HN.06.0504", name: "Pimienta" },
    { code: "HN.06.0505", name: "Potrerillos" },
    { code: "HN.06.0506", name: "Puerto Cortés" },
    { code: "HN.06.0507", name: "San Antonio de Cortés" },
    { code: "HN.06.0508", name: "San Francisco de Yojoa" },
    { code: "HN.06.0509", name: "San Manuel" },
    { code: "HN.06.0510", name: "Santa Cruz de Yojoa" },
    { code: "HN.06.0511", name: "Villanueva" },
    { code: "HN.06.0512", name: "La Lima" },
  ],
  "HN.07": [
    { code: "HN.07.0701", name: "Yuscarán" },
    { code: "HN.07.0702", name: "Alauca" },
    { code: "HN.07.0703", name: "Danlí" },
    { code: "HN.07.0704", name: "El Paraíso" },
    { code: "HN.07.0705", name: "Güinope" },
    { code: "HN.07.0706", name: "Jacaleapa" },
    { code: "HN.07.0707", name: "Liure" },
    { code: "HN.07.0708", name: "Morocelí" },
    { code: "HN.07.0709", name: "Oropolí" },
    { code: "HN.07.0710", name: "Potrerillos" },
    { code: "HN.07.0711", name: "San Antonio de Flores" },
    { code: "HN.07.0712", name: "San Lucas" },
    { code: "HN.07.0713", name: "San Matías" },
    { code: "HN.07.0714", name: "Soledad" },
    { code: "HN.07.0715", name: "Teupasenti" },
    { code: "HN.07.0716", name: "Municipio de Texiguat" },
    { code: "HN.07.0717", name: "Vado Ancho" },
    { code: "HN.07.0718", name: "Yauyupe" },
    { code: "HN.07.0719", name: "Trojes" },
  ],
  "HN.08": [
    { code: "HN.08.0801", name: "Distrito Central" },
    { code: "HN.08.0802", name: "Alubarén" },
    { code: "HN.08.0803", name: "Cedros" },
    { code: "HN.08.0804", name: "Curarén" },
    { code: "HN.08.0805", name: "El Porvenir" },
    { code: "HN.08.0806", name: "Guaimaca" },
    { code: "HN.08.0807", name: "La Libertad" },
    { code: "HN.08.0808", name: "La Venta" },
    { code: "HN.08.0809", name: "Lepaterique" },
    { code: "HN.08.0810", name: "Maraita" },
    { code: "HN.08.0811", name: "Marale" },
    { code: "HN.08.0812", name: "Nueva Armenia" },
    { code: "HN.08.0813", name: "Ojojona" },
    { code: "HN.08.0814", name: "Orica" },
    { code: "HN.08.0815", name: "Reitoca" },
    { code: "HN.08.0816", name: "Sabanagrande" },
    { code: "HN.08.0817", name: "San Antonio de Oriente" },
    { code: "HN.08.0818", name: "San Buenaventura" },
    { code: "HN.08.0819", name: "San Ignacio" },
    { code: "HN.08.0820", name: "San Juan de Flores" },
    { code: "HN.08.0821", name: "San Miguelito" },
    { code: "HN.08.0822", name: "Santa Ana" },
    { code: "HN.08.0823", name: "Santa Lucía" },
    { code: "HN.08.0824", name: "Talanga" },
    { code: "HN.08.0825", name: "Tatumbla" },
    { code: "HN.08.0826", name: "Valle de Ángeles" },
    { code: "HN.08.0827", name: "Villa de San Francisco" },
    { code: "HN.08.0828", name: "Vallecillo" },
  ],
  "HN.09": [
    { code: "HN.09.0901", name: "Puerto Lempira" },
    { code: "HN.09.0902", name: "Brus Laguna" },
    { code: "HN.09.0903", name: "Ahuas" },
    { code: "HN.09.0904", name: "Juan Francisco Bulnes" },
    { code: "HN.09.0905", name: "Villeda Morales" },
    { code: "HN.09.0906", name: "Wampusirpi" },
  ],
  "HN.10": [
    { code: "HN.10.1001", name: "La Esperanza" },
    { code: "HN.10.1002", name: "Camasca" },
    { code: "HN.10.1003", name: "Colomoncagua" },
    { code: "HN.10.1004", name: "Concepción" },
    { code: "HN.10.1005", name: "Dolores" },
    { code: "HN.10.1006", name: "Intibucá" },
    { code: "HN.10.1007", name: "Jesús de Otoro" },
    { code: "HN.10.1008", name: "Magdalena" },
    { code: "HN.10.1009", name: "Masaguara" },
    { code: "HN.10.1010", name: "San Antonio" },
    { code: "HN.10.1011", name: "San Isidro" },
    { code: "HN.10.1012", name: "San Juan" },
    { code: "HN.10.1013", name: "San Marcos de la Sierra" },
    { code: "HN.10.1014", name: "San Miguelito" },
    { code: "HN.10.1015", name: "Santa Lucía" },
    { code: "HN.10.1016", name: "Yamaranguila" },
    { code: "HN.10.1017", name: "San Francisco de Opalaca" },
  ],
  "HN.11": [
    { code: "HN.11.1101", name: "Roatán" },
    { code: "HN.11.1102", name: "Guanaja" },
    { code: "HN.11.1103", name: "José Santos Guardiola" },
    { code: "HN.11.1104", name: "Utila" },
  ],
  "HN.12": [
    { code: "HN.12.1201", name: "La Paz" },
    { code: "HN.12.1202", name: "Aguanqueterique" },
    { code: "HN.12.1203", name: "Cabañas" },
    { code: "HN.12.1204", name: "Cane" },
    { code: "HN.12.1205", name: "Chinacla" },
    { code: "HN.12.1206", name: "Guajiquiro" },
    { code: "HN.12.1207", name: "Lauterique" },
    { code: "HN.12.1208", name: "Marcala" },
    { code: "HN.12.1209", name: "Mercedes de Oriente" },
    { code: "HN.12.1210", name: "Opatoro" },
    { code: "HN.12.1211", name: "San Antonio del Norte" },
    { code: "HN.12.1212", name: "San José" },
    { code: "HN.12.1213", name: "San Juan" },
    { code: "HN.12.1214", name: "San Pedro de Tutule" },
    { code: "HN.12.1215", name: "Santa Ana" },
    { code: "HN.12.1216", name: "Santa Elena" },
    { code: "HN.12.1217", name: "Santa María" },
    { code: "HN.12.1218", name: "Santiago Puringla" },
    { code: "HN.12.1219", name: "Yarula" },
  ],
  "HN.13": [
    { code: "HN.13.1301", name: "Gracias" },
    { code: "HN.13.1302", name: "Belén" },
    { code: "HN.13.1303", name: "Candelaria" },
    { code: "HN.13.1304", name: "Cololaca" },
    { code: "HN.13.1305", name: "Erandique" },
    { code: "HN.13.1306", name: "Gualcince" },
    { code: "HN.13.1307", name: "Guarita" },
    { code: "HN.13.1308", name: "La Campa" },
    { code: "HN.13.1309", name: "La Iguala" },
    { code: "HN.13.1310", name: "Las Flores" },
    { code: "HN.13.1311", name: "La Unión" },
    { code: "HN.13.1312", name: "La Virtud" },
    { code: "HN.13.1313", name: "Lepaera" },
    { code: "HN.13.1314", name: "Mapulaca" },
    { code: "HN.13.1315", name: "Piraera" },
    { code: "HN.13.1316", name: "San Andrés" },
    { code: "HN.13.1317", name: "San Francisco" },
    { code: "HN.13.1318", name: "San Juan Guarita" },
    { code: "HN.13.1319", name: "San Manuel Colohete" },
    { code: "HN.13.1320", name: "San Rafael" },
    { code: "HN.13.1321", name: "San Sebastián" },
    { code: "HN.13.1322", name: "Santa Cruz" },
    { code: "HN.13.1323", name: "Talgua" },
    { code: "HN.13.1324", name: "Tambla" },
    { code: "HN.13.1325", name: "Tomalá" },
    { code: "HN.13.1326", name: "Valladolid" },
    { code: "HN.13.1327", name: "Virginia" },
    { code: "HN.13.1328", name: "San Marcos de Caiquin" },
  ],
  "HN.14": [
    { code: "HN.14.1401", name: "Nueva Ocotepeque" },
    { code: "HN.14.1402", name: "Belén Gualcho" },
    { code: "HN.14.1403", name: "Concepción" },
    { code: "HN.14.1404", name: "Dolores Merendón" },
    { code: "HN.14.1405", name: "Fraternidad" },
    { code: "HN.14.1406", name: "La Encarnación" },
    { code: "HN.14.1407", name: "La Labor" },
    { code: "HN.14.1408", name: "Lucerna" },
    { code: "HN.14.1409", name: "Mercedes" },
    { code: "HN.14.1410", name: "San Fernando" },
    { code: "HN.14.1411", name: "San Francisco del Valle" },
    { code: "HN.14.1412", name: "San Jorge" },
    { code: "HN.14.1413", name: "San Marcos" },
    { code: "HN.14.1414", name: "Santa Fe" },
    { code: "HN.14.1415", name: "Sensenti" },
    { code: "HN.14.1416", name: "Sinuapa" },
  ],
  "HN.15": [
    { code: "HN.15.1501", name: "Juticalpa" },
    { code: "HN.15.1502", name: "Campamento" },
    { code: "HN.15.1503", name: "Catacamas" },
    { code: "HN.15.1504", name: "Concordia" },
    { code: "HN.15.1505", name: "Dulce Nombre de Culmí" },
    { code: "HN.15.1506", name: "El Rosario" },
    { code: "HN.15.1507", name: "Esquipulas del Norte" },
    { code: "HN.15.1508", name: "Gualaco" },
    { code: "HN.15.1509", name: "Guarizama" },
    { code: "HN.15.1510", name: "Guata" },
    { code: "HN.15.1511", name: "Guayape" },
    { code: "HN.15.1512", name: "Jano" },
    { code: "HN.15.1513", name: "La Unión" },
    { code: "HN.15.1514", name: "Mangulile" },
    { code: "HN.15.1515", name: "Manto" },
    { code: "HN.15.1516", name: "Salamá" },
    { code: "HN.15.1517", name: "San Esteban" },
    { code: "HN.15.1518", name: "San Francisco de Becerra" },
    { code: "HN.15.1519", name: "Municipio de San Francisco de La Paz" },
    { code: "HN.15.1520", name: "Santa María del Real" },
    { code: "HN.15.1521", name: "Silca" },
    { code: "HN.15.1522", name: "Yocón" },
    { code: "HN.15.1523", name: "Patuca" },
  ],
  "HN.16": [
    { code: "HN.16.1601", name: "Santa Bárbara" },
    { code: "HN.16.1602", name: "Arada" },
    { code: "HN.16.1603", name: "Atima" },
    { code: "HN.16.1604", name: "Azacualpa" },
    { code: "HN.16.1605", name: "Ceguaca" },
    { code: "HN.16.1606", name: "Concepción del Norte" },
    { code: "HN.16.1607", name: "Concepción del Sur" },
    { code: "HN.16.1608", name: "Chinda" },
    { code: "HN.16.1609", name: "El Níspero" },
    { code: "HN.16.1610", name: "Gualala" },
    { code: "HN.16.1611", name: "Ilama" },
    { code: "HN.16.1612", name: "Macuelizo" },
    { code: "HN.16.1613", name: "Naranjito" },
    { code: "HN.16.1614", name: "Nuevo Celilac" },
    { code: "HN.16.1615", name: "Petoa" },
    { code: "HN.16.1616", name: "Protección" },
    { code: "HN.16.1617", name: "Quimistán" },
    { code: "HN.16.1618", name: "San Francisco de Ojuera" },
    { code: "HN.16.1619", name: "San José de Colinas" },
    { code: "HN.16.1620", name: "San Luis" },
    { code: "HN.16.1621", name: "San Marcos" },
    { code: "HN.16.1622", name: "San Nicolás" },
    { code: "HN.16.1623", name: "San Pedro Zacapa" },
    { code: "HN.16.1624", name: "San Vicente Centenario" },
    { code: "HN.16.1625", name: "Santa Rita" },
    { code: "HN.16.1626", name: "Trinidad" },
    { code: "HN.16.1627", name: "Las Vegas" },
    { code: "HN.16.1628", name: "Nueva Frontera" },
  ],
  "HN.17": [
    { code: "HN.17.1701", name: "Nacaome" },
    { code: "HN.17.1702", name: "Alianza" },
    { code: "HN.17.1703", name: "Amapala" },
    { code: "HN.17.1704", name: "Aramecina" },
    { code: "HN.17.1705", name: "Caridad" },
    { code: "HN.17.1706", name: "Goascorán" },
    { code: "HN.17.1707", name: "Langue" },
    { code: "HN.17.1708", name: "San Francisco de Coray" },
    { code: "HN.17.1709", name: "San Lorenzo" },
  ],
  "HN.18": [
    { code: "HN.18.1801", name: "Yoro" },
    { code: "HN.18.1802", name: "Arenal" },
    { code: "HN.18.1803", name: "El Negrito" },
    { code: "HN.18.1804", name: "El Progreso" },
    { code: "HN.18.1805", name: "Jocón" },
    { code: "HN.18.1806", name: "Morazán" },
    { code: "HN.18.1807", name: "Olanchito" },
    { code: "HN.18.1808", name: "Santa Rita" },
    { code: "HN.18.1809", name: "Sulaco" },
    { code: "HN.18.1810", name: "Victoria" },
    { code: "HN.18.1811", name: "Yorito" },
  ],
  "HR.01": [
    { code: "HR.01.11049398", name: "Berek" },
    { code: "HR.01.11049399", name: "Dežanovac" },
    { code: "HR.01.11049403", name: "Hercegovac" },
    { code: "HR.01.11049406", name: "Ivanska" },
    { code: "HR.01.11049413", name: "Kapela" },
    { code: "HR.01.11049414", name: "Končanica" },
    { code: "HR.01.11049415", name: "Nova Rača" },
    { code: "HR.01.11049416", name: "Rovišće" },
    { code: "HR.01.11049417", name: "Severin" },
    { code: "HR.01.11049418", name: "Sirač" },
    { code: "HR.01.11049419", name: "Šandrovac" },
    { code: "HR.01.11049420", name: "Štefanje" },
    { code: "HR.01.11049421", name: "Velika Pisanica" },
    { code: "HR.01.11049422", name: "Velika Trnovitica" },
    { code: "HR.01.11049424", name: "Veliki Grđevac" },
    { code: "HR.01.11049426", name: "Veliko Trojstvo" },
    { code: "HR.01.11049428", name: "Zrinski Topolovac" },
    { code: "HR.01.11055019", name: "Đulovac" },
    { code: "HR.01.3199514", name: "Grad Grubišno Polje" },
    { code: "HR.01.3200709", name: "Grad Garešnica" },
    { code: "HR.01.3202183", name: "Grad Daruvar" },
    { code: "HR.01.3202819", name: "Grad Čazma" },
    { code: "HR.01.3203981", name: "Grad Bjelovar" },
  ],
  "HR.02": [
    { code: "HR.02.11049480", name: "Bebrina" },
    { code: "HR.02.11049481", name: "Brodski Stupnik" },
    { code: "HR.02.11049482", name: "Bukovlje" },
    { code: "HR.02.11049489", name: "Cernik" },
    { code: "HR.02.11049490", name: "Davor" },
    { code: "HR.02.11049491", name: "Donji Andrijevci" },
    { code: "HR.02.11049492", name: "Dragalić" },
    { code: "HR.02.11049493", name: "Garčin" },
    { code: "HR.02.11049494", name: "Gornja Vrba" },
    { code: "HR.02.11049495", name: "Gornji Bogićevci" },
    { code: "HR.02.11049496", name: "Gundinci" },
    { code: "HR.02.11049497", name: "Klakar" },
    { code: "HR.02.11049498", name: "Nova Kapela" },
    { code: "HR.02.11049499", name: "Okučani" },
    { code: "HR.02.11049500", name: "Oprisavci" },
    { code: "HR.02.11049501", name: "Oriovac" },
    { code: "HR.02.11049502", name: "Podcrkavlje" },
    { code: "HR.02.11049503", name: "Rešetari" },
    { code: "HR.02.11049504", name: "Sibinj" },
    { code: "HR.02.11049505", name: "Sikirevci" },
    { code: "HR.02.11049506", name: "Slavonski Šamac" },
    { code: "HR.02.11049507", name: "Stara Gradiška" },
    { code: "HR.02.11049508", name: "Staro Petrovo Selo" },
    { code: "HR.02.11049509", name: "Velika Kopanica" },
    { code: "HR.02.11049510", name: "Vrbje" },
    { code: "HR.02.11049511", name: "Vrpolje" },
    { code: "HR.02.3190585", name: "Grad Slavonski Brod" },
    { code: "HR.02.3194448", name: "Grad Nova Gradiška" },
  ],
  "HR.03": [
    { code: "HR.03.11054489", name: "Blato" },
    { code: "HR.03.11054957", name: "Župa dubrovačka" },
    { code: "HR.03.11054958", name: "Zažablje" },
    { code: "HR.03.11054959", name: "Vela Luka" },
    { code: "HR.03.11054960", name: "Trpanj" },
    { code: "HR.03.11054961", name: "Ston" },
    { code: "HR.03.11054962", name: "Smokvica" },
    { code: "HR.03.11054963", name: "Slivno" },
    { code: "HR.03.11054964", name: "Pojezerje" },
    { code: "HR.03.11054966", name: "Orebić" },
    { code: "HR.03.11054967", name: "Opuzen" },
    { code: "HR.03.11054968", name: "Mljet" },
    { code: "HR.03.11054969", name: "Metković" },
    { code: "HR.03.11054970", name: "Lumbarda" },
    { code: "HR.03.11054971", name: "Kula Norinska" },
    { code: "HR.03.11054972", name: "Konavle" },
    { code: "HR.03.11054973", name: "Janjina" },
    { code: "HR.03.11055009", name: "Dubrovačko primorje" },
    { code: "HR.03.3193146", name: "Grad Ploče" },
    { code: "HR.03.3196753", name: "Općina Lastovo" },
    { code: "HR.03.3197709", name: "Grad Korčula" },
    { code: "HR.03.7577034", name: "Grad Dubrovnik" },
  ],
  "HR.04": [
    { code: "HR.04.11054745", name: "Bale-Valle" },
    { code: "HR.04.11054746", name: "Barban" },
    { code: "HR.04.11054747", name: "Brtonigla-Verteneglio" },
    { code: "HR.04.11054748", name: "Buje-Buie" },
    { code: "HR.04.11054749", name: "Cerovlje" },
    { code: "HR.04.11054750", name: "Fažana-Fasana" },
    { code: "HR.04.11054751", name: "Funtana-Fontane" },
    { code: "HR.04.11054790", name: "Gračišće" },
    { code: "HR.04.11054800", name: "Grožnjan-Grisignana" },
    { code: "HR.04.11054801", name: "Kanfanar" },
    { code: "HR.04.11054804", name: "Karojba" },
    { code: "HR.04.11054805", name: "Kršan" },
    { code: "HR.04.11054806", name: "Ližnjan-Lisignano" },
    { code: "HR.04.11054807", name: "Lupoglav" },
    { code: "HR.04.11054808", name: "Marčana" },
    { code: "HR.04.11054809", name: "Medulin" },
    { code: "HR.04.11054810", name: "Motovun-Montona" },
    { code: "HR.04.11054811", name: "Novigrad-Cittanova" },
    { code: "HR.04.11054812", name: "Oprtalj-Portole" },
    { code: "HR.04.11054813", name: "Pićan" },
    { code: "HR.04.11054814", name: "Poreč-Parenzo" },
    { code: "HR.04.11054815", name: "Pula-Pola" },
    { code: "HR.04.11054816", name: "Raša" },
    { code: "HR.04.11054817", name: "Rovinj-Rovigno" },
    { code: "HR.04.11054818", name: "Sveti Lovreč" },
    { code: "HR.04.11054819", name: "Sveti Petar u Šumi" },
    { code: "HR.04.11054820", name: "Svetvinčenat" },
    { code: "HR.04.11054821", name: "Tinjan" },
    { code: "HR.04.11054822", name: "Umag-Umago" },
    { code: "HR.04.11054824", name: "Višnjan-Visignano" },
    { code: "HR.04.11054825", name: "Vižinada-Visinada" },
    { code: "HR.04.11054827", name: "Vodnjan-Dignano" },
    { code: "HR.04.11054828", name: "Vrsar-Orsera" },
    { code: "HR.04.11054829", name: "Žminj" },
    { code: "HR.04.11054952", name: "Kaštelir-Labinci" },
    { code: "HR.04.11072234", name: "Sveta Nedelja" },
    { code: "HR.04.11072413", name: "Tar-Vabriga-Torre Abrega" },
    { code: "HR.04.11129767", name: "Grad Umag" },
    { code: "HR.04.11129768", name: "Grad Vodnjan" },
    { code: "HR.04.11129784", name: "Općina Vižinada" },
    { code: "HR.04.11129785", name: "Općina Višnjan" },
    { code: "HR.04.11129787", name: "Općina Lanišće" },
    { code: "HR.04.3191516", name: "Grad Rovinj" },
    { code: "HR.04.3192222", name: "Grad Pula" },
    { code: "HR.04.3192696", name: "Grad Poreč" },
    { code: "HR.04.3193560", name: "Grad Pazin" },
    { code: "HR.04.3196833", name: "Grad Labin" },
    { code: "HR.04.3202941", name: "Grad Buzet" },
    { code: "HR.04.3203088", name: "Grad Buje" },
  ],
  "HR.05": [
    { code: "HR.05.11049266", name: "Barilović" },
    { code: "HR.05.11049267", name: "Bosiljevo" },
    { code: "HR.05.11049268", name: "Cetingrad" },
    { code: "HR.05.11049269", name: "Draganić" },
    { code: "HR.05.11049270", name: "Generalski Stol" },
    { code: "HR.05.11049271", name: "Josipdol" },
    { code: "HR.05.11049272", name: "Kamanje" },
    { code: "HR.05.11049273", name: "Krnjak" },
    { code: "HR.05.11049275", name: "Lasinja" },
    { code: "HR.05.11049276", name: "Netretić" },
    { code: "HR.05.11049277", name: "Plaški" },
    { code: "HR.05.11049278", name: "Rakovica" },
    { code: "HR.05.11049279", name: "Ribnik" },
    { code: "HR.05.11049280", name: "Saborsko" },
    { code: "HR.05.11049281", name: "Tounj" },
    { code: "HR.05.11049283", name: "Žakanje" },
    { code: "HR.05.3187450", name: "Općina Vojnić" },
    { code: "HR.05.3190522", name: "Grad Slunj" },
    { code: "HR.05.3193753", name: "Grad Ozalj" },
    { code: "HR.05.3194182", name: "Grad Ogulin" },
    { code: "HR.05.3198257", name: "Grad Karlovac" },
    { code: "HR.05.3201029", name: "Grad Duga Resa" },
  ],
  "HR.06": [
    { code: "HR.06.11049322", name: "Drnje" },
    { code: "HR.06.11049323", name: "Ferdinandovac" },
    { code: "HR.06.11049324", name: "Gola" },
    { code: "HR.06.11049326", name: "Gornja Rijeka" },
    { code: "HR.06.11049369", name: "Hlebine" },
    { code: "HR.06.11049370", name: "Kalinovac" },
    { code: "HR.06.11049372", name: "Kalnik" },
    { code: "HR.06.11049373", name: "Kloštar Podravski" },
    { code: "HR.06.11049374", name: "Koprivnički Bregi" },
    { code: "HR.06.11049375", name: "Koprivnički Ivanec" },
    { code: "HR.06.11049376", name: "Legrad" },
    { code: "HR.06.11049377", name: "Molve" },
    { code: "HR.06.11049378", name: "Novigrad Podravski" },
    { code: "HR.06.11049380", name: "Novo Virje" },
    { code: "HR.06.11049381", name: "Peteranec" },
    { code: "HR.06.11049383", name: "Podravske Sesvete" },
    { code: "HR.06.11049389", name: "Rasinja" },
    { code: "HR.06.11049391", name: "Sokolovac" },
    { code: "HR.06.11049393", name: "Sveti Ivan Žabno" },
    { code: "HR.06.11049395", name: "Sveti Petar Orehovec" },
    { code: "HR.06.11049397", name: "Virje" },
    { code: "HR.06.11055014", name: "Đelekovec" },
    { code: "HR.06.11055015", name: "Đurđevac" },
    { code: "HR.06.3197228", name: "Grad Križevci" },
    { code: "HR.06.3197726", name: "Grad Koprivnica" },
    { code: "HR.06.3200960", name: "Grad Đurđevac" },
  ],
  "HR.07": [
    { code: "HR.07.11049007", name: "Bedekovčina" },
    { code: "HR.07.11049008", name: "Budinščina" },
    { code: "HR.07.11049009", name: "Desinić" },
    { code: "HR.07.11049010", name: "Gornja Stubica" },
    { code: "HR.07.11049011", name: "Hrašćina" },
    { code: "HR.07.11049012", name: "Hum na Sutli" },
    { code: "HR.07.11049013", name: "Jesenje" },
    { code: "HR.07.11049014", name: "Konjščina" },
    { code: "HR.07.11049188", name: "Kraljevec na Sutli" },
    { code: "HR.07.11049189", name: "Krapinske Toplice" },
    { code: "HR.07.11049190", name: "Kumrovec" },
    { code: "HR.07.11049191", name: "Lobor" },
    { code: "HR.07.11049192", name: "Mače" },
    { code: "HR.07.11049193", name: "Mihovljan" },
    { code: "HR.07.11049194", name: "Novi Golubovec" },
    { code: "HR.07.11049195", name: "Petrovsko" },
    { code: "HR.07.11049212", name: "Radoboj" },
    { code: "HR.07.11049213", name: "Sveti Križ Začretje" },
    { code: "HR.07.11049214", name: "Stubičke Toplice" },
    { code: "HR.07.11049218", name: "Tuhelj" },
    { code: "HR.07.11049219", name: "Veliko Trgovišće" },
    { code: "HR.07.11049220", name: "Zagorska Sela" },
    { code: "HR.07.11049222", name: "Zlatar Bistrica" },
    { code: "HR.07.11054890", name: "Marija Bistrica" },
    { code: "HR.07.11054895", name: "Oroslavje" },
    { code: "HR.07.11054900", name: "Pregrada" },
    { code: "HR.07.11055011", name: "Đurmanec" },
    { code: "HR.07.3186405", name: "Grad Zlatar" },
    { code: "HR.07.3186983", name: "Grad Zabok" },
    { code: "HR.07.3197366", name: "Grad Krapina" },
    { code: "HR.07.3198102", name: "Grad Klanjec" },
    { code: "HR.07.3201620", name: "Grad Donja Stubica" },
  ],
  "HR.08": [
    { code: "HR.08.11049284", name: "Brinje" },
    { code: "HR.08.11049285", name: "Donji Lapac" },
    { code: "HR.08.11049286", name: "Gospić" },
    { code: "HR.08.11049287", name: "Karlobag" },
    { code: "HR.08.11049288", name: "Lovinac" },
    { code: "HR.08.11049289", name: "Novalja" },
    { code: "HR.08.11049290", name: "Otočac" },
    { code: "HR.08.11049291", name: "Perušić" },
    { code: "HR.08.11049292", name: "Plitvička Jezera" },
    { code: "HR.08.11049293", name: "Senj" },
    { code: "HR.08.11049294", name: "Udbina" },
    { code: "HR.08.11049295", name: "Vrhovine" },
  ],
  "HR.09": [
    { code: "HR.09.11054830", name: "Belica" },
    { code: "HR.09.11054832", name: "Dekanovec" },
    { code: "HR.09.11054834", name: "Domašinec" },
    { code: "HR.09.11054835", name: "Donja Dubrava" },
    { code: "HR.09.11054836", name: "Donji Kraljevec" },
    { code: "HR.09.11054837", name: "Donji Vidovec" },
    { code: "HR.09.11054838", name: "Goričan" },
    { code: "HR.09.11054839", name: "Gornji Mihaljevec" },
    { code: "HR.09.11054840", name: "Kotoriba" },
    { code: "HR.09.11054845", name: "Mala Subotica" },
    { code: "HR.09.11054846", name: "Mursko Središće" },
    { code: "HR.09.11054847", name: "Nedelišće" },
    { code: "HR.09.11054848", name: "Orehovica" },
    { code: "HR.09.11054849", name: "Podturen" },
    { code: "HR.09.11054850", name: "Prelog" },
    { code: "HR.09.11054852", name: "Pribislavec" },
    { code: "HR.09.11054853", name: "Selnica" },
    { code: "HR.09.11054879", name: "Strahoninec" },
    { code: "HR.09.11054880", name: "Sveta Marija" },
    { code: "HR.09.11054883", name: "Sveti Juraj na Bregu" },
    { code: "HR.09.11054884", name: "Sveti Martin na Muri" },
    { code: "HR.09.11054885", name: "Šenkovec" },
    { code: "HR.09.11054886", name: "Štrigova" },
    { code: "HR.09.11054887", name: "Vratišinec" },
    { code: "HR.09.3202887", name: "Grad Čakovec" },
  ],
  "HR.10": [
    { code: "HR.10.11054390", name: "Antunovac" },
    { code: "HR.10.11054391", name: "Belišće" },
    { code: "HR.10.11054392", name: "Bilje" },
    { code: "HR.10.11054393", name: "Bizovac" },
    { code: "HR.10.11054394", name: "Čeminac" },
    { code: "HR.10.11054395", name: "Čepin" },
    { code: "HR.10.11054454", name: "Darda" },
    { code: "HR.10.11054455", name: "Donja Motičina" },
    { code: "HR.10.11054456", name: "Draž" },
    { code: "HR.10.11054458", name: "Drenje" },
    { code: "HR.10.11054459", name: "Đakovo" },
    { code: "HR.10.11054461", name: "Erdut" },
    { code: "HR.10.11054464", name: "Ernestinovo" },
    { code: "HR.10.11054465", name: "Feričanci" },
    { code: "HR.10.11054467", name: "Gorjani" },
    { code: "HR.10.11054468", name: "Jagodnjak" },
    { code: "HR.10.11054469", name: "Kneževi Vinogradi" },
    { code: "HR.10.11054470", name: "Koška" },
    { code: "HR.10.11054471", name: "Levanjska Varoš" },
    { code: "HR.10.11054472", name: "Magadenovac" },
    { code: "HR.10.11054473", name: "Marijanci" },
    { code: "HR.10.11054474", name: "Petlovac" },
    { code: "HR.10.11054475", name: "Petrijevci" },
    { code: "HR.10.11054476", name: "Podgorač" },
    { code: "HR.10.11054477", name: "Podravska Moslavina" },
    { code: "HR.10.11054478", name: "Popovac" },
    { code: "HR.10.11054479", name: "Punitovci" },
    { code: "HR.10.11054480", name: "Semeljci" },
    { code: "HR.10.11054481", name: "Strizivojna" },
    { code: "HR.10.11054482", name: "Šodolovci" },
    { code: "HR.10.11054483", name: "Trnava" },
    { code: "HR.10.11054484", name: "Viljevo" },
    { code: "HR.10.11054485", name: "Viškovci" },
    { code: "HR.10.11054486", name: "Vladislavci" },
    { code: "HR.10.11054488", name: "Vuka" },
    { code: "HR.10.11055020", name: "Đurđenovac" },
    { code: "HR.10.11055021", name: "Satnica Đakovačka" },
    { code: "HR.10.3188394", name: "Grad Valpovo" },
    { code: "HR.10.3193934", name: "Grad Osijek" },
    { code: "HR.10.3194580", name: "Grad Našice" },
    { code: "HR.10.3201431", name: "Grad Donji Miholjac" },
    { code: "HR.10.3202219", name: "Grad Đakovo" },
    { code: "HR.10.3204319", name: "Grad Beli Manastir" },
  ],
  "HR.11": [
    { code: "HR.11.11049472", name: "Brestovac" },
    { code: "HR.11.11049473", name: "Čaglin" },
    { code: "HR.11.11049474", name: "Jakšić" },
    { code: "HR.11.11049475", name: "Kaptol" },
    { code: "HR.11.11049476", name: "Kutjevo" },
    { code: "HR.11.11049477", name: "Lipik" },
    { code: "HR.11.11049478", name: "Pleternica" },
    { code: "HR.11.11049479", name: "Velika" },
    { code: "HR.11.3190588", name: "Grad Požega" },
    { code: "HR.11.3193705", name: "Grad Pakrac" },
  ],
  "HR.12": [
    { code: "HR.12.11049429", name: "Bakar" },
    { code: "HR.12.11049430", name: "Baška" },
    { code: "HR.12.11049431", name: "Brod Moravice" },
    { code: "HR.12.11049432", name: "Čavle" },
    { code: "HR.12.11049433", name: "Dobrinj" },
    { code: "HR.12.11049434", name: "Fužine" },
    { code: "HR.12.11049435", name: "Jelenje" },
    { code: "HR.12.11049436", name: "Kastav" },
    { code: "HR.12.11049437", name: "Klana" },
    { code: "HR.12.11049438", name: "Kostrena" },
    { code: "HR.12.11049439", name: "Lokve" },
    { code: "HR.12.11049440", name: "Lopar" },
    { code: "HR.12.11049441", name: "Lovran" },
    { code: "HR.12.11049442", name: "Mali Lošinj" },
    { code: "HR.12.11049443", name: "Matulji" },
    { code: "HR.12.11049445", name: "Mošćenička Draga" },
    { code: "HR.12.11049446", name: "Mrkopalj" },
    { code: "HR.12.11049447", name: "Novi Vinodolski" },
    { code: "HR.12.11049448", name: "Omišalj" },
    { code: "HR.12.11049449", name: "Punat" },
    { code: "HR.12.11049450", name: "Rab" },
    { code: "HR.12.11049451", name: "Ravna Gora" },
    { code: "HR.12.11049452", name: "Skrad" },
    { code: "HR.12.11049453", name: "Viškovo" },
    { code: "HR.12.11049454", name: "Vrbnik" },
    { code: "HR.12.11054902", name: "Cres" },
    { code: "HR.12.11054903", name: "Kraljevica" },
    { code: "HR.12.11072235", name: "Vinodolska općina" },
    { code: "HR.12.11072236", name: "Malinska-Dubašnica" },
    { code: "HR.12.3187256", name: "Grad Vrbovsko" },
    { code: "HR.12.3191647", name: "Grad Rijeka" },
    { code: "HR.12.3194097", name: "Grad Opatija" },
    { code: "HR.12.3197207", name: "Grad Krk" },
    { code: "HR.12.3202102", name: "Grad Delnice" },
    { code: "HR.12.3202506", name: "Grad Crikvenica" },
    { code: "HR.12.3202931", name: "Grad Čabar" },
  ],
  "HR.13": [
    { code: "HR.13.11054512", name: "Biskupija" },
    { code: "HR.13.11054513", name: "Civljane" },
    { code: "HR.13.11054514", name: "Kijevo" },
    { code: "HR.13.11054515", name: "Kistanje" },
    { code: "HR.13.11054516", name: "Knin" },
    { code: "HR.13.11054517", name: "Pirovac" },
    { code: "HR.13.11054518", name: "Murter-Kornati" },
    { code: "HR.13.11054519", name: "Primošten" },
    { code: "HR.13.11054520", name: "Ružić" },
    { code: "HR.13.11054521", name: "Skradin" },
    { code: "HR.13.11054522", name: "Tisno" },
    { code: "HR.13.11054523", name: "Tribunj" },
    { code: "HR.13.11054524", name: "Unešić" },
    { code: "HR.13.11054525", name: "Vodice" },
    { code: "HR.13.11054956", name: "Bilice" },
    { code: "HR.13.11055022", name: "Ervenik" },
    { code: "HR.13.11055025", name: "Promina" },
    { code: "HR.13.3190938", name: "Grad Šibenik" },
    { code: "HR.13.3201161", name: "Grad Drniš" },
    { code: "HR.13.9076750", name: "Rogoznica Općina" },
  ],
  "HR.14": [
    { code: "HR.14.11049225", name: "Donji Kukuruzari" },
    { code: "HR.14.11049226", name: "Hrvatska Dubica" },
    { code: "HR.14.11049227", name: "Jasenovac" },
    { code: "HR.14.11049228", name: "Lekenik" },
    { code: "HR.14.11049229", name: "Lipovljani" },
    { code: "HR.14.11049230", name: "Majur" },
    { code: "HR.14.11049231", name: "Martinska Ves" },
    { code: "HR.14.11049232", name: "Popovača" },
    { code: "HR.14.11049233", name: "Sunja" },
    { code: "HR.14.11049234", name: "Topusko" },
    { code: "HR.14.11049235", name: "Velika Ludina" },
    { code: "HR.14.3187231", name: "Općina Gvozd" },
    { code: "HR.14.3190812", name: "Grad Sisak" },
    { code: "HR.14.3193419", name: "Grad Petrinja" },
    { code: "HR.14.3194318", name: "Grad Novska" },
    { code: "HR.14.3196862", name: "Grad Kutina" },
    { code: "HR.14.3197593", name: "Grad Hrvatska Kostajnica" },
    { code: "HR.14.3200597", name: "Grad Glina" },
    { code: "HR.14.3200915", name: "Općina Dvor" },
  ],
  "HR.15": [
    { code: "HR.15.11054557", name: "Baška Voda" },
    { code: "HR.15.11054558", name: "Bol" },
    { code: "HR.15.11054559", name: "Brela" },
    { code: "HR.15.11054560", name: "Cista Provo" },
    { code: "HR.15.11054601", name: "Dicmo" },
    { code: "HR.15.11054602", name: "Dugopolje" },
    { code: "HR.15.11054603", name: "Gradac" },
    { code: "HR.15.11054604", name: "Hrvace" },
    { code: "HR.15.11054605", name: "Jelsa" },
    { code: "HR.15.11054606", name: "Kaštela" },
    { code: "HR.15.11054607", name: "Klis" },
    { code: "HR.15.11054608", name: "Komiža" },
    { code: "HR.15.11054609", name: "Lećevica" },
    { code: "HR.15.11054610", name: "Lokvičići" },
    { code: "HR.15.11054611", name: "Lovreć" },
    { code: "HR.15.11054612", name: "Marina" },
    { code: "HR.15.11054613", name: "Milna" },
    { code: "HR.15.11054614", name: "Muć" },
    { code: "HR.15.11054615", name: "Nerežišća" },
    { code: "HR.15.11054616", name: "Okrug" },
    { code: "HR.15.11054617", name: "Podbablje" },
    { code: "HR.15.11054618", name: "Podgora" },
    { code: "HR.15.11054619", name: "Podstrana" },
    { code: "HR.15.11054620", name: "Postira" },
    { code: "HR.15.11054621", name: "Prgomet" },
    { code: "HR.15.11054622", name: "Primorski Dolac" },
    { code: "HR.15.11054623", name: "Proložac" },
    { code: "HR.15.11054624", name: "Pučišća" },
    { code: "HR.15.11054625", name: "Runovići" },
    { code: "HR.15.11054627", name: "Seget" },
    { code: "HR.15.11054631", name: "Selca" },
    { code: "HR.15.11054720", name: "Solin" },
    { code: "HR.15.11054721", name: "Stari Grad" },
    { code: "HR.15.11054722", name: "Sućuraj" },
    { code: "HR.15.11054727", name: "Sutivan" },
    { code: "HR.15.11054733", name: "Šestanovac" },
    { code: "HR.15.11054737", name: "Šolta" },
    { code: "HR.15.11054739", name: "Trilj" },
    { code: "HR.15.11054740", name: "Tučepi" },
    { code: "HR.15.11054741", name: "Vrlika" },
    { code: "HR.15.11054742", name: "Zadvarje" },
    { code: "HR.15.11054743", name: "Zagvozd" },
    { code: "HR.15.11054744", name: "Zmijavci" },
    { code: "HR.15.11054954", name: "Otok" },
    { code: "HR.15.3187229", name: "Grad Vrgorac" },
    { code: "HR.15.3187684", name: "Grad Vis" },
    { code: "HR.15.3188762", name: "Grad Trogir" },
    { code: "HR.15.3190259", name: "Grad Split" },
    { code: "HR.15.3190864", name: "Grad Sinj" },
    { code: "HR.15.3194113", name: "Grad Omiš" },
    { code: "HR.15.3195888", name: "Grad Makarska" },
    { code: "HR.15.3199110", name: "Grad Imotski" },
    { code: "HR.15.3199178", name: "Grad Hvar" },
    { code: "HR.15.3203595", name: "Grad Supetar" },
    { code: "HR.15.9076752", name: "Dugi Rat Općina" },
  ],
  "HR.16": [
    { code: "HR.16.11049296", name: "Bednja" },
    { code: "HR.16.11049297", name: "Beretinec" },
    { code: "HR.16.11049298", name: "Breznica" },
    { code: "HR.16.11049299", name: "Breznički Hum" },
    { code: "HR.16.11049300", name: "Cestica" },
    { code: "HR.16.11049301", name: "Donja Voća" },
    { code: "HR.16.11049302", name: "Gornji Kneginec" },
    { code: "HR.16.11049303", name: "Jalžabet" },
    { code: "HR.16.11049306", name: "Klenovnik" },
    { code: "HR.16.11049307", name: "Ljubešćica" },
    { code: "HR.16.11049308", name: "Lepoglava" },
    { code: "HR.16.11049309", name: "Mali Bukovec" },
    { code: "HR.16.11049310", name: "Martijanec" },
    { code: "HR.16.11049311", name: "Maruševec" },
    { code: "HR.16.11049312", name: "Petrijanec" },
    { code: "HR.16.11049313", name: "Sračinec" },
    { code: "HR.16.11049314", name: "Sveti Ilija" },
    { code: "HR.16.11049315", name: "Trnovec Bartolovečki" },
    { code: "HR.16.11049316", name: "Varaždinske Toplice" },
    { code: "HR.16.11049317", name: "Veliki Bukovec" },
    { code: "HR.16.11049318", name: "Vidovec" },
    { code: "HR.16.11049320", name: "Vinica" },
    { code: "HR.16.11049321", name: "Visoko" },
    { code: "HR.16.11055013", name: "Sveti Đurđ" },
    { code: "HR.16.3188382", name: "Grad Varaždin" },
    { code: "HR.16.3194366", name: "Grad Novi Marof" },
    { code: "HR.16.3196119", name: "Grad Ludbreg" },
    { code: "HR.16.3199075", name: "Grad Ivanec" },
  ],
  "HR.17": [
    { code: "HR.17.11049455", name: "Crnac" },
    { code: "HR.17.11049456", name: "Čačinci" },
    { code: "HR.17.11049457", name: "Čađavica" },
    { code: "HR.17.11049459", name: "Gradina" },
    { code: "HR.17.11049462", name: "Lukač" },
    { code: "HR.17.11049464", name: "Mikleuš" },
    { code: "HR.17.11049465", name: "Nova Bukovica" },
    { code: "HR.17.11049466", name: "Pitomača" },
    { code: "HR.17.11049467", name: "Sopje" },
    { code: "HR.17.11049468", name: "Suhopolje" },
    { code: "HR.17.11049469", name: "Špišić Bukovica" },
    { code: "HR.17.11049470", name: "Voćin" },
    { code: "HR.17.11049471", name: "Zdenci" },
    { code: "HR.17.3187693", name: "Grad Virovitica" },
    { code: "HR.17.3192931", name: "Grad Slatina" },
    { code: "HR.17.3194063", name: "Grad Orahovica" },
  ],
  "HR.18": [
    { code: "HR.18.11054526", name: "Andrijaševci" },
    { code: "HR.18.11054527", name: "Babina Greda" },
    { code: "HR.18.11054529", name: "Bogdanovci" },
    { code: "HR.18.11054530", name: "Borovo" },
    { code: "HR.18.11054531", name: "Bošnjaci" },
    { code: "HR.18.11054533", name: "Cerna" },
    { code: "HR.18.11054534", name: "Drenovci" },
    { code: "HR.18.11054535", name: "Gradište" },
    { code: "HR.18.11054536", name: "Gunja" },
    { code: "HR.18.11054537", name: "Ilok" },
    { code: "HR.18.11054538", name: "Ivankovo" },
    { code: "HR.18.11054539", name: "Jarmina" },
    { code: "HR.18.11054540", name: "Lovas" },
    { code: "HR.18.11054541", name: "Markušica" },
    { code: "HR.18.11054542", name: "Negoslavci" },
    { code: "HR.18.11054543", name: "Nijemci" },
    { code: "HR.18.11054545", name: "Nuštar" },
    { code: "HR.18.11054546", name: "Stari Jankovci" },
    { code: "HR.18.11054547", name: "Stari Mikanovci" },
    { code: "HR.18.11054549", name: "Štitar" },
    { code: "HR.18.11054550", name: "Tompojevci" },
    { code: "HR.18.11054551", name: "Tordinci" },
    { code: "HR.18.11054552", name: "Tovarnik" },
    { code: "HR.18.11054553", name: "Trpinja" },
    { code: "HR.18.11054554", name: "Vođinci" },
    { code: "HR.18.11054556", name: "Vrbanja" },
    { code: "HR.18.11054955", name: "Otok" },
    { code: "HR.18.11072232", name: "Privlaka" },
    { code: "HR.18.3186293", name: "Grad Županja" },
    { code: "HR.18.3187046", name: "Grad Vukovar" },
    { code: "HR.18.3187718", name: "Grad Vinkovci" },
  ],
  "HR.19": [
    { code: "HR.19.11049512", name: "Benkovac" },
    { code: "HR.19.11049513", name: "Bibinje" },
    { code: "HR.19.11049514", name: "Galovac" },
    { code: "HR.19.11054319", name: "Gračac" },
    { code: "HR.19.11054321", name: "Jasenice" },
    { code: "HR.19.11054322", name: "Kali" },
    { code: "HR.19.11054323", name: "Kolan" },
    { code: "HR.19.11054325", name: "Kukljica" },
    { code: "HR.19.11054326", name: "Lišane Ostrovičke" },
    { code: "HR.19.11054327", name: "Nin" },
    { code: "HR.19.11054328", name: "Obrovac" },
    { code: "HR.19.11054329", name: "Pag" },
    { code: "HR.19.11054332", name: "Pakoštane" },
    { code: "HR.19.11054333", name: "Pašman" },
    { code: "HR.19.11054335", name: "Polača" },
    { code: "HR.19.11054336", name: "Poličnik" },
    { code: "HR.19.11054372", name: "Posedarje" },
    { code: "HR.19.11054373", name: "Povljana" },
    { code: "HR.19.11054374", name: "Preko" },
    { code: "HR.19.11054375", name: "Privlaka" },
    { code: "HR.19.11054376", name: "Ražanac" },
    { code: "HR.19.11054377", name: "Sali" },
    { code: "HR.19.11054378", name: "Stankovci" },
    { code: "HR.19.11054379", name: "Starigrad" },
    { code: "HR.19.11054380", name: "Sukošan" },
    { code: "HR.19.11054381", name: "Sveti Filip i Jakov" },
    { code: "HR.19.11054383", name: "Škabrnja" },
    { code: "HR.19.11054384", name: "Tkon" },
    { code: "HR.19.11054386", name: "Vir" },
    { code: "HR.19.11054387", name: "Vrsi" },
    { code: "HR.19.11054389", name: "Zemunik Donji" },
    { code: "HR.19.11055010", name: "Zadar" },
    { code: "HR.19.3204122", name: "Grad Biograd na Moru" },
    { code: "HR.19.9077071", name: "Novigrad Općina" },
  ],
  "HR.20": [
    { code: "HR.20.11048980", name: "Bedenica" },
    { code: "HR.20.11048981", name: "Brckovljani" },
    { code: "HR.20.11048982", name: "Brdovec" },
    { code: "HR.20.11048983", name: "Farkaševac" },
    { code: "HR.20.11048984", name: "Dubravica" },
    { code: "HR.20.11048985", name: "Gradec" },
    { code: "HR.20.11048986", name: "Jakovlje" },
    { code: "HR.20.11048987", name: "Klinča Sela" },
    { code: "HR.20.11048989", name: "Kloštar Ivanić" },
    { code: "HR.20.11048992", name: "Krašić" },
    { code: "HR.20.11048993", name: "Kravarsko" },
    { code: "HR.20.11048994", name: "Križ" },
    { code: "HR.20.11048995", name: "Luka" },
    { code: "HR.20.11048997", name: "Marija Gorica" },
    { code: "HR.20.11048998", name: "Orle" },
    { code: "HR.20.11048999", name: "Pisarovina" },
    { code: "HR.20.11049000", name: "Pokupsko" },
    { code: "HR.20.11049001", name: "Preseka" },
    { code: "HR.20.11049002", name: "Pušća" },
    { code: "HR.20.11049003", name: "Rakovec" },
    { code: "HR.20.11049004", name: "Rugvica" },
    { code: "HR.20.11049005", name: "Stupnik" },
    { code: "HR.20.11049006", name: "Žumberak" },
    { code: "HR.20.11054888", name: "Bistra" },
    { code: "HR.20.11054889", name: "Sveta Nedelja" },
    { code: "HR.20.3186602", name: "Grad Sveti Ivan Zelina" },
    { code: "HR.20.3186780", name: "Grad Zaprešić" },
    { code: "HR.20.3187264", name: "Grad Vrbovec" },
    { code: "HR.20.3188243", name: "Grad Velika Gorica" },
    { code: "HR.20.3191315", name: "Grad Samobor" },
    { code: "HR.20.3198798", name: "Grad Jastrebarsko" },
    { code: "HR.20.3199068", name: "Ivanić-Grad" },
    { code: "HR.20.3201007", name: "Grad Dugo Selo" },
    { code: "HR.20.8260123", name: "Općina Dubrava" },
  ],
  "HR.21": [
    { code: "HR.21.3190965", name: "Sesvete" },
    { code: "HR.21.8531816", name: "Gradska četvrt Donji grad" },
    { code: "HR.21.8531817", name: "Gradska četvrt Gornji Grad - Medvescak" },
    { code: "HR.21.8531820", name: "Gradska četvrt Trnje" },
    { code: "HR.21.8531822", name: "Gradska četvrt Maksimir" },
    { code: "HR.21.8531823", name: "Gradska cetvrt Pescenica - Zitnjak" },
    { code: "HR.21.8531824", name: "Gradska cetvrt Novi Zagreb - istok" },
    { code: "HR.21.8531825", name: "Gradska četvrt Novi Zagreb - zapad" },
    { code: "HR.21.8531826", name: "Gradska četvrt Tresnjevka - sjever" },
    { code: "HR.21.8531827", name: "Gradska četvrt Tresnjevka - jug" },
    { code: "HR.21.8531828", name: "Gradska četvrt Črnomerec" },
    { code: "HR.21.8531829", name: "Gradska četvrt Gornja Dubrava" },
    { code: "HR.21.8531830", name: "Gradska četvrt Donja Dubrava" },
    { code: "HR.21.8531831", name: "Gradska četvrt Stenjevec" },
    { code: "HR.21.8531832", name: "Podsused - Vrapce" },
    { code: "HR.21.8531833", name: "Gradska četvrt Podsljeme" },
    { code: "HR.21.8531834", name: "Gradska četvrt Brezovica" },
  ],
  "HT.03": [
    { code: "HT.03.3717599", name: "Arrondissement de Saint-Louis du Nord" },
    { code: "HT.03.3718419", name: "Arrondissement de Port-de-Paix" },
    { code: "HT.03.3720764", name: "Arrondissement du Môle Saint-Nicolas" },
  ],
  "HT.06": [
    { code: "HT.06.3717563", name: "Arrondissement de Marmelade" },
    { code: "HT.06.3717587", name: "Arrondissement de Saint-Marc" },
    { code: "HT.06.3724144", name: "Arrondissement de Gros Morne" },
    { code: "HT.06.3724695", name: "Gonayiv" },
    { code: "HT.06.3726539", name: "Arrondissement de Dessalines" },
  ],
  "HT.07": [
    { code: "HT.07.3720809", name: "Arrondissement de Mirebalais" },
    { code: "HT.07.3722578", name: "Arrondissement de Lascahobas" },
    { code: "HT.07.3723840", name: "Arrondissement de Hinche" },
    { code: "HT.07.3728053", name: "Arrondissement de Cerca La Source" },
  ],
  "HT.09": [
    { code: "HT.09.3717545", name: "Arrondissement de Saint-Raphaël" },
    { code: "HT.09.3718665", name: "Arrondissement de Plaisance" },
    { code: "HT.09.3722122", name: "Lenbe" },
    { code: "HT.09.3724438", name: "Arrondissement de la Grande Rivière du Nord" },
    { code: "HT.09.3728473", name: "Okap" },
    { code: "HT.09.3729454", name: "Arrondissement du Borgne" },
    { code: "HT.09.3731232", name: "Arrondissement de l'Acul du Nord" },
  ],
  "HT.10": [
    { code: "HT.10.3716114", name: "Arrondissement de Vallières" },
    { code: "HT.10.3716223", name: "Arrondissement du Trou du Nord" },
    { code: "HT.10.3719435", name: "Arrondissement d'Ouanaminthe" },
    { code: "HT.10.3725169", name: "Arrondissement de Fort Liberté" },
  ],
  "HT.11": [
    { code: "HT.11.3718425", name: "Arrondissement de Port-au-Prince" },
    { code: "HT.11.3722285", name: "Arrondissement de Léogâne" },
    { code: "HT.11.3723019", name: "Lagonav" },
    { code: "HT.11.3727134", name: "Arrondissement de Croix des Bouquets" },
    { code: "HT.11.3731086", name: "Arrondissement d'Arcahaie" },
  ],
  "HT.12": [
    { code: "HT.12.3718404", name: "Arrondissement de Port-Salut" },
    { code: "HT.12.3727295", name: "Arrondissement des Coteaux" },
    { code: "HT.12.3727900", name: "Arrondissement des Chardonnières" },
    { code: "HT.12.3728096", name: "Arrondissement des Cayes" },
    { code: "HT.12.3731094", name: "Arrondissement d'Aquin" },
  ],
  "HT.13": [
    { code: "HT.13.3723778", name: "Arrondissement de Jacmel" },
    { code: "HT.13.3730361", name: "Arrondissement de Belle-Anse" },
    { code: "HT.13.3730910", name: "Arrondissement de Bainet" },
  ],
  "HT.14": [
    { code: "HT.14.3723592", name: "Jeremi" },
    { code: "HT.14.3727381", name: "Arrondissement de Corail" },
    { code: "HT.14.3731116", name: "Ansdeno" },
  ],
  "HT.15": [
    { code: "HT.15.3720823", name: "Arrondissement de Miragoâne" },
    { code: "HT.15.3730801", name: "Arrondissement de Baradères" },
    { code: "HT.15.3731122", name: "Ansavo" },
  ],
  "HU.01": [
    { code: "HU.01.034", name: "Bácsalmási Járás" },
    { code: "HU.01.035", name: "Bajai Járás" },
    { code: "HU.01.036", name: "Jánoshalmai Járás" },
    { code: "HU.01.037", name: "Kalocsai Járás" },
    { code: "HU.01.038", name: "Kecskeméti Járás" },
    { code: "HU.01.039", name: "Kiskőrösi Járás" },
    { code: "HU.01.040", name: "Kiskunfélegyházi Járás" },
    { code: "HU.01.041", name: "Kiskunhalasi Járás" },
    { code: "HU.01.042", name: "Kiskunmajsai Járás" },
    { code: "HU.01.043", name: "Kunszentmiklósi Járás" },
    { code: "HU.01.044", name: "Tiszakécskei Járás" },
  ],
  "HU.02": [
    { code: "HU.02.024", name: "Bólyi Járás" },
    { code: "HU.02.025", name: "Hegyháti Járás" },
    { code: "HU.02.026", name: "Komlói Járás" },
    { code: "HU.02.027", name: "Mohácsi Járás" },
    { code: "HU.02.028", name: "Pécsi Járás" },
    { code: "HU.02.029", name: "Pécsváradi Járás" },
    { code: "HU.02.030", name: "Sellyei Járás" },
    { code: "HU.02.031", name: "Siklósi Járás" },
    { code: "HU.02.032", name: "Szentlőrinci Járás" },
    { code: "HU.02.033", name: "Szigetvári Járás" },
  ],
  "HU.03": [
    { code: "HU.03.045", name: "Békési Járás" },
    { code: "HU.03.046", name: "Békéscsabai Járás" },
    { code: "HU.03.047", name: "Gyomaendrődi Járás" },
    { code: "HU.03.048", name: "Gyulai Járás" },
    { code: "HU.03.049", name: "Mezőkovácsházai Járás" },
    { code: "HU.03.050", name: "Orosházi Járás" },
    { code: "HU.03.051", name: "Sarkadi Járás" },
    { code: "HU.03.052", name: "Szarvasi Járás" },
    { code: "HU.03.053", name: "Szeghalmi Járás" },
  ],
  "HU.04": [
    { code: "HU.04.054", name: "Cigándi Járás" },
    { code: "HU.04.055", name: "Edelényi Járás" },
    { code: "HU.04.056", name: "Encsi Járás" },
    { code: "HU.04.057", name: "Gönci Járás" },
    { code: "HU.04.058", name: "Kazincbarcikai Járás" },
    { code: "HU.04.059", name: "Mezőcsáti Járás" },
    { code: "HU.04.060", name: "Mezőkövesdi Járás" },
    { code: "HU.04.061", name: "Miskolci Járás" },
    { code: "HU.04.062", name: "Ózdi Járás" },
    { code: "HU.04.063", name: "Putnoki Járás" },
    { code: "HU.04.064", name: "Sárospataki Járás" },
    { code: "HU.04.065", name: "Sátoraljaújhelyi Járás" },
    { code: "HU.04.066", name: "Szerencsi Járás" },
    { code: "HU.04.067", name: "Szikszói Járás" },
    { code: "HU.04.068", name: "Tiszaújvárosi Járás" },
    { code: "HU.04.069", name: "Tokaji Járás" },
  ],
  "HU.05": [
    { code: "HU.05.001", name: "Budapest I." },
    { code: "HU.05.002", name: "Budapest II." },
    { code: "HU.05.003", name: "Budapest III." },
    { code: "HU.05.004", name: "Budapest IV." },
    { code: "HU.05.005", name: "Budapest V." },
    { code: "HU.05.006", name: "Budapest VI." },
    { code: "HU.05.007", name: "Budapest VII." },
    { code: "HU.05.008", name: "Budapest VIII." },
    { code: "HU.05.009", name: "Budapest IX." },
    { code: "HU.05.010", name: "Budapest X." },
    { code: "HU.05.011", name: "Budapest XI." },
    { code: "HU.05.012", name: "Budapest XII." },
    { code: "HU.05.013", name: "Budapest XIII." },
    { code: "HU.05.014", name: "Budapest XIV." },
    { code: "HU.05.015", name: "Budapest XV." },
    { code: "HU.05.016", name: "Budapest XVI." },
    { code: "HU.05.017", name: "Budapest XVII." },
    { code: "HU.05.018", name: "Budapest XVIII." },
    { code: "HU.05.019", name: "Budapest XIX." },
    { code: "HU.05.020", name: "Budapest XX." },
    { code: "HU.05.021", name: "Budapest XXI." },
    { code: "HU.05.022", name: "Budapest XXII." },
    { code: "HU.05.023", name: "Budapest XXIII." },
  ],
  "HU.06": [
    { code: "HU.06.070", name: "Csongrádi Járás" },
    { code: "HU.06.071", name: "Hódmezővásárhelyi Járás" },
    { code: "HU.06.072", name: "Kisteleki Járás" },
    { code: "HU.06.073", name: "Makói Járás" },
    { code: "HU.06.074", name: "Mórahalmi Járás" },
    { code: "HU.06.075", name: "Szegedi Járás" },
    { code: "HU.06.076", name: "Szentesi Járás" },
  ],
  "HU.08": [
    { code: "HU.08.077", name: "Bicskei Járás" },
    { code: "HU.08.078", name: "Dunaújvárosi Járás" },
    { code: "HU.08.079", name: "Enyingi Járás" },
    { code: "HU.08.080", name: "Gárdonyi Járás" },
    { code: "HU.08.081", name: "Martonvásári Járás" },
    { code: "HU.08.082", name: "Móri Járás" },
    { code: "HU.08.084", name: "Sárbogárdi Járás" },
    { code: "HU.08.085", name: "Székesfehérvári Járás" },
  ],
  "HU.09": [
    { code: "HU.09.086", name: "Csornai Járás" },
    { code: "HU.09.087", name: "Győri Járás" },
    { code: "HU.09.088", name: "Kapuvári Járás" },
    { code: "HU.09.089", name: "Mosonmagyaróvári Járás" },
    { code: "HU.09.090", name: "Pannonhalmi Járás" },
    { code: "HU.09.091", name: "Soproni Járás" },
    { code: "HU.09.092", name: "Téti Járás" },
  ],
  "HU.10": [
    { code: "HU.10.093", name: "Balmazújvárosi Járás" },
    { code: "HU.10.094", name: "Berettyóújfalui Járás" },
    { code: "HU.10.095", name: "Debreceni Járás" },
    { code: "HU.10.096", name: "Derecskei Járás" },
    { code: "HU.10.097", name: "Hajdúböszörményi Járás" },
    { code: "HU.10.098", name: "Hajdúhadházi Járás" },
    { code: "HU.10.099", name: "Hajdúnánási Járás" },
    { code: "HU.10.100", name: "Hadjúszoboszlói Járás" },
    { code: "HU.10.101", name: "Nyíradonyi Járás" },
    { code: "HU.10.102", name: "Püspökladányi Járás" },
  ],
  "HU.11": [
    { code: "HU.11.103", name: "Bélapátfalvai Járás" },
    { code: "HU.11.104", name: "Egri Járás" },
    { code: "HU.11.105", name: "Füzesabonyi Járás" },
    { code: "HU.11.106", name: "Gyöngyösi Járás" },
    { code: "HU.11.107", name: "Hatvani Járás" },
    { code: "HU.11.108", name: "Hevesi Járás" },
    { code: "HU.11.109", name: "Pétervásárai Járás" },
  ],
  "HU.12": [
    { code: "HU.12.110", name: "Esztergomi Járás" },
    { code: "HU.12.111", name: "Kisbéri Járás" },
    { code: "HU.12.112", name: "Komáromi Járás" },
    { code: "HU.12.113", name: "Oroszlányi Járás" },
    { code: "HU.12.114", name: "Tatai Járás" },
    { code: "HU.12.115", name: "Tatabányai Járás" },
  ],
  "HU.14": [
    { code: "HU.14.116", name: "Balassagyarmati Járás" },
    { code: "HU.14.117", name: "Bátonyterenyei Járás" },
    { code: "HU.14.118", name: "Pásztói Járás" },
    { code: "HU.14.119", name: "Rétsági Járás" },
    { code: "HU.14.120", name: "Salgótarjáni Járás" },
    { code: "HU.14.121", name: "Szécsényi Járás" },
  ],
  "HU.16": [
    { code: "HU.16.122", name: "Aszódi Járás" },
    { code: "HU.16.123", name: "Budakeszi Járás" },
    { code: "HU.16.124", name: "Ceglédi Járás" },
    { code: "HU.16.125", name: "Dabasi Járás" },
    { code: "HU.16.126", name: "Dunakeszi Járás" },
    { code: "HU.16.127", name: "Érdi Járás" },
    { code: "HU.16.128", name: "Gödöllői Járás" },
    { code: "HU.16.129", name: "Gyáli Járás" },
    { code: "HU.16.130", name: "Monori Járás" },
    { code: "HU.16.131", name: "Nagykátai Járás" },
    { code: "HU.16.132", name: "Nagykőrösi Járás" },
    { code: "HU.16.133", name: "Pilisvörösvári Járás" },
    { code: "HU.16.134", name: "Ráckevei Járás" },
    { code: "HU.16.135", name: "Szentendrei Járás" },
    { code: "HU.16.136", name: "Szigetszentmiklósi Járás" },
    { code: "HU.16.137", name: "Szobi Járás" },
    { code: "HU.16.138", name: "Váci Járás" },
    { code: "HU.16.139", name: "Vecsési Járás" },
  ],
  "HU.17": [
    { code: "HU.17.140", name: "Barcsi Járás" },
    { code: "HU.17.141", name: "Csurgói Járás" },
    { code: "HU.17.142", name: "Fonyódi Járás" },
    { code: "HU.17.143", name: "Kaposvári Járás" },
    { code: "HU.17.144", name: "Marcali Járás" },
    { code: "HU.17.145", name: "Nagyatádi Járás" },
    { code: "HU.17.146", name: "Siófoki Járás" },
    { code: "HU.17.147", name: "Tabi Járás" },
  ],
  "HU.18": [
    { code: "HU.18.148", name: "Baktalórántházai Járás" },
    { code: "HU.18.149", name: "Csengeri Járás" },
    { code: "HU.18.150", name: "Fehérgyarmati Járás" },
    { code: "HU.18.151", name: "Ibrányi Járás" },
    { code: "HU.18.152", name: "Kemecsei Járás" },
    { code: "HU.18.153", name: "Kisvárdai Járás" },
    { code: "HU.18.154", name: "Mátészalkai Járás" },
    { code: "HU.18.155", name: "Nagykállói Járás" },
    { code: "HU.18.156", name: "Nyírbátori Járás" },
    { code: "HU.18.157", name: "Nyíregyházi Járás" },
    { code: "HU.18.158", name: "Tiszavasvári Járás" },
    { code: "HU.18.159", name: "Vásárosnaményi Járás" },
    { code: "HU.18.160", name: "Záhonyi Járás" },
  ],
  "HU.20": [
    { code: "HU.20.161", name: "Jászapáti Járás" },
    { code: "HU.20.162", name: "Jászberényi Járás" },
    { code: "HU.20.163", name: "Karcagi Járás" },
    { code: "HU.20.164", name: "Kunhegyesi Járás" },
    { code: "HU.20.165", name: "Kunszentmártoni Járás" },
    { code: "HU.20.166", name: "Mezőtúri Járás" },
    { code: "HU.20.167", name: "Szolnoki Járás" },
    { code: "HU.20.168", name: "Tiszafüredi Járás" },
    { code: "HU.20.169", name: "Törökszentmiklósi Járás" },
  ],
  "HU.21": [
    { code: "HU.21.170", name: "Bonyhádi Járás" },
    { code: "HU.21.171", name: "Dombóvári Járás" },
    { code: "HU.21.172", name: "Paksi Járás" },
    { code: "HU.21.173", name: "Szekszárdi Járás" },
    { code: "HU.21.174", name: "Tamási Járás" },
    { code: "HU.21.175", name: "Tolnai Járás" },
  ],
  "HU.22": [
    { code: "HU.22.176", name: "Celldömölki Járás" },
    { code: "HU.22.177", name: "Körmendi Járás" },
    { code: "HU.22.178", name: "Kőszegi Járás" },
    { code: "HU.22.179", name: "Sárvári Járás" },
    { code: "HU.22.180", name: "Szentgotthárdi Járás" },
    { code: "HU.22.181", name: "Szombathelyi Járás" },
    { code: "HU.22.182", name: "Vasvári Járás" },
  ],
  "HU.23": [
    { code: "HU.23.183", name: "Ajkai Járás" },
    { code: "HU.23.184", name: "Balatonalmádi Járás" },
    { code: "HU.23.185", name: "Balatonfüredi Járás" },
    { code: "HU.23.186", name: "Devecseri Járás" },
    { code: "HU.23.187", name: "Pápai Járás" },
    { code: "HU.23.188", name: "Sümegi Járás" },
    { code: "HU.23.189", name: "Tapolcai Járás" },
    { code: "HU.23.190", name: "Várpalotai Járás" },
    { code: "HU.23.191", name: "Veszprémi Járás" },
    { code: "HU.23.192", name: "Zirci Járás" },
  ],
  "HU.24": [
    { code: "HU.24.193", name: "Keszthelyi Járás" },
    { code: "HU.24.194", name: "Lenti Járás" },
    { code: "HU.24.195", name: "Letenyei Járás" },
    { code: "HU.24.196", name: "Nagykanizsai Járás" },
    { code: "HU.24.197", name: "Zalaegerszegi Járás" },
    { code: "HU.24.198", name: "Zalaszentgróti Járás" },
  ],
  "ID.01": [
    { code: "ID.01.1101", name: "Kabupaten Simeulue" },
    { code: "ID.01.1102", name: "Kabupaten Aceh Singkil" },
    { code: "ID.01.1103", name: "Kabupaten Aceh Selatan" },
    { code: "ID.01.1104", name: "Kabupaten Aceh Tenggara" },
    { code: "ID.01.1105", name: "Kabupaten Aceh Timur" },
    { code: "ID.01.1106", name: "Kabupaten Aceh Tengah" },
    { code: "ID.01.1107", name: "Kabupaten Aceh Barat" },
    { code: "ID.01.1108", name: "Kabupaten Aceh Besar" },
    { code: "ID.01.1109", name: "Kabupaten Pidie" },
    { code: "ID.01.1110", name: "Kabupaten Bireuen" },
    { code: "ID.01.1111", name: "Kabupaten Aceh Utara" },
    { code: "ID.01.1112", name: "Kabupaten Aceh Barat Daya" },
    { code: "ID.01.1113", name: "Kabupaten Gayo Lues" },
    { code: "ID.01.1114", name: "Kabupaten Aceh Tamiang" },
    { code: "ID.01.1115", name: "Kabupaten Nagan Raya" },
    { code: "ID.01.1116", name: "Kabupaten Aceh Jaya" },
    { code: "ID.01.1117", name: "Kabupaten Bener Meriah" },
    { code: "ID.01.1118", name: "Kabupaten Pidie Jaya" },
    { code: "ID.01.1171", name: "Kota Banda Aceh" },
    { code: "ID.01.1172", name: "Kota Sabang" },
    { code: "ID.01.1173", name: "Kota Langsa" },
    { code: "ID.01.1174", name: "Kota Lhokseumawe" },
    { code: "ID.01.1175", name: "Kota Subulussalam" },
  ],
  "ID.02": [
    { code: "ID.02.5101", name: "Kabupaten Jembrana" },
    { code: "ID.02.5102", name: "Kabupaten Tabanan" },
    { code: "ID.02.5103", name: "Kabupaten Badung" },
    { code: "ID.02.5104", name: "Kabupaten Gianyar" },
    { code: "ID.02.5105", name: "Kabupaten Klungkung" },
    { code: "ID.02.5106", name: "Kabupaten Bangli" },
    { code: "ID.02.5107", name: "Kabupaten Karang Asem" },
    { code: "ID.02.5108", name: "Kabupaten Buleleng" },
    { code: "ID.02.5171", name: "Kota Denpasar" },
  ],
  "ID.03": [
    { code: "ID.03.1701", name: "Kabupaten Bengkulu Selatan" },
    { code: "ID.03.1702", name: "Kabupaten Rejang Lebong" },
    { code: "ID.03.1703", name: "Kabupaten Bengkulu Utara" },
    { code: "ID.03.1704", name: "Kabupaten Kaur" },
    { code: "ID.03.1705", name: "Kabupaten Seluma" },
    { code: "ID.03.1706", name: "Kabupaten Mukomuko" },
    { code: "ID.03.1707", name: "Kabupaten Lebong" },
    { code: "ID.03.1708", name: "Kabupaten Kepahiang" },
    { code: "ID.03.1709", name: "Kabupaten Bengkulu Tengah" },
    { code: "ID.03.1771", name: "Kota Bengkulu" },
  ],
  "ID.04": [
    { code: "ID.04.3101", name: "Kabupaten Administrasi Kepulauan Seribu" },
    { code: "ID.04.3171", name: "Kota Administrasi Jakarta Selatan" },
    { code: "ID.04.3172", name: "Kota Administrasi Jakarta Timur" },
    { code: "ID.04.3173", name: "Kota Administrasi Jakarta Pusat" },
    { code: "ID.04.3174", name: "Kota Administrasi Jakarta Barat" },
    { code: "ID.04.3175", name: "Kota Administrasi Jakarta Utara" },
  ],
  "ID.05": [
    { code: "ID.05.1501", name: "Kabupaten Kerinci" },
    { code: "ID.05.1502", name: "Kabupaten Merangin" },
    { code: "ID.05.1503", name: "Kabupaten Sarolangun" },
    { code: "ID.05.1504", name: "Kabupaten Batang Hari" },
    { code: "ID.05.1505", name: "Kabupaten Muaro Jambi" },
    { code: "ID.05.1506", name: "Kabupaten Tanjung Jabung Timur" },
    { code: "ID.05.1507", name: "Kabupaten Tanjung Jabung Barat" },
    { code: "ID.05.1508", name: "Kabupaten Tebo" },
    { code: "ID.05.1509", name: "Kabupaten Bungo" },
    { code: "ID.05.1571", name: "Kota Jambi" },
    { code: "ID.05.1572", name: "Kota Sungai Penuh" },
  ],
  "ID.07": [
    { code: "ID.07.3301", name: "Kabupaten Cilacap" },
    { code: "ID.07.3302", name: "Kabupaten Banyumas" },
    { code: "ID.07.3303", name: "Kabupaten Purbalingga" },
    { code: "ID.07.3304", name: "Kabupaten Banjarnegara" },
    { code: "ID.07.3305", name: "Kabupaten Kebumen" },
    { code: "ID.07.3306", name: "Kabupaten Purworejo" },
    { code: "ID.07.3307", name: "Kabupaten Wonosobo" },
    { code: "ID.07.3308", name: "Kabupaten Magelang" },
    { code: "ID.07.3309", name: "Kabupaten Boyolali" },
    { code: "ID.07.3310", name: "Kabupaten Klaten" },
    { code: "ID.07.3311", name: "Kabupaten Sukoharjo" },
    { code: "ID.07.3312", name: "Kabupaten Wonogiri" },
    { code: "ID.07.3313", name: "Kabupaten Karanganyar" },
    { code: "ID.07.3314", name: "Kabupaten Sragen" },
    { code: "ID.07.3315", name: "Kabupaten Grobogan" },
    { code: "ID.07.3316", name: "Kabupaten Blora" },
    { code: "ID.07.3317", name: "Kabupaten Rembang" },
    { code: "ID.07.3318", name: "Kabupaten Pati" },
    { code: "ID.07.3319", name: "Kabupaten Kudus" },
    { code: "ID.07.3320", name: "Kabupaten Jepara" },
    { code: "ID.07.3321", name: "Kabupaten Demak" },
    { code: "ID.07.3322", name: "Kabupaten Semarang" },
    { code: "ID.07.3323", name: "Kabupaten Temanggung" },
    { code: "ID.07.3324", name: "Kabupaten Kendal" },
    { code: "ID.07.3325", name: "Kabupaten Batang" },
    { code: "ID.07.3326", name: "Kabupaten Pekalongan" },
    { code: "ID.07.3327", name: "Kabupaten Pemalang" },
    { code: "ID.07.3328", name: "Kabupaten Tegal" },
    { code: "ID.07.3329", name: "Kabupaten Brebes" },
    { code: "ID.07.3371", name: "Kota Magelang" },
    { code: "ID.07.3372", name: "Kota Surakarta" },
    { code: "ID.07.3373", name: "Kota Salatiga" },
    { code: "ID.07.3374", name: "Kota Semarang" },
    { code: "ID.07.3375", name: "Kota Pekalongan" },
    { code: "ID.07.3376", name: "Kota Tegal" },
  ],
  "ID.08": [
    { code: "ID.08.3501", name: "Kabupaten Pacitan" },
    { code: "ID.08.3502", name: "Kabupaten Ponorogo" },
    { code: "ID.08.3503", name: "Kabupaten Trenggalek" },
    { code: "ID.08.3504", name: "Kabupaten Tulungagung" },
    { code: "ID.08.3505", name: "Kabupaten Blitar" },
    { code: "ID.08.3506", name: "Kabupaten Kediri" },
    { code: "ID.08.3507", name: "Kabupaten Malang" },
    { code: "ID.08.3508", name: "Kabupaten Lumajang" },
    { code: "ID.08.3509", name: "Kabupaten Jember" },
    { code: "ID.08.3510", name: "Kabupaten Banyuwangi" },
    { code: "ID.08.3511", name: "Kabupaten Bondowoso" },
    { code: "ID.08.3512", name: "Kabupaten Situbondo" },
    { code: "ID.08.3513", name: "Kabupaten Probolinggo" },
    { code: "ID.08.3514", name: "Kabupaten Pasuruan" },
    { code: "ID.08.3515", name: "Kabupaten Sidoarjo" },
    { code: "ID.08.3516", name: "Kabupaten Mojokerto" },
    { code: "ID.08.3517", name: "Kabupaten Jombang" },
    { code: "ID.08.3518", name: "Kabupaten Nganjuk" },
    { code: "ID.08.3519", name: "Kabupaten Madiun" },
    { code: "ID.08.3520", name: "Kabupaten Magetan" },
    { code: "ID.08.3521", name: "Kabupaten Ngawi" },
    { code: "ID.08.3522", name: "Kabupaten Bojonegoro" },
    { code: "ID.08.3523", name: "Kabupaten Tuban" },
    { code: "ID.08.3524", name: "Kabupaten Lamongan" },
    { code: "ID.08.3525", name: "Gresik Regency" },
    { code: "ID.08.3526", name: "Kabupaten Bangkalan" },
    { code: "ID.08.3527", name: "Kabupaten Sampang" },
    { code: "ID.08.3528", name: "Kabupaten Pamekasan" },
    { code: "ID.08.3529", name: "Kabupaten Sumenep" },
    { code: "ID.08.3571", name: "Kota Kediri" },
    { code: "ID.08.3572", name: "Kota Blitar" },
    { code: "ID.08.3573", name: "Kota Malang" },
    { code: "ID.08.3574", name: "Kota Probolinggo" },
    { code: "ID.08.3575", name: "Kota Pasuruan" },
    { code: "ID.08.3576", name: "Kota Mojokerto" },
    { code: "ID.08.3577", name: "Kota Madiun" },
    { code: "ID.08.3578", name: "Kota Surabaya" },
    { code: "ID.08.3579", name: "Kota Batu" },
  ],
  "ID.10": [
    { code: "ID.10.3401", name: "Kabupaten Kulon Progo" },
    { code: "ID.10.3402", name: "Kabupaten Bantul" },
    { code: "ID.10.3403", name: "Kabupaten Gunung Kidul" },
    { code: "ID.10.3404", name: "Kabupaten Sleman" },
    { code: "ID.10.3471", name: "Kota Yogyakarta" },
  ],
  "ID.11": [
    { code: "ID.11.6101", name: "Kabupaten Sambas" },
    { code: "ID.11.6102", name: "Kabupaten Bengkayang" },
    { code: "ID.11.6103", name: "Kabupaten Landak" },
    { code: "ID.11.6104", name: "Kabupaten Mempawah" },
    { code: "ID.11.6105", name: "Kabupaten Sanggau" },
    { code: "ID.11.6106", name: "Kabupaten Ketapang" },
    { code: "ID.11.6107", name: "Kabupaten Sintang" },
    { code: "ID.11.6108", name: "Kabupaten Kapuas Hulu" },
    { code: "ID.11.6109", name: "Kabupaten Sekadau" },
    { code: "ID.11.6110", name: "Kabupaten Melawi" },
    { code: "ID.11.6111", name: "Kabupaten Kayong Utara" },
    { code: "ID.11.6112", name: "Kabupaten Kubu Raya" },
    { code: "ID.11.6171", name: "Kota Pontianak" },
    { code: "ID.11.6172", name: "Kota Singkawang" },
  ],
  "ID.12": [
    { code: "ID.12.6301", name: "Kabupaten Tanah Laut" },
    { code: "ID.12.6302", name: "Kabupaten Kota Baru" },
    { code: "ID.12.6303", name: "Kabupaten Banjar" },
    { code: "ID.12.6304", name: "Kabupaten Barito Kuala" },
    { code: "ID.12.6305", name: "Kabupaten Tapin" },
    { code: "ID.12.6306", name: "Kabupaten Hulu Sungai Selatan" },
    { code: "ID.12.6307", name: "Kabupaten Hulu Sungai Tengah" },
    { code: "ID.12.6308", name: "Kabupaten Hulu Sungai Utara" },
    { code: "ID.12.6309", name: "Kabupaten Tabalong" },
    { code: "ID.12.6310", name: "Kabupaten Tanah Bumbu" },
    { code: "ID.12.6311", name: "Kabupaten Balangan" },
    { code: "ID.12.6371", name: "Kota Banjarmasin" },
    { code: "ID.12.6372", name: "Kota Banjar Baru" },
  ],
  "ID.13": [
    { code: "ID.13.6201", name: "Kabupaten Kotawaringin Barat" },
    { code: "ID.13.6202", name: "Kabupaten Kotawaringin Timur" },
    { code: "ID.13.6203", name: "Kabupaten Kapuas" },
    { code: "ID.13.6204", name: "Kabupaten Barito Selatan" },
    { code: "ID.13.6205", name: "Kabupaten Barito Utara" },
    { code: "ID.13.6206", name: "Kabupaten Sukamara" },
    { code: "ID.13.6207", name: "Kabupaten Lamandau" },
    { code: "ID.13.6208", name: "Kabupaten Seruyan" },
    { code: "ID.13.6209", name: "Kabupaten Katingan" },
    { code: "ID.13.6210", name: "Kabupaten Pulang Pisau" },
    { code: "ID.13.6211", name: "Kabupaten Gunung Mas" },
    { code: "ID.13.6212", name: "Kabupaten Barito Timur" },
    { code: "ID.13.6213", name: "Kabupaten Murung Raya" },
    { code: "ID.13.6271", name: "Kota Palangka Raya" },
  ],
  "ID.14": [
    { code: "ID.14.6401", name: "Kabupaten Paser" },
    { code: "ID.14.6402", name: "Kabupaten Kutai Barat" },
    { code: "ID.14.6403", name: "Kabupaten Kutai Kartanegara" },
    { code: "ID.14.6404", name: "Kabupaten Kutai Timur" },
    { code: "ID.14.6405", name: "Kabupaten Berau" },
    { code: "ID.14.6409", name: "Kabupaten Penajam Paser Utara" },
    { code: "ID.14.6411", name: "Kabupaten Mahakam Hulu" },
    { code: "ID.14.6471", name: "Kota Balikpapan" },
    { code: "ID.14.6472", name: "Kota Samarinda" },
    { code: "ID.14.6474", name: "Kota Bontang" },
  ],
  "ID.15": [
    { code: "ID.15.1801", name: "Kabupaten Lampung Barat" },
    { code: "ID.15.1802", name: "Kabupaten Tanggamus" },
    { code: "ID.15.1803", name: "Kabupaten Lampung Selatan" },
    { code: "ID.15.1804", name: "Kabupaten Lampung Timur" },
    { code: "ID.15.1805", name: "Kabupaten Lampung Tengah" },
    { code: "ID.15.1806", name: "Kabupaten Lampung Utara" },
    { code: "ID.15.1807", name: "Kabupaten Way Kanan" },
    { code: "ID.15.1808", name: "Kabupaten Tulangbawang" },
    { code: "ID.15.1809", name: "Kabupaten Pesawaran" },
    { code: "ID.15.1810", name: "Kabupaten Pringsewu" },
    { code: "ID.15.1811", name: "Kabupaten Mesuji" },
    { code: "ID.15.1812", name: "Kabupaten Tulang Bawang Barat" },
    { code: "ID.15.1813", name: "West Pesisir Regency" },
    { code: "ID.15.1871", name: "Kota Bandar Lampung" },
    { code: "ID.15.1872", name: "Kota Metro" },
  ],
  "ID.17": [
    { code: "ID.17.5201", name: "Kabupaten Lombok Barat" },
    { code: "ID.17.5202", name: "Kabupaten Lombok Tengah" },
    { code: "ID.17.5203", name: "Kabupaten Lombok Timur" },
    { code: "ID.17.5204", name: "Kabupaten Sumbawa" },
    { code: "ID.17.5205", name: "Kabupaten Dompu" },
    { code: "ID.17.5206", name: "Kabupaten Bima" },
    { code: "ID.17.5207", name: "Kabupaten Sumbawa Barat" },
    { code: "ID.17.5208", name: "Kabupaten Lombok Utara" },
    { code: "ID.17.5271", name: "Kota Mataram" },
    { code: "ID.17.5272", name: "Kota Bima" },
  ],
  "ID.18": [
    { code: "ID.18.5301", name: "Kabupaten Sumba Barat" },
    { code: "ID.18.5302", name: "Kabupaten Sumba Timur" },
    { code: "ID.18.5303", name: "Kabupaten Kupang" },
    { code: "ID.18.5304", name: "Kabupaten Timor Tengah Selatan" },
    { code: "ID.18.5305", name: "Kabupaten Timor Tengah Utara" },
    { code: "ID.18.5306", name: "Kabupaten Belu" },
    { code: "ID.18.5307", name: "Kabupaten Alor" },
    { code: "ID.18.5308", name: "Kabupaten Lembata" },
    { code: "ID.18.5309", name: "Kabupaten Flores Timur" },
    { code: "ID.18.5310", name: "Kabupaten Sikka" },
    { code: "ID.18.5311", name: "Kabupaten Ende" },
    { code: "ID.18.5312", name: "Kabupaten Ngada" },
    { code: "ID.18.5313", name: "Kabupaten Manggarai" },
    { code: "ID.18.5314", name: "Kabupaten Rote Ndao" },
    { code: "ID.18.5315", name: "Kabupaten Manggarai Barat" },
    { code: "ID.18.5316", name: "Kabupaten Sumba Tengah" },
    { code: "ID.18.5317", name: "Kabupaten Sumba Barat Daya" },
    { code: "ID.18.5318", name: "Kabupaten Nagekeo" },
    { code: "ID.18.5319", name: "Kabupaten Manggarai Timur" },
    { code: "ID.18.5320", name: "Kabupaten Sabu Raijua" },
    { code: "ID.18.5321", name: "Kabupaten Malaka" },
    { code: "ID.18.5371", name: "Kota Kupang" },
  ],
  "ID.21": [
    { code: "ID.21.7201", name: "Kabupaten Banggai Kepulauan" },
    { code: "ID.21.7202", name: "Kabupaten Banggai" },
    { code: "ID.21.7203", name: "Morowali Regency" },
    { code: "ID.21.7204", name: "Kabupaten Poso" },
    { code: "ID.21.7205", name: "Kabupaten Donggala" },
    { code: "ID.21.7206", name: "Kabupaten Toli-Toli" },
    { code: "ID.21.7207", name: "Kabupaten Buol" },
    { code: "ID.21.7208", name: "Kabupaten Parigi Moutong" },
    { code: "ID.21.7209", name: "Tojo Una-Una Regency" },
    { code: "ID.21.7210", name: "Kabupaten Sigi" },
    { code: "ID.21.7211", name: "Kabupaten Banggai Laut" },
    { code: "ID.21.7212", name: "Kabupaten Morowali Utara" },
    { code: "ID.21.7271", name: "Kota Palu" },
  ],
  "ID.22": [
    { code: "ID.22.7401", name: "Kabupaten Buton" },
    { code: "ID.22.7402", name: "Kabupaten Muna" },
    { code: "ID.22.7403", name: "Kabupaten Konawe" },
    { code: "ID.22.7404", name: "Kabupaten Kolaka" },
    { code: "ID.22.7405", name: "Kabupaten Konawe Selatan" },
    { code: "ID.22.7406", name: "Kabupaten Bombana" },
    { code: "ID.22.7407", name: "Wakatobi Regency" },
    { code: "ID.22.7408", name: "Kabupaten Kolaka Utara" },
    { code: "ID.22.7409", name: "Kabupaten Buton Utara" },
    { code: "ID.22.7410", name: "Kabupaten Konawe Utara" },
    { code: "ID.22.7411", name: "Kabupaten Kolaka Timur" },
    { code: "ID.22.7412", name: "Kabupaten Konawe Kepulauan" },
    { code: "ID.22.7413", name: "Kabupaten Muna Barat" },
    { code: "ID.22.7414", name: "Kabupaten Buton Tengah" },
    { code: "ID.22.7415", name: "Kabupaten Buton Selatan" },
    { code: "ID.22.7471", name: "Kota Kendari" },
    { code: "ID.22.7472", name: "Kota Baubau" },
  ],
  "ID.24": [
    { code: "ID.24.1301", name: "Kabupaten Kepulauan Mentawai" },
    { code: "ID.24.1302", name: "Kabupaten Pesisir Selatan" },
    { code: "ID.24.1303", name: "Kabupaten Solok" },
    { code: "ID.24.1304", name: "Kabupaten Sijunjung" },
    { code: "ID.24.1305", name: "Kabupaten Tanah Datar" },
    { code: "ID.24.1306", name: "Kabupaten Padang Pariaman" },
    { code: "ID.24.1307", name: "Kabupaten Agam" },
    { code: "ID.24.1308", name: "Kabupaten Lima Puluh Kota" },
    { code: "ID.24.1309", name: "Kabupaten Pasaman" },
    { code: "ID.24.1310", name: "Kabupaten Solok Selatan" },
    { code: "ID.24.1311", name: "Kabupaten Dharmasraya" },
    { code: "ID.24.1312", name: "Kabupaten Pasaman Barat" },
    { code: "ID.24.1371", name: "Kota Padang" },
    { code: "ID.24.1372", name: "Kota Solok" },
    { code: "ID.24.1373", name: "Kota Sawah Lunto" },
    { code: "ID.24.1374", name: "Kota Padang Panjang" },
    { code: "ID.24.1375", name: "Kota Bukittinggi" },
    { code: "ID.24.1376", name: "Kota Payakumbuh" },
    { code: "ID.24.1377", name: "Kota Pariaman" },
  ],
  "ID.26": [
    { code: "ID.26.1201", name: "Kabupaten Nias" },
    { code: "ID.26.1202", name: "Kabupaten Mandailing Natal" },
    { code: "ID.26.1203", name: "South Tapanuli Regency" },
    { code: "ID.26.1204", name: "Kabupaten Tapanuli Tengah" },
    { code: "ID.26.1205", name: "Kabupaten Tapanuli Utara" },
    { code: "ID.26.1206", name: "Kabupaten Toba Samosir" },
    { code: "ID.26.1207", name: "Kabupaten Labuhan Batu" },
    { code: "ID.26.1208", name: "Kabupaten Asahan" },
    { code: "ID.26.1209", name: "Kabupaten Simalungun" },
    { code: "ID.26.1210", name: "Kabupaten Dairi" },
    { code: "ID.26.1211", name: "Kabupaten Karo" },
    { code: "ID.26.1212", name: "Kabupaten Deli Serdang" },
    { code: "ID.26.1213", name: "Kabupaten Langkat" },
    { code: "ID.26.1214", name: "Kabupaten Nias Selatan" },
    { code: "ID.26.1215", name: "Kabupaten Humbang Hasundutan" },
    { code: "ID.26.1216", name: "Kabupaten Pakpak Bharat" },
    { code: "ID.26.1217", name: "Kabupaten Samosir" },
    { code: "ID.26.1218", name: "Kabupaten Serdang Bedagai" },
    { code: "ID.26.1219", name: "Kabupaten Batu Bara" },
    { code: "ID.26.1220", name: "Kabupaten Padang Lawas Utara" },
    { code: "ID.26.1221", name: "Kabupaten Padang Lawas" },
    { code: "ID.26.1222", name: "Kabupaten Labuhan Batu Selatan" },
    { code: "ID.26.1223", name: "Kabupaten Labuhan Batu Utara" },
    { code: "ID.26.1224", name: "Kabupaten Nias Utara" },
    { code: "ID.26.1225", name: "Kabupaten Nias Barat" },
    { code: "ID.26.1271", name: "Kota Sibolga" },
    { code: "ID.26.1272", name: "Kota Tanjung Balai" },
    { code: "ID.26.1273", name: "Kota Pematang Siantar" },
    { code: "ID.26.1274", name: "Kota Tebing Tinggi" },
    { code: "ID.26.1275", name: "Kota Medan" },
    { code: "ID.26.1276", name: "Kota Binjai" },
    { code: "ID.26.1277", name: "Kota Padangsidimpuan" },
    { code: "ID.26.1278", name: "Kota Gunungsitoli" },
  ],
  "ID.28": [
    { code: "ID.28.8101", name: "Kabupaten Maluku Tenggara Barat" },
    { code: "ID.28.8102", name: "Kabupaten Maluku Tenggara" },
    { code: "ID.28.8103", name: "Kabupaten Maluku Tengah" },
    { code: "ID.28.8104", name: "Kabupaten Buru" },
    { code: "ID.28.8105", name: "Kabupaten Kepulauan Aru" },
    { code: "ID.28.8106", name: "Kabupaten Seram Bagian Barat" },
    { code: "ID.28.8107", name: "Kabupaten Seram Bagian Timur" },
    { code: "ID.28.8108", name: "Kabupaten Maluku Barat Daya" },
    { code: "ID.28.8109", name: "Kabupaten Buru Selatan" },
    { code: "ID.28.8171", name: "Kota Ambon" },
    { code: "ID.28.8172", name: "Kota Tual" },
  ],
  "ID.29": [
    { code: "ID.29.8201", name: "Kabupaten Halmahera Barat" },
    { code: "ID.29.8202", name: "Kabupaten Halmahera Tengah" },
    { code: "ID.29.8203", name: "Kabupaten Kepulauan Sula" },
    { code: "ID.29.8204", name: "Kabupaten Halmahera Selatan" },
    { code: "ID.29.8205", name: "Kabupaten Halmahera Utara" },
    { code: "ID.29.8206", name: "East Halmahera Regency" },
    { code: "ID.29.8207", name: "Kabupaten Pulau Morotai" },
    { code: "ID.29.8208", name: "Kabupaten Pulau Taliabu" },
    { code: "ID.29.8271", name: "Kota Ternate" },
    { code: "ID.29.8272", name: "Kota Tidore Kepulauan" },
  ],
  "ID.30": [
    { code: "ID.30.3201", name: "Kabupaten Bogor" },
    { code: "ID.30.3202", name: "Kabupaten Sukabumi" },
    { code: "ID.30.3203", name: "Kabupaten Cianjur" },
    { code: "ID.30.3204", name: "Kabupaten Bandung" },
    { code: "ID.30.3205", name: "Kabupaten Garut" },
    { code: "ID.30.3206", name: "Kabupaten Tasikmalaya" },
    { code: "ID.30.3207", name: "Kabupaten Ciamis" },
    { code: "ID.30.3208", name: "Kabupaten Kuningan" },
    { code: "ID.30.3209", name: "Kabupaten Cirebon" },
    { code: "ID.30.3210", name: "Kabupaten Majalengka" },
    { code: "ID.30.3211", name: "Kabupaten Sumedang" },
    { code: "ID.30.3212", name: "Kabupaten Indramayu" },
    { code: "ID.30.3213", name: "Kabupaten Subang" },
    { code: "ID.30.3214", name: "Kabupaten Purwakarta" },
    { code: "ID.30.3215", name: "Kabupaten Karawang" },
    { code: "ID.30.3216", name: "Kabupaten Bekasi" },
    { code: "ID.30.3217", name: "Kabupaten Bandung Barat" },
    { code: "ID.30.3218", name: "Kabupaten Pangandaran" },
    { code: "ID.30.3271", name: "Kota Bogor" },
    { code: "ID.30.3272", name: "Kota Sukabumi" },
    { code: "ID.30.3273", name: "Kota Bandung" },
    { code: "ID.30.3274", name: "Kota Cirebon" },
    { code: "ID.30.3275", name: "Kota Bekasi" },
    { code: "ID.30.3276", name: "Kota Depok" },
    { code: "ID.30.3277", name: "Kota Cimahi" },
    { code: "ID.30.3278", name: "Kota Tasikmalaya" },
    { code: "ID.30.3279", name: "Kota Banjar" },
  ],
  "ID.31": [
    { code: "ID.31.7101", name: "Kabupaten Bolaang Mongondow" },
    { code: "ID.31.7102", name: "Kabupaten Minahasa" },
    { code: "ID.31.7103", name: "Kabupaten Kepulauan Sangihe" },
    { code: "ID.31.7104", name: "Kabupaten Kepulauan Talaud" },
    { code: "ID.31.7105", name: "Kabupaten Minahasa Selatan" },
    { code: "ID.31.7106", name: "Kabupaten Minahasa Utara" },
    { code: "ID.31.7107", name: "Kabupaten Bolaang Mongondow Utara" },
    { code: "ID.31.7108", name: "Kabupaten Siau Tagulandang Biaro" },
    { code: "ID.31.7109", name: "Kabupaten Minahasa Tenggara" },
    { code: "ID.31.7110", name: "Kabupaten Bolaang Mongondow Selatan" },
    { code: "ID.31.7111", name: "Kabupaten Bolaang Mongondow Timur" },
    { code: "ID.31.7171", name: "Kota Manado" },
    { code: "ID.31.7172", name: "Kota Bitung" },
    { code: "ID.31.7173", name: "Kota Tomohon" },
    { code: "ID.31.7174", name: "Kota Kotamobagu" },
  ],
  "ID.32": [
    { code: "ID.32.1601", name: "Kabupaten Ogan Komering Ulu" },
    { code: "ID.32.1602", name: "Kabupaten Ogan Komering Ilir" },
    { code: "ID.32.1603", name: "Kabupaten Muara Enim" },
    { code: "ID.32.1604", name: "Lahat Regency" },
    { code: "ID.32.1605", name: "Kabupaten Musi Rawas" },
    { code: "ID.32.1606", name: "Kabupaten Musi Banyuasin" },
    { code: "ID.32.1607", name: "Kabupaten Banyu Asin" },
    { code: "ID.32.1608", name: "Kabupaten Ogan Komering Ulu Selatan" },
    { code: "ID.32.1609", name: "Kabupaten Ogan Komering Ulu Timur" },
    { code: "ID.32.1610", name: "Kabupaten Ogan Ilir" },
    { code: "ID.32.1611", name: "Kabupaten Empat Lawang" },
    { code: "ID.32.1612", name: "Kabupaten Penukal Abab Lematang Ilir" },
    { code: "ID.32.1613", name: "Kabupaten Musi Rawas Utara" },
    { code: "ID.32.1671", name: "Kota Palembang" },
    { code: "ID.32.1672", name: "Kota Prabumulih" },
    { code: "ID.32.1673", name: "Kota Pagar Alam" },
    { code: "ID.32.1674", name: "Kota Lubuklinggau" },
  ],
  "ID.33": [
    { code: "ID.33.3601", name: "Kabupaten Pandeglang" },
    { code: "ID.33.3602", name: "Kabupaten Lebak" },
    { code: "ID.33.3603", name: "Kabupaten Tangerang" },
    { code: "ID.33.3604", name: "Kabupaten Serang" },
    { code: "ID.33.3671", name: "Kota Tangerang" },
    { code: "ID.33.3672", name: "Kota Cilegon" },
    { code: "ID.33.3673", name: "Kota Serang" },
    { code: "ID.33.3674", name: "Kota Tangerang Selatan" },
  ],
  "ID.34": [
    { code: "ID.34.7501", name: "Kabupaten Boalemo" },
    { code: "ID.34.7502", name: "Kabupaten Gorontalo" },
    { code: "ID.34.7503", name: "Kabupaten Pohuwato" },
    { code: "ID.34.7504", name: "Kabupaten Bone Bolango" },
    { code: "ID.34.7505", name: "Kabupaten Gorontalo Utara" },
    { code: "ID.34.7571", name: "Kota Gorontalo" },
  ],
  "ID.35": [
    { code: "ID.35.1901", name: "Kabupaten Bangka" },
    { code: "ID.35.1902", name: "Kabupaten Belitung" },
    { code: "ID.35.1903", name: "Kabupaten Bangka Barat" },
    { code: "ID.35.1904", name: "Kabupaten Bangka Tengah" },
    { code: "ID.35.1905", name: "Kabupaten Bangka Selatan" },
    { code: "ID.35.1906", name: "Kabupaten Belitung Timur" },
    { code: "ID.35.1971", name: "Kota Pangkal Pinang" },
  ],
  "ID.36": [
    { code: "ID.36.9401", name: "Kabupaten Merauke" },
    { code: "ID.36.9402", name: "Kabupaten Jayawijaya" },
    { code: "ID.36.9403", name: "Kabupaten Jayapura" },
    { code: "ID.36.9404", name: "Kabupaten Nabire" },
    { code: "ID.36.9408", name: "Kabupaten Kepulauan Yapen" },
    { code: "ID.36.9409", name: "Kabupaten Biak Numfor" },
    { code: "ID.36.9410", name: "Kabupaten Paniai" },
    { code: "ID.36.9411", name: "Kabupaten Puncak Jaya" },
    { code: "ID.36.9412", name: "Kabupaten Mimika" },
    { code: "ID.36.9413", name: "Kabupaten Boven Digoel" },
    { code: "ID.36.9414", name: "Kabupaten Mappi" },
    { code: "ID.36.9415", name: "Kabupaten Asmat" },
    { code: "ID.36.9416", name: "Kabupaten Yahukimo" },
    { code: "ID.36.9417", name: "Kabupaten Pegunungan Bintang" },
    { code: "ID.36.9418", name: "Kabupaten Tolikara" },
    { code: "ID.36.9419", name: "Kabupaten Sarmi" },
    { code: "ID.36.9420", name: "Kabupaten Keerom" },
    { code: "ID.36.9426", name: "Kabupaten Waropen" },
    { code: "ID.36.9427", name: "Kabupaten Supiori" },
    { code: "ID.36.9428", name: "Kabupaten Mamberamo Raya" },
    { code: "ID.36.9429", name: "Kabupaten Nduga" },
    { code: "ID.36.9430", name: "Kabupaten Lanny Jaya" },
    { code: "ID.36.9431", name: "Kabupaten Mamberamo Tengah" },
    { code: "ID.36.9432", name: "Kabupaten Yalimo" },
    { code: "ID.36.9433", name: "Kabupaten Puncak" },
    { code: "ID.36.9434", name: "Kabupaten Dogiyai" },
    { code: "ID.36.9435", name: "Kabupaten Intan Jaya" },
    { code: "ID.36.9436", name: "Kabupaten Deiyai" },
    { code: "ID.36.9471", name: "Kota Jayapura" },
  ],
  "ID.37": [
    { code: "ID.37.1401", name: "Kabupaten Kuantan Singingi" },
    { code: "ID.37.1402", name: "Kabupaten Indragiri Hulu" },
    { code: "ID.37.1403", name: "Kabupaten Indragiri Hilir" },
    { code: "ID.37.1404", name: "Kabupaten Pelalawan" },
    { code: "ID.37.1405", name: "Kabupaten Siak" },
    { code: "ID.37.1406", name: "Kabupaten Kampar" },
    { code: "ID.37.1407", name: "Kabupaten Rokan Hulu" },
    { code: "ID.37.1408", name: "Kabupaten Bengkalis" },
    { code: "ID.37.1409", name: "Kabupaten Rokan Hilir" },
    { code: "ID.37.1410", name: "Kabupaten Kepulauan Meranti" },
    { code: "ID.37.1471", name: "Kota Pekanbaru" },
    { code: "ID.37.1473", name: "Kota Dumai" },
  ],
  "ID.38": [
    { code: "ID.38.7301", name: "Selayar Islands Regency" },
    { code: "ID.38.7302", name: "Kabupaten Bulukumba" },
    { code: "ID.38.7303", name: "Kabupaten Bantaeng" },
    { code: "ID.38.7304", name: "Kabupaten Jeneponto" },
    { code: "ID.38.7305", name: "Kabupaten Takalar" },
    { code: "ID.38.7306", name: "Kabupaten Gowa" },
    { code: "ID.38.7307", name: "Kabupaten Sinjai" },
    { code: "ID.38.7308", name: "Kabupaten Maros" },
    { code: "ID.38.7309", name: "Kabupaten Pangkajene Dan Kepulauan" },
    { code: "ID.38.7310", name: "Kabupaten Barru" },
    { code: "ID.38.7311", name: "Kabupaten Bone" },
    { code: "ID.38.7312", name: "Kabupaten Soppeng" },
    { code: "ID.38.7313", name: "Kabupaten Wajo" },
    { code: "ID.38.7314", name: "Kabupaten Sidenreng Rappang" },
    { code: "ID.38.7315", name: "Kabupaten Pinrang" },
    { code: "ID.38.7316", name: "Kabupaten Enrekang" },
    { code: "ID.38.7317", name: "Kabupaten Luwu" },
    { code: "ID.38.7318", name: "Kabupaten Tana Toraja" },
    { code: "ID.38.7322", name: "Kabupaten Luwu Utara" },
    { code: "ID.38.7325", name: "Kabupaten Luwu Timur" },
    { code: "ID.38.7326", name: "Kabupaten Toraja Utara" },
    { code: "ID.38.7371", name: "Kota Makassar" },
    { code: "ID.38.7372", name: "Kota Parepare" },
    { code: "ID.38.7373", name: "Kota Palopo" },
  ],
  "ID.39": [
    { code: "ID.39.9101", name: "Kabupaten Fakfak" },
    { code: "ID.39.9102", name: "Kabupaten Kaimana" },
    { code: "ID.39.9103", name: "Kabupaten Teluk Wondama" },
    { code: "ID.39.9104", name: "Kabupaten Teluk Bintuni" },
    { code: "ID.39.9105", name: "Kabupaten Manokwari" },
    { code: "ID.39.9106", name: "Kabupaten Sorong Selatan" },
    { code: "ID.39.9107", name: "Kabupaten Sorong" },
    { code: "ID.39.9108", name: "Kabupaten Raja Ampat" },
    { code: "ID.39.9109", name: "Kabupaten Tambrauw" },
    { code: "ID.39.9110", name: "Kabupaten Maybrat" },
    { code: "ID.39.9111", name: "Kabupaten Manokwari Selatan" },
    { code: "ID.39.9112", name: "Kabupaten Pegunungan Arfak" },
    { code: "ID.39.9171", name: "Kota Sorong" },
  ],
  "ID.40": [
    { code: "ID.40.2101", name: "Kabupaten Karimun" },
    { code: "ID.40.2102", name: "Kabupaten Bintan" },
    { code: "ID.40.2103", name: "Kabupaten Natuna" },
    { code: "ID.40.2104", name: "Kabupaten Lingga" },
    { code: "ID.40.2105", name: "Kabupaten Kepulauan Anambas" },
    { code: "ID.40.2171", name: "Kota Batam" },
    { code: "ID.40.2172", name: "Kota Tanjung Pinang" },
  ],
  "ID.41": [
    { code: "ID.41.7601", name: "Kabupaten Majene" },
    { code: "ID.41.7602", name: "Kabupaten Polewali Mandar" },
    { code: "ID.41.7603", name: "Kabupaten Mamasa" },
    { code: "ID.41.7604", name: "Kabupaten Mamuju" },
    { code: "ID.41.7605", name: "Kabupaten Mamuju Utara" },
    { code: "ID.41.7606", name: "Kabupaten Mamuju Tengah" },
  ],
  "ID.42": [
    { code: "ID.42.6501", name: "Kabupaten Malinau" },
    { code: "ID.42.6502", name: "Kabupaten Bulungan" },
    { code: "ID.42.6503", name: "Kabupaten Tana Tidung" },
    { code: "ID.42.6504", name: "Kabupaten Nunukan" },
    { code: "ID.42.6571", name: "Kota Tarakan" },
  ],
  "IE.C": [
    { code: "IE.C.10", name: "County Galway" },
    { code: "IE.C.14", name: "County Leitrim" },
    { code: "IE.C.20", name: "Mayo County" },
    { code: "IE.C.24", name: "Roscommon" },
    { code: "IE.C.25", name: "Sligo" },
    { code: "IE.C.36", name: "Galway City" },
  ],
  "IE.L": [
    { code: "IE.L.01", name: "County Carlow" },
    { code: "IE.L.12", name: "Kildare" },
    { code: "IE.L.13", name: "Kilkenny" },
    { code: "IE.L.15", name: "Laois" },
    { code: "IE.L.18", name: "An Longfort" },
    { code: "IE.L.19", name: "Lú" },
    { code: "IE.L.21", name: "An Mhí" },
    { code: "IE.L.23", name: "Uíbh Fhailí" },
    { code: "IE.L.29", name: "An Iarmhí" },
    { code: "IE.L.30", name: "Loch Garman" },
    { code: "IE.L.31", name: "Wicklow" },
    { code: "IE.L.33", name: "Dublin City" },
    { code: "IE.L.34", name: "Dún Laoghaire-Rathdown" },
    { code: "IE.L.35", name: "Fingal County" },
    { code: "IE.L.39", name: "South Dublin" },
  ],
  "IE.M": [
    { code: "IE.M.03", name: "An Clár" },
    { code: "IE.M.04", name: "County Cork" },
    { code: "IE.M.11", name: "Ciarraí" },
    { code: "IE.M.26", name: "County Tipperary" },
    { code: "IE.M.32", name: "Cork City" },
    { code: "IE.M.42", name: "Limerick City and County Council" },
    { code: "IE.M.44", name: "County Waterford" },
  ],
  "IE.U": [
    { code: "IE.U.02", name: "An Cabhán" },
    { code: "IE.U.06", name: "County Donegal" },
    { code: "IE.U.22", name: "County Monaghan" },
  ],
  "IL.01": [
    { code: "IL.01.12046836", name: "Nefat Be’er Sheva‘" },
    { code: "IL.01.295618", name: "Ashqelon" },
    { code: "IL.01.7870269", name: "Gaza" },
  ],
  "IL.02": [
    { code: "IL.02.12046845", name: "Nefat Reẖovot" },
    { code: "IL.02.12046847", name: "Nefat Ramla" },
    { code: "IL.02.12046848", name: "Nefat Petaẖ Tiqvva" },
    { code: "IL.02.12046849", name: "Nefat HaSharon" },
  ],
  "IL.03": [
    { code: "IL.03.12046852", name: "Nefat Yizre‘el" },
    { code: "IL.03.12046853", name: "Nefat Tsefat" },
    { code: "IL.03.12046854", name: "Nafat HaGolan" },
    { code: "IL.03.12046855", name: "Nefat Kinneret" },
    { code: "IL.03.295719", name: "‘Akko" },
  ],
  "IL.04": [
    { code: "IL.04.12046851", name: "Nefat H̱adera" },
    { code: "IL.04.294798", name: "H̱efa" },
  ],
  "IL.05": [
    { code: "IL.05.12046850", name: "Nefat Tel Aviv" },
  ],
  "IL.06": [
    { code: "IL.06.12046838", name: "Nefat Yerushalayim" },
  ],
  "IL.WE": [
    { code: "IL.WE.11821182", name: "Mateh Binyamin Regional Council" },
  ],
  "IN.01": [
    { code: "IN.01.638", name: "Nicobar" },
    { code: "IN.01.639", name: "North  & Middle Andaman" },
    { code: "IN.01.640", name: "South Andaman" },
  ],
  "IN.02": [
    { code: "IN.02.542", name: "Srīkākulam" },
    { code: "IN.02.543", name: "Vizianagaram District" },
    { code: "IN.02.544", name: "Vishākhapatnam" },
    { code: "IN.02.545", name: "East Godāvari" },
    { code: "IN.02.546", name: "West Godāvari" },
    { code: "IN.02.547", name: "Krishna" },
    { code: "IN.02.548", name: "Guntūr" },
    { code: "IN.02.549", name: "Prakasam" },
    { code: "IN.02.550", name: "Nellore" },
    { code: "IN.02.551", name: "Cuddapah" },
    { code: "IN.02.552", name: "Kurnool" },
    { code: "IN.02.553", name: "Anantapur" },
    { code: "IN.02.554", name: "Chittoor" },
  ],
  "IN.03": [
    { code: "IN.03.300", name: "Kokrajhar" },
    { code: "IN.03.301", name: "Dhubri" },
    { code: "IN.03.302", name: "Goālpāra" },
    { code: "IN.03.303", name: "Barpeta" },
    { code: "IN.03.304", name: "Morigaon" },
    { code: "IN.03.305", name: "Nagaon" },
    { code: "IN.03.306", name: "Sonitpur" },
    { code: "IN.03.307", name: "Lakhimpur" },
    { code: "IN.03.308", name: "Dhemaji" },
    { code: "IN.03.309", name: "Tinsukia" },
    { code: "IN.03.310", name: "Dibrugarh" },
    { code: "IN.03.311", name: "Sibsāgar" },
    { code: "IN.03.312", name: "Jorhat" },
    { code: "IN.03.313", name: "Golaghat" },
    { code: "IN.03.314", name: "Kārbi Ānglong" },
    { code: "IN.03.315", name: "Dima Hasao District" },
    { code: "IN.03.316", name: "Cāchār" },
    { code: "IN.03.317", name: "Karimganj" },
    { code: "IN.03.318", name: "Hailakandi" },
    { code: "IN.03.319", name: "Bongaigaon" },
    { code: "IN.03.320", name: "Chirang" },
    { code: "IN.03.321", name: "Kāmrūp" },
    { code: "IN.03.322", name: "Kamrup Metropolitan" },
    { code: "IN.03.323", name: "Nalbari" },
    { code: "IN.03.324", name: "Baksa" },
    { code: "IN.03.325", name: "Darrang" },
    { code: "IN.03.326", name: "Udalguri" },
    { code: "IN.03.705", name: "Biswanath" },
    { code: "IN.03.706", name: "Majuli" },
    { code: "IN.03.707", name: "South Salmara Mancachar" },
    { code: "IN.03.708", name: "Charaideo" },
    { code: "IN.03.709", name: "Hojai" },
    { code: "IN.03.710", name: "West Karbi Anglong" },
  ],
  "IN.05": [
    { code: "IN.05.055", name: "Chandigarh" },
  ],
  "IN.06": [
    { code: "IN.06.496", name: "Dadra & Nagar Haveli" },
  ],
  "IN.07": [
    { code: "IN.07.090", name: "North West Delhi" },
    { code: "IN.07.091", name: "North Delhi" },
    { code: "IN.07.092", name: "North East Delhi" },
    { code: "IN.07.093", name: "East Delhi" },
    { code: "IN.07.094", name: "New Delhi" },
    { code: "IN.07.095", name: "Central Delhi" },
    { code: "IN.07.096", name: "West Delhi" },
    { code: "IN.07.097", name: "South West Delhi" },
    { code: "IN.07.098", name: "South Delhi" },
    { code: "IN.07.670", name: "South East" },
    { code: "IN.07.671", name: "Shahdara" },
  ],
  "IN.09": [
    { code: "IN.09.468", name: "Kachchh" },
    { code: "IN.09.469", name: "Banās Kāntha" },
    { code: "IN.09.470", name: "Patan" },
    { code: "IN.09.471", name: "Mahesāna" },
    { code: "IN.09.472", name: "Sabar Kāntha" },
    { code: "IN.09.473", name: "Gāndhīnagar" },
    { code: "IN.09.474", name: "Ahmadābād" },
    { code: "IN.09.475", name: "Surendranagar" },
    { code: "IN.09.476", name: "Rājkot" },
    { code: "IN.09.477", name: "Jāmnagar" },
    { code: "IN.09.478", name: "Porbandar" },
    { code: "IN.09.479", name: "Jūnāgadh" },
    { code: "IN.09.480", name: "Amreli" },
    { code: "IN.09.481", name: "Bhāvnagar" },
    { code: "IN.09.482", name: "Anand" },
    { code: "IN.09.483", name: "Kheda" },
    { code: "IN.09.484", name: "Pānch Mahāls" },
    { code: "IN.09.485", name: "Dohad" },
    { code: "IN.09.486", name: "Vadodara" },
    { code: "IN.09.487", name: "Narmada" },
    { code: "IN.09.488", name: "Bharūch" },
    { code: "IN.09.489", name: "The Dāngs" },
    { code: "IN.09.490", name: "Navsari" },
    { code: "IN.09.491", name: "Valsād" },
    { code: "IN.09.492", name: "Sūrat" },
    { code: "IN.09.493", name: "Tapi" },
    { code: "IN.09.668", name: "Chhotaudepur" },
    { code: "IN.09.669", name: "Mahisagar" },
    { code: "IN.09.672", name: "Arvalli" },
    { code: "IN.09.673", name: "Morbi" },
    { code: "IN.09.674", name: "Devbhumi Dwarka" },
    { code: "IN.09.675", name: "Gir Somnath" },
    { code: "IN.09.676", name: "Botad" },
  ],
  "IN.10": [
    { code: "IN.10.069", name: "Panchkula" },
    { code: "IN.10.070", name: "Ambāla" },
    { code: "IN.10.071", name: "Yamunanagar" },
    { code: "IN.10.072", name: "Kurukshetra" },
    { code: "IN.10.073", name: "Kaithal" },
    { code: "IN.10.074", name: "Karnāl" },
    { code: "IN.10.075", name: "Panipat" },
    { code: "IN.10.076", name: "Sonīpat" },
    { code: "IN.10.077", name: "Jīnd" },
    { code: "IN.10.078", name: "Fatehabad District" },
    { code: "IN.10.079", name: "Sirsa" },
    { code: "IN.10.080", name: "Hisār" },
    { code: "IN.10.081", name: "Bhiwani" },
    { code: "IN.10.082", name: "Rohtak" },
    { code: "IN.10.083", name: "Jhajjar" },
    { code: "IN.10.084", name: "Mahendragarh" },
    { code: "IN.10.085", name: "Rewari District" },
    { code: "IN.10.086", name: "Gurgaon" },
    { code: "IN.10.087", name: "Mewat" },
    { code: "IN.10.088", name: "Faridabad District" },
    { code: "IN.10.089", name: "Palwal" },
    { code: "IN.10.701", name: "Charki Dadri" },
  ],
  "IN.11": [
    { code: "IN.11.023", name: "Chamba" },
    { code: "IN.11.024", name: "Kāngra" },
    { code: "IN.11.025", name: "Lāhul and Spiti" },
    { code: "IN.11.026", name: "Kulu" },
    { code: "IN.11.027", name: "Mandi" },
    { code: "IN.11.028", name: "Hamīrpur" },
    { code: "IN.11.029", name: "Una" },
    { code: "IN.11.030", name: "Bilāspur" },
    { code: "IN.11.031", name: "Solan" },
    { code: "IN.11.032", name: "Sirmaur" },
    { code: "IN.11.033", name: "Shimla" },
    { code: "IN.11.034", name: "Kinnaur" },
  ],
  "IN.12": [
    { code: "IN.12.001", name: "Kupwara" },
    { code: "IN.12.002", name: "Badgam" },
    { code: "IN.12.005", name: "Punch" },
    { code: "IN.12.006", name: "Rājauri" },
    { code: "IN.12.007", name: "Kathua" },
    { code: "IN.12.008", name: "Bāramūla" },
    { code: "IN.12.009", name: "Bandipore" },
    { code: "IN.12.010", name: "Srīnagar" },
    { code: "IN.12.011", name: "Ganderbal" },
    { code: "IN.12.012", name: "Pulwama" },
    { code: "IN.12.013", name: "Shupiyan" },
    { code: "IN.12.014", name: "Anantnāg" },
    { code: "IN.12.015", name: "Kulgam" },
    { code: "IN.12.016", name: "Doda" },
    { code: "IN.12.017", name: "Ramban" },
    { code: "IN.12.018", name: "Kishtwar" },
    { code: "IN.12.019", name: "Udhampur" },
    { code: "IN.12.020", name: "Reasi" },
    { code: "IN.12.021", name: "Jammu" },
    { code: "IN.12.022", name: "Samba" },
  ],
  "IN.13": [
    { code: "IN.13.588", name: "Kāsaragod District" },
    { code: "IN.13.589", name: "Kannur" },
    { code: "IN.13.590", name: "Wayanad" },
    { code: "IN.13.591", name: "Kozhikode" },
    { code: "IN.13.592", name: "Malappuram" },
    { code: "IN.13.593", name: "Palakkad district" },
    { code: "IN.13.594", name: "Thrissur District" },
    { code: "IN.13.595", name: "Ernākulam" },
    { code: "IN.13.596", name: "Idukki" },
    { code: "IN.13.597", name: "Kottayam" },
    { code: "IN.13.598", name: "Alappuzha" },
    { code: "IN.13.599", name: "Pattanamtitta" },
    { code: "IN.13.600", name: "Kollam" },
    { code: "IN.13.601", name: "Thiruvananthapuram" },
  ],
  "IN.14": [
    { code: "IN.14.587", name: "Lakshadweep" },
  ],
  "IN.16": [
    { code: "IN.16.497", name: "Nandurbar" },
    { code: "IN.16.498", name: "Dhule" },
    { code: "IN.16.499", name: "Jalgaon" },
    { code: "IN.16.500", name: "Buldana" },
    { code: "IN.16.501", name: "Akola" },
    { code: "IN.16.502", name: "Washim" },
    { code: "IN.16.503", name: "Amravati Division" },
    { code: "IN.16.504", name: "Wardha" },
    { code: "IN.16.505", name: "Nagpur Division" },
    { code: "IN.16.506", name: "Bhandara" },
    { code: "IN.16.507", name: "Gondiya" },
    { code: "IN.16.508", name: "Gadchiroli" },
    { code: "IN.16.509", name: "Chandrapur" },
    { code: "IN.16.510", name: "Yavatmal" },
    { code: "IN.16.511", name: "Nanded" },
    { code: "IN.16.512", name: "Hingoli" },
    { code: "IN.16.513", name: "Parbhani" },
    { code: "IN.16.514", name: "Jalna" },
    { code: "IN.16.515", name: "Aurangabad" },
    { code: "IN.16.516", name: "Nashik Division" },
    { code: "IN.16.517", name: "Thane" },
    { code: "IN.16.518", name: "Mumbai Suburban" },
    { code: "IN.16.519", name: "Mumbai" },
    { code: "IN.16.520", name: "Raigarh" },
    { code: "IN.16.521", name: "Pune Division" },
    { code: "IN.16.522", name: "Ahmadnagar" },
    { code: "IN.16.523", name: "Bid" },
    { code: "IN.16.524", name: "Latur" },
    { code: "IN.16.525", name: "Osmanabad" },
    { code: "IN.16.526", name: "Solapur" },
    { code: "IN.16.527", name: "Satara Division" },
    { code: "IN.16.528", name: "Ratnagiri" },
    { code: "IN.16.529", name: "Sindhudurg" },
    { code: "IN.16.530", name: "Kolhapur" },
    { code: "IN.16.531", name: "Sangli" },
    { code: "IN.16.665", name: "Palghar" },
  ],
  "IN.17": [
    { code: "IN.17.272", name: "Senapati" },
    { code: "IN.17.273", name: "Tamenglong" },
    { code: "IN.17.274", name: "Churachandpur" },
    { code: "IN.17.275", name: "Bishnupur" },
    { code: "IN.17.276", name: "Thoubal" },
    { code: "IN.17.277", name: "Imphal West" },
    { code: "IN.17.278", name: "Imphal East" },
    { code: "IN.17.279", name: "Ukhrul" },
    { code: "IN.17.280", name: "Chandel" },
    { code: "IN.17.711", name: "Kakching" },
    { code: "IN.17.712", name: "Kangpokpi" },
    { code: "IN.17.713", name: "Jiribam" },
    { code: "IN.17.714", name: "Noney" },
    { code: "IN.17.715", name: "Pherzawl" },
    { code: "IN.17.716", name: "Tengnoupal" },
    { code: "IN.17.717", name: "Kamjong" },
  ],
  "IN.18": [
    { code: "IN.18.293", name: "West Garo Hills" },
    { code: "IN.18.294", name: "East Gāro Hills" },
    { code: "IN.18.295", name: "South Garo Hills" },
    { code: "IN.18.296", name: "West Khasi Hills" },
    { code: "IN.18.297", name: "Ri-Bhoi" },
    { code: "IN.18.298", name: "East Khāsi Hills" },
    { code: "IN.18.299", name: "West Jaintia Hills" },
    { code: "IN.18.656", name: "North Garo Hills" },
    { code: "IN.18.657", name: "East Jaintia Hills" },
    { code: "IN.18.658", name: "South West Khasi Hills" },
    { code: "IN.18.663", name: "South West Garo Hills" },
  ],
  "IN.19": [
    { code: "IN.19.555", name: "Belgaum" },
    { code: "IN.19.556", name: "Bagalkot" },
    { code: "IN.19.557", name: "Bijāpur" },
    { code: "IN.19.558", name: "Bīdar" },
    { code: "IN.19.559", name: "Raichur" },
    { code: "IN.19.560", name: "Koppal" },
    { code: "IN.19.561", name: "Gadag" },
    { code: "IN.19.562", name: "Dharwad" },
    { code: "IN.19.563", name: "Uttar Kannada" },
    { code: "IN.19.564", name: "Haveri" },
    { code: "IN.19.565", name: "Ballari" },
    { code: "IN.19.566", name: "Chitradurga" },
    { code: "IN.19.567", name: "Davanagere" },
    { code: "IN.19.568", name: "Shimoga" },
    { code: "IN.19.569", name: "Udupi" },
    { code: "IN.19.570", name: "Chikmagalur" },
    { code: "IN.19.571", name: "Tumkur" },
    { code: "IN.19.572", name: "Bangalore Urban" },
    { code: "IN.19.573", name: "Mandya" },
    { code: "IN.19.574", name: "Hassan" },
    { code: "IN.19.575", name: "Dakshina Kannada" },
    { code: "IN.19.576", name: "Kodagu" },
    { code: "IN.19.577", name: "Mysore" },
    { code: "IN.19.578", name: "Chamrajnagar" },
    { code: "IN.19.579", name: "Gulbarga" },
    { code: "IN.19.580", name: "Yadgir" },
    { code: "IN.19.581", name: "Kolar" },
    { code: "IN.19.582", name: "Chikkaballapur" },
    { code: "IN.19.583", name: "Bangalore Rural" },
    { code: "IN.19.584", name: "Ramanagara" },
  ],
  "IN.20": [
    { code: "IN.20.261", name: "Mon" },
    { code: "IN.20.262", name: "Mokokchūng" },
    { code: "IN.20.263", name: "Zunheboto" },
    { code: "IN.20.264", name: "Wokha" },
    { code: "IN.20.265", name: "Dimapur" },
    { code: "IN.20.266", name: "Phek" },
    { code: "IN.20.267", name: "Tuensang District" },
    { code: "IN.20.268", name: "Longleng" },
    { code: "IN.20.269", name: "Kiphire" },
    { code: "IN.20.270", name: "Kohīma" },
    { code: "IN.20.271", name: "Peren" },
  ],
  "IN.21": [
    { code: "IN.21.370", name: "Baragarh" },
    { code: "IN.21.371", name: "Jharsuguda District" },
    { code: "IN.21.372", name: "Sambalpur" },
    { code: "IN.21.373", name: "Debagarh" },
    { code: "IN.21.374", name: "Sundargarh" },
    { code: "IN.21.375", name: "Kendujhar" },
    { code: "IN.21.376", name: "Mayūrbhanj" },
    { code: "IN.21.377", name: "Bāleshwar" },
    { code: "IN.21.378", name: "Bhadrak" },
    { code: "IN.21.379", name: "Kendrapara" },
    { code: "IN.21.380", name: "Jagatsinghpur" },
    { code: "IN.21.381", name: "Cuttack" },
    { code: "IN.21.382", name: "Jajpur" },
    { code: "IN.21.383", name: "Dhenkānāl" },
    { code: "IN.21.384", name: "Angul District" },
    { code: "IN.21.385", name: "Nayagarh District" },
    { code: "IN.21.386", name: "Khordha" },
    { code: "IN.21.387", name: "Puri" },
    { code: "IN.21.388", name: "Ganjām" },
    { code: "IN.21.389", name: "Gajapati" },
    { code: "IN.21.390", name: "Kandhamal" },
    { code: "IN.21.391", name: "Baudh" },
    { code: "IN.21.392", name: "Subarnapur" },
    { code: "IN.21.393", name: "Balāngīr" },
    { code: "IN.21.394", name: "Nuapada" },
    { code: "IN.21.395", name: "Kālāhandi" },
    { code: "IN.21.396", name: "Rayagada" },
    { code: "IN.21.397", name: "Nabarangpur" },
    { code: "IN.21.398", name: "Koraput" },
    { code: "IN.21.399", name: "Malkangiri" },
  ],
  "IN.22": [
    { code: "IN.22.634", name: "Yanam" },
    { code: "IN.22.635", name: "Puducherry" },
    { code: "IN.22.636", name: "Mahe" },
    { code: "IN.22.637", name: "Kāraikāl" },
  ],
  "IN.23": [
    { code: "IN.23.035", name: "Gurdaspur" },
    { code: "IN.23.036", name: "Kapurthala" },
    { code: "IN.23.037", name: "Jalandhar" },
    { code: "IN.23.038", name: "Hoshiarpur" },
    { code: "IN.23.039", name: "Shahid Bhagat Singh Nagar" },
    { code: "IN.23.040", name: "Fatehgarh Sahib" },
    { code: "IN.23.041", name: "Ludhiana" },
    { code: "IN.23.042", name: "Moga" },
    { code: "IN.23.043", name: "Firozpur" },
    { code: "IN.23.044", name: "Muktsar" },
    { code: "IN.23.045", name: "Faridkot" },
    { code: "IN.23.046", name: "Bathinda" },
    { code: "IN.23.047", name: "Mansa" },
    { code: "IN.23.048", name: "Patiala" },
    { code: "IN.23.049", name: "Amritsar" },
    { code: "IN.23.050", name: "Tarn Taran" },
    { code: "IN.23.051", name: "Rupnagar" },
    { code: "IN.23.052", name: "Ajitgarh" },
    { code: "IN.23.053", name: "Sangrur" },
    { code: "IN.23.054", name: "Barnala" },
    { code: "IN.23.8407166", name: "Fazilka" },
    { code: "IN.23.8408318", name: "Pathankot" },
  ],
  "IN.24": [
    { code: "IN.24.099", name: "Gangānagar" },
    { code: "IN.24.100", name: "Hanumangarh" },
    { code: "IN.24.101", name: "Bīkāner" },
    { code: "IN.24.102", name: "Chūru" },
    { code: "IN.24.103", name: "Jhunjhunūn" },
    { code: "IN.24.104", name: "Alwar" },
    { code: "IN.24.105", name: "Bharatpur" },
    { code: "IN.24.106", name: "Dhaulpur" },
    { code: "IN.24.107", name: "Karauli" },
    { code: "IN.24.108", name: "Sawāi Mādhopur" },
    { code: "IN.24.109", name: "Dausa" },
    { code: "IN.24.110", name: "Jaipur" },
    { code: "IN.24.111", name: "Sīkar" },
    { code: "IN.24.112", name: "Nāgaur" },
    { code: "IN.24.113", name: "Jodhpur" },
    { code: "IN.24.114", name: "Jaisalmer" },
    { code: "IN.24.115", name: "Bārmer" },
    { code: "IN.24.116", name: "Jalore" },
    { code: "IN.24.117", name: "Sirohi" },
    { code: "IN.24.118", name: "Pāli" },
    { code: "IN.24.119", name: "Ajmer" },
    { code: "IN.24.120", name: "Tonk" },
    { code: "IN.24.121", name: "Būndi" },
    { code: "IN.24.122", name: "Bhīlwāra" },
    { code: "IN.24.123", name: "Rajsamand" },
    { code: "IN.24.124", name: "Dūngarpur" },
    { code: "IN.24.125", name: "Bānswāra" },
    { code: "IN.24.126", name: "Chittaurgarh" },
    { code: "IN.24.127", name: "Kota" },
    { code: "IN.24.128", name: "Baran" },
    { code: "IN.24.129", name: "Jhālāwār" },
    { code: "IN.24.130", name: "Udaipur" },
    { code: "IN.24.131", name: "Pratapgarh" },
  ],
  "IN.25": [
    { code: "IN.25.602", name: "Thiruvallur" },
    { code: "IN.25.603", name: "Chennai" },
    { code: "IN.25.604", name: "Kancheepuram" },
    { code: "IN.25.605", name: "Vellore" },
    { code: "IN.25.606", name: "Tiruvannamalai" },
    { code: "IN.25.607", name: "Villupuram" },
    { code: "IN.25.608", name: "Salem" },
    { code: "IN.25.609", name: "Namakkal" },
    { code: "IN.25.610", name: "Erode" },
    { code: "IN.25.611", name: "Nilgiris" },
    { code: "IN.25.612", name: "Dindigul" },
    { code: "IN.25.613", name: "Karur" },
    { code: "IN.25.614", name: "Tiruchirappalli" },
    { code: "IN.25.615", name: "Perambalur" },
    { code: "IN.25.616", name: "Ariyalur" },
    { code: "IN.25.617", name: "Cuddalore" },
    { code: "IN.25.618", name: "Nagapattinam" },
    { code: "IN.25.619", name: "Thiruvarur" },
    { code: "IN.25.620", name: "Thanjavur" },
    { code: "IN.25.621", name: "Pudukkottai" },
    { code: "IN.25.622", name: "Sivaganga" },
    { code: "IN.25.623", name: "Madurai" },
    { code: "IN.25.624", name: "Theni" },
    { code: "IN.25.625", name: "Virudhunagar" },
    { code: "IN.25.626", name: "Rāmanāthapuram" },
    { code: "IN.25.627", name: "Thoothukkudi" },
    { code: "IN.25.628", name: "Tirunelveli Kattabo" },
    { code: "IN.25.629", name: "Kanniyakumari" },
    { code: "IN.25.630", name: "Dharmapuri" },
    { code: "IN.25.631", name: "Krishnagiri" },
    { code: "IN.25.632", name: "Coimbatore" },
    { code: "IN.25.633", name: "Tiruppur" },
  ],
  "IN.26": [
    { code: "IN.26.289", name: "West Tripura" },
    { code: "IN.26.290", name: "South Tripura" },
    { code: "IN.26.291", name: "Dhalai" },
    { code: "IN.26.292", name: "North Tripura" },
    { code: "IN.26.652", name: "Khowai" },
    { code: "IN.26.653", name: "Sepahijala" },
    { code: "IN.26.654", name: "Gomati" },
    { code: "IN.26.655", name: "Unakoti" },
  ],
  "IN.28": [
    { code: "IN.28.327", name: "Darjiling" },
    { code: "IN.28.328", name: "Jalpāiguri" },
    { code: "IN.28.329", name: "Koch Bihār" },
    { code: "IN.28.330", name: "Uttar Dinajpur" },
    { code: "IN.28.331", name: "Dakshin Dinajpur" },
    { code: "IN.28.332", name: "Māldah" },
    { code: "IN.28.333", name: "Murshidabad" },
    { code: "IN.28.334", name: "Bīrbhūm" },
    { code: "IN.28.335", name: "Barddhamān" },
    { code: "IN.28.336", name: "Nadia" },
    { code: "IN.28.337", name: "North 24 Parganas" },
    { code: "IN.28.338", name: "Hugli" },
    { code: "IN.28.339", name: "Bānkurā" },
    { code: "IN.28.340", name: "Puruliya" },
    { code: "IN.28.341", name: "Hāora" },
    { code: "IN.28.342", name: "Kolkata" },
    { code: "IN.28.343", name: "South 24 Parganas" },
    { code: "IN.28.344", name: "Paschim Medinipur" },
    { code: "IN.28.345", name: "Purba Medinipur" },
    { code: "IN.28.664", name: "Alipurduar" },
    { code: "IN.28.702", name: "Kalimpong" },
    { code: "IN.28.703", name: "Jhargram" },
    { code: "IN.28.704", name: "Paschim Bardhaman" },
  ],
  "IN.29": [
    { code: "IN.29.241", name: "North District" },
    { code: "IN.29.242", name: "West District" },
    { code: "IN.29.243", name: "South District" },
    { code: "IN.29.244", name: "East District" },
  ],
  "IN.30": [
    { code: "IN.30.245", name: "Tawang" },
    { code: "IN.30.246", name: "West Kameng" },
    { code: "IN.30.247", name: "East Kameng" },
    { code: "IN.30.248", name: "Papum Pare" },
    { code: "IN.30.249", name: "Upper Subansiri" },
    { code: "IN.30.250", name: "West Siang" },
    { code: "IN.30.251", name: "East Siang" },
    { code: "IN.30.252", name: "Upper Siang" },
    { code: "IN.30.253", name: "Changlang" },
    { code: "IN.30.254", name: "Tirāp" },
    { code: "IN.30.255", name: "Lower Subansiri" },
    { code: "IN.30.256", name: "Kurung Kumey" },
    { code: "IN.30.257", name: "Dibāng Valley" },
    { code: "IN.30.258", name: "Lower Dibang Valley" },
    { code: "IN.30.259", name: "Lohit District" },
    { code: "IN.30.260", name: "Anjaw" },
    { code: "IN.30.666", name: "Longding" },
    { code: "IN.30.677", name: "Kra Daadi" },
    { code: "IN.30.678", name: "Namsai" },
    { code: "IN.30.679", name: "Siang" },
    { code: "IN.30.720", name: "Lower Siang" },
  ],
  "IN.31": [
    { code: "IN.31.281", name: "Mamit" },
    { code: "IN.31.282", name: "Kolasib district" },
    { code: "IN.31.283", name: "Aizawl" },
    { code: "IN.31.284", name: "Champhai" },
    { code: "IN.31.285", name: "Serchhip" },
    { code: "IN.31.286", name: "Lunglei" },
    { code: "IN.31.287", name: "Lawngtlai" },
    { code: "IN.31.288", name: "Saiha" },
  ],
  "IN.32": [
    { code: "IN.32.494", name: "Diu" },
    { code: "IN.32.495", name: "Daman District" },
  ],
  "IN.33": [
    { code: "IN.33.585", name: "North Goa" },
    { code: "IN.33.586", name: "South Goa" },
  ],
  "IN.34": [
    { code: "IN.34.203", name: "Pashchim Champāran" },
    { code: "IN.34.204", name: "Pūrba Champāran" },
    { code: "IN.34.205", name: "Sheohar" },
    { code: "IN.34.206", name: "Sītāmarhi" },
    { code: "IN.34.207", name: "Madhubani" },
    { code: "IN.34.208", name: "Supaul" },
    { code: "IN.34.209", name: "Araria" },
    { code: "IN.34.210", name: "Kishanganj" },
    { code: "IN.34.211", name: "Purnia" },
    { code: "IN.34.212", name: "Katihar" },
    { code: "IN.34.213", name: "Madhepura" },
    { code: "IN.34.214", name: "Saharsa" },
    { code: "IN.34.215", name: "Darbhanga" },
    { code: "IN.34.216", name: "Muzaffarpur" },
    { code: "IN.34.217", name: "Gopālganj" },
    { code: "IN.34.218", name: "Siwān" },
    { code: "IN.34.219", name: "Sāran" },
    { code: "IN.34.220", name: "Vaishāli" },
    { code: "IN.34.221", name: "Samastīpur" },
    { code: "IN.34.222", name: "Begusarāi" },
    { code: "IN.34.223", name: "Khagaria" },
    { code: "IN.34.224", name: "Bhāgalpur" },
    { code: "IN.34.225", name: "Banka" },
    { code: "IN.34.226", name: "Munger" },
    { code: "IN.34.227", name: "Lakhisarai" },
    { code: "IN.34.228", name: "Sheikhpura" },
    { code: "IN.34.229", name: "Nālanda" },
    { code: "IN.34.230", name: "Patna" },
    { code: "IN.34.231", name: "Bhojpur" },
    { code: "IN.34.232", name: "Buxar" },
    { code: "IN.34.233", name: "Kaimur District" },
    { code: "IN.34.234", name: "Rohtās" },
    { code: "IN.34.235", name: "Aurangābād" },
    { code: "IN.34.236", name: "Gayā" },
    { code: "IN.34.237", name: "Nawāda" },
    { code: "IN.34.238", name: "Jamui" },
    { code: "IN.34.239", name: "Jehanabad" },
    { code: "IN.34.240", name: "Arwal" },
  ],
  "IN.35": [
    { code: "IN.35.418", name: "Sheopur" },
    { code: "IN.35.419", name: "Morena" },
    { code: "IN.35.420", name: "Bhind" },
    { code: "IN.35.421", name: "Gwalior" },
    { code: "IN.35.422", name: "Datia" },
    { code: "IN.35.423", name: "Shivpurī" },
    { code: "IN.35.424", name: "Tīkamgarh" },
    { code: "IN.35.425", name: "Chhatarpur" },
    { code: "IN.35.426", name: "Panna" },
    { code: "IN.35.427", name: "Sāgar" },
    { code: "IN.35.428", name: "Damoh" },
    { code: "IN.35.429", name: "Satna" },
    { code: "IN.35.430", name: "Rewa" },
    { code: "IN.35.431", name: "Umaria District" },
    { code: "IN.35.432", name: "Neemuch" },
    { code: "IN.35.433", name: "Mandsaur" },
    { code: "IN.35.434", name: "Ratlām" },
    { code: "IN.35.435", name: "Ujjain" },
    { code: "IN.35.436", name: "Shājāpur" },
    { code: "IN.35.437", name: "Dewas" },
    { code: "IN.35.438", name: "Dhār" },
    { code: "IN.35.439", name: "Indore" },
    { code: "IN.35.440", name: "Khargone" },
    { code: "IN.35.441", name: "Barwani" },
    { code: "IN.35.442", name: "Rājgarh" },
    { code: "IN.35.443", name: "Vidisha" },
    { code: "IN.35.444", name: "Bhopāl" },
    { code: "IN.35.445", name: "Sehore" },
    { code: "IN.35.446", name: "Raisen" },
    { code: "IN.35.447", name: "Betūl" },
    { code: "IN.35.448", name: "Harda" },
    { code: "IN.35.449", name: "Hoshangābād" },
    { code: "IN.35.450", name: "Katni" },
    { code: "IN.35.451", name: "Jabalpur" },
    { code: "IN.35.452", name: "Narsimhapur" },
    { code: "IN.35.453", name: "Dindori" },
    { code: "IN.35.454", name: "Mandla" },
    { code: "IN.35.455", name: "Chhindwāra" },
    { code: "IN.35.456", name: "Seonī" },
    { code: "IN.35.457", name: "Bālāghāt" },
    { code: "IN.35.458", name: "Guna" },
    { code: "IN.35.459", name: "Ashoknagar" },
    { code: "IN.35.460", name: "Shahdol" },
    { code: "IN.35.461", name: "Anuppur" },
    { code: "IN.35.462", name: "Sidhi" },
    { code: "IN.35.463", name: "Singrauli" },
    { code: "IN.35.464", name: "Jhābua" },
    { code: "IN.35.465", name: "Alirajpur" },
    { code: "IN.35.466", name: "Khandwa district" },
    { code: "IN.35.467", name: "Burhanpur" },
    { code: "IN.35.667", name: "Agar Malwa" },
  ],
  "IN.36": [
    { code: "IN.36.132", name: "Sahāranpur" },
    { code: "IN.36.133", name: "Muzaffarnagar" },
    { code: "IN.36.134", name: "Bijnor" },
    { code: "IN.36.135", name: "Morādābād" },
    { code: "IN.36.136", name: "Rāmpur" },
    { code: "IN.36.137", name: "Jyotiba Phule Nagar" },
    { code: "IN.36.138", name: "Meerut" },
    { code: "IN.36.139", name: "Baghpat" },
    { code: "IN.36.140", name: "Ghāziābād" },
    { code: "IN.36.141", name: "Gautam Buddha Nagar" },
    { code: "IN.36.142", name: "Bulandshahr" },
    { code: "IN.36.143", name: "Alīgarh" },
    { code: "IN.36.144", name: "Hathras" },
    { code: "IN.36.145", name: "Mathura" },
    { code: "IN.36.146", name: "Āgra" },
    { code: "IN.36.147", name: "Firozabad" },
    { code: "IN.36.148", name: "Mainpuri" },
    { code: "IN.36.149", name: "Budaun" },
    { code: "IN.36.150", name: "Bareilly" },
    { code: "IN.36.151", name: "Pīlībhīt" },
    { code: "IN.36.152", name: "Shāhjahānpur" },
    { code: "IN.36.153", name: "Kheri" },
    { code: "IN.36.154", name: "Sītāpur" },
    { code: "IN.36.155", name: "Hardoi" },
    { code: "IN.36.156", name: "Unnāo" },
    { code: "IN.36.157", name: "Lucknow District" },
    { code: "IN.36.158", name: "Rāe Bareli" },
    { code: "IN.36.159", name: "Farrukhābād" },
    { code: "IN.36.160", name: "Kannauj" },
    { code: "IN.36.161", name: "Etāwah" },
    { code: "IN.36.162", name: "Auraiya" },
    { code: "IN.36.163", name: "Kanpur Dehat" },
    { code: "IN.36.164", name: "Kānpur" },
    { code: "IN.36.165", name: "Jālaun" },
    { code: "IN.36.166", name: "Jhānsi" },
    { code: "IN.36.167", name: "Lalitpur" },
    { code: "IN.36.168", name: "Hamīrpur" },
    { code: "IN.36.169", name: "Mahoba" },
    { code: "IN.36.170", name: "Bānda" },
    { code: "IN.36.171", name: "Chitrakoot" },
    { code: "IN.36.172", name: "Fatehpur" },
    { code: "IN.36.173", name: "Pratāpgarh" },
    { code: "IN.36.174", name: "Kaushambi District" },
    { code: "IN.36.175", name: "Allahābād" },
    { code: "IN.36.176", name: "Bāra Banki" },
    { code: "IN.36.177", name: "Faizābād" },
    { code: "IN.36.178", name: "Ambedkar Nagar" },
    { code: "IN.36.179", name: "Sultānpur" },
    { code: "IN.36.180", name: "Bahraich" },
    { code: "IN.36.181", name: "Shrawasti" },
    { code: "IN.36.182", name: "Balrampur" },
    { code: "IN.36.183", name: "Gonda" },
    { code: "IN.36.184", name: "Siddharthnagar" },
    { code: "IN.36.185", name: "Basti" },
    { code: "IN.36.186", name: "Sant Kabir Nagar" },
    { code: "IN.36.187", name: "Maharajganj" },
    { code: "IN.36.188", name: "Gorakhpur" },
    { code: "IN.36.189", name: "Kushinagar" },
    { code: "IN.36.190", name: "Deoria" },
    { code: "IN.36.191", name: "Āzamgarh" },
    { code: "IN.36.192", name: "Mau" },
    { code: "IN.36.193", name: "Ballia" },
    { code: "IN.36.194", name: "Jaunpur" },
    { code: "IN.36.195", name: "Ghāzīpur" },
    { code: "IN.36.196", name: "Chandauli District" },
    { code: "IN.36.197", name: "Vārānasi" },
    { code: "IN.36.198", name: "Sant Ravi Das Nagar" },
    { code: "IN.36.199", name: "Mirzāpur" },
    { code: "IN.36.200", name: "Sonbhadra" },
    { code: "IN.36.201", name: "Etah" },
    { code: "IN.36.202", name: "Kasganj" },
    { code: "IN.36.640", name: "Amethi" },
    { code: "IN.36.659", name: "Sambhal" },
    { code: "IN.36.660", name: "Shamli" },
    { code: "IN.36.661", name: "Hapur" },
  ],
  "IN.37": [
    { code: "IN.37.400", name: "Koriya" },
    { code: "IN.37.401", name: "Surguja" },
    { code: "IN.37.402", name: "Jashpur" },
    { code: "IN.37.403", name: "Raigarh" },
    { code: "IN.37.404", name: "Korba" },
    { code: "IN.37.405", name: "Janjgir-Champa" },
    { code: "IN.37.406", name: "Bilāspur" },
    { code: "IN.37.407", name: "Kabeerdham" },
    { code: "IN.37.408", name: "Rāj Nāndgaon" },
    { code: "IN.37.409", name: "Durg" },
    { code: "IN.37.410", name: "Raipur" },
    { code: "IN.37.411", name: "Mahasamund" },
    { code: "IN.37.412", name: "Dhamtari" },
    { code: "IN.37.413", name: "Uttar Bastar Kanker" },
    { code: "IN.37.414", name: "Bastar" },
    { code: "IN.37.415", name: "Narayanpur" },
    { code: "IN.37.416", name: "Dakshin Bastar Dantewada" },
    { code: "IN.37.417", name: "Bijapur" },
    { code: "IN.37.642", name: "Sukma" },
    { code: "IN.37.643", name: "Kondagaon" },
    { code: "IN.37.644", name: "Baloda Bazar" },
    { code: "IN.37.645", name: "Gariyaband" },
    { code: "IN.37.646", name: "Balod" },
    { code: "IN.37.647", name: "Mungeli" },
    { code: "IN.37.648", name: "Surajpur" },
    { code: "IN.37.649", name: "Balrampur" },
    { code: "IN.37.650", name: "Bemetara" },
  ],
  "IN.38": [
    { code: "IN.38.346", name: "Garhwa" },
    { code: "IN.38.347", name: "Chatra" },
    { code: "IN.38.348", name: "Kodarma" },
    { code: "IN.38.349", name: "Girīdīh" },
    { code: "IN.38.350", name: "Deogarh" },
    { code: "IN.38.351", name: "Godda" },
    { code: "IN.38.352", name: "Sahibganj" },
    { code: "IN.38.353", name: "Pakur" },
    { code: "IN.38.354", name: "Dhānbād" },
    { code: "IN.38.355", name: "Bokaro" },
    { code: "IN.38.356", name: "Lohardaga" },
    { code: "IN.38.357", name: "Purba Singhbhum" },
    { code: "IN.38.358", name: "Palāmu" },
    { code: "IN.38.359", name: "Latehar" },
    { code: "IN.38.360", name: "Hazārībāg" },
    { code: "IN.38.361", name: "Ramgarh" },
    { code: "IN.38.362", name: "Dumka" },
    { code: "IN.38.363", name: "Jamtara" },
    { code: "IN.38.364", name: "Rānchī" },
    { code: "IN.38.365", name: "Khunti" },
    { code: "IN.38.366", name: "Gumla" },
    { code: "IN.38.367", name: "Simdega" },
    { code: "IN.38.368", name: "Pashchim Singhbhūm" },
    { code: "IN.38.369", name: "Saraikela" },
  ],
  "IN.39": [
    { code: "IN.39.056", name: "Uttarkāshi" },
    { code: "IN.39.057", name: "Chamoli" },
    { code: "IN.39.058", name: "Rudraprayag" },
    { code: "IN.39.059", name: "Tehri-Garhwāl" },
    { code: "IN.39.060", name: "Dehradun" },
    { code: "IN.39.061", name: "Garhwāl" },
    { code: "IN.39.062", name: "Pithorāgarh" },
    { code: "IN.39.063", name: "Bageshwar" },
    { code: "IN.39.064", name: "Almora" },
    { code: "IN.39.065", name: "Champawat" },
    { code: "IN.39.066", name: "Naini Tāl" },
    { code: "IN.39.067", name: "Udham Singh Nagar" },
    { code: "IN.39.068", name: "Haridwar" },
  ],
  "IN.40": [
    { code: "IN.40.532", name: "Ādilābād" },
    { code: "IN.40.533", name: "Nizamabad" },
    { code: "IN.40.534", name: "Karīmnagar" },
    { code: "IN.40.535", name: "Medak" },
    { code: "IN.40.536", name: "Hyderābād" },
    { code: "IN.40.537", name: "Rangareddi" },
    { code: "IN.40.538", name: "Mahbūbnagar" },
    { code: "IN.40.539", name: "Nalgonda" },
    { code: "IN.40.540", name: "Warangal" },
    { code: "IN.40.541", name: "Khammam" },
    { code: "IN.40.680", name: "Nirmal" },
    { code: "IN.40.681", name: "Jagitial" },
    { code: "IN.40.682", name: "Peddapalli" },
    { code: "IN.40.683", name: "Rajanna Sircilla" },
    { code: "IN.40.684", name: "Mancherial" },
    { code: "IN.40.685", name: "Kamareddy" },
    { code: "IN.40.686", name: "Warangal Urban" },
    { code: "IN.40.687", name: "Jayashankar Bhupalapally" },
    { code: "IN.40.688", name: "Mahabubabad" },
    { code: "IN.40.689", name: "Jangoan" },
    { code: "IN.40.690", name: "Bhadradri Kothagudem" },
    { code: "IN.40.691", name: "Sangareddy" },
    { code: "IN.40.692", name: "Siddipet" },
    { code: "IN.40.693", name: "Wanaparthy" },
    { code: "IN.40.694", name: "Nagarkurnool" },
    { code: "IN.40.695", name: "Jogulamba Gadwal" },
    { code: "IN.40.696", name: "Suryapet" },
    { code: "IN.40.697", name: "Yadadri Bhuvanagiri" },
    { code: "IN.40.698", name: "Vikarabad" },
    { code: "IN.40.699", name: "Kumuram Bheem Asifabad" },
    { code: "IN.40.700", name: "Medchal Malkajgiri" },
  ],
  "IN.41": [
    { code: "IN.41.003", name: "Ladākh" },
    { code: "IN.41.004", name: "Kargil" },
  ],
  "IQ.01": [
    { code: "IQ.01.6765480", name: "Haditha District" },
    { code: "IQ.01.9166576", name: "Al-Ka'im District" },
    { code: "IQ.01.9166579", name: "Hīt District" },
    { code: "IQ.01.9166650", name: "Rawah District" },
    { code: "IQ.01.98678", name: "Al-Rutba District" },
    { code: "IQ.01.98718", name: "Ramadi District" },
    { code: "IQ.01.9873152", name: "Qaḑā’ al Qā’im" },
    { code: "IQ.01.98884", name: "Anah District" },
    { code: "IQ.01.99455", name: "Falluja District" },
  ],
  "IQ.02": [
    { code: "IQ.02.100049", name: "Abu Al-Khaseeb District" },
    { code: "IQ.02.9166549", name: "Al-Faw District" },
    { code: "IQ.02.9166563", name: "Al-Midaina District" },
    { code: "IQ.02.98247", name: "Al-Zubair District" },
    { code: "IQ.02.9873224", name: "Qaḑā’ al Madīnah" },
    { code: "IQ.02.98994", name: "Al-Qurna District" },
    { code: "IQ.02.99534", name: "Basrah District" },
  ],
  "IQ.03": [
    { code: "IQ.03.9166568", name: "Al-Rumaitha District" },
    { code: "IQ.03.9166626", name: "Al-Khidir District" },
    { code: "IQ.03.98532", name: "Al-Samawa District" },
    { code: "IQ.03.98534", name: "Al-Salman District" },
    { code: "IQ.03.9873260", name: "Qaḑā’ ar Rumaythah" },
    { code: "IQ.03.9873264", name: "Qaḑā’ al Khiḑr" },
  ],
  "IQ.04": [
    { code: "IQ.04.6850588", name: "Hamza District" },
    { code: "IQ.04.98634", name: "Qada Al-Shamiya" },
    { code: "IQ.04.99737", name: "Afaq District" },
    { code: "IQ.04.99763", name: "Qada Diwaniya" },
  ],
  "IQ.05": [
    { code: "IQ.05.91176", name: "Sharbazher District" },
    { code: "IQ.05.9166594", name: "Darbandokeh District" },
    { code: "IQ.05.9166596", name: "Dokan District" },
    { code: "IQ.05.9166600", name: "Kalar District" },
    { code: "IQ.05.9166684", name: "Penjwin District" },
    { code: "IQ.05.92051", name: "Rania District" },
    { code: "IQ.05.92743", name: "Pshdar District" },
    { code: "IQ.05.96204", name: "Qaḑā’ Ḩalabchah" },
    { code: "IQ.05.97416", name: "Chamchamal District" },
    { code: "IQ.05.98464", name: "Qaḑā’ as Sulaymānīyah" },
    { code: "IQ.05.9873292", name: "Qaḑā’ Darbandīkhān" },
    { code: "IQ.05.9873303", name: "Qeza-î Sharezûr" },
    { code: "IQ.05.9873312", name: "Qeza-î Pênciwên" },
    { code: "IQ.05.9877732", name: "Qeza-î Qeredagh" },
    { code: "IQ.05.9877795", name: "Qaḑā’ Sayyid Şādiq" },
    { code: "IQ.05.9877798", name: "Qaḑā’ Māwat" },
  ],
  "IQ.06": [
    { code: "IQ.06.6818313", name: "Al-Mahawil District" },
    { code: "IQ.06.99040", name: "Al-Musayab District" },
    { code: "IQ.06.99348", name: "Al-Hilla District" },
    { code: "IQ.06.99358", name: "Hashimiya District" },
  ],
  "IQ.07": [
    { code: "IQ.07.9166542", name: "Abu Ghraib District" },
    { code: "IQ.07.9166545", name: "Karkh" },
    { code: "IQ.07.9166561", name: "Sadr" },
    { code: "IQ.07.9166564", name: "Taji District" },
    { code: "IQ.07.9166569", name: "Al Tarmia District" },
    { code: "IQ.07.9166668", name: "Al Rusafa" },
    { code: "IQ.07.9167771", name: "Thawra" },
    { code: "IQ.07.9179819", name: "Al-Mada'in District" },
    { code: "IQ.07.98179", name: "Baghdad" },
    { code: "IQ.07.9873556", name: "Qaḑā’ ar Ruşāfah" },
    { code: "IQ.07.9873561", name: "Qaḑā’ al A‘z̧amīyah" },
    { code: "IQ.07.9874049", name: "Qaḑā’ Abū Ghurayb" },
    { code: "IQ.07.9874067", name: "Qaḑā’ al Madā’in" },
    { code: "IQ.07.9890735", name: "Qaḑā’ aţ Ţārmīyah" },
    { code: "IQ.07.99101", name: "Mahmudiya District" },
    { code: "IQ.07.99173", name: "Al-Kāżimiyyah" },
  ],
  "IQ.08": [
    { code: "IQ.08.89569", name: "Zakho District" },
    { code: "IQ.08.9166607", name: "Semel District" },
    { code: "IQ.08.97269", name: "Dohuk District" },
    { code: "IQ.08.9873355", name: "Qeza-î Sêmêl" },
    { code: "IQ.08.99612", name: "Adhamiyah" },
  ],
  "IQ.09": [
    { code: "IQ.09.90509", name: "Suq Al-Shoyokh District" },
    { code: "IQ.09.98623", name: "Al-Shatra District" },
    { code: "IQ.09.98700", name: "Al-Rifa'i District" },
    { code: "IQ.09.98855", name: "Nassriya District" },
    { code: "IQ.09.99185", name: "Al-Chibayish District" },
  ],
  "IQ.10": [
    { code: "IQ.10.9166680", name: "Qada Balad Ruz" },
    { code: "IQ.10.94296", name: "Qaḑā’ Kifrī" },
    { code: "IQ.10.94590", name: "Khanaqin District" },
    { code: "IQ.10.97988", name: "Ba'quba District" },
    { code: "IQ.10.99063", name: "Al-Muqdadiya District" },
    { code: "IQ.10.99170", name: "Al-Khalis District" },
  ],
  "IQ.11": [
    { code: "IQ.11.9166534", name: "Mergasur District" },
    { code: "IQ.11.9166586", name: "Choman District" },
    { code: "IQ.11.9166588", name: "Koisnjaq district" },
    { code: "IQ.11.9166591", name: "Shaqlawa" },
    { code: "IQ.11.9166592", name: "Soran District" },
    { code: "IQ.11.93817", name: "Makhmūr District" },
    { code: "IQ.11.95444", name: "Arbil" },
    { code: "IQ.11.9873235", name: "Qaḑā’ Jawmān" },
    { code: "IQ.11.9873236", name: "Qaḑā’ Sawrān" },
    { code: "IQ.11.9873237", name: "Qaḑā’ Shaqlāwah" },
    { code: "IQ.11.9874070", name: "Qaḑā’ Khabāt" },
    { code: "IQ.11.9874079", name: "Qeza-î Mêrgasur" },
    { code: "IQ.11.9877799", name: "Qaḑā’ Dashtī Hawlayr" },
    { code: "IQ.11.9878719", name: "Qeza-î Ṟuwandiz" },
  ],
  "IQ.12": [
    { code: "IQ.12.9166603", name: "Ain Al-Tamur District" },
    { code: "IQ.12.94822", name: "Kerbala District" },
    { code: "IQ.12.9873410", name: "Qaḑā’ ‘Ayn Tamr" },
    { code: "IQ.12.99345", name: "Al-Hindiya District" },
  ],
  "IQ.13": [
    { code: "IQ.13.6770659", name: "Al-Hawija District" },
    { code: "IQ.13.9166581", name: "Daquq District" },
    { code: "IQ.13.9171727", name: "Dabes" },
    { code: "IQ.13.94786", name: "Kirkuk District" },
    { code: "IQ.13.9873409", name: "Qaḑā’ Dibis" },
  ],
  "IQ.14": [
    { code: "IQ.14.9166557", name: "Al Kahla District" },
    { code: "IQ.14.9166562", name: "Al-Maimouna District" },
    { code: "IQ.14.92536", name: "Qaḑā’ Qal‘at Şāliḩ" },
    { code: "IQ.14.9873407", name: "Qaḑā’ al Majar al Kabīr" },
    { code: "IQ.14.9873408", name: "Qaḑā’ al Maymūnah" },
    { code: "IQ.14.99097", name: "Al-Mejar Al-Kabi District" },
    { code: "IQ.14.99305", name: "Ali Al-Gharbi District" },
    { code: "IQ.14.99610", name: "Amara District" },
  ],
  "IQ.15": [
    { code: "IQ.15.90392", name: "Tel Afar District" },
    { code: "IQ.15.9166541", name: "Al-Hamdaniya District" },
    { code: "IQ.15.9166608", name: "Al-Ba'aj District" },
    { code: "IQ.15.9166618", name: "Tel Keppe District" },
    { code: "IQ.15.9166620", name: "Sinjar" },
    { code: "IQ.15.9166649", name: "Mosul" },
    { code: "IQ.15.98612", name: "Shekhan District" },
    { code: "IQ.15.9873239", name: "Qaḑā’ Tallkayf" },
    { code: "IQ.15.9873392", name: "Qaḑā’ Ba‘āj" },
    { code: "IQ.15.98820", name: "Akre District" },
    { code: "IQ.15.99414", name: "Hatra District" },
  ],
  "IQ.16": [
    { code: "IQ.16.9166606", name: "Al-Na'maniya District" },
    { code: "IQ.16.9166961", name: "Qada Al-Azezia" },
    { code: "IQ.16.98197", name: "Badra District" },
    { code: "IQ.16.98460", name: "Al-Suwaira District" },
    { code: "IQ.16.9873403", name: "Qaḑā’ al ‘Azīzīyah" },
    { code: "IQ.16.9873404", name: "Qaḑā’ an Nu‘mānīyah" },
    { code: "IQ.16.99132", name: "Kut District" },
    { code: "IQ.16.99351", name: "Al-Hai District" },
  ],
  "IQ.17": [
    { code: "IQ.17.9166552", name: "Al-Manathera District" },
    { code: "IQ.17.9166629", name: "Kufa" },
    { code: "IQ.17.98861", name: "Najaf District" },
  ],
  "IQ.18": [
    { code: "IQ.18.6783103", name: "Al-Daur District" },
    { code: "IQ.18.6804454", name: "Al-Shirqat District" },
    { code: "IQ.18.6805736", name: "Balad District" },
    { code: "IQ.18.6872046", name: "Baiji District" },
    { code: "IQ.18.90148", name: "Tikrit District" },
    { code: "IQ.18.91594", name: "Qaḑā’ Sāmarrā’" },
    { code: "IQ.18.9166598", name: "Tooz District" },
    { code: "IQ.18.9166616", name: "Al-Faris" },
    { code: "IQ.18.9167093", name: "Al-Thethar District" },
  ],
  "IR.01": [
    { code: "IR.01.449444", name: "Shahrestān-e Orūmīyeh" },
    { code: "IR.01.449445", name: "Shahrestān-e Oshnavīyeh" },
    { code: "IR.01.449446", name: "Shahrestān-e Būkān" },
    { code: "IR.01.449447", name: "Shahrestān-e Pīrānshahr" },
    { code: "IR.01.449448", name: "Shahrestān-e Takāb" },
    { code: "IR.01.449449", name: "Shahrestān-e Chāldorān" },
    { code: "IR.01.449450", name: "Khowy" },
    { code: "IR.01.449451", name: "Sardasht" },
    { code: "IR.01.449452", name: "Shahrestān-e Salmās" },
    { code: "IR.01.449453", name: "Shahrestān-e Shāhīn Dezh" },
    { code: "IR.01.449454", name: "Shahrestān-e Mākū" },
    { code: "IR.01.449455", name: "Shahrestān-e Mahābād" },
    { code: "IR.01.449456", name: "Shahrestān-e Mīāndoāb" },
    { code: "IR.01.449457", name: "Naqadeh" },
    { code: "IR.01.9517619", name: "Showţ" },
    { code: "IR.01.9517620", name: "Chāypāreh" },
    { code: "IR.01.9517621", name: "Poldasht" },
  ],
  "IR.03": [
    { code: "IR.03.11963425", name: "Ben" },
    { code: "IR.03.11963426", name: "Saman" },
    { code: "IR.03.449517", name: "Ardal" },
    { code: "IR.03.449518", name: "Shahrestān-e Borūjen" },
    { code: "IR.03.449519", name: "Shahrekord" },
    { code: "IR.03.449520", name: "Shahrestān-e Fārsān" },
    { code: "IR.03.449521", name: "Shahrestān-e Kūhrang" },
    { code: "IR.03.449522", name: "Shahrestān-e Lordegān" },
    { code: "IR.03.9519976", name: "Shahrestān-e Kīār" },
  ],
  "IR.04": [
    { code: "IR.04.1158999", name: "Shahrestān-e Īrānshahr" },
    { code: "IR.04.11963510", name: "Qaser-e Qand" },
    { code: "IR.04.11963514", name: "Mirjaveh" },
    { code: "IR.04.11963516", name: "Nimruz" },
    { code: "IR.04.11963518", name: "Hamoon" },
    { code: "IR.04.11963562", name: "Fanuj" },
    { code: "IR.04.1482480", name: "Shahrestān-e Chābahār" },
    { code: "IR.04.1482481", name: "Shahrestān-e Khāsh" },
    { code: "IR.04.1482483", name: "Shahrestān-e Zābol" },
    { code: "IR.04.1482486", name: "Shahrestān-e Zāhedān" },
    { code: "IR.04.1482494", name: "Shahrestān-e Sarāvān" },
    { code: "IR.04.1482499", name: "Shahrestān-e Sarbāz" },
    { code: "IR.04.1482504", name: "Shahrestān-e Nīkshahr" },
    { code: "IR.04.9533574", name: "Zehak" },
    { code: "IR.04.9533575", name: "Shahrestān-e Hīrmand" },
    { code: "IR.04.9533580", name: "Shahrestān-e Dalgān" },
    { code: "IR.04.9533581", name: "Shahrestān-e Konārak" },
    { code: "IR.04.9533590", name: "Shahrestān-e Mehrestān" },
    { code: "IR.04.9533591", name: "Shahrestān-e Sīb va Sūrān" },
  ],
  "IR.05": [
    { code: "IR.05.11963520", name: "Landeh" },
    { code: "IR.05.449634", name: "Shahrestān-e Bowyer Aḩmad" },
    { code: "IR.05.449635", name: "Shahrestān-e Danā" },
    { code: "IR.05.449636", name: "Shahrestān-e Kohgīlūyeh" },
    { code: "IR.05.449637", name: "Shahrestān-e Gachsārān" },
    { code: "IR.05.9532946", name: "Shahrestān-e Bahma’ī" },
    { code: "IR.05.9532947", name: "Shahrestān-e Charām" },
    { code: "IR.05.9532948", name: "Shahrestān-e Bāsht" },
  ],
  "IR.07": [
    { code: "IR.07.125034", name: "Mamasanī" },
    { code: "IR.07.449573", name: "Shahrestān-e Ābādeh" },
    { code: "IR.07.449574", name: "Shahrestān-e Arsanjān" },
    { code: "IR.07.449575", name: "Shahrestān-e Estahbān" },
    { code: "IR.07.449577", name: "Shahrestān-e Bavānāt" },
    { code: "IR.07.449578", name: "Jahrom" },
    { code: "IR.07.449579", name: "Shahrestān-e Khorrambīd" },
    { code: "IR.07.449580", name: "Shahrestān-e Dārāb" },
    { code: "IR.07.449581", name: "Shahrestān-e Zarrīn Dasht" },
    { code: "IR.07.449582", name: "Shahrestān-e Sepīdān" },
    { code: "IR.07.449583", name: "Shahrestān-e Shīrāz" },
    { code: "IR.07.449584", name: "Shahrestān-e Farāshband" },
    { code: "IR.07.449586", name: "Shahrestān-e Fīrūzābād" },
    { code: "IR.07.449587", name: "Shahrestān-e Qīr va Kārzīn" },
    { code: "IR.07.449588", name: "Shahrestān-e Kāzerūn" },
    { code: "IR.07.449589", name: "Shahrestān-e Lārestān" },
    { code: "IR.07.449590", name: "Shahrestān-e Lāmerd" },
    { code: "IR.07.449591", name: "Marvdasht" },
    { code: "IR.07.449593", name: "Mohr" },
    { code: "IR.07.449594", name: "Shahrestān-e Neyrīz" },
    { code: "IR.07.68471", name: "Shahrestān-e Fasā" },
    { code: "IR.07.8620947", name: "Shahrestān-e Eqlīd" },
    { code: "IR.07.9520534", name: "Rostam" },
    { code: "IR.07.9520865", name: "Shahrestān-e Pāsārgād" },
    { code: "IR.07.9520866", name: "Shahrestān-e Kherāmeh" },
    { code: "IR.07.9520867", name: "Shahrestān-e Kavār" },
    { code: "IR.07.9520868", name: "Shahrestān-e Sarvestān" },
    { code: "IR.07.9520869", name: "Shahrestān-e Gerāsh" },
    { code: "IR.07.9520870", name: "Khonj" },
  ],
  "IR.08": [
    { code: "IR.08.449649", name: "Shahrestān-e Āstārā" },
    { code: "IR.08.449650", name: "Shahrestān-e Āstāneh-ye Ashrafīyeh" },
    { code: "IR.08.449651", name: "Amlash" },
    { code: "IR.08.449652", name: "Shahrestān-e Bandar-e Anzalī" },
    { code: "IR.08.449653", name: "Rasht" },
    { code: "IR.08.449654", name: "Shahrestān-e Reẕvānshahr" },
    { code: "IR.08.449655", name: "Shahrestān-e Rūdbār" },
    { code: "IR.08.449656", name: "Shahrestān-e Rūdsar" },
    { code: "IR.08.449657", name: "Shahrestān-e Sīāhkal" },
    { code: "IR.08.449658", name: "Shaft" },
    { code: "IR.08.449659", name: "Shahrestān-e Şowme‘eh Sarā" },
    { code: "IR.08.449661", name: "Shahrestān-e Fūman" },
    { code: "IR.08.449662", name: "Shahrestān-e Lāhījān" },
    { code: "IR.08.449663", name: "Shahrestān-e Langarūd" },
    { code: "IR.08.449664", name: "Shahrestān-e Māsāl" },
    { code: "IR.08.8620884", name: "Shahrestān-e Tālesh" },
  ],
  "IR.09": [
    { code: "IR.09.449708", name: "Shahrestān-e Asadābād" },
    { code: "IR.09.449709", name: "Shahrestān-e Bahār" },
    { code: "IR.09.449710", name: "Shahrestān-e Tūyserkān" },
    { code: "IR.09.449711", name: "Razan" },
    { code: "IR.09.449712", name: "Shahrestān-e Kabūdarāhang" },
    { code: "IR.09.449713", name: "Shahrestān-e Malāyer" },
    { code: "IR.09.449714", name: "Shahrestān-e Nahāvand" },
    { code: "IR.09.449715", name: "Shahrestān-e Hamadān" },
    { code: "IR.09.9523287", name: "Shahrestān-e Fāmenīn" },
  ],
  "IR.10": [
    { code: "IR.10.112941", name: "Badreh" },
    { code: "IR.10.11963421", name: "Chardavol County" },
    { code: "IR.10.11963422", name: "Sirvan" },
    { code: "IR.10.28354", name: "Darrehshahr" },
    { code: "IR.10.449458", name: "Shahrestān-e Ābdānān" },
    { code: "IR.10.449459", name: "Shahrestān-e Īlām" },
    { code: "IR.10.449460", name: "Shahrestān-e Eyvān" },
    { code: "IR.10.449462", name: "Shahrestān-e Dehlorān" },
    { code: "IR.10.449464", name: "Shahrestān-e Mehrān" },
    { code: "IR.10.9524084", name: "Shahrestān-e Malekshāhī" },
  ],
  "IR.11": [
    { code: "IR.11.449699", name: "Shahrestān-e Abū Mūsá" },
    { code: "IR.11.449700", name: "Bastak" },
    { code: "IR.11.449701", name: "Shahrestān-e Bandar ‘Abbās" },
    { code: "IR.11.449702", name: "Bandar Lengeh" },
    { code: "IR.11.449703", name: "Shahrestān-e Jāsk" },
    { code: "IR.11.449704", name: "Shahrestān-e Ḩājjīābād" },
    { code: "IR.11.449705", name: "Shahrestān-e Rūdān" },
    { code: "IR.11.449706", name: "Qeshm" },
    { code: "IR.11.449707", name: "Shahrestān-e Mīnāb" },
    { code: "IR.11.8620945", name: "Shahrestān-e Khamīr" },
    { code: "IR.11.8620946", name: "Shahrestān-e Pārsīān" },
    { code: "IR.11.9523757", name: "Shahrestān-e Bashāgard" },
    { code: "IR.11.9523758", name: "Shahrestān-e Sīrīk" },
  ],
  "IR.13": [
    { code: "IR.13.449622", name: "Shahrestān-e Eslāmābād-e Gharb" },
    { code: "IR.13.449623", name: "Shahrestān-e Pāveh" },
    { code: "IR.13.449624", name: "Shahrestān-e S̄alās̄-e Bābā Jānī" },
    { code: "IR.13.449625", name: "Shahrestān-e Javānrūd" },
    { code: "IR.13.449626", name: "Shahrestān-e Sarpol-e Z̄ahāb" },
    { code: "IR.13.449627", name: "Sonqor" },
    { code: "IR.13.449628", name: "Shahrestān-e Şaḩneh" },
    { code: "IR.13.449629", name: "Shahrestān-e Qaşr-e Shīrīn" },
    { code: "IR.13.449630", name: "Shahrestān-e Kermānshāh" },
    { code: "IR.13.449631", name: "Shahrestān-e Kangāvar" },
    { code: "IR.13.449632", name: "Shahrestān-e Gīlān-e Gharb" },
    { code: "IR.13.449633", name: "Shahrestān-e Harsīn" },
    { code: "IR.13.8620948", name: "Shahrestān-e Dālāhū" },
    { code: "IR.13.8620949", name: "Shahrestān-e Ravānsar" },
  ],
  "IR.15": [
    { code: "IR.15.11963429", name: "Aghajari" },
    { code: "IR.15.11963430", name: "Hamidiyeh" },
    { code: "IR.15.11963434", name: "Karun" },
    { code: "IR.15.449544", name: "Shahrestān-e Ābādān" },
    { code: "IR.15.449545", name: "Shahrestān-e Omīdīyeh" },
    { code: "IR.15.449546", name: "Shahrestān-e Andīmeshk" },
    { code: "IR.15.449547", name: "Shahrestān-e Ahvāz" },
    { code: "IR.15.449548", name: "Shahrestān-e Īz̄eh" },
    { code: "IR.15.449549", name: "Bāgh Shahrestān-e Malek" },
    { code: "IR.15.449550", name: "Shahrestān-e Bandar-e Māhshahr" },
    { code: "IR.15.449551", name: "Shahrestān-e Behbahān" },
    { code: "IR.15.449552", name: "Khorramshahr" },
    { code: "IR.15.449553", name: "Shahrestān-e Dezfūl" },
    { code: "IR.15.449554", name: "Shahrestān-e Dasht-e Āzādegān" },
    { code: "IR.15.449555", name: "Shahrestān-e Rāmhormoz" },
    { code: "IR.15.449556", name: "Shahrestān-e Shādegān" },
    { code: "IR.15.449557", name: "Shahrestān-e Shūsh" },
    { code: "IR.15.449558", name: "Shahrestān-e Shūshtar" },
    { code: "IR.15.449559", name: "Shahrestān-e Lālī" },
    { code: "IR.15.449560", name: "Shahrestān-e Masjed Soleymān" },
    { code: "IR.15.449561", name: "Shahrestān-e Hendījān" },
    { code: "IR.15.9532909", name: "Gotvand" },
    { code: "IR.15.9532922", name: "Shahrestān-e Andīkā" },
    { code: "IR.15.9532924", name: "Hoveyzeh" },
    { code: "IR.15.9532926", name: "Shahrestān-e Bāvī" },
    { code: "IR.15.9532928", name: "Haftkel" },
    { code: "IR.15.9532929", name: "Shahrestān-e Rāmshīr" },
  ],
  "IR.16": [
    { code: "IR.16.449600", name: "Shahrestān-e Bāneh" },
    { code: "IR.16.449601", name: "Shahrestān-e Bījār" },
    { code: "IR.16.449602", name: "Shahrestān-e Dīvāndarreh" },
    { code: "IR.16.449603", name: "Shahrestān-e Sarvābād" },
    { code: "IR.16.449604", name: "Saqqez" },
    { code: "IR.16.449605", name: "Sanandaj" },
    { code: "IR.16.449606", name: "Qorveh" },
    { code: "IR.16.449607", name: "Shahrestān-e Kāmyārān" },
    { code: "IR.16.449608", name: "Shahrestān-e Marīvān" },
    { code: "IR.16.9532949", name: "Shahrestān-e Dehgolān" },
  ],
  "IR.22": [
    { code: "IR.22.449495", name: "Shahrestān-e Būshehr" },
    { code: "IR.22.449496", name: "Shahrestān-e Tangestān" },
    { code: "IR.22.449497", name: "Jam" },
    { code: "IR.22.449498", name: "Shahrestān-e Dashtestān" },
    { code: "IR.22.449499", name: "Shahrestān-e Dashtī" },
    { code: "IR.22.449500", name: "Deyr" },
    { code: "IR.22.449501", name: "Deylam" },
    { code: "IR.22.449502", name: "Shahrestān-e Kangān" },
    { code: "IR.22.449503", name: "Shahrestān-e Genāveh" },
    { code: "IR.22.9519975", name: "Shahrestān-e ‘Asalūyeh" },
  ],
  "IR.23": [
    { code: "IR.23.11962671", name: "Rumeshkhan County" },
    { code: "IR.23.449665", name: "Shahrestān-e Aznā" },
    { code: "IR.23.449666", name: "Shahrestān-e Alīgūdarz" },
    { code: "IR.23.449667", name: "Shahrestān-e Borūjerd" },
    { code: "IR.23.449668", name: "Pol-e Dokhtar" },
    { code: "IR.23.449669", name: "Shahrestān-e Khorramābād" },
    { code: "IR.23.449670", name: "Delfan" },
    { code: "IR.23.449671", name: "Dorūd" },
    { code: "IR.23.449672", name: "Selseleh" },
    { code: "IR.23.449673", name: "Shahrestān-e Kūhdasht" },
    { code: "IR.23.9533002", name: "Shahrestān-e Dūreh" },
  ],
  "IR.25": [
    { code: "IR.25.124337", name: "Mahdishahr" },
    { code: "IR.25.449569", name: "Shahrestān-e Dāmghān" },
    { code: "IR.25.449570", name: "Shahrestān-e Semnān" },
    { code: "IR.25.449571", name: "Shahrestān-e Shāhrūd" },
    { code: "IR.25.449572", name: "Shahrestān-e Garmsār" },
    { code: "IR.25.9533331", name: "Shahrestān-e Mayāmey" },
    { code: "IR.25.9533333", name: "Shahrestān-e Ārādān" },
    { code: "IR.25.9533334", name: "Sorkheh" },
  ],
  "IR.26": [
    { code: "IR.26.11963423", name: "Pardis" },
    { code: "IR.26.11963424", name: "Qarchak" },
    { code: "IR.26.449505", name: "Shahrestān-e Pākdasht" },
    { code: "IR.26.449506", name: "Shahrestān-e Tehrān" },
    { code: "IR.26.449507", name: "Shahrestān-e Damāvand" },
    { code: "IR.26.449508", name: "Shahrestān-e Robāţ Karīm" },
    { code: "IR.26.449509", name: "Rey" },
    { code: "IR.26.449511", name: "Shahrestān-e Shemīrānāt" },
    { code: "IR.26.449512", name: "Shahrestān-e Shahrīār" },
    { code: "IR.26.449513", name: "Shahrestān-e Fīrūzkūh" },
    { code: "IR.26.449516", name: "Shahrestān-e Varāmīn" },
    { code: "IR.26.9533736", name: "Shahrestān-e Malārd" },
    { code: "IR.26.9533737", name: "Qods" },
    { code: "IR.26.9533739", name: "Shahrestān-e Bahārestān" },
    { code: "IR.26.9533740", name: "Shahrestān-e Eslāmshahr" },
    { code: "IR.26.9533741", name: "Shahrestān-e Pīshvā" },
  ],
  "IR.28": [
    { code: "IR.28.11962673", name: "Buin va Miandasht" },
    { code: "IR.28.122490", name: "Shahrestān-e Naţanz" },
    { code: "IR.28.449474", name: "Shahrestān-e Ārān va Bīdgol" },
    { code: "IR.28.449475", name: "Shahrestān-e Ardestān" },
    { code: "IR.28.449476", name: "Shahrestān-e Eşfahān" },
    { code: "IR.28.449477", name: "Shahrestān-e Borkhvār" },
    { code: "IR.28.449478", name: "Shahrestān-e Tīrān va Karvan" },
    { code: "IR.28.449479", name: "Shahrestān-e Chādegān" },
    { code: "IR.28.449480", name: "Shahrestān-e Khomeynī Shahr" },
    { code: "IR.28.449481", name: "Shahrestān-e Khvānsār" },
    { code: "IR.28.449482", name: "Shahrestān-e Semīrom" },
    { code: "IR.28.449483", name: "Shahrestān-e Dehāqān" },
    { code: "IR.28.449484", name: "Shahrestān-e Shahreẕā" },
    { code: "IR.28.449485", name: "Fereydan" },
    { code: "IR.28.449486", name: "Shahrestān-e Fareydūnshahr" },
    { code: "IR.28.449487", name: "Shahrestān-e Falāvarjān" },
    { code: "IR.28.449488", name: "Shahrestān-e Kāshān" },
    { code: "IR.28.449489", name: "Shahrestān-e Golpāyegān" },
    { code: "IR.28.449490", name: "Shahrestān-e Lenjān" },
    { code: "IR.28.449491", name: "Shahrestān-e Mobārakeh" },
    { code: "IR.28.449492", name: "Shahrestān-e Nā’īn" },
    { code: "IR.28.449493", name: "Shahrestān-e Najafābād" },
    { code: "IR.28.9519980", name: "Shahrestān-e Khūr va Bīābānak" },
    { code: "IR.28.9519981", name: "Shahrestān-e Shāhīn Shahr va Meymeh" },
  ],
  "IR.29": [
    { code: "IR.29.449609", name: "Shahrestān-e Bāft" },
    { code: "IR.29.449610", name: "Shahrestān-e Bardsīr" },
    { code: "IR.29.449611", name: "Bam" },
    { code: "IR.29.449612", name: "Shahrestān-e Jīroft" },
    { code: "IR.29.449613", name: "Rāvar" },
    { code: "IR.29.449614", name: "Shahrestān-e Rafsanjān" },
    { code: "IR.29.449615", name: "Zarand" },
    { code: "IR.29.449617", name: "Shahrestān-e Shahr-e Bābak" },
    { code: "IR.29.449618", name: "Shahrestān-e ‘Anbarābād" },
    { code: "IR.29.449619", name: "Shahrestān-e Kermān" },
    { code: "IR.29.449620", name: "Shahrestān-e Kahnūj" },
    { code: "IR.29.449621", name: "Shahrestān-e Manūjān" },
    { code: "IR.29.66575", name: "Shahrestān-e Sīrjān" },
    { code: "IR.29.9524445", name: "Shahrestān-e Anār" },
    { code: "IR.29.9524446", name: "Shahrestān-e Kūhbanān" },
    { code: "IR.29.9524447", name: "Shahrestān-e Rābor" },
    { code: "IR.29.9524448", name: "Shahrestān-e Orzū‘īyeh" },
    { code: "IR.29.9524449", name: "Shahrestān-e Fāryāb" },
    { code: "IR.29.9524451", name: "Shahrestān-e Narmāshīr" },
    { code: "IR.29.9524452", name: "Fahraj" },
    { code: "IR.29.9524453", name: "Rīgān" },
    { code: "IR.29.9524454", name: "Shahrestān-e Rūdbār-e Jonūbī" },
    { code: "IR.29.9524455", name: "Shahrestān-e Qal‘eh Ganj" },
  ],
  "IR.32": [
    { code: "IR.32.449465", name: "Shahrestān-e Ardabīl" },
    { code: "IR.32.449466", name: "Shahrestān-e Bīleh Savār" },
    { code: "IR.32.449467", name: "Shahrestān-e Pārsābād" },
    { code: "IR.32.449469", name: "Shahrestān-e Kows̄ar" },
    { code: "IR.32.449470", name: "Shahrestān-e Germī" },
    { code: "IR.32.449471", name: "Shahrestān-e Meshgīn Shahr" },
    { code: "IR.32.449472", name: "Shahrestān-e Namīn" },
    { code: "IR.32.449473", name: "Shahrestān-e Nīr" },
    { code: "IR.32.8620950", name: "Shahrestān-e Khalkhāl" },
    { code: "IR.32.9514745", name: "Shahrestān-e Sar‘eyn" },
  ],
  "IR.33": [
    { code: "IR.33.449425", name: "Shahrestān-e Āz̄arshahr" },
    { code: "IR.33.449426", name: "Shahrestān-e Oskū" },
    { code: "IR.33.449427", name: "Ahar" },
    { code: "IR.33.449428", name: "Shahrestān-e Bostānābād" },
    { code: "IR.33.449429", name: "Shahrestān-e Bonāb" },
    { code: "IR.33.449430", name: "Shahrestān-e Tabrīz" },
    { code: "IR.33.449431", name: "Shahrestān-e Jolfā" },
    { code: "IR.33.449432", name: "Shahrestān-e Chārāvīmāq" },
    { code: "IR.33.449434", name: "Shabestar" },
    { code: "IR.33.449435", name: "Shahrestān-e ‘Ajab Shīr" },
    { code: "IR.33.449436", name: "Kaleybar" },
    { code: "IR.33.449437", name: "Shahrestān-e Marāgheh" },
    { code: "IR.33.449438", name: "Marand" },
    { code: "IR.33.449439", name: "Shahrestān-e Malekān" },
    { code: "IR.33.449440", name: "Shahrestān-e Mīāneh" },
    { code: "IR.33.449441", name: "Shahrestān-e Herīs" },
    { code: "IR.33.449442", name: "Shahrestān-e Varzaqān" },
    { code: "IR.33.449443", name: "Shahrestān-e Hashtrūd" },
    { code: "IR.33.8620951", name: "Shahrestān-e Sarāb" },
    { code: "IR.33.9517647", name: "Shahrestān-e Khodā Āfarīn" },
  ],
  "IR.34": [
    { code: "IR.34.449690", name: "Shahrestān-e Arāk" },
    { code: "IR.34.449691", name: "Tafresh" },
    { code: "IR.34.449692", name: "Khomeyn" },
    { code: "IR.34.449693", name: "Shahrestān-e Delījān" },
    { code: "IR.34.449694", name: "Shahrestān-e Zarandīyeh" },
    { code: "IR.34.449695", name: "Shahrestān-e Sāveh" },
    { code: "IR.34.449696", name: "Shahrestān-e Shāzand" },
    { code: "IR.34.449697", name: "Shahrestān-e Komījān" },
    { code: "IR.34.449698", name: "Shahrestān-e Maḩallāt" },
    { code: "IR.34.69179", name: "Shahrestān-e Āshtīān" },
    { code: "IR.34.9533005", name: "Shahrestān-e Farahān" },
    { code: "IR.34.9533006", name: "Shahrestān-e Khondāb" },
  ],
  "IR.35": [
    { code: "IR.35.11962672", name: "Simorgh County" },
    { code: "IR.35.449674", name: "Shahrestān-e Āmol" },
    { code: "IR.35.449675", name: "Shahrestān-e Bābol" },
    { code: "IR.35.449676", name: "Shahrestān-e Bābolsar" },
    { code: "IR.35.449677", name: "Behshahr" },
    { code: "IR.35.449678", name: "Shahrestān-e Tonekābon" },
    { code: "IR.35.449679", name: "Shahrestān-e Jūybār" },
    { code: "IR.35.449680", name: "Shahrestān-e Chālūs" },
    { code: "IR.35.449681", name: "Shahrestān-e Rāmsar" },
    { code: "IR.35.449682", name: "Shahrestān-e Sārī" },
    { code: "IR.35.449683", name: "Shahrestān-e Savādkūh" },
    { code: "IR.35.449684", name: "Shahrestān-e Qā’em Shahr" },
    { code: "IR.35.449685", name: "Shahrestān-e Maḩmūdābād" },
    { code: "IR.35.449686", name: "Shahrestān-e Nekā" },
    { code: "IR.35.449687", name: "Shahrestān-e Nūr" },
    { code: "IR.35.449688", name: "Nowshahr" },
    { code: "IR.35.68057", name: "Shahrestan-e Kalār Dasht" },
    { code: "IR.35.7830204", name: "Savadkuh-e Shomali" },
    { code: "IR.35.9533059", name: "Shahrestān-e ‘Abbāsābād" },
    { code: "IR.35.9533060", name: "Shahrestān-e Galūgāh" },
    { code: "IR.35.9533061", name: "Shahrestān-e Mīāndorūd" },
    { code: "IR.35.9533062", name: "Shahrestān-e Fareydūnkenār" },
  ],
  "IR.36": [
    { code: "IR.36.11963463", name: "Soltaniyeh" },
    { code: "IR.36.449562", name: "Abhar" },
    { code: "IR.36.449563", name: "Shahrestān-e Ījrūd" },
    { code: "IR.36.449564", name: "Shahrestān-e Khodābandeh" },
    { code: "IR.36.449565", name: "Khorramdarreh" },
    { code: "IR.36.449567", name: "Shahrestān-e Ţārom" },
    { code: "IR.36.449568", name: "Shahrestān-e Māhneshān" },
    { code: "IR.36.66310", name: "Shahrestān-e Zanjān" },
  ],
  "IR.37": [
    { code: "IR.37.449638", name: "Shahrestān-e Āzādshahr" },
    { code: "IR.37.449639", name: "Shahrestān-e Āq Qalā" },
    { code: "IR.37.449640", name: "Torkaman" },
    { code: "IR.37.449641", name: "Bandar-e Gaz" },
    { code: "IR.37.449642", name: "Shahrestān-e Rāmīān" },
    { code: "IR.37.449643", name: "Shahrestān-e ‘Alīābād" },
    { code: "IR.37.449644", name: "Shahrestān-e Kordkūy" },
    { code: "IR.37.449645", name: "Shahrestān-e Kalāleh" },
    { code: "IR.37.449646", name: "Shahrestān-e Gorgān" },
    { code: "IR.37.449647", name: "Shahrestān-e Gonbad-e Kāvūs" },
    { code: "IR.37.449648", name: "Shahrestān-e Mīnūdasht" },
    { code: "IR.37.9522216", name: "Shahrestān-e Gomīshān" },
    { code: "IR.37.9522217", name: "Shahrestān-e Marāveh Tappeh" },
    { code: "IR.37.9522218", name: "Shahrestān-e Gālīkesh" },
  ],
  "IR.38": [
    { code: "IR.38.11963519", name: "Avaj" },
    { code: "IR.38.11963561", name: "Alborz" },
    { code: "IR.38.449595", name: "Ābyek" },
    { code: "IR.38.449596", name: "Shahrestān-e Bū’īn Zahrā" },
    { code: "IR.38.449597", name: "Shahrestān-e Tākestān" },
    { code: "IR.38.449598", name: "Shahrestān-e Qazvīn" },
  ],
  "IR.39": [
    { code: "IR.39.449599", name: "Qom" },
  ],
  "IR.40": [
    { code: "IR.40.449716", name: "Shahrestān-e Abarkūh" },
    { code: "IR.40.449717", name: "Shahrestān-e Ardakān" },
    { code: "IR.40.449718", name: "Shahrestān-e Bāfq" },
    { code: "IR.40.449719", name: "Taft" },
    { code: "IR.40.449720", name: "Shahrestān-e Khātam" },
    { code: "IR.40.449721", name: "Shahrestān-e Ashkez̄ar" },
    { code: "IR.40.449723", name: "Shahrestān-e Mehrīz" },
    { code: "IR.40.449724", name: "Meybod" },
    { code: "IR.40.449725", name: "Shahrestān-e Yazd" },
    { code: "IR.40.9533896", name: "Shahrestān-e Behābād" },
  ],
  "IR.41": [
    { code: "IR.41.11963427", name: "Tabas" },
    { code: "IR.41.1482419", name: "Shahrestān-e Nehbandān" },
    { code: "IR.41.449523", name: "Shahrestān-e Bīrjand" },
    { code: "IR.41.449524", name: "Shahrestān-e Sarbīsheh" },
    { code: "IR.41.449532", name: "Ferdows" },
    { code: "IR.41.449534", name: "Shahrestān-e Qā’en" },
    { code: "IR.41.8620944", name: "Shahrestān-e Darmīān" },
    { code: "IR.41.9525806", name: "Boshrūyeh" },
    { code: "IR.41.9525807", name: "Shahrestān-e Sarāyān" },
    { code: "IR.41.9534259", name: "Shahrestān-e Khūsf" },
    { code: "IR.41.9534260", name: "Shahrestān-e Zīrkūh" },
  ],
  "IR.42": [
    { code: "IR.42.1482420", name: "Shahrestān-e Tāybād" },
    { code: "IR.42.1482421", name: "Shahrestān-e Torbat-e Jām" },
    { code: "IR.42.1482426", name: "Shahrestān-e Khvāf" },
    { code: "IR.42.1482443", name: "Sarakhs" },
    { code: "IR.42.1482469", name: "Shahrestān-e Kalāt" },
    { code: "IR.42.449525", name: "Bardaskan" },
    { code: "IR.42.449526", name: "Shahrestān-e Torbat-e Ḩeydarīyeh" },
    { code: "IR.42.449527", name: "Shahrestān-e Chenārān" },
    { code: "IR.42.449528", name: "Shahrestān-e Khalīlābād" },
    { code: "IR.42.449529", name: "Dargaz" },
    { code: "IR.42.449530", name: "Shahrestān-e Roshtkhvār" },
    { code: "IR.42.449531", name: "Shahrestān-e Sabzevār" },
    { code: "IR.42.449533", name: "Shahrestān-e Farīmān" },
    { code: "IR.42.449535", name: "Shahrestān-e Qūchān" },
    { code: "IR.42.449536", name: "Shahrestān-e Kāshmar" },
    { code: "IR.42.449537", name: "Shahrestān-e Gonābād" },
    { code: "IR.42.449538", name: "Mashhad" },
    { code: "IR.42.449539", name: "Shahrestān-e Neyshābūr" },
    { code: "IR.42.6550", name: "Dāvarzan" },
    { code: "IR.42.8620943", name: "Shahrestān-e Mah Velāt" },
    { code: "IR.42.9526253", name: "Shahrestān-e Bajestān" },
    { code: "IR.42.9526254", name: "Shahrestān-e Joghatāy" },
    { code: "IR.42.9526255", name: "Joveyn" },
    { code: "IR.42.9526257", name: "Shahrestān-e Khowshāb" },
    { code: "IR.42.9526258", name: "Shahrestān-e Fīrūzeh" },
    { code: "IR.42.9526260", name: "Shahrestān-e Bīnālūd" },
    { code: "IR.42.9526342", name: "Shahrestān-e Zāveh" },
    { code: "IR.42.9526343", name: "Shahrestān-e Bākharz" },
  ],
  "IR.43": [
    { code: "IR.43.11963428", name: "Raz and Jargalan" },
    { code: "IR.43.449540", name: "Shahrestān-e Esfarāyen" },
    { code: "IR.43.449541", name: "Shahrestān-e Bojnūrd" },
    { code: "IR.43.449542", name: "Shahrestān-e Jājarm" },
    { code: "IR.43.449543", name: "Shahrestān-e Shīrvān" },
    { code: "IR.43.8620941", name: "Shahrestān-e Māneh va Samalqān" },
    { code: "IR.43.8620942", name: "Shahrestān-e Fārūj" },
    { code: "IR.43.9532886", name: "Garmeh" },
  ],
  "IR.44": [
    { code: "IR.44.11963420", name: "Fardis" },
    { code: "IR.44.449510", name: "Shahrestān-e Sāvojbolāgh" },
    { code: "IR.44.449514", name: "Karaj" },
    { code: "IR.44.449515", name: "Shahrestān-e Naz̧arābād" },
    { code: "IR.44.9513960", name: "Shahrestān-e Ţāleqān" },
    { code: "IR.44.9513961", name: "Shahrestān-e Eshtehārd" },
  ],
  "IS.38": [
    { code: "IS.38.7000", name: "Seyðisfjarðarkaupstaður" },
    { code: "IS.38.7300", name: "Fjarðabyggð" },
    { code: "IS.38.7502", name: "Vopnafjarðarhreppur" },
    { code: "IS.38.7505", name: "Fljótsdalshreppur" },
    { code: "IS.38.7509", name: "Borgarfjarðarhreppur" },
    { code: "IS.38.7613", name: "Breiðdalshreppur" },
    { code: "IS.38.7617", name: "Djúpavogshreppur" },
    { code: "IS.38.7620", name: "Fljótsdalshérað" },
    { code: "IS.38.7708", name: "Sveitarfélagið Hornafjörður" },
  ],
  "IS.39": [
    { code: "IS.39.0000", name: "Reykjavíkurborg" },
    { code: "IS.39.1000", name: "Kópavogsbær" },
    { code: "IS.39.1100", name: "Seltjarnarneskaupstaður" },
    { code: "IS.39.1300", name: "Garðabær" },
    { code: "IS.39.1400", name: "Hafnarfjarðarkaupstaður" },
    { code: "IS.39.1604", name: "Mosfellsbaer" },
    { code: "IS.39.1606", name: "Kjósarhreppur" },
  ],
  "IS.40": [
    { code: "IS.40.6000", name: "Akureyrarkaupstaður" },
    { code: "IS.40.6100", name: "Norðurþing" },
    { code: "IS.40.6250", name: "Fjallabyggð" },
    { code: "IS.40.6400", name: "Dalvíkurbyggð" },
    { code: "IS.40.6513", name: "Eyjafjarðarsveit" },
    { code: "IS.40.6515", name: "Hörgársveit" },
    { code: "IS.40.6601", name: "Svalbarðsstrandarhreppur" },
    { code: "IS.40.6602", name: "Grýtubakkahreppur" },
    { code: "IS.40.6607", name: "Skútustaðahreppur" },
    { code: "IS.40.6611", name: "Tjörneshreppur" },
    { code: "IS.40.6612", name: "Þingeyjarsveit" },
    { code: "IS.40.6706", name: "Svalbarðshreppur" },
    { code: "IS.40.6709", name: "Langanesbyggð" },
  ],
  "IS.41": [
    { code: "IS.41.5200", name: "Sveitarfélagið Skagafjörður" },
    { code: "IS.41.5508", name: "Húnaþing Vestra" },
    { code: "IS.41.5604", name: "Blönduósbær" },
    { code: "IS.41.5609", name: "Sveitarfélagið Skagaströnd" },
    { code: "IS.41.5611", name: "Skagabyggð" },
    { code: "IS.41.5612", name: "Húnavatnshreppur" },
    { code: "IS.41.5706", name: "Akrahreppur" },
  ],
  "IS.42": [
    { code: "IS.42.8000", name: "Vestmannaeyjabær" },
    { code: "IS.42.8200", name: "Sveitarfélagið Árborg" },
    { code: "IS.42.8508", name: "Mýrdalshreppur" },
    { code: "IS.42.8509", name: "Skaftárhreppur" },
    { code: "IS.42.8610", name: "Ásahreppur" },
    { code: "IS.42.8613", name: "Rangárþing Eystra" },
    { code: "IS.42.8614", name: "Rangárþing Ytra" },
    { code: "IS.42.8710", name: "Hrunamannahreppur" },
    { code: "IS.42.8716", name: "Hveragerðisbær" },
    { code: "IS.42.8717", name: "Sveitarfélagið Ölfus" },
    { code: "IS.42.8719", name: "Grímsnes- og Grafningshreppur" },
    { code: "IS.42.8720", name: "Skeiða- og Gnúpverjahreppur" },
    { code: "IS.42.8721", name: "Bláskógabyggð" },
    { code: "IS.42.8722", name: "Flóahreppur" },
  ],
  "IS.43": [
    { code: "IS.43.2000", name: "Reykjanesbær" },
    { code: "IS.43.2300", name: "Grindavíkurbær" },
    { code: "IS.43.2503", name: "Sandgerðisbær" },
    { code: "IS.43.2504", name: "Sveitarfélagið Garður" },
    { code: "IS.43.2506", name: "Sveitarfélagið Vogar" },
  ],
  "IS.44": [
    { code: "IS.44.4100", name: "Bolungarvíkurkaupstaður" },
    { code: "IS.44.4200", name: "Ísafjarðarbær" },
    { code: "IS.44.4502", name: "Reykhólahreppur" },
    { code: "IS.44.4604", name: "Tálknafjarðarhreppur" },
    { code: "IS.44.4607", name: "Vesturbyggð" },
    { code: "IS.44.4803", name: "Súðavíkurhreppur" },
    { code: "IS.44.4901", name: "Árneshreppur" },
    { code: "IS.44.4902", name: "Kaldrananeshreppur" },
    { code: "IS.44.4911", name: "Strandabyggð" },
  ],
  "IS.45": [
    { code: "IS.45.3000", name: "Akraneskaupstaður" },
    { code: "IS.45.3506", name: "Skorradalshreppur" },
    { code: "IS.45.3511", name: "Hvalfjarðarsveit" },
    { code: "IS.45.3609", name: "Borgarbyggð" },
    { code: "IS.45.3709", name: "Grundarfjarðarbær" },
    { code: "IS.45.3710", name: "Helgafellssveit" },
    { code: "IS.45.3711", name: "Stykkishólmsbær" },
    { code: "IS.45.3713", name: "Eyja- og Miklaholtshreppur" },
    { code: "IS.45.3714", name: "Snæfellsbær" },
    { code: "IS.45.3811", name: "Dalabyggð" },
  ],
  "IT.01": [
    { code: "IT.01.AQ", name: "Provincia dell' Aquila" },
    { code: "IT.01.CH", name: "Provincia di Chieti" },
    { code: "IT.01.PE", name: "Provincia di Pescara" },
    { code: "IT.01.TE", name: "Provincia di Teramo" },
  ],
  "IT.02": [
    { code: "IT.02.MT", name: "Provincia di Matera" },
    { code: "IT.02.PZ", name: "Provincia di Potenza" },
  ],
  "IT.03": [
    { code: "IT.03.CS", name: "Provincia di Cosenza" },
    { code: "IT.03.CZ", name: "Provincia di Catanzaro" },
    { code: "IT.03.KR", name: "Provincia di Crotone" },
    { code: "IT.03.RC", name: "Provincia di Reggio Calabria" },
    { code: "IT.03.VV", name: "Provincia di Vibo-Valentia" },
  ],
  "IT.04": [
    { code: "IT.04.AV", name: "Provincia di Avellino" },
    { code: "IT.04.BN", name: "Provincia di Benevento" },
    { code: "IT.04.CE", name: "Provincia di Caserta" },
    { code: "IT.04.NA", name: "Napoli" },
    { code: "IT.04.SA", name: "Provincia di Salerno" },
  ],
  "IT.05": [
    { code: "IT.05.BO", name: "Bologna" },
    { code: "IT.05.FC", name: "Provincia di Forlì-Cesena" },
    { code: "IT.05.FE", name: "Provincia di Ferrara" },
    { code: "IT.05.MO", name: "Provincia di Modena" },
    { code: "IT.05.PC", name: "Provincia di Piacenza" },
    { code: "IT.05.PR", name: "Provincia di Parma" },
    { code: "IT.05.RA", name: "Provincia di Ravenna" },
    { code: "IT.05.RE", name: "Provincia di Reggio Emilia" },
    { code: "IT.05.RN", name: "Provincia di Rimini" },
  ],
  "IT.06": [
    { code: "IT.06.GO", name: "Provincia di Gorizia" },
    { code: "IT.06.PN", name: "Provincia di Pordenone" },
    { code: "IT.06.TS", name: "Provincia di Trieste" },
    { code: "IT.06.UD", name: "Provincia di Udine" },
  ],
  "IT.07": [
    { code: "IT.07.FR", name: "Provincia di Frosinone" },
    { code: "IT.07.LT", name: "Provincia di Latina" },
    { code: "IT.07.RI", name: "Provincia di Rieti" },
    { code: "IT.07.RM", name: "Città metropolitana di Roma Capitale" },
    { code: "IT.07.VT", name: "Provincia di Viterbo" },
  ],
  "IT.08": [
    { code: "IT.08.GE", name: "Provincia di Genova" },
    { code: "IT.08.IM", name: "Provincia di Imperia" },
    { code: "IT.08.SP", name: "Provincia di La Spezia" },
    { code: "IT.08.SV", name: "Provincia di Savona" },
  ],
  "IT.09": [
    { code: "IT.09.BG", name: "Provincia di Bergamo" },
    { code: "IT.09.BS", name: "Provincia di Brescia" },
    { code: "IT.09.CO", name: "Provincia di Como" },
    { code: "IT.09.CR", name: "Provincia di Cremona" },
    { code: "IT.09.LC", name: "Provincia di Lecco" },
    { code: "IT.09.LO", name: "Provincia di Lodi" },
    { code: "IT.09.MB", name: "Provincia di Monza e della Brianza" },
    { code: "IT.09.MI", name: "Città metropolitana di Milano" },
    { code: "IT.09.MN", name: "Provincia di Mantova" },
    { code: "IT.09.PV", name: "Provincia di Pavia" },
    { code: "IT.09.SO", name: "Provincia di Sondrio" },
    { code: "IT.09.VA", name: "Provincia di Varese" },
  ],
  "IT.10": [
    { code: "IT.10.AN", name: "Provincia di Ancona" },
    { code: "IT.10.AP", name: "Provincia di Ascoli Piceno" },
    { code: "IT.10.FM", name: "Province of Fermo" },
    { code: "IT.10.MC", name: "Provincia di Macerata" },
    { code: "IT.10.PU", name: "Provincia di Pesaro e Urbino" },
  ],
  "IT.11": [
    { code: "IT.11.CB", name: "Provincia di Campobasso" },
    { code: "IT.11.IS", name: "Provincia di Isernia" },
  ],
  "IT.12": [
    { code: "IT.12.AL", name: "Provincia di Alessandria" },
    { code: "IT.12.AT", name: "Provincia di Asti" },
    { code: "IT.12.BI", name: "Provincia di Biella" },
    { code: "IT.12.CN", name: "Provincia di Cuneo" },
    { code: "IT.12.NO", name: "Provincia di Novara" },
    { code: "IT.12.TO", name: "Torino" },
    { code: "IT.12.VB", name: "Provincia Verbano-Cusio-Ossola" },
    { code: "IT.12.VC", name: "Provincia di Vercelli" },
  ],
  "IT.13": [
    { code: "IT.13.BA", name: "Bari" },
    { code: "IT.13.BR", name: "Provincia di Brindisi" },
    { code: "IT.13.BT", name: "Provincia di Barletta - Andria - Trani" },
    { code: "IT.13.FG", name: "Provincia di Foggia" },
    { code: "IT.13.LE", name: "Provincia di Lecce" },
    { code: "IT.13.TA", name: "Provincia di Taranto" },
  ],
  "IT.14": [
    { code: "IT.14.CA", name: "Provincia di Cagliari" },
    { code: "IT.14.NU", name: "Provincia di Nuoro" },
    { code: "IT.14.OR", name: "Provincia di Oristano" },
    { code: "IT.14.SS", name: "Provincia di Sassari" },
    { code: "IT.14.SU", name: "Provincia del Sud Sardegna" },
  ],
  "IT.15": [
    { code: "IT.15.AG", name: "Agrigento" },
    { code: "IT.15.CL", name: "Provincia di Caltanissetta" },
    { code: "IT.15.CT", name: "Catania" },
    { code: "IT.15.EN", name: "Enna" },
    { code: "IT.15.ME", name: "Messina" },
    { code: "IT.15.PA", name: "Palermo" },
    { code: "IT.15.RG", name: "Ragusa" },
    { code: "IT.15.SR", name: "Provincia di Siracusa" },
    { code: "IT.15.TP", name: "Trapani" },
  ],
  "IT.16": [
    { code: "IT.16.AR", name: "Province of Arezzo" },
    { code: "IT.16.FI", name: "Province of Florence" },
    { code: "IT.16.GR", name: "Provincia di Grosseto" },
    { code: "IT.16.LI", name: "Provincia di Livorno" },
    { code: "IT.16.LU", name: "Provincia di Lucca" },
    { code: "IT.16.MS", name: "Provincia di Massa-Carrara" },
    { code: "IT.16.PI", name: "Province of Pisa" },
    { code: "IT.16.PO", name: "Provincia di Prato" },
    { code: "IT.16.PT", name: "Provincia di Pistoia" },
    { code: "IT.16.SI", name: "Provincia di Siena" },
  ],
  "IT.17": [
    { code: "IT.17.BZ", name: "Bolzano" },
    { code: "IT.17.TN", name: "Provincia autonoma di Trento" },
  ],
  "IT.18": [
    { code: "IT.18.PG", name: "Provincia di Perugia" },
    { code: "IT.18.TR", name: "Provincia di Terni" },
  ],
  "IT.19": [
    { code: "IT.19.AO", name: "Valle d'Aosta" },
  ],
  "IT.20": [
    { code: "IT.20.BL", name: "Provincia di Belluno" },
    { code: "IT.20.PD", name: "Provincia di Padova" },
    { code: "IT.20.RO", name: "Provincia di Rovigo" },
    { code: "IT.20.TV", name: "Provincia di Treviso" },
    { code: "IT.20.VE", name: "Provincia di Venezia" },
    { code: "IT.20.VI", name: "Provincia di Vicenza" },
    { code: "IT.20.VR", name: "Provincia di Verona" },
  ],
  "JM.01": [
    { code: "JM.01.1301", name: "Silent Hill" },
    { code: "JM.01.1302", name: "Spaldings" },
    { code: "JM.01.1303", name: "Alston" },
    { code: "JM.01.1304", name: "Morgans Forest" },
    { code: "JM.01.1305", name: "Aenon Town" },
    { code: "JM.01.1306", name: "Johns Hall" },
    { code: "JM.01.1307", name: "James Hill" },
    { code: "JM.01.1308", name: "Part of Douglas Castle" },
    { code: "JM.01.1309", name: "Part of Kellits" },
    { code: "JM.01.1310", name: "Brandon Hill" },
    { code: "JM.01.1311", name: "Crofts Hill" },
    { code: "JM.01.1312", name: "Colonels Ridge" },
    { code: "JM.01.1313", name: "Morgans Pass" },
    { code: "JM.01.1314", name: "Crooked River" },
    { code: "JM.01.1315", name: "Trout Hall" },
    { code: "JM.01.1316", name: "Frankfield" },
    { code: "JM.01.1317", name: "Peckham" },
    { code: "JM.01.1318", name: "Grantham" },
    { code: "JM.01.1319", name: "Sanguinetti" },
    { code: "JM.01.1320", name: "Ritchies" },
    { code: "JM.01.1321", name: "Cumberland" },
    { code: "JM.01.1322", name: "Coffee Piece" },
    { code: "JM.01.1323", name: "Smithville" },
    { code: "JM.01.1324", name: "Orange Hill" },
    { code: "JM.01.1325", name: "Pennants" },
    { code: "JM.01.1326", name: "Summerfield" },
    { code: "JM.01.1327", name: "Chapelton" },
    { code: "JM.01.1328", name: "Coxswain" },
    { code: "JM.01.1329", name: "Rock River" },
    { code: "JM.01.1330", name: "Turners" },
    { code: "JM.01.1331", name: "Woodhall" },
    { code: "JM.01.1332", name: "Dawkins" },
    { code: "JM.01.1333", name: "Beckford Kraal" },
    { code: "JM.01.1334", name: "Thompson Town" },
    { code: "JM.01.1335", name: "Part of Banana Ground" },
    { code: "JM.01.1336", name: "Porus" },
    { code: "JM.01.1337", name: "Richmond Park" },
    { code: "JM.01.1338", name: "Mount Airy" },
    { code: "JM.01.1339", name: "Rock" },
    { code: "JM.01.1340", name: "Ashley" },
    { code: "JM.01.1341", name: "Brixton Hill" },
    { code: "JM.01.1342", name: "Pleasant Valley" },
    { code: "JM.01.1343", name: "New Denbigh" },
    { code: "JM.01.1344", name: "Treadlight" },
    { code: "JM.01.1345", name: "Bucknor" },
    { code: "JM.01.1346", name: "New Longsville" },
    { code: "JM.01.1347", name: "Moores" },
    { code: "JM.01.1348", name: "Chateau" },
    { code: "JM.01.1349", name: "Effortville" },
    { code: "JM.01.1350", name: "Bucks Common" },
    { code: "JM.01.1351", name: "May Pen Proper" },
    { code: "JM.01.1352", name: "Bushy Park" },
    { code: "JM.01.1353", name: "Glenmuir" },
    { code: "JM.01.1354", name: "Old Denbigh" },
    { code: "JM.01.1355", name: "Four Paths" },
    { code: "JM.01.1356", name: "Osbourne Store" },
    { code: "JM.01.1357", name: "Tollgate" },
    { code: "JM.01.1358", name: "Milk River" },
    { code: "JM.01.1359", name: "Gravel Hill" },
    { code: "JM.01.1360", name: "York Town" },
    { code: "JM.01.1361", name: "Curatoe Hill" },
    { code: "JM.01.1362", name: "Mineral Heights" },
    { code: "JM.01.1363", name: "Hazard" },
    { code: "JM.01.1364", name: "Paisley" },
    { code: "JM.01.1365", name: "Palmers Cross" },
    { code: "JM.01.1366", name: "Sandy Bay" },
    { code: "JM.01.1367", name: "Freetown" },
    { code: "JM.01.1368", name: "Inverness" },
    { code: "JM.01.1369", name: "Longville Park" },
    { code: "JM.01.1370", name: "Cockpit" },
    { code: "JM.01.1371", name: "Salt River" },
    { code: "JM.01.1372", name: "Hayes" },
    { code: "JM.01.1373", name: "Gimme-me-bit" },
    { code: "JM.01.1374", name: "Sedgepond" },
    { code: "JM.01.1375", name: "Banks" },
    { code: "JM.01.1376", name: "Race Course" },
    { code: "JM.01.1377", name: "Water Lane" },
    { code: "JM.01.1378", name: "Longwood" },
    { code: "JM.01.1379", name: "Alley" },
    { code: "JM.01.1380", name: "Lionel Town" },
    { code: "JM.01.1381", name: "Rocky Point" },
    { code: "JM.01.1382", name: "Portland Cottage" },
    { code: "JM.01.1383", name: "Mitchell Town" },
  ],
  "JM.02": [
    { code: "JM.02.901", name: "Cousins Cove" },
    { code: "JM.02.902", name: "Lances Bay" },
    { code: "JM.02.903", name: "Cacoon" },
    { code: "JM.02.904", name: "Lucea West" },
    { code: "JM.02.905", name: "Lucea East" },
    { code: "JM.02.906", name: "Jericho" },
    { code: "JM.02.907", name: "Sandy Bay" },
    { code: "JM.02.908", name: "Hopewell" },
    { code: "JM.02.909", name: "Woodlands" },
    { code: "JM.02.910", name: "Cacoon Castle" },
    { code: "JM.02.911", name: "Haddington" },
    { code: "JM.02.912", name: "Copse" },
    { code: "JM.02.913", name: "Chester Castle" },
    { code: "JM.02.914", name: "Ramble" },
    { code: "JM.02.916", name: "Mount Peto" },
    { code: "JM.02.917", name: "Success" },
    { code: "JM.02.918", name: "Great Valley" },
    { code: "JM.02.919", name: "Woodsville" },
    { code: "JM.02.920", name: "Pondside" },
    { code: "JM.02.921", name: "Cascade" },
    { code: "JM.02.922", name: "Cash Hill" },
    { code: "JM.02.923", name: "Maryland" },
    { code: "JM.02.924", name: "Askenish" },
    { code: "JM.02.925", name: "Chambers Pen" },
    { code: "JM.02.926", name: "Dias" },
    { code: "JM.02.927", name: "Kingsvale" },
    { code: "JM.02.928", name: "Kendal" },
    { code: "JM.02.929", name: "Pell River" },
    { code: "JM.02.930", name: "Cauldwell" },
    { code: "JM.02.931", name: "Green Island" },
    { code: "JM.02.932", name: "Rock Spring" },
    { code: "JM.02.933", name: "March Town" },
    { code: "JM.02.934", name: "Santoy" },
    { code: "JM.02.935", name: "Logwood" },
    { code: "JM.02.936", name: "Orange Bay" },
  ],
  "JM.04": [
    { code: "JM.04.1201", name: "Auchtembeddie" },
    { code: "JM.04.1202", name: "Craig Head" },
    { code: "JM.04.1203", name: "Pike" },
    { code: "JM.04.1204", name: "Coleyville" },
    { code: "JM.04.1205", name: "Robins Hall" },
    { code: "JM.04.1206", name: "Good Intent" },
    { code: "JM.04.1207", name: "Comfort Hall" },
    { code: "JM.04.1208", name: "Harry Watch" },
    { code: "JM.04.1209", name: "Hibernia" },
    { code: "JM.04.1210", name: "Devon" },
    { code: "JM.04.1211", name: "Christiana" },
    { code: "JM.04.1212", name: "Spring Ground" },
    { code: "JM.04.1213", name: "Part of Spaldings" },
    { code: "JM.04.1214", name: "Cobbla" },
    { code: "JM.04.1215", name: "Chudleigh" },
    { code: "JM.04.1216", name: "Bethany" },
    { code: "JM.04.1217", name: "Litchfield" },
    { code: "JM.04.1218", name: "Mile Gully" },
    { code: "JM.04.1219", name: "Evergreen" },
    { code: "JM.04.1220", name: "St. Paul's" },
    { code: "JM.04.1221", name: "Medina" },
    { code: "JM.04.1222", name: "Maidstone" },
    { code: "JM.04.1223", name: "Grove Place" },
    { code: "JM.04.1224", name: "Top Hill" },
    { code: "JM.04.1225", name: "Walderston" },
    { code: "JM.04.1226", name: "Chantilly" },
    { code: "JM.04.1227", name: "Bombay" },
    { code: "JM.04.1228", name: "Bellefield" },
    { code: "JM.04.1229", name: "Part Of Banana Ground" },
    { code: "JM.04.1230", name: "Comfort" },
    { code: "JM.04.1231", name: "Blue Mountain" },
    { code: "JM.04.1232", name: "Content" },
    { code: "JM.04.1233", name: "Williamsfield" },
    { code: "JM.04.1234", name: "Kendal" },
    { code: "JM.04.1235", name: "New Green" },
    { code: "JM.04.1236", name: "Somerset" },
    { code: "JM.04.1237", name: "Huntley" },
    { code: "JM.04.1238", name: "Part Of Gutters" },
    { code: "JM.04.1239", name: "Fairfield" },
    { code: "JM.04.1240", name: "Mike Town" },
    { code: "JM.04.1241", name: "Greenvale" },
    { code: "JM.04.1242", name: "Mandeville Proper" },
    { code: "JM.04.1243", name: "Heartease" },
    { code: "JM.04.1244", name: "Royal Flat" },
    { code: "JM.04.1245", name: "Porus" },
    { code: "JM.04.1246", name: "Scotts Pass" },
    { code: "JM.04.1247", name: "Harmons" },
    { code: "JM.04.1248", name: "Ellen Street" },
    { code: "JM.04.1249", name: "Old England" },
    { code: "JM.04.1250", name: "Richmond" },
    { code: "JM.04.1251", name: "George's Valley" },
    { code: "JM.04.1252", name: "May Day" },
    { code: "JM.04.1253", name: "Cedar Grove" },
    { code: "JM.04.1254", name: "Knockpatrick" },
    { code: "JM.04.1255", name: "Watham" },
    { code: "JM.04.1256", name: "Hatfield" },
    { code: "JM.04.1257", name: "Spur Tree" },
    { code: "JM.04.1258", name: "Prospect" },
    { code: "JM.04.1259", name: "Butt-Up" },
    { code: "JM.04.1260", name: "Downs" },
    { code: "JM.04.1261", name: "French Park" },
    { code: "JM.04.1262", name: "Swaby's Hope" },
    { code: "JM.04.1263", name: "Newport" },
    { code: "JM.04.1264", name: "Snowdon" },
    { code: "JM.04.1265", name: "Lancaster" },
    { code: "JM.04.1266", name: "Rose Hill" },
    { code: "JM.04.1267", name: "Plowden" },
    { code: "JM.04.1268", name: "New Forest" },
    { code: "JM.04.1269", name: "Alligator Pond" },
    { code: "JM.04.1270", name: "Marlie Hill" },
    { code: "JM.04.1271", name: "Cross Keys" },
    { code: "JM.04.1272", name: "Grove Town" },
    { code: "JM.04.1273", name: "Asia/Pratville" },
    { code: "JM.04.1274", name: "Victoria Town" },
  ],
  "JM.07": [
    { code: "JM.07.401", name: "Windsor Castle" },
    { code: "JM.07.402", name: "Belvedere" },
    { code: "JM.07.403", name: "Charles Town" },
    { code: "JM.07.404", name: "Buff Bay" },
    { code: "JM.07.405", name: "Orange Bay" },
    { code: "JM.07.406", name: "Black Hill" },
    { code: "JM.07.407", name: "Hope Bay" },
    { code: "JM.07.408", name: "Rock Hall" },
    { code: "JM.07.409", name: "St. Margaret's Bay" },
    { code: "JM.07.410", name: "Mount Pleasant" },
    { code: "JM.07.411", name: "Snow Hill" },
    { code: "JM.07.412", name: "Norwich" },
    { code: "JM.07.413", name: "Boundbrook" },
    { code: "JM.07.414", name: "Breastworks" },
    { code: "JM.07.415", name: "Central Port Antonio" },
    { code: "JM.07.416", name: "Prospect" },
    { code: "JM.07.417", name: "Drapers" },
    { code: "JM.07.418", name: "Nonsuch" },
    { code: "JM.07.419", name: "Sherwood Forest" },
    { code: "JM.07.420", name: "Fairy Hill" },
    { code: "JM.07.421", name: "Castle Comfort" },
    { code: "JM.07.422", name: "Windsor Forest" },
    { code: "JM.07.424", name: "Long Bay" },
    { code: "JM.07.425", name: "Kensington" },
    { code: "JM.07.426", name: "Manchioneal" },
    { code: "JM.07.427", name: "Long Road" },
    { code: "JM.07.428", name: "Hectors River" },
    { code: "JM.07.429", name: "Comfort Castle" },
    { code: "JM.07.430", name: "Moore Town" },
    { code: "JM.07.431", name: "Windsor" },
    { code: "JM.07.432", name: "Fellowship" },
    { code: "JM.07.433", name: "Durham" },
    { code: "JM.07.434", name: "Fruitfulvale" },
    { code: "JM.07.435", name: "Swift River" },
    { code: "JM.07.436", name: "Shirley Castle" },
    { code: "JM.07.437", name: "Skibo" },
    { code: "JM.07.438", name: "Claverty Cottage" },
    { code: "JM.07.439", name: "Bybrook" },
    { code: "JM.07.440", name: "Tranquility" },
    { code: "JM.07.441", name: "Bangor Ridge" },
    { code: "JM.07.442", name: "Balcarres" },
    { code: "JM.07.443", name: "Spring Hill" },
    { code: "JM.07.444", name: "Cascade" },
  ],
  "JM.08": [
    { code: "JM.08.15001", name: "August Town" },
    { code: "JM.08.15002", name: "Hermitage" },
    { code: "JM.08.15003", name: "University" },
    { code: "JM.08.15004", name: "Mona Heights" },
    { code: "JM.08.15005", name: "Elleston Flats/ Mona Commons" },
    { code: "JM.08.15006", name: "Papine" },
    { code: "JM.08.15007", name: "Kintyre" },
    { code: "JM.08.15008", name: "Hope Tavern" },
    { code: "JM.08.15009", name: "Jacks Hill" },
    { code: "JM.08.15010", name: "Hope Pastures/ UTECH" },
    { code: "JM.08.15011", name: "Barbican" },
    { code: "JM.08.15012", name: "Liguanea" },
    { code: "JM.08.15013", name: "Beverley Hills" },
    { code: "JM.08.15014", name: "Swallowfield" },
    { code: "JM.08.15015", name: "Seymour Lands" },
    { code: "JM.08.15016", name: "Trafalgar Park" },
    { code: "JM.08.15017", name: "New Kingston" },
    { code: "JM.08.15018", name: "Half-Way-Tree" },
    { code: "JM.08.15019", name: "Drumblair" },
    { code: "JM.08.15020", name: "Grants Pen" },
    { code: "JM.08.15021", name: "Arcadia" },
    { code: "JM.08.15022", name: "Cherry Gardens" },
    { code: "JM.08.15023", name: "Norbrook" },
    { code: "JM.08.15024", name: "Stony Hill" },
    { code: "JM.08.15025", name: "Constant Spring" },
    { code: "JM.08.15026", name: "Oaklands" },
    { code: "JM.08.15027", name: "Constant Spring Gardens" },
    { code: "JM.08.15028", name: "Zaidie Gardens" },
    { code: "JM.08.15029", name: "Red Hills Gardens" },
    { code: "JM.08.15030", name: "Whitehall" },
    { code: "JM.08.15031", name: "Roehampton" },
    { code: "JM.08.15032", name: "Havendale" },
    { code: "JM.08.15033", name: "Mannings Hill" },
    { code: "JM.08.15034", name: "Red Hills/ Sterling Castle" },
    { code: "JM.08.15035", name: "Forest Hills/ Plantation Height" },
    { code: "JM.08.15036", name: "Meadowbrook" },
    { code: "JM.08.15037", name: "Queensborough/ Tunbridge" },
    { code: "JM.08.15038", name: "Forest Hills Gardens" },
    { code: "JM.08.15039", name: "Meadowbrook Estate" },
    { code: "JM.08.15040", name: "Patrick City" },
    { code: "JM.08.15041", name: "Duhaney Park" },
    { code: "JM.08.15042", name: "New Haven" },
    { code: "JM.08.15043", name: "Ferry" },
    { code: "JM.08.15044", name: "Riverton City" },
    { code: "JM.08.15045", name: "Cooreville Gardens" },
    { code: "JM.08.15046", name: "Washington Gardens" },
    { code: "JM.08.15047", name: "Pembroke Hall" },
    { code: "JM.08.15048", name: "Arlene Gardens" },
    { code: "JM.08.15049", name: "Three Oaks/ Glendale" },
    { code: "JM.08.15050", name: "Hughenden" },
    { code: "JM.08.15051", name: "Marverley" },
    { code: "JM.08.15052", name: "Drewsland" },
    { code: "JM.08.15053", name: "Penwood" },
    { code: "JM.08.15054", name: "Waterhouse" },
    { code: "JM.08.15055", name: "Seaview Gardens" },
    { code: "JM.08.15056", name: "Majestic Gardens" },
    { code: "JM.08.15057", name: "Cockburn Gardens" },
    { code: "JM.08.15058", name: "Waltham Gardens" },
    { code: "JM.08.15059", name: "Tower Hill" },
    { code: "JM.08.15060", name: "Seaward Pen" },
    { code: "JM.08.15061", name: "Molynes Gardens" },
    { code: "JM.08.15062", name: "Cassia Park" },
    { code: "JM.08.15063", name: "Eastwood Park Gardens" },
    { code: "JM.08.15064", name: "Molynes Four Roads" },
    { code: "JM.08.15065", name: "Boucher Park" },
    { code: "JM.08.15066", name: "Delacree Pen" },
    { code: "JM.08.15067", name: "Delacree Park/ Union Gardens" },
    { code: "JM.08.15068", name: "Greenwich Town/ Newport West" },
    { code: "JM.08.15069", name: "Whitfield Town" },
    { code: "JM.08.15070", name: "Maxfield Park" },
    { code: "JM.08.15071", name: "Richmond Park" },
    { code: "JM.08.15072", name: "Kencot" },
    { code: "JM.08.15073", name: "Arnett Gardens" },
    { code: "JM.08.15074", name: "Rose Town" },
    { code: "JM.08.15075", name: "Wilton Gardens/ Rema" },
    { code: "JM.08.15076", name: "Trench Town" },
    { code: "JM.08.15077", name: "Jones Town" },
    { code: "JM.08.15078", name: "Cross Roads" },
    { code: "JM.08.15079", name: "Woodford Park" },
    { code: "JM.08.15080", name: "Stadium Gardens" },
    { code: "JM.08.15081", name: "Nannyville" },
    { code: "JM.08.15082", name: "Vineyard Town" },
    { code: "JM.08.15083", name: "Mountain View Gardens" },
    { code: "JM.08.15084", name: "Harbour View" },
    { code: "JM.08.15085", name: "Bull Bay/ Seven Mile" },
    { code: "JM.08.15110", name: "Lawrence Tavern" },
    { code: "JM.08.15111", name: "Brandon Hill" },
    { code: "JM.08.15112", name: "Temple Hall" },
    { code: "JM.08.15113", name: "Mount James" },
    { code: "JM.08.15114", name: "Golden Spring" },
    { code: "JM.08.15115", name: "Cavaliers" },
    { code: "JM.08.15116", name: "Parks Road" },
    { code: "JM.08.15117", name: "Red Hills (Rural)" },
    { code: "JM.08.15118", name: "Mannings Hill (Rural)" },
    { code: "JM.08.15119", name: "Woodford" },
    { code: "JM.08.15120", name: "Maryland" },
    { code: "JM.08.15121", name: "Irish Town" },
    { code: "JM.08.15122", name: "St. Peter's" },
    { code: "JM.08.15123", name: "Content Gap" },
    { code: "JM.08.15124", name: "Mavis Bank" },
    { code: "JM.08.15125", name: "Gordon Town" },
    { code: "JM.08.15126", name: "Constitution Hill" },
    { code: "JM.08.15127", name: "Dallas" },
    { code: "JM.08.15128", name: "Bloxborough" },
    { code: "JM.08.15129", name: "Bito" },
    { code: "JM.08.15130", name: "Cane River" },
  ],
  "JM.09": [
    { code: "JM.09.601", name: "Discovery Bay" },
    { code: "JM.09.602", name: "Runaway Bay" },
    { code: "JM.09.603", name: "Mount Zion" },
    { code: "JM.09.604", name: "Chester" },
    { code: "JM.09.605", name: "Priory" },
    { code: "JM.09.606", name: "St. Ann's Bay" },
    { code: "JM.09.607", name: "Steer Town" },
    { code: "JM.09.608", name: "Ocho Rios" },
    { code: "JM.09.609", name: "Content Garden" },
    { code: "JM.09.610", name: "Exchange" },
    { code: "JM.09.611", name: "Great Pond" },
    { code: "JM.09.612", name: "Mansfield" },
    { code: "JM.09.613", name: "Parry Town" },
    { code: "JM.09.615", name: "Pimento Walk" },
    { code: "JM.09.616", name: "Beecher Town" },
    { code: "JM.09.617", name: "Epworth" },
    { code: "JM.09.618", name: "Chalky Hill" },
    { code: "JM.09.619", name: "Lime Hall" },
    { code: "JM.09.620", name: "Bamboo" },
    { code: "JM.09.621", name: "Sturge Town" },
    { code: "JM.09.622", name: "Philadelphia" },
    { code: "JM.09.623", name: "Browns Town" },
    { code: "JM.09.624", name: "Gibraltar" },
    { code: "JM.09.625", name: "Lime Tree Gardens" },
    { code: "JM.09.626", name: "St. D'Acre" },
    { code: "JM.09.627", name: "Alexandria" },
    { code: "JM.09.628", name: "Alva" },
    { code: "JM.09.629", name: "Higgin Land" },
    { code: "JM.09.630", name: "Claremont" },
    { code: "JM.09.631", name: "Golden Grove" },
    { code: "JM.09.632", name: "Hinds Town" },
    { code: "JM.09.633", name: "Cole Gate" },
    { code: "JM.09.634", name: "Walkers Wood" },
    { code: "JM.09.635", name: "Moneague" },
    { code: "JM.09.636", name: "Alderton" },
    { code: "JM.09.637", name: "Calderwood" },
    { code: "JM.09.638", name: "Inverness" },
    { code: "JM.09.639", name: "Linton Park" },
    { code: "JM.09.640", name: "Watt Town" },
    { code: "JM.09.641", name: "Madras" },
    { code: "JM.09.642", name: "Cascade" },
    { code: "JM.09.643", name: "Bohemia" },
    { code: "JM.09.644", name: "Mount Moriah" },
    { code: "JM.09.645", name: "Borobridge" },
    { code: "JM.09.646", name: "Cuffie Ridge" },
    { code: "JM.09.647", name: "Cave Valley" },
    { code: "JM.09.648", name: "Aboukir" },
    { code: "JM.09.649", name: "Macknie" },
    { code: "JM.09.650", name: "York Castle" },
    { code: "JM.09.651", name: "Bensonton" },
    { code: "JM.09.652", name: "Gibraltar" },
    { code: "JM.09.653", name: "Faith's Pen" },
    { code: "JM.09.654", name: "River Head" },
    { code: "JM.09.655", name: "Blackstonedge" },
  ],
  "JM.10": [
    { code: "JM.10.1401", name: "Lluidas Vale" },
    { code: "JM.10.1402", name: "Ewarton" },
    { code: "JM.10.1403", name: "Linstead" },
    { code: "JM.10.1404", name: "Part of Guys Hill" },
    { code: "JM.10.1405", name: "Pear Tree Grove" },
    { code: "JM.10.1406", name: "Redwood" },
    { code: "JM.10.1407", name: "Riversdale" },
    { code: "JM.10.1408", name: "Troja" },
    { code: "JM.10.1409", name: "Harewood" },
    { code: "JM.10.1410", name: "Glengoffe" },
    { code: "JM.10.1411", name: "Above Rocks" },
    { code: "JM.10.1412", name: "Harkers Hall" },
    { code: "JM.10.1413", name: "Bogwalk" },
    { code: "JM.10.1414", name: "Sligoville" },
    { code: "JM.10.1415", name: "Part of Rock Hall" },
    { code: "JM.10.1416", name: "Caymanas" },
    { code: "JM.10.1417", name: "Keystone" },
    { code: "JM.10.1418", name: "Part of Keystone" },
    { code: "JM.10.1419", name: "Greendale" },
    { code: "JM.10.1420", name: "Ensom" },
    { code: "JM.10.1421", name: "Crescent" },
    { code: "JM.10.1422", name: "Kitson Town" },
    { code: "JM.10.1423", name: "Watermount" },
    { code: "JM.10.1424", name: "Point Hill" },
    { code: "JM.10.1425", name: "Browns Hill" },
    { code: "JM.10.1426", name: "Ginger Ridge" },
    { code: "JM.10.1427", name: "Bellas Gate" },
    { code: "JM.10.1428", name: "Bartons" },
    { code: "JM.10.1429", name: "Old Harbour" },
    { code: "JM.10.1430", name: "Old Harbour Bay" },
    { code: "JM.10.1431", name: "Old Harbour Road" },
    { code: "JM.10.1432", name: "St. John's West" },
    { code: "JM.10.1433", name: "Golden Acres" },
    { code: "JM.10.1434", name: "Hampton Green" },
    { code: "JM.10.1435", name: "St. John's East" },
    { code: "JM.10.1436", name: "Willowdene" },
    { code: "JM.10.1437", name: "Cromarty" },
    { code: "JM.10.1438", name: "Spanish Town Central" },
    { code: "JM.10.1439", name: "Central Village" },
    { code: "JM.10.1440", name: "Gregory Park" },
    { code: "JM.10.1441", name: "Waterford" },
    { code: "JM.10.1442", name: "Passage Fort" },
    { code: "JM.10.1443", name: "Edgewater" },
    { code: "JM.10.1444", name: "Bridgeport" },
    { code: "JM.10.1445", name: "Independence City" },
    { code: "JM.10.1446", name: "Cumberland" },
    { code: "JM.10.1447", name: "West Cumberland" },
    { code: "JM.10.1448", name: "Naggo Head" },
    { code: "JM.10.1449", name: "Braeton" },
    { code: "JM.10.1450", name: "Greater Portmore" },
    { code: "JM.10.1451", name: "Hellshire" },
  ],
  "JM.11": [
    { code: "JM.11.1101", name: "Pisgah" },
    { code: "JM.11.1102", name: "Springfield" },
    { code: "JM.11.1103", name: "Ginger Hill" },
    { code: "JM.11.1104", name: "Merrywood" },
    { code: "JM.11.1105", name: "Mulgrave" },
    { code: "JM.11.1106", name: "Elderslie" },
    { code: "JM.11.1107", name: "Retirement" },
    { code: "JM.11.1108", name: "Accompong" },
    { code: "JM.11.1109", name: "Quick Step" },
    { code: "JM.11.1110", name: "Balaclava" },
    { code: "JM.11.1111", name: "Aberdeen" },
    { code: "JM.11.1112", name: "Siloah" },
    { code: "JM.11.1113", name: "Thornton" },
    { code: "JM.11.1114", name: "Maggotty" },
    { code: "JM.11.1115", name: "Carisbrook" },
    { code: "JM.11.1116", name: "White Hill" },
    { code: "JM.11.1117", name: "Middle Quarters" },
    { code: "JM.11.1118", name: "Brighton" },
    { code: "JM.11.1119", name: "New Market" },
    { code: "JM.11.1120", name: "Giddy Hall" },
    { code: "JM.11.1121", name: "Cotterwood" },
    { code: "JM.11.1122", name: "Crawford" },
    { code: "JM.11.1123", name: "Brompton" },
    { code: "JM.11.1124", name: "Black River" },
    { code: "JM.11.1125", name: "Slipe" },
    { code: "JM.11.1126", name: "Holland" },
    { code: "JM.11.1127", name: "Lacovia" },
    { code: "JM.11.1128", name: "Newton" },
    { code: "JM.11.1129", name: "Bogue" },
    { code: "JM.11.1130", name: "Braes River" },
    { code: "JM.11.1131", name: "Goshen" },
    { code: "JM.11.1132", name: "Pepper" },
    { code: "JM.11.1133", name: "Leeds" },
    { code: "JM.11.1134", name: "Santa Cruz" },
    { code: "JM.11.1135", name: "Scholefield" },
    { code: "JM.11.1136", name: "Burnt Savannah" },
    { code: "JM.11.1137", name: "Fullerswood" },
    { code: "JM.11.1138", name: "Parottee" },
    { code: "JM.11.1139", name: "Pondside" },
    { code: "JM.11.1140", name: "Barbary Hall" },
    { code: "JM.11.1141", name: "Mountainside" },
    { code: "JM.11.1142", name: "Malvern" },
    { code: "JM.11.1143", name: "Russels" },
    { code: "JM.11.1144", name: "Hopeton" },
    { code: "JM.11.1145", name: "Warminister" },
    { code: "JM.11.1146", name: "Myersville" },
    { code: "JM.11.1147", name: "Nain" },
    { code: "JM.11.1148", name: "Lititz" },
    { code: "JM.11.1149", name: "Junction" },
    { code: "JM.11.1150", name: "Red Bank" },
    { code: "JM.11.1151", name: "Rose Hall" },
    { code: "JM.11.1152", name: "Potsdam" },
    { code: "JM.11.1153", name: "Bigwoods" },
    { code: "JM.11.1154", name: "Newell" },
    { code: "JM.11.1155", name: "Watchwell" },
    { code: "JM.11.1156", name: "Treasure Beach" },
    { code: "JM.11.1157", name: "Pedro Plains" },
    { code: "JM.11.1158", name: "Southfield" },
    { code: "JM.11.1159", name: "Top Hill" },
    { code: "JM.11.1160", name: "Ballards  Valley" },
    { code: "JM.11.1161", name: "Bull Savannah" },
  ],
  "JM.12": [
    { code: "JM.12.801", name: "Flankers" },
    { code: "JM.12.802", name: "Coral Gardens" },
    { code: "JM.12.803", name: "Ironshore" },
    { code: "JM.12.804", name: "Rose Hall" },
    { code: "JM.12.805", name: "Barrett Town" },
    { code: "JM.12.806", name: "Lilliput" },
    { code: "JM.12.807", name: "Greenwood" },
    { code: "JM.12.809", name: "Goodwill" },
    { code: "JM.12.810", name: "Spot Valley" },
    { code: "JM.12.811", name: "Cornwall" },
    { code: "JM.12.812", name: "Flower Hill" },
    { code: "JM.12.813", name: "Salt Spring" },
    { code: "JM.12.814", name: "Norwood" },
    { code: "JM.12.815", name: "Paradise" },
    { code: "JM.12.816", name: "Down Town Montego Bay" },
    { code: "JM.12.817", name: "Albion" },
    { code: "JM.12.818", name: "Canterbury" },
    { code: "JM.12.819", name: "Brandon Hill" },
    { code: "JM.12.820", name: "Glendevon" },
    { code: "JM.12.821", name: "Montego Hill" },
    { code: "JM.12.822", name: "Green Pond" },
    { code: "JM.12.823", name: "Orange" },
    { code: "JM.12.824", name: "Adelphi" },
    { code: "JM.12.825", name: "Dumfries" },
    { code: "JM.12.826", name: "Somerton" },
    { code: "JM.12.827", name: "Lottery" },
    { code: "JM.12.828", name: "Sunderland" },
    { code: "JM.12.829", name: "John's Hall" },
    { code: "JM.12.830", name: "Porto Bello" },
    { code: "JM.12.831", name: "Farm Heights" },
    { code: "JM.12.832", name: "Rose Heights" },
    { code: "JM.12.833", name: "Rosemount" },
    { code: "JM.12.834", name: "Mount Salem" },
    { code: "JM.12.835", name: "Catherine Hall" },
    { code: "JM.12.836", name: "West Green" },
    { code: "JM.12.837", name: "Fairfield" },
    { code: "JM.12.838", name: "Tucker" },
    { code: "JM.12.839", name: "Catherine Mount" },
    { code: "JM.12.840", name: "Rose Mount Garden" },
    { code: "JM.12.842", name: "Irwin" },
    { code: "JM.12.843", name: "Friendship" },
    { code: "JM.12.844", name: "Retirement" },
    { code: "JM.12.845", name: "Granville" },
    { code: "JM.12.846", name: "Pitfour" },
    { code: "JM.12.847", name: "Comfort Hall" },
    { code: "JM.12.848", name: "Bogue" },
    { code: "JM.12.849", name: "Reading" },
    { code: "JM.12.850", name: "Tower Hill/Moy Hall" },
    { code: "JM.12.852", name: "Unity Hall" },
    { code: "JM.12.854", name: "Anchovy" },
    { code: "JM.12.855", name: "Mount Carey" },
    { code: "JM.12.856", name: "Montpelier" },
    { code: "JM.12.857", name: "Roehampton" },
    { code: "JM.12.859", name: "Hopeton" },
    { code: "JM.12.860", name: "Welcome Hall" },
    { code: "JM.12.861", name: "Summer Hill" },
    { code: "JM.12.862", name: "Flagstaff" },
    { code: "JM.12.863", name: "Vaughnsfield" },
    { code: "JM.12.864", name: "Maroon Town" },
    { code: "JM.12.865", name: "Maldon" },
    { code: "JM.12.866", name: "Flamstead" },
    { code: "JM.12.867", name: "Tangle River" },
    { code: "JM.12.868", name: "Mount Horeb" },
    { code: "JM.12.869", name: "Bickersteth" },
    { code: "JM.12.870", name: "Seven Rivers" },
    { code: "JM.12.871", name: "Cambridge" },
    { code: "JM.12.872", name: "Retrieve" },
    { code: "JM.12.873", name: "Catadupa" },
    { code: "JM.12.874", name: "Mocho" },
    { code: "JM.12.875", name: "Garlands" },
    { code: "JM.12.876", name: "Arcadia" },
    { code: "JM.12.877", name: "Niagara" },
    { code: "JM.12.878", name: "Stonehenge" },
  ],
  "JM.13": [
    { code: "JM.13.501", name: "Prospect" },
    { code: "JM.13.502", name: "Charles Town" },
    { code: "JM.13.503", name: "Retreat" },
    { code: "JM.13.504", name: "Mango Valley" },
    { code: "JM.13.506", name: "Oracabessa" },
    { code: "JM.13.507", name: "Jacks River" },
    { code: "JM.13.508", name: "Mason Hall" },
    { code: "JM.13.509", name: "Galina" },
    { code: "JM.13.510", name: "Port Maria" },
    { code: "JM.13.511", name: "Sandside" },
    { code: "JM.13.512", name: "Hampstead" },
    { code: "JM.13.513", name: "Baileys Vale" },
    { code: "JM.13.514", name: "Free Hill" },
    { code: "JM.13.515", name: "Bonnygate" },
    { code: "JM.13.516", name: "Mile Gully" },
    { code: "JM.13.517", name: "Amiel Town" },
    { code: "JM.13.518", name: "Gayle" },
    { code: "JM.13.519", name: "Labyrinth" },
    { code: "JM.13.520", name: "Lucky Hill" },
    { code: "JM.13.521", name: "Woodpark" },
    { code: "JM.13.522", name: "Jeffery Town" },
    { code: "JM.13.523", name: "Guys Hill" },
    { code: "JM.13.524", name: "Carron Hall" },
    { code: "JM.13.525", name: "Highgate" },
    { code: "JM.13.526", name: "Woodside" },
    { code: "JM.13.527", name: "Flint River" },
    { code: "JM.13.528", name: "Richmond" },
    { code: "JM.13.529", name: "Clonmel" },
    { code: "JM.13.530", name: "Belfield" },
    { code: "JM.13.531", name: "Martin" },
    { code: "JM.13.532", name: "Islington" },
    { code: "JM.13.533", name: "Robins Bay" },
    { code: "JM.13.534", name: "Annotto Bay" },
    { code: "JM.13.535", name: "Camberwell" },
    { code: "JM.13.536", name: "Broadgate" },
    { code: "JM.13.537", name: "Devon Pen" },
    { code: "JM.13.538", name: "Friendship Gap" },
    { code: "JM.13.539", name: "Scotts Hall" },
    { code: "JM.13.540", name: "Brainerd" },
    { code: "JM.13.541", name: "Castleton" },
    { code: "JM.13.542", name: "Baxter Mountain" },
    { code: "JM.13.543", name: "Long Road" },
    { code: "JM.13.544", name: "Enfield" },
    { code: "JM.13.545", name: "Epson" },
    { code: "JM.13.546", name: "Dover" },
  ],
  "JM.14": [
    { code: "JM.14.301", name: "Hagley Gap" },
    { code: "JM.14.302", name: "River Head" },
    { code: "JM.14.303", name: "Cedar Valley" },
    { code: "JM.14.304", name: "Bethel" },
    { code: "JM.14.305", name: "New Monkland" },
    { code: "JM.14.306", name: "Mount Lebanus" },
    { code: "JM.14.307", name: "Somerset" },
    { code: "JM.14.308", name: "Trinityville" },
    { code: "JM.14.309", name: "Hillside" },
    { code: "JM.14.310", name: "White Hall" },
    { code: "JM.14.311", name: "Sunning Hill" },
    { code: "JM.14.312", name: "Hayfield" },
    { code: "JM.14.313", name: "Bath" },
    { code: "JM.14.314", name: "Spring Bank" },
    { code: "JM.14.315", name: "Wheelerfield" },
    { code: "JM.14.316", name: "Johnson Mountain" },
    { code: "JM.14.317", name: "Rowlandsfield" },
    { code: "JM.14.318", name: "Amity Hall" },
    { code: "JM.14.319", name: "Duckenfield" },
    { code: "JM.14.320", name: "Hampton Court" },
    { code: "JM.14.321", name: "Golden Grove" },
    { code: "JM.14.322", name: "Winchester" },
    { code: "JM.14.323", name: "Arcadia" },
    { code: "JM.14.324", name: "Pear Tree" },
    { code: "JM.14.325", name: "Airy Castle" },
    { code: "JM.14.326", name: "Wilmington" },
    { code: "JM.14.327", name: "Spring Garden" },
    { code: "JM.14.328", name: "York" },
    { code: "JM.14.329", name: "Middleton" },
    { code: "JM.14.330", name: "Seaforth" },
    { code: "JM.14.331", name: "Danvers Pen" },
    { code: "JM.14.332", name: "Font Hill" },
    { code: "JM.14.333", name: "Lloyds" },
    { code: "JM.14.334", name: "Jones Pen" },
    { code: "JM.14.335", name: "Easington" },
    { code: "JM.14.336", name: "Richmond Vale" },
    { code: "JM.14.337", name: "Ramble" },
    { code: "JM.14.338", name: "Llandewey" },
    { code: "JM.14.339", name: "Eleven Miles" },
    { code: "JM.14.340", name: "Albion" },
    { code: "JM.14.341", name: "Poormans Corner" },
    { code: "JM.14.342", name: "Baptist" },
    { code: "JM.14.343", name: "Yallahs" },
    { code: "JM.14.344", name: "Pamphret" },
    { code: "JM.14.345", name: "White Horses" },
    { code: "JM.14.346", name: "Duhaney Pen" },
    { code: "JM.14.347", name: "Church Corner" },
    { code: "JM.14.348", name: "Morant Bay" },
    { code: "JM.14.349", name: "Lyssons" },
    { code: "JM.14.350", name: "Johns Town" },
    { code: "JM.14.351", name: "Retreat" },
    { code: "JM.14.352", name: "Prospect" },
    { code: "JM.14.353", name: "Leith Hall" },
    { code: "JM.14.354", name: "Port Morant" },
    { code: "JM.14.355", name: "Barking Lodge" },
    { code: "JM.14.356", name: "Dalvey" },
  ],
  "JM.15": [
    { code: "JM.15.701", name: "Salt Marsh" },
    { code: "JM.15.702", name: "Falmouth" },
    { code: "JM.15.703", name: "Duncans" },
    { code: "JM.15.704", name: "Rio Bueno" },
    { code: "JM.15.705", name: "Brampton" },
    { code: "JM.15.706", name: "Samuels Prospect" },
    { code: "JM.15.707", name: "Spicy Hill" },
    { code: "JM.15.708", name: "Refuge" },
    { code: "JM.15.709", name: "Daniel Town" },
    { code: "JM.15.710", name: "Martha Brae" },
    { code: "JM.15.711", name: "Granville" },
    { code: "JM.15.712", name: "Bounty Hall" },
    { code: "JM.15.713", name: "Hampden" },
    { code: "JM.15.714", name: "Wakefield" },
    { code: "JM.15.715", name: "Sherwood Content" },
    { code: "JM.15.716", name: "Perth Town" },
    { code: "JM.15.717", name: "Duanvale" },
    { code: "JM.15.718", name: "Kinloss" },
    { code: "JM.15.719", name: "Clarks Town" },
    { code: "JM.15.720", name: "Jackson Town" },
    { code: "JM.15.721", name: "Stewart Town" },
    { code: "JM.15.722", name: "Sawyers" },
    { code: "JM.15.723", name: "Alps" },
    { code: "JM.15.724", name: "St. Vincent" },
    { code: "JM.15.725", name: "Bunkers Hill" },
    { code: "JM.15.726", name: "Deeside" },
    { code: "JM.15.727", name: "Wilson's Run" },
    { code: "JM.15.728", name: "Troy" },
    { code: "JM.15.729", name: "Warsop" },
    { code: "JM.15.730", name: "Spring Garden" },
    { code: "JM.15.731", name: "Stettin" },
    { code: "JM.15.732", name: "Albert Town" },
    { code: "JM.15.733", name: "Ulster Spring" },
    { code: "JM.15.734", name: "Freemans Hall" },
    { code: "JM.15.735", name: "Joe Hut" },
    { code: "JM.15.736", name: "Wirefence" },
    { code: "JM.15.737", name: "Wait-A-Bit" },
    { code: "JM.15.738", name: "Lorrimers" },
  ],
  "JM.16": [
    { code: "JM.16.1001", name: "Jerusalem" },
    { code: "JM.16.1002", name: "Grange Hill" },
    { code: "JM.16.1003", name: "Truro" },
    { code: "JM.16.1004", name: "Town Head" },
    { code: "JM.16.1005", name: "Burnt Savannah" },
    { code: "JM.16.1006", name: "Red Hills" },
    { code: "JM.16.1007", name: "Bath Mountain" },
    { code: "JM.16.1008", name: "Grange" },
    { code: "JM.16.1009", name: "Strawberry" },
    { code: "JM.16.1010", name: "Williamsfield" },
    { code: "JM.16.1011", name: "Fort Williams" },
    { code: "JM.16.1012", name: "Porters Mountain" },
    { code: "JM.16.1013", name: "Roaring River" },
    { code: "JM.16.1014", name: "Mackfield" },
    { code: "JM.16.1015", name: "Haddo" },
    { code: "JM.16.1016", name: "Mount Stewart" },
    { code: "JM.16.1017", name: "Cornwall Mountian" },
    { code: "JM.16.1018", name: "Barneyside" },
    { code: "JM.16.1019", name: "Bethel Town" },
    { code: "JM.16.1020", name: "Amity" },
    { code: "JM.16.1021", name: "St. Leonards" },
    { code: "JM.16.1022", name: "Dundee" },
    { code: "JM.16.1023", name: "Seaford Town" },
    { code: "JM.16.1024", name: "Lambs River" },
    { code: "JM.16.1025", name: "Belvedere" },
    { code: "JM.16.1026", name: "Ashton" },
    { code: "JM.16.1027", name: "Struie" },
    { code: "JM.16.1028", name: "Beaufort" },
    { code: "JM.16.1029", name: "Darliston" },
    { code: "JM.16.1030", name: "Caledonia" },
    { code: "JM.16.1031", name: "Whithorn" },
    { code: "JM.16.1032", name: "Petersfield" },
    { code: "JM.16.1033", name: "Hertford" },
    { code: "JM.16.1034", name: "Georges Plain" },
    { code: "JM.16.1035", name: "Frome" },
    { code: "JM.16.1036", name: "Paul Island" },
    { code: "JM.16.1037", name: "Fullersfield" },
    { code: "JM.16.1038", name: "Delveland" },
    { code: "JM.16.1039", name: "Shefield" },
    { code: "JM.16.1040", name: "Negril" },
    { code: "JM.16.1041", name: "Mount Airy" },
    { code: "JM.16.1042", name: "Orange Hill" },
    { code: "JM.16.1043", name: "Revival" },
    { code: "JM.16.1045", name: "Broughton" },
    { code: "JM.16.1046", name: "Little London" },
    { code: "JM.16.1047", name: "Big Bridge" },
    { code: "JM.16.1048", name: "Three Mile River" },
    { code: "JM.16.1050", name: "Llandilo" },
    { code: "JM.16.1051", name: "Gooden's River" },
    { code: "JM.16.1052", name: "Shoalin Grotto" },
    { code: "JM.16.1053", name: "Harmony Town" },
    { code: "JM.16.1054", name: "Seaton Crescent" },
    { code: "JM.16.1055", name: "New Market Oval" },
    { code: "JM.16.1056", name: "12th Street" },
    { code: "JM.16.1057", name: "Savannah-la-mar Business Dist." },
    { code: "JM.16.1058", name: "Russia" },
    { code: "JM.16.1059", name: "Smithfield" },
    { code: "JM.16.1060", name: "Chantilly" },
    { code: "JM.16.1061", name: "Strathbogie" },
    { code: "JM.16.1062", name: "Bath" },
    { code: "JM.16.1063", name: "Amity" },
    { code: "JM.16.1064", name: "Water Works" },
    { code: "JM.16.1065", name: "Ferris" },
    { code: "JM.16.1066", name: "Cave" },
    { code: "JM.16.1067", name: "Cairn Curran" },
    { code: "JM.16.1068", name: "Kentucky" },
    { code: "JM.16.1069", name: "Dillion Bigwoods" },
    { code: "JM.16.1070", name: "Lenox Bigwoods" },
    { code: "JM.16.1071", name: "Enfield" },
    { code: "JM.16.1072", name: "Leamington" },
    { code: "JM.16.1073", name: "Berkshire" },
    { code: "JM.16.1074", name: "New Roads" },
    { code: "JM.16.1075", name: "Carmel" },
    { code: "JM.16.1076", name: "New Works" },
    { code: "JM.16.1077", name: "Content" },
    { code: "JM.16.1078", name: "Mearnsville" },
    { code: "JM.16.1079", name: "Bluefields" },
    { code: "JM.16.1080", name: "Beeston Spring" },
    { code: "JM.16.1081", name: "Bog" },
    { code: "JM.16.1082", name: "Kilmarnoch" },
    { code: "JM.16.1083", name: "Petersville" },
    { code: "JM.16.1084", name: "Whitehouse" },
  ],
  "JM.17": [
    { code: "JM.17.15086", name: "Port Royal" },
    { code: "JM.17.15087", name: "Springfield" },
    { code: "JM.17.15088", name: "D'Aguilar Town/ Rennock Lodge" },
    { code: "JM.17.15089", name: "Johnson Town" },
    { code: "JM.17.15090", name: "Norman Gardens" },
    { code: "JM.17.15091", name: "Bournemouth Gardens" },
    { code: "JM.17.15092", name: "Rollington Town" },
    { code: "JM.17.15093", name: "Newton Square" },
    { code: "JM.17.15094", name: "Passmore Town" },
    { code: "JM.17.15095", name: "Franklyn Town" },
    { code: "JM.17.15096", name: "Campbell Town" },
    { code: "JM.17.15097", name: "Allman Town" },
    { code: "JM.17.15098", name: "Kingston Gardens" },
    { code: "JM.17.15099", name: "Fletchers Land" },
    { code: "JM.17.15100", name: "Hannah Town/ Craig Town" },
    { code: "JM.17.15101", name: "Denham Town" },
    { code: "JM.17.15102", name: "Tivoli Gardens" },
    { code: "JM.17.15103", name: "Newport East" },
    { code: "JM.17.15104", name: "East Down Town" },
    { code: "JM.17.15105", name: "Southside" },
    { code: "JM.17.15106", name: "Central Down Town" },
    { code: "JM.17.15107", name: "West Down Town" },
    { code: "JM.17.15108", name: "Manley Meadows" },
    { code: "JM.17.15109", name: "Rae Town" },
  ],
  "JO.02": [
    { code: "JO.02.7910931", name: "Qasabat As Salt" },
    { code: "JO.02.8621685", name: "Liwā’ ash Shūnah al Janūbīyah" },
    { code: "JO.02.8621686", name: "Liwā’ Dayr ‘Allā" },
    { code: "JO.02.8621687", name: "Liwā’ ‘Ayn al Bāshā" },
    { code: "JO.02.8621688", name: "Liwā’ Māḩiş wa al Fuḩayş" },
  ],
  "JO.09": [
    { code: "JO.09.8621694", name: "Liwā’ Fuqū‘" },
    { code: "JO.09.8621695", name: "Liwā’ al Qaşr" },
    { code: "JO.09.8621696", name: "Liwā’ ‘Ayy" },
    { code: "JO.09.8621697", name: "Liwā’ Qaşabat al Karak" },
    { code: "JO.09.8621719", name: "Liwā’ al Qaţrānah" },
    { code: "JO.09.8621720", name: "Liwā’ al Mazār al Janūbī" },
    { code: "JO.09.8621721", name: "Liwā’ al Aghwār al Janūbīyah" },
  ],
  "JO.12": [
    { code: "JO.12.8621730", name: "Liwā’ al Ḩasā" },
    { code: "JO.12.8621739", name: "Liwā’ Qaşabat aţ Ţafīlah" },
    { code: "JO.12.8621741", name: "Liwā’ Buşayrā" },
  ],
  "JO.15": [
    { code: "JO.15.8621634", name: "Liwā’ Qaşabat al Mafraq" },
    { code: "JO.15.8621635", name: "Liwā’ al Bādiyah ash Shamālīyah" },
    { code: "JO.15.8621683", name: "Liwā’ al Bādiyah ash Shamālīyah al Gharbīyah" },
    { code: "JO.15.8621684", name: "Liwā’ ar Ruwayshid" },
  ],
  "JO.16": [
    { code: "JO.16.8621740", name: "Liwā’ Saḩāb" },
    { code: "JO.16.8621742", name: "Liwā’ Qaşabat ‘Ammān" },
    { code: "JO.16.8621743", name: "Liwā’ Mārkā" },
    { code: "JO.16.8621761", name: "Liwā’ al Jāmi‘ah" },
    { code: "JO.16.8621762", name: "Liwā’ Wādī as Sīr" },
    { code: "JO.16.8621763", name: "Liwā’ al Muwaqqar" },
    { code: "JO.16.8621764", name: "Liwā’ Nā‘ūr" },
    { code: "JO.16.8621765", name: "Liwā’ al Jīzah" },
    { code: "JO.16.9915282", name: "Liwā’ al Quwaysimah" },
  ],
  "JO.17": [
    { code: "JO.17.7910933", name: "Qasabat Az Zarqa" },
    { code: "JO.17.8621689", name: "Liwā’ Qaşabat az Zarqā’" },
    { code: "JO.17.8621690", name: "Liwā’ ar Ruşayfah" },
    { code: "JO.17.8621691", name: "Liwā’ al Hāshimīyah" },
  ],
  "JO.18": [
    { code: "JO.18.8621599", name: "Liwa’ Banī Kinānah" },
    { code: "JO.18.8621601", name: "Liwā’ ar Ramthā" },
    { code: "JO.18.8621602", name: "Liwā’ Qaşabat Irbid" },
    { code: "JO.18.8621603", name: "Liwā’ al Kūrah" },
    { code: "JO.18.8621604", name: "Liwā’ al Aghwār ash Shamālīyah" },
    { code: "JO.18.8621605", name: "Liwā’ Banī ‘Ubayd" },
    { code: "JO.18.8621606", name: "Liwā’ al Mazār ash Shamālī" },
    { code: "JO.18.8621607", name: "Liwā’ aţ Ţayyibah" },
    { code: "JO.18.8621630", name: "Liwā’ al Wasaţīyah" },
  ],
  "JO.19": [
    { code: "JO.19.11189149", name: "Shoubak" },
    { code: "JO.19.8621722", name: "Liwā’ Qaşabat Ma‘ān" },
    { code: "JO.19.8621727", name: "Liwā’ ash Shawbak" },
    { code: "JO.19.8621728", name: "Liwā’ al Batrā’" },
    { code: "JO.19.8621737", name: "Liwā’ al Ḩusaynīyah" },
  ],
  "JO.20": [
    { code: "JO.20.8621631", name: "Liwā’ Qaşabat ‘Ajlūn" },
    { code: "JO.20.8621632", name: "Liwā’ Kufrinjah" },
  ],
  "JO.21": [
    { code: "JO.21.8621729", name: "Liwā’ al Quwayrah" },
    { code: "JO.21.8621738", name: "Liwā’ Qaşabat al ‘Aqabah" },
  ],
  "JO.22": [
    { code: "JO.22.8621633", name: "Liwā’ Qaşabat Jarash" },
  ],
  "JO.23": [
    { code: "JO.23.8621692", name: "Liwā’ Qaşabat Mādabā" },
    { code: "JO.23.8621693", name: "Liwā’ Dhībān" },
  ],
  "JP.01": [
    { code: "JP.01.1848455", name: "Yatomi-shi" },
    { code: "JP.01.1849535", name: "Tsushima-shi" },
    { code: "JP.01.1849809", name: "Toyota-shi" },
    { code: "JP.01.1849840", name: "Toyokawa-shi" },
    { code: "JP.01.1849862", name: "Toyoake-shi" },
    { code: "JP.01.1850183", name: "Tokoname-shi" },
    { code: "JP.01.1850219", name: "Tōkai-shi" },
    { code: "JP.01.1851258", name: "Tahara-shi" },
    { code: "JP.01.1852044", name: "Shinshiro-shi" },
    { code: "JP.01.1852647", name: "Seto-shi" },
    { code: "JP.01.1853518", name: "Owariasahi-shi" },
    { code: "JP.01.1854373", name: "Okazaki-shi" },
    { code: "JP.01.1854797", name: "Ōbu-shi" },
    { code: "JP.01.1854914", name: "Nukata-gun" },
    { code: "JP.01.1855103", name: "Niwa-gun" },
    { code: "JP.01.1855111", name: "Nisshin-shi" },
    { code: "JP.01.1855183", name: "Nishio-shi" },
    { code: "JP.01.1855273", name: "Nishikasugai-gun" },
    { code: "JP.01.1856053", name: "Nagoya-shi" },
    { code: "JP.01.1856225", name: "Nagakute-shi" },
    { code: "JP.01.1856697", name: "Miyoshi-shi" },
    { code: "JP.01.1858832", name: "Kōnan-shi" },
    { code: "JP.01.1858921", name: "Komaki-shi" },
    { code: "JP.01.1859272", name: "Kitashitara-gun" },
    { code: "JP.01.1859890", name: "Kasugai-shi" },
    { code: "JP.01.1860033", name: "Kariya-shi" },
    { code: "JP.01.1861527", name: "Inuyama-shi" },
    { code: "JP.01.1861601", name: "Inazawa-shi" },
    { code: "JP.01.1861940", name: "Ichinomiya-shi" },
    { code: "JP.01.1862911", name: "Hekinan-shi" },
    { code: "JP.01.1863204", name: "Handa-shi" },
    { code: "JP.01.1863692", name: "Gamagōri-shi" },
    { code: "JP.01.1864539", name: "Chita-shi" },
    { code: "JP.01.1864542", name: "Chita-gun" },
    { code: "JP.01.1864548", name: "Chiryū-shi" },
    { code: "JP.01.1865293", name: "Anjō-shi" },
    { code: "JP.01.1865365", name: "Ama-gun" },
    { code: "JP.01.1865696", name: "Aichi-gun" },
    { code: "JP.01.7369797", name: "Kiyosu-shi" },
    { code: "JP.01.7369798", name: "Aisai-shi" },
    { code: "JP.01.7369799", name: "Iwakura-shi" },
    { code: "JP.01.7369800", name: "Kitanagoya-shi" },
    { code: "JP.01.7369801", name: "Takahama-shi" },
    { code: "JP.01.7369802", name: "Toyohashi-shi" },
    { code: "JP.01.9405857", name: "Ama-Shi" },
  ],
  "JP.02": [
    { code: "JP.02.1854681", name: "Oga-shi" },
    { code: "JP.02.1855401", name: "Nikaho-shi" },
    { code: "JP.02.2110459", name: "Yuzawa-shi" },
    { code: "JP.02.2110504", name: "Yokote-shi" },
    { code: "JP.02.2111153", name: "Semboku-gun" },
    { code: "JP.02.2111935", name: "Minamiakita-gun" },
    { code: "JP.02.2112235", name: "Kitaakita-gun" },
    { code: "JP.02.2113122", name: "Akita Shi" },
    { code: "JP.02.2127468", name: "Yamamoto-gun" },
    { code: "JP.02.2128783", name: "Ōdate-shi" },
    { code: "JP.02.2128864", name: "Noshiro Shi" },
    { code: "JP.02.2129593", name: "Kazuno Shi" },
    { code: "JP.02.2129594", name: "Kazuno-gun" },
    { code: "JP.02.7443147", name: "Ogachi-gun" },
    { code: "JP.02.7443149", name: "Daisen-shi" },
    { code: "JP.02.7443155", name: "Katagami-shi" },
    { code: "JP.02.7443156", name: "Kitaakita-shi" },
    { code: "JP.02.7443160", name: "Yurihonjō-shi" },
    { code: "JP.02.9035660", name: "Semboku-shi" },
  ],
  "JP.03": [
    { code: "JP.03.2127674", name: "Towada Shi" },
    { code: "JP.03.2128134", name: "Shimokita-gun" },
    { code: "JP.03.2128302", name: "Sannohe Gun" },
    { code: "JP.03.2129089", name: "Mutsu-shi" },
    { code: "JP.03.2129224", name: "Minamitsugaru Gun" },
    { code: "JP.03.2129393", name: "Kuroishi Shi" },
    { code: "JP.03.2129525", name: "Kitatsugaru Gun" },
    { code: "JP.03.2129754", name: "Kamikita-gun" },
    { code: "JP.03.2130056", name: "Hirosaki Shi" },
    { code: "JP.03.2130088", name: "Higashitsugaru-gun" },
    { code: "JP.03.2130200", name: "Hachinohe Shi" },
    { code: "JP.03.2130225", name: "Goshogawara Shi" },
    { code: "JP.03.2130654", name: "Aomori Shi" },
    { code: "JP.03.7439929", name: "Nakatsugaru Gun" },
    { code: "JP.03.7439934", name: "Hirakawa Shi" },
    { code: "JP.03.7439937", name: "Misawa Shi" },
    { code: "JP.03.7439944", name: "Tsugaru Shi" },
    { code: "JP.03.8534376", name: "Nishitsugaru-gun" },
  ],
  "JP.04": [
    { code: "JP.04.1849185", name: "Urayasu-shi" },
    { code: "JP.04.1850520", name: "Tateyama-shi" },
    { code: "JP.04.1855071", name: "Noda-shi" },
    { code: "JP.04.1856183", name: "Nagareyama-shi" },
    { code: "JP.04.1857552", name: "Matsudo Shi" },
    { code: "JP.04.1859468", name: "Kimitsu Shi" },
    { code: "JP.04.1861964", name: "Ichikawa Shi" },
    { code: "JP.04.1863711", name: "Futtsu Shi" },
    { code: "JP.04.1863903", name: "Funabashi-shi" },
    { code: "JP.04.1864901", name: "Awa-gun" },
    { code: "JP.04.2110578", name: "Yachiyo-shi" },
    { code: "JP.04.2110747", name: "Tomisato-shi" },
    { code: "JP.04.2110773", name: "Tōgane-shi" },
    { code: "JP.04.2110982", name: "Sodegaura-shi" },
    { code: "JP.04.2111017", name: "Shiroi-shi" },
    { code: "JP.04.2111171", name: "Katori-shi" },
    { code: "JP.04.2111211", name: "Sambu-gun" },
    { code: "JP.04.2111215", name: "Sakura-shi" },
    { code: "JP.04.2111683", name: "Narita-shi" },
    { code: "JP.04.2111686", name: "Narashino-shi" },
    { code: "JP.04.2111854", name: "Mobara Shi" },
    { code: "JP.04.2112318", name: "Katori-gun" },
    { code: "JP.04.2112330", name: "Kashiwa Shi" },
    { code: "JP.04.2112386", name: "Kamogawa-shi" },
    { code: "JP.04.2112445", name: "Kamagaya Shi" },
    { code: "JP.04.2112557", name: "Isumi-gun" },
    { code: "JP.04.2112602", name: "Inzai-shi" },
    { code: "JP.04.2112631", name: "Imba-gun" },
    { code: "JP.04.2112663", name: "Ichihara Shi" },
    { code: "JP.04.2112994", name: "Chōshi-shi" },
    { code: "JP.04.2112997", name: "Chōsei-gun" },
    { code: "JP.04.2113012", name: "Chiba-shi" },
    { code: "JP.04.2113074", name: "Asahi-shi" },
    { code: "JP.04.2113162", name: "Abiko-shi" },
    { code: "JP.04.7465520", name: "Yotsukaidō-shi" },
    { code: "JP.04.7465521", name: "Minamibōsō Shi" },
    { code: "JP.04.7465522", name: "Sōsa-shi" },
    { code: "JP.04.7465523", name: "Sanmu-shi" },
    { code: "JP.04.7465524", name: "Isumi Shi" },
    { code: "JP.04.7465528", name: "Ōamishirasato-shi" },
    { code: "JP.04.8304237", name: "Kisarazu Shi" },
    { code: "JP.04.8304238", name: "Yachimata-shi" },
    { code: "JP.04.9062338", name: "Katsuura-shi" },
  ],
  "JP.05": [
    { code: "JP.05.10861187", name: "Seiyo-shi" },
    { code: "JP.05.1849041", name: "Uwajima-shi" },
    { code: "JP.05.1853240", name: "Saijō-shi" },
    { code: "JP.05.1853424", name: "Ōzu-shi" },
    { code: "JP.05.1854782", name: "Ochi-gun" },
    { code: "JP.05.1855138", name: "Nishiuwa-gun" },
    { code: "JP.05.1855422", name: "Niihama-shi" },
    { code: "JP.05.1857121", name: "Minamiuwa-gun" },
    { code: "JP.05.1857456", name: "Matsuyama-shi" },
    { code: "JP.05.1859256", name: "Kitauwa-gun" },
    { code: "JP.05.1859338", name: "Kita-gun" },
    { code: "JP.05.1861141", name: "Iyo-gun" },
    { code: "JP.05.1861143", name: "Iyo-shi" },
    { code: "JP.05.1926017", name: "Yawatahama-shi" },
    { code: "JP.05.1926135", name: "Imabari-shi" },
    { code: "JP.05.6691620", name: "Tōon-shi" },
    { code: "JP.05.6691622", name: "Kamiukena-gun" },
    { code: "JP.05.7406319", name: "Shikoku-chūō Shi" },
  ],
  "JP.06": [
    { code: "JP.06.1849587", name: "Tsuruga-shi" },
    { code: "JP.06.1854517", name: "Ōi-gun" },
    { code: "JP.06.1854843", name: "Obama-shi" },
    { code: "JP.06.1854875", name: "Nyū-gun" },
    { code: "JP.06.1859762", name: "Katsuyama Shi" },
    { code: "JP.06.1861716", name: "Imadate-gun" },
    { code: "JP.06.1863982", name: "Fukui-shi" },
    { code: "JP.06.7465770", name: "Yoshida Gun" },
    { code: "JP.06.7465771", name: "Nanjō-gun" },
    { code: "JP.06.7465772", name: "Mikata-gun" },
    { code: "JP.06.7465773", name: "Mikatakaminaka-gun" },
    { code: "JP.06.7467384", name: "Ōno-shi" },
    { code: "JP.06.7467385", name: "Awara-shi" },
    { code: "JP.06.7467386", name: "Echizen-shi" },
    { code: "JP.06.7467387", name: "Sakai-shi" },
    { code: "JP.06.8304246", name: "Sabae-shi" },
  ],
  "JP.07": [
    { code: "JP.07.1848086", name: "Yukuhashi Shi" },
    { code: "JP.07.1848572", name: "Yanagawa Shi" },
    { code: "JP.07.1848578", name: "Yame Shi" },
    { code: "JP.07.1848579", name: "Yame-gun" },
    { code: "JP.07.1851268", name: "Tagawa Shi" },
    { code: "JP.07.1851269", name: "Tagawa-gun" },
    { code: "JP.07.1854000", name: "Ōnojō Shi" },
    { code: "JP.07.1854055", name: "Onga-gun" },
    { code: "JP.07.1854081", name: "Ōmuta Shi" },
    { code: "JP.07.1854385", name: "Ōkawa-shi" },
    { code: "JP.07.1854627", name: "Ogōri-shi" },
    { code: "JP.07.1855902", name: "Nakama Shi" },
    { code: "JP.07.1856443", name: "Munakata-shi" },
    { code: "JP.07.1858087", name: "Kurume Shi" },
    { code: "JP.07.1858305", name: "Kuraten-gun" },
    { code: "JP.07.1859090", name: "Koga-shi" },
    { code: "JP.07.1859306", name: "Kitakyushu-shi" },
    { code: "JP.07.1859874", name: "Kasuya-gun" },
    { code: "JP.07.1859888", name: "Kasuga Shi" },
    { code: "JP.07.1860814", name: "Kaho-gun" },
    { code: "JP.07.1861834", name: "Iizuka Shi" },
    { code: "JP.07.1863955", name: "Fukuoka-shi" },
    { code: "JP.07.1864394", name: "Dazaifu-shi" },
    { code: "JP.07.1864573", name: "Chikushino-shi" },
    { code: "JP.07.1864574", name: "Chikushi-gun" },
    { code: "JP.07.1864588", name: "Chikujō-gun" },
    { code: "JP.07.1864591", name: "Chikugo Shi" },
    { code: "JP.07.1864660", name: "Buzen-shi" },
    { code: "JP.07.7406948", name: "Asakura-gun" },
    { code: "JP.07.7406949", name: "Mii-gun" },
    { code: "JP.07.7406950", name: "Miyako-gun" },
    { code: "JP.07.7406951", name: "Mizuma-gun" },
    { code: "JP.07.7407411", name: "Asakura Shi" },
    { code: "JP.07.7407412", name: "Fukutsu Shi" },
    { code: "JP.07.7407413", name: "Kama Shi" },
    { code: "JP.07.7407415", name: "Miyama Shi" },
    { code: "JP.07.7407416", name: "Miyawaka Shi" },
    { code: "JP.07.7407417", name: "Nōgata Shi" },
    { code: "JP.07.7407420", name: "Ukiha Shi" },
    { code: "JP.07.9035649", name: "Itoshima-shi" },
  ],
  "JP.08": [
    { code: "JP.08.1848677", name: "Yama-gun" },
    { code: "JP.08.1857203", name: "Minamiaizu-gun" },
    { code: "JP.08.1859317", name: "Kitakata-shi" },
    { code: "JP.08.1859662", name: "Kawanuma-gun" },
    { code: "JP.08.1865633", name: "Aizu-wakamatsu Shi" },
    { code: "JP.08.2110839", name: "Tamura-gun" },
    { code: "JP.08.2110958", name: "Sukagawa Shi" },
    { code: "JP.08.2110975", name: "Sōma Shi" },
    { code: "JP.08.2110976", name: "Sōma-gun" },
    { code: "JP.08.2111029", name: "Shirakawa Shi" },
    { code: "JP.08.2111613", name: "Nishishirakawa-gun" },
    { code: "JP.08.2111654", name: "Nihonmatsu Shi" },
    { code: "JP.08.2112139", name: "Kōriyama Shi" },
    { code: "JP.08.2112535", name: "Iwaki-shi" },
    { code: "JP.08.2112921", name: "Fukushima Shi" },
    { code: "JP.08.2112978", name: "Date-shi" },
    { code: "JP.08.2112979", name: "Date-gun" },
    { code: "JP.08.2113158", name: "Adachi-gun" },
    { code: "JP.08.7451488", name: "Futaba-gun" },
    { code: "JP.08.7451501", name: "Higashishirakawa-gun" },
    { code: "JP.08.7451502", name: "Ishikawa-gun" },
    { code: "JP.08.7451503", name: "Iwase-gun" },
    { code: "JP.08.7451504", name: "Ōnuma-gun" },
    { code: "JP.08.7451517", name: "Minamisōma Shi" },
    { code: "JP.08.9035647", name: "Tamura-shi" },
    { code: "JP.08.9035648", name: "Motomiya-shi" },
  ],
  "JP.09": [
    { code: "JP.09.1850200", name: "Toki-shi" },
    { code: "JP.09.1850890", name: "Takayama Shi" },
    { code: "JP.09.1851192", name: "Tajimi-shi" },
    { code: "JP.09.1852765", name: "Seki-shi" },
    { code: "JP.09.1854700", name: "Ōgaki-shi" },
    { code: "JP.09.1855750", name: "Nakatsugawa-shi" },
    { code: "JP.09.1856506", name: "Motosu-gun" },
    { code: "JP.09.1856666", name: "Mizunami-shi" },
    { code: "JP.09.1857051", name: "Minokamo-shi" },
    { code: "JP.09.1860188", name: "Kani-gun" },
    { code: "JP.09.1860193", name: "Kani-shi" },
    { code: "JP.09.1860326", name: "Kamo-gun" },
    { code: "JP.09.1860734", name: "Kakamigahara-shi" },
    { code: "JP.09.1860766", name: "Kaizu-shi" },
    { code: "JP.09.1863084", name: "Hashima-shi" },
    { code: "JP.09.1863085", name: "Hashima-gun" },
    { code: "JP.09.1863639", name: "Gifu-shi" },
    { code: "JP.09.1863645", name: "Gero-shi" },
    { code: "JP.09.1863710", name: "Fuwa-gun" },
    { code: "JP.09.1864208", name: "Ena-shi" },
    { code: "JP.09.1865323", name: "Ampachi-gun" },
    { code: "JP.09.7418819", name: "Ibi-gun" },
    { code: "JP.09.7418820", name: "Ōno Gun" },
    { code: "JP.09.7418821", name: "Yōrō-gun" },
    { code: "JP.09.7419031", name: "Gujō-shi" },
    { code: "JP.09.7419032", name: "Hida Shi" },
    { code: "JP.09.7419033", name: "Mino-shi" },
    { code: "JP.09.7419034", name: "Mizuho-shi" },
    { code: "JP.09.7419035", name: "Motosu-shi" },
    { code: "JP.09.7419036", name: "Yamagata-shi" },
  ],
  "JP.10": [
    { code: "JP.10.1850090", name: "Tomioka-shi" },
    { code: "JP.10.1850653", name: "Tano-gun" },
    { code: "JP.10.1850994", name: "Takasaki Shi" },
    { code: "JP.10.1852593", name: "Shibukawa-shi" },
    { code: "JP.10.1852846", name: "Sawa-gun" },
    { code: "JP.10.1853626", name: "Ōta-shi" },
    { code: "JP.10.1853946", name: "Ōra-gun" },
    { code: "JP.10.1857842", name: "Maebashi Shi" },
    { code: "JP.10.1859339", name: "Kitagumma-gun" },
    { code: "JP.10.1860108", name: "Kanra-gun" },
    { code: "JP.10.1861435", name: "Isesaki Shi" },
    { code: "JP.10.7453747", name: "Agatsuma-gun" },
    { code: "JP.10.7453748", name: "Tone-gun" },
    { code: "JP.10.7453835", name: "Annaka Shi" },
    { code: "JP.10.7453836", name: "Fujioka Shi" },
    { code: "JP.10.7453839", name: "Kiryū Shi" },
    { code: "JP.10.7453841", name: "Midori Shi" },
    { code: "JP.10.7453843", name: "Numata Shi" },
    { code: "JP.10.7453849", name: "Tatebayashi-shi" },
  ],
  "JP.11": [
    { code: "JP.11.1848699", name: "Yamagata-gun" },
    { code: "JP.11.1849812", name: "Toyota-gun" },
    { code: "JP.11.1850858", name: "Takehara-shi" },
    { code: "JP.11.1853661", name: "Ōtake-shi" },
    { code: "JP.11.1853990", name: "Onomichi-shi" },
    { code: "JP.11.1856691", name: "Miyoshi Shi" },
    { code: "JP.11.1857327", name: "Mihara Shi" },
    { code: "JP.11.1858288", name: "Kure-shi" },
    { code: "JP.11.1861022", name: "Jinseki-gun" },
    { code: "JP.11.1862412", name: "Hiroshima-shi" },
    { code: "JP.11.1862821", name: "Higashihiroshima Shi" },
    { code: "JP.11.1863017", name: "Hatsukaichi-shi" },
    { code: "JP.11.1863914", name: "Fukuyama Shi" },
    { code: "JP.11.1864151", name: "Fuchū-shi" },
    { code: "JP.11.1865442", name: "Aki-gun" },
    { code: "JP.11.7372274", name: "Aki-takata Shi" },
    { code: "JP.11.7372275", name: "Shōbara-shi" },
    { code: "JP.11.7372276", name: "Sera-gun" },
    { code: "JP.11.8740425", name: "Etajima-shi" },
  ],
  "JP.12": [
    { code: "JP.12.11497558", name: "Kamikawa-gun" },
    { code: "JP.12.11497755", name: "Kamikawa-gun (Teshio no kuni)" },
    { code: "JP.12.2038726", name: "Okushiri-gun" },
    { code: "JP.12.2127415", name: "Yūbari-shi" },
    { code: "JP.12.2127440", name: "Yoichi-gun" },
    { code: "JP.12.2127513", name: "Wakkanai Shi" },
    { code: "JP.12.2127544", name: "Utashinai-shi" },
    { code: "JP.12.2127730", name: "Tomamae Gun" },
    { code: "JP.12.2127732", name: "Tomakomai Shi" },
    { code: "JP.12.2127817", name: "Teshio Gun" },
    { code: "JP.12.2127895", name: "Takikawa-shi" },
    { code: "JP.12.2127954", name: "Sunagawa-shi" },
    { code: "JP.12.2128201", name: "Shibetsu Shi" },
    { code: "JP.12.2128291", name: "Sapporo-shi" },
    { code: "JP.12.2128378", name: "Rumoi-shi" },
    { code: "JP.12.2128405", name: "Rishiri Gun" },
    { code: "JP.12.2128418", name: "Rebun Gun" },
    { code: "JP.12.2128570", name: "Otaru-shi" },
    { code: "JP.12.2128812", name: "Obihiro Shi" },
    { code: "JP.12.2128892", name: "Noboribetsu-shi" },
    { code: "JP.12.2128971", name: "Nemuro-shi" },
    { code: "JP.12.2129098", name: "Muroran-shi" },
    { code: "JP.12.2129370", name: "Kushiro Shi" },
    { code: "JP.12.2129373", name: "Kushiro-gun" },
    { code: "JP.12.2129532", name: "Ktiami Shi" },
    { code: "JP.12.2129597", name: "Kayabe-gun" },
    { code: "JP.12.2129758", name: "Kamikawa-gun" },
    { code: "JP.12.2129763", name: "Kamiiso-gun" },
    { code: "JP.12.2129779", name: "Kameda-gun" },
    { code: "JP.12.2129864", name: "Iwanai-gun" },
    { code: "JP.12.2129869", name: "Iwamizawa-shi" },
    { code: "JP.12.2130044", name: "Hiyama-gun" },
    { code: "JP.12.2130058", name: "Hiroo-gun" },
    { code: "JP.12.2130184", name: "Hakodate Shi" },
    { code: "JP.12.2130287", name: "Furubira-gun" },
    { code: "JP.12.2130304", name: "Furano-shi" },
    { code: "JP.12.2130331", name: "Fukagawa-shi" },
    { code: "JP.12.2130385", name: "Eniwa-shi" },
    { code: "JP.12.2130402", name: "Ebetsu-shi" },
    { code: "JP.12.2130419", name: "Date-shi" },
    { code: "JP.12.2130449", name: "Chitose Shi" },
    { code: "JP.12.2130533", name: "Bibai-shi" },
    { code: "JP.12.2130609", name: "Ashibetsu-shi" },
    { code: "JP.12.2130628", name: "Asahikawa-shi" },
    { code: "JP.12.2130704", name: "Akabira-shi" },
    { code: "JP.12.2130724", name: "Abuta-gun" },
    { code: "JP.12.2130736", name: "Abashiri Shi" },
    { code: "JP.12.7428076", name: "Abashiri-gun" },
    { code: "JP.12.7428077", name: "Akan-gun" },
    { code: "JP.12.7428078", name: "Akkeshi-gun" },
    { code: "JP.12.7428079", name: "Ashoro-gun" },
    { code: "JP.12.7428080", name: "Esashi Gun" },
    { code: "JP.12.7428081", name: "Furuu-gun" },
    { code: "JP.12.7428082", name: "Futami-gun" },
    { code: "JP.12.7428083", name: "Hidaka-gun" },
    { code: "JP.12.7428084", name: "Horoizumi-gun" },
    { code: "JP.12.7428085", name: "Ishikari-gun" },
    { code: "JP.12.7428086", name: "Isoya-gun" },
    { code: "JP.12.7428087", name: "Kabato-gun" },
    { code: "JP.12.7428088", name: "Kasai-gun" },
    { code: "JP.12.7428089", name: "Katō-gun" },
    { code: "JP.12.7428090", name: "Kawakami-gun" },
    { code: "JP.12.7428091", name: "Kudō-gun" },
    { code: "JP.12.7428092", name: "Mashike-gun" },
    { code: "JP.12.7428093", name: "Matsumae-gun" },
    { code: "JP.12.7428094", name: "Menashi-gun" },
    { code: "JP.12.7428095", name: "Monbetsu Gun" },
    { code: "JP.12.7428096", name: "Nakagawa Gun" },
    { code: "JP.12.7428097", name: "Nakagawa-gun" },
    { code: "JP.12.7428098", name: "Niikappu-gun" },
    { code: "JP.12.7428099", name: "Nishi-gun" },
    { code: "JP.12.7428100", name: "Notsuke-gun" },
    { code: "JP.12.7428101", name: "Rumoi Gun" },
    { code: "JP.12.7428102", name: "Samani-gun" },
    { code: "JP.12.7428103", name: "Saru-gun" },
    { code: "JP.12.7428104", name: "Setana-gun" },
    { code: "JP.12.7428105", name: "Shakotan-gun" },
    { code: "JP.12.7428106", name: "Shari-gun" },
    { code: "JP.12.7428107", name: "Shibetsu-gun" },
    { code: "JP.12.7428108", name: "Shimamaki-gun" },
    { code: "JP.12.7428109", name: "Shiranuka-gun" },
    { code: "JP.12.7428110", name: "Shiraoi-gun" },
    { code: "JP.12.7428111", name: "Sorachi-gun" },
    { code: "JP.12.7428112", name: "Sōya Gun" },
    { code: "JP.12.7428113", name: "Suttsu-gun" },
    { code: "JP.12.7428114", name: "Tokachi-gun" },
    { code: "JP.12.7428115", name: "Tokoro-gun" },
    { code: "JP.12.7428116", name: "Urukawa-gun" },
    { code: "JP.12.7428117", name: "Uryū Gun" },
    { code: "JP.12.7428118", name: "Usu-gun" },
    { code: "JP.12.7428119", name: "Yamakoshi-gun" },
    { code: "JP.12.7428120", name: "Yūbari-gun" },
    { code: "JP.12.7428121", name: "Yūfutsu-gun" },
    { code: "JP.12.7429513", name: "Hokuto-shi" },
    { code: "JP.12.7429514", name: "Ishikari-shi" },
    { code: "JP.12.7429515", name: "Monbetsu Shi" },
    { code: "JP.12.7429516", name: "Nayoro Shi" },
    { code: "JP.12.8301405", name: "Mikasa-shi" },
    { code: "JP.12.9072585", name: "Kitahiroshima-shi" },
  ],
  "JP.13": [
    { code: "JP.13.11668516", name: "Aioi Shi" },
    { code: "JP.13.1847945", name: "Tatsuno-shi" },
    { code: "JP.13.1848845", name: "Yabu-shi" },
    { code: "JP.13.1849826", name: "Toyooka-shi" },
    { code: "JP.13.1851005", name: "Takasago Shi" },
    { code: "JP.13.1851011", name: "Takarazuka Shi" },
    { code: "JP.13.1851159", name: "Taka-gun" },
    { code: "JP.13.1852830", name: "Sayō-gun" },
    { code: "JP.13.1855132", name: "Nishiwaki-shi" },
    { code: "JP.13.1855204", name: "Nishinomiya Shi" },
    { code: "JP.13.1859161", name: "Kōbe Shi" },
    { code: "JP.13.1859671", name: "Kawanishi Shi" },
    { code: "JP.13.1859755", name: "Kawanabe-gun" },
    { code: "JP.13.1860701", name: "Kako-gun" },
    { code: "JP.13.1860702", name: "Kakogawa Shi" },
    { code: "JP.13.1861308", name: "Itami Shi" },
    { code: "JP.13.1862022", name: "Ibo-gun" },
    { code: "JP.13.1862625", name: "Himeji Shi" },
    { code: "JP.13.1864981", name: "Ashiya Shi" },
    { code: "JP.13.1865383", name: "Amagasaki Shi" },
    { code: "JP.13.1865406", name: "Akō Shi" },
    { code: "JP.13.1865409", name: "Akō-gun" },
    { code: "JP.13.1865470", name: "Akashi Shi" },
    { code: "JP.13.7370808", name: "Kanzaki-gun" },
    { code: "JP.13.7370809", name: "Mikata-gun" },
    { code: "JP.13.7370810", name: "Sumoto Shi" },
    { code: "JP.13.7370811", name: "Miki Shi" },
    { code: "JP.13.7370812", name: "Ono Shi" },
    { code: "JP.13.7370813", name: "Sanda Shi" },
    { code: "JP.13.7370814", name: "Kasai Shi" },
    { code: "JP.13.7370815", name: "Sasayama-shi" },
    { code: "JP.13.7370816", name: "Tanba-shi" },
    { code: "JP.13.7370817", name: "Minamiawaji Shi" },
    { code: "JP.13.7370818", name: "Asago-shi" },
    { code: "JP.13.7370819", name: "Awaji Shi" },
    { code: "JP.13.7370820", name: "Shisō-shi" },
    { code: "JP.13.7370821", name: "Katō Shi" },
  ],
  "JP.14": [
    { code: "JP.14.1848088", name: "Yūki-shi" },
    { code: "JP.14.1848093", name: "Yūki-gun" },
    { code: "JP.14.1852162", name: "Shimotsuma-shi" },
    { code: "JP.14.1852883", name: "Sashima-gun" },
    { code: "JP.14.1859082", name: "Koga-shi" },
    { code: "JP.14.2110701", name: "Tsuchiura-shi" },
    { code: "JP.14.2110728", name: "Toride-shi" },
    { code: "JP.14.2111256", name: "Ryūgasaki-shi" },
    { code: "JP.14.2111741", name: "Naka-gun" },
    { code: "JP.14.2111742", name: "Naka-gun" },
    { code: "JP.14.2111899", name: "Mito-shi" },
    { code: "JP.14.2112115", name: "Kuji-gun" },
    { code: "JP.14.2112231", name: "Kitaibaraki-shi" },
    { code: "JP.14.2112334", name: "Kashima-shi" },
    { code: "JP.14.2112342", name: "Kasama-shi" },
    { code: "JP.14.2112399", name: "Kamisu-shi" },
    { code: "JP.14.2112616", name: "Inashiki-gun" },
    { code: "JP.14.2112704", name: "Hitachi-shi" },
    { code: "JP.14.2112705", name: "Hitachiōta-shi" },
    { code: "JP.14.2112766", name: "Higashiibaraki-gun" },
    { code: "JP.14.6950859", name: "Moriya-shi" },
    { code: "JP.14.7452677", name: "Bandō-shi" },
    { code: "JP.14.7452678", name: "Chikusei-shi" },
    { code: "JP.14.7452680", name: "Hitachiōmiya-shi" },
    { code: "JP.14.7452799", name: "Hokota-shi" },
    { code: "JP.14.7452800", name: "Ishioka-shi" },
    { code: "JP.14.7452801", name: "Itako-shi" },
    { code: "JP.14.7452802", name: "Jōsō-shi" },
    { code: "JP.14.7452804", name: "Namegata-shi" },
    { code: "JP.14.7452805", name: "Omitama-shi" },
    { code: "JP.14.7452807", name: "Takahagi-shi" },
    { code: "JP.14.7452808", name: "Tsukubamirai-shi" },
    { code: "JP.14.7452809", name: "Tsukuba-shi" },
    { code: "JP.14.7452810", name: "Ushiku-shi" },
    { code: "JP.14.8304033", name: "Hitachinaka-shi" },
    { code: "JP.14.8304034", name: "Inashiki-shi" },
    { code: "JP.14.8304035", name: "Sakuragawa-shi" },
    { code: "JP.14.8741149", name: "Kasumigaura-shi" },
    { code: "JP.14.9072668", name: "Kitasoma-gun" },
  ],
  "JP.15": [
    { code: "JP.15.1848973", name: "Wajima Shi" },
    { code: "JP.15.1851337", name: "Suzu Shi" },
    { code: "JP.15.1854977", name: "Nonoichi-shi" },
    { code: "JP.15.1855000", name: "Nomi Gun" },
    { code: "JP.15.1858904", name: "Komatsu Shi" },
    { code: "JP.15.1860240", name: "Kanazawa-shi" },
    { code: "JP.15.1860811", name: "Kahoku Gun" },
    { code: "JP.15.1860845", name: "Kaga Shi" },
    { code: "JP.15.1863340", name: "Hakui Shi" },
    { code: "JP.15.7467838", name: "Hakui Gun" },
    { code: "JP.15.7467839", name: "Hōsu Gun" },
    { code: "JP.15.7467840", name: "Kashima Gun" },
    { code: "JP.15.7467879", name: "Nanao Shi" },
    { code: "JP.15.7467880", name: "Kahoku Shi" },
    { code: "JP.15.7467881", name: "Hakusan Shi" },
    { code: "JP.15.7467882", name: "Nomi Shi" },
  ],
  "JP.16": [
    { code: "JP.16.11497023", name: "Isawa-gun" },
    { code: "JP.16.2110604", name: "Waga-gun" },
    { code: "JP.16.2110732", name: "Tōno-shi" },
    { code: "JP.16.2110852", name: "Takizawa-shi" },
    { code: "JP.16.2111005", name: "Shiwa-gun" },
    { code: "JP.16.2111528", name: "Ōfunato-shi" },
    { code: "JP.16.2111833", name: "Morioka-shi" },
    { code: "JP.16.2111883", name: "Miyako-shi" },
    { code: "JP.16.2112223", name: "Kitakami-shi" },
    { code: "JP.16.2112264", name: "Kesen-gun" },
    { code: "JP.16.2112424", name: "Kamihei-gun" },
    { code: "JP.16.2112441", name: "Kamaishi-shi" },
    { code: "JP.16.2112655", name: "Ichinoseki-shi" },
    { code: "JP.16.2112822", name: "Hanamaki Shi" },
    { code: "JP.16.2128940", name: "Ninohe Shi" },
    { code: "JP.16.2128941", name: "Ninohe-gun" },
    { code: "JP.16.2129400", name: "Kunohe-gun" },
    { code: "JP.16.2129423", name: "Kuji-shi" },
    { code: "JP.16.7441804", name: "Iwate-gun" },
    { code: "JP.16.7441805", name: "Nishiiwai Gun" },
    { code: "JP.16.7441806", name: "Shimohei-gun" },
    { code: "JP.16.7441808", name: "Hachimantai Shi" },
    { code: "JP.16.7441816", name: "Ōshū-shi" },
    { code: "JP.16.7441817", name: "Rikuzentakata-shi" },
  ],
  "JP.17": [
    { code: "JP.17.1847982", name: "Zentsūji Shi" },
    { code: "JP.17.1851095", name: "Takamatsu Shi" },
    { code: "JP.17.1851654", name: "Shōzu-gun" },
    { code: "JP.17.1853186", name: "Sakaide Shi" },
    { code: "JP.17.1855768", name: "Nakatado-gun" },
    { code: "JP.17.1856906", name: "Mitoyo Shi" },
    { code: "JP.17.1857664", name: "Marugame Shi" },
    { code: "JP.17.1859337", name: "Kita-gun" },
    { code: "JP.17.1860119", name: "Kan’onji Shi" },
    { code: "JP.17.1860835", name: "Kagawa-gun" },
    { code: "JP.17.7391347", name: "Higashikagawa Shi" },
    { code: "JP.17.7391348", name: "Ayauta-gun" },
    { code: "JP.17.9036694", name: "Sanuki-shi" },
  ],
  "JP.18": [
    { code: "JP.18.1850587", name: "Tarumizu Shi" },
    { code: "JP.18.1851576", name: "Soo Gun" },
    { code: "JP.18.1852587", name: "Shibushi-shi" },
    { code: "JP.18.1852852", name: "Satsuma Gun" },
    { code: "JP.18.1853737", name: "Ōshima-gun" },
    { code: "JP.18.1855201", name: "Nishinoomote Shi" },
    { code: "JP.18.1857710", name: "Makurazaki Shi" },
    { code: "JP.18.1860823", name: "Kagoshima Shi" },
    { code: "JP.18.1861090", name: "Izumi Shi" },
    { code: "JP.18.1862007", name: "Ibusuki Shi" },
    { code: "JP.18.1865399", name: "Akune Shi" },
    { code: "JP.18.1865649", name: "Aira Gun" },
    { code: "JP.18.1865650", name: "Aira Shi" },
    { code: "JP.18.7383987", name: "Amami Shi" },
    { code: "JP.18.7383988", name: "Hioki Shi" },
    { code: "JP.18.7383990", name: "Ichikikushikino Shi" },
    { code: "JP.18.7383991", name: "Isa Shi" },
    { code: "JP.18.7383992", name: "Kirishima Shi" },
    { code: "JP.18.7383993", name: "Minamikyushu Shi" },
    { code: "JP.18.7383994", name: "Minamisatsuma Shi" },
    { code: "JP.18.7383995", name: "Satsumasendai Shi" },
    { code: "JP.18.7383996", name: "Soo Shi" },
    { code: "JP.18.7383997", name: "Izumi-gun" },
    { code: "JP.18.7383998", name: "Kagoshima-gun" },
    { code: "JP.18.7383999", name: "Kimotsuki Gun" },
    { code: "JP.18.8300556", name: "Kanoya Shi" },
    { code: "JP.18.8714932", name: "Kumage-gun" },
  ],
  "JP.19": [
    { code: "JP.19.1847999", name: "Zama Shi" },
    { code: "JP.19.1848308", name: "Yokosuka Shi" },
    { code: "JP.19.1848350", name: "Yokohama Shi" },
    { code: "JP.19.1848595", name: "Yamato-shi" },
    { code: "JP.19.1853293", name: "Sagamihara-shi" },
    { code: "JP.19.1854744", name: "Odawara-shi" },
    { code: "JP.19.1855966", name: "Naka-gun" },
    { code: "JP.19.1856849", name: "Miura Shi" },
    { code: "JP.19.1856851", name: "Miura-gun" },
    { code: "JP.19.1858593", name: "Kōza-gun" },
    { code: "JP.19.1859635", name: "Kawasaki-shi" },
    { code: "JP.19.1860670", name: "Kamakura Shi" },
    { code: "JP.19.1861448", name: "Isehara Shi" },
    { code: "JP.19.1862461", name: "Hiratsuka Shi" },
    { code: "JP.19.1863429", name: "Hadano-shi" },
    { code: "JP.19.1864091", name: "Fujisawa Shi" },
    { code: "JP.19.1864622", name: "Chigasaki Shi" },
    { code: "JP.19.1864864", name: "Ayase Shi" },
    { code: "JP.19.1864928", name: "Atsugi Shi" },
    { code: "JP.19.1865009", name: "Ashigarashimo-gun" },
    { code: "JP.19.1865011", name: "Ashigarakami-gun" },
    { code: "JP.19.7468160", name: "Aikō-gun" },
    { code: "JP.19.7470888", name: "Zushi Shi" },
    { code: "JP.19.7470889", name: "Ebina Shi" },
    { code: "JP.19.7470890", name: "Minamiashigara Shi" },
  ],
  "JP.20": [
    { code: "JP.20.1849927", name: "Tosashimizu-shi" },
    { code: "JP.20.1849928", name: "Tosa-shi" },
    { code: "JP.20.1849939", name: "Tosa-gun" },
    { code: "JP.20.1851029", name: "Takaoka-gun" },
    { code: "JP.20.1851387", name: "Susaki-shi" },
    { code: "JP.20.1855637", name: "Nankoku Shi" },
    { code: "JP.20.1856197", name: "Nagaoka Gun" },
    { code: "JP.20.1856389", name: "Muroto Shi" },
    { code: "JP.20.1859127", name: "Kōchi Shi" },
    { code: "JP.20.1863048", name: "Hata-gun" },
    { code: "JP.20.1865426", name: "Aki Shi" },
    { code: "JP.20.1865443", name: "Aki Gun" },
    { code: "JP.20.1865726", name: "Agawa-gun" },
    { code: "JP.20.7405897", name: "Sukumo-shi" },
    { code: "JP.20.7405898", name: "Shimanto-shi" },
    { code: "JP.20.7405899", name: "Kōnan Shi" },
    { code: "JP.20.7405900", name: "Kami Shi" },
  ],
  "JP.21": [
    { code: "JP.21.1848441", name: "Yatsushiro Shi" },
    { code: "JP.21.1848443", name: "Yatsushiro-gun" },
    { code: "JP.21.1849062", name: "Uto Shi" },
    { code: "JP.21.1850743", name: "Tamana Shi" },
    { code: "JP.21.1850744", name: "Tamana-gun" },
    { code: "JP.21.1857206", name: "Minamata Shi" },
    { code: "JP.21.1858418", name: "Kumamoto Shi" },
    { code: "JP.21.1859488", name: "Kikuchi Shi" },
    { code: "JP.21.1859490", name: "Kikuchi-gun" },
    { code: "JP.21.1862350", name: "Hitoyoshi Shi" },
    { code: "JP.21.1864973", name: "Aso-shi" },
    { code: "JP.21.1864975", name: "Aso-gun" },
    { code: "JP.21.1865168", name: "Arao Shi" },
    { code: "JP.21.1865358", name: "Amakusa Shi" },
    { code: "JP.21.1865360", name: "Amakusa Gun" },
    { code: "JP.21.7412705", name: "Ashikita-gun" },
    { code: "JP.21.7412706", name: "Kamimashiki-gun" },
    { code: "JP.21.7412708", name: "Kuma-gun" },
    { code: "JP.21.7412709", name: "Shimomashiki-gun" },
    { code: "JP.21.7413150", name: "Yamaga Shi" },
    { code: "JP.21.7413151", name: "Kamiamakusa Shi" },
    { code: "JP.21.7413152", name: "Uki Shi" },
    { code: "JP.21.7413153", name: "Kōshi Shi" },
  ],
  "JP.22": [
    { code: "JP.22.1848224", name: "Yosa-gun" },
    { code: "JP.22.1849362", name: "Uji Shi" },
    { code: "JP.22.1851574", name: "Sōraku-gun" },
    { code: "JP.22.1856196", name: "Nagaokakyō Shi" },
    { code: "JP.22.1857764", name: "Maizuru-shi" },
    { code: "JP.22.1857906", name: "Kyōto-shi" },
    { code: "JP.22.1859202", name: "Kizugawa-shi" },
    { code: "JP.22.1860633", name: "Kameoka-shi" },
    { code: "JP.22.1860951", name: "Jōyō Shi" },
    { code: "JP.22.1864008", name: "Fukuchiyama-shi" },
    { code: "JP.22.1864872", name: "Ayabe-shi" },
    { code: "JP.22.7412122", name: "Funai-gun" },
    { code: "JP.22.7412123", name: "Kuse-gun" },
    { code: "JP.22.7412124", name: "Otokuni-gun" },
    { code: "JP.22.7412125", name: "Tsuzuki-gun" },
    { code: "JP.22.7412197", name: "Miyazu-shi" },
    { code: "JP.22.7412198", name: "Mukō Shi" },
    { code: "JP.22.7412199", name: "Yawata Shi" },
    { code: "JP.22.7412200", name: "Kyōtango-shi" },
    { code: "JP.22.7412201", name: "Nantan-shi" },
    { code: "JP.22.7412210", name: "Kyōtanabe Shi" },
  ],
  "JP.23": [
    { code: "JP.23.1848370", name: "Yokkaichi-shi" },
    { code: "JP.23.1848873", name: "Watarai-gun" },
    { code: "JP.23.1849544", name: "Tsu-shi" },
    { code: "JP.23.1850342", name: "Toba-shi" },
    { code: "JP.23.1851345", name: "Suzuka-shi" },
    { code: "JP.23.1852464", name: "Shima-shi" },
    { code: "JP.23.1853513", name: "Owase Shi" },
    { code: "JP.23.1856290", name: "Nabari-shi" },
    { code: "JP.23.1857355", name: "Mie-gun" },
    { code: "JP.23.1857496", name: "Matsuzaka-shi" },
    { code: "JP.23.1857965", name: "Kuwana-shi" },
    { code: "JP.23.1857966", name: "Kuwana-gun" },
    { code: "JP.23.1858408", name: "Kumano-shi" },
    { code: "JP.23.1859297", name: "Kitamuro-gun" },
    { code: "JP.23.1861434", name: "Ise-shi" },
    { code: "JP.23.1861901", name: "Iga-shi" },
    { code: "JP.23.7417702", name: "Inabe-gun" },
    { code: "JP.23.7417703", name: "Minamimuro-gun" },
    { code: "JP.23.7417704", name: "Taki-gun" },
    { code: "JP.23.7417710", name: "Inabe-shi" },
    { code: "JP.23.7417711", name: "Kameyama Shi" },
  ],
  "JP.24": [
    { code: "JP.24.2110755", name: "Tome Shi" },
    { code: "JP.24.2111014", name: "Shiroishi Shi" },
    { code: "JP.24.2111045", name: "Shiogama Shi" },
    { code: "JP.24.2111130", name: "Shibata-gun" },
    { code: "JP.24.2111147", name: "Sendai Shi" },
    { code: "JP.24.2111817", name: "Motoyoshi Gun" },
    { code: "JP.24.2111889", name: "Miyagi Gun" },
    { code: "JP.24.2112074", name: "Kurokawa-gun" },
    { code: "JP.24.2112092", name: "Kurihara Shi" },
    { code: "JP.24.2112261", name: "Kesennuma Shi" },
    { code: "JP.24.2112306", name: "Katta-gun" },
    { code: "JP.24.2112525", name: "Iwanuma-shi" },
    { code: "JP.24.2112574", name: "Ishinomaki Shi" },
    { code: "JP.24.7446984", name: "Igu-gun" },
    { code: "JP.24.7446985", name: "Kami-gun" },
    { code: "JP.24.7446986", name: "Oshika Gun" },
    { code: "JP.24.7446987", name: "Tōda Gun" },
    { code: "JP.24.7446988", name: "Watari-gun" },
    { code: "JP.24.7446990", name: "Higashimatshushima Shi" },
    { code: "JP.24.7446991", name: "Kakuda Shi" },
    { code: "JP.24.7447001", name: "Ōsaki Shi" },
    { code: "JP.24.8303940", name: "Natori Shi" },
    { code: "JP.24.8303941", name: "Tagajō Shi" },
  ],
  "JP.25": [
    { code: "JP.25.1853223", name: "Saito-shi" },
    { code: "JP.25.1855094", name: "Nobeoka-shi" },
    { code: "JP.25.1855473", name: "Nichinan Shi" },
    { code: "JP.25.1856706", name: "Miyazaki-shi" },
    { code: "JP.25.1856774", name: "Miyakonojō Shi" },
    { code: "JP.25.1858035", name: "Kushima Shi" },
    { code: "JP.25.1858599", name: "Kōyu-gun" },
    { code: "JP.25.1862036", name: "Hyūga-shi" },
    { code: "JP.25.1862717", name: "Higashiusuki-gun" },
    { code: "JP.25.1864313", name: "Ebino-shi" },
    { code: "JP.25.7413964", name: "HIgashimorokata Gun" },
    { code: "JP.25.7413965", name: "Kitamorokata Gun" },
    { code: "JP.25.7413967", name: "Nishimorokata Gun" },
    { code: "JP.25.7413968", name: "Nishiusuki-gun" },
    { code: "JP.25.7413970", name: "Kobayashi Shi" },
  ],
  "JP.26": [
    { code: "JP.26.10629642", name: "Azumino-Shi" },
    { code: "JP.26.1849427", name: "Ueda Shi" },
    { code: "JP.26.1851356", name: "Suzaka-shi" },
    { code: "JP.26.1851362", name: "Suwa Shi" },
    { code: "JP.26.1851367", name: "Suwa-gun" },
    { code: "JP.26.1852001", name: "Shiojiri-shi" },
    { code: "JP.26.1852186", name: "Shimotakai-gun" },
    { code: "JP.26.1852253", name: "Shimominochi-gun" },
    { code: "JP.26.1852309", name: "Shimoina-gun" },
    { code: "JP.26.1853055", name: "Saku Shi" },
    { code: "JP.26.1854184", name: "Ōmachi-shi" },
    { code: "JP.26.1854378", name: "Okaya Shi" },
    { code: "JP.26.1855829", name: "Nakano Shi" },
    { code: "JP.26.1856209", name: "Nagano Shi" },
    { code: "JP.26.1857141", name: "Minamisaku-gun" },
    { code: "JP.26.1857516", name: "Matsumoto Shi" },
    { code: "JP.26.1858856", name: "Komoro Shi" },
    { code: "JP.26.1858938", name: "Komagane-shi" },
    { code: "JP.26.1859278", name: "Kitasaku-gun" },
    { code: "JP.26.1859364", name: "Kitaazumi Gun" },
    { code: "JP.26.1860414", name: "Kamitakai-gun" },
    { code: "JP.26.1860552", name: "Kamiina-gun" },
    { code: "JP.26.1861606", name: "Ina-shi" },
    { code: "JP.26.1861837", name: "Iiyama Shi" },
    { code: "JP.26.1861858", name: "Iida-shi" },
    { code: "JP.26.1862841", name: "Higashichikuma Gun" },
    { code: "JP.26.1863187", name: "Hanishina-gun" },
    { code: "JP.26.1864555", name: "Chino Shi" },
    { code: "JP.26.1864613", name: "Chiisakata-gun" },
    { code: "JP.26.7416552", name: "Kamiminochi-gun" },
    { code: "JP.26.7416554", name: "Kiso-gun" },
    { code: "JP.26.7417078", name: "Chikuma Shi" },
    { code: "JP.26.7417079", name: "Tōmi Shi" },
  ],
  "JP.27": [
    { code: "JP.27.1852895", name: "Sasebo Shi" },
    { code: "JP.27.1855163", name: "Nishisonogi-gun" },
    { code: "JP.27.1856152", name: "Nagasaki-shi" },
    { code: "JP.27.1857159", name: "Minamimatsuura Gun" },
    { code: "JP.27.1857466", name: "Matsuura Shi" },
    { code: "JP.27.1859301", name: "Kitamatsuura-gun" },
    { code: "JP.27.1861758", name: "Iki Shi" },
    { code: "JP.27.1862734", name: "Higashisonigi-gun" },
    { code: "JP.27.7418804", name: "Gotō Shi" },
    { code: "JP.27.7418805", name: "Hirado Shi" },
    { code: "JP.27.7418806", name: "Minamishimabara-shi" },
    { code: "JP.27.7418807", name: "Ōmura-shi" },
    { code: "JP.27.7418808", name: "Saikai-shi" },
    { code: "JP.27.7418809", name: "Shimabara-shi" },
    { code: "JP.27.7418810", name: "Tsushima Shi" },
    { code: "JP.27.7418811", name: "Unzen-shi" },
    { code: "JP.27.8301120", name: "Isahaya-shi" },
  ],
  "JP.28": [
    { code: "JP.28.1848164", name: "Yoshino-gun" },
    { code: "JP.28.1848592", name: "Yamatotakada-shi" },
    { code: "JP.28.1848602", name: "Yamatokōriyama-shi" },
    { code: "JP.28.1849448", name: "Uda-gun" },
    { code: "JP.28.1850395", name: "Tenri-shi" },
    { code: "JP.28.1852501", name: "Shiki-gun" },
    { code: "JP.28.1853062", name: "Sakurai-shi" },
    { code: "JP.28.1855604", name: "Nara-shi" },
    { code: "JP.28.1859955", name: "Kashiba-shi" },
    { code: "JP.28.1861747", name: "Ikoma-shi" },
    { code: "JP.28.1861748", name: "Ikoma-gun" },
    { code: "JP.28.1863538", name: "Gose Shi" },
    { code: "JP.28.1863590", name: "Gojō-shi" },
    { code: "JP.28.7411375", name: "Kitakatsuragi-gun" },
    { code: "JP.28.7411376", name: "Takaichi-gun" },
    { code: "JP.28.7411377", name: "Yamabe-gun" },
    { code: "JP.28.7412211", name: "Katsuragi Shi" },
    { code: "JP.28.7412212", name: "Uda Shi" },
    { code: "JP.28.9036699", name: "Kashihara-shi" },
  ],
  "JP.29": [
    { code: "JP.29.1849786", name: "Tsubame Shi" },
    { code: "JP.29.1850218", name: "Tōkamachi-shi" },
    { code: "JP.29.1852604", name: "Shibata Shi" },
    { code: "JP.29.1852957", name: "Santō-gun" },
    { code: "JP.29.1852981", name: "Sanjō Shi" },
    { code: "JP.29.1853313", name: "Sado Shi" },
    { code: "JP.29.1854443", name: "Ojiya-shi" },
    { code: "JP.29.1855274", name: "Nishikanbara-gun" },
    { code: "JP.29.1855427", name: "Niigata Shi" },
    { code: "JP.29.1856195", name: "Nagaoka Shi" },
    { code: "JP.29.1856876", name: "Mitsuke Shi" },
    { code: "JP.29.1859323", name: "Kitakambara-gun" },
    { code: "JP.29.1859907", name: "Kashiwazaki Shi" },
    { code: "JP.29.1860308", name: "Kamo Shi" },
    { code: "JP.29.1860992", name: "Jōetsu Shi" },
    { code: "JP.29.1861238", name: "Iwafune-gun" },
    { code: "JP.29.1862804", name: "Higashikambara-gun" },
    { code: "JP.29.1863539", name: "Gosen Shi" },
    { code: "JP.29.1865200", name: "Myoko-shi" },
    { code: "JP.29.7468155", name: "Minamikanbara-gun" },
    { code: "JP.29.7468157", name: "Minamiōnuma-gun" },
    { code: "JP.29.7468158", name: "Nakaōnuma-gun" },
    { code: "JP.29.7468159", name: "Kariwa-gun" },
    { code: "JP.29.7468177", name: "Murakami Shi" },
    { code: "JP.29.7468178", name: "Itoigawa Shi" },
    { code: "JP.29.7468179", name: "Agano Shi" },
    { code: "JP.29.7468180", name: "Uonuma Shi" },
    { code: "JP.29.7468181", name: "Minamiuonuma Shi" },
    { code: "JP.29.7468182", name: "Tainai Shi" },
  ],
  "JP.30": [
    { code: "JP.30.1849092", name: "Usuki Shi" },
    { code: "JP.30.1849160", name: "Usa Shi" },
    { code: "JP.30.1849659", name: "Tsukumi-shi" },
    { code: "JP.30.1850823", name: "Taketa-shi" },
    { code: "JP.30.1853234", name: "Saiki-shi" },
    { code: "JP.30.1854480", name: "Ōita-shi" },
    { code: "JP.30.1855742", name: "Nakatsu Shi" },
    { code: "JP.30.1858008", name: "Kusu-gun" },
    { code: "JP.30.1859233", name: "Kitsuki Shi" },
    { code: "JP.30.1862367", name: "Hita Shi" },
    { code: "JP.30.1864667", name: "Bungo-takada Shi" },
    { code: "JP.30.7279571", name: "Kunisaki-shi" },
    { code: "JP.30.7414041", name: "Hayami-gun" },
    { code: "JP.30.7414042", name: "Higashikunisaki-gun" },
    { code: "JP.30.7414050", name: "Beppu Shi" },
    { code: "JP.30.7414051", name: "Bungo-ōno Shi" },
    { code: "JP.30.8739980", name: "Yufu-shi" },
  ],
  "JP.31": [
    { code: "JP.31.1849518", name: "Tsuyama-shi" },
    { code: "JP.31.1849672", name: "Tsukubo-gun" },
    { code: "JP.31.1850139", name: "Tomata-gun" },
    { code: "JP.31.1850741", name: "Tamano Shi" },
    { code: "JP.31.1851133", name: "Takahashi Shi" },
    { code: "JP.31.1854380", name: "Okayama Shi" },
    { code: "JP.31.1854770", name: "Oda-gun" },
    { code: "JP.31.1857232", name: "Mimasaka-shi" },
    { code: "JP.31.1858309", name: "Kurashiki Shi" },
    { code: "JP.31.1858395", name: "Kume-gun" },
    { code: "JP.31.1859776", name: "Katsuta-gun" },
    { code: "JP.31.1859989", name: "Kasaoka Shi" },
    { code: "JP.31.1864698", name: "Bizen Shi" },
    { code: "JP.31.1865049", name: "Asakuchi-gun" },
    { code: "JP.31.7405219", name: "Aida-gun" },
    { code: "JP.31.7405220", name: "Kaga-gun" },
    { code: "JP.31.7405221", name: "Maniwa-gun" },
    { code: "JP.31.7405222", name: "Wake-gun" },
    { code: "JP.31.7405223", name: "Ibara Shi" },
    { code: "JP.31.7405224", name: "Sōja Shi" },
    { code: "JP.31.7405225", name: "Niimi Shi" },
    { code: "JP.31.7405226", name: "Setouchi Shi" },
    { code: "JP.31.7405227", name: "Akaiwa Shi" },
    { code: "JP.31.7405228", name: "Maniwa-shi" },
    { code: "JP.31.7405229", name: "Asakuchi Shi" },
  ],
  "JP.32": [
    { code: "JP.32.1848519", name: "Yao-shi" },
    { code: "JP.32.1850033", name: "Tondabayashi Shi" },
    { code: "JP.32.1850907", name: "Takatsuki Shi" },
    { code: "JP.32.1851123", name: "Takaishi Shi" },
    { code: "JP.32.1851482", name: "Suita Shi" },
    { code: "JP.32.1852523", name: "Shijonawate Shi" },
    { code: "JP.32.1852642", name: "Settsu Shi" },
    { code: "JP.32.1852716", name: "Sennan-gun" },
    { code: "JP.32.1853167", name: "Sakai Shi" },
    { code: "JP.32.1853897", name: "Osaka-shi" },
    { code: "JP.32.1855493", name: "Neyagawa Shi" },
    { code: "JP.32.1856974", name: "Mishima-gun" },
    { code: "JP.32.1857043", name: "Minoo Shi" },
    { code: "JP.32.1857170", name: "Minamikawachi-gun" },
    { code: "JP.32.1857563", name: "Matsubara-shi" },
    { code: "JP.32.1859382", name: "Kishiwada Shi" },
    { code: "JP.32.1859747", name: "Kawachi-nagano Shi" },
    { code: "JP.32.1859848", name: "Katano Shi" },
    { code: "JP.32.1859912", name: "Kashiwara-shi" },
    { code: "JP.32.1860764", name: "Kaizuka Shi" },
    { code: "JP.32.1860870", name: "Kadoma Shi" },
    { code: "JP.32.1861089", name: "Izumi Shi" },
    { code: "JP.32.1861094", name: "Izumiōtsu Shi" },
    { code: "JP.32.1861785", name: "Ikeda Shi" },
    { code: "JP.32.1862032", name: "Ibaraki Shi" },
    { code: "JP.32.1862538", name: "Hirakata Shi" },
    { code: "JP.32.1862751", name: "Higashiōsaka Shi" },
    { code: "JP.32.1863185", name: "Hannan Shi" },
    { code: "JP.32.1863476", name: "Habikino-shi" },
    { code: "JP.32.1864125", name: "Fujiidera-shi" },
    { code: "JP.32.1864413", name: "Daitō Shi" },
    { code: "JP.32.7391698", name: "Izumisano Shi" },
    { code: "JP.32.7391699", name: "Ōsaka-sayama Shi" },
    { code: "JP.32.7391700", name: "Sennan Shi" },
    { code: "JP.32.7391701", name: "Toyonaka Shi" },
    { code: "JP.32.7391703", name: "Senboku-gun" },
    { code: "JP.32.8300631", name: "Moriguchi Shi" },
    { code: "JP.32.8714934", name: "Toyono Gun" },
  ],
  "JP.33": [
    { code: "JP.33.1849903", name: "Tosu Shi" },
    { code: "JP.33.1850771", name: "Taku Shi" },
    { code: "JP.33.1850832", name: "Takeo Shi" },
    { code: "JP.33.1853274", name: "Saga Shi" },
    { code: "JP.33.1854650", name: "Ogi-shi" },
    { code: "JP.33.1855238", name: "Nishimatsuura-gun" },
    { code: "JP.33.1856784", name: "Miyaki-gun" },
    { code: "JP.33.1859936", name: "Kashima Shi" },
    { code: "JP.33.1862779", name: "Higashimatsuura-gun" },
    { code: "JP.33.7391354", name: "Fujitsu-gun" },
    { code: "JP.33.7391355", name: "Imari Shi" },
    { code: "JP.33.7391356", name: "Kanzaki-gun" },
    { code: "JP.33.7391357", name: "Kanzaki Shi" },
    { code: "JP.33.7391358", name: "Kishima-gun" },
    { code: "JP.33.7391363", name: "Ureshino Shi" },
    { code: "JP.33.8300623", name: "Karatsu Shi" },
  ],
  "JP.34": [
    { code: "JP.34.10942180", name: "Konosu-Shi" },
    { code: "JP.34.11668552", name: "Yashio-shi" },
    { code: "JP.34.1848902", name: "Warabi-shi" },
    { code: "JP.34.1848915", name: "Wakō-shi" },
    { code: "JP.34.1849187", name: "Saitama-shi" },
    { code: "JP.34.1849586", name: "Tsurugashima-shi" },
    { code: "JP.34.1850180", name: "Tokorozawa-shi" },
    { code: "JP.34.1850300", name: "Toda-shi" },
    { code: "JP.34.1851882", name: "Shiraoka-shi" },
    { code: "JP.34.1852833", name: "Sayama-shi" },
    { code: "JP.34.1853207", name: "Sakado-shi" },
    { code: "JP.34.1854369", name: "Okegawa-shi" },
    { code: "JP.34.1855405", name: "Niiza-shi" },
    { code: "JP.34.1856987", name: "Misato Shi" },
    { code: "JP.34.1857143", name: "Minamisaitama Gun" },
    { code: "JP.34.1858728", name: "Koshigaya Shi" },
    { code: "JP.34.1859316", name: "Kitakatsushika Gun" },
    { code: "JP.34.1859369", name: "Kitaadachi-gun" },
    { code: "JP.34.1859584", name: "Kazo-shi" },
    { code: "JP.34.1859726", name: "Kawaguchi-shi" },
    { code: "JP.34.1859739", name: "Kawagoe-shi" },
    { code: "JP.34.1861469", name: "Iruma-shi" },
    { code: "JP.34.1861470", name: "Iruma-gun" },
    { code: "JP.34.1862192", name: "Honjō Shi" },
    { code: "JP.34.1862655", name: "Hiki-gun" },
    { code: "JP.34.1862777", name: "Higashimatsuyama Shi" },
    { code: "JP.34.1863058", name: "Hasuda-shi" },
    { code: "JP.34.1863182", name: "Hannō-shi" },
    { code: "JP.34.1863481", name: "Gyōda Shi" },
    { code: "JP.34.1864030", name: "Fukaya-shi" },
    { code: "JP.34.1864112", name: "Fujimi-shi" },
    { code: "JP.34.1864636", name: "Chichibu-gun" },
    { code: "JP.34.1865056", name: "Asaka-shi" },
    { code: "JP.34.7458572", name: "Kodama-gun" },
    { code: "JP.34.7458573", name: "Ōsato-gun" },
    { code: "JP.34.7464121", name: "Chichibu-shi" },
    { code: "JP.34.7464122", name: "Hanyū-shi" },
    { code: "JP.34.7464123", name: "Sōka Shi" },
    { code: "JP.34.7464124", name: "Kuki-shi" },
    { code: "JP.34.7464125", name: "Kitamoto Shi" },
    { code: "JP.34.7464126", name: "Satte Shi" },
    { code: "JP.34.7464127", name: "Yoshikawa Shi" },
    { code: "JP.34.7464128", name: "Fujimino Shi" },
    { code: "JP.34.8304212", name: "Kumagaya Shi" },
    { code: "JP.34.8304213", name: "Kasukabe Shi" },
    { code: "JP.34.8304214", name: "Ageo Shi" },
    { code: "JP.34.8304215", name: "Shiki Shi" },
    { code: "JP.34.9881554", name: "Hidaka-shi" },
  ],
  "JP.35": [
    { code: "JP.35.1848489", name: "Yasu-shi" },
    { code: "JP.35.1853408", name: "Rittō-shi" },
    { code: "JP.35.1853552", name: "Ōtsu-shi" },
    { code: "JP.35.1854152", name: "Ōmihachiman-shi" },
    { code: "JP.35.1856237", name: "Nagahama-shi" },
    { code: "JP.35.1856568", name: "Moriyama-shi" },
    { code: "JP.35.1858063", name: "Kusatsu-shi" },
    { code: "JP.35.1858739", name: "Konan-shi" },
    { code: "JP.35.1858984", name: "Kōka-shi" },
    { code: "JP.35.1862635", name: "Hikone-shi" },
    { code: "JP.35.1863686", name: "Gamō-gun" },
    { code: "JP.35.1864254", name: "Echi-gun" },
    { code: "JP.35.6822197", name: "Higashiōmi-shi" },
    { code: "JP.35.7394802", name: "Maibara-shi" },
    { code: "JP.35.7394806", name: "Inukami-gun" },
    { code: "JP.35.8740424", name: "Takashima-shi" },
  ],
  "JP.36": [
    { code: "JP.36.1854361", name: "Oki-gun" },
    { code: "JP.36.1854750", name: "Ōda Shi" },
    { code: "JP.36.1854781", name: "Ōchi Gun" },
    { code: "JP.36.1857549", name: "Matsue Shi" },
    { code: "JP.36.1857590", name: "Masuda Shi" },
    { code: "JP.36.1861082", name: "Izumo Shi" },
    { code: "JP.36.1863308", name: "Hamada Shi" },
    { code: "JP.36.1863519", name: "Gōtsu Shi" },
    { code: "JP.36.7392547", name: "Ishii Gun" },
    { code: "JP.36.7392548", name: "Nita Gun" },
    { code: "JP.36.7392549", name: "Kanoashi Gun" },
    { code: "JP.36.7392557", name: "Unnan Shi" },
    { code: "JP.36.7392558", name: "Yasugi Shi" },
  ],
  "JP.37": [
    { code: "JP.37.1848772", name: "Yaizu Shi" },
    { code: "JP.37.1851274", name: "Tagata-gun" },
    { code: "JP.37.1851376", name: "Susono Shi" },
    { code: "JP.37.1851401", name: "Suntō-gun" },
    { code: "JP.37.1851714", name: "Shizuoka-shi" },
    { code: "JP.37.1852349", name: "Shimoda-shi" },
    { code: "JP.37.1854181", name: "Omaezaki-shi" },
    { code: "JP.37.1854900", name: "Numazu-shi" },
    { code: "JP.37.1856971", name: "Mishima Shi" },
    { code: "JP.37.1859485", name: "Kikugawa-shi" },
    { code: "JP.37.1860327", name: "Kamo-gun" },
    { code: "JP.37.1861167", name: "Iwata-shi" },
    { code: "JP.37.1863288", name: "Hamamatsu-shi" },
    { code: "JP.37.1863397", name: "Haibara-gun" },
    { code: "JP.37.1863526", name: "Gotenba Shi" },
    { code: "JP.37.1863944", name: "Fukuroi-shi" },
    { code: "JP.37.1864089", name: "Fuji Shi" },
    { code: "JP.37.1864104", name: "Fujinomiya Shi" },
    { code: "JP.37.1864131", name: "Fujieda Shi" },
    { code: "JP.37.1864943", name: "Atami-shi" },
    { code: "JP.37.7418312", name: "Shūchi-gun" },
    { code: "JP.37.7418320", name: "Izunokuni-shi" },
    { code: "JP.37.7418321", name: "Makinohara Shi" },
    { code: "JP.37.7418322", name: "Shimada-shi" },
    { code: "JP.37.8301106", name: "Itō Shi" },
    { code: "JP.37.8301107", name: "Kakegawa Shi" },
    { code: "JP.37.8301108", name: "Kosai-shi" },
    { code: "JP.37.9036693", name: "Izu-shi" },
  ],
  "JP.38": [
    { code: "JP.38.1848775", name: "Yaita-shi" },
    { code: "JP.38.1849052", name: "Utsunomiya-shi" },
    { code: "JP.38.1851957", name: "Shioya-gun" },
    { code: "JP.38.1852170", name: "Shimotsuga-gun" },
    { code: "JP.38.1853473", name: "Oyama-shi" },
    { code: "JP.38.1859750", name: "Kawachi-gun" },
    { code: "JP.38.1860097", name: "Kanuma-shi" },
    { code: "JP.38.1861696", name: "Nikko-shi" },
    { code: "JP.38.1865004", name: "Ashikaga Shi" },
    { code: "JP.38.2111324", name: "Ōtawara-shi" },
    { code: "JP.38.2111674", name: "Nasu-gun" },
    { code: "JP.38.2111835", name: "Mooka-shi" },
    { code: "JP.38.2112845", name: "Haga-gun" },
    { code: "JP.38.7453512", name: "Nasukarasuyama-shi" },
    { code: "JP.38.7453513", name: "Nasushiobara-shi" },
    { code: "JP.38.7453516", name: "Sakura-shi" },
    { code: "JP.38.7453517", name: "Sano-shi" },
    { code: "JP.38.7453590", name: "Tochigi-shi" },
    { code: "JP.38.8739981", name: "Shimotsuke-shi" },
  ],
  "JP.39": [
    { code: "JP.39.10172903", name: "Naruto-shi" },
    { code: "JP.39.1850156", name: "Tokushima Shi" },
    { code: "JP.39.1856299", name: "Myōzai Gun" },
    { code: "JP.39.1856695", name: "Miyoshi-gun" },
    { code: "JP.39.1858900", name: "Komatsushima Shi" },
    { code: "JP.39.1859771", name: "Katsuura Gun" },
    { code: "JP.39.1860803", name: "Kaifu Gun" },
    { code: "JP.39.1861303", name: "Itano-gun" },
    { code: "JP.39.1864902", name: "Awa-shi" },
    { code: "JP.39.1865306", name: "Anan Shi" },
    { code: "JP.39.7406321", name: "Mima Gun" },
    { code: "JP.39.7406322", name: "Myōdō Gun" },
    { code: "JP.39.7406323", name: "Naka Gun" },
    { code: "JP.39.7406324", name: "Yoshinogawa Shi" },
    { code: "JP.39.7406325", name: "Mima Shi" },
    { code: "JP.39.7406326", name: "Miyoshi Shi" },
  ],
  "JP.40": [
    { code: "JP.40.1850731", name: "Tama-shi" },
    { code: "JP.40.1851306", name: "Tachikawa-shi" },
    { code: "JP.40.1851451", name: "Sumida-ku" },
    { code: "JP.40.1851510", name: "Suginami-ku" },
    { code: "JP.40.1852083", name: "Shinjuku-ku" },
    { code: "JP.40.1852140", name: "Shinagawa-ku" },
    { code: "JP.40.1852582", name: "Shibuya-ku" },
    { code: "JP.40.1852675", name: "Setagaya-ku" },
    { code: "JP.40.1853655", name: "Ōta-ku" },
    { code: "JP.40.1853724", name: "Ōshima Shichō" },
    { code: "JP.40.1854160", name: "Ōme-shi" },
    { code: "JP.40.1855156", name: "Nishitama-gun" },
    { code: "JP.40.1855502", name: "Nerima-ku" },
    { code: "JP.40.1855848", name: "Nakano-ku" },
    { code: "JP.40.1856366", name: "Musashino-shi" },
    { code: "JP.40.1856368", name: "Musashimurayama-shi" },
    { code: "JP.40.1856786", name: "Miyake Shichō" },
    { code: "JP.40.1856942", name: "Mitaka-shi" },
    { code: "JP.40.1857091", name: "Minato-ku" },
    { code: "JP.40.1857420", name: "Meguro-ku" },
    { code: "JP.40.1857869", name: "Machida-shi" },
    { code: "JP.40.1858346", name: "Kunitachi-shi" },
    { code: "JP.40.1858665", name: "Kōtō-ku" },
    { code: "JP.40.1858941", name: "Komae-shi" },
    { code: "JP.40.1858962", name: "Kokubunji-shi" },
    { code: "JP.40.1859087", name: "Koganei-shi" },
    { code: "JP.40.1859115", name: "Kodaira-shi" },
    { code: "JP.40.1859211", name: "Kiyose-shi" },
    { code: "JP.40.1859308", name: "Kita-ku" },
    { code: "JP.40.1859779", name: "Katsushika Ku" },
    { code: "JP.40.1861322", name: "Itabashi-ku" },
    { code: "JP.40.1861634", name: "Inagi-shi" },
    { code: "JP.40.1862576", name: "Hino-shi" },
    { code: "JP.40.1862703", name: "Higashiyamato-shi" },
    { code: "JP.40.1862768", name: "Higashi-murayama-shi" },
    { code: "JP.40.1862785", name: "Higashikurume-shi" },
    { code: "JP.40.1863251", name: "Hamura-shi" },
    { code: "JP.40.1863453", name: "Hachijō Shichō" },
    { code: "JP.40.1863780", name: "Fussa-shi" },
    { code: "JP.40.1864148", name: "Fuchū-shi" },
    { code: "JP.40.1864242", name: "Edogawa Ku" },
    { code: "JP.40.1864487", name: "Chūō Ku" },
    { code: "JP.40.1864514", name: "Chōfu-shi" },
    { code: "JP.40.1864529", name: "Chiyoda-ku" },
    { code: "JP.40.1865187", name: "Arakawa Ku" },
    { code: "JP.40.1865425", name: "Akishima-shi" },
    { code: "JP.40.1865750", name: "Adachi Ku" },
    { code: "JP.40.2111520", name: "Ogasawara Shichō" },
    { code: "JP.40.7475133", name: "Bunkyō-ku" },
    { code: "JP.40.7475134", name: "Taitō-ku" },
    { code: "JP.40.7475135", name: "Toshima-ku" },
    { code: "JP.40.8304374", name: "Akiruno-shi" },
    { code: "JP.40.8304375", name: "Hachiōji-shi" },
    { code: "JP.40.8304376", name: "Nishitōkyō-shi" },
  ],
  "JP.41": [
    { code: "JP.41.1848276", name: "Yonago Shi" },
    { code: "JP.41.1848416", name: "Yazu-gun" },
    { code: "JP.41.1849887", name: "Tottori-shi" },
    { code: "JP.41.1850247", name: "Tōhaku-gun" },
    { code: "JP.41.1853173", name: "Sakaiminato Shi" },
    { code: "JP.41.1853248", name: "Saihaku-gun" },
    { code: "JP.41.1862590", name: "Hino Gun" },
    { code: "JP.41.7392255", name: "Kurayoshi-shi" },
    { code: "JP.41.7392260", name: "Iwami-gun" },
  ],
  "JP.42": [
    { code: "JP.42.1849235", name: "Uozu Shi" },
    { code: "JP.42.1849870", name: "Toyama Shi" },
    { code: "JP.42.1850038", name: "Tonami Shi" },
    { code: "JP.42.1851028", name: "Takaoka Shi" },
    { code: "JP.42.1852239", name: "Shimoniikawa Gun" },
    { code: "JP.42.1853505", name: "Oyabe Shi" },
    { code: "JP.42.1855693", name: "Namerikawa-shi" },
    { code: "JP.42.1855873", name: "Nakaniikawa Gun" },
    { code: "JP.42.1858253", name: "Kurobe Shi" },
    { code: "JP.42.1861653", name: "Imizu Shi" },
    { code: "JP.42.1862610", name: "Himi Shi" },
    { code: "JP.42.7391183", name: "Nanto Shi" },
  ],
  "JP.43": [
    { code: "JP.43.1848936", name: "Wakayama Shi" },
    { code: "JP.43.1850706", name: "Tanabe-shi" },
    { code: "JP.43.1852105", name: "Shingū-shi" },
    { code: "JP.43.1855225", name: "Nishimuro-gun" },
    { code: "JP.43.1860774", name: "Kaisō-gun" },
    { code: "JP.43.1860782", name: "Kainan Shi" },
    { code: "JP.43.1861287", name: "Ito-gun" },
    { code: "JP.43.1862767", name: "Higashimuro-gun" },
    { code: "JP.43.1862875", name: "Hidaka-gun" },
    { code: "JP.43.1863079", name: "Hashimoto Shi" },
    { code: "JP.43.1865121", name: "Arida Shi" },
    { code: "JP.43.1865123", name: "Arida-gun" },
    { code: "JP.43.7411112", name: "Gobō-shi" },
    { code: "JP.43.7411113", name: "Iwade Shi" },
    { code: "JP.43.7411114", name: "Kinokawa Shi" },
  ],
  "JP.44": [
    { code: "JP.44.1849562", name: "Tsuruoka Shi" },
    { code: "JP.44.1853136", name: "Sakata Shi" },
    { code: "JP.44.1855187", name: "Nishiokitama-gun" },
    { code: "JP.44.1862730", name: "Higashitagawa-gun" },
    { code: "JP.44.2110496", name: "Yonezawa Shi" },
    { code: "JP.44.2110552", name: "Yamagata Shi" },
    { code: "JP.44.2111061", name: "Shinjō Shi" },
    { code: "JP.44.2111245", name: "Sagae-shi" },
    { code: "JP.44.2111620", name: "Nishimurayama-gun" },
    { code: "JP.44.2111692", name: "Nanyō Shi" },
    { code: "JP.44.2111778", name: "Nagai-shi" },
    { code: "JP.44.2111805", name: "Murayama Shi" },
    { code: "JP.44.2111850", name: "Mogami-gun" },
    { code: "JP.44.2112407", name: "Kaminoyama-shi" },
    { code: "JP.44.2112756", name: "Higashiokitama-gun" },
    { code: "JP.44.2112760", name: "Higashimurayama-gun" },
    { code: "JP.44.7450014", name: "Higashine Shi" },
    { code: "JP.44.7450018", name: "Obanazawa Shi" },
    { code: "JP.44.7450462", name: "Akumi-gun" },
    { code: "JP.44.7450463", name: "Kitamurayama-gun" },
    { code: "JP.44.7450466", name: "Tendō Shi" },
  ],
  "JP.45": [
    { code: "JP.45.1848548", name: "Yanai Shi" },
    { code: "JP.45.1848678", name: "Yamaguchi Shi" },
    { code: "JP.45.1849494", name: "Ube Shi" },
    { code: "JP.45.1852222", name: "Shimonoseki Shi" },
    { code: "JP.45.1853738", name: "Ōshima-gun" },
    { code: "JP.45.1856090", name: "Nagato Shi" },
    { code: "JP.45.1857072", name: "Mine Shi" },
    { code: "JP.45.1858484", name: "Kuga Gun" },
    { code: "JP.45.1858497", name: "Kudamatsu Shi" },
    { code: "JP.45.1861209", name: "Iwakuni Shi" },
    { code: "JP.45.1862301", name: "Hofu Shi" },
    { code: "JP.45.1862667", name: "Hikari Shi" },
    { code: "JP.45.1863413", name: "Hagi Shi" },
    { code: "JP.45.1865762", name: "Abu-gun" },
    { code: "JP.45.7392999", name: "Sanyōonoda Shi" },
    { code: "JP.45.7393001", name: "Shūnan Shi" },
    { code: "JP.45.8740711", name: "Kumage-gun" },
  ],
  "JP.46": [
    { code: "JP.46.1848648", name: "Yamanashi-shi" },
    { code: "JP.46.1849406", name: "Uenohara-shi" },
    { code: "JP.46.1849556", name: "Tsuru-shi" },
    { code: "JP.46.1853562", name: "Ōtsuki-shi" },
    { code: "JP.46.1855121", name: "Nishiyatsushiro-gun" },
    { code: "JP.46.1855362", name: "Nirasaki-shi" },
    { code: "JP.46.1857168", name: "Minamikoma-gun" },
    { code: "JP.46.1859096", name: "Kōfu-shi" },
    { code: "JP.46.1859260", name: "Kitatsuru-gun" },
    { code: "JP.46.1864076", name: "Fuji-yoshida Shi" },
    { code: "JP.46.7415908", name: "Minamitsuru-gun" },
    { code: "JP.46.7415909", name: "Nakakoma-gun" },
    { code: "JP.46.7415914", name: "Minami Alps-shi" },
    { code: "JP.46.7415915", name: "Hokuto-shi" },
    { code: "JP.46.7415916", name: "Fuefuki-shi" },
    { code: "JP.46.7415917", name: "Kōshū-shi" },
    { code: "JP.46.7415926", name: "Chūō-shi" },
    { code: "JP.46.9062326", name: "Kai-shi" },
  ],
  "JP.47": [
    { code: "JP.47.1848816", name: "Yaeyama-gun" },
    { code: "JP.47.1849184", name: "Urasoe Shi" },
    { code: "JP.47.1850107", name: "Tomigusuku-shi" },
    { code: "JP.47.1852456", name: "Shimajiri-gun" },
    { code: "JP.47.1854344", name: "Okinawa Shi" },
    { code: "JP.47.1855990", name: "Nakagami-gun" },
    { code: "JP.47.1856030", name: "Naha Shi" },
    { code: "JP.47.1856061", name: "Nago Shi" },
    { code: "JP.47.1858371", name: "Kunigami-gun" },
    { code: "JP.47.1861279", name: "Itoman Shi" },
    { code: "JP.47.1861412", name: "Ishigaki-shi" },
    { code: "JP.47.1863626", name: "Ginowan Shi" },
    { code: "JP.47.7415817", name: "Miyako-gun" },
    { code: "JP.47.7415819", name: "Miyakojima Shi" },
    { code: "JP.47.7415820", name: "Nanjō Shi" },
    { code: "JP.47.7415821", name: "Uruma Shi" },
  ],
  "KE.05": [
    { code: "KE.05.7667649", name: "Nairobi District" },
  ],
  "KE.13": [
    { code: "KE.13.7602535", name: "Teso District" },
  ],
  "KE.15": [
    { code: "KE.15.7667992", name: "Mbeere District" },
  ],
  "KE.16": [
    { code: "KE.16.8299464", name: "Ijara District" },
  ],
  "KE.17": [
    { code: "KE.17.7800141", name: "Suba District" },
    { code: "KE.17.7802748", name: "Rachuonyo District" },
  ],
  "KE.18": [
    { code: "KE.18.7667663", name: "Meru North District" },
  ],
  "KE.19": [
    { code: "KE.19.11258224", name: "Rarieda" },
  ],
  "KE.20": [
    { code: "KE.20.7667626", name: "Butere/Mumias District" },
    { code: "KE.20.7667629", name: "Lugari District" },
  ],
  "KE.22": [
    { code: "KE.22.179328", name: "Thika District" },
    { code: "KE.22.8693007", name: "Kiambu County" },
  ],
  "KE.23": [
    { code: "KE.23.7667639", name: "Malindi District" },
    { code: "KE.23.7667674", name: "Kisii Central" },
  ],
  "KE.25": [
    { code: "KE.25.7667668", name: "Gucha District" },
    { code: "KE.25.8051335", name: "Central Kisii" },
  ],
  "KE.26": [
    { code: "KE.26.7602531", name: "Nyando District" },
  ],
  "KE.27": [
    { code: "KE.27.11170827", name: "Kyuso sub-county" },
    { code: "KE.27.7667670", name: "Mwingi" },
  ],
  "KE.30": [
    { code: "KE.30.189739", name: "Lamu District" },
  ],
  "KE.31": [
    { code: "KE.31.187246", name: "Matungulu Location" },
  ],
  "KE.34": [
    { code: "KE.34.7733024", name: "Moyale District" },
    { code: "KE.34.8298605", name: "Oloitokitok District" },
  ],
  "KE.35": [
    { code: "KE.35.11258464", name: "South Imenti" },
    { code: "KE.35.8693009", name: "Meru County" },
  ],
  "KE.36": [
    { code: "KE.36.7909895", name: "Kuria" },
  ],
  "KE.38": [
    { code: "KE.38.7669154", name: "Maragua District" },
  ],
  "KE.40": [
    { code: "KE.40.7602644", name: "Nandi North District" },
  ],
  "KE.41": [
    { code: "KE.41.11257923", name: "Trans Mara District" },
  ],
  "KE.49": [
    { code: "KE.49.7733025", name: "Meru South District" },
  ],
  "KE.53": [
    { code: "KE.53.11239665", name: "Emuhaya" },
  ],
  "KE.55": [
    { code: "KE.55.7668897", name: "West Potok" },
  ],
  "KG.01": [
    { code: "KG.01.1527315", name: "Sverdlovskiy Rayon" },
    { code: "KG.01.1527506", name: "Pervomayskiy Rayon" },
    { code: "KG.01.1527686", name: "Leninskiy Rayon" },
    { code: "KG.01.8220960", name: "Oktyabr’skiy Rayon" },
  ],
  "KG.02": [
    { code: "KG.02.10291336", name: "Tokmok District" },
    { code: "KG.02.1527358", name: "Sokulukskiy Rayon" },
    { code: "KG.02.1527509", name: "Panfilovskiy Rayon" },
    { code: "KG.02.1527974", name: "Keminskiy Rayon" },
    { code: "KG.02.1528261", name: "Ysyk-Ata" },
    { code: "KG.02.1528472", name: "Chuyskiy Rayon" },
    { code: "KG.02.1528867", name: "Alamudunskiy Rayon" },
    { code: "KG.02.7667441", name: "Moskovsky Raion" },
    { code: "KG.02.8739737", name: "Jaiyl" },
  ],
  "KG.03": [
    { code: "KG.03.1527194", name: "Toktogul District" },
    { code: "KG.03.7910407", name: "Suzak" },
    { code: "KG.03.8139375", name: "Aksy" },
    { code: "KG.03.8139376", name: "Chatkal" },
    { code: "KG.03.9165680", name: "Bazar-Korgon" },
    { code: "KG.03.9165682", name: "Ala-Buka" },
    { code: "KG.03.9165683", name: "Nooken" },
    { code: "KG.03.9165780", name: "Kazarman" },
  ],
  "KG.04": [
    { code: "KG.04.10237161", name: "Naryn District" },
    { code: "KG.04.7649245", name: "Ak-Tala" },
    { code: "KG.04.7654212", name: "Jumgal" },
    { code: "KG.04.9165773", name: "Kochkor" },
    { code: "KG.04.9165774", name: "At-Bashi" },
  ],
  "KG.06": [
    { code: "KG.06.1527296", name: "Talasskiy Rayon" },
    { code: "KG.06.1527687", name: "Bakay-Atinskiy Rayon" },
    { code: "KG.06.1527920", name: "Kara-Buurinskiy Rayon" },
    { code: "KG.06.9165692", name: "Manas" },
  ],
  "KG.07": [
    { code: "KG.07.10237012", name: "Jeti-Oguz District" },
    { code: "KG.07.8046904", name: "Tüp" },
    { code: "KG.07.8308862", name: "Tong" },
    { code: "KG.07.8357767", name: "Ysyk-Köl" },
    { code: "KG.07.8537999", name: "Ak-Suu" },
  ],
  "KG.08": [
    { code: "KG.08.7667445", name: "Uzgen District" },
    { code: "KG.08.7910403", name: "Aravan" },
    { code: "KG.08.7910404", name: "Kara-Suu" },
    { code: "KG.08.7910405", name: "Nookat" },
    { code: "KG.08.8739771", name: "Alay District" },
    { code: "KG.08.9165129", name: "Kara Kulja" },
    { code: "KG.08.9192641", name: "Chong-Alay District" },
  ],
  "KG.09": [
    { code: "KG.09.1222597", name: "Leylekskiy Rayon" },
    { code: "KG.09.1222671", name: "Kadamjaiskiy Raion" },
    { code: "KG.09.1222703", name: "Batkenskiy Rayon" },
  ],
  "KH.02": [
    { code: "KH.02.7647221", name: "Cheung Prey" },
    { code: "KH.02.7647526", name: "Kampong Cham" },
    { code: "KH.02.8403885", name: "Srŏk Bathéay" },
    { code: "KH.02.9253736", name: "Chamkar Leu" },
    { code: "KH.02.9253738", name: "Kampong Siem" },
    { code: "KH.02.9253739", name: "Kang Meas" },
    { code: "KH.02.9253741", name: "Kaoh Soutin" },
    { code: "KH.02.9253743", name: "Prey Chhor" },
    { code: "KH.02.9253747", name: "Srei Santhor" },
    { code: "KH.02.9253748", name: "Steung Trang" },
  ],
  "KH.03": [
    { code: "KH.03.7647209", name: "Kampong Chhnang" },
    { code: "KH.03.7647218", name: "Baribour" },
    { code: "KH.03.7647219", name: "Rolea B'ier" },
    { code: "KH.03.8405259", name: "Srŏk Chol Kiri" },
    { code: "KH.03.8405260", name: "Srŏk Sameakki Mean Chey" },
    { code: "KH.03.9253749", name: "Kampong Leaeng" },
    { code: "KH.03.9253752", name: "Kampong Tralach" },
    { code: "KH.03.9253753", name: "Tuek Phos" },
  ],
  "KH.04": [
    { code: "KH.04.1830230", name: "Srŏk Ŏdŏngk" },
    { code: "KH.04.1830613", name: "Srŏk Kông Pĭsei" },
    { code: "KH.04.8405257", name: "Srŏk Basedth" },
    { code: "KH.04.8405258", name: "Krŏng Chbar Mon" },
    { code: "KH.04.9253754", name: "Aoral" },
    { code: "KH.04.9253755", name: "Phnum Sruoch" },
    { code: "KH.04.9253758", name: "Samraong Tong" },
    { code: "KH.04.9253759", name: "Thpong" },
  ],
  "KH.05": [
    { code: "KH.05.1822025", name: "Srŏk Stoŭng" },
    { code: "KH.05.1831130", name: "Srŏk Kâmpóng Svay" },
    { code: "KH.05.7647211", name: "Stueng Saen" },
    { code: "KH.05.7647222", name: "Baray" },
    { code: "KH.05.7647223", name: "Santuk" },
    { code: "KH.05.7873979", name: "Prasat Balangk" },
    { code: "KH.05.8541396", name: "Srŏk Prâsat Sâmbor" },
    { code: "KH.05.9253760", name: "Sandan" },
  ],
  "KH.07": [
    { code: "KH.07.8405991", name: "Srŏk Khsăch Kândal" },
    { code: "KH.07.8405992", name: "Krŏng Ta Khmau" },
    { code: "KH.07.9253763", name: "Kaoh Thum" },
    { code: "KH.07.9253767", name: "Kien Svay" },
    { code: "KH.07.9253769", name: "Leuk Daek" },
    { code: "KH.07.9253771", name: "Mukh Kampul" },
    { code: "KH.07.9253772", name: "Popnhea Lueu" },
    { code: "KH.07.9253773", name: "S'ang" },
  ],
  "KH.08": [
    { code: "KH.08.1831788", name: "Srŏk Batum Sakôr" },
    { code: "KH.08.8405254", name: "Krŏng Khémârâ Phumĭn" },
    { code: "KH.08.8405255", name: "Srŏk Môndôl Seima" },
    { code: "KH.08.8740319", name: "Srae Ambel" },
    { code: "KH.08.9253774", name: "Kampong Seila" },
    { code: "KH.08.9253775", name: "Kiri Sakor" },
    { code: "KH.08.9253776", name: "Thma Bang" },
  ],
  "KH.09": [
    { code: "KH.09.7647220", name: "Kracheh" },
    { code: "KH.09.8405250", name: "Srŏk Chĕt Bŭri" },
    { code: "KH.09.9253777", name: "Chhloung" },
    { code: "KH.09.9253778", name: "Preaek Prasab" },
    { code: "KH.09.9253779", name: "Sambour" },
    { code: "KH.09.9253780", name: "Snuol" },
  ],
  "KH.10": [
    { code: "KH.10.8405032", name: "Srŏk Kaev Seima" },
    { code: "KH.10.8405033", name: "Srŏk Pech Chreada" },
    { code: "KH.10.8405034", name: "Krŏng Sênmônoŭrôm" },
    { code: "KH.10.9253783", name: "Khaoh Neaek" },
    { code: "KH.10.9253785", name: "Ou Reang" },
  ],
  "KH.12": [
    { code: "KH.12.7647215", name: "Bakan" },
    { code: "KH.12.7647216", name: "Sampov Meas" },
    { code: "KH.12.7647217", name: "Krakor" },
    { code: "KH.12.8405251", name: "Srŏk Kândiĕng" },
    { code: "KH.12.8405252", name: "Krŏng Poŭthĭsăt" },
    { code: "KH.12.8405253", name: "Srŏk Véal Vêng" },
    { code: "KH.12.9253798", name: "Phnum Kravanh" },
  ],
  "KH.13": [
    { code: "KH.13.1822431", name: "Srŏk Rôviĕng" },
    { code: "KH.13.1831603", name: "Srŏk Chhêb" },
    { code: "KH.13.7873990", name: "Sangkom Thmei" },
    { code: "KH.13.8403983", name: "Srŏk Ch’êh Sên" },
    { code: "KH.13.8403984", name: "Srŏk Kulén" },
    { code: "KH.13.8403986", name: "Srŏk Tbêng Méanchey" },
    { code: "KH.13.8403987", name: "Krŏng Preăh Vĭhéar" },
    { code: "KH.13.9253788", name: "Choam Khsant" },
  ],
  "KH.14": [
    { code: "KH.14.10627327", name: "Me Sang" },
    { code: "KH.14.8406192", name: "Srŏk Mésang" },
    { code: "KH.14.8406195", name: "Srŏk Preăh Sdéch" },
    { code: "KH.14.8406197", name: "Srŏk Kâmpóng Léav" },
    { code: "KH.14.8406203", name: "Srŏk Svay Ântôr" },
    { code: "KH.14.9253770", name: "Lvea Aem" },
    { code: "KH.14.9253789", name: "Ba Phnum" },
    { code: "KH.14.9253790", name: "Kamchay Mear" },
    { code: "KH.14.9253791", name: "Kampong Trabaek" },
    { code: "KH.14.9253792", name: "Kanhchriech" },
    { code: "KH.14.9253793", name: "Pea Reang" },
    { code: "KH.14.9253795", name: "Peam Chor" },
    { code: "KH.14.9253796", name: "Peam Ro" },
    { code: "KH.14.9253797", name: "Sithor Kandal" },
  ],
  "KH.17": [
    { code: "KH.17.7647528", name: "Stueng Traeng" },
    { code: "KH.17.8404435", name: "Srŏk Srêsén" },
    { code: "KH.17.9253808", name: "Siem Bouk" },
    { code: "KH.17.9253809", name: "Siem Pang" },
    { code: "KH.17.9253810", name: "Thala Barivat" },
  ],
  "KH.18": [
    { code: "KH.18.8403503", name: "Srŏk Svay Chrŭm" },
    { code: "KH.18.8406206", name: "Krŏng Bavĕt" },
    { code: "KH.18.9253811", name: "Chantrea" },
    { code: "KH.18.9253812", name: "Romeas Haek" },
    { code: "KH.18.9253813", name: "Rumduol" },
    { code: "KH.18.9253820", name: "Kampong Rou" },
  ],
  "KH.19": [
    { code: "KH.19.8405261", name: "Srŏk Ângkôr Borei" },
    { code: "KH.19.8405262", name: "Srŏk Borei Cholsar" },
    { code: "KH.19.8405707", name: "Krŏng Doun Kaev" },
    { code: "KH.19.9253814", name: "Bati" },
    { code: "KH.19.9253815", name: "Kiri Vong" },
    { code: "KH.19.9253816", name: "Prey Kabbas" },
    { code: "KH.19.9253818", name: "Tram Kak" },
    { code: "KH.19.9253819", name: "Treang" },
  ],
  "KH.21": [
    { code: "KH.21.8405988", name: "Srŏk Chŭm Kiri" },
    { code: "KH.21.8405989", name: "Srŏk Dângtóng" },
    { code: "KH.21.8405990", name: "Srok Tuek Chhou" },
    { code: "KH.21.8740325", name: "Mittakpheap District" },
    { code: "KH.21.9034950", name: "Kampong Bay" },
    { code: "KH.21.9034991", name: "Kampong Tranch" },
    { code: "KH.21.9034994", name: "Banteay Meas" },
    { code: "KH.21.9072881", name: "Angkor Chey" },
    { code: "KH.21.9072882", name: "Chhouk District" },
    { code: "KH.21.9253787", name: "Prey Nob" },
  ],
  "KH.22": [
    { code: "KH.22.7647210", name: "Phnom Penh" },
    { code: "KH.22.8405993", name: "Khan Russey Keo" },
    { code: "KH.22.8405994", name: "Khan Duŏn Pénh" },
    { code: "KH.22.8405995", name: "Khan Tuŏl Koŭk" },
    { code: "KH.22.8405996", name: "Khan 7 Makara" },
    { code: "KH.22.8405998", name: "Khan Châmkar Mon" },
    { code: "KH.22.8405999", name: "Khan Saen Sokh" },
    { code: "KH.22.8406000", name: "Khan Méan Chey" },
    { code: "KH.22.8406003", name: "Khan Chey Por Senchey" },
    { code: "KH.22.8406190", name: "Khan Dângkaô" },
  ],
  "KH.23": [
    { code: "KH.23.8405025", name: "Srŏk Ândong Méas" },
    { code: "KH.23.8405026", name: "Srŏk Ban Lŭng" },
    { code: "KH.23.8405027", name: "Srŏk Bâ Kêv" },
    { code: "KH.23.8405028", name: "Srŏk Koun Mom" },
    { code: "KH.23.8405029", name: "Srŏk Ou Chum" },
    { code: "KH.23.8405030", name: "Srŏk Ou Ya Dav" },
    { code: "KH.23.8405031", name: "Srŏk Ta Vêng" },
    { code: "KH.23.9253799", name: "Lumphat" },
    { code: "KH.23.9253800", name: "Veun Sai" },
  ],
  "KH.24": [
    { code: "KH.24.1822579", name: "Srŏk Puŏk" },
    { code: "KH.24.7647224", name: "Siem Reap" },
    { code: "KH.24.7873944", name: "Angkor Chum" },
    { code: "KH.24.7873945", name: "Varin" },
    { code: "KH.24.7873947", name: "Svay Leu" },
    { code: "KH.24.8403891", name: "Srŏk Prasat Bakong" },
    { code: "KH.24.8541392", name: "Srŏk Ângkôr Thum" },
    { code: "KH.24.9253786", name: "Chong Kal" },
    { code: "KH.24.9253801", name: "Banteay Srei" },
    { code: "KH.24.9253803", name: "Chi Kraeng" },
    { code: "KH.24.9253804", name: "Kralanh" },
    { code: "KH.24.9253806", name: "Soutr Nkom" },
    { code: "KH.24.9253807", name: "Srei Snam" },
  ],
  "KH.25": [
    { code: "KH.25.1821743", name: "Srŏk Thmâ Pôk" },
    { code: "KH.25.8403556", name: "Srŏk Svay Chék" },
    { code: "KH.25.8403557", name: "Srŏk Malai" },
    { code: "KH.25.8403850", name: "Srŏk Sâmpŏu Lun" },
    { code: "KH.25.8403852", name: "Srŏk Kâmriĕng" },
    { code: "KH.25.8403854", name: "Srŏk Koăs Krâlâ" },
    { code: "KH.25.8403855", name: "Srŏk Rukh Kiri" },
    { code: "KH.25.8403890", name: "Krŏng Paôy Pêt" },
    { code: "KH.25.8541391", name: "Srok Phnum Proek" },
    { code: "KH.25.8740317", name: "Ou Chrov District" },
    { code: "KH.25.8740323", name: "Serei Saophoan" },
    { code: "KH.25.9253711", name: "Mongkol Borei" },
    { code: "KH.25.9253715", name: "Phnom Srok" },
    { code: "KH.25.9253716", name: "Preah Netr Preah" },
    { code: "KH.25.9253732", name: "Thma Puok" },
  ],
  "KH.26": [
    { code: "KH.26.8405987", name: "Srŏk Dâmnăk Châng’aeur" },
  ],
  "KH.27": [
    { code: "KH.27.1822319", name: "Srŏk Sâmraông" },
    { code: "KH.27.1831825", name: "Srŏk Bântéay Âmpĭl" },
    { code: "KH.27.8403981", name: "Srŏk Ânlóng Vêng" },
    { code: "KH.27.8403982", name: "Srŏk Trâpeăng Prasat" },
  ],
  "KH.28": [
    { code: "KH.28.8405256", name: "Srok Stueng Hav" },
  ],
  "KH.29": [
    { code: "KH.29.7647212", name: "Svay Pao" },
    { code: "KH.29.7647213", name: "Sangkae" },
    { code: "KH.29.7647214", name: "Moung Ruessei" },
    { code: "KH.29.8403559", name: "Srŏk Thmâ Koŭl" },
    { code: "KH.29.8403576", name: "Srŏk Bâvĭl" },
    { code: "KH.29.8403582", name: "Srŏk Rotanak Mondol" },
    { code: "KH.29.8403643", name: "Srŏk Sâmlot" },
    { code: "KH.29.8541388", name: "Srŏk Banăn" },
    { code: "KH.29.8541389", name: "Srŏk Âk Phnŭm" },
  ],
  "KH.30": [
    { code: "KH.30.8403856", name: "Khan Sala Krau" },
    { code: "KH.30.8403884", name: "Khan Pailĭn" },
  ],
  "KH.31": [
    { code: "KH.31.1821789", name: "Srŏk Tbong Khmŭm" },
    { code: "KH.31.1830336", name: "Srŏk Mémót" },
    { code: "KH.31.1830473", name: "Srŏk Kroch Chhmar" },
    { code: "KH.31.8403886", name: "Srŏk Dâmbê" },
    { code: "KH.31.8403887", name: "Srŏk O Reăng Âu" },
    { code: "KH.31.8403888", name: "Srŏk Pônhê Krêk" },
    { code: "KH.31.8403889", name: "Krŏng Suŏng" },
  ],
  "KI.01": [
    { code: "KI.01.AG", name: "Abaiang" },
    { code: "KI.01.AK", name: "Aranuka" },
    { code: "KI.01.AM", name: "Abemama" },
    { code: "KI.01.AO", name: "Arorae" },
    { code: "KI.01.BA", name: "Banaba" },
    { code: "KI.01.BE", name: "Beru" },
    { code: "KI.01.BT", name: "Butaritari" },
    { code: "KI.01.KU", name: "Kuria" },
    { code: "KI.01.ME", name: "Marakei" },
    { code: "KI.01.MI", name: "Maiana" },
    { code: "KI.01.MN", name: "Makin" },
    { code: "KI.01.NI", name: "Nikunau" },
    { code: "KI.01.NO", name: "Nonouti" },
    { code: "KI.01.ON", name: "Onotoa" },
    { code: "KI.01.TM", name: "Tamana" },
    { code: "KI.01.TR", name: "Tabiteuea" },
    { code: "KI.01.TW", name: "Tarawa" },
  ],
  "KI.02": [
    { code: "KI.02.CA", name: "Caroline" },
    { code: "KI.02.FL", name: "Flint" },
    { code: "KI.02.KT", name: "Kiritimati" },
    { code: "KI.02.ML", name: "Malden" },
    { code: "KI.02.SB", name: "Starbuck" },
    { code: "KI.02.TE", name: "Teraina" },
    { code: "KI.02.TU", name: "Tabuaeran" },
    { code: "KI.02.VO", name: "Vostok" },
  ],
  "KI.03": [
    { code: "KI.03.BI", name: "Birnie" },
    { code: "KI.03.EN", name: "Enderbury" },
    { code: "KI.03.KA", name: "Kanton" },
    { code: "KI.03.MA", name: "Manra" },
    { code: "KI.03.MK", name: "McKean" },
    { code: "KI.03.NK", name: "Nikumaroro" },
    { code: "KI.03.OR", name: "Orona" },
    { code: "KI.03.RA", name: "Rawaki" },
  ],
  "KP.01": [
    { code: "KP.01.2039045", name: "Yongnim-gun" },
    { code: "KP.01.2039456", name: "Wiwŏn-gun" },
    { code: "KP.01.2039499", name: "Usi-gun" },
    { code: "KP.01.2039727", name: "Tongsin-gun" },
    { code: "KP.01.2040482", name: "Songwŏn-gun" },
    { code: "KP.01.2040630", name: "Sŏnggan-gun" },
    { code: "KP.01.2041138", name: "Sijung-gun" },
    { code: "KP.01.2042491", name: "Nangnim-gun" },
    { code: "KP.01.2042891", name: "Manp’o-si" },
    { code: "KP.01.2043336", name: "Kop’ung-gun" },
    { code: "KP.01.2043568", name: "Kanggye-si" },
    { code: "KP.01.2043879", name: "Hwap’yŏng-gun" },
    { code: "KP.01.2044013", name: "Hŭich’ŏn-si" },
    { code: "KP.01.2044491", name: "Chunggang-gun" },
    { code: "KP.01.2044602", name: "Ch’osan-gun" },
    { code: "KP.01.2044803", name: "Chŏnch’ŏn-gun" },
    { code: "KP.01.2045006", name: "Chasŏng-gun" },
    { code: "KP.01.2045178", name: "Changgang-gun" },
  ],
  "KP.03": [
    { code: "KP.03.1866638", name: "Yodŏk-kun" },
    { code: "KP.03.1873885", name: "Nagwŏn-gun" },
    { code: "KP.03.1875280", name: "Kŭmya-gun" },
    { code: "KP.03.1875589", name: "Kowŏn-gun" },
    { code: "KP.03.1877442", name: "Hamju-gun" },
    { code: "KP.03.1877447", name: "Hamhŭng-si" },
    { code: "KP.03.1878321", name: "Chongpyong County" },
    { code: "KP.03.2039115", name: "Yŏnggwang-gun" },
    { code: "KP.03.2039905", name: "Tŏksŏng-gun" },
    { code: "KP.03.2040063", name: "Tanch’ŏn-gun" },
    { code: "KP.03.2040953", name: "Sinp’o-si" },
    { code: "KP.03.2041012", name: "Sinhŭng-gun" },
    { code: "KP.03.2041812", name: "Pukch’ŏng-gun" },
    { code: "KP.03.2041826", name: "Pujŏn-gun" },
    { code: "KP.03.2043679", name: "Iwŏn-gun" },
    { code: "KP.03.2044051", name: "Hongwŏn-gun" },
    { code: "KP.03.2044126", name: "Hŏch’ŏn-gun" },
    { code: "KP.03.2045125", name: "Changjin-gun" },
    { code: "KP.03.6258675", name: "Sudong-gu" },
  ],
  "KP.06": [
    { code: "KP.06.1866571", name: "Yŏnan-gun" },
    { code: "KP.06.1867379", name: "Ŭnch’ŏn-gun" },
    { code: "KP.06.1867428", name: "Ŭllyul-gun" },
    { code: "KP.06.1868579", name: "T’aet’an-gun" },
    { code: "KP.06.1869582", name: "Songhwa-gun" },
    { code: "KP.06.1870278", name: "Sinwŏn-gun" },
    { code: "KP.06.1870659", name: "Sinch’ŏn-gun" },
    { code: "KP.06.1871541", name: "Samch’ŏn-gun" },
    { code: "KP.06.1871938", name: "Pongch’ŏn-gun" },
    { code: "KP.06.1871968", name: "Pyŏksŏng-gun" },
    { code: "KP.06.1873016", name: "Paech’ŏn-gun" },
    { code: "KP.06.1873174", name: "Ongjin-gun" },
    { code: "KP.06.1875061", name: "Kwail-gun" },
    { code: "KP.06.1876125", name: "Kangnyŏng-gun" },
    { code: "KP.06.1876370", name: "Kaesŏng-si" },
    { code: "KP.06.1876380", name: "Kaep’ung-gun" },
    { code: "KP.06.1877609", name: "Haeju-si" },
    { code: "KP.06.1878459", name: "Ch’ŏngdan-gun" },
    { code: "KP.06.1879031", name: "Changyŏn-gun" },
    { code: "KP.06.1879105", name: "Changp’ung-gun" },
    { code: "KP.06.1879491", name: "Chaeryŏng-gun" },
    { code: "KP.06.1879681", name: "Anak-kun" },
    { code: "KP.06.8594115", name: "Yongyŏn-gun" },
  ],
  "KP.07": [
    { code: "KP.07.1865966", name: "Yŏnt’an-gun" },
    { code: "KP.07.1865975", name: "Yŏnsan-gun" },
    { code: "KP.07.1867256", name: "Ŭnp’a-gun" },
    { code: "KP.07.1867627", name: "T’osan-gun" },
    { code: "KP.07.1869140", name: "Suan-gun" },
    { code: "KP.07.1869433", name: "Songnim-si" },
    { code: "KP.07.1870041", name: "Sŏhŭng-gun" },
    { code: "KP.07.1870370", name: "Sinp’yŏng-gun" },
    { code: "KP.07.1870544", name: "Sin’gye-gun" },
    { code: "KP.07.1870881", name: "Sariwŏn-si" },
    { code: "KP.07.1871875", name: "P’yŏngsan-gun" },
    { code: "KP.07.1872337", name: "Pongsan-gun" },
    { code: "KP.07.1872688", name: "P’anmun-gun" },
    { code: "KP.07.1875414", name: "Kŭmch’ŏn-gun" },
    { code: "KP.07.1875793", name: "Koksan-gun" },
    { code: "KP.07.1876510", name: "Insan-gun" },
    { code: "KP.07.1876874", name: "Hwangju-gun" },
  ],
  "KP.09": [
    { code: "KP.09.1866905", name: "Wŏnsan-si" },
    { code: "KP.09.1867930", name: "T’ongch’ŏn-gun" },
    { code: "KP.09.1870827", name: "Sep’o-gun" },
    { code: "KP.09.1871928", name: "P’yŏnggang-gun" },
    { code: "KP.09.1872294", name: "Pŏptong-gun" },
    { code: "KP.09.1872704", name: "P’an’gyo-gun" },
    { code: "KP.09.1874228", name: "Munch’ŏn-si" },
    { code: "KP.09.1875385", name: "Kŭmgang-gun" },
    { code: "KP.09.1875619", name: "Kosŏng-gun" },
    { code: "KP.09.1875637", name: "Kosan-gun" },
    { code: "KP.09.1875980", name: "Kimhwa-gun" },
    { code: "KP.09.1876674", name: "Ich’ŏn-gun" },
    { code: "KP.09.1877150", name: "Hoeyang-gun" },
    { code: "KP.09.1878166", name: "Ch’ŏrwŏn-gun" },
    { code: "KP.09.1878230", name: "Ch’ŏnnae-gun" },
    { code: "KP.09.1879312", name: "Ch’angdo-gun" },
    { code: "KP.09.1879673", name: "Anbyŏn-gun" },
  ],
  "KP.11": [
    { code: "KP.11.1865779", name: "Yongch’ŏn-gun" },
    { code: "KP.11.1866454", name: "Nyŏngbyŏn-gun" },
    { code: "KP.11.1866590", name: "Yŏmju-gun" },
    { code: "KP.11.1867275", name: "Unjŏn-gun" },
    { code: "KP.11.1867778", name: "Tongnim-gun" },
    { code: "KP.11.1868849", name: "T’aech’ŏn-gun" },
    { code: "KP.11.1869746", name: "Sŏnch’ŏn-gun" },
    { code: "KP.11.1872626", name: "P’ihyŏn-gun" },
    { code: "KP.11.1872819", name: "Pakch’ŏn-gun" },
    { code: "KP.11.1875055", name: "Kwaksan-gun" },
    { code: "KP.11.1875101", name: "Kusŏng-si" },
    { code: "KP.11.1875509", name: "Kujang-gun" },
    { code: "KP.11.1876770", name: "Hyangsan-gun" },
    { code: "KP.11.1878391", name: "Chŏngju-gun" },
    { code: "KP.11.1878581", name: "Ch’ŏlsan-gun" },
    { code: "KP.11.2039522", name: "Unsan-gun" },
    { code: "KP.11.2039624", name: "Uiju County" },
    { code: "KP.11.2039860", name: "Tongch’ang-gun" },
    { code: "KP.11.2040192", name: "Taegwan-gun" },
    { code: "KP.11.2040892", name: "Sinŭiju-si" },
    { code: "KP.11.2041535", name: "Sakchu-gun" },
    { code: "KP.11.2041678", name: "Pyŏktong-gun" },
    { code: "KP.11.2044670", name: "Ch’ŏnma-gun" },
    { code: "KP.11.2045038", name: "Ch’angsŏng-gun" },
    { code: "KP.11.6279118", name: "Sindo-gun" },
  ],
  "KP.12": [
    { code: "KP.12.11791938", name: "Ŭnjŏng-guyŏk" },
    { code: "KP.12.1866090", name: "Ryongsŏng-guyŏk" },
    { code: "KP.12.1866614", name: "Ryŏkp’o-guyŏk" },
    { code: "KP.12.1867918", name: "Tongdaewŏn-guyŏk" },
    { code: "KP.12.1868593", name: "Taesŏng-guyŏk" },
    { code: "KP.12.1868813", name: "Taedonggang" },
    { code: "KP.12.1868997", name: "Sŭngho-guyŏk" },
    { code: "KP.12.1869019", name: "Sunan" },
    { code: "KP.12.1869227", name: "Sŏsŏng-guyŏk" },
    { code: "KP.12.1869345", name: "Sŏn’gyo-guyŏk" },
    { code: "KP.12.1870984", name: "Sangwŏn-gun" },
    { code: "KP.12.1871416", name: "Samsŏk-kuyŏk" },
    { code: "KP.12.1871810", name: "Sadong-guyŏk" },
    { code: "KP.12.1871937", name: "P’yŏngch’ŏn-guyŏk" },
    { code: "KP.12.1872260", name: "Pot’onggang-guyŏk" },
    { code: "KP.12.1873641", name: "Rangnang" },
    { code: "KP.12.1874339", name: "Moranbong" },
    { code: "KP.12.1874534", name: "Man’gyŏngdae" },
    { code: "KP.12.1876132", name: "Kangnam-gun" },
    { code: "KP.12.1876156", name: "Kangdong-gun" },
    { code: "KP.12.1876737", name: "Hyŏngjesan-guyŏk" },
    { code: "KP.12.1877859", name: "Chung" },
    { code: "KP.12.1877875", name: "Chunghwa-gun" },
  ],
  "KP.13": [
    { code: "KP.13.2039548", name: "Unhŭng-gun" },
    { code: "KP.13.2040183", name: "Taehongdan-gun" },
    { code: "KP.13.2041411", name: "Samsu-gun" },
    { code: "KP.13.2041443", name: "Samjiyŏn-gun" },
    { code: "KP.13.2041726", name: "P’ungsŏ-gun" },
    { code: "KP.13.2041732", name: "Kimhyŏnggwŏn-gun" },
    { code: "KP.13.2041997", name: "Poch’ŏn-gun" },
    { code: "KP.13.2042211", name: "Paegam-gun" },
    { code: "KP.13.2043475", name: "Kimjŏngsuk-kun" },
    { code: "KP.13.2043532", name: "Kapsan-gun" },
    { code: "KP.13.2043834", name: "Hyesan-si" },
    { code: "KP.13.2044027", name: "Kimhyŏngjik-kun" },
  ],
  "KP.15": [
    { code: "KP.15.1865781", name: "Tŏkch’ŏn-si" },
    { code: "KP.15.1865786", name: "Kangsŏ-guyŏk" },
    { code: "KP.15.1866047", name: "Nyŏngwŏn-gun" },
    { code: "KP.15.1866367", name: "Yonggang-gun" },
    { code: "KP.15.1866790", name: "Yangdŏk-kun" },
    { code: "KP.15.1868812", name: "Taedong-gun" },
    { code: "KP.15.1869013", name: "Sunch’ŏn-si" },
    { code: "KP.15.1869039", name: "Sukch’ŏn-gun" },
    { code: "KP.15.1869676", name: "Sŏngch’ŏn-gun" },
    { code: "KP.15.1870271", name: "Sinyang-gun" },
    { code: "KP.15.1871865", name: "P’yŏngwŏn-gun" },
    { code: "KP.15.1871869", name: "P’yŏngsŏng-si" },
    { code: "KP.15.1872201", name: "Pukch’ang-gun" },
    { code: "KP.15.1873193", name: "Onch’ŏn-gun" },
    { code: "KP.15.1874222", name: "Mundŏk-kun" },
    { code: "KP.15.1874668", name: "Maengsan-gun" },
    { code: "KP.15.1876403", name: "Kaech’ŏn-si" },
    { code: "KP.15.1877192", name: "Hoech’ang-gun" },
    { code: "KP.15.1877796", name: "Chŭngsan-gun" },
    { code: "KP.15.1878380", name: "Ch’ŏngnam-gu" },
    { code: "KP.15.1879614", name: "Anju-si" },
    { code: "KP.15.1883585", name: "Hanggu-guyŏk" },
    { code: "KP.15.1883586", name: "Waudo-guyŏk" },
    { code: "KP.15.2040178", name: "Taehŭng-gun" },
    { code: "KP.15.6258672", name: "Ŭnsan-gun" },
    { code: "KP.15.6258673", name: "Ch’ŏllima-guyŏk" },
    { code: "KP.15.6258674", name: "Taean-guyŏk" },
  ],
  "KP.17": [
    { code: "KP.17.2038910", name: "Yŏnsa-gun" },
    { code: "KP.17.2039588", name: "Kyŏnghŭng" },
    { code: "KP.17.2041593", name: "Kyŏngwŏn" },
    { code: "KP.17.2041700", name: "Puryŏng-gun" },
    { code: "KP.17.2042256", name: "Ŏrang-gun" },
    { code: "KP.17.2042268", name: "Onsŏng-gun" },
    { code: "KP.17.2042710", name: "Hwasŏng-gun" },
    { code: "KP.17.2042719", name: "Myŏngch’ŏn-gun" },
    { code: "KP.17.2042740", name: "Musan-gun" },
    { code: "KP.17.2042989", name: "Kyŏngsŏng-gun" },
    { code: "KP.17.2043476", name: "Kimch’aek-si" },
    { code: "KP.17.2043486", name: "Kilchu-gun" },
    { code: "KP.17.2043963", name: "Hwadae-gun" },
    { code: "KP.17.2044094", name: "Hoeryŏng" },
    { code: "KP.17.2044754", name: "Ch’ŏngjin-si" },
  ],
  "KP.18": [
    { code: "KP.18.2040675", name: "Sŏnbong-gun" },
    { code: "KP.18.2042641", name: "Rajin" },
  ],
  "KR.01": [
    { code: "KR.01.39010", name: "Jeju-si" },
    { code: "KR.01.39020", name: "Seogwipo-si" },
  ],
  "KR.03": [
    { code: "KR.03.35010", name: "Jeonju-si" },
    { code: "KR.03.35020", name: "Gunsan-si" },
    { code: "KR.03.35030", name: "Iksan-si" },
    { code: "KR.03.35040", name: "Jeongeup-si" },
    { code: "KR.03.35050", name: "Namwon" },
    { code: "KR.03.35060", name: "Gimje-si" },
    { code: "KR.03.35310", name: "Wanju-gun" },
    { code: "KR.03.35320", name: "Jinan-gun" },
    { code: "KR.03.35330", name: "Muju-gun" },
    { code: "KR.03.35340", name: "Jangsu-gun" },
    { code: "KR.03.35350", name: "Imsil-gun" },
    { code: "KR.03.35360", name: "Sunchang-gun" },
    { code: "KR.03.35370", name: "Gochang-gun" },
    { code: "KR.03.35380", name: "Buan-gun" },
  ],
  "KR.05": [
    { code: "KR.05.33010", name: "Cheongju-si" },
    { code: "KR.05.33020", name: "Chungju-si" },
    { code: "KR.05.33030", name: "Jecheon-si" },
    { code: "KR.05.33320", name: "Boeun-gun" },
    { code: "KR.05.33330", name: "Okcheon-gun" },
    { code: "KR.05.33340", name: "Yeongdong-gun" },
    { code: "KR.05.33350", name: "Jincheon-gun" },
    { code: "KR.05.33360", name: "Goesan-gun" },
    { code: "KR.05.33370", name: "Eumseong-gun" },
    { code: "KR.05.33380", name: "Danyang-gun" },
    { code: "KR.05.33390", name: "Jeungpyeong-gun" },
  ],
  "KR.06": [
    { code: "KR.06.32010", name: "Chuncheon-si" },
    { code: "KR.06.32020", name: "Wonju-si" },
    { code: "KR.06.32030", name: "Gangneung-si" },
    { code: "KR.06.32040", name: "Donghae-si" },
    { code: "KR.06.32050", name: "Taebaek-si" },
    { code: "KR.06.32060", name: "Sokcho-si" },
    { code: "KR.06.32070", name: "Samcheok-si" },
    { code: "KR.06.32310", name: "Hongcheon-gun" },
    { code: "KR.06.32320", name: "Hoengseong-gun" },
    { code: "KR.06.32330", name: "Yeongwol-gun" },
    { code: "KR.06.32340", name: "Pyeongchang-gun" },
    { code: "KR.06.32350", name: "Jeongseon-gun" },
    { code: "KR.06.32360", name: "Cheorwon-gun" },
    { code: "KR.06.32370", name: "Hwacheon-gun" },
    { code: "KR.06.32380", name: "Yanggu-gun" },
    { code: "KR.06.32390", name: "Inje-gun" },
    { code: "KR.06.32400", name: "Goseong-gun" },
    { code: "KR.06.32410", name: "Yangyang-gun" },
  ],
  "KR.10": [
    { code: "KR.10.21010", name: "Jung-gu" },
    { code: "KR.10.21020", name: "Seo-gu" },
    { code: "KR.10.21030", name: "Dong-gu" },
    { code: "KR.10.21040", name: "Yeongdo-gu" },
    { code: "KR.10.21050", name: "Busanjin-gu" },
    { code: "KR.10.21060", name: "Dongnae-gu" },
    { code: "KR.10.21070", name: "Nam-gu" },
    { code: "KR.10.21080", name: "Buk-gu" },
    { code: "KR.10.21090", name: "Haeundae-gu" },
    { code: "KR.10.21100", name: "Saha-gu" },
    { code: "KR.10.21110", name: "Geumjeong-gu" },
    { code: "KR.10.21120", name: "Gangseo-gu" },
    { code: "KR.10.21130", name: "Yeonje-gu" },
    { code: "KR.10.21140", name: "Suyeong-gu" },
    { code: "KR.10.21150", name: "Sasang-gu" },
    { code: "KR.10.21310", name: "Gijang-gun" },
  ],
  "KR.11": [
    { code: "KR.11.11010", name: "Jongno-gu" },
    { code: "KR.11.11020", name: "Jung-gu" },
    { code: "KR.11.11030", name: "Yongsan-gu" },
    { code: "KR.11.11040", name: "Seongdong-gu" },
    { code: "KR.11.11050", name: "Gwangjin-gu" },
    { code: "KR.11.11060", name: "Dongdaemun-gu" },
    { code: "KR.11.11070", name: "Jungnang-gu" },
    { code: "KR.11.11080", name: "Seongbuk-gu" },
    { code: "KR.11.11090", name: "Gangbuk-gu" },
    { code: "KR.11.11100", name: "Dobong-gu" },
    { code: "KR.11.11110", name: "Nowon-gu" },
    { code: "KR.11.11120", name: "Eunpyeong-gu" },
    { code: "KR.11.11130", name: "Seodaemun-gu" },
    { code: "KR.11.11140", name: "Mapo-gu" },
    { code: "KR.11.11150", name: "Yangcheon-gu" },
    { code: "KR.11.11160", name: "Gangseo-gu" },
    { code: "KR.11.11170", name: "Guro-gu" },
    { code: "KR.11.11180", name: "Geumcheon-gu" },
    { code: "KR.11.11190", name: "Yeongdeungpo-gu" },
    { code: "KR.11.11200", name: "Dongjak-gu" },
    { code: "KR.11.11210", name: "Gwanak-gu" },
    { code: "KR.11.11220", name: "Seocho-gu" },
    { code: "KR.11.11230", name: "Gangnam-gu" },
    { code: "KR.11.11240", name: "Songpa-gu" },
    { code: "KR.11.11250", name: "Gangdong-gu" },
  ],
  "KR.12": [
    { code: "KR.12.23010", name: "Jung-gu" },
    { code: "KR.12.23020", name: "Dong-gu" },
    { code: "KR.12.23030", name: "Michuhol" },
    { code: "KR.12.23040", name: "Yeonsu-gu" },
    { code: "KR.12.23050", name: "Namdong-gu" },
    { code: "KR.12.23060", name: "Bupyeong-gu" },
    { code: "KR.12.23070", name: "Gyeyang-gu" },
    { code: "KR.12.23080", name: "Seo-gu" },
    { code: "KR.12.23310", name: "Ganghwa-gun" },
    { code: "KR.12.23320", name: "Ongjin-gun" },
  ],
  "KR.13": [
    { code: "KR.13.31010", name: "Suwon-si" },
    { code: "KR.13.31020", name: "Seongnam-si" },
    { code: "KR.13.31030", name: "Uijeongbu-si" },
    { code: "KR.13.31040", name: "Anyang-si" },
    { code: "KR.13.31050", name: "Bucheon-si" },
    { code: "KR.13.31060", name: "Gwangmyeong-si" },
    { code: "KR.13.31070", name: "Pyeongtaek" },
    { code: "KR.13.31080", name: "Dongducheon" },
    { code: "KR.13.31090", name: "Ansan-si" },
    { code: "KR.13.31100", name: "Goyang-si" },
    { code: "KR.13.31110", name: "Gwacheon-si" },
    { code: "KR.13.31120", name: "Guri-si" },
    { code: "KR.13.31130", name: "Namyangju-si" },
    { code: "KR.13.31140", name: "Osan-si" },
    { code: "KR.13.31150", name: "Siheung" },
    { code: "KR.13.31160", name: "Gunpo-si" },
    { code: "KR.13.31170", name: "Uiwang-si" },
    { code: "KR.13.31180", name: "Hanam-si" },
    { code: "KR.13.31190", name: "Yongin-si" },
    { code: "KR.13.31200", name: "Paju-si" },
    { code: "KR.13.31210", name: "Icheon-si" },
    { code: "KR.13.31220", name: "Anseong" },
    { code: "KR.13.31230", name: "Gimpo-si" },
    { code: "KR.13.31240", name: "Hwaseong-si" },
    { code: "KR.13.31250", name: "Gwangju-si" },
    { code: "KR.13.31260", name: "Yangju-si" },
    { code: "KR.13.31270", name: "Pocheon-si" },
    { code: "KR.13.31280", name: "Yeoju-si" },
    { code: "KR.13.31350", name: "Yeoncheon-gun" },
    { code: "KR.13.31370", name: "Gapyeong-gun" },
    { code: "KR.13.31380", name: "Yangpyeong-gun" },
  ],
  "KR.14": [
    { code: "KR.14.37010", name: "Pohang-si" },
    { code: "KR.14.37020", name: "Gyeongju" },
    { code: "KR.14.37030", name: "Gimcheon-si" },
    { code: "KR.14.37040", name: "Andong-si" },
    { code: "KR.14.37050", name: "Gumi-si" },
    { code: "KR.14.37060", name: "Yeongju-si" },
    { code: "KR.14.37070", name: "Yeongcheon-si" },
    { code: "KR.14.37080", name: "Sangju-si" },
    { code: "KR.14.37090", name: "Mungyeong-si" },
    { code: "KR.14.37100", name: "Gyeongsan-si" },
    { code: "KR.14.37310", name: "Gunwi-gun" },
    { code: "KR.14.37320", name: "Uiseong-gun" },
    { code: "KR.14.37330", name: "Cheongsong-gun" },
    { code: "KR.14.37340", name: "Yeongyang-gun" },
    { code: "KR.14.37350", name: "Yeongdeok-gun" },
    { code: "KR.14.37360", name: "Cheongdo-gun" },
    { code: "KR.14.37370", name: "Goryeong-gun" },
    { code: "KR.14.37380", name: "Seongju-gun" },
    { code: "KR.14.37390", name: "Chilgok-gun" },
    { code: "KR.14.37400", name: "Yecheon-gun" },
    { code: "KR.14.37410", name: "Bonghwa-gun" },
    { code: "KR.14.37420", name: "Uljin-gun" },
    { code: "KR.14.37430", name: "Ulleung-gun" },
  ],
  "KR.15": [
    { code: "KR.15.22010", name: "Jung-gu" },
    { code: "KR.15.22020", name: "Dong-gu" },
    { code: "KR.15.22030", name: "Seo-gu" },
    { code: "KR.15.22040", name: "Nam-gu" },
    { code: "KR.15.22050", name: "Buk-gu" },
    { code: "KR.15.22060", name: "Suseong-gu" },
    { code: "KR.15.22070", name: "Dalseo-gu" },
    { code: "KR.15.22310", name: "Dalseong-gun" },
  ],
  "KR.16": [
    { code: "KR.16.36010", name: "Mokpo-si" },
    { code: "KR.16.36020", name: "Yeosu-si" },
    { code: "KR.16.36030", name: "Suncheon-si" },
    { code: "KR.16.36040", name: "Naju-si" },
    { code: "KR.16.36060", name: "Gwangyang-si" },
    { code: "KR.16.36310", name: "Damyang-gun" },
    { code: "KR.16.36320", name: "Gokseong-gun" },
    { code: "KR.16.36330", name: "Gurye-gun" },
    { code: "KR.16.36350", name: "Goheung-gun" },
    { code: "KR.16.36360", name: "Boseong-gun" },
    { code: "KR.16.36370", name: "Hwasun-gun" },
    { code: "KR.16.36380", name: "Jangheung-gun" },
    { code: "KR.16.36390", name: "Gangjin-gun" },
    { code: "KR.16.36400", name: "Haenam-gun" },
    { code: "KR.16.36410", name: "Yeongam-gun" },
    { code: "KR.16.36420", name: "Muan-gun" },
    { code: "KR.16.36430", name: "Hampyeong-gun" },
    { code: "KR.16.36440", name: "Yeonggwang-gun" },
    { code: "KR.16.36450", name: "Jangseong-gun" },
    { code: "KR.16.36460", name: "Wando-gun" },
    { code: "KR.16.36470", name: "Jindo-gun" },
    { code: "KR.16.36480", name: "Sinan-gun" },
  ],
  "KR.17": [
    { code: "KR.17.34010", name: "Cheonan-si" },
    { code: "KR.17.34020", name: "Gongju-si" },
    { code: "KR.17.34030", name: "Boryeong-si" },
    { code: "KR.17.34040", name: "Asan-si" },
    { code: "KR.17.34050", name: "Seosan-si" },
    { code: "KR.17.34060", name: "Nonsan-si" },
    { code: "KR.17.34070", name: "Gyeryong-si" },
    { code: "KR.17.34080", name: "Dangjin-si" },
    { code: "KR.17.34310", name: "Geumsan-gun" },
    { code: "KR.17.34330", name: "Buyeo-gun" },
    { code: "KR.17.34340", name: "Seocheon-gun" },
    { code: "KR.17.34350", name: "Cheongyang-gun" },
    { code: "KR.17.34360", name: "Hongseong-gun" },
    { code: "KR.17.34370", name: "Yesan-gun" },
    { code: "KR.17.34380", name: "Taean-gun" },
  ],
  "KR.18": [
    { code: "KR.18.24010", name: "Dong-gu" },
    { code: "KR.18.24020", name: "Seo-gu" },
    { code: "KR.18.24030", name: "Nam-gu" },
    { code: "KR.18.24040", name: "Buk-gu" },
    { code: "KR.18.24050", name: "Gwangsan-gu" },
  ],
  "KR.19": [
    { code: "KR.19.25010", name: "Dong-gu" },
    { code: "KR.19.25020", name: "Jung-gu" },
    { code: "KR.19.25030", name: "Seo-gu" },
    { code: "KR.19.25040", name: "Yuseong-gu" },
    { code: "KR.19.25050", name: "Daedeok-gu" },
  ],
  "KR.20": [
    { code: "KR.20.38030", name: "Jinju-si" },
    { code: "KR.20.38050", name: "Tongyeong-si" },
    { code: "KR.20.38060", name: "Sacheon-si" },
    { code: "KR.20.38070", name: "Gimhae-si" },
    { code: "KR.20.38080", name: "Miryang-si" },
    { code: "KR.20.38090", name: "Geoje-si" },
    { code: "KR.20.38100", name: "Yangsan-si" },
    { code: "KR.20.38110", name: "Changwon-si" },
    { code: "KR.20.38310", name: "Uiryeong-gun" },
    { code: "KR.20.38320", name: "Haman-gun" },
    { code: "KR.20.38330", name: "Changnyeong-gun" },
    { code: "KR.20.38340", name: "Goseong-gun" },
    { code: "KR.20.38350", name: "Namhae-gun" },
    { code: "KR.20.38360", name: "Hadong-gun" },
    { code: "KR.20.38370", name: "Sancheong-gun" },
    { code: "KR.20.38380", name: "Hamyang-gun" },
    { code: "KR.20.38390", name: "Geochang-gun" },
    { code: "KR.20.38400", name: "Hapcheon-gun" },
  ],
  "KR.21": [
    { code: "KR.21.26010", name: "Jung-gu" },
    { code: "KR.21.26020", name: "Nam-gu" },
    { code: "KR.21.26030", name: "Dong-gu" },
    { code: "KR.21.26040", name: "Buk-gu" },
    { code: "KR.21.26310", name: "Ulju-gun" },
  ],
  "KR.22": [
    { code: "KR.22.29010", name: "Sejong-Si" },
  ],
  "KZ.01": [
    { code: "KZ.01.11184241", name: "Zhambyl District" },
    { code: "KZ.01.11886905", name: "Karasay" },
    { code: "KZ.01.1517577", name: "Üyghyr Aūdany" },
    { code: "KZ.01.1518519", name: "Talghar Aūdany" },
    { code: "KZ.01.1518545", name: "Taldyqorghan Aūdany" },
    { code: "KZ.01.1519704", name: "Sarqan Aūdany" },
    { code: "KZ.01.1520251", name: "Panfīlov Aūdany" },
    { code: "KZ.01.1520746", name: "Rayymbek Aūdany" },
    { code: "KZ.01.1521711", name: "Kürti Aūdany" },
    { code: "KZ.01.1522636", name: "Köksū Aūdany" },
    { code: "KZ.01.1522739", name: "Kerbulaq Aūdany" },
    { code: "KZ.01.1522816", name: "Kegen Aūdany" },
    { code: "KZ.01.1522943", name: "Qaskeleng Aūdany" },
    { code: "KZ.01.1523101", name: "Qaratal Aūdany" },
    { code: "KZ.01.1523500", name: "Qapal Aūdany" },
    { code: "KZ.01.1524128", name: "Ile Aūdany" },
    { code: "KZ.01.1524156", name: "Gvardīya Aūdany" },
    { code: "KZ.01.1524315", name: "Engbekshiqazaq Aūdany" },
    { code: "KZ.01.1524438", name: "Zhambyl Aūdany" },
    { code: "KZ.01.1524792", name: "Shelek Aūdany" },
    { code: "KZ.01.1524969", name: "Börilitöbe Aūdany" },
    { code: "KZ.01.1525804", name: "Balqash Aūdany" },
    { code: "KZ.01.1526298", name: "Üygentas Aūdany" },
    { code: "KZ.01.1526489", name: "Alakol District" },
    { code: "KZ.01.1526631", name: "Aqsū Aūdany" },
    { code: "KZ.01.1537281", name: "Kapshagay city" },
    { code: "KZ.01.1537282", name: "Talghar Qalasy" },
    { code: "KZ.01.1537283", name: "Taldyqorghan Qalasy" },
    { code: "KZ.01.1537284", name: "Tekeli Qalasy" },
  ],
  "KZ.02": [
    { code: "KZ.02.1526020", name: "Auezovskiy Rayon" },
  ],
  "KZ.03": [
    { code: "KZ.03.1516873", name: "Zhangadala Aūdany" },
    { code: "KZ.03.1517012", name: "Zhaksy" },
    { code: "KZ.03.1517044", name: "Zerendi" },
    { code: "KZ.03.1517166", name: "Esil" },
    { code: "KZ.03.1517189", name: "Ereymentau" },
    { code: "KZ.03.1517439", name: "Arshaly" },
    { code: "KZ.03.1518002", name: "Tselinograd" },
    { code: "KZ.03.1519052", name: "Shortandy" },
    { code: "KZ.03.1519241", name: "Burabay" },
    { code: "KZ.03.1519433", name: "Sileti Aūdany" },
    { code: "KZ.03.1521227", name: "Bulandy" },
    { code: "KZ.03.1521748", name: "Korgalzhyn" },
    { code: "KZ.03.1521995", name: "Egindikol" },
    { code: "KZ.03.1522599", name: "Qīma Aūdany" },
    { code: "KZ.03.1524313", name: "Birzhan sal" },
    { code: "KZ.03.1524603", name: "Zharkain" },
    { code: "KZ.03.1525806", name: "Sandyktau" },
    { code: "KZ.03.1526033", name: "Atbasar" },
    { code: "KZ.03.1526056", name: "Astrakhan" },
    { code: "KZ.03.1526436", name: "Akkol" },
    { code: "KZ.03.1537265", name: "Stepnogorsk Qalasy" },
  ],
  "KZ.04": [
    { code: "KZ.04.1522334", name: "Bögetköl Aūdany" },
    { code: "KZ.04.1523423", name: "Äyteke Bī Aūdany" },
    { code: "KZ.04.1523782", name: "Yrghyz Aūdany" },
    { code: "KZ.04.607866", name: "Oyyl Aūdany" },
    { code: "KZ.04.608031", name: "Temir Aūdany" },
    { code: "KZ.04.608677", name: "Oktyabr’sk Aūdany" },
    { code: "KZ.04.608707", name: "Khromtaū Aūdany" },
    { code: "KZ.04.608796", name: "Mughalzhar Aūdany" },
    { code: "KZ.04.608866", name: "Mortyq Aūdany" },
    { code: "KZ.04.608948", name: "Leninskiy Rayon" },
    { code: "KZ.04.609408", name: "Qobda Aūdany" },
    { code: "KZ.04.609786", name: "Īsatay Aūdany" },
    { code: "KZ.04.610114", name: "Shalqar Aūdany" },
    { code: "KZ.04.610385", name: "Bayghanīn Aūdany" },
    { code: "KZ.04.610656", name: "Algha Aūdany" },
    { code: "KZ.04.610687", name: "Aqtöbe Aūdany" },
    { code: "KZ.04.828331", name: "Aqtöbe Qalasy" },
  ],
  "KZ.06": [
    { code: "KZ.06.11886716", name: "Zhylyoi" },
    { code: "KZ.06.11886717", name: "Kyzylkoga" },
    { code: "KZ.06.608723", name: "Īsatay Aūdany" },
    { code: "KZ.06.608914", name: "Makhambet Aūdany" },
    { code: "KZ.06.608919", name: "Maqat Aūdany" },
    { code: "KZ.06.608966", name: "Qyzylqogha Aūdany" },
    { code: "KZ.06.609795", name: "Īnder Aūdany" },
    { code: "KZ.06.609923", name: "Zhylyoy Aūdany" },
    { code: "KZ.06.610044", name: "Kurmanghazy Aūdany" },
    { code: "KZ.06.610444", name: "Balyqshy Aūdany" },
    { code: "KZ.06.828321", name: "Atyraū Qalasy" },
  ],
  "KZ.07": [
    { code: "KZ.07.607687", name: "Zelenoe Aūdany" },
    { code: "KZ.07.607842", name: "Orda Aūdany" },
    { code: "KZ.07.608022", name: "Terekti Aūdany" },
    { code: "KZ.07.608048", name: "Taypaq Aūdany" },
    { code: "KZ.07.608573", name: "Prīūral’e Aūdany" },
    { code: "KZ.07.609453", name: "Kaztalovka Aūdany" },
    { code: "KZ.07.609541", name: "Qaratöbe Aūdany" },
    { code: "KZ.07.609717", name: "Tasqala Aūdany" },
    { code: "KZ.07.609902", name: "Zhalpaqtal Aūdany" },
    { code: "KZ.07.609952", name: "Zhänibek Aūdany" },
    { code: "KZ.07.609964", name: "Zhangaqala Aūdany" },
    { code: "KZ.07.609978", name: "Syrym Aūdany" },
    { code: "KZ.07.610089", name: "Shyngghyrlaū Aūdany" },
    { code: "KZ.07.610130", name: "Chapaev Aūdany" },
    { code: "KZ.07.610162", name: "Börili Aūdany" },
    { code: "KZ.07.610685", name: "Aqzhayyq Aūdany" },
    { code: "KZ.07.828320", name: "Oral Qalasy" },
  ],
  "KZ.09": [
    { code: "KZ.09.11886715", name: "Munaily" },
    { code: "KZ.09.607726", name: "Qaraqīya Aūdany" },
    { code: "KZ.09.608878", name: "Mangghystaū Aūdany" },
    { code: "KZ.09.610297", name: "Beyneū Aūdany" },
    { code: "KZ.09.828323", name: "Tupqaraghan Aūdany" },
    { code: "KZ.09.828324", name: "Aqtaū Qalasy" },
    { code: "KZ.09.828325", name: "Zhangaözen Qalasy" },
  ],
  "KZ.10": [
    { code: "KZ.10.1517878", name: "Tülkibas Aūdany" },
    { code: "KZ.10.1517946", name: "Türkistan Aūdany" },
    { code: "KZ.10.1518678", name: "Sozaq Aūdany" },
    { code: "KZ.10.1519452", name: "Sayram Aūdany" },
    { code: "KZ.10.1519675", name: "Saryaghash Aūdany" },
    { code: "KZ.10.1520258", name: "Maqtaaral Aūdany" },
    { code: "KZ.10.1521354", name: "Qazyqurt Aūdany" },
    { code: "KZ.10.1521378", name: "Töle Bī Aūdany" },
    { code: "KZ.10.1521407", name: "Otyrar Aūdany" },
    { code: "KZ.10.1522640", name: "Kīrov Aūdany" },
    { code: "KZ.10.1522812", name: "Keles Aūdany" },
    { code: "KZ.10.1524384", name: "Zhetisay Aūdany" },
    { code: "KZ.10.1524885", name: "Shardara Aūdany" },
    { code: "KZ.10.1525042", name: "Ordabasy Aūdany" },
    { code: "KZ.10.1526412", name: "Alghabas Aūdany" },
    { code: "KZ.10.1537271", name: "Arys Aūdany" },
    { code: "KZ.10.1537273", name: "Arys Qalasy" },
    { code: "KZ.10.1537274", name: "Kentaū Qalasy" },
    { code: "KZ.10.1537276", name: "Türkistan Qalasy" },
    { code: "KZ.10.8739752", name: "Kazygurt District" },
  ],
  "KZ.11": [
    { code: "KZ.11.1516632", name: "Zhelezīn Aūdany" },
    { code: "KZ.11.1517194", name: "Aqsū Aūdany" },
    { code: "KZ.11.1517619", name: "Ūspenka Aūdany" },
    { code: "KZ.11.1517745", name: "Ūl’yanov Aūdany" },
    { code: "KZ.11.1519247", name: "Sharbaqty Aūdany" },
    { code: "KZ.11.1520238", name: "Pavlodar Aūdany" },
    { code: "KZ.11.1521012", name: "May Aūdany" },
    { code: "KZ.11.1521382", name: "Lebyazh’e Aūdany" },
    { code: "KZ.11.1522019", name: "Aqtoghay Aūdany" },
    { code: "KZ.11.1523663", name: "Qashyr Aūdany" },
    { code: "KZ.11.1523767", name: "Ertis Aūdany" },
    { code: "KZ.11.1524322", name: "Ekibastuz Aūdany" },
    { code: "KZ.11.1525651", name: "Bayanaūyl Aūdany" },
    { code: "KZ.11.1537290", name: "Pavlodar Qalasy" },
    { code: "KZ.11.1537291", name: "Gorod Aksu" },
    { code: "KZ.11.1537292", name: "Ekibastuz Qalasy" },
  ],
  "KZ.12": [
    { code: "KZ.12.1516894", name: "Zhangaarqa Aūdany" },
    { code: "KZ.12.1517288", name: "Qazybek Bī Aūdany" },
    { code: "KZ.12.1517740", name: "Ulytaū Aūdany" },
    { code: "KZ.12.1518252", name: "Tengiz Aūdany" },
    { code: "KZ.12.1518281", name: "Tel’man Aūdany" },
    { code: "KZ.12.1519197", name: "Shet Aūdany" },
    { code: "KZ.12.1520325", name: "Osakarovka Aūdany" },
    { code: "KZ.12.1520378", name: "Ordzhonīkīdze Aūdany" },
    { code: "KZ.12.1520497", name: "Nura Aūdany" },
    { code: "KZ.12.1520873", name: "Molodezhnyy Aūdany" },
    { code: "KZ.12.1520952", name: "Mīchūrīn Aūdany" },
    { code: "KZ.12.1523004", name: "Qarqaraly Aūdany" },
    { code: "KZ.12.1524382", name: "Zhezdi Aūdany" },
    { code: "KZ.12.1526570", name: "Aqtoghay Aūdany" },
    { code: "KZ.12.1526940", name: "Aqadyr Aūdany" },
    { code: "KZ.12.1537252", name: "Toqyraūyn Aūdany" },
    { code: "KZ.12.1537254", name: "Zhezqazghan Qalasy" },
    { code: "KZ.12.1537255", name: "Balqash Qalasy" },
    { code: "KZ.12.1537256", name: "Qarazhal Qalasy" },
    { code: "KZ.12.1537257", name: "Qalasy Sätbaev" },
    { code: "KZ.12.1537266", name: "Qaraghandy Qalasy" },
    { code: "KZ.12.1537267", name: "Abay Qalasy" },
    { code: "KZ.12.1537268", name: "Sorang Qalasy" },
    { code: "KZ.12.1537269", name: "Temirtaū Qalasy" },
    { code: "KZ.12.1537270", name: "Shakhtīnsk Qalasy" },
    { code: "KZ.12.9072845", name: "Bukhar-Zhyrau" },
  ],
  "KZ.13": [
    { code: "KZ.13.1517715", name: "Ūrītskīy Aūdany" },
    { code: "KZ.13.1518463", name: "Taranovskiy Rayon" },
    { code: "KZ.13.1519416", name: "Semiozërnyy Rayon" },
    { code: "KZ.13.1520735", name: "Naūryzym Aūdany" },
    { code: "KZ.13.1521358", name: "Lenīn Aūdany" },
    { code: "KZ.13.1521667", name: "Kustanayskiy Rayon" },
    { code: "KZ.13.1522333", name: "Komsomol Aūdany" },
    { code: "KZ.13.1523115", name: "Qarasū Aūdany" },
    { code: "KZ.13.1523544", name: "Qamysty Aūdany" },
    { code: "KZ.13.1524278", name: "Fëdorovskiy Rayon" },
    { code: "KZ.13.1524388", name: "Zhetiqara Aūdany" },
    { code: "KZ.13.1524425", name: "Zhangeldīn Aūdany" },
    { code: "KZ.13.1525120", name: "Mendykarinskiy Rayon" },
    { code: "KZ.13.1526209", name: "Arqalyq Aūdany" },
    { code: "KZ.13.1526321", name: "Amantoghay Aūdany" },
    { code: "KZ.13.1526340", name: "Amangeldi Aūdany" },
    { code: "KZ.13.1537245", name: "Altynsarinskiy Rayon" },
    { code: "KZ.13.1537246", name: "Qostanay Qalasy" },
    { code: "KZ.13.1537247", name: "Zhetiqara Qalasy" },
    { code: "KZ.13.1537248", name: "Līsakovsk Qalasy" },
    { code: "KZ.13.1537249", name: "Rūdnyy Qalasy" },
    { code: "KZ.13.1537251", name: "Oktyabr’ Aūdany" },
  ],
  "KZ.14": [
    { code: "KZ.14.1517322", name: "Zhangaqorghan Aūdany" },
    { code: "KZ.14.1518202", name: "Terengözek Aūdany" },
    { code: "KZ.14.1518650", name: "Syrdarīya Aūdany" },
    { code: "KZ.14.1522859", name: "Qazaly Aūdany" },
    { code: "KZ.14.1522998", name: "Qarmaqshy Aūdany" },
    { code: "KZ.14.1524477", name: "Zhalaghash Aūdany" },
    { code: "KZ.14.1524798", name: "Shīeli Aūdany" },
    { code: "KZ.14.1526248", name: "Aral Aūdany" },
  ],
  "KZ.15": [
    { code: "KZ.15.1516437", name: "Zyryanovsk Aūdany" },
    { code: "KZ.15.1516713", name: "Zharma Aūdany" },
    { code: "KZ.15.1516846", name: "Zhangasemey Aūdany" },
    { code: "KZ.15.1517057", name: "Zaysan Aūdany" },
    { code: "KZ.15.1517718", name: "Ürzhar Aūdany" },
    { code: "KZ.15.1517810", name: "Ulan Aūdany" },
    { code: "KZ.15.1518334", name: "Tavrīya Aūdany" },
    { code: "KZ.15.1518415", name: "Taskesken Aūdany" },
    { code: "KZ.15.1518456", name: "Tarbaghatay Aūdany" },
    { code: "KZ.15.1519224", name: "Shemonaīkha Aūdany" },
    { code: "KZ.15.1519757", name: "Samarskoe Aūdany" },
    { code: "KZ.15.1520548", name: "Novoshūl’ba Aūdany" },
    { code: "KZ.15.1521109", name: "Marqaköl Aūdany" },
    { code: "KZ.15.1521244", name: "Maqanshy Aūdany" },
    { code: "KZ.15.1521759", name: "Kürshim Aūdany" },
    { code: "KZ.15.1522504", name: "Kökpekti Aūdany" },
    { code: "KZ.15.1522926", name: "Qotanqaraghay Aūdany" },
    { code: "KZ.15.1524226", name: "Glūbokoe Aūdany" },
    { code: "KZ.15.1524717", name: "Shubartaū Aūdany" },
    { code: "KZ.15.1524882", name: "Shar Aūdany" },
    { code: "KZ.15.1525133", name: "Borodūlīkha Aūdany" },
    { code: "KZ.15.1525198", name: "Ülkennaryn Aūdany" },
    { code: "KZ.15.1525406", name: "Besqaraghay Aūdany" },
    { code: "KZ.15.1525986", name: "Ayaköz Qalasy" },
    { code: "KZ.15.1526637", name: "Aqsūat Aūdany" },
    { code: "KZ.15.1526967", name: "Abay Aūdany" },
    { code: "KZ.15.1537285", name: "Semey Qalasy" },
    { code: "KZ.15.1537286", name: "Öskemen Qalasy" },
    { code: "KZ.15.1537287", name: "Zyryanovsk Qalasy" },
    { code: "KZ.15.1537288", name: "Lenīnogorsk Qalasy" },
    { code: "KZ.15.1537289", name: "Serebryansk Qalasy" },
    { code: "KZ.15.1537309", name: "Abyraly Aūdany" },
  ],
  "KZ.16": [
    { code: "KZ.16.1517353", name: "Vozvyshenka Aūdany" },
    { code: "KZ.16.1517412", name: "Ayyrtaū Aūdany" },
    { code: "KZ.16.1517502", name: "Ūälīkhanov Aūdany" },
    { code: "KZ.16.1518161", name: "Tīmīryazev Aūdany" },
    { code: "KZ.16.1518835", name: "Sovet Aūdany" },
    { code: "KZ.16.1518912", name: "Sokolovka Aūdany" },
    { code: "KZ.16.1519383", name: "Sergeevka Aūdany" },
    { code: "KZ.16.1519834", name: "Rūzaevka Aūdany" },
    { code: "KZ.16.1520047", name: "Presnovka Aūdany" },
    { code: "KZ.16.1520854", name: "Moskva Aūdany" },
    { code: "KZ.16.1521151", name: "Mamlyutka Aūdany" },
    { code: "KZ.16.1521352", name: "Lenīn Aūdany" },
    { code: "KZ.16.1521359", name: "Lenīn Aūdany" },
    { code: "KZ.16.1521375", name: "Lenīngrad Aūdany" },
    { code: "KZ.16.1521400", name: "Qyzyltū Aūdany" },
    { code: "KZ.16.1521634", name: "Kūybyshev Aūdany" },
    { code: "KZ.16.1522032", name: "Krasnoarmeysk Aūdany" },
    { code: "KZ.16.1522531", name: "Kökshetaū Aūdany" },
    { code: "KZ.16.1522808", name: "Kellerovka Aūdany" },
    { code: "KZ.16.1524440", name: "Zhambyl Aūdany" },
    { code: "KZ.16.1524749", name: "Chkalov Aūdany" },
    { code: "KZ.16.1524766", name: "Chīstopol’e Aūdany" },
    { code: "KZ.16.1525010", name: "Būlaevo Aūdany" },
    { code: "KZ.16.1525293", name: "Besköl Aūdany" },
    { code: "KZ.16.1526177", name: "Aryqbalyq Aūdany" },
  ],
  "KZ.17": [
    { code: "KZ.17.1518589", name: "Talas Aūdany" },
    { code: "KZ.17.1518673", name: "Sverdlov Aūdany" },
    { code: "KZ.17.1519552", name: "Sarysū Aūdany" },
    { code: "KZ.17.1520845", name: "Moyynqum Aūdany" },
    { code: "KZ.17.1520965", name: "Merke Aūdany" },
    { code: "KZ.17.1521288", name: "Lūgovoe Aūdany" },
    { code: "KZ.17.1521754", name: "Qorday Aūdany" },
    { code: "KZ.17.1524333", name: "Zhūaly Aūdany" },
    { code: "KZ.17.1524439", name: "Zhambyl Aūdany" },
    { code: "KZ.17.1524678", name: "Shū Aūdany" },
    { code: "KZ.17.1537277", name: "Zhambyl Qalasy" },
    { code: "KZ.17.1537278", name: "Zhangatas Qalasy" },
    { code: "KZ.17.1537279", name: "Qarataū Qalasy" },
    { code: "KZ.17.1537280", name: "Shū Qalasy" },
    { code: "KZ.17.8739769", name: "Bayzak District" },
    { code: "KZ.17.8739777", name: "Korday" },
  ],
  "LA.01": [
    { code: "LA.01.1701", name: "Muang Xaiséttha" },
    { code: "LA.01.1702", name: "Muang Samakhixai" },
    { code: "LA.01.1703", name: "Muang Sanamxai" },
    { code: "LA.01.1704", name: "Muang Sanxai" },
    { code: "LA.01.1705", name: "Muang Phouvong" },
  ],
  "LA.02": [
    { code: "LA.02.1601", name: "Muang Pakxé" },
    { code: "LA.02.1602", name: "Muang Xanasômboun" },
    { code: "LA.02.1603", name: "Muang Bachiangchaleunsook" },
    { code: "LA.02.1604", name: "Muang Pakxong" },
    { code: "LA.02.1605", name: "Muang Pathoumphon" },
    { code: "LA.02.1606", name: "Muang Phônthong" },
    { code: "LA.02.1607", name: "Muang Champasak" },
    { code: "LA.02.1608", name: "Muang Soukhouma" },
    { code: "LA.02.1609", name: "Muang Mounlapamôk" },
    { code: "LA.02.1610", name: "Muang Không" },
  ],
  "LA.03": [
    { code: "LA.03.0701", name: "Xam Neua" },
    { code: "LA.03.0702", name: "Muang Xiengkhor" },
    { code: "LA.03.0703", name: "Viengxon" },
    { code: "LA.03.0704", name: "Muang Viangxai" },
    { code: "LA.03.0705", name: "Muang Houamuang" },
    { code: "LA.03.0706", name: "Muang Xam-Tai" },
    { code: "LA.03.0707", name: "Sopbao" },
    { code: "LA.03.0708", name: "Muang Et" },
    { code: "LA.03.0709", name: "Kuan" },
    { code: "LA.03.0710", name: "Muang Hiam" },
  ],
  "LA.07": [
    { code: "LA.07.0401", name: "Muang Xai" },
    { code: "LA.07.0402", name: "Muang La" },
    { code: "LA.07.0403", name: "Muang Namo" },
    { code: "LA.07.0404", name: "Muang Nga" },
    { code: "LA.07.0405", name: "Muang Bèng" },
    { code: "LA.07.0406", name: "Muang Houn" },
    { code: "LA.07.0407", name: "Muang Pakbèng" },
  ],
  "LA.13": [
    { code: "LA.13.0801", name: "Muang Xaignabouli" },
    { code: "LA.13.0802", name: "Muang Khop" },
    { code: "LA.13.0803", name: "Muang Hôngsa" },
    { code: "LA.13.0804", name: "Muang Ngeun" },
    { code: "LA.13.0805", name: "Muang Xianghon" },
    { code: "LA.13.0806", name: "Muang Phiang" },
    { code: "LA.13.0807", name: "Muang Paklay" },
    { code: "LA.13.0808", name: "Muang Kènthao" },
    { code: "LA.13.0809", name: "Botene" },
    { code: "LA.13.0810", name: "Thongmyxay" },
    { code: "LA.13.0811", name: "Xaysathan" },
  ],
  "LA.14": [
    { code: "LA.14.0901", name: "Muang Pèk" },
    { code: "LA.14.0902", name: "Muang Kham" },
    { code: "LA.14.0903", name: "Muang Nonghèt" },
    { code: "LA.14.0904", name: "Muang Khoun" },
    { code: "LA.14.0905", name: "Muang Mok" },
    { code: "LA.14.0906", name: "Muang Phou Kont" },
    { code: "LA.14.0907", name: "Muang Phaxai" },
  ],
  "LA.15": [
    { code: "LA.15.1201", name: "Muang Thakhèk" },
    { code: "LA.15.1202", name: "Muang Mahaxai" },
    { code: "LA.15.1203", name: "Muang Nongbôk" },
    { code: "LA.15.1204", name: "Muang Hinboun" },
    { code: "LA.15.1205", name: "Muang Gnômmarat" },
    { code: "LA.15.1206", name: "Muang Boualapha" },
    { code: "LA.15.1207", name: "Muang Na Kay" },
    { code: "LA.15.1208", name: "Muang Xebangfai" },
    { code: "LA.15.1209", name: "Muang Xaibouathong" },
    { code: "LA.15.1210", name: "Kounkham" },
  ],
  "LA.16": [
    { code: "LA.16.0301", name: "Muang Louang Namtha" },
    { code: "LA.16.0302", name: "Muang Sing" },
    { code: "LA.16.0303", name: "Muang Long" },
    { code: "LA.16.0304", name: "Muang Viangphoukha" },
    { code: "LA.16.0305", name: "Muang Nalè" },
  ],
  "LA.17": [
    { code: "LA.17.0601", name: "Muang Louangphabang" },
    { code: "LA.17.0602", name: "Xieng ngeun" },
    { code: "LA.17.0603", name: "Muang Nan" },
    { code: "LA.17.0604", name: "Muang Pak-Ou" },
    { code: "LA.17.0605", name: "Muang Nambak" },
    { code: "LA.17.0606", name: "Muang Ngoy" },
    { code: "LA.17.0607", name: "Muang Pakxèng" },
    { code: "LA.17.0608", name: "Muang Phônxai" },
    { code: "LA.17.0609", name: "Muang Chomphét" },
    { code: "LA.17.0610", name: "Muang Viangkhan" },
    { code: "LA.17.0611", name: "Muang Phou Khoun" },
    { code: "LA.17.0612", name: "Phonthong" },
  ],
  "LA.18": [
    { code: "LA.18.0201", name: "Muang Phôngsali" },
    { code: "LA.18.0202", name: "Muang Mai" },
    { code: "LA.18.0203", name: "Muang Khoa" },
    { code: "LA.18.0204", name: "Samphanh" },
    { code: "LA.18.0205", name: "Muang Boun-Nua" },
    { code: "LA.18.0206", name: "Muang Gnot-Ou" },
    { code: "LA.18.0207", name: "Muang Boun Tai" },
  ],
  "LA.19": [
    { code: "LA.19.1401", name: "Muang Saravan" },
    { code: "LA.19.1402", name: "Muang Ta-Ôy" },
    { code: "LA.19.1403", name: "Muang Toumlan" },
    { code: "LA.19.1404", name: "Muang Lakhonphéng" },
    { code: "LA.19.1405", name: "Muang Vapi" },
    { code: "LA.19.1406", name: "Muang Khôngxédôn" },
    { code: "LA.19.1407", name: "Muang Laongam" },
    { code: "LA.19.1408", name: "Muang Samouay" },
  ],
  "LA.20": [
    { code: "LA.20.1301", name: "Kaysone Phomvihane" },
    { code: "LA.20.1302", name: "Muang Outhoumphon" },
    { code: "LA.20.1303", name: "Muang Alsaphangthong" },
    { code: "LA.20.1304", name: "Muang Phin" },
    { code: "LA.20.1305", name: "Muang Xépôn" },
    { code: "LA.20.1306", name: "Muang Nong" },
    { code: "LA.20.1307", name: "Muang Thapangthong" },
    { code: "LA.20.1308", name: "Muang Songkhon" },
    { code: "LA.20.1309", name: "Muang Champhon" },
    { code: "LA.20.1310", name: "Muang Xônbouli" },
    { code: "LA.20.1311", name: "Muang Xaibouli" },
    { code: "LA.20.1312", name: "Muang Vilabouli" },
    { code: "LA.20.1313", name: "Muang Atsaphan" },
    { code: "LA.20.1314", name: "Muang Xayphoothong" },
    { code: "LA.20.1315", name: "Thaphalanxay" },
  ],
  "LA.22": [
    { code: "LA.22.0501", name: "Muang Houayxay" },
    { code: "LA.22.0502", name: "Muang Tônpheung" },
    { code: "LA.22.0503", name: "Muang Meung" },
    { code: "LA.22.0504", name: "Muang Pha Oudôm" },
    { code: "LA.22.0505", name: "Muang Paktha" },
  ],
  "LA.23": [
    { code: "LA.23.1101", name: "Paksane" },
    { code: "LA.23.1102", name: "Muang Thaphabat" },
    { code: "LA.23.1103", name: "Muang Pakkading" },
    { code: "LA.23.1104", name: "Muang Bolikhan" },
    { code: "LA.23.1105", name: "Muang Khamkeut" },
    { code: "LA.23.1106", name: "Muang Viangthong" },
    { code: "LA.23.1107", name: "Xaychamphone" },
  ],
  "LA.24": [
    { code: "LA.24.0101", name: "Muang Chanthabouli" },
    { code: "LA.24.0102", name: "Muang Sikhôttabong" },
    { code: "LA.24.0103", name: "Muang Xaiséttha" },
    { code: "LA.24.0104", name: "Muang Sisattanak" },
    { code: "LA.24.0105", name: "Muang Naxaythong" },
    { code: "LA.24.0106", name: "Muang Xaithani" },
    { code: "LA.24.0107", name: "Muang Hatxayfong" },
    { code: "LA.24.0108", name: "Muang Sangthong" },
    { code: "LA.24.0109", name: "Muang Maypakngum" },
  ],
  "LA.26": [
    { code: "LA.26.1501", name: "Muang Laman" },
    { code: "LA.26.1502", name: "Muang Khaleum" },
    { code: "LA.26.1503", name: "Muang Dakchung" },
    { code: "LA.26.1504", name: "Muang Thatèng" },
  ],
  "LA.27": [
    { code: "LA.27.1001", name: "Muang Phôn-Hông" },
    { code: "LA.27.1002", name: "Muang Thoulakhôm" },
    { code: "LA.27.1003", name: "Muang Kèo-Oudôm" },
    { code: "LA.27.1004", name: "Muang Kasi" },
    { code: "LA.27.1005", name: "Muang Vangviang" },
    { code: "LA.27.1006", name: "Muang Fuang" },
    { code: "LA.27.1007", name: "Xanakharm" },
    { code: "LA.27.1008", name: "Mad" },
    { code: "LA.27.1009", name: "Viengkham" },
    { code: "LA.27.1010", name: "Hinherb" },
    { code: "LA.27.1013", name: "Muen" },
  ],
  "LA.28": [
    { code: "LA.28.1801", name: "Anouvong district" },
    { code: "LA.28.1802", name: "Muang Thathôm" },
    { code: "LA.28.1803", name: "Longchaeng" },
    { code: "LA.28.1804", name: "Muang Hôm" },
    { code: "LA.28.1805", name: "Muang Longxan" },
  ],
  "LB.05": [
    { code: "LB.05.10119971", name: "Keserwan District" },
    { code: "LB.05.272300", name: "Caza du Kesrouane" },
    { code: "LB.05.273201", name: "Caza de Jbayl" },
    { code: "LB.05.277225", name: "Caza de Baabda" },
    { code: "LB.05.278156", name: "Caza du Chouf" },
    { code: "LB.05.279440", name: "Caza du Matn" },
    { code: "LB.05.280424", name: "Caza de Aaley" },
    { code: "LB.05.7838967", name: "Metn District" },
  ],
  "LB.06": [
    { code: "LB.06.267006", name: "Caza de Tyr" },
    { code: "LB.06.273359", name: "Caza de Jezzîne" },
    { code: "LB.06.7735345", name: "Caza de Saida" },
  ],
  "LB.07": [
    { code: "LB.07.271225", name: "Caza de Marjayoûn" },
    { code: "LB.07.274311", name: "Caza de Hâsbaïya" },
    { code: "LB.07.276591", name: "Caza de Bent Jbaïl" },
    { code: "LB.07.278915", name: "Caza de Nabatîyé" },
    { code: "LB.07.7646521", name: "Marjayoun" },
  ],
  "LB.08": [
    { code: "LB.08.266042", name: "Caza de Zahleh" },
    { code: "LB.08.268737", name: "Caza de Rachaïya" },
    { code: "LB.08.280280", name: "Caza de la Beqâa-Ouest" },
  ],
  "LB.09": [
    { code: "LB.09.10121424", name: "Miniyeh-Danniyeh" },
    { code: "LB.09.10121443", name: "Tripoli" },
    { code: "LB.09.10126909", name: "Minie-Denniyeh" },
    { code: "LB.09.265845", name: "Caza de Zgharta" },
    { code: "LB.09.266825", name: "Caza de Trablous" },
    { code: "LB.09.276358", name: "Caza de Bécharré" },
    { code: "LB.09.279676", name: "Caza de Koura" },
    { code: "LB.09.280329", name: "Caza de Batroun" },
    { code: "LB.09.7735321", name: "Caza de Miniyé-Danniyé" },
  ],
  "LB.10": [
    { code: "LB.10.280572", name: "Caza de Aakkar" },
  ],
  "LB.11": [
    { code: "LB.11.277129", name: "Caza de Baalbek" },
    { code: "LB.11.279999", name: "Caza du Hermel" },
  ],
  "LC.01": [
    { code: "LC.01.40020000", name: "Au Tabor" },
    { code: "LC.01.40020100", name: "Au Tabor Hill" },
    { code: "LC.01.40050000", name: "Bois D'Inde" },
    { code: "LC.01.40060000", name: "Champen Estate" },
    { code: "LC.01.40070000", name: "Dame De Traversay" },
    { code: "LC.01.40080000", name: "Derriere Dos" },
    { code: "LC.01.40090000", name: "Derriere Lagoon" },
    { code: "LC.01.40100000", name: "Durandeau" },
    { code: "LC.01.40110000", name: "Fond Eau Rouge" },
    { code: "LC.01.40120000", name: "Invorgoil Estate" },
    { code: "LC.01.40130000", name: "Jacmel" },
    { code: "LC.01.40140000", name: "Jean Baptiste" },
    { code: "LC.01.40150000", name: "La Trielle" },
    { code: "LC.01.40170000", name: "Massacre" },
    { code: "LC.01.40180000", name: "Millet" },
    { code: "LC.01.40180100", name: "Caico/Millet" },
    { code: "LC.01.40180101", name: "Enbar Pwin" },
    { code: "LC.01.40180300", name: "Tete Chemin" },
    { code: "LC.01.40200000", name: "Morne Ciseaux" },
    { code: "LC.01.40210000", name: "Morne D'Or" },
    { code: "LC.01.40220000", name: "Roseau Valley" },
    { code: "LC.01.40230000", name: "St Lawrence" },
    { code: "LC.01.40230100", name: "St Lawrence Estate" },
    { code: "LC.01.40240000", name: "Vanard" },
    { code: "LC.01.40250000", name: "Venus" },
    { code: "LC.01.40260000", name: "Village" },
    { code: "LC.01.40260100", name: "Village/Petite Bourgh" },
  ],
  "LC.03": [
    { code: "LC.03.10060000", name: "Banannes Bay" },
    { code: "LC.03.10070000", name: "Barnard Hill" },
    { code: "LC.03.10090000", name: "Bella Rosa" },
    { code: "LC.03.10160000", name: "Bois Catchet" },
    { code: "LC.03.10170000", name: "Calvary" },
    { code: "LC.03.10190000", name: "Cedars" },
    { code: "LC.03.10200100", name: "Sunbilt" },
    { code: "LC.03.10240000", name: "City" },
    { code: "LC.03.10243800", name: "Grass Street" },
    { code: "LC.03.10244800", name: "Peart'S Gap" },
    { code: "LC.03.10245500", name: "Conway/Waterfront" },
    { code: "LC.03.10250000", name: "City Gate/La Clery" },
    { code: "LC.03.10270000", name: "Coolie Town" },
    { code: "LC.03.10310000", name: "Darling Road" },
    { code: "LC.03.10380000", name: "Faux A Chaud" },
    { code: "LC.03.10400000", name: "Fond Manger" },
    { code: "LC.03.10470000", name: "Hospital Road" },
    { code: "LC.03.10480000", name: "John Compton Highway" },
    { code: "LC.03.10570000", name: "La Toc" },
    { code: "LC.03.10580000", name: "Lastic Hill" },
    { code: "LC.03.10670000", name: "New Village" },
    { code: "LC.03.10690000", name: "Patterson'S Gap" },
    { code: "LC.03.10700000", name: "Pavee" },
    { code: "LC.03.10720000", name: "Pointe Seraphine" },
    { code: "LC.03.10760000", name: "Rose Hill" },
    { code: "LC.03.10920000", name: "Waterworks" },
    { code: "LC.03.10930000", name: "Wilton'S Yard/Grave Yard" },
    { code: "LC.03.10940000", name: "Forest Reserve" },
    { code: "LC.03.20010000", name: "Almondale" },
    { code: "LC.03.20020000", name: "Aurendel Hill" },
    { code: "LC.03.20040000", name: "Bagatelle" },
    { code: "LC.03.20120000", name: "Bissee" },
    { code: "LC.03.20130000", name: "Bishop'S Gap" },
    { code: "LC.03.20150000", name: "Bocage" },
    { code: "LC.03.20180100", name: "Carellie" },
    { code: "LC.03.20210000", name: "Ravine Chabot" },
    { code: "LC.03.20220000", name: "Choc" },
    { code: "LC.03.20230000", name: "Ciceron" },
    { code: "LC.03.20231400", name: "Monkey Town Ciceron" },
    { code: "LC.03.20280000", name: "Coubaril" },
    { code: "LC.03.20370000", name: "Entrepot" },
    { code: "LC.03.20370400", name: "Independence City" },
    { code: "LC.03.20500000", name: "La Clery" },
    { code: "LC.03.20500100", name: "Active Hill" },
    { code: "LC.03.20500300", name: "Chase Gardens" },
    { code: "LC.03.20501400", name: "Yorke Hill" },
    { code: "LC.03.20550000", name: "La Pansee" },
    { code: "LC.03.20550100", name: "Goergeville" },
    { code: "LC.03.20590000", name: "Leslie Land" },
    { code: "LC.03.20600000", name: "Marchand" },
    { code: "LC.03.20600100", name: "Black Mallet" },
    { code: "LC.03.20600200", name: "George Charles Boulevard" },
    { code: "LC.03.20600400", name: "Maynard Hill" },
    { code: "LC.03.20600700", name: "Trou Rouge" },
    { code: "LC.03.20630000", name: "Morne Dudon" },
    { code: "LC.03.20630100", name: "Agard Lands/Morne Dudon" },
    { code: "LC.03.20630300", name: "Bois Patat" },
    { code: "LC.03.20630400", name: "Hillcrest Gardens" },
    { code: "LC.03.20640000", name: "Morne Road" },
    { code: "LC.03.20650000", name: "Mount Pleasant" },
    { code: "LC.03.20680000", name: "Parker'S Hill" },
    { code: "LC.03.20750000", name: "Rock Hall" },
    { code: "LC.03.20750100", name: "Ravine Touterelle" },
    { code: "LC.03.20780000", name: "San Soucis" },
    { code: "LC.03.20781100", name: "L'Anse Road" },
    { code: "LC.03.20790000", name: "Summersdale" },
    { code: "LC.03.20800000", name: "Sunny Acres" },
    { code: "LC.03.20810000", name: "Tapion" },
    { code: "LC.03.20820000", name: "The Morne" },
    { code: "LC.03.20820100", name: "Capital Hill" },
    { code: "LC.03.20890000", name: "Vide Bouteille" },
    { code: "LC.03.20910000", name: "Vigie" },
    { code: "LC.03.30030000", name: "Babonneau Proper" },
    { code: "LC.03.30030100", name: "Cabiche/Babonneau" },
    { code: "LC.03.30030200", name: "Cacoa/Babonneau" },
    { code: "LC.03.30030201", name: "Girard" },
    { code: "LC.03.30030202", name: "Green Gold" },
    { code: "LC.03.30030203", name: "Hill 20/Babonneau" },
    { code: "LC.03.30030400", name: "Chassin/Babonneau" },
    { code: "LC.03.30030500", name: "Fond Assau/Babonneau" },
    { code: "LC.03.30030501", name: "Morne Assau/Babonneau" },
    { code: "LC.03.30031100", name: "Talvern" },
    { code: "LC.03.30031101", name: "En Pois Doux/Babonneau" },
    { code: "LC.03.30050000", name: "Balata" },
    { code: "LC.03.30110000", name: "Bexon" },
    { code: "LC.03.30110100", name: "Barre Denis" },
    { code: "LC.03.30110200", name: "Choppin Ridge/Sarot" },
    { code: "LC.03.30110400", name: "Labayee" },
    { code: "LC.03.30110500", name: "Marc" },
    { code: "LC.03.30110501", name: "Crownlands/Marc" },
    { code: "LC.03.30110502", name: "Floissac/Marc" },
    { code: "LC.03.30110504", name: "Morne Rouge/Marc" },
    { code: "LC.03.30110505", name: "Trou Cochan/Marc" },
    { code: "LC.03.30110506", name: "Trou Florent/Marc" },
    { code: "LC.03.30110600", name: "Miami/Bexon" },
    { code: "LC.03.30110700", name: "Odsan" },
    { code: "LC.03.30110800", name: "Ravine Poisson" },
    { code: "LC.03.30110900", name: "Sarot" },
    { code: "LC.03.30110901", name: "Sand De Feu" },
    { code: "LC.03.30300000", name: "Cul De Sac" },
    { code: "LC.03.30300100", name: "Ferrand" },
    { code: "LC.03.30300300", name: "Soucis" },
    { code: "LC.03.30320000", name: "Deglos" },
    { code: "LC.03.30330000", name: "Derierre Fort/Old Victoria Road" },
    { code: "LC.03.30340000", name: "Dubrassay" },
    { code: "LC.03.30390000", name: "Fond Canie" },
    { code: "LC.03.30410000", name: "Forestiere" },
    { code: "LC.03.30410200", name: "Piton Flore" },
    { code: "LC.03.30430000", name: "Goodlands" },
    { code: "LC.03.30460000", name: "Guesneau" },
    { code: "LC.03.30490000", name: "La Carierre" },
    { code: "LC.03.30530000", name: "La Croix Maingot" },
    { code: "LC.03.30530100", name: "Barre Duchaussee" },
    { code: "LC.03.30530200", name: "Barre St.Joseph" },
    { code: "LC.03.30530300", name: "Perou" },
    { code: "LC.03.30610000", name: "Marigot" },
    { code: "LC.03.30730000", name: "Quarte Chemins" },
    { code: "LC.03.30740000", name: "Resinard/Babonneau" },
    { code: "LC.03.30770100", name: "Belair" },
    { code: "LC.03.30830000", name: "Ti Colon" },
    { code: "LC.03.30840000", name: "Ti Rocher" },
    { code: "LC.03.30850000", name: "Tourat/Soucis" },
    { code: "LC.03.30870000", name: "Trois Piton" },
  ],
  "LC.04": [
    { code: "LC.04.70010000", name: "Belle Vue" },
    { code: "LC.04.70020000", name: "Marche Gaye" },
    { code: "LC.04.70030000", name: "Bois Dinde" },
    { code: "LC.04.70040000", name: "Caffiere" },
    { code: "LC.04.70060000", name: "Dacretin" },
    { code: "LC.04.70080000", name: "Debreuil" },
    { code: "LC.04.70090000", name: "Delcer" },
    { code: "LC.04.70100000", name: "Derriere Morne" },
    { code: "LC.04.70110000", name: "Dugard" },
    { code: "LC.04.70120000", name: "Dupre" },
    { code: "LC.04.70140000", name: "Esperance" },
    { code: "LC.04.70150000", name: "New Field/Fiette" },
    { code: "LC.04.70160000", name: "Franciou" },
    { code: "LC.04.70170000", name: "Industry" },
    { code: "LC.04.70180000", name: "La Fargue" },
    { code: "LC.04.70180100", name: "Cedars/Chu Tigre" },
    { code: "LC.04.70190000", name: "La Pointe" },
    { code: "LC.04.70200000", name: "Lamaze" },
    { code: "LC.04.70210000", name: "Le Riche" },
    { code: "LC.04.70240000", name: "Mailly Motete" },
    { code: "LC.04.70250000", name: "Martin" },
    { code: "LC.04.70260000", name: "Mavay" },
    { code: "LC.04.70270000", name: "Mongouge" },
    { code: "LC.04.70280000", name: "Motete" },
    { code: "LC.04.70290000", name: "Monzie" },
    { code: "LC.04.70300000", name: "Morne Jacques" },
    { code: "LC.04.70310000", name: "Morne Sion" },
    { code: "LC.04.70320000", name: "Morne Palama" },
    { code: "LC.04.70350000", name: "Ponyon" },
    { code: "LC.04.70360000", name: "Raveneau" },
    { code: "LC.04.70370000", name: "Reunion" },
    { code: "LC.04.70370200", name: "Port Alese" },
    { code: "LC.04.70380000", name: "River Doree" },
    { code: "LC.04.70390000", name: "Roblot" },
    { code: "LC.04.70400000", name: "Sauzay" },
    { code: "LC.04.70420000", name: "Victoria" },
    { code: "LC.04.70430000", name: "Village" },
    { code: "LC.04.70430100", name: "Savannesgeorge/Constitution" },
    { code: "LC.04.70440000", name: "Christian Hill" },
  ],
  "LC.05": [
    { code: "LC.05.110010000", name: "Anse Canot" },
    { code: "LC.05.110020000", name: "Athens" },
    { code: "LC.05.110030000", name: "Au Leon" },
    { code: "LC.05.110040000", name: "Bara Bara" },
    { code: "LC.05.110060000", name: "Barre De L'Isle" },
    { code: "LC.05.110070000", name: "Bazile" },
    { code: "LC.05.110080000", name: "Mount Beaujolais" },
    { code: "LC.05.110090000", name: "Belmont" },
    { code: "LC.05.110100000", name: "Bois Joli" },
    { code: "LC.05.110110000", name: "Bosquet D'Or" },
    { code: "LC.05.110120000", name: "Dennery By Pass" },
    { code: "LC.05.110120100", name: "Dennery By Pass/Green Mountain" },
    { code: "LC.05.110120200", name: "Dennery By Pass/Rocky Lane" },
    { code: "LC.05.110120300", name: "Dennery By Pass/White Rock Gardens" },
    { code: "LC.05.110130000", name: "Delaide" },
    { code: "LC.05.110140000", name: "Derniere Riviere" },
    { code: "LC.05.110140100", name: "Derniere Riviere/Morne Panache" },
    { code: "LC.05.110140200", name: "Derniere Riviere/Mardi Gras/Morne Caca Cochon" },
    { code: "LC.05.110140300", name: "Derniere Riviere/Fond Maricient" },
    { code: "LC.05.110140400", name: "Derniere Riviere/Fond Petit" },
    { code: "LC.05.110150000", name: "Despinoze" },
    { code: "LC.05.110170000", name: "Dubonnaire" },
    { code: "LC.05.110180000", name: "Errard" },
    { code: "LC.05.110190000", name: "Fond D'Or" },
    { code: "LC.05.110220000", name: "Gadette" },
    { code: "LC.05.110230000", name: "Glavier" },
    { code: "LC.05.110240000", name: "Grande Ravine" },
    { code: "LC.05.110250000", name: "Grande Riviere" },
    { code: "LC.05.110250100", name: "Grande Riviere/Des Branch" },
    { code: "LC.05.110250300", name: "Grande Riviere/En Leur Morne/Discompere" },
    { code: "LC.05.110250400", name: "Grande Riviere/Funier" },
    { code: "LC.05.110250500", name: "Grande Riviere/Morne Caca Cochon" },
    { code: "LC.05.110270000", name: "La Caye" },
    { code: "LC.05.110280000", name: "La Pelle" },
    { code: "LC.05.110290000", name: "La Ressource" },
    { code: "LC.05.110300000", name: "Lumiere" },
    { code: "LC.05.110330000", name: "Morne Panache" },
    { code: "LC.05.110360000", name: "Pascal" },
    { code: "LC.05.110370000", name: "Riche Fond" },
    { code: "LC.05.110370100", name: "Riche Fond/La Belle Vie" },
    { code: "LC.05.110370200", name: "Riche Fond/New Village" },
    { code: "LC.05.110380000", name: "St. Joseph Estate" },
    { code: "LC.05.110390000", name: "Thamazo" },
    { code: "LC.05.110390100", name: "Thomazo/Tournesse" },
    { code: "LC.05.110400000", name: "Dennery Village" },
    { code: "LC.05.110401800", name: "La Pointe" },
    { code: "LC.05.110410000", name: "Louvet" },
    { code: "LC.05.110420000", name: "La Sociere" },
    { code: "LC.05.110430000", name: "Bordelais" },
    { code: "LC.05.110440000", name: "Mandele" },
    { code: "LC.05.110450000", name: "Central Forest Reserve" },
  ],
  "LC.06": [
    { code: "LC.06.120010000", name: "Americ" },
    { code: "LC.06.120020100", name: "Paix Bouche" },
    { code: "LC.06.120040000", name: "Beausejour" },
    { code: "LC.06.120040100", name: "Beausejour/Fostin'S Development" },
    { code: "LC.06.120040200", name: "Beausejour/Ndc" },
    { code: "LC.06.120050000", name: "Bella Rosa" },
    { code: "LC.06.120060000", name: "Boguis" },
    { code: "LC.06.120060100", name: "Boguis/Desa Blond" },
    { code: "LC.06.120080000", name: "Bois D'Orange" },
    { code: "LC.06.120080100", name: "Bois D'Ornange/Trouya" },
    { code: "LC.06.120100000", name: "Bonneterre" },
    { code: "LC.06.120100100", name: "Bonneterre Gardens" },
    { code: "LC.06.120110000", name: "Caille Des" },
    { code: "LC.06.120120000", name: "Caye Manje'" },
    { code: "LC.06.120130000", name: "Cap Estate" },
    { code: "LC.06.120130100", name: "Cap Estate/Anse Du Cap" },
    { code: "LC.06.120130200", name: "Cap Estate/Saddlec Back" },
    { code: "LC.06.120130300", name: "Cap Estate/Lower Saline Point" },
    { code: "LC.06.120130400", name: "Cap Estate/Upper Saline Point" },
    { code: "LC.06.120130500", name: "Cap Estate/Mon Du Cap" },
    { code: "LC.06.120130600", name: "Cap Estate/Caribbean Park" },
    { code: "LC.06.120130700", name: "Cap Estate/Ranch Site" },
    { code: "LC.06.120130800", name: "Cap Estate/Golf Park" },
    { code: "LC.06.120131000", name: "Cap Estate/Becune Park" },
    { code: "LC.06.120131100", name: "Cap Estate/Becune Point" },
    { code: "LC.06.120150000", name: "Cas En Bas" },
    { code: "LC.06.120170000", name: "Corinth" },
    { code: "LC.06.120170100", name: "Corinth Estate" },
    { code: "LC.06.120170200", name: "Corinth/La Bel Lair" },
    { code: "LC.06.120180000", name: "Dauphin" },
    { code: "LC.06.120190000", name: "Des Barras" },
    { code: "LC.06.120190100", name: "Des Barras/Cacolie" },
    { code: "LC.06.120200000", name: "Garrand" },
    { code: "LC.06.120230000", name: "Grand Riviere" },
    { code: "LC.06.120230100", name: "Grande Riviere/Assou Canal" },
    { code: "LC.06.120230200", name: "Grande Riviere/Ingle Woods" },
    { code: "LC.06.120230400", name: "Grande Riviere/Morne Elwin" },
    { code: "LC.06.120230500", name: "Grande Riviere/Morne Serpent" },
    { code: "LC.06.120230600", name: "Grande Riviere/Norbert" },
    { code: "LC.06.120230700", name: "Grande Riviere/Piat" },
    { code: "LC.06.120230800", name: "Grande Riviere/White Rock" },
    { code: "LC.06.120230900", name: "Grande Riviere/Postlewaithe" },
    { code: "LC.06.120231000", name: "Grande Riviere/Degazon" },
    { code: "LC.06.120250000", name: "La Croix Chabourgh" },
    { code: "LC.06.120260000", name: "La Guerre" },
    { code: "LC.06.120260100", name: "La Guerre/Chicken Back Street" },
    { code: "LC.06.120270000", name: "L'Hermitage" },
    { code: "LC.06.120290000", name: "Marisule" },
    { code: "LC.06.120290100", name: "Marisule/Bon Air" },
    { code: "LC.06.120290200", name: "Marisule/East Winds" },
    { code: "LC.06.120290300", name: "Marisule/Top Of The World/Belle Ville" },
    { code: "LC.06.120290400", name: "Marisule/La Brellotte" },
    { code: "LC.06.120290500", name: "Marisule/Top Of The World" },
    { code: "LC.06.120300000", name: "Marquis Estate" },
    { code: "LC.06.120310000", name: "Massade" },
    { code: "LC.06.120330000", name: "Monchy" },
    { code: "LC.06.120330100", name: "Monchy/Careffe" },
    { code: "LC.06.120330200", name: "Monchy/Cletus Village" },
    { code: "LC.06.120330400", name: "Monchy/La Borne" },
    { code: "LC.06.120330403", name: "Monchy/La Borne/Sans Souci" },
    { code: "LC.06.120330500", name: "Monchy/Lafeuillee" },
    { code: "LC.06.120330600", name: "Monchy/La Retraite" },
    { code: "LC.06.120330700", name: "Monchy/Riviere Mitan" },
    { code: "LC.06.120330900", name: "Monchy/Moulin A Vent" },
    { code: "LC.06.120331000", name: "Monchy/Ravine Macock" },
    { code: "LC.06.120331100", name: "Monchy/Ti Dauphin" },
    { code: "LC.06.120331200", name: "Monchy/Vieux Sucreic" },
    { code: "LC.06.120331201", name: "Monchy/Vieux Sucreic/Careffe" },
    { code: "LC.06.120331202", name: "Monchy/Vieux Sucreic/Bois D'Inde" },
    { code: "LC.06.120331300", name: "Monchy/Malgretoute" },
    { code: "LC.06.120331400", name: "Monchy/Cardinal" },
    { code: "LC.06.120331500", name: "Monchy/Lawi Fwen" },
    { code: "LC.06.120331600", name: "Monchy/Mount Layau" },
    { code: "LC.06.120340000", name: "Mongiraud" },
    { code: "LC.06.120350000", name: "Monier" },
    { code: "LC.06.120390000", name: "Pigeon Island" },
    { code: "LC.06.120410000", name: "Plateau" },
    { code: "LC.06.120440000", name: "Reduit" },
    { code: "LC.06.120440100", name: "Reduit Orchard" },
    { code: "LC.06.120440200", name: "Reduit Park" },
    { code: "LC.06.120450000", name: "Rodney Bay" },
    { code: "LC.06.120460000", name: "Rodney Heights" },
    { code: "LC.06.120500000", name: "Gros Islet Town" },
    { code: "LC.06.120501100", name: "Gros Islet/Edge Water" },
    { code: "LC.06.120520000", name: "Union" },
    { code: "LC.06.120520300", name: "Union Terrace" },
    { code: "LC.06.120520400", name: "Union/Ti Morne" },
    { code: "LC.06.120530000", name: "Belle Vue" },
    { code: "LC.06.120530100", name: "Belle Vue Estate" },
    { code: "LC.06.120540000", name: "Desrameaux" },
    { code: "LC.06.120550000", name: "Morne Citon" },
  ],
  "LC.07": [
    { code: "LC.07.80010000", name: "Annus" },
    { code: "LC.07.80020000", name: "Beyar" },
    { code: "LC.07.80030000", name: "Balca" },
    { code: "LC.07.80030100", name: "Balca/En Leur Ba" },
    { code: "LC.07.80040000", name: "Balembouche" },
    { code: "LC.07.80050000", name: "Banse" },
    { code: "LC.07.80060000", name: "Banse La Grace" },
    { code: "LC.07.80070000", name: "Fond Berange" },
    { code: "LC.07.80080000", name: "Bongalo" },
    { code: "LC.07.80110000", name: "Daban" },
    { code: "LC.07.80110100", name: "Warwick/Daban" },
    { code: "LC.07.80120000", name: "Gayabois" },
    { code: "LC.07.80130000", name: "Gentil" },
    { code: "LC.07.80140000", name: "Getrine" },
    { code: "LC.07.80150000", name: "Giraud" },
    { code: "LC.07.80160000", name: "H'Erelle" },
    { code: "LC.07.80220000", name: "La Haut" },
    { code: "LC.07.80230000", name: "La Perle" },
    { code: "LC.07.80250000", name: "Londonderry" },
    { code: "LC.07.80260000", name: "Macdomel" },
    { code: "LC.07.80270000", name: "Morne Gomier" },
    { code: "LC.07.80280000", name: "Morne Le Blanc" },
    { code: "LC.07.80290000", name: "Morne Lezard Estate" },
    { code: "LC.07.80300000", name: "Morne Paul" },
    { code: "LC.07.80310000", name: "Olibo" },
    { code: "LC.07.80320000", name: "Parc Estate" },
    { code: "LC.07.80330000", name: "Piaye" },
    { code: "LC.07.80350000", name: "Saltibus" },
    { code: "LC.07.80360000", name: "Saphire" },
    { code: "LC.07.80390000", name: "Tete Morne" },
    { code: "LC.07.80410000", name: "Village" },
    { code: "LC.07.80411300", name: "Kennedy Highway/Laborie Bypass" },
  ],
  "LC.08": [
    { code: "LC.08.100010000", name: "Anbre" },
    { code: "LC.08.100030000", name: "Anse Ger" },
    { code: "LC.08.100060000", name: "Beauchamp" },
    { code: "LC.08.100070000", name: "Catter Beaufond" },
    { code: "LC.08.100090000", name: "Blanchard" },
    { code: "LC.08.100090200", name: "Chique/Blanchard" },
    { code: "LC.08.100090300", name: "Gomier" },
    { code: "LC.08.100090400", name: "Gouette" },
    { code: "LC.08.100090500", name: "Lezy" },
    { code: "LC.08.100090600", name: "Morne Vient" },
    { code: "LC.08.100110000", name: "Calypso" },
    { code: "LC.08.100120000", name: "Canelles" },
    { code: "LC.08.100130000", name: "Carriere" },
    { code: "LC.08.100140000", name: "Cazuca" },
    { code: "LC.08.100160000", name: "Delomel" },
    { code: "LC.08.100170000", name: "Desruisseaux" },
    { code: "LC.08.100170300", name: "En Mango" },
    { code: "LC.08.100170400", name: "Fond/Desruisseaux" },
    { code: "LC.08.100170500", name: "London Road" },
    { code: "LC.08.100180000", name: "Dugard" },
    { code: "LC.08.100180100", name: "Fond D'Lor/Dugard" },
    { code: "LC.08.100210000", name: "Escap" },
    { code: "LC.08.100240000", name: "Fond Estate" },
    { code: "LC.08.100260000", name: "Galba" },
    { code: "LC.08.100280000", name: "La Courville" },
    { code: "LC.08.100290000", name: "La Fille" },
    { code: "LC.08.100300000", name: "La Pointe" },
    { code: "LC.08.100310000", name: "La Tille" },
    { code: "LC.08.100320000", name: "L'Eau Mineau" },
    { code: "LC.08.100330000", name: "Lombard" },
    { code: "LC.08.100340000", name: "Mahaut" },
    { code: "LC.08.100350000", name: "Malgretoute" },
    { code: "LC.08.100360000", name: "Mamiku" },
    { code: "LC.08.100370000", name: "Mon Repos" },
    { code: "LC.08.100380000", name: "Moreau" },
    { code: "LC.08.100400000", name: "Myette Gardens" },
    { code: "LC.08.100410000", name: "New Village" },
    { code: "LC.08.100420000", name: "Palmiste Estate" },
    { code: "LC.08.100430000", name: "Patience" },
    { code: "LC.08.100430100", name: "Coolie Town" },
    { code: "LC.08.100460000", name: "Planard" },
    { code: "LC.08.100470000", name: "Praslin" },
    { code: "LC.08.100480000", name: "Rouarne" },
    { code: "LC.08.100490000", name: "Savannes" },
    { code: "LC.08.100510000", name: "Saint Marie Road" },
    { code: "LC.08.100520000", name: "Ti Riviere" },
    { code: "LC.08.100530000", name: "Ti Rocher" },
    { code: "LC.08.100530100", name: "Saut" },
    { code: "LC.08.100530200", name: "Des Blanchard" },
    { code: "LC.08.100530400", name: "Paix Bouche" },
    { code: "LC.08.100530600", name: "Tou Cochan/Ti Rocher" },
    { code: "LC.08.100540000", name: "Troumassee" },
    { code: "LC.08.100570000", name: "Village" },
    { code: "LC.08.100580000", name: "Volet" },
    { code: "LC.08.100590000", name: "St Helen Estate" },
    { code: "LC.08.100600000", name: "Rameau" },
    { code: "LC.08.100610000", name: "Honeymoon Beach" },
    { code: "LC.08.100620000", name: "Raillon Road" },
    { code: "LC.08.100630000", name: "Descatier/Six Miles" },
    { code: "LC.08.100640000", name: "Bois Canot" },
    { code: "LC.08.100650000", name: "L'Orangerie Road" },
    { code: "LC.08.100660000", name: "La Haut" },
    { code: "LC.08.100670000", name: "Mount Erole" },
    { code: "LC.08.100680000", name: "Mine" },
    { code: "LC.08.100690000", name: "La Gwen Ba" },
    { code: "LC.08.100700000", name: "La Croix" },
    { code: "LC.08.100710000", name: "L'Union" },
    { code: "LC.08.100720000", name: "Pelouze" },
    { code: "LC.08.100740000", name: "Choucomel" },
  ],
  "LC.09": [
    { code: "LC.09.60010000", name: "Anse Chastanet" },
    { code: "LC.09.60020000", name: "Beasejour/Myers Bridge" },
    { code: "LC.09.60030000", name: "Bellefond" },
    { code: "LC.09.60040000", name: "Belle Plaine" },
    { code: "LC.09.60050000", name: "Belvedere" },
    { code: "LC.09.60060000", name: "Bois D'Inde" },
    { code: "LC.09.60070000", name: "Bouton" },
    { code: "LC.09.60090000", name: "Calvary/Calvaire" },
    { code: "LC.09.60100000", name: "Chateau Belair" },
    { code: "LC.09.60110000", name: "Colombette" },
    { code: "LC.09.60120000", name: "Cresslands" },
    { code: "LC.09.60130000", name: "Morne Lastic/Desruisseaux" },
    { code: "LC.09.60140000", name: "Deville" },
    { code: "LC.09.60150000", name: "Diamond/Diamond Estate" },
    { code: "LC.09.60160000", name: "Esperance" },
    { code: "LC.09.60170000", name: "Etangs" },
    { code: "LC.09.60170100", name: "La Dauphine" },
    { code: "LC.09.60180000", name: "Fond Bernier" },
    { code: "LC.09.60190000", name: "Fond Cacoa" },
    { code: "LC.09.60200000", name: "Fond Doux" },
    { code: "LC.09.60230000", name: "Jalousie" },
    { code: "LC.09.60240000", name: "La Pearle" },
    { code: "LC.09.60260000", name: "Malgretoute" },
    { code: "LC.09.60260100", name: "Plat Pays" },
    { code: "LC.09.60270000", name: "Migny" },
    { code: "LC.09.60280000", name: "Mocha" },
    { code: "LC.09.60290000", name: "Morne Bonin" },
    { code: "LC.09.60310000", name: "Coubaril Estate" },
    { code: "LC.09.60320000", name: "Morne La Croix" },
    { code: "LC.09.60340000", name: "New Development" },
    { code: "LC.09.60350000", name: "Palmiste" },
    { code: "LC.09.60370000", name: "Rabot" },
    { code: "LC.09.60390000", name: "Ravine Claire" },
    { code: "LC.09.60420000", name: "Ruby Estate" },
    { code: "LC.09.60430000", name: "Sapphire" },
    { code: "LC.09.60440000", name: "Soufriere Estate" },
    { code: "LC.09.60450000", name: "St Phillip" },
    { code: "LC.09.60460000", name: "Sulphur Springs" },
    { code: "LC.09.60470000", name: "Ti Boug" },
    { code: "LC.09.60480000", name: "Toraille" },
    { code: "LC.09.60490000", name: "Town" },
    { code: "LC.09.60490100", name: "Barons Drive/Coin De L'Anse" },
    { code: "LC.09.60490700", name: "Lenny Hill" },
    { code: "LC.09.60500000", name: "Union Vale" },
    { code: "LC.09.60530000", name: "Zenon" },
    { code: "LC.09.60550000", name: "La Haut" },
    { code: "LC.09.60570000", name: "Terre Blanche" },
    { code: "LC.09.60580000", name: "Stonefield" },
    { code: "LC.09.60600000", name: "Fond Gens Libre" },
    { code: "LC.09.60630000", name: "St Remy Estate" },
    { code: "LC.09.60640000", name: "Compar" },
    { code: "LC.09.60660000", name: "Cenac" },
    { code: "LC.09.60670000", name: "Descolons" },
    { code: "LC.09.60680000", name: "Gros Piton" },
    { code: "LC.09.60700000", name: "Mal Maison" },
    { code: "LC.09.60710000", name: "Morne Tabac" },
    { code: "LC.09.60720000", name: "Ti Delcer" },
  ],
  "LC.10": [
    { code: "LC.10.90010000", name: "Augier" },
    { code: "LC.10.90010300", name: "Derierre Bois" },
    { code: "LC.10.90010500", name: "Obrier" },
    { code: "LC.10.90030000", name: "Beane Field" },
    { code: "LC.10.90030200", name: "Anse De Sables/Beane Field" },
    { code: "LC.10.90040000", name: "Beausejour" },
    { code: "LC.10.90050000", name: "Belle Vue" },
    { code: "LC.10.90060000", name: "Black Bay" },
    { code: "LC.10.90090000", name: "Cantonement" },
    { code: "LC.10.90100000", name: "Carierre" },
    { code: "LC.10.90110000", name: "Catin" },
    { code: "LC.10.90120000", name: "Cocoa Dan" },
    { code: "LC.10.90130000", name: "Coolie Town" },
    { code: "LC.10.90140000", name: "De Mailly" },
    { code: "LC.10.90150000", name: "Derierre Morne" },
    { code: "LC.10.90160000", name: "Eau Piquant/St Urbain" },
    { code: "LC.10.90170000", name: "Esperance" },
    { code: "LC.10.90180000", name: "Fond Sabot" },
    { code: "LC.10.90190000", name: "Grace" },
    { code: "LC.10.90190300", name: "Woodlands" },
    { code: "LC.10.90220000", name: "Hope Estate" },
    { code: "LC.10.90230000", name: "Industrial Estate" },
    { code: "LC.10.90240000", name: "Hewanorra Orchard" },
    { code: "LC.10.90250000", name: "Joyeux" },
    { code: "LC.10.90260000", name: "La Resource" },
    { code: "LC.10.90260100", name: "Docamel/La Resource" },
    { code: "LC.10.90270000", name: "La Retraite" },
    { code: "LC.10.90280000", name: "La Tourney/Cedar Heights" },
    { code: "LC.10.90300000", name: "Maganier" },
    { code: "LC.10.90330000", name: "Morne Cayenne" },
    { code: "LC.10.90340000", name: "Morne Vert" },
    { code: "LC.10.90350000", name: "Moule A Chique" },
    { code: "LC.10.90360000", name: "Pierrot" },
    { code: "LC.10.90360100", name: "Tete Morne/Morne Andrew" },
    { code: "LC.10.90370000", name: "Plut" },
    { code: "LC.10.90380000", name: "Pomme" },
    { code: "LC.10.90400000", name: "Bruceville/Shanty Town" },
    { code: "LC.10.90410000", name: "St Jude'S Highway" },
    { code: "LC.10.90430000", name: "Town" },
    { code: "LC.10.90433300", name: "Westall Group/The Mangue" },
    { code: "LC.10.90440000", name: "Vieux Fort/Laborie Highway" },
    { code: "LC.10.90440100", name: "Viancelle" },
    { code: "LC.10.90510000", name: "Vige'" },
    { code: "LC.10.90520000", name: "En Bamboo" },
    { code: "LC.10.90530000", name: "Fond Capeche" },
    { code: "LC.10.90540000", name: "Cacoa" },
  ],
  "LC.12": [
    { code: "LC.12.50010000", name: "Anse Cochon" },
    { code: "LC.12.50020000", name: "Anse Galet" },
    { code: "LC.12.50030000", name: "Anse La Verdue" },
    { code: "LC.12.50040000", name: "Belvedere" },
    { code: "LC.12.50060000", name: "Chalon" },
    { code: "LC.12.50070000", name: "Chatin" },
    { code: "LC.12.50080000", name: "Des Bottes" },
    { code: "LC.12.50110000", name: "Morne Siquot" },
    { code: "LC.12.50130000", name: "Theodrine" },
    { code: "LC.12.50140000", name: "Village" },
    { code: "LC.12.50141100", name: "Riverside Road" },
  ],
  "LK.29": [
    { code: "LK.29.21", name: "Kandy District" },
    { code: "LK.29.22", name: "Matale District" },
    { code: "LK.29.23", name: "Nuwara Eliya District" },
  ],
  "LK.30": [
    { code: "LK.30.71", name: "Anuradhapura District" },
    { code: "LK.30.72", name: "Polonnaruwa District" },
  ],
  "LK.32": [
    { code: "LK.32.61", name: "Kurunegala District" },
    { code: "LK.32.62", name: "Puttalam District" },
  ],
  "LK.33": [
    { code: "LK.33.91", name: "Ratnapura District" },
    { code: "LK.33.92", name: "Kegalle District" },
  ],
  "LK.34": [
    { code: "LK.34.31", name: "Galle District" },
    { code: "LK.34.32", name: "Matara District" },
    { code: "LK.34.33", name: "Hambantota District" },
  ],
  "LK.35": [
    { code: "LK.35.81", name: "Badulla District" },
    { code: "LK.35.82", name: "Moneragala District" },
  ],
  "LK.36": [
    { code: "LK.36.11", name: "Colombo District" },
    { code: "LK.36.12", name: "Gampaha District" },
    { code: "LK.36.13", name: "Kalutara District" },
  ],
  "LK.37": [
    { code: "LK.37.51", name: "Batticaloa District" },
    { code: "LK.37.52", name: "Ampara District" },
    { code: "LK.37.53", name: "Trincomalee District" },
  ],
  "LK.38": [
    { code: "LK.38.41", name: "Jaffna District" },
    { code: "LK.38.42", name: "Mannar District" },
    { code: "LK.38.43", name: "Vavuniya District" },
    { code: "LK.38.44", name: "Mullaitivu District" },
    { code: "LK.38.45", name: "Kilinochchi District" },
  ],
  "LR.01": [
    { code: "LR.01.2272532", name: "Zota" },
    { code: "LR.01.2274124", name: "Sanoyeah" },
    { code: "LR.01.2274491", name: "Panta" },
    { code: "LR.01.2274578", name: "Nyafokole" },
    { code: "LR.01.2275814", name: "Kokoyah" },
    { code: "LR.01.2276212", name: "Jorquelleh" },
    { code: "LR.01.2277288", name: "Fuamah" },
    { code: "LR.01.7669283", name: "Jorquelleh" },
    { code: "LR.01.7669284", name: "Suakoko" },
    { code: "LR.01.7669285", name: "Salala" },
    { code: "LR.01.9645113", name: "Yeallequelleh District" },
    { code: "LR.01.9645114", name: "Kpaai District" },
    { code: "LR.01.9645115", name: "Boinsen District" },
    { code: "LR.01.9645116", name: "Tukpahblee District" },
  ],
  "LR.09": [
    { code: "LR.09.2272565", name: "Zo-Ge" },
    { code: "LR.09.2272804", name: "Yarwein Mehnsonnoh" },
    { code: "LR.09.2274125", name: "Sanniquellie Mahn" },
    { code: "LR.09.2274221", name: "Sagleipie-Ma" },
    { code: "LR.09.2275644", name: "Keaple" },
    { code: "LR.09.2276973", name: "Gbokole" },
    { code: "LR.09.2277003", name: "Gbi and Doru" },
    { code: "LR.09.2277028", name: "Gbehlay-Geh" },
    { code: "LR.09.2279133", name: "Doe" },
    { code: "LR.09.7669286", name: "Sanniquelleh- Mahn" },
    { code: "LR.09.7669299", name: "Saclepea-Mah" },
    { code: "LR.09.9295768", name: "Tappita" },
    { code: "LR.09.9645132", name: "Wee-Gbehy-Mahn" },
    { code: "LR.09.9645133", name: "Kparblee District" },
    { code: "LR.09.9645134", name: "Boe and Quilla District" },
    { code: "LR.09.9645135", name: "Buu-Yao District" },
    { code: "LR.09.9645136", name: "Zoe-Gbao District" },
    { code: "LR.09.9645137", name: "Gbor District" },
    { code: "LR.09.9645138", name: "Leewehpea-Mahn District" },
    { code: "LR.09.9645139", name: "Meinpea-Mahn District" },
    { code: "LR.09.9645140", name: "Garr-Bain District" },
    { code: "LR.09.9645141", name: "Twan River District" },
    { code: "LR.09.9645142", name: "Yarpea Mahn District" },
    { code: "LR.09.9645143", name: "Yarmein District" },
  ],
  "LR.10": [
    { code: "LR.10.2273181", name: "Wedjah-Cabade" },
    { code: "LR.10.2273473", name: "Toto" },
    { code: "LR.10.2273482", name: "Topo" },
    { code: "LR.10.2273679", name: "Tasu" },
    { code: "LR.10.2273682", name: "Tarjuazon" },
    { code: "LR.10.2274043", name: "Seedor" },
    { code: "LR.10.2274591", name: "Nuohn Point" },
    { code: "LR.10.2274596", name: "Numo" },
    { code: "LR.10.2274818", name: "Nana Kru" },
    { code: "LR.10.2274827", name: "Nake" },
    { code: "LR.10.2275067", name: "Matro" },
    { code: "LR.10.2275592", name: "Kulu" },
    { code: "LR.10.2276117", name: "Kabor" },
    { code: "LR.10.2276156", name: "Seekon" },
    { code: "LR.10.2276354", name: "Jeetrah" },
    { code: "LR.10.2276356", name: "Jeadepo" },
    { code: "LR.10.2278113", name: "Butaw" },
    { code: "LR.10.7911028", name: "Pyneston District" },
    { code: "LR.10.9645156", name: "Kulu Shaw Boe District" },
    { code: "LR.10.9645157", name: "Plahn Nyarn District" },
    { code: "LR.10.9645158", name: "Juarzon District" },
    { code: "LR.10.9645160", name: "Pynes Town District" },
    { code: "LR.10.9645161", name: "Wedjah District" },
    { code: "LR.10.9645162", name: "Greenville District" },
    { code: "LR.10.9645163", name: "Kpayan District" },
    { code: "LR.10.9645164", name: "Dugbe River District" },
    { code: "LR.10.9645165", name: "Bokon District" },
    { code: "LR.10.9645166", name: "Jaedae District" },
    { code: "LR.10.9645167", name: "Bodae District" },
    { code: "LR.10.9645168", name: "Sanquin District Number One" },
    { code: "LR.10.9645169", name: "Sanquin District Number Two" },
    { code: "LR.10.9645170", name: "Sanquin District Number Three" },
  ],
  "LR.11": [
    { code: "LR.11.2273621", name: "Three B" },
    { code: "LR.11.2273622", name: "Three A" },
    { code: "LR.11.2273635", name: "Tenor" },
    { code: "LR.11.2276367", name: "Jayah" },
    { code: "LR.11.2276820", name: "Glarkon" },
    { code: "LR.11.2277306", name: "Trade Town" },
    { code: "LR.11.2277366", name: "Five A" },
    { code: "LR.11.2278080", name: "Campwood" },
    { code: "LR.11.7669301", name: "District #1" },
    { code: "LR.11.7669302", name: "District #2" },
    { code: "LR.11.7669303", name: "District #3" },
    { code: "LR.11.9645122", name: "Owensgrove District" },
    { code: "LR.11.9645125", name: "Saint John River City District" },
    { code: "LR.11.9645126", name: "Neekreen District" },
    { code: "LR.11.9645127", name: "Commonwealth District" },
    { code: "LR.11.9645128", name: "District Number One" },
    { code: "LR.11.9645129", name: "District Number Two" },
    { code: "LR.11.9645130", name: "District Number Three" },
    { code: "LR.11.9645131", name: "District Number Four" },
  ],
  "LR.12": [
    { code: "LR.12.2273511", name: "Tombe" },
    { code: "LR.12.2273632", name: "Tewor" },
    { code: "LR.12.2274351", name: "Porkpa District" },
    { code: "LR.12.2275757", name: "Kone" },
    { code: "LR.12.2276661", name: "Gola Konneh" },
    { code: "LR.12.2277160", name: "Garwula" },
    { code: "LR.12.7911025", name: "Robertsport District" },
    { code: "LR.12.9645004", name: "Commonwealth District" },
  ],
  "LR.13": [
    { code: "LR.13.2272794", name: "Yederabo" },
    { code: "LR.13.2273404", name: "Tuobo" },
    { code: "LR.13.2273858", name: "Sodoke" },
    { code: "LR.13.2274269", name: "Rock Town" },
    { code: "LR.13.2274336", name: "Po River" },
    { code: "LR.13.2274373", name: "Pleebo/Sodoken" },
    { code: "LR.13.2274403", name: "Picnicess" },
    { code: "LR.13.2274476", name: "Pate" },
    { code: "LR.13.2274569", name: "Nyanbo" },
    { code: "LR.13.2274778", name: "Nemea" },
    { code: "LR.13.2275351", name: "Little Wrebo" },
    { code: "LR.13.2276614", name: "Grawa" },
    { code: "LR.13.2276816", name: "Glebo" },
    { code: "LR.13.2276908", name: "Gedetarbo" },
    { code: "LR.13.2276909", name: "Gedabo" },
    { code: "LR.13.2277011", name: "Gbeta Klepo" },
    { code: "LR.13.2277030", name: "Gbelakpo" },
    { code: "LR.13.2277061", name: "Gbarlobo" },
    { code: "LR.13.2277359", name: "Flenipo" },
    { code: "LR.13.2277383", name: "Firestone" },
    { code: "LR.13.2277593", name: "Dorobo" },
    { code: "LR.13.2277859", name: "Dedabo" },
    { code: "LR.13.2278062", name: "Cavalla" },
    { code: "LR.13.2278356", name: "Bolobo" },
    { code: "LR.13.2278880", name: "Barobo" },
    { code: "LR.13.8260606", name: "Pleebo/Sodeken District" },
    { code: "LR.13.9645230", name: "Whojah District" },
    { code: "LR.13.9645231", name: "Gwelekpoken District" },
    { code: "LR.13.9645232", name: "Nyorken District" },
    { code: "LR.13.9645233", name: "Karluway Number One District" },
    { code: "LR.13.9645234", name: "Karluway Number Two District" },
  ],
  "LR.14": [
    { code: "LR.14.2273549", name: "Todee" },
    { code: "LR.14.2276087", name: "Kakata" },
    { code: "LR.14.2277769", name: "Ding" },
    { code: "LR.14.2278073", name: "Careysburg" },
    { code: "LR.14.7669292", name: "Topee" },
    { code: "LR.14.7669297", name: "Mambah-Kaba" },
    { code: "LR.14.7669298", name: "Greater Monrovia" },
    { code: "LR.14.7669300", name: "St. Paul River" },
    { code: "LR.14.9645118", name: "Saint Paul River District" },
    { code: "LR.14.9645120", name: "Commonwealth District" },
  ],
  "LR.15": [
    { code: "LR.15.2275016", name: "Suehn Mecca District" },
    { code: "LR.15.2276737", name: "Gola" },
    { code: "LR.15.2277849", name: "Dei" },
    { code: "LR.15.8714531", name: "Klay District" },
    { code: "LR.15.9645005", name: "Senjeh District" },
    { code: "LR.15.9645006", name: "Dowein District" },
  ],
  "LR.16": [
    { code: "LR.16.2273190", name: "Webado" },
    { code: "LR.16.2274101", name: "Sasstown" },
    { code: "LR.16.2276161", name: "Lower Jloh" },
    { code: "LR.16.2276626", name: "Grand Cess Wedabo" },
    { code: "LR.16.2277191", name: "Garraway" },
    { code: "LR.16.2278169", name: "Buah" },
    { code: "LR.16.2278361", name: "Bolloh District" },
    { code: "LR.16.2278890", name: "Barclayville" },
    { code: "LR.16.9645219", name: "Forpoh District" },
    { code: "LR.16.9645220", name: "Wlogba District" },
    { code: "LR.16.9645221", name: "Dweh District" },
    { code: "LR.16.9645222", name: "Kpi District" },
    { code: "LR.16.9645223", name: "Dorbor District" },
    { code: "LR.16.9645224", name: "Fenetoe District" },
    { code: "LR.16.9645225", name: "Upper Jloh District" },
    { code: "LR.16.9645226", name: "Nrokwia-Wesldow District" },
    { code: "LR.16.9645227", name: "Felo-Jekwi District" },
    { code: "LR.16.9645228", name: "Bleebo District" },
    { code: "LR.16.9645229", name: "Trenbo District" },
  ],
  "LR.17": [
    { code: "LR.17.2275179", name: "Mambah Kaba" },
    { code: "LR.17.2276853", name: "Gibi" },
    { code: "LR.17.7670839", name: "Firestone" },
  ],
  "LR.18": [
    { code: "LR.18.2274273", name: "Rock Cess" },
    { code: "LR.18.2277365", name: "Mowe" },
    { code: "LR.18.9645144", name: "Doedain District" },
    { code: "LR.18.9645145", name: "Jo River District" },
    { code: "LR.18.9645146", name: "Norwein District" },
    { code: "LR.18.9645147", name: "Central River Cess District" },
    { code: "LR.18.9645148", name: "Fen River District" },
    { code: "LR.18.9645149", name: "Zarflahn District" },
    { code: "LR.18.9645150", name: "Beawor District" },
    { code: "LR.18.9645151", name: "Sam Gbalor District" },
  ],
  "LR.19": [
    { code: "LR.19.2273657", name: "Tchien" },
    { code: "LR.19.2274312", name: "Putu" },
    { code: "LR.19.2274719", name: "Niabo" },
    { code: "LR.19.2275728", name: "Konobo" },
    { code: "LR.19.2276801", name: "Glio-Twarbo" },
    { code: "LR.19.2276983", name: "Gbobo" },
    { code: "LR.19.2277043", name: "Gbazohn" },
    { code: "LR.19.2278611", name: "B’hai District" },
    { code: "LR.19.9645153", name: "Gboe-Ploe District" },
    { code: "LR.19.9645154", name: "Gbao District" },
    { code: "LR.19.9645155", name: "Cavala District" },
  ],
  "LR.20": [
    { code: "LR.20.2273272", name: "Waiglomai-Woniglomai" },
    { code: "LR.20.2275898", name: "Kisi" },
    { code: "LR.20.2276054", name: "Kambo Hills" },
    { code: "LR.20.2276555", name: "Guma-Mendi" },
    { code: "LR.20.2276828", name: "Gizima-Ziema" },
    { code: "LR.20.2277082", name: "Gbandi" },
    { code: "LR.20.2277102", name: "Gbalein Faala" },
    { code: "LR.20.2278307", name: "Bonde-Wubomai" },
    { code: "LR.20.2569974", name: "Guma" },
    { code: "LR.20.9645009", name: "Vahun District" },
    { code: "LR.20.9645106", name: "Foya District" },
    { code: "LR.20.9645107", name: "Kolahun District" },
    { code: "LR.20.9645108", name: "Voinjama District" },
    { code: "LR.20.9645110", name: "Zorzor District" },
    { code: "LR.20.9645111", name: "Salayea District" },
    { code: "LR.20.9645112", name: "Quardu Gboni District" },
  ],
  "LR.21": [
    { code: "LR.21.2275770", name: "Kongba District" },
    { code: "LR.21.2276743", name: "Goije" },
    { code: "LR.21.2278250", name: "Bopolu" },
    { code: "LR.21.2278379", name: "Bokomu" },
    { code: "LR.21.2278733", name: "Belleh" },
    { code: "LR.21.9645007", name: "Gounwolaila District" },
    { code: "LR.21.9645008", name: "Gbarma District" },
  ],
  "LR.22": [
    { code: "LR.22.2273186", name: "Webbo District" },
    { code: "LR.22.2273443", name: "Tuobo" },
    { code: "LR.22.2273599", name: "Tienpo" },
    { code: "LR.22.2274235", name: "Sarbo" },
    { code: "LR.22.2274502", name: "Palipo" },
    { code: "LR.22.2275896", name: "Kitabo" },
    { code: "LR.22.2276934", name: "Glaro" },
    { code: "LR.22.2277041", name: "Gbeapo District" },
    { code: "LR.22.2278019", name: "Chedepo" },
    { code: "LR.22.9645171", name: "Karforh District" },
    { code: "LR.22.9645172", name: "Nanee District" },
    { code: "LR.22.9645173", name: "Nyenawliken District" },
    { code: "LR.22.9645174", name: "Potupo District" },
    { code: "LR.22.9645175", name: "Nyenebo District" },
  ],
  "LS.10": [
    { code: "LS.10.7670808", name: "Mokomahatsi" },
    { code: "LS.10.7670809", name: "Mokhachane" },
    { code: "LS.10.7670811", name: "Mapoteng" },
    { code: "LS.10.7670815", name: "Makhoroana" },
    { code: "LS.10.7670819", name: "Urban" },
    { code: "LS.10.7670820", name: "Mamathe" },
  ],
  "LS.11": [
    { code: "LS.11.11258465", name: "Motete" },
    { code: "LS.11.11280716", name: "Qalo" },
  ],
  "LS.12": [
    { code: "LS.12.7303922", name: "Khomokhoana Community" },
    { code: "LS.12.7670780", name: "Urban" },
    { code: "LS.12.7670807", name: "Hleoheng" },
  ],
  "LS.14": [
    { code: "LS.14.11256888", name: "Rothe" },
    { code: "LS.14.11428652", name: "Maseru Central" },
    { code: "LS.14.7522489", name: "Makhaleng Constituency" },
  ],
  "LT.56": [
    { code: "LT.56.11", name: "Alytaus rajonas" },
    { code: "LT.56.15", name: "Druskininkai" },
    { code: "LT.56.33", name: "Alytus" },
    { code: "LT.56.38", name: "Varėna" },
    { code: "LT.56.59", name: "Lazdijai" },
  ],
  "LT.57": [
    { code: "LT.57.12", name: "Birštonas" },
    { code: "LT.57.19", name: "Kauno rajonas" },
    { code: "LT.57.46", name: "Jonava" },
    { code: "LT.57.49", name: "Kaišiadorys" },
    { code: "LT.57.52", name: "Kaunas" },
    { code: "LT.57.53", name: "Kėdainiai" },
    { code: "LT.57.69", name: "Prienai" },
    { code: "LT.57.72", name: "Raseiniai" },
  ],
  "LT.58": [
    { code: "LT.58.21", name: "Klaipėdos rajonas" },
    { code: "LT.58.23", name: "Neringa" },
    { code: "LT.58.25", name: "Palanga" },
    { code: "LT.58.55", name: "Klaipėda" },
    { code: "LT.58.56", name: "Kretinga" },
    { code: "LT.58.75", name: "Skuodas" },
    { code: "LT.58.88", name: "Šilutė" },
  ],
  "LT.59": [
    { code: "LT.59.18", name: "Marijampolė Municipality" },
    { code: "LT.59.39", name: "Vilkaviškis District Municipality" },
    { code: "LT.59.48", name: "Kalvarija Municipality" },
    { code: "LT.59.51", name: "Marijampolės Rajonas" },
    { code: "LT.59.58", name: "Kazlų Rūda Municipality" },
    { code: "LT.59.84", name: "Sakiai" },
  ],
  "LT.60": [
    { code: "LT.60.27", name: "Panevėžys City" },
    { code: "LT.60.36", name: "Biržai" },
    { code: "LT.60.57", name: "Kupiškis" },
    { code: "LT.60.66", name: "Panevėžys District Municipality" },
    { code: "LT.60.67", name: "Pasvalys" },
    { code: "LT.60.73", name: "Rokiškis" },
  ],
  "LT.61": [
    { code: "LT.61.29", name: "Šiaulių rajonas" },
    { code: "LT.61.32", name: "Akmenės Rajonas" },
    { code: "LT.61.47", name: "Joniškis" },
    { code: "LT.61.54", name: "Kelmė" },
    { code: "LT.61.65", name: "Pakruojis" },
    { code: "LT.61.71", name: "Radviliškis" },
    { code: "LT.61.91", name: "Šiauliai" },
  ],
  "LT.62": [
    { code: "LT.62.63", name: "Pagėgiai" },
    { code: "LT.62.77", name: "Tauragė" },
    { code: "LT.62.87", name: "Šilalė" },
    { code: "LT.62.94", name: "Jurbarkas" },
  ],
  "LT.63": [
    { code: "LT.63.61", name: "Mažeikiai" },
    { code: "LT.63.68", name: "Plungė" },
    { code: "LT.63.74", name: "Rietavas" },
    { code: "LT.63.78", name: "Telšiai" },
  ],
  "LT.64": [
    { code: "LT.64.30", name: "Visaginas" },
    { code: "LT.64.34", name: "Anykščiai" },
    { code: "LT.64.43", name: "Zarasai" },
    { code: "LT.64.45", name: "Ignalina" },
    { code: "LT.64.62", name: "Moletai" },
    { code: "LT.64.82", name: "Utena" },
  ],
  "LT.65": [
    { code: "LT.65.13", name: "Vilnius District Municipality" },
    { code: "LT.65.41", name: "Vilnius" },
    { code: "LT.65.42", name: "Elektrėnai" },
    { code: "LT.65.79", name: "Trakai" },
    { code: "LT.65.81", name: "Ukmergė" },
    { code: "LT.65.85", name: "Šalčininkai" },
    { code: "LT.65.86", name: "Svencionys" },
    { code: "LT.65.89", name: "Sirvintos" },
  ],
  "LU.CA": [
    { code: "LU.CA.03", name: "Dippach" },
    { code: "LU.CA.04", name: "Garnich" },
    { code: "LU.CA.05", name: "Hobscheid" },
    { code: "LU.CA.06", name: "Kehlen" },
    { code: "LU.CA.07", name: "Koerich" },
    { code: "LU.CA.08", name: "Kopstal" },
    { code: "LU.CA.09", name: "Mamer" },
    { code: "LU.CA.10", name: "Septfontaines" },
    { code: "LU.CA.11", name: "Steinfort" },
    { code: "LU.CA.8641865", name: "Käerjeng" },
  ],
  "LU.CL": [
    { code: "LU.CL.01", name: "Wincrange" },
    { code: "LU.CL.03", name: "Clervaux" },
    { code: "LU.CL.09", name: "Troisvierges" },
    { code: "LU.CL.10", name: "Weiswampach" },
    { code: "LU.CL.63", name: "Parc Hosingen" },
  ],
  "LU.DI": [
    { code: "LU.DI.02", name: "Bettendorf" },
    { code: "LU.DI.03", name: "Bourscheid" },
    { code: "LU.DI.04", name: "Diekirch" },
    { code: "LU.DI.06", name: "Erpeldange" },
    { code: "LU.DI.07", name: "Ettelbruck" },
    { code: "LU.DI.08", name: "Feulen" },
    { code: "LU.DI.11", name: "Mertzig" },
    { code: "LU.DI.12", name: "Reisdorf" },
    { code: "LU.DI.13", name: "Schieren" },
    { code: "LU.DI.8641526", name: "Aerenzdallgemeng" },
  ],
  "LU.EC": [
    { code: "LU.EC.01", name: "Beaufort" },
    { code: "LU.EC.02", name: "Bech" },
    { code: "LU.EC.03", name: "Berdorf" },
    { code: "LU.EC.04", name: "Consdorf" },
    { code: "LU.EC.05", name: "Echternach" },
    { code: "LU.EC.06", name: "Mompach" },
    { code: "LU.EC.07", name: "Rosport" },
    { code: "LU.EC.08", name: "Waldbillig" },
  ],
  "LU.ES": [
    { code: "LU.ES.01", name: "Bettembourg" },
    { code: "LU.ES.02", name: "Differdange" },
    { code: "LU.ES.03", name: "Dudelange" },
    { code: "LU.ES.04", name: "Esch-sur-Alzette" },
    { code: "LU.ES.05", name: "Frisange" },
    { code: "LU.ES.06", name: "Kayl" },
    { code: "LU.ES.07", name: "Leudelange" },
    { code: "LU.ES.08", name: "Mondercange" },
    { code: "LU.ES.09", name: "Pétange" },
    { code: "LU.ES.10", name: "Reckange-sur-Mess" },
    { code: "LU.ES.11", name: "Roeser" },
    { code: "LU.ES.12", name: "Rumelange" },
    { code: "LU.ES.13", name: "Sanem" },
    { code: "LU.ES.14", name: "Schifflange" },
  ],
  "LU.GR": [
    { code: "LU.GR.01", name: "Betzdorf" },
    { code: "LU.GR.02", name: "Biwer" },
    { code: "LU.GR.03", name: "Flaxweiler" },
    { code: "LU.GR.04", name: "Grevenmacher" },
    { code: "LU.GR.05", name: "Junglinster" },
    { code: "LU.GR.06", name: "Manternach" },
    { code: "LU.GR.07", name: "Mertert" },
    { code: "LU.GR.09", name: "Wormeldange" },
  ],
  "LU.LU": [
    { code: "LU.LU.01", name: "Bertrange" },
    { code: "LU.LU.02", name: "Contern" },
    { code: "LU.LU.03", name: "Hesperange" },
    { code: "LU.LU.04", name: "Niederanven" },
    { code: "LU.LU.05", name: "Sandweiler" },
    { code: "LU.LU.06", name: "Schuttrange" },
    { code: "LU.LU.07", name: "Steinsel" },
    { code: "LU.LU.08", name: "Strassen" },
    { code: "LU.LU.09", name: "Walferdange" },
    { code: "LU.LU.10", name: "Weiler-la-Tour" },
    { code: "LU.LU.2960317", name: "Ville de Luxembourg" },
  ],
  "LU.ME": [
    { code: "LU.ME.01", name: "Berg" },
    { code: "LU.ME.02", name: "Bissen" },
    { code: "LU.ME.03", name: "Boevange-sur-Attert" },
    { code: "LU.ME.04", name: "Fischbach" },
    { code: "LU.ME.05", name: "Heffingen" },
    { code: "LU.ME.06", name: "Larochette" },
    { code: "LU.ME.07", name: "Lintgen" },
    { code: "LU.ME.08", name: "Lorentzweiler" },
    { code: "LU.ME.09", name: "Mersch" },
    { code: "LU.ME.10", name: "Nommern" },
    { code: "LU.ME.11", name: "Tuntange" },
  ],
  "LU.RD": [
    { code: "LU.RD.02", name: "Beckerich" },
    { code: "LU.RD.05", name: "Ell" },
    { code: "LU.RD.06", name: "Rambrouch" },
    { code: "LU.RD.07", name: "Grosbous" },
    { code: "LU.RD.09", name: "Redange-sur-Attert" },
    { code: "LU.RD.10", name: "Saeul" },
    { code: "LU.RD.11", name: "Useldange" },
    { code: "LU.RD.12", name: "Vichten" },
    { code: "LU.RD.13", name: "Wahl" },
    { code: "LU.RD.8641291", name: "Commune de Préizerdaul" },
  ],
  "LU.RM": [
    { code: "LU.RM.00", name: "Bous" },
    { code: "LU.RM.02", name: "Dalheim" },
    { code: "LU.RM.03", name: "Lenningen" },
    { code: "LU.RM.04", name: "Mondorf-les-Bains" },
    { code: "LU.RM.05", name: "Schengen" },
    { code: "LU.RM.06", name: "Remich" },
    { code: "LU.RM.07", name: "Stadtbredimus" },
    { code: "LU.RM.08", name: "Waldbredimus" },
  ],
  "LU.VD": [
    { code: "LU.VD.01", name: "Tandel" },
    { code: "LU.VD.02", name: "Putscheid" },
    { code: "LU.VD.03", name: "Vianden" },
  ],
  "LU.WI": [
    { code: "LU.WI.01", name: "Boulaide" },
    { code: "LU.WI.02", name: "Esch-sur-Sûre" },
    { code: "LU.WI.04", name: "Goesdorf" },
    { code: "LU.WI.05", name: "Lac de la Haute-Sûre" },
    { code: "LU.WI.11", name: "Wiltz" },
    { code: "LU.WI.13", name: "Winseler" },
    { code: "LU.WI.8641289", name: "Kiischpelt" },
  ],
  "LV.01": [
    { code: "LV.01.0320201", name: "Aizkraukle" },
    { code: "LV.01.0320244", name: "Aizkraukles pagasts" },
  ],
  "LV.02": [
    { code: "LV.02.0360201", name: "Alūksne" },
    { code: "LV.02.0360242", name: "Alsviķu pagasts" },
    { code: "LV.02.0360244", name: "Annas pagasts" },
    { code: "LV.02.0360252", name: "Ilzenes pagasts" },
    { code: "LV.02.0360256", name: "Jaunalūksnes pagasts" },
    { code: "LV.02.0360258", name: "Jaunannas pagasts" },
    { code: "LV.02.0360260", name: "Jaunlaicenes pagasts" },
    { code: "LV.02.0360264", name: "Kalncempju pagasts" },
    { code: "LV.02.0360268", name: "Liepnas pagasts" },
    { code: "LV.02.0360272", name: "Malienas pagasts" },
    { code: "LV.02.0360274", name: "Mālupes pagasts" },
    { code: "LV.02.0360276", name: "Mārkalnes pagasts" },
    { code: "LV.02.0360280", name: "Pededzes pagasts" },
    { code: "LV.02.0360288", name: "Veclaicenes pagasts" },
    { code: "LV.02.0360294", name: "Zeltiņu pagasts" },
    { code: "LV.02.0360296", name: "Ziemera pagasts" },
  ],
  "LV.03": [
    { code: "LV.03.0380201", name: "Balvi" },
    { code: "LV.03.0380246", name: "Balvu pagasts" },
    { code: "LV.03.0380248", name: "Bērzkalnes pagasts" },
    { code: "LV.03.0380250", name: "Bērzpils pagasts" },
    { code: "LV.03.0380252", name: "Briežuciema pagasts" },
    { code: "LV.03.0380256", name: "Krišjāņu pagasts" },
    { code: "LV.03.0380258", name: "Kubulu pagasts" },
    { code: "LV.03.0380266", name: "Lazdulejas pagasts" },
    { code: "LV.03.0380286", name: "Tilžas pagasts" },
    { code: "LV.03.0380290", name: "Vectilžas pagasts" },
    { code: "LV.03.0380294", name: "Vīksnas pagasts" },
  ],
  "LV.04": [
    { code: "LV.04.0400201", name: "Bauska" },
    { code: "LV.04.0400246", name: "Brunavas pagasts" },
    { code: "LV.04.0400250", name: "Ceraukstes pagasts" },
    { code: "LV.04.0400252", name: "Codes pagasts" },
    { code: "LV.04.0400256", name: "Dāviņu pagasts" },
    { code: "LV.04.0400260", name: "Gailīšu pagasts" },
    { code: "LV.04.0400268", name: "Īslīces pagasts" },
    { code: "LV.04.0400272", name: "Mežotnes pagasts" },
    { code: "LV.04.0400292", name: "Vecsaules pagasts" },
  ],
  "LV.05": [
    { code: "LV.05.0420201", name: "Cēsis" },
    { code: "LV.05.0420290", name: "Vaives pagasts" },
  ],
  "LV.06": [
    { code: "LV.06.0050000", name: "Daugavpils" },
  ],
  "LV.07": [
    { code: "LV.07.0440242", name: "Ambeļu pagasts" },
    { code: "LV.07.0440246", name: "Biķernieku pagasts" },
    { code: "LV.07.0440250", name: "Demenes pagasts" },
    { code: "LV.07.0440252", name: "Dubnas pagasts" },
    { code: "LV.07.0440260", name: "Kalkūnes pagasts" },
    { code: "LV.07.0440262", name: "Kalupes pagasts" },
    { code: "LV.07.0440264", name: "Laucesas pagasts" },
    { code: "LV.07.0440268", name: "Līksnas pagasts" },
    { code: "LV.07.0440270", name: "Maļinovas pagasts" },
    { code: "LV.07.0440272", name: "Medumu pagasts" },
    { code: "LV.07.0440274", name: "Naujenes pagasts" },
    { code: "LV.07.0440276", name: "Nīcgales pagasts" },
    { code: "LV.07.0440284", name: "Salienas pagasts" },
    { code: "LV.07.0440286", name: "Skrudalienas pagasts" },
    { code: "LV.07.0440288", name: "Sventes pagasts" },
    { code: "LV.07.0440292", name: "Tabores pagasts" },
    { code: "LV.07.0440294", name: "Vaboles pagasts" },
    { code: "LV.07.0440296", name: "Vecsalienas pagasts" },
    { code: "LV.07.0440298", name: "Višķu pagasts" },
  ],
  "LV.08": [
    { code: "LV.08.0460201", name: "Dobele" },
    { code: "LV.08.0460242", name: "Annenieku pagasts" },
    { code: "LV.08.0460246", name: "Auru pagasts" },
    { code: "LV.08.0460252", name: "Bērzes pagasts" },
    { code: "LV.08.0460254", name: "Bikstu pagasts" },
    { code: "LV.08.0460260", name: "Dobeles pagasts" },
    { code: "LV.08.0460268", name: "Jaunbērzes pagasts" },
    { code: "LV.08.0460272", name: "Krimūnu pagasts" },
    { code: "LV.08.0460280", name: "Naudītes pagasts" },
    { code: "LV.08.0460284", name: "Penkules pagasts" },
    { code: "LV.08.0460298", name: "Zebrenes pagasts" },
  ],
  "LV.09": [
    { code: "LV.09.0500201", name: "Gulbene" },
    { code: "LV.09.0500244", name: "Beļavas pagasts" },
    { code: "LV.09.0500248", name: "Daukstu pagasts" },
    { code: "LV.09.0500252", name: "Druvienas pagasts" },
    { code: "LV.09.0500256", name: "Galgauskas pagasts" },
    { code: "LV.09.0500260", name: "Jaungulbenes pagasts" },
    { code: "LV.09.0500264", name: "Lejasciema pagasts" },
    { code: "LV.09.0500268", name: "Litenes pagasts" },
    { code: "LV.09.0500272", name: "Lizuma pagasts" },
    { code: "LV.09.0500276", name: "Līgo pagasts" },
    { code: "LV.09.0500284", name: "Rankas pagasts" },
    { code: "LV.09.0500288", name: "Stāmerienas pagasts" },
    { code: "LV.09.0500290", name: "Stradu pagasts" },
    { code: "LV.09.0500294", name: "Tirzas pagasts" },
  ],
  "LV.10": [
    { code: "LV.10.0560248", name: "Ābeļu pagasts" },
    { code: "LV.10.0560252", name: "Dignājas pagasts" },
    { code: "LV.10.0560254", name: "Dunavas pagasts" },
    { code: "LV.10.0560266", name: "Kalna pagasts" },
    { code: "LV.10.0560274", name: "Leimaņu pagasts" },
    { code: "LV.10.0560282", name: "Rubenes pagasts" },
    { code: "LV.10.0560298", name: "Zasas pagasts" },
  ],
  "LV.11": [
    { code: "LV.11.0090000", name: "Jelgava" },
  ],
  "LV.12": [
    { code: "LV.12.0540248", name: "Elejas pagasts" },
    { code: "LV.12.0540252", name: "Glūdas pagasts" },
    { code: "LV.12.0540256", name: "Jaunsvirlaukas pagasts" },
    { code: "LV.12.0540258", name: "Kalnciema pagasts" },
    { code: "LV.12.0540260", name: "Lielplatones pagasts" },
    { code: "LV.12.0540262", name: "Līvbērzes pagasts" },
    { code: "LV.12.0540270", name: "Platones pagasts" },
    { code: "LV.12.0540274", name: "Sesavas pagasts" },
    { code: "LV.12.0540282", name: "Svētes pagasts" },
    { code: "LV.12.0540286", name: "Valgundes pagasts" },
    { code: "LV.12.0540290", name: "Vilces pagasts" },
    { code: "LV.12.0540292", name: "Vircavas pagasts" },
    { code: "LV.12.0540296", name: "Zaļenieku pagasts" },
  ],
  "LV.13": [
    { code: "LV.13.0130000", name: "Jūrmala" },
  ],
  "LV.14": [
    { code: "LV.14.0600201", name: "Krāslava" },
    { code: "LV.14.0600248", name: "Aulejas pagasts" },
    { code: "LV.14.0600262", name: "Indras pagasts" },
    { code: "LV.14.0600264", name: "Izvaltas pagasts" },
    { code: "LV.14.0600268", name: "Kalniešu pagasts" },
    { code: "LV.14.0600270", name: "Kaplavas pagasts" },
    { code: "LV.14.0600274", name: "Kombuļu pagasts" },
    { code: "LV.14.0600278", name: "Krāslavas pagasts" },
    { code: "LV.14.0600284", name: "Piedrujas pagasts" },
    { code: "LV.14.0600286", name: "Robežnieku pagasts" },
    { code: "LV.14.0600288", name: "Skaistas pagasts" },
    { code: "LV.14.0600296", name: "Ūdrīšu pagasts" },
  ],
  "LV.15": [
    { code: "LV.15.0620201", name: "Kuldīga" },
    { code: "LV.15.0620246", name: "Ēdoles pagasts" },
    { code: "LV.15.0620250", name: "Gudenieku pagasts" },
    { code: "LV.15.0620254", name: "Īvandes pagasts" },
    { code: "LV.15.0620258", name: "Kabiles pagasts" },
    { code: "LV.15.0620260", name: "Kurmāles pagasts" },
    { code: "LV.15.0620264", name: "Laidu pagasts" },
    { code: "LV.15.0620272", name: "Padures pagasts" },
    { code: "LV.15.0620274", name: "Pelču pagasts" },
    { code: "LV.15.0620280", name: "Rendas pagasts" },
    { code: "LV.15.0620284", name: "Rumbas pagasts" },
    { code: "LV.15.0620290", name: "Snēpeles pagasts" },
    { code: "LV.15.0620292", name: "Turlavas pagasts" },
    { code: "LV.15.0620296", name: "Vārmes pagasts" },
  ],
  "LV.16": [
    { code: "LV.16.0170000", name: "Liepāja" },
  ],
  "LV.18": [
    { code: "LV.18.0660201", name: "Limbaži" },
    { code: "LV.18.0660252", name: "Katvaru pagasts" },
    { code: "LV.18.0660264", name: "Limbažu pagasts" },
    { code: "LV.18.0660268", name: "Pāles pagasts" },
    { code: "LV.18.0660276", name: "Skultes pagasts" },
    { code: "LV.18.0660280", name: "Umurgas pagasts" },
    { code: "LV.18.0660284", name: "Vidrižu pagasts" },
    { code: "LV.18.0660288", name: "Viļķenes pagasts" },
  ],
  "LV.19": [
    { code: "LV.19.0680201", name: "Ludza" },
    { code: "LV.19.0680246", name: "Briģu pagasts" },
    { code: "LV.19.0680250", name: "Cirmas pagasts" },
    { code: "LV.19.0680258", name: "Isnaudas pagasts" },
    { code: "LV.19.0680260", name: "Istras pagasts" },
    { code: "LV.19.0680278", name: "Nirzas pagasts" },
    { code: "LV.19.0680280", name: "Ņukšu pagasts" },
    { code: "LV.19.0680286", name: "Pildas pagasts" },
    { code: "LV.19.0680288", name: "Pureņu pagasts" },
    { code: "LV.19.0680292", name: "Rundēnu pagasts" },
  ],
  "LV.20": [
    { code: "LV.20.0700201", name: "Madona" },
    { code: "LV.20.0700242", name: "Aronas pagasts" },
    { code: "LV.20.0700244", name: "Barkavas pagasts" },
    { code: "LV.20.0700246", name: "Bērzaunes pagasts" },
    { code: "LV.20.0700250", name: "Dzelzavas pagasts" },
    { code: "LV.20.0700262", name: "Kalsnavas pagasts" },
    { code: "LV.20.0700266", name: "Lazdonas pagasts" },
    { code: "LV.20.0700268", name: "Liezēres pagasts" },
    { code: "LV.20.0700270", name: "Ļaudonas pagasts" },
    { code: "LV.20.0700274", name: "Mārcienas pagasts" },
    { code: "LV.20.0700276", name: "Mētrienas pagasts" },
    { code: "LV.20.0700282", name: "Ošupes pagasts" },
    { code: "LV.20.0700286", name: "Praulienas pagasts" },
    { code: "LV.20.0700290", name: "Sarkaņu pagasts" },
    { code: "LV.20.0700296", name: "Vestienas pagasts" },
  ],
  "LV.21": [
    { code: "LV.21.0740201", name: "Ogre" },
    { code: "LV.21.0740252", name: "Krapes pagasts" },
    { code: "LV.21.0740256", name: "Ķeipenes pagasts" },
    { code: "LV.21.0740260", name: "Lauberes pagasts" },
    { code: "LV.21.0740268", name: "Madlienas pagasts" },
    { code: "LV.21.0740272", name: "Mazozolu pagasts" },
    { code: "LV.21.0740276", name: "Meņģeles pagasts" },
    { code: "LV.21.0740280", name: "Ogresgala pagasts" },
    { code: "LV.21.0740288", name: "Suntažu pagasts" },
    { code: "LV.21.0740292", name: "Taurupes pagasts" },
  ],
  "LV.22": [
    { code: "LV.22.0760201", name: "Preiļi" },
    { code: "LV.22.0760244", name: "Aizkalnes pagasts" },
    { code: "LV.22.0760256", name: "Pelēču pagasts" },
    { code: "LV.22.0760258", name: "Preiļu pagasts" },
    { code: "LV.22.0760274", name: "Saunas pagasts" },
  ],
  "LV.23": [
    { code: "LV.23.0210000", name: "Rēzekne" },
  ],
  "LV.24": [
    { code: "LV.24.0780242", name: "Audriņu pagasts" },
    { code: "LV.24.0780244", name: "Bērzgales pagasts" },
    { code: "LV.24.0780246", name: "Čornajas pagasts" },
    { code: "LV.24.0780250", name: "Dricānu pagasts" },
    { code: "LV.24.0780252", name: "Feimaņu pagasts" },
    { code: "LV.24.0780254", name: "Gaigalavas pagasts" },
    { code: "LV.24.0780256", name: "Griškānu pagasts" },
    { code: "LV.24.0780258", name: "Ilzeskalna pagasts" },
    { code: "LV.24.0780260", name: "Kantinieku pagasts" },
    { code: "LV.24.0780262", name: "Kaunatas pagasts" },
    { code: "LV.24.0780266", name: "Lendžu pagasts" },
    { code: "LV.24.0780268", name: "Lūznavas pagasts" },
    { code: "LV.24.0780270", name: "Maltas pagasts" },
    { code: "LV.24.0780272", name: "Mākoņkalna pagasts" },
    { code: "LV.24.0780274", name: "Nagļu pagasts" },
    { code: "LV.24.0780276", name: "Ozolaines pagasts" },
    { code: "LV.24.0780278", name: "Ozolmuižas pagasts" },
    { code: "LV.24.0780280", name: "Pušas pagasts" },
    { code: "LV.24.0780282", name: "Rikavas pagasts" },
    { code: "LV.24.0780284", name: "Nautrēnu pagasts" },
    { code: "LV.24.0780286", name: "Sakstagala pagasts" },
    { code: "LV.24.0780288", name: "Silmalas pagasts" },
    { code: "LV.24.0780292", name: "Stoļerovas pagasts" },
    { code: "LV.24.0780294", name: "Stružānu pagasts" },
    { code: "LV.24.0780296", name: "Vērēmu pagasts" },
  ],
  "LV.25": [
    { code: "LV.25.0010000", name: "Rīga" },
  ],
  "LV.27": [
    { code: "LV.27.0840201", name: "Saldus" },
    { code: "LV.27.0840248", name: "Ezeres pagasts" },
    { code: "LV.27.0840256", name: "Jaunauces pagasts" },
    { code: "LV.27.0840258", name: "Jaunlutriņu pagasts" },
    { code: "LV.27.0840262", name: "Kursīšu pagasts" },
    { code: "LV.27.0840266", name: "Lutriņu pagasts" },
    { code: "LV.27.0840270", name: "Nīgrandes pagasts" },
    { code: "LV.27.0840272", name: "Novadnieku pagasts" },
    { code: "LV.27.0840276", name: "Pampāļu pagasts" },
    { code: "LV.27.0840282", name: "Rubas pagasts" },
    { code: "LV.27.0840286", name: "Saldus pagasts" },
    { code: "LV.27.0840288", name: "Šķēdes pagasts" },
    { code: "LV.27.0840292", name: "Vadakstes pagasts" },
    { code: "LV.27.0840294", name: "Zaņas pagasts" },
    { code: "LV.27.0840296", name: "Zirņu pagasts" },
    { code: "LV.27.0840298", name: "Zvārdes pagasts" },
  ],
  "LV.28": [
    { code: "LV.28.0880201", name: "Talsi" },
    { code: "LV.28.0880213", name: "Sabile" },
    { code: "LV.28.0880215", name: "Stende" },
    { code: "LV.28.0880217", name: "Valdemārpils" },
    { code: "LV.28.0880237", name: "Ārlavas pagasts" },
    { code: "LV.28.0880242", name: "Abavas pagasts" },
    { code: "LV.28.0880246", name: "Balgales pagasts" },
    { code: "LV.28.0880254", name: "Ģibuļu pagasts" },
    { code: "LV.28.0880258", name: "Īves pagasts" },
    { code: "LV.28.0880264", name: "Ķūļciema pagasts" },
    { code: "LV.28.0880268", name: "Laidzes pagasts" },
    { code: "LV.28.0880270", name: "Laucienes pagasts" },
    { code: "LV.28.0880272", name: "Lībagu pagasts" },
    { code: "LV.28.0880274", name: "Lubes pagasts" },
    { code: "LV.28.0880286", name: "Strazdes pagasts" },
    { code: "LV.28.0880292", name: "Valdgales pagasts" },
    { code: "LV.28.0880294", name: "Vandzenes pagasts" },
    { code: "LV.28.0880296", name: "Virbu pagasts" },
  ],
  "LV.29": [
    { code: "LV.29.0900201", name: "Tukums" },
    { code: "LV.29.0900246", name: "Degoles pagasts" },
    { code: "LV.29.0900248", name: "Džūkstes pagasts" },
    { code: "LV.29.0900254", name: "Irlavas pagasts" },
    { code: "LV.29.0900258", name: "Jaunsātu pagasts" },
    { code: "LV.29.0900268", name: "Lestenes pagasts" },
    { code: "LV.29.0900274", name: "Pūres pagasts" },
    { code: "LV.29.0900278", name: "Sēmes pagasts" },
    { code: "LV.29.0900280", name: "Slampes pagasts" },
    { code: "LV.29.0900284", name: "Tumes pagasts" },
    { code: "LV.29.0900296", name: "Zentenes pagasts" },
  ],
  "LV.30": [
    { code: "LV.30.0940201", name: "Valka" },
    { code: "LV.30.0940252", name: "Ērģemes pagasts" },
    { code: "LV.30.0940266", name: "Kārķu pagasts" },
    { code: "LV.30.0940288", name: "Valkas pagasts" },
    { code: "LV.30.0940292", name: "Vijciema pagasts" },
    { code: "LV.30.0940296", name: "Zvārtavas pagasts" },
  ],
  "LV.31": [
    { code: "LV.31.0250000", name: "Valmiera" },
  ],
  "LV.32": [
    { code: "LV.32.0270000", name: "Ventspils" },
  ],
  "LV.33": [
    { code: "LV.33.0980213", name: "Piltene" },
    { code: "LV.33.0980233", name: "Piltenes pagasts" },
    { code: "LV.33.0980244", name: "Ances pagasts" },
    { code: "LV.33.0980250", name: "Jūrkalnes pagasts" },
    { code: "LV.33.0980256", name: "Popes pagasts" },
    { code: "LV.33.0980260", name: "Puzes pagasts" },
    { code: "LV.33.0980266", name: "Tārgales pagasts" },
    { code: "LV.33.0980270", name: "Ugāles pagasts" },
    { code: "LV.33.0980274", name: "Usmas pagasts" },
    { code: "LV.33.0980278", name: "Užavas pagasts" },
    { code: "LV.33.0980284", name: "Vārves pagasts" },
    { code: "LV.33.0980290", name: "Ziru pagasts" },
    { code: "LV.33.0980294", name: "Zlēku pagasts" },
  ],
  "LV.34": [
    { code: "LV.34.0804400", name: "Ādažu novads" },
  ],
  "LV.35": [
    { code: "LV.35.0604342", name: "Aglonas pagasts" },
    { code: "LV.35.0604358", name: "Grāveru pagasts" },
    { code: "LV.35.0604372", name: "Kastuļinas pagasts" },
    { code: "LV.35.0604394", name: "Šķeltovas pagasts" },
  ],
  "LV.37": [
    { code: "LV.37.0640605", name: "Aizpute" },
    { code: "LV.37.0640642", name: "Aizputes pagasts" },
    { code: "LV.37.0640648", name: "Cīravas pagasts" },
    { code: "LV.37.0640666", name: "Kalvenes pagasts" },
    { code: "LV.37.0640668", name: "Kazdangas pagasts" },
    { code: "LV.37.0640672", name: "Lažas pagasts" },
  ],
  "LV.38": [
    { code: "LV.38.0560805", name: "Aknīste" },
    { code: "LV.38.0560825", name: "Aknīstes pagasts" },
    { code: "LV.38.0560844", name: "Asares pagasts" },
    { code: "LV.38.0560862", name: "Gārsenes pagasts" },
  ],
  "LV.39": [
    { code: "LV.39.0661007", name: "Aloja" },
    { code: "LV.39.0661017", name: "Staicele" },
    { code: "LV.39.0661027", name: "Alojas pagasts" },
    { code: "LV.39.0661037", name: "Staiceles pagasts" },
    { code: "LV.39.0661044", name: "Braslavas pagasts" },
    { code: "LV.39.0661048", name: "Brīvzemnieku pagasts" },
  ],
  "LV.40": [
    { code: "LV.40.0624200", name: "Alsungas novads" },
  ],
  "LV.42": [
    { code: "LV.42.0424742", name: "Amatas pagasts" },
    { code: "LV.42.0424746", name: "Drabešu pagasts" },
    { code: "LV.42.0424768", name: "Nītaures pagasts" },
    { code: "LV.42.0424778", name: "Skujenes pagasts" },
    { code: "LV.42.0424796", name: "Zaubes pagasts" },
  ],
  "LV.43": [
    { code: "LV.43.0360805", name: "Ape" },
    { code: "LV.43.0360825", name: "Apes pagasts" },
    { code: "LV.43.0360848", name: "Gaujienas pagasts" },
    { code: "LV.43.0360884", name: "Trapenes pagasts" },
    { code: "LV.43.0360890", name: "Virešu pagasts" },
  ],
  "LV.44": [
    { code: "LV.44.0460805", name: "Auce" },
    { code: "LV.44.0460825", name: "Vecauces pagasts" },
    { code: "LV.44.0460850", name: "Bēnes pagasts" },
    { code: "LV.44.0460864", name: "Īles pagasts" },
    { code: "LV.44.0460876", name: "Lielauces pagasts" },
    { code: "LV.44.0460890", name: "Ukru pagasts" },
    { code: "LV.44.0460894", name: "Vītiņu pagasts" },
  ],
  "LV.45": [
    { code: "LV.45.0804948", name: "Babītes pagasts" },
    { code: "LV.45.0804988", name: "Salas pagasts" },
  ],
  "LV.46": [
    { code: "LV.46.0800605", name: "Baldone" },
    { code: "LV.46.0800625", name: "Baldones pagasts" },
  ],
  "LV.47": [
    { code: "LV.47.0384400", name: "Baltinavas novads" },
  ],
  "LV.50": [
    { code: "LV.50.0964746", name: "Brenguļu pagasts" },
    { code: "LV.50.0964762", name: "Kauguru pagasts" },
    { code: "LV.50.0964784", name: "Trikātas pagasts" },
  ],
  "LV.51": [
    { code: "LV.51.0840605", name: "Brocēni" },
    { code: "LV.51.0840625", name: "Cieceres pagasts" },
    { code: "LV.51.0840644", name: "Blīdenes pagasts" },
    { code: "LV.51.0840652", name: "Gaiķu pagasts" },
    { code: "LV.51.0840680", name: "Remtes pagasts" },
  ],
  "LV.52": [
    { code: "LV.52.0967148", name: "Burtnieku pagasts" },
    { code: "LV.52.0967154", name: "Ēveles pagasts" },
    { code: "LV.52.0967170", name: "Matīšu pagasts" },
    { code: "LV.52.0967178", name: "Rencēnu pagasts" },
    { code: "LV.52.0967190", name: "Valmieras pagasts" },
    { code: "LV.52.0967192", name: "Vecates pagasts" },
  ],
  "LV.53": [
    { code: "LV.53.0805200", name: "Carnikavas novads" },
  ],
  "LV.55": [
    { code: "LV.55.0700807", name: "Cesvaine" },
    { code: "LV.55.0700827", name: "Cesvaines pagasts" },
  ],
  "LV.56": [
    { code: "LV.56.0684944", name: "Blontu pagasts" },
    { code: "LV.56.0684948", name: "Ciblas pagasts" },
    { code: "LV.56.0684966", name: "Līdumnieku pagasts" },
    { code: "LV.56.0684990", name: "Pušmucovas pagasts" },
    { code: "LV.56.0684998", name: "Zvirgzdenes pagasts" },
  ],
  "LV.57": [
    { code: "LV.57.0601009", name: "Dagda" },
    { code: "LV.57.0601042", name: "Andrupenes pagasts" },
    { code: "LV.57.0601044", name: "Andzeļu pagasts" },
    { code: "LV.57.0601046", name: "Asūnes pagasts" },
    { code: "LV.57.0601050", name: "Bērziņu pagasts" },
    { code: "LV.57.0601054", name: "Dagdas pagasts" },
    { code: "LV.57.0601056", name: "Ezernieku pagasts" },
    { code: "LV.57.0601076", name: "Konstantinovas pagasts" },
    { code: "LV.57.0601080", name: "Ķepovas pagasts" },
    { code: "LV.57.0601090", name: "Svariņu pagasts" },
    { code: "LV.57.0601092", name: "Šķaunes pagasts" },
  ],
  "LV.60": [
    { code: "LV.60.0885150", name: "Dundagas pagasts" },
    { code: "LV.60.0885162", name: "Kolkas pagasts" },
  ],
  "LV.61": [
    { code: "LV.61.0640807", name: "Durbe" },
    { code: "LV.61.0640827", name: "Durbes pagasts" },
    { code: "LV.61.0640850", name: "Dunalkas pagasts" },
    { code: "LV.61.0640888", name: "Tadaiķu pagasts" },
    { code: "LV.61.0640894", name: "Vecpils pagasts" },
  ],
  "LV.62": [
    { code: "LV.62.0905150", name: "Engures pagasts" },
    { code: "LV.62.0905166", name: "Lapmežciema pagasts" },
    { code: "LV.62.0905182", name: "Smārdes pagasts" },
  ],
  "LV.63": [
    { code: "LV.63.0705554", name: "Ērgļu pagasts" },
    { code: "LV.63.0705560", name: "Jumurdas pagasts" },
    { code: "LV.63.0705592", name: "Sausnējas pagasts" },
  ],
  "LV.64": [
    { code: "LV.64.0806000", name: "Garkalnes novads" },
  ],
  "LV.65": [
    { code: "LV.65.0641009", name: "Grobiņa" },
    { code: "LV.65.0641044", name: "Bārtas pagasts" },
    { code: "LV.65.0641056", name: "Gaviezes pagasts" },
    { code: "LV.65.0641060", name: "Grobiņas pagasts" },
    { code: "LV.65.0641076", name: "Medzes pagasts" },
  ],
  "LV.67": [
    { code: "LV.67.0406400", name: "Iecavas novads" },
  ],
  "LV.68": [
    { code: "LV.68.0740605", name: "Ikšķile" },
    { code: "LV.68.0740625", name: "Tīnūžu pagasts" },
  ],
  "LV.69": [
    { code: "LV.69.0440807", name: "Ilūkste" },
    { code: "LV.69.0440815", name: "Subate" },
    { code: "LV.69.0440835", name: "Prodes pagasts" },
    { code: "LV.69.0440844", name: "Bebrenes pagasts" },
    { code: "LV.69.0440854", name: "Dvietes pagasts" },
    { code: "LV.69.0440856", name: "Eglaines pagasts" },
    { code: "LV.69.0440880", name: "Pilskalnes pagasts" },
    { code: "LV.69.0440890", name: "Šēderes pagasts" },
  ],
  "LV.70": [
    { code: "LV.70.0801817", name: "Vangaži" },
    { code: "LV.70.0801864", name: "Inčukalna pagasts" },
  ],
  "LV.71": [
    { code: "LV.71.0321007", name: "Jaunjelgava" },
    { code: "LV.71.0321027", name: "Jaunjelgavas pagasts" },
    { code: "LV.71.0321050", name: "Daudzeses pagasts" },
    { code: "LV.71.0321078", name: "Seces pagasts" },
    { code: "LV.71.0321080", name: "Sērenes pagasts" },
    { code: "LV.71.0321084", name: "Staburaga pagasts" },
    { code: "LV.71.0321086", name: "Sunākstes pagasts" },
  ],
  "LV.72": [
    { code: "LV.72.0425756", name: "Jaunpiebalgas pagasts" },
    { code: "LV.72.0425798", name: "Zosēnu pagasts" },
  ],
  "LV.73": [
    { code: "LV.73.0905756", name: "Jaunpils pagasts" },
    { code: "LV.73.0905790", name: "Viesatu pagasts" },
  ],
  "LV.74": [
    { code: "LV.74.0110000", name: "Jēkabpils" },
  ],
  "LV.77": [
    { code: "LV.77.0901211", name: "Kandava" },
    { code: "LV.77.0901244", name: "Cēres pagasts" },
    { code: "LV.77.0901262", name: "Kandavas pagasts" },
    { code: "LV.77.0901270", name: "Matkules pagasts" },
    { code: "LV.77.0901288", name: "Vānes pagasts" },
    { code: "LV.77.0901292", name: "Zantes pagasts" },
    { code: "LV.77.0901294", name: "Zemītes pagasts" },
  ],
  "LV.78": [
    { code: "LV.78.0681009", name: "Kārsava" },
    { code: "LV.78.0681054", name: "Goliševas pagasts" },
    { code: "LV.78.0681068", name: "Malnavas pagasts" },
    { code: "LV.78.0681070", name: "Mežvidu pagasts" },
    { code: "LV.78.0681072", name: "Mērdzenes pagasts" },
    { code: "LV.78.0681094", name: "Salnavas pagasts" },
  ],
  "LV.79": [
    { code: "LV.79.0741009", name: "Ķegums" },
    { code: "LV.79.0741029", name: "Tomes pagasts" },
    { code: "LV.79.0741044", name: "Birzgales pagasts" },
    { code: "LV.79.0741084", name: "Rembates pagasts" },
  ],
  "LV.80": [
    { code: "LV.80.0800807", name: "Baloži" },
    { code: "LV.80.0800856", name: "Daugmales pagasts" },
    { code: "LV.80.0800870", name: "Ķekavas pagasts" },
  ],
  "LV.81": [
    { code: "LV.81.0960244", name: "Bērzaines pagasts" },
    { code: "LV.81.0960252", name: "Dikļu pagasts" },
    { code: "LV.81.0960264", name: "Kocēnu pagasts" },
    { code: "LV.81.0960288", name: "Vaidavas pagasts" },
    { code: "LV.81.0960296", name: "Zilākalna pagasts" },
  ],
  "LV.82": [
    { code: "LV.82.0326146", name: "Bebru pagasts" },
    { code: "LV.82.0326154", name: "Iršu pagasts" },
    { code: "LV.82.0326160", name: "Kokneses pagasts" },
  ],
  "LV.84": [
    { code: "LV.84.0806956", name: "Lēdurgas pagasts" },
    { code: "LV.84.0806968", name: "Krimuldas pagasts" },
  ],
  "LV.85": [
    { code: "LV.85.0566946", name: "Atašienes pagasts" },
    { code: "LV.85.0566968", name: "Krustpils pagasts" },
    { code: "LV.85.0566970", name: "Kūku pagasts" },
    { code: "LV.85.0566976", name: "Mežāres pagasts" },
    { code: "LV.85.0566994", name: "Variešu pagasts" },
    { code: "LV.85.0566996", name: "Vīpes pagasts" },
  ],
  "LV.87": [
    { code: "LV.87.0741413", name: "Lielvārde" },
    { code: "LV.87.0741433", name: "Lielvārdes pagasts" },
    { code: "LV.87.0741448", name: "Jumpravas pagasts" },
    { code: "LV.87.0741464", name: "Lēdmanes pagasts" },
  ],
  "LV.88": [
    { code: "LV.88.0421211", name: "Līgatne" },
    { code: "LV.88.0421262", name: "Līgatnes pagasts" },
  ],
  "LV.90": [
    { code: "LV.90.0761211", name: "Līvāni" },
    { code: "LV.90.0761252", name: "Jersikas pagasts" },
    { code: "LV.90.0761266", name: "Rožupes pagasts" },
    { code: "LV.90.0761268", name: "Rudzātu pagasts" },
    { code: "LV.90.0761282", name: "Sutru pagasts" },
    { code: "LV.90.0761286", name: "Turku pagasts" },
  ],
  "LV.91": [
    { code: "LV.91.0701413", name: "Lubāna" },
    { code: "LV.91.0701458", name: "Indrānu pagasts" },
  ],
  "LV.94": [
    { code: "LV.94.0807400", name: "Mālpils novads" },
  ],
  "LV.95": [
    { code: "LV.95.0807600", name: "Mārupes novads" },
  ],
  "LV.96": [
    { code: "LV.96.0961011", name: "Mazsalaca" },
    { code: "LV.96.0961031", name: "Mazsalacas pagasts" },
    { code: "LV.96.0961076", name: "Ramatas pagasts" },
    { code: "LV.96.0961082", name: "Sēļu pagasts" },
    { code: "LV.96.0961084", name: "Skaņkalnes pagasts" },
  ],
  "LV.97": [
    { code: "LV.97.0967366", name: "Ķoņu pagasts" },
    { code: "LV.97.0967372", name: "Naukšēnu pagasts" },
  ],
  "LV.98": [
    { code: "LV.98.0327166", name: "Mazzalves pagasts" },
    { code: "LV.98.0327170", name: "Neretas pagasts" },
    { code: "LV.98.0327174", name: "Pilskalnes pagasts" },
    { code: "LV.98.0327196", name: "Zalves pagasts" },
  ],
  "LV.99": [
    { code: "LV.99.0647978", name: "Nīcas pagasts" },
    { code: "LV.99.0647980", name: "Otaņķu pagasts" },
  ],
  "LV.A2": [
    { code: "LV.A2.0801009", name: "Olaine" },
    { code: "LV.A2.0801080", name: "Olaines pagasts" },
  ],
  "LV.A3": [
    { code: "LV.A3.0546744", name: "Cenu pagasts" },
    { code: "LV.A3.0546766", name: "Ozolnieku pagasts" },
    { code: "LV.A3.0546778", name: "Salgales pagasts" },
  ],
  "LV.A4": [
    { code: "LV.A4.0427574", name: "Raiskuma pagasts" },
    { code: "LV.A4.0427580", name: "Stalbes pagasts" },
    { code: "LV.A4.0427582", name: "Straupes pagasts" },
  ],
  "LV.A5": [
    { code: "LV.A5.0641413", name: "Pāvilosta" },
    { code: "LV.A5.0641486", name: "Sakas pagasts" },
    { code: "LV.A5.0641496", name: "Vērgales pagasts" },
  ],
  "LV.A6": [
    { code: "LV.A6.0321413", name: "Pļaviņas" },
    { code: "LV.A6.0321442", name: "Aiviekstes pagasts" },
    { code: "LV.A6.0321458", name: "Klintaines pagasts" },
    { code: "LV.A6.0321492", name: "Vietalvas pagasts" },
  ],
  "LV.A8": [
    { code: "LV.A8.0641615", name: "Priekule" },
    { code: "LV.A8.0641646", name: "Bunkas pagasts" },
    { code: "LV.A8.0641658", name: "Gramzdas pagasts" },
    { code: "LV.A8.0641664", name: "Kalētu pagasts" },
    { code: "LV.A8.0641682", name: "Priekules pagasts" },
    { code: "LV.A8.0641698", name: "Virgas pagasts" },
  ],
  "LV.A9": [
    { code: "LV.A9.0427360", name: "Liepas pagasts" },
    { code: "LV.A9.0427364", name: "Mārsnēnu pagasts" },
    { code: "LV.A9.0427372", name: "Priekuļu pagasts" },
    { code: "LV.A9.0427394", name: "Veselavas pagasts" },
  ],
  "LV.B1": [
    { code: "LV.B1.0427748", name: "Drustu pagasts" },
    { code: "LV.B1.0427776", name: "Raunas pagasts" },
  ],
  "LV.B3": [
    { code: "LV.B3.0766348", name: "Galēnu pagasts" },
    { code: "LV.B3.0766362", name: "Riebiņu pagasts" },
    { code: "LV.B3.0766370", name: "Rušonas pagasts" },
    { code: "LV.B3.0766376", name: "Silajāņu pagasts" },
    { code: "LV.B3.0766378", name: "Sīļukalna pagasts" },
    { code: "LV.B3.0766380", name: "Stabulnieku pagasts" },
  ],
  "LV.B4": [
    { code: "LV.B4.0888301", name: "Rojas novads" },
  ],
  "LV.B5": [
    { code: "LV.B5.0808400", name: "Ropažu novads" },
  ],
  "LV.B6": [
    { code: "LV.B6.0648552", name: "Dunikas pagasts" },
    { code: "LV.B6.0648584", name: "Rucavas pagasts" },
  ],
  "LV.B7": [
    { code: "LV.B7.0387564", name: "Lazdukalna pagasts" },
    { code: "LV.B7.0387574", name: "Rugāju pagasts" },
  ],
  "LV.B8": [
    { code: "LV.B8.0961615", name: "Rūjiena" },
    { code: "LV.B8.0961656", name: "Ipiķu pagasts" },
    { code: "LV.B8.0961658", name: "Jeru pagasts" },
    { code: "LV.B8.0961668", name: "Lodes pagasts" },
    { code: "LV.B8.0961694", name: "Vilpulkas pagasts" },
  ],
  "LV.B9": [
    { code: "LV.B9.0407776", name: "Rundāles pagasts" },
    { code: "LV.B9.0407788", name: "Svitenes pagasts" },
    { code: "LV.B9.0407796", name: "Viesturu pagasts" },
  ],
  "LV.C1": [
    { code: "LV.C1.0661405", name: "Ainaži" },
    { code: "LV.C1.0661415", name: "Salacgrīva" },
    { code: "LV.C1.0661425", name: "Ainažu pagasts" },
    { code: "LV.C1.0661435", name: "Salacgrīvas pagasts" },
    { code: "LV.C1.0661460", name: "Liepupes pagasts" },
  ],
  "LV.C2": [
    { code: "LV.C2.0568786", name: "Salas pagasts" },
    { code: "LV.C2.0568790", name: "Sēlpils pagasts" },
  ],
  "LV.C3": [
    { code: "LV.C3.0801211", name: "Salaspils" },
    { code: "LV.C3.0801231", name: "Salaspils pagasts" },
  ],
  "LV.C5": [
    { code: "LV.C5.0801413", name: "Saulkrasti" },
    { code: "LV.C5.0801433", name: "Saulkrastu pagasts" },
  ],
  "LV.C6": [
    { code: "LV.C6.0809200", name: "Sējas novads" },
  ],
  "LV.C7": [
    { code: "LV.C7.0801615", name: "Sigulda" },
    { code: "LV.C7.0801642", name: "Allažu pagasts" },
    { code: "LV.C7.0801666", name: "Mores pagasts" },
    { code: "LV.C7.0801694", name: "Siguldas pagasts" },
  ],
  "LV.C8": [
    { code: "LV.C8.0328200", name: "Skrīveru novads" },
  ],
  "LV.C9": [
    { code: "LV.C9.0621209", name: "Skrunda" },
    { code: "LV.C9.0621229", name: "Skrundas pagasts" },
    { code: "LV.C9.0621268", name: "Nīkrāces pagasts" },
    { code: "LV.C9.0621278", name: "Raņķu pagasts" },
    { code: "LV.C9.0621282", name: "Rudbāržu pagasts" },
  ],
  "LV.D1": [
    { code: "LV.D1.0941615", name: "Smiltene" },
    { code: "LV.D1.0941644", name: "Bilskas pagasts" },
    { code: "LV.D1.0941646", name: "Blomes pagasts" },
    { code: "LV.D1.0941648", name: "Brantu pagasts" },
    { code: "LV.D1.0941658", name: "Grundzāles pagasts" },
    { code: "LV.D1.0941670", name: "Launkalnes pagasts" },
    { code: "LV.D1.0941674", name: "Palsmanes pagasts" },
    { code: "LV.D1.0941680", name: "Smiltenes pagasts" },
    { code: "LV.D1.0941690", name: "Variņu pagasts" },
  ],
  "LV.D2": [
    { code: "LV.D2.0809600", name: "Stopiņu novads" },
  ],
  "LV.D3": [
    { code: "LV.D3.0941813", name: "Seda" },
    { code: "LV.D3.0941817", name: "Strenči" },
    { code: "LV.D3.0941860", name: "Jērcēnu pagasts" },
    { code: "LV.D3.0941876", name: "Plāņu pagasts" },
  ],
  "LV.D5": [
    { code: "LV.D5.0468944", name: "Augstkalnes pagasts" },
    { code: "LV.D5.0468956", name: "Bukaišu pagasts" },
    { code: "LV.D5.0468988", name: "Tērvetes pagasts" },
  ],
  "LV.D7": [
    { code: "LV.D7.0649354", name: "Embūtes pagasts" },
    { code: "LV.D7.0649392", name: "Vaiņodes pagasts" },
  ],
  "LV.E1": [
    { code: "LV.E1.0701817", name: "Varakļāni" },
    { code: "LV.E1.0701878", name: "Murmastienes pagasts" },
    { code: "LV.E1.0701894", name: "Varakļānu pagasts" },
  ],
  "LV.E2": [
    { code: "LV.E2.0769164", name: "Rožkalnu pagasts" },
    { code: "LV.E2.0769190", name: "Upmalas pagasts" },
    { code: "LV.E2.0769194", name: "Vārkavas pagasts" },
  ],
  "LV.E3": [
    { code: "LV.E3.0429350", name: "Dzērbenes pagasts" },
    { code: "LV.E3.0429354", name: "Inešu pagasts" },
    { code: "LV.E3.0429358", name: "Kaives pagasts" },
    { code: "LV.E3.0429386", name: "Taurenes pagasts" },
    { code: "LV.E3.0429392", name: "Vecpiebalgas pagasts" },
  ],
  "LV.E4": [
    { code: "LV.E4.0409544", name: "Bārbeles pagasts" },
    { code: "LV.E4.0409562", name: "Kurmenes pagasts" },
    { code: "LV.E4.0409580", name: "Skaistkalnes pagasts" },
    { code: "LV.E4.0409584", name: "Stelpes pagasts" },
    { code: "LV.E4.0409590", name: "Valles pagasts" },
    { code: "LV.E4.0409594", name: "Vecumnieku pagasts" },
  ],
  "LV.E6": [
    { code: "LV.E6.0561815", name: "Viesīte" },
    { code: "LV.E6.0561835", name: "Viesītes pagasts" },
    { code: "LV.E6.0561858", name: "Elkšņu pagasts" },
    { code: "LV.E6.0561880", name: "Rites pagasts" },
    { code: "LV.E6.0561888", name: "Saukas pagasts" },
  ],
  "LV.E7": [
    { code: "LV.E7.0381615", name: "Viļaka" },
    { code: "LV.E7.0381660", name: "Kupravas pagasts" },
    { code: "LV.E7.0381670", name: "Medņevas pagasts" },
    { code: "LV.E7.0381678", name: "Susāju pagasts" },
    { code: "LV.E7.0381682", name: "Šķilbēnu pagasts" },
    { code: "LV.E7.0381692", name: "Vecumu pagasts" },
    { code: "LV.E7.0381698", name: "Žīguru pagasts" },
  ],
  "LV.E8": [
    { code: "LV.E8.0781817", name: "Viļāni" },
    { code: "LV.E8.0781848", name: "Dekšāres pagasts" },
    { code: "LV.E8.0781890", name: "Sokolku pagasts" },
    { code: "LV.E8.0781898", name: "Viļānu pagasts" },
  ],
  "LV.E9": [
    { code: "LV.E9.0681817", name: "Zilupe" },
    { code: "LV.E9.0681864", name: "Lauderu pagasts" },
    { code: "LV.E9.0681884", name: "Pasienes pagasts" },
    { code: "LV.E9.0681896", name: "Zaļesjes pagasts" },
  ],
  "LV.F1": [
    { code: "LV.F1.0887600", name: "Mērsraga novads" },
  ],
  "LY.74": [
    { code: "LY.74.2208403", name: "Mutuşarrifīyat Ghadāmis" },
  ],
  "MA.01": [
    { code: "MA.01.051", name: "Al-Hoceima" },
    { code: "MA.01.151", name: "Chefchaouen Province" },
    { code: "MA.01.227", name: "Fahs-Anjra" },
    { code: "MA.01.331", name: "Larache" },
    { code: "MA.01.405", name: "Ouezzane Province" },
    { code: "MA.01.511", name: "Tanger-Assilah" },
    { code: "MA.01.571", name: "Tetouan" },
    { code: "MA.01.573", name: "M'Diq-Fnideq" },
  ],
  "MA.02": [
    { code: "MA.02.113", name: "Berkane" },
    { code: "MA.02.167", name: "Driouch Province" },
    { code: "MA.02.251", name: "Figuig" },
    { code: "MA.02.265", name: "Guercif Province" },
    { code: "MA.02.275", name: "Jerada" },
    { code: "MA.02.381", name: "Nador" },
    { code: "MA.02.411", name: "Oujda-Angad" },
    { code: "MA.02.533", name: "Taourirt" },
  ],
  "MA.03": [
    { code: "MA.03.061", name: "Meknes" },
    { code: "MA.03.131", name: "Boulemane" },
    { code: "MA.03.171", name: "El-Hajeb" },
    { code: "MA.03.231", name: "Fes" },
    { code: "MA.03.271", name: "Ifrane" },
    { code: "MA.03.451", name: "Sefrou" },
    { code: "MA.03.531", name: "Taounate" },
    { code: "MA.03.561", name: "Taza" },
    { code: "MA.03.591", name: "Moulay-Yacoub" },
  ],
  "MA.04": [
    { code: "MA.04.281", name: "Kenitra Province" },
    { code: "MA.04.291", name: "Khemisset" },
    { code: "MA.04.421", name: "Rabat" },
    { code: "MA.04.441", name: "Sale" },
    { code: "MA.04.481", name: "Sidi-Kacem" },
    { code: "MA.04.491", name: "Sidi Slimane" },
    { code: "MA.04.501", name: "Skhirate-Temara" },
  ],
  "MA.05": [
    { code: "MA.05.081", name: "Azilal Province" },
    { code: "MA.05.091", name: "Beni-Mellal" },
    { code: "MA.05.255", name: "Fquih Ben Salah Province" },
    { code: "MA.05.301", name: "Khenifra" },
    { code: "MA.05.311", name: "Khouribga Province" },
  ],
  "MA.06": [
    { code: "MA.06.111", name: "Benslimane" },
    { code: "MA.06.117", name: "Berrechid Province" },
    { code: "MA.06.141", name: "Casablanca" },
    { code: "MA.06.181", name: "El-Jadida" },
    { code: "MA.06.355", name: "Mediouna" },
    { code: "MA.06.371", name: "Mohammedia" },
    { code: "MA.06.385", name: "Nouaceur" },
    { code: "MA.06.461", name: "Settat Province" },
    { code: "MA.06.467", name: "Sidi Bennour" },
  ],
  "MA.07": [
    { code: "MA.07.041", name: "Al-Haouz" },
    { code: "MA.07.161", name: "Chichaoua" },
    { code: "MA.07.191", name: "Kelaa-Des-Sraghna" },
    { code: "MA.07.211", name: "Essaouira" },
    { code: "MA.07.351", name: "Marrakech" },
    { code: "MA.07.427", name: "Rehamna" },
    { code: "MA.07.431", name: "Safi" },
    { code: "MA.07.585", name: "Youssoufia" },
  ],
  "MA.08": [
    { code: "MA.08.201", name: "Errachidia" },
    { code: "MA.08.363", name: "Midelt" },
    { code: "MA.08.401", name: "Ouarzazate" },
    { code: "MA.08.577", name: "Tinghir Province" },
    { code: "MA.08.587", name: "Zagora" },
  ],
  "MA.09": [
    { code: "MA.09.001", name: "Agadir-Ida-ou-Tnan" },
    { code: "MA.09.163", name: "Chtouka-Ait-Baha" },
    { code: "MA.09.273", name: "Inezgane-Ait Melloul" },
    { code: "MA.09.541", name: "Taroudannt" },
    { code: "MA.09.551", name: "Tata" },
    { code: "MA.09.581", name: "Tiznit" },
  ],
  "MA.10": [
    { code: "MA.10.071", name: "Assa-Zag" },
    { code: "MA.10.261", name: "Guelmim" },
    { code: "MA.10.473", name: "Sidi Ifni" },
    { code: "MA.10.521", name: "Tan-Tan" },
  ],
  "MA.11": [
    { code: "MA.11.121", name: "Boujdour" },
    { code: "MA.11.221", name: "Es-Semara" },
    { code: "MA.11.321", name: "Laayoune" },
    { code: "MA.11.537", name: "Tarfaya" },
  ],
  "MA.12": [
    { code: "MA.12.066", name: "Aousserd" },
    { code: "MA.12.391", name: "Oued-Ed-Dahab" },
  ],
  "MG.11": [
    { code: "MG.11.11101001", name: "1er Arrondissement" },
    { code: "MG.11.11101002", name: "2e Arrondissement" },
    { code: "MG.11.11101003", name: "3e Arrondissement" },
    { code: "MG.11.11101004", name: "4e Arrondissement" },
    { code: "MG.11.11101005", name: "5e Arrondissement" },
    { code: "MG.11.11101006", name: "6e Arrondissement" },
    { code: "MG.11.11102", name: "Antananarivo Avaradrano" },
    { code: "MG.11.11103", name: "Ambohidratrimo District" },
    { code: "MG.11.11104", name: "Ankazobe District" },
    { code: "MG.11.11106", name: "Manjakandriana" },
    { code: "MG.11.11107", name: "Anjozorobe" },
    { code: "MG.11.11115", name: "Andramasina District" },
    { code: "MG.11.11117", name: "Antananarivo-Atsimondrano" },
  ],
  "MG.12": [
    { code: "MG.12.12108", name: "Antsirabe I District" },
    { code: "MG.12.12109", name: "Betafo District" },
    { code: "MG.12.12110", name: "Ambatolampy" },
    { code: "MG.12.12114", name: "Antanifotsy" },
    { code: "MG.12.12116", name: "Faratsiho" },
    { code: "MG.12.12118", name: "Antsirabe II" },
    { code: "MG.12.12120", name: "Mandoto" },
  ],
  "MG.13": [
    { code: "MG.13.13105", name: "Arivonimamo" },
    { code: "MG.13.13112", name: "Miarinarivo" },
    { code: "MG.13.13113", name: "Soavinandriana" },
  ],
  "MG.14": [
    { code: "MG.14.14111", name: "Tsiroanomandidy" },
    { code: "MG.14.14119", name: "Fenoarivobe" },
  ],
  "MG.21": [
    { code: "MG.21.21201", name: "Fianarantsoa I" },
    { code: "MG.21.21205", name: "Ambalavao" },
    { code: "MG.21.21208", name: "Ambohimahasoa" },
    { code: "MG.21.21219", name: "Ikalamavony" },
    { code: "MG.21.21220", name: "Lalangina" },
    { code: "MG.21.21224", name: "Vohibato" },
    { code: "MG.21.21225", name: "Isandra" },
  ],
  "MG.22": [
    { code: "MG.22.22202", name: "Ambatofinandrahana District" },
    { code: "MG.22.22203", name: "Ambositra District" },
    { code: "MG.22.22204", name: "Fandriana District" },
    { code: "MG.22.22223", name: "Manandriana District" },
  ],
  "MG.23": [
    { code: "MG.23.23206", name: "Ifanadiana" },
    { code: "MG.23.23207", name: "Nosy-Varika" },
    { code: "MG.23.23209", name: "Mananjary" },
    { code: "MG.23.23210", name: "Manakara" },
    { code: "MG.23.23211", name: "Ikongo" },
    { code: "MG.23.23212", name: "Vohipeno" },
  ],
  "MG.24": [
    { code: "MG.24.24216", name: "Ihosy" },
    { code: "MG.24.24218", name: "Ivohibe" },
    { code: "MG.24.24221", name: "Iakora" },
  ],
  "MG.25": [
    { code: "MG.25.25213", name: "Farafangana District" },
    { code: "MG.25.25214", name: "Vangaindrano District" },
    { code: "MG.25.25215", name: "Midongy-Atsimo" },
    { code: "MG.25.25217", name: "Vondrozo" },
    { code: "MG.25.25222", name: "Befotaka" },
  ],
  "MG.31": [
    { code: "MG.31.31301", name: "Toamasina I" },
    { code: "MG.31.31306", name: "Brickaville" },
    { code: "MG.31.31307", name: "Vatomandry" },
    { code: "MG.31.31308", name: "Mahanoro" },
    { code: "MG.31.31309", name: "Marolambo" },
    { code: "MG.31.31310", name: "Toamasina II" },
    { code: "MG.31.31311", name: "Antanambao Manampontsy" },
  ],
  "MG.32": [
    { code: "MG.32.32302", name: "Nosy Boraha" },
    { code: "MG.32.32303", name: "Maroantsetra District" },
    { code: "MG.32.32304", name: "Mananara Nord District" },
    { code: "MG.32.32305", name: "Fenerive Est" },
    { code: "MG.32.32315", name: "Vavatenina District" },
    { code: "MG.32.32318", name: "Soanierana Ivongo" },
  ],
  "MG.33": [
    { code: "MG.33.33312", name: "Amparafaravola District" },
    { code: "MG.33.33313", name: "Ambatondrazaka District" },
    { code: "MG.33.33314", name: "Moramanga District" },
    { code: "MG.33.33316", name: "Andilamena District" },
    { code: "MG.33.33317", name: "Anosibe An'ala District" },
  ],
  "MG.41": [
    { code: "MG.41.41401", name: "Mahajanga I" },
    { code: "MG.41.41403", name: "Soalala" },
    { code: "MG.41.41405", name: "Ambato Boeni" },
    { code: "MG.41.41406", name: "Marovoay District" },
    { code: "MG.41.41407", name: "Mitsinjo" },
    { code: "MG.41.41415", name: "Mahajanga II" },
  ],
  "MG.42": [
    { code: "MG.42.42409", name: "Port-Berge (Boriziny-Vaovao)" },
    { code: "MG.42.42410", name: "Mandritsara" },
    { code: "MG.42.42411", name: "Analalava" },
    { code: "MG.42.42412", name: "Befandriana Nord" },
    { code: "MG.42.42413", name: "Antsohihy" },
    { code: "MG.42.42414", name: "Bealanana District" },
    { code: "MG.42.42423", name: "Mampikony" },
  ],
  "MG.43": [
    { code: "MG.43.43404", name: "Maevatanana" },
    { code: "MG.43.43408", name: "Tsaratanana" },
    { code: "MG.43.43416", name: "Kandreho" },
  ],
  "MG.44": [
    { code: "MG.44.44402", name: "Besalampy" },
    { code: "MG.44.44417", name: "Ambatomainty" },
    { code: "MG.44.44420", name: "Antsalova" },
    { code: "MG.44.44421", name: "Maintirano" },
    { code: "MG.44.44422", name: "Morafenobe" },
  ],
  "MG.51": [
    { code: "MG.51.51501", name: "Toliara I District" },
    { code: "MG.51.51503", name: "Beroroha District" },
    { code: "MG.51.51504", name: "Morombe District" },
    { code: "MG.51.51505", name: "Ankazoabo District" },
    { code: "MG.51.51506", name: "Betioky District" },
    { code: "MG.51.51507", name: "Ampanihy District" },
    { code: "MG.51.51512", name: "Sakaraha District" },
    { code: "MG.51.51520", name: "Toliara II District" },
    { code: "MG.51.51521", name: "Benenitra" },
  ],
  "MG.52": [
    { code: "MG.52.52513", name: "Beloha District" },
    { code: "MG.52.52514", name: "Tsihombe" },
    { code: "MG.52.52516", name: "Ambovombe District" },
    { code: "MG.52.52518", name: "Bekily District" },
  ],
  "MG.53": [
    { code: "MG.53.53515", name: "Taolagnaro" },
    { code: "MG.53.53517", name: "Betroka District" },
    { code: "MG.53.53519", name: "Amboasary District" },
  ],
  "MG.54": [
    { code: "MG.54.54502", name: "Manja District" },
    { code: "MG.54.54508", name: "Morondava District" },
    { code: "MG.54.54509", name: "Mahabo District" },
    { code: "MG.54.54510", name: "Belo Sur Tsiribihina" },
    { code: "MG.54.54511", name: "Miandrivazo District" },
  ],
  "MG.71": [
    { code: "MG.71.71713", name: "Antsiranana II" },
    { code: "MG.71.71715", name: "Antsiranana I" },
    { code: "MG.71.71717", name: "Ambilobe" },
    { code: "MG.71.71718", name: "Nosy Be" },
    { code: "MG.71.71719", name: "Ambanja" },
  ],
  "MG.72": [
    { code: "MG.72.72710", name: "Antalaha" },
    { code: "MG.72.72711", name: "Sambava" },
    { code: "MG.72.72712", name: "Andapa District" },
    { code: "MG.72.72716", name: "Vohemar" },
  ],
  "MK.F6": [
    { code: "MK.F6.29", name: "Opstina Gjorce Petrov" },
    { code: "MK.F6.32", name: "Gazi Baba" },
    { code: "MK.F6.41", name: "Opština Karpoš" },
    { code: "MK.F6.44", name: "Kisela Voda" },
    { code: "MK.F6.90", name: "Saraj" },
    { code: "MK.F6.A3", name: "Šuto Orizari" },
    { code: "MK.F6.C8", name: "Čair" },
    { code: "MK.F6.D1", name: "Opština Centar" },
    { code: "MK.F6.F3", name: "Aerodrom" },
    { code: "MK.F6.F4", name: "Butel" },
  ],
  "ML.01": [
    { code: "ML.01.11996137", name: "Bamako Cercle" },
  ],
  "ML.03": [
    { code: "ML.03.7701481", name: "Kayes Cercle" },
    { code: "ML.03.7701501", name: "Kita Cercle" },
    { code: "ML.03.8261489", name: "Diema Cercle" },
    { code: "ML.03.8261494", name: "Nioro Cercle" },
    { code: "ML.03.8299787", name: "Kenieba Cercle" },
    { code: "ML.03.8334585", name: "Bafoulabe Cercle" },
    { code: "ML.03.8631403", name: "Cercle de Yélimané" },
  ],
  "ML.04": [
    { code: "ML.04.7670549", name: "Douentza Cercle" },
    { code: "ML.04.7701484", name: "Mopti Cercle" },
    { code: "ML.04.7701493", name: "Bankass Cercle" },
    { code: "ML.04.7701494", name: "Koro Cercle" },
    { code: "ML.04.8299587", name: "Youwarou Cercle" },
    { code: "ML.04.8299589", name: "Tenenkou Cercle" },
    { code: "ML.04.8299590", name: "Djenne Cercle" },
    { code: "ML.04.8299591", name: "Bandiagara Cercle" },
  ],
  "ML.05": [
    { code: "ML.05.7701201", name: "Baroueli" },
    { code: "ML.05.7701202", name: "Segou" },
    { code: "ML.05.7701496", name: "Bla" },
    { code: "ML.05.7701500", name: "Tominian" },
    { code: "ML.05.8631514", name: "Cercle de Niono" },
    { code: "ML.05.8631515", name: "Cercle de Macina" },
    { code: "ML.05.8631516", name: "Cercle de San" },
  ],
  "ML.06": [
    { code: "ML.06.7670554", name: "Koutiala Cercle" },
    { code: "ML.06.7701502", name: "Bougouni Cercle" },
    { code: "ML.06.7729902", name: "Sikasso Cercle" },
    { code: "ML.06.8334591", name: "Kolondieba Cercle" },
    { code: "ML.06.8631446", name: "Cercle de Yanfolila" },
    { code: "ML.06.8631512", name: "Cercle de Kadiolo" },
    { code: "ML.06.8631513", name: "Cercle de Yorosso" },
  ],
  "ML.07": [
    { code: "ML.07.7701199", name: "Kati Cercle" },
    { code: "ML.07.7701200", name: "Dioila" },
    { code: "ML.07.7701503", name: "Koulikoro" },
    { code: "ML.07.8261491", name: "Kolokani Cercle" },
    { code: "ML.07.8261492", name: "Banamba Cercle" },
    { code: "ML.07.8261493", name: "Nara Cercle" },
    { code: "ML.07.8631413", name: "Cercle de Kangaba" },
  ],
  "ML.08": [
    { code: "ML.08.7670552", name: "Gourma-Rharous Cercle" },
    { code: "ML.08.7701470", name: "Tombouctou" },
    { code: "ML.08.7701473", name: "Dire" },
    { code: "ML.08.8299588", name: "Niafunke Cercle" },
    { code: "ML.08.8631536", name: "Cercle de Goundam" },
  ],
  "ML.09": [
    { code: "ML.09.7670553", name: "Gao Cercle" },
    { code: "ML.09.8631537", name: "Cercle de Bourem" },
    { code: "ML.09.8631538", name: "Ansongo Cercle" },
  ],
  "ML.10": [
    { code: "ML.10.7701465", name: "Kidal" },
    { code: "ML.10.8631540", name: "Ti-n-Essako" },
    { code: "ML.10.8631541", name: "Cercle d’Abeïbara" },
    { code: "ML.10.8631542", name: "Cercle de Tessalit" },
  ],
  "ML.12070577": [
    { code: "ML.12070577.8631539", name: "Cercle de Ménaka" },
  ],
  "MM.01": [
    { code: "MM.01.MMR012D001", name: "Sittwe District" },
    { code: "MM.01.MMR012D002", name: "Maungdaw District" },
    { code: "MM.01.MMR012D003", name: "Kyaunkpyu District" },
    { code: "MM.01.MMR012D004", name: "Thandwe District" },
    { code: "MM.01.MMR012D005", name: "Mrauk-U" },
  ],
  "MM.02": [
    { code: "MM.02.MMR004D001", name: "Falam" },
    { code: "MM.02.MMR004D002", name: "Mindat" },
    { code: "MM.02.MMR004D003", name: "Hakha" },
  ],
  "MM.03": [
    { code: "MM.03.MMR017D001", name: "Pathein District" },
    { code: "MM.03.MMR017D002", name: "Hinthada District" },
    { code: "MM.03.MMR017D003", name: "Myaungmya District" },
    { code: "MM.03.MMR017D004", name: "Labutta District" },
    { code: "MM.03.MMR017D005", name: "Ma-ubin District" },
    { code: "MM.03.MMR017D006", name: "Pyapon District" },
  ],
  "MM.04": [
    { code: "MM.04.MMR001D001", name: "Myitkyinā District" },
    { code: "MM.04.MMR001D002", name: "Mohnyin District" },
    { code: "MM.04.MMR001D003", name: "Bhamo District" },
    { code: "MM.04.MMR001D004", name: "Putao District" },
  ],
  "MM.05": [
    { code: "MM.05.MMR003D001", name: "Hpa-an District" },
    { code: "MM.05.MMR003D002", name: "Myawaddy District" },
    { code: "MM.05.MMR003D003", name: "Kawkareik District" },
    { code: "MM.05.MMR003D004", name: "Hpapun" },
  ],
  "MM.06": [
    { code: "MM.06.MMR002D001", name: "Loikaw District" },
    { code: "MM.06.MMR002D002", name: "Bawlakhe District" },
  ],
  "MM.08": [
    { code: "MM.08.MMR010D001", name: "Mandalay District" },
    { code: "MM.08.MMR010D002", name: "Pyin Oo Lwin District" },
    { code: "MM.08.MMR010D003", name: "Kyaukse District" },
    { code: "MM.08.MMR010D004", name: "Myingyan District" },
    { code: "MM.08.MMR010D005", name: "Nyaung-U District" },
    { code: "MM.08.MMR010D006", name: "Yamethin District" },
    { code: "MM.08.MMR010D007", name: "Meiktila District" },
  ],
  "MM.10": [
    { code: "MM.10.MMR005D001", name: "Sagaing District" },
    { code: "MM.10.MMR005D002", name: "Shwebo District" },
    { code: "MM.10.MMR005D003", name: "Monywa" },
    { code: "MM.10.MMR005D004", name: "Katha District" },
    { code: "MM.10.MMR005D005", name: "Kale District" },
    { code: "MM.10.MMR005D006", name: "Tamu District" },
    { code: "MM.10.MMR005D007", name: "Mawlaik District" },
    { code: "MM.10.MMR005D008", name: "Hkamti District" },
    { code: "MM.10.MMR005D009", name: "Yinmabin" },
  ],
  "MM.11": [
    { code: "MM.11.MMR014D001", name: "Taunggyi District" },
    { code: "MM.11.MMR014D002", name: "Loilem District" },
    { code: "MM.11.MMR014D003", name: "Langhko District" },
    { code: "MM.11.MMR015D001", name: "Lashio District" },
    { code: "MM.11.MMR015D002", name: "Mu Se District" },
    { code: "MM.11.MMR015D003", name: "Kyaukme District" },
    { code: "MM.11.MMR015D005", name: "Laukkaing" },
    { code: "MM.11.MMR015D006", name: "Hopang" },
    { code: "MM.11.MMR015D007", name: "Matman" },
    { code: "MM.11.MMR015D008", name: "Mongmit" },
    { code: "MM.11.MMR016D001", name: "Kengtung District" },
    { code: "MM.11.MMR016D002", name: "Mong Hsat District" },
    { code: "MM.11.MMR016D003", name: "Tachileik District" },
  ],
  "MM.12": [
    { code: "MM.12.MMR006D001", name: "Dawei District" },
    { code: "MM.12.MMR006D002", name: "Myeik District" },
    { code: "MM.12.MMR006D003", name: "Kawthaung District" },
  ],
  "MM.13": [
    { code: "MM.13.MMR011D001", name: "Mawlamyine District" },
    { code: "MM.13.MMR011D002", name: "Thaton District" },
  ],
  "MM.15": [
    { code: "MM.15.MMR009D001", name: "Magway District" },
    { code: "MM.15.MMR009D002", name: "Minbu District" },
    { code: "MM.15.MMR009D003", name: "Thayet District" },
    { code: "MM.15.MMR009D004", name: "Pakokku District" },
    { code: "MM.15.MMR009D005", name: "Gangaw District" },
  ],
  "MM.16": [
    { code: "MM.16.MMR007D001", name: "Bago District" },
    { code: "MM.16.MMR007D002", name: "Taungoo District" },
    { code: "MM.16.MMR008D001", name: "Pyay District" },
    { code: "MM.16.MMR008D002", name: "Thayarwady District" },
  ],
  "MM.17": [
    { code: "MM.17.MMR013D001", name: "Yangon (North)" },
    { code: "MM.17.MMR013D002", name: "Yangon (East)" },
    { code: "MM.17.MMR013D003", name: "Yangon South District" },
    { code: "MM.17.MMR013D004", name: "Yangon East District" },
  ],
  "MM.18": [
    { code: "MM.18.MMR018D001", name: "Nay Pyi Taw (North)" },
    { code: "MM.18.MMR018D002", name: "Nay Pyi Taw (South)" },
  ],
  "MN.01": [
    { code: "MN.01.1515709", name: "Tariat Sum" },
    { code: "MN.01.6618894", name: "Rashaant" },
    { code: "MN.01.6619019", name: "Tsetserleg" },
    { code: "MN.01.6619020", name: "Jargalant" },
    { code: "MN.01.6619021", name: "Erdenemandal" },
    { code: "MN.01.6619022", name: "Hayrhan" },
    { code: "MN.01.6619023", name: "Erdenebulgan" },
    { code: "MN.01.6619024", name: "Ihtamir" },
    { code: "MN.01.6619025", name: "Öndör-Ulaan" },
    { code: "MN.01.6619026", name: "Chuluut" },
    { code: "MN.01.6619027", name: "Hangay" },
    { code: "MN.01.6619028", name: "Tsahir" },
    { code: "MN.01.6619029", name: "Bulgan" },
    { code: "MN.01.6619030", name: "Tsenher" },
    { code: "MN.01.6619031", name: "Tüvshrüüleh" },
    { code: "MN.01.6619032", name: "Hotont" },
    { code: "MN.01.6619033", name: "Hashaat" },
    { code: "MN.01.6619034", name: "Ögiynuur" },
    { code: "MN.01.6619035", name: "Battsengel" },
    { code: "MN.01.6619036", name: "Öldziyt" },
    { code: "MN.01.6987826", name: "Bulgan Sum" },
    { code: "MN.01.6998261", name: "Erdenebulgan Sum" },
    { code: "MN.01.7667597", name: "Khairkhan" },
  ],
  "MN.02": [
    { code: "MN.02.6619062", name: "Dzag" },
    { code: "MN.02.6619063", name: "Gurvanbulag" },
    { code: "MN.02.6619064", name: "Jargalant" },
    { code: "MN.02.6619065", name: "Bayanbulag" },
    { code: "MN.02.6619066", name: "Bayantsagaan" },
    { code: "MN.02.6619067", name: "Hüreemaral" },
    { code: "MN.02.6619068", name: "Buutsagaan" },
    { code: "MN.02.6619069", name: "Bömbögör" },
    { code: "MN.02.6619070", name: "Bayan-Ovoo" },
    { code: "MN.02.6619071", name: "Galuut" },
    { code: "MN.02.6619072", name: "Erdenetsogt" },
    { code: "MN.02.6619073", name: "Bayanhongor" },
    { code: "MN.02.6619074", name: "Öldziyt" },
    { code: "MN.02.6619075", name: "Jinst" },
    { code: "MN.02.6619076", name: "Bogd" },
    { code: "MN.02.6619077", name: "Bayangovĭ" },
    { code: "MN.02.6619078", name: "Bayanlig" },
    { code: "MN.02.6619079", name: "Baatsagaan" },
    { code: "MN.02.6619080", name: "Bayan-Öndör" },
    { code: "MN.02.6619081", name: "Shinejinst" },
    { code: "MN.02.6987839", name: "Bayanbulag Sum" },
    { code: "MN.02.6987911", name: "Erdenetsogt Sum" },
    { code: "MN.02.6998274", name: "Bayanhongor Sum" },
    { code: "MN.02.7667614", name: "Olziit" },
  ],
  "MN.03": [
    { code: "MN.03.1516281", name: "Bayannuur" },
    { code: "MN.03.6619140", name: "Tsagaannuur" },
    { code: "MN.03.6619141", name: "Nogoonnuur" },
    { code: "MN.03.6619142", name: "Ulaanhus" },
    { code: "MN.03.6619143", name: "Tsengel" },
    { code: "MN.03.6619144", name: "Sagsay sum" },
    { code: "MN.03.6619145", name: "Bugat" },
    { code: "MN.03.6619146", name: "Ölgii" },
    { code: "MN.03.6619147", name: "Altantsögts" },
    { code: "MN.03.6619149", name: "Tolbo" },
    { code: "MN.03.6619150", name: "Altay" },
    { code: "MN.03.6619151", name: "Buyant" },
    { code: "MN.03.6619152", name: "Delüün" },
    { code: "MN.03.6619153", name: "Bulgan" },
    { code: "MN.03.6998284", name: "Ölgiy Sum" },
  ],
  "MN.06": [
    { code: "MN.06.10375939", name: "Kherlen" },
    { code: "MN.06.10375940", name: "Khölönbuir" },
    { code: "MN.06.6618688", name: "Halhgol" },
    { code: "MN.06.6618689", name: "Matad" },
    { code: "MN.06.6618690", name: "Bayantümen" },
    { code: "MN.06.6618691", name: "Bulgan" },
    { code: "MN.06.6618692", name: "Hölönbuyr" },
    { code: "MN.06.6618693", name: "Choybalsan" },
    { code: "MN.06.6618694", name: "Chuluunhoroot" },
    { code: "MN.06.6618695", name: "Dashbalbar" },
    { code: "MN.06.6618696", name: "Gurvandzagal" },
    { code: "MN.06.6618697", name: "Sergelen" },
    { code: "MN.06.6618698", name: "Tsagaan-Ovoo" },
    { code: "MN.06.6618699", name: "Bayandun" },
    { code: "MN.06.6618700", name: "Bayan-Uul" },
    { code: "MN.06.6618701", name: "Herlen" },
    { code: "MN.06.6988033", name: "Bayantümen Sum" },
    { code: "MN.06.6988036", name: "Tsagaan-Ovoo Sum" },
    { code: "MN.06.6988038", name: "Choybalsan Sum" },
    { code: "MN.06.6988042", name: "Gurvanzagal Sum" },
  ],
  "MN.07": [
    { code: "MN.07.11886725", name: "Sainshand" },
    { code: "MN.07.6618754", name: "Dalanjargalan" },
    { code: "MN.07.6618755", name: "Ayrag" },
    { code: "MN.07.6618756", name: "Ihhet" },
    { code: "MN.07.6618757", name: "Altanshiree" },
    { code: "MN.07.6618758", name: "Delgereh" },
    { code: "MN.07.6618760", name: "Saynshand" },
    { code: "MN.07.6618761", name: "Örgön" },
    { code: "MN.07.6618762", name: "Erdene" },
    { code: "MN.07.6618763", name: "Dzamyn Üüd" },
    { code: "MN.07.6618764", name: "Ulaanbadrah" },
    { code: "MN.07.6618765", name: "Sayhandulaan" },
    { code: "MN.07.6618766", name: "Mandah" },
    { code: "MN.07.6618767", name: "Hövsgöl" },
    { code: "MN.07.6618768", name: "Hatanbulag" },
    { code: "MN.07.6618771", name: "Shiveegovĭ" },
    { code: "MN.07.6997394", name: "Saynshand Sum" },
    { code: "MN.07.6999252", name: "Dzamïn-Üüd Sum" },
  ],
  "MN.08": [
    { code: "MN.08.6618769", name: "Sümber" },
    { code: "MN.08.6618803", name: "Sayhan-Ovoo" },
    { code: "MN.08.6618804", name: "Delgerhangay" },
    { code: "MN.08.6618805", name: "Huld" },
    { code: "MN.08.6618806", name: "Luus" },
    { code: "MN.08.6618807", name: "Erdenedalay" },
    { code: "MN.08.6618808", name: "Adaatsag" },
    { code: "MN.08.6618809", name: "Delgertsogt" },
    { code: "MN.08.6618810", name: "Deren" },
    { code: "MN.08.6618811", name: "Tsagaandelger" },
    { code: "MN.08.6618812", name: "Govĭ-Ugtaal" },
    { code: "MN.08.6618813", name: "Bayanjargalan" },
    { code: "MN.08.6618814", name: "Gurvansayhan" },
    { code: "MN.08.6618815", name: "Öndörshil" },
    { code: "MN.08.6618816", name: "Öldziyt" },
    { code: "MN.08.6618817", name: "Saintsagaan" },
    { code: "MN.08.6987992", name: "Öldziyt Sum" },
    { code: "MN.08.6997600", name: "Sayntsagaan Sum" },
  ],
  "MN.09": [
    { code: "MN.09.1515279", name: "Songino" },
    { code: "MN.09.6619214", name: "Bayantes" },
    { code: "MN.09.6619215", name: "Tes" },
    { code: "MN.09.6619216", name: "Asgat" },
    { code: "MN.09.6619217", name: "Bayanhayrhan" },
    { code: "MN.09.6619218", name: "Tüdevtey" },
    { code: "MN.09.6619220", name: "Tsetsen-Uul" },
    { code: "MN.09.6619221", name: "Nömrög" },
    { code: "MN.09.6619222", name: "Santmargats" },
    { code: "MN.09.6619223", name: "Urgamal" },
    { code: "MN.09.6619224", name: "Dzavhanmandal" },
    { code: "MN.09.6619226", name: "Erdenehayrhan" },
    { code: "MN.09.6619227", name: "Uliastay" },
    { code: "MN.09.6619228", name: "Aldarhaan" },
    { code: "MN.09.6619229", name: "Yaruu" },
    { code: "MN.09.6619230", name: "Tsagaanhayrhan" },
    { code: "MN.09.6619231", name: "Tsagaanchuluut" },
    { code: "MN.09.6619232", name: "Shilüüstey" },
    { code: "MN.09.6619233", name: "Otgon" },
    { code: "MN.09.6619234", name: "Ider" },
    { code: "MN.09.6619235", name: "Telmen" },
    { code: "MN.09.6619236", name: "Tosontsengel" },
    { code: "MN.09.6619238", name: "Ih-Uul" },
    { code: "MN.09.6987797", name: "Dorvoljin Sum" },
    { code: "MN.09.6987802", name: "Tes Sum" },
    { code: "MN.09.6987852", name: "Asgat Sum" },
  ],
  "MN.10": [
    { code: "MN.10.10375936", name: "Yesönbulag" },
    { code: "MN.10.6619082", name: "Höhmorĭt" },
    { code: "MN.10.6619083", name: "Bayan-Uul" },
    { code: "MN.10.6619084", name: "Jargalan" },
    { code: "MN.10.6619085", name: "Tayshir" },
    { code: "MN.10.6619086", name: "Delger" },
    { code: "MN.10.6619087", name: "Sharga" },
    { code: "MN.10.6619088", name: "Darvi" },
    { code: "MN.10.6619089", name: "Tonhil" },
    { code: "MN.10.6619090", name: "Tögrög" },
    { code: "MN.10.6619091", name: "Bugat" },
    { code: "MN.10.6619092", name: "Yösönbulag" },
    { code: "MN.10.6619093", name: "Haliun" },
    { code: "MN.10.6619094", name: "Tseel" },
    { code: "MN.10.6619095", name: "Altay" },
    { code: "MN.10.6619096", name: "Tsogt" },
    { code: "MN.10.6619097", name: "Biger" },
    { code: "MN.10.6619098", name: "Chandmanĭ" },
    { code: "MN.10.6619099", name: "Erdene" },
    { code: "MN.10.6619225", name: "Dörvöljin" },
  ],
  "MN.11": [
    { code: "MN.11.11898755", name: "Bor-Öndör Sum" },
    { code: "MN.11.6618715", name: "Ömnödelger" },
    { code: "MN.11.6618719", name: "Darhan" },
    { code: "MN.11.6618720", name: "Bayanmönh" },
    { code: "MN.11.6618721", name: "Delgerhaan" },
    { code: "MN.11.6618722", name: "Jargalthaan" },
    { code: "MN.11.6618723", name: "Tsenhermandal" },
    { code: "MN.11.6618725", name: "Mörön" },
    { code: "MN.11.6618726", name: "Herlen" },
    { code: "MN.11.6618727", name: "Bayanhutag" },
    { code: "MN.11.6618728", name: "Galshar" },
    { code: "MN.11.6618729", name: "Batshireet" },
    { code: "MN.11.6618730", name: "Binder" },
    { code: "MN.11.6618731", name: "Bayan-Adarga" },
    { code: "MN.11.6618732", name: "Dadal" },
    { code: "MN.11.6618733", name: "Batnorov" },
    { code: "MN.11.6618734", name: "Bayan-Ovoo" },
    { code: "MN.11.6618735", name: "Norovlin" },
    { code: "MN.11.6988013", name: "Darhan Sum" },
  ],
  "MN.12": [
    { code: "MN.12.10375932", name: "Mönkhkhairkhan" },
    { code: "MN.12.1516065", name: "Dörgön" },
    { code: "MN.12.6619109", name: "Erdenebüren" },
    { code: "MN.12.6619110", name: "Buyant" },
    { code: "MN.12.6619111", name: "Myangad" },
    { code: "MN.12.6619113", name: "Jargalant" },
    { code: "MN.12.6619115", name: "Khovd" },
    { code: "MN.12.6619116", name: "Duut" },
    { code: "MN.12.6619117", name: "Manhan" },
    { code: "MN.12.6619118", name: "Dzereg" },
    { code: "MN.12.6619119", name: "Mönhhayrhan" },
    { code: "MN.12.6619120", name: "Chandmanĭ" },
    { code: "MN.12.6619121", name: "Darvi" },
    { code: "MN.12.6619122", name: "Tsetseg" },
    { code: "MN.12.6619123", name: "Möst" },
    { code: "MN.12.6619124", name: "Üyönch" },
    { code: "MN.12.6619126", name: "Altay" },
    { code: "MN.12.6987811", name: "Bulgan District" },
  ],
  "MN.13": [
    { code: "MN.13.10375937", name: "Bayanzürkh" },
    { code: "MN.13.10375938", name: "Khatgal" },
    { code: "MN.13.2029006", name: "Tarialan" },
    { code: "MN.13.6618997", name: "Renchinlhümbe" },
    { code: "MN.13.6618998", name: "Tsagaannuur" },
    { code: "MN.13.6618999", name: "Ulaan-Uul" },
    { code: "MN.13.6619000", name: "Bayandzürh" },
    { code: "MN.13.6619001", name: "Alag-Erdene" },
    { code: "MN.13.6619002", name: "Arbulag" },
    { code: "MN.13.6619003", name: "Tsagaan-Uul" },
    { code: "MN.13.6619004", name: "Tsetserleg" },
    { code: "MN.13.6619005", name: "Mörön" },
    { code: "MN.13.6619006", name: "Bürentogtoh" },
    { code: "MN.13.6619007", name: "Tömörbulag" },
    { code: "MN.13.6619008", name: "Shine-Ider" },
    { code: "MN.13.6619009", name: "Galt" },
    { code: "MN.13.6619010", name: "Jargalant" },
    { code: "MN.13.6619011", name: "Tosontsengel" },
    { code: "MN.13.6619013", name: "Rashaant" },
    { code: "MN.13.6619014", name: "Tünel" },
    { code: "MN.13.6619015", name: "Chandmanĭ-Öndör" },
    { code: "MN.13.6619016", name: "Tsagaan-Üür" },
    { code: "MN.13.6619017", name: "Erdenebulgan" },
    { code: "MN.13.6619018", name: "Hanh" },
    { code: "MN.13.6987854", name: "Jargalant Sum" },
    { code: "MN.13.6987860", name: "Ih-Uul Sum" },
    { code: "MN.13.6987865", name: "Tsagaan-Uul Sum" },
    { code: "MN.13.6999363", name: "Mörön Sum" },
  ],
  "MN.14": [
    { code: "MN.14.2029819", name: "Nomgon Sum" },
    { code: "MN.14.6618789", name: "Mandal-Ovoo" },
    { code: "MN.14.6618790", name: "Tsogt-Ovoo" },
    { code: "MN.14.6618791", name: "Hanhongor" },
    { code: "MN.14.6618792", name: "Tsogttsetsiy" },
    { code: "MN.14.6618793", name: "Manlay" },
    { code: "MN.14.6618794", name: "Hanbogd" },
    { code: "MN.14.6618795", name: "Bayan-Ovoo" },
    { code: "MN.14.6618796", name: "Hürmen" },
    { code: "MN.14.6618797", name: "Bayandalay" },
    { code: "MN.14.6618798", name: "Bulgan" },
    { code: "MN.14.6618799", name: "Sevrey" },
    { code: "MN.14.6618800", name: "Noyon" },
    { code: "MN.14.6618801", name: "Gurvantes" },
    { code: "MN.14.6618802", name: "Dalandzadgad" },
    { code: "MN.14.6987984", name: "Bayan-Ovoo Sum" },
  ],
  "MN.15": [
    { code: "MN.15.10375951", name: "Baruun Bayan-Ulaan" },
    { code: "MN.15.10375952", name: "Bat-Ölzii" },
    { code: "MN.15.10375953", name: "Yesönzüil" },
    { code: "MN.15.10375954", name: "Züünbayan-Ulaan" },
    { code: "MN.15.2028174", name: "Yusun Tszuyl Somon" },
    { code: "MN.15.6619042", name: "Harhorin" },
    { code: "MN.15.6619043", name: "Hujirt" },
    { code: "MN.15.6619044", name: "Bat-Öldziy" },
    { code: "MN.15.6619045", name: "Uyanga" },
    { code: "MN.15.6619046", name: "Dzüünbayan-Ulaan" },
    { code: "MN.15.6619047", name: "Taragt" },
    { code: "MN.15.6619048", name: "Arvayheer" },
    { code: "MN.15.6619049", name: "Hayrhandulaan" },
    { code: "MN.15.6619050", name: "Nariynteel" },
    { code: "MN.15.6619051", name: "Baruunbayan-Ulaan" },
    { code: "MN.15.6619052", name: "Guchin-Us" },
    { code: "MN.15.6619053", name: "Bogd" },
    { code: "MN.15.6619054", name: "Tögrög" },
    { code: "MN.15.6619056", name: "Bayangol" },
    { code: "MN.15.6619057", name: "Sant" },
    { code: "MN.15.6619058", name: "Bayan-Öndör" },
    { code: "MN.15.6619059", name: "Öldziyt" },
    { code: "MN.15.6619060", name: "Yösöndzüyl" },
    { code: "MN.15.6619061", name: "Bürd" },
  ],
  "MN.16": [
    { code: "MN.16.10375955", name: "Khüder" },
    { code: "MN.16.10375957", name: "Züünbüren" },
    { code: "MN.16.2032552", name: "Bayangol" },
    { code: "MN.16.6618857", name: "Mandal" },
    { code: "MN.16.6618859", name: "Orhon" },
    { code: "MN.16.6618861", name: "Sayhan" },
    { code: "MN.16.6618862", name: "Sant" },
    { code: "MN.16.6618863", name: "Baruunbüren" },
    { code: "MN.16.6618864", name: "Orhontuul" },
    { code: "MN.16.6618865", name: "Shaamar" },
    { code: "MN.16.6618866", name: "Dzüünbüren" },
    { code: "MN.16.6618867", name: "Tsagaannuur" },
    { code: "MN.16.6618868", name: "Tüshig" },
    { code: "MN.16.6618869", name: "Sühbaatar" },
    { code: "MN.16.6618870", name: "Altanbulag" },
    { code: "MN.16.6618872", name: "Hüder" },
    { code: "MN.16.6618873", name: "Javhlant" },
    { code: "MN.16.6618874", name: "Hushaat" },
    { code: "MN.16.6987957", name: "Orhontuul Sum" },
    { code: "MN.16.6987969", name: "Yöröö Sum" },
    { code: "MN.16.6987971", name: "Mandal Sum" },
    { code: "MN.16.6987972", name: "Bayangol Sum" },
  ],
  "MN.17": [
    { code: "MN.17.6618702", name: "Erdenetsagaan" },
    { code: "MN.17.6618703", name: "Darĭganga" },
    { code: "MN.17.6618704", name: "Ongon" },
    { code: "MN.17.6618705", name: "Naran" },
    { code: "MN.17.6618706", name: "Bayandelger" },
    { code: "MN.17.6618707", name: "Haldzan" },
    { code: "MN.17.6618708", name: "Uulbayan" },
    { code: "MN.17.6618709", name: "Mönhhaan" },
    { code: "MN.17.6618710", name: "Tümentsogt" },
    { code: "MN.17.6618711", name: "Sühbaatar" },
    { code: "MN.17.6618712", name: "Tüvshinshiree" },
    { code: "MN.17.6618713", name: "Asgat" },
    { code: "MN.17.6618714", name: "Baruun-Urt" },
    { code: "MN.17.6988047", name: "Darĭganga Sum" },
  ],
  "MN.18": [
    { code: "MN.18.11608745", name: "Khan-Uul" },
    { code: "MN.18.2032465", name: "Bayantsogt Sum" },
    { code: "MN.18.2032495", name: "Bayan-Önjüül Sum" },
    { code: "MN.18.6618770", name: "Bayantal" },
    { code: "MN.18.6618822", name: "Delgerhaan" },
    { code: "MN.18.6618823", name: "Büren" },
    { code: "MN.18.6618824", name: "Bayantsagaan" },
    { code: "MN.18.6618826", name: "Sergelen" },
    { code: "MN.18.6618827", name: "Altanbulag" },
    { code: "MN.18.6618828", name: "Öndörshireet" },
    { code: "MN.18.6618829", name: "Erdenesant" },
    { code: "MN.18.6618830", name: "Lün" },
    { code: "MN.18.6618831", name: "Bayanhangay" },
    { code: "MN.18.6618832", name: "Argalant" },
    { code: "MN.18.6618833", name: "Bayantsogt" },
    { code: "MN.18.6618834", name: "Ugtaal" },
    { code: "MN.18.6618835", name: "Dzaamar" },
    { code: "MN.18.6618836", name: "Tseel" },
    { code: "MN.18.6618837", name: "Jargalant" },
    { code: "MN.18.6618838", name: "Sümber" },
    { code: "MN.18.6618839", name: "Bornuur" },
    { code: "MN.18.6618840", name: "Bayanchandmanĭ" },
    { code: "MN.18.6618841", name: "Batsümber" },
    { code: "MN.18.6618842", name: "Möngönmorĭt" },
    { code: "MN.18.6618843", name: "Bayandelger" },
    { code: "MN.18.6618844", name: "Erdene" },
    { code: "MN.18.6618845", name: "Arhust" },
    { code: "MN.18.6618846", name: "Bayan" },
    { code: "MN.18.6618847", name: "Bayanjargalan" },
    { code: "MN.18.6618848", name: "Dzuunmod" },
    { code: "MN.18.6618851", name: "Baganuur" },
    { code: "MN.18.6987939", name: "Bayan Sum" },
    { code: "MN.18.6987952", name: "Ugtaaltsaydam Sum" },
    { code: "MN.18.6988008", name: "Bayantsagaan Sum" },
  ],
  "MN.19": [
    { code: "MN.19.10375933", name: "Öndörkhangai" },
    { code: "MN.19.10375934", name: "Züüngovi" },
    { code: "MN.19.10375935", name: "Züünkhangai" },
    { code: "MN.19.6619154", name: "Davst" },
    { code: "MN.19.6619155", name: "Sagil" },
    { code: "MN.19.6619156", name: "Türgen" },
    { code: "MN.19.6619157", name: "Tarialan" },
    { code: "MN.19.6619158", name: "Ulaangom" },
    { code: "MN.19.6619159", name: "Naranbulag" },
    { code: "MN.19.6619160", name: "Ölgiy" },
    { code: "MN.19.6619161", name: "Ömnögovĭ" },
    { code: "MN.19.6619162", name: "Hovd" },
    { code: "MN.19.6619163", name: "Böhmörön" },
    { code: "MN.19.6619164", name: "Tes" },
    { code: "MN.19.6619165", name: "Dzüüngovĭ" },
    { code: "MN.19.6619166", name: "Malchin" },
    { code: "MN.19.6619167", name: "Dzavhan" },
    { code: "MN.19.6619168", name: "Hyargas" },
    { code: "MN.19.6619169", name: "Tsagaanhayrhan" },
    { code: "MN.19.6619170", name: "Baruunturuun" },
    { code: "MN.19.6619171", name: "Öndörhangay" },
    { code: "MN.19.6619172", name: "Dzüünhangay" },
    { code: "MN.19.6987792", name: "Dzüüngovĭ Sum" },
  ],
  "MN.20": [
    { code: "MN.20.6618852", name: "Bayandzürh" },
  ],
  "MN.21": [
    { code: "MN.21.6618878", name: "Hangal" },
    { code: "MN.21.6618879", name: "Selenge" },
    { code: "MN.21.6618881", name: "Teshig" },
    { code: "MN.21.6618882", name: "Hutag-Öndör" },
    { code: "MN.21.6618883", name: "Bugat" },
    { code: "MN.21.6618884", name: "Bayan-Agt" },
    { code: "MN.21.6618885", name: "Sayhan" },
    { code: "MN.21.6618886", name: "Orhon" },
    { code: "MN.21.6618887", name: "Hishig-Öndör" },
    { code: "MN.21.6618888", name: "Mogod" },
    { code: "MN.21.6618889", name: "Büreghangay" },
    { code: "MN.21.6618890", name: "Dashinchilen" },
    { code: "MN.21.6618892", name: "Bayannuur" },
    { code: "MN.21.6618893", name: "Gurvanbulag" },
    { code: "MN.21.6618895", name: "Bulgan District" },
    { code: "MN.21.6987814", name: "Rashaant Sum" },
    { code: "MN.21.6987815", name: "Gurvanbulag Sum" },
    { code: "MN.21.6987819", name: "Hutag-Öndör Sum" },
    { code: "MN.21.6987973", name: "Dashinchilen Sum" },
    { code: "MN.21.6987974", name: "Bayannuur Sum" },
    { code: "MN.21.6987975", name: "Büreghangay Sum" },
    { code: "MN.21.6987976", name: "Orhon Sum" },
  ],
  "MN.23": [
    { code: "MN.23.6618853", name: "Sharïngol" },
    { code: "MN.23.6618854", name: "Hongor" },
    { code: "MN.23.6618855", name: "Orhon" },
  ],
  "MN.24": [
    { code: "MN.24.6988010", name: "Bayantal Sum" },
    { code: "MN.24.6988011", name: "Shiveegovi Sum" },
    { code: "MN.24.6988012", name: "Sümber Sum" },
  ],
  "MN.25": [
    { code: "MN.25.6618875", name: "Bayan-Öndör" },
    { code: "MN.25.6618877", name: "Jargalant" },
    { code: "MN.25.6987977", name: "Jargalant Sum" },
    { code: "MN.25.6987978", name: "Erdenet Sum" },
  ],
  "MP.085": [
    { code: "MP.085.7733402", name: "Farallon de Pajaros" },
    { code: "MP.085.7733403", name: "Asuncion Island" },
    { code: "MP.085.7733404", name: "Agrihan Island" },
    { code: "MP.085.7733405", name: "Pagan Island" },
    { code: "MP.085.7733406", name: "Alamagan Island" },
    { code: "MP.085.7733407", name: "Guguan Island" },
    { code: "MP.085.7733408", name: "Zealandia Bank" },
    { code: "MP.085.7733409", name: "Sarigan Island" },
    { code: "MP.085.7733410", name: "Anatahan Island" },
    { code: "MP.085.7733411", name: "Farallon de Medinilla" },
    { code: "MP.085.7733412", name: "Maug Islands" },
  ],
  "MP.120": [
    { code: "MP.120.7755008", name: "Aguijan Island" },
  ],
  "MQ.MQ": [
    { code: "MQ.MQ.972", name: "Martinique" },
  ],
  "MR.01": [
    { code: "MR.01.11996537", name: "D'har" },
    { code: "MR.01.9212608", name: "Nema" },
    { code: "MR.01.9212609", name: "Timbedra" },
    { code: "MR.01.9212623", name: "Amourj" },
    { code: "MR.01.9212655", name: "Oualata" },
    { code: "MR.01.9222754", name: "Bassiknou" },
    { code: "MR.01.9226996", name: "Djigueni" },
  ],
  "MR.02": [
    { code: "MR.02.9212606", name: "Aioun" },
    { code: "MR.02.9212625", name: "Tintane" },
    { code: "MR.02.9212627", name: "Kobenni" },
    { code: "MR.02.9226673", name: "Tamchekett" },
  ],
  "MR.03": [
    { code: "MR.03.9212602", name: "Guerou" },
    { code: "MR.03.9212605", name: "Kiffa" },
    { code: "MR.03.9212624", name: "Kankossa" },
    { code: "MR.03.9212638", name: "Boumdeid" },
    { code: "MR.03.9229053", name: "Barkeol" },
  ],
  "MR.04": [
    { code: "MR.04.9212603", name: "Maghama" },
    { code: "MR.04.9212629", name: "Kaedi" },
    { code: "MR.04.9212634", name: "M'Bout" },
    { code: "MR.04.9212642", name: "Monguel" },
  ],
  "MR.05": [
    { code: "MR.05.7910308", name: "Aleg" },
    { code: "MR.05.8335141", name: "Bogué Department" },
    { code: "MR.05.9212619", name: "Bababe" },
    { code: "MR.05.9212631", name: "M'Bagne" },
    { code: "MR.05.9212635", name: "Magta-Lahjar" },
  ],
  "MR.06": [
    { code: "MR.06.7910309", name: "Rosso Department" },
    { code: "MR.06.8051339", name: "Ouad Naga" },
    { code: "MR.06.8051340", name: "Mederdra" },
    { code: "MR.06.8051341", name: "Boutilimit" },
    { code: "MR.06.9212604", name: "R'Kiz" },
    { code: "MR.06.9212614", name: "Keur-Macene" },
  ],
  "MR.07": [
    { code: "MR.07.9212615", name: "Aoujeft" },
    { code: "MR.07.9212628", name: "Chinguetti" },
    { code: "MR.07.9212641", name: "Atar" },
    { code: "MR.07.9212644", name: "Ouadane" },
  ],
  "MR.08": [
    { code: "MR.08.11996536", name: "Chami" },
    { code: "MR.08.9212637", name: "Nouadhibou" },
  ],
  "MR.09": [
    { code: "MR.09.7910310", name: "Tidjikja" },
    { code: "MR.09.9212630", name: "Tichitt" },
    { code: "MR.09.9212633", name: "Moudjeria" },
  ],
  "MR.10": [
    { code: "MR.10.9212601", name: "Selibaby" },
    { code: "MR.10.9212620", name: "Ould Yenge" },
  ],
  "MR.11": [
    { code: "MR.11.9212610", name: "F'Derik" },
    { code: "MR.11.9212618", name: "Bir Moghreïn" },
    { code: "MR.11.9212643", name: "Zouerate" },
  ],
  "MR.12": [
    { code: "MR.12.9212639", name: "Akjoujt" },
  ],
  "MR.13": [
    { code: "MR.13.9212586", name: "Ksar" },
    { code: "MR.13.9212593", name: "Sebkha" },
    { code: "MR.13.9222773", name: "Tevragh Zeina" },
  ],
  "MR.14": [
    { code: "MR.14.9212580", name: "Dar Naim" },
    { code: "MR.14.9212594", name: "Teyarett" },
    { code: "MR.14.9212597", name: "Toujounine" },
  ],
  "MR.15": [
    { code: "MR.15.9212577", name: "Arafat" },
    { code: "MR.15.9212590", name: "Riad" },
    { code: "MR.15.9222769", name: "El Mina" },
  ],
  "MW.C": [
    { code: "MW.C.06", name: "Dedza District" },
    { code: "MW.C.07", name: "Dowa District" },
    { code: "MW.C.09", name: "Kasungu District" },
    { code: "MW.C.11", name: "Lilongwe District" },
    { code: "MW.C.13", name: "Mchinji District" },
    { code: "MW.C.16", name: "Ntcheu District" },
    { code: "MW.C.18", name: "Nkhotakota District" },
    { code: "MW.C.20", name: "Ntchisi District" },
    { code: "MW.C.22", name: "Salima District" },
  ],
  "MW.N": [
    { code: "MW.N.04", name: "Chitipa District" },
    { code: "MW.N.08", name: "Karonga District" },
    { code: "MW.N.15", name: "Mzimba District" },
    { code: "MW.N.17", name: "Nkhata Bay District" },
    { code: "MW.N.21", name: "Rumphi District" },
    { code: "MW.N.27", name: "Likoma District" },
  ],
  "MW.S": [
    { code: "MW.S.02", name: "Chikwawa District" },
    { code: "MW.S.03", name: "Chiradzulu District" },
    { code: "MW.S.05", name: "Thyolo District" },
    { code: "MW.S.12", name: "Mangochi District" },
    { code: "MW.S.19", name: "Nsanje District" },
    { code: "MW.S.23", name: "Zomba District" },
    { code: "MW.S.24", name: "Blantyre District" },
    { code: "MW.S.25", name: "Mwanza District" },
    { code: "MW.S.26", name: "Balaka District" },
    { code: "MW.S.28", name: "Machinga District" },
    { code: "MW.S.29", name: "Mulanje District" },
    { code: "MW.S.30", name: "Phalombe District" },
    { code: "MW.S.31", name: "Neno District" },
  ],
  "MX.01": [
    { code: "MX.01.001", name: "Aguascalientes" },
    { code: "MX.01.002", name: "Asientos" },
    { code: "MX.01.003", name: "Calvillo" },
    { code: "MX.01.004", name: "Cosío" },
    { code: "MX.01.005", name: "Jesús María" },
    { code: "MX.01.006", name: "Pabellón de Arteaga" },
    { code: "MX.01.007", name: "Rincón de Romos" },
    { code: "MX.01.008", name: "San José de Gracia" },
    { code: "MX.01.009", name: "Tepezalá" },
    { code: "MX.01.010", name: "El Llano" },
    { code: "MX.01.011", name: "San Francisco de los Romo" },
  ],
  "MX.02": [
    { code: "MX.02.001", name: "Ensenada" },
    { code: "MX.02.002", name: "Mexicali" },
    { code: "MX.02.003", name: "Tecate" },
    { code: "MX.02.004", name: "Tijuana" },
    { code: "MX.02.005", name: "Playas de Rosarito" },
  ],
  "MX.03": [
    { code: "MX.03.001", name: "Comondú" },
    { code: "MX.03.002", name: "Mulegé" },
    { code: "MX.03.003", name: "La Paz" },
    { code: "MX.03.008", name: "Los Cabos" },
    { code: "MX.03.009", name: "Loreto" },
  ],
  "MX.04": [
    { code: "MX.04.001", name: "Calkiní" },
    { code: "MX.04.002", name: "Campeche" },
    { code: "MX.04.003", name: "Carmen" },
    { code: "MX.04.004", name: "Champotón" },
    { code: "MX.04.005", name: "Hecelchakán" },
    { code: "MX.04.006", name: "Hopelchén" },
    { code: "MX.04.007", name: "Palizada" },
    { code: "MX.04.008", name: "Tenabo" },
    { code: "MX.04.009", name: "Escárcega" },
    { code: "MX.04.010", name: "Calakmul" },
    { code: "MX.04.011", name: "Candelaria" },
  ],
  "MX.05": [
    { code: "MX.05.001", name: "Acacoyagua" },
    { code: "MX.05.002", name: "Acala" },
    { code: "MX.05.003", name: "Acapetahua" },
    { code: "MX.05.004", name: "Altamirano" },
    { code: "MX.05.005", name: "Amatán" },
    { code: "MX.05.006", name: "Amatenango de la Frontera" },
    { code: "MX.05.007", name: "Amatenango del Valle" },
    { code: "MX.05.008", name: "Ángel Albino Corzo" },
    { code: "MX.05.009", name: "Arriaga" },
    { code: "MX.05.010", name: "Bejucal de Ocampo" },
    { code: "MX.05.011", name: "Bella Vista" },
    { code: "MX.05.012", name: "Berriozábal" },
    { code: "MX.05.013", name: "Bochil" },
    { code: "MX.05.014", name: "El Bosque" },
    { code: "MX.05.015", name: "Cacahoatán" },
    { code: "MX.05.016", name: "Catazajá" },
    { code: "MX.05.017", name: "Cintalapa" },
    { code: "MX.05.018", name: "Coapilla" },
    { code: "MX.05.019", name: "Comitán Municipality" },
    { code: "MX.05.020", name: "La Concordia" },
    { code: "MX.05.021", name: "Copainalá" },
    { code: "MX.05.022", name: "Chalchihuitán" },
    { code: "MX.05.023", name: "Chamula" },
    { code: "MX.05.024", name: "Chanal" },
    { code: "MX.05.025", name: "Chapultenango" },
    { code: "MX.05.026", name: "Chenalhó" },
    { code: "MX.05.027", name: "Chiapa de Corzo" },
    { code: "MX.05.028", name: "Chiapilla" },
    { code: "MX.05.029", name: "Chicoasén" },
    { code: "MX.05.030", name: "Chicomuselo" },
    { code: "MX.05.031", name: "Chilón" },
    { code: "MX.05.032", name: "Escuintla" },
    { code: "MX.05.033", name: "Francisco León" },
    { code: "MX.05.034", name: "Frontera Comalapa" },
    { code: "MX.05.035", name: "Frontera Hidalgo" },
    { code: "MX.05.036", name: "La Grandeza" },
    { code: "MX.05.037", name: "Huehuetán" },
    { code: "MX.05.038", name: "Huixtán" },
    { code: "MX.05.039", name: "Huitiupán" },
    { code: "MX.05.040", name: "Huixtla" },
    { code: "MX.05.041", name: "La Independencia" },
    { code: "MX.05.042", name: "Ixhuatán" },
    { code: "MX.05.043", name: "Ixtacomitán" },
    { code: "MX.05.044", name: "Ixtapa" },
    { code: "MX.05.045", name: "Ixtapangajoya" },
    { code: "MX.05.046", name: "Jiquipilas" },
    { code: "MX.05.047", name: "Jitotol" },
    { code: "MX.05.048", name: "Juárez" },
    { code: "MX.05.049", name: "Larráinzar" },
    { code: "MX.05.050", name: "La Libertad" },
    { code: "MX.05.051", name: "Mapastepec" },
    { code: "MX.05.052", name: "Las Margaritas" },
    { code: "MX.05.053", name: "Mazapa de Madero" },
    { code: "MX.05.054", name: "Mazatán" },
    { code: "MX.05.055", name: "Metapa" },
    { code: "MX.05.056", name: "Mitontic" },
    { code: "MX.05.057", name: "Motozintla" },
    { code: "MX.05.058", name: "Nicolás Ruíz" },
    { code: "MX.05.059", name: "Ocosingo" },
    { code: "MX.05.060", name: "Ocotepec" },
    { code: "MX.05.061", name: "Ocozocoautla de Espinosa" },
    { code: "MX.05.062", name: "Ostuacán" },
    { code: "MX.05.063", name: "Osumacinta" },
    { code: "MX.05.064", name: "Oxchuc" },
    { code: "MX.05.065", name: "Palenque" },
    { code: "MX.05.066", name: "Pantelhó" },
    { code: "MX.05.067", name: "Pantepec" },
    { code: "MX.05.068", name: "Pichucalco" },
    { code: "MX.05.069", name: "Pijijiapan" },
    { code: "MX.05.070", name: "El Porvenir" },
    { code: "MX.05.071", name: "Villa Comaltitlán" },
    { code: "MX.05.072", name: "Pueblo Nuevo Solistahuacán" },
    { code: "MX.05.073", name: "Rayón" },
    { code: "MX.05.074", name: "Reforma" },
    { code: "MX.05.075", name: "Las Rosas" },
    { code: "MX.05.076", name: "Sabanilla" },
    { code: "MX.05.077", name: "Salto de Agua" },
    { code: "MX.05.078", name: "San Cristobal De Casas" },
    { code: "MX.05.079", name: "San Fernando" },
    { code: "MX.05.080", name: "Siltepec" },
    { code: "MX.05.081", name: "Simojovel" },
    { code: "MX.05.082", name: "Sitalá" },
    { code: "MX.05.083", name: "Socoltenango" },
    { code: "MX.05.084", name: "Solosuchiapa" },
    { code: "MX.05.085", name: "Soyaló" },
    { code: "MX.05.086", name: "Suchiapa" },
    { code: "MX.05.087", name: "Suchiate" },
    { code: "MX.05.088", name: "Sunuapa" },
    { code: "MX.05.089", name: "Tapachula" },
    { code: "MX.05.090", name: "Tapalapa" },
    { code: "MX.05.091", name: "Tapilula" },
    { code: "MX.05.092", name: "Tecpatán" },
    { code: "MX.05.093", name: "Tenejapa" },
    { code: "MX.05.094", name: "Teopisca" },
    { code: "MX.05.096", name: "Tila" },
    { code: "MX.05.097", name: "Tonalá" },
    { code: "MX.05.098", name: "Totolapa" },
    { code: "MX.05.099", name: "La Trinitaria" },
    { code: "MX.05.100", name: "Tumbalá" },
    { code: "MX.05.101", name: "Tuxtla Gutiérrez" },
    { code: "MX.05.102", name: "Tuxtla Chico" },
    { code: "MX.05.103", name: "Tuzantán" },
    { code: "MX.05.104", name: "Tzimol" },
    { code: "MX.05.105", name: "Unión Juárez" },
    { code: "MX.05.106", name: "Venustiano Carranza" },
    { code: "MX.05.107", name: "Villa Corzo" },
    { code: "MX.05.108", name: "Villaflores" },
    { code: "MX.05.109", name: "Yajalón" },
    { code: "MX.05.110", name: "San Lucas" },
    { code: "MX.05.111", name: "Zinacantán" },
    { code: "MX.05.112", name: "San Juan Cancuc" },
    { code: "MX.05.113", name: "Aldama" },
    { code: "MX.05.114", name: "Benemérito de las Américas" },
    { code: "MX.05.115", name: "Maravilla Tenejapa" },
    { code: "MX.05.116", name: "Marqués de Comillas" },
    { code: "MX.05.117", name: "Montecristo de Guerrero" },
    { code: "MX.05.118", name: "San Andrés Duraznal" },
    { code: "MX.05.119", name: "Santiago el Pinar" },
  ],
  "MX.06": [
    { code: "MX.06.001", name: "Ahumada" },
    { code: "MX.06.002", name: "Aldama" },
    { code: "MX.06.003", name: "Allende" },
    { code: "MX.06.004", name: "Aquiles Serdán" },
    { code: "MX.06.005", name: "Ascensión" },
    { code: "MX.06.006", name: "Bachíniva" },
    { code: "MX.06.007", name: "Balleza" },
    { code: "MX.06.008", name: "Batopilas" },
    { code: "MX.06.009", name: "Bocoyna" },
    { code: "MX.06.010", name: "Buenaventura" },
    { code: "MX.06.011", name: "Camargo" },
    { code: "MX.06.012", name: "Carichí" },
    { code: "MX.06.013", name: "Casas Grandes" },
    { code: "MX.06.014", name: "Coronado" },
    { code: "MX.06.015", name: "Coyame del Sotol" },
    { code: "MX.06.016", name: "La Cruz" },
    { code: "MX.06.017", name: "Cuauhtémoc" },
    { code: "MX.06.018", name: "Cusihuiriachi" },
    { code: "MX.06.019", name: "Chihuahua" },
    { code: "MX.06.020", name: "Chínipas" },
    { code: "MX.06.021", name: "Delicias" },
    { code: "MX.06.022", name: "Dr. Belisario Domínguez" },
    { code: "MX.06.023", name: "Galeana" },
    { code: "MX.06.024", name: "Santa Isabel" },
    { code: "MX.06.025", name: "Gómez Farías" },
    { code: "MX.06.026", name: "Gran Morelos" },
    { code: "MX.06.027", name: "Guachochi" },
    { code: "MX.06.028", name: "Guadalupe" },
    { code: "MX.06.029", name: "Guadalupe y Calvo" },
    { code: "MX.06.030", name: "Guazapares" },
    { code: "MX.06.031", name: "Guerrero" },
    { code: "MX.06.032", name: "Hidalgo del Parral" },
    { code: "MX.06.033", name: "Huejotitán" },
    { code: "MX.06.034", name: "Ignacio Zaragoza" },
    { code: "MX.06.035", name: "Janos" },
    { code: "MX.06.036", name: "Jiménez" },
    { code: "MX.06.037", name: "Juárez" },
    { code: "MX.06.038", name: "Julimes" },
    { code: "MX.06.039", name: "López" },
    { code: "MX.06.040", name: "Madera" },
    { code: "MX.06.041", name: "Maguarichi" },
    { code: "MX.06.042", name: "Manuel Benavides" },
    { code: "MX.06.043", name: "Matachí" },
    { code: "MX.06.044", name: "Matamoros" },
    { code: "MX.06.045", name: "Meoqui" },
    { code: "MX.06.046", name: "Morelos" },
    { code: "MX.06.047", name: "Moris" },
    { code: "MX.06.048", name: "Namiquipa" },
    { code: "MX.06.049", name: "Nonoava" },
    { code: "MX.06.050", name: "Nuevo Casas Grandes" },
    { code: "MX.06.051", name: "Ocampo" },
    { code: "MX.06.052", name: "Ojinaga" },
    { code: "MX.06.053", name: "Praxedis G. Guerrero" },
    { code: "MX.06.054", name: "Riva Palacio" },
    { code: "MX.06.055", name: "Rosales" },
    { code: "MX.06.056", name: "Rosario" },
    { code: "MX.06.057", name: "San Francisco de Borja" },
    { code: "MX.06.058", name: "San Francisco de Conchos" },
    { code: "MX.06.059", name: "San Francisco del Oro" },
    { code: "MX.06.060", name: "Santa Bárbara" },
    { code: "MX.06.061", name: "Satevó" },
    { code: "MX.06.062", name: "Saucillo" },
    { code: "MX.06.063", name: "Temósachic" },
    { code: "MX.06.064", name: "El Tule" },
    { code: "MX.06.065", name: "Urique" },
    { code: "MX.06.066", name: "Uruachi" },
    { code: "MX.06.067", name: "Valle de Zaragoza" },
  ],
  "MX.07": [
    { code: "MX.07.001", name: "Abasolo" },
    { code: "MX.07.002", name: "Acuña" },
    { code: "MX.07.003", name: "Allende" },
    { code: "MX.07.004", name: "Arteaga" },
    { code: "MX.07.005", name: "Candela" },
    { code: "MX.07.006", name: "Castaños" },
    { code: "MX.07.007", name: "Cuatro Ciénegas" },
    { code: "MX.07.008", name: "Escobedo" },
    { code: "MX.07.009", name: "Francisco I. Madero" },
    { code: "MX.07.010", name: "Frontera" },
    { code: "MX.07.011", name: "General Cepeda" },
    { code: "MX.07.012", name: "Guerrero" },
    { code: "MX.07.013", name: "Hidalgo" },
    { code: "MX.07.014", name: "Jiménez" },
    { code: "MX.07.015", name: "Juárez" },
    { code: "MX.07.016", name: "Lamadrid" },
    { code: "MX.07.017", name: "Matamoros" },
    { code: "MX.07.018", name: "Monclova" },
    { code: "MX.07.019", name: "Morelos" },
    { code: "MX.07.020", name: "Múzquiz" },
    { code: "MX.07.021", name: "Nadadores" },
    { code: "MX.07.022", name: "Nava" },
    { code: "MX.07.023", name: "Ocampo" },
    { code: "MX.07.024", name: "Parras" },
    { code: "MX.07.025", name: "Piedras Negras" },
    { code: "MX.07.026", name: "Progreso" },
    { code: "MX.07.027", name: "Ramos Arizpe" },
    { code: "MX.07.028", name: "Sabinas" },
    { code: "MX.07.029", name: "Sacramento" },
    { code: "MX.07.030", name: "Saltillo" },
    { code: "MX.07.031", name: "San Buenaventura" },
    { code: "MX.07.032", name: "San Juan de Sabinas" },
    { code: "MX.07.033", name: "San Pedro" },
    { code: "MX.07.034", name: "Sierra Mojada" },
    { code: "MX.07.035", name: "Torreón" },
    { code: "MX.07.036", name: "Viesca" },
    { code: "MX.07.037", name: "Villa Unión" },
    { code: "MX.07.038", name: "Zaragoza" },
  ],
  "MX.08": [
    { code: "MX.08.001", name: "Armería" },
    { code: "MX.08.002", name: "Colima" },
    { code: "MX.08.003", name: "Comala" },
    { code: "MX.08.004", name: "Coquimatlán" },
    { code: "MX.08.005", name: "Cuauhtémoc" },
    { code: "MX.08.006", name: "Ixtlahuacán" },
    { code: "MX.08.007", name: "Manzanillo" },
    { code: "MX.08.008", name: "Minatitlán" },
    { code: "MX.08.009", name: "Tecomán" },
    { code: "MX.08.010", name: "Villa de Álvarez" },
  ],
  "MX.09": [
    { code: "MX.09.002", name: "Azcapotzalco" },
    { code: "MX.09.003", name: "Coyoacán" },
    { code: "MX.09.004", name: "Cuajimalpa de Morelos" },
    { code: "MX.09.005", name: "Gustavo A. Madero" },
    { code: "MX.09.006", name: "Iztacalco" },
    { code: "MX.09.007", name: "Iztapalapa" },
    { code: "MX.09.008", name: "Magdalena Contreras" },
    { code: "MX.09.009", name: "Milpa Alta" },
    { code: "MX.09.010", name: "Álvaro Obregón" },
    { code: "MX.09.011", name: "Tláhuac" },
    { code: "MX.09.012", name: "Tlalpan" },
    { code: "MX.09.013", name: "Xochimilco" },
    { code: "MX.09.014", name: "Benito Juárez" },
    { code: "MX.09.015", name: "Cuauhtémoc" },
    { code: "MX.09.016", name: "Miguel Hidalgo" },
    { code: "MX.09.017", name: "Venustiano Carranza" },
  ],
  "MX.10": [
    { code: "MX.10.001", name: "Canatlán" },
    { code: "MX.10.002", name: "Canelas" },
    { code: "MX.10.003", name: "Coneto de Comonfort" },
    { code: "MX.10.004", name: "Cuencamé" },
    { code: "MX.10.005", name: "Durango" },
    { code: "MX.10.006", name: "General Simón Bolívar" },
    { code: "MX.10.007", name: "Gómez Palacio" },
    { code: "MX.10.008", name: "Guadalupe Victoria" },
    { code: "MX.10.009", name: "Guanaceví" },
    { code: "MX.10.010", name: "Hidalgo" },
    { code: "MX.10.011", name: "Indé" },
    { code: "MX.10.012", name: "Lerdo" },
    { code: "MX.10.013", name: "Mapimí" },
    { code: "MX.10.014", name: "Mezquital" },
    { code: "MX.10.015", name: "Nazas" },
    { code: "MX.10.016", name: "Nombre de Dios" },
    { code: "MX.10.017", name: "Ocampo" },
    { code: "MX.10.018", name: "El Oro" },
    { code: "MX.10.019", name: "Otáez" },
    { code: "MX.10.020", name: "Pánuco de Coronado" },
    { code: "MX.10.021", name: "Peñón Blanco" },
    { code: "MX.10.022", name: "Poanas" },
    { code: "MX.10.023", name: "Pueblo Nuevo" },
    { code: "MX.10.024", name: "Rodeo" },
    { code: "MX.10.025", name: "San Bernardo" },
    { code: "MX.10.026", name: "San Dimas" },
    { code: "MX.10.027", name: "San Juan de Guadalupe" },
    { code: "MX.10.028", name: "San Juan del Río" },
    { code: "MX.10.029", name: "San Luis del Cordero" },
    { code: "MX.10.030", name: "San Pedro del Gallo" },
    { code: "MX.10.031", name: "Santa Clara" },
    { code: "MX.10.032", name: "Santiago Papasquiaro" },
    { code: "MX.10.033", name: "Súchil" },
    { code: "MX.10.034", name: "Tamazula" },
    { code: "MX.10.035", name: "Tepehuanes" },
    { code: "MX.10.036", name: "Tlahualilo" },
    { code: "MX.10.037", name: "Topia" },
    { code: "MX.10.038", name: "Vicente Guerrero" },
    { code: "MX.10.039", name: "Nuevo Ideal" },
  ],
  "MX.11": [
    { code: "MX.11.001", name: "Abasolo" },
    { code: "MX.11.002", name: "Acámbaro" },
    { code: "MX.11.003", name: "San Miguel de Allende" },
    { code: "MX.11.004", name: "Apaseo el Alto" },
    { code: "MX.11.005", name: "Apaseo el Grande" },
    { code: "MX.11.006", name: "Atarjea" },
    { code: "MX.11.007", name: "Celaya" },
    { code: "MX.11.008", name: "Manuel Doblado" },
    { code: "MX.11.009", name: "Comonfort" },
    { code: "MX.11.010", name: "Coroneo" },
    { code: "MX.11.011", name: "Cortazar" },
    { code: "MX.11.012", name: "Cuerámaro" },
    { code: "MX.11.013", name: "Doctor Mora" },
    { code: "MX.11.014", name: "Dolores Hidalgo Cuna de la Independencia Nacional" },
    { code: "MX.11.015", name: "Guanajuato" },
    { code: "MX.11.016", name: "Huanímaro" },
    { code: "MX.11.017", name: "Irapuato" },
    { code: "MX.11.018", name: "Jaral del Progreso" },
    { code: "MX.11.019", name: "Jerécuaro" },
    { code: "MX.11.020", name: "León" },
    { code: "MX.11.021", name: "Moroleón" },
    { code: "MX.11.022", name: "Ocampo" },
    { code: "MX.11.023", name: "Pénjamo" },
    { code: "MX.11.024", name: "Pueblo Nuevo" },
    { code: "MX.11.025", name: "Purísima del Rincón" },
    { code: "MX.11.026", name: "Romita" },
    { code: "MX.11.027", name: "Salamanca" },
    { code: "MX.11.028", name: "Salvatierra" },
    { code: "MX.11.029", name: "San Diego de la Unión" },
    { code: "MX.11.030", name: "San Felipe" },
    { code: "MX.11.031", name: "San Francisco del Rincón" },
    { code: "MX.11.032", name: "San José Iturbide" },
    { code: "MX.11.033", name: "San Luis de la Paz" },
    { code: "MX.11.034", name: "Santa Catarina" },
    { code: "MX.11.035", name: "Santa Cruz de Juventino Rosas" },
    { code: "MX.11.036", name: "Santiago Maravatío" },
    { code: "MX.11.037", name: "Silao de la Victoria" },
    { code: "MX.11.038", name: "Tarandacuao" },
    { code: "MX.11.039", name: "Tarimoro" },
    { code: "MX.11.040", name: "Tierra Blanca" },
    { code: "MX.11.041", name: "Uriangato" },
    { code: "MX.11.042", name: "Valle de Santiago" },
    { code: "MX.11.043", name: "Victoria" },
    { code: "MX.11.044", name: "Villagrán" },
    { code: "MX.11.045", name: "Xichú" },
    { code: "MX.11.046", name: "Yuriria" },
  ],
  "MX.12": [
    { code: "MX.12.001", name: "Acapulco de Juárez" },
    { code: "MX.12.002", name: "Ahuacuotzingo" },
    { code: "MX.12.003", name: "Ajuchitlán del Progreso" },
    { code: "MX.12.004", name: "Alcozauca de Guerrero" },
    { code: "MX.12.005", name: "Alpoyeca" },
    { code: "MX.12.006", name: "Apaxtla" },
    { code: "MX.12.007", name: "Arcelia" },
    { code: "MX.12.008", name: "Atenango del Río" },
    { code: "MX.12.009", name: "Atlamajalcingo del Monte" },
    { code: "MX.12.010", name: "Atlixtac" },
    { code: "MX.12.011", name: "Atoyac de Álvarez" },
    { code: "MX.12.012", name: "Ayutla de los Libres" },
    { code: "MX.12.013", name: "Azoyú" },
    { code: "MX.12.014", name: "Benito Juárez" },
    { code: "MX.12.015", name: "Buenavista de Cuéllar" },
    { code: "MX.12.016", name: "Coahuayutla de José María Izazaga" },
    { code: "MX.12.017", name: "Cocula" },
    { code: "MX.12.018", name: "Copala" },
    { code: "MX.12.019", name: "Copalillo" },
    { code: "MX.12.020", name: "Copanatoyac" },
    { code: "MX.12.021", name: "Coyuca de Benítez" },
    { code: "MX.12.022", name: "Coyuca de Catalán" },
    { code: "MX.12.023", name: "Cuajinicuilapa" },
    { code: "MX.12.024", name: "Cualác" },
    { code: "MX.12.025", name: "Cuautepec" },
    { code: "MX.12.026", name: "Cuetzala del Progreso" },
    { code: "MX.12.027", name: "Cutzamala de Pinzón" },
    { code: "MX.12.028", name: "Chilapa de Álvarez" },
    { code: "MX.12.029", name: "Chilpancingo de los Bravo" },
    { code: "MX.12.030", name: "Florencio Villarreal" },
    { code: "MX.12.031", name: "General Canuto A. Neri" },
    { code: "MX.12.032", name: "General Heliodoro Castillo" },
    { code: "MX.12.033", name: "Huamuxtitlán" },
    { code: "MX.12.034", name: "Huitzuco de los Figueroa" },
    { code: "MX.12.035", name: "Iguala de la Independencia" },
    { code: "MX.12.036", name: "Igualapa" },
    { code: "MX.12.037", name: "Ixcateopan de Cuauhtémoc" },
    { code: "MX.12.038", name: "Zihuatanejo de Azueta" },
    { code: "MX.12.039", name: "Juan R. Escudero" },
    { code: "MX.12.040", name: "Leonardo Bravo" },
    { code: "MX.12.041", name: "Malinaltepec" },
    { code: "MX.12.042", name: "Mártir de Cuilapan" },
    { code: "MX.12.043", name: "Metlatónoc" },
    { code: "MX.12.044", name: "Mochitlán" },
    { code: "MX.12.045", name: "Olinalá" },
    { code: "MX.12.046", name: "Ometepec" },
    { code: "MX.12.047", name: "Pedro Ascencio Alquisiras" },
    { code: "MX.12.048", name: "Petatlán" },
    { code: "MX.12.049", name: "Pilcaya" },
    { code: "MX.12.050", name: "Pungarabato" },
    { code: "MX.12.051", name: "Quechultenango" },
    { code: "MX.12.052", name: "San Luis Acatlán" },
    { code: "MX.12.053", name: "San Marcos" },
    { code: "MX.12.054", name: "San Miguel Totolapan" },
    { code: "MX.12.055", name: "Taxco de Alarcón" },
    { code: "MX.12.056", name: "Tecoanapa" },
    { code: "MX.12.057", name: "Técpan de Galeana" },
    { code: "MX.12.058", name: "Teloloapan" },
    { code: "MX.12.059", name: "Tepecoacuilco de Trujano" },
    { code: "MX.12.060", name: "Tetipac" },
    { code: "MX.12.061", name: "Tixtla de Guerrero" },
    { code: "MX.12.062", name: "Tlacoachistlahuaca" },
    { code: "MX.12.063", name: "Tlacoapa" },
    { code: "MX.12.064", name: "Tlalchapa" },
    { code: "MX.12.065", name: "Tlalixtaquilla de Maldonado" },
    { code: "MX.12.066", name: "Tlapa de Comonfort" },
    { code: "MX.12.067", name: "Tlapehuala" },
    { code: "MX.12.068", name: "La Unión de Isidoro Montes de Oca" },
    { code: "MX.12.069", name: "Xalpatláhuac" },
    { code: "MX.12.070", name: "Xochihuehuetlán" },
    { code: "MX.12.071", name: "Xochistlahuaca" },
    { code: "MX.12.072", name: "Zapotitlán Tablas" },
    { code: "MX.12.073", name: "Zirándaro" },
    { code: "MX.12.074", name: "Zitlala" },
    { code: "MX.12.075", name: "Eduardo Neri" },
    { code: "MX.12.076", name: "Acatepec" },
    { code: "MX.12.077", name: "Marquelia" },
    { code: "MX.12.078", name: "Cochoapa el Grande" },
    { code: "MX.12.079", name: "José Joaquín de Herrera" },
    { code: "MX.12.080", name: "Juchitán" },
    { code: "MX.12.081", name: "Iliatenco" },
  ],
  "MX.13": [
    { code: "MX.13.001", name: "Acatlán" },
    { code: "MX.13.002", name: "Acaxochitlán" },
    { code: "MX.13.003", name: "Actopan" },
    { code: "MX.13.004", name: "Agua Blanca de Iturbide" },
    { code: "MX.13.005", name: "Ajacuba" },
    { code: "MX.13.006", name: "Alfajayucan" },
    { code: "MX.13.007", name: "Almoloya" },
    { code: "MX.13.008", name: "Apan" },
    { code: "MX.13.009", name: "El Arenal" },
    { code: "MX.13.010", name: "Atitalaquia" },
    { code: "MX.13.011", name: "Atlapexco" },
    { code: "MX.13.012", name: "Atotonilco el Grande" },
    { code: "MX.13.013", name: "Atotonilco de Tula" },
    { code: "MX.13.014", name: "Calnali" },
    { code: "MX.13.015", name: "Cardonal" },
    { code: "MX.13.016", name: "Cuautepec de Hinojosa" },
    { code: "MX.13.017", name: "Chapantongo" },
    { code: "MX.13.018", name: "Chapulhuacán" },
    { code: "MX.13.019", name: "Chilcuautla" },
    { code: "MX.13.020", name: "Eloxochitlán" },
    { code: "MX.13.021", name: "Emiliano Zapata" },
    { code: "MX.13.022", name: "Epazoyucan" },
    { code: "MX.13.023", name: "Francisco I. Madero" },
    { code: "MX.13.024", name: "Huasca de Ocampo" },
    { code: "MX.13.025", name: "Huautla" },
    { code: "MX.13.026", name: "Huazalingo" },
    { code: "MX.13.027", name: "Huehuetla" },
    { code: "MX.13.028", name: "Huejutla de Reyes" },
    { code: "MX.13.029", name: "Huichapan" },
    { code: "MX.13.030", name: "Ixmiquilpan" },
    { code: "MX.13.031", name: "Jacala de Ledezma" },
    { code: "MX.13.032", name: "Jaltocán" },
    { code: "MX.13.033", name: "Juárez Hidalgo" },
    { code: "MX.13.034", name: "Lolotla" },
    { code: "MX.13.035", name: "Metepec" },
    { code: "MX.13.036", name: "San Agustín Metzquititlán" },
    { code: "MX.13.037", name: "Metztitlán" },
    { code: "MX.13.038", name: "Mineral del Chico" },
    { code: "MX.13.039", name: "Mineral del Monte" },
    { code: "MX.13.040", name: "La Misión" },
    { code: "MX.13.041", name: "Mixquiahuala de Juárez" },
    { code: "MX.13.042", name: "Molango de Escamilla" },
    { code: "MX.13.043", name: "Nicolás Flores" },
    { code: "MX.13.044", name: "Nopala de Villagrán" },
    { code: "MX.13.045", name: "Omitlán de Juárez" },
    { code: "MX.13.046", name: "San Felipe Orizatlán" },
    { code: "MX.13.047", name: "Pacula" },
    { code: "MX.13.048", name: "Pachuca de Soto" },
    { code: "MX.13.049", name: "Pisaflores" },
    { code: "MX.13.050", name: "Progreso de Obregón" },
    { code: "MX.13.051", name: "Mineral de la Reforma" },
    { code: "MX.13.052", name: "San Agustín Tlaxiaca" },
    { code: "MX.13.053", name: "San Bartolo Tutotepec" },
    { code: "MX.13.054", name: "San Salvador" },
    { code: "MX.13.055", name: "Santiago de Anaya" },
    { code: "MX.13.056", name: "Santiago Tulantepec de Lugo Guerrero" },
    { code: "MX.13.057", name: "Singuilucan" },
    { code: "MX.13.058", name: "Tasquillo" },
    { code: "MX.13.059", name: "Tecozautla" },
    { code: "MX.13.060", name: "Tenango de Doria" },
    { code: "MX.13.061", name: "Tepeapulco" },
    { code: "MX.13.062", name: "Tepehuacán de Guerrero" },
    { code: "MX.13.063", name: "Tepeji del Río de Ocampo" },
    { code: "MX.13.064", name: "Tepetitlán" },
    { code: "MX.13.065", name: "Tetepango" },
    { code: "MX.13.066", name: "Villa de Tezontepec" },
    { code: "MX.13.067", name: "Tezontepec de Aldama" },
    { code: "MX.13.068", name: "Tianguistengo" },
    { code: "MX.13.069", name: "Tizayuca" },
    { code: "MX.13.070", name: "Tlahuelilpan" },
    { code: "MX.13.071", name: "Tlahuiltepa" },
    { code: "MX.13.072", name: "Tlanalapa" },
    { code: "MX.13.073", name: "Tlanchinol" },
    { code: "MX.13.074", name: "Tlaxcoapan" },
    { code: "MX.13.075", name: "Tolcayuca" },
    { code: "MX.13.076", name: "Tula de Allende" },
    { code: "MX.13.077", name: "Tulancingo de Bravo" },
    { code: "MX.13.078", name: "Xochiatipan" },
    { code: "MX.13.079", name: "Xochicoatlán" },
    { code: "MX.13.080", name: "Yahualica" },
    { code: "MX.13.081", name: "Zacualtipán de Ángeles" },
    { code: "MX.13.082", name: "Zapotlán de Juárez" },
    { code: "MX.13.083", name: "Zempoala" },
    { code: "MX.13.084", name: "Zimapán" },
  ],
  "MX.14": [
    { code: "MX.14.001", name: "Acatic" },
    { code: "MX.14.002", name: "Acatlán de Juárez" },
    { code: "MX.14.003", name: "Ahualulco de Mercado" },
    { code: "MX.14.004", name: "Amacueca" },
    { code: "MX.14.005", name: "Amatitán" },
    { code: "MX.14.006", name: "Ameca" },
    { code: "MX.14.007", name: "San Juanito de Escobedo" },
    { code: "MX.14.008", name: "Arandas" },
    { code: "MX.14.009", name: "El Arenal" },
    { code: "MX.14.010", name: "Atemajac de Brizuela" },
    { code: "MX.14.011", name: "Atengo" },
    { code: "MX.14.012", name: "Atenguillo" },
    { code: "MX.14.013", name: "Atotonilco el Alto" },
    { code: "MX.14.014", name: "Atoyac" },
    { code: "MX.14.015", name: "Autlán de Navarro" },
    { code: "MX.14.016", name: "Ayotlán" },
    { code: "MX.14.017", name: "Ayutla" },
    { code: "MX.14.018", name: "La Barca" },
    { code: "MX.14.019", name: "Bolaños" },
    { code: "MX.14.020", name: "Cabo Corrientes" },
    { code: "MX.14.021", name: "Casimiro Castillo" },
    { code: "MX.14.022", name: "Cihuatlán" },
    { code: "MX.14.023", name: "Zapotlán el Grande" },
    { code: "MX.14.024", name: "Cocula" },
    { code: "MX.14.025", name: "Colotlán" },
    { code: "MX.14.026", name: "Concepción de Buenos Aires" },
    { code: "MX.14.027", name: "Cuautitlán de García Barragán" },
    { code: "MX.14.028", name: "Cuautla" },
    { code: "MX.14.029", name: "Cuquío" },
    { code: "MX.14.030", name: "Chapala" },
    { code: "MX.14.031", name: "Chimaltitán" },
    { code: "MX.14.032", name: "Chiquilistlán" },
    { code: "MX.14.033", name: "Degollado" },
    { code: "MX.14.034", name: "Ejutla" },
    { code: "MX.14.035", name: "Encarnación de Díaz" },
    { code: "MX.14.036", name: "Etzatlán" },
    { code: "MX.14.037", name: "El Grullo" },
    { code: "MX.14.038", name: "Guachinango" },
    { code: "MX.14.039", name: "Guadalajara" },
    { code: "MX.14.040", name: "Hostotipaquillo" },
    { code: "MX.14.041", name: "Huejúcar" },
    { code: "MX.14.042", name: "Huejuquilla el Alto" },
    { code: "MX.14.043", name: "La Huerta" },
    { code: "MX.14.044", name: "Ixtlahuacán de los Membrillos" },
    { code: "MX.14.045", name: "Ixtlahuacán del Río" },
    { code: "MX.14.046", name: "Jalostotitlán" },
    { code: "MX.14.047", name: "Jamay" },
    { code: "MX.14.048", name: "Jesús María" },
    { code: "MX.14.049", name: "Jilotlán de los Dolores" },
    { code: "MX.14.050", name: "Jocotepec" },
    { code: "MX.14.051", name: "Juanacatlán" },
    { code: "MX.14.052", name: "Juchitlán" },
    { code: "MX.14.053", name: "Lagos de Moreno" },
    { code: "MX.14.054", name: "El Limón" },
    { code: "MX.14.055", name: "Magdalena" },
    { code: "MX.14.056", name: "Santa María del Oro" },
    { code: "MX.14.057", name: "La Manzanilla de la Paz" },
    { code: "MX.14.058", name: "Mascota" },
    { code: "MX.14.059", name: "Mazamitla" },
    { code: "MX.14.060", name: "Mexticacán" },
    { code: "MX.14.061", name: "Mezquitic" },
    { code: "MX.14.062", name: "Mixtlán" },
    { code: "MX.14.063", name: "Ocotlán" },
    { code: "MX.14.064", name: "Ojuelos de Jalisco" },
    { code: "MX.14.065", name: "Pihuamo" },
    { code: "MX.14.066", name: "Poncitlán" },
    { code: "MX.14.067", name: "Puerto Vallarta" },
    { code: "MX.14.068", name: "Villa Purificación" },
    { code: "MX.14.069", name: "Quitupan" },
    { code: "MX.14.070", name: "El Salto" },
    { code: "MX.14.071", name: "San Cristóbal de la Barranca" },
    { code: "MX.14.072", name: "San Diego de Alejandría" },
    { code: "MX.14.073", name: "San Juan de los Lagos" },
    { code: "MX.14.074", name: "San Julián" },
    { code: "MX.14.075", name: "San Marcos" },
    { code: "MX.14.076", name: "San Martín de Bolaños" },
    { code: "MX.14.077", name: "San Martín Hidalgo" },
    { code: "MX.14.078", name: "San Miguel el Alto" },
    { code: "MX.14.079", name: "Gómez Farías" },
    { code: "MX.14.080", name: "San Sebastián del Oeste" },
    { code: "MX.14.081", name: "Santa María de los Ángeles" },
    { code: "MX.14.082", name: "Sayula" },
    { code: "MX.14.083", name: "Tala" },
    { code: "MX.14.084", name: "Talpa de Allende" },
    { code: "MX.14.085", name: "Tamazula de Gordiano" },
    { code: "MX.14.086", name: "Tapalpa" },
    { code: "MX.14.087", name: "Tecalitlán" },
    { code: "MX.14.088", name: "Tecolotlán" },
    { code: "MX.14.089", name: "Techaluta de Montenegro" },
    { code: "MX.14.090", name: "Tenamaxtlán" },
    { code: "MX.14.091", name: "Teocaltiche" },
    { code: "MX.14.092", name: "Teocuitatlán de Corona" },
    { code: "MX.14.093", name: "Tepatitlán de Morelos" },
    { code: "MX.14.094", name: "Tequila" },
    { code: "MX.14.095", name: "Teuchitlán" },
    { code: "MX.14.096", name: "Tizapán el Alto" },
    { code: "MX.14.097", name: "Tlajomulco de Zúñiga" },
    { code: "MX.14.098", name: "San Pedro Tlaquepaque" },
    { code: "MX.14.099", name: "Tolimán" },
    { code: "MX.14.100", name: "Tomatlán" },
    { code: "MX.14.101", name: "Tonalá" },
    { code: "MX.14.102", name: "Tonaya" },
    { code: "MX.14.103", name: "Tonila" },
    { code: "MX.14.104", name: "Totatiche" },
    { code: "MX.14.105", name: "Tototlán" },
    { code: "MX.14.106", name: "Tuxcacuesco" },
    { code: "MX.14.107", name: "Tuxcueca" },
    { code: "MX.14.108", name: "Tuxpan" },
    { code: "MX.14.109", name: "Unión de San Antonio" },
    { code: "MX.14.110", name: "Unión de Tula" },
    { code: "MX.14.111", name: "Valle de Guadalupe" },
    { code: "MX.14.112", name: "Valle de Juárez" },
    { code: "MX.14.113", name: "San Gabriel" },
    { code: "MX.14.114", name: "Villa Corona" },
    { code: "MX.14.115", name: "Villa Guerrero" },
    { code: "MX.14.116", name: "Villa Hidalgo" },
    { code: "MX.14.117", name: "Cañadas de Obregón" },
    { code: "MX.14.118", name: "Yahualica de González Gallo" },
    { code: "MX.14.119", name: "Zacoalco de Torres" },
    { code: "MX.14.120", name: "Zapopan" },
    { code: "MX.14.121", name: "Zapotiltic" },
    { code: "MX.14.122", name: "Zapotitlán de Vadillo" },
    { code: "MX.14.123", name: "Zapotlán del Rey" },
    { code: "MX.14.124", name: "Zapotlanejo" },
    { code: "MX.14.125", name: "San Ignacio Cerro Gordo" },
  ],
  "MX.15": [
    { code: "MX.15.001", name: "Acambay de Ruíz Castañeda" },
    { code: "MX.15.002", name: "Acolman de Nezahualcóyotl" },
    { code: "MX.15.003", name: "Aculco" },
    { code: "MX.15.004", name: "Almoloya de Alquisiras" },
    { code: "MX.15.005", name: "Almoloya de Juárez" },
    { code: "MX.15.006", name: "Almoloya del Río" },
    { code: "MX.15.007", name: "Amanalco" },
    { code: "MX.15.008", name: "Amatepec" },
    { code: "MX.15.009", name: "Amecameca" },
    { code: "MX.15.010", name: "Apaxco" },
    { code: "MX.15.011", name: "Atenco" },
    { code: "MX.15.012", name: "Atizapán" },
    { code: "MX.15.013", name: "Atizapán de Zaragoza" },
    { code: "MX.15.014", name: "Atlacomulco" },
    { code: "MX.15.015", name: "Atlautla" },
    { code: "MX.15.016", name: "Axapusco" },
    { code: "MX.15.017", name: "Ayapango" },
    { code: "MX.15.018", name: "Calimaya" },
    { code: "MX.15.019", name: "Capulhuac" },
    { code: "MX.15.020", name: "Coacalco" },
    { code: "MX.15.021", name: "Coatepec Harinas" },
    { code: "MX.15.022", name: "Cocotitlán" },
    { code: "MX.15.023", name: "Coyotepec" },
    { code: "MX.15.024", name: "Cuautitlán" },
    { code: "MX.15.025", name: "Chalco" },
    { code: "MX.15.026", name: "Chapa de Mota" },
    { code: "MX.15.027", name: "Chapultepec" },
    { code: "MX.15.028", name: "Chiautla" },
    { code: "MX.15.029", name: "Chicoloapan" },
    { code: "MX.15.030", name: "Chiconcuac" },
    { code: "MX.15.031", name: "Chimalhuacán" },
    { code: "MX.15.032", name: "Donato Guerra" },
    { code: "MX.15.033", name: "Ecatepec de Morelos" },
    { code: "MX.15.034", name: "Ecatzingo" },
    { code: "MX.15.035", name: "Huehuetoca" },
    { code: "MX.15.036", name: "Hueypoxtla" },
    { code: "MX.15.037", name: "Huixquilucan" },
    { code: "MX.15.038", name: "Isidro Fabela" },
    { code: "MX.15.039", name: "Ixtapaluca" },
    { code: "MX.15.040", name: "Ixtapan de la Sal" },
    { code: "MX.15.041", name: "Ixtapan del Oro" },
    { code: "MX.15.042", name: "Ixtlahuaca" },
    { code: "MX.15.043", name: "Xalatlaco" },
    { code: "MX.15.044", name: "Jaltenco" },
    { code: "MX.15.045", name: "Jilotepec" },
    { code: "MX.15.046", name: "Jilotzingo" },
    { code: "MX.15.047", name: "Jiquipilco" },
    { code: "MX.15.048", name: "Jocotitlán" },
    { code: "MX.15.049", name: "Joquicingo" },
    { code: "MX.15.050", name: "Juchitepec" },
    { code: "MX.15.051", name: "Lerma" },
    { code: "MX.15.052", name: "Malinalco" },
    { code: "MX.15.053", name: "Melchor Ocampo" },
    { code: "MX.15.054", name: "Metepec" },
    { code: "MX.15.055", name: "Mexicaltzingo" },
    { code: "MX.15.056", name: "Morelos" },
    { code: "MX.15.057", name: "Naucalpan de Juárez" },
    { code: "MX.15.058", name: "Ciudad Nezahualcóyotl" },
    { code: "MX.15.059", name: "Nextlalpan" },
    { code: "MX.15.060", name: "Nicolás Romero" },
    { code: "MX.15.061", name: "Nopaltepec" },
    { code: "MX.15.062", name: "Ocoyoacac" },
    { code: "MX.15.063", name: "Ocuilan" },
    { code: "MX.15.064", name: "El Oro" },
    { code: "MX.15.065", name: "Otumba" },
    { code: "MX.15.066", name: "Otzoloapan" },
    { code: "MX.15.067", name: "Otzolotepec" },
    { code: "MX.15.068", name: "Ozumba" },
    { code: "MX.15.069", name: "Papalotla" },
    { code: "MX.15.070", name: "La Paz" },
    { code: "MX.15.071", name: "Polotitlán" },
    { code: "MX.15.072", name: "Rayón" },
    { code: "MX.15.073", name: "San Antonio la Isla" },
    { code: "MX.15.074", name: "San Felipe del Progreso" },
    { code: "MX.15.075", name: "San Martín de las Pirámides" },
    { code: "MX.15.076", name: "San Mateo Atenco" },
    { code: "MX.15.077", name: "San Simón de Guerrero" },
    { code: "MX.15.078", name: "Santo Tomás" },
    { code: "MX.15.079", name: "Soyaniquilpan de Juárez" },
    { code: "MX.15.080", name: "Sultepec" },
    { code: "MX.15.081", name: "Tecámac" },
    { code: "MX.15.082", name: "Tejupilco" },
    { code: "MX.15.083", name: "Temamatla" },
    { code: "MX.15.084", name: "Temascalapa" },
    { code: "MX.15.085", name: "Temascalcingo" },
    { code: "MX.15.086", name: "Temascaltepec" },
    { code: "MX.15.087", name: "Temoaya" },
    { code: "MX.15.088", name: "Tenancingo" },
    { code: "MX.15.089", name: "Tenango del Aire" },
    { code: "MX.15.090", name: "Tenango del Valle" },
    { code: "MX.15.091", name: "Teoloyucan" },
    { code: "MX.15.092", name: "Teotihuacán" },
    { code: "MX.15.093", name: "Tepetlaoxtoc" },
    { code: "MX.15.094", name: "Tepetlixpa" },
    { code: "MX.15.095", name: "Tepotzotlán" },
    { code: "MX.15.096", name: "Tequixquiac" },
    { code: "MX.15.097", name: "Texcaltitlán" },
    { code: "MX.15.098", name: "Texcalyacac" },
    { code: "MX.15.099", name: "Texcoco" },
    { code: "MX.15.100", name: "Tezoyuca" },
    { code: "MX.15.101", name: "Tianguistenco" },
    { code: "MX.15.102", name: "Timilpan" },
    { code: "MX.15.103", name: "Tlalmanalco" },
    { code: "MX.15.104", name: "Tlalnepantla de Baz" },
    { code: "MX.15.105", name: "Tlatlaya" },
    { code: "MX.15.106", name: "Toluca" },
    { code: "MX.15.107", name: "Tonatico" },
    { code: "MX.15.108", name: "Tultepec" },
    { code: "MX.15.109", name: "Tultitlán" },
    { code: "MX.15.110", name: "Valle de Bravo" },
    { code: "MX.15.111", name: "Villa de Allende" },
    { code: "MX.15.112", name: "Villa del Carbón" },
    { code: "MX.15.113", name: "Villa Guerrero" },
    { code: "MX.15.114", name: "Villa Victoria" },
    { code: "MX.15.115", name: "Xonacatlan" },
    { code: "MX.15.116", name: "Zacazonapan" },
    { code: "MX.15.117", name: "Zacualpan" },
    { code: "MX.15.118", name: "Zinacantepec" },
    { code: "MX.15.119", name: "Zumpahuacán" },
    { code: "MX.15.120", name: "Zumpango" },
    { code: "MX.15.121", name: "Cuautitlán Izcalli" },
    { code: "MX.15.122", name: "Valle de Chalco Solidaridad" },
    { code: "MX.15.123", name: "Luvianos" },
    { code: "MX.15.124", name: "San José del Rincón" },
    { code: "MX.15.125", name: "Tonanitla" },
  ],
  "MX.16": [
    { code: "MX.16.001", name: "Acuitzio" },
    { code: "MX.16.002", name: "Aguililla" },
    { code: "MX.16.003", name: "Álvaro Obregón" },
    { code: "MX.16.004", name: "Angamacutiro" },
    { code: "MX.16.005", name: "Angangueo" },
    { code: "MX.16.006", name: "Apatzingán" },
    { code: "MX.16.007", name: "Aporo" },
    { code: "MX.16.008", name: "Aquila" },
    { code: "MX.16.009", name: "Ario" },
    { code: "MX.16.010", name: "Arteaga" },
    { code: "MX.16.011", name: "Briseñas" },
    { code: "MX.16.012", name: "Buenavista" },
    { code: "MX.16.013", name: "Carácuaro" },
    { code: "MX.16.014", name: "Coahuayana" },
    { code: "MX.16.015", name: "Coalcomán de Vázquez Pallares" },
    { code: "MX.16.016", name: "Coeneo" },
    { code: "MX.16.017", name: "Contepec" },
    { code: "MX.16.018", name: "Copándaro" },
    { code: "MX.16.019", name: "Cotija" },
    { code: "MX.16.020", name: "Cuitzeo" },
    { code: "MX.16.021", name: "Charapan" },
    { code: "MX.16.022", name: "Charo" },
    { code: "MX.16.023", name: "Chavinda" },
    { code: "MX.16.024", name: "Cherán" },
    { code: "MX.16.025", name: "Chilchota" },
    { code: "MX.16.026", name: "Chinicuila" },
    { code: "MX.16.027", name: "Chucándiro" },
    { code: "MX.16.028", name: "Churintzio" },
    { code: "MX.16.029", name: "Churumuco" },
    { code: "MX.16.030", name: "Ecuandureo" },
    { code: "MX.16.031", name: "Epitacio Huerta" },
    { code: "MX.16.032", name: "Erongarícuaro" },
    { code: "MX.16.033", name: "Gabriel Zamora" },
    { code: "MX.16.034", name: "Hidalgo" },
    { code: "MX.16.035", name: "La Huacana" },
    { code: "MX.16.036", name: "Huandacareo" },
    { code: "MX.16.037", name: "Huaniqueo" },
    { code: "MX.16.038", name: "Huetamo" },
    { code: "MX.16.039", name: "Huiramba" },
    { code: "MX.16.040", name: "Indaparapeo" },
    { code: "MX.16.041", name: "Irimbo" },
    { code: "MX.16.042", name: "Ixtlán" },
    { code: "MX.16.043", name: "Jacona" },
    { code: "MX.16.044", name: "Jiménez" },
    { code: "MX.16.045", name: "Jiquilpan" },
    { code: "MX.16.046", name: "Juárez" },
    { code: "MX.16.047", name: "Jungapeo" },
    { code: "MX.16.048", name: "Lagunillas" },
    { code: "MX.16.049", name: "Madero" },
    { code: "MX.16.050", name: "Maravatío" },
    { code: "MX.16.051", name: "Marcos Castellanos" },
    { code: "MX.16.052", name: "Lázaro Cárdenas" },
    { code: "MX.16.053", name: "Morelia" },
    { code: "MX.16.054", name: "Morelos" },
    { code: "MX.16.055", name: "Múgica" },
    { code: "MX.16.056", name: "Nahuatzen" },
    { code: "MX.16.057", name: "Nocupétaro" },
    { code: "MX.16.058", name: "Nuevo Parangaricutiro" },
    { code: "MX.16.059", name: "Nuevo Urecho" },
    { code: "MX.16.060", name: "Numarán" },
    { code: "MX.16.061", name: "Ocampo" },
    { code: "MX.16.062", name: "Pajacuarán" },
    { code: "MX.16.063", name: "Panindícuaro" },
    { code: "MX.16.064", name: "Parácuaro" },
    { code: "MX.16.065", name: "Paracho" },
    { code: "MX.16.066", name: "Pátzcuaro" },
    { code: "MX.16.067", name: "Penjamillo" },
    { code: "MX.16.068", name: "Peribán" },
    { code: "MX.16.069", name: "La Piedad" },
    { code: "MX.16.070", name: "Purépero" },
    { code: "MX.16.071", name: "Puruándiro" },
    { code: "MX.16.072", name: "Queréndaro" },
    { code: "MX.16.073", name: "Quiroga" },
    { code: "MX.16.074", name: "Cojumatlán de Régules" },
    { code: "MX.16.075", name: "Los Reyes" },
    { code: "MX.16.076", name: "Sahuayo" },
    { code: "MX.16.077", name: "San Lucas" },
    { code: "MX.16.078", name: "Santa Ana Maya" },
    { code: "MX.16.079", name: "Salvador Escalante" },
    { code: "MX.16.080", name: "Senguio" },
    { code: "MX.16.081", name: "Susupuato" },
    { code: "MX.16.082", name: "Tacámbaro" },
    { code: "MX.16.083", name: "Tancítaro" },
    { code: "MX.16.084", name: "Tangamandapio" },
    { code: "MX.16.085", name: "Tangancícuaro" },
    { code: "MX.16.086", name: "Tanhuato" },
    { code: "MX.16.087", name: "Taretan" },
    { code: "MX.16.088", name: "Tarímbaro" },
    { code: "MX.16.089", name: "Tepalcatepec" },
    { code: "MX.16.090", name: "Tingambato" },
    { code: "MX.16.091", name: "Tingüindín" },
    { code: "MX.16.092", name: "Tiquicheo de Nicolás Romero" },
    { code: "MX.16.093", name: "Tlalpujahua" },
    { code: "MX.16.094", name: "Tlazazalca" },
    { code: "MX.16.095", name: "Tocumbo" },
    { code: "MX.16.096", name: "Tumbiscatío" },
    { code: "MX.16.097", name: "Turicato" },
    { code: "MX.16.098", name: "Tuxpan" },
    { code: "MX.16.099", name: "Tuzantla" },
    { code: "MX.16.100", name: "Tzintzuntzan" },
    { code: "MX.16.101", name: "Tzitzio" },
    { code: "MX.16.102", name: "Uruapan" },
    { code: "MX.16.103", name: "Venustiano Carranza" },
    { code: "MX.16.104", name: "Villamar" },
    { code: "MX.16.105", name: "Vista Hermosa" },
    { code: "MX.16.106", name: "Yurécuaro" },
    { code: "MX.16.107", name: "Zacapu" },
    { code: "MX.16.108", name: "Zamora" },
    { code: "MX.16.109", name: "Zináparo" },
    { code: "MX.16.110", name: "Zinapécuaro" },
    { code: "MX.16.111", name: "Ziracuaretiro" },
    { code: "MX.16.112", name: "Zitácuaro" },
    { code: "MX.16.113", name: "José Sixto Verduzco" },
  ],
  "MX.17": [
    { code: "MX.17.001", name: "Amacuzac" },
    { code: "MX.17.002", name: "Atlatlahucan" },
    { code: "MX.17.003", name: "Axochiapan" },
    { code: "MX.17.004", name: "Ayala" },
    { code: "MX.17.005", name: "Coatlán del Río" },
    { code: "MX.17.006", name: "Cuautla" },
    { code: "MX.17.007", name: "Cuernavaca" },
    { code: "MX.17.008", name: "Emiliano Zapata" },
    { code: "MX.17.009", name: "Huitzilac" },
    { code: "MX.17.010", name: "Jantetelco" },
    { code: "MX.17.011", name: "Jiutepec" },
    { code: "MX.17.012", name: "Jojutla" },
    { code: "MX.17.013", name: "Jonacatepec" },
    { code: "MX.17.014", name: "Mazatepec" },
    { code: "MX.17.015", name: "Miacatlán" },
    { code: "MX.17.016", name: "Ocuituco" },
    { code: "MX.17.017", name: "Puente de Ixtla" },
    { code: "MX.17.018", name: "Temixco" },
    { code: "MX.17.019", name: "Tepalcingo" },
    { code: "MX.17.020", name: "Tepoztlán" },
    { code: "MX.17.021", name: "Tetecala" },
    { code: "MX.17.022", name: "Tetela del Volcán" },
    { code: "MX.17.023", name: "Tlalnepantla" },
    { code: "MX.17.024", name: "Tlaltizapán de Zapata" },
    { code: "MX.17.025", name: "Tlaquiltenango" },
    { code: "MX.17.026", name: "Tlayacapan" },
    { code: "MX.17.027", name: "Totolapan" },
    { code: "MX.17.028", name: "Xochitepec" },
    { code: "MX.17.029", name: "Yautepec" },
    { code: "MX.17.030", name: "Yecapixtla" },
    { code: "MX.17.031", name: "Zacatepec" },
    { code: "MX.17.032", name: "Zacualpan" },
    { code: "MX.17.033", name: "Temoac" },
  ],
  "MX.18": [
    { code: "MX.18.001", name: "Acaponeta" },
    { code: "MX.18.002", name: "Ahuacatlán" },
    { code: "MX.18.003", name: "Amatlán de Cañas" },
    { code: "MX.18.004", name: "Compostela" },
    { code: "MX.18.005", name: "Huajicori" },
    { code: "MX.18.006", name: "Ixtlán del Río" },
    { code: "MX.18.007", name: "Jala" },
    { code: "MX.18.008", name: "Xalisco" },
    { code: "MX.18.009", name: "Del Nayar" },
    { code: "MX.18.010", name: "Rosamorada" },
    { code: "MX.18.011", name: "Ruíz" },
    { code: "MX.18.012", name: "San Blas" },
    { code: "MX.18.013", name: "San Pedro Lagunillas" },
    { code: "MX.18.014", name: "Santa María del Oro" },
    { code: "MX.18.015", name: "Santiago Ixcuintla" },
    { code: "MX.18.016", name: "Tecuala" },
    { code: "MX.18.017", name: "Tepic" },
    { code: "MX.18.018", name: "Tuxpan" },
    { code: "MX.18.019", name: "La Yesca" },
    { code: "MX.18.020", name: "Bahía de Banderas" },
  ],
  "MX.19": [
    { code: "MX.19.001", name: "Abasolo" },
    { code: "MX.19.002", name: "Agualeguas" },
    { code: "MX.19.003", name: "Los Aldamas" },
    { code: "MX.19.004", name: "Allende" },
    { code: "MX.19.005", name: "Anáhuac" },
    { code: "MX.19.006", name: "Apodaca" },
    { code: "MX.19.007", name: "Aramberri" },
    { code: "MX.19.008", name: "Bustamante" },
    { code: "MX.19.009", name: "Cadereyta Jiménez" },
    { code: "MX.19.010", name: "El Carmen" },
    { code: "MX.19.011", name: "Cerralvo" },
    { code: "MX.19.012", name: "Ciénega de Flores" },
    { code: "MX.19.013", name: "China" },
    { code: "MX.19.014", name: "Doctor Arroyo" },
    { code: "MX.19.015", name: "Doctor Coss" },
    { code: "MX.19.016", name: "Doctor González" },
    { code: "MX.19.017", name: "Galeana" },
    { code: "MX.19.018", name: "García" },
    { code: "MX.19.019", name: "San Pedro Garza García" },
    { code: "MX.19.020", name: "General Bravo" },
    { code: "MX.19.021", name: "General Escobedo" },
    { code: "MX.19.022", name: "General Terán" },
    { code: "MX.19.023", name: "General Treviño" },
    { code: "MX.19.024", name: "General Zaragoza" },
    { code: "MX.19.025", name: "General Zuazua" },
    { code: "MX.19.026", name: "Guadalupe" },
    { code: "MX.19.027", name: "Los Herreras" },
    { code: "MX.19.028", name: "Higueras" },
    { code: "MX.19.029", name: "Hualahuises" },
    { code: "MX.19.030", name: "Iturbide" },
    { code: "MX.19.031", name: "Juárez" },
    { code: "MX.19.032", name: "Lampazos de Naranjo" },
    { code: "MX.19.033", name: "Linares" },
    { code: "MX.19.034", name: "Marín" },
    { code: "MX.19.035", name: "Melchor Ocampo" },
    { code: "MX.19.036", name: "Mier y Noriega" },
    { code: "MX.19.037", name: "Mina" },
    { code: "MX.19.038", name: "Montemorelos" },
    { code: "MX.19.039", name: "Monterrey" },
    { code: "MX.19.040", name: "Parás" },
    { code: "MX.19.041", name: "Pesquería" },
    { code: "MX.19.042", name: "Los Ramones" },
    { code: "MX.19.043", name: "Rayones" },
    { code: "MX.19.044", name: "Sabinas Hidalgo" },
    { code: "MX.19.045", name: "Salinas Victoria" },
    { code: "MX.19.046", name: "San Nicolás de los Garza" },
    { code: "MX.19.047", name: "Hidalgo" },
    { code: "MX.19.048", name: "Santa Catarina" },
    { code: "MX.19.049", name: "Santiago" },
    { code: "MX.19.050", name: "Vallecillo" },
    { code: "MX.19.051", name: "Villaldama" },
  ],
  "MX.20": [
    { code: "MX.20.001", name: "Abejones" },
    { code: "MX.20.002", name: "Acatlán de Pérez Figueroa" },
    { code: "MX.20.003", name: "Asunción Cacalotepec" },
    { code: "MX.20.004", name: "Asunción Cuyotepeji" },
    { code: "MX.20.005", name: "Asunción Ixtaltepec" },
    { code: "MX.20.006", name: "Asunción Nochixtlán" },
    { code: "MX.20.007", name: "Asunción Ocotlán" },
    { code: "MX.20.008", name: "Asunción Tlacolulita" },
    { code: "MX.20.009", name: "Ayotzintepec" },
    { code: "MX.20.010", name: "El Barrio de la Soledad" },
    { code: "MX.20.011", name: "Calihualá" },
    { code: "MX.20.012", name: "Candelaria Loxicha" },
    { code: "MX.20.013", name: "Ciénega de Zimatlán" },
    { code: "MX.20.014", name: "Ciudad Ixtepec" },
    { code: "MX.20.015", name: "Coatecas Altas" },
    { code: "MX.20.016", name: "Coicoyán de las Flores" },
    { code: "MX.20.017", name: "La Compañía" },
    { code: "MX.20.018", name: "Concepción Buenavista" },
    { code: "MX.20.019", name: "Concepción Pápalo" },
    { code: "MX.20.020", name: "Constancia del Rosario" },
    { code: "MX.20.021", name: "Cosolapa" },
    { code: "MX.20.022", name: "Cosoltepec" },
    { code: "MX.20.023", name: "Cuilápam de Guerrero" },
    { code: "MX.20.024", name: "Cuyamecalco Villa de Zaragoza" },
    { code: "MX.20.025", name: "Chahuites" },
    { code: "MX.20.026", name: "Chalcatongo de Hidalgo" },
    { code: "MX.20.027", name: "Chiquihuitlán de Benito Juárez" },
    { code: "MX.20.028", name: "Heroica Ciudad de Ejutla de Crespo" },
    { code: "MX.20.029", name: "Eloxochitlán de Flores Magón" },
    { code: "MX.20.030", name: "El Espinal" },
    { code: "MX.20.031", name: "Tamazulápam del Espíritu Santo" },
    { code: "MX.20.032", name: "Fresnillo de Trujano" },
    { code: "MX.20.033", name: "Guadalupe Etla" },
    { code: "MX.20.034", name: "Guadalupe de Ramírez" },
    { code: "MX.20.035", name: "Guelatao de Juárez" },
    { code: "MX.20.036", name: "Guevea de Humboldt" },
    { code: "MX.20.037", name: "Mesones Hidalgo" },
    { code: "MX.20.038", name: "Villa Hidalgo" },
    { code: "MX.20.039", name: "Heroica Ciudad de Huajuapan de León" },
    { code: "MX.20.040", name: "Huautepec" },
    { code: "MX.20.041", name: "Huautla de Jiménez" },
    { code: "MX.20.042", name: "Ixtlán de Juárez" },
    { code: "MX.20.043", name: "Heroica Ciudad de Juchitán de Zaragoza" },
    { code: "MX.20.044", name: "Loma Bonita" },
    { code: "MX.20.045", name: "Magdalena Apasco" },
    { code: "MX.20.046", name: "Magdalena Jaltepec" },
    { code: "MX.20.047", name: "Santa Magdalena Jicotlán" },
    { code: "MX.20.048", name: "Magdalena Mixtepec" },
    { code: "MX.20.049", name: "Magdalena Ocotlán" },
    { code: "MX.20.050", name: "Magdalena Peñasco" },
    { code: "MX.20.051", name: "Magdalena Teitipac" },
    { code: "MX.20.052", name: "Magdalena Tequisistlán" },
    { code: "MX.20.053", name: "Magdalena Tlacotepec" },
    { code: "MX.20.054", name: "Magdalena Zahuatlán" },
    { code: "MX.20.055", name: "Mariscala de Juárez" },
    { code: "MX.20.056", name: "Mártires de Tacubaya" },
    { code: "MX.20.057", name: "Matías Romero Avendaño" },
    { code: "MX.20.058", name: "Mazatlán Villa de Flores" },
    { code: "MX.20.059", name: "Miahuatlán de Porfirio Díaz" },
    { code: "MX.20.060", name: "Mixistlán de la Reforma" },
    { code: "MX.20.061", name: "Monjas" },
    { code: "MX.20.062", name: "Natividad" },
    { code: "MX.20.063", name: "Nazareno Etla" },
    { code: "MX.20.064", name: "Nejapa de Madero" },
    { code: "MX.20.065", name: "Ixpantepec Nieves" },
    { code: "MX.20.066", name: "Santiago Niltepec" },
    { code: "MX.20.067", name: "Oaxaca de Juárez" },
    { code: "MX.20.068", name: "Ocotlán de Morelos" },
    { code: "MX.20.069", name: "La Pe" },
    { code: "MX.20.070", name: "Pinotepa de Don Luis" },
    { code: "MX.20.071", name: "Pluma Hidalgo" },
    { code: "MX.20.072", name: "San José del Progreso" },
    { code: "MX.20.073", name: "Putla Villa de Guerrero" },
    { code: "MX.20.074", name: "Santa Catarina Quioquitani" },
    { code: "MX.20.075", name: "Reforma de Pineda" },
    { code: "MX.20.076", name: "La Reforma" },
    { code: "MX.20.077", name: "Reyes Etla" },
    { code: "MX.20.078", name: "Rojas de Cuauhtémoc" },
    { code: "MX.20.079", name: "Salina Cruz" },
    { code: "MX.20.080", name: "San Agustín Amatengo" },
    { code: "MX.20.081", name: "San Agustín Atenango" },
    { code: "MX.20.082", name: "San Agustín Chayuco" },
    { code: "MX.20.083", name: "San Agustín de las Juntas" },
    { code: "MX.20.084", name: "San Agustín Etla" },
    { code: "MX.20.085", name: "San Agustín Loxicha" },
    { code: "MX.20.086", name: "San Agustín Tlacotepec" },
    { code: "MX.20.087", name: "San Agustín Yatareni" },
    { code: "MX.20.088", name: "San Andrés Cabecera Nueva" },
    { code: "MX.20.089", name: "San Andrés Dinicuiti" },
    { code: "MX.20.090", name: "San Andrés Huaxpaltepec" },
    { code: "MX.20.091", name: "San Andrés Huayápam" },
    { code: "MX.20.092", name: "San Andrés Ixtlahuaca" },
    { code: "MX.20.093", name: "San Andrés Lagunas" },
    { code: "MX.20.094", name: "San Andrés Nuxiño" },
    { code: "MX.20.095", name: "San Andrés Paxtlán" },
    { code: "MX.20.096", name: "San Andrés Sinaxtla" },
    { code: "MX.20.097", name: "San Andrés Solaga" },
    { code: "MX.20.098", name: "San Andrés Teotilálpam" },
    { code: "MX.20.099", name: "San Andrés Tepetlapa" },
    { code: "MX.20.100", name: "San Andrés Yaá" },
    { code: "MX.20.101", name: "San Andrés Zabache" },
    { code: "MX.20.102", name: "San Andrés Zautla" },
    { code: "MX.20.103", name: "San Antonino Castillo Velasco" },
    { code: "MX.20.104", name: "San Antonino el Alto" },
    { code: "MX.20.105", name: "San Antonino Monte Verde" },
    { code: "MX.20.106", name: "San Antonio Acutla" },
    { code: "MX.20.107", name: "San Antonio de la Cal" },
    { code: "MX.20.108", name: "San Antonio Huitepec" },
    { code: "MX.20.109", name: "San Antonio Nanahuatípam" },
    { code: "MX.20.110", name: "San Antonio Sinicahua" },
    { code: "MX.20.111", name: "San Antonio Tepetlapa" },
    { code: "MX.20.112", name: "San Baltazar Chichicápam" },
    { code: "MX.20.113", name: "San Baltazar Loxicha" },
    { code: "MX.20.114", name: "San Baltazar Yatzachi el Bajo" },
    { code: "MX.20.115", name: "San Bartolo Coyotepec" },
    { code: "MX.20.116", name: "San Bartolomé Ayautla" },
    { code: "MX.20.117", name: "San Bartolomé Loxicha" },
    { code: "MX.20.118", name: "San Bartolomé Quialana" },
    { code: "MX.20.119", name: "San Bartolomé Yucuañe" },
    { code: "MX.20.120", name: "San Bartolomé Zoogocho" },
    { code: "MX.20.121", name: "San Bartolo Soyaltepec" },
    { code: "MX.20.122", name: "San Bartolo Yautepec" },
    { code: "MX.20.123", name: "San Bernardo Mixtepec" },
    { code: "MX.20.124", name: "San Blas Atempa" },
    { code: "MX.20.125", name: "San Carlos Yautepec" },
    { code: "MX.20.126", name: "San Cristóbal Amatlán" },
    { code: "MX.20.127", name: "San Cristóbal Amoltepec" },
    { code: "MX.20.128", name: "San Cristóbal Lachirioag" },
    { code: "MX.20.129", name: "San Cristóbal Suchixtlahuaca" },
    { code: "MX.20.130", name: "San Dionisio del Mar" },
    { code: "MX.20.131", name: "San Dionisio Ocotepec" },
    { code: "MX.20.132", name: "San Dionisio Ocotlán" },
    { code: "MX.20.133", name: "San Esteban Atatlahuca" },
    { code: "MX.20.134", name: "San Felipe Jalapa de Díaz" },
    { code: "MX.20.135", name: "San Felipe Tejalápam" },
    { code: "MX.20.136", name: "San Felipe Usila" },
    { code: "MX.20.137", name: "San Francisco Cahuacuá" },
    { code: "MX.20.138", name: "San Francisco Cajonos" },
    { code: "MX.20.139", name: "San Francisco Chapulapa" },
    { code: "MX.20.140", name: "San Francisco Chindúa" },
    { code: "MX.20.141", name: "San Francisco del Mar" },
    { code: "MX.20.142", name: "San Francisco Huehuetlán" },
    { code: "MX.20.143", name: "San Francisco Ixhuatán" },
    { code: "MX.20.144", name: "San Francisco Jaltepetongo" },
    { code: "MX.20.145", name: "San Francisco Lachigoló" },
    { code: "MX.20.146", name: "San Francisco Logueche" },
    { code: "MX.20.147", name: "San Francisco Nuxaño" },
    { code: "MX.20.148", name: "San Francisco Ozolotepec" },
    { code: "MX.20.149", name: "San Francisco Sola" },
    { code: "MX.20.150", name: "San Francisco Telixtlahuaca" },
    { code: "MX.20.151", name: "San Francisco Teopan" },
    { code: "MX.20.152", name: "San Francisco Tlapancingo" },
    { code: "MX.20.153", name: "San Gabriel Mixtepec" },
    { code: "MX.20.154", name: "San Ildefonso Amatlán" },
    { code: "MX.20.155", name: "San Ildefonso Sola" },
    { code: "MX.20.156", name: "San Ildefonso Villa Alta" },
    { code: "MX.20.157", name: "San Jacinto Amilpas" },
    { code: "MX.20.158", name: "San Jacinto Tlacotepec" },
    { code: "MX.20.159", name: "San Jerónimo Coatlán" },
    { code: "MX.20.160", name: "San Jerónimo Silacayoapilla" },
    { code: "MX.20.161", name: "San Jerónimo Sosola" },
    { code: "MX.20.162", name: "San Jerónimo Taviche" },
    { code: "MX.20.163", name: "San Jerónimo Tecóatl" },
    { code: "MX.20.164", name: "San Jorge Nuchita" },
    { code: "MX.20.165", name: "San José Ayuquila" },
    { code: "MX.20.166", name: "San José Chiltepec" },
    { code: "MX.20.167", name: "San José del Peñasco" },
    { code: "MX.20.168", name: "San José Estancia Grande" },
    { code: "MX.20.169", name: "San José Independencia" },
    { code: "MX.20.170", name: "San José Lachiguiri" },
    { code: "MX.20.171", name: "San José Tenango" },
    { code: "MX.20.172", name: "San Juan Achiutla" },
    { code: "MX.20.173", name: "San Juan Atepec" },
    { code: "MX.20.174", name: "Ánimas Trujano" },
    { code: "MX.20.175", name: "San Juan Bautista Atatlahuca" },
    { code: "MX.20.176", name: "San Juan Bautista Coixtlahuaca" },
    { code: "MX.20.177", name: "San Juan Bautista Cuicatlán" },
    { code: "MX.20.178", name: "San Juan Bautista Guelache" },
    { code: "MX.20.179", name: "San Juan Bautista Jayacatlán" },
    { code: "MX.20.180", name: "San Juan Bautista Lo de Soto" },
    { code: "MX.20.181", name: "San Juan Bautista Suchitepec" },
    { code: "MX.20.182", name: "San Juan Bautista Tlacoatzintepec" },
    { code: "MX.20.183", name: "San Juan Bautista Tlachichilco" },
    { code: "MX.20.184", name: "San Juan Bautista Tuxtepec" },
    { code: "MX.20.185", name: "San Juan Cacahuatepec" },
    { code: "MX.20.186", name: "San Juan Cieneguilla" },
    { code: "MX.20.187", name: "San Juan Coatzóspam" },
    { code: "MX.20.188", name: "San Juan Colorado" },
    { code: "MX.20.189", name: "San Juan Comaltepec" },
    { code: "MX.20.190", name: "San Juan Cotzocón" },
    { code: "MX.20.191", name: "San Juan Chicomezúchil" },
    { code: "MX.20.192", name: "San Juan Chilateca" },
    { code: "MX.20.193", name: "San Juan del Estado" },
    { code: "MX.20.194", name: "San Juan del Río" },
    { code: "MX.20.195", name: "San Juan Diuxi" },
    { code: "MX.20.196", name: "San Juan Evangelista Analco" },
    { code: "MX.20.197", name: "San Juan Guelavía" },
    { code: "MX.20.198", name: "San Juan Guichicovi" },
    { code: "MX.20.199", name: "San Juan Ihualtepec" },
    { code: "MX.20.200", name: "San Juan Juquila Mixes" },
    { code: "MX.20.201", name: "San Juan Juquila Vijanos" },
    { code: "MX.20.202", name: "San Juan Lachao" },
    { code: "MX.20.203", name: "San Juan Lachigalla" },
    { code: "MX.20.204", name: "San Juan Lajarcia" },
    { code: "MX.20.205", name: "San Juan Lalana" },
    { code: "MX.20.206", name: "San Juan de los Cués" },
    { code: "MX.20.207", name: "San Juan Mazatlán" },
    { code: "MX.20.208", name: "San Juan Mixtepec -Dto. 08 -" },
    { code: "MX.20.209", name: "San Juan Mixtepec -Dto. 26 -" },
    { code: "MX.20.210", name: "San Juan Ñumí" },
    { code: "MX.20.211", name: "San Juan Ozolotepec" },
    { code: "MX.20.212", name: "San Juan Petlapa" },
    { code: "MX.20.213", name: "San Juan Quiahije" },
    { code: "MX.20.214", name: "San Juan Quiotepec" },
    { code: "MX.20.215", name: "San Juan Sayultepec" },
    { code: "MX.20.216", name: "San Juan Tabaá" },
    { code: "MX.20.217", name: "San Juan Tamazola" },
    { code: "MX.20.218", name: "San Juan Teita" },
    { code: "MX.20.219", name: "San Juan Teitipac" },
    { code: "MX.20.220", name: "San Juan Tepeuxila" },
    { code: "MX.20.221", name: "San Juan Teposcolula" },
    { code: "MX.20.222", name: "San Juan Yaeé" },
    { code: "MX.20.223", name: "San Juan Yatzona" },
    { code: "MX.20.224", name: "San Juan Yucuita" },
    { code: "MX.20.225", name: "San Lorenzo" },
    { code: "MX.20.226", name: "San Lorenzo Albarradas" },
    { code: "MX.20.227", name: "San Lorenzo Cacaotepec" },
    { code: "MX.20.228", name: "San Lorenzo Cuaunecuiltitla" },
    { code: "MX.20.229", name: "San Lorenzo Texmelúcan" },
    { code: "MX.20.230", name: "San Lorenzo Victoria" },
    { code: "MX.20.231", name: "San Lucas Camotlán" },
    { code: "MX.20.232", name: "San Lucas Ojitlán" },
    { code: "MX.20.233", name: "San Lucas Quiaviní" },
    { code: "MX.20.234", name: "San Lucas Zoquiápam" },
    { code: "MX.20.235", name: "San Luis Amatlán" },
    { code: "MX.20.236", name: "San Marcial Ozolotepec" },
    { code: "MX.20.237", name: "San Marcos Arteaga" },
    { code: "MX.20.238", name: "San Martín de los Cansecos" },
    { code: "MX.20.239", name: "San Martín Huamelúlpam" },
    { code: "MX.20.240", name: "San Martín Itunyoso" },
    { code: "MX.20.241", name: "San Martín Lachilá" },
    { code: "MX.20.242", name: "San Martín Peras" },
    { code: "MX.20.243", name: "San Martín Tilcajete" },
    { code: "MX.20.244", name: "San Martín Toxpalan" },
    { code: "MX.20.245", name: "San Martín Zacatepec" },
    { code: "MX.20.246", name: "San Mateo Cajonos" },
    { code: "MX.20.247", name: "Capulálpam de Méndez" },
    { code: "MX.20.248", name: "San Mateo del Mar" },
    { code: "MX.20.249", name: "San Mateo Yoloxochitlán" },
    { code: "MX.20.250", name: "San Mateo Etlatongo" },
    { code: "MX.20.251", name: "San Mateo Nejápam" },
    { code: "MX.20.252", name: "San Mateo Peñasco" },
    { code: "MX.20.253", name: "San Mateo Piñas" },
    { code: "MX.20.254", name: "San Mateo Río Hondo" },
    { code: "MX.20.255", name: "San Mateo Sindihui" },
    { code: "MX.20.256", name: "San Mateo Tlapiltepec" },
    { code: "MX.20.257", name: "San Melchor Betaza" },
    { code: "MX.20.258", name: "San Miguel Achiutla" },
    { code: "MX.20.259", name: "San Miguel Ahuehuetitlán" },
    { code: "MX.20.260", name: "San Miguel Aloápam" },
    { code: "MX.20.261", name: "San Miguel Amatitlán" },
    { code: "MX.20.262", name: "San Miguel Amatlán" },
    { code: "MX.20.263", name: "San Miguel Coatlán" },
    { code: "MX.20.264", name: "San Miguel Chicahua" },
    { code: "MX.20.265", name: "San Miguel Chimalapa" },
    { code: "MX.20.266", name: "San Miguel del Puerto" },
    { code: "MX.20.267", name: "San Miguel del Río" },
    { code: "MX.20.268", name: "San Miguel Ejutla" },
    { code: "MX.20.269", name: "San Miguel el Grande" },
    { code: "MX.20.270", name: "San Miguel Huautla" },
    { code: "MX.20.271", name: "San Miguel Mixtepec" },
    { code: "MX.20.272", name: "San Miguel Panixtlahuaca" },
    { code: "MX.20.273", name: "San Miguel Peras" },
    { code: "MX.20.274", name: "San Miguel Piedras" },
    { code: "MX.20.275", name: "San Miguel Quetzaltepec" },
    { code: "MX.20.276", name: "San Miguel Santa Flor" },
    { code: "MX.20.277", name: "Villa Sola de Vega" },
    { code: "MX.20.278", name: "San Miguel Soyaltepec" },
    { code: "MX.20.279", name: "San Miguel Suchixtepec" },
    { code: "MX.20.280", name: "Villa Talea de Castro" },
    { code: "MX.20.281", name: "San Miguel Tecomatlán" },
    { code: "MX.20.282", name: "San Miguel Tenango" },
    { code: "MX.20.283", name: "San Miguel Tequixtepec" },
    { code: "MX.20.284", name: "San Miguel Tilquiápam" },
    { code: "MX.20.285", name: "San Miguel Tlacamama" },
    { code: "MX.20.286", name: "San Miguel Tlacotepec" },
    { code: "MX.20.287", name: "San Miguel Tulancingo" },
    { code: "MX.20.288", name: "San Miguel Yotao" },
    { code: "MX.20.289", name: "San Nicolás" },
    { code: "MX.20.290", name: "San Nicolás Hidalgo" },
    { code: "MX.20.291", name: "San Pablo Coatlán" },
    { code: "MX.20.292", name: "San Pablo Cuatro Venados" },
    { code: "MX.20.293", name: "San Pablo Etla" },
    { code: "MX.20.294", name: "San Pablo Huitzo" },
    { code: "MX.20.295", name: "San Pablo Huixtepec" },
    { code: "MX.20.296", name: "San Pablo Macuiltianguis" },
    { code: "MX.20.297", name: "San Pablo Tijaltepec" },
    { code: "MX.20.298", name: "San Pablo Villa de Mitla" },
    { code: "MX.20.299", name: "San Pablo Yaganiza" },
    { code: "MX.20.300", name: "San Pedro Amuzgos" },
    { code: "MX.20.301", name: "San Pedro Apóstol" },
    { code: "MX.20.302", name: "San Pedro Atoyac" },
    { code: "MX.20.303", name: "San Pedro Cajonos" },
    { code: "MX.20.304", name: "San Pedro Coxcaltepec Cántaros" },
    { code: "MX.20.305", name: "San Pedro Comitancillo" },
    { code: "MX.20.306", name: "San Pedro el Alto" },
    { code: "MX.20.307", name: "San Pedro Huamelula" },
    { code: "MX.20.308", name: "San Pedro Huilotepec" },
    { code: "MX.20.309", name: "San Pedro Ixcatlán" },
    { code: "MX.20.310", name: "San Pedro Ixtlahuaca" },
    { code: "MX.20.311", name: "San Pedro Jaltepetongo" },
    { code: "MX.20.312", name: "San Pedro Jicayán" },
    { code: "MX.20.313", name: "San Pedro Jocotipac" },
    { code: "MX.20.314", name: "San Pedro Juchatengo" },
    { code: "MX.20.315", name: "San Pedro Mártir" },
    { code: "MX.20.316", name: "San Pedro Mártir Quiechapa" },
    { code: "MX.20.317", name: "San Pedro Mártir Yucuxaco" },
    { code: "MX.20.318", name: "San Pedro Mixtepec -Dto. 22 -" },
    { code: "MX.20.319", name: "San Pedro Mixtepec -Dto. 26 -" },
    { code: "MX.20.320", name: "San Pedro Molinos" },
    { code: "MX.20.321", name: "San Pedro Nopala" },
    { code: "MX.20.322", name: "San Pedro Ocopetatillo" },
    { code: "MX.20.323", name: "San Pedro Ocotepec" },
    { code: "MX.20.324", name: "San Pedro Pochutla" },
    { code: "MX.20.325", name: "San Pedro Quiatoni" },
    { code: "MX.20.326", name: "San Pedro Sochiápam" },
    { code: "MX.20.327", name: "San Pedro Tapanatepec" },
    { code: "MX.20.328", name: "San Pedro Taviche" },
    { code: "MX.20.329", name: "San Pedro Teozacoalco" },
    { code: "MX.20.330", name: "San Pedro Teutila" },
    { code: "MX.20.331", name: "San Pedro Tidaá" },
    { code: "MX.20.332", name: "San Pedro Topiltepec" },
    { code: "MX.20.333", name: "San Pedro Totolápam" },
    { code: "MX.20.334", name: "Villa de Tututepec de Melchor Ocampo" },
    { code: "MX.20.335", name: "San Pedro Yaneri" },
    { code: "MX.20.336", name: "San Pedro Yólox" },
    { code: "MX.20.337", name: "San Pedro y San Pablo Ayutla" },
    { code: "MX.20.338", name: "Villa de Etla" },
    { code: "MX.20.339", name: "San Pedro y San Pablo Teposcolula" },
    { code: "MX.20.340", name: "San Pedro y San Pablo Tequixtepec" },
    { code: "MX.20.341", name: "San Pedro Yucunama" },
    { code: "MX.20.342", name: "San Raymundo Jalpan" },
    { code: "MX.20.343", name: "San Sebastián Abasolo" },
    { code: "MX.20.344", name: "San Sebastián Coatlán" },
    { code: "MX.20.345", name: "San Sebastián Ixcapa" },
    { code: "MX.20.346", name: "San Sebastián Nicananduta" },
    { code: "MX.20.347", name: "San Sebastián Río Hondo" },
    { code: "MX.20.348", name: "San Sebastián Tecomaxtlahuaca" },
    { code: "MX.20.349", name: "San Sebastián Teitipac" },
    { code: "MX.20.350", name: "San Sebastián Tutla" },
    { code: "MX.20.351", name: "San Simón Almolongas" },
    { code: "MX.20.352", name: "San Simón Zahuatlán" },
    { code: "MX.20.353", name: "Santa Ana" },
    { code: "MX.20.354", name: "Santa Ana Ateixtlahuaca" },
    { code: "MX.20.355", name: "Santa Ana Cuauhtémoc" },
    { code: "MX.20.356", name: "Santa Ana del Valle" },
    { code: "MX.20.357", name: "Santa Ana Tavela" },
    { code: "MX.20.358", name: "Santa Ana Tlapacoyan" },
    { code: "MX.20.359", name: "Santa Ana Yareni" },
    { code: "MX.20.360", name: "Santa Ana Zegache" },
    { code: "MX.20.361", name: "Santa Catalina Quierí" },
    { code: "MX.20.362", name: "Santa Catarina Cuixtla" },
    { code: "MX.20.363", name: "Santa Catarina Ixtepeji" },
    { code: "MX.20.364", name: "Santa Catarina Juquila" },
    { code: "MX.20.365", name: "Santa Catarina Lachatao" },
    { code: "MX.20.366", name: "Santa Catarina Loxicha" },
    { code: "MX.20.367", name: "Santa Catarina Mechoacán" },
    { code: "MX.20.368", name: "Santa Catarina Minas" },
    { code: "MX.20.369", name: "Santa Catarina Quiané" },
    { code: "MX.20.370", name: "Santa Catarina Tayata" },
    { code: "MX.20.371", name: "Santa Catarina Ticuá" },
    { code: "MX.20.372", name: "Santa Catarina Yosonotú" },
    { code: "MX.20.373", name: "Santa Catarina Zapoquila" },
    { code: "MX.20.374", name: "Santa Cruz Acatepec" },
    { code: "MX.20.375", name: "Santa Cruz Amilpas" },
    { code: "MX.20.376", name: "Santa Cruz de Bravo" },
    { code: "MX.20.377", name: "Santa Cruz Itundujia" },
    { code: "MX.20.378", name: "Santa Cruz Mixtepec" },
    { code: "MX.20.379", name: "Santa Cruz Nundaco" },
    { code: "MX.20.380", name: "Santa Cruz Papalutla" },
    { code: "MX.20.381", name: "Santa Cruz Tacache de Mina" },
    { code: "MX.20.382", name: "Santa Cruz Tacahua" },
    { code: "MX.20.383", name: "Santa Cruz Tayata" },
    { code: "MX.20.384", name: "Santa Cruz Xitla" },
    { code: "MX.20.385", name: "Santa Cruz Xoxocotlán" },
    { code: "MX.20.386", name: "Santa Cruz Zenzontepec" },
    { code: "MX.20.387", name: "Santa Gertrudis" },
    { code: "MX.20.388", name: "Santa Inés del Monte" },
    { code: "MX.20.389", name: "Santa Inés Yatzeche" },
    { code: "MX.20.390", name: "Santa Lucía del Camino" },
    { code: "MX.20.391", name: "Santa Lucía Miahuatlán" },
    { code: "MX.20.392", name: "Santa Lucía Monteverde" },
    { code: "MX.20.393", name: "Santa Lucía Ocotlán" },
    { code: "MX.20.394", name: "Santa María Alotepec" },
    { code: "MX.20.395", name: "Santa María Apazco" },
    { code: "MX.20.396", name: "Santa María la Asunción" },
    { code: "MX.20.397", name: "Heroica Ciudad de Tlaxiaco" },
    { code: "MX.20.398", name: "Ayoquezco de Aldama" },
    { code: "MX.20.399", name: "Santa María Atzompa" },
    { code: "MX.20.400", name: "Santa María Camotlán" },
    { code: "MX.20.401", name: "Santa María Colotepec" },
    { code: "MX.20.402", name: "Santa María Cortijo" },
    { code: "MX.20.403", name: "Santa María Coyotepec" },
    { code: "MX.20.404", name: "Santa María Chachoápam" },
    { code: "MX.20.405", name: "Villa de Chilapa de Díaz" },
    { code: "MX.20.406", name: "Santa María Chilchotla" },
    { code: "MX.20.407", name: "Santa María Chimalapa" },
    { code: "MX.20.408", name: "Santa María del Rosario" },
    { code: "MX.20.409", name: "Santa María del Tule" },
    { code: "MX.20.410", name: "Santa María Ecatepec" },
    { code: "MX.20.411", name: "Santa María Guelacé" },
    { code: "MX.20.412", name: "Santa María Guienagati" },
    { code: "MX.20.413", name: "Santa María Huatulco" },
    { code: "MX.20.414", name: "Santa María Huazolotitlán" },
    { code: "MX.20.415", name: "Santa María Ipalapa" },
    { code: "MX.20.416", name: "Santa María Ixcatlán" },
    { code: "MX.20.417", name: "Santa María Jacatepec" },
    { code: "MX.20.418", name: "Santa María Jalapa del Marqués" },
    { code: "MX.20.419", name: "Santa María Jaltianguis" },
    { code: "MX.20.420", name: "Santa María Lachixío" },
    { code: "MX.20.421", name: "Santa María Mixtequilla" },
    { code: "MX.20.422", name: "Santa María Nativitas" },
    { code: "MX.20.423", name: "Santa María Nduayaco" },
    { code: "MX.20.424", name: "Santa María Ozolotepec" },
    { code: "MX.20.425", name: "Santa María Pápalo" },
    { code: "MX.20.426", name: "Santa María Peñoles" },
    { code: "MX.20.427", name: "Santa María Petapa" },
    { code: "MX.20.428", name: "Santa María Quiegolani" },
    { code: "MX.20.429", name: "Santa María Sola" },
    { code: "MX.20.430", name: "Santa María Tataltepec" },
    { code: "MX.20.431", name: "Santa María Tecomavaca" },
    { code: "MX.20.432", name: "Santa María Temaxcalapa" },
    { code: "MX.20.433", name: "Santa María Temaxcaltepec" },
    { code: "MX.20.434", name: "Santa María Teopoxco" },
    { code: "MX.20.435", name: "Santa María Tepantlali" },
    { code: "MX.20.436", name: "Santa María Texcatitlán" },
    { code: "MX.20.437", name: "Santa María Tlahuitoltepec" },
    { code: "MX.20.438", name: "Santa María Tlalixtac" },
    { code: "MX.20.439", name: "Santa María Tonameca" },
    { code: "MX.20.440", name: "Santa María Totolapilla" },
    { code: "MX.20.441", name: "Santa María Xadani" },
    { code: "MX.20.442", name: "Santa María Yalina" },
    { code: "MX.20.443", name: "Santa María Yavesía" },
    { code: "MX.20.444", name: "Santa María Yolotepec" },
    { code: "MX.20.445", name: "Santa María Yosoyúa" },
    { code: "MX.20.446", name: "Santa María Yucuhiti" },
    { code: "MX.20.447", name: "Santa María Zacatepec" },
    { code: "MX.20.448", name: "Santa María Zaniza" },
    { code: "MX.20.449", name: "Santa María Zoquitlán" },
    { code: "MX.20.450", name: "Santiago Amoltepec" },
    { code: "MX.20.451", name: "Santiago Apoala" },
    { code: "MX.20.452", name: "Santiago Apóstol" },
    { code: "MX.20.453", name: "Santiago Astata" },
    { code: "MX.20.454", name: "Santiago Atitlán" },
    { code: "MX.20.455", name: "Santiago Ayuquililla" },
    { code: "MX.20.456", name: "Santiago Cacaloxtepec" },
    { code: "MX.20.457", name: "Santiago Camotlán" },
    { code: "MX.20.458", name: "Santiago Comaltepec" },
    { code: "MX.20.459", name: "Santiago Chazumba" },
    { code: "MX.20.460", name: "Santiago Choápam" },
    { code: "MX.20.461", name: "Santiago del Río" },
    { code: "MX.20.462", name: "Santiago Huajolotitlán" },
    { code: "MX.20.463", name: "Santiago Huauclilla" },
    { code: "MX.20.464", name: "Santiago Ihuitlán Plumas" },
    { code: "MX.20.465", name: "Santiago Ixcuintepec" },
    { code: "MX.20.466", name: "Santiago Ixtayutla" },
    { code: "MX.20.467", name: "Santiago Jamiltepec" },
    { code: "MX.20.468", name: "Santiago Jocotepec" },
    { code: "MX.20.469", name: "Santiago Juxtlahuaca" },
    { code: "MX.20.470", name: "Santiago Lachiguiri" },
    { code: "MX.20.471", name: "Santiago Lalopa" },
    { code: "MX.20.472", name: "Santiago Laollaga" },
    { code: "MX.20.473", name: "Santiago Laxopa" },
    { code: "MX.20.474", name: "Santiago Llano Grande" },
    { code: "MX.20.475", name: "Santiago Matatlán" },
    { code: "MX.20.476", name: "Santiago Miltepec" },
    { code: "MX.20.477", name: "Santiago Minas" },
    { code: "MX.20.478", name: "Santiago Nacaltepec" },
    { code: "MX.20.479", name: "Santiago Nejapilla" },
    { code: "MX.20.480", name: "Santiago Nundiche" },
    { code: "MX.20.481", name: "Santiago Nuyoó" },
    { code: "MX.20.482", name: "Santiago Pinotepa Nacional" },
    { code: "MX.20.483", name: "Santiago Suchilquitongo" },
    { code: "MX.20.484", name: "Santiago Tamazola" },
    { code: "MX.20.485", name: "Santiago Tapextla" },
    { code: "MX.20.486", name: "Villa Tejúpam de la Unión" },
    { code: "MX.20.487", name: "Santiago Tenango" },
    { code: "MX.20.488", name: "Santiago Tepetlapa" },
    { code: "MX.20.489", name: "Santiago Tetepec" },
    { code: "MX.20.490", name: "Santiago Texcalcingo" },
    { code: "MX.20.491", name: "Santiago Textitlán" },
    { code: "MX.20.492", name: "Santiago Tilantongo" },
    { code: "MX.20.493", name: "Santiago Tillo" },
    { code: "MX.20.494", name: "Santiago Tlazoyaltepec" },
    { code: "MX.20.495", name: "Santiago Xanica" },
    { code: "MX.20.496", name: "Santiago Xiacuí" },
    { code: "MX.20.497", name: "Santiago Yaitepec" },
    { code: "MX.20.498", name: "Santiago Yaveo" },
    { code: "MX.20.499", name: "Santiago Yolomécatl" },
    { code: "MX.20.500", name: "Santiago Yosondúa" },
    { code: "MX.20.501", name: "Santiago Yucuyachi" },
    { code: "MX.20.502", name: "Santiago Zacatepec" },
    { code: "MX.20.503", name: "Santiago Zoochila" },
    { code: "MX.20.504", name: "Nuevo Zoquiápam" },
    { code: "MX.20.505", name: "Santo Domingo Ingenio" },
    { code: "MX.20.506", name: "Santo Domingo Albarradas" },
    { code: "MX.20.507", name: "Santo Domingo Armenta" },
    { code: "MX.20.508", name: "Santo Domingo Chihuitán" },
    { code: "MX.20.509", name: "Santo Domingo de Morelos" },
    { code: "MX.20.510", name: "Santo Domingo Ixcatlán" },
    { code: "MX.20.511", name: "Santo Domingo Nuxaá" },
    { code: "MX.20.512", name: "Santo Domingo Ozolotepec" },
    { code: "MX.20.513", name: "Santo Domingo Petapa" },
    { code: "MX.20.514", name: "Santo Domingo Roayaga" },
    { code: "MX.20.515", name: "Santo Domingo Tehuantepec" },
    { code: "MX.20.516", name: "Santo Domingo Teojomulco" },
    { code: "MX.20.517", name: "Santo Domingo Tepuxtepec" },
    { code: "MX.20.518", name: "Santo Domingo Tlatayápam" },
    { code: "MX.20.519", name: "Santo Domingo Tomaltepec" },
    { code: "MX.20.520", name: "Santo Domingo Tonalá" },
    { code: "MX.20.521", name: "Santo Domingo Tonaltepec" },
    { code: "MX.20.522", name: "Santo Domingo Xagacía" },
    { code: "MX.20.523", name: "Santo Domingo Yanhuitlán" },
    { code: "MX.20.524", name: "Santo Domingo Yodohino" },
    { code: "MX.20.525", name: "Santo Domingo Zanatepec" },
    { code: "MX.20.526", name: "Santos Reyes Nopala" },
    { code: "MX.20.527", name: "Santos Reyes Pápalo" },
    { code: "MX.20.528", name: "Santos Reyes Tepejillo" },
    { code: "MX.20.529", name: "Santos Reyes Yucuná" },
    { code: "MX.20.530", name: "Santo Tomás Jalieza" },
    { code: "MX.20.531", name: "Santo Tomás Mazaltepec" },
    { code: "MX.20.532", name: "Santo Tomás Ocotepec" },
    { code: "MX.20.533", name: "Santo Tomás Tamazulapan" },
    { code: "MX.20.534", name: "San Vicente Coatlán" },
    { code: "MX.20.535", name: "San Vicente Lachixío" },
    { code: "MX.20.536", name: "San Vicente Nuñú" },
    { code: "MX.20.537", name: "Silacayoápam" },
    { code: "MX.20.538", name: "Sitio de Xitlapehua" },
    { code: "MX.20.539", name: "Soledad Etla" },
    { code: "MX.20.540", name: "Villa de Tamazulápam del Progreso" },
    { code: "MX.20.541", name: "Tanetze de Zaragoza" },
    { code: "MX.20.542", name: "Taniche" },
    { code: "MX.20.543", name: "Tataltepec de Valdés" },
    { code: "MX.20.544", name: "Teococuilco de Marcos Pérez" },
    { code: "MX.20.545", name: "Teotitlán de Flores Magón" },
    { code: "MX.20.546", name: "Teotitlán del Valle" },
    { code: "MX.20.547", name: "Teotongo" },
    { code: "MX.20.548", name: "Tepelmeme Villa de Morelos" },
    { code: "MX.20.549", name: "Heroica Villa Tezoatlán de Segura y Luna, Cuna de la Independencia de Oaxaca" },
    { code: "MX.20.550", name: "San Jerónimo Tlacochahuaya" },
    { code: "MX.20.551", name: "Tlacolula de Matamoros" },
    { code: "MX.20.552", name: "Tlacotepec Plumas" },
    { code: "MX.20.553", name: "Tlalixtac de Cabrera" },
    { code: "MX.20.554", name: "Totontepec Villa de Morelos" },
    { code: "MX.20.555", name: "Trinidad Zaachila" },
    { code: "MX.20.556", name: "La Trinidad Vista Hermosa" },
    { code: "MX.20.557", name: "Unión Hidalgo" },
    { code: "MX.20.558", name: "Valerio Trujano" },
    { code: "MX.20.559", name: "San Juan Bautista Valle Nacional" },
    { code: "MX.20.560", name: "Villa Díaz Ordaz" },
    { code: "MX.20.561", name: "Yaxe" },
    { code: "MX.20.562", name: "Magdalena Yodocono de Porfirio Díaz" },
    { code: "MX.20.563", name: "Yogana" },
    { code: "MX.20.564", name: "Yutanduchi de Guerrero" },
    { code: "MX.20.565", name: "Villa de Zaachila" },
    { code: "MX.20.566", name: "San Mateo Yucutindoo" },
    { code: "MX.20.567", name: "Zapotitlán Lagunas" },
    { code: "MX.20.568", name: "Zapotitlán Palmas" },
    { code: "MX.20.569", name: "Santa Inés de Zaragoza" },
    { code: "MX.20.570", name: "Zimatlán de Álvarez" },
  ],
  "MX.21": [
    { code: "MX.21.001", name: "Acajete" },
    { code: "MX.21.002", name: "Acateno" },
    { code: "MX.21.003", name: "Acatlán" },
    { code: "MX.21.004", name: "Acatzingo" },
    { code: "MX.21.005", name: "Acteopan" },
    { code: "MX.21.006", name: "Ahuacatlán" },
    { code: "MX.21.007", name: "Ahuatlán" },
    { code: "MX.21.008", name: "Ahuazotepec" },
    { code: "MX.21.009", name: "Ahuehuetitla" },
    { code: "MX.21.010", name: "Ajalpan" },
    { code: "MX.21.011", name: "Albino Zertuche" },
    { code: "MX.21.012", name: "Aljojuca" },
    { code: "MX.21.013", name: "Altepexi" },
    { code: "MX.21.014", name: "Amixtlán" },
    { code: "MX.21.015", name: "Amozoc" },
    { code: "MX.21.016", name: "Aquixtla" },
    { code: "MX.21.017", name: "Atempan" },
    { code: "MX.21.018", name: "Atexcal" },
    { code: "MX.21.019", name: "Atlixco" },
    { code: "MX.21.020", name: "Atoyatempan" },
    { code: "MX.21.021", name: "Atzala" },
    { code: "MX.21.022", name: "Atzitzihuacán" },
    { code: "MX.21.023", name: "Atzitzintla" },
    { code: "MX.21.024", name: "Axutla" },
    { code: "MX.21.025", name: "Ayotoxco de Guerrero" },
    { code: "MX.21.026", name: "Calpan" },
    { code: "MX.21.027", name: "Caltepec" },
    { code: "MX.21.028", name: "Camocuautla" },
    { code: "MX.21.029", name: "Caxhuacan" },
    { code: "MX.21.030", name: "Coatepec" },
    { code: "MX.21.031", name: "Coatzingo" },
    { code: "MX.21.032", name: "Cohetzala" },
    { code: "MX.21.033", name: "Cohuecan" },
    { code: "MX.21.034", name: "Coronango" },
    { code: "MX.21.035", name: "Coxcatlán" },
    { code: "MX.21.036", name: "Coyomeapan" },
    { code: "MX.21.037", name: "Coyotepec" },
    { code: "MX.21.038", name: "Cuapiaxtla de Madero" },
    { code: "MX.21.039", name: "Cuautempan" },
    { code: "MX.21.040", name: "Cuautinchán" },
    { code: "MX.21.041", name: "Cuautlancingo" },
    { code: "MX.21.042", name: "Cuayuca de Andrade" },
    { code: "MX.21.043", name: "Cuetzalan del Progreso" },
    { code: "MX.21.044", name: "Cuyoaco" },
    { code: "MX.21.045", name: "Chalchicomula de Sesma" },
    { code: "MX.21.046", name: "Chapulco" },
    { code: "MX.21.047", name: "Chiautla" },
    { code: "MX.21.048", name: "Chiautzingo" },
    { code: "MX.21.049", name: "Chiconcuautla" },
    { code: "MX.21.050", name: "Chichiquila" },
    { code: "MX.21.051", name: "Chietla" },
    { code: "MX.21.052", name: "Chigmecatitlán" },
    { code: "MX.21.053", name: "Chignahuapan" },
    { code: "MX.21.054", name: "Chignautla" },
    { code: "MX.21.055", name: "Chila" },
    { code: "MX.21.056", name: "Chila de la Sal" },
    { code: "MX.21.057", name: "Honey" },
    { code: "MX.21.058", name: "Chilchotla" },
    { code: "MX.21.059", name: "Chinantla" },
    { code: "MX.21.060", name: "Domingo Arenas" },
    { code: "MX.21.061", name: "Eloxochitlán" },
    { code: "MX.21.062", name: "Epatlán" },
    { code: "MX.21.063", name: "Esperanza" },
    { code: "MX.21.064", name: "Francisco Z. Mena" },
    { code: "MX.21.065", name: "General Felipe Ángeles" },
    { code: "MX.21.066", name: "Guadalupe" },
    { code: "MX.21.067", name: "Guadalupe Victoria" },
    { code: "MX.21.068", name: "Hermenegildo Galeana" },
    { code: "MX.21.069", name: "Huaquechula" },
    { code: "MX.21.070", name: "Huatlatlauca" },
    { code: "MX.21.071", name: "Huauchinango" },
    { code: "MX.21.072", name: "Huehuetla" },
    { code: "MX.21.073", name: "Huehuetlán el Chico" },
    { code: "MX.21.074", name: "Huejotzingo" },
    { code: "MX.21.075", name: "Hueyapan" },
    { code: "MX.21.076", name: "Hueytamalco" },
    { code: "MX.21.077", name: "Hueytlalpan" },
    { code: "MX.21.078", name: "Huitzilan de Serdán" },
    { code: "MX.21.079", name: "Huitziltepec" },
    { code: "MX.21.080", name: "Atlequizayan" },
    { code: "MX.21.081", name: "Ixcamilpa de Guerrero" },
    { code: "MX.21.082", name: "Ixcaquixtla" },
    { code: "MX.21.083", name: "Ixtacamaxtitlán" },
    { code: "MX.21.084", name: "Ixtepec" },
    { code: "MX.21.085", name: "Izúcar de Matamoros" },
    { code: "MX.21.086", name: "Jalpan" },
    { code: "MX.21.087", name: "Jolalpan" },
    { code: "MX.21.088", name: "Jonotla" },
    { code: "MX.21.089", name: "Jopala" },
    { code: "MX.21.090", name: "Juan C. Bonilla" },
    { code: "MX.21.091", name: "Juan Galindo" },
    { code: "MX.21.092", name: "Juan N. Méndez" },
    { code: "MX.21.093", name: "Lafragua" },
    { code: "MX.21.094", name: "Libres" },
    { code: "MX.21.095", name: "La Magdalena Tlatlauquitepec" },
    { code: "MX.21.096", name: "Mazapiltepec de Juárez" },
    { code: "MX.21.097", name: "Mixtla" },
    { code: "MX.21.098", name: "Molcaxac" },
    { code: "MX.21.099", name: "Cañada Morelos" },
    { code: "MX.21.100", name: "Naupan" },
    { code: "MX.21.101", name: "Nauzontla" },
    { code: "MX.21.102", name: "Nealtican" },
    { code: "MX.21.103", name: "Nicolás Bravo" },
    { code: "MX.21.104", name: "Nopalucan" },
    { code: "MX.21.105", name: "Ocotepec" },
    { code: "MX.21.106", name: "Ocoyucan" },
    { code: "MX.21.107", name: "Olintla" },
    { code: "MX.21.108", name: "Oriental" },
    { code: "MX.21.109", name: "Pahuatlán" },
    { code: "MX.21.110", name: "Palmar de Bravo" },
    { code: "MX.21.111", name: "Pantepec" },
    { code: "MX.21.112", name: "Petlalcingo" },
    { code: "MX.21.113", name: "Piaxtla" },
    { code: "MX.21.114", name: "Puebla" },
    { code: "MX.21.115", name: "Quecholac" },
    { code: "MX.21.116", name: "Quimixtlán" },
    { code: "MX.21.117", name: "Rafael Lara Grajales" },
    { code: "MX.21.118", name: "Los Reyes de Juárez" },
    { code: "MX.21.119", name: "San Andrés Cholula" },
    { code: "MX.21.120", name: "San Antonio Cañada" },
    { code: "MX.21.121", name: "San Diego la Mesa Tochimiltzingo" },
    { code: "MX.21.122", name: "San Felipe Teotlalcingo" },
    { code: "MX.21.123", name: "San Felipe Tepatlán" },
    { code: "MX.21.124", name: "San Gabriel Chilac" },
    { code: "MX.21.125", name: "San Gregorio Atzompa" },
    { code: "MX.21.126", name: "San Jerónimo Tecuanipan" },
    { code: "MX.21.127", name: "San Jerónimo Xayacatlán" },
    { code: "MX.21.128", name: "San José Chiapa" },
    { code: "MX.21.129", name: "San José Miahuatlán" },
    { code: "MX.21.130", name: "San Juan Atenco" },
    { code: "MX.21.131", name: "San Juan Atzompa" },
    { code: "MX.21.132", name: "San Martín Texmelucan" },
    { code: "MX.21.133", name: "San Martín Totoltepec" },
    { code: "MX.21.134", name: "San Matías Tlalancaleca" },
    { code: "MX.21.135", name: "San Miguel Ixitlán" },
    { code: "MX.21.136", name: "San Miguel Xoxtla" },
    { code: "MX.21.137", name: "San Nicolás Buenos Aires" },
    { code: "MX.21.138", name: "San Nicolás de los Ranchos" },
    { code: "MX.21.139", name: "San Pablo Anicano" },
    { code: "MX.21.140", name: "San Pedro Cholula" },
    { code: "MX.21.141", name: "San Pedro Yeloixtlahuaca" },
    { code: "MX.21.142", name: "San Salvador el Seco" },
    { code: "MX.21.143", name: "San Salvador el Verde" },
    { code: "MX.21.144", name: "San Salvador Huixcolotla" },
    { code: "MX.21.145", name: "San Sebastián Tlacotepec" },
    { code: "MX.21.146", name: "Santa Catarina Tlaltempan" },
    { code: "MX.21.147", name: "Santa Inés Ahuatempan" },
    { code: "MX.21.148", name: "Santa Isabel Cholula" },
    { code: "MX.21.149", name: "Santiago Miahuatlán" },
    { code: "MX.21.150", name: "Huehuetlán el Grande" },
    { code: "MX.21.151", name: "Santo Tomás Hueyotlipan" },
    { code: "MX.21.152", name: "Soltepec" },
    { code: "MX.21.153", name: "Tecali de Herrera" },
    { code: "MX.21.154", name: "Tecamachalco" },
    { code: "MX.21.155", name: "Tecomatlán" },
    { code: "MX.21.156", name: "Tehuacán" },
    { code: "MX.21.157", name: "Tehuitzingo" },
    { code: "MX.21.158", name: "Tenampulco" },
    { code: "MX.21.159", name: "Teopantlán" },
    { code: "MX.21.160", name: "Teotlalco" },
    { code: "MX.21.161", name: "Tepanco de López" },
    { code: "MX.21.162", name: "Tepango de Rodríguez" },
    { code: "MX.21.163", name: "Tepatlaxco de Hidalgo" },
    { code: "MX.21.164", name: "Tepeaca" },
    { code: "MX.21.165", name: "Tepemaxalco" },
    { code: "MX.21.166", name: "Tepeojuma" },
    { code: "MX.21.167", name: "Tepetzintla" },
    { code: "MX.21.168", name: "Tepexco" },
    { code: "MX.21.169", name: "Tepexi de Rodríguez" },
    { code: "MX.21.170", name: "Tepeyahualco" },
    { code: "MX.21.171", name: "Tepeyahualco de Cuauhtémoc" },
    { code: "MX.21.172", name: "Tetela de Ocampo" },
    { code: "MX.21.173", name: "Teteles de Avila Castillo" },
    { code: "MX.21.174", name: "Teziutlán" },
    { code: "MX.21.175", name: "Tianguismanalco" },
    { code: "MX.21.176", name: "Tilapa" },
    { code: "MX.21.177", name: "Tlacotepec de Benito Juárez" },
    { code: "MX.21.178", name: "Tlacuilotepec" },
    { code: "MX.21.179", name: "Tlachichuca" },
    { code: "MX.21.180", name: "Tlahuapan" },
    { code: "MX.21.181", name: "Tlaltenango" },
    { code: "MX.21.182", name: "Tlanepantla" },
    { code: "MX.21.183", name: "Tlaola" },
    { code: "MX.21.184", name: "Tlapacoya" },
    { code: "MX.21.185", name: "Tlapanalá" },
    { code: "MX.21.186", name: "Tlatlauquitepec" },
    { code: "MX.21.187", name: "Tlaxco" },
    { code: "MX.21.188", name: "Tochimilco" },
    { code: "MX.21.189", name: "Tochtepec" },
    { code: "MX.21.190", name: "Totoltepec de Guerrero" },
    { code: "MX.21.191", name: "Tulcingo" },
    { code: "MX.21.192", name: "Tuzamapan de Galeana" },
    { code: "MX.21.193", name: "Tzicatlacoyan" },
    { code: "MX.21.194", name: "Venustiano Carranza" },
    { code: "MX.21.195", name: "Vicente Guerrero" },
    { code: "MX.21.196", name: "Xayacatlán de Bravo" },
    { code: "MX.21.197", name: "Xicotepec" },
    { code: "MX.21.198", name: "Xicotlán" },
    { code: "MX.21.199", name: "Xiutetelco" },
    { code: "MX.21.200", name: "Xochiapulco" },
    { code: "MX.21.201", name: "Xochiltepec" },
    { code: "MX.21.202", name: "Xochitlán de Vicente Suárez" },
    { code: "MX.21.203", name: "Xochitlán Todos Santos" },
    { code: "MX.21.204", name: "Yaonáhuac" },
    { code: "MX.21.205", name: "Yehualtepec" },
    { code: "MX.21.206", name: "Zacapala" },
    { code: "MX.21.207", name: "Zacapoaxtla" },
    { code: "MX.21.208", name: "Zacatlán" },
    { code: "MX.21.209", name: "Zapotitlán" },
    { code: "MX.21.210", name: "Zapotitlán de Méndez" },
    { code: "MX.21.211", name: "Zaragoza" },
    { code: "MX.21.212", name: "Zautla" },
    { code: "MX.21.213", name: "Zihuateutla" },
    { code: "MX.21.214", name: "Zinacatepec" },
    { code: "MX.21.215", name: "Zongozotla" },
    { code: "MX.21.216", name: "Zoquiapan" },
    { code: "MX.21.217", name: "Zoquitlán" },
  ],
  "MX.22": [
    { code: "MX.22.001", name: "Amealco de Bonfil" },
    { code: "MX.22.002", name: "Pinal de Amoles" },
    { code: "MX.22.003", name: "Arroyo Seco" },
    { code: "MX.22.004", name: "Cadereyta de Montes" },
    { code: "MX.22.005", name: "Colón" },
    { code: "MX.22.006", name: "Corregidora" },
    { code: "MX.22.007", name: "Ezequiel Montes" },
    { code: "MX.22.008", name: "Huimilpan" },
    { code: "MX.22.009", name: "Jalpan de Serra" },
    { code: "MX.22.010", name: "Landa de Matamoros" },
    { code: "MX.22.011", name: "El Marqués" },
    { code: "MX.22.012", name: "Pedro Escobedo" },
    { code: "MX.22.013", name: "Peñamiller" },
    { code: "MX.22.014", name: "Querétaro" },
    { code: "MX.22.015", name: "San Joaquín" },
    { code: "MX.22.016", name: "San Juan del Río" },
    { code: "MX.22.017", name: "Tequisquiapan" },
    { code: "MX.22.018", name: "Tolimán" },
  ],
  "MX.23": [
    { code: "MX.23.001", name: "Cozumel" },
    { code: "MX.23.002", name: "Felipe Carrillo Puerto" },
    { code: "MX.23.003", name: "Isla Mujeres" },
    { code: "MX.23.004", name: "Othón P. Blanco" },
    { code: "MX.23.005", name: "Benito Juárez" },
    { code: "MX.23.006", name: "José María Morelos" },
    { code: "MX.23.007", name: "Lázaro Cárdenas" },
    { code: "MX.23.008", name: "Solidaridad" },
    { code: "MX.23.009", name: "Tulum" },
    { code: "MX.23.010", name: "Bacalar" },
    { code: "MX.23.011", name: "Puerto Morelos" },
  ],
  "MX.24": [
    { code: "MX.24.001", name: "Ahualulco" },
    { code: "MX.24.002", name: "Alaquines" },
    { code: "MX.24.003", name: "Aquismón" },
    { code: "MX.24.004", name: "Armadillo de los Infante" },
    { code: "MX.24.005", name: "Cárdenas" },
    { code: "MX.24.006", name: "Catorce" },
    { code: "MX.24.007", name: "Cedral" },
    { code: "MX.24.008", name: "Cerritos" },
    { code: "MX.24.009", name: "Cerro de San Pedro" },
    { code: "MX.24.010", name: "Ciudad del Maíz" },
    { code: "MX.24.011", name: "Ciudad Fernández" },
    { code: "MX.24.012", name: "Tancanhuitz" },
    { code: "MX.24.013", name: "Ciudad Valles" },
    { code: "MX.24.014", name: "Coxcatlán" },
    { code: "MX.24.015", name: "Charcas" },
    { code: "MX.24.016", name: "Ebano" },
    { code: "MX.24.017", name: "Guadalcázar" },
    { code: "MX.24.018", name: "Huehuetlán" },
    { code: "MX.24.019", name: "Lagunillas" },
    { code: "MX.24.020", name: "Matehuala" },
    { code: "MX.24.021", name: "Mexquitic de Carmona" },
    { code: "MX.24.022", name: "Moctezuma" },
    { code: "MX.24.023", name: "Rayón" },
    { code: "MX.24.024", name: "Rioverde" },
    { code: "MX.24.025", name: "Salinas" },
    { code: "MX.24.026", name: "San Antonio" },
    { code: "MX.24.027", name: "San Ciro de Acosta" },
    { code: "MX.24.028", name: "San Luis Potosí" },
    { code: "MX.24.029", name: "San Martín Chalchicuautla" },
    { code: "MX.24.030", name: "San Nicolás Tolentino" },
    { code: "MX.24.031", name: "Santa Catarina" },
    { code: "MX.24.032", name: "Santa María del Río" },
    { code: "MX.24.033", name: "Santo Domingo" },
    { code: "MX.24.034", name: "San Vicente Tancuayalab" },
    { code: "MX.24.035", name: "Soledad de Graciano Sánchez" },
    { code: "MX.24.036", name: "Tamasopo" },
    { code: "MX.24.037", name: "Tamazunchale" },
    { code: "MX.24.038", name: "Tampacán" },
    { code: "MX.24.039", name: "Tampamolón Corona" },
    { code: "MX.24.040", name: "Tamuín" },
    { code: "MX.24.041", name: "Tanlajás" },
    { code: "MX.24.042", name: "Tanquián de Escobedo" },
    { code: "MX.24.043", name: "Tierra Nueva" },
    { code: "MX.24.044", name: "Vanegas" },
    { code: "MX.24.045", name: "Venado" },
    { code: "MX.24.046", name: "Villa de Arriaga" },
    { code: "MX.24.047", name: "Villa de Guadalupe" },
    { code: "MX.24.048", name: "Villa de la Paz" },
    { code: "MX.24.049", name: "Villa de Ramos" },
    { code: "MX.24.050", name: "Villa de Reyes" },
    { code: "MX.24.051", name: "Villa Hidalgo" },
    { code: "MX.24.052", name: "Villa Juárez" },
    { code: "MX.24.053", name: "Axtla de Terrazas" },
    { code: "MX.24.054", name: "Xilitla" },
    { code: "MX.24.055", name: "Zaragoza" },
    { code: "MX.24.056", name: "Villa de Arista" },
    { code: "MX.24.057", name: "Matlapa" },
    { code: "MX.24.058", name: "El Naranjo" },
  ],
  "MX.25": [
    { code: "MX.25.001", name: "Ahome" },
    { code: "MX.25.002", name: "Angostura" },
    { code: "MX.25.003", name: "Badiraguato" },
    { code: "MX.25.004", name: "Concordia" },
    { code: "MX.25.005", name: "Cosalá" },
    { code: "MX.25.006", name: "Culiacán" },
    { code: "MX.25.007", name: "Choix" },
    { code: "MX.25.008", name: "Elota" },
    { code: "MX.25.009", name: "Escuinapa" },
    { code: "MX.25.010", name: "El Fuerte" },
    { code: "MX.25.011", name: "Guasave" },
    { code: "MX.25.012", name: "Mazatlán" },
    { code: "MX.25.013", name: "Mocorito" },
    { code: "MX.25.014", name: "Rosario" },
    { code: "MX.25.015", name: "Salvador Alvarado" },
    { code: "MX.25.016", name: "San Ignacio" },
    { code: "MX.25.017", name: "Sinaloa" },
    { code: "MX.25.018", name: "Navolato" },
  ],
  "MX.26": [
    { code: "MX.26.001", name: "Aconchi" },
    { code: "MX.26.002", name: "Agua Prieta Municipality" },
    { code: "MX.26.003", name: "Alamos" },
    { code: "MX.26.004", name: "Altar" },
    { code: "MX.26.005", name: "Arivechi" },
    { code: "MX.26.006", name: "Arizpe" },
    { code: "MX.26.007", name: "Atil" },
    { code: "MX.26.008", name: "Bacadéhuachi" },
    { code: "MX.26.009", name: "Bacanora" },
    { code: "MX.26.010", name: "Bacerac" },
    { code: "MX.26.011", name: "Bacoachi" },
    { code: "MX.26.012", name: "Bácum" },
    { code: "MX.26.013", name: "Banámichi" },
    { code: "MX.26.014", name: "Baviácora" },
    { code: "MX.26.015", name: "Bavispe" },
    { code: "MX.26.016", name: "Benjamín Hill" },
    { code: "MX.26.017", name: "Caborca" },
    { code: "MX.26.018", name: "Cajeme" },
    { code: "MX.26.019", name: "Cananea" },
    { code: "MX.26.020", name: "Carbó" },
    { code: "MX.26.021", name: "La Colorada" },
    { code: "MX.26.022", name: "Cucurpe" },
    { code: "MX.26.023", name: "Cumpas" },
    { code: "MX.26.024", name: "Divisaderos" },
    { code: "MX.26.025", name: "Empalme" },
    { code: "MX.26.026", name: "Etchojoa" },
    { code: "MX.26.027", name: "Fronteras" },
    { code: "MX.26.028", name: "Granados" },
    { code: "MX.26.029", name: "Guaymas" },
    { code: "MX.26.030", name: "Hermosillo" },
    { code: "MX.26.031", name: "Huachinera" },
    { code: "MX.26.032", name: "Huásabas" },
    { code: "MX.26.033", name: "Huatabampo" },
    { code: "MX.26.034", name: "Huépac" },
    { code: "MX.26.035", name: "Imuris" },
    { code: "MX.26.036", name: "Magdalena" },
    { code: "MX.26.037", name: "Mazatán" },
    { code: "MX.26.038", name: "Moctezuma" },
    { code: "MX.26.039", name: "Naco" },
    { code: "MX.26.040", name: "Nácori Chico" },
    { code: "MX.26.041", name: "Nacozari de García" },
    { code: "MX.26.042", name: "Navojoa" },
    { code: "MX.26.043", name: "Nogales" },
    { code: "MX.26.044", name: "Onavas" },
    { code: "MX.26.045", name: "Opodepe" },
    { code: "MX.26.046", name: "Oquitoa" },
    { code: "MX.26.047", name: "Pitiquito" },
    { code: "MX.26.048", name: "Puerto Peñasco" },
    { code: "MX.26.049", name: "Quiriego" },
    { code: "MX.26.050", name: "Rayón" },
    { code: "MX.26.051", name: "Rosario" },
    { code: "MX.26.052", name: "Sahuaripa" },
    { code: "MX.26.053", name: "San Felipe de Jesús" },
    { code: "MX.26.054", name: "San Javier" },
    { code: "MX.26.055", name: "San Luis Río Colorado" },
    { code: "MX.26.056", name: "San Miguel de Horcasitas" },
    { code: "MX.26.057", name: "San Pedro de la Cueva" },
    { code: "MX.26.058", name: "Santa Ana" },
    { code: "MX.26.059", name: "Santa Cruz" },
    { code: "MX.26.060", name: "Sáric" },
    { code: "MX.26.061", name: "Soyopa" },
    { code: "MX.26.062", name: "Suaqui Grande" },
    { code: "MX.26.063", name: "Tepache" },
    { code: "MX.26.064", name: "Trincheras" },
    { code: "MX.26.065", name: "Tubutama" },
    { code: "MX.26.066", name: "Ures" },
    { code: "MX.26.067", name: "Villa Hidalgo" },
    { code: "MX.26.068", name: "Villa Pesqueira" },
    { code: "MX.26.069", name: "Yécora" },
    { code: "MX.26.070", name: "General Plutarco Elías Calles" },
    { code: "MX.26.071", name: "Benito Juárez" },
    { code: "MX.26.072", name: "San Ignacio Río Muerto" },
  ],
  "MX.27": [
    { code: "MX.27.001", name: "Balancán" },
    { code: "MX.27.002", name: "Cárdenas" },
    { code: "MX.27.003", name: "Centla" },
    { code: "MX.27.004", name: "Centro" },
    { code: "MX.27.005", name: "Comalcalco" },
    { code: "MX.27.006", name: "Cunduacán" },
    { code: "MX.27.007", name: "Emiliano Zapata" },
    { code: "MX.27.008", name: "Huimanguillo" },
    { code: "MX.27.009", name: "Jalapa" },
    { code: "MX.27.010", name: "Jalpa de Méndez" },
    { code: "MX.27.011", name: "Jonuta" },
    { code: "MX.27.012", name: "Macuspana" },
    { code: "MX.27.013", name: "Nacajuca" },
    { code: "MX.27.014", name: "Paraíso" },
    { code: "MX.27.015", name: "Tacotalpa" },
    { code: "MX.27.016", name: "Teapa" },
    { code: "MX.27.017", name: "Tenosique" },
  ],
  "MX.28": [
    { code: "MX.28.001", name: "Abasolo" },
    { code: "MX.28.002", name: "Aldama" },
    { code: "MX.28.003", name: "Altamira" },
    { code: "MX.28.004", name: "Antiguo Morelos" },
    { code: "MX.28.005", name: "Burgos" },
    { code: "MX.28.006", name: "Bustamante" },
    { code: "MX.28.007", name: "Camargo" },
    { code: "MX.28.008", name: "Casas" },
    { code: "MX.28.009", name: "Ciudad Madero" },
    { code: "MX.28.010", name: "Cruillas" },
    { code: "MX.28.011", name: "Gómez Farías" },
    { code: "MX.28.012", name: "González" },
    { code: "MX.28.013", name: "Güémez" },
    { code: "MX.28.014", name: "Guerrero" },
    { code: "MX.28.015", name: "Gustavo Díaz Ordaz" },
    { code: "MX.28.016", name: "Hidalgo" },
    { code: "MX.28.017", name: "Jaumave" },
    { code: "MX.28.018", name: "Jiménez" },
    { code: "MX.28.019", name: "Llera" },
    { code: "MX.28.020", name: "Mainero" },
    { code: "MX.28.021", name: "El Mante" },
    { code: "MX.28.022", name: "Matamoros" },
    { code: "MX.28.023", name: "Méndez" },
    { code: "MX.28.024", name: "Mier" },
    { code: "MX.28.025", name: "Miguel Alemán" },
    { code: "MX.28.026", name: "Miquihuana" },
    { code: "MX.28.027", name: "Nuevo Laredo" },
    { code: "MX.28.028", name: "Nuevo Morelos" },
    { code: "MX.28.029", name: "Ocampo" },
    { code: "MX.28.030", name: "Padilla" },
    { code: "MX.28.031", name: "Palmillas" },
    { code: "MX.28.032", name: "Reynosa" },
    { code: "MX.28.033", name: "Río Bravo" },
    { code: "MX.28.034", name: "San Carlos" },
    { code: "MX.28.035", name: "San Fernando" },
    { code: "MX.28.036", name: "San Nicolás" },
    { code: "MX.28.037", name: "Soto la Marina" },
    { code: "MX.28.038", name: "Tampico" },
    { code: "MX.28.039", name: "Tula" },
    { code: "MX.28.040", name: "Valle Hermoso" },
    { code: "MX.28.041", name: "Victoria" },
    { code: "MX.28.042", name: "Villagrán" },
    { code: "MX.28.043", name: "Xicoténcatl" },
  ],
  "MX.29": [
    { code: "MX.29.001", name: "Amaxac de Guerrero" },
    { code: "MX.29.002", name: "Apetatitlán de Antonio Carvajal" },
    { code: "MX.29.003", name: "Atlangatepec" },
    { code: "MX.29.004", name: "Atltzayanca" },
    { code: "MX.29.005", name: "Apizaco" },
    { code: "MX.29.006", name: "Calpulalpan" },
    { code: "MX.29.007", name: "El Carmen Tequexquitla" },
    { code: "MX.29.008", name: "Cuapiaxtla" },
    { code: "MX.29.009", name: "Cuaxomulco" },
    { code: "MX.29.010", name: "Chiautempan" },
    { code: "MX.29.011", name: "Muñoz de Domingo Arenas" },
    { code: "MX.29.012", name: "Españita" },
    { code: "MX.29.013", name: "Huamantla" },
    { code: "MX.29.014", name: "Hueyotlipan" },
    { code: "MX.29.015", name: "Ixtacuixtla de Mariano Matamoros" },
    { code: "MX.29.016", name: "Ixtenco" },
    { code: "MX.29.017", name: "Mazatecochco de José María Morelos" },
    { code: "MX.29.018", name: "Contla de Juan Cuamatzi" },
    { code: "MX.29.019", name: "Tepetitla de Lardizábal" },
    { code: "MX.29.020", name: "Sanctórum de Lázaro Cárdenas" },
    { code: "MX.29.021", name: "Nanacamilpa de Mariano Arista" },
    { code: "MX.29.022", name: "Acuamanala de Miguel Hidalgo" },
    { code: "MX.29.023", name: "Natívitas" },
    { code: "MX.29.024", name: "Panotla" },
    { code: "MX.29.025", name: "San Pablo del Monte" },
    { code: "MX.29.026", name: "Santa Cruz Tlaxcala" },
    { code: "MX.29.027", name: "Tenancingo" },
    { code: "MX.29.028", name: "Teolocholco" },
    { code: "MX.29.029", name: "Tepeyanco" },
    { code: "MX.29.030", name: "Terrenate" },
    { code: "MX.29.031", name: "Tetla de la Solidaridad" },
    { code: "MX.29.032", name: "Tetlatlahuca" },
    { code: "MX.29.033", name: "Tlaxcala" },
    { code: "MX.29.034", name: "Tlaxco" },
    { code: "MX.29.035", name: "Tocatlán" },
    { code: "MX.29.036", name: "Totolac" },
    { code: "MX.29.037", name: "Ziltlaltépec de Trinidad Sánchez Santos" },
    { code: "MX.29.038", name: "Tzompantepec" },
    { code: "MX.29.039", name: "Xaloztoc" },
    { code: "MX.29.040", name: "Xaltocan" },
    { code: "MX.29.041", name: "Papalotla de Xicohténcatl" },
    { code: "MX.29.042", name: "Xicohtzinco" },
    { code: "MX.29.043", name: "Yauhquemehcan" },
    { code: "MX.29.044", name: "Zacatelco" },
    { code: "MX.29.045", name: "Benito Juárez" },
    { code: "MX.29.046", name: "Emiliano Zapata" },
    { code: "MX.29.047", name: "Lázaro Cárdenas" },
    { code: "MX.29.048", name: "La Magdalena Tlaltelulco" },
    { code: "MX.29.049", name: "San Damián Texóloc" },
    { code: "MX.29.050", name: "San Francisco Tetlanohcan" },
    { code: "MX.29.051", name: "San Jerónimo Zacualpan" },
    { code: "MX.29.052", name: "San José Teacalco" },
    { code: "MX.29.053", name: "San Juan Huactzinco" },
    { code: "MX.29.054", name: "San Lorenzo Axocomanitla" },
    { code: "MX.29.055", name: "San Lucas Tecopilco" },
    { code: "MX.29.056", name: "Santa Ana Nopalucan" },
    { code: "MX.29.057", name: "Santa Apolonia Teacalco" },
    { code: "MX.29.058", name: "Santa Catarina Ayometla" },
    { code: "MX.29.059", name: "Santa Cruz Quilehtla" },
    { code: "MX.29.060", name: "Santa Isabel Xiloxoxtla" },
  ],
  "MX.30": [
    { code: "MX.30.001", name: "Acajete" },
    { code: "MX.30.002", name: "Acatlán" },
    { code: "MX.30.003", name: "Acayucan" },
    { code: "MX.30.004", name: "Actopan" },
    { code: "MX.30.005", name: "Acula" },
    { code: "MX.30.006", name: "Acultzingo" },
    { code: "MX.30.007", name: "Camarón de Tejeda" },
    { code: "MX.30.008", name: "Alpatláhuac" },
    { code: "MX.30.009", name: "Alto Lucero de Gutiérrez Barrios" },
    { code: "MX.30.010", name: "Altotonga" },
    { code: "MX.30.011", name: "Alvarado" },
    { code: "MX.30.012", name: "Amatitlán" },
    { code: "MX.30.013", name: "Naranjos Amatlán" },
    { code: "MX.30.014", name: "Amatlán de los Reyes" },
    { code: "MX.30.015", name: "Angel R. Cabada" },
    { code: "MX.30.016", name: "La Antigua" },
    { code: "MX.30.017", name: "Apazapan" },
    { code: "MX.30.018", name: "Aquila" },
    { code: "MX.30.019", name: "Astacinga" },
    { code: "MX.30.020", name: "Atlahuilco" },
    { code: "MX.30.021", name: "Atoyac" },
    { code: "MX.30.022", name: "Atzacan" },
    { code: "MX.30.023", name: "Atzalan" },
    { code: "MX.30.024", name: "Tlaltetela" },
    { code: "MX.30.025", name: "Ayahualulco" },
    { code: "MX.30.026", name: "Banderilla" },
    { code: "MX.30.027", name: "Benito Juárez" },
    { code: "MX.30.028", name: "Boca del Río" },
    { code: "MX.30.029", name: "Calcahualco" },
    { code: "MX.30.030", name: "Camerino Z. Mendoza" },
    { code: "MX.30.031", name: "Carrillo Puerto" },
    { code: "MX.30.032", name: "Catemaco" },
    { code: "MX.30.033", name: "Cazones de Herrera" },
    { code: "MX.30.034", name: "Cerro Azul" },
    { code: "MX.30.035", name: "Citlaltépetl" },
    { code: "MX.30.036", name: "Coacoatzintla" },
    { code: "MX.30.037", name: "Coahuitlán" },
    { code: "MX.30.038", name: "Coatepec" },
    { code: "MX.30.039", name: "Coatzacoalcos" },
    { code: "MX.30.040", name: "Coatzintla" },
    { code: "MX.30.041", name: "Coetzala" },
    { code: "MX.30.042", name: "Colipa" },
    { code: "MX.30.043", name: "Comapa" },
    { code: "MX.30.044", name: "Córdoba" },
    { code: "MX.30.045", name: "Cosamaloapan de Carpio" },
    { code: "MX.30.046", name: "Cosautlán de Carvajal" },
    { code: "MX.30.047", name: "Coscomatepec" },
    { code: "MX.30.048", name: "Cosoleacaque" },
    { code: "MX.30.049", name: "Cotaxtla" },
    { code: "MX.30.050", name: "Coxquihui" },
    { code: "MX.30.051", name: "Coyutla" },
    { code: "MX.30.052", name: "Cuichapa" },
    { code: "MX.30.053", name: "Cuitláhuac" },
    { code: "MX.30.054", name: "Chacaltianguis" },
    { code: "MX.30.055", name: "Chalma" },
    { code: "MX.30.056", name: "Chiconamel" },
    { code: "MX.30.057", name: "Chiconquiaco" },
    { code: "MX.30.058", name: "Chicontepec" },
    { code: "MX.30.059", name: "Chinameca" },
    { code: "MX.30.060", name: "Chinampa de Gorostiza" },
    { code: "MX.30.061", name: "Las Choapas" },
    { code: "MX.30.062", name: "Chocamán" },
    { code: "MX.30.063", name: "Chontla" },
    { code: "MX.30.064", name: "Chumatlán" },
    { code: "MX.30.065", name: "Emiliano Zapata" },
    { code: "MX.30.066", name: "Espinal" },
    { code: "MX.30.067", name: "Filomeno Mata" },
    { code: "MX.30.068", name: "Fortín" },
    { code: "MX.30.069", name: "Gutiérrez Zamora" },
    { code: "MX.30.070", name: "Hidalgotitlán" },
    { code: "MX.30.071", name: "Huatusco" },
    { code: "MX.30.072", name: "Huayacocotla" },
    { code: "MX.30.073", name: "Hueyapan de Ocampo" },
    { code: "MX.30.074", name: "Huiloapan de Cuauhtémoc" },
    { code: "MX.30.075", name: "Ignacio de la Llave" },
    { code: "MX.30.076", name: "Ilamatlán" },
    { code: "MX.30.077", name: "Isla" },
    { code: "MX.30.078", name: "Ixcatepec" },
    { code: "MX.30.079", name: "Ixhuacán de los Reyes" },
    { code: "MX.30.080", name: "Ixhuatlán del Café" },
    { code: "MX.30.081", name: "Ixhuatlancillo" },
    { code: "MX.30.082", name: "Ixhuatlán del Sureste" },
    { code: "MX.30.083", name: "Ixhuatlán de Madero" },
    { code: "MX.30.084", name: "Ixmatlahuacan" },
    { code: "MX.30.085", name: "Ixtaczoquitlán" },
    { code: "MX.30.086", name: "Jalacingo" },
    { code: "MX.30.087", name: "Xalapa" },
    { code: "MX.30.088", name: "Jalcomulco" },
    { code: "MX.30.089", name: "Jáltipan" },
    { code: "MX.30.090", name: "Jamapa" },
    { code: "MX.30.091", name: "Jesús Carranza" },
    { code: "MX.30.092", name: "Xico" },
    { code: "MX.30.093", name: "Jilotepec" },
    { code: "MX.30.094", name: "Juan Rodríguez Clara" },
    { code: "MX.30.095", name: "Juchique de Ferrer" },
    { code: "MX.30.096", name: "Landero y Coss" },
    { code: "MX.30.097", name: "Lerdo de Tejada" },
    { code: "MX.30.098", name: "Magdalena" },
    { code: "MX.30.099", name: "Maltrata" },
    { code: "MX.30.100", name: "Manlio Fabio Altamirano" },
    { code: "MX.30.101", name: "Mariano Escobedo" },
    { code: "MX.30.102", name: "Martínez de la Torre" },
    { code: "MX.30.103", name: "Mecatlán" },
    { code: "MX.30.104", name: "Mecayapan" },
    { code: "MX.30.105", name: "Medellín" },
    { code: "MX.30.106", name: "Miahuatlán" },
    { code: "MX.30.107", name: "Las Minas" },
    { code: "MX.30.108", name: "Minatitlán" },
    { code: "MX.30.109", name: "Misantla" },
    { code: "MX.30.110", name: "Mixtla de Altamirano" },
    { code: "MX.30.111", name: "Moloacán" },
    { code: "MX.30.112", name: "Naolinco" },
    { code: "MX.30.113", name: "Naranjal" },
    { code: "MX.30.114", name: "Nautla" },
    { code: "MX.30.115", name: "Nogales" },
    { code: "MX.30.116", name: "Oluta" },
    { code: "MX.30.117", name: "Omealca" },
    { code: "MX.30.118", name: "Orizaba" },
    { code: "MX.30.119", name: "Otatitlán" },
    { code: "MX.30.120", name: "Oteapan" },
    { code: "MX.30.121", name: "Ozuluama de Mascareñas" },
    { code: "MX.30.122", name: "Pajapan" },
    { code: "MX.30.123", name: "Pánuco" },
    { code: "MX.30.124", name: "Papantla" },
    { code: "MX.30.125", name: "Paso del Macho" },
    { code: "MX.30.126", name: "Paso de Ovejas" },
    { code: "MX.30.127", name: "La Perla" },
    { code: "MX.30.128", name: "Perote" },
    { code: "MX.30.129", name: "Platón Sánchez" },
    { code: "MX.30.130", name: "Playa Vicente" },
    { code: "MX.30.131", name: "Poza Rica de Hidalgo" },
    { code: "MX.30.132", name: "Las Vigas de Ramírez" },
    { code: "MX.30.133", name: "Pueblo Viejo" },
    { code: "MX.30.134", name: "Puente Nacional" },
    { code: "MX.30.135", name: "Rafael Delgado" },
    { code: "MX.30.136", name: "Rafael Lucio" },
    { code: "MX.30.137", name: "Los Reyes" },
    { code: "MX.30.138", name: "Río Blanco" },
    { code: "MX.30.139", name: "Saltabarranca" },
    { code: "MX.30.140", name: "San Andrés Tenejapan" },
    { code: "MX.30.141", name: "San Andrés Tuxtla" },
    { code: "MX.30.142", name: "San Juan Evangelista" },
    { code: "MX.30.143", name: "Santiago Tuxtla" },
    { code: "MX.30.144", name: "Sayula de Alemán" },
    { code: "MX.30.145", name: "Soconusco" },
    { code: "MX.30.146", name: "Sochiapa" },
    { code: "MX.30.147", name: "Soledad Atzompa" },
    { code: "MX.30.148", name: "Soledad de Doblado" },
    { code: "MX.30.149", name: "Soteapan" },
    { code: "MX.30.150", name: "Tamalín" },
    { code: "MX.30.151", name: "Tamiahua" },
    { code: "MX.30.152", name: "Tampico Alto" },
    { code: "MX.30.153", name: "Tancoco" },
    { code: "MX.30.154", name: "Tantima" },
    { code: "MX.30.155", name: "Tantoyuca" },
    { code: "MX.30.156", name: "Tatatila" },
    { code: "MX.30.157", name: "Castillo de Teayo" },
    { code: "MX.30.158", name: "Tecolutla" },
    { code: "MX.30.159", name: "Tehuipango" },
    { code: "MX.30.160", name: "Álamo Temapache" },
    { code: "MX.30.161", name: "Tempoal" },
    { code: "MX.30.162", name: "Tenampa" },
    { code: "MX.30.163", name: "Tenochtitlán" },
    { code: "MX.30.164", name: "Teocelo" },
    { code: "MX.30.165", name: "Tepatlaxco" },
    { code: "MX.30.166", name: "Tepetlán" },
    { code: "MX.30.167", name: "Tepetzintla" },
    { code: "MX.30.168", name: "Tequila" },
    { code: "MX.30.169", name: "José Azueta" },
    { code: "MX.30.170", name: "Texcatepec" },
    { code: "MX.30.171", name: "Texhuacán" },
    { code: "MX.30.172", name: "Texistepec" },
    { code: "MX.30.173", name: "Tezonapa" },
    { code: "MX.30.174", name: "Tierra Blanca" },
    { code: "MX.30.175", name: "Tihuatlán" },
    { code: "MX.30.176", name: "Tlacojalpan" },
    { code: "MX.30.177", name: "Tlacolulan" },
    { code: "MX.30.178", name: "Tlacotalpan" },
    { code: "MX.30.179", name: "Tlacotepec de Mejía" },
    { code: "MX.30.180", name: "Tlachichilco" },
    { code: "MX.30.181", name: "Tlalixcoyan" },
    { code: "MX.30.182", name: "Tlalnelhuayocan" },
    { code: "MX.30.183", name: "Tlapacoyan" },
    { code: "MX.30.184", name: "Tlaquilpa" },
    { code: "MX.30.185", name: "Tlilapan" },
    { code: "MX.30.186", name: "Tomatlán" },
    { code: "MX.30.187", name: "Tonayán" },
    { code: "MX.30.188", name: "Totutla" },
    { code: "MX.30.189", name: "Tuxpan" },
    { code: "MX.30.190", name: "Tuxtilla" },
    { code: "MX.30.191", name: "Ursulo Galván" },
    { code: "MX.30.192", name: "Vega de Alatorre" },
    { code: "MX.30.193", name: "Veracruz" },
    { code: "MX.30.194", name: "Villa Aldama" },
    { code: "MX.30.195", name: "Xoxocotla" },
    { code: "MX.30.196", name: "Yanga" },
    { code: "MX.30.197", name: "Yecuatla" },
    { code: "MX.30.198", name: "Zacualpan" },
    { code: "MX.30.199", name: "Zaragoza" },
    { code: "MX.30.200", name: "Zentla" },
    { code: "MX.30.201", name: "Zongolica" },
    { code: "MX.30.202", name: "Zontecomatlán de López y Fuentes" },
    { code: "MX.30.203", name: "Zozocolco de Hidalgo" },
    { code: "MX.30.204", name: "Agua Dulce" },
    { code: "MX.30.205", name: "El Higo" },
    { code: "MX.30.206", name: "Nanchital de Lázaro Cárdenas del Río" },
    { code: "MX.30.207", name: "Tres Valles" },
    { code: "MX.30.208", name: "Carlos A. Carrillo" },
    { code: "MX.30.209", name: "Tatahuicapan de Juárez" },
    { code: "MX.30.210", name: "Uxpanapa" },
    { code: "MX.30.211", name: "San Rafael" },
    { code: "MX.30.212", name: "Santiago Sochiapan" },
  ],
  "MX.31": [
    { code: "MX.31.001", name: "Abalá" },
    { code: "MX.31.002", name: "Acanceh" },
    { code: "MX.31.003", name: "Akil" },
    { code: "MX.31.004", name: "Baca" },
    { code: "MX.31.005", name: "Bokobá" },
    { code: "MX.31.006", name: "Buctzotz" },
    { code: "MX.31.007", name: "Cacalchén" },
    { code: "MX.31.008", name: "Calotmul" },
    { code: "MX.31.009", name: "Cansahcab" },
    { code: "MX.31.010", name: "Cantamayec" },
    { code: "MX.31.011", name: "Celestún" },
    { code: "MX.31.012", name: "Cenotillo" },
    { code: "MX.31.013", name: "Conkal" },
    { code: "MX.31.014", name: "Cuncunul" },
    { code: "MX.31.015", name: "Cuzamá" },
    { code: "MX.31.016", name: "Chacsinkín" },
    { code: "MX.31.017", name: "Chankom" },
    { code: "MX.31.018", name: "Chapab" },
    { code: "MX.31.019", name: "Chemax" },
    { code: "MX.31.020", name: "Chicxulub Pueblo" },
    { code: "MX.31.021", name: "Chichimilá" },
    { code: "MX.31.022", name: "Chikindzonot" },
    { code: "MX.31.023", name: "Chocholá" },
    { code: "MX.31.024", name: "Chumayel" },
    { code: "MX.31.025", name: "Dzán" },
    { code: "MX.31.026", name: "Dzemul" },
    { code: "MX.31.027", name: "Dzidzantún" },
    { code: "MX.31.028", name: "Dzilam de Bravo" },
    { code: "MX.31.029", name: "Dzilam González" },
    { code: "MX.31.030", name: "Dzitás" },
    { code: "MX.31.031", name: "Dzoncauich" },
    { code: "MX.31.032", name: "Espita" },
    { code: "MX.31.033", name: "Halachó" },
    { code: "MX.31.034", name: "Hocabá" },
    { code: "MX.31.035", name: "Hoctún" },
    { code: "MX.31.036", name: "Homún" },
    { code: "MX.31.037", name: "Huhí" },
    { code: "MX.31.038", name: "Hunucmá" },
    { code: "MX.31.039", name: "Ixil" },
    { code: "MX.31.040", name: "Izamal" },
    { code: "MX.31.041", name: "Kanasín" },
    { code: "MX.31.042", name: "Kantunil" },
    { code: "MX.31.043", name: "Kaua" },
    { code: "MX.31.044", name: "Kinchil" },
    { code: "MX.31.045", name: "Kopomá" },
    { code: "MX.31.046", name: "Mama" },
    { code: "MX.31.047", name: "Maní" },
    { code: "MX.31.048", name: "Maxcanú" },
    { code: "MX.31.049", name: "Mayapán" },
    { code: "MX.31.050", name: "Mérida" },
    { code: "MX.31.051", name: "Mocochá" },
    { code: "MX.31.052", name: "Motul" },
    { code: "MX.31.053", name: "Muna" },
    { code: "MX.31.054", name: "Muxupip" },
    { code: "MX.31.055", name: "Opichén" },
    { code: "MX.31.056", name: "Oxkutzcab" },
    { code: "MX.31.057", name: "Panabá" },
    { code: "MX.31.058", name: "Peto" },
    { code: "MX.31.059", name: "Progreso" },
    { code: "MX.31.060", name: "Quintana Roo" },
    { code: "MX.31.061", name: "Río Lagartos" },
    { code: "MX.31.062", name: "Sacalum" },
    { code: "MX.31.063", name: "Samahil" },
    { code: "MX.31.064", name: "Sanahcat" },
    { code: "MX.31.065", name: "San Felipe" },
    { code: "MX.31.066", name: "Santa Elena" },
    { code: "MX.31.067", name: "Seyé" },
    { code: "MX.31.068", name: "Sinanché" },
    { code: "MX.31.069", name: "Sotuta" },
    { code: "MX.31.070", name: "Sucilá" },
    { code: "MX.31.071", name: "Sudzal" },
    { code: "MX.31.072", name: "Suma" },
    { code: "MX.31.073", name: "Tahdziú" },
    { code: "MX.31.074", name: "Tahmek" },
    { code: "MX.31.075", name: "Teabo" },
    { code: "MX.31.076", name: "Tecoh" },
    { code: "MX.31.077", name: "Tekal de Venegas" },
    { code: "MX.31.078", name: "Tekantó" },
    { code: "MX.31.079", name: "Tekax" },
    { code: "MX.31.080", name: "Tekit" },
    { code: "MX.31.081", name: "Tekom" },
    { code: "MX.31.082", name: "Telchac Pueblo" },
    { code: "MX.31.083", name: "Telchac Puerto" },
    { code: "MX.31.084", name: "Temax" },
    { code: "MX.31.085", name: "Temozón" },
    { code: "MX.31.086", name: "Tepakán" },
    { code: "MX.31.087", name: "Tetiz" },
    { code: "MX.31.088", name: "Teya" },
    { code: "MX.31.089", name: "Ticul" },
    { code: "MX.31.090", name: "Timucuy" },
    { code: "MX.31.091", name: "Tinum" },
    { code: "MX.31.092", name: "Tixcacalcupul" },
    { code: "MX.31.093", name: "Tixkokob" },
    { code: "MX.31.094", name: "Tixmehuac" },
    { code: "MX.31.095", name: "Tixpéhual" },
    { code: "MX.31.096", name: "Tizimín" },
    { code: "MX.31.097", name: "Tunkás" },
    { code: "MX.31.098", name: "Tzucacab" },
    { code: "MX.31.099", name: "Uayma" },
    { code: "MX.31.100", name: "Ucú" },
    { code: "MX.31.101", name: "Umán" },
    { code: "MX.31.102", name: "Valladolid" },
    { code: "MX.31.103", name: "Xocchel" },
    { code: "MX.31.104", name: "Yaxcabá" },
    { code: "MX.31.105", name: "Yaxkukul" },
    { code: "MX.31.106", name: "Yobaín" },
  ],
  "MX.32": [
    { code: "MX.32.001", name: "Apozol" },
    { code: "MX.32.002", name: "Apulco" },
    { code: "MX.32.003", name: "Atolinga" },
    { code: "MX.32.004", name: "Benito Juárez" },
    { code: "MX.32.005", name: "Calera" },
    { code: "MX.32.006", name: "Cañitas de Felipe Pescador" },
    { code: "MX.32.007", name: "Concepción del Oro" },
    { code: "MX.32.008", name: "Cuauhtémoc" },
    { code: "MX.32.009", name: "Chalchihuites" },
    { code: "MX.32.010", name: "Fresnillo" },
    { code: "MX.32.011", name: "Trinidad García de la Cadena" },
    { code: "MX.32.012", name: "Genaro Codina" },
    { code: "MX.32.013", name: "General Enrique Estrada" },
    { code: "MX.32.014", name: "General Francisco R. Murguía" },
    { code: "MX.32.015", name: "El Plateado de Joaquín Amaro" },
    { code: "MX.32.016", name: "General Pánfilo Natera" },
    { code: "MX.32.017", name: "Guadalupe" },
    { code: "MX.32.018", name: "Huanusco" },
    { code: "MX.32.019", name: "Jalpa" },
    { code: "MX.32.020", name: "Jerez" },
    { code: "MX.32.021", name: "Jiménez del Teul" },
    { code: "MX.32.022", name: "Juan Aldama" },
    { code: "MX.32.023", name: "Juchipila" },
    { code: "MX.32.024", name: "Loreto" },
    { code: "MX.32.025", name: "Luis Moya" },
    { code: "MX.32.026", name: "Mazapil" },
    { code: "MX.32.027", name: "Melchor Ocampo" },
    { code: "MX.32.028", name: "Mezquital del Oro" },
    { code: "MX.32.029", name: "Miguel Auza" },
    { code: "MX.32.030", name: "Momax" },
    { code: "MX.32.031", name: "Monte Escobedo" },
    { code: "MX.32.032", name: "Morelos" },
    { code: "MX.32.033", name: "Moyahua de Estrada" },
    { code: "MX.32.034", name: "Nochistlán de Mejía" },
    { code: "MX.32.035", name: "Noria de Ángeles" },
    { code: "MX.32.036", name: "Ojocaliente" },
    { code: "MX.32.037", name: "Pánuco" },
    { code: "MX.32.038", name: "Pinos" },
    { code: "MX.32.039", name: "Río Grande" },
    { code: "MX.32.040", name: "Sain Alto" },
    { code: "MX.32.041", name: "El Salvador" },
    { code: "MX.32.042", name: "Sombrerete" },
    { code: "MX.32.043", name: "Susticacán" },
    { code: "MX.32.044", name: "Tabasco" },
    { code: "MX.32.045", name: "Tepechitlán" },
    { code: "MX.32.046", name: "Tepetongo" },
    { code: "MX.32.047", name: "Teúl de González Ortega" },
    { code: "MX.32.048", name: "Tlaltenango de Sánchez Román" },
    { code: "MX.32.049", name: "Valparaíso" },
    { code: "MX.32.050", name: "Vetagrande" },
    { code: "MX.32.051", name: "Villa de Cos" },
    { code: "MX.32.052", name: "Villa García" },
    { code: "MX.32.053", name: "Villa González Ortega" },
    { code: "MX.32.054", name: "Villa Hidalgo" },
    { code: "MX.32.055", name: "Villanueva" },
    { code: "MX.32.056", name: "Zacatecas" },
    { code: "MX.32.057", name: "Trancoso" },
    { code: "MX.32.058", name: "Santa María de la Paz" },
  ],
  "MY.01": [
    { code: "MY.01.1732686", name: "Daerah Batu Pahat" },
    { code: "MY.01.1732707", name: "Daerah Pontian" },
    { code: "MY.01.1732737", name: "Daerah Kota Tinggi" },
    { code: "MY.01.1732751", name: "Daerah Johor Baharu" },
    { code: "MY.01.1732810", name: "Daerah Keluang" },
    { code: "MY.01.1732827", name: "Daerah Mersing" },
    { code: "MY.01.1732847", name: "Daerah Segamat" },
    { code: "MY.01.1732868", name: "Daerah Muar" },
    { code: "MY.01.1734905", name: "Daerha Rompin" },
  ],
  "MY.02": [
    { code: "MY.02.1222381", name: "Langkawi" },
    { code: "MY.02.1734392", name: "Kulim" },
    { code: "MY.02.1734406", name: "Bandar Baharu" },
    { code: "MY.02.1734449", name: "Baling" },
    { code: "MY.02.1735487", name: "Yan" },
    { code: "MY.02.1736296", name: "Kubang Pasu" },
    { code: "MY.02.1736333", name: "Padang Terap" },
    { code: "MY.02.1736341", name: "Pendang" },
    { code: "MY.02.1736342", name: "Daerah Kota Setar" },
    { code: "MY.02.6805171", name: "Kuala Muda" },
    { code: "MY.02.6857715", name: "Naga Lilit" },
    { code: "MY.02.6857718", name: "Bagan Sena" },
    { code: "MY.02.6857723", name: "Bakai" },
    { code: "MY.02.6857732", name: "Mahang" },
  ],
  "MY.03": [
    { code: "MY.03.1734461", name: "Tanah Merah" },
    { code: "MY.03.1736375", name: "Kota Bharu" },
    { code: "MY.03.7067991", name: "Jeli" },
    { code: "MY.03.9781089", name: "Kuala Krai" },
  ],
  "MY.06": [
    { code: "MY.06.1732585", name: "Temerluh" },
    { code: "MY.06.1734988", name: "Bera" },
    { code: "MY.06.1735203", name: "Daerah Jerantut" },
    { code: "MY.06.1735261", name: "Cameron Highlands" },
  ],
  "MY.07": [
    { code: "MY.07.1734400", name: "Larut Matang & Selama" },
    { code: "MY.07.1734598", name: "Daerah Kuala Kangsar" },
    { code: "MY.07.1734640", name: "Daerah Kinta" },
  ],
  "MY.09": [
    { code: "MY.09.1735085", name: "Selatan" },
    { code: "MY.09.1735104", name: "Daerah Timur Laut" },
    { code: "MY.09.1735411", name: "Daerah Barat Daya" },
    { code: "MY.09.6823231", name: "Utara" },
    { code: "MY.09.6833194", name: "Barat Daya" },
    { code: "MY.09.8133400", name: "Seberang Perai" },
  ],
  "MY.11": [
    { code: "MY.11.1734504", name: "Bahagian Kuching" },
    { code: "MY.11.1735861", name: "Bahagian Sarikei" },
    { code: "MY.11.1736901", name: "Bahagian Sri Aman" },
    { code: "MY.11.1736980", name: "Bahagian Sibu" },
    { code: "MY.11.1737785", name: "Bahagian Limbang" },
    { code: "MY.11.1737860", name: "Bahagian Kapit" },
    { code: "MY.11.1738079", name: "Bahagian Miri" },
    { code: "MY.11.1966740", name: "Bahagian Bintulu" },
    { code: "MY.11.1966741", name: "Bahagian Samarahan" },
  ],
  "MY.12": [
    { code: "MY.12.1732890", name: "Kuala Selangor" },
    { code: "MY.12.1732904", name: "Klang" },
    { code: "MY.12.1734782", name: "Kuala Langat" },
    { code: "MY.12.1734789", name: "Sepang" },
    { code: "MY.12.1735136", name: "Gombak" },
    { code: "MY.12.1735145", name: "Hulu Selangor" },
    { code: "MY.12.1735156", name: "Petaling" },
    { code: "MY.12.1735173", name: "Hulu Langat" },
    { code: "MY.12.1735194", name: "Sabak Bernam" },
  ],
  "MY.13": [
    { code: "MY.13.9781175", name: "Daerah Setiu" },
    { code: "MY.13.9781176", name: "Daerah Besut" },
  ],
  "MY.16": [
    { code: "MY.16.1732562", name: "Bahagian Pantai Barat" },
    { code: "MY.16.1733564", name: "Bahagian Sandakan" },
    { code: "MY.16.1733595", name: "Bahagian Tawau" },
    { code: "MY.16.1734148", name: "Bahagian Pedalaman" },
    { code: "MY.16.1736645", name: "Bahagian Pantai Barat" },
    { code: "MY.16.1966738", name: "Bahagian Kudat" },
  ],
  "MZ.01": [
    { code: "MZ.01.1028315", name: "Circunscrição da Quissanga" },
    { code: "MZ.01.1029247", name: "Circunscrição de Palma" },
    { code: "MZ.01.1037368", name: "Mocimboa da Praia" },
    { code: "MZ.01.1039148", name: "Mecufi" },
    { code: "MZ.01.1042455", name: "Circunscrição de Macomia" },
    { code: "MZ.01.1045383", name: "Concelho do Ibo" },
    { code: "MZ.01.12041484", name: "Cidade de Pemba" },
    { code: "MZ.01.12041567", name: "Metuge District" },
    { code: "MZ.01.7874119", name: "Balama District" },
    { code: "MZ.01.7909845", name: "Mueda District" },
    { code: "MZ.01.7909876", name: "Ancuabe District" },
    { code: "MZ.01.7911292", name: "Namuno District" },
    { code: "MZ.01.8299277", name: "Montepuez District" },
    { code: "MZ.01.9252727", name: "Meluco" },
    { code: "MZ.01.9252729", name: "Chiure" },
    { code: "MZ.01.9252735", name: "Muidumbe" },
    { code: "MZ.01.9252736", name: "Nangade" },
  ],
  "MZ.02": [
    { code: "MZ.02.1040936", name: "Mandlakaze" },
    { code: "MZ.02.1049858", name: "Distrito de Chibuto" },
    { code: "MZ.02.10668849", name: "Cidade de Xai-Xai" },
    { code: "MZ.02.7670759", name: "Chicualacuala" },
    { code: "MZ.02.7670767", name: "Massingir" },
    { code: "MZ.02.7670771", name: "Massangena" },
    { code: "MZ.02.7670772", name: "Chigubo" },
    { code: "MZ.02.7670774", name: "Mabalane" },
    { code: "MZ.02.7874104", name: "Chokwe District" },
    { code: "MZ.02.9072735", name: "Bilene Macia District" },
    { code: "MZ.02.9252728", name: "Guija" },
    { code: "MZ.02.9408663", name: "Xai-Xai District" },
  ],
  "MZ.03": [
    { code: "MZ.03.1045762", name: "Circunscrição do Govuro" },
    { code: "MZ.03.7670754", name: "Vilankulos District" },
    { code: "MZ.03.7670768", name: "Mabote" },
    { code: "MZ.03.7909714", name: "Zavala District" },
    { code: "MZ.03.7909715", name: "Massinga District" },
    { code: "MZ.03.7909780", name: "Funhalouro District" },
    { code: "MZ.03.7909781", name: "Inhassoro District" },
    { code: "MZ.03.7909783", name: "Inharrime District" },
    { code: "MZ.03.7909784", name: "Jangamo District" },
    { code: "MZ.03.7909785", name: "Homoine District" },
    { code: "MZ.03.7909786", name: "Morrumbene District" },
    { code: "MZ.03.9252722", name: "Maxixe" },
    { code: "MZ.03.9252733", name: "Cidade de Inhambane" },
    { code: "MZ.03.9252738", name: "Panda" },
  ],
  "MZ.04": [
    { code: "MZ.04.1039852", name: "Concelho de Matola" },
    { code: "MZ.04.1090080", name: "Manhica" },
    { code: "MZ.04.12041485", name: "Cidade de Manhiça" },
    { code: "MZ.04.7670756", name: "Matutiune District" },
    { code: "MZ.04.7701205", name: "Aeroporto" },
    { code: "MZ.04.7873976", name: "Magude District" },
    { code: "MZ.04.7873980", name: "Moamba District" },
    { code: "MZ.04.7873983", name: "Boane District" },
    { code: "MZ.04.8301113", name: "Namaacha District" },
    { code: "MZ.04.8693192", name: "Marracuene District" },
  ],
  "MZ.05": [
    { code: "MZ.05.1040396", name: "Circunscrição de Marromeu" },
    { code: "MZ.05.1045789", name: "Gorongosa District" },
    { code: "MZ.05.1051852", name: "Concelho do Búzi" },
    { code: "MZ.05.1052372", name: "Concelho da Beira" },
    { code: "MZ.05.7873984", name: "Nhamatanda District" },
    { code: "MZ.05.7873985", name: "Chibabava District" },
    { code: "MZ.05.7873986", name: "Dondo District" },
    { code: "MZ.05.7874046", name: "Caia District" },
    { code: "MZ.05.7874471", name: "Chemba District" },
    { code: "MZ.05.7874472", name: "Muanza District" },
    { code: "MZ.05.7874473", name: "Maringué District" },
    { code: "MZ.05.7874474", name: "Machanga District" },
    { code: "MZ.05.7874614", name: "Cheringoma District" },
  ],
  "MZ.06": [
    { code: "MZ.06.1033355", name: "Distrito de Rapale" },
    { code: "MZ.06.1035018", name: "Nacala-a-Velha" },
    { code: "MZ.06.1035470", name: "Circunscrição de Murrupula" },
    { code: "MZ.06.1037020", name: "Mossuril" },
    { code: "MZ.06.1037178", name: "Concelho de Monapo" },
    { code: "MZ.06.1037222", name: "Distrito de Moma" },
    { code: "MZ.06.1037282", name: "Circunscrìção de Mogovolas" },
    { code: "MZ.06.1037286", name: "Circunscrìção do Mogincual" },
    { code: "MZ.06.1038879", name: "Memba" },
    { code: "MZ.06.1039205", name: "Meconta" },
    { code: "MZ.06.1046627", name: "Circunscrição do Eráti" },
    { code: "MZ.06.10703926", name: "Distrito de Larde" },
    { code: "MZ.06.10703927", name: "Distrito de Liúpo" },
    { code: "MZ.06.7732034", name: "Malema" },
    { code: "MZ.06.7732035", name: "Ribaue" },
    { code: "MZ.06.7732036", name: "Nampula" },
    { code: "MZ.06.7732037", name: "Mecuburi" },
    { code: "MZ.06.7732038", name: "Cidade de Nampula" },
    { code: "MZ.06.7874406", name: "Angoche District" },
    { code: "MZ.06.7874408", name: "Lalaua District" },
    { code: "MZ.06.7874410", name: "Muecate District" },
    { code: "MZ.06.7874411", name: "Nacaroa District" },
    { code: "MZ.06.9072697", name: "Nacala-Porto" },
    { code: "MZ.06.9252730", name: "Ilha de Mocambique" },
  ],
  "MZ.07": [
    { code: "MZ.07.1027397", name: "Circunscrição de Sanga" },
    { code: "MZ.07.1039135", name: "Mecula" },
    { code: "MZ.07.1041189", name: "Circunscrição de Mandimba" },
    { code: "MZ.07.10651614", name: "Cidade de Lichinga" },
    { code: "MZ.07.7732033", name: "Cuamba" },
    { code: "MZ.07.7874115", name: "Lichinga District" },
    { code: "MZ.07.7874117", name: "Majune District" },
    { code: "MZ.07.7874414", name: "Lago District" },
    { code: "MZ.07.7874416", name: "Maúa District" },
    { code: "MZ.07.7874417", name: "Mecanhelas District" },
    { code: "MZ.07.7874418", name: "Metarica District" },
    { code: "MZ.07.7874419", name: "Muembe District" },
    { code: "MZ.07.7874420", name: "Ngauma District" },
    { code: "MZ.07.7874421", name: "Nipepe District" },
    { code: "MZ.07.8299276", name: "Marrupa District" },
    { code: "MZ.07.9252721", name: "Mavago" },
  ],
  "MZ.08": [
    { code: "MZ.08.1035304", name: "Circunscrição da Mutarara" },
    { code: "MZ.08.1037394", name: "Moatize" },
    { code: "MZ.08.1040587", name: "Circunscrição de Marávia" },
    { code: "MZ.08.1041912", name: "Circunscrição de Màgoé" },
    { code: "MZ.08.1042871", name: "Circunscrição da Macanga" },
    { code: "MZ.08.1052937", name: "Circunscrição da Angónia" },
    { code: "MZ.08.10703925", name: "Distrito de Dôa" },
    { code: "MZ.08.10704473", name: "Distrito de Marara" },
    { code: "MZ.08.11204389", name: "Angónia District" },
    { code: "MZ.08.7874106", name: "Tsangano District" },
    { code: "MZ.08.7905000", name: "Changara District" },
    { code: "MZ.08.7905199", name: "Chifunde District" },
    { code: "MZ.08.7905529", name: "Chiuta District" },
    { code: "MZ.08.7909828", name: "Cahora Bassa District" },
    { code: "MZ.08.9252731", name: "Cidade de Tete" },
    { code: "MZ.08.9252732", name: "Luenha" },
    { code: "MZ.08.9252739", name: "Zumbu" },
  ],
  "MZ.09": [
    { code: "MZ.09.1028433", name: "Concelho de Quelimane" },
    { code: "MZ.09.1037109", name: "Circunscrição de Mopeia" },
    { code: "MZ.09.1045351", name: "Circunscrição do Ile" },
    { code: "MZ.09.1049181", name: "Concelho do Chinde" },
    { code: "MZ.09.1053142", name: "Alto Molócuè" },
    { code: "MZ.09.10701342", name: "Distrito de Mulevala" },
    { code: "MZ.09.10701343", name: "Distrito de Mocubela" },
    { code: "MZ.09.10701344", name: "Distrito de Derre" },
    { code: "MZ.09.10702916", name: "Distrito de Molumbo" },
    { code: "MZ.09.10703116", name: "Distrito de Luabo" },
    { code: "MZ.09.11189152", name: "Mopeia District" },
    { code: "MZ.09.7873988", name: "Nicodala District" },
    { code: "MZ.09.7873991", name: "Gurue District" },
    { code: "MZ.09.7873993", name: "Morrumbala District" },
    { code: "MZ.09.7874708", name: "Gilé District" },
    { code: "MZ.09.7874710", name: "Lugela District" },
    { code: "MZ.09.7874711", name: "Maganja da Costa District" },
    { code: "MZ.09.7874712", name: "Milange District" },
    { code: "MZ.09.7874724", name: "Namarroi District" },
    { code: "MZ.09.7874726", name: "Pebane District" },
    { code: "MZ.09.7880951", name: "Mocuba District" },
    { code: "MZ.09.7909704", name: "Inhassunge District" },
    { code: "MZ.09.8714615", name: "Namacurra District" },
  ],
  "MZ.10": [
    { code: "MZ.10.1035732", name: "Guro" },
    { code: "MZ.10.1037018", name: "Circunscrição de Mossurize" },
    { code: "MZ.10.1040948", name: "Concelho de Manica" },
    { code: "MZ.10.1049260", name: "Concelho do Chimoio" },
    { code: "MZ.10.1052446", name: "Barue District" },
    { code: "MZ.10.10701340", name: "Distrito de Vanduzi" },
    { code: "MZ.10.10701341", name: "Distrito de Macate" },
    { code: "MZ.10.7646374", name: "Gondola District" },
    { code: "MZ.10.7670758", name: "Sussundenga District" },
    { code: "MZ.10.7874045", name: "Guro District" },
    { code: "MZ.10.7874620", name: "Machaze District" },
    { code: "MZ.10.7874622", name: "Macossa District" },
    { code: "MZ.10.7874624", name: "Tambara District" },
  ],
  "MZ.11": [
    { code: "MZ.11.10683815", name: "KaMubukwana" },
    { code: "MZ.11.10685827", name: "KaMavota" },
    { code: "MZ.11.10685828", name: "Nhlamankulo" },
    { code: "MZ.11.10685829", name: "KaMaxakeni" },
    { code: "MZ.11.10685830", name: "KaMpfumo" },
    { code: "MZ.11.10685831", name: "KaTembe" },
    { code: "MZ.11.10685832", name: "KaNyaka" },
  ],
  "NA.21": [
    { code: "NA.21.11125897", name: "Moses Garoeb" },
    { code: "NA.21.11257205", name: "Samora Machel" },
    { code: "NA.21.11287032", name: "Windhoek Rural" },
    { code: "NA.21.11609877", name: "Windhoek East" },
  ],
  "NA.28": [
    { code: "NA.28.11467713", name: "Linyanti" },
  ],
  "NA.29": [
    { code: "NA.29.7931905", name: "Daures Constituency" },
    { code: "NA.29.7931906", name: "Arandis Constituency" },
    { code: "NA.29.7931907", name: "Swakopmund Constituency" },
    { code: "NA.29.7931908", name: "Walvis Bay Urban Constituency" },
    { code: "NA.29.7931909", name: "Walvis Bay Rural Constituency" },
  ],
  "NA.30": [
    { code: "NA.30.11257257", name: "Rehoboth Rural" },
    { code: "NA.30.11427240", name: "Mariental Rural" },
    { code: "NA.30.7931910", name: "Gibeon Constituency" },
  ],
  "NA.31": [
    { code: "NA.31.11257293", name: "Karasburg Constituency" },
    { code: "NA.31.7931911", name: "Luderitz Constituency" },
    { code: "NA.31.7931912", name: "Oranjemund Constituency" },
  ],
  "NA.32": [
    { code: "NA.32.7931901", name: "Epupa Constituency" },
    { code: "NA.32.7931902", name: "Opuwo Constituency" },
    { code: "NA.32.7931903", name: "Sesfontein Constituency" },
    { code: "NA.32.7931904", name: "Khorixas Constituency" },
  ],
  "NA.33": [
    { code: "NA.33.11205493", name: "Epembe Constituency" },
    { code: "NA.33.11205499", name: "Endola" },
    { code: "NA.33.11238950", name: "Oshikango" },
    { code: "NA.33.11428769", name: "Omuthiyagwiipundi" },
  ],
  "NA.35": [
    { code: "NA.35.11204872", name: "Otjombinde" },
  ],
  "NA.36": [
    { code: "NA.36.11256953", name: "Tsandi" },
    { code: "NA.36.11257223", name: "Etayi" },
    { code: "NA.36.11428097", name: "Oshikuku" },
    { code: "NA.36.11495912", name: "Anamulenge Constituency" },
    { code: "NA.36.11979320", name: "Okahao" },
  ],
  "NA.37": [
    { code: "NA.37.11205500", name: "Oshakati East" },
    { code: "NA.37.11257218", name: "Oshakati West" },
    { code: "NA.37.11428032", name: "Okaku Constituency" },
    { code: "NA.37.11428703", name: "Ongwediva" },
    { code: "NA.37.11467743", name: "Uukwiyu" },
  ],
  "NA.38": [
    { code: "NA.38.11204947", name: "Olukonda Constituency" },
    { code: "NA.38.11205505", name: "Omuntele Constituency" },
    { code: "NA.38.11257350", name: "Eengodi" },
    { code: "NA.38.11467812", name: "Onayena" },
  ],
  "NA.39": [
    { code: "NA.39.10400504", name: "Omatako Constituency" },
    { code: "NA.39.11204952", name: "Okahandja Constituency" },
    { code: "NA.39.11428998", name: "Otavi" },
  ],
  "NA.40": [
    { code: "NA.40.11205595", name: "Rundu Rural West" },
    { code: "NA.40.11256901", name: "Mashare" },
    { code: "NA.40.11429192", name: "Rundu Urban" },
  ],
  "NA.41": [
    { code: "NA.41.11256866", name: "Kapako Constituency" },
    { code: "NA.41.11429079", name: "Mpungu" },
  ],
  "NC.01": [
    { code: "NC.01.98801", name: "Bélep" },
    { code: "NC.01.98804", name: "Canala" },
    { code: "NC.01.98807", name: "Hienghéne" },
    { code: "NC.01.98808", name: "Houaïlou" },
    { code: "NC.01.98810", name: "Kaala-Gomén" },
    { code: "NC.01.98811", name: "Koné" },
    { code: "NC.01.98812", name: "Koumac" },
    { code: "NC.01.98819", name: "Ouégoa" },
    { code: "NC.01.98822", name: "Poindimié" },
    { code: "NC.01.98823", name: "Ponérihouen" },
    { code: "NC.01.98824", name: "Pouébo" },
    { code: "NC.01.98825", name: "Pouembout" },
    { code: "NC.01.98826", name: "Poum" },
    { code: "NC.01.98827", name: "Poya" },
    { code: "NC.01.98830", name: "Touho" },
    { code: "NC.01.98831", name: "Voh" },
    { code: "NC.01.98833", name: "Kouaoua" },
  ],
  "NC.02": [
    { code: "NC.02.98802", name: "Bouloupari" },
    { code: "NC.02.98803", name: "Bourail" },
    { code: "NC.02.98805", name: "Dumbéa" },
    { code: "NC.02.98806", name: "Farino" },
    { code: "NC.02.98809", name: "L’Île des Pins" },
    { code: "NC.02.98813", name: "La Foa" },
    { code: "NC.02.98816", name: "Moindou" },
    { code: "NC.02.98817", name: "Le Mont-Dore" },
    { code: "NC.02.98818", name: "Nouméa" },
    { code: "NC.02.98821", name: "Païta" },
    { code: "NC.02.98828", name: "Sarraméa" },
    { code: "NC.02.98829", name: "Thio" },
    { code: "NC.02.98832", name: "Yaté" },
  ],
  "NC.03": [
    { code: "NC.03.98814", name: "Lifou" },
    { code: "NC.03.98815", name: "Maré" },
    { code: "NC.03.98820", name: "Ouvéa" },
  ],
  "NE.01": [
    { code: "NE.01.11996007", name: "Ingall" },
    { code: "NE.01.11996009", name: "Aderbissinat" },
    { code: "NE.01.11996022", name: "Iferouane" },
    { code: "NE.01.2446795", name: "Département de Bilma" },
    { code: "NE.01.8624000", name: "Arlit" },
    { code: "NE.01.8624001", name: "Département de Tchirozérine" },
  ],
  "NE.02": [
    { code: "NE.02.11996010", name: "Goudoumaria" },
    { code: "NE.02.11996019", name: "Bosso" },
    { code: "NE.02.11996024", name: "N'Gourti" },
    { code: "NE.02.2440494", name: "Département de Nguigmi" },
    { code: "NE.02.2441446", name: "Département de Maïné-Soroa" },
    { code: "NE.02.2445703", name: "Département de Diffa" },
  ],
  "NE.03": [
    { code: "NE.03.11204211", name: "Boboye Department" },
    { code: "NE.03.11996008", name: "Dioundiou" },
    { code: "NE.03.11996020", name: "Falmey" },
    { code: "NE.03.11996027", name: "Tibiri" },
    { code: "NE.03.2441629", name: "Département de Loga" },
    { code: "NE.03.2444487", name: "Département de Gaya" },
    { code: "NE.03.2445487", name: "Département de Dosso" },
    { code: "NE.03.2445552", name: "Département de Dogondoutchi" },
  ],
  "NE.04": [
    { code: "NE.04.11996004", name: "Bermo" },
    { code: "NE.04.11996006", name: "Gazaoua" },
    { code: "NE.04.2438821", name: "Département de Tessaoua" },
    { code: "NE.04.2441193", name: "Département de Mayahi" },
    { code: "NE.04.2441290", name: "Ville de Maradi" },
    { code: "NE.04.2446266", name: "Département de Dakoro" },
    { code: "NE.04.8299475", name: "Guidan Roumdji Department" },
    { code: "NE.04.8624179", name: "Département d’Aguié" },
    { code: "NE.04.8624180", name: "Madarounfa" },
  ],
  "NE.06": [
    { code: "NE.06.11996025", name: "Tassara" },
    { code: "NE.06.11996028", name: "Tillia" },
    { code: "NE.06.11996030", name: "Ville de Tahoua" },
    { code: "NE.06.11996032", name: "Bagaroua" },
    { code: "NE.06.11996034", name: "Malbaza" },
    { code: "NE.06.2438973", name: "Département de Tchin-Tabaraden" },
    { code: "NE.06.2439375", name: "Département de Tahoua" },
    { code: "NE.06.2441528", name: "Département de Madaoua" },
    { code: "NE.06.2442477", name: "Département de Keïta" },
    { code: "NE.06.2443303", name: "Département d' Illéla" },
    { code: "NE.06.2446465", name: "Département de Bouza" },
    { code: "NE.06.2446752", name: "Département de Birni Nkonni" },
    { code: "NE.06.8624181", name: "Abalak" },
  ],
  "NE.07": [
    { code: "NE.07.10943048", name: "Mirriah Department" },
    { code: "NE.07.11204206", name: "Magaria Department" },
    { code: "NE.07.11996011", name: "Ville de Zinder" },
    { code: "NE.07.11996014", name: "Belbedji" },
    { code: "NE.07.11996017", name: "Damagaram Takaya" },
    { code: "NE.07.11996018", name: "Dungass" },
    { code: "NE.07.11996023", name: "Takeita" },
    { code: "NE.07.11996026", name: "Tesker" },
    { code: "NE.07.2439154", name: "Département de Tânout" },
    { code: "NE.07.2441216", name: "Département de Kantché" },
    { code: "NE.07.2444218", name: "Département de Gouré" },
  ],
  "NE.08": [
    { code: "NE.08.2440482", name: "Ville de Niamey" },
  ],
  "NE.09": [
    { code: "NE.09.11996005", name: "Bankilaré" },
    { code: "NE.09.11996013", name: "Banibangou" },
    { code: "NE.09.11996015", name: "Abala" },
    { code: "NE.09.11996016", name: "Ayerou" },
    { code: "NE.09.11996021", name: "Gothèye" },
    { code: "NE.09.11996029", name: "Torodi" },
    { code: "NE.09.11996031", name: "Balleyara" },
    { code: "NE.09.2439811", name: "Département de Say" },
    { code: "NE.09.2440370", name: "Département de Ouallam" },
    { code: "NE.09.2444994", name: "Département de Filingué" },
    { code: "NE.09.8334576", name: "Tillaberi Department" },
    { code: "NE.09.8334577", name: "Tera Department" },
    { code: "NE.09.8334578", name: "Kollo Department" },
  ],
  "NG.05": [
    { code: "NG.05.25001", name: "Agege" },
    { code: "NG.05.25002", name: "Ajeromi/Ifelodun" },
    { code: "NG.05.25003", name: "Alimosho" },
    { code: "NG.05.25004", name: "Amuwo Odofin" },
    { code: "NG.05.25005", name: "Apapa" },
    { code: "NG.05.25006", name: "Badagry" },
    { code: "NG.05.25007", name: "Epe" },
    { code: "NG.05.25008", name: "Eti Osa" },
    { code: "NG.05.25009", name: "Ibeju Lekki" },
    { code: "NG.05.25010", name: "Ifako/Ijaye" },
    { code: "NG.05.25011", name: "Ikeja" },
    { code: "NG.05.25012", name: "Ikorodu" },
    { code: "NG.05.25013", name: "Kosofe" },
    { code: "NG.05.25014", name: "Mushin" },
    { code: "NG.05.25015", name: "Ojo" },
    { code: "NG.05.25016", name: "Oshodi/Isolo" },
    { code: "NG.05.25017", name: "Shomolu" },
    { code: "NG.05.25018", name: "Surulere" },
    { code: "NG.05.9485473", name: "Oshodi-Isolo Local Government Area" },
    { code: "NG.05.9485474", name: "Lagos Mainland Local Government Area" },
    { code: "NG.05.9485475", name: "Ifako-Ijaiye Local Government Area" },
    { code: "NG.05.9485476", name: "Lagos Island Local Government Area" },
  ],
  "NG.11": [
    { code: "NG.11.15001", name: "Abaji" },
    { code: "NG.11.15002", name: "Bwari" },
    { code: "NG.11.15003", name: "Gwagwalada" },
    { code: "NG.11.15004", name: "Kuje" },
    { code: "NG.11.15005", name: "Kwali" },
    { code: "NG.11.15006", name: "Municipal Area Council" },
  ],
  "NG.16": [
    { code: "NG.16.28001", name: "Abeokuta North" },
    { code: "NG.16.28002", name: "Abeokuta South" },
    { code: "NG.16.28003", name: "Ado Odo/Ota" },
    { code: "NG.16.28004", name: "Egbado North" },
    { code: "NG.16.28005", name: "Egbado South" },
    { code: "NG.16.28006", name: "Ewekoro" },
    { code: "NG.16.28007", name: "Ifo" },
    { code: "NG.16.28008", name: "Ijebu East" },
    { code: "NG.16.28009", name: "Ijebu North" },
    { code: "NG.16.28010", name: "Ijebu North East" },
    { code: "NG.16.28011", name: "Ijebu Ode" },
    { code: "NG.16.28012", name: "Ikenne" },
    { code: "NG.16.28013", name: "Imeko Afon" },
    { code: "NG.16.28014", name: "Ipokia" },
    { code: "NG.16.28015", name: "Obafemi Owode" },
    { code: "NG.16.28016", name: "Odeda" },
    { code: "NG.16.28017", name: "Odogbolu" },
    { code: "NG.16.28018", name: "Ogun Waterside" },
    { code: "NG.16.28019", name: "Remo North" },
    { code: "NG.16.28020", name: "Shagamu" },
  ],
  "NG.21": [
    { code: "NG.21.3001", name: "Abak" },
    { code: "NG.21.3002", name: "Eastern Obolo" },
    { code: "NG.21.3003", name: "Eket" },
    { code: "NG.21.3004", name: "Esit Eket" },
    { code: "NG.21.3005", name: "Essien Udim" },
    { code: "NG.21.3006", name: "Etim Ekpo" },
    { code: "NG.21.3007", name: "Etinan" },
    { code: "NG.21.3008", name: "Ibeno" },
    { code: "NG.21.3009", name: "Ibesikpo Asutan" },
    { code: "NG.21.3010", name: "Ibiono Ibom" },
    { code: "NG.21.3011", name: "Ika" },
    { code: "NG.21.3012", name: "Ikono" },
    { code: "NG.21.3013", name: "Ikot Abasi" },
    { code: "NG.21.3014", name: "Ikot Ekpene" },
    { code: "NG.21.3015", name: "Ini" },
    { code: "NG.21.3016", name: "Itu" },
    { code: "NG.21.3017", name: "Mbo" },
    { code: "NG.21.3018", name: "Mkpat Enin" },
    { code: "NG.21.3019", name: "Nsit Atai" },
    { code: "NG.21.3020", name: "Nsit Ibom" },
    { code: "NG.21.3021", name: "Nsit Ubium" },
    { code: "NG.21.3022", name: "Obot Akara" },
    { code: "NG.21.3023", name: "Okobo" },
    { code: "NG.21.3024", name: "Onna" },
    { code: "NG.21.3025", name: "Oron" },
    { code: "NG.21.3026", name: "Oruk Anam" },
    { code: "NG.21.3027", name: "Udung Uko" },
    { code: "NG.21.3028", name: "Ukanafun" },
    { code: "NG.21.3029", name: "Uruan" },
    { code: "NG.21.3030", name: "Urue Offong/Oruko" },
    { code: "NG.21.3031", name: "Uyo" },
  ],
  "NG.22": [
    { code: "NG.22.9001", name: "Abi" },
    { code: "NG.22.9002", name: "Akamkpa" },
    { code: "NG.22.9003", name: "Akpabuyo" },
    { code: "NG.22.9004", name: "Bakassi" },
    { code: "NG.22.9005", name: "Bekwarra" },
    { code: "NG.22.9006", name: "Biase" },
    { code: "NG.22.9007", name: "Boki" },
    { code: "NG.22.9008", name: "Calabar Municipal" },
    { code: "NG.22.9009", name: "Calabar South" },
    { code: "NG.22.9010", name: "Etung" },
    { code: "NG.22.9011", name: "Ikom" },
    { code: "NG.22.9012", name: "Obanliku" },
    { code: "NG.22.9013", name: "Obubra" },
    { code: "NG.22.9014", name: "Obudu" },
    { code: "NG.22.9015", name: "Odukpani" },
    { code: "NG.22.9016", name: "Ogoja" },
    { code: "NG.22.9017", name: "Yakurr" },
    { code: "NG.22.9018", name: "Yala" },
  ],
  "NG.23": [
    { code: "NG.23.19001", name: "Birnin Gwari" },
    { code: "NG.23.19002", name: "Chikun" },
    { code: "NG.23.19003", name: "Giwa" },
    { code: "NG.23.19004", name: "Igabi" },
    { code: "NG.23.19005", name: "Ikara" },
    { code: "NG.23.19006", name: "Jaba" },
    { code: "NG.23.19007", name: "Jema'A" },
    { code: "NG.23.19008", name: "Kachia" },
    { code: "NG.23.19009", name: "Kaduna North" },
    { code: "NG.23.19010", name: "Kaduna South" },
    { code: "NG.23.19011", name: "Kagarko" },
    { code: "NG.23.19012", name: "Kajuru" },
    { code: "NG.23.19013", name: "Kaura" },
    { code: "NG.23.19014", name: "Kauru" },
    { code: "NG.23.19015", name: "Kuban" },
    { code: "NG.23.19016", name: "Kudan" },
    { code: "NG.23.19017", name: "Lere" },
    { code: "NG.23.19018", name: "Makarfi" },
    { code: "NG.23.19019", name: "Sabon Gari" },
    { code: "NG.23.19020", name: "Sanga" },
    { code: "NG.23.19021", name: "Soba" },
    { code: "NG.23.19022", name: "Zangon Kataf" },
    { code: "NG.23.19023", name: "Zaria" },
  ],
  "NG.24": [
    { code: "NG.24.401", name: "Bakori" },
    { code: "NG.24.402", name: "Batagarawa" },
    { code: "NG.24.403", name: "Batsari" },
    { code: "NG.24.404", name: "Baure" },
    { code: "NG.24.405", name: "Bindawa" },
    { code: "NG.24.406", name: "Charanchi" },
    { code: "NG.24.407", name: "Dandume" },
    { code: "NG.24.408", name: "Danja" },
    { code: "NG.24.409", name: "Dan Musa" },
    { code: "NG.24.410", name: "Daura" },
    { code: "NG.24.411", name: "Dutsi" },
    { code: "NG.24.412", name: "Dutsin Ma" },
    { code: "NG.24.413", name: "Faskari" },
    { code: "NG.24.414", name: "Funtua" },
    { code: "NG.24.415", name: "Ingawa" },
    { code: "NG.24.416", name: "Jibia" },
    { code: "NG.24.417", name: "Kafur" },
    { code: "NG.24.418", name: "Kaita" },
    { code: "NG.24.419", name: "Kankara" },
    { code: "NG.24.420", name: "Kankia" },
    { code: "NG.24.421", name: "Katsina" },
    { code: "NG.24.422", name: "Kurfi" },
    { code: "NG.24.423", name: "Kusada" },
    { code: "NG.24.424", name: "Mai'Adua" },
    { code: "NG.24.425", name: "Malumfashi" },
    { code: "NG.24.426", name: "Mani" },
    { code: "NG.24.427", name: "Mashi" },
    { code: "NG.24.428", name: "Matazu" },
    { code: "NG.24.429", name: "Musawa" },
    { code: "NG.24.430", name: "Rimi" },
    { code: "NG.24.431", name: "Sabuwa" },
    { code: "NG.24.432", name: "Safana" },
    { code: "NG.24.433", name: "Sandamu" },
    { code: "NG.24.434", name: "Zango" },
  ],
  "NG.25": [
    { code: "NG.25.4001", name: "Aguata" },
    { code: "NG.25.4002", name: "Anambra East" },
    { code: "NG.25.4003", name: "Anambra West" },
    { code: "NG.25.4004", name: "Anaocha" },
    { code: "NG.25.4005", name: "Awka North" },
    { code: "NG.25.4006", name: "Awka South" },
    { code: "NG.25.4007", name: "Ayamelum" },
    { code: "NG.25.4008", name: "Dunukofia" },
    { code: "NG.25.4009", name: "Ekwusigo" },
    { code: "NG.25.4010", name: "Idemili North" },
    { code: "NG.25.4011", name: "Idemili South" },
    { code: "NG.25.4012", name: "Ihiala" },
    { code: "NG.25.4013", name: "Njikoka" },
    { code: "NG.25.4014", name: "Nnewi North" },
    { code: "NG.25.4015", name: "Nnewi South" },
    { code: "NG.25.4016", name: "Ogbaru" },
    { code: "NG.25.4017", name: "Onitsha North" },
    { code: "NG.25.4018", name: "Onitsha South" },
    { code: "NG.25.4019", name: "Orumba North" },
    { code: "NG.25.4020", name: "Orumba South" },
    { code: "NG.25.4021", name: "Oyi" },
  ],
  "NG.26": [
    { code: "NG.26.7001", name: "Ado" },
    { code: "NG.26.7002", name: "Agatu" },
    { code: "NG.26.7003", name: "Apa" },
    { code: "NG.26.7004", name: "Bukuru" },
    { code: "NG.26.7005", name: "Gboko" },
    { code: "NG.26.7006", name: "Guma" },
    { code: "NG.26.7007", name: "Gwer East" },
    { code: "NG.26.7008", name: "Gwer West" },
    { code: "NG.26.7009", name: "Katsina-Ala" },
    { code: "NG.26.7010", name: "Konshisha" },
    { code: "NG.26.7011", name: "Kwande" },
    { code: "NG.26.7012", name: "Logo" },
    { code: "NG.26.7013", name: "Markurdi" },
    { code: "NG.26.7014", name: "Obi" },
    { code: "NG.26.7015", name: "Ogbadibo" },
    { code: "NG.26.7016", name: "Ohimini" },
    { code: "NG.26.7017", name: "Oju" },
    { code: "NG.26.7018", name: "Okpokwu" },
    { code: "NG.26.7019", name: "Oturkpo" },
    { code: "NG.26.7020", name: "Tarka" },
    { code: "NG.26.7021", name: "Ukum" },
    { code: "NG.26.7022", name: "Ushongo" },
    { code: "NG.26.7023", name: "Vandeikya" },
    { code: "NG.26.9485482", name: "Makurdi Local Government Area" },
    { code: "NG.26.9485483", name: "Buruku Local Government Area" },
  ],
  "NG.27": [
    { code: "NG.27.101", name: "Abadam" },
    { code: "NG.27.102", name: "Askira-Uba" },
    { code: "NG.27.103", name: "Bama" },
    { code: "NG.27.104", name: "Bayo" },
    { code: "NG.27.105", name: "Biu" },
    { code: "NG.27.106", name: "Chibok" },
    { code: "NG.27.107", name: "Damboa" },
    { code: "NG.27.108", name: "Dikwa" },
    { code: "NG.27.109", name: "Gubio" },
    { code: "NG.27.110", name: "Guzamala" },
    { code: "NG.27.111", name: "Gwoza" },
    { code: "NG.27.112", name: "Hawul" },
    { code: "NG.27.113", name: "Jere" },
    { code: "NG.27.114", name: "Kaga" },
    { code: "NG.27.115", name: "Kala-Balge" },
    { code: "NG.27.116", name: "Konduga" },
    { code: "NG.27.117", name: "Kukawa" },
    { code: "NG.27.118", name: "Kwaya Kusar" },
    { code: "NG.27.119", name: "Mafa" },
    { code: "NG.27.120", name: "Magumeri" },
    { code: "NG.27.121", name: "Marte" },
    { code: "NG.27.122", name: "Mobbar" },
    { code: "NG.27.123", name: "Monguno" },
    { code: "NG.27.124", name: "Maiduguri" },
    { code: "NG.27.125", name: "Ngala" },
    { code: "NG.27.126", name: "Nganzai" },
    { code: "NG.27.127", name: "Shani" },
  ],
  "NG.28": [
    { code: "NG.28.17001", name: "Aboh-Mbaise" },
    { code: "NG.28.17002", name: "Ahiazu-Mbaise" },
    { code: "NG.28.17003", name: "Ehime -Mbano" },
    { code: "NG.28.17004", name: "Ezinihitte" },
    { code: "NG.28.17005", name: "Ideato North" },
    { code: "NG.28.17006", name: "Ideato South" },
    { code: "NG.28.17007", name: "Ihitte/Uboma" },
    { code: "NG.28.17008", name: "Ikeduru" },
    { code: "NG.28.17009", name: "Isiala Mbano" },
    { code: "NG.28.17010", name: "Isu" },
    { code: "NG.28.17011", name: "Mbatoli" },
    { code: "NG.28.17012", name: "Ngor-Okpala" },
    { code: "NG.28.17013", name: "Njaba" },
    { code: "NG.28.17014", name: "Nkwerre" },
    { code: "NG.28.17015", name: "Nwangele" },
    { code: "NG.28.17016", name: "Obowo" },
    { code: "NG.28.17017", name: "Oguta" },
    { code: "NG.28.17018", name: "Ohaji/Egbema" },
    { code: "NG.28.17019", name: "Okigwe" },
    { code: "NG.28.17020", name: "Orlu" },
    { code: "NG.28.17021", name: "Orsu" },
    { code: "NG.28.17022", name: "Oru East" },
    { code: "NG.28.17023", name: "Oru West" },
    { code: "NG.28.17024", name: "Owerri Municipal" },
    { code: "NG.28.17025", name: "Owerri North" },
    { code: "NG.28.17026", name: "Owerri West" },
    { code: "NG.28.17027", name: "Unuimo" },
    { code: "NG.28.9485478", name: "Mbaitoli Local Government Area" },
  ],
  "NG.29": [
    { code: "NG.29.20001", name: "Tarauni" },
    { code: "NG.29.20002", name: "Takai" },
    { code: "NG.29.20003", name: "Garum Mallam" },
    { code: "NG.29.20004", name: "Ajingi" },
    { code: "NG.29.20005", name: "Rimin Gado" },
    { code: "NG.29.20006", name: "Garko" },
    { code: "NG.29.20007", name: "Gaya" },
    { code: "NG.29.20008", name: "Tsanyawa" },
    { code: "NG.29.20009", name: "Albasu" },
    { code: "NG.29.20010", name: "Gezawa" },
    { code: "NG.29.20011", name: "Sumaila" },
    { code: "NG.29.20012", name: "Gwale" },
    { code: "NG.29.20013", name: "Shanono" },
    { code: "NG.29.20014", name: "Rano" },
    { code: "NG.29.20015", name: "Tofa" },
    { code: "NG.29.20016", name: "Gabasawa" },
    { code: "NG.29.20017", name: "Gwarzo" },
    { code: "NG.29.20018", name: "Ungogo" },
    { code: "NG.29.20019", name: "Warawa" },
    { code: "NG.29.20020", name: "Doguwa" },
    { code: "NG.29.20021", name: "Dawakin Tofa" },
    { code: "NG.29.20022", name: "Dawakin Kudu" },
    { code: "NG.29.20023", name: "Dambatta" },
    { code: "NG.29.20024", name: "Dala" },
    { code: "NG.29.20025", name: "Bebeji" },
    { code: "NG.29.20026", name: "Kabo" },
    { code: "NG.29.20027", name: "Wudil" },
    { code: "NG.29.20028", name: "Bunkure" },
    { code: "NG.29.20029", name: "Tudun Wada" },
    { code: "NG.29.20030", name: "Fagge" },
    { code: "NG.29.20031", name: "Bichi" },
    { code: "NG.29.20032", name: "Rogo" },
    { code: "NG.29.20033", name: "Kibiya" },
    { code: "NG.29.20034", name: "Kiru" },
    { code: "NG.29.20035", name: "Kura" },
    { code: "NG.29.20036", name: "Madobi" },
    { code: "NG.29.20037", name: "Nassarawa" },
    { code: "NG.29.20038", name: "Bagwai" },
    { code: "NG.29.20039", name: "Makoda" },
    { code: "NG.29.20040", name: "Minjibir" },
    { code: "NG.29.20041", name: "Karaye" },
    { code: "NG.29.20042", name: "Kunchi" },
    { code: "NG.29.20043", name: "Kano Municipal" },
    { code: "NG.29.20044", name: "Kumbotso" },
  ],
  "NG.30": [
    { code: "NG.30.24001", name: "Asa" },
    { code: "NG.30.24002", name: "Baruten" },
    { code: "NG.30.24003", name: "Edu" },
    { code: "NG.30.24004", name: "Ekiti" },
    { code: "NG.30.24005", name: "Ifelodun" },
    { code: "NG.30.24006", name: "Ilorin East" },
    { code: "NG.30.24007", name: "Ilorin South" },
    { code: "NG.30.24008", name: "Ilorin West" },
    { code: "NG.30.24009", name: "Irepodun" },
    { code: "NG.30.24010", name: "Isin" },
    { code: "NG.30.24011", name: "Kaiama" },
    { code: "NG.30.24012", name: "Moro" },
    { code: "NG.30.24013", name: "Offa" },
    { code: "NG.30.24014", name: "Oke Ero" },
    { code: "NG.30.24015", name: "Oyun" },
    { code: "NG.30.24016", name: "Pategi" },
  ],
  "NG.31": [
    { code: "NG.31.27001", name: "Agaie" },
    { code: "NG.31.27002", name: "Agwara" },
    { code: "NG.31.27003", name: "Bida" },
    { code: "NG.31.27004", name: "Borgu" },
    { code: "NG.31.27005", name: "Bosso" },
    { code: "NG.31.27006", name: "Chanchaga" },
    { code: "NG.31.27007", name: "Edati" },
    { code: "NG.31.27008", name: "Gbako" },
    { code: "NG.31.27009", name: "Gurara" },
    { code: "NG.31.27010", name: "Katcha" },
    { code: "NG.31.27011", name: "Kontagora" },
    { code: "NG.31.27012", name: "Lapai" },
    { code: "NG.31.27013", name: "Lavun" },
    { code: "NG.31.27014", name: "Magama" },
    { code: "NG.31.27015", name: "Mariga" },
    { code: "NG.31.27016", name: "Mashegu" },
    { code: "NG.31.27017", name: "Mokwa" },
    { code: "NG.31.27018", name: "Muya" },
    { code: "NG.31.27019", name: "Paikoro" },
    { code: "NG.31.27020", name: "Rafi" },
    { code: "NG.31.27021", name: "Rijau" },
    { code: "NG.31.27022", name: "Shiroro" },
    { code: "NG.31.27023", name: "Suleja" },
    { code: "NG.31.27024", name: "Tafa" },
    { code: "NG.31.27025", name: "Wushishi" },
  ],
  "NG.32": [
    { code: "NG.32.31001", name: "Afijio" },
    { code: "NG.32.31002", name: "Akinyele" },
    { code: "NG.32.31003", name: "Atiba" },
    { code: "NG.32.31004", name: "Atisbo" },
    { code: "NG.32.31005", name: "Egbeda" },
    { code: "NG.32.31006", name: "Ibadan North" },
    { code: "NG.32.31007", name: "Ibadan North East" },
    { code: "NG.32.31008", name: "Ibadan North West" },
    { code: "NG.32.31009", name: "Ibadan South East" },
    { code: "NG.32.31010", name: "Ibadan South West" },
    { code: "NG.32.31011", name: "Ibarapa Central" },
    { code: "NG.32.31012", name: "Ibarapa East" },
    { code: "NG.32.31013", name: "Ibarapa North" },
    { code: "NG.32.31014", name: "Ido" },
    { code: "NG.32.31015", name: "Irepo" },
    { code: "NG.32.31016", name: "Iseyin" },
    { code: "NG.32.31017", name: "Itesiwaju" },
    { code: "NG.32.31018", name: "Iwajowa" },
    { code: "NG.32.31019", name: "Kajola" },
    { code: "NG.32.31020", name: "Lagelu" },
    { code: "NG.32.31021", name: "Ogbomosho North" },
    { code: "NG.32.31022", name: "Ogbomosho South" },
    { code: "NG.32.31023", name: "Ogo Oluwa" },
    { code: "NG.32.31024", name: "Olorunsogo" },
    { code: "NG.32.31025", name: "Oluyole" },
    { code: "NG.32.31026", name: "Ona Ara" },
    { code: "NG.32.31027", name: "Orelope" },
    { code: "NG.32.31028", name: "Ori Ire" },
    { code: "NG.32.31029", name: "Oyo East" },
    { code: "NG.32.31030", name: "Oyo West" },
    { code: "NG.32.31031", name: "Saki East" },
    { code: "NG.32.31032", name: "Saki West" },
    { code: "NG.32.31033", name: "Surulere" },
  ],
  "NG.35": [
    { code: "NG.35.2001", name: "Demsa" },
    { code: "NG.35.2002", name: "Fufore" },
    { code: "NG.35.2003", name: "Ganye" },
    { code: "NG.35.2004", name: "Girei" },
    { code: "NG.35.2005", name: "Gombi" },
    { code: "NG.35.2006", name: "Guyuk" },
    { code: "NG.35.2007", name: "Hong" },
    { code: "NG.35.2008", name: "Jada" },
    { code: "NG.35.2009", name: "Larmurde" },
    { code: "NG.35.2010", name: "Madagali" },
    { code: "NG.35.2011", name: "Maiha" },
    { code: "NG.35.2012", name: "Mayo-Belwa" },
    { code: "NG.35.2013", name: "Michika" },
    { code: "NG.35.2014", name: "Mubi North" },
    { code: "NG.35.2015", name: "Mubi South" },
    { code: "NG.35.2016", name: "Numan" },
    { code: "NG.35.2017", name: "Shelleng" },
    { code: "NG.35.2018", name: "Song" },
    { code: "NG.35.2019", name: "Teungo" },
    { code: "NG.35.2020", name: "Yola North" },
    { code: "NG.35.2021", name: "Yola South" },
  ],
  "NG.36": [
    { code: "NG.36.10001", name: "Aniocha North" },
    { code: "NG.36.10002", name: "Aniocha South" },
    { code: "NG.36.10003", name: "Bomadi" },
    { code: "NG.36.10004", name: "Burutu" },
    { code: "NG.36.10005", name: "Ethiope East" },
    { code: "NG.36.10006", name: "Ethiope West" },
    { code: "NG.36.10007", name: "Ika North East" },
    { code: "NG.36.10008", name: "Ika South" },
    { code: "NG.36.10009", name: "Isoko North" },
    { code: "NG.36.10010", name: "Isoko South" },
    { code: "NG.36.10011", name: "Ndokwa East" },
    { code: "NG.36.10012", name: "Ndokwa West" },
    { code: "NG.36.10013", name: "Okpe" },
    { code: "NG.36.10014", name: "Oshimili North" },
    { code: "NG.36.10015", name: "Oshimili South" },
    { code: "NG.36.10016", name: "Patani" },
    { code: "NG.36.10017", name: "Sapele" },
    { code: "NG.36.10018", name: "Udu" },
    { code: "NG.36.10019", name: "Ughelli North" },
    { code: "NG.36.10020", name: "Ughelli South" },
    { code: "NG.36.10021", name: "Ukwuani" },
    { code: "NG.36.10022", name: "Uvwie" },
    { code: "NG.36.10023", name: "Warri North" },
    { code: "NG.36.10024", name: "Warri South" },
    { code: "NG.36.10025", name: "Warri South-West" },
  ],
  "NG.37": [
    { code: "NG.37.12001", name: "Akoko-Edo" },
    { code: "NG.37.12002", name: "Egor" },
    { code: "NG.37.12003", name: "Esan North-East" },
    { code: "NG.37.12004", name: "Esan Central" },
    { code: "NG.37.12005", name: "Esan South-East" },
    { code: "NG.37.12006", name: "Esan West" },
    { code: "NG.37.12007", name: "Etsako Central" },
    { code: "NG.37.12008", name: "Etsako East" },
    { code: "NG.37.12009", name: "Etsako West" },
    { code: "NG.37.12010", name: "Iguegben" },
    { code: "NG.37.12011", name: "Ikpoba-Okha" },
    { code: "NG.37.12012", name: "Oredo" },
    { code: "NG.37.12013", name: "Orhionmwon" },
    { code: "NG.37.12014", name: "Ovia North-East" },
    { code: "NG.37.12015", name: "Ovia South-West" },
    { code: "NG.37.12016", name: "Owan East" },
    { code: "NG.37.12017", name: "Owan West" },
    { code: "NG.37.12018", name: "Uhunmwonde" },
  ],
  "NG.39": [
    { code: "NG.39.18001", name: "Kaugama" },
    { code: "NG.39.18002", name: "Taura" },
    { code: "NG.39.18004", name: "Babura" },
    { code: "NG.39.18005", name: "Guri" },
    { code: "NG.39.18006", name: "Gumel" },
    { code: "NG.39.18007", name: "Kiri Kasama" },
    { code: "NG.39.18008", name: "Gwaram" },
    { code: "NG.39.18009", name: "Gwiwa" },
    { code: "NG.39.18010", name: "Kazaure" },
    { code: "NG.39.18011", name: "Hadejia" },
    { code: "NG.39.18012", name: "Dutse" },
    { code: "NG.39.18013", name: "Auyo" },
    { code: "NG.39.18014", name: "Miga" },
    { code: "NG.39.18015", name: "Roni" },
    { code: "NG.39.18016", name: "Gagarawa" },
    { code: "NG.39.18017", name: "Malam Maduri" },
    { code: "NG.39.18018", name: "Buji" },
    { code: "NG.39.18019", name: "Yankwashi" },
    { code: "NG.39.18020", name: "Ringim" },
    { code: "NG.39.18021", name: "Biriniwa" },
    { code: "NG.39.18022", name: "Birnin Kudu" },
    { code: "NG.39.18023", name: "Maigatari" },
    { code: "NG.39.18024", name: "Garki" },
    { code: "NG.39.18025", name: "Kiyawa" },
    { code: "NG.39.18026", name: "Jahun" },
    { code: "NG.39.18027", name: "Kafin Hausa" },
    { code: "NG.39.18030", name: "Sule Tankakar" },
  ],
  "NG.40": [
    { code: "NG.40.501", name: "Aleiro" },
    { code: "NG.40.502", name: "Arewa Dandi" },
    { code: "NG.40.503", name: "Argungu" },
    { code: "NG.40.504", name: "Augie" },
    { code: "NG.40.505", name: "Bagudo" },
    { code: "NG.40.506", name: "Birnin Kebbi" },
    { code: "NG.40.507", name: "Bunza" },
    { code: "NG.40.508", name: "Dandi" },
    { code: "NG.40.509", name: "Fakai" },
    { code: "NG.40.510", name: "Gwandu" },
    { code: "NG.40.511", name: "Jega" },
    { code: "NG.40.512", name: "Kalgo" },
    { code: "NG.40.513", name: "Koko-Besse" },
    { code: "NG.40.514", name: "Maiyama" },
    { code: "NG.40.515", name: "Ngaski" },
    { code: "NG.40.516", name: "Sakaba" },
    { code: "NG.40.517", name: "Shanga" },
    { code: "NG.40.518", name: "Suru" },
    { code: "NG.40.519", name: "Wasagu-Danko" },
    { code: "NG.40.520", name: "Yauri" },
    { code: "NG.40.521", name: "Zuru" },
    { code: "NG.40.9485472", name: "Koko/Besse Local Government Area" },
    { code: "NG.40.9492098", name: "Yauri Local Government Area" },
  ],
  "NG.41": [
    { code: "NG.41.23001", name: "Adavi" },
    { code: "NG.41.23002", name: "Ajaokuta" },
    { code: "NG.41.23003", name: "Ankpa" },
    { code: "NG.41.23004", name: "Bassa" },
    { code: "NG.41.23005", name: "Dekina" },
    { code: "NG.41.23006", name: "Ibaji" },
    { code: "NG.41.23007", name: "Idah" },
    { code: "NG.41.23008", name: "Igalamela-Odolu" },
    { code: "NG.41.23009", name: "Ijumu" },
    { code: "NG.41.23010", name: "Kabba/Bunu" },
    { code: "NG.41.23011", name: "Kogi" },
    { code: "NG.41.23012", name: "Lokoja" },
    { code: "NG.41.23013", name: "Mopa-Muro" },
    { code: "NG.41.23014", name: "Ofu" },
    { code: "NG.41.23015", name: "Ogori/Magongo" },
    { code: "NG.41.23016", name: "Okehi" },
    { code: "NG.41.23017", name: "Okene" },
    { code: "NG.41.23018", name: "Olamaboro" },
    { code: "NG.41.23019", name: "Omala" },
    { code: "NG.41.23020", name: "Yagba East" },
    { code: "NG.41.23021", name: "Yagba West" },
  ],
  "NG.42": [
    { code: "NG.42.30001", name: "Aiyedade" },
    { code: "NG.42.30002", name: "Aiyedire" },
    { code: "NG.42.30003", name: "Atakunmosa East" },
    { code: "NG.42.30004", name: "Atakunmosa West" },
    { code: "NG.42.30005", name: "Boluwaduro" },
    { code: "NG.42.30006", name: "Boripe" },
    { code: "NG.42.30007", name: "Ede North" },
    { code: "NG.42.30008", name: "Ede South" },
    { code: "NG.42.30009", name: "Egbedore" },
    { code: "NG.42.30010", name: "Ejigbo" },
    { code: "NG.42.30011", name: "Ife Central" },
    { code: "NG.42.30012", name: "Ife East" },
    { code: "NG.42.30013", name: "Ife North" },
    { code: "NG.42.30014", name: "Ife South" },
    { code: "NG.42.30015", name: "Ifedayo" },
    { code: "NG.42.30016", name: "Ifelodun" },
    { code: "NG.42.30017", name: "Ila" },
    { code: "NG.42.30018", name: "Ilesha East" },
    { code: "NG.42.30019", name: "Ilesha West" },
    { code: "NG.42.30020", name: "Irepodun" },
    { code: "NG.42.30021", name: "Irewole" },
    { code: "NG.42.30022", name: "Isokan" },
    { code: "NG.42.30023", name: "Iwo" },
    { code: "NG.42.30024", name: "Obokun" },
    { code: "NG.42.30025", name: "Odo Otin" },
    { code: "NG.42.30026", name: "Ola Oluwa" },
    { code: "NG.42.30027", name: "Olorunda" },
    { code: "NG.42.30028", name: "Oriade" },
    { code: "NG.42.30029", name: "Orolu" },
    { code: "NG.42.30030", name: "Osogbo" },
  ],
  "NG.43": [
    { code: "NG.43.35001", name: "Ardo-Kola" },
    { code: "NG.43.35002", name: "Bali" },
    { code: "NG.43.35003", name: "Donga" },
    { code: "NG.43.35004", name: "Gashaka" },
    { code: "NG.43.35005", name: "Gassol" },
    { code: "NG.43.35006", name: "Ibi" },
    { code: "NG.43.35007", name: "Jalingo" },
    { code: "NG.43.35008", name: "Karim Lamido" },
    { code: "NG.43.35009", name: "Kurmi" },
    { code: "NG.43.35010", name: "Lau" },
    { code: "NG.43.35011", name: "Sardauna" },
    { code: "NG.43.35012", name: "Takum" },
    { code: "NG.43.35013", name: "Ussa" },
    { code: "NG.43.35014", name: "Wukari" },
    { code: "NG.43.35015", name: "Yorro" },
    { code: "NG.43.35016", name: "Zing" },
  ],
  "NG.44": [
    { code: "NG.44.701", name: "Barde" },
    { code: "NG.44.702", name: "Borsari" },
    { code: "NG.44.703", name: "Damaturu" },
    { code: "NG.44.704", name: "Fika" },
    { code: "NG.44.705", name: "Fune" },
    { code: "NG.44.706", name: "Geidam" },
    { code: "NG.44.707", name: "Gujba" },
    { code: "NG.44.708", name: "Gulani" },
    { code: "NG.44.709", name: "Jakusko" },
    { code: "NG.44.710", name: "Karasuwa" },
    { code: "NG.44.711", name: "Machina" },
    { code: "NG.44.712", name: "Nangere" },
    { code: "NG.44.713", name: "Nguru" },
    { code: "NG.44.714", name: "Potiskum" },
    { code: "NG.44.715", name: "Tarmua" },
    { code: "NG.44.716", name: "Yunusari" },
    { code: "NG.44.717", name: "Yusufari" },
    { code: "NG.44.9485484", name: "Bursari Local Government Area" },
  ],
  "NG.45": [
    { code: "NG.45.1001", name: "Aba North" },
    { code: "NG.45.1002", name: "Aba South" },
    { code: "NG.45.1003", name: "Arochukwu" },
    { code: "NG.45.1004", name: "Bende" },
    { code: "NG.45.1005", name: "Ikwuano" },
    { code: "NG.45.1006", name: "Isiala-Ngwa North" },
    { code: "NG.45.1007", name: "Isiala-Ngwa South" },
    { code: "NG.45.1008", name: "Isuikwuato" },
    { code: "NG.45.1009", name: "Obi Nwga" },
    { code: "NG.45.1010", name: "Ohafia" },
    { code: "NG.45.1011", name: "Osisioma Ngwa" },
    { code: "NG.45.1012", name: "Ugwunagbo" },
    { code: "NG.45.1013", name: "Ukwa East" },
    { code: "NG.45.1014", name: "Ukwa West" },
    { code: "NG.45.1015", name: "Umu-Nneochi" },
    { code: "NG.45.1016", name: "Umuahia North" },
    { code: "NG.45.1017", name: "Umuahia South" },
    { code: "NG.45.9485480", name: "Isiala Ngwa North Local Government Area" },
    { code: "NG.45.9485481", name: "Isiala Ngwa South Local Government Area" },
  ],
  "NG.46": [
    { code: "NG.46.5001", name: "Alkaleri" },
    { code: "NG.46.5002", name: "Bauchi" },
    { code: "NG.46.5003", name: "Bogoro" },
    { code: "NG.46.5004", name: "Damban" },
    { code: "NG.46.5005", name: "Darazo" },
    { code: "NG.46.5006", name: "Dass" },
    { code: "NG.46.5007", name: "Gamawa" },
    { code: "NG.46.5008", name: "Ganjuwa" },
    { code: "NG.46.5009", name: "Giade" },
    { code: "NG.46.5010", name: "Itas/Gadau" },
    { code: "NG.46.5011", name: "Jama'Are" },
    { code: "NG.46.5012", name: "Katagum" },
    { code: "NG.46.5013", name: "Kirfi" },
    { code: "NG.46.5014", name: "Misau" },
    { code: "NG.46.5015", name: "Ningi" },
    { code: "NG.46.5016", name: "Shira" },
    { code: "NG.46.5017", name: "Tafawa-Balewa" },
    { code: "NG.46.5018", name: "Toro" },
    { code: "NG.46.5019", name: "Warji" },
    { code: "NG.46.5020", name: "Zaki" },
  ],
  "NG.47": [
    { code: "NG.47.14001", name: "Aninri" },
    { code: "NG.47.14002", name: "Awgu" },
    { code: "NG.47.14003", name: "Enugu East" },
    { code: "NG.47.14004", name: "Enugu North" },
    { code: "NG.47.14005", name: "Enugu South" },
    { code: "NG.47.14006", name: "Ezeagu" },
    { code: "NG.47.14007", name: "Igbo-Etiti" },
    { code: "NG.47.14008", name: "Igbo-Eze-North" },
    { code: "NG.47.14009", name: "Igbo-Eze-South" },
    { code: "NG.47.14010", name: "Isi-Uzo" },
    { code: "NG.47.14011", name: "Nkanu East" },
    { code: "NG.47.14012", name: "Nkanu West" },
    { code: "NG.47.14013", name: "Nsukka" },
    { code: "NG.47.14014", name: "Oji-River" },
    { code: "NG.47.14015", name: "Udenu" },
    { code: "NG.47.14016", name: "Udi" },
    { code: "NG.47.14017", name: "Uzo-Uwani" },
  ],
  "NG.48": [
    { code: "NG.48.29001", name: "Akoko North East" },
    { code: "NG.48.29002", name: "Akoko North West" },
    { code: "NG.48.29003", name: "Akoko South East" },
    { code: "NG.48.29004", name: "Akoko South West" },
    { code: "NG.48.29005", name: "Akure North" },
    { code: "NG.48.29006", name: "Akure South" },
    { code: "NG.48.29007", name: "Ese Odo" },
    { code: "NG.48.29008", name: "Idanre" },
    { code: "NG.48.29009", name: "Ifedore" },
    { code: "NG.48.29010", name: "Ilaje" },
    { code: "NG.48.29011", name: "Ile Oluji/Okeigbo" },
    { code: "NG.48.29012", name: "Irele" },
    { code: "NG.48.29013", name: "Odigbo" },
    { code: "NG.48.29014", name: "Okitipupa" },
    { code: "NG.48.29015", name: "Ondo East" },
    { code: "NG.48.29016", name: "Ondo West" },
    { code: "NG.48.29017", name: "Ose" },
    { code: "NG.48.29018", name: "Owo" },
  ],
  "NG.49": [
    { code: "NG.49.32001", name: "Barkin Ladi" },
    { code: "NG.49.32002", name: "Bassa" },
    { code: "NG.49.32003", name: "Bokkos" },
    { code: "NG.49.32004", name: "Jos East" },
    { code: "NG.49.32005", name: "Jos North" },
    { code: "NG.49.32006", name: "Jos South" },
    { code: "NG.49.32007", name: "Kanam" },
    { code: "NG.49.32008", name: "Kanke" },
    { code: "NG.49.32009", name: "Langtang North" },
    { code: "NG.49.32010", name: "Langtang South" },
    { code: "NG.49.32011", name: "Mangu" },
    { code: "NG.49.32012", name: "Mikang" },
    { code: "NG.49.32013", name: "Pankshin" },
    { code: "NG.49.32014", name: "Qua'An Pan" },
    { code: "NG.49.32015", name: "Riyom" },
    { code: "NG.49.32016", name: "Shendam" },
    { code: "NG.49.32017", name: "Wase" },
  ],
  "NG.50": [
    { code: "NG.50.33001", name: "Abua/Odual" },
    { code: "NG.50.33002", name: "Ahoada East" },
    { code: "NG.50.33003", name: "Ahoada West" },
    { code: "NG.50.33004", name: "Akuku Toru" },
    { code: "NG.50.33005", name: "Andoni" },
    { code: "NG.50.33006", name: "Asari-Toru" },
    { code: "NG.50.33007", name: "Bonny" },
    { code: "NG.50.33008", name: "Degema" },
    { code: "NG.50.33009", name: "Eleme" },
    { code: "NG.50.33010", name: "Emuoha" },
    { code: "NG.50.33011", name: "Etche" },
    { code: "NG.50.33012", name: "Gokana" },
    { code: "NG.50.33013", name: "Ikwerre" },
    { code: "NG.50.33014", name: "Khana" },
    { code: "NG.50.33015", name: "Obio/Akpor" },
    { code: "NG.50.33016", name: "Ogba/Egbema/Ndoni" },
    { code: "NG.50.33017", name: "Ogu Bolo" },
    { code: "NG.50.33018", name: "Okrika" },
    { code: "NG.50.33019", name: "Omumma" },
    { code: "NG.50.33020", name: "Opobo/Nkoro" },
    { code: "NG.50.33021", name: "Oyigbo" },
    { code: "NG.50.33022", name: "Port-Harcourt" },
    { code: "NG.50.33023", name: "Tai" },
    { code: "NG.50.9485477", name: "Ogu/Bolo Local Government Area" },
  ],
  "NG.51": [
    { code: "NG.51.601", name: "Binji" },
    { code: "NG.51.602", name: "Bodinga" },
    { code: "NG.51.603", name: "Dange-Shuni" },
    { code: "NG.51.604", name: "Gada" },
    { code: "NG.51.605", name: "Goronyo" },
    { code: "NG.51.606", name: "Gudu" },
    { code: "NG.51.607", name: "Gwadabawa" },
    { code: "NG.51.608", name: "Illela" },
    { code: "NG.51.609", name: "Isa" },
    { code: "NG.51.610", name: "Kebbe" },
    { code: "NG.51.611", name: "Kware" },
    { code: "NG.51.612", name: "Rabah" },
    { code: "NG.51.613", name: "Sabon Birni" },
    { code: "NG.51.614", name: "Shagari" },
    { code: "NG.51.615", name: "Silame" },
    { code: "NG.51.616", name: "Sokoto North" },
    { code: "NG.51.617", name: "Sokoto South" },
    { code: "NG.51.618", name: "Tambuwal" },
    { code: "NG.51.619", name: "Tangaza" },
    { code: "NG.51.620", name: "Tureta" },
    { code: "NG.51.621", name: "Wamako" },
    { code: "NG.51.622", name: "Wurno" },
    { code: "NG.51.623", name: "Yabo" },
  ],
  "NG.52": [
    { code: "NG.52.6001", name: "Brass" },
    { code: "NG.52.6002", name: "Ekeremor" },
    { code: "NG.52.6003", name: "Kolokuma/Opokuma" },
    { code: "NG.52.6004", name: "Nembe" },
    { code: "NG.52.6005", name: "Ogbia" },
    { code: "NG.52.6006", name: "Sagbama" },
    { code: "NG.52.6007", name: "Southern Ijaw" },
    { code: "NG.52.6008", name: "Yenegoa" },
  ],
  "NG.53": [
    { code: "NG.53.11001", name: "Abakaliki" },
    { code: "NG.53.11002", name: "Afikpo North" },
    { code: "NG.53.11003", name: "Afikpo South" },
    { code: "NG.53.11004", name: "Ebonyi" },
    { code: "NG.53.11005", name: "Ezza North" },
    { code: "NG.53.11006", name: "Ezza South" },
    { code: "NG.53.11007", name: "Ikwo" },
    { code: "NG.53.11008", name: "Ishielu" },
    { code: "NG.53.11009", name: "Ivo" },
    { code: "NG.53.11010", name: "Izzi" },
    { code: "NG.53.11011", name: "Ohaozara" },
    { code: "NG.53.11012", name: "Ohaukwu" },
    { code: "NG.53.11013", name: "Onicha" },
  ],
  "NG.54": [
    { code: "NG.54.13001", name: "Ado-Ekiti" },
    { code: "NG.54.13002", name: "Efon" },
    { code: "NG.54.13003", name: "Ekiti East" },
    { code: "NG.54.13004", name: "Ekiti South-West" },
    { code: "NG.54.13005", name: "Ekiti West" },
    { code: "NG.54.13006", name: "Emure" },
    { code: "NG.54.13007", name: "Gbonyin" },
    { code: "NG.54.13008", name: "Ido-Osi" },
    { code: "NG.54.13009", name: "Ijero" },
    { code: "NG.54.13010", name: "Ikere" },
    { code: "NG.54.13011", name: "Ikole" },
    { code: "NG.54.13012", name: "Ilejemeje" },
    { code: "NG.54.13013", name: "Irepodun/Ifelodun" },
    { code: "NG.54.13014", name: "Ise/Orun" },
    { code: "NG.54.13015", name: "Moba" },
    { code: "NG.54.13016", name: "Oye" },
  ],
  "NG.55": [
    { code: "NG.55.16001", name: "Akko" },
    { code: "NG.55.16002", name: "Balanga" },
    { code: "NG.55.16003", name: "Billiri" },
    { code: "NG.55.16004", name: "Dukku" },
    { code: "NG.55.16005", name: "Funakaye" },
    { code: "NG.55.16006", name: "Gombe" },
    { code: "NG.55.16007", name: "Kaltungo" },
    { code: "NG.55.16008", name: "Kwami" },
    { code: "NG.55.16009", name: "Nafada" },
    { code: "NG.55.16010", name: "Shomgom" },
    { code: "NG.55.16011", name: "Yamaltu/Deba" },
  ],
  "NG.56": [
    { code: "NG.56.26001", name: "Akwanga" },
    { code: "NG.56.26002", name: "Awe" },
    { code: "NG.56.26003", name: "Doma" },
    { code: "NG.56.26004", name: "Karu" },
    { code: "NG.56.26005", name: "Keana" },
    { code: "NG.56.26006", name: "Keffi" },
    { code: "NG.56.26007", name: "Kokona" },
    { code: "NG.56.26008", name: "Lafia" },
    { code: "NG.56.26009", name: "Nasarawa" },
    { code: "NG.56.26010", name: "Nasarawa Egon" },
    { code: "NG.56.26011", name: "Obi" },
    { code: "NG.56.26012", name: "Toto" },
    { code: "NG.56.26013", name: "Wamba" },
  ],
  "NG.57": [
    { code: "NG.57.801", name: "Anka" },
    { code: "NG.57.802", name: "Bakura" },
    { code: "NG.57.803", name: "Birnin Magaji-Kiyaw" },
    { code: "NG.57.804", name: "Bukkuyum" },
    { code: "NG.57.805", name: "Bungudu" },
    { code: "NG.57.806", name: "Gummi" },
    { code: "NG.57.807", name: "Gusau" },
    { code: "NG.57.808", name: "Kaura Namoda" },
    { code: "NG.57.809", name: "Maradun" },
    { code: "NG.57.810", name: "Maru" },
    { code: "NG.57.811", name: "Shinkafi" },
    { code: "NG.57.812", name: "Talata Mafara" },
    { code: "NG.57.813", name: "Tsafe" },
    { code: "NG.57.814", name: "Zurmi" },
  ],
  "NI.01": [
    { code: "NI.01.5005", name: "Municipio de San José de los Remates" },
    { code: "NI.01.5010", name: "Municipio de Boaco" },
    { code: "NI.01.5015", name: "Municipio de Camoapa" },
    { code: "NI.01.5020", name: "Municipio de Santa Lucía" },
    { code: "NI.01.5025", name: "Municipio de Teustepe" },
    { code: "NI.01.5030", name: "Municipio de San Lorenzo" },
  ],
  "NI.02": [
    { code: "NI.02.7505", name: "Municipio de San Marcos" },
    { code: "NI.02.7510", name: "Municipio de Jinotepe" },
    { code: "NI.02.7515", name: "Municipio de Dolores" },
    { code: "NI.02.7520", name: "Municipio de Diriamba" },
    { code: "NI.02.7525", name: "Municipio de El Rosario" },
    { code: "NI.02.7530", name: "La Paz de Carazo" },
    { code: "NI.02.7535", name: "Municipio de Santa Teresa" },
    { code: "NI.02.7540", name: "Municipio de La Conquista" },
  ],
  "NI.03": [
    { code: "NI.03.3005", name: "Municipio de San Pedro del Norte" },
    { code: "NI.03.3010", name: "Municipio de San Francisco del Norte" },
    { code: "NI.03.3015", name: "Municipio de Cinco Pinos" },
    { code: "NI.03.3020", name: "Municipio de Santo Tomás del Norte" },
    { code: "NI.03.3025", name: "Municipio de El Viejo" },
    { code: "NI.03.3030", name: "Municipio de Puerto Morazán" },
    { code: "NI.03.3035", name: "Municipio de Somotillo" },
    { code: "NI.03.3040", name: "Municipio de Villanueva" },
    { code: "NI.03.3045", name: "Municipio de Chinandega" },
    { code: "NI.03.3050", name: "Municipio de El Realejo" },
    { code: "NI.03.3055", name: "Municipio de Corinto" },
    { code: "NI.03.3060", name: "Municipio de Chichigalpa" },
    { code: "NI.03.3065", name: "Municipio de Posoltega" },
  ],
  "NI.04": [
    { code: "NI.04.6505", name: "Municipio de Comalapa" },
    { code: "NI.04.6507", name: "Municipio de San Francisco de Cuapa" },
    { code: "NI.04.6510", name: "Municipio de Juigalpa" },
    { code: "NI.04.6515", name: "Municipio de La Libertad" },
    { code: "NI.04.6520", name: "Municipio de Santo Domingo" },
    { code: "NI.04.6525", name: "Municipio de Santo Tomás" },
    { code: "NI.04.6530", name: "Municipio de San Pedro de Lóvago" },
    { code: "NI.04.6535", name: "Municipio de Acoyapa" },
    { code: "NI.04.6540", name: "Municipio de Villa Sandino" },
    { code: "NI.04.6545", name: "El Coral" },
  ],
  "NI.05": [
    { code: "NI.05.2505", name: "Municipio de Pueblo Nuevo" },
    { code: "NI.05.2510", name: "Municipio de Condega" },
    { code: "NI.05.2515", name: "Municipio de Estelí" },
    { code: "NI.05.2520", name: "Municipio de San Juan de Limay" },
    { code: "NI.05.2525", name: "Municipio de La Trinidad" },
    { code: "NI.05.2530", name: "Municipio de San Nicolás" },
  ],
  "NI.06": [
    { code: "NI.06.7005", name: "Municipio de Diriá" },
    { code: "NI.06.7010", name: "Municipio de Diriomo" },
    { code: "NI.06.7015", name: "Municipio de Granada" },
    { code: "NI.06.7020", name: "Municipio de Nandaime" },
  ],
  "NI.07": [
    { code: "NI.07.1005", name: "Wiwilí de Jinotega" },
    { code: "NI.07.1010", name: "Municipio El Cua" },
    { code: "NI.07.1012", name: "Municipio de San José de Bocay" },
    { code: "NI.07.1015", name: "Municipio de Santa María de Pantasma" },
    { code: "NI.07.1020", name: "Municipio de San Rafael del Norte" },
    { code: "NI.07.1025", name: "Municipio de San Sebastián de Yalí" },
    { code: "NI.07.1030", name: "Municipio de La Concordia" },
    { code: "NI.07.1035", name: "Municipio de Jinotega" },
  ],
  "NI.08": [
    { code: "NI.08.3505", name: "Municipio de Achuapa" },
    { code: "NI.08.3510", name: "Municipio de El Sauce" },
    { code: "NI.08.3515", name: "Municipio de Santa Rosa del Peñón" },
    { code: "NI.08.3520", name: "Municipio de El Jicaral" },
    { code: "NI.08.3525", name: "Municipio de Larreynaga" },
    { code: "NI.08.3530", name: "Municipio de Telica" },
    { code: "NI.08.3535", name: "Municipio de Quezalguaque" },
    { code: "NI.08.3540", name: "Municipio de León" },
    { code: "NI.08.3545", name: "La Paz Centro" },
    { code: "NI.08.3550", name: "Municipio de Nagarote" },
  ],
  "NI.09": [
    { code: "NI.09.2005", name: "Municipio de Somoto" },
    { code: "NI.09.2010", name: "Municipio de Totogalpa" },
    { code: "NI.09.2015", name: "Municipio de Telpaneca" },
    { code: "NI.09.2020", name: "Municipio de San Juan de Río Coco" },
    { code: "NI.09.2025", name: "Municipio de Palacagüina" },
    { code: "NI.09.2030", name: "Municipio de Yalagüina" },
    { code: "NI.09.2035", name: "Municipio de San Lucas" },
    { code: "NI.09.2040", name: "Municipio de Las Sabanas" },
    { code: "NI.09.2045", name: "Municipio de San José de Cusmapa" },
  ],
  "NI.10": [
    { code: "NI.10.5505", name: "Municipio de San Francisco Libre" },
    { code: "NI.10.5510", name: "Municipio de Tipitapa" },
    { code: "NI.10.5515", name: "Municipio de Mateare" },
    { code: "NI.10.5520", name: "Villa El Carmen" },
    { code: "NI.10.5522", name: "Ciudad Sandino" },
    { code: "NI.10.5525", name: "Municipio de Managua" },
    { code: "NI.10.5530", name: "Ticuantepe" },
    { code: "NI.10.5532", name: "El Crucero" },
    { code: "NI.10.5535", name: "Municipio de San Rafael del Sur" },
  ],
  "NI.11": [
    { code: "NI.11.6005", name: "Municipio de Nindirí" },
    { code: "NI.11.6010", name: "Municipio de Masaya" },
    { code: "NI.11.6015", name: "Municipio de Tisma" },
    { code: "NI.11.6020", name: "Municipio de La Concepción" },
    { code: "NI.11.6025", name: "Municipio de Masatepe" },
    { code: "NI.11.6030", name: "Municipio de Nandasmo" },
    { code: "NI.11.6035", name: "Municipio de Catarina" },
    { code: "NI.11.6040", name: "Municipio de San Juan de Oriente" },
    { code: "NI.11.6045", name: "Municipio de Niquinohomo" },
  ],
  "NI.12": [
    { code: "NI.12.4005", name: "Municipio de Rancho Grande" },
    { code: "NI.12.4010", name: "Municipio de Río Blanco" },
    { code: "NI.12.4015", name: "Municipio del Tuma-La Dalia" },
    { code: "NI.12.4020", name: "Municipio de San Isidro" },
    { code: "NI.12.4025", name: "Municipio de Sébaco" },
    { code: "NI.12.4030", name: "Municipio de Matagalpa" },
    { code: "NI.12.4035", name: "Municipio de San Ramón" },
    { code: "NI.12.4040", name: "Municipio de Matiguás" },
    { code: "NI.12.4045", name: "Municipio de Muy Muy" },
    { code: "NI.12.4050", name: "Municipio de Esquipulas" },
    { code: "NI.12.4055", name: "Municipio de San Dionisio" },
    { code: "NI.12.4060", name: "Municipio de Terrabona" },
    { code: "NI.12.4065", name: "Municipio de Ciudad Darío" },
  ],
  "NI.13": [
    { code: "NI.13.0505", name: "Municipio de Jalapa" },
    { code: "NI.13.0510", name: "Municipio de Murra" },
    { code: "NI.13.0515", name: "El Jícaro" },
    { code: "NI.13.0520", name: "Municipio de San Fernando" },
    { code: "NI.13.0525", name: "Municipio de Mozonte" },
    { code: "NI.13.0530", name: "Municipio de Dipilto" },
    { code: "NI.13.0535", name: "Municipio de Macuelizo" },
    { code: "NI.13.0540", name: "Municipio de Santa María" },
    { code: "NI.13.0545", name: "Municipio de Ocotal" },
    { code: "NI.13.0550", name: "Municipio de Ciudad Antigua" },
    { code: "NI.13.0555", name: "Municipio de Quilalí" },
    { code: "NI.13.0560", name: "Wiwilí de Nueva Segovia" },
  ],
  "NI.14": [
    { code: "NI.14.8505", name: "Municipio de Morrito" },
    { code: "NI.14.8510", name: "El Almendro" },
    { code: "NI.14.8515", name: "Municipio de San Miguelito" },
    { code: "NI.14.8520", name: "Municipio de San Carlos" },
    { code: "NI.14.8525", name: "El Castillo" },
    { code: "NI.14.8530", name: "San Juan del Nicaragua" },
  ],
  "NI.15": [
    { code: "NI.15.8005", name: "Municipio de Tola" },
    { code: "NI.15.8010", name: "Municipio de Belén" },
    { code: "NI.15.8015", name: "Municipio de Potosí" },
    { code: "NI.15.8020", name: "Municipio de Buenos Aires" },
    { code: "NI.15.8025", name: "Municipio de Moyogalpa" },
    { code: "NI.15.8030", name: "Municipio de Altagracia" },
    { code: "NI.15.8035", name: "Municipio de San Jorge" },
    { code: "NI.15.8040", name: "Municipio de Rivas" },
    { code: "NI.15.8045", name: "Municipio de San Juan del Sur" },
    { code: "NI.15.8050", name: "Municipio de Cárdenas" },
  ],
  "NI.17": [
    { code: "NI.17.9105", name: "Municipio de Waspán" },
    { code: "NI.17.9110", name: "Municipio de Puerto Cabezas" },
    { code: "NI.17.9115", name: "Municipio de Rosita" },
    { code: "NI.17.9120", name: "Municipio de Bonanza" },
    { code: "NI.17.9125", name: "Municipio de Waslala" },
    { code: "NI.17.9127", name: "Mulukuku" },
    { code: "NI.17.9130", name: "Municipio de Siuna" },
    { code: "NI.17.9135", name: "Municipio de Prinzapolka" },
  ],
  "NI.18": [
    { code: "NI.18.9305", name: "Municipio de Bocana de Paiwas" },
    { code: "NI.18.9310", name: "Municipio de La Cruz de Río Grande" },
    { code: "NI.18.9312", name: "Desembocadura de la Cruz de Rio Grande" },
    { code: "NI.18.9315", name: "Municipio de Laguna" },
    { code: "NI.18.9316", name: "Municipio El Tortuguero" },
    { code: "NI.18.9320", name: "El Rama" },
    { code: "NI.18.9323", name: "Municipio El Ayote" },
    { code: "NI.18.9325", name: "Municipio de Muelle de los Bueyes" },
    { code: "NI.18.9330", name: "Municipio de Kukra Hill" },
    { code: "NI.18.9335", name: "Municipio de Corn Island" },
    { code: "NI.18.9340", name: "Municipio de Bluefields" },
    { code: "NI.18.9345", name: "Nueva Guinea" },
  ],
  "NL.01": [
    { code: "NL.01.0106", name: "Gemeente Assen" },
    { code: "NL.01.0109", name: "Gemeente Coevorden" },
    { code: "NL.01.0114", name: "Gemeente Emmen" },
    { code: "NL.01.0118", name: "Gemeente Hoogeveen" },
    { code: "NL.01.0119", name: "Gemeente Meppel" },
    { code: "NL.01.1680", name: "Gemeente Aa en Hunze" },
    { code: "NL.01.1681", name: "Gemeente Borger-Odoorn" },
    { code: "NL.01.1690", name: "Gemeente De Wolden" },
    { code: "NL.01.1699", name: "Gemeente Noordenveld" },
    { code: "NL.01.1701", name: "Gemeente Westerveld" },
    { code: "NL.01.1730", name: "Gemeente Tynaarlo" },
    { code: "NL.01.1731", name: "Gemeente Midden-Drenthe" },
  ],
  "NL.02": [
    { code: "NL.02.0059", name: "Gemeente Achtkarspelen" },
    { code: "NL.02.0060", name: "Gemeente Ameland" },
    { code: "NL.02.0072", name: "Gemeente Harlingen" },
    { code: "NL.02.0074", name: "Gemeente Heerenveen" },
    { code: "NL.02.0080", name: "Gemeente Leeuwarden" },
    { code: "NL.02.0085", name: "Gemeente Ooststellingwerf" },
    { code: "NL.02.0086", name: "Gemeente Opsterland" },
    { code: "NL.02.0088", name: "Gemeente Schiermonnikoog" },
    { code: "NL.02.0090", name: "Gemeente Smallingerland" },
    { code: "NL.02.0093", name: "Gemeente Terschelling" },
    { code: "NL.02.0096", name: "Gemeente Vlieland" },
    { code: "NL.02.0098", name: "Gemeente Weststellingwerf" },
    { code: "NL.02.0737", name: "Gemeente Tytsjerksteradiel" },
    { code: "NL.02.1891", name: "Gemeente Dantumadiel" },
    { code: "NL.02.1900", name: "Sûdwest Fryslân" },
    { code: "NL.02.1940", name: "De Fryske Marren" },
    { code: "NL.02.1949", name: "Waadhoeke" },
    { code: "NL.02.1970", name: "Noardeast-Fryslân" },
  ],
  "NL.03": [
    { code: "NL.03.0197", name: "Gemeente Aalten" },
    { code: "NL.03.0200", name: "Gemeente Apeldoorn" },
    { code: "NL.03.0202", name: "Gemeente Arnhem" },
    { code: "NL.03.0203", name: "Gemeente Barneveld" },
    { code: "NL.03.0209", name: "Gemeente Beuningen" },
    { code: "NL.03.0213", name: "Gemeente Brummen" },
    { code: "NL.03.0214", name: "Gemeente Buren" },
    { code: "NL.03.0216", name: "Gemeente Culemborg" },
    { code: "NL.03.0221", name: "Gemeente Doesburg" },
    { code: "NL.03.0222", name: "Gemeente Doetinchem" },
    { code: "NL.03.0225", name: "Gemeente Druten" },
    { code: "NL.03.0226", name: "Gemeente Duiven" },
    { code: "NL.03.0228", name: "Gemeente Ede" },
    { code: "NL.03.0230", name: "Gemeente Elburg" },
    { code: "NL.03.0232", name: "Gemeente Epe" },
    { code: "NL.03.0233", name: "Gemeente Ermelo" },
    { code: "NL.03.0243", name: "Gemeente Harderwijk" },
    { code: "NL.03.0244", name: "Gemeente Hattem" },
    { code: "NL.03.0246", name: "Gemeente Heerde" },
    { code: "NL.03.0252", name: "Gemeente Heumen" },
    { code: "NL.03.0262", name: "Gemeente Lochem" },
    { code: "NL.03.0263", name: "Gemeente Maasdriel" },
    { code: "NL.03.0267", name: "Gemeente Nijkerk" },
    { code: "NL.03.0268", name: "Gemeente Nijmegen" },
    { code: "NL.03.0269", name: "Gemeente Oldebroek" },
    { code: "NL.03.0273", name: "Gemeente Putten" },
    { code: "NL.03.0274", name: "Gemeente Renkum" },
    { code: "NL.03.0275", name: "Gemeente Rheden" },
    { code: "NL.03.0277", name: "Gemeente Rozendaal" },
    { code: "NL.03.0279", name: "Gemeente Scherpenzeel" },
    { code: "NL.03.0281", name: "Gemeente Tiel" },
    { code: "NL.03.0285", name: "Gemeente Voorst" },
    { code: "NL.03.0289", name: "Gemeente Wageningen" },
    { code: "NL.03.0293", name: "Gemeente Westervoort" },
    { code: "NL.03.0294", name: "Gemeente Winterswijk" },
    { code: "NL.03.0296", name: "Gemeente Wijchen" },
    { code: "NL.03.0297", name: "Gemeente Zaltbommel" },
    { code: "NL.03.0299", name: "Gemeente Zevenaar" },
    { code: "NL.03.0301", name: "Gemeente Zutphen" },
    { code: "NL.03.0302", name: "Gemeente Nunspeet" },
    { code: "NL.03.0668", name: "Gemeente West Maas en Waal" },
    { code: "NL.03.1509", name: "Oude IJsselstreek" },
    { code: "NL.03.1586", name: "Oost Gelre" },
    { code: "NL.03.1705", name: "Gemeente Lingewaard" },
    { code: "NL.03.1734", name: "Gemeente Overbetuwe" },
    { code: "NL.03.1740", name: "Gemeente Neder-Betuwe" },
    { code: "NL.03.1859", name: "Berkelland" },
    { code: "NL.03.1876", name: "Gemeente Bronckhorst" },
    { code: "NL.03.1945", name: "Gemeente Berg en Dal" },
    { code: "NL.03.1955", name: "Gemeente Montferland" },
    { code: "NL.03.1960", name: "West Betuwe" },
  ],
  "NL.04": [
    { code: "NL.04.0003", name: "Gemeente Appingedam" },
    { code: "NL.04.0010", name: "Gemeente Delfzijl" },
    { code: "NL.04.0014", name: "Gemeente Groningen" },
    { code: "NL.04.0024", name: "Gemeente Loppersum" },
    { code: "NL.04.0037", name: "Gemeente Stadskanaal" },
    { code: "NL.04.0047", name: "Gemeente Veendam" },
    { code: "NL.04.0765", name: "Gemeente Pekela" },
    { code: "NL.04.1895", name: "Gemeente  Oldambt" },
    { code: "NL.04.1950", name: "Westerwolde" },
    { code: "NL.04.1952", name: "Midden-Groningen" },
    { code: "NL.04.1966", name: "Het Hogeland" },
    { code: "NL.04.1969", name: "Westerkwartier" },
  ],
  "NL.05": [
    { code: "NL.05.0882", name: "Landgraaf" },
    { code: "NL.05.0888", name: "Gemeente Beek" },
    { code: "NL.05.0889", name: "Gemeente Beesel" },
    { code: "NL.05.0893", name: "Gemeente Bergen" },
    { code: "NL.05.0899", name: "Gemeente Brunssum" },
    { code: "NL.05.0907", name: "Gemeente Gennep" },
    { code: "NL.05.0917", name: "Gemeente Heerlen" },
    { code: "NL.05.0928", name: "Gemeente Kerkrade" },
    { code: "NL.05.0935", name: "Gemeente Maastricht" },
    { code: "NL.05.0938", name: "Gemeente Meerssen" },
    { code: "NL.05.0944", name: "Gemeente Mook en Middelaar" },
    { code: "NL.05.0946", name: "Gemeente Nederweert" },
    { code: "NL.05.0957", name: "Gemeente Roermond" },
    { code: "NL.05.0965", name: "Gemeente Simpelveld" },
    { code: "NL.05.0971", name: "Gemeente Stein" },
    { code: "NL.05.0981", name: "Gemeente Vaals" },
    { code: "NL.05.0983", name: "Gemeente Venlo" },
    { code: "NL.05.0984", name: "Gemeente Venray" },
    { code: "NL.05.0986", name: "Gemeente Voerendaal" },
    { code: "NL.05.0988", name: "Gemeente Weert" },
    { code: "NL.05.0994", name: "Valkenburg aan de Geul" },
    { code: "NL.05.1507", name: "Gemeente Horst aan de Maas" },
    { code: "NL.05.1640", name: "Gemeente Leudal" },
    { code: "NL.05.1641", name: "Gemeente Maasgouw" },
    { code: "NL.05.1669", name: "Gemeente Roerdalen" },
    { code: "NL.05.1711", name: "Gemeente Echt-Susteren" },
    { code: "NL.05.1729", name: "Gulpen-Wittem" },
    { code: "NL.05.1883", name: "Gemeente Sittard-Geleen" },
    { code: "NL.05.1894", name: "Gemeente Peel en Maas" },
    { code: "NL.05.1903", name: "Eijsden-Margraten" },
    { code: "NL.05.1954", name: "Beekdaelen" },
  ],
  "NL.06": [
    { code: "NL.06.0743", name: "Gemeente Asten" },
    { code: "NL.06.0744", name: "Gemeente Baarle-Nassau" },
    { code: "NL.06.0748", name: "Gemeente Bergen op Zoom" },
    { code: "NL.06.0753", name: "Gemeente Best" },
    { code: "NL.06.0755", name: "Gemeente Boekel" },
    { code: "NL.06.0756", name: "Gemeente Boxmeer" },
    { code: "NL.06.0757", name: "Gemeente Boxtel" },
    { code: "NL.06.0758", name: "Gemeente Breda" },
    { code: "NL.06.0762", name: "Gemeente Deurne" },
    { code: "NL.06.0766", name: "Gemeente Dongen" },
    { code: "NL.06.0770", name: "Gemeente Eersel" },
    { code: "NL.06.0772", name: "Gemeente Eindhoven" },
    { code: "NL.06.0777", name: "Gemeente Etten-Leur" },
    { code: "NL.06.0779", name: "Gemeente Geertruidenberg" },
    { code: "NL.06.0784", name: "Gemeente Gilze en Rijen" },
    { code: "NL.06.0785", name: "Gemeente Goirle" },
    { code: "NL.06.0786", name: "Gemeente Grave" },
    { code: "NL.06.0788", name: "Gemeente Haaren" },
    { code: "NL.06.0794", name: "Gemeente Helmond" },
    { code: "NL.06.0796", name: "Gemeente 's-Hertogenbosch" },
    { code: "NL.06.0797", name: "Gemeente Heusden" },
    { code: "NL.06.0798", name: "Gemeente Hilvarenbeek" },
    { code: "NL.06.0809", name: "Gemeente Loon op Zand" },
    { code: "NL.06.0815", name: "Gemeente Mill en Sint Hubert" },
    { code: "NL.06.0820", name: "Gemeente Nuenen, Gerwen en Nederwetten" },
    { code: "NL.06.0823", name: "Gemeente Oirschot" },
    { code: "NL.06.0824", name: "Gemeente Oisterwijk" },
    { code: "NL.06.0826", name: "Gemeente Oosterhout" },
    { code: "NL.06.0828", name: "Gemeente Oss" },
    { code: "NL.06.0840", name: "Gemeente Rucphen" },
    { code: "NL.06.0845", name: "Gemeente Sint-Michielsgestel" },
    { code: "NL.06.0847", name: "Gemeente Someren" },
    { code: "NL.06.0848", name: "Gemeente Son en Breugel" },
    { code: "NL.06.0851", name: "Gemeente Steenbergen" },
    { code: "NL.06.0855", name: "Gemeente Tilburg" },
    { code: "NL.06.0856", name: "Gemeente Uden" },
    { code: "NL.06.0858", name: "Gemeente Valkenswaard" },
    { code: "NL.06.0861", name: "Gemeente Veldhoven" },
    { code: "NL.06.0865", name: "Gemeente Vught" },
    { code: "NL.06.0866", name: "Gemeente Waalre" },
    { code: "NL.06.0867", name: "Gemeente Waalwijk" },
    { code: "NL.06.0873", name: "Gemeente Woensdrecht" },
    { code: "NL.06.0879", name: "Gemeente Zundert" },
    { code: "NL.06.1652", name: "Gemeente Gemert-Bakel" },
    { code: "NL.06.1655", name: "Gemeente Halderberge" },
    { code: "NL.06.1658", name: "Gemeente Heeze-Leende" },
    { code: "NL.06.1659", name: "Gemeente Laarbeek" },
    { code: "NL.06.1667", name: "Gemeente Reusel-De Mierden" },
    { code: "NL.06.1674", name: "Roosendaal" },
    { code: "NL.06.1684", name: "Gemeente Cuijk" },
    { code: "NL.06.1685", name: "Gemeente Landerd" },
    { code: "NL.06.1702", name: "Gemeente Sint Anthonis" },
    { code: "NL.06.1706", name: "Gemeente Cranendonck" },
    { code: "NL.06.1709", name: "Gemeente Moerdijk" },
    { code: "NL.06.1719", name: "Gemeente Drimmelen" },
    { code: "NL.06.1721", name: "Gemeente Bernheze" },
    { code: "NL.06.1723", name: "Gemeente Alphen-Chaam" },
    { code: "NL.06.1724", name: "Bergeijk" },
    { code: "NL.06.1728", name: "Gemeente Bladel" },
    { code: "NL.06.1771", name: "Gemeente Geldrop-Mierlo" },
    { code: "NL.06.1948", name: "Meierijstad" },
    { code: "NL.06.1959", name: "Altena" },
  ],
  "NL.07": [
    { code: "NL.07.0358", name: "Gemeente Aalsmeer" },
    { code: "NL.07.0361", name: "Gemeente Alkmaar" },
    { code: "NL.07.0362", name: "Gemeente Amstelveen" },
    { code: "NL.07.0363", name: "Gemeente Amsterdam" },
    { code: "NL.07.0370", name: "Gemeente Beemster" },
    { code: "NL.07.0373", name: "Gemeente Bergen" },
    { code: "NL.07.0375", name: "Gemeente Beverwijk" },
    { code: "NL.07.0376", name: "Gemeente Blaricum" },
    { code: "NL.07.0377", name: "Gemeente Bloemendaal" },
    { code: "NL.07.0383", name: "Gemeente Castricum" },
    { code: "NL.07.0384", name: "Gemeente Diemen" },
    { code: "NL.07.0385", name: "Gemeente Edam-Volendam" },
    { code: "NL.07.0388", name: "Gemeente Enkhuizen" },
    { code: "NL.07.0392", name: "Gemeente Haarlem" },
    { code: "NL.07.0394", name: "Gemeente Haarlemmermeer" },
    { code: "NL.07.0396", name: "Gemeente Heemskerk" },
    { code: "NL.07.0397", name: "Gemeente Heemstede" },
    { code: "NL.07.0398", name: "Gemeente Heerhugowaard" },
    { code: "NL.07.0399", name: "Gemeente Heiloo" },
    { code: "NL.07.0400", name: "Gemeente Den Helder" },
    { code: "NL.07.0402", name: "Gemeente Hilversum" },
    { code: "NL.07.0405", name: "Gemeente Hoorn" },
    { code: "NL.07.0406", name: "Gemeente Huizen" },
    { code: "NL.07.0415", name: "Gemeente Landsmeer" },
    { code: "NL.07.0416", name: "Gemeente Langedijk" },
    { code: "NL.07.0417", name: "Gemeente Laren" },
    { code: "NL.07.0420", name: "Gemeente Medemblik" },
    { code: "NL.07.0431", name: "Gemeente Oostzaan" },
    { code: "NL.07.0432", name: "Gemeente Opmeer" },
    { code: "NL.07.0437", name: "Gemeente Ouder-Amstel" },
    { code: "NL.07.0439", name: "Gemeente Purmerend" },
    { code: "NL.07.0441", name: "Gemeente Schagen" },
    { code: "NL.07.0448", name: "Gemeente Texel" },
    { code: "NL.07.0450", name: "Gemeente Uitgeest" },
    { code: "NL.07.0451", name: "Gemeente Uithoorn" },
    { code: "NL.07.0453", name: "Gemeente Velsen" },
    { code: "NL.07.0457", name: "Gemeente Weesp" },
    { code: "NL.07.0473", name: "Gemeente Zandvoort" },
    { code: "NL.07.0479", name: "Gemeente Zaanstad" },
    { code: "NL.07.0498", name: "Gemeente Drechterland" },
    { code: "NL.07.0532", name: "Gemeente Stede Broec" },
    { code: "NL.07.0852", name: "Gemeente Waterland" },
    { code: "NL.07.0880", name: "Gemeente Wormerland" },
    { code: "NL.07.1598", name: "Gemeente Koggenland" },
    { code: "NL.07.1696", name: "Gemeente Wijdemeren" },
    { code: "NL.07.1911", name: "Gemeente Hollands Kroon" },
    { code: "NL.07.1942", name: "Gooise Meren" },
  ],
  "NL.09": [
    { code: "NL.09.0307", name: "Gemeente Amersfoort" },
    { code: "NL.09.0308", name: "Gemeente Baarn" },
    { code: "NL.09.0310", name: "Gemeente De Bilt" },
    { code: "NL.09.0312", name: "Gemeente Bunnik" },
    { code: "NL.09.0313", name: "Gemeente Bunschoten" },
    { code: "NL.09.0317", name: "Gemeente Eemnes" },
    { code: "NL.09.0321", name: "Gemeente Houten" },
    { code: "NL.09.0327", name: "Gemeente Leusden" },
    { code: "NL.09.0331", name: "Gemeente Lopik" },
    { code: "NL.09.0335", name: "Gemeente Montfoort" },
    { code: "NL.09.0339", name: "Gemeente Renswoude" },
    { code: "NL.09.0340", name: "Gemeente Rhenen" },
    { code: "NL.09.0342", name: "Gemeente Soest" },
    { code: "NL.09.0344", name: "Gemeente Utrecht" },
    { code: "NL.09.0345", name: "Gemeente Veenendaal" },
    { code: "NL.09.0351", name: "Gemeente Woudenberg" },
    { code: "NL.09.0352", name: "Gemeente Wijk bij Duurstede" },
    { code: "NL.09.0353", name: "Gemeente IJsselstein" },
    { code: "NL.09.0355", name: "Gemeente Zeist" },
    { code: "NL.09.0356", name: "Gemeente Nieuwegein" },
    { code: "NL.09.0589", name: "Gemeente Oudewater" },
    { code: "NL.09.0632", name: "Gemeente Woerden" },
    { code: "NL.09.0736", name: "Gemeente De Ronde Venen" },
    { code: "NL.09.1581", name: "Gemeente Utrechtse Heuvelrug" },
    { code: "NL.09.1904", name: "Stichtse Vecht" },
    { code: "NL.09.1961", name: "Vijfheerenlanden" },
  ],
  "NL.10": [
    { code: "NL.10.0654", name: "Gemeente Borsele" },
    { code: "NL.10.0664", name: "Gemeente Goes" },
    { code: "NL.10.0677", name: "Gemeente Hulst" },
    { code: "NL.10.0678", name: "Gemeente Kapelle" },
    { code: "NL.10.0687", name: "Gemeente Middelburg" },
    { code: "NL.10.0703", name: "Gemeente Reimerswaal" },
    { code: "NL.10.0715", name: "Gemeente Terneuzen" },
    { code: "NL.10.0716", name: "Gemeente Tholen" },
    { code: "NL.10.0717", name: "Gemeente Veere" },
    { code: "NL.10.0718", name: "Gemeente Vlissingen" },
    { code: "NL.10.1676", name: "Schouwen-Duiveland" },
    { code: "NL.10.1695", name: "Gemeente Noord-Beveland" },
    { code: "NL.10.1714", name: "Gemeente Sluis" },
  ],
  "NL.11": [
    { code: "NL.11.0482", name: "Gemeente Alblasserdam" },
    { code: "NL.11.0484", name: "Gemeente Alphen aan den Rijn" },
    { code: "NL.11.0489", name: "Gemeente Barendrecht" },
    { code: "NL.11.0501", name: "Gemeente Brielle" },
    { code: "NL.11.0502", name: "Gemeente Capelle aan den IJssel" },
    { code: "NL.11.0503", name: "Gemeente Delft" },
    { code: "NL.11.0505", name: "Gemeente Dordrecht" },
    { code: "NL.11.0512", name: "Gemeente Gorinchem" },
    { code: "NL.11.0513", name: "Gemeente Gouda" },
    { code: "NL.11.0518", name: "Gemeente Den Haag" },
    { code: "NL.11.0523", name: "Gemeente Hardinxveld-Giessendam" },
    { code: "NL.11.0530", name: "Gemeente Hellevoetsluis" },
    { code: "NL.11.0531", name: "Gemeente Hendrik-Ido-Ambacht" },
    { code: "NL.11.0534", name: "Gemeente Hillegom" },
    { code: "NL.11.0537", name: "Gemeente Katwijk" },
    { code: "NL.11.0542", name: "Gemeente Krimpen aan den IJssel" },
    { code: "NL.11.0546", name: "Gemeente Leiden" },
    { code: "NL.11.0547", name: "Gemeente Leiderdorp" },
    { code: "NL.11.0553", name: "Gemeente Lisse" },
    { code: "NL.11.0556", name: "Gemeente Maassluis" },
    { code: "NL.11.0569", name: "Gemeente Nieuwkoop" },
    { code: "NL.11.0575", name: "Gemeente Noordwijk" },
    { code: "NL.11.0579", name: "Gemeente Oegstgeest" },
    { code: "NL.11.0590", name: "Gemeente Papendrecht" },
    { code: "NL.11.0597", name: "Gemeente Ridderkerk" },
    { code: "NL.11.0599", name: "Gemeente Rotterdam" },
    { code: "NL.11.0603", name: "Gemeente Rijswijk" },
    { code: "NL.11.0606", name: "Gemeente Schiedam" },
    { code: "NL.11.0610", name: "Gemeente Sliedrecht" },
    { code: "NL.11.0613", name: "Gemeente Albrandswaard" },
    { code: "NL.11.0614", name: "Gemeente Westvoorne" },
    { code: "NL.11.0622", name: "Gemeente Vlaardingen" },
    { code: "NL.11.0626", name: "Gemeente Voorschoten" },
    { code: "NL.11.0627", name: "Gemeente Waddinxveen" },
    { code: "NL.11.0629", name: "Gemeente Wassenaar" },
    { code: "NL.11.0637", name: "Gemeente Zoetermeer" },
    { code: "NL.11.0638", name: "Gemeente Zoeterwoude" },
    { code: "NL.11.0642", name: "Gemeente Zwijndrecht" },
    { code: "NL.11.1525", name: "Gemeente Teylingen" },
    { code: "NL.11.1621", name: "Gemeente Lansingerland" },
    { code: "NL.11.1783", name: "Gemeente Westland" },
    { code: "NL.11.1842", name: "Gemeente Midden-Delfland" },
    { code: "NL.11.1884", name: "Gemeente Kaag en Braassem" },
    { code: "NL.11.1892", name: "Gemeente Zuidplas" },
    { code: "NL.11.1901", name: "Bodegraven-Reeuwijk" },
    { code: "NL.11.1916", name: "Gemeente Leidschendam-Voorburg" },
    { code: "NL.11.1924", name: "Gemeente Goeree-Overflakkee" },
    { code: "NL.11.1926", name: "Gemeente Pijnacker-Nootdorp" },
    { code: "NL.11.1930", name: "Nissewaard" },
    { code: "NL.11.1931", name: "Krimpenerwaard" },
    { code: "NL.11.1963", name: "Hoeksche Waard" },
    { code: "NL.11.1978", name: "Molenlanden" },
  ],
  "NL.15": [
    { code: "NL.15.0141", name: "Gemeente Almelo" },
    { code: "NL.15.0147", name: "Gemeente Borne" },
    { code: "NL.15.0148", name: "Gemeente Dalfsen" },
    { code: "NL.15.0150", name: "Gemeente Deventer" },
    { code: "NL.15.0153", name: "Gemeente Enschede" },
    { code: "NL.15.0158", name: "Gemeente Haaksbergen" },
    { code: "NL.15.0160", name: "Gemeente Hardenberg" },
    { code: "NL.15.0163", name: "Gemeente Hellendoorn" },
    { code: "NL.15.0164", name: "Gemeente Hengelo" },
    { code: "NL.15.0166", name: "Gemeente Kampen" },
    { code: "NL.15.0168", name: "Gemeente Losser" },
    { code: "NL.15.0173", name: "Gemeente Oldenzaal" },
    { code: "NL.15.0175", name: "Gemeente Ommen" },
    { code: "NL.15.0177", name: "Gemeente Raalte" },
    { code: "NL.15.0180", name: "Gemeente Staphorst" },
    { code: "NL.15.0183", name: "Gemeente Tubbergen" },
    { code: "NL.15.0189", name: "Gemeente Wierden" },
    { code: "NL.15.0193", name: "Gemeente Zwolle" },
    { code: "NL.15.1700", name: "Gemeente Twenterand" },
    { code: "NL.15.1708", name: "Gemeente Steenwijkerland" },
    { code: "NL.15.1735", name: "Gemeente Hof van Twente" },
    { code: "NL.15.1742", name: "Gemeente Rijssen-Holten" },
    { code: "NL.15.1773", name: "Gemeente Olst-Wijhe" },
    { code: "NL.15.1774", name: "Gemeente Dinkelland" },
    { code: "NL.15.1896", name: "Gemeente Zwartewaterland" },
  ],
  "NL.16": [
    { code: "NL.16.0034", name: "Gemeente Almere" },
    { code: "NL.16.0050", name: "Gemeente Zeewolde" },
    { code: "NL.16.0171", name: "Gemeente Noordoostpolder" },
    { code: "NL.16.0184", name: "Gemeente Urk" },
    { code: "NL.16.0303", name: "Gemeente Dronten" },
    { code: "NL.16.0995", name: "Gemeente Lelystad" },
  ],
  "NO.08": [
    { code: "NO.08.1505", name: "Kristiansund" },
    { code: "NO.08.1506", name: "Molde" },
    { code: "NO.08.1507", name: "Ålesund" },
    { code: "NO.08.1511", name: "Vanylven" },
    { code: "NO.08.1514", name: "Sande" },
    { code: "NO.08.1515", name: "Herøy" },
    { code: "NO.08.1516", name: "Ulstein" },
    { code: "NO.08.1517", name: "Hareid" },
    { code: "NO.08.1520", name: "Ørsta" },
    { code: "NO.08.1525", name: "Stranda" },
    { code: "NO.08.1528", name: "Sykkylven" },
    { code: "NO.08.1531", name: "Sula" },
    { code: "NO.08.1532", name: "Giske" },
    { code: "NO.08.1535", name: "Vestnes" },
    { code: "NO.08.1539", name: "Rauma" },
    { code: "NO.08.1547", name: "Aukra" },
    { code: "NO.08.1554", name: "Averøy" },
    { code: "NO.08.1557", name: "Gjemnes" },
    { code: "NO.08.1560", name: "Tingvoll" },
    { code: "NO.08.1563", name: "Sunndal" },
    { code: "NO.08.1566", name: "Surnadal" },
    { code: "NO.08.1573", name: "Smøla" },
    { code: "NO.08.1576", name: "Aure" },
    { code: "NO.08.1577", name: "Volda" },
    { code: "NO.08.1578", name: "Fjord" },
    { code: "NO.08.1579", name: "Hustadvika" },
  ],
  "NO.09": [
    { code: "NO.09.1804", name: "Bodø" },
    { code: "NO.09.1806", name: "Narvik" },
    { code: "NO.09.1811", name: "Bindal" },
    { code: "NO.09.1812", name: "Sømna" },
    { code: "NO.09.1813", name: "Brønnøy" },
    { code: "NO.09.1815", name: "Vega" },
    { code: "NO.09.1816", name: "Vevelstad" },
    { code: "NO.09.1818", name: "Herøy" },
    { code: "NO.09.1820", name: "Alstahaug" },
    { code: "NO.09.1822", name: "Leirfjord" },
    { code: "NO.09.1824", name: "Vefsn" },
    { code: "NO.09.1825", name: "Grane" },
    { code: "NO.09.1826", name: "Hattfjelldal" },
    { code: "NO.09.1827", name: "Dønna" },
    { code: "NO.09.1828", name: "Nesna" },
    { code: "NO.09.1832", name: "Hemnes" },
    { code: "NO.09.1833", name: "Rana" },
    { code: "NO.09.1834", name: "Lurøy" },
    { code: "NO.09.1835", name: "Træna" },
    { code: "NO.09.1836", name: "Rødøy" },
    { code: "NO.09.1837", name: "Meløy" },
    { code: "NO.09.1838", name: "Gildeskål" },
    { code: "NO.09.1839", name: "Beiarn" },
    { code: "NO.09.1840", name: "Saltdal" },
    { code: "NO.09.1841", name: "Fauske" },
    { code: "NO.09.1845", name: "Sørfold" },
    { code: "NO.09.1848", name: "Steigen" },
    { code: "NO.09.1851", name: "Lødingen" },
    { code: "NO.09.1853", name: "Evenes" },
    { code: "NO.09.1856", name: "Røst" },
    { code: "NO.09.1857", name: "Værøy" },
    { code: "NO.09.1859", name: "Flakstad" },
    { code: "NO.09.1860", name: "Vestvågøy" },
    { code: "NO.09.1865", name: "Vågan" },
    { code: "NO.09.1866", name: "Hadsel" },
    { code: "NO.09.1867", name: "Bø" },
    { code: "NO.09.1868", name: "Øksnes" },
    { code: "NO.09.1870", name: "Sortland" },
    { code: "NO.09.1871", name: "Andøy" },
    { code: "NO.09.1874", name: "Moskenes" },
    { code: "NO.09.1875", name: "Hamarøy" },
  ],
  "NO.12": [
    { code: "NO.12.0301", name: "Oslo" },
  ],
  "NO.14": [
    { code: "NO.14.1101", name: "Eigersund" },
    { code: "NO.14.1103", name: "Stavanger" },
    { code: "NO.14.1106", name: "Haugesund" },
    { code: "NO.14.1108", name: "Sandnes" },
    { code: "NO.14.1111", name: "Sokndal" },
    { code: "NO.14.1112", name: "Lund" },
    { code: "NO.14.1114", name: "Bjerkreim" },
    { code: "NO.14.1119", name: "Hå" },
    { code: "NO.14.1120", name: "Klepp" },
    { code: "NO.14.1121", name: "Time" },
    { code: "NO.14.1122", name: "Gjesdal" },
    { code: "NO.14.1124", name: "Sola" },
    { code: "NO.14.1127", name: "Randaberg" },
    { code: "NO.14.1130", name: "Strand" },
    { code: "NO.14.1133", name: "Hjelmeland" },
    { code: "NO.14.1134", name: "Suldal" },
    { code: "NO.14.1135", name: "Sauda" },
    { code: "NO.14.1144", name: "Kvitsøy" },
    { code: "NO.14.1145", name: "Bokn" },
    { code: "NO.14.1146", name: "Tysvær" },
    { code: "NO.14.1149", name: "Karmøy" },
    { code: "NO.14.1151", name: "Utsira" },
    { code: "NO.14.1160", name: "Vindafjord" },
  ],
  "NO.21": [
    { code: "NO.21.5001", name: "Trondheim" },
    { code: "NO.21.5006", name: "Steinkjer" },
    { code: "NO.21.5007", name: "Namsos" },
    { code: "NO.21.5014", name: "Frøya" },
    { code: "NO.21.5020", name: "Osen" },
    { code: "NO.21.5021", name: "Oppdal" },
    { code: "NO.21.5022", name: "Rennebu" },
    { code: "NO.21.5025", name: "Røros" },
    { code: "NO.21.5026", name: "Holtålen" },
    { code: "NO.21.5027", name: "Midtre Gauldal" },
    { code: "NO.21.5028", name: "Melhus" },
    { code: "NO.21.5029", name: "Skaun" },
    { code: "NO.21.5031", name: "Malvik" },
    { code: "NO.21.5032", name: "Selbu" },
    { code: "NO.21.5033", name: "Tydal" },
    { code: "NO.21.5034", name: "Meråker" },
    { code: "NO.21.5035", name: "Stjørdal" },
    { code: "NO.21.5036", name: "Frosta" },
    { code: "NO.21.5037", name: "Levanger" },
    { code: "NO.21.5038", name: "Verdal" },
    { code: "NO.21.5041", name: "Snåase - Snåsa" },
    { code: "NO.21.5042", name: "Lierne" },
    { code: "NO.21.5043", name: "Raarvihke - Røyrvik" },
    { code: "NO.21.5044", name: "Namsskogan" },
    { code: "NO.21.5045", name: "Grong" },
    { code: "NO.21.5046", name: "Høylandet" },
    { code: "NO.21.5047", name: "Overhalla" },
    { code: "NO.21.5049", name: "Flatanger" },
    { code: "NO.21.5052", name: "Leka" },
    { code: "NO.21.5053", name: "Inderøy" },
    { code: "NO.21.5054", name: "Indre Fosen" },
    { code: "NO.21.5055", name: "Heim" },
    { code: "NO.21.5056", name: "Hitra" },
    { code: "NO.21.5057", name: "Ørland" },
    { code: "NO.21.5058", name: "Åfjord" },
    { code: "NO.21.5059", name: "Orkland" },
    { code: "NO.21.5060", name: "Nærøysund" },
    { code: "NO.21.5061", name: "Rindal" },
  ],
  "NO.30": [
    { code: "NO.30.3001", name: "Halden" },
    { code: "NO.30.3002", name: "Moss" },
    { code: "NO.30.3003", name: "Sarpsborg" },
    { code: "NO.30.3004", name: "Fredrikstad" },
    { code: "NO.30.3005", name: "Drammen" },
    { code: "NO.30.3006", name: "Kongsberg" },
    { code: "NO.30.3007", name: "Ringerike" },
    { code: "NO.30.3011", name: "Hvaler" },
    { code: "NO.30.3012", name: "Aremark" },
    { code: "NO.30.3013", name: "Marker" },
    { code: "NO.30.3014", name: "Indre Østfold" },
    { code: "NO.30.3015", name: "Skiptvet" },
    { code: "NO.30.3016", name: "Rakkestad" },
    { code: "NO.30.3017", name: "Råde" },
    { code: "NO.30.3018", name: "Våler" },
    { code: "NO.30.3019", name: "Vestby" },
    { code: "NO.30.3020", name: "Nordre Follo" },
    { code: "NO.30.3021", name: "Ås" },
    { code: "NO.30.3022", name: "Frogn" },
    { code: "NO.30.3023", name: "Nesodden" },
    { code: "NO.30.3024", name: "Bærum" },
    { code: "NO.30.3025", name: "Asker" },
    { code: "NO.30.3026", name: "Aurskog-Høland" },
    { code: "NO.30.3027", name: "Rælingen" },
    { code: "NO.30.3028", name: "Enebakk" },
    { code: "NO.30.3029", name: "Lørenskog" },
    { code: "NO.30.3030", name: "Lillestrøm" },
    { code: "NO.30.3031", name: "Nittedal" },
    { code: "NO.30.3032", name: "Gjerdrum" },
    { code: "NO.30.3033", name: "Ullensaker" },
    { code: "NO.30.3034", name: "Nes" },
    { code: "NO.30.3035", name: "Eidsvoll" },
    { code: "NO.30.3036", name: "Nannestad" },
    { code: "NO.30.3037", name: "Hurdal" },
    { code: "NO.30.3038", name: "Hole" },
    { code: "NO.30.3039", name: "Flå" },
    { code: "NO.30.3040", name: "Nesbyen" },
    { code: "NO.30.3041", name: "Gol" },
    { code: "NO.30.3042", name: "Hemsedal" },
    { code: "NO.30.3043", name: "Ål" },
    { code: "NO.30.3044", name: "Hol" },
    { code: "NO.30.3045", name: "Sigdal" },
    { code: "NO.30.3046", name: "Krødsherad" },
    { code: "NO.30.3047", name: "Modum" },
    { code: "NO.30.3048", name: "Øvre Eiker" },
    { code: "NO.30.3049", name: "Lier" },
    { code: "NO.30.3050", name: "Flesberg" },
    { code: "NO.30.3051", name: "Rollag" },
    { code: "NO.30.3052", name: "Nore og Uvdal" },
    { code: "NO.30.3053", name: "Jevnaker" },
    { code: "NO.30.3054", name: "Lunner" },
  ],
  "NO.34": [
    { code: "NO.34.3401", name: "Kongsvinger" },
    { code: "NO.34.3403", name: "Hamar" },
    { code: "NO.34.3405", name: "Lillehammer" },
    { code: "NO.34.3407", name: "Gjøvik" },
    { code: "NO.34.3411", name: "Ringsaker" },
    { code: "NO.34.3412", name: "Løten" },
    { code: "NO.34.3413", name: "Stange" },
    { code: "NO.34.3414", name: "Nord-Odal" },
    { code: "NO.34.3415", name: "Sør-Odal" },
    { code: "NO.34.3416", name: "Eidskog" },
    { code: "NO.34.3417", name: "Grue" },
    { code: "NO.34.3418", name: "Åsnes" },
    { code: "NO.34.3419", name: "Våler" },
    { code: "NO.34.3420", name: "Elverum" },
    { code: "NO.34.3421", name: "Trysil" },
    { code: "NO.34.3422", name: "Åmot" },
    { code: "NO.34.3423", name: "Stor-Elvdal" },
    { code: "NO.34.3424", name: "Rendalen" },
    { code: "NO.34.3425", name: "Engerdal" },
    { code: "NO.34.3426", name: "Tolga" },
    { code: "NO.34.3427", name: "Tynset" },
    { code: "NO.34.3428", name: "Alvdal" },
    { code: "NO.34.3429", name: "Folldal" },
    { code: "NO.34.3430", name: "Os" },
    { code: "NO.34.3431", name: "Dovre" },
    { code: "NO.34.3432", name: "Lesja" },
    { code: "NO.34.3433", name: "Skjåk" },
    { code: "NO.34.3434", name: "Lom" },
    { code: "NO.34.3435", name: "Vågå" },
    { code: "NO.34.3436", name: "Nord-Fron" },
    { code: "NO.34.3437", name: "Sel" },
    { code: "NO.34.3438", name: "Sør-Fron" },
    { code: "NO.34.3439", name: "Ringebu" },
    { code: "NO.34.3440", name: "Øyer" },
    { code: "NO.34.3441", name: "Gausdal" },
    { code: "NO.34.3442", name: "Østre Toten" },
    { code: "NO.34.3443", name: "Vestre Toten" },
    { code: "NO.34.3446", name: "Gran" },
    { code: "NO.34.3447", name: "Søndre Land" },
    { code: "NO.34.3448", name: "Nordre Land" },
    { code: "NO.34.3449", name: "Sør-Aurdal" },
    { code: "NO.34.3450", name: "Etnedal" },
    { code: "NO.34.3451", name: "Nord-Aurdal" },
    { code: "NO.34.3452", name: "Vestre Slidre" },
    { code: "NO.34.3453", name: "Øystre Slidre" },
    { code: "NO.34.3454", name: "Vang" },
  ],
  "NO.38": [
    { code: "NO.38.3801", name: "Horten" },
    { code: "NO.38.3802", name: "Holmestrand" },
    { code: "NO.38.3803", name: "Tønsberg" },
    { code: "NO.38.3804", name: "Sandefjord" },
    { code: "NO.38.3805", name: "Larvik" },
    { code: "NO.38.3806", name: "Porsgrunn" },
    { code: "NO.38.3807", name: "Skien" },
    { code: "NO.38.3808", name: "Notodden" },
    { code: "NO.38.3811", name: "Færder" },
    { code: "NO.38.3812", name: "Siljan" },
    { code: "NO.38.3813", name: "Bamble" },
    { code: "NO.38.3814", name: "Kragerø" },
    { code: "NO.38.3815", name: "Drangedal" },
    { code: "NO.38.3816", name: "Nome" },
    { code: "NO.38.3817", name: "Midt-Telemark" },
    { code: "NO.38.3818", name: "Tinn" },
    { code: "NO.38.3819", name: "Hjartdal" },
    { code: "NO.38.3820", name: "Seljord" },
    { code: "NO.38.3821", name: "Kviteseid" },
    { code: "NO.38.3822", name: "Nissedal" },
    { code: "NO.38.3823", name: "Fyresdal" },
    { code: "NO.38.3824", name: "Tokke" },
    { code: "NO.38.3825", name: "Vinje" },
  ],
  "NO.42": [
    { code: "NO.42.4201", name: "Risør" },
    { code: "NO.42.4202", name: "Grimstad" },
    { code: "NO.42.4203", name: "Arendal" },
    { code: "NO.42.4204", name: "Kristiansand" },
    { code: "NO.42.4205", name: "Lindesnes" },
    { code: "NO.42.4206", name: "Farsund" },
    { code: "NO.42.4207", name: "Flekkefjord" },
    { code: "NO.42.4211", name: "Gjerstad" },
    { code: "NO.42.4212", name: "Vegårshei" },
    { code: "NO.42.4213", name: "Tvedestrand" },
    { code: "NO.42.4214", name: "Froland" },
    { code: "NO.42.4215", name: "Lillesand" },
    { code: "NO.42.4216", name: "Birkenes" },
    { code: "NO.42.4217", name: "Åmli" },
    { code: "NO.42.4218", name: "Iveland" },
    { code: "NO.42.4219", name: "Evje og Hornnes" },
    { code: "NO.42.4220", name: "Bygland" },
    { code: "NO.42.4221", name: "Valle" },
    { code: "NO.42.4222", name: "Bykle" },
    { code: "NO.42.4223", name: "Vennesla" },
    { code: "NO.42.4224", name: "Åseral" },
    { code: "NO.42.4225", name: "Lyngdal" },
    { code: "NO.42.4226", name: "Hægebostad" },
    { code: "NO.42.4227", name: "Kvinesdal" },
    { code: "NO.42.4228", name: "Sirdal" },
  ],
  "NO.46": [
    { code: "NO.46.4601", name: "Bergen" },
    { code: "NO.46.4602", name: "Kinn" },
    { code: "NO.46.4611", name: "Etne" },
    { code: "NO.46.4612", name: "Sveio" },
    { code: "NO.46.4613", name: "Bømlo" },
    { code: "NO.46.4614", name: "Stord" },
    { code: "NO.46.4615", name: "Fitjar" },
    { code: "NO.46.4616", name: "Tysnes" },
    { code: "NO.46.4617", name: "Kvinnherad" },
    { code: "NO.46.4618", name: "Ullensvang" },
    { code: "NO.46.4619", name: "Eidfjord" },
    { code: "NO.46.4620", name: "Ulvik" },
    { code: "NO.46.4621", name: "Voss" },
    { code: "NO.46.4622", name: "Kvam" },
    { code: "NO.46.4623", name: "Samnanger" },
    { code: "NO.46.4624", name: "Bjørnafjorden" },
    { code: "NO.46.4625", name: "Austevoll" },
    { code: "NO.46.4626", name: "Øygarden" },
    { code: "NO.46.4627", name: "Askøy" },
    { code: "NO.46.4628", name: "Vaksdal" },
    { code: "NO.46.4629", name: "Modalen" },
    { code: "NO.46.4630", name: "Osterøy" },
    { code: "NO.46.4631", name: "Alver" },
    { code: "NO.46.4632", name: "Austrheim" },
    { code: "NO.46.4633", name: "Fedje" },
    { code: "NO.46.4634", name: "Masfjorden" },
    { code: "NO.46.4635", name: "Gulen" },
    { code: "NO.46.4636", name: "Solund" },
    { code: "NO.46.4637", name: "Hyllestad" },
    { code: "NO.46.4638", name: "Høyanger" },
    { code: "NO.46.4639", name: "Vik" },
    { code: "NO.46.4640", name: "Sogndal" },
    { code: "NO.46.4641", name: "Aurland" },
    { code: "NO.46.4642", name: "Lærdal" },
    { code: "NO.46.4643", name: "Årdal" },
    { code: "NO.46.4644", name: "Luster" },
    { code: "NO.46.4645", name: "Askvoll" },
    { code: "NO.46.4646", name: "Fjaler" },
    { code: "NO.46.4647", name: "Sunnfjord" },
    { code: "NO.46.4648", name: "Bremanger" },
    { code: "NO.46.4649", name: "Stad" },
    { code: "NO.46.4650", name: "Gloppen" },
    { code: "NO.46.4651", name: "Stryn" },
  ],
  "NO.54": [
    { code: "NO.54.5401", name: "Tromsø" },
    { code: "NO.54.5402", name: "Harstad" },
    { code: "NO.54.5403", name: "Alta" },
    { code: "NO.54.5404", name: "Vardø" },
    { code: "NO.54.5405", name: "Vadsø" },
    { code: "NO.54.5406", name: "Hammerfest" },
    { code: "NO.54.5411", name: "Kvæfjord" },
    { code: "NO.54.5412", name: "Tjeldsund" },
    { code: "NO.54.5413", name: "Ibestad" },
    { code: "NO.54.5414", name: "Gratangen" },
    { code: "NO.54.5415", name: "Lavangen" },
    { code: "NO.54.5416", name: "Bardu" },
    { code: "NO.54.5417", name: "Salangen" },
    { code: "NO.54.5418", name: "Målselv" },
    { code: "NO.54.5419", name: "Sørreisa" },
    { code: "NO.54.5420", name: "Dyrøy" },
    { code: "NO.54.5421", name: "Senja" },
    { code: "NO.54.5422", name: "Balsfjord" },
    { code: "NO.54.5423", name: "Karlsøy" },
    { code: "NO.54.5424", name: "Lyngen" },
    { code: "NO.54.5425", name: "Storfjord" },
    { code: "NO.54.5426", name: "Kåfjord" },
    { code: "NO.54.5427", name: "Skjervøy" },
    { code: "NO.54.5428", name: "Nordreisa" },
    { code: "NO.54.5429", name: "Kvænangen" },
    { code: "NO.54.5430", name: "Kautokeino" },
    { code: "NO.54.5432", name: "Loppa" },
    { code: "NO.54.5433", name: "Hasvik" },
    { code: "NO.54.5434", name: "Måsøy" },
    { code: "NO.54.5435", name: "Nordkapp" },
    { code: "NO.54.5436", name: "Porsanger" },
    { code: "NO.54.5437", name: "Karasjok" },
    { code: "NO.54.5438", name: "Lebesby" },
    { code: "NO.54.5439", name: "Gamvik" },
    { code: "NO.54.5440", name: "Berlevåg" },
    { code: "NO.54.5441", name: "Tana" },
    { code: "NO.54.5442", name: "Nesseby" },
    { code: "NO.54.5443", name: "Båtsfjord" },
    { code: "NO.54.5444", name: "Sør-Varanger" },
  ],
  "NP.1": [
    { code: "NP.1.12095460", name: "Bhojpur" },
    { code: "NP.1.12095467", name: "Dhankuta" },
    { code: "NP.1.12095475", name: "Ilam" },
    { code: "NP.1.12095477", name: "Jhapa" },
    { code: "NP.1.12095486", name: "Khotang" },
    { code: "NP.1.12095492", name: "Morang" },
    { code: "NP.1.12095498", name: "Okhaldhunga" },
    { code: "NP.1.12095500", name: "Panchthar" },
    { code: "NP.1.12095517", name: "Sankhuwasabha" },
    { code: "NP.1.12095523", name: "Solukhumbu" },
    { code: "NP.1.12095524", name: "Sunsari" },
    { code: "NP.1.12095528", name: "Taplejung" },
    { code: "NP.1.12095529", name: "Terathum" },
    { code: "NP.1.12095530", name: "Udayapur" },
  ],
  "NP.2": [
    { code: "NP.2.12095457", name: "Bara" },
    { code: "NP.2.12095468", name: "Dhanusa" },
    { code: "NP.2.12095489", name: "Mahottari" },
    { code: "NP.2.12095502", name: "Parsa" },
    { code: "NP.2.12095512", name: "Rautahat" },
    { code: "NP.2.12095518", name: "Saptari" },
    { code: "NP.2.12095519", name: "Sarlahi" },
    { code: "NP.2.12095522", name: "Siraha" },
  ],
  "NP.3": [
    { code: "NP.3.12095459", name: "Bhaktapur" },
    { code: "NP.3.12095461", name: "Chitwan" },
    { code: "NP.3.12095466", name: "Dhading" },
    { code: "NP.3.12095469", name: "Dolakha" },
    { code: "NP.3.12095484", name: "Kathmandu" },
    { code: "NP.3.12095485", name: "Kavrepalanchok" },
    { code: "NP.3.12095487", name: "Lalitpur" },
    { code: "NP.3.12095490", name: "Makwanpur" },
    { code: "NP.3.12095497", name: "Nuwakot" },
    { code: "NP.3.12095504", name: "Ramechhap" },
    { code: "NP.3.12095511", name: "Rasuwa" },
    { code: "NP.3.12095520", name: "Sindhuli" },
    { code: "NP.3.12095521", name: "Sindhupalchowk" },
  ],
  "NP.4": [
    { code: "NP.4.12095472", name: "Gorkha" },
    { code: "NP.4.12095483", name: "Kaski" },
    { code: "NP.4.12095488", name: "Lamjung" },
    { code: "NP.4.12095491", name: "Manag" },
    { code: "NP.4.12095494", name: "Mustang" },
    { code: "NP.4.12095495", name: "Myagdi" },
    { code: "NP.4.12095496", name: "Nawalparasi" },
    { code: "NP.4.12095501", name: "Parbat" },
    { code: "NP.4.12095507", name: "Baglung" },
    { code: "NP.4.12095526", name: "Syangja" },
    { code: "NP.4.12095527", name: "Tanahun" },
  ],
  "NP.5": [
    { code: "NP.5.12095456", name: "Banke" },
    { code: "NP.5.12095458", name: "Bardiya" },
    { code: "NP.5.12095464", name: "Dang" },
    { code: "NP.5.12095473", name: "Gulmi" },
    { code: "NP.5.12095482", name: "Kapilbastu" },
    { code: "NP.5.12095499", name: "Palpa" },
    { code: "NP.5.12095503", name: "Pyuthan" },
    { code: "NP.5.12095506", name: "Arghakhanchi" },
    { code: "NP.5.12095513", name: "Rolpa" },
    { code: "NP.5.12095514", name: "Rukum" },
    { code: "NP.5.12095515", name: "Rupandehi" },
    { code: "NP.5.12095531", name: "Nawalparasi" },
  ],
  "NP.6": [
    { code: "NP.6.12095463", name: "Dailekh" },
    { code: "NP.6.12095470", name: "Dolpa" },
    { code: "NP.6.12095474", name: "Humla" },
    { code: "NP.6.12095476", name: "Jajarkot" },
    { code: "NP.6.12095478", name: "Jumla" },
    { code: "NP.6.12095480", name: "Kalikot" },
    { code: "NP.6.12095493", name: "Mugu" },
    { code: "NP.6.12095516", name: "Salyan" },
    { code: "NP.6.12095525", name: "Surkhet" },
    { code: "NP.6.12095532", name: "Rukum" },
  ],
  "NP.7": [
    { code: "NP.7.12095462", name: "Dadeldhura" },
    { code: "NP.7.12095465", name: "Darchula" },
    { code: "NP.7.12095471", name: "Doti" },
    { code: "NP.7.12095479", name: "Kailali" },
    { code: "NP.7.12095481", name: "Kanchanpur" },
    { code: "NP.7.12095505", name: "Achham" },
    { code: "NP.7.12095508", name: "Baitadi" },
    { code: "NP.7.12095509", name: "Bajhang" },
    { code: "NP.7.12095510", name: "Bajura" },
  ],
  "NZ.E7": [
    { code: "NZ.E7.076", name: "Auckland" },
  ],
  "NZ.E8": [
    { code: "NZ.E8.022", name: "Western Bay of Plenty District" },
    { code: "NZ.E8.023", name: "Tauranga City" },
    { code: "NZ.E8.024", name: "Rotorua District" },
    { code: "NZ.E8.025", name: "Whakatane District" },
    { code: "NZ.E8.026", name: "Kawerau District" },
    { code: "NZ.E8.027", name: "Opotiki District" },
  ],
  "NZ.E9": [
    { code: "NZ.E9.054", name: "Kaikoura District" },
    { code: "NZ.E9.058", name: "Hurunui District" },
    { code: "NZ.E9.059", name: "Waimakariri District" },
    { code: "NZ.E9.060", name: "Christchurch City" },
    { code: "NZ.E9.062", name: "Selwyn District" },
    { code: "NZ.E9.063", name: "Ashburton District" },
    { code: "NZ.E9.064", name: "Timaru District" },
    { code: "NZ.E9.065", name: "Mackenzie District" },
    { code: "NZ.E9.066", name: "Waimate District" },
    { code: "NZ.E9.068", name: "Waitaki District" },
  ],
  "NZ.F1": [
    { code: "NZ.F1.028", name: "Gisborne District" },
  ],
  "NZ.F2": [
    { code: "NZ.F2.029", name: "Wairoa District" },
    { code: "NZ.F2.030", name: "Hastings District" },
    { code: "NZ.F2.031", name: "Napier City" },
    { code: "NZ.F2.032", name: "Central Hawke's Bay District" },
  ],
  "NZ.F3": [
    { code: "NZ.F3.036", name: "Ruapehu District" },
    { code: "NZ.F3.037", name: "Wanganui District" },
    { code: "NZ.F3.038", name: "Rangitikei District" },
    { code: "NZ.F3.039", name: "Manawatu District" },
    { code: "NZ.F3.040", name: "Palmerston North City" },
    { code: "NZ.F3.041", name: "Tararua District" },
    { code: "NZ.F3.042", name: "Horowhenua District" },
  ],
  "NZ.F4": [
    { code: "NZ.F4.053", name: "Marlborough District" },
  ],
  "NZ.F5": [
    { code: "NZ.F5.052", name: "Nelson City" },
  ],
  "NZ.F6": [
    { code: "NZ.F6.001", name: "Far North District" },
    { code: "NZ.F6.002", name: "Whangarei" },
    { code: "NZ.F6.003", name: "Kaipara District" },
  ],
  "NZ.F7": [
    { code: "NZ.F7.069", name: "Central Otago District" },
    { code: "NZ.F7.070", name: "Queenstown-Lakes District" },
    { code: "NZ.F7.071", name: "Dunedin City" },
    { code: "NZ.F7.072", name: "Clutha District" },
  ],
  "NZ.F8": [
    { code: "NZ.F8.073", name: "Southland District" },
    { code: "NZ.F8.074", name: "Gore District" },
    { code: "NZ.F8.075", name: "Invercargill City" },
  ],
  "NZ.F9": [
    { code: "NZ.F9.033", name: "New Plymouth District" },
    { code: "NZ.F9.034", name: "Stratford District" },
    { code: "NZ.F9.035", name: "South Taranaki District" },
  ],
  "NZ.G1": [
    { code: "NZ.G1.011", name: "Thames-Coromandel District" },
    { code: "NZ.G1.012", name: "Hauraki District" },
    { code: "NZ.G1.013", name: "Waikato District" },
    { code: "NZ.G1.015", name: "Matamata-Piako District" },
    { code: "NZ.G1.016", name: "Hamilton City" },
    { code: "NZ.G1.017", name: "Waipa District" },
    { code: "NZ.G1.018", name: "Otorohanga District" },
    { code: "NZ.G1.019", name: "South Waikato District" },
    { code: "NZ.G1.020", name: "Waitomo District" },
    { code: "NZ.G1.021", name: "Taupo District" },
  ],
  "NZ.G2": [
    { code: "NZ.G2.043", name: "Kapiti Coast District" },
    { code: "NZ.G2.044", name: "Porirua City" },
    { code: "NZ.G2.045", name: "Upper Hutt City" },
    { code: "NZ.G2.046", name: "Lower Hutt City" },
    { code: "NZ.G2.047", name: "Wellington City" },
    { code: "NZ.G2.048", name: "Masterton District" },
    { code: "NZ.G2.049", name: "Carterton District" },
    { code: "NZ.G2.050", name: "South Wairarapa District" },
  ],
  "NZ.G3": [
    { code: "NZ.G3.055", name: "Buller District" },
    { code: "NZ.G3.056", name: "Grey District" },
    { code: "NZ.G3.057", name: "Westland District" },
  ],
  "NZ.TAS": [
    { code: "NZ.TAS.051", name: "Tasman District" },
  ],
  "OM.07": [
    { code: "OM.07.11748046", name: "Madha" },
  ],
  "PA.01": [
    { code: "PA.01.0101", name: "Distrito de Bocas del Toro" },
    { code: "PA.01.0102", name: "Distrito de Changuinola" },
    { code: "PA.01.0103", name: "Distrito Chiriquí Grande" },
  ],
  "PA.02": [
    { code: "PA.02.0401", name: "Distrito de Alanje" },
    { code: "PA.02.0402", name: "Distrito de Barú" },
    { code: "PA.02.0403", name: "Distrito de Boquerón" },
    { code: "PA.02.0404", name: "Distrito de Boquete" },
    { code: "PA.02.0405", name: "Distrito de Bugaba" },
    { code: "PA.02.0406", name: "Distrito de David" },
    { code: "PA.02.0407", name: "Distrito de Dolega" },
    { code: "PA.02.0408", name: "Distrito de Gualaca" },
    { code: "PA.02.0409", name: "Distrito de Remedios" },
    { code: "PA.02.0410", name: "Distrito de Renacimiento" },
    { code: "PA.02.0411", name: "Distrito de San Félix" },
    { code: "PA.02.0412", name: "Distrito de San Lorenzo" },
    { code: "PA.02.0413", name: "Distrito de Tolé" },
  ],
  "PA.03": [
    { code: "PA.03.0201", name: "Distrito de Aguadulce" },
    { code: "PA.03.0202", name: "Distrito de Antón" },
    { code: "PA.03.0203", name: "Distrito de La Pintada" },
    { code: "PA.03.0204", name: "Distrito de Natá" },
    { code: "PA.03.0205", name: "Distrito de Olá" },
    { code: "PA.03.0206", name: "Distrito Penonomé" },
  ],
  "PA.04": [
    { code: "PA.04.0301", name: "Distrito de Colón" },
    { code: "PA.04.0302", name: "Distrito de Chagres" },
    { code: "PA.04.0303", name: "Distrito de Donoso" },
    { code: "PA.04.0304", name: "Distrito de Portobelo" },
    { code: "PA.04.0305", name: "Distrito de Santa Isabel" },
  ],
  "PA.05": [
    { code: "PA.05.0501", name: "Distrito de Chepigana" },
    { code: "PA.05.0502", name: "Distrito de Pinogana" },
  ],
  "PA.06": [
    { code: "PA.06.0601", name: "Distrito de Chitré" },
    { code: "PA.06.0602", name: "Distrito de Las Minas" },
    { code: "PA.06.0603", name: "Distrito de Los Pozos" },
    { code: "PA.06.0604", name: "Distrito de Ocú" },
    { code: "PA.06.0605", name: "Distrito de Parita" },
    { code: "PA.06.0606", name: "Distrito de Pesé" },
    { code: "PA.06.0607", name: "Distrito de Santa María" },
  ],
  "PA.07": [
    { code: "PA.07.0701", name: "Distrito de Guararé" },
    { code: "PA.07.0702", name: "Distrito de Las Tablas" },
    { code: "PA.07.0703", name: "Distrito de Los Santos" },
    { code: "PA.07.0704", name: "Distrito de Macaracas" },
    { code: "PA.07.0705", name: "Distrito de Pedasí" },
    { code: "PA.07.0706", name: "Distrito de Pocrí" },
    { code: "PA.07.0707", name: "Distrito de Tonosí" },
  ],
  "PA.08": [
    { code: "PA.08.0802", name: "Distrito de Balboa" },
    { code: "PA.08.0805", name: "Distrito de Chepo" },
    { code: "PA.08.0806", name: "Distrito de Chimán" },
    { code: "PA.08.0808", name: "Distrito de Panamá" },
    { code: "PA.08.0810", name: "Distrito San Miguelito" },
    { code: "PA.08.0811", name: "Distrito de Taboga" },
  ],
  "PA.09": [
    { code: "PA.09.1001", name: "El Porvenir" },
  ],
  "PA.10": [
    { code: "PA.10.0901", name: "Distrito de Atalaya" },
    { code: "PA.10.0902", name: "Distrito de Calobre" },
    { code: "PA.10.0903", name: "Distrito de Cañazas" },
    { code: "PA.10.0904", name: "Distrito de La Mesa" },
    { code: "PA.10.0905", name: "Distrito de Las Palmas" },
    { code: "PA.10.0906", name: "Distrito de Montijo" },
    { code: "PA.10.0907", name: "Distrito de Río de Jesús" },
    { code: "PA.10.0908", name: "Distrito de San Francisco" },
    { code: "PA.10.0909", name: "Distrito de Santa Fé" },
    { code: "PA.10.0910", name: "Distrito de Santiago" },
    { code: "PA.10.0911", name: "Distrito de Soná" },
    { code: "PA.10.0912", name: "Mariato District" },
  ],
  "PA.11": [
    { code: "PA.11.1101", name: "Cémaco" },
    { code: "PA.11.1102", name: "Sambú" },
  ],
  "PA.12": [
    { code: "PA.12.1201", name: "Besiko" },
    { code: "PA.12.1202", name: "Mirono" },
    { code: "PA.12.1203", name: "Müna" },
    { code: "PA.12.1204", name: "Nole Düima" },
    { code: "PA.12.1205", name: "Nurun" },
    { code: "PA.12.1206", name: "Kankintú" },
    { code: "PA.12.1207", name: "Kusapín" },
  ],
  "PA.13": [
    { code: "PA.13.0801", name: "Distrito Arraiján" },
    { code: "PA.13.0803", name: "Distrito de Capira" },
    { code: "PA.13.0804", name: "Distrito de Chame" },
    { code: "PA.13.0807", name: "Distrito de La Chorrera" },
    { code: "PA.13.0809", name: "Distrito de San Carlos" },
  ],
  "PE.01": [
    { code: "PE.01.0101", name: "Provincia de Chachapoyas" },
    { code: "PE.01.0102", name: "Provincia de Bagua" },
    { code: "PE.01.0103", name: "Provincia de Bongará" },
    { code: "PE.01.0104", name: "Condorcanqui" },
    { code: "PE.01.0105", name: "Provincia de Luya" },
    { code: "PE.01.0106", name: "Provincia de Rodríguez de Mendoza" },
    { code: "PE.01.0107", name: "Utcubamba" },
  ],
  "PE.02": [
    { code: "PE.02.0201", name: "Provincia de Huaraz" },
    { code: "PE.02.0202", name: "Provincia de Aija" },
    { code: "PE.02.0203", name: "Provincia de Antonio Raymondi" },
    { code: "PE.02.0204", name: "Asuncion" },
    { code: "PE.02.0205", name: "Provincia de Bolognesi" },
    { code: "PE.02.0206", name: "Provincia de Carhuaz" },
    { code: "PE.02.0207", name: "Carlos Fermin Fitzcarrald" },
    { code: "PE.02.0208", name: "Provincia de Casma" },
    { code: "PE.02.0209", name: "Provincia de Corongo" },
    { code: "PE.02.0210", name: "Provincia de Huari" },
    { code: "PE.02.0211", name: "Provincia de Huarmey" },
    { code: "PE.02.0212", name: "Provincia de Huaylas" },
    { code: "PE.02.0213", name: "Provincia de Mariscal Luzuriaga" },
    { code: "PE.02.0214", name: "Ocros" },
    { code: "PE.02.0215", name: "Provincia de Pallasca" },
    { code: "PE.02.0216", name: "Provincia de Pomabamba" },
    { code: "PE.02.0217", name: "Provincia de Recuay" },
    { code: "PE.02.0218", name: "Provincia de Santa" },
    { code: "PE.02.0219", name: "Provincia de Sihuas" },
    { code: "PE.02.0220", name: "Provincia de Yungay" },
  ],
  "PE.03": [
    { code: "PE.03.0301", name: "Provincia de Abancay" },
    { code: "PE.03.0302", name: "Provincia de Andahuaylas" },
    { code: "PE.03.0303", name: "Provincia de Antabamba" },
    { code: "PE.03.0304", name: "Provincia de Aymaraes" },
    { code: "PE.03.0305", name: "Provincia de Cotabambas" },
    { code: "PE.03.0306", name: "Chincheros" },
    { code: "PE.03.0307", name: "Provincia de Grau" },
  ],
  "PE.04": [
    { code: "PE.04.0401", name: "Provincia de Arequipa" },
    { code: "PE.04.0402", name: "Provincia de Camaná" },
    { code: "PE.04.0403", name: "Provincia de Caravelí" },
    { code: "PE.04.0404", name: "Provincia de Castilla" },
    { code: "PE.04.0405", name: "Provincia de Caylloma" },
    { code: "PE.04.0406", name: "Provincia de Condesuyos" },
    { code: "PE.04.0407", name: "Provincia de Islay" },
    { code: "PE.04.0408", name: "Provincia de La Unión" },
  ],
  "PE.05": [
    { code: "PE.05.0501", name: "Provincia de Huamanga" },
    { code: "PE.05.0502", name: "Provincia de Cangallo" },
    { code: "PE.05.0503", name: "Provincia de Huanca Sancos" },
    { code: "PE.05.0504", name: "Provincia de Huanta" },
    { code: "PE.05.0505", name: "Provincia de La Mar" },
    { code: "PE.05.0506", name: "Provincia de Lucanas" },
    { code: "PE.05.0507", name: "Provincia de Parinacochas" },
    { code: "PE.05.0508", name: "Paucar Del Sara Sara" },
    { code: "PE.05.0509", name: "Provincia de Sucre" },
    { code: "PE.05.0510", name: "Provincia de Víctor Fajardo" },
    { code: "PE.05.0511", name: "Provincia de Vilcas Huamán" },
  ],
  "PE.06": [
    { code: "PE.06.0601", name: "Provincia de Cajamarca" },
    { code: "PE.06.0602", name: "Provincia de Cajabamba" },
    { code: "PE.06.0603", name: "Provincia de Celendín" },
    { code: "PE.06.0604", name: "Provincia de Chota" },
    { code: "PE.06.0605", name: "Provincia de Contumazá" },
    { code: "PE.06.0606", name: "Provincia de Cutervo" },
    { code: "PE.06.0607", name: "Provincia de Hualgayoc" },
    { code: "PE.06.0608", name: "Provincia de Jaén" },
    { code: "PE.06.0609", name: "Provincia de San Ignacio" },
    { code: "PE.06.0610", name: "San Marcos" },
    { code: "PE.06.0611", name: "Provincia de San Miguel" },
    { code: "PE.06.0612", name: "San Pablo" },
    { code: "PE.06.0613", name: "Provincia de Santa Cruz" },
  ],
  "PE.07": [
    { code: "PE.07.0701", name: "Callao" },
  ],
  "PE.08": [
    { code: "PE.08.0801", name: "Provincia de Cusco" },
    { code: "PE.08.0802", name: "Provincia de Acomayo" },
    { code: "PE.08.0803", name: "Provincia de Anta" },
    { code: "PE.08.0804", name: "Provincia de Calca" },
    { code: "PE.08.0805", name: "Provincia de Canas" },
    { code: "PE.08.0806", name: "Provincia de Canchis" },
    { code: "PE.08.0807", name: "Provincia de Chumbivilcas" },
    { code: "PE.08.0808", name: "Provincia de Espinar" },
    { code: "PE.08.0809", name: "Provincia de La Convención" },
    { code: "PE.08.0810", name: "Provincia de Paruro" },
    { code: "PE.08.0811", name: "Provincia de Paucartambo" },
    { code: "PE.08.0812", name: "Provincia de Quispicanchis" },
    { code: "PE.08.0813", name: "Provincia de Urubamba" },
  ],
  "PE.09": [
    { code: "PE.09.0901", name: "Provincia de Huancavelica" },
    { code: "PE.09.0902", name: "Provincia de Acobamba" },
    { code: "PE.09.0903", name: "Provincia de Angaraes" },
    { code: "PE.09.0904", name: "Provincia de Castrovirreyna" },
    { code: "PE.09.0905", name: "Provincia de Churcampa" },
    { code: "PE.09.0906", name: "Huaytara" },
    { code: "PE.09.0907", name: "Provincia de Tayacaja" },
  ],
  "PE.10": [
    { code: "PE.10.1001", name: "Provincia de Huánuco" },
    { code: "PE.10.1002", name: "Provincia de Ambo" },
    { code: "PE.10.1003", name: "Provincia de Dos de Mayo" },
    { code: "PE.10.1004", name: "Huacaybamba" },
    { code: "PE.10.1005", name: "Provincia de Huamalíes" },
    { code: "PE.10.1006", name: "Provincia de Leoncio Prado" },
    { code: "PE.10.1007", name: "Provincia de Marañón" },
    { code: "PE.10.1008", name: "Provincia de Pachitea" },
    { code: "PE.10.1009", name: "Puerto Inca" },
    { code: "PE.10.1010", name: "Lauricocha" },
    { code: "PE.10.1011", name: "Yarowilca" },
  ],
  "PE.11": [
    { code: "PE.11.1101", name: "Provincia de Ica" },
    { code: "PE.11.1102", name: "Provincia de Chincha" },
    { code: "PE.11.1103", name: "Provincia de Nazca" },
    { code: "PE.11.1104", name: "Provincia de Palpa" },
    { code: "PE.11.1105", name: "Provincia de Pisco" },
  ],
  "PE.12": [
    { code: "PE.12.1201", name: "Provincia de Huancayo" },
    { code: "PE.12.1202", name: "Provincia de Concepción" },
    { code: "PE.12.1203", name: "Chanchamayo" },
    { code: "PE.12.1204", name: "Provincia de Jauja" },
    { code: "PE.12.1205", name: "Provincia de Junín" },
    { code: "PE.12.1206", name: "Provincia de Satipo" },
    { code: "PE.12.1207", name: "Provincia de Tarma" },
    { code: "PE.12.1208", name: "Provincia de Yauli" },
    { code: "PE.12.1209", name: "Provincia de Chupaca" },
  ],
  "PE.13": [
    { code: "PE.13.1301", name: "Provincia de Trujillo" },
    { code: "PE.13.1302", name: "Ascope" },
    { code: "PE.13.1303", name: "Provincia de Bolívar" },
    { code: "PE.13.1304", name: "Chepen" },
    { code: "PE.13.1305", name: "Julcan" },
    { code: "PE.13.1306", name: "Provincia de Otuzco" },
    { code: "PE.13.1307", name: "Provincia de Pacasmayo" },
    { code: "PE.13.1308", name: "Provincia de Pataz" },
    { code: "PE.13.1309", name: "Sanchez Carrion" },
    { code: "PE.13.1310", name: "Provincia de Santiago de Chuco" },
    { code: "PE.13.1311", name: "Gran Chimu" },
    { code: "PE.13.1312", name: "Viru" },
  ],
  "PE.14": [
    { code: "PE.14.1401", name: "Provincia de Chiclayo" },
    { code: "PE.14.1402", name: "Provincia de Ferreñafe" },
    { code: "PE.14.1403", name: "Provincia de Lambayeque" },
  ],
  "PE.15": [
    { code: "PE.15.1501", name: "Lima" },
    { code: "PE.15.1502", name: "Barranca" },
    { code: "PE.15.1503", name: "Provincia de Cajatambo" },
    { code: "PE.15.1504", name: "Provincia de Canta" },
    { code: "PE.15.1505", name: "Provincia de Cañete" },
    { code: "PE.15.1506", name: "Provincia de Huaral" },
    { code: "PE.15.1507", name: "Provincia de Huarochirí" },
    { code: "PE.15.1508", name: "Huaura" },
    { code: "PE.15.1509", name: "Oyon" },
    { code: "PE.15.1510", name: "Provincia de Yauyos" },
  ],
  "PE.16": [
    { code: "PE.16.1601", name: "Provincia de Maynas" },
    { code: "PE.16.1602", name: "Provincia de Alto Amazonas" },
    { code: "PE.16.1603", name: "Provincia de Loreto" },
    { code: "PE.16.1604", name: "Mariscal Ramon Castilla" },
    { code: "PE.16.1605", name: "Provincia de Requena" },
    { code: "PE.16.1606", name: "Provincia de Ucayali" },
    { code: "PE.16.1607", name: "Datem Del Marañon" },
    { code: "PE.16.1608", name: "Putumayo" },
  ],
  "PE.17": [
    { code: "PE.17.1701", name: "Provincia de Tambopata" },
    { code: "PE.17.1702", name: "Provincia de Manú" },
    { code: "PE.17.1703", name: "Provincia de Tahuamanú" },
  ],
  "PE.18": [
    { code: "PE.18.1801", name: "Provincia de Mariscal Nieto" },
    { code: "PE.18.1802", name: "Provincia de General Sánchez Cerro" },
    { code: "PE.18.1803", name: "Provincia de Ilo" },
  ],
  "PE.19": [
    { code: "PE.19.1901", name: "Provincia de Pasco" },
    { code: "PE.19.1902", name: "Provincia de Daniel Carrión" },
    { code: "PE.19.1903", name: "Provincia de Oxapampa" },
  ],
  "PE.20": [
    { code: "PE.20.2001", name: "Provincia de Piura" },
    { code: "PE.20.2002", name: "Provincia de Ayabaca" },
    { code: "PE.20.2003", name: "Provincia de Huancabamba" },
    { code: "PE.20.2004", name: "Morropon" },
    { code: "PE.20.2005", name: "Provincia de Paita" },
    { code: "PE.20.2006", name: "Provincia de Sullana" },
    { code: "PE.20.2007", name: "Provincia de Talara" },
    { code: "PE.20.2008", name: "Sechura" },
  ],
  "PE.21": [
    { code: "PE.21.2101", name: "Provincia de Puno" },
    { code: "PE.21.2102", name: "Provincia de Azángaro" },
    { code: "PE.21.2103", name: "Provincia de Carabaya" },
    { code: "PE.21.2104", name: "Provincia de Chucuito" },
    { code: "PE.21.2105", name: "El Collao" },
    { code: "PE.21.2106", name: "Provincia de Huancané" },
    { code: "PE.21.2107", name: "Provincia de Lampa" },
    { code: "PE.21.2108", name: "Provincia de Melgar" },
    { code: "PE.21.2109", name: "Moho" },
    { code: "PE.21.2110", name: "San Antonio De Putina" },
    { code: "PE.21.2111", name: "San Roman" },
    { code: "PE.21.2112", name: "Provincia de Sandia" },
    { code: "PE.21.2113", name: "Yunguyo" },
  ],
  "PE.22": [
    { code: "PE.22.2201", name: "Provincia de Moyobamba" },
    { code: "PE.22.2202", name: "Bellavista" },
    { code: "PE.22.2203", name: "El Dorado" },
    { code: "PE.22.2204", name: "Provincia de Huallaga" },
    { code: "PE.22.2205", name: "Provincia de Lamas" },
    { code: "PE.22.2206", name: "Provincia de Mariscal Cáceres" },
    { code: "PE.22.2207", name: "Picota" },
    { code: "PE.22.2208", name: "Provincia de Rioja" },
    { code: "PE.22.2209", name: "Provincia de San Martín" },
    { code: "PE.22.2210", name: "Tocache" },
  ],
  "PE.23": [
    { code: "PE.23.2301", name: "Provincia de Tacna" },
    { code: "PE.23.2302", name: "Candarave" },
    { code: "PE.23.2303", name: "Jorge Basadre" },
    { code: "PE.23.2304", name: "Provincia de Tarata" },
  ],
  "PE.24": [
    { code: "PE.24.2401", name: "Provincia de Tumbes" },
    { code: "PE.24.2402", name: "Provincia de Contralmirante Villar" },
    { code: "PE.24.2403", name: "Provincia de Zarumilla" },
  ],
  "PE.25": [
    { code: "PE.25.2501", name: "Provincia de Coronel Portillo" },
    { code: "PE.25.2502", name: "Atalaya" },
    { code: "PE.25.2503", name: "Padre Abad" },
    { code: "PE.25.2504", name: "Purus" },
  ],
  "PF.01": [
    { code: "PF.01.10295208", name: "Arue" },
    { code: "PF.01.10295209", name: "Faaa" },
    { code: "PF.01.10295210", name: "Mahina" },
    { code: "PF.01.10295211", name: "Paea" },
    { code: "PF.01.10295212", name: "Papara" },
    { code: "PF.01.10295213", name: "Papeete" },
    { code: "PF.01.10295214", name: "Pirae" },
    { code: "PF.01.10297425", name: "Taiarapu-Est" },
    { code: "PF.01.10297426", name: "Taiarapu-Ouest" },
    { code: "PF.01.10297429", name: "Teva I Uta" },
    { code: "PF.01.4033777", name: "Punaauia" },
    { code: "PF.01.4034400", name: "Hitiaa O Te Ra" },
  ],
  "PF.02": [
    { code: "PF.02.10295377", name: "Bora-Bora" },
    { code: "PF.02.10295378", name: "Huahine" },
    { code: "PF.02.10295379", name: "Maupiti" },
    { code: "PF.02.10295380", name: "Tahaa" },
    { code: "PF.02.10295384", name: "Uturoa" },
    { code: "PF.02.10297424", name: "Moorea-Maiao" },
    { code: "PF.02.10297427", name: "Taputapuatea" },
    { code: "PF.02.10297428", name: "Tumaraa" },
  ],
  "PF.03": [
    { code: "PF.03.10295215", name: "Anaa" },
    { code: "PF.03.10295216", name: "Arutua" },
    { code: "PF.03.10295217", name: "Fakarava" },
    { code: "PF.03.10295218", name: "Fangatau" },
    { code: "PF.03.10295219", name: "Gambier" },
    { code: "PF.03.10295301", name: "Hikueru" },
    { code: "PF.03.10295307", name: "Makemo" },
    { code: "PF.03.10295319", name: "Manihi" },
    { code: "PF.03.10295320", name: "Napuka" },
    { code: "PF.03.10295321", name: "Nukutavake" },
    { code: "PF.03.10295322", name: "Pukapuka" },
    { code: "PF.03.10295326", name: "Rangiroa" },
    { code: "PF.03.10295340", name: "Reao" },
    { code: "PF.03.10295365", name: "Takaroa" },
    { code: "PF.03.10295367", name: "Tatakoto" },
    { code: "PF.03.10295368", name: "Tureia" },
    { code: "PF.03.10297421", name: "Hao" },
  ],
  "PF.04": [
    { code: "PF.04.10295149", name: "Fatu-Hiva" },
    { code: "PF.04.10295183", name: "Hiva-Oa" },
    { code: "PF.04.10295204", name: "Nuku-Hiva" },
    { code: "PF.04.10295205", name: "Tahuata" },
    { code: "PF.04.10295206", name: "Ua Huka" },
    { code: "PF.04.10295207", name: "Ua-Pou" },
  ],
  "PF.05": [
    { code: "PF.05.10295370", name: "Raivavae" },
    { code: "PF.05.10295371", name: "Rapa" },
    { code: "PF.05.10295372", name: "Rimatara" },
    { code: "PF.05.10295374", name: "Rurutu" },
    { code: "PF.05.10295375", name: "Tubuai" },
  ],
  "PG.01": [
    { code: "PG.01.2087633", name: "Rigo" },
    { code: "PG.01.2096826", name: "Goilala" },
    { code: "PG.01.2134008", name: "Abau" },
    { code: "PG.01.7668019", name: "Kairuku-Hiri" },
  ],
  "PG.02": [
    { code: "PG.02.2094002", name: "Kikori" },
    { code: "PG.02.2094142", name: "Kerema" },
  ],
  "PG.03": [
    { code: "PG.03.2097572", name: "Esa’ala" },
    { code: "PG.03.8657199", name: "Kiriwina Goodenough" },
    { code: "PG.03.8657203", name: "Alotau" },
    { code: "PG.03.9855462", name: "Samarai Murua" },
  ],
  "PG.04": [
    { code: "PG.04.2093690", name: "Sohe" },
    { code: "PG.04.8657190", name: "Ijivitari" },
  ],
  "PG.05": [
    { code: "PG.05.2089577", name: "Nipa Kutubu" },
    { code: "PG.05.2090988", name: "Mendi" },
    { code: "PG.05.2095923", name: "Ialibu Pangia" },
    { code: "PG.05.8657202", name: "Kagua Erave" },
    { code: "PG.05.8657218", name: "Imbonggu" },
  ],
  "PG.06": [
    { code: "PG.06.8657194", name: "Middle Fly" },
    { code: "PG.06.8657196", name: "South Fly" },
    { code: "PG.06.9855465", name: "North Fly" },
  ],
  "PG.07": [
    { code: "PG.07.8714537", name: "Central Bougainville" },
    { code: "PG.07.8714538", name: "South Bougainville" },
    { code: "PG.07.8740754", name: "North Bougainville" },
  ],
  "PG.08": [
    { code: "PG.08.2094124", name: "Kerowagi" },
    { code: "PG.08.2094554", name: "Karimui Nomane" },
    { code: "PG.08.2096611", name: "Gumine" },
    { code: "PG.08.2098576", name: "Chuave" },
    { code: "PG.08.8657200", name: "Kundiawa" },
    { code: "PG.08.8657204", name: "Sinasina Yonggamugl" },
  ],
  "PG.09": [
    { code: "PG.09.2089207", name: "Okapa" },
    { code: "PG.09.2092104", name: "Lufa" },
    { code: "PG.09.2095037", name: "Kainantu" },
    { code: "PG.09.2096222", name: "Henganofi" },
    { code: "PG.09.2096740", name: "Goroka" },
    { code: "PG.09.8657205", name: "Unggai Bena" },
    { code: "PG.09.8657206", name: "Daulo" },
    { code: "PG.09.9855501", name: "Obura Wonenara" },
  ],
  "PG.10": [
    { code: "PG.10.2087893", name: "Rabaul" },
    { code: "PG.10.2088199", name: "Pomio" },
    { code: "PG.10.2093683", name: "Kokopo" },
    { code: "PG.10.8657207", name: "Gazelle" },
  ],
  "PG.11": [
    { code: "PG.11.2083536", name: "Wewak" },
    { code: "PG.11.2091472", name: "Maprik" },
    { code: "PG.11.2100764", name: "Angoram" },
    { code: "PG.11.2100931", name: "Ambunti Dreikikir" },
    { code: "PG.11.8657208", name: "Wosera Gaui" },
    { code: "PG.11.8657209", name: "Yangoru Saussia" },
  ],
  "PG.12": [
    { code: "PG.12.2099273", name: "Bogia" },
    { code: "PG.12.7910339", name: "Madang" },
    { code: "PG.12.8657191", name: "Middle Ramu" },
    { code: "PG.12.8657192", name: "Usino Bundi" },
    { code: "PG.12.8657210", name: "Sumkar" },
    { code: "PG.12.9855506", name: "Rai Coast" },
  ],
  "PG.13": [
    { code: "PG.13.7910338", name: "Manus" },
  ],
  "PG.14": [
    { code: "PG.14.2090950", name: "Menyamya" },
    { code: "PG.14.2092738", name: "Lae" },
    { code: "PG.14.2095129", name: "Kabwum" },
    { code: "PG.14.2097417", name: "Finschhafen" },
    { code: "PG.14.8657188", name: "Bulolo" },
    { code: "PG.14.8657211", name: "Huon Gulf" },
    { code: "PG.14.8657212", name: "Nawae" },
    { code: "PG.14.8657213", name: "Tewai Siassi" },
    { code: "PG.14.9855507", name: "Markham" },
  ],
  "PG.15": [
    { code: "PG.15.2090019", name: "Namatanai" },
    { code: "PG.15.2094341", name: "Kavieng" },
  ],
  "PG.16": [
    { code: "PG.16.2090408", name: "Hagen" },
    { code: "PG.16.8657195", name: "Dei" },
    { code: "PG.16.8657214", name: "Baiyer Mul" },
    { code: "PG.16.8657215", name: "Tambul Nebilyer" },
  ],
  "PG.17": [
    { code: "PG.17.2085943", name: "Talasea" },
    { code: "PG.17.2094745", name: "Kandrian Gloucester" },
  ],
  "PG.18": [
    { code: "PG.18.2085584", name: "Telefomin" },
    { code: "PG.18.2089418", name: "Nuku" },
    { code: "PG.18.8657189", name: "Vanimo Green" },
    { code: "PG.18.8657198", name: "Aitape Lumi" },
  ],
  "PG.19": [
    { code: "PG.19.2083851", name: "Wapenamanda" },
    { code: "PG.19.2084245", name: "Wabag" },
    { code: "PG.19.2093564", name: "Kompiam Ambum" },
    { code: "PG.19.2094755", name: "Kandep" },
    { code: "PG.19.8657193", name: "Lagaip Porgera" },
  ],
  "PG.20": [
    { code: "PG.20.9855526", name: "National Capital District" },
  ],
  "PG.21": [
    { code: "PG.21.2085770", name: "Tari Pori" },
    { code: "PG.21.8657201", name: "Koroba-Lake Kopiago" },
    { code: "PG.21.8657216", name: "Komo Margarima" },
  ],
  "PG.22": [
    { code: "PG.22.2095253", name: "Jimi" },
    { code: "PG.22.8657197", name: "Angalimp South Wahgi" },
    { code: "PG.22.8657217", name: "North Wahgi" },
  ],
  "PH.01": [
    { code: "PH.01.28", name: "Province of Ilocos Norte" },
    { code: "PH.01.29", name: "Province of Ilocos Sur" },
    { code: "PH.01.36", name: "Province of La Union" },
    { code: "PH.01.51", name: "Province of Pangasinan" },
  ],
  "PH.02": [
    { code: "PH.02.08", name: "Province of Batanes" },
    { code: "PH.02.14", name: "Province of Cagayan" },
    { code: "PH.02.31", name: "Province of Isabela" },
    { code: "PH.02.48", name: "Province of Nueva Vizcaya" },
    { code: "PH.02.68", name: "Province of Quirino" },
  ],
  "PH.03": [
    { code: "PH.03.07", name: "Province of Bataan" },
    { code: "PH.03.13", name: "Province of Bulacan" },
    { code: "PH.03.47", name: "Province of Nueva Ecija" },
    { code: "PH.03.50", name: "Province of Pampanga" },
    { code: "PH.03.63", name: "Province of Tarlac" },
    { code: "PH.03.64", name: "Province of Zambales" },
    { code: "PH.03.G8", name: "Province of Aurora" },
  ],
  "PH.05": [
    { code: "PH.05.05", name: "Province of Albay" },
    { code: "PH.05.15", name: "Province of Camarines Norte" },
    { code: "PH.05.16", name: "Province of Camarines Sur" },
    { code: "PH.05.19", name: "Province of Catanduanes" },
    { code: "PH.05.39", name: "Province of Masbate" },
    { code: "PH.05.58", name: "Province of Sorsogon" },
  ],
  "PH.06": [
    { code: "PH.06.04", name: "Province of Aklan" },
    { code: "PH.06.06", name: "Province of Antique" },
    { code: "PH.06.18", name: "Province of Capiz" },
    { code: "PH.06.30", name: "Province of Iloilo" },
    { code: "PH.06.H3", name: "Province of Negros Occidental" },
    { code: "PH.06.J3", name: "Province of Guimaras" },
  ],
  "PH.07": [
    { code: "PH.07.11", name: "Bohol" },
    { code: "PH.07.21", name: "Province of Cebu" },
    { code: "PH.07.46", name: "Province of Negros Oriental" },
    { code: "PH.07.69", name: "Province of Siquijor" },
  ],
  "PH.08": [
    { code: "PH.08.23", name: "Province of Eastern Samar" },
    { code: "PH.08.37", name: "Province of Leyte" },
    { code: "PH.08.55", name: "Province of Samar" },
    { code: "PH.08.59", name: "Province of Southern Leyte" },
    { code: "PH.08.67", name: "Province of Northern Samar" },
    { code: "PH.08.H9", name: "Biliran" },
  ],
  "PH.09": [
    { code: "PH.09.65", name: "Province of Zamboanga del Norte" },
    { code: "PH.09.66", name: "Province of  Zamboanga del Sur" },
    { code: "PH.09.ZSI", name: "Province of Zamboanga Sibugay" },
  ],
  "PH.10": [
    { code: "PH.10.12", name: "Province of Bukidnon" },
    { code: "PH.10.17", name: "Province of Camiguin" },
    { code: "PH.10.34", name: "Province of Lanao del Norte" },
    { code: "PH.10.42", name: "Province of Misamis Occidental" },
    { code: "PH.10.43", name: "Province of Misamis Oriental" },
  ],
  "PH.11": [
    { code: "PH.11.25", name: "Province of Davao del Sur" },
    { code: "PH.11.26", name: "Province of Davao Oriental" },
    { code: "PH.11.I6", name: "Compostela Valley" },
    { code: "PH.11.I7", name: "Province of Davao del Norte" },
    { code: "PH.11.P3", name: "Davao Occidental" },
  ],
  "PH.12": [
    { code: "PH.12.57", name: "Province of Cotabato" },
    { code: "PH.12.70", name: "Province of South Cotabato" },
    { code: "PH.12.71", name: "Province of Sultan Kudarat" },
    { code: "PH.12.B8", name: "Cotabato City" },
    { code: "PH.12.M9", name: "Province of Sarangani" },
  ],
  "PH.13": [
    { code: "PH.13.02", name: "Province of Agusan del Norte" },
    { code: "PH.13.03", name: "Province of Agusan del Sur" },
    { code: "PH.13.61", name: "Province of Surigao del Norte" },
    { code: "PH.13.62", name: "Province of Surigao del Sur" },
    { code: "PH.13.I9", name: "Dinagat Islands" },
  ],
  "PH.14": [
    { code: "PH.14.22", name: "Province of Basilan" },
    { code: "PH.14.35", name: "Province of Lanao del Sur" },
    { code: "PH.14.56", name: "Province of Maguindanao" },
    { code: "PH.14.60", name: "Province of Sulu" },
    { code: "PH.14.72", name: "Province of Tawi-Tawi" },
  ],
  "PH.15": [
    { code: "PH.15.01", name: "Province of Abra" },
    { code: "PH.15.10", name: "Province of Benguet" },
    { code: "PH.15.27", name: "Province of Ifugao" },
    { code: "PH.15.32", name: "Kalinga" },
    { code: "PH.15.44", name: "Mountain Province" },
    { code: "PH.15.H6", name: "Apayao" },
  ],
  "PH.40": [
    { code: "PH.40.09", name: "Province of Batangas" },
    { code: "PH.40.20", name: "Province of Cavite" },
    { code: "PH.40.33", name: "Province of Laguna" },
    { code: "PH.40.53", name: "Province of Rizal" },
    { code: "PH.40.H2", name: "Province of Quezon" },
  ],
  "PH.41": [
    { code: "PH.41.38", name: "Province of Marinduque" },
    { code: "PH.41.40", name: "Province of Mindoro Occidental" },
    { code: "PH.41.41", name: "Province of Mindoro Oriental" },
    { code: "PH.41.49", name: "Province of Palawan" },
    { code: "PH.41.54", name: "Province of Romblon" },
  ],
  "PH.NCR": [
    { code: "PH.NCR.133900000", name: "Capital District" },
    { code: "PH.NCR.137400000", name: "Eastern Manila District" },
    { code: "PH.NCR.137500000", name: "Northern Manila District" },
    { code: "PH.NCR.137600000", name: "Southern Manila District" },
  ],
  "PK.02": [
    { code: "PK.02.1162104", name: "Zhob District" },
    { code: "PK.02.1163052", name: "Kech District" },
    { code: "PK.02.1164895", name: "Sibi District" },
    { code: "PK.02.1167527", name: "Quetta District" },
    { code: "PK.02.1167820", name: "Pishīn District" },
    { code: "PK.02.1168444", name: "Panjgūr District" },
    { code: "PK.02.1169249", name: "Nasīrābād District" },
    { code: "PK.02.1171867", name: "Loralai District" },
    { code: "PK.02.1172115", name: "Lasbela District" },
    { code: "PK.02.1173463", name: "Kohlu District" },
    { code: "PK.02.1173663", name: "Khuzdār District" },
    { code: "PK.02.1174059", name: "Khārān District" },
    { code: "PK.02.11744842", name: "Sohbatpur District" },
    { code: "PK.02.1175293", name: "Kalāt District" },
    { code: "PK.02.1175527", name: "Kachhi District" },
    { code: "PK.02.1177445", name: "Gwādar District" },
    { code: "PK.02.1181950", name: "Chāgai District" },
    { code: "PK.02.6641896", name: "Awārān District" },
    { code: "PK.02.6641912", name: "Bārkhān District" },
    { code: "PK.02.6641919", name: "Dera Bugti District" },
    { code: "PK.02.6641922", name: "Jāfarābād District" },
    { code: "PK.02.6641923", name: "Jhal Magsi District" },
    { code: "PK.02.6641952", name: "Mastung District" },
    { code: "PK.02.6641955", name: "Mūsa Khel District" },
    { code: "PK.02.6641960", name: "Nushki District" },
    { code: "PK.02.6641961", name: "Qila Abdullāh District" },
    { code: "PK.02.6641963", name: "Qila Saifullāh District" },
    { code: "PK.02.6641965", name: "Wāshuk District" },
    { code: "PK.02.6641972", name: "Ziārat District" },
    { code: "PK.02.8309758", name: "Harnai" },
    { code: "PK.02.8309759", name: "Shirāni" },
  ],
  "PK.03": [
    { code: "PK.03.1164211", name: "Swāt District" },
    { code: "PK.03.1164536", name: "South Wazīristān District" },
    { code: "PK.03.1168195", name: "Peshāwar District" },
    { code: "PK.03.1168705", name: "Orakzai Agency" },
    { code: "PK.03.1168875", name: "North Wazīristān District" },
    { code: "PK.03.1170122", name: "Mohmand Agency" },
    { code: "PK.03.1170875", name: "Mardān District" },
    { code: "PK.03.1170950", name: "Mānsehra District" },
    { code: "PK.03.1171388", name: "Malakand Protected Area" },
    { code: "PK.03.1172574", name: "Kurram District" },
    { code: "PK.03.1173489", name: "Kohāt District" },
    { code: "PK.03.1173641", name: "Khyber Agency" },
    { code: "PK.03.1179754", name: "Upper Dīr District" },
    { code: "PK.03.1180280", name: "Dera Ismāīl Khān Tribal Area" },
    { code: "PK.03.1180282", name: "Dera Ismāīl Khān District" },
    { code: "PK.03.1181064", name: "Chitrāl District" },
    { code: "PK.03.1182146", name: "Buner District" },
    { code: "PK.03.1183459", name: "Bannu District" },
    { code: "PK.03.1183781", name: "Bājaur Agency" },
    { code: "PK.03.1185055", name: "Abbottābād District" },
    { code: "PK.03.12105028", name: "Lower Kohistan District" },
    { code: "PK.03.12105031", name: "Upper Kohistan District" },
    { code: "PK.03.7419039", name: "Lakki Marwat District" },
    { code: "PK.03.7419040", name: "Tānk District" },
    { code: "PK.03.7419041", name: "Tānk Tribal Area" },
    { code: "PK.03.7419043", name: "Bannu Tribal Area" },
    { code: "PK.03.7419044", name: "Lakki Marwat Tribal Area" },
    { code: "PK.03.7419047", name: "Karak District" },
    { code: "PK.03.7419048", name: "Hangu District" },
    { code: "PK.03.7419049", name: "Peshāwar Tribal Area" },
    { code: "PK.03.7419050", name: "Kohāt Tribal Area" },
    { code: "PK.03.7419051", name: "Chārsadda District" },
    { code: "PK.03.7419052", name: "Nowshera District" },
    { code: "PK.03.7419053", name: "Shāngla District" },
    { code: "PK.03.7419054", name: "Harīpur District" },
    { code: "PK.03.7419055", name: "Swābi District" },
    { code: "PK.03.7419056", name: "Lower Dīr District" },
    { code: "PK.03.8061265", name: "Tor Ghar" },
    { code: "PK.03.8224052", name: "Battagram District" },
  ],
  "PK.04": [
    { code: "PK.04.10344547", name: "Vehari District" },
    { code: "PK.04.1164908", name: "Siālkot District" },
    { code: "PK.04.1165218", name: "Shekhūpura District" },
    { code: "PK.04.1165999", name: "Sargodha District" },
    { code: "PK.04.1166545", name: "Sāhīwāl District" },
    { code: "PK.04.1166991", name: "Rawalpindi District" },
    { code: "PK.04.1167458", name: "Rahīmyār Khān District" },
    { code: "PK.04.1169603", name: "Muzaffargarh District" },
    { code: "PK.04.1169821", name: "Multān District" },
    { code: "PK.04.1170424", name: "Miānwāli District" },
    { code: "PK.04.1172449", name: "Lahore District" },
    { code: "PK.04.1174623", name: "Kasūr District" },
    { code: "PK.04.1175862", name: "Jhelum District" },
    { code: "PK.04.1175906", name: "Jhang District" },
    { code: "PK.04.1177651", name: "Gujrāt District" },
    { code: "PK.04.1177658", name: "Gujrānwāla District" },
    { code: "PK.04.1179399", name: "Faisalābād District" },
    { code: "PK.04.1180287", name: "Dera Ghāzi Khān District" },
    { code: "PK.04.1183876", name: "Bahāwalpur District" },
    { code: "PK.04.1183882", name: "Bahāwalnagar District" },
    { code: "PK.04.1184248", name: "Attock District" },
    { code: "PK.04.11886901", name: "Chiniot" },
    { code: "PK.04.7331706", name: "Toba Tek Singh District" },
    { code: "PK.04.7418846", name: "Lodhrān District" },
    { code: "PK.04.7418850", name: "Pākpattan District" },
    { code: "PK.04.7418888", name: "Okāra District" },
    { code: "PK.04.7418890", name: "Khānewāl District" },
    { code: "PK.04.7418962", name: "Hāfizābād District" },
    { code: "PK.04.7418963", name: "Mandi Bahāuddīn District" },
    { code: "PK.04.7418964", name: "Chakwāl District" },
    { code: "PK.04.7418965", name: "Khushāb District" },
    { code: "PK.04.7418966", name: "Bhakkar District" },
    { code: "PK.04.7418967", name: "Layyah District" },
    { code: "PK.04.7418968", name: "Nārowāl District" },
    { code: "PK.04.7419159", name: "Nankāna Sāhib District" },
    { code: "PK.04.8309731", name: "Rājanpur" },
  ],
  "PK.05": [
    { code: "PK.05.10300608", name: "Sujawal District" },
    { code: "PK.05.1163570", name: "Thatta District" },
    { code: "PK.05.1163602", name: "Thar Pārkar District" },
    { code: "PK.05.1164407", name: "Sukkur District" },
    { code: "PK.05.1165106", name: "Shikārpur District" },
    { code: "PK.05.1166162", name: "Sānghar District" },
    { code: "PK.05.1169115", name: "Shaheed Benazirabad District" },
    { code: "PK.05.1172127", name: "Lārkāna District" },
    { code: "PK.05.1174349", name: "Khairpur District" },
    { code: "PK.05.11744831", name: "Karachi Central District" },
    { code: "PK.05.11744832", name: "Karachi East District" },
    { code: "PK.05.11744833", name: "Karachi South District" },
    { code: "PK.05.11744835", name: "Korangi District" },
    { code: "PK.05.11744837", name: "Malir District" },
    { code: "PK.05.1176514", name: "Jacobabad District" },
    { code: "PK.05.1176733", name: "Hyderābād District" },
    { code: "PK.05.1180802", name: "Dādu District" },
    { code: "PK.05.1184051", name: "Badīn District" },
    { code: "PK.05.12105033", name: "District of West Karachi" },
    { code: "PK.05.1376894", name: "Mirpur Khas District" },
    { code: "PK.05.7352189", name: "Naushahro Fīroz District" },
    { code: "PK.05.7418822", name: "Ghotki District" },
    { code: "PK.05.7419156", name: "Jāmshoro District" },
    { code: "PK.05.7419157", name: "Matiāri District" },
    { code: "PK.05.9034783", name: "Qamber Shahdadkot District" },
    { code: "PK.05.9035095", name: "Kashmore District" },
    { code: "PK.05.9072726", name: "Umerkot District" },
    { code: "PK.05.9625763", name: "Tando Allahyar District" },
    { code: "PK.05.9625902", name: "Tando Mohammad Khan District" },
  ],
  "PK.06": [
    { code: "PK.06.1167717", name: "Poonch District" },
    { code: "PK.06.1169606", name: "Muzaffarābād District" },
    { code: "PK.06.1170297", name: "Mirpur District" },
    { code: "PK.06.1173037", name: "Kotli District" },
    { code: "PK.06.7536187", name: "Bhimbar District" },
    { code: "PK.06.7536188", name: "Bagh District" },
    { code: "PK.06.8199376", name: "Neelum District" },
    { code: "PK.06.8309754", name: "Haveli" },
    { code: "PK.06.8309755", name: "Hatian" },
    { code: "PK.06.8986039", name: "Sudhanoti District" },
  ],
  "PK.07": [
    { code: "PK.07.11594770", name: "Ghizer District" },
    { code: "PK.07.11744834", name: "Kharmang District" },
    { code: "PK.07.11744838", name: "Nagar District" },
    { code: "PK.07.11744839", name: "Shigar District" },
    { code: "PK.07.1176775", name: "Hunza-Nagar District" },
    { code: "PK.07.1183615", name: "Skārdu District" },
    { code: "PK.07.7419077", name: "Ghanche District" },
    { code: "PK.07.8309748", name: "Astor" },
    { code: "PK.07.8358419", name: "Gilgit" },
    { code: "PK.07.8358421", name: "Diamīr" },
  ],
  "PL.72": [
    { code: "PL.72.0201", name: "Powiat bolesławiecki" },
    { code: "PL.72.0202", name: "Powiat dzierżoniowski" },
    { code: "PL.72.0203", name: "Powiat głogowski" },
    { code: "PL.72.0204", name: "Powiat górowski" },
    { code: "PL.72.0205", name: "Powiat jaworski" },
    { code: "PL.72.0206", name: "Powiat jeleniogórski" },
    { code: "PL.72.0207", name: "Powiat kamiennogórski" },
    { code: "PL.72.0208", name: "Powiat kłodzki" },
    { code: "PL.72.0209", name: "Powiat legnicki" },
    { code: "PL.72.0210", name: "Powiat lubański" },
    { code: "PL.72.0211", name: "Powiat lubiński" },
    { code: "PL.72.0212", name: "Powiat lwówecki" },
    { code: "PL.72.0213", name: "Powiat milicki" },
    { code: "PL.72.0214", name: "Powiat oleśnicki" },
    { code: "PL.72.0215", name: "Powiat oławski" },
    { code: "PL.72.0216", name: "Powiat polkowicki" },
    { code: "PL.72.0217", name: "Powiat strzeliński" },
    { code: "PL.72.0218", name: "Powiat średzki" },
    { code: "PL.72.0219", name: "Powiat świdnicki" },
    { code: "PL.72.0220", name: "Powiat trzebnicki" },
    { code: "PL.72.0221", name: "Powiat wałbrzyski" },
    { code: "PL.72.0222", name: "Powiat wołowski" },
    { code: "PL.72.0223", name: "Powiat wrocławski" },
    { code: "PL.72.0224", name: "Powiat ząbkowicki" },
    { code: "PL.72.0225", name: "Powiat zgorzelecki" },
    { code: "PL.72.0226", name: "Powiat złotoryjski" },
    { code: "PL.72.0261", name: "Jelenia Góra" },
    { code: "PL.72.0262", name: "Legnica" },
    { code: "PL.72.0264", name: "Wrocław" },
    { code: "PL.72.0265", name: "Wałbrzych" },
  ],
  "PL.73": [
    { code: "PL.73.0401", name: "Powiat aleksandrowski" },
    { code: "PL.73.0402", name: "Powiat brodnicki" },
    { code: "PL.73.0403", name: "Powiat bydgoski" },
    { code: "PL.73.0404", name: "Powiat chełmiński" },
    { code: "PL.73.0405", name: "Powiat golubsko-dobrzyński" },
    { code: "PL.73.0406", name: "Powiat grudziądzki" },
    { code: "PL.73.0407", name: "Powiat inowrocławski" },
    { code: "PL.73.0408", name: "Powiat lipnowski" },
    { code: "PL.73.0409", name: "Powiat mogileński" },
    { code: "PL.73.0410", name: "Powiat nakielski" },
    { code: "PL.73.0411", name: "Powiat radziejowski" },
    { code: "PL.73.0412", name: "Powiat rypiński" },
    { code: "PL.73.0413", name: "Powiat sępoleński" },
    { code: "PL.73.0414", name: "Powiat świecki" },
    { code: "PL.73.0415", name: "Powiat toruński" },
    { code: "PL.73.0416", name: "Powiat tucholski" },
    { code: "PL.73.0417", name: "Powiat wąbrzeski" },
    { code: "PL.73.0418", name: "Powiat włocławski" },
    { code: "PL.73.0419", name: "Powiat żniński" },
    { code: "PL.73.0461", name: "Bydgoszcz" },
    { code: "PL.73.0462", name: "Grudziądz" },
    { code: "PL.73.0463", name: "Toruń" },
    { code: "PL.73.0464", name: "Włocławek" },
  ],
  "PL.74": [
    { code: "PL.74.1001", name: "Powiat bełchatowski" },
    { code: "PL.74.1002", name: "Powiat kutnowski" },
    { code: "PL.74.1003", name: "Powiat łaski" },
    { code: "PL.74.1004", name: "Powiat łęczycki" },
    { code: "PL.74.1005", name: "powiat Łowicki" },
    { code: "PL.74.1006", name: "Powiat łódzki wschodni" },
    { code: "PL.74.1007", name: "Powiat opoczyński" },
    { code: "PL.74.1008", name: "Powiat pabianicki" },
    { code: "PL.74.1009", name: "Powiat pajęczański" },
    { code: "PL.74.1010", name: "Powiat piotrkowski" },
    { code: "PL.74.1011", name: "Powiat poddębicki" },
    { code: "PL.74.1012", name: "Powiat radomszczański" },
    { code: "PL.74.1013", name: "Powiat rawski" },
    { code: "PL.74.1014", name: "Powiat sieradzki" },
    { code: "PL.74.1015", name: "Powiat skierniewicki" },
    { code: "PL.74.1016", name: "Powiat tomaszowski" },
    { code: "PL.74.1017", name: "Powiat wieluński" },
    { code: "PL.74.1018", name: "Powiat wieruszowski" },
    { code: "PL.74.1019", name: "Powiat zduńskowolski" },
    { code: "PL.74.1020", name: "Powiat zgierski" },
    { code: "PL.74.1021", name: "Powiat brzeziński" },
    { code: "PL.74.1061", name: "powiat Łódzki Wschodni" },
    { code: "PL.74.1062", name: "Piotrków Trybunalski" },
    { code: "PL.74.1063", name: "Skierniewice" },
  ],
  "PL.75": [
    { code: "PL.75.0601", name: "Powiat bialski" },
    { code: "PL.75.0602", name: "Powiat biłgorajski" },
    { code: "PL.75.0603", name: "Powiat chełmski" },
    { code: "PL.75.0604", name: "Powiat hrubieszowski" },
    { code: "PL.75.0605", name: "Powiat janowski" },
    { code: "PL.75.0606", name: "Powiat krasnostawski" },
    { code: "PL.75.0607", name: "Powiat kraśnicki" },
    { code: "PL.75.0608", name: "Powiat lubartowski" },
    { code: "PL.75.0609", name: "Powiat lubelski" },
    { code: "PL.75.0610", name: "Powiat łęczyński" },
    { code: "PL.75.0611", name: "Powiat łukowski" },
    { code: "PL.75.0612", name: "Powiat opolski" },
    { code: "PL.75.0613", name: "Powiat parczewski" },
    { code: "PL.75.0614", name: "Powiat puławski" },
    { code: "PL.75.0615", name: "Powiat radzyński" },
    { code: "PL.75.0616", name: "Powiat rycki" },
    { code: "PL.75.0617", name: "Powiat świdnicki" },
    { code: "PL.75.0618", name: "Powiat tomaszowski" },
    { code: "PL.75.0619", name: "Powiat włodawski" },
    { code: "PL.75.0620", name: "Powiat zamojski" },
    { code: "PL.75.0661", name: "Biała Podlaska" },
    { code: "PL.75.0662", name: "Chełm" },
    { code: "PL.75.0663", name: "Lublin" },
    { code: "PL.75.0664", name: "Zamość" },
  ],
  "PL.76": [
    { code: "PL.76.0801", name: "Powiat gorzowski" },
    { code: "PL.76.0802", name: "Powiat krośnieński" },
    { code: "PL.76.0803", name: "Powiat międzyrzecki" },
    { code: "PL.76.0804", name: "Powiat nowosolski" },
    { code: "PL.76.0805", name: "Powiat słubicki" },
    { code: "PL.76.0806", name: "Powiat strzelecko-drezdenecki" },
    { code: "PL.76.0807", name: "Powiat sulęciński" },
    { code: "PL.76.0808", name: "Powiat świebodziński" },
    { code: "PL.76.0809", name: "Powiat zielonogórski" },
    { code: "PL.76.0810", name: "Powiat żagański" },
    { code: "PL.76.0811", name: "Powiat żarski" },
    { code: "PL.76.0812", name: "Powiat wschowski" },
    { code: "PL.76.0861", name: "Gorzów Wielkopolski" },
    { code: "PL.76.0862", name: "Zielona Góra" },
  ],
  "PL.77": [
    { code: "PL.77.1201", name: "Powiat bocheński" },
    { code: "PL.77.1202", name: "Powiat brzeski" },
    { code: "PL.77.1203", name: "Powiat chrzanowski" },
    { code: "PL.77.1204", name: "Powiat dąbrowski" },
    { code: "PL.77.1205", name: "Powiat gorlicki" },
    { code: "PL.77.1206", name: "Powiat krakowski" },
    { code: "PL.77.1207", name: "Powiat limanowski" },
    { code: "PL.77.1208", name: "Powiat miechowski" },
    { code: "PL.77.1209", name: "Powiat myślenicki" },
    { code: "PL.77.1210", name: "Powiat nowosądecki" },
    { code: "PL.77.1211", name: "Powiat nowotarski" },
    { code: "PL.77.1212", name: "Powiat olkuski" },
    { code: "PL.77.1213", name: "Powiat oświęcimski" },
    { code: "PL.77.1214", name: "Powiat proszowicki" },
    { code: "PL.77.1215", name: "Powiat suski" },
    { code: "PL.77.1216", name: "Powiat tarnowski" },
    { code: "PL.77.1217", name: "Powiat tatrzański" },
    { code: "PL.77.1218", name: "Powiat wadowicki" },
    { code: "PL.77.1219", name: "Powiat wielicki" },
    { code: "PL.77.1261", name: "Kraków" },
    { code: "PL.77.1262", name: "Powiat nowosądecki" },
    { code: "PL.77.1263", name: "Powiat tarnowski" },
  ],
  "PL.78": [
    { code: "PL.78.1401", name: "Powiat białobrzeski" },
    { code: "PL.78.1402", name: "Powiat ciechanowski" },
    { code: "PL.78.1403", name: "Powiat garwoliński" },
    { code: "PL.78.1404", name: "Powiat gostyniński" },
    { code: "PL.78.1405", name: "Powiat grodziski" },
    { code: "PL.78.1406", name: "Powiat grójecki" },
    { code: "PL.78.1407", name: "Powiat kozienicki" },
    { code: "PL.78.1408", name: "Powiat legionowski" },
    { code: "PL.78.1409", name: "Powiat lipski" },
    { code: "PL.78.1410", name: "Powiat łosicki" },
    { code: "PL.78.1411", name: "Powiat makowski" },
    { code: "PL.78.1412", name: "Powiat miński" },
    { code: "PL.78.1413", name: "Powiat mławski" },
    { code: "PL.78.1414", name: "Powiat nowodworski" },
    { code: "PL.78.1415", name: "Powiat ostrołęcki" },
    { code: "PL.78.1416", name: "Powiat ostrowski" },
    { code: "PL.78.1417", name: "Powiat otwocki" },
    { code: "PL.78.1418", name: "Powiat piaseczyński" },
    { code: "PL.78.1419", name: "Powiat płocki" },
    { code: "PL.78.1420", name: "Powiat płoński" },
    { code: "PL.78.1421", name: "Powiat pruszkowski" },
    { code: "PL.78.1422", name: "Powiat przasnyski" },
    { code: "PL.78.1423", name: "Powiat przysuski" },
    { code: "PL.78.1424", name: "Powiat pułtuski" },
    { code: "PL.78.1425", name: "Powiat radomski" },
    { code: "PL.78.1426", name: "Powiat siedlecki" },
    { code: "PL.78.1427", name: "Powiat sierpecki" },
    { code: "PL.78.1428", name: "Powiat sochaczewski" },
    { code: "PL.78.1429", name: "Powiat sokołowski" },
    { code: "PL.78.1430", name: "Powiat szydłowiecki" },
    { code: "PL.78.1432", name: "Powiat warszawski zachodni" },
    { code: "PL.78.1433", name: "Powiat węgrowski" },
    { code: "PL.78.1434", name: "Powiat wołomiński" },
    { code: "PL.78.1435", name: "Powiat wyszkowski" },
    { code: "PL.78.1436", name: "Powiat zwoleński" },
    { code: "PL.78.1437", name: "Powiat żuromiński" },
    { code: "PL.78.1438", name: "Powiat żyrardowski" },
    { code: "PL.78.1461", name: "Ostrołęka" },
    { code: "PL.78.1462", name: "Płock" },
    { code: "PL.78.1463", name: "Radom" },
    { code: "PL.78.1464", name: "Siedlce" },
    { code: "PL.78.1465", name: "Warszawa" },
  ],
  "PL.79": [
    { code: "PL.79.1601", name: "Powiat brzeski" },
    { code: "PL.79.1602", name: "Powiat głubczycki" },
    { code: "PL.79.1603", name: "Powiat kędzierzyńsko-kozielski" },
    { code: "PL.79.1604", name: "Powiat kluczborski" },
    { code: "PL.79.1605", name: "Powiat krapkowicki" },
    { code: "PL.79.1606", name: "Powiat namysłowski" },
    { code: "PL.79.1607", name: "Powiat nyski" },
    { code: "PL.79.1608", name: "Powiat oleski" },
    { code: "PL.79.1609", name: "Powiat opolski" },
    { code: "PL.79.1610", name: "Powiat prudnicki" },
    { code: "PL.79.1611", name: "Powiat strzelecki" },
    { code: "PL.79.1661", name: "Opole" },
  ],
  "PL.80": [
    { code: "PL.80.1801", name: "Powiat bieszczadzki" },
    { code: "PL.80.1802", name: "Powiat brzozowski" },
    { code: "PL.80.1803", name: "Powiat dębicki" },
    { code: "PL.80.1804", name: "Powiat jarosławski" },
    { code: "PL.80.1805", name: "Powiat jasielski" },
    { code: "PL.80.1806", name: "Powiat kolbuszowski" },
    { code: "PL.80.1807", name: "Powiat krośnieński" },
    { code: "PL.80.1808", name: "Powiat leżajski" },
    { code: "PL.80.1809", name: "Powiat lubaczowski" },
    { code: "PL.80.1810", name: "Powiat łańcucki" },
    { code: "PL.80.1811", name: "Powiat mielecki" },
    { code: "PL.80.1812", name: "Powiat niżański" },
    { code: "PL.80.1813", name: "Powiat przemyski" },
    { code: "PL.80.1814", name: "Powiat przeworski" },
    { code: "PL.80.1815", name: "Powiat ropczycko-sędziszowski" },
    { code: "PL.80.1816", name: "Powiat rzeszowski" },
    { code: "PL.80.1817", name: "Powiat sanocki" },
    { code: "PL.80.1818", name: "Powiat stalowowolski" },
    { code: "PL.80.1819", name: "Powiat strzyżowski" },
    { code: "PL.80.1820", name: "Powiat tarnobrzeski" },
    { code: "PL.80.1821", name: "Powiat leski" },
    { code: "PL.80.1861", name: "Krosno" },
    { code: "PL.80.1862", name: "Przemyśl" },
    { code: "PL.80.1863", name: "Rzeszów" },
    { code: "PL.80.1864", name: "Tarnobrzeg" },
  ],
  "PL.81": [
    { code: "PL.81.2001", name: "Powiat augustowski" },
    { code: "PL.81.2002", name: "Powiat białostocki" },
    { code: "PL.81.2003", name: "Powiat bielski" },
    { code: "PL.81.2004", name: "Powiat grajewski" },
    { code: "PL.81.2005", name: "Powiat hajnowski" },
    { code: "PL.81.2006", name: "Powiat kolneński" },
    { code: "PL.81.2007", name: "Powiat łomżyński" },
    { code: "PL.81.2008", name: "Powiat moniecki" },
    { code: "PL.81.2009", name: "Powiat sejneński" },
    { code: "PL.81.2010", name: "Powiat siemiatycki" },
    { code: "PL.81.2011", name: "Powiat sokólski" },
    { code: "PL.81.2012", name: "Powiat suwalski" },
    { code: "PL.81.2013", name: "Powiat wysokomazowiecki" },
    { code: "PL.81.2014", name: "Powiat zambrowski" },
    { code: "PL.81.2061", name: "Białystok" },
    { code: "PL.81.2062", name: "Łomża" },
    { code: "PL.81.2063", name: "Suwałki" },
  ],
  "PL.82": [
    { code: "PL.82.2201", name: "Powiat bytowski" },
    { code: "PL.82.2202", name: "Powiat chojnicki" },
    { code: "PL.82.2203", name: "Powiat człuchowski" },
    { code: "PL.82.2204", name: "Powiat gdański" },
    { code: "PL.82.2205", name: "Powiat kartuski" },
    { code: "PL.82.2206", name: "Powiat kościerski" },
    { code: "PL.82.2207", name: "Powiat kwidzyński" },
    { code: "PL.82.2208", name: "Powiat lęborski" },
    { code: "PL.82.2209", name: "Powiat malborski" },
    { code: "PL.82.2210", name: "Powiat nowodworski" },
    { code: "PL.82.2211", name: "Powiat pucki" },
    { code: "PL.82.2212", name: "Powiat słupski" },
    { code: "PL.82.2213", name: "Powiat starogardzki" },
    { code: "PL.82.2214", name: "Powiat tczewski" },
    { code: "PL.82.2215", name: "Powiat wejherowski" },
    { code: "PL.82.2216", name: "Powiat sztumski" },
    { code: "PL.82.2261", name: "Gdańsk" },
    { code: "PL.82.2262", name: "Gdynia" },
    { code: "PL.82.2263", name: "Słupsk" },
    { code: "PL.82.2264", name: "Sopot" },
  ],
  "PL.83": [
    { code: "PL.83.2401", name: "Powiat będziński" },
    { code: "PL.83.2402", name: "Powiat bielski" },
    { code: "PL.83.2403", name: "Powiat cieszyński" },
    { code: "PL.83.2404", name: "Powiat częstochowski" },
    { code: "PL.83.2405", name: "Powiat gliwicki" },
    { code: "PL.83.2406", name: "Powiat kłobucki" },
    { code: "PL.83.2407", name: "Powiat lubliniecki" },
    { code: "PL.83.2408", name: "Powiat mikołowski" },
    { code: "PL.83.2409", name: "Powiat myszkowski" },
    { code: "PL.83.2410", name: "Powiat pszczyński" },
    { code: "PL.83.2411", name: "Powiat raciborski" },
    { code: "PL.83.2412", name: "Powiat rybnicki" },
    { code: "PL.83.2413", name: "Powiat tarnogórski" },
    { code: "PL.83.2414", name: "Powiat bieruńsko-lędziński" },
    { code: "PL.83.2415", name: "Powiat wodzisławski" },
    { code: "PL.83.2416", name: "Powiat zawierciański" },
    { code: "PL.83.2417", name: "Powiat żywiecki" },
    { code: "PL.83.2461", name: "Bielsko-Biała" },
    { code: "PL.83.2462", name: "Bytom" },
    { code: "PL.83.2463", name: "Chorzów" },
    { code: "PL.83.2464", name: "Częstochowa" },
    { code: "PL.83.2465", name: "Dąbrowa Górnicza" },
    { code: "PL.83.2466", name: "Gliwice" },
    { code: "PL.83.2467", name: "Jastrzębie-Zdrój" },
    { code: "PL.83.2468", name: "Jaworzno" },
    { code: "PL.83.2469", name: "Katowice" },
    { code: "PL.83.2470", name: "Mysłowice" },
    { code: "PL.83.2471", name: "Piekary Śląskie" },
    { code: "PL.83.2472", name: "Ruda Śląska" },
    { code: "PL.83.2473", name: "Rybnik" },
    { code: "PL.83.2474", name: "Siemianowice Śląskie" },
    { code: "PL.83.2475", name: "Sosnowiec" },
    { code: "PL.83.2476", name: "Świętochłowice" },
    { code: "PL.83.2477", name: "Tychy" },
    { code: "PL.83.2478", name: "Zabrze" },
    { code: "PL.83.2479", name: "Żory" },
  ],
  "PL.84": [
    { code: "PL.84.2601", name: "Powiat buski" },
    { code: "PL.84.2602", name: "Powiat jędrzejowski" },
    { code: "PL.84.2603", name: "Powiat kazimierski" },
    { code: "PL.84.2604", name: "Powiat kielecki" },
    { code: "PL.84.2605", name: "Powiat konecki" },
    { code: "PL.84.2606", name: "Powiat opatowski" },
    { code: "PL.84.2607", name: "Powiat ostrowiecki" },
    { code: "PL.84.2608", name: "Powiat pińczowski" },
    { code: "PL.84.2609", name: "Powiat sandomierski" },
    { code: "PL.84.2610", name: "Powiat skarżyski" },
    { code: "PL.84.2611", name: "Powiat starachowicki" },
    { code: "PL.84.2612", name: "Powiat staszowski" },
    { code: "PL.84.2613", name: "Powiat włoszczowski" },
    { code: "PL.84.2661", name: "Kielce" },
  ],
  "PL.85": [
    { code: "PL.85.2801", name: "Powiat bartoszycki" },
    { code: "PL.85.2802", name: "Powiat braniewski" },
    { code: "PL.85.2803", name: "Powiat działdowski" },
    { code: "PL.85.2804", name: "Powiat elbląski" },
    { code: "PL.85.2805", name: "Powiat ełcki" },
    { code: "PL.85.2806", name: "Powiat giżycki" },
    { code: "PL.85.2807", name: "Powiat iławski" },
    { code: "PL.85.2808", name: "Powiat kętrzyński" },
    { code: "PL.85.2809", name: "Powiat lidzbarski" },
    { code: "PL.85.2810", name: "Powiat mrągowski" },
    { code: "PL.85.2811", name: "Powiat nidzicki" },
    { code: "PL.85.2812", name: "Powiat nowomiejski" },
    { code: "PL.85.2813", name: "Powiat olecki" },
    { code: "PL.85.2814", name: "Powiat olsztyński" },
    { code: "PL.85.2815", name: "Powiat ostródzki" },
    { code: "PL.85.2816", name: "Powiat piski" },
    { code: "PL.85.2817", name: "Powiat szczycieński" },
    { code: "PL.85.2818", name: "Powiat gołdapski" },
    { code: "PL.85.2819", name: "Powiat węgorzewski" },
    { code: "PL.85.2861", name: "Elbląg" },
    { code: "PL.85.2862", name: "Olsztyn" },
  ],
  "PL.86": [
    { code: "PL.86.3001", name: "Powiat chodzieski" },
    { code: "PL.86.3002", name: "Powiat czarnkowsko-trzcianecki" },
    { code: "PL.86.3003", name: "Powiat gnieźnieński" },
    { code: "PL.86.3004", name: "Powiat gostyński" },
    { code: "PL.86.3005", name: "Powiat grodziski" },
    { code: "PL.86.3006", name: "Powiat jarociński" },
    { code: "PL.86.3007", name: "Powiat kaliski" },
    { code: "PL.86.3008", name: "Powiat kępiński" },
    { code: "PL.86.3009", name: "Powiat kolski" },
    { code: "PL.86.3010", name: "Powiat koniński" },
    { code: "PL.86.3011", name: "Powiat kościański" },
    { code: "PL.86.3012", name: "Powiat krotoszyński" },
    { code: "PL.86.3013", name: "Powiat leszczyński" },
    { code: "PL.86.3014", name: "Powiat międzychodzki" },
    { code: "PL.86.3015", name: "Powiat nowotomyski" },
    { code: "PL.86.3016", name: "Powiat obornicki" },
    { code: "PL.86.3017", name: "Powiat ostrowski" },
    { code: "PL.86.3018", name: "Powiat ostrzeszowski" },
    { code: "PL.86.3019", name: "Powiat pilski" },
    { code: "PL.86.3020", name: "Powiat pleszewski" },
    { code: "PL.86.3021", name: "Powiat poznański" },
    { code: "PL.86.3022", name: "Powiat rawicki" },
    { code: "PL.86.3023", name: "Powiat słupecki" },
    { code: "PL.86.3024", name: "Powiat szamotulski" },
    { code: "PL.86.3025", name: "Powiat średzki" },
    { code: "PL.86.3026", name: "Powiat śremski" },
    { code: "PL.86.3027", name: "Powiat turecki" },
    { code: "PL.86.3028", name: "Powiat wągrowiecki" },
    { code: "PL.86.3029", name: "Powiat wolsztyński" },
    { code: "PL.86.3030", name: "Powiat wrzesiński" },
    { code: "PL.86.3031", name: "Powiat złotowski" },
    { code: "PL.86.3061", name: "Kalisz" },
    { code: "PL.86.3062", name: "Konin" },
    { code: "PL.86.3063", name: "Leszno" },
    { code: "PL.86.3064", name: "Poznań" },
  ],
  "PL.87": [
    { code: "PL.87.3201", name: "Powiat białogardzki" },
    { code: "PL.87.3202", name: "Powiat choszczeński" },
    { code: "PL.87.3203", name: "Powiat drawski" },
    { code: "PL.87.3204", name: "Powiat goleniowski" },
    { code: "PL.87.3205", name: "Powiat gryficki" },
    { code: "PL.87.3206", name: "Powiat gryfiński" },
    { code: "PL.87.3207", name: "Powiat kamieński" },
    { code: "PL.87.3208", name: "Powiat kołobrzeski" },
    { code: "PL.87.3209", name: "Powiat koszaliński" },
    { code: "PL.87.3210", name: "Powiat myśliborski" },
    { code: "PL.87.3211", name: "Powiat policki" },
    { code: "PL.87.3212", name: "Powiat pyrzycki" },
    { code: "PL.87.3213", name: "Powiat sławieński" },
    { code: "PL.87.3214", name: "Powiat stargardzki" },
    { code: "PL.87.3215", name: "Powiat szczecinecki" },
    { code: "PL.87.3216", name: "Powiat świdwiński" },
    { code: "PL.87.3217", name: "Powiat wałecki" },
    { code: "PL.87.3218", name: "Powiat łobeski" },
    { code: "PL.87.3261", name: "Koszalin" },
    { code: "PL.87.3262", name: "Szczecin" },
    { code: "PL.87.3263", name: "Świnoujście" },
  ],
  "PR.001": [
    { code: "PR.001.7268167", name: "Adjuntas Pueblo Barrio" },
    { code: "PR.001.7268336", name: "Capáez Barrio" },
    { code: "PR.001.7268409", name: "Garzas Barrio" },
    { code: "PR.001.7268435", name: "Guayabo Dulce Barrio" },
    { code: "PR.001.7268442", name: "Guayo Barrio" },
    { code: "PR.001.7268445", name: "Guilarte Barrio" },
    { code: "PR.001.7268529", name: "Juan González Barrio" },
    { code: "PR.001.7268558", name: "Limaní Barrio" },
    { code: "PR.001.7268744", name: "Pellejas Barrio" },
    { code: "PR.001.7268777", name: "Portillo Barrio" },
    { code: "PR.001.7268778", name: "Portugués Barrio" },
    { code: "PR.001.7268954", name: "Saltillo Barrio" },
    { code: "PR.001.7269027", name: "Tanamá Barrio" },
    { code: "PR.001.7269070", name: "Vegas Abajo Barrio" },
    { code: "PR.001.7269086", name: "Yahuecas Barrio" },
    { code: "PR.001.7269089", name: "Yayales Barrio" },
    { code: "PR.001.8199258", name: "Vegas Arriba" },
  ],
  "PR.003": [
    { code: "PR.003.7268063", name: "Cerro Gordo Barrio" },
    { code: "PR.003.7268119", name: "Cruces Barrio" },
    { code: "PR.003.7268170", name: "Aguada Barrio-Pueblo" },
    { code: "PR.003.7268215", name: "Asomante Barrio" },
    { code: "PR.003.7268217", name: "Atalaya Barrio" },
    { code: "PR.003.7268350", name: "Carrizal Barrio" },
    { code: "PR.003.7268377", name: "Espinar Barrio" },
    { code: "PR.003.7268418", name: "Guanábano Barrio" },
    { code: "PR.003.7268423", name: "Guaniquilla Barrio" },
    { code: "PR.003.7268434", name: "Guayabo Barrio" },
    { code: "PR.003.7268512", name: "Jagüey Barrio" },
    { code: "PR.003.7268541", name: "Lagunas Barrio" },
    { code: "PR.003.7268595", name: "Mal Paso Barrio" },
    { code: "PR.003.7268600", name: "Mamey Barrio" },
    { code: "PR.003.7268620", name: "Marías Barrio" },
    { code: "PR.003.7268695", name: "Naranjo Barrio" },
    { code: "PR.003.7268756", name: "Piedras Blancas Barrio" },
    { code: "PR.003.7268905", name: "Río Grande Barrio" },
  ],
  "PR.005": [
    { code: "PR.005.7268050", name: "Ceiba Baja Barrio" },
    { code: "PR.005.7268111", name: "Corrales Barrio" },
    { code: "PR.005.7268168", name: "Aguacate Barrio" },
    { code: "PR.005.7268171", name: "Aguadilla Barrio-Pueblo" },
    { code: "PR.005.7268210", name: "Arenales Barrio" },
    { code: "PR.005.7268262", name: "Borinquen Barrio" },
    { code: "PR.005.7268289", name: "Caimital Alto Barrio" },
    { code: "PR.005.7268290", name: "Caimital Bajo Barrio" },
    { code: "PR.005.7268304", name: "Camaceyes Barrio" },
    { code: "PR.005.7268366", name: "Ceiba Alta Barrio" },
    { code: "PR.005.7268443", name: "Guerrero Barrio" },
    { code: "PR.005.7268596", name: "Maleza Alta Barrio" },
    { code: "PR.005.7268597", name: "Maleza Baja Barrio" },
    { code: "PR.005.7268669", name: "Montaña Barrio" },
    { code: "PR.005.7268716", name: "Palmar Barrio" },
    { code: "PR.005.7269076", name: "Victoria Barrio" },
  ],
  "PR.007": [
    { code: "PR.007.7268173", name: "Aguas Buenas Barrio-Pueblo" },
    { code: "PR.007.7268221", name: "Bairoa Barrio" },
    { code: "PR.007.7268247", name: "Bayamoncito Barrio" },
    { code: "PR.007.7268288", name: "Cagüitas Barrio" },
    { code: "PR.007.7268514", name: "Jagüeyes Barrio" },
    { code: "PR.007.7268528", name: "Juan Asencio Barrio" },
    { code: "PR.007.7268686", name: "Mula Barrio" },
    { code: "PR.007.7268688", name: "Mulita Barrio" },
    { code: "PR.007.7269011", name: "Sonadora Barrio" },
    { code: "PR.007.7269015", name: "Sumidero Barrio" },
  ],
  "PR.009": [
    { code: "PR.009.7268139", name: "Cuyón Barrio" },
    { code: "PR.009.7268178", name: "Aibonito Barrio-Pueblo" },
    { code: "PR.009.7268180", name: "Algarrobo Barrio" },
    { code: "PR.009.7268216", name: "Asomante Barrio" },
    { code: "PR.009.7268334", name: "Caonillas Barrio" },
    { code: "PR.009.7268566", name: "Llanos Barrio" },
    { code: "PR.009.7268735", name: "Pasto Barrio" },
    { code: "PR.009.7268765", name: "Plata Barrio" },
    { code: "PR.009.7268920", name: "Robles Barrio" },
  ],
  "PR.011": [
    { code: "PR.011.7268064", name: "Cerro Gordo Barrio" },
    { code: "PR.011.7268079", name: "Cidra Barrio" },
    { code: "PR.011.7268107", name: "Corcovada Barrio" },
    { code: "PR.011.7268143", name: "Dagüey Barrio" },
    { code: "PR.011.7268194", name: "Añasco Abajo Barrio" },
    { code: "PR.011.7268195", name: "Añasco Arriba Barrio" },
    { code: "PR.011.7268196", name: "Añasco Barrio-Pueblo" },
    { code: "PR.011.7268285", name: "Caguabo Barrio" },
    { code: "PR.011.7268341", name: "Caracol Barrio" },
    { code: "PR.011.7268348", name: "Carreras Barrio" },
    { code: "PR.011.7268353", name: "Casey Abajo Barrio" },
    { code: "PR.011.7268354", name: "Casey Arriba Barrio" },
    { code: "PR.011.7268378", name: "Espino Barrio" },
    { code: "PR.011.7268451", name: "Hatillo Barrio" },
    { code: "PR.011.7268487", name: "Humatas Barrio" },
    { code: "PR.011.7268621", name: "Marías Barrio" },
    { code: "PR.011.7268659", name: "Miraflores Barrio" },
    { code: "PR.011.7268712", name: "Ovejas Barrio" },
    { code: "PR.011.7268759", name: "Piñales Barrio" },
    { code: "PR.011.7268768", name: "Playa Barrio" },
    { code: "PR.011.7268859", name: "Quebrada Larga Barrio" },
    { code: "PR.011.7268889", name: "Río Arriba Barrio" },
    { code: "PR.011.7268902", name: "Río Cañas Barrio" },
  ],
  "PR.013": [
    { code: "PR.013.7268150", name: "Domingo Ruíz Barrio" },
    { code: "PR.013.7268151", name: "Dominguito Barrio" },
    { code: "PR.013.7268205", name: "Arecibo Barrio-Pueblo" },
    { code: "PR.013.7268207", name: "Arenalejos Barrio" },
    { code: "PR.013.7268214", name: "Arrozal Barrio" },
    { code: "PR.013.7268306", name: "Cambalache Barrio" },
    { code: "PR.013.7268349", name: "Carreras Barrio" },
    { code: "PR.013.7268376", name: "Esperanza Barrio" },
    { code: "PR.013.7268384", name: "Factor Barrio" },
    { code: "PR.013.7268407", name: "Garrochales Barrio" },
    { code: "PR.013.7268454", name: "Hato Abajo Barrio" },
    { code: "PR.013.7268455", name: "Hato Arriba Barrio" },
    { code: "PR.013.7268467", name: "Hato Viejo Barrio" },
    { code: "PR.013.7268499", name: "Islote Barrio" },
    { code: "PR.013.7268660", name: "Miraflores Barrio" },
    { code: "PR.013.7268890", name: "Río Arriba Barrio" },
    { code: "PR.013.7268942", name: "Sabana Hoyos Barrio" },
    { code: "PR.013.7268995", name: "Santana Barrio" },
    { code: "PR.013.7269028", name: "Tanamá Barrio" },
  ],
  "PR.015": [
    { code: "PR.015.7268197", name: "Ancones Barrio" },
    { code: "PR.015.7268213", name: "Arroyo Barrio-Pueblo" },
    { code: "PR.015.7268430", name: "Guásimas Barrio" },
    { code: "PR.015.7268722", name: "Palmas Barrio" },
    { code: "PR.015.7268762", name: "Pitahaya Barrio" },
    { code: "PR.015.7269088", name: "Yaurel Barrio" },
  ],
  "PR.017": [
    { code: "PR.017.7268232", name: "Barceloneta Barrio-Pueblo" },
    { code: "PR.017.7268394", name: "Florida Afuera Barrio" },
    { code: "PR.017.7268408", name: "Garrochales Barrio" },
    { code: "PR.017.7268721", name: "Palmas Altas Barrio" },
  ],
  "PR.019": [
    { code: "PR.019.7268234", name: "Barrancas Barrio" },
    { code: "PR.019.7268235", name: "Barranquitas Barrio-Pueblo" },
    { code: "PR.019.7268312", name: "Cañabón Barrio" },
    { code: "PR.019.7268470", name: "Helechal Barrio" },
    { code: "PR.019.7268479", name: "Honduras Barrio" },
    { code: "PR.019.7268726", name: "Palo Hincado Barrio" },
    { code: "PR.019.7268853", name: "Quebrada Grande Barrio" },
    { code: "PR.019.7268867", name: "Quebradillas Barrio" },
  ],
  "PR.021": [
    { code: "PR.021.7268065", name: "Cerro Gordo Barrio" },
    { code: "PR.021.7268144", name: "Dajaos Barrio" },
    { code: "PR.021.7268246", name: "Bayamón Barrio-Pueblo" },
    { code: "PR.021.7268270", name: "Buena Vista Barrio" },
    { code: "PR.021.7268425", name: "Guaraguao Abajo Barrio" },
    { code: "PR.021.7268426", name: "Guaraguao Arriba Barrio" },
    { code: "PR.021.7268466", name: "Hato Tejas Barrio" },
    { code: "PR.021.7268532", name: "Juan Sánchez Barrio" },
    { code: "PR.021.7268653", name: "Minillas Barrio" },
    { code: "PR.021.7268703", name: "Nuevo Barrio" },
    { code: "PR.021.7268714", name: "Pájaros Barrio" },
    { code: "PR.021.7268990", name: "Santa Olaya Barrio" },
  ],
  "PR.023": [
    { code: "PR.023.7268226", name: "Bajura Barrio" },
    { code: "PR.023.7268260", name: "Boquerón Barrio" },
    { code: "PR.023.7268279", name: "Cabo Rojo Barrio-Pueblo" },
    { code: "PR.023.7268419", name: "Guanajibo Barrio" },
    { code: "PR.023.7268568", name: "Llanos Costa Barrio" },
    { code: "PR.023.7268569", name: "Llanos Tuna Barrio" },
    { code: "PR.023.7268657", name: "Miradero Barrio" },
    { code: "PR.023.7268670", name: "Monte Grande Barrio" },
    { code: "PR.023.7268741", name: "Pedernales Barrio" },
  ],
  "PR.025": [
    { code: "PR.025.7268222", name: "Bairoa Barrio" },
    { code: "PR.025.7268250", name: "Beatriz Barrio" },
    { code: "PR.025.7268263", name: "Borinquen Barrio" },
    { code: "PR.025.7268287", name: "Caguas Barrio-Pueblo" },
    { code: "PR.025.7268313", name: "Cañabón Barrio" },
    { code: "PR.025.7268314", name: "Cañaboncito Barrio" },
    { code: "PR.025.7268903", name: "Río Cañas Barrio" },
    { code: "PR.025.7268963", name: "San Antonio Barrio" },
    { code: "PR.025.7268983", name: "San Salvador Barrio" },
    { code: "PR.025.7269043", name: "Tomás de Castro Barrio" },
    { code: "PR.025.7269055", name: "Turabo Barrio" },
  ],
  "PR.027": [
    { code: "PR.027.7268075", name: "Cibao Barrio" },
    { code: "PR.027.7268085", name: "Ciénagas Barrio" },
    { code: "PR.027.7268163", name: "Abra Honda Barrio" },
    { code: "PR.027.7268310", name: "Camuy Arriba Barrio" },
    { code: "PR.027.7268311", name: "Camuy Barrio-Pueblo" },
    { code: "PR.027.7268650", name: "Membrillo Barrio" },
    { code: "PR.027.7268754", name: "Piedra Gorda Barrio" },
    { code: "PR.027.7268823", name: "Puente Barrio" },
    { code: "PR.027.7268831", name: "Puertos Barrio" },
    { code: "PR.027.7268848", name: "Quebrada Barrio" },
    { code: "PR.027.7268997", name: "Santiago Barrio" },
    { code: "PR.027.7269090", name: "Yeguada Barrio" },
    { code: "PR.027.7269093", name: "Zanja Barrio" },
  ],
  "PR.029": [
    { code: "PR.029.7268128", name: "Cubuy Barrio" },
    { code: "PR.029.7268326", name: "Canóvanas Barrio" },
    { code: "PR.029.7268328", name: "Canóvanas Barrio-Pueblo" },
    { code: "PR.029.7268462", name: "Hato Puerco Barrio" },
    { code: "PR.029.7268573", name: "Lomas Barrio" },
    { code: "PR.029.7269046", name: "Torrecilla Alta Barrio" },
  ],
  "PR.031": [
    { code: "PR.031.7268236", name: "Barrazas Barrio" },
    { code: "PR.031.7268282", name: "Cacao Barrio" },
    { code: "PR.031.7268323", name: "Cangrejo Arriba Barrio" },
    { code: "PR.031.7268329", name: "Canovanillas Barrio" },
    { code: "PR.031.7268346", name: "Carolina Barrio-Pueblo" },
    { code: "PR.031.7268352", name: "Carruzos Barrio" },
    { code: "PR.031.7268363", name: "Cedro Barrio" },
    { code: "PR.031.7268484", name: "Buena Vista Barrio (Inactive)" },
    { code: "PR.031.7268631", name: "Martín González Barrio" },
    { code: "PR.031.7268934", name: "Sabana Abajo Barrio" },
    { code: "PR.031.7268961", name: "San Antón Barrio" },
    { code: "PR.031.7268987", name: "Santa Cruz Barrio" },
    { code: "PR.031.7269053", name: "Trujillo Bajo Barrio" },
  ],
  "PR.033": [
    { code: "PR.033.7268356", name: "Cataño Barrio-Pueblo" },
    { code: "PR.033.7268723", name: "Palmas Barrio" },
  ],
  "PR.035": [
    { code: "PR.035.7268061", name: "Cercadillo Barrio" },
    { code: "PR.035.7268135", name: "Culebras Alto Barrio" },
    { code: "PR.035.7268136", name: "Culebras Bajo Barrio" },
    { code: "PR.035.7268251", name: "Beatriz Barrio" },
    { code: "PR.035.7268359", name: "Cayey Barrio-Pueblo" },
    { code: "PR.035.7268364", name: "Cedro Barrio" },
    { code: "PR.035.7268386", name: "Farallón Barrio" },
    { code: "PR.035.7268432", name: "Guavate Barrio" },
    { code: "PR.035.7268516", name: "Jájome Alto Barrio" },
    { code: "PR.035.7268517", name: "Jájome Bajo Barrio" },
    { code: "PR.035.7268545", name: "Lapa Barrio" },
    { code: "PR.035.7268638", name: "Matón Abajo Barrio" },
    { code: "PR.035.7268639", name: "Matón Arriba Barrio" },
    { code: "PR.035.7268671", name: "Monte Llano Barrio" },
    { code: "PR.035.7268739", name: "Pasto Viejo Barrio" },
    { code: "PR.035.7268742", name: "Pedro Avila Barrio" },
    { code: "PR.035.7268755", name: "Piedras Barrio" },
    { code: "PR.035.7268846", name: "Quebrada Arriba Barrio" },
    { code: "PR.035.7268879", name: "Rincón Barrio" },
    { code: "PR.035.7269016", name: "Sumido Barrio" },
    { code: "PR.035.7269041", name: "Toíta Barrio" },
    { code: "PR.035.7269072", name: "Vegas Barrio" },
  ],
  "PR.037": [
    { code: "PR.037.7268054", name: "Ceiba Barrio-Pueblo" },
    { code: "PR.037.7268072", name: "Chupacallos Barrio" },
    { code: "PR.037.7268141", name: "Daguao Barrio" },
    { code: "PR.037.7268438", name: "Guayacán Barrio" },
    { code: "PR.037.7268583", name: "Machos Barrio" },
    { code: "PR.037.7268862", name: "Quebrada Seca Barrio" },
    { code: "PR.037.7268884", name: "Río Abajo Barrio" },
    { code: "PR.037.7268950", name: "Saco Barrio" },
  ],
  "PR.039": [
    { code: "PR.039.7268073", name: "Ciales Barrio-Pueblo" },
    { code: "PR.039.7268074", name: "Cialitos Barrio" },
    { code: "PR.039.7268109", name: "Cordillera Barrio" },
    { code: "PR.039.7268401", name: "Frontón Barrio" },
    { code: "PR.039.7268468", name: "Hato Viejo Barrio" },
    { code: "PR.039.7268508", name: "Jaguas Barrio" },
    { code: "PR.039.7268751", name: "Pesas Barrio" },
    { code: "PR.039.7268781", name: "Pozas Barrio" },
    { code: "PR.039.7269044", name: "Toro Negro Barrio" },
  ],
  "PR.041": [
    { code: "PR.041.7268051", name: "Ceiba Barrio" },
    { code: "PR.041.7268080", name: "Cidra Barrio-Pueblo" },
    { code: "PR.041.7268211", name: "Arenas Barrio" },
    { code: "PR.041.7268245", name: "Bayamón Barrio" },
    { code: "PR.041.7268252", name: "Beatriz Barrio" },
    { code: "PR.041.7268480", name: "Honduras Barrio" },
    { code: "PR.041.7268672", name: "Monte Llano Barrio" },
    { code: "PR.041.7268873", name: "Rabanal Barrio" },
    { code: "PR.041.7268880", name: "Rincón Barrio" },
    { code: "PR.041.7268885", name: "Río Abajo Barrio" },
    { code: "PR.041.7268957", name: "Salto Barrio" },
    { code: "PR.041.7269014", name: "Sud Barrio" },
    { code: "PR.041.7269042", name: "Toíta Barrio" },
    { code: "PR.041.7309609", name: "Certenejas Barrio" },
  ],
  "PR.043": [
    { code: "PR.043.7268091", name: "Coamo Arriba Barrio" },
    { code: "PR.043.7268092", name: "Coamo Barrio-Pueblo" },
    { code: "PR.043.7268140", name: "Cuyón Barrio" },
    { code: "PR.043.7268469", name: "Hayales Barrio" },
    { code: "PR.043.7268577", name: "Los Llanos Barrio" },
    { code: "PR.043.7268717", name: "Palmarejo Barrio" },
    { code: "PR.043.7268736", name: "Pasto Barrio" },
    { code: "PR.043.7268743", name: "Pedro García Barrio" },
    { code: "PR.043.7268835", name: "Pulguillas Barrio" },
    { code: "PR.043.7268971", name: "San Ildefonso Barrio" },
    { code: "PR.043.7268986", name: "Santa Catalina Barrio" },
  ],
  "PR.045": [
    { code: "PR.045.7268057", name: "Cejas Barrio" },
    { code: "PR.045.7268100", name: "Comerío Barrio-Pueblo" },
    { code: "PR.045.7268153", name: "Doña Elena Barrio" },
    { code: "PR.045.7268360", name: "Cedrito Barrio" },
    { code: "PR.045.7268696", name: "Naranjo Barrio" },
    { code: "PR.045.7268729", name: "Palomas Barrio" },
    { code: "PR.045.7268760", name: "Piñas Barrio" },
    { code: "PR.045.7268910", name: "Río Hondo Barrio" },
    { code: "PR.045.7269069", name: "Vega Redonda Barrio" },
  ],
  "PR.047": [
    { code: "PR.047.7268077", name: "Cibuco Barrio" },
    { code: "PR.047.7268110", name: "Corozal Barrio-Pueblo" },
    { code: "PR.047.7268129", name: "Cuchillas Barrio" },
    { code: "PR.047.7268155", name: "Dos Bocas Barrio" },
    { code: "PR.047.7268164", name: "Abras Barrio" },
    { code: "PR.047.7268591", name: "Magueyes Barrio" },
    { code: "PR.047.7268610", name: "Maná Barrio" },
    { code: "PR.047.7268701", name: "Negros Barrio" },
    { code: "PR.047.7268713", name: "Padilla Barrio" },
    { code: "PR.047.7268718", name: "Palmarejo Barrio" },
    { code: "PR.047.7268720", name: "Palmarito Barrio" },
    { code: "PR.047.7268730", name: "Palos Blancos Barrio" },
    { code: "PR.047.7268786", name: "Pueblo Barrio" },
  ],
  "PR.049": [
    { code: "PR.049.7268134", name: "Culebra Barrio-Pueblo" },
    { code: "PR.049.7268390", name: "Flamenco Barrio" },
    { code: "PR.049.7268397", name: "Fraile Barrio" },
    { code: "PR.049.7268773", name: "Playa Sardinas I Barrio" },
    { code: "PR.049.7268774", name: "Playa Sardinas II Barrio" },
    { code: "PR.049.7268972", name: "San Isidro Barrio" },
  ],
  "PR.051": [
    { code: "PR.051.7268154", name: "Dorado Barrio-Pueblo" },
    { code: "PR.051.7268382", name: "Espinosa Barrio" },
    { code: "PR.051.7268474", name: "Higuillar Barrio" },
    { code: "PR.051.7268590", name: "Maguayo Barrio" },
    { code: "PR.051.7268605", name: "Mameyal Barrio" },
    { code: "PR.051.7268913", name: "Río Lajas Barrio" },
  ],
  "PR.053": [
    { code: "PR.053.7268147", name: "Demajagua Barrio" },
    { code: "PR.053.7268277", name: "Cabezas Barrio" },
    { code: "PR.053.7268385", name: "Fajardo Barrio-Pueblo" },
    { code: "PR.053.7268392", name: "Florencio Barrio" },
    { code: "PR.053.7268697", name: "Naranjo Barrio" },
    { code: "PR.053.7268852", name: "Quebrada Fajardo Barrio" },
    { code: "PR.053.7268863", name: "Quebrada Vueltas Barrio" },
    { code: "PR.053.7268891", name: "Río Arriba Barrio" },
    { code: "PR.053.7269003", name: "Sardinera Barrio" },
  ],
  "PR.054": [
    { code: "PR.054.7268393", name: "Florida Adentro Barrio" },
  ],
  "PR.055": [
    { code: "PR.055.7268084", name: "Ciénaga Barrio" },
    { code: "PR.055.7268206", name: "Arena Barrio" },
    { code: "PR.055.7268325", name: "Caño Barrio" },
    { code: "PR.055.7268343", name: "Carenero Barrio" },
    { code: "PR.055.7268374", name: "Ensenada Barrio" },
    { code: "PR.055.7268422", name: "Guánica Barrio-Pueblo" },
    { code: "PR.055.7268668", name: "Montalva Barrio" },
    { code: "PR.055.7269018", name: "Susúa Baja Barrio" },
  ],
  "PR.057": [
    { code: "PR.057.7268181", name: "Algarrobo Barrio" },
    { code: "PR.057.7268291", name: "Caimital Barrio" },
    { code: "PR.057.7268344", name: "Carite Barrio" },
    { code: "PR.057.7268345", name: "Carmen Barrio" },
    { code: "PR.057.7268417", name: "Guamaní Barrio" },
    { code: "PR.057.7268439", name: "Guayama Barrio-Pueblo" },
    { code: "PR.057.7268525", name: "Jobos Barrio" },
    { code: "PR.057.7268582", name: "Machete Barrio" },
    { code: "PR.057.7268724", name: "Palmas Barrio" },
    { code: "PR.057.7268784", name: "Pozo Hondo Barrio" },
  ],
  "PR.059": [
    { code: "PR.059.7268103", name: "Consejo Barrio" },
    { code: "PR.059.7268238", name: "Barrero Barrio" },
    { code: "PR.059.7268257", name: "Boca Barrio" },
    { code: "PR.059.7268365", name: "Cedro Barrio" },
    { code: "PR.059.7268440", name: "Guayanilla Barrio-Pueblo" },
    { code: "PR.059.7268493", name: "Indios Barrio" },
    { code: "PR.059.7268504", name: "Jagua Pasto Barrio" },
    { code: "PR.059.7268509", name: "Jaguas Barrio" },
    { code: "PR.059.7268565", name: "Llano Barrio" },
    { code: "PR.059.7268580", name: "Macaná Barrio" },
    { code: "PR.059.7268588", name: "Magas Barrio" },
    { code: "PR.059.7268737", name: "Pasto Barrio" },
    { code: "PR.059.7268769", name: "Playa Barrio" },
    { code: "PR.059.7268856", name: "Quebrada Honda Barrio" },
    { code: "PR.059.7268865", name: "Quebradas Barrio" },
    { code: "PR.059.7268932", name: "Rufina Barrio" },
    { code: "PR.059.7269009", name: "Sierra Baja Barrio" },
  ],
  "PR.061": [
    { code: "PR.061.7268305", name: "Camarones Barrio" },
    { code: "PR.061.7268398", name: "Frailes Barrio" },
    { code: "PR.061.7268427", name: "Guaraguao Barrio" },
    { code: "PR.061.7268441", name: "Guaynabo Barrio-Pueblo" },
    { code: "PR.061.7268458", name: "Hato Nuevo Barrio" },
    { code: "PR.061.7268601", name: "Mamey Barrio" },
    { code: "PR.061.7268822", name: "Pueblo Viejo Barrio" },
    { code: "PR.061.7268895", name: "Río Barrio" },
    { code: "PR.061.7268992", name: "Santa Rosa Barrio" },
    { code: "PR.061.7269012", name: "Sonadora Barrio" },
  ],
  "PR.063": [
    { code: "PR.063.7268058", name: "Celada Barrio" },
    { code: "PR.063.7268448", name: "Gurabo Barrio-Pueblo" },
    { code: "PR.063.7268459", name: "Hato Nuevo Barrio" },
    { code: "PR.063.7268507", name: "Jaguar Barrio" },
    { code: "PR.063.7268510", name: "Jaguas Barrio" },
    { code: "PR.063.7268602", name: "Mamey Barrio" },
    { code: "PR.063.7268635", name: "Masa Barrio" },
    { code: "PR.063.7268700", name: "Navarro Barrio" },
    { code: "PR.063.7268858", name: "Quebrada Infierno Barrio" },
    { code: "PR.063.7268881", name: "Rincón Barrio" },
  ],
  "PR.065": [
    { code: "PR.065.7268108", name: "Corcovado Barrio" },
    { code: "PR.065.7268176", name: "Aibonito Barrio" },
    { code: "PR.065.7268248", name: "Bayaney Barrio" },
    { code: "PR.065.7268271", name: "Buena Vista Barrio" },
    { code: "PR.065.7268308", name: "Campo Alegre Barrio" },
    { code: "PR.065.7268337", name: "Capáez Barrio" },
    { code: "PR.065.7268351", name: "Carrizales Barrio" },
    { code: "PR.065.7268452", name: "Hatillo Barrio" },
    { code: "PR.065.7268453", name: "Hatillo Barrio-Pueblo" },
    { code: "PR.065.7268693", name: "Naranjito Barrio" },
  ],
  "PR.067": [
    { code: "PR.067.7268255", name: "Benavente Barrio" },
    { code: "PR.067.7268420", name: "Guanajibo Barrio" },
    { code: "PR.067.7268481", name: "Hormigueros Barrio" },
    { code: "PR.067.7268482", name: "Hormigueros Barrio-Pueblo" },
    { code: "PR.067.7268515", name: "Jaguitas Barrio" },
    { code: "PR.067.7268556", name: "Lavadero Barrio" },
  ],
  "PR.069": [
    { code: "PR.069.7268094", name: "Collores Barrio" },
    { code: "PR.069.7268203", name: "Antón Ruíz Barrio" },
    { code: "PR.069.7268272", name: "Buena Vista Barrio" },
    { code: "PR.069.7268321", name: "Candelero Abajo Barrio" },
    { code: "PR.069.7268322", name: "Candelero Arriba Barrio" },
    { code: "PR.069.7268355", name: "Cataño Barrio" },
    { code: "PR.069.7268486", name: "Humacao Barrio-Pueblo" },
    { code: "PR.069.7268579", name: "Mabú Barrio" },
    { code: "PR.069.7268599", name: "Mambiche Barrio" },
    { code: "PR.069.7268618", name: "Mariana Barrio" },
    { code: "PR.069.7268837", name: "Punta Santiago Barrio" },
    { code: "PR.069.7268886", name: "Río Abajo Barrio" },
    { code: "PR.069.7269029", name: "Tejas Barrio" },
  ],
  "PR.071": [
    { code: "PR.071.7268113", name: "Coto Barrio" },
    { code: "PR.071.7268208", name: "Arenales Altos Barrio" },
    { code: "PR.071.7268209", name: "Arenales Bajos Barrio" },
    { code: "PR.071.7268227", name: "Bajura Barrio" },
    { code: "PR.071.7268253", name: "Bejucos Barrio" },
    { code: "PR.071.7268403", name: "Galateo Alto Barrio" },
    { code: "PR.071.7268404", name: "Galateo Bajo Barrio" },
    { code: "PR.071.7268436", name: "Guayabos Barrio" },
    { code: "PR.071.7268444", name: "Guerrero Barrio" },
    { code: "PR.071.7268496", name: "Isabela Barrio-Pueblo" },
    { code: "PR.071.7268526", name: "Jobos Barrio" },
    { code: "PR.071.7268564", name: "Llanadas Barrio" },
    { code: "PR.071.7268680", name: "Mora Barrio" },
    { code: "PR.071.7268764", name: "Planas Barrio" },
  ],
  "PR.073": [
    { code: "PR.073.7268090", name: "Coabey Barrio" },
    { code: "PR.073.7268095", name: "Collores Barrio" },
    { code: "PR.073.7268521", name: "Jauca Barrio" },
    { code: "PR.073.7268522", name: "Jayuya Abajo Barrio" },
    { code: "PR.073.7268523", name: "Jayuya Barrio-Pueblo" },
    { code: "PR.073.7268607", name: "Mameyes Arriba Barrio" },
    { code: "PR.073.7268753", name: "Pica Barrio" },
    { code: "PR.073.7268906", name: "Río Grande Barrio" },
    { code: "PR.073.7268952", name: "Saliente Barrio" },
    { code: "PR.073.7269074", name: "Veguitas Barrio" },
    { code: "PR.073.7269092", name: "Zamas Barrio" },
  ],
  "PR.075": [
    { code: "PR.075.7268087", name: "Cintrona Barrio" },
    { code: "PR.075.7268096", name: "Collores Barrio" },
    { code: "PR.075.7268193", name: "Amuelas Barrio" },
    { code: "PR.075.7268300", name: "Callabo Barrio" },
    { code: "PR.075.7268339", name: "Capitanejo Barrio" },
    { code: "PR.075.7268371", name: "Emajagual Barrio" },
    { code: "PR.075.7268433", name: "Guayabal Barrio" },
    { code: "PR.075.7268501", name: "Jacaguas Barrio" },
    { code: "PR.075.7268533", name: "Juana Díaz Barrio-Pueblo" },
    { code: "PR.075.7268574", name: "Lomas Barrio" },
    { code: "PR.075.7268898", name: "Río Cañas Abajo Barrio" },
    { code: "PR.075.7268900", name: "Río Cañas Arriba Barrio" },
    { code: "PR.075.7268943", name: "Sabana Llana Barrio" },
    { code: "PR.075.7269038", name: "Tijeras Barrio" },
  ],
  "PR.077": [
    { code: "PR.077.7268055", name: "Ceiba Norte Barrio" },
    { code: "PR.077.7268056", name: "Ceiba Sur Barrio" },
    { code: "PR.077.7268292", name: "Caimito Barrio" },
    { code: "PR.077.7268446", name: "Gurabo Abajo Barrio" },
    { code: "PR.077.7268447", name: "Gurabo Arriba Barrio" },
    { code: "PR.077.7268535", name: "Juncos Barrio-Pueblo" },
    { code: "PR.077.7268562", name: "Lirios Barrio" },
    { code: "PR.077.7268603", name: "Mamey Barrio" },
    { code: "PR.077.7269064", name: "Valenciano Abajo Barrio" },
    { code: "PR.077.7269065", name: "Valenciano Arriba Barrio" },
  ],
  "PR.079": [
    { code: "PR.079.7268112", name: "Costa Barrio" },
    { code: "PR.079.7268317", name: "Candelaria Barrio" },
    { code: "PR.079.7268542", name: "Lajas Arriba Barrio" },
    { code: "PR.079.7268543", name: "Lajas Barrio" },
    { code: "PR.079.7268544", name: "Lajas Barrio-Pueblo" },
    { code: "PR.079.7268567", name: "Llanos Barrio" },
    { code: "PR.079.7268719", name: "Palmarejo Barrio" },
    { code: "PR.079.7268731", name: "Parguera Barrio" },
    { code: "PR.079.7268732", name: "París Barrio" },
    { code: "PR.079.7268766", name: "Plata Barrio" },
    { code: "PR.079.7268947", name: "Sabana Yeguas Barrio" },
    { code: "PR.079.7268993", name: "Santa Rosa Barrio" },
  ],
  "PR.081": [
    { code: "PR.081.7268241", name: "Bartolo Barrio" },
    { code: "PR.081.7268274", name: "Buenos Aires Barrio" },
    { code: "PR.081.7268301", name: "Callejones Barrio" },
    { code: "PR.081.7268379", name: "Espino Barrio" },
    { code: "PR.081.7268539", name: "La Torre Barrio" },
    { code: "PR.081.7268547", name: "Lares Barrio" },
    { code: "PR.081.7268548", name: "Lares Barrio-Pueblo" },
    { code: "PR.081.7268663", name: "Mirasol Barrio" },
    { code: "PR.081.7268752", name: "Pezuela Barrio" },
    { code: "PR.081.7268758", name: "Piletas Barrio" },
    { code: "PR.081.7268787", name: "Pueblo Barrio" },
    { code: "PR.081.7268916", name: "Río Prieto Barrio" },
  ],
  "PR.083": [
    { code: "PR.083.7268068", name: "Cerrote Barrio" },
    { code: "PR.083.7268069", name: "Chamorro Barrio" },
    { code: "PR.083.7268190", name: "Alto Sano Barrio" },
    { code: "PR.083.7268201", name: "Anones Barrio" },
    { code: "PR.083.7268267", name: "Bucarabones Barrio" },
    { code: "PR.083.7268273", name: "Buena Vista Barrio" },
    { code: "PR.083.7268380", name: "Espino Barrio" },
    { code: "PR.083.7268402", name: "Furnias Barrio" },
    { code: "PR.083.7268550", name: "Las Marías Barrio-Pueblo" },
    { code: "PR.083.7268613", name: "Maravilla Este Barrio" },
    { code: "PR.083.7268614", name: "Maravilla Norte Barrio" },
    { code: "PR.083.7268615", name: "Maravilla Sur Barrio" },
    { code: "PR.083.7268691", name: "Naranjales Barrio" },
    { code: "PR.083.7268715", name: "Palma Escrita Barrio" },
    { code: "PR.083.7268839", name: "Purísima Concepción Barrio" },
    { code: "PR.083.7268904", name: "Río Cañas Barrio" },
  ],
  "PR.085": [
    { code: "PR.085.7268052", name: "Ceiba Barrio" },
    { code: "PR.085.7268097", name: "Collores Barrio" },
    { code: "PR.085.7268261", name: "Boquerón Barrio" },
    { code: "PR.085.7268367", name: "El Río Barrio" },
    { code: "PR.085.7268555", name: "Las Piedras Barrio-Pueblo" },
    { code: "PR.085.7268677", name: "Montones Barrio" },
    { code: "PR.085.7268840", name: "Quebrada Arenas Barrio" },
    { code: "PR.085.7269030", name: "Tejas Barrio" },
  ],
  "PR.087": [
    { code: "PR.087.7268327", name: "Canóvanas Barrio" },
    { code: "PR.087.7268571", name: "Loíza Barrio-Pueblo" },
    { code: "PR.087.7268647", name: "Medianía Alta Barrio" },
    { code: "PR.087.7268648", name: "Medianía Baja Barrio" },
    { code: "PR.087.7269047", name: "Torrecilla Alta Barrio" },
    { code: "PR.087.7269048", name: "Torrecilla Baja Barrio" },
  ],
  "PR.089": [
    { code: "PR.089.7268530", name: "Juan Martín Barrio" },
    { code: "PR.089.7268578", name: "Luquillo Barrio-Pueblo" },
    { code: "PR.089.7268608", name: "Mameyes I Barrio" },
    { code: "PR.089.7268637", name: "Mata de Plátano Barrio" },
    { code: "PR.089.7268763", name: "Pitahaya Barrio" },
    { code: "PR.089.7268935", name: "Sabana Barrio" },
  ],
  "PR.091": [
    { code: "PR.091.7268116", name: "Coto Norte Barrio" },
    { code: "PR.091.7268117", name: "Coto Sur Barrio" },
    { code: "PR.091.7268224", name: "Bajura Adentro Barrio" },
    { code: "PR.091.7268225", name: "Bajura Afuera Barrio" },
    { code: "PR.091.7268611", name: "Manatí Barrio-Pueblo" },
    { code: "PR.091.7268893", name: "Río Arriba Poniente Barrio" },
    { code: "PR.091.7268894", name: "Río Arriba Saliente Barrio" },
    { code: "PR.091.7269036", name: "Tierras Nuevas Poniente Barrio" },
    { code: "PR.091.7269037", name: "Tierras Nuevas Saliente Barrio" },
  ],
  "PR.093": [
    { code: "PR.093.7268268", name: "Bucarabones Barrio" },
    { code: "PR.093.7268490", name: "Indiera Alta Barrio" },
    { code: "PR.093.7268491", name: "Indiera Baja Barrio" },
    { code: "PR.093.7268492", name: "Indiera Fría Barrio" },
    { code: "PR.093.7268623", name: "Maricao Afuera Barrio" },
    { code: "PR.093.7268625", name: "Maricao Barrio-Pueblo" },
    { code: "PR.093.7268678", name: "Montoso Barrio" },
  ],
  "PR.095": [
    { code: "PR.095.7268303", name: "Calzada Barrio" },
    { code: "PR.095.7268370", name: "Emajagua Barrio" },
    { code: "PR.095.7268563", name: "Lizas Barrio" },
    { code: "PR.095.7268640", name: "Matuyas Alto Barrio" },
    { code: "PR.095.7268641", name: "Matuyas Bajo Barrio" },
    { code: "PR.095.7268642", name: "Maunabo Barrio-Pueblo" },
    { code: "PR.095.7268727", name: "Palo Seco Barrio" },
    { code: "PR.095.7268841", name: "Quebrada Arenas Barrio" },
    { code: "PR.095.7269022", name: "Talante Barrio" },
    { code: "PR.095.7269433", name: "Tumbao Barrio" },
  ],
  "PR.097": [
    { code: "PR.097.7268184", name: "Algarrobos Barrio" },
    { code: "PR.097.7268242", name: "Bateyes Barrio" },
    { code: "PR.097.7268421", name: "Guanajibo Barrio" },
    { code: "PR.097.7268497", name: "Isla de Mona e Islote Monito Barrio" },
    { code: "PR.097.7268527", name: "Juan Alonso Barrio" },
    { code: "PR.097.7268557", name: "Leguísamo Barrio" },
    { code: "PR.097.7268559", name: "Limón Barrio" },
    { code: "PR.097.7268598", name: "Malezas Barrio" },
    { code: "PR.097.7268644", name: "Mayagüez Arriba Barrio" },
    { code: "PR.097.7268645", name: "Mayagüez Barrio-Pueblo" },
    { code: "PR.097.7268658", name: "Miradero Barrio" },
    { code: "PR.097.7268679", name: "Montoso Barrio" },
    { code: "PR.097.7268692", name: "Naranjales Barrio" },
    { code: "PR.097.7268854", name: "Quebrada Grande Barrio" },
    { code: "PR.097.7268869", name: "Quemado Barrio" },
    { code: "PR.097.7268899", name: "Río Cañas Abajo Barrio" },
    { code: "PR.097.7268901", name: "Río Cañas Arriba Barrio" },
    { code: "PR.097.7268911", name: "Río Hondo Barrio" },
    { code: "PR.097.7268926", name: "Rosario Barrio" },
    { code: "PR.097.7268933", name: "Sábalos Barrio" },
    { code: "PR.097.7268948", name: "Sabanetas Barrio" },
  ],
  "PR.099": [
    { code: "PR.099.7268060", name: "Centro Barrio" },
    { code: "PR.099.7268066", name: "Cerro Gordo Barrio" },
    { code: "PR.099.7268121", name: "Cruz Barrio" },
    { code: "PR.099.7268130", name: "Cuchillas Barrio" },
    { code: "PR.099.7268165", name: "Aceitunas Barrio" },
    { code: "PR.099.7268335", name: "Capá Barrio" },
    { code: "PR.099.7268622", name: "Marías Barrio" },
    { code: "PR.099.7268664", name: "Moca Barrio-Pueblo" },
    { code: "PR.099.7268698", name: "Naranjo Barrio" },
    { code: "PR.099.7268767", name: "Plata Barrio" },
    { code: "PR.099.7268788", name: "Pueblo Barrio" },
    { code: "PR.099.7268922", name: "Rocha Barrio" },
    { code: "PR.099.7269084", name: "Voladoras Barrio" },
  ],
  "PR.101": [
    { code: "PR.101.7268131", name: "Cuchillas Barrio" },
    { code: "PR.101.7268231", name: "Barahona Barrio" },
    { code: "PR.101.7268400", name: "Fránquez Barrio" },
    { code: "PR.101.7268673", name: "Monte Llano Barrio" },
    { code: "PR.101.7268681", name: "Morovis Barrio-Pueblo" },
    { code: "PR.101.7268682", name: "Morovis Norte Barrio" },
    { code: "PR.101.7268683", name: "Morovis Sud Barrio" },
    { code: "PR.101.7268738", name: "Pasto Barrio" },
    { code: "PR.101.7268750", name: "Perchas Barrio" },
    { code: "PR.101.7268907", name: "Río Grande Barrio" },
    { code: "PR.101.7268978", name: "San Lorenzo Barrio" },
    { code: "PR.101.7269049", name: "Torrecillas Barrio" },
    { code: "PR.101.7269057", name: "Unibón Barrio" },
    { code: "PR.101.7269062", name: "Vaga Barrio" },
  ],
  "PR.103": [
    { code: "PR.103.7268142", name: "Daguao Barrio" },
    { code: "PR.103.7268160", name: "Duque Barrio" },
    { code: "PR.103.7268485", name: "Húcares Barrio" },
    { code: "PR.103.7268594", name: "Maizales Barrio" },
    { code: "PR.103.7268619", name: "Mariana Barrio" },
    { code: "PR.103.7268690", name: "Naguabo Barrio-Pueblo" },
    { code: "PR.103.7268746", name: "Peña Pobre Barrio" },
    { code: "PR.103.7268896", name: "Río Barrio" },
    { code: "PR.103.7268897", name: "Río Blanco Barrio" },
    { code: "PR.103.7268999", name: "Santiago y Lima Barrio" },
  ],
  "PR.105": [
    { code: "PR.105.7268166", name: "Achiote Barrio" },
    { code: "PR.105.7268202", name: "Anones Barrio" },
    { code: "PR.105.7268361", name: "Cedro Abajo Barrio" },
    { code: "PR.105.7268362", name: "Cedro Arriba Barrio" },
    { code: "PR.105.7268413", name: "Guadiana Barrio" },
    { code: "PR.105.7268575", name: "Lomas Barrio" },
    { code: "PR.105.7268694", name: "Naranjito Barrio-Pueblo" },
    { code: "PR.105.7268704", name: "Nuevo Barrio" },
  ],
  "PR.107": [
    { code: "PR.107.7268098", name: "Collores Barrio" },
    { code: "PR.107.7268145", name: "Damián Abajo Barrio" },
    { code: "PR.107.7268146", name: "Damián Arriba Barrio" },
    { code: "PR.107.7268179", name: "Ala de la Piedra Barrio" },
    { code: "PR.107.7268240", name: "Barros Barrio" },
    { code: "PR.107.7268243", name: "Bauta Abajo Barrio" },
    { code: "PR.107.7268244", name: "Bauta Arriba Barrio" },
    { code: "PR.107.7268256", name: "Bermejales Barrio" },
    { code: "PR.107.7268265", name: "Botijas Barrio" },
    { code: "PR.107.7268284", name: "Cacaos Barrio" },
    { code: "PR.107.7268410", name: "Gato Barrio" },
    { code: "PR.107.7268636", name: "Mata de Cañas Barrio" },
    { code: "PR.107.7268709", name: "Orocovis Barrio" },
    { code: "PR.107.7268710", name: "Orocovis Barrio-Pueblo" },
    { code: "PR.107.7268745", name: "Pellejas Barrio" },
    { code: "PR.107.7268936", name: "Sabana Barrio" },
    { code: "PR.107.7268959", name: "Saltos Barrio" },
  ],
  "PR.109": [
    { code: "PR.109.7268161", name: "Egozcue Barrio" },
    { code: "PR.109.7268204", name: "Apeadero Barrio" },
    { code: "PR.109.7268223", name: "Bajo Barrio" },
    { code: "PR.109.7268280", name: "Cacao Alto Barrio" },
    { code: "PR.109.7268281", name: "Cacao Bajo Barrio" },
    { code: "PR.109.7268429", name: "Guardarraya Barrio" },
    { code: "PR.109.7268500", name: "Jacaboa Barrio" },
    { code: "PR.109.7268505", name: "Jagual Barrio" },
    { code: "PR.109.7268604", name: "Mamey Barrio" },
    { code: "PR.109.7268626", name: "Marín Barrio" },
    { code: "PR.109.7268687", name: "Mulas Barrio" },
    { code: "PR.109.7268689", name: "Muñoz Rivera Barrio" },
    { code: "PR.109.7268740", name: "Patillas Barrio-Pueblo" },
    { code: "PR.109.7268776", name: "Pollos Barrio" },
    { code: "PR.109.7268847", name: "Quebrada Arriba Barrio" },
    { code: "PR.109.7268919", name: "Ríos Barrio" },
  ],
  "PR.111": [
    { code: "PR.111.7268114", name: "Coto Barrio" },
    { code: "PR.111.7268132", name: "Cuebas Barrio" },
    { code: "PR.111.7268237", name: "Barreal Barrio" },
    { code: "PR.111.7268372", name: "Encarnación Barrio" },
    { code: "PR.111.7268511", name: "Jaguas Barrio" },
    { code: "PR.111.7268581", name: "Macaná Barrio" },
    { code: "PR.111.7268747", name: "Peñuelas Barrio-Pueblo" },
    { code: "PR.111.7268850", name: "Quebrada Ceiba Barrio" },
    { code: "PR.111.7268931", name: "Rucio Barrio" },
    { code: "PR.111.7269000", name: "Santo Domingo Barrio" },
    { code: "PR.111.7269023", name: "Tallaboa Alta Barrio" },
    { code: "PR.111.7269024", name: "Tallaboa Poniente Barrio" },
    { code: "PR.111.7269025", name: "Tallaboa Saliente Barrio" },
  ],
  "PR.113": [
    { code: "PR.113.7268062", name: "Cerrillos Barrio" },
    { code: "PR.113.7268115", name: "Coto Laurel Barrio" },
    { code: "PR.113.7268126", name: "Cuarto Barrio" },
    { code: "PR.113.7268200", name: "Anón Barrio" },
    { code: "PR.113.7268266", name: "Bucaná Barrio" },
    { code: "PR.113.7268315", name: "Canas Barrio" },
    { code: "PR.113.7268316", name: "Canas Urbano Barrio" },
    { code: "PR.113.7268340", name: "Capitanejo Barrio" },
    { code: "PR.113.7268428", name: "Guaraguao Barrio" },
    { code: "PR.113.7268586", name: "Machuelo Abajo Barrio" },
    { code: "PR.113.7268587", name: "Machuelo Arriba Barrio" },
    { code: "PR.113.7268592", name: "Magueyes Barrio" },
    { code: "PR.113.7268593", name: "Magueyes Urbano Barrio" },
    { code: "PR.113.7268612", name: "Maragüez Barrio" },
    { code: "PR.113.7268634", name: "Marueño Barrio" },
    { code: "PR.113.7268674", name: "Monte Llano Barrio" },
    { code: "PR.113.7268770", name: "Playa Barrio" },
    { code: "PR.113.7268779", name: "Portugués Barrio" },
    { code: "PR.113.7268780", name: "Portugués Urbano Barrio" },
    { code: "PR.113.7268785", name: "Primero Barrio" },
    { code: "PR.113.7268860", name: "Quebrada Limón Barrio" },
    { code: "PR.113.7268872", name: "Quinto Barrio" },
    { code: "PR.113.7268876", name: "Real Barrio" },
    { code: "PR.113.7268949", name: "Sabanetas Barrio" },
    { code: "PR.113.7268962", name: "San Antón Barrio" },
    { code: "PR.113.7268982", name: "San Patricio Barrio" },
    { code: "PR.113.7269005", name: "Segundo Barrio" },
    { code: "PR.113.7269006", name: "Sexto Barrio" },
    { code: "PR.113.7269032", name: "Tercero Barrio" },
    { code: "PR.113.7269035", name: "Tibes Barrio" },
    { code: "PR.113.7269066", name: "Vayas Barrio" },
  ],
  "PR.115": [
    { code: "PR.115.7268070", name: "Charcas Barrio" },
    { code: "PR.115.7268093", name: "Cocos Barrio" },
    { code: "PR.115.7268283", name: "Cacao Barrio" },
    { code: "PR.115.7268414", name: "Guajataca Barrio" },
    { code: "PR.115.7268868", name: "Quebradillas Barrio-Pueblo" },
    { code: "PR.115.7268964", name: "San Antonio Barrio" },
    { code: "PR.115.7268973", name: "San José Barrio" },
    { code: "PR.115.7269033", name: "Terranova Barrio" },
  ],
  "PR.117": [
    { code: "PR.117.7268120", name: "Cruces Barrio" },
    { code: "PR.117.7268218", name: "Atalaya Barrio" },
    { code: "PR.117.7268239", name: "Barrero Barrio" },
    { code: "PR.117.7268302", name: "Calvache Barrio" },
    { code: "PR.117.7268375", name: "Ensenada Barrio" },
    { code: "PR.117.7268513", name: "Jagüey Barrio" },
    { code: "PR.117.7268789", name: "Pueblo Barrio" },
    { code: "PR.117.7268838", name: "Puntas Barrio" },
    { code: "PR.117.7268883", name: "Rincón Barrio-Pueblo" },
    { code: "PR.117.7268908", name: "Río Grande Barrio" },
  ],
  "PR.119": [
    { code: "PR.119.7268082", name: "Ciénaga Alta Barrio" },
    { code: "PR.119.7268083", name: "Ciénaga Baja Barrio" },
    { code: "PR.119.7268449", name: "Guzmán Abajo Barrio" },
    { code: "PR.119.7268450", name: "Guzmán Arriba Barrio" },
    { code: "PR.119.7268472", name: "Herreras Barrio" },
    { code: "PR.119.7268524", name: "Jiménez Barrio" },
    { code: "PR.119.7268609", name: "Mameyes II Barrio" },
    { code: "PR.119.7268909", name: "Río Grande Barrio-Pueblo" },
    { code: "PR.119.7269094", name: "Zarzal Barrio" },
  ],
  "PR.121": [
    { code: "PR.121.7268584", name: "Machuchal Barrio" },
    { code: "PR.121.7268875", name: "Rayo Barrio" },
    { code: "PR.121.7268882", name: "Rincón Barrio" },
    { code: "PR.121.7268941", name: "Sabana Grande Barrio-Pueblo" },
    { code: "PR.121.7268996", name: "Santana Barrio" },
    { code: "PR.121.7269020", name: "Susúa Barrio" },
    { code: "PR.121.7269021", name: "Tabonuco Barrio" },
    { code: "PR.121.7269045", name: "Torre Barrio" },
  ],
  "PR.123": [
    { code: "PR.123.7268174", name: "Aguirre Barrio" },
    { code: "PR.123.7268546", name: "Lapa Barrio" },
    { code: "PR.123.7268725", name: "Palmas Barrio" },
    { code: "PR.123.7268864", name: "Quebrada Yeguas Barrio" },
    { code: "PR.123.7268912", name: "Río Jueyes Barrio" },
    { code: "PR.123.7268953", name: "Salinas Barrio-Pueblo" },
  ],
  "PR.125": [
    { code: "PR.125.7268118", name: "Cotuí Barrio" },
    { code: "PR.125.7268157", name: "Duey Alto Barrio" },
    { code: "PR.125.7268158", name: "Duey Bajo Barrio" },
    { code: "PR.125.7268198", name: "Ancones Barrio" },
    { code: "PR.125.7268295", name: "Caín Alto Barrio" },
    { code: "PR.125.7268296", name: "Caín Bajo Barrio" },
    { code: "PR.125.7268416", name: "Guamá Barrio" },
    { code: "PR.125.7268477", name: "Hoconuco Alto Barrio" },
    { code: "PR.125.7268478", name: "Hoconuco Bajo Barrio" },
    { code: "PR.125.7268616", name: "Maresúa Barrio" },
    { code: "PR.125.7268654", name: "Minillas Barrio" },
    { code: "PR.125.7268878", name: "Retiro Barrio" },
    { code: "PR.125.7268924", name: "Rosario Alto Barrio" },
    { code: "PR.125.7268925", name: "Rosario Bajo Barrio" },
    { code: "PR.125.7268927", name: "Rosario Peñón Barrio" },
    { code: "PR.125.7268938", name: "Sabana Eneas Barrio" },
    { code: "PR.125.7268939", name: "Sabana Grande Abajo Barrio" },
    { code: "PR.125.7268970", name: "San Germán Barrio-Pueblo" },
    { code: "PR.125.7269054", name: "Tuna Barrio" },
  ],
  "PR.127": [
    { code: "PR.127.7268138", name: "Cupey Barrio" },
    { code: "PR.127.7268162", name: "El Cinco Barrio" },
    { code: "PR.127.7268293", name: "Caimito Barrio" },
    { code: "PR.127.7268411", name: "Gobernador Piñero Barrio" },
    { code: "PR.127.7268463", name: "Hato Rey Central Barrio" },
    { code: "PR.127.7268464", name: "Hato Rey Norte Barrio" },
    { code: "PR.127.7268465", name: "Hato Rey Sur Barrio" },
    { code: "PR.127.7268665", name: "Monacillo Barrio" },
    { code: "PR.127.7268666", name: "Monacillo Urbano Barrio" },
    { code: "PR.127.7268708", name: "Oriente Barrio" },
    { code: "PR.127.7268790", name: "Pueblo Barrio" },
    { code: "PR.127.7268842", name: "Quebrada Arenas Barrio" },
    { code: "PR.127.7268944", name: "Sabana Llana Norte Barrio" },
    { code: "PR.127.7268945", name: "Sabana Llana Sur Barrio" },
    { code: "PR.127.7268975", name: "San Juan Antiguo Barrio" },
    { code: "PR.127.7269002", name: "Santurce Barrio" },
    { code: "PR.127.7269050", name: "Tortugo Barrio" },
    { code: "PR.127.7269058", name: "Universidad Barrio" },
  ],
  "PR.129": [
    { code: "PR.129.7268067", name: "Cerro Gordo Barrio" },
    { code: "PR.129.7268358", name: "Cayaguas Barrio" },
    { code: "PR.129.7268381", name: "Espino Barrio" },
    { code: "PR.129.7268395", name: "Florida Barrio" },
    { code: "PR.129.7268457", name: "Hato Barrio" },
    { code: "PR.129.7268506", name: "Jagual Barrio" },
    { code: "PR.129.7268843", name: "Quebrada Arenas Barrio" },
    { code: "PR.129.7268849", name: "Quebrada Barrio" },
    { code: "PR.129.7268857", name: "Quebrada Honda Barrio" },
    { code: "PR.129.7268870", name: "Quemados Barrio" },
    { code: "PR.129.7268979", name: "San Lorenzo Barrio-Pueblo" },
  ],
  "PR.131": [
    { code: "PR.131.7268076", name: "Cibao Barrio" },
    { code: "PR.131.7268081", name: "Cidral Barrio" },
    { code: "PR.131.7268137", name: "Culebrinas Barrio" },
    { code: "PR.131.7268177", name: "Aibonito Barrio" },
    { code: "PR.131.7268191", name: "Alto Sano Barrio" },
    { code: "PR.131.7268220", name: "Bahomamey Barrio" },
    { code: "PR.131.7268297", name: "Calabazas Barrio" },
    { code: "PR.131.7268373", name: "Eneas Barrio" },
    { code: "PR.131.7268412", name: "Guacio Barrio" },
    { code: "PR.131.7268415", name: "Guajataca Barrio" },
    { code: "PR.131.7268431", name: "Guatemala Barrio" },
    { code: "PR.131.7268456", name: "Hato Arriba Barrio" },
    { code: "PR.131.7268483", name: "Hoya Mala Barrio" },
    { code: "PR.131.7268534", name: "Juncal Barrio" },
    { code: "PR.131.7268589", name: "Magos Barrio" },
    { code: "PR.131.7268656", name: "Mirabales Barrio" },
    { code: "PR.131.7268748", name: "Perchas 1 Barrio" },
    { code: "PR.131.7268749", name: "Perchas 2 Barrio" },
    { code: "PR.131.7268757", name: "Piedras Blancas Barrio" },
    { code: "PR.131.7268782", name: "Pozas Barrio" },
    { code: "PR.131.7268921", name: "Robles Barrio" },
    { code: "PR.131.7268958", name: "Salto Barrio" },
    { code: "PR.131.7268984", name: "San Sebastián Barrio-Pueblo" },
    { code: "PR.131.7269010", name: "Sonador Barrio" },
  ],
  "PR.133": [
    { code: "PR.133.7268148", name: "Descalabrado Barrio" },
    { code: "PR.133.7268258", name: "Boca Velázquez Barrio" },
    { code: "PR.133.7268387", name: "Felicia 1 Barrio" },
    { code: "PR.133.7268388", name: "Felicia 2 Barrio" },
    { code: "PR.133.7268519", name: "Jauca 1 Barrio" },
    { code: "PR.133.7268520", name: "Jauca 2 Barrio" },
    { code: "PR.133.7268771", name: "Playa Barrio" },
    { code: "PR.133.7268989", name: "Santa Isabel Barrio-Pueblo" },
  ],
  "PR.135": [
    { code: "PR.135.7268105", name: "Contorno Barrio" },
    { code: "PR.135.7268405", name: "Galateo Barrio" },
    { code: "PR.135.7268685", name: "Mucarabones Barrio" },
    { code: "PR.135.7268711", name: "Ortíz Barrio" },
    { code: "PR.135.7268761", name: "Piñas Barrio" },
    { code: "PR.135.7268844", name: "Quebrada Arenas Barrio" },
    { code: "PR.135.7268851", name: "Quebrada Cruz Barrio" },
    { code: "PR.135.7268914", name: "Río Lajas Barrio" },
    { code: "PR.135.7269039", name: "Toa Alta Barrio-Pueblo" },
  ],
  "PR.137": [
    { code: "PR.137.7268318", name: "Candelaria Barrio" },
    { code: "PR.137.7268646", name: "Media Luna Barrio" },
    { code: "PR.137.7268728", name: "Palo Seco Barrio" },
    { code: "PR.137.7268946", name: "Sabana Seca Barrio" },
    { code: "PR.137.7269040", name: "Toa Baja Barrio-Pueblo" },
  ],
  "PR.139": [
    { code: "PR.139.7268133", name: "Cuevas Barrio" },
    { code: "PR.139.7268156", name: "Dos Bocas Barrio" },
    { code: "PR.139.7268347", name: "Carraízo Barrio" },
    { code: "PR.139.7268538", name: "La Gloria Barrio" },
    { code: "PR.139.7268855", name: "Quebrada Grande Barrio" },
    { code: "PR.139.7268861", name: "Quebrada Negrito Barrio" },
    { code: "PR.139.7269013", name: "St. Just Barrio" },
    { code: "PR.139.7269052", name: "Trujillo Alto Barrio-Pueblo" },
  ],
  "PR.141": [
    { code: "PR.141.7268104", name: "Consejo Barrio" },
    { code: "PR.141.7268152", name: "Don Alonso Barrio" },
    { code: "PR.141.7268199", name: "Angeles Barrio" },
    { code: "PR.141.7268212", name: "Arenas Barrio" },
    { code: "PR.141.7268286", name: "Caguana Barrio" },
    { code: "PR.141.7268324", name: "Caníaco Barrio" },
    { code: "PR.141.7268330", name: "Caonillas Abajo Barrio" },
    { code: "PR.141.7268332", name: "Caonillas Arriba Barrio" },
    { code: "PR.141.7268424", name: "Guaonico Barrio" },
    { code: "PR.141.7268553", name: "Las Palmas Barrio" },
    { code: "PR.141.7268560", name: "Limón Barrio" },
    { code: "PR.141.7268606", name: "Mameyes Abajo Barrio" },
    { code: "PR.141.7268734", name: "Paso Palma Barrio" },
    { code: "PR.141.7268887", name: "Río Abajo Barrio" },
    { code: "PR.141.7268923", name: "Roncador Barrio" },
    { code: "PR.141.7268940", name: "Sabana Grande Barrio" },
    { code: "PR.141.7268955", name: "Salto Abajo Barrio" },
    { code: "PR.141.7268956", name: "Salto Arriba Barrio" },
    { code: "PR.141.7268988", name: "Santa Isabel Barrio" },
    { code: "PR.141.7268994", name: "Santa Rosa Barrio" },
    { code: "PR.141.7269034", name: "Tetuán Barrio" },
    { code: "PR.141.7269060", name: "Utuado Barrio-Pueblo" },
    { code: "PR.141.7269082", name: "Viví Abajo Barrio" },
    { code: "PR.141.7269083", name: "Viví Arriba Barrio" },
  ],
  "PR.143": [
    { code: "PR.143.7268086", name: "Cienegueta Barrio" },
    { code: "PR.143.7268228", name: "Bajura Barrio" },
    { code: "PR.143.7268319", name: "Candelaria Barrio" },
    { code: "PR.143.7268383", name: "Espinosa Barrio" },
    { code: "PR.143.7268624", name: "Maricao Barrio" },
    { code: "PR.143.7268643", name: "Mavilla Barrio" },
    { code: "PR.143.7268937", name: "Sabana Barrio" },
    { code: "PR.143.7269067", name: "Vega Alta Barrio-Pueblo" },
  ],
  "PR.145": [
    { code: "PR.145.7268053", name: "Ceiba Barrio" },
    { code: "PR.145.7268078", name: "Cibuco Barrio" },
    { code: "PR.145.7268182", name: "Algarrobo Barrio" },
    { code: "PR.145.7268187", name: "Almirante Norte Barrio" },
    { code: "PR.145.7268188", name: "Almirante Sur Barrio" },
    { code: "PR.145.7268278", name: "Cabo Caribe Barrio" },
    { code: "PR.145.7268827", name: "Puerto Nuevo Barrio" },
    { code: "PR.145.7268832", name: "Pugnado Adentro Barrio" },
    { code: "PR.145.7268833", name: "Pugnado Afuera Barrio" },
    { code: "PR.145.7268845", name: "Quebrada Arenas Barrio" },
    { code: "PR.145.7268888", name: "Río Abajo Barrio" },
    { code: "PR.145.7268892", name: "Río Arriba Barrio" },
    { code: "PR.145.7269068", name: "Vega Baja Barrio-Pueblo" },
    { code: "PR.145.7269091", name: "Yeguada Barrio" },
  ],
  "PR.147": [
    { code: "PR.147.7268396", name: "Florida Barrio" },
    { code: "PR.147.7268495", name: "Isabel Segunda" },
    { code: "PR.147.7268570", name: "Llave Barrio" },
    { code: "PR.147.7268684", name: "Mosquito Barrio" },
    { code: "PR.147.7268825", name: "Puerto Diablo Barrio" },
    { code: "PR.147.7268826", name: "Puerto Ferro Barrio" },
    { code: "PR.147.7268829", name: "Puerto Real Barrio" },
    { code: "PR.147.7268836", name: "Punta Arenas Barrio" },
  ],
  "PR.149": [
    { code: "PR.149.7268331", name: "Caonillas Abajo Barrio" },
    { code: "PR.149.7268333", name: "Caonillas Arriba Barrio" },
    { code: "PR.149.7268460", name: "Hato Puerco Abajo Barrio" },
    { code: "PR.149.7268461", name: "Hato Puerco Arriba Barrio" },
    { code: "PR.149.7269061", name: "Vacas Barrio" },
    { code: "PR.149.7269079", name: "Villalba Abajo Barrio" },
    { code: "PR.149.7269080", name: "Villalba Arriba Barrio" },
    { code: "PR.149.7269081", name: "Villalba Barrio-Pueblo" },
  ],
  "PR.151": [
    { code: "PR.151.7268169", name: "Aguacate Barrio" },
    { code: "PR.151.7268298", name: "Calabazas Barrio" },
    { code: "PR.151.7268307", name: "Camino Nuevo Barrio" },
    { code: "PR.151.7268437", name: "Guayabota Barrio" },
    { code: "PR.151.7268503", name: "Jácanas Barrio" },
    { code: "PR.151.7268531", name: "Juan Martín Barrio" },
    { code: "PR.151.7268561", name: "Limones Barrio" },
    { code: "PR.151.7268772", name: "Playa Barrio" },
    { code: "PR.151.7269031", name: "Tejas Barrio" },
    { code: "PR.151.7269085", name: "Yabucoa Barrio-Pueblo" },
  ],
  "PR.153": [
    { code: "PR.153.7268099", name: "Collores Barrio" },
    { code: "PR.153.7268149", name: "Diego Hernández Barrio" },
    { code: "PR.153.7268159", name: "Duey Barrio" },
    { code: "PR.153.7268172", name: "Aguas Blancas Barrio" },
    { code: "PR.153.7268183", name: "Algarrobo Barrio" },
    { code: "PR.153.7268185", name: "Almácigo Alto Barrio" },
    { code: "PR.153.7268186", name: "Almácigo Bajo Barrio" },
    { code: "PR.153.7268233", name: "Barina Barrio" },
    { code: "PR.153.7268294", name: "Caimito Barrio" },
    { code: "PR.153.7268399", name: "Frailes Barrio" },
    { code: "PR.153.7268502", name: "Jácana Barrio" },
    { code: "PR.153.7268699", name: "Naranjo Barrio" },
    { code: "PR.153.7268866", name: "Quebradas Barrio" },
    { code: "PR.153.7268874", name: "Ranchera Barrio" },
    { code: "PR.153.7268917", name: "Río Prieto Barrio" },
    { code: "PR.153.7268930", name: "Rubias Barrio" },
    { code: "PR.153.7269008", name: "Sierra Alta Barrio" },
    { code: "PR.153.7269017", name: "Susúa Alta Barrio" },
    { code: "PR.153.7269019", name: "Susúa Baja Barrio" },
    { code: "PR.153.7269073", name: "Vegas Barrio" },
    { code: "PR.153.7269087", name: "Yauco Barrio-Pueblo" },
  ],
  "PS.GZ": [
    { code: "PS.GZ.11184609", name: "Gaza" },
    { code: "PS.GZ.7870260", name: "Rafah" },
    { code: "PS.GZ.7870263", name: "North Gaza" },
    { code: "PS.GZ.7870268", name: "Deir Al Balah" },
    { code: "PS.GZ.7871092", name: "Khan Yunis Governorate" },
  ],
  "PS.WE": [
    { code: "PS.WE.7828733", name: "Jenin" },
    { code: "PS.WE.7870463", name: "Bethlehem" },
    { code: "PS.WE.7870555", name: "Nablus" },
    { code: "PS.WE.7870644", name: "Tulkarm" },
    { code: "PS.WE.7870648", name: "Tubas" },
    { code: "PS.WE.7870649", name: "Qalqilya" },
    { code: "PS.WE.7870652", name: "Salfit" },
    { code: "PS.WE.7870653", name: "Jericho" },
    { code: "PS.WE.7870654", name: "Al Quds" },
    { code: "PS.WE.7870657", name: "Ramallah" },
    { code: "PS.WE.7870658", name: "Al Khalil" },
  ],
  "PT.02": [
    { code: "PT.02.0101", name: "Águeda" },
    { code: "PT.02.0102", name: "Albergaria-A-Velha" },
    { code: "PT.02.0103", name: "Anadia" },
    { code: "PT.02.0104", name: "Arouca" },
    { code: "PT.02.0105", name: "Aveiro" },
    { code: "PT.02.0106", name: "Castelo de Paiva" },
    { code: "PT.02.0107", name: "Espinho" },
    { code: "PT.02.0108", name: "Estarreja" },
    { code: "PT.02.0109", name: "Santa Maria da Feira" },
    { code: "PT.02.0110", name: "Ílhavo" },
    { code: "PT.02.0111", name: "Mealhada" },
    { code: "PT.02.0112", name: "Murtosa" },
    { code: "PT.02.0113", name: "Oliveira de Azeméis" },
    { code: "PT.02.0114", name: "Oliveira do Bairro" },
    { code: "PT.02.0115", name: "Ovar" },
    { code: "PT.02.0116", name: "São João da Madeira" },
    { code: "PT.02.0117", name: "Sever do Vouga" },
    { code: "PT.02.0118", name: "Vagos" },
    { code: "PT.02.0119", name: "Vale de Cambra" },
  ],
  "PT.03": [
    { code: "PT.03.0201", name: "Aljustrel" },
    { code: "PT.03.0202", name: "Almodôvar" },
    { code: "PT.03.0203", name: "Alvito" },
    { code: "PT.03.0204", name: "Barrancos" },
    { code: "PT.03.0205", name: "Beja" },
    { code: "PT.03.0206", name: "Castro Verde" },
    { code: "PT.03.0207", name: "Cuba" },
    { code: "PT.03.0208", name: "Ferreira do Alentejo" },
    { code: "PT.03.0209", name: "Mértola" },
    { code: "PT.03.0210", name: "Moura" },
    { code: "PT.03.0211", name: "Odemira" },
    { code: "PT.03.0212", name: "Ourique" },
    { code: "PT.03.0213", name: "Serpa" },
    { code: "PT.03.0214", name: "Vidigueira" },
  ],
  "PT.04": [
    { code: "PT.04.0301", name: "Amares" },
    { code: "PT.04.0302", name: "Barcelos" },
    { code: "PT.04.0303", name: "Braga" },
    { code: "PT.04.0304", name: "Cabeceiras de Basto" },
    { code: "PT.04.0305", name: "Celorico de Basto" },
    { code: "PT.04.0306", name: "Esposende" },
    { code: "PT.04.0307", name: "Fafe" },
    { code: "PT.04.0308", name: "Guimarães" },
    { code: "PT.04.0309", name: "Póvoa de Lanhoso" },
    { code: "PT.04.0310", name: "Terras de Bouro" },
    { code: "PT.04.0311", name: "Vieira do Minho" },
    { code: "PT.04.0312", name: "Vila Nova de Famalicão" },
    { code: "PT.04.0313", name: "Vila Verde" },
    { code: "PT.04.0314", name: "Vizela" },
  ],
  "PT.05": [
    { code: "PT.05.0401", name: "Alfândega da Fé" },
    { code: "PT.05.0402", name: "Bragança Municipality" },
    { code: "PT.05.0403", name: "Carrazeda de Ansiães" },
    { code: "PT.05.0404", name: "Freixo de Espada À Cinta" },
    { code: "PT.05.0405", name: "Macedo de Cavaleiros" },
    { code: "PT.05.0406", name: "Miranda do Douro" },
    { code: "PT.05.0407", name: "Mirandela" },
    { code: "PT.05.0408", name: "Mogadouro" },
    { code: "PT.05.0409", name: "Torre de Moncorvo" },
    { code: "PT.05.0410", name: "Vila Flor" },
    { code: "PT.05.0411", name: "Vimioso" },
    { code: "PT.05.0412", name: "Vinhais" },
  ],
  "PT.06": [
    { code: "PT.06.0501", name: "Belmonte" },
    { code: "PT.06.0502", name: "Castelo Branco" },
    { code: "PT.06.0503", name: "Covilhã" },
    { code: "PT.06.0504", name: "Fundão" },
    { code: "PT.06.0505", name: "Idanha-A-Nova" },
    { code: "PT.06.0506", name: "Oleiros" },
    { code: "PT.06.0507", name: "Penamacor" },
    { code: "PT.06.0508", name: "Proença-A-Nova" },
    { code: "PT.06.0509", name: "Sertã" },
    { code: "PT.06.0510", name: "Vila de Rei" },
    { code: "PT.06.0511", name: "Vila Velha de Ródão" },
  ],
  "PT.07": [
    { code: "PT.07.0601", name: "Arganil" },
    { code: "PT.07.0602", name: "Cantanhede" },
    { code: "PT.07.0603", name: "Coimbra" },
    { code: "PT.07.0604", name: "Condeixa-A-Nova" },
    { code: "PT.07.0605", name: "Figueira da Foz" },
    { code: "PT.07.0606", name: "Góis" },
    { code: "PT.07.0607", name: "Lousã" },
    { code: "PT.07.0608", name: "Mira" },
    { code: "PT.07.0609", name: "Miranda do Corvo" },
    { code: "PT.07.0610", name: "Montemor-O-Velho" },
    { code: "PT.07.0611", name: "Oliveira do Hospital" },
    { code: "PT.07.0612", name: "Pampilhosa da Serra" },
    { code: "PT.07.0613", name: "Penacova" },
    { code: "PT.07.0614", name: "Penela" },
    { code: "PT.07.0615", name: "Soure" },
    { code: "PT.07.0616", name: "Tábua" },
    { code: "PT.07.0617", name: "Vila Nova de Poiares" },
  ],
  "PT.08": [
    { code: "PT.08.0701", name: "Alandroal" },
    { code: "PT.08.0702", name: "Arraiolos" },
    { code: "PT.08.0703", name: "Borba" },
    { code: "PT.08.0704", name: "Estremoz" },
    { code: "PT.08.0705", name: "Évora" },
    { code: "PT.08.0706", name: "Montemor-O-Novo" },
    { code: "PT.08.0707", name: "Mora" },
    { code: "PT.08.0708", name: "Mourão" },
    { code: "PT.08.0709", name: "Portel" },
    { code: "PT.08.0710", name: "Redondo" },
    { code: "PT.08.0711", name: "Reguengos de Monsaraz" },
    { code: "PT.08.0712", name: "Vendas Novas" },
    { code: "PT.08.0713", name: "Viana do Alentejo" },
    { code: "PT.08.0714", name: "Vila Viçosa" },
  ],
  "PT.09": [
    { code: "PT.09.0801", name: "Albufeira" },
    { code: "PT.09.0802", name: "Alcoutim" },
    { code: "PT.09.0803", name: "Aljezur" },
    { code: "PT.09.0804", name: "Castro Marim" },
    { code: "PT.09.0805", name: "Faro" },
    { code: "PT.09.0806", name: "Lagoa" },
    { code: "PT.09.0807", name: "Lagos" },
    { code: "PT.09.0808", name: "Loulé" },
    { code: "PT.09.0809", name: "Monchique" },
    { code: "PT.09.0810", name: "Olhão" },
    { code: "PT.09.0811", name: "Portimão" },
    { code: "PT.09.0812", name: "São Brás de Alportel" },
    { code: "PT.09.0813", name: "Silves" },
    { code: "PT.09.0814", name: "Tavira" },
    { code: "PT.09.0815", name: "Vila do Bispo" },
    { code: "PT.09.0816", name: "Vila Real de Santo António" },
  ],
  "PT.10": [
    { code: "PT.10.3101", name: "Calheta" },
    { code: "PT.10.3102", name: "Câmara de Lobos" },
    { code: "PT.10.3103", name: "Funchal" },
    { code: "PT.10.3104", name: "Machico" },
    { code: "PT.10.3105", name: "Ponta do Sol" },
    { code: "PT.10.3106", name: "Porto Moniz" },
    { code: "PT.10.3107", name: "Ribeira Brava" },
    { code: "PT.10.3108", name: "Santa Cruz" },
    { code: "PT.10.3109", name: "Santana" },
    { code: "PT.10.3110", name: "São Vicente" },
    { code: "PT.10.3201", name: "Porto Santo" },
  ],
  "PT.11": [
    { code: "PT.11.0901", name: "Aguiar da Beira" },
    { code: "PT.11.0902", name: "Almeida" },
    { code: "PT.11.0903", name: "Celorico da Beira" },
    { code: "PT.11.0904", name: "Figueira de Castelo Rodrigo" },
    { code: "PT.11.0905", name: "Fornos de Algodres" },
    { code: "PT.11.0906", name: "Gouveia" },
    { code: "PT.11.0907", name: "Guarda" },
    { code: "PT.11.0908", name: "Manteigas" },
    { code: "PT.11.0909", name: "Mêda" },
    { code: "PT.11.0910", name: "Pinhel" },
    { code: "PT.11.0911", name: "Sabugal" },
    { code: "PT.11.0912", name: "Seia" },
    { code: "PT.11.0913", name: "Trancoso" },
    { code: "PT.11.0914", name: "Vila Nova de Foz Côa" },
  ],
  "PT.13": [
    { code: "PT.13.1001", name: "Alcobaça" },
    { code: "PT.13.1002", name: "Alvaiázere" },
    { code: "PT.13.1003", name: "Ansião" },
    { code: "PT.13.1004", name: "Batalha" },
    { code: "PT.13.1005", name: "Bombarral" },
    { code: "PT.13.1006", name: "Caldas da Rainha" },
    { code: "PT.13.1007", name: "Castanheira de Pêra" },
    { code: "PT.13.1008", name: "Figueiró Dos Vinhos" },
    { code: "PT.13.1009", name: "Leiria" },
    { code: "PT.13.1010", name: "Marinha Grande" },
    { code: "PT.13.1011", name: "Nazaré" },
    { code: "PT.13.1012", name: "Óbidos" },
    { code: "PT.13.1013", name: "Pedrógão Grande" },
    { code: "PT.13.1014", name: "Peniche" },
    { code: "PT.13.1015", name: "Pombal" },
    { code: "PT.13.1016", name: "Porto de Mós" },
  ],
  "PT.14": [
    { code: "PT.14.1101", name: "Alenquer" },
    { code: "PT.14.1102", name: "Arruda Dos Vinhos" },
    { code: "PT.14.1103", name: "Azambuja" },
    { code: "PT.14.1104", name: "Cadaval" },
    { code: "PT.14.1105", name: "Cascais" },
    { code: "PT.14.1106", name: "Lisbon" },
    { code: "PT.14.1107", name: "Loures" },
    { code: "PT.14.1108", name: "Lourinhã" },
    { code: "PT.14.1109", name: "Mafra" },
    { code: "PT.14.1110", name: "Oeiras" },
    { code: "PT.14.1111", name: "Sintra" },
    { code: "PT.14.1112", name: "Sobral de Monte Agraço" },
    { code: "PT.14.1113", name: "Torres Vedras" },
    { code: "PT.14.1114", name: "Vila Franca de Xira" },
    { code: "PT.14.1115", name: "Amadora" },
    { code: "PT.14.1116", name: "Odivelas" },
  ],
  "PT.16": [
    { code: "PT.16.1201", name: "Alter do Chão" },
    { code: "PT.16.1202", name: "Arronches" },
    { code: "PT.16.1203", name: "Avis" },
    { code: "PT.16.1204", name: "Campo Maior" },
    { code: "PT.16.1205", name: "Castelo de Vide" },
    { code: "PT.16.1206", name: "Crato" },
    { code: "PT.16.1207", name: "Elvas" },
    { code: "PT.16.1208", name: "Fronteira" },
    { code: "PT.16.1209", name: "Gavião" },
    { code: "PT.16.1210", name: "Marvão" },
    { code: "PT.16.1211", name: "Monforte" },
    { code: "PT.16.1212", name: "Nisa" },
    { code: "PT.16.1213", name: "Ponte de Sor" },
    { code: "PT.16.1214", name: "Portalegre" },
    { code: "PT.16.1215", name: "Sousel" },
  ],
  "PT.17": [
    { code: "PT.17.1301", name: "Amarante" },
    { code: "PT.17.1302", name: "Baião" },
    { code: "PT.17.1303", name: "Felgueiras" },
    { code: "PT.17.1304", name: "Gondomar" },
    { code: "PT.17.1305", name: "Lousada" },
    { code: "PT.17.1306", name: "Maia" },
    { code: "PT.17.1307", name: "Marco de Canaveses" },
    { code: "PT.17.1308", name: "Matosinhos" },
    { code: "PT.17.1309", name: "Paços de Ferreira" },
    { code: "PT.17.1310", name: "Paredes" },
    { code: "PT.17.1311", name: "Penafiel" },
    { code: "PT.17.1312", name: "Porto" },
    { code: "PT.17.1313", name: "Póvoa de Varzim" },
    { code: "PT.17.1314", name: "Santo Tirso" },
    { code: "PT.17.1315", name: "Valongo" },
    { code: "PT.17.1316", name: "Vila do Conde" },
    { code: "PT.17.1317", name: "Vila Nova de Gaia" },
    { code: "PT.17.1318", name: "Trofa" },
  ],
  "PT.18": [
    { code: "PT.18.1401", name: "Abrantes" },
    { code: "PT.18.1402", name: "Alcanena" },
    { code: "PT.18.1403", name: "Almeirim" },
    { code: "PT.18.1404", name: "Alpiarça" },
    { code: "PT.18.1405", name: "Benavente" },
    { code: "PT.18.1406", name: "Cartaxo" },
    { code: "PT.18.1407", name: "Chamusca" },
    { code: "PT.18.1408", name: "Constância" },
    { code: "PT.18.1409", name: "Coruche" },
    { code: "PT.18.1410", name: "Entroncamento" },
    { code: "PT.18.1411", name: "Ferreira do Zêzere" },
    { code: "PT.18.1412", name: "Golegã" },
    { code: "PT.18.1413", name: "Mação" },
    { code: "PT.18.1414", name: "Rio Maior" },
    { code: "PT.18.1415", name: "Salvaterra de Magos" },
    { code: "PT.18.1416", name: "Santarém" },
    { code: "PT.18.1417", name: "Sardoal" },
    { code: "PT.18.1418", name: "Tomar" },
    { code: "PT.18.1419", name: "Torres Novas" },
    { code: "PT.18.1420", name: "Vila Nova da Barquinha" },
    { code: "PT.18.1421", name: "Ourém" },
  ],
  "PT.19": [
    { code: "PT.19.1501", name: "Alcácer do Sal" },
    { code: "PT.19.1502", name: "Alcochete" },
    { code: "PT.19.1503", name: "Almada" },
    { code: "PT.19.1504", name: "Barreiro" },
    { code: "PT.19.1505", name: "Grândola" },
    { code: "PT.19.1506", name: "Moita" },
    { code: "PT.19.1507", name: "Montijo" },
    { code: "PT.19.1508", name: "Palmela" },
    { code: "PT.19.1509", name: "Santiago do Cacém" },
    { code: "PT.19.1510", name: "Seixal" },
    { code: "PT.19.1511", name: "Sesimbra" },
    { code: "PT.19.1512", name: "Setúbal" },
    { code: "PT.19.1513", name: "Sines" },
  ],
  "PT.20": [
    { code: "PT.20.1601", name: "Arcos de Valdevez" },
    { code: "PT.20.1602", name: "Caminha" },
    { code: "PT.20.1603", name: "Melgaço" },
    { code: "PT.20.1604", name: "Monção" },
    { code: "PT.20.1605", name: "Paredes de Coura" },
    { code: "PT.20.1606", name: "Ponte da Barca" },
    { code: "PT.20.1607", name: "Ponte de Lima" },
    { code: "PT.20.1608", name: "Valença" },
    { code: "PT.20.1609", name: "Viana do Castelo" },
    { code: "PT.20.1610", name: "Vila Nova de Cerveira" },
  ],
  "PT.21": [
    { code: "PT.21.1701", name: "Alijó" },
    { code: "PT.21.1702", name: "Boticas" },
    { code: "PT.21.1703", name: "Chaves" },
    { code: "PT.21.1704", name: "Mesão Frio" },
    { code: "PT.21.1705", name: "Mondim de Basto" },
    { code: "PT.21.1706", name: "Montalegre" },
    { code: "PT.21.1707", name: "Murça" },
    { code: "PT.21.1708", name: "Peso da Régua" },
    { code: "PT.21.1709", name: "Ribeira de Pena" },
    { code: "PT.21.1710", name: "Sabrosa" },
    { code: "PT.21.1711", name: "Santa Marta de Penaguião" },
    { code: "PT.21.1712", name: "Valpaços" },
    { code: "PT.21.1713", name: "Vila Pouca de Aguiar" },
    { code: "PT.21.1714", name: "Vila Real" },
  ],
  "PT.22": [
    { code: "PT.22.1801", name: "Armamar" },
    { code: "PT.22.1802", name: "Carregal do Sal" },
    { code: "PT.22.1803", name: "Castro Daire" },
    { code: "PT.22.1804", name: "Cinfães" },
    { code: "PT.22.1805", name: "Lamego" },
    { code: "PT.22.1806", name: "Mangualde" },
    { code: "PT.22.1807", name: "Moimenta da Beira" },
    { code: "PT.22.1808", name: "Mortágua" },
    { code: "PT.22.1809", name: "Nelas" },
    { code: "PT.22.1810", name: "Oliveira de Frades" },
    { code: "PT.22.1811", name: "Penalva do Castelo" },
    { code: "PT.22.1812", name: "Penedono" },
    { code: "PT.22.1813", name: "Resende" },
    { code: "PT.22.1814", name: "Santa Comba Dão" },
    { code: "PT.22.1815", name: "São João da Pesqueira" },
    { code: "PT.22.1816", name: "São Pedro do Sul" },
    { code: "PT.22.1817", name: "Sátão" },
    { code: "PT.22.1818", name: "Sernancelhe" },
    { code: "PT.22.1819", name: "Tabuaço" },
    { code: "PT.22.1820", name: "Tarouca" },
    { code: "PT.22.1821", name: "Tondela" },
    { code: "PT.22.1822", name: "Vila Nova de Paiva" },
    { code: "PT.22.1823", name: "Viseu" },
    { code: "PT.22.1824", name: "Vouzela" },
  ],
  "PT.23": [
    { code: "PT.23.4101", name: "Vila do Porto" },
    { code: "PT.23.4201", name: "Lagoa" },
    { code: "PT.23.4202", name: "Nordeste" },
    { code: "PT.23.4203", name: "Ponta Delgada" },
    { code: "PT.23.4204", name: "Povoação" },
    { code: "PT.23.4205", name: "Ribeira Grande" },
    { code: "PT.23.4206", name: "Vila Franca do Campo" },
    { code: "PT.23.4301", name: "Angra do Heroísmo" },
    { code: "PT.23.4302", name: "Praia da Vitória" },
    { code: "PT.23.4401", name: "Santa Cruz da Graciosa" },
    { code: "PT.23.4501", name: "Calheta de São Jorge" },
    { code: "PT.23.4502", name: "Velas" },
    { code: "PT.23.4601", name: "Lajes do Pico" },
    { code: "PT.23.4602", name: "Madalena" },
    { code: "PT.23.4603", name: "São Roque do Pico" },
    { code: "PT.23.4701", name: "Horta" },
    { code: "PT.23.4801", name: "Lajes Das Flores" },
    { code: "PT.23.4802", name: "Santa Cruz Das Flores" },
    { code: "PT.23.4901", name: "Corvo" },
  ],
  "PW.06": [
    { code: "PW.06.7732470", name: "Rock Islands" },
  ],
  "PY.01": [
    { code: "PY.01.1001", name: "Ciudad Del Este" },
    { code: "PY.01.1002", name: "Presidente Franco" },
    { code: "PY.01.1003", name: "Domingo Martinez De Irala" },
    { code: "PY.01.1004", name: "Dr. Juan Leon Mallorquin" },
    { code: "PY.01.1005", name: "Hernandarias" },
    { code: "PY.01.1006", name: "Itakyry" },
    { code: "PY.01.1007", name: "Juan E. O´Leary" },
    { code: "PY.01.1008", name: "Ñacunday" },
    { code: "PY.01.1009", name: "Yguazu" },
    { code: "PY.01.1010", name: "Los Cedrales" },
    { code: "PY.01.1011", name: "Minga Guazu" },
    { code: "PY.01.1012", name: "San Cristobal" },
    { code: "PY.01.1013", name: "Santa Rita" },
    { code: "PY.01.1014", name: "Naranjal" },
    { code: "PY.01.1015", name: "Santa Rosa Del Monday" },
    { code: "PY.01.1016", name: "Minga Pora District" },
    { code: "PY.01.1017", name: "Mbaracayu" },
    { code: "PY.01.1018", name: "San Alberto" },
    { code: "PY.01.1019", name: "Iruña" },
    { code: "PY.01.1020", name: "Santa Fe Del Parana" },
    { code: "PY.01.1021", name: "Tavapy" },
    { code: "PY.01.1022", name: "Dr. Raul Peña" },
  ],
  "PY.02": [
    { code: "PY.02.1301", name: "Pedro Juan Caballero" },
    { code: "PY.02.1302", name: "Bella Vista" },
    { code: "PY.02.1303", name: "Capitan Bado" },
    { code: "PY.02.1304", name: "Zanja Pyta" },
  ],
  "PY.04": [
    { code: "PY.04.0501", name: "Coronel Oviedo" },
    { code: "PY.04.0502", name: "Caaguazu" },
    { code: "PY.04.0503", name: "Carayao" },
    { code: "PY.04.0504", name: "Cecilio Baez" },
    { code: "PY.04.0505", name: "Santa Rosa Del Mbutuy" },
    { code: "PY.04.0506", name: "Dr. Juan Manuel Frutos" },
    { code: "PY.04.0507", name: "Repatriacion" },
    { code: "PY.04.0508", name: "Nueva Londres" },
    { code: "PY.04.0509", name: "San Joaquin" },
    { code: "PY.04.0510", name: "San Jose De Los Arroyos" },
    { code: "PY.04.0511", name: "Yhu" },
    { code: "PY.04.0512", name: "J Eulogio Estigarribia" },
    { code: "PY.04.0513", name: "R.I. 3 Corrales" },
    { code: "PY.04.0514", name: "Raul Arsenio Oviedo" },
    { code: "PY.04.0515", name: "Jose Domingo Ocampos" },
    { code: "PY.04.0516", name: "Mcal. Francisco Solano Lopez" },
    { code: "PY.04.0517", name: "La Pastora" },
    { code: "PY.04.0518", name: "3 De Febrero" },
    { code: "PY.04.0519", name: "Simon Bolivar" },
    { code: "PY.04.0520", name: "Vaqueria" },
    { code: "PY.04.0521", name: "Tembiapora" },
    { code: "PY.04.0522", name: "Nueva Toledo" },
  ],
  "PY.05": [
    { code: "PY.05.0601", name: "Caazapa" },
    { code: "PY.05.0602", name: "Abai" },
    { code: "PY.05.0603", name: "Buena Vista" },
    { code: "PY.05.0604", name: "Moises Bertoni" },
    { code: "PY.05.0605", name: "General Higinio Morinigo" },
    { code: "PY.05.0606", name: "Maciel" },
    { code: "PY.05.0607", name: "San Juan Nepomuceno" },
    { code: "PY.05.0608", name: "Tavai" },
    { code: "PY.05.0609", name: "Fulgencio Yegros" },
    { code: "PY.05.0610", name: "Yuty" },
    { code: "PY.05.0611", name: "3 De Mayo" },
  ],
  "PY.06": [
    { code: "PY.06.1101", name: "Aregua" },
    { code: "PY.06.1102", name: "Capiata" },
    { code: "PY.06.1103", name: "Fernando De La Mora" },
    { code: "PY.06.1104", name: "Guarambare" },
    { code: "PY.06.1105", name: "Ita" },
    { code: "PY.06.1106", name: "Itaugua" },
    { code: "PY.06.1107", name: "Lambare" },
    { code: "PY.06.1108", name: "Limpio" },
    { code: "PY.06.1109", name: "Luque" },
    { code: "PY.06.1110", name: "Mariano Roque Alonso" },
    { code: "PY.06.1111", name: "Nueva Italia" },
    { code: "PY.06.1112", name: "Ñemby" },
    { code: "PY.06.1113", name: "San Antonio" },
    { code: "PY.06.1114", name: "San Lorenzo" },
    { code: "PY.06.1115", name: "Villa Elisa" },
    { code: "PY.06.1116", name: "Villeta" },
    { code: "PY.06.1117", name: "Ypacarai" },
    { code: "PY.06.1118", name: "Ypane" },
    { code: "PY.06.1119", name: "J Augusto Saldivar" },
  ],
  "PY.07": [
    { code: "PY.07.0101", name: "Concepcion" },
    { code: "PY.07.0102", name: "Belen" },
    { code: "PY.07.0103", name: "Horqueta" },
    { code: "PY.07.0104", name: "Loreto" },
    { code: "PY.07.0105", name: "San Carlos" },
    { code: "PY.07.0106", name: "San Lazaro" },
    { code: "PY.07.0107", name: "Yvy Ya´U" },
    { code: "PY.07.0108", name: "Azotey" },
    { code: "PY.07.0109", name: "Sgto. Jose Felix Lopez" },
  ],
  "PY.08": [
    { code: "PY.08.0301", name: "Caacupe" },
    { code: "PY.08.0302", name: "Altos" },
    { code: "PY.08.0303", name: "Arroyos Y Esteros" },
    { code: "PY.08.0304", name: "Atyra" },
    { code: "PY.08.0305", name: "Caraguatay" },
    { code: "PY.08.0306", name: "Emboscada" },
    { code: "PY.08.0307", name: "Eusebio Ayala" },
    { code: "PY.08.0308", name: "Isla Pucu" },
    { code: "PY.08.0309", name: "Itacurubi De La Cordillera" },
    { code: "PY.08.0310", name: "Juan De Mena" },
    { code: "PY.08.0311", name: "Loma Grande" },
    { code: "PY.08.0312", name: "Mbocayaty Del Yhaguy" },
    { code: "PY.08.0313", name: "Nueva Colombia" },
    { code: "PY.08.0314", name: "Piribebuy" },
    { code: "PY.08.0315", name: "Primero De Marzo" },
    { code: "PY.08.0316", name: "San Bernardino" },
    { code: "PY.08.0317", name: "Santa Elena" },
    { code: "PY.08.0318", name: "Tobati" },
    { code: "PY.08.0319", name: "Valenzuela" },
    { code: "PY.08.0320", name: "San Jose Obrero" },
  ],
  "PY.10": [
    { code: "PY.10.0401", name: "Villarrica" },
    { code: "PY.10.0402", name: "Borja" },
    { code: "PY.10.0403", name: "Mauricio Jose Troche" },
    { code: "PY.10.0404", name: "Coronel Martinez" },
    { code: "PY.10.0405", name: "Felix Perez Cardozo" },
    { code: "PY.10.0406", name: "General Eugenio A. Garay" },
    { code: "PY.10.0407", name: "Colonia Independencia" },
    { code: "PY.10.0408", name: "Itape" },
    { code: "PY.10.0409", name: "Iturbe" },
    { code: "PY.10.0410", name: "Jose Fassardi" },
    { code: "PY.10.0411", name: "Mbocayaty" },
    { code: "PY.10.0412", name: "Natalicio Talavera" },
    { code: "PY.10.0413", name: "Ñumi" },
    { code: "PY.10.0414", name: "San Salvador" },
    { code: "PY.10.0415", name: "Yataity" },
    { code: "PY.10.0416", name: "Dr. Bottrell" },
    { code: "PY.10.0417", name: "Paso Yobai" },
    { code: "PY.10.0418", name: "Tebicuary" },
  ],
  "PY.11": [
    { code: "PY.11.0701", name: "Encarnacion" },
    { code: "PY.11.0702", name: "Bella Vista" },
    { code: "PY.11.0703", name: "Cambyreta" },
    { code: "PY.11.0704", name: "Capitan Meza" },
    { code: "PY.11.0705", name: "Capitan Miranda" },
    { code: "PY.11.0706", name: "Nueva Alborada" },
    { code: "PY.11.0707", name: "Carmen Del Parana" },
    { code: "PY.11.0708", name: "Coronel Bogado" },
    { code: "PY.11.0709", name: "Carlos Antonio Lopez" },
    { code: "PY.11.0710", name: "Natalio" },
    { code: "PY.11.0711", name: "Fram" },
    { code: "PY.11.0712", name: "General Artigas" },
    { code: "PY.11.0713", name: "General Delgado" },
    { code: "PY.11.0714", name: "Hohenau" },
    { code: "PY.11.0715", name: "Jesus" },
    { code: "PY.11.0716", name: "Leandro Oviedo" },
    { code: "PY.11.0717", name: "Obligado" },
    { code: "PY.11.0718", name: "Mayor Otaño" },
    { code: "PY.11.0719", name: "San Cosme y Damian" },
    { code: "PY.11.0720", name: "San Pedro Del Parana" },
    { code: "PY.11.0721", name: "San Rafael Del Parana" },
    { code: "PY.11.0722", name: "Trinidad" },
    { code: "PY.11.0723", name: "Edelira" },
    { code: "PY.11.0724", name: "Tomas Romero Pereira" },
    { code: "PY.11.0725", name: "Alto Vera" },
    { code: "PY.11.0726", name: "La Paz" },
    { code: "PY.11.0727", name: "Yatytay" },
    { code: "PY.11.0728", name: "San Juan del Parana" },
    { code: "PY.11.0729", name: "Pirapo" },
    { code: "PY.11.0730", name: "Itapua Poty" },
  ],
  "PY.12": [
    { code: "PY.12.0801", name: "San Juan Bautista" },
    { code: "PY.12.0802", name: "Ayolas" },
    { code: "PY.12.0803", name: "San Ignacio" },
    { code: "PY.12.0804", name: "San Miguel" },
    { code: "PY.12.0805", name: "San Patricio" },
    { code: "PY.12.0806", name: "Santa Maria" },
    { code: "PY.12.0807", name: "Santa Rosa" },
    { code: "PY.12.0808", name: "Santiago" },
    { code: "PY.12.0809", name: "Villa Florida" },
    { code: "PY.12.0810", name: "Yabebyry" },
  ],
  "PY.13": [
    { code: "PY.13.1201", name: "Pilar" },
    { code: "PY.13.1202", name: "Alberdi" },
    { code: "PY.13.1203", name: "Cerrito" },
    { code: "PY.13.1204", name: "Desmochados" },
    { code: "PY.13.1205", name: "General Diaz" },
    { code: "PY.13.1206", name: "Guazu Cua" },
    { code: "PY.13.1207", name: "Humaita" },
    { code: "PY.13.1208", name: "Isla Umbu" },
    { code: "PY.13.1209", name: "Los Laureles" },
    { code: "PY.13.1210", name: "Mayor Martinez" },
    { code: "PY.13.1211", name: "Paso De Patria" },
    { code: "PY.13.1212", name: "San Juan Bautista De Ñeembucu" },
    { code: "PY.13.1213", name: "Tacuaras" },
    { code: "PY.13.1214", name: "Villa Franca" },
    { code: "PY.13.1215", name: "Villa Oliva" },
    { code: "PY.13.1216", name: "Villalbin" },
  ],
  "PY.15": [
    { code: "PY.15.0901", name: "Paraguari" },
    { code: "PY.15.0902", name: "Acahay" },
    { code: "PY.15.0903", name: "Caapucu" },
    { code: "PY.15.0904", name: "General Bernardino Caballero" },
    { code: "PY.15.0905", name: "Carapegua" },
    { code: "PY.15.0906", name: "Escobar" },
    { code: "PY.15.0907", name: "La Colmena" },
    { code: "PY.15.0908", name: "Mbuyapey" },
    { code: "PY.15.0909", name: "Pirayu" },
    { code: "PY.15.0910", name: "Quiindy" },
    { code: "PY.15.0911", name: "Quyquyho" },
    { code: "PY.15.0912", name: "San Roque Gonzalez" },
    { code: "PY.15.0913", name: "Sapucai" },
    { code: "PY.15.0914", name: "Tebicuary-Mi" },
    { code: "PY.15.0915", name: "Yaguaron" },
    { code: "PY.15.0916", name: "Yvycui" },
    { code: "PY.15.0917", name: "Yvytimi" },
  ],
  "PY.16": [
    { code: "PY.16.1502", name: "Benjamin Aceval" },
    { code: "PY.16.1503", name: "Puerto Pinasco" },
    { code: "PY.16.1504", name: "Villa Hayes" },
    { code: "PY.16.1505", name: "Nanawa" },
    { code: "PY.16.1506", name: "Jose Falcon" },
    { code: "PY.16.1507", name: "Tte 1ro Manuel Irala Fernandez" },
    { code: "PY.16.1508", name: "Tte. Esteban Martinez" },
    { code: "PY.16.1509", name: "General Jose Maria Bruguez" },
  ],
  "PY.17": [
    { code: "PY.17.0201", name: "San Pedro Del Ykuamandiyu" },
    { code: "PY.17.0202", name: "Antequera" },
    { code: "PY.17.0203", name: "Chore" },
    { code: "PY.17.0204", name: "General Elizardo Aquino" },
    { code: "PY.17.0205", name: "Itacurubi Del Rosario" },
    { code: "PY.17.0206", name: "Lima" },
    { code: "PY.17.0207", name: "Nueva Germania" },
    { code: "PY.17.0208", name: "San Estanislao" },
    { code: "PY.17.0209", name: "San Pablo" },
    { code: "PY.17.0210", name: "Tacuati" },
    { code: "PY.17.0211", name: "Union" },
    { code: "PY.17.0212", name: "25 De Diciembre" },
    { code: "PY.17.0213", name: "Villa Del Rosario" },
    { code: "PY.17.0214", name: "General Resquin" },
    { code: "PY.17.0215", name: "Yataity Del Norte" },
    { code: "PY.17.0216", name: "Guajayvi" },
    { code: "PY.17.0217", name: "Capiibary" },
    { code: "PY.17.0218", name: "Santa Rosa Del Aguaray" },
    { code: "PY.17.0219", name: "Yryvu Cua" },
    { code: "PY.17.0220", name: "Liberacion" },
  ],
  "PY.19": [
    { code: "PY.19.1401", name: "Saltos Del Guaira" },
    { code: "PY.19.1402", name: "Corpus Christi" },
    { code: "PY.19.1403", name: "Curuguaty" },
    { code: "PY.19.1404", name: "Villa Ygatimí" },
    { code: "PY.19.1405", name: "Itanara" },
    { code: "PY.19.1406", name: "Ype Jhu" },
    { code: "PY.19.1407", name: "Francisco Caballero Alvarez" },
    { code: "PY.19.1408", name: "Katuete" },
    { code: "PY.19.1409", name: "La Paloma" },
    { code: "PY.19.1410", name: "Nueva Esperanza" },
    { code: "PY.19.1411", name: "Yasy Kañy" },
    { code: "PY.19.1412", name: "Ybyrarobana" },
  ],
  "PY.22": [
    { code: "PY.22.0000", name: "Asuncion" },
  ],
  "PY.23": [
    { code: "PY.23.1701", name: "Fuerte Olimpo" },
    { code: "PY.23.1702", name: "Puerto Casado" },
    { code: "PY.23.1704", name: "Bahia Negra" },
    { code: "PY.23.1705", name: "Carmelo Peralta" },
  ],
  "PY.24": [
    { code: "PY.24.1602", name: "Mariscal Estigarribia" },
    { code: "PY.24.1604", name: "Filadelfia" },
    { code: "PY.24.1605", name: "Loma Plata" },
  ],
  "RE.RE": [
    { code: "RE.RE.974", name: "Réunion" },
  ],
  "RO.01": [
    { code: "RO.01.1017", name: "Municipiul Alba Iulia" },
    { code: "RO.01.1071", name: "Comuna Ciugud" },
    { code: "RO.01.1151", name: "Oraş abrud" },
    { code: "RO.01.1213", name: "Municipiul Aiud" },
    { code: "RO.01.1348", name: "Municipiul Blaj" },
    { code: "RO.01.1455", name: "Oraş Câmpeni" },
    { code: "RO.01.1696", name: "Oraş Cugir" },
    { code: "RO.01.1794", name: "Oraş Ocna Mureş" },
    { code: "RO.01.1874", name: "Municipiul Sebeş" },
    { code: "RO.01.1936", name: "Oraş Zlatna" },
    { code: "RO.01.2130", name: "Comuna Albac" },
    { code: "RO.01.2309", name: "Comuna Almaşu Mare" },
    { code: "RO.01.2381", name: "Comuna Arieşeni" },
    { code: "RO.01.2577", name: "Comuna Avram Iancu" },
    { code: "RO.01.2915", name: "Oraş Baia de Arieş" },
    { code: "RO.01.2988", name: "Comuna Berghin" },
    { code: "RO.01.3039", name: "Comuna Bistra" },
    { code: "RO.01.3397", name: "Comuna Blândiana" },
    { code: "RO.01.3459", name: "Comuna Bucium" },
    { code: "RO.01.3761", name: "Comuna Cenade" },
    { code: "RO.01.3805", name: "Comuna Cergău" },
    { code: "RO.01.3841", name: "Comuna Ceru-Băcăinţi" },
    { code: "RO.01.3958", name: "Comuna Cetatea de Baltă" },
    { code: "RO.01.4008", name: "Comuna Ciuruleasa" },
    { code: "RO.01.4106", name: "Comuna Câlnic" },
    { code: "RO.01.4142", name: "Comuna Cricău" },
    { code: "RO.01.4188", name: "Comuna Crăciunelu de Jos" },
    { code: "RO.01.4240", name: "Comuna Daia Română" },
    { code: "RO.01.4268", name: "Comuna Doştat" },
    { code: "RO.01.4302", name: "Comuna Fărău" },
    { code: "RO.01.4366", name: "Comuna Galda de Jos" },
    { code: "RO.01.4482", name: "Comuna Gârbova" },
    { code: "RO.01.4525", name: "Comuna Gârda de Sus" },
    { code: "RO.01.4703", name: "Comuna Hopârta" },
    { code: "RO.01.4767", name: "Comuna Horea" },
    { code: "RO.01.4927", name: "Comuna Ighiu" },
    { code: "RO.01.4981", name: "Comuna Întregalde" },
    { code: "RO.01.5103", name: "Comuna Jidvei" },
    { code: "RO.01.5167", name: "Comuna Livezile" },
    { code: "RO.01.5210", name: "Comuna Lopadea Nouă" },
    { code: "RO.01.5309", name: "Comuna Lunca Mureşului" },
    { code: "RO.01.5336", name: "Comuna Lupşa" },
    { code: "RO.01.5577", name: "Comuna Meteş" },
    { code: "RO.01.5700", name: "Comuna Mihalţ" },
    { code: "RO.01.5755", name: "Comuna Mirăslău" },
    { code: "RO.01.5826", name: "Comuna Mogoş" },
    { code: "RO.01.6048", name: "Comuna Noşlac" },
    { code: "RO.01.6119", name: "Comuna Ocoliş" },
    { code: "RO.01.6164", name: "Comuna Ohaba" },
    { code: "RO.01.6217", name: "Comuna Pianu" },
    { code: "RO.01.6271", name: "Comuna Poiana Vadului" },
    { code: "RO.01.6397", name: "Comuna Ponor" },
    { code: "RO.01.6468", name: "Comuna Poşaga" },
    { code: "RO.01.6547", name: "Comuna Rădeşti" },
    { code: "RO.01.6592", name: "Comuna Râmetea" },
    { code: "RO.01.6627", name: "Comuna Râmeţ" },
    { code: "RO.01.6761", name: "Comuna Roşia Montană" },
    { code: "RO.01.6930", name: "Comuna Roşia de Secaş" },
    { code: "RO.01.6976", name: "Comuna Sălciua" },
    { code: "RO.01.7044", name: "Comuna Sãliştea" },
    { code: "RO.01.7099", name: "Comuna Săsciori" },
    { code: "RO.01.7197", name: "Comuna Scărişoara" },
    { code: "RO.01.7348", name: "Comuna Sâncel" },
    { code: "RO.01.7384", name: "Comuna Sântimbru" },
    { code: "RO.01.7446", name: "Comuna Sohodol" },
    { code: "RO.01.7767", name: "Comuna Stremţ" },
    { code: "RO.01.7810", name: "Comuna Şibot" },
    { code: "RO.01.7865", name: "Comuna Şona" },
    { code: "RO.01.7945", name: "Comuna Şpring" },
    { code: "RO.01.8014", name: "Comuna Şugag" },
    { code: "RO.01.8096", name: "Oraş Teiuş" },
    { code: "RO.01.8158", name: "Comuna Unirea" },
    { code: "RO.01.8229", name: "Comuna Vadu Moţilor" },
    { code: "RO.01.8354", name: "Comuna Valea Lungă" },
    { code: "RO.01.8425", name: "Comuna Vidra" },
    { code: "RO.01.8826", name: "Comuna Vinţu de Jos" },
    { code: "RO.01.9019", name: "Comuna Cut" },
    { code: "RO.01.9026", name: "Comuna Bucerdea-Grânoasă" },
  ],
  "RO.02": [
    { code: "RO.02.10006", name: "Comuna Birchiş" },
    { code: "RO.02.10051", name: "Comuna Bârsa" },
    { code: "RO.02.10104", name: "Comuna Bârzava" },
    { code: "RO.02.10195", name: "Comuna Bocsig" },
    { code: "RO.02.10239", name: "Comuna Brazii" },
    { code: "RO.02.10293", name: "Comuna Buteni" },
    { code: "RO.02.10346", name: "Comuna Cărand" },
    { code: "RO.02.10373", name: "Comuna Cermei" },
    { code: "RO.02.10417", name: "Comuna Chisindia" },
    { code: "RO.02.10453", name: "Comuna Conop" },
    { code: "RO.02.10514", name: "Comuna Covăsinţ" },
    { code: "RO.02.10532", name: "Comuna Craiva" },
    { code: "RO.02.10649", name: "Comuna Dezna" },
    { code: "RO.02.10701", name: "Comuna Dieci" },
    { code: "RO.02.10765", name: "Comuna Ususău" },
    { code: "RO.02.10827", name: "Comuna Felnac" },
    { code: "RO.02.10872", name: "Comuna Ghioroc" },
    { code: "RO.02.10916", name: "Comuna Grăniceri" },
    { code: "RO.02.10943", name: "Comuna Gurahonţ" },
    { code: "RO.02.11058", name: "Comuna Hălmagiu" },
    { code: "RO.02.11174", name: "Comuna Hălmăgel" },
    { code: "RO.02.11236", name: "Comuna Hăşmaş" },
    { code: "RO.02.11307", name: "Comuna Igneşti" },
    { code: "RO.02.11352", name: "Comuna Iratoşu" },
    { code: "RO.02.11398", name: "Comuna Macea" },
    { code: "RO.02.11423", name: "Comuna Mişca" },
    { code: "RO.02.11478", name: "Comuna Moneasa" },
    { code: "RO.02.11502", name: "Comuna Olari" },
    { code: "RO.02.11539", name: "Comuna Păuliş" },
    { code: "RO.02.11584", name: "Oraş Pecica" },
    { code: "RO.02.11637", name: "Comuna Peregu Mare" },
    { code: "RO.02.11664", name: "Comuna Petriş" },
    { code: "RO.02.11735", name: "Comuna Pilu" },
    { code: "RO.02.11762", name: "Comuna Pleşcuţa" },
    { code: "RO.02.11842", name: "Comuna Săvârşin" },
    { code: "RO.02.11940", name: "Comuna Secusigiu" },
    { code: "RO.02.11995", name: "Comuna Seleuş" },
    { code: "RO.02.12037", name: "Comuna Semlac" },
    { code: "RO.02.12055", name: "Comuna Sintea Mare" },
    { code: "RO.02.12091", name: "Oraş Sântana" },
    { code: "RO.02.12126", name: "Comuna Socodor" },
    { code: "RO.02.12144", name: "Comuna Şagu" },
    { code: "RO.02.12206", name: "Comuna Şeitin" },
    { code: "RO.02.12224", name: "Comuna Şepreuş" },
    { code: "RO.02.12242", name: "Comuna Şicula" },
    { code: "RO.02.12288", name: "Comuna Şilindia" },
    { code: "RO.02.12340", name: "Comuna Şimand" },
    { code: "RO.02.12368", name: "Comuna Şiria" },
    { code: "RO.02.12402", name: "Comuna Şiştarovăţ" },
    { code: "RO.02.12457", name: "Comuna Tauţ" },
    { code: "RO.02.12509", name: "Comuna Târnova" },
    { code: "RO.02.12572", name: "Comuna Vărădia de Mureş" },
    { code: "RO.02.12643", name: "Comuna Vinga" },
    { code: "RO.02.12689", name: "Comuna Vârfurile" },
    { code: "RO.02.12778", name: "Comuna Zăbrani" },
    { code: "RO.02.12812", name: "Comuna Zărand" },
    { code: "RO.02.12849", name: "Comuna Zerind" },
    { code: "RO.02.12876", name: "Comuna Zimandu Nou" },
    { code: "RO.02.12912", name: "Comuna Dorobanți" },
    { code: "RO.02.12920", name: "Comuna Frumuşeni" },
    { code: "RO.02.12938", name: "Comuna Zădăreni" },
    { code: "RO.02.9262", name: "Municipiul Arad" },
    { code: "RO.02.9280", name: "Comuna Fântânele" },
    { code: "RO.02.9333", name: "Comuna Livada" },
    { code: "RO.02.9360", name: "Comuna Şofronea" },
    { code: "RO.02.9397", name: "Comuna Vladimirescu" },
    { code: "RO.02.9459", name: "Oraş Chişineu-Criş" },
    { code: "RO.02.9495", name: "Oraş Curtici" },
    { code: "RO.02.9538", name: "Oraş Ineu" },
    { code: "RO.02.9574", name: "Oraş Lipova" },
    { code: "RO.02.9627", name: "Oraş Nãdlac" },
    { code: "RO.02.9654", name: "Oraş Pâncota" },
    { code: "RO.02.9690", name: "Oraş Sebiş" },
    { code: "RO.02.9743", name: "Comuna Almaş" },
    { code: "RO.02.9798", name: "Comuna Apateu" },
    { code: "RO.02.9832", name: "Comuna Archiş" },
    { code: "RO.02.9887", name: "Comuna Bata" },
    { code: "RO.02.9930", name: "Comuna Beliu" },
  ],
  "RO.03": [
    { code: "RO.03.13169", name: "Municipiul Piteşti" },
    { code: "RO.03.13187", name: "Comuna Başcov" },
    { code: "RO.03.13276", name: "Comuna Bradu" },
    { code: "RO.03.13301", name: "Oraș Mioveni" },
    { code: "RO.03.13365", name: "Comuna Mărăcineni" },
    { code: "RO.03.13392", name: "Oraș Ştefăneşti" },
    { code: "RO.03.13490", name: "Municipiul Câmpulung" },
    { code: "RO.03.13524", name: "Comuna Valea Mare-Pravăţ" },
    { code: "RO.03.13622", name: "Municipiul Curtea de Argeș" },
    { code: "RO.03.13668", name: "Oraș Costeşti" },
    { code: "RO.03.13757", name: "Oraș Topoloveni" },
    { code: "RO.03.13819", name: "Comuna Albeștii de Argeș" },
    { code: "RO.03.13891", name: "Comuna Albeștii de Muscel" },
    { code: "RO.03.13935", name: "Comuna Albota" },
    { code: "RO.03.13999", name: "Comuna Aninoasa" },
    { code: "RO.03.14049", name: "Comuna Arefu" },
    { code: "RO.03.14085", name: "Comuna Băbana" },
    { code: "RO.03.14165", name: "Comuna Băiculeşti" },
    { code: "RO.03.14272", name: "Comuna Bălileşti" },
    { code: "RO.03.14352", name: "Comuna Beleţi-Negreşti" },
    { code: "RO.03.14405", name: "Comuna Berevoeşti" },
    { code: "RO.03.14450", name: "Comuna Bârla" },
    { code: "RO.03.14584", name: "Comuna Bogaţi" },
    { code: "RO.03.14673", name: "Comuna Boteni" },
    { code: "RO.03.14726", name: "Comuna Boţeşti" },
    { code: "RO.03.14753", name: "Comuna Brăduleţ" },
    { code: "RO.03.14851", name: "Comuna Budeasa" },
    { code: "RO.03.14922", name: "Comuna Bughea de Jos" },
    { code: "RO.03.14940", name: "Comuna Buzoeşti" },
    { code: "RO.03.15064", name: "Comuna Căldăraru" },
    { code: "RO.03.15108", name: "Comuna Călineşti" },
    { code: "RO.03.15233", name: "Comuna Căteasca" },
    { code: "RO.03.15313", name: "Comuna Cepari" },
    { code: "RO.03.15402", name: "Comuna Cetăţeni" },
    { code: "RO.03.15448", name: "Comuna Cicănești" },
    { code: "RO.03.15493", name: "Comuna Ciofrângeni" },
    { code: "RO.03.15554", name: "Comuna Ciomăgeşti" },
    { code: "RO.03.15652", name: "Comuna Cocu" },
    { code: "RO.03.15741", name: "Comuna Corbeni" },
    { code: "RO.03.15830", name: "Comuna Corbi" },
    { code: "RO.03.15901", name: "Comuna Coşeşti" },
    { code: "RO.03.15983", name: "Comuna Cotmeana" },
    { code: "RO.03.16132", name: "Comuna Cuca" },
    { code: "RO.03.16285", name: "Comuna Davideşti" },
    { code: "RO.03.16329", name: "Comuna Dâmbovicioara" },
    { code: "RO.03.16365", name: "Comuna Dărmăneşti" },
    { code: "RO.03.16427", name: "Comuna Dobreşti" },
    { code: "RO.03.16454", name: "Comuna Domneşti" },
    { code: "RO.03.16472", name: "Comuna Dragoslavele" },
    { code: "RO.03.16506", name: "Comuna Drăganu" },
    { code: "RO.03.16551", name: "Comuna Godeni" },
    { code: "RO.03.16613", name: "Comuna Hârseşti" },
    { code: "RO.03.16659", name: "Comuna Hârtieşti" },
    { code: "RO.03.16739", name: "Comuna Izvoru" },
    { code: "RO.03.16757", name: "Comuna Leordeni" },
    { code: "RO.03.16908", name: "Comuna Lereşti" },
    { code: "RO.03.16944", name: "Comuna Lunca Corbului" },
    { code: "RO.03.17049", name: "Comuna Mălureni" },
    { code: "RO.03.17101", name: "Comuna Merișani" },
    { code: "RO.03.17209", name: "Comuna Miceşti" },
    { code: "RO.03.17254", name: "Comuna Mihăeşti" },
    { code: "RO.03.17334", name: "Comuna Mioarele" },
    { code: "RO.03.17398", name: "Comuna Miroşi" },
    { code: "RO.03.17423", name: "Comuna Morărești" },
    { code: "RO.03.17496", name: "Comuna Moşoaia" },
    { code: "RO.03.17575", name: "Comuna Mozăceni" },
    { code: "RO.03.17619", name: "Comuna Mușătești" },
    { code: "RO.03.17726", name: "Comuna Negraşi" },
    { code: "RO.03.17771", name: "Comuna Nucşoara" },
    { code: "RO.03.17824", name: "Comuna Oarja" },
    { code: "RO.03.17851", name: "Comuna Pietroşani" },
    { code: "RO.03.17913", name: "Comuna Poienarii de Argeş" },
    { code: "RO.03.17968", name: "Comuna Poienarii de Muscel" },
    { code: "RO.03.18028", name: "Comuna Poiana Lacului" },
    { code: "RO.03.18162", name: "Comuna Popeşti" },
    { code: "RO.03.18242", name: "Comuna Priboieni" },
    { code: "RO.03.18331", name: "Comuna Răteşti" },
    { code: "RO.03.18411", name: "Comuna Recea" },
    { code: "RO.03.18475", name: "Comuna Rociu" },
    { code: "RO.03.18527", name: "Comuna Rucăr" },
    { code: "RO.03.18554", name: "Comuna Sălătrucu" },
    { code: "RO.03.18581", name: "Comuna Săpata" },
    { code: "RO.03.18670", name: "Comuna Schitu-Goleşti" },
    { code: "RO.03.18741", name: "Comuna Slobozia" },
    { code: "RO.03.18778", name: "Comuna Stâlpeni" },
    { code: "RO.03.18858", name: "Comuna Stoeneşti" },
    { code: "RO.03.18938", name: "Comuna Stolnici" },
    { code: "RO.03.19007", name: "Comuna Suseni" },
    { code: "RO.03.19114", name: "Comuna Ştefan cel Mare" },
    { code: "RO.03.19141", name: "Comuna Şuici" },
    { code: "RO.03.19212", name: "Comuna Teiu" },
    { code: "RO.03.19249", name: "Comuna Tigveni" },
    { code: "RO.03.19338", name: "Comuna Țițești" },
    { code: "RO.03.19392", name: "Comuna Uda" },
    { code: "RO.03.19560", name: "Comuna Ungheni" },
    { code: "RO.03.19631", name: "Comuna Valea Danului" },
    { code: "RO.03.19695", name: "Comuna Valea Iaşului" },
    { code: "RO.03.19793", name: "Comuna Vedea" },
    { code: "RO.03.19999", name: "Comuna Vlădeşti" },
    { code: "RO.03.20048", name: "Comuna Râca" },
    { code: "RO.03.20055", name: "Comuna Vultureşti" },
    { code: "RO.03.20063", name: "Comuna Bughea de Sus" },
  ],
  "RO.04": [
    { code: "RO.04.20297", name: "Municipiul Bacãu" },
    { code: "RO.04.20313", name: "Comuna Hemeiuşi" },
    { code: "RO.04.20359", name: "Comuna Letea Veche" },
    { code: "RO.04.20411", name: "Comuna Măgura" },
    { code: "RO.04.20466", name: "Comuna Mărgineni" },
    { code: "RO.04.20563", name: "Municipiul Oneşti" },
    { code: "RO.04.20607", name: "Comuna Gura Văii" },
    { code: "RO.04.20670", name: "Comuna Ştefan Cel Mare" },
    { code: "RO.04.20778", name: "Oraş Buhuşi" },
    { code: "RO.04.20821", name: "Oraş Comãneşti" },
    { code: "RO.04.20876", name: "Municipiul Moineşti" },
    { code: "RO.04.20910", name: "Oraş Slãnic-Moldova" },
    { code: "RO.04.20965", name: "Oraş Târgu Ocna" },
    { code: "RO.04.21007", name: "Comuna Agăş" },
    { code: "RO.04.21098", name: "Comuna Ardeoani" },
    { code: "RO.04.21123", name: "Comuna Asău" },
    { code: "RO.04.21196", name: "Comuna Balcani" },
    { code: "RO.04.21249", name: "Comuna Bereşti-Bistriţa" },
    { code: "RO.04.21338", name: "Comuna Bereşti-Tazlău" },
    { code: "RO.04.21418", name: "Comuna Berzunţi" },
    { code: "RO.04.21454", name: "Comuna Bârsăneşti" },
    { code: "RO.04.21506", name: "Comuna Blăgeşti" },
    { code: "RO.04.21560", name: "Comuna Bogdăneşti" },
    { code: "RO.04.21597", name: "Comuna Brusturoasa" },
    { code: "RO.04.21668", name: "Comuna Buhoci" },
    { code: "RO.04.21720", name: "Comuna Mânăstirea Caşin" },
    { code: "RO.04.21757", name: "Comuna Căiuţi" },
    { code: "RO.04.21855", name: "Comuna Cleja" },
    { code: "RO.04.21891", name: "Comuna Coloneşti" },
    { code: "RO.04.21971", name: "Comuna Corbasca" },
    { code: "RO.04.22059", name: "Comuna Coţofăneşti" },
    { code: "RO.04.22111", name: "Comuna Dămieneşti" },
    { code: "RO.04.22166", name: "Oraş Dãrmãneşti" },
    { code: "RO.04.22237", name: "Comuna Dealu Morii" },
    { code: "RO.04.22380", name: "Comuna Dofteana" },
    { code: "RO.04.22460", name: "Comuna Faraoani" },
    { code: "RO.04.22488", name: "Comuna Filipeni" },
    { code: "RO.04.22576", name: "Comuna Filipeşti" },
    { code: "RO.04.22665", name: "Comuna Găiceana" },
    { code: "RO.04.22718", name: "Comuna Ghimeş-Făget" },
    { code: "RO.04.22781", name: "Comuna Gârleni" },
    { code: "RO.04.22834", name: "Comuna Glăvăneşti" },
    { code: "RO.04.22898", name: "Comuna Helegiu" },
    { code: "RO.04.22941", name: "Comuna Horgeşti" },
    { code: "RO.04.23047", name: "Comuna Huruieşti" },
    { code: "RO.04.23127", name: "Comuna Izvoru Berheciului" },
    { code: "RO.04.23207", name: "Comuna Lipova" },
    { code: "RO.04.23289", name: "Comuna Livezi" },
    { code: "RO.04.23350", name: "Comuna Luizi-Cãlugãra" },
    { code: "RO.04.23387", name: "Comuna Măgireşti" },
    { code: "RO.04.23449", name: "Comuna Mãnãstirea Caşin" },
    { code: "RO.04.23494", name: "Comuna Motoşeni" },
    { code: "RO.04.23644", name: "Comuna Negri" },
    { code: "RO.04.23715", name: "Comuna Nicolae Bălcescu" },
    { code: "RO.04.23797", name: "Comuna Oituz" },
    { code: "RO.04.23868", name: "Comuna Onceşti" },
    { code: "RO.04.23948", name: "Comuna Orbeni" },
    { code: "RO.04.23975", name: "Comuna Palanca" },
    { code: "RO.04.24034", name: "Comuna Parava" },
    { code: "RO.04.24089", name: "Comuna Parincea" },
    { code: "RO.04.24187", name: "Comuna Pănceşti" },
    { code: "RO.04.24276", name: "Comuna Pârgăreşti" },
    { code: "RO.04.24338", name: "Comuna Pârjol" },
    { code: "RO.04.24427", name: "Comuna Plopana" },
    { code: "RO.04.24524", name: "Comuna Podu Turcului" },
    { code: "RO.04.24631", name: "Comuna Poduri" },
    { code: "RO.04.24711", name: "Comuna Racova" },
    { code: "RO.04.24766", name: "Comuna Răcăciuni" },
    { code: "RO.04.24837", name: "Comuna Răchitoasa" },
    { code: "RO.04.24999", name: "Comuna Roşiori" },
    { code: "RO.04.25068", name: "Comuna Sascut" },
    { code: "RO.04.25148", name: "Comuna Sănduleni" },
    { code: "RO.04.25228", name: "Comuna Săuceşti" },
    { code: "RO.04.25291", name: "Comuna Scorţeni" },
    { code: "RO.04.25362", name: "Comuna Secuieni" },
    { code: "RO.04.25488", name: "Comuna Solonţ" },
    { code: "RO.04.25521", name: "Comuna Stănişeşti" },
    { code: "RO.04.25629", name: "Comuna Strugari" },
    { code: "RO.04.25692", name: "Comuna Tamaşi" },
    { code: "RO.04.25745", name: "Comuna Tătărăşti" },
    { code: "RO.04.25825", name: "Comuna Târgu Trotuş" },
    { code: "RO.04.25861", name: "Comuna Traian" },
    { code: "RO.04.25932", name: "Comuna Ungureni" },
    { code: "RO.04.26029", name: "Comuna Urecheşti" },
    { code: "RO.04.26083", name: "Comuna Valea Seacă" },
    { code: "RO.04.26118", name: "Comuna Vultureni" },
    { code: "RO.04.26289", name: "Comuna Zemeş" },
    { code: "RO.04.26320", name: "Comuna Sărata" },
    { code: "RO.04.26338", name: "Comuna Buciumi" },
    { code: "RO.04.26346", name: "Comuna Gioseni" },
    { code: "RO.04.26353", name: "Comuna Odobeşti" },
    { code: "RO.04.26361", name: "Comuna Prăjeşti" },
    { code: "RO.04.26379", name: "Comuna Iteşti" },
  ],
  "RO.05": [
    { code: "RO.05.26564", name: "Municipiul Oradea" },
    { code: "RO.05.26582", name: "Comuna Sânmartin" },
    { code: "RO.05.26653", name: "Comuna Sântandrei" },
    { code: "RO.05.26699", name: "Oraș Aleşd" },
    { code: "RO.05.26742", name: "Comuna Aştileu" },
    { code: "RO.05.26804", name: "Municipiul Beiuş" },
    { code: "RO.05.26840", name: "Oraş Ştei" },
    { code: "RO.05.26877", name: "Municipiul Marghita" },
    { code: "RO.05.26920", name: "Oraş Nucet" },
    { code: "RO.05.26975", name: "Municipiul Salonta" },
    { code: "RO.05.27007", name: "Oraş Vaşcãu" },
    { code: "RO.05.27070", name: "Comuna Abram" },
    { code: "RO.05.27169", name: "Comuna Abrămuţ" },
    { code: "RO.05.27212", name: "Comuna Auşeu" },
    { code: "RO.05.27285", name: "Comuna Avram Iancu" },
    { code: "RO.05.27329", name: "Comuna Balc" },
    { code: "RO.05.27383", name: "Comuna Batăr" },
    { code: "RO.05.27436", name: "Comuna Biharia" },
    { code: "RO.05.27506", name: "Comuna Boianu Mare" },
    { code: "RO.05.27560", name: "Comuna Borod" },
    { code: "RO.05.27631", name: "Comuna Borş" },
    { code: "RO.05.27686", name: "Comuna Bratca" },
    { code: "RO.05.27757", name: "Comuna Brusturi" },
    { code: "RO.05.27846", name: "Comuna Budureasa" },
    { code: "RO.05.27908", name: "Comuna Buduslău" },
    { code: "RO.05.27935", name: "Comuna Bulz" },
    { code: "RO.05.27971", name: "Comuna Bunteşti" },
    { code: "RO.05.28077", name: "Comuna Căbeşti" },
    { code: "RO.05.28139", name: "Comuna Cãpâlna" },
    { code: "RO.05.28193", name: "Comuna Cărpinet" },
    { code: "RO.05.28246", name: "Comuna Cefa" },
    { code: "RO.05.28335", name: "Comuna Ceica" },
    { code: "RO.05.28415", name: "Comuna Cetariu" },
    { code: "RO.05.28497", name: "Comuna Cherechiu" },
    { code: "RO.05.28530", name: "Comuna Chişlaz" },
    { code: "RO.05.28610", name: "Comuna Sâniob" },
    { code: "RO.05.28665", name: "Comuna Ciumeghiu" },
    { code: "RO.05.28709", name: "Comuna Câmpani" },
    { code: "RO.05.28763", name: "Comuna Cociuba Mare" },
    { code: "RO.05.28816", name: "Comuna Copăcel" },
    { code: "RO.05.28889", name: "Comuna Criștioru de Jos" },
    { code: "RO.05.28941", name: "Comuna Curăţele" },
    { code: "RO.05.29001", name: "Comuna Curtuişeni" },
    { code: "RO.05.29038", name: "Comuna Derna" },
    { code: "RO.05.29092", name: "Comuna Diosig" },
    { code: "RO.05.29154", name: "Comuna Dobreşti" },
    { code: "RO.05.29243", name: "Comuna Drăgăneşti" },
    { code: "RO.05.29341", name: "Comuna Drăgeşti" },
    { code: "RO.05.29403", name: "Comuna Finiş" },
    { code: "RO.05.29467", name: "Comuna Girişu de Criş" },
    { code: "RO.05.29519", name: "Comuna Hidişelu De Sus" },
    { code: "RO.05.29573", name: "Comuna Holod" },
    { code: "RO.05.29662", name: "Comuna Husasău de Tinca" },
    { code: "RO.05.29724", name: "Comuna Ineu" },
    { code: "RO.05.29760", name: "Comuna Lazuri de Beiuş" },
    { code: "RO.05.29813", name: "Comuna Lăzăreni" },
    { code: "RO.05.29902", name: "Comuna Lugaşu De Jos" },
    { code: "RO.05.29948", name: "Comuna Lunca" },
    { code: "RO.05.30014", name: "Comuna Mădăraş" },
    { code: "RO.05.30069", name: "Comuna Măgeşti" },
    { code: "RO.05.30149", name: "Comuna Nojorid" },
    { code: "RO.05.30229", name: "Comuna Olcea" },
    { code: "RO.05.30274", name: "Comuna Oşorhei" },
    { code: "RO.05.30336", name: "Comuna Pietroasa" },
    { code: "RO.05.30416", name: "Comuna Pocola" },
    { code: "RO.05.30470", name: "Comuna Pomezeu" },
    { code: "RO.05.30568", name: "Comuna Popeşti" },
    { code: "RO.05.30648", name: "Comuna Răbăgani" },
    { code: "RO.05.30719", name: "Comuna Remetea" },
    { code: "RO.05.30773", name: "Comuna Rieni" },
    { code: "RO.05.30844", name: "Comuna Roşia" },
    { code: "RO.05.30871", name: "Comuna Săcădat" },
    { code: "RO.05.30915", name: "Oraş Sãcueni" },
    { code: "RO.05.30988", name: "Comuna Sălacea" },
    { code: "RO.05.31011", name: "Comuna Sălard" },
    { code: "RO.05.31057", name: "Comuna Sâmbăta" },
    { code: "RO.05.31128", name: "Comuna Sârbi" },
    { code: "RO.05.31208", name: "Comuna Spinuş" },
    { code: "RO.05.31262", name: "Comuna Suplacu de Barcău" },
    { code: "RO.05.31333", name: "Comuna Şimian" },
    { code: "RO.05.31379", name: "Comuna Şinteu" },
    { code: "RO.05.31422", name: "Comuna Şoimi" },
    { code: "RO.05.31510", name: "Comuna Şuncuiuş" },
    { code: "RO.05.31565", name: "Comuna Tarcea" },
    { code: "RO.05.31609", name: "Comuna Tărcaia" },
    { code: "RO.05.31654", name: "Comuna Tăuteu" },
    { code: "RO.05.31716", name: "Comuna Tileagd" },
    { code: "RO.05.31789", name: "Comuna Tinca" },
    { code: "RO.05.31841", name: "Comuna Tulca" },
    { code: "RO.05.31878", name: "Comuna Ţeţchea" },
    { code: "RO.05.31921", name: "Comuna Uileacu de Beiuş" },
    { code: "RO.05.31976", name: "Comuna Vadu Crişului" },
    { code: "RO.05.32027", name: "Oraş Valea Lui Mihai" },
    { code: "RO.05.32045", name: "Comuna Viişoara" },
    { code: "RO.05.32090", name: "Comuna Vârciorog" },
    { code: "RO.05.32153", name: "Comuna Tãmãşeu" },
    { code: "RO.05.32161", name: "Comuna Paleu" },
    { code: "RO.05.32179", name: "Comuna Sânnicolau-Român" },
    { code: "RO.05.32187", name: "Comuna Roşiori" },
    { code: "RO.05.32195", name: "Comuna Gepiu" },
    { code: "RO.05.32201", name: "Comuna Toboliu" },
  ],
  "RO.06": [
    { code: "RO.06.179659", name: "Comuna Negrileşti" },
    { code: "RO.06.179686", name: "Comuna Dumitriţa" },
    { code: "RO.06.179720", name: "Comuna Poiana  Ilvei" },
    { code: "RO.06.179944", name: "Comuna Runcu Salvei" },
    { code: "RO.06.179953", name: "Comuna Ciceu-Mihăieşti" },
    { code: "RO.06.32394", name: "Municipiul Bistriţa" },
    { code: "RO.06.32483", name: "Oraş Beclean" },
    { code: "RO.06.32544", name: "Oraş Nãsãud" },
    { code: "RO.06.32599", name: "Oraş Sângeorz-Bãi" },
    { code: "RO.06.32633", name: "Comuna Bistriţa Bârgăului" },
    { code: "RO.06.32660", name: "Comuna Braniştea" },
    { code: "RO.06.32704", name: "Comuna Budacu de Jos" },
    { code: "RO.06.32768", name: "Comuna Budeşti" },
    { code: "RO.06.32811", name: "Comuna Căianu" },
    { code: "RO.06.32884", name: "Comuna Războeni-Cetate" },
    { code: "RO.06.32955", name: "Comuna Ciceu-Giurgeşti" },
    { code: "RO.06.33015", name: "Comuna Chiochiş" },
    { code: "RO.06.33122", name: "Comuna Chiuza" },
    { code: "RO.06.33177", name: "Comuna Coşbuc" },
    { code: "RO.06.33202", name: "Comuna Dumitra" },
    { code: "RO.06.33248", name: "Comuna Feldru" },
    { code: "RO.06.33275", name: "Comuna Galaţii Bistriţei" },
    { code: "RO.06.33337", name: "Comuna Ilva Mare" },
    { code: "RO.06.33364", name: "Comuna Ilva Mică" },
    { code: "RO.06.33382", name: "Comuna Josenii Bârgăului" },
    { code: "RO.06.33435", name: "Comuna Lechinţa" },
    { code: "RO.06.33514", name: "Comuna Leşu" },
    { code: "RO.06.33541", name: "Comuna Livezile" },
    { code: "RO.06.33603", name: "Comuna Lunca Ilvei" },
    { code: "RO.06.33621", name: "Comuna Măieru" },
    { code: "RO.06.33658", name: "Comuna Matei" },
    { code: "RO.06.33729", name: "Comuna Măgura Ilvei" },
    { code: "RO.06.33765", name: "Comuna Mărişelu" },
    { code: "RO.06.33845", name: "Comuna Miceştii de Câmpie" },
    { code: "RO.06.33881", name: "Comuna Milas" },
    { code: "RO.06.33952", name: "Comuna Monor" },
    { code: "RO.06.33989", name: "Comuna Nimigea" },
    { code: "RO.06.34075", name: "Comuna Nuşeni" },
    { code: "RO.06.34155", name: "Comuna Parva" },
    { code: "RO.06.34173", name: "Comuna Petru Rareş" },
    { code: "RO.06.34235", name: "Comuna Prundu Bârgăului" },
    { code: "RO.06.34262", name: "Comuna Rebra" },
    { code: "RO.06.34280", name: "Comuna Rebrişoara" },
    { code: "RO.06.34333", name: "Comuna Rodna" },
    { code: "RO.06.34360", name: "Comuna Romuli" },
    { code: "RO.06.34397", name: "Comuna Salva" },
    { code: "RO.06.34422", name: "Comuna Silivaşu De Câmpie" },
    { code: "RO.06.34477", name: "Comuna Sânmihaiu de Câmpie" },
    { code: "RO.06.34547", name: "Comuna Spermezeu" },
    { code: "RO.06.34618", name: "Comuna Şanţ" },
    { code: "RO.06.34645", name: "Comuna Şieu" },
    { code: "RO.06.34690", name: "Comuna Şieu-Măgheruş" },
    { code: "RO.06.34770", name: "Comuna Şieu-Odorhei" },
    { code: "RO.06.34850", name: "Comuna Şieuţ" },
    { code: "RO.06.34903", name: "Comuna Şintereag" },
    { code: "RO.06.34985", name: "Comuna Teaca" },
    { code: "RO.06.35054", name: "Comuna Telciu" },
    { code: "RO.06.35090", name: "Comuna Tiha Bârgăului" },
    { code: "RO.06.35152", name: "Comuna Târlişua" },
    { code: "RO.06.35269", name: "Comuna Uriu" },
    { code: "RO.06.35312", name: "Comuna Urmeniş" },
    { code: "RO.06.35429", name: "Comuna Zagra" },
  ],
  "RO.07": [
    { code: "RO.07.35731", name: "Municipiul Botoşani" },
    { code: "RO.07.35759", name: "Comuna Curteşti" },
    { code: "RO.07.35839", name: "Comuna Răchiţi" },
    { code: "RO.07.35884", name: "Comuna Stăuceni" },
    { code: "RO.07.35946", name: "Oraş Darabani" },
    { code: "RO.07.36006", name: "Municipiul Dorohoi" },
    { code: "RO.07.36060", name: "Oraş Sãveni" },
    { code: "RO.07.36131", name: "Comuna Albeşti" },
    { code: "RO.07.36202", name: "Comuna Avrămeni" },
    { code: "RO.07.36300", name: "Comuna Băluşeni" },
    { code: "RO.07.36373", name: "Comuna Brăeşti" },
    { code: "RO.07.36426", name: "Comuna Broscăuţi" },
    { code: "RO.07.36453", name: "Oraş Bucecea" },
    { code: "RO.07.36499", name: "Comuna Călăraşi" },
    { code: "RO.07.36532", name: "Comuna Conceşti" },
    { code: "RO.07.36569", name: "Comuna Copălău" },
    { code: "RO.07.36649", name: "Comună Cordăreni" },
    { code: "RO.07.36676", name: "Comuna Corlăteni" },
    { code: "RO.07.36756", name: "Comuna Corni" },
    { code: "RO.07.36809", name: "Comuna Coţuşca" },
    { code: "RO.07.36907", name: "Comuna Cristeşti" },
    { code: "RO.07.36952", name: "Comuna Cristineşti" },
    { code: "RO.07.37011", name: "Comuna Dersca" },
    { code: "RO.07.37057", name: "Comuna Dângeni" },
    { code: "RO.07.37100", name: "Comuna Dobârceni" },
    { code: "RO.07.37173", name: "Comuna Drăguşeni" },
    { code: "RO.07.37217", name: "Comuna Durneşti" },
    { code: "RO.07.37280", name: "Oraş Flãmânzi" },
    { code: "RO.07.37324", name: "Comuna Frumuşica" },
    { code: "RO.07.37397", name: "Comuna George Enescu" },
    { code: "RO.07.37459", name: "Comuna Gorbăneşti" },
    { code: "RO.07.37547", name: "Comuna Havârna" },
    { code: "RO.07.37618", name: "Comuna Hăneşti" },
    { code: "RO.07.37672", name: "Comuna Hilişeu-Horia" },
    { code: "RO.07.37734", name: "Comuna Hlipiceni" },
    { code: "RO.07.37770", name: "Comuna Hudeşti" },
    { code: "RO.07.37823", name: "Comuna Ibăneşti" },
    { code: "RO.07.37850", name: "Comuna Leorda" },
    { code: "RO.07.37912", name: "Comuna Lunca" },
    { code: "RO.07.37958", name: "Comuna Manoleasa" },
    { code: "RO.07.38063", name: "Comuna Mihai Eminescu" },
    { code: "RO.07.38161", name: "Comuna Mihăileni" },
    { code: "RO.07.38241", name: "Comuna Mihălăşeni" },
    { code: "RO.07.38321", name: "Comuna Mileanca" },
    { code: "RO.07.38376", name: "Comuna Mitoc" },
    { code: "RO.07.38456", name: "Comuna Nicşeni" },
    { code: "RO.07.38492", name: "Comuna Păltiniş" },
    { code: "RO.07.38544", name: "Comuna Pomârla" },
    { code: "RO.07.38580", name: "Comuna Prăjeni" },
    { code: "RO.07.38633", name: "Comuna Rãdãuţi-Prut" },
    { code: "RO.07.38679", name: "Comuna Răuseni" },
    { code: "RO.07.38731", name: "Comuna Ripiceni" },
    { code: "RO.07.38811", name: "Comuna Roma" },
    { code: "RO.07.38848", name: "Comuna Româneşti" },
    { code: "RO.07.38893", name: "Comuna Santa Mare" },
    { code: "RO.07.38982", name: "Comuna Suharău" },
    { code: "RO.07.39051", name: "Comuna Suliţa" },
    { code: "RO.07.39122", name: "Comuna Şendriceni" },
    { code: "RO.07.39168", name: "Oraş Ştefãneşti" },
    { code: "RO.07.39220", name: "Comuna Ştiubieni" },
    { code: "RO.07.39266", name: "Comuna Todireni" },
    { code: "RO.07.39328", name: "Comuna Truşeşti" },
    { code: "RO.07.39391", name: "Comuna Tudora" },
    { code: "RO.07.39417", name: "Comuna Ungureni" },
    { code: "RO.07.39532", name: "Comuna Unţeni" },
    { code: "RO.07.39612", name: "Comuna Văculeşti" },
    { code: "RO.07.39658", name: "Comuna Viişoara" },
    { code: "RO.07.39694", name: "Comuna Vârfu Câmpului" },
    { code: "RO.07.39738", name: "Comuna Vlădeni" },
    { code: "RO.07.39792", name: "Comuna Vlăsineşti" },
    { code: "RO.07.39836", name: "Comuna Vorniceni" },
    { code: "RO.07.39872", name: "Comuna Vorona" },
    { code: "RO.07.39942", name: "Comuna Lozna" },
    { code: "RO.07.39959", name: "Comuna Dimăcheni" },
    { code: "RO.07.39967", name: "Comuna Cândeşti" },
    { code: "RO.07.39975", name: "Comuna Coşula" },
    { code: "RO.07.39983", name: "Comuna Blândeşti" },
    { code: "RO.07.40035", name: "Comuna Adăşeni" },
  ],
  "RO.08": [
    { code: "RO.08.42682", name: "Municipiul Brãila" },
    { code: "RO.08.42708", name: "Comuna Chiscani" },
    { code: "RO.08.42753", name: "Oraş Fãurei" },
    { code: "RO.08.42771", name: "Comuna Surdila-Greci" },
    { code: "RO.08.42824", name: "Comuna Bărăganul" },
    { code: "RO.08.42842", name: "Comuna Berteştii de Jos" },
    { code: "RO.08.42913", name: "Comuna Bordei Verde" },
    { code: "RO.08.42968", name: "Comuna Ciocile" },
    { code: "RO.08.43019", name: "Comuna Cireşu" },
    { code: "RO.08.43073", name: "Comuna Dudeşti" },
    { code: "RO.08.43117", name: "Comuna Frecãţei" },
    { code: "RO.08.43180", name: "Comuna Galbenu" },
    { code: "RO.08.43242", name: "Comuna Gemenele" },
    { code: "RO.08.43279", name: "Comuna Grădiştea" },
    { code: "RO.08.43313", name: "Comuna Gropeni" },
    { code: "RO.08.43331", name: "Oraş Ianca" },
    { code: "RO.08.43411", name: "Oraş Însurãţei" },
    { code: "RO.08.43466", name: "Comuna Jirlău" },
    { code: "RO.08.43493", name: "Comuna Măraşu" },
    { code: "RO.08.43563", name: "Comuna Măxineni" },
    { code: "RO.08.43625", name: "Comuna Mircea Vodă" },
    { code: "RO.08.43652", name: "Comuna Movila Miresii" },
    { code: "RO.08.43698", name: "Comuna Racoviţa" },
    { code: "RO.08.43732", name: "Comuna Râmnicelu" },
    { code: "RO.08.43787", name: "Comuna Romanu" },
    { code: "RO.08.43812", name: "Comuna Roşiori" },
    { code: "RO.08.43867", name: "Comuna Salcia Tudor" },
    { code: "RO.08.43929", name: "Comuna Scorţaru Nou" },
    { code: "RO.08.43992", name: "Comuna Siliştea" },
    { code: "RO.08.44060", name: "Comuna Stăncuţa" },
    { code: "RO.08.44113", name: "Comuna Surdila-Găiseanca" },
    { code: "RO.08.44140", name: "Comuna Şuţeşti" },
    { code: "RO.08.44177", name: "Comuna Tichileşti" },
    { code: "RO.08.44202", name: "Comuna Traian" },
    { code: "RO.08.44257", name: "Comuna Tudor Vladimirescu" },
    { code: "RO.08.44300", name: "Comuna Tufeşti" },
    { code: "RO.08.44328", name: "Comuna Ulmu" },
    { code: "RO.08.44355", name: "Comuna Unirea" },
    { code: "RO.08.44391", name: "Comuna Vădeni" },
    { code: "RO.08.44435", name: "Comuna Victoria" },
    { code: "RO.08.44462", name: "Comuna Vişani" },
    { code: "RO.08.44505", name: "Comuna Viziru" },
    { code: "RO.08.44532", name: "Comuna Zăvoaia" },
    { code: "RO.08.44560", name: "Comuna Cazasu" },
  ],
  "RO.09": [
    { code: "RO.09.40198", name: "Municipiul Braşov" },
    { code: "RO.09.40214", name: "Oraş Ghimbav" },
    { code: "RO.09.40241", name: "Municipiul  Codlea" },
    { code: "RO.09.40278", name: "Municipiul Fãgãraş" },
    { code: "RO.09.40303", name: "Oraş Predeal" },
    { code: "RO.09.40367", name: "Oraş Râşnov" },
    { code: "RO.09.40394", name: "Oraş Rupea" },
    { code: "RO.09.40438", name: "Municipiul Sãcele" },
    { code: "RO.09.40465", name: "Oraş Victoria" },
    { code: "RO.09.40492", name: "Oraş Zãrneşti" },
    { code: "RO.09.40526", name: "Comuna Apaţa" },
    { code: "RO.09.40544", name: "Comuna Beclean" },
    { code: "RO.09.40606", name: "Comuna Bod" },
    { code: "RO.09.40633", name: "Comuna Bran" },
    { code: "RO.09.40688", name: "Comuna Budila" },
    { code: "RO.09.40704", name: "Comuna Buneşti" },
    { code: "RO.09.40768", name: "Comuna Caţa" },
    { code: "RO.09.40820", name: "Comuna Cincu" },
    { code: "RO.09.40857", name: "Comuna Comana" },
    { code: "RO.09.40900", name: "Comuna Cristian" },
    { code: "RO.09.40928", name: "Comuna Dumbrăviţa" },
    { code: "RO.09.40955", name: "Comuna Feldioara" },
    { code: "RO.09.40991", name: "Comuna Fundata" },
    { code: "RO.09.41033", name: "Comuna Hălchiu" },
    { code: "RO.09.41088", name: "Comuna Hărman" },
    { code: "RO.09.41113", name: "Comuna Hârşeni" },
    { code: "RO.09.41177", name: "Comuna Hoghiz" },
    { code: "RO.09.41248", name: "Comuna Homorod" },
    { code: "RO.09.41284", name: "Comuna Jibert" },
    { code: "RO.09.41346", name: "Comuna Lisa" },
    { code: "RO.09.41382", name: "Comuna Mãieruş" },
    { code: "RO.09.41417", name: "Comuna Mândra" },
    { code: "RO.09.41471", name: "Comuna Moieciu" },
    { code: "RO.09.41541", name: "Comuna Ormeniş" },
    { code: "RO.09.41578", name: "Comuna Pârâu" },
    { code: "RO.09.41621", name: "Comuna Poiana Mărului (Brașov)" },
    { code: "RO.09.41667", name: "Comuna Prejmer" },
    { code: "RO.09.41701", name: "Comuna Racoş" },
    { code: "RO.09.41738", name: "Comuna Recea" },
    { code: "RO.09.41818", name: "Comuna Şercaia" },
    { code: "RO.09.41854", name: "Comuna Şinca Veche" },
    { code: "RO.09.41925", name: "Comuna Sânpetru" },
    { code: "RO.09.41943", name: "Comuna Şoarş" },
    { code: "RO.09.42003", name: "Comuna Tărlungeni" },
    { code: "RO.09.42058", name: "Comuna Teliu" },
    { code: "RO.09.42076", name: "Comuna Ticuşu Vechi" },
    { code: "RO.09.42101", name: "Comuna Ucea de Jos" },
    { code: "RO.09.42156", name: "Comuna Ungra" },
    { code: "RO.09.42183", name: "Comuna Vama Buzăului" },
    { code: "RO.09.42236", name: "Comuna Viştea de Jos" },
    { code: "RO.09.42307", name: "Comuna Voila" },
    { code: "RO.09.42398", name: "Comuna Vulcan" },
    { code: "RO.09.42449", name: "Comuna Şinca Nouă" },
    { code: "RO.09.42456", name: "Comuna Crizbav" },
    { code: "RO.09.42464", name: "Comuna Sâmbăta de Sus" },
    { code: "RO.09.42472", name: "Comuna Holbav" },
    { code: "RO.09.42480", name: "Comuna Drăguş" },
    { code: "RO.09.42498", name: "Comuna Augustin" },
  ],
  "RO.10": [
    { code: "RO.10.179132", name: "Municipiul Bucureşti" },
  ],
  "RO.11": [
    { code: "RO.11.44818", name: "Municipiul Buzău" },
    { code: "RO.11.44845", name: "Municipiul Râmnicu Sãrat" },
    { code: "RO.11.44863", name: "Comuna Amaru" },
    { code: "RO.11.44934", name: "Comuna Balta Albă" },
    { code: "RO.11.44989", name: "Comuna Bălăceanu" },
    { code: "RO.11.45003", name: "Comuna Beceni" },
    { code: "RO.11.45101", name: "Comuna Berca" },
    { code: "RO.11.45245", name: "Comuna Bisoca" },
    { code: "RO.11.45334", name: "Comuna Blăjani" },
    { code: "RO.11.45361", name: "Comuna Boldu" },
    { code: "RO.11.45389", name: "Comuna Bozioru" },
    { code: "RO.11.45496", name: "Comuna Brădeanu" },
    { code: "RO.11.45539", name: "Comuna Brăeşti" },
    { code: "RO.11.45619", name: "Comuna Breaza" },
    { code: "RO.11.45673", name: "Comuna Buda" },
    { code: "RO.11.45753", name: "Comuna Calvini" },
    { code: "RO.11.45815", name: "Comuna C.A. Rosetti" },
    { code: "RO.11.45888", name: "Comuna Căneşti" },
    { code: "RO.11.45959", name: "Comuna Cătina" },
    { code: "RO.11.46019", name: "Comuna Cernăteşti" },
    { code: "RO.11.46108", name: "Comuna Chiliile" },
    { code: "RO.11.46180", name: "Comuna Chiojdu" },
    { code: "RO.11.46251", name: "Comuna Cilibia" },
    { code: "RO.11.46313", name: "Comuna Cislău" },
    { code: "RO.11.46377", name: "Comuna Cochirleanca" },
    { code: "RO.11.46439", name: "Comuna Colţi" },
    { code: "RO.11.46484", name: "Comuna Costeşti" },
    { code: "RO.11.46554", name: "Comuna Cozieni" },
    { code: "RO.11.46769", name: "Comuna Gălbinaşi" },
    { code: "RO.11.46803", name: "Comuna Gherăseni" },
    { code: "RO.11.46830", name: "Comuna Ghergheasa" },
    { code: "RO.11.46867", name: "Comuna Glodeanu-Sărat" },
    { code: "RO.11.46910", name: "Comuna Glodeanu-Siliştea" },
    { code: "RO.11.47006", name: "Comuna Greabănu" },
    { code: "RO.11.47079", name: "Comuna Gura Teghii" },
    { code: "RO.11.47159", name: "Comuna Largu" },
    { code: "RO.11.47186", name: "Comuna Lopătari" },
    { code: "RO.11.47300", name: "Comuna Luciu" },
    { code: "RO.11.47337", name: "Comuna Măgura" },
    { code: "RO.11.47373", name: "Comuna Mărăcineni" },
    { code: "RO.11.47417", name: "Comuna Mărgăriteşti" },
    { code: "RO.11.47453", name: "Comuna Merei" },
    { code: "RO.11.47578", name: "Comuna Mihăileşti" },
    { code: "RO.11.47630", name: "Comuna Mânzăleşti" },
    { code: "RO.11.47774", name: "Comuna Movila Banului" },
    { code: "RO.11.47818", name: "Comuna Murgeşti" },
    { code: "RO.11.47854", name: "Comuna Năeni" },
    { code: "RO.11.47916", name: "Oraş Nehoiu" },
    { code: "RO.11.48021", name: "Comuna Odăile" },
    { code: "RO.11.48138", name: "Comuna Padina" },
    { code: "RO.11.48165", name: "Comuna Pardoşi" },
    { code: "RO.11.48227", name: "Comuna Pănătău" },
    { code: "RO.11.48325", name: "Oraş Pãtârlagele" },
    { code: "RO.11.48487", name: "Comuna Pietroasele" },
    { code: "RO.11.48557", name: "Comuna Pârscov" },
    { code: "RO.11.48682", name: "Comuna Podgoria" },
    { code: "RO.11.48744", name: "Oraş Pogoanele" },
    { code: "RO.11.48771", name: "Comuna Poşta Câlnãu" },
    { code: "RO.11.48842", name: "Comuna Puieşti" },
    { code: "RO.11.48922", name: "Comuna Racoviţeni" },
    { code: "RO.11.48968", name: "Comuna Râmnicelu" },
    { code: "RO.11.49019", name: "Comuna Robeasca" },
    { code: "RO.11.49046", name: "Comuna Ruşeţu" },
    { code: "RO.11.49073", name: "Comuna Săgeata" },
    { code: "RO.11.49153", name: "Comuna Săhăteni" },
    { code: "RO.11.49206", name: "Comuna Săpoca" },
    { code: "RO.11.49233", name: "Comuna Săruleşti" },
    { code: "RO.11.49313", name: "Comuna Scorţoasa" },
    { code: "RO.11.49439", name: "Comuna Scutelnici" },
    { code: "RO.11.49484", name: "Comuna Siriu" },
    { code: "RO.11.49545", name: "Comuna Smeeni" },
    { code: "RO.11.49625", name: "Comuna Stâlpu" },
    { code: "RO.11.49643", name: "Comuna Tisãu" },
    { code: "RO.11.49769", name: "Comuna Topliceni" },
    { code: "RO.11.49849", name: "Comuna Ţinteşti" },
    { code: "RO.11.49894", name: "Comuna Ulmeni" },
    { code: "RO.11.49956", name: "Comuna Vadu Paşii" },
    { code: "RO.11.50022", name: "Comuna Valea Râmnicului" },
    { code: "RO.11.50068", name: "Comuna Valea Sălciei" },
    { code: "RO.11.50102", name: "Comuna Verneşti" },
    { code: "RO.11.50228", name: "Comuna Vintilă Vodă" },
    { code: "RO.11.50326", name: "Comuna Vipereşti" },
    { code: "RO.11.50399", name: "Comuna Vâlcelele" },
    { code: "RO.11.50415", name: "Comuna Zărneşti" },
    { code: "RO.11.50479", name: "Comuna Ziduri" },
    { code: "RO.11.50549", name: "Comuna Unguriu" },
    { code: "RO.11.50564", name: "Comuna Florica" },
  ],
  "RO.12": [
    { code: "RO.12.50790", name: "Municipiul Reşiţa" },
    { code: "RO.12.50889", name: "Oraş Anina" },
    { code: "RO.12.50923", name: "Oraş Bãile Herculane" },
    { code: "RO.12.50969", name: "Oraş Bocşa" },
    { code: "RO.12.50987", name: "Comuna Ocna De Fier" },
    { code: "RO.12.51010", name: "Municipiul Caransebeş" },
    { code: "RO.12.51056", name: "Oraş Moldova Nouã" },
    { code: "RO.12.51118", name: "Oraş Oraviţa" },
    { code: "RO.12.51207", name: "Oraş Oţelu Roşu" },
    { code: "RO.12.51243", name: "Comuna Armeniş" },
    { code: "RO.12.51305", name: "Comuna Bănia" },
    { code: "RO.12.51332", name: "Comuna Băuţar" },
    { code: "RO.12.51387", name: "Comuna Berlişte" },
    { code: "RO.12.51449", name: "Comuna Berzasca" },
    { code: "RO.12.51500", name: "Comuna Berzovia" },
    { code: "RO.12.51546", name: "Comuna Bolvaşniţa" },
    { code: "RO.12.51573", name: "Comuna Bozovici" },
    { code: "RO.12.51626", name: "Comuna Brebu" },
    { code: "RO.12.51662", name: "Comuna Brebu Nou" },
    { code: "RO.12.51699", name: "Comuna Buchin" },
    { code: "RO.12.51751", name: "Comuna Bucoşniţa" },
    { code: "RO.12.51804", name: "Comuna Caraşova" },
    { code: "RO.12.51840", name: "Comuna Cărbunari" },
    { code: "RO.12.51877", name: "Comuna Constantin Daicoviciu" },
    { code: "RO.12.51948", name: "Comuna Ciclova Română" },
    { code: "RO.12.51984", name: "Comuna Ciuchici" },
    { code: "RO.12.52035", name: "Comuna Ciudanoviţa" },
    { code: "RO.12.52062", name: "Comuna Copăcele" },
    { code: "RO.12.52115", name: "Comuna Cornea" },
    { code: "RO.12.52160", name: "Comuna Cornereva" },
    { code: "RO.12.52570", name: "Comuna Dalboşeţ" },
    { code: "RO.12.52650", name: "Comuna Doclin" },
    { code: "RO.12.52696", name: "Comuna Dognecea" },
    { code: "RO.12.52721", name: "Comuna Domaşnea" },
    { code: "RO.12.52758", name: "Comuna Ezeriş" },
    { code: "RO.12.52785", name: "Comuna Fârliug" },
    { code: "RO.12.52856", name: "Comuna Forotic" },
    { code: "RO.12.52909", name: "Comuna Gârnic" },
    { code: "RO.12.52936", name: "Comuna Glimboca" },
    { code: "RO.12.52954", name: "Comuna Goruia" },
    { code: "RO.12.52990", name: "Comuna Grădinari" },
    { code: "RO.12.53023", name: "Comuna Iablaniţa" },
    { code: "RO.12.53069", name: "Comuna Lăpuşnicel" },
    { code: "RO.12.53103", name: "Comuna Lăpuşnicu Mare" },
    { code: "RO.12.53130", name: "Comuna Luncaviţa" },
    { code: "RO.12.53167", name: "Comuna Lupac" },
    { code: "RO.12.53210", name: "Comuna Marga" },
    { code: "RO.12.53247", name: "Comuna Măureni" },
    { code: "RO.12.53274", name: "Comuna Mehadia" },
    { code: "RO.12.53327", name: "Comuna Mehadica" },
    { code: "RO.12.53345", name: "Comuna Naidaş" },
    { code: "RO.12.53372", name: "Comuna Obreja" },
    { code: "RO.12.53425", name: "Comuna Pãltiniş" },
    { code: "RO.12.53489", name: "Comuna Pescari" },
    { code: "RO.12.53513", name: "Comuna Pojejena" },
    { code: "RO.12.53577", name: "Comuna Prigor" },
    { code: "RO.12.53639", name: "Comuna Ramna" },
    { code: "RO.12.53675", name: "Comuna Răcăşdia" },
    { code: "RO.12.53700", name: "Comuna Eftimie Murgu" },
    { code: "RO.12.53728", name: "Comuna Rusca Montană" },
    { code: "RO.12.53755", name: "Comuna Sacu" },
    { code: "RO.12.53791", name: "Comuna Sasca Montană" },
    { code: "RO.12.53853", name: "Comuna Sicheviţa" },
    { code: "RO.12.54056", name: "Comuna Slatina-Timiş" },
    { code: "RO.12.54109", name: "Comuna Socol" },
    { code: "RO.12.54163", name: "Comuna Şopotu Nou" },
    { code: "RO.12.54270", name: "Comuna Teregova" },
    { code: "RO.12.54305", name: "Comuna Ticvaniu Mare" },
    { code: "RO.12.54350", name: "Comuna Târnova" },
    { code: "RO.12.54387", name: "Comuna Topleţ" },
    { code: "RO.12.54412", name: "Comuna Turnu Rueni" },
    { code: "RO.12.54485", name: "Comuna Văliug" },
    { code: "RO.12.54500", name: "Comuna Vărădia" },
    { code: "RO.12.54537", name: "Comuna Vermeş" },
    { code: "RO.12.54573", name: "Comuna Vrani" },
    { code: "RO.12.54617", name: "Comuna Zăvoi" },
    { code: "RO.12.54699", name: "Comuna Zorlenţu Mare" },
  ],
  "RO.13": [
    { code: "RO.13.54975", name: "Municipiul Cluj-Napoca" },
    { code: "RO.13.55008", name: "Municipiul Dej" },
    { code: "RO.13.55062", name: "Comuna Cuzdrioara" },
    { code: "RO.13.55106", name: "Comuna Jichişu De Jos" },
    { code: "RO.13.55160", name: "Comuna Mica" },
    { code: "RO.13.55259", name: "Municipiul Turda" },
    { code: "RO.13.55277", name: "Comuna Mihai Viteazu" },
    { code: "RO.13.55311", name: "Comuna Sănduleşti" },
    { code: "RO.13.55357", name: "Municipiul Câmpia Turzii" },
    { code: "RO.13.55384", name: "Municipiul Gherla" },
    { code: "RO.13.55446", name: "Oraş Huedin" },
    { code: "RO.13.55473", name: "Comuna Aghireşu" },
    { code: "RO.13.55598", name: "Comuna Aiton" },
    { code: "RO.13.55623", name: "Comuna Aluniş" },
    { code: "RO.13.55687", name: "Comuna Apahida" },
    { code: "RO.13.55776", name: "Comuna Aşchileu" },
    { code: "RO.13.55838", name: "Comuna Baciu" },
    { code: "RO.13.55918", name: "Comuna Băişoara" },
    { code: "RO.13.56014", name: "Comuna Beliş" },
    { code: "RO.13.56096", name: "Comuna Bobâlna" },
    { code: "RO.13.56210", name: "Comuna Bonţida" },
    { code: "RO.13.56265", name: "Comuna Borşa" },
    { code: "RO.13.56327", name: "Comuna Buza" },
    { code: "RO.13.56354", name: "Comuna Căianu" },
    { code: "RO.13.56425", name: "Comuna Călăraşi" },
    { code: "RO.13.56461", name: "Comuna Călăţele" },
    { code: "RO.13.56522", name: "Comuna Cămăraşu" },
    { code: "RO.13.56568", name: "Comuna Cãpuşu Mare" },
    { code: "RO.13.56666", name: "Comuna Căşeiu" },
    { code: "RO.13.56773", name: "Comuna Cătina" },
    { code: "RO.13.56844", name: "Comuna Ceanu Mare" },
    { code: "RO.13.56988", name: "Comuna Chinteni" },
    { code: "RO.13.57083", name: "Comuna Chiuieşti" },
    { code: "RO.13.57163", name: "Comuna Ciucea" },
    { code: "RO.13.57225", name: "Comuna Ciurila" },
    { code: "RO.13.57314", name: "Comuna Câţcău" },
    { code: "RO.13.57350", name: "Comuna Cojocna" },
    { code: "RO.13.57449", name: "Comuna Corneşti" },
    { code: "RO.13.57546", name: "Comuna Dăbâca" },
    { code: "RO.13.57582", name: "Comuna Feleacu" },
    { code: "RO.13.57644", name: "Comuna Fizeşu Gherlii" },
    { code: "RO.13.57706", name: "Comuna Floreşti" },
    { code: "RO.13.57742", name: "Comuna Frata" },
    { code: "RO.13.57831", name: "Comuna Geaca" },
    { code: "RO.13.57902", name: "Comuna Gilău" },
    { code: "RO.13.57948", name: "Comuna Gârbãu" },
    { code: "RO.13.58008", name: "Comuna Iara" },
    { code: "RO.13.58142", name: "Comuna Iclod" },
    { code: "RO.13.58204", name: "Comuna Izvoru Crişului" },
    { code: "RO.13.58259", name: "Comuna Jucu" },
    { code: "RO.13.58311", name: "Comuna Luna" },
    { code: "RO.13.58357", name: "Comuna Mãguri-Rãcãtãu" },
    { code: "RO.13.58393", name: "Comuna Mânăstireni" },
    { code: "RO.13.58464", name: "Comuna Mărgău" },
    { code: "RO.13.58534", name: "Comuna Mărişel" },
    { code: "RO.13.58552", name: "Comuna Mintiu Gherlii" },
    { code: "RO.13.58623", name: "Comuna Mociu" },
    { code: "RO.13.58721", name: "Comuna Moldoveneşti" },
    { code: "RO.13.58794", name: "Comuna Pãlatca" },
    { code: "RO.13.58856", name: "Comuna Panticeu" },
    { code: "RO.13.58918", name: "Comuna Petreştii De Jos" },
    { code: "RO.13.58990", name: "Comuna Ploscoş" },
    { code: "RO.13.59041", name: "Comuna Poieni" },
    { code: "RO.13.59130", name: "Comuna Recea Cristur" },
    { code: "RO.13.59238", name: "Comuna Râșca" },
    { code: "RO.13.59283", name: "Comuna Sãcuieu" },
    { code: "RO.13.59327", name: "Comuna Săvădisla" },
    { code: "RO.13.59416", name: "Comuna Sic" },
    { code: "RO.13.59434", name: "Comuna Sâncraiu" },
    { code: "RO.13.59498", name: "Comuna Sânmărtin" },
    { code: "RO.13.59586", name: "Comuna Sânpaul" },
    { code: "RO.13.59657", name: "Comuna Suatu" },
    { code: "RO.13.59693", name: "Comuna Tritenii De Jos" },
    { code: "RO.13.59764", name: "Comuna Tureni" },
    { code: "RO.13.59826", name: "Comuna Ţaga" },
    { code: "RO.13.59880", name: "Comuna Unguraş" },
    { code: "RO.13.59942", name: "Comuna Vad" },
    { code: "RO.13.60026", name: "Comuna Valea Ierii" },
    { code: "RO.13.60062", name: "Comuna Viişoara" },
    { code: "RO.13.60099", name: "Comuna Vultureni" },
    { code: "RO.13.60169", name: "Comuna Negreni" },
  ],
  "RO.14": [
    { code: "RO.14.60419", name: "Municipiul Constanţa" },
    { code: "RO.14.60455", name: "Oraş Eforie" },
    { code: "RO.14.60482", name: "Municipiul Mangalia" },
    { code: "RO.14.60507", name: "Oraş Nãvodari" },
    { code: "RO.14.60534", name: "Oraş Techirghiol" },
    { code: "RO.14.60570", name: "Comuna Agigea" },
    { code: "RO.14.60598", name: "Comuna 23 August" },
    { code: "RO.14.60632", name: "Comuna Limanu" },
    { code: "RO.14.60687", name: "Oraş Ovidiu" },
    { code: "RO.14.60721", name: "Comuna Tuzla" },
    { code: "RO.14.60776", name: "Oraş Cernavodã" },
    { code: "RO.14.60801", name: "Oraş Hârşova" },
    { code: "RO.14.60847", name: "Municipiul Medgidia" },
    { code: "RO.14.60883", name: "Comuna Adamclisi" },
    { code: "RO.14.60945", name: "Comuna Albeşti" },
    { code: "RO.14.61005", name: "Comuna Aliman" },
    { code: "RO.14.61069", name: "Oraş Bãneasa" },
    { code: "RO.14.61121", name: "Comuna Castelu" },
    { code: "RO.14.61167", name: "Comuna Cerchezu" },
    { code: "RO.14.61210", name: "Comuna Chirnogeni" },
    { code: "RO.14.61256", name: "Comuna Ciobanu" },
    { code: "RO.14.61283", name: "Comuna Ciocârlia" },
    { code: "RO.14.61318", name: "Comuna Cobadin" },
    { code: "RO.14.61372", name: "Comuna Cogealac" },
    { code: "RO.14.61452", name: "Comuna Comana" },
    { code: "RO.14.61513", name: "Comuna Corbu" },
    { code: "RO.14.61559", name: "Comuna Crucea" },
    { code: "RO.14.61620", name: "Comuna Cumpăna" },
    { code: "RO.14.61675", name: "Comuna Deleni" },
    { code: "RO.14.61737", name: "Comună Dobromir" },
    { code: "RO.14.61808", name: "Comuna Gârliciu" },
    { code: "RO.14.61826", name: "Comuna Ghindăreşti" },
    { code: "RO.14.61871", name: "Comuna Independenţa" },
    { code: "RO.14.61951", name: "Comuna Ion Corvin" },
    { code: "RO.14.62020", name: "Comuna Istria" },
    { code: "RO.14.62057", name: "Comuna Lipniţa" },
    { code: "RO.14.62137", name: "Comuna Mereni" },
    { code: "RO.14.62191", name: "Comuna Mihail Kogălniceanu" },
    { code: "RO.14.62253", name: "Comuna Mihai Viteazu" },
    { code: "RO.14.62280", name: "Comuna Mircea Vodă" },
    { code: "RO.14.62360", name: "Oraş Murfatlar" },
    { code: "RO.14.62397", name: "Oraş Negru Vodã" },
    { code: "RO.14.62440", name: "Comuna Nicolae Bălcescu" },
    { code: "RO.14.62486", name: "Comuna Oltina" },
    { code: "RO.14.62538", name: "Comuna Ostrov" },
    { code: "RO.14.62609", name: "Comuna Pantelimon" },
    { code: "RO.14.62672", name: "Comuna Pecineaga" },
    { code: "RO.14.62707", name: "Comuna Peştera" },
    { code: "RO.14.62761", name: "Comuna Poarta Albă" },
    { code: "RO.14.62798", name: "Comuna Rasova" },
    { code: "RO.14.62823", name: "Comuna Saraiu" },
    { code: "RO.14.62878", name: "Comuna Săcele" },
    { code: "RO.14.62903", name: "Comuna Seimeni" },
    { code: "RO.14.62949", name: "Comuna Siliştea" },
    { code: "RO.14.62985", name: "Comuna Târguşor" },
    { code: "RO.14.63045", name: "Comuna Topalu" },
    { code: "RO.14.63072", name: "Comuna Topraisar" },
    { code: "RO.14.63125", name: "Comuna Valu lui Traian" },
    { code: "RO.14.63152", name: "Comuna Lumina" },
    { code: "RO.14.63161", name: "Comuna Dumbrăveni" },
    { code: "RO.14.63170", name: "Comuna Vulturu" },
    { code: "RO.14.63189", name: "Comuna Tortoman" },
    { code: "RO.14.63198", name: "Comuna Amzacea" },
    { code: "RO.14.63278", name: "Comuna Horia" },
    { code: "RO.14.63286", name: "Comuna Costineşti" },
    { code: "RO.14.63294", name: "Comuna Bărăganu" },
    { code: "RO.14.63300", name: "Comuna Cuza Voda" },
    { code: "RO.14.63318", name: "Comuna Saligny" },
    { code: "RO.14.63326", name: "Comuna Grădina" },
    { code: "RO.14.63334", name: "Comuna Fântânele" },
  ],
  "RO.15": [
    { code: "RO.15.63394", name: "Municipiul Sfântu Gheorghe" },
    { code: "RO.15.63447", name: "Oraş Baraolt" },
    { code: "RO.15.63526", name: "Oraş Covasna" },
    { code: "RO.15.63553", name: "Comuna Comandău" },
    { code: "RO.15.63580", name: "Oraş Întorsura Buzãului" },
    { code: "RO.15.63633", name: "Comuna Barcani" },
    { code: "RO.15.63688", name: "Comuna Sita Buzăului" },
    { code: "RO.15.63740", name: "Municipiul Târgu Secuiesc" },
    { code: "RO.15.63777", name: "Comuna Aita Mare" },
    { code: "RO.15.63802", name: "Comuna Băţani" },
    { code: "RO.15.63866", name: "Comuna Belin" },
    { code: "RO.15.63893", name: "Comuna Bodoc" },
    { code: "RO.15.63937", name: "Comuna Boroşneu Mare" },
    { code: "RO.15.64005", name: "Comuna Brateş" },
    { code: "RO.15.64041", name: "Comuna Brăduţ" },
    { code: "RO.15.64096", name: "Comuna Breţcu" },
    { code: "RO.15.64130", name: "Comuna Catalina" },
    { code: "RO.15.64194", name: "Comună Cernat" },
    { code: "RO.15.64238", name: "Comuna Chichiş" },
    { code: "RO.15.64265", name: "Comuna Dobârlău" },
    { code: "RO.15.64318", name: "Comuna Ghelinţa" },
    { code: "RO.15.64345", name: "Comuna Ghidfalău" },
    { code: "RO.15.64390", name: "Comuna Hăghig" },
    { code: "RO.15.64425", name: "Comuna Ilieni" },
    { code: "RO.15.64461", name: "Comuna Lemnia" },
    { code: "RO.15.64504", name: "Comuna Malnaş" },
    { code: "RO.15.64568", name: "Comuna Moacşa" },
    { code: "RO.15.64602", name: "Comuna Ojdula" },
    { code: "RO.15.64639", name: "Comuna Ozun" },
    { code: "RO.15.64719", name: "Comuna Poian" },
    { code: "RO.15.64773", name: "Comuna Reci" },
    { code: "RO.15.64826", name: "Comuna Sânzieni" },
    { code: "RO.15.64871", name: "Comuna Turia" },
    { code: "RO.15.64906", name: "Comuna Valea Crişului" },
    { code: "RO.15.64942", name: "Comuna Vâlcele" },
    { code: "RO.15.64997", name: "Comuna Vârghiş" },
    { code: "RO.15.65011", name: "Comuna Zagon" },
    { code: "RO.15.65048", name: "Comuna Zăbala" },
    { code: "RO.15.65099", name: "Comuna Valea Mare" },
    { code: "RO.15.65105", name: "Comuna Mereni" },
    { code: "RO.15.65113", name: "Comuna Arcuş" },
    { code: "RO.15.65121", name: "Comuna Bixad" },
    { code: "RO.15.65139", name: "Comuna Micfalău" },
    { code: "RO.15.65147", name: "Comuna Dalnic" },
    { code: "RO.15.65154", name: "Comuna Estelnic" },
  ],
  "RO.16": [
    { code: "RO.16.101341", name: "Comuna Brezoaele" },
    { code: "RO.16.101564", name: "Comuna Butimanu" },
    { code: "RO.16.101840", name: "Comuna Ciocăneşti" },
    { code: "RO.16.102286", name: "Comuna Crevedia" },
    { code: "RO.16.104387", name: "Comuna Niculeşti" },
    { code: "RO.16.105142", name: "Comuna Slobozia Moara" },
    { code: "RO.16.105534", name: "Comuna Tărtăşeşti" },
    { code: "RO.16.179640", name: "Comuna Vulcana-Pandele" },
    { code: "RO.16.179711", name: "Comuna Vlădeni" },
    { code: "RO.16.179891", name: "Comuna Raciu" },
    { code: "RO.16.179908", name: "Comuna Pietrari" },
    { code: "RO.16.179917", name: "Comuna Râu Alb" },
    { code: "RO.16.179926", name: "Comuna Răscăeţi" },
    { code: "RO.16.179935", name: "Comuna Perşinari" },
    { code: "RO.16.65342", name: "Municipiul Târgovişte" },
    { code: "RO.16.65379", name: "Comuna Aninoasa" },
    { code: "RO.16.65413", name: "Comuna Doiceşti" },
    { code: "RO.16.65431", name: "Comuna Rãzvad" },
    { code: "RO.16.65477", name: "Comuna Şotânga" },
    { code: "RO.16.65501", name: "Comuna Ulmi" },
    { code: "RO.16.65609", name: "Oraş Fieni" },
    { code: "RO.16.65645", name: "Comuna Moţãieni" },
    { code: "RO.16.65681", name: "Oraş Gãeşti" },
    { code: "RO.16.65707", name: "Comuna Gura Foii" },
    { code: "RO.16.65752", name: "Comuna Petreşti" },
    { code: "RO.16.65841", name: "Municipiul Moreni" },
    { code: "RO.16.65869", name: "Comuna Iedera" },
    { code: "RO.16.65921", name: "Oraş Pucioasa" },
    { code: "RO.16.66009", name: "Comuna Brăneşti" },
    { code: "RO.16.66081", name: "Oraş Titu" },
    { code: "RO.16.66152", name: "Comuna Braniştea" },
    { code: "RO.16.66198", name: "Comuna Băleni Sârbi" },
    { code: "RO.16.66223", name: "Comuna Bărbuleţu" },
    { code: "RO.16.66330", name: "Comuna Bezdead" },
    { code: "RO.16.66401", name: "Comuna Bilciureşti" },
    { code: "RO.16.66438", name: "Comuna Buciumeni" },
    { code: "RO.16.66474", name: "Comuna Bucşani" },
    { code: "RO.16.66526", name: "Comuna Cândeşti Vale" },
    { code: "RO.16.66580", name: "Comuna Cobia de Sus" },
    { code: "RO.16.66697", name: "Comuna Cojasca" },
    { code: "RO.16.66731", name: "Comuna Comişani" },
    { code: "RO.16.66768", name: "Comuna Conţeşti" },
    { code: "RO.16.66857", name: "Comuna Corbii Mari" },
    { code: "RO.16.66955", name: "Comuna Cornăţelu" },
    { code: "RO.16.67014", name: "Comuna Corneşti" },
    { code: "RO.16.67121", name: "Comuna Costeştii din Vale" },
    { code: "RO.16.67167", name: "Comuna Crângurile" },
    { code: "RO.16.67256", name: "Comuna Dărmăneşti" },
    { code: "RO.16.67292", name: "Comuna Dobra" },
    { code: "RO.16.67327", name: "Comuna Dragodana" },
    { code: "RO.16.67407", name: "Comuna Dragomireşti" },
    { code: "RO.16.67470", name: "Comuna Finta" },
    { code: "RO.16.67522", name: "Comuna Glodeni" },
    { code: "RO.16.67595", name: "Comuna Gura Ocniţei" },
    { code: "RO.16.67648", name: "Comuna Gura Şuţii" },
    { code: "RO.16.67675", name: "Comuna Hulubeşti" },
    { code: "RO.16.67737", name: "Comuna I. L. Caragiale" },
    { code: "RO.16.67773", name: "Comuna Lucieni" },
    { code: "RO.16.67835", name: "Comuna Ludeşti" },
    { code: "RO.16.67906", name: "Comuna Lunguleţu" },
    { code: "RO.16.67942", name: "Comuna Malu cu Flori" },
    { code: "RO.16.68002", name: "Comuna Măneşti" },
    { code: "RO.16.68048", name: "Comuna Mătăsaru" },
    { code: "RO.16.68128", name: "Comuna Mogoşani" },
    { code: "RO.16.68182", name: "Comuna Moroeni" },
    { code: "RO.16.68253", name: "Comuna Morteni" },
    { code: "RO.16.68280", name: "Comuna Nucet" },
    { code: "RO.16.68324", name: "Comuna Ocniţa" },
    { code: "RO.16.68342", name: "Comuna Odobeşti" },
    { code: "RO.16.68404", name: "Comuna Pietroşiţa" },
    { code: "RO.16.68431", name: "Comuna Poiana" },
    { code: "RO.16.68468", name: "Comuna Potlogi" },
    { code: "RO.16.68529", name: "Comuna Produleşti" },
    { code: "RO.16.68565", name: "Comuna Pucheni" },
    { code: "RO.16.68627", name: "Oraş Rãcari" },
    { code: "RO.16.68716", name: "Comuna Runcu" },
    { code: "RO.16.68789", name: "Comuna Sălcioara" },
    { code: "RO.16.68887", name: "Comuna Şelaru" },
    { code: "RO.16.68921", name: "Comuna Tătărani" },
    { code: "RO.16.68976", name: "Comuna Ulieşti" },
    { code: "RO.16.69063", name: "Comuna Valea Lungă" },
    { code: "RO.16.69170", name: "Comuna Valea Mare" },
    { code: "RO.16.69250", name: "Comuna Văcăreşti" },
    { code: "RO.16.69303", name: "Comuna Văleni-Dâmboviţa" },
    { code: "RO.16.69330", name: "Comuna Vişina" },
    { code: "RO.16.69394", name: "Comuna Vişineşti" },
    { code: "RO.16.69447", name: "Comuna Vârfuri" },
    { code: "RO.16.69526", name: "Comuna Voineşti" },
    { code: "RO.16.69615", name: "Comuna Vulcana Băi" },
  ],
  "RO.17": [
    { code: "RO.17.69900", name: "Municipiul Craiova" },
    { code: "RO.17.69964", name: "Comuna Bucovăţ" },
    { code: "RO.17.70094", name: "Comuna Işalniţa" },
    { code: "RO.17.70110", name: "Comuna Podari" },
    { code: "RO.17.70174", name: "Comuna Şimnicu de Sus" },
    { code: "RO.17.70316", name: "Municipiul Bãileşti" },
    { code: "RO.17.70352", name: "Municipiul Calafat" },
    { code: "RO.17.70414", name: "Oraş Filiaşi" },
    { code: "RO.17.70502", name: "Oraş Segarcea" },
    { code: "RO.17.70520", name: "Comuna Afumaţi" },
    { code: "RO.17.70566", name: "Comuna Almãj" },
    { code: "RO.17.70637", name: "Comuna Amărăştii de Jos" },
    { code: "RO.17.70673", name: "Comuna Amărăştii de Sus" },
    { code: "RO.17.70726", name: "Comuna Apele Vii" },
    { code: "RO.17.70744", name: "Comuna Argetoaia" },
    { code: "RO.17.70879", name: "Oraş Bechet" },
    { code: "RO.17.70897", name: "Comuna Bistreţ" },
    { code: "RO.17.70940", name: "Comuna Bârca" },
    { code: "RO.17.70968", name: "Comuna Botoşeşti-Paia" },
    { code: "RO.17.70986", name: "Comuna Brabova" },
    { code: "RO.17.71055", name: "Comuna Brădeşti" },
    { code: "RO.17.71126", name: "Comuna Braloştiţa" },
    { code: "RO.17.71199", name: "Comuna Bratovoeşti" },
    { code: "RO.17.71260", name: "Comuna Breasta" },
    { code: "RO.17.71340", name: "Comuna Bulzeşti" },
    { code: "RO.17.71457", name: "Comuna Calopăru" },
    { code: "RO.17.71518", name: "Comuna Caraula" },
    { code: "RO.17.71536", name: "Comuna Carpen" },
    { code: "RO.17.71572", name: "Comuna Castranova" },
    { code: "RO.17.71607", name: "Comuna Călăraşi" },
    { code: "RO.17.71634", name: "Comuna Celaru" },
    { code: "RO.17.71698", name: "Comuna Cerãt" },
    { code: "RO.17.71723", name: "Comuna Cernăteşti" },
    { code: "RO.17.71787", name: "Comuna Cetate" },
    { code: "RO.17.71812", name: "Comuna Cioroiaşi" },
    { code: "RO.17.71858", name: "Comuna Ciupercenii Noi" },
    { code: "RO.17.71885", name: "Comuna Coşoveni" },
    { code: "RO.17.71910", name: "Comuna Coţofenii din Dos" },
    { code: "RO.17.71956", name: "Comuna Dăneţi" },
    { code: "RO.17.72007", name: "Oraş Dãbuleni" },
    { code: "RO.17.72034", name: "Comuna Desa" },
    { code: "RO.17.72052", name: "Comuna Dioşti" },
    { code: "RO.17.72098", name: "Comuna Dobreşti" },
    { code: "RO.17.72150", name: "Comuna Drăgoteşti" },
    { code: "RO.17.72221", name: "Comuna Drãnic" },
    { code: "RO.17.72276", name: "Comuna Fãrcaş" },
    { code: "RO.17.72383", name: "Comuna Galicea Mare" },
    { code: "RO.17.72409", name: "Comuna Gherceşti" },
    { code: "RO.17.72463", name: "Comuna Gighera" },
    { code: "RO.17.72506", name: "Comuna Giubega" },
    { code: "RO.17.72533", name: "Comuna Giurgiţa" },
    { code: "RO.17.72579", name: "Comuna Gângiova" },
    { code: "RO.17.72604", name: "Comuna Gogoşu" },
    { code: "RO.17.72640", name: "Comuna Goicea" },
    { code: "RO.17.72677", name: "Comuna Goieşti" },
    { code: "RO.17.72819", name: "Comuna Greceşti" },
    { code: "RO.17.72882", name: "Comuna Izvoare" },
    { code: "RO.17.72926", name: "Comuna Leu" },
    { code: "RO.17.72953", name: "Comuna Lipovu" },
    { code: "RO.17.72980", name: "Comuna Măceşu de Jos" },
    { code: "RO.17.73013", name: "Comuna Măceşu de Sus" },
    { code: "RO.17.73031", name: "Comuna Maglavit" },
    { code: "RO.17.73068", name: "Comuna Malu Mare" },
    { code: "RO.17.73102", name: "Comuna Melineşti" },
    { code: "RO.17.73246", name: "Comuna Mischii" },
    { code: "RO.17.73317", name: "Comuna Mârşani" },
    { code: "RO.17.73335", name: "Comuna Moţăţei" },
    { code: "RO.17.73371", name: "Comuna Murgaşi" },
    { code: "RO.17.73460", name: "Comuna Negoi" },
    { code: "RO.17.73503", name: "Comuna Orodel" },
    { code: "RO.17.73567", name: "Comuna Ostroveni" },
    { code: "RO.17.73594", name: "Comuna Perişor" },
    { code: "RO.17.73629", name: "Comuna Pieleşti" },
    { code: "RO.17.73665", name: "Comuna Piscu Vechi" },
    { code: "RO.17.73709", name: "Comuna Pleniţa" },
    { code: "RO.17.73736", name: "Comuna Poiana Mare" },
    { code: "RO.17.73772", name: "Comuna Predeşti" },
    { code: "RO.17.73852", name: "Comuna Radovan" },
    { code: "RO.17.73905", name: "Comuna Rast" },
    { code: "RO.17.73923", name: "Comuna Robăneşti" },
    { code: "RO.17.73996", name: "Comuna Sadova" },
    { code: "RO.17.74028", name: "Comuna Sălcuţa" },
    { code: "RO.17.74073", name: "Comuna Scăeşti" },
    { code: "RO.17.74108", name: "Comuna Seaca de Câmp" },
    { code: "RO.17.74135", name: "Comuna Seaca de Pădure" },
    { code: "RO.17.74171", name: "Comuna Secu" },
    { code: "RO.17.74224", name: "Comuna Siliştea Crucii" },
    { code: "RO.17.74242", name: "Comuna Sopot" },
    { code: "RO.17.74322", name: "Comuna Teasc" },
    { code: "RO.17.74359", name: "Comuna Terpeziţa" },
    { code: "RO.17.74411", name: "Comuna Teslui" },
    { code: "RO.17.74509", name: "Comuna Ţuglui" },
    { code: "RO.17.74536", name: "Comuna Unirea" },
    { code: "RO.17.74554", name: "Comuna Urzicuţa" },
    { code: "RO.17.74581", name: "Comuna Valea Stanciului" },
    { code: "RO.17.74616", name: "Comuna Vela" },
    { code: "RO.17.74705", name: "Comuna Verbiţa" },
    { code: "RO.17.74732", name: "Comuna Vârtop" },
    { code: "RO.17.74750", name: "Comuna Vârvoru de Jos" },
    { code: "RO.17.74842", name: "Comuna Catane" },
    { code: "RO.17.74859", name: "Comuna Cârcea" },
    { code: "RO.17.74867", name: "Comuna Cârna" },
    { code: "RO.17.74875", name: "Comuna Coţofenii din Faţă" },
    { code: "RO.17.74883", name: "Comuna Dobroteşti" },
    { code: "RO.17.74891", name: "Comuna Galiciuica" },
    { code: "RO.17.74907", name: "Comuna Ghidici" },
    { code: "RO.17.74915", name: "Comuna Ghindeni" },
    { code: "RO.17.74923", name: "Comuna Întorsura" },
    { code: "RO.17.74931", name: "Comuna Pleşoi" },
    { code: "RO.17.74949", name: "Comuna Rojişte" },
    { code: "RO.17.74956", name: "Comuna Tãlpaş" },
  ],
  "RO.18": [
    { code: "RO.18.75098", name: "Municipiul Galaţi" },
    { code: "RO.18.75114", name: "Comuna Şendreni" },
    { code: "RO.18.75150", name: "Comuna Vânători" },
    { code: "RO.18.75203", name: "Municipiul Tecuci" },
    { code: "RO.18.75221", name: "Comuna Drăgăneşti" },
    { code: "RO.18.75258", name: "Comuna Munteni" },
    { code: "RO.18.75338", name: "Oraş Bereşti" },
    { code: "RO.18.75356", name: "Comuna Bereşti-Meria" },
    { code: "RO.18.75472", name: "Oraș Târgu Bujor" },
    { code: "RO.18.75515", name: "Comuna Barcea" },
    { code: "RO.18.75542", name: "Comuna Bălăbăneşti" },
    { code: "RO.18.75613", name: "Comuna Bălăşeşti" },
    { code: "RO.18.75668", name: "Comuna Băleni" },
    { code: "RO.18.75686", name: "Comuna Băneasa" },
    { code: "RO.18.75711", name: "Comuna Braniştea" },
    { code: "RO.18.75766", name: "Comuna Brăhăşeşti" },
    { code: "RO.18.75819", name: "Comuna Buciumeni" },
    { code: "RO.18.75864", name: "Comuna Cavadineşti" },
    { code: "RO.18.75917", name: "Comuna Cerţeşti" },
    { code: "RO.18.75953", name: "Comuna Corod" },
    { code: "RO.18.76004", name: "Comuna Corni" },
    { code: "RO.18.76040", name: "Comuna Cosmeşti" },
    { code: "RO.18.76111", name: "Comuna Costache Negri" },
    { code: "RO.18.76139", name: "Comuna Cuca" },
    { code: "RO.18.76157", name: "Comuna Cudalbi" },
    { code: "RO.18.76175", name: "Comuna Drăguşeni" },
    { code: "RO.18.76255", name: "Comuna Fârţăneşti" },
    { code: "RO.18.76282", name: "Comuna Folteşti" },
    { code: "RO.18.76317", name: "Comuna Frumuşiţa" },
    { code: "RO.18.76353", name: "Comuna Fundeni" },
    { code: "RO.18.76406", name: "Comuna Ghidigeni" },
    { code: "RO.18.76497", name: "Comuna Gohor" },
    { code: "RO.18.76558", name: "Comuna Griviţa" },
    { code: "RO.18.76585", name: "Comuna Independenţa" },
    { code: "RO.18.76601", name: "Comuna Iveşti" },
    { code: "RO.18.76638", name: "Comuna Jorăşti" },
    { code: "RO.18.76674", name: "Comuna Lieşti" },
    { code: "RO.18.76692", name: "Comuna Matca" },
    { code: "RO.18.76718", name: "Comuna Măstăcani" },
    { code: "RO.18.76745", name: "Comuna Movileni" },
    { code: "RO.18.76763", name: "Comuna Nămoloasa" },
    { code: "RO.18.76807", name: "Comuna Nicoreşti" },
    { code: "RO.18.76932", name: "Comuna Oancea" },
    { code: "RO.18.76969", name: "Comuna Pechea" },
    { code: "RO.18.76996", name: "Comuna Piscu" },
    { code: "RO.18.77028", name: "Comuna Priponeşti" },
    { code: "RO.18.77082", name: "Comuna Rediu" },
    { code: "RO.18.77126", name: "Comuna Scânteieşti" },
    { code: "RO.18.77153", name: "Comuna Schela" },
    { code: "RO.18.77180", name: "Comuna Slobozia Conachi" },
    { code: "RO.18.77224", name: "Comuna Smârdan" },
    { code: "RO.18.77260", name: "Comuna Smulţi" },
    { code: "RO.18.77288", name: "Comuna Suceveni" },
    { code: "RO.18.77313", name: "Comuna Tudor Vladimirescu" },
    { code: "RO.18.77331", name: "Comuna Tuluceşti" },
    { code: "RO.18.77377", name: "Comuna Ţepu" },
    { code: "RO.18.77402", name: "Comuna Umbrăreşti" },
    { code: "RO.18.77475", name: "Comuna Valea Mãrului" },
    { code: "RO.18.77509", name: "Comuna Vârlezi" },
    { code: "RO.18.77536", name: "Comuna Vlădeşti" },
    { code: "RO.18.77561", name: "Comuna Rădeşti" },
    { code: "RO.18.77579", name: "Comuna Negrileşti" },
    { code: "RO.18.77587", name: "Comuna Poiana" },
    { code: "RO.18.77595", name: "Comuna Cuza Vodă" },
    { code: "RO.18.77601", name: "Comuna Suhurlui" },
  ],
  "RO.19": [
    { code: "RO.19.77812", name: "Municipiul Târgu Jiu" },
    { code: "RO.19.77910", name: "Comuna Băleşti" },
    { code: "RO.19.78016", name: "Comuna Drãguţeşti" },
    { code: "RO.19.78089", name: "Comuna Turcineşti" },
    { code: "RO.19.78141", name: "Municipiul Motru" },
    { code: "RO.19.78258", name: "Novaci" },
    { code: "RO.19.78329", name: "Oraş Târgu Cãrbuneşti" },
    { code: "RO.19.78454", name: "Oraş Ţicleni" },
    { code: "RO.19.78472", name: "Comuna Albeni" },
    { code: "RO.19.78542", name: "Comuna Alimpeşti" },
    { code: "RO.19.78604", name: "Comuna Aninoasa" },
    { code: "RO.19.78668", name: "Comuna Arcani" },
    { code: "RO.19.78711", name: "Comuna Baia de Fier" },
    { code: "RO.19.78748", name: "Comuna Bălăneşti" },
    { code: "RO.19.78828", name: "Comuna Bărbăteşti" },
    { code: "RO.19.78873", name: "Comuna Bengeşti-Ciocadia" },
    { code: "RO.19.78926", name: "Berleşti" },
    { code: "RO.19.79004", name: "Comuna Bâlteni" },
    { code: "RO.19.79077", name: "Comuna Bolboşi" },
    { code: "RO.19.79157", name: "Comuna Borăscu" },
    { code: "RO.19.79237", name: "Comuna Brăneşti" },
    { code: "RO.19.79308", name: "Oraş Bumbeşti-Jiu" },
    { code: "RO.19.79362", name: "Comuna Bumbeşti-Piţic" },
    { code: "RO.19.79406", name: "Comuna Bustuchin" },
    { code: "RO.19.79497", name: "Comuna Căpreni" },
    { code: "RO.19.79585", name: "Comuna Cătunele" },
    { code: "RO.19.79656", name: "Comuna Ciuperceni" },
    { code: "RO.19.79736", name: "Comuna Câlnic" },
    { code: "RO.19.79834", name: "Comuna Crasna" },
    { code: "RO.19.79932", name: "Comuna Crușeț" },
    { code: "RO.19.80043", name: "Comuna Dănciuleşti" },
    { code: "RO.19.80123", name: "Comuna Dăneşti" },
    { code: "RO.19.80249", name: "Comuna Drăgoteşti" },
    { code: "RO.19.80285", name: "Comuna Fãrcãşeşti" },
    { code: "RO.19.80365", name: "Comuna Glogova" },
    { code: "RO.19.80427", name: "Comuna Godineşti" },
    { code: "RO.19.80506", name: "Comuna Hurezani" },
    { code: "RO.19.80560", name: "Comuna Ioneşti" },
    { code: "RO.19.80613", name: "Comuna Jupâneşti" },
    { code: "RO.19.80677", name: "Comuna Leleşti" },
    { code: "RO.19.80711", name: "Comuna Licurici" },
    { code: "RO.19.80766", name: "Comuna Logreşti-Moşteni" },
    { code: "RO.19.80846", name: "Comuna Mătăsari" },
    { code: "RO.19.80908", name: "Comuna Muşeteşti" },
    { code: "RO.19.80980", name: "Comuna Negomir" },
    { code: "RO.19.81095", name: "Comuna Padeş" },
    { code: "RO.19.81184", name: "Comuna Peştişani" },
    { code: "RO.19.81264", name: "Comuna Plopşoru" },
    { code: "RO.19.81380", name: "Comuna Polovragi" },
    { code: "RO.19.81415", name: "Comuna Prigoria" },
    { code: "RO.19.81497", name: "Comuna Roşia De Amaradia" },
    { code: "RO.19.81576", name: "Comuna Runcu" },
    { code: "RO.19.81656", name: "Comuna Samarineşti" },
    { code: "RO.19.81754", name: "Comuna Săcelu" },
    { code: "RO.19.81816", name: "Comuna Săuleşti" },
    { code: "RO.19.81861", name: "Comuna Scoarţa" },
    { code: "RO.19.81987", name: "Comuna Schela" },
    { code: "RO.19.82047", name: "Comuna Slivileşti" },
    { code: "RO.19.82136", name: "Comuna Stăneşti" },
    { code: "RO.19.82243", name: "Comuna Stejari" },
    { code: "RO.19.82314", name: "Comuna Stoina" },
    { code: "RO.19.82396", name: "Comuna Teleşti" },
    { code: "RO.19.82430", name: "Oraş Tismana" },
    { code: "RO.19.82555", name: "Comuna Turburea" },
    { code: "RO.19.82617", name: "Oraş Turceni" },
    { code: "RO.19.82680", name: "Comuna Ţânţăreni" },
    { code: "RO.19.82733", name: "Comuna Urdari" },
    { code: "RO.19.82779", name: "Comuna Văgiuleşti" },
    { code: "RO.19.82831", name: "Comuna Vladimir" },
    { code: "RO.19.82895", name: "Oraş Rovinari" },
  ],
  "RO.20": [
    { code: "RO.20.83133", name: "Municipiul Odorheiu Secuiesc" },
    { code: "RO.20.83151", name: "Comuna Brădeşti" },
    { code: "RO.20.83197", name: "Comuna Feliceni" },
    { code: "RO.20.83320", name: "Municipiul Miercurea Ciuc" },
    { code: "RO.20.83375", name: "Comuna Pãuleni-Ciuc" },
    { code: "RO.20.83428", name: "Oraş Bãile Tuşnad" },
    { code: "RO.20.83464", name: "Oraş Bãlan" },
    { code: "RO.20.83491", name: "Oraş Borsec" },
    { code: "RO.20.83525", name: "Oraş Cristuru Secuiesc" },
    { code: "RO.20.83561", name: "Municipiul Gheorgheni" },
    { code: "RO.20.83632", name: "Municipiul  Topliţa" },
    { code: "RO.20.83749", name: "Oraş Vlãhiţa" },
    { code: "RO.20.83785", name: "Comuna Atid" },
    { code: "RO.20.83847", name: "Comuna Avrămeşti" },
    { code: "RO.20.83936", name: "Comuna Bilbor" },
    { code: "RO.20.83963", name: "Comuna Căpâlniţa" },
    { code: "RO.20.83981", name: "Comuna Ciucsângeorgiu" },
    { code: "RO.20.84086", name: "Comuna Ciumani" },
    { code: "RO.20.84102", name: "Comuna Cârţa" },
    { code: "RO.20.84148", name: "Comuna Corbu" },
    { code: "RO.20.84175", name: "Comuna Corund" },
    { code: "RO.20.84237", name: "Comuna Dăneşti" },
    { code: "RO.20.84264", name: "Comuna Dealu" },
    { code: "RO.20.84344", name: "Comuna Ditrău" },
    { code: "RO.20.84380", name: "Comuna Dârjiu" },
    { code: "RO.20.84415", name: "Comuna Frumoasa" },
    { code: "RO.20.84460", name: "Comuna Gălăuţaş" },
    { code: "RO.20.84558", name: "Comuna Joseni" },
    { code: "RO.20.84594", name: "Comuna Lăzarea" },
    { code: "RO.20.84629", name: "Comuna Lueta" },
    { code: "RO.20.84656", name: "Comuna Lunca de Jos" },
    { code: "RO.20.84754", name: "Comuna Lunca de Sus" },
    { code: "RO.20.84825", name: "Comuna Lupeni" },
    { code: "RO.20.84923", name: "Comuna Mărtiniş" },
    { code: "RO.20.85056", name: "Comuna Mereşti" },
    { code: "RO.20.85074", name: "Comuna Mihăileni" },
    { code: "RO.20.85127", name: "Comuna Mugeni" },
    { code: "RO.20.85243", name: "Comuna Ocland" },
    { code: "RO.20.85289", name: "Comuna Plãieşii De Jos" },
    { code: "RO.20.85341", name: "Comuna Praid" },
    { code: "RO.20.85412", name: "Comuna Remetea" },
    { code: "RO.20.85467", name: "Comuna Săcel" },
    { code: "RO.20.85528", name: "Comuna Sărmaş" },
    { code: "RO.20.85582", name: "Comuna Secuieni" },
    { code: "RO.20.85626", name: "Comuna Siculeni" },
    { code: "RO.20.85680", name: "Comuna Sâncrăieni" },
    { code: "RO.20.85760", name: "Comuna Sândominic" },
    { code: "RO.20.85788", name: "Comuna Sânmartin" },
    { code: "RO.20.85840", name: "Comuna Sânsimion" },
    { code: "RO.20.85877", name: "Comuna Subcetate" },
    { code: "RO.20.85920", name: "Comuna Suseni" },
    { code: "RO.20.85984", name: "Comuna Simoneşti" },
    { code: "RO.20.86133", name: "Comuna Tulgheş" },
    { code: "RO.20.86188", name: "Comuna Tuşnad" },
    { code: "RO.20.86222", name: "Comuna Ulieş" },
    { code: "RO.20.86311", name: "Comuna Vărşag" },
    { code: "RO.20.86339", name: "Comuna Voşlãbeni" },
    { code: "RO.20.86366", name: "Comuna Zetea" },
    { code: "RO.20.86438", name: "Comuna Mădăraş" },
    { code: "RO.20.86446", name: "Comuna Cozmeni" },
    { code: "RO.20.86453", name: "Comuna Tomeşti" },
    { code: "RO.20.86461", name: "Comuna Ciceu" },
    { code: "RO.20.86479", name: "Comuna Leliceni" },
    { code: "RO.20.86487", name: "Comuna Porumbeni" },
    { code: "RO.20.86495", name: "Comuna Racu" },
    { code: "RO.20.86501", name: "Comuna Satu Mare" },
    { code: "RO.20.86519", name: "Comuna Sântimbru" },
  ],
  "RO.21": [
    { code: "RO.21.86687", name: "Municipiul Deva" },
    { code: "RO.21.86749", name: "Comuna Cârjiţi" },
    { code: "RO.21.86810", name: "Municipiul Hunedoara" },
    { code: "RO.21.86883", name: "Comuna Ghelari" },
    { code: "RO.21.86936", name: "Comuna Teliucu Inferior" },
    { code: "RO.21.86990", name: "Municipiul Petroşani" },
    { code: "RO.21.87059", name: "Municipiul  Lupeni" },
    { code: "RO.21.87077", name: "Oraş Petrila" },
    { code: "RO.21.87139", name: "Oraş Uricani" },
    { code: "RO.21.87175", name: "Municipiul  Vulcan" },
    { code: "RO.21.87219", name: "Oraş Aninoasa" },
    { code: "RO.21.87246", name: "Comuna Băniţa" },
    { code: "RO.21.87291", name: "Municipiul Brad" },
    { code: "RO.21.87362", name: "Comuna Crişcior" },
    { code: "RO.21.87424", name: "Oraş Cãlan" },
    { code: "RO.21.87576", name: "Oraş Haţeg" },
    { code: "RO.21.87638", name: "Municipiul Orãştie" },
    { code: "RO.21.87665", name: "Oraş Simeria" },
    { code: "RO.21.87745", name: "Comuna Baia de Criş" },
    { code: "RO.21.87843", name: "Comuna Balşa" },
    { code: "RO.21.87996", name: "Comuna Baru" },
    { code: "RO.21.88047", name: "Comuna Băcia" },
    { code: "RO.21.88092", name: "Comuna Băiţa" },
    { code: "RO.21.88216", name: "Comuna Bătrâna" },
    { code: "RO.21.88261", name: "Comuna Beriu" },
    { code: "RO.21.88350", name: "Comuna Blăjeni" },
    { code: "RO.21.88449", name: "Comuna Boşorod" },
    { code: "RO.21.88546", name: "Comuna Brănişca" },
    { code: "RO.21.88644", name: "Comuna Bretea Română" },
    { code: "RO.21.88788", name: "Comuna Buceş" },
    { code: "RO.21.88868", name: "Comuna Bucureşci" },
    { code: "RO.21.88920", name: "Comuna Bulzeştii De Sus" },
    { code: "RO.21.89026", name: "Comuna Bunila" },
    { code: "RO.21.89080", name: "Comuna Burjuc" },
    { code: "RO.21.89151", name: "Comuna Cerbăl" },
    { code: "RO.21.89240", name: "Comuna Certeju de Sus" },
    { code: "RO.21.89348", name: "Comuna Densuş" },
    { code: "RO.21.89428", name: "Comuna Dobra" },
    { code: "RO.21.89561", name: "Oraş Geoagiu" },
    { code: "RO.21.89687", name: "Comuna Gurasada" },
    { code: "RO.21.89801", name: "Comuna Hărău" },
    { code: "RO.21.89856", name: "Comuna Ilia" },
    { code: "RO.21.89954", name: "Comuna Lãpugiu De Jos" },
    { code: "RO.21.90066", name: "Comuna Lelese" },
    { code: "RO.21.90119", name: "Comuna Lunca Cernii De Jos" },
    { code: "RO.21.90208", name: "Comuna Luncoiu De Jos" },
    { code: "RO.21.90262", name: "Comuna Mărtineşti" },
    { code: "RO.21.90342", name: "Comuna Orăştioara de Sus" },
    { code: "RO.21.90431", name: "Comuna Pestişu Mic" },
    { code: "RO.21.90538", name: "Comuna Pui" },
    { code: "RO.21.90663", name: "Comuna Rapoltu Mare" },
    { code: "RO.21.90725", name: "Comuna Răchitova" },
    { code: "RO.21.90805", name: "Comuna Ribiţa" },
    { code: "RO.21.90878", name: "Comuna Râu de Mori" },
    { code: "RO.21.90994", name: "Comuna Romos" },
    { code: "RO.21.91054", name: "Comuna Sarmizegetusa" },
    { code: "RO.21.91116", name: "Comuna Sãlaşu De Sus" },
    { code: "RO.21.91232", name: "Comuna Sântămăria-Orlea" },
    { code: "RO.21.91330", name: "Comuna Şoimuş" },
    { code: "RO.21.91447", name: "Comuna Tomeşti" },
    { code: "RO.21.91535", name: "Comuna Topliţa" },
    { code: "RO.21.91624", name: "Comuna Toteşti" },
    { code: "RO.21.91688", name: "Comuna Turdaş" },
    { code: "RO.21.91731", name: "Comuna General Berthelot" },
    { code: "RO.21.91795", name: "Comuna Vaţa De Jos" },
    { code: "RO.21.91937", name: "Comuna Vălişoara" },
    { code: "RO.21.91982", name: "Comuna Veţel" },
    { code: "RO.21.92097", name: "Comuna Vorţa" },
    { code: "RO.21.92177", name: "Comuna Zam" },
  ],
  "RO.22": [
    { code: "RO.22.100683", name: "Municipiul Urziceni" },
    { code: "RO.22.100709", name: "Comuna Ciocârlia" },
    { code: "RO.22.100736", name: "Comuna Manasia" },
    { code: "RO.22.100754", name: "Comuna Adâncata" },
    { code: "RO.22.100852", name: "Comuna Alexeni" },
    { code: "RO.22.100870", name: "Comuna Armăşeşti" },
    { code: "RO.22.100923", name: "Comuna Axintele" },
    { code: "RO.22.101056", name: "Comuna Bărcăneşti" },
    { code: "RO.22.101243", name: "Comuna Răduleşti" },
    { code: "RO.22.102240", name: "Comuna Coşereni" },
    { code: "RO.22.102641", name: "Comuna Drăgoeşti" },
    { code: "RO.22.102703", name: "Comuna Dridu" },
    { code: "RO.22.102749", name: "Oraş Fierbinţi-Târg" },
    { code: "RO.22.103283", name: "Comuna Gârbovi" },
    { code: "RO.22.103862", name: "Comuna Ion Roată" },
    { code: "RO.22.103960", name: "Comuna Jilavele" },
    { code: "RO.22.104270", name: "Comuna Moviliţa" },
    { code: "RO.22.105026", name: "Comuna Sinteşti" },
    { code: "RO.22.105794", name: "Comuna Valea Măcrişului" },
    { code: "RO.22.179702", name: "Comuna Traian" },
    { code: "RO.22.179784", name: "Comuna Borăneşti" },
    { code: "RO.22.179793", name: "Comuna Bueşti" },
    { code: "RO.22.179800", name: "Comuna Maia" },
    { code: "RO.22.179819", name: "Comuna Ograda" },
    { code: "RO.22.179828", name: "Comuna Roşiori" },
    { code: "RO.22.179971", name: "Comuna Colelia" },
    { code: "RO.22.179980", name: "Comuna Mărculeşti" },
    { code: "RO.22.179999", name: "Comuna Moldoveni" },
    { code: "RO.22.180000", name: "Comuna Platoneşti" },
    { code: "RO.22.180019", name: "Comuna Sărăţeni" },
    { code: "RO.22.180046", name: "Comuna Gura Ialomiţei" },
    { code: "RO.22.180064", name: "Comuna Bărbuleşti" },
    { code: "RO.22.92658", name: "Comuna Slobozia" },
    { code: "RO.22.92701", name: "Municipiul Feteşti" },
    { code: "RO.22.92765", name: "Oraş Ţãndãrei" },
    { code: "RO.22.92783", name: "Comuna Albeşti" },
    { code: "RO.22.92836", name: "Oraş Amara" },
    { code: "RO.22.92872", name: "Comuna Andrăşeşti" },
    { code: "RO.22.92907", name: "Comuna Balaciu" },
    { code: "RO.22.92989", name: "Comuna Borduşani" },
    { code: "RO.22.93021", name: "Comuna Bucu" },
    { code: "RO.22.93067", name: "Oraş Cãzãneşti" },
    { code: "RO.22.93101", name: "Comuna Ciochina" },
    { code: "RO.22.93156", name: "Comuna Ciulniţa" },
    { code: "RO.22.93209", name: "Comuna Cocora" },
    { code: "RO.22.93236", name: "Comuna Cosâmbeşti" },
    { code: "RO.22.93575", name: "Comuna Făcăeni" },
    { code: "RO.22.93600", name: "Comuna Gheorghe Doja" },
    { code: "RO.22.93628", name: "Comuna Gheorghe Lazăr" },
    { code: "RO.22.93646", name: "Comuna Giurgeni" },
    { code: "RO.22.93717", name: "Comuna Grindu" },
    { code: "RO.22.93735", name: "Comuna Griviţa" },
    { code: "RO.22.93995", name: "Comuna Mihail Kogălniceanu" },
    { code: "RO.22.94045", name: "Comuna Miloşeşti" },
    { code: "RO.22.94081", name: "Comuna Movila" },
    { code: "RO.22.94107", name: "Comuna Munteni Buzău" },
    { code: "RO.22.94161", name: "Comuna Perieţi" },
    { code: "RO.22.94269", name: "Comuna Reviga" },
    { code: "RO.22.94330", name: "Comuna Sălcioara" },
    { code: "RO.22.94376", name: "Comuna Săveni" },
    { code: "RO.22.94429", name: "Comuna Scânteia" },
    { code: "RO.22.94456", name: "Comuna Sfântu Gheorghe" },
    { code: "RO.22.94492", name: "Comuna Stelnica" },
    { code: "RO.22.94535", name: "Comuna Sudiţi" },
    { code: "RO.22.94688", name: "Comuna Valea Ciorii" },
    { code: "RO.22.94795", name: "Comuna Vlădeni" },
  ],
  "RO.23": [
    { code: "RO.23.100004", name: "Comuna Victoria" },
    { code: "RO.23.100086", name: "Comuna Vânãtori" },
    { code: "RO.23.100148", name: "Comuna Vlădeni" },
    { code: "RO.23.100219", name: "Comuna Voineşti" },
    { code: "RO.23.100273", name: "Comuna Balş" },
    { code: "RO.23.100282", name: "Comuna Costeşti" },
    { code: "RO.23.100308", name: "Comuna Drăguşeni" },
    { code: "RO.23.100317", name: "Comuna Fântânele" },
    { code: "RO.23.100326", name: "Comuna Hărmăneşti" },
    { code: "RO.23.100335", name: "Comuna Răchiţeni" },
    { code: "RO.23.100344", name: "Comuna Roşcani" },
    { code: "RO.23.100353", name: "Comuna Valea Lupului" },
    { code: "RO.23.100362", name: "Comuna Ciohorãni" },
    { code: "RO.23.95060", name: "Municipiul Iaşi" },
    { code: "RO.23.95088", name: "Comuna Bârnova" },
    { code: "RO.23.95159", name: "Comuna Holboca" },
    { code: "RO.23.95239", name: "Comuna Rediu-Tătar" },
    { code: "RO.23.95293", name: "Comuna Tomeşti" },
    { code: "RO.23.95355", name: "Oraş Hârlãu" },
    { code: "RO.23.95391", name: "Municipiul Paşcani" },
    { code: "RO.23.95471", name: "Oraş Târgu Frumos" },
    { code: "RO.23.95499", name: "Comuna Ion Neculce" },
    { code: "RO.23.95612", name: "Comuna Alexandru I. Cuza" },
    { code: "RO.23.95667", name: "Comuna Andrieşeni" },
    { code: "RO.23.95747", name: "Comuna Aroneanu" },
    { code: "RO.23.95792", name: "Comuna Bălţaţi" },
    { code: "RO.23.95872", name: "Comuna Belceşti" },
    { code: "RO.23.95943", name: "Comuna Bivolari" },
    { code: "RO.23.96003", name: "Comuna Ungheni" },
    { code: "RO.23.96058", name: "Comuna Brăeşti" },
    { code: "RO.23.96110", name: "Comuna Butea" },
    { code: "RO.23.96147", name: "Comuna Cepleniţa" },
    { code: "RO.23.96192", name: "Comuna Ciorteşti" },
    { code: "RO.23.96254", name: "Comuna Ciurea" },
    { code: "RO.23.96334", name: "Comuna Coarnele Caprei" },
    { code: "RO.23.96370", name: "Comuna Comarna" },
    { code: "RO.23.96423", name: "Comuna Costuleni" },
    { code: "RO.23.96478", name: "Comuna Cotnari" },
    { code: "RO.23.96593", name: "Comuna Cozmeşti" },
    { code: "RO.23.96637", name: "Comuna Cristeşti" },
    { code: "RO.23.96664", name: "Comuna Cucuteni" },
    { code: "RO.23.96717", name: "Comuna Dagâţa" },
    { code: "RO.23.96815", name: "Comuna Deleni" },
    { code: "RO.23.96888", name: "Comuna Dobrovăţ" },
    { code: "RO.23.96904", name: "Comuna Dolheşti" },
    { code: "RO.23.96940", name: "Comuna Dumeşti" },
    { code: "RO.23.97009", name: "Comuna Erbiceni" },
    { code: "RO.23.97063", name: "Comuna Focuri" },
    { code: "RO.23.97090", name: "Comuna Golãieşti" },
    { code: "RO.23.97189", name: "Comuna Gorban" },
    { code: "RO.23.97241", name: "Comuna Grajduri" },
    { code: "RO.23.97321", name: "Comuna Gropniţa" },
    { code: "RO.23.97394", name: "Comuna Grozeşti" },
    { code: "RO.23.97438", name: "Comuna Hălăuceşti" },
    { code: "RO.23.97465", name: "Comuna Heleşteni" },
    { code: "RO.23.97517", name: "Comuna Horleşti" },
    { code: "RO.23.97553", name: "Comuna Ipatele" },
    { code: "RO.23.97606", name: "Comuna Lespezi" },
    { code: "RO.23.97679", name: "Comuna Leţcani" },
    { code: "RO.23.97722", name: "Comuna Lungani" },
    { code: "RO.23.97777", name: "Comuna Mădârjac" },
    { code: "RO.23.97811", name: "Comuna Mirceşti" },
    { code: "RO.23.97875", name: "Comuna Mironeasa" },
    { code: "RO.23.97919", name: "Comuna Miroslava" },
    { code: "RO.23.98051", name: "Comuna Mirosloveşti" },
    { code: "RO.23.98113", name: "Comuna Mogoşeşti" },
    { code: "RO.23.98168", name: "Comuna Mogoşeşti-Siret" },
    { code: "RO.23.98202", name: "Comuna Moşna" },
    { code: "RO.23.98220", name: "Comuna Moţca" },
    { code: "RO.23.98257", name: "Comuna Movileni" },
    { code: "RO.23.98300", name: "Comuna Oţeleni" },
    { code: "RO.23.98337", name: "Comuna Plugari" },
    { code: "RO.23.98373", name: "Oraş Podu Iloaiei" },
    { code: "RO.23.98435", name: "Comuna Popeşti" },
    { code: "RO.23.98505", name: "Comuna Popricani" },
    { code: "RO.23.98603", name: "Comuna Prisăcani" },
    { code: "RO.23.98649", name: "Comuna Probota" },
    { code: "RO.23.98685", name: "Comuna Răducăneni" },
    { code: "RO.23.98738", name: "Comuna Româneşti" },
    { code: "RO.23.98774", name: "Comuna Ruginoasa" },
    { code: "RO.23.98827", name: "Comuna Schitu-Duca" },
    { code: "RO.23.98916", name: "Comuna Scânteia" },
    { code: "RO.23.98998", name: "Comuna Scobinţi" },
    { code: "RO.23.99058", name: "Comuna Sineşti" },
    { code: "RO.23.99101", name: "Comuna Sireţel" },
    { code: "RO.23.99165", name: "Comuna Stolniceni-Prăjescu" },
    { code: "RO.23.99209", name: "Comuna Strunga" },
    { code: "RO.23.99290", name: "Comuna Scheia" },
    { code: "RO.23.99370", name: "Comuna Şipote" },
    { code: "RO.23.99441", name: "Comuna Tansa" },
    { code: "RO.23.99478", name: "Comuna Tătăruşi" },
    { code: "RO.23.99539", name: "Comuna Todireşti" },
    { code: "RO.23.99600", name: "Comuna Trifeşti" },
    { code: "RO.23.99673", name: "Comuna Ţibana" },
    { code: "RO.23.99780", name: "Comuna Ţibăneşti" },
    { code: "RO.23.99879", name: "Comuna Ţigănaşi" },
    { code: "RO.23.99922", name: "Comuna Ţuţora" },
    { code: "RO.23.99968", name: "Comuna Valea Seacă" },
  ],
  "RO.25": [
    { code: "RO.25.106318", name: "Municipiul Baia Mare" },
    { code: "RO.25.106363", name: "Comuna Groşi" },
    { code: "RO.25.106407", name: "Comuna Recea" },
    { code: "RO.25.106461", name: "Oraș Tăuţii-Măgherăuş" },
    { code: "RO.25.106559", name: "Municipiul Sighetu Marmaţiei" },
    { code: "RO.25.106620", name: "Comuna Sărăsău" },
    { code: "RO.25.106648", name: "Comuna Vadu Izei" },
    { code: "RO.25.106684", name: "Oraş Baia Sprie" },
    { code: "RO.25.106746", name: "Oraş Borşa" },
    { code: "RO.25.106782", name: "Oraș Cavnic" },
    { code: "RO.25.106817", name: "Oraș Târgu Lăpuş" },
    { code: "RO.25.106979", name: "Oraş Vişeu De Sus" },
    { code: "RO.25.107001", name: "Comuna Ardusat" },
    { code: "RO.25.107047", name: "Comuna Ariniş" },
    { code: "RO.25.107083", name: "Comuna Asuaju de Sus" },
    { code: "RO.25.107118", name: "Comuna Băiţa de sub Codru" },
    { code: "RO.25.107154", name: "Comuna Băiuţ" },
    { code: "RO.25.107190", name: "Comuna Băseşti" },
    { code: "RO.25.107234", name: "Comuna Bicaz" },
    { code: "RO.25.107270", name: "Comuna Bistra" },
    { code: "RO.25.107314", name: "Comuna Bârsana" },
    { code: "RO.25.107350", name: "Comuna Bocicoiu Mare" },
    { code: "RO.25.107403", name: "Comuna Bogdan Vodă" },
    { code: "RO.25.107430", name: "Comuna Boiu Mare" },
    { code: "RO.25.107485", name: "Comuna Botiza" },
    { code: "RO.25.107519", name: "Comuna Budeşti" },
    { code: "RO.25.107546", name: "Comuna Călineşti" },
    { code: "RO.25.107582", name: "Comuna Cerneşti" },
    { code: "RO.25.107662", name: "Comuna Cicârlău" },
    { code: "RO.25.107715", name: "Comuna Câmpulung la Tisa" },
    { code: "RO.25.107733", name: "Comuna Copalnic Mănăştur" },
    { code: "RO.25.107868", name: "Comuna Coroieni" },
    { code: "RO.25.107920", name: "Comuna Cupşeni" },
    { code: "RO.25.107975", name: "Comuna Deseşti" },
    { code: "RO.25.108017", name: "Oraș Dragomireşti" },
    { code: "RO.25.108035", name: "Comuna Dumbrăviţa" },
    { code: "RO.25.108106", name: "Comuna Fărcaşa" },
    { code: "RO.25.108151", name: "Comuna Giuleşti" },
    { code: "RO.25.108204", name: "Comuna Ieud" },
    { code: "RO.25.108222", name: "Comuna Lăpuş" },
    { code: "RO.25.108240", name: "Comuna Leordina" },
    { code: "RO.25.108268", name: "Comuna Mireşu Mare" },
    { code: "RO.25.108348", name: "Comuna Moisei" },
    { code: "RO.25.108366", name: "Comuna Oarţa De Jos" },
    { code: "RO.25.108400", name: "Comuna Ocna Şugatag" },
    { code: "RO.25.108455", name: "Comuna Petrova" },
    { code: "RO.25.108473", name: "Comuna Poienile de sub Munte" },
    { code: "RO.25.108491", name: "Comuna Remetea Chioarului" },
    { code: "RO.25.108552", name: "Comuna Remeţi" },
    { code: "RO.25.108598", name: "Comuna Repedea" },
    { code: "RO.25.108614", name: "Comuna Rona de Jos" },
    { code: "RO.25.108632", name: "Comuna Rona de Sus" },
    { code: "RO.25.108669", name: "Comuna Rozavlea" },
    { code: "RO.25.108696", name: "Comuna Ruşcova" },
    { code: "RO.25.108712", name: "Comuna Satulung" },
    { code: "RO.25.108794", name: "Comuna Săcălăşeni" },
    { code: "RO.25.108874", name: "Comuna Săcel" },
    { code: "RO.25.108892", name: "Oraș Săliştea de Sus" },
    { code: "RO.25.108918", name: "Comuna Sălsig" },
    { code: "RO.25.108945", name: "Comuna Sãpânţa" },
    { code: "RO.25.108963", name: "Oraș Seini" },
    { code: "RO.25.109005", name: "Comuna Strâmtura" },
    { code: "RO.25.109041", name: "Comuna Suciu de Sus" },
    { code: "RO.25.109096", name: "Comuna Şişeşti" },
    { code: "RO.25.109176", name: "Oraș Şomcuta Mare" },
    { code: "RO.25.109265", name: "Oraş Ulmeni" },
    { code: "RO.25.109354", name: "Comuna Valea Chioarului" },
    { code: "RO.25.109425", name: "Comuna Vima Micã" },
    { code: "RO.25.109504", name: "Comuna Vişeu de Jos" },
    { code: "RO.25.179604", name: "Comuna Poienile Izei" },
    { code: "RO.25.179613", name: "Comuna Şieu" },
    { code: "RO.25.179622", name: "Comuna Groşii Ţibleşului" },
    { code: "RO.25.179837", name: "Comuna Coaş" },
    { code: "RO.25.179846", name: "Comuna Coltãu" },
    { code: "RO.25.179855", name: "Comuna Gârdani" },
    { code: "RO.25.179864", name: "Comuna Onceşti" },
  ],
  "RO.26": [
    { code: "RO.26.109773", name: "Municipiul Drobeta-Turnu Severin" },
    { code: "RO.26.109826", name: "Comuna Simian" },
    { code: "RO.26.109924", name: "Oraş Baia De Aramã" },
    { code: "RO.26.110027", name: "Comuna Obârşia-Cloşani" },
    { code: "RO.26.110063", name: "Municipiul Orşova" },
    { code: "RO.26.110116", name: "Oraş Strehaia" },
    { code: "RO.26.110232", name: "Oraş Vânju Mare" },
    { code: "RO.26.110296", name: "Comuna Bala" },
    { code: "RO.26.110456", name: "Comuna Balta" },
    { code: "RO.26.110535", name: "Comuna Bălăciţa" },
    { code: "RO.26.110571", name: "Comuna Bâcleş" },
    { code: "RO.26.110688", name: "Comuna Bâlvăneşti" },
    { code: "RO.26.110740", name: "Comuna Brezniţa-Motru" },
    { code: "RO.26.110820", name: "Comuna Brezniţa Ocol" },
    { code: "RO.26.110875", name: "Comuna Broşteni" },
    { code: "RO.26.110946", name: "Comuna Burila Mare" },
    { code: "RO.26.111006", name: "Comuna Butoieşti" },
    { code: "RO.26.111097", name: "Comuna Căzăneşti" },
    { code: "RO.26.111220", name: "Comuna Cireşu" },
    { code: "RO.26.111275", name: "Comuna Corcova" },
    { code: "RO.26.111417", name: "Comuna Corlăţel" },
    { code: "RO.26.111444", name: "Comuna Cujmir" },
    { code: "RO.26.111480", name: "Comuna Devesel" },
    { code: "RO.26.111550", name: "Comuna Dârvari" },
    { code: "RO.26.111587", name: "Comuna Dumbrava" },
    { code: "RO.26.111685", name: "Comuna Floreşti" },
    { code: "RO.26.111783", name: "Comuna Gârla Mare" },
    { code: "RO.26.111818", name: "Comuna Godeanu" },
    { code: "RO.26.111863", name: "Comuna Gogoşu" },
    { code: "RO.26.111916", name: "Comuna Greci" },
    { code: "RO.26.111989", name: "Comuna Grozeşti" },
    { code: "RO.26.112030", name: "Comuna Gruia" },
    { code: "RO.26.112076", name: "Comuna Hinova" },
    { code: "RO.26.112129", name: "Comuna Husnicioara" },
    { code: "RO.26.112245", name: "Comuna Eşelniţa" },
    { code: "RO.26.112263", name: "Comuna Ilovăt" },
    { code: "RO.26.112334", name: "Comuna Iloviţa" },
    { code: "RO.26.112370", name: "Comuna Isverna" },
    { code: "RO.26.112469", name: "Comuna Izvoru Bârzii" },
    { code: "RO.26.112548", name: "Comuna Jiana" },
    { code: "RO.26.112600", name: "Comuna Livezile" },
    { code: "RO.26.112664", name: "Comuna Malovãţ" },
    { code: "RO.26.112744", name: "Comuna Obârşia De Câmp" },
    { code: "RO.26.112771", name: "Comuna Oprişor" },
    { code: "RO.26.112806", name: "Comuna Padina" },
    { code: "RO.26.112879", name: "Comuna Pătulele" },
    { code: "RO.26.112904", name: "Comuna Dubova" },
    { code: "RO.26.112959", name: "Comuna Podeni" },
    { code: "RO.26.112995", name: "Comuna Ponoarele" },
    { code: "RO.26.113153", name: "Comuna Poroina Mare" },
    { code: "RO.26.113206", name: "Comuna Pristol" },
    { code: "RO.26.113233", name: "Comuna Prunişor" },
    { code: "RO.26.113395", name: "Comuna Punghina" },
    { code: "RO.26.113466", name: "Comuna Rogova" },
    { code: "RO.26.113493", name: "Comuna Salcia" },
    { code: "RO.26.113518", name: "Comuna Stângăceaua" },
    { code: "RO.26.113607", name: "Comuna Sviniţa" },
    { code: "RO.26.113625", name: "Comuna Siseşti" },
    { code: "RO.26.113698", name: "Comuna Sovarna" },
    { code: "RO.26.113732", name: "Comuna Tâmna" },
    { code: "RO.26.113849", name: "Comuna Vânători" },
    { code: "RO.26.113894", name: "Comuna Vânjuleţ" },
    { code: "RO.26.113929", name: "Comuna Vlădaia" },
    { code: "RO.26.113974", name: "Comuna Voloiac" },
    { code: "RO.26.114060", name: "Comuna Braniştea" },
    { code: "RO.26.114079", name: "Comuna Vrata" },
  ],
  "RO.27": [
    { code: "RO.27.114319", name: "Municipiul Târgu Mureş" },
    { code: "RO.27.114355", name: "Comuna Cristeşti" },
    { code: "RO.27.114382", name: "Comuna Sâncraiu de Mureş" },
    { code: "RO.27.114417", name: "Comuna Sângeorgiu de Mureş" },
    { code: "RO.27.114453", name: "Comuna Sântana de Mureş" },
    { code: "RO.27.114514", name: "Municipiul Sighişoara" },
    { code: "RO.27.114603", name: "Comuna Albeşti" },
    { code: "RO.27.114710", name: "Oraş Luduş" },
    { code: "RO.27.114809", name: "Municipiul Reghin" },
    { code: "RO.27.114854", name: "Oraş Sovata" },
    { code: "RO.27.114925", name: "Municipiul Târnãveni" },
    { code: "RO.27.114970", name: "Comuna Acăţari" },
    { code: "RO.27.115076", name: "Comuna Adămuş" },
    { code: "RO.27.115147", name: "Comuna Aluniş" },
    { code: "RO.27.115183", name: "Comuna Apold" },
    { code: "RO.27.115236", name: "Comuna Aţintiş" },
    { code: "RO.27.115307", name: "Comuna Bahnea" },
    { code: "RO.27.115389", name: "Comuna Band" },
    { code: "RO.27.115520", name: "Comuna Batoş" },
    { code: "RO.27.115575", name: "Comuna Bãgaciu" },
    { code: "RO.27.115600", name: "Comuna Băla" },
    { code: "RO.27.115637", name: "Comuna Bălăuşeri" },
    { code: "RO.27.115708", name: "Comuna Beica De Jos" },
    { code: "RO.27.115771", name: "Comuna Bichiş" },
    { code: "RO.27.115824", name: "Comuna Bogata" },
    { code: "RO.27.115851", name: "Comuna Breaza" },
    { code: "RO.27.115897", name: "Comuna Brâncoveneşti" },
    { code: "RO.27.115959", name: "Comuna Ceuaşu De Câmpie" },
    { code: "RO.27.116046", name: "Comuna Cheţani" },
    { code: "RO.27.116126", name: "Comuna Chiheru De Jos" },
    { code: "RO.27.116171", name: "Comuna Coroisânmartin" },
    { code: "RO.27.116224", name: "Comuna Cozma" },
    { code: "RO.27.116288", name: "Comuna Crăciuneşti" },
    { code: "RO.27.116340", name: "Comuna Crãieşti" },
    { code: "RO.27.116395", name: "Comuna Cucerdea" },
    { code: "RO.27.116439", name: "Comuna Cuci" },
    { code: "RO.27.116493", name: "Comuna Daneş" },
    { code: "RO.27.116545", name: "Comuna Deda" },
    { code: "RO.27.116590", name: "Comuna Eremitu" },
    { code: "RO.27.116652", name: "Comuna Ernei" },
    { code: "RO.27.116723", name: "Comuna Fărăgău" },
    { code: "RO.27.116796", name: "Comuna Fântânele" },
    { code: "RO.27.116867", name: "Comuna Găleşti" },
    { code: "RO.27.116938", name: "Comuna Găneşti" },
    { code: "RO.27.116983", name: "Comuna Gheorghe Doja" },
    { code: "RO.27.117042", name: "Comuna Ghindari" },
    { code: "RO.27.117113", name: "Comuna Glodeni" },
    { code: "RO.27.117177", name: "Comuna Gorneşti" },
    { code: "RO.27.117275", name: "Comuna Grebenişu de Câmpie" },
    { code: "RO.27.117319", name: "Comuna Gurghiu" },
    { code: "RO.27.117426", name: "Comuna Hodac" },
    { code: "RO.27.117505", name: "Comuna Hodoşa" },
    { code: "RO.27.117550", name: "Comuna Ibăneşti Pădure" },
    { code: "RO.27.117667", name: "Comuna Iclănzel" },
    { code: "RO.27.117783", name: "Comuna Ideciu de Jos" },
    { code: "RO.27.117827", name: "Oraş Iernut" },
    { code: "RO.27.117925", name: "Comuna Livezeni" },
    { code: "RO.27.117998", name: "Comuna Lunca" },
    { code: "RO.27.118058", name: "Comuna Lunca Bradului" },
    { code: "RO.27.118094", name: "Comuna Măgherani" },
    { code: "RO.27.118209", name: "Comuna Mica" },
    { code: "RO.27.118281", name: "Oraş Miercurea Nirajului" },
    { code: "RO.27.118370", name: "Comuna Miheşu de Câmpie" },
    { code: "RO.27.118469", name: "Comuna Nadeş" },
    { code: "RO.27.118511", name: "Comuna Neaua" },
    { code: "RO.27.118575", name: "Comuna Ogra" },
    { code: "RO.27.118637", name: "Comuna Papiu Ilarian" },
    { code: "RO.27.118691", name: "Comuna Pănet" },
    { code: "RO.27.118753", name: "Comuna Păsăreni" },
    { code: "RO.27.118799", name: "Comuna Petelea" },
    { code: "RO.27.118824", name: "Comuna Pogăceaua" },
    { code: "RO.27.118931", name: "Comuna Răstoliţa" },
    { code: "RO.27.118995", name: "Comuna Râciu" },
    { code: "RO.27.119153", name: "Comuna Ruşii Munţi" },
    { code: "RO.27.119206", name: "Comuna Saschiz" },
    { code: "RO.27.119242", name: "Oraş Sarmaşu" },
    { code: "RO.27.119331", name: "Oraş   Sângeorgiu De Pãdure" },
    { code: "RO.27.119386", name: "Comuna Sânger" },
    { code: "RO.27.119466", name: "Comuna Sânpaul" },
    { code: "RO.27.119527", name: "Comuna Sânpetru de Câmpie" },
    { code: "RO.27.119590", name: "Comuna Solovãstru" },
    { code: "RO.27.119625", name: "Comuna Stânceni" },
    { code: "RO.27.119661", name: "Comuna Suplac" },
    { code: "RO.27.119723", name: "Comuna Suseni" },
    { code: "RO.27.119750", name: "Comuna Şăulia" },
    { code: "RO.27.119803", name: "Comuna Şincai" },
    { code: "RO.27.119858", name: "Comuna Tãureni" },
    { code: "RO.27.119894", name: "Oraş Ungheni" },
    { code: "RO.27.119974", name: "Comuna Valea Largă" },
    { code: "RO.27.120076", name: "Comuna Vărgata" },
    { code: "RO.27.120138", name: "Comuna Vătava" },
    { code: "RO.27.120174", name: "Comuna Veţca" },
    { code: "RO.27.120218", name: "Comuna Viişoara" },
    { code: "RO.27.120254", name: "Comuna Vânători" },
    { code: "RO.27.120316", name: "Comuna Voivodeni" },
    { code: "RO.27.120343", name: "Comuna Zagăr" },
    { code: "RO.27.120370", name: "Comuna Zau De Câmpie" },
    { code: "RO.27.120478", name: "Comuna Chibed" },
    { code: "RO.27.120487", name: "Comuna Corunca" },
    { code: "RO.27.120496", name: "Comuna Sărăţeni" },
    { code: "RO.27.120502", name: "Comuna Mădăraş" },
    { code: "RO.27.120511", name: "Comuna Bereni" },
  ],
  "RO.28": [
    { code: "RO.28.120726", name: "Municipiul Piatra-Neamţ" },
    { code: "RO.28.120771", name: "Comuna Dumbrava Roşie" },
    { code: "RO.28.120824", name: "Comuna Săvineşti" },
    { code: "RO.28.120860", name: "Municipiul Roman" },
    { code: "RO.28.120888", name: "Comuna Cordun" },
    { code: "RO.28.120922", name: "Comuna Horia" },
    { code: "RO.28.120968", name: "Oraş Bicaz" },
    { code: "RO.28.121055", name: "Oraş Târgu Neamţ" },
    { code: "RO.28.121108", name: "Comuna Agapia" },
    { code: "RO.28.121153", name: "Comuna Bahna" },
    { code: "RO.28.121242", name: "Comuna Bălţăteşti" },
    { code: "RO.28.121297", name: "Comuna Bicaz Chei" },
    { code: "RO.28.121340", name: "Comuna Bicazu Ardelean" },
    { code: "RO.28.121386", name: "Comuna Bâra" },
    { code: "RO.28.121466", name: "Comuna Bârgãuani" },
    { code: "RO.28.121607", name: "Comuna Bodeşti-Precista" },
    { code: "RO.28.121652", name: "Comuna Borca" },
    { code: "RO.28.121732", name: "Comuna Borleşti" },
    { code: "RO.28.121796", name: "Comuna Boteşti" },
    { code: "RO.28.121876", name: "Comuna Bozieni" },
    { code: "RO.28.121938", name: "Comuna Brusturi-Drăgăneşti" },
    { code: "RO.28.122025", name: "Comuna Ceahlău" },
    { code: "RO.28.122061", name: "Comuna Cândeşti" },
    { code: "RO.28.122132", name: "Comuna Costişa" },
    { code: "RO.28.122187", name: "Comuna Crăcăoani" },
    { code: "RO.28.122249", name: "Comuna Dămuc" },
    { code: "RO.28.122285", name: "Comuna Dobreni" },
    { code: "RO.28.122347", name: "Comuna Doljeşti" },
    { code: "RO.28.122392", name: "Comuna Dragomireşti" },
    { code: "RO.28.122463", name: "Comuna Dulceşti" },
    { code: "RO.28.122551", name: "Comuna Fărcaşa" },
    { code: "RO.28.122613", name: "Comuna Fãurei" },
    { code: "RO.28.122668", name: "Comuna Gherăeşti" },
    { code: "RO.28.122702", name: "Comuna Girov" },
    { code: "RO.28.122828", name: "Comuna Gârcina" },
    { code: "RO.28.122864", name: "Comuna Grinţieş" },
    { code: "RO.28.122908", name: "Comuna Grumăzeşti" },
    { code: "RO.28.122953", name: "Comuna Hangu" },
    { code: "RO.28.123013", name: "Comuna Icuseşti" },
    { code: "RO.28.123102", name: "Comuna Ion Creangă" },
    { code: "RO.28.123175", name: "Comuna Mărgineni" },
    { code: "RO.28.123228", name: "Comuna Moldoveni" },
    { code: "RO.28.123255", name: "Comuna Oniceni" },
    { code: "RO.28.123371", name: "Comuna Păstrăveni" },
    { code: "RO.28.123424", name: "Comuna Petricani" },
    { code: "RO.28.123479", name: "Comuna Piatra Şoimului" },
    { code: "RO.28.123521", name: "Comuna Pipirig" },
    { code: "RO.28.123601", name: "Comuna Pângăraţi" },
    { code: "RO.28.123674", name: "Comuna Podoleni" },
    { code: "RO.28.123709", name: "Comuna Poienari" },
    { code: "RO.28.123790", name: "Comuna Poiana Teiului" },
    { code: "RO.28.123914", name: "Comuna Răuceşti" },
    { code: "RO.28.123969", name: "Comuna Rãzboieni" },
    { code: "RO.28.124028", name: "Comuna Rediu" },
    { code: "RO.28.124073", name: "Comuna Români" },
    { code: "RO.28.124117", name: "Oraş Roznov" },
    { code: "RO.28.124153", name: "Comuna Sagna" },
    { code: "RO.28.124206", name: "Comuna Săbăoani" },
    { code: "RO.28.124233", name: "Comuna Secuieni" },
    { code: "RO.28.124331", name: "Comuna Stăniţa" },
    { code: "RO.28.124411", name: "Comuna Ştefan cel Mare" },
    { code: "RO.28.124493", name: "Comuna Tarcău" },
    { code: "RO.28.124563", name: "Comuna Taşca" },
    { code: "RO.28.124616", name: "Comuna Tazlău" },
    { code: "RO.28.124634", name: "Comuna Tămăşeni" },
    { code: "RO.28.124661", name: "Comuna Timişeşti" },
    { code: "RO.28.124723", name: "Comuna Trifeşti" },
    { code: "RO.28.124750", name: "Comuna Tupilaţi" },
    { code: "RO.28.124803", name: "Comuna Ţibucani" },
    { code: "RO.28.124849", name: "Comuna Urecheni" },
    { code: "RO.28.124885", name: "Comuna Valea Ursului" },
    { code: "RO.28.124938", name: "Comuna Alexandru Cel Bun" },
    { code: "RO.28.125016", name: "Comuna Vânători Neamţ" },
    { code: "RO.28.125061", name: "Comuna Zăneşti" },
    { code: "RO.28.125098", name: "Comuna Dochia" },
    { code: "RO.28.125105", name: "Comuna Ruginoasa" },
    { code: "RO.28.125114", name: "Comuna Ghindăoani" },
    { code: "RO.28.125123", name: "Comuna Văleni" },
    { code: "RO.28.125132", name: "Comuna Drăgăneşti" },
    { code: "RO.28.125141", name: "Comuna Pânceşti" },
    { code: "RO.28.125150", name: "Comuna Gâdinţi" },
    { code: "RO.28.125169", name: "Comuna Negreşti" },
    { code: "RO.28.125178", name: "Comuna Boghicea" },
  ],
  "RO.29": [
    { code: "RO.29.125347", name: "Municipiul Slatina" },
    { code: "RO.29.125374", name: "Comuna Slătioara" },
    { code: "RO.29.125418", name: "Oraş Balş" },
    { code: "RO.29.125472", name: "Municipiul Caracal" },
    { code: "RO.29.125490", name: "Comuna Drăghiceni" },
    { code: "RO.29.125542", name: "Oraş Corabia" },
    { code: "RO.29.125588", name: "Comuna Gârcov" },
    { code: "RO.29.125622", name: "Oraş Drãgãneşti-Olt" },
    { code: "RO.29.125659", name: "Comuna Băbiciu" },
    { code: "RO.29.125677", name: "Comuna Baldovineşti" },
    { code: "RO.29.125757", name: "Comuna Bãrãşti" },
    { code: "RO.29.125846", name: "Comuna Bârza" },
    { code: "RO.29.125873", name: "Comuna Bobiceşti" },
    { code: "RO.29.125962", name: "Comuna Brastavăţu" },
    { code: "RO.29.125999", name: "Comuna Brebeni" },
    { code: "RO.29.126022", name: "Comuna Brâncoveni" },
    { code: "RO.29.126077", name: "Comuna Bucinişu" },
    { code: "RO.29.126102", name: "Comuna Cezieni" },
    { code: "RO.29.126148", name: "Comuna Cilieni" },
    { code: "RO.29.126166", name: "Comuna Cârlogani" },
    { code: "RO.29.126228", name: "Comuna Coloneşti" },
    { code: "RO.29.126326", name: "Comuna Corbu" },
    { code: "RO.29.126380", name: "Comuna Coteana" },
    { code: "RO.29.126406", name: "Comuna Crâmpoia" },
    { code: "RO.29.126433", name: "Comuna Curtişoara" },
    { code: "RO.29.126503", name: "Comuna Cungrea" },
    { code: "RO.29.126585", name: "Comuna Dăneasa" },
    { code: "RO.29.126647", name: "Comuna Deveselu" },
    { code: "RO.29.126674", name: "Comuna Dobreţu" },
    { code: "RO.29.126718", name: "Comuna Dobrosloveni" },
    { code: "RO.29.126772", name: "Comuna Dobroteasa" },
    { code: "RO.29.126825", name: "Comuna Dobrun" },
    { code: "RO.29.126905", name: "Comuna Făgeţelu" },
    { code: "RO.29.126978", name: "Comuna Fălcoiu" },
    { code: "RO.29.127019", name: "Comuna Fărcaşele" },
    { code: "RO.29.127064", name: "Comuna Găneasa" },
    { code: "RO.29.127126", name: "Comuna Giuvărăşti" },
    { code: "RO.29.127144", name: "Comuna Gostavăţu" },
    { code: "RO.29.127171", name: "Comuna Grãdinari" },
    { code: "RO.29.127224", name: "Comuna Grojdibodu" },
    { code: "RO.29.127251", name: "Comuna Ianca" },
    { code: "RO.29.127288", name: "Comuna Iancu Jianu" },
    { code: "RO.29.127322", name: "Comuna Icoana" },
    { code: "RO.29.127368", name: "Comuna Izbiceni" },
    { code: "RO.29.127386", name: "Comuna Izvoarele" },
    { code: "RO.29.127411", name: "Comuna Leleasca" },
    { code: "RO.29.127493", name: "Comuna Mărunţei" },
    { code: "RO.29.127536", name: "Comuna Mihăeşti" },
    { code: "RO.29.127563", name: "Comuna Milcov" },
    { code: "RO.29.127625", name: "Comuna Morunglav" },
    { code: "RO.29.127689", name: "Comuna Movileni" },
    { code: "RO.29.127714", name: "Comuna Nicolae Titulescu" },
    { code: "RO.29.127750", name: "Comuna Obârşia" },
    { code: "RO.29.127812", name: "Comuna Oboga" },
    { code: "RO.29.127858", name: "Comuna Oporelu" },
    { code: "RO.29.127901", name: "Comuna Optaşi-Mãgura" },
    { code: "RO.29.127938", name: "Comuna Orlea" },
    { code: "RO.29.127983", name: "Comuna Osica de Sus" },
    { code: "RO.29.128052", name: "Comuna Perieţi" },
    { code: "RO.29.128105", name: "Oraş Piatra-Olt" },
    { code: "RO.29.128178", name: "Comuna Pârşcoveni" },
    { code: "RO.29.128221", name: "Comuna Pleşoiu" },
    { code: "RO.29.128301", name: "Comuna Poboru" },
    { code: "RO.29.128374", name: "Oraş Potcoava" },
    { code: "RO.29.128436", name: "Comuna Priseaca" },
    { code: "RO.29.128472", name: "Comuna Radomireşti" },
    { code: "RO.29.128524", name: "Comuna Redea" },
    { code: "RO.29.128560", name: "Comuna Rotunda" },
    { code: "RO.29.128588", name: "Comuna Rusăneşti" },
    { code: "RO.29.128613", name: "Comuna Scărişoara" },
    { code: "RO.29.128659", name: "Comuna Schitu" },
    { code: "RO.29.128711", name: "Oraş Scorniceşti" },
    { code: "RO.29.128864", name: "Comuna Seaca" },
    { code: "RO.29.128882", name: "Comuna Sâmbureşti" },
    { code: "RO.29.128962", name: "Comuna Spineni" },
    { code: "RO.29.129040", name: "Comuna Sprâncenata" },
    { code: "RO.29.129095", name: "Comuna Stoeneşti" },
    { code: "RO.29.129111", name: "Comuna Stoicăneşti" },
    { code: "RO.29.129139", name: "Comuna Strejeşti" },
    { code: "RO.29.129184", name: "Comuna Studina" },
    { code: "RO.29.129246", name: "Comuna Şerbăneşti" },
    { code: "RO.29.129282", name: "Comuna Ştefan cel Mare" },
    { code: "RO.29.129317", name: "Comuna Tătuleşti" },
    { code: "RO.29.129380", name: "Comuna Teslui" },
    { code: "RO.29.129460", name: "Comuna Tia Mare" },
    { code: "RO.29.129503", name: "Comuna Topana" },
    { code: "RO.29.129567", name: "Comuna Traian" },
    { code: "RO.29.129585", name: "Comuna Tufeni" },
    { code: "RO.29.129629", name: "Comuna Urzica" },
    { code: "RO.29.129656", name: "Comuna Valea Mare" },
    { code: "RO.29.129718", name: "Comuna Vădastra" },
    { code: "RO.29.129745", name: "Comuna Vădăstriţa" },
    { code: "RO.29.129763", name: "Comuna Văleni" },
    { code: "RO.29.129816", name: "Comuna Verguleasa" },
    { code: "RO.29.129898", name: "Comuna Vişina" },
    { code: "RO.29.129914", name: "Comuna Vitomireşti" },
    { code: "RO.29.129987", name: "Comuna Vâlcele" },
    { code: "RO.29.130026", name: "Comuna Vlădila" },
    { code: "RO.29.130062", name: "Comuna Voineasa" },
    { code: "RO.29.130124", name: "Comuna Vulpeni" },
    { code: "RO.29.130231", name: "Comuna Vultureşti" },
    { code: "RO.29.130286", name: "Comuna Bălteni" },
    { code: "RO.29.130295", name: "Comuna Cãlui" },
    { code: "RO.29.130302", name: "Comuna Găvăneşti" },
    { code: "RO.29.130311", name: "Comuna Ghimpeţeni" },
    { code: "RO.29.130320", name: "Comuna Grãdinile" },
    { code: "RO.29.130339", name: "Comuna Gura Padinii" },
    { code: "RO.29.130348", name: "Comuna Ipotesti" },
    { code: "RO.29.130357", name: "Comuna Osica de Jos" },
    { code: "RO.29.130366", name: "Comuna Sârbii-Măgura" },
    { code: "RO.29.130375", name: "Comuna Vişina Nouă" },
    { code: "RO.29.130384", name: "Comuna Şopârliţa" },
  ],
  "RO.30": [
    { code: "RO.30.130534", name: "Municipiul Ploieşti" },
    { code: "RO.30.130552", name: "Comuna Bărcăneşti" },
    { code: "RO.30.130614", name: "Comuna Berceni" },
    { code: "RO.30.130678", name: "Comuna Blejoi" },
    { code: "RO.30.130712", name: "Comuna Brazi" },
    { code: "RO.30.130785", name: "Comuna Bucov" },
    { code: "RO.30.130847", name: "Comuna Păuleşti" },
    { code: "RO.30.130892", name: "Comuna Târgşoru Vechi" },
    { code: "RO.30.130954", name: "Oraş Azuga" },
    { code: "RO.30.130981", name: "Oraş Bãicoi" },
    { code: "RO.30.131069", name: "Oraş Boldeşti-Scãeni" },
    { code: "RO.30.131103", name: "Oraş Breaza" },
    { code: "RO.30.131210", name: "Oraş Buşteni" },
    { code: "RO.30.131256", name: "Municipiul Câmpina" },
    { code: "RO.30.131274", name: "Comuna Poiana Câmpina" },
    { code: "RO.30.131336", name: "Oraş Comarnic" },
    { code: "RO.30.131407", name: "Oraş Mizil" },
    { code: "RO.30.131443", name: "Oraş Plopeni" },
    { code: "RO.30.131461", name: "Comuna Dumbrãveşti" },
    { code: "RO.30.131540", name: "Oraş Sinaia" },
    { code: "RO.30.131577", name: "Oraş Slãnic" },
    { code: "RO.30.131620", name: "Oraş Urlaţi" },
    { code: "RO.30.131817", name: "Oraş Vãlenii De Munte" },
    { code: "RO.30.131835", name: "Comuna Gura Vitioarei" },
    { code: "RO.30.131899", name: "Comuna Adunaţi" },
    { code: "RO.30.131933", name: "Comuna Albeşti-Paleologu" },
    { code: "RO.30.131988", name: "Comuna Aluniş" },
    { code: "RO.30.132011", name: "Comuna Apostolache" },
    { code: "RO.30.132075", name: "Comuna Ariceştii-Rahtivani" },
    { code: "RO.30.132137", name: "Comuna Ariceştii Zeletin" },
    { code: "RO.30.132164", name: "Comuna Baba Ana" },
    { code: "RO.30.132226", name: "Comuna Balta Doamnei" },
    { code: "RO.30.132271", name: "Comuna Bălţeşti" },
    { code: "RO.30.132315", name: "Comuna Băneşti" },
    { code: "RO.30.132342", name: "Comuna Bertea" },
    { code: "RO.30.132379", name: "Comuna Boldeşti-Gradiştea" },
    { code: "RO.30.132404", name: "Comuna Brebu" },
    { code: "RO.30.132459", name: "Comuna Călugăreni" },
    { code: "RO.30.132486", name: "Comuna Cărbuneşti" },
    { code: "RO.30.132510", name: "Comuna Ceptura" },
    { code: "RO.30.132574", name: "Comuna Ceraşu" },
    { code: "RO.30.132645", name: "Comuna Chiojdeanca" },
    { code: "RO.30.132681", name: "Comuna Ciorani" },
    { code: "RO.30.132716", name: "Comuna Cocorãştii Mislii" },
    { code: "RO.30.132752", name: "Comuna Colceag" },
    { code: "RO.30.132805", name: "Comuna Cornu" },
    { code: "RO.30.132841", name: "Comuna Cosminele" },
    { code: "RO.30.132896", name: "Comuna Drajna de Sus" },
    { code: "RO.30.133018", name: "Comuna Drăgăneşti" },
    { code: "RO.30.133090", name: "Comuna Dumbrava" },
    { code: "RO.30.133161", name: "Comuna Filipeştii de Pădure" },
    { code: "RO.30.133214", name: "Comuna Filipeştii de Târg" },
    { code: "RO.30.133278", name: "Comuna Fântânele" },
    { code: "RO.30.133330", name: "Comuna Floreşti" },
    { code: "RO.30.133394", name: "Comuna Fulga" },
    { code: "RO.30.133429", name: "Comuna Gherghiţa" },
    { code: "RO.30.133508", name: "Comuna Gorgota" },
    { code: "RO.30.133562", name: "Comuna Gornet" },
    { code: "RO.30.133615", name: "Comuna Gornet-Cricov" },
    { code: "RO.30.133688", name: "Comuna Gura Vadului" },
    { code: "RO.30.133722", name: "Comuna Iordãcheanu" },
    { code: "RO.30.133795", name: "Comuna Izvoarele" },
    { code: "RO.30.133866", name: "Comuna Jugureni" },
    { code: "RO.30.133919", name: "Comuna Lapoş" },
    { code: "RO.30.133964", name: "Comuna Lipăneşti" },
    { code: "RO.30.134014", name: "Comuna Măgurele" },
    { code: "RO.30.134050", name: "Comuna Măgureni" },
    { code: "RO.30.134096", name: "Comuna Măneciu" },
    { code: "RO.30.134194", name: "Comuna Măneşti" },
    { code: "RO.30.134336", name: "Comuna Păcureţi" },
    { code: "RO.30.134390", name: "Comuna Plopu" },
    { code: "RO.30.134443", name: "Comuna Podenii Noi" },
    { code: "RO.30.134559", name: "Comuna Poienarii Burchii" },
    { code: "RO.30.134648", name: "Comuna Poseşti" },
    { code: "RO.30.134755", name: "Comuna Predeal-Sărari" },
    { code: "RO.30.134853", name: "Comuna Proviţa de Jos" },
    { code: "RO.30.134899", name: "Comuna Proviţa de Sus" },
    { code: "RO.30.134942", name: "Comuna Puchenii Mari" },
    { code: "RO.30.135020", name: "Comuna Râfov" },
    { code: "RO.30.135128", name: "Comuna Salcia" },
    { code: "RO.30.135146", name: "Comuna Sălciile" },
    { code: "RO.30.135164", name: "Comuna Scorţeni" },
    { code: "RO.30.135226", name: "Comuna Secăria" },
    { code: "RO.30.135244", name: "Comuna Sângeru" },
    { code: "RO.30.135315", name: "Comuna Starchiojd" },
    { code: "RO.30.135404", name: "Comuna Surani" },
    { code: "RO.30.135431", name: "Comuna Şirna" },
    { code: "RO.30.135501", name: "Comuna Şoimari" },
    { code: "RO.30.135547", name: "Comuna Şotrile" },
    { code: "RO.30.135618", name: "Comuna Ştefeşti" },
    { code: "RO.30.135654", name: "Comuna Talea" },
    { code: "RO.30.135681", name: "Comuna Tătaru" },
    { code: "RO.30.135725", name: "Comuna Teişani" },
    { code: "RO.30.135789", name: "Comuna Telega" },
    { code: "RO.30.135850", name: "Comuna Tinosu" },
    { code: "RO.30.135896", name: "Comuna Tomşani" },
    { code: "RO.30.135949", name: "Comuna Valea Călugărească" },
    { code: "RO.30.136107", name: "Comuna Valea Doftanei" },
    { code: "RO.30.136134", name: "Comuna Vărbilău" },
    { code: "RO.30.136198", name: "Comuna Vâlcăneşti" },
    { code: "RO.30.136241", name: "Comuna Cocorăştii-Colţ" },
    { code: "RO.30.136250", name: "Comuna Olari" },
    { code: "RO.30.136269", name: "Comuna Vadu Săpat" },
    { code: "RO.30.136278", name: "Comuna Bătrâni" },
  ],
  "RO.31": [
    { code: "RO.31.139704", name: "Municipiul Zalãu" },
    { code: "RO.31.139740", name: "Comuna Cehu Silvaniei" },
    { code: "RO.31.139811", name: "Oraș Jibou" },
    { code: "RO.31.139884", name: "Oraş Şimleu Silvaniei" },
    { code: "RO.31.139937", name: "Comuna Agrij" },
    { code: "RO.31.139982", name: "Comuna Almaşu" },
    { code: "RO.31.140084", name: "Comuna Băbeni" },
    { code: "RO.31.140146", name: "Comuna Bălan" },
    { code: "RO.31.140208", name: "Comuna Bănişor" },
    { code: "RO.31.140244", name: "Comuna Benesat" },
    { code: "RO.31.140280", name: "Comuna Bobota" },
    { code: "RO.31.140324", name: "Comuna Bocşa" },
    { code: "RO.31.140379", name: "Comuna Buciumi" },
    { code: "RO.31.140440", name: "Comuna Camăr" },
    { code: "RO.31.140477", name: "Comuna Carastelec" },
    { code: "RO.31.140501", name: "Comuna Chieşd" },
    { code: "RO.31.140547", name: "Comuna Cizer" },
    { code: "RO.31.140583", name: "Comuna Coşeiu" },
    { code: "RO.31.140627", name: "Comuna Crasna" },
    { code: "RO.31.140672", name: "Comuna Creaca" },
    { code: "RO.31.140770", name: "Comuna Cristolţ" },
    { code: "RO.31.140823", name: "Comuna Crişeni" },
    { code: "RO.31.140869", name: "Comuna Cuzăplac" },
    { code: "RO.31.140958", name: "Comuna Dobrin" },
    { code: "RO.31.141027", name: "Comuna Dragu" },
    { code: "RO.31.141081", name: "Comuna Fildu De Jos" },
    { code: "RO.31.141134", name: "Comuna Gâlgău" },
    { code: "RO.31.141232", name: "Comuna Gârbou" },
    { code: "RO.31.141312", name: "Comuna Halmăşd" },
    { code: "RO.31.141376", name: "Comuna Hereclean" },
    { code: "RO.31.141447", name: "Comuna Hida" },
    { code: "RO.31.141535", name: "Comuna Horoatu Crasnei" },
    { code: "RO.31.141580", name: "Comuna Ileanda" },
    { code: "RO.31.141722", name: "Comuna Ip" },
    { code: "RO.31.141786", name: "Comuna Letca" },
    { code: "RO.31.141884", name: "Comuna Lozna" },
    { code: "RO.31.141946", name: "Comuna Marca" },
    { code: "RO.31.142006", name: "Comuna Măerişte" },
    { code: "RO.31.142079", name: "Comună Meseşenii de Jos" },
    { code: "RO.31.142122", name: "Comuna Mirşid" },
    { code: "RO.31.142177", name: "Comuna Năpradea" },
    { code: "RO.31.142239", name: "Comuna Nuşfalău" },
    { code: "RO.31.142284", name: "Comuna Pericei" },
    { code: "RO.31.142337", name: "Comuna Plopiş" },
    { code: "RO.31.142373", name: "Comuna Poiana Blenchii" },
    { code: "RO.31.142426", name: "Comuna Românaşi" },
    { code: "RO.31.142499", name: "Comuna Rus" },
    { code: "RO.31.142550", name: "Comuna Sălăţig" },
    { code: "RO.31.142612", name: "Comuna Sâg" },
    { code: "RO.31.142676", name: "Comuna Sânmihaiu Almaşului" },
    { code: "RO.31.142710", name: "Comuna Someş-Odorhei" },
    { code: "RO.31.142774", name: "Comuna Surduc" },
    { code: "RO.31.142854", name: "Comuna Şamşud" },
    { code: "RO.31.142881", name: "Comuna Şărmăşag" },
    { code: "RO.31.142952", name: "Comuna Valcãu De Jos" },
    { code: "RO.31.143021", name: "Comuna Vârşolţ" },
    { code: "RO.31.143067", name: "Comuna Zalha" },
    { code: "RO.31.143147", name: "Comuna Zimbor" },
    { code: "RO.31.179631", name: "Comuna Treznea" },
    { code: "RO.31.179695", name: "Comuna Şimişna" },
    { code: "RO.31.180037", name: "Comuna Boghiş" },
  ],
  "RO.32": [
    { code: "RO.32.136483", name: "Municipiul Satu Mare" },
    { code: "RO.32.136526", name: "Municipiul Carei" },
    { code: "RO.32.136553", name: "Comuna Căpleni" },
    { code: "RO.32.136599", name: "Oraş Negreşti-Oaş" },
    { code: "RO.32.136642", name: "Oraș Tăşnad" },
    { code: "RO.32.136713", name: "Comuna Acâş" },
    { code: "RO.32.136768", name: "Comuna Andrid" },
    { code: "RO.32.136802", name: "Comuna Apa" },
    { code: "RO.32.136848", name: "Oraș Ardud" },
    { code: "RO.32.136919", name: "Comuna Bătarci" },
    { code: "RO.32.136964", name: "Comuna Beltiug" },
    { code: "RO.32.137032", name: "Comuna Berveni" },
    { code: "RO.32.137069", name: "Comuna Bixad" },
    { code: "RO.32.137103", name: "Comuna Bârsău" },
    { code: "RO.32.137130", name: "Comuna Bogdand" },
    { code: "RO.32.137185", name: "Comuna Botiz" },
    { code: "RO.32.137229", name: "Comuna Cãlineşti-Oaş" },
    { code: "RO.32.137274", name: "Comuna Cămărzana" },
    { code: "RO.32.137292", name: "Comuna Căuaş" },
    { code: "RO.32.137363", name: "Comuna Cehal" },
    { code: "RO.32.137407", name: "Comuna Certeze" },
    { code: "RO.32.137443", name: "Comuna Craidorolţ" },
    { code: "RO.32.137504", name: "Comuna Crucişor" },
    { code: "RO.32.137540", name: "Comuna Culciu" },
    { code: "RO.32.137611", name: "Comuna Doba" },
    { code: "RO.32.137675", name: "Comuna Dorolţ" },
    { code: "RO.32.137728", name: "Comuna Foieni" },
    { code: "RO.32.137746", name: "Comuna Gherţa Mică" },
    { code: "RO.32.137764", name: "Comuna Halmeu" },
    { code: "RO.32.137844", name: "Comuna Hodod" },
    { code: "RO.32.137899", name: "Comuna Homoroade" },
    { code: "RO.32.137960", name: "Comuna Lazuri" },
    { code: "RO.32.138039", name: "Oraș Livada" },
    { code: "RO.32.138084", name: "Comuna Medieşu Aurit" },
    { code: "RO.32.138164", name: "Comuna Micula" },
    { code: "RO.32.138208", name: "Comuna Moftinu" },
    { code: "RO.32.138280", name: "Comuna Odoreu" },
    { code: "RO.32.138351", name: "Comuna Oraşu Nou" },
    { code: "RO.32.138431", name: "Comuna Pãuleşti" },
    { code: "RO.32.138501", name: "Comuna Petreşti" },
    { code: "RO.32.138538", name: "Comuna Pir" },
    { code: "RO.32.138574", name: "Comuna Pişcolt" },
    { code: "RO.32.138618", name: "Comuna Pomi" },
    { code: "RO.32.138663", name: "Comuna Sanislău" },
    { code: "RO.32.138734", name: "Comuna Santău" },
    { code: "RO.32.138770", name: "Comuna Săcăşeni" },
    { code: "RO.32.138805", name: "Comuna Săuca" },
    { code: "RO.32.138869", name: "Comuna Socond" },
    { code: "RO.32.138921", name: "Comuna Supur" },
    { code: "RO.32.139009", name: "Comuna Tarna Mare" },
    { code: "RO.32.139054", name: "Comuna Terebeşti" },
    { code: "RO.32.139107", name: "Comuna Tiream" },
    { code: "RO.32.139143", name: "Comuna Târşolţ" },
    { code: "RO.32.139170", name: "Comuna Turţ" },
    { code: "RO.32.139214", name: "Comuna Turulung" },
    { code: "RO.32.139250", name: "Comuna Urziceni" },
    { code: "RO.32.139287", name: "Comuna Valea Vinului" },
    { code: "RO.32.139330", name: "Comuna Vama" },
    { code: "RO.32.139358", name: "Comuna Vetiş" },
    { code: "RO.32.139394", name: "Comuna Viile Satu Mare" },
    { code: "RO.32.179677", name: "Comuna Cãmin" },
    { code: "RO.32.179873", name: "Comuna Agriş" },
    { code: "RO.32.179882", name: "Comuna Ciumeşti" },
    { code: "RO.32.180028", name: "Comuna Porumbeşti" },
    { code: "RO.32.180091", name: "Comuna Racşa" },
  ],
  "RO.33": [
    { code: "RO.33.143450", name: "Municipiul Sibiu" },
    { code: "RO.33.143487", name: "Comuna Cristian" },
    { code: "RO.33.143502", name: "Comuna Poplaca" },
    { code: "RO.33.143520", name: "Comuna Răşinari" },
    { code: "RO.33.143557", name: "Comuna Şelimbăr" },
    { code: "RO.33.143619", name: "Municipiul Mediaş" },
    { code: "RO.33.143646", name: "Comuna Târnava" },
    { code: "RO.33.143682", name: "Oraş Agnita" },
    { code: "RO.33.143735", name: "Oraş Cisnãdie" },
    { code: "RO.33.143771", name: "Oraş Copşa Micã" },
    { code: "RO.33.143806", name: "Oraş Dumbrãveni" },
    { code: "RO.33.143851", name: "Oraş Ocna Sibiului" },
    { code: "RO.33.143888", name: "Comuna Alțâna" },
    { code: "RO.33.143922", name: "Comuna Apoldu de Jos" },
    { code: "RO.33.143959", name: "Comuna Arpaşu de Jos" },
    { code: "RO.33.143995", name: "Comuna Aţel" },
    { code: "RO.33.144054", name: "Oraş Avrig" },
    { code: "RO.33.144116", name: "Comuna Axente Sever" },
    { code: "RO.33.144152", name: "Comuna Bazna" },
    { code: "RO.33.144198", name: "Comuna Biertan" },
    { code: "RO.33.144232", name: "Comuna Bârghiş" },
    { code: "RO.33.144303", name: "Comuna Blăjel" },
    { code: "RO.33.144349", name: "Comuna Brateiu" },
    { code: "RO.33.144376", name: "Comuna Brădeni" },
    { code: "RO.33.144410", name: "Comuna Bruiu" },
    { code: "RO.33.144456", name: "Comuna Chirpăr" },
    { code: "RO.33.144508", name: "Comuna Cârţa" },
    { code: "RO.33.144535", name: "Comuna Cârţişoara" },
    { code: "RO.33.144553", name: "Comuna Dârlos" },
    { code: "RO.33.144599", name: "Comuna Gura Râului" },
    { code: "RO.33.144615", name: "Comuna Hoghilag" },
    { code: "RO.33.144651", name: "Comuna Iacobeni" },
    { code: "RO.33.144713", name: "Comuna Jina" },
    { code: "RO.33.144731", name: "Comuna Laslea" },
    { code: "RO.33.144795", name: "Comuna Loamneş" },
    { code: "RO.33.144866", name: "Comuna Ludoş" },
    { code: "RO.33.144893", name: "Comuna Marpod" },
    { code: "RO.33.144928", name: "Oraş Miercurea Sibiului" },
    { code: "RO.33.144964", name: "Comuna Merghindeal" },
    { code: "RO.33.144991", name: "Comuna Micăsasa" },
    { code: "RO.33.145042", name: "Comuna Mihăileni" },
    { code: "RO.33.145104", name: "Comuna Moşna" },
    { code: "RO.33.145140", name: "Comuna Nocrich" },
    { code: "RO.33.145202", name: "Comuna Orlat" },
    { code: "RO.33.145220", name: "Comuna Păuca" },
    { code: "RO.33.145275", name: "Comuna Poiana Sibiului" },
    { code: "RO.33.145293", name: "Comuna Porumbacu de Jos" },
    { code: "RO.33.145355", name: "Comuna Racoviţa" },
    { code: "RO.33.145382", name: "Comuna Râu Sadului" },
    { code: "RO.33.145408", name: "Comuna Roşia" },
    { code: "RO.33.145471", name: "Comuna Sadu" },
    { code: "RO.33.145499", name: "Oraş Sãlişte" },
    { code: "RO.33.145603", name: "Comuna Slimnic" },
    { code: "RO.33.145667", name: "Comuna Şeica Mare" },
    { code: "RO.33.145738", name: "Comuna Şeica Mică" },
    { code: "RO.33.145765", name: "Comuna Şura Mare" },
    { code: "RO.33.145792", name: "Comuna Şura Mică" },
    { code: "RO.33.145827", name: "Oraş Tãlmaciu" },
    { code: "RO.33.145907", name: "Comuna Tilişca" },
    { code: "RO.33.145934", name: "Comuna Turnu Roşu" },
    { code: "RO.33.145961", name: "Comuna Valea Viilor" },
    { code: "RO.33.145998", name: "Comuna Vurpăr" },
    { code: "RO.33.146012", name: "Comuna Alma" },
    { code: "RO.33.146021", name: "Comuna Boiţa" },
  ],
  "RO.34": [
    { code: "RO.34.146263", name: "Municipiul Suceava" },
    { code: "RO.34.146281", name: "Comuna Ipoteşti" },
    { code: "RO.34.146325", name: "Comuna Mitocu Dragomirnei" },
    { code: "RO.34.146370", name: "Oraş Salcea" },
    { code: "RO.34.146432", name: "Comuna Scheia" },
    { code: "RO.34.146502", name: "Municipiul Câmpulung Moldovenesc" },
    { code: "RO.34.146539", name: "Municipiul Fãlticeni" },
    { code: "RO.34.146584", name: "Oraş Gura Humorului" },
    { code: "RO.34.146628", name: "Municipiul Rãdãuţi" },
    { code: "RO.34.146655", name: "Oraş Siret" },
    { code: "RO.34.146708", name: "Oraş Solca" },
    { code: "RO.34.146744", name: "Municipiul Vatra Dornei" },
    { code: "RO.34.146799", name: "Comuna Adâncata" },
    { code: "RO.34.146860", name: "Comuna Arbore" },
    { code: "RO.34.146904", name: "Comuna Baia" },
    { code: "RO.34.146931", name: "Oraş Milişãuţi" },
    { code: "RO.34.146995", name: "Comuna Bălcăuţi" },
    { code: "RO.34.147036", name: "Comuna Bilca" },
    { code: "RO.34.147054", name: "Comuna Bogdăneşti" },
    { code: "RO.34.147072", name: "Comuna Boroaia" },
    { code: "RO.34.147134", name: "Comuna Bosanci" },
    { code: "RO.34.147161", name: "Comuna Botoşana" },
    { code: "RO.34.147205", name: "Comuna Breaza" },
    { code: "RO.34.147241", name: "Comuna Brodina" },
    { code: "RO.34.147358", name: "Oraş Broşteni" },
    { code: "RO.34.147465", name: "Comuna Buneşti" },
    { code: "RO.34.147526", name: "Comuna Cacica" },
    { code: "RO.34.147580", name: "Comuna Calafindeşti" },
    { code: "RO.34.147633", name: "Oraş Cajvana" },
    { code: "RO.34.147660", name: "Comuna Ilişeşti" },
    { code: "RO.34.147713", name: "Comuna Cârlibaba" },
    { code: "RO.34.147786", name: "Comuna Cornu Luncii" },
    { code: "RO.34.147884", name: "Comuna Crucea" },
    { code: "RO.34.147937", name: "Comuna Dărmăneşti" },
    { code: "RO.34.148006", name: "Oraş Dolhasca" },
    { code: "RO.34.148097", name: "Comuna Dolheşti" },
    { code: "RO.34.148131", name: "Comuna Dorna-Arini" },
    { code: "RO.34.148202", name: "Comuna Dorna Cândrenilor" },
    { code: "RO.34.148293", name: "Comuna Dorneşti" },
    { code: "RO.34.148328", name: "Comuna Drãgoieşti" },
    { code: "RO.34.148382", name: "Comuna Drăguşeni" },
    { code: "RO.34.148426", name: "Comuna Dumbrăveni" },
    { code: "RO.34.148453", name: "Comuna Fântânele" },
    { code: "RO.34.148514", name: "Comuna Forăşti" },
    { code: "RO.34.148612", name: "Oraş Frasin" },
    { code: "RO.34.148667", name: "Comuna Frătăuţii Noi" },
    { code: "RO.34.148694", name: "Comuna Frătăuţii Vechi" },
    { code: "RO.34.148729", name: "Comuna Frumosu" },
    { code: "RO.34.148765", name: "Comuna Fundu Moldovei" },
    { code: "RO.34.148872", name: "Comuna Gălăneşti" },
    { code: "RO.34.148916", name: "Comuna Grămeşti" },
    { code: "RO.34.148970", name: "Comuna Grăniceşti" },
    { code: "RO.34.149049", name: "Comuna Horodniceni" },
    { code: "RO.34.149101", name: "Comuna Horodnic De Jos" },
    { code: "RO.34.149138", name: "Comuna Iacobeni" },
    { code: "RO.34.149183", name: "Comuna Izvoarele Sucevei" },
    { code: "RO.34.149227", name: "Oraş Liteni" },
    { code: "RO.34.149290", name: "Comuna Marginea" },
    { code: "RO.34.149316", name: "Comuna Mălini" },
    { code: "RO.34.149370", name: "Comuna Mânăstirea Humorului" },
    { code: "RO.34.149414", name: "Comuna Moara" },
    { code: "RO.34.149502", name: "Comuna Moldova Suliţa" },
    { code: "RO.34.149539", name: "Comuna Moldoviţa" },
    { code: "RO.34.149584", name: "Comuna Muşeniţa" },
    { code: "RO.34.149655", name: "Comuna Ostra" },
    { code: "RO.34.149682", name: "Comuna Panaci" },
    { code: "RO.34.149753", name: "Comuna Păltinoasa" },
    { code: "RO.34.149780", name: "Comuna Părteştii de Jos" },
    { code: "RO.34.149833", name: "Comuna Pătrăuţi" },
    { code: "RO.34.149851", name: "Comuna Poiana Stampei" },
    { code: "RO.34.149931", name: "Comuna Pojorâta" },
    { code: "RO.34.149968", name: "Comuna Preuteşti" },
    { code: "RO.34.150043", name: "Comuna Putna" },
    { code: "RO.34.150070", name: "Comuna Rădăşeni" },
    { code: "RO.34.150114", name: "Comuna Râşca" },
    { code: "RO.34.150178", name: "Comuna Sadova" },
    { code: "RO.34.150196", name: "Comuna Satu Mare" },
    { code: "RO.34.150221", name: "Comuna Siminicea" },
    { code: "RO.34.150258", name: "Comuna Slatina" },
    { code: "RO.34.150294", name: "Comuna Straja" },
    { code: "RO.34.150310", name: "Comuna Stroieşti" },
    { code: "RO.34.150356", name: "Comuna Stulpicani" },
    { code: "RO.34.150418", name: "Comuna Suceviţa" },
    { code: "RO.34.150445", name: "Comuna Şaru Dornei" },
    { code: "RO.34.150524", name: "Comuna Todireşti" },
    { code: "RO.34.150588", name: "Comuna Udeşti" },
    { code: "RO.34.150702", name: "Comuna Ulma" },
    { code: "RO.34.150766", name: "Comuna Vadu Moldovei" },
    { code: "RO.34.150891", name: "Comuna Valea Moldovei" },
    { code: "RO.34.150935", name: "Comuna Vama" },
    { code: "RO.34.150980", name: "Comuna Vatra Moldoviţei" },
    { code: "RO.34.151022", name: "Comuna Vereşti" },
    { code: "RO.34.151077", name: "Comuna Vicovu de Jos" },
    { code: "RO.34.151095", name: "Oraş Vicovu De Sus" },
    { code: "RO.34.151120", name: "Comuna Volovăţ" },
    { code: "RO.34.151157", name: "Comuna Vultureşti" },
    { code: "RO.34.151246", name: "Comuna Zamostea" },
    { code: "RO.34.151344", name: "Comuna Zvoriştea" },
    { code: "RO.34.151433", name: "Comuna Comăneşti" },
    { code: "RO.34.151442", name: "Comuna Iaslovăţ" },
    { code: "RO.34.151451", name: "Comuna Ciocăneşti" },
    { code: "RO.34.151460", name: "Comuna Şerbăuţi" },
    { code: "RO.34.151479", name: "Comuna Horodnic De Sus" },
    { code: "RO.34.151488", name: "Comuna Fântâna Mare" },
    { code: "RO.34.151497", name: "Comuna Coşna" },
    { code: "RO.34.151503", name: "Comuna Capu Câmpului" },
    { code: "RO.34.151512", name: "Comuna Hănţeşti" },
    { code: "RO.34.151521", name: "Comuna Burla" },
    { code: "RO.34.151530", name: "Comuna Bălăceana" },
    { code: "RO.34.151549", name: "Comuna Hârtop" },
    { code: "RO.34.151558", name: "Comuna Voitinel" },
    { code: "RO.34.151567", name: "Comuna Ciprian Porumbescu" },
    { code: "RO.34.151576", name: "Comuna Berchişeşti" },
    { code: "RO.34.151585", name: "Comuna Poieni-Solca" },
  ],
  "RO.35": [
    { code: "RO.35.151683", name: "Municipiul Turnu Magurele" },
    { code: "RO.35.151709", name: "Comuna Ciuperceni" },
    { code: "RO.35.151736", name: "Comuna Islaz" },
    { code: "RO.35.151763", name: "Comuna Liţa" },
    { code: "RO.35.151790", name: "Municipiul Alexandria" },
    { code: "RO.35.151816", name: "Comuna Nanov" },
    { code: "RO.35.151834", name: "Comuna Poroschia" },
    { code: "RO.35.151870", name: "Municipiul Roșiorii de Vede" },
    { code: "RO.35.151905", name: "Oraş Videle" },
    { code: "RO.35.151932", name: "Comuna Crevenicu" },
    { code: "RO.35.151978", name: "Oraş Zimnicea" },
    { code: "RO.35.151996", name: "Comuna Balaci" },
    { code: "RO.35.152038", name: "Comuna Băbăiţa" },
    { code: "RO.35.152083", name: "Comuna Blejeşti" },
    { code: "RO.35.152127", name: "Comuna Bogdana" },
    { code: "RO.35.152172", name: "Comuna Botoroaga" },
    { code: "RO.35.152234", name: "Comuna Bragadiru" },
    { code: "RO.35.152252", name: "Comuna Brânceni" },
    { code: "RO.35.152270", name: "Comuna Bujoreni" },
    { code: "RO.35.152314", name: "Comuna Bujoru" },
    { code: "RO.35.152332", name: "Comuna Buzescu" },
    { code: "RO.35.152350", name: "Comuna Călineşti" },
    { code: "RO.35.152412", name: "Comuna Cãlmãţuiu" },
    { code: "RO.35.152467", name: "Comuna Cãlmãţuiu De Sus" },
    { code: "RO.35.152500", name: "Comuna Cervenia" },
    { code: "RO.35.152528", name: "Comuna Ciolăneşti" },
    { code: "RO.35.152564", name: "Comuna Conţeşti" },
    { code: "RO.35.152582", name: "Comuna Cosmeşti" },
    { code: "RO.35.152617", name: "Comuna Crângeni" },
    { code: "RO.35.152662", name: "Comuna Crângu" },
    { code: "RO.35.152724", name: "Comuna Dideşti" },
    { code: "RO.35.152760", name: "Comuna Dobroteşti" },
    { code: "RO.35.152797", name: "Comuna Drãcşenei" },
    { code: "RO.35.152868", name: "Comuna Drăgăneşti de Vede" },
    { code: "RO.35.152902", name: "Comuna Drăgăneşti-Vlaşca" },
    { code: "RO.35.152948", name: "Comuna Furculeşti" },
    { code: "RO.35.152993", name: "Comuna Frumoasa" },
    { code: "RO.35.153026", name: "Comuna Gălăţeni" },
    { code: "RO.35.153062", name: "Comuna Gratia" },
    { code: "RO.35.153106", name: "Comuna Izvoarele" },
    { code: "RO.35.153124", name: "Comuna Lisa" },
    { code: "RO.35.153151", name: "Comuna Lunca" },
    { code: "RO.35.153204", name: "Comuna Mavrodin" },
    { code: "RO.35.153240", name: "Comuna Măgura" },
    { code: "RO.35.153277", name: "Comuna Măldăeni" },
    { code: "RO.35.153295", name: "Comuna Mereni" },
    { code: "RO.35.153339", name: "Comuna Mârzãneşti" },
    { code: "RO.35.153384", name: "Comuna Moşteni" },
    { code: "RO.35.153400", name: "Comuna Năsturelu" },
    { code: "RO.35.153437", name: "Comuna Necşeşti" },
    { code: "RO.35.153473", name: "Comuna Olteni" },
    { code: "RO.35.153507", name: "Comuna Orbeasca" },
    { code: "RO.35.153543", name: "Comuna Peretu" },
    { code: "RO.35.153561", name: "Comuna Piatra" },
    { code: "RO.35.153589", name: "Comuna Pietroşani" },
    { code: "RO.35.153605", name: "Comuna Plosca" },
    { code: "RO.35.153623", name: "Comuna Plopii Slăviţeşti" },
    { code: "RO.35.153696", name: "Comuna Poeni" },
    { code: "RO.35.153776", name: "Comuna Vităneşti" },
    { code: "RO.35.153829", name: "Comuna Putineiu" },
    { code: "RO.35.153865", name: "Comuna Rãdoieşti" },
    { code: "RO.35.153909", name: "Comuna Răsmireşti" },
    { code: "RO.35.153936", name: "Comuna Salcia" },
    { code: "RO.35.153972", name: "Comuna Săceni" },
    { code: "RO.35.154013", name: "Comuna Scrioaştea" },
    { code: "RO.35.154068", name: "Comuna Scurtu Mare" },
    { code: "RO.35.154139", name: "Comuna Seaca" },
    { code: "RO.35.154166", name: "Comuna Sfinţeşti" },
    { code: "RO.35.154184", name: "Comuna Segarcea Vale" },
    { code: "RO.35.154228", name: "Comuna Siliştea" },
    { code: "RO.35.154282", name: "Comuna Siliștea Gumești" },
    { code: "RO.35.154308", name: "Comuna Sârbeni" },
    { code: "RO.35.154344", name: "Comuna Slobozia-Mândra" },
    { code: "RO.35.154380", name: "Comuna Smârdioasa" },
    { code: "RO.35.154415", name: "Comuna Stejaru" },
    { code: "RO.35.154460", name: "Comuna Suhaia" },
    { code: "RO.35.154497", name: "Comuna Storobăneasa" },
    { code: "RO.35.154521", name: "Comuna Talpa" },
    { code: "RO.35.154585", name: "Comuna Tătărăştii de Jos" },
    { code: "RO.35.154665", name: "Comuna Tătărăştii de Sus" },
    { code: "RO.35.154736", name: "Comuna Traian" },
    { code: "RO.35.154754", name: "Comuna Trivalea-Moşteni" },
    { code: "RO.35.154790", name: "Comuna Troianul" },
    { code: "RO.35.154834", name: "Comuna Ţigăneşti" },
    { code: "RO.35.154852", name: "Comuna Vedea" },
    { code: "RO.35.154914", name: "Comuna Viişoara" },
    { code: "RO.35.154932", name: "Comuna Vârtoape" },
    { code: "RO.35.154978", name: "Comuna Zâmbreasca" },
    { code: "RO.35.154996", name: "Comuna Nenciuleşti" },
    { code: "RO.35.155083", name: "Comuna Beciu" },
    { code: "RO.35.155092", name: "Comuna Beuca" },
    { code: "RO.35.155109", name: "Comuna Dracea" },
    { code: "RO.35.155118", name: "Comuna Fântânele" },
    { code: "RO.35.155127", name: "Comuna Frăsinet" },
    { code: "RO.35.155136", name: "Comuna Purani" },
    { code: "RO.35.155145", name: "Comuna Saelele" },
    { code: "RO.35.155154", name: "Comuna Uda-Clocociov" },
  ],
  "RO.36": [
    { code: "RO.36.155243", name: "Municipiul Timişoara" },
    { code: "RO.36.155261", name: "Comuna Dumbrăviţa" },
    { code: "RO.36.155289", name: "Comuna Ghiroda" },
    { code: "RO.36.155314", name: "Comuna Giroc" },
    { code: "RO.36.155350", name: "Municipiul Lugoj" },
    { code: "RO.36.155403", name: "Oraş Buziaş" },
    { code: "RO.36.155458", name: "Oraş Deta" },
    { code: "RO.36.155494", name: "Oraş Jimbolia" },
    { code: "RO.36.155528", name: "Oraş Sânnicolau Mare" },
    { code: "RO.36.155546", name: "Comuna Balinţ" },
    { code: "RO.36.155591", name: "Comuna Banloc" },
    { code: "RO.36.155662", name: "Comuna Bara" },
    { code: "RO.36.155724", name: "Comuna Beba Veche" },
    { code: "RO.36.155760", name: "Comuna Becicherecu Mic" },
    { code: "RO.36.155797", name: "Comuna Belinţ" },
    { code: "RO.36.155840", name: "Comuna Bethausen" },
    { code: "RO.36.155911", name: "Comuna Biled" },
    { code: "RO.36.155957", name: "Comuna Bârna" },
    { code: "RO.36.156035", name: "Comuna Bogda" },
    { code: "RO.36.156106", name: "Comuna Boldur" },
    { code: "RO.36.156151", name: "Comuna Brestovăţ" },
    { code: "RO.36.156213", name: "Comuna Cărpiniş" },
    { code: "RO.36.156259", name: "Comuna Cenad" },
    { code: "RO.36.156277", name: "Comuna Cenei" },
    { code: "RO.36.156311", name: "Comuna Chevereşu Mare" },
    { code: "RO.36.156357", name: "Oraş Ciacova" },
    { code: "RO.36.156437", name: "Comuna Comloşu Mare" },
    { code: "RO.36.156473", name: "Comuna Coşteiu" },
    { code: "RO.36.156534", name: "Comuna Criciova" },
    { code: "RO.36.156589", name: "Comuna Curtea" },
    { code: "RO.36.156623", name: "Comuna Darova" },
    { code: "RO.36.156669", name: "Comuna Denta" },
    { code: "RO.36.156712", name: "Comuna Dudeştii Vechi" },
    { code: "RO.36.156767", name: "Comuna Dumbrava" },
    { code: "RO.36.156801", name: "Oraş Fãget" },
    { code: "RO.36.156927", name: "Comuna Fârdea" },
    { code: "RO.36.157004", name: "Comuna Foeni" },
    { code: "RO.36.157031", name: "Comuna Gavojdia" },
    { code: "RO.36.157086", name: "Oraş Gãtaia" },
    { code: "RO.36.157193", name: "Comuna Ghizela" },
    { code: "RO.36.157246", name: "Comuna Giarmata" },
    { code: "RO.36.157273", name: "Comuna Giera" },
    { code: "RO.36.157317", name: "Comuna Giulvăz" },
    { code: "RO.36.157362", name: "Comuna Jamu Mare" },
    { code: "RO.36.157424", name: "Comuna Jebel" },
    { code: "RO.36.157451", name: "Comuna Lenauheim" },
    { code: "RO.36.157497", name: "Comuna Liebling" },
    { code: "RO.36.157530", name: "Comuna Lovrin" },
    { code: "RO.36.157585", name: "Comuna Margina" },
    { code: "RO.36.157683", name: "Comuna Maşloc" },
    { code: "RO.36.157736", name: "Comuna Mănăştiur" },
    { code: "RO.36.157781", name: "Comuna Moraviţa" },
    { code: "RO.36.157834", name: "Comuna Moşniţa Nouã" },
    { code: "RO.36.157898", name: "Comuna Nădrag" },
    { code: "RO.36.157923", name: "Comuna Niţchidorf" },
    { code: "RO.36.157969", name: "Comuna Ohaba Lungă" },
    { code: "RO.36.158010", name: "Comuna Orţişoara" },
    { code: "RO.36.158065", name: "Comuna Peciu Nou" },
    { code: "RO.36.158109", name: "Comuna Periam" },
    { code: "RO.36.158136", name: "Comuna Pietroasa" },
    { code: "RO.36.158181", name: "Comuna Pişchia" },
    { code: "RO.36.158243", name: "Comuna Racoviţa" },
    { code: "RO.36.158314", name: "Oraş Recaş" },
    { code: "RO.36.158396", name: "Comuna Remetea Mare" },
    { code: "RO.36.158449", name: "Comuna Sacoşu Turcesc" },
    { code: "RO.36.158528", name: "Comuna Satchinez" },
    { code: "RO.36.158564", name: "Comuna Săcălaz" },
    { code: "RO.36.158608", name: "Comuna Secaş" },
    { code: "RO.36.158653", name: "Comuna Sânandrei" },
    { code: "RO.36.158699", name: "Comuna Sânmihaiu Român" },
    { code: "RO.36.158733", name: "Comuna Sânpetru Mare" },
    { code: "RO.36.158779", name: "Comuna Şag" },
    { code: "RO.36.158804", name: "Comuna Ştiuca" },
    { code: "RO.36.158859", name: "Comuna Teremia Mare" },
    { code: "RO.36.158895", name: "Comuna Tomeşti" },
    { code: "RO.36.158966", name: "Comuna Topolovãţu Mare" },
    { code: "RO.36.159035", name: "Comuna Tormac" },
    { code: "RO.36.159071", name: "Comuna Traian Vuia" },
    { code: "RO.36.159142", name: "Comuna Uivar" },
    { code: "RO.36.159213", name: "Comuna Variaş" },
    { code: "RO.36.159259", name: "Comuna Victor Vlad Delamarina" },
    { code: "RO.36.159339", name: "Comuna Voiteg" },
    { code: "RO.36.159366", name: "Comuna Birda" },
    { code: "RO.36.159375", name: "Comuna Checea" },
    { code: "RO.36.159384", name: "Comuna Dudeştii Noi" },
    { code: "RO.36.159393", name: "Comuna Fibiş" },
    { code: "RO.36.159400", name: "Comuna Ghilad" },
    { code: "RO.36.159419", name: "Comuna Gottlob" },
    { code: "RO.36.159428", name: "Comuna Iecea Mare" },
    { code: "RO.36.159437", name: "Comuna Parţa" },
    { code: "RO.36.159446", name: "Comuna Pădureni" },
    { code: "RO.36.159455", name: "Comuna Saravale" },
    { code: "RO.36.159464", name: "Comuna Şandra" },
    { code: "RO.36.159473", name: "Comuna Tomnatic" },
    { code: "RO.36.159482", name: "Comuna Vălcani" },
    { code: "RO.36.159491", name: "Comuna Livezile" },
    { code: "RO.36.159507", name: "Comuna Pesac" },
    { code: "RO.36.159516", name: "Comuna Bucovăţ" },
    { code: "RO.36.159525", name: "Comuna Otelec" },
  ],
  "RO.37": [
    { code: "RO.37.159614", name: "Municipiul Tulcea" },
    { code: "RO.37.159650", name: "Oraş Babadag" },
    { code: "RO.37.159687", name: "Oraş Isaccea" },
    { code: "RO.37.159730", name: "Oraş Mãcin" },
    { code: "RO.37.159767", name: "Oraş Sulina" },
    { code: "RO.37.159785", name: "Comuna Baia" },
    { code: "RO.37.159847", name: "Comuna Beidaud" },
    { code: "RO.37.159883", name: "Comuna C.A. Rosetti" },
    { code: "RO.37.159945", name: "Comuna Carcaliu" },
    { code: "RO.37.159963", name: "Comuna Casimcea" },
    { code: "RO.37.160047", name: "Comuna Ceatalchioi" },
    { code: "RO.37.160092", name: "Comuna Ceamurlia de Jos" },
    { code: "RO.37.160127", name: "Comuna Cerna" },
    { code: "RO.37.160172", name: "Comuna Chilia Veche" },
    { code: "RO.37.160225", name: "Comuna Ciucurova" },
    { code: "RO.37.160261", name: "Comuna Crişan" },
    { code: "RO.37.160305", name: "Comuna Dăeni" },
    { code: "RO.37.160323", name: "Comuna Dorobanţu" },
    { code: "RO.37.160387", name: "Comuna Frecăţei" },
    { code: "RO.37.160430", name: "Comuna Greci" },
    { code: "RO.37.160458", name: "Comuna Grindu" },
    { code: "RO.37.160476", name: "Comuna Hamcearca" },
    { code: "RO.37.160528", name: "Comuna Horia" },
    { code: "RO.37.160564", name: "Comuna Izvoarele" },
    { code: "RO.37.160617", name: "Comuna Jijila" },
    { code: "RO.37.160644", name: "Comuna Jurilovca" },
    { code: "RO.37.160680", name: "Comuna Luncaviţa" },
    { code: "RO.37.160724", name: "Comuna Mahmudia" },
    { code: "RO.37.160779", name: "Comuna Maliuc" },
    { code: "RO.37.160831", name: "Comuna Mihai Bravu" },
    { code: "RO.37.160877", name: "Comuna Mihail Kogălniceanu" },
    { code: "RO.37.160911", name: "Comuna Murighiol" },
    { code: "RO.37.160993", name: "Comuna Nalbant" },
    { code: "RO.37.161035", name: "Comuna Niculiţel" },
    { code: "RO.37.161053", name: "Comuna Nufăru" },
    { code: "RO.37.161106", name: "Comuna Ostrov" },
    { code: "RO.37.161133", name: "Comuna Pardina" },
    { code: "RO.37.161151", name: "Comuna Peceneaga" },
    { code: "RO.37.161179", name: "Comuna Sarichioi" },
    { code: "RO.37.161231", name: "Comuna Sfântu Gheorghe" },
    { code: "RO.37.161259", name: "Comuna Slava Cercheză" },
    { code: "RO.37.161286", name: "Comuna Smârdan" },
    { code: "RO.37.161302", name: "Comuna Somova" },
    { code: "RO.37.161348", name: "Comuna Stejaru" },
    { code: "RO.37.161384", name: "Comuna Topolog" },
    { code: "RO.37.161464", name: "Comuna Turcoaia" },
    { code: "RO.37.161482", name: "Comuna Valea Nucarilor" },
    { code: "RO.37.161525", name: "Comuna I.C.Brãtianu" },
    { code: "RO.37.161543", name: "Comuna Văcăreni" },
    { code: "RO.37.161552", name: "Comuna Beştepe" },
    { code: "RO.37.161561", name: "Comuna Valea Teilor" },
  ],
  "RO.38": [
    { code: "RO.38.161794", name: "Municipiul Bârlad" },
    { code: "RO.38.161829", name: "Municipiul Huşi" },
    { code: "RO.38.161856", name: "Oraş Negreşti" },
    { code: "RO.38.161945", name: "Municipiul Vaslui" },
    { code: "RO.38.162014", name: "Comuna Albeşti" },
    { code: "RO.38.162069", name: "Comuna Alexandru Vlăhuţă" },
    { code: "RO.38.162149", name: "Comuna Arsura" },
    { code: "RO.38.162194", name: "Comuna Banca" },
    { code: "RO.38.162327", name: "Comuna Băcani" },
    { code: "RO.38.162381", name: "Comuna Băceşti" },
    { code: "RO.38.162452", name: "Comuna Bălteni" },
    { code: "RO.38.162498", name: "Comuna Berezeni" },
    { code: "RO.38.162559", name: "Comuna Blăgeşti" },
    { code: "RO.38.162595", name: "Comuna Bogdana" },
    { code: "RO.38.162693", name: "Comuna Bogdăneşti" },
    { code: "RO.38.162791", name: "Comuna Bogdăniţa" },
    { code: "RO.38.162871", name: "Comuna Boţeşti" },
    { code: "RO.38.162924", name: "Comuna Bunești Averești" },
    { code: "RO.38.163002", name: "Comuna Codăeşti" },
    { code: "RO.38.163057", name: "Comuna Coroieşti" },
    { code: "RO.38.163137", name: "Comuna Costeşti" },
    { code: "RO.38.163208", name: "Comuna Creţeşti" },
    { code: "RO.38.163253", name: "Comuna Dăneşti" },
    { code: "RO.38.163324", name: "Comuna Deleni" },
    { code: "RO.38.163379", name: "Comuna Deleşti" },
    { code: "RO.38.163486", name: "Comuna Dragomireşti" },
    { code: "RO.38.163618", name: "Comuna Drânceni" },
    { code: "RO.38.163681", name: "Comuna Duda  Epureni" },
    { code: "RO.38.163734", name: "Comuna Dumeşti" },
    { code: "RO.38.163789", name: "Comuna Epureni" },
    { code: "RO.38.163832", name: "Comuna Fălciu" },
    { code: "RO.38.163903", name: "Comuna Găgeşti" },
    { code: "RO.38.163967", name: "Comuna Ghergheşti" },
    { code: "RO.38.164062", name: "Comuna Gârceni" },
    { code: "RO.38.164133", name: "Comuna Griviţa" },
    { code: "RO.38.164197", name: "Comuna Hoceni" },
    { code: "RO.38.164277", name: "Comuna Dimitrie Cantemir" },
    { code: "RO.38.164339", name: "Comuna Iana" },
    { code: "RO.38.164393", name: "Comuna Ivăneşti" },
    { code: "RO.38.164543", name: "Comuna Iveşti" },
    { code: "RO.38.164598", name: "Comuna Laza" },
    { code: "RO.38.164687", name: "Comuna Lipovăţ" },
    { code: "RO.38.164749", name: "Comuna Lunca Banului" },
    { code: "RO.38.164829", name: "Comuna Măluşteni" },
    { code: "RO.38.164892", name: "Comuna Micleşti" },
    { code: "RO.38.164936", name: "Comuna Muntenii de Jos" },
    { code: "RO.38.164981", name: "Oraș Murgeni" },
    { code: "RO.38.165069", name: "Comuna Olteneşti" },
    { code: "RO.38.165130", name: "Comuna Oşeşti" },
    { code: "RO.38.165185", name: "Comuna Pădureni" },
    { code: "RO.38.165274", name: "Comuna Perieni" },
    { code: "RO.38.165336", name: "Comuna Poieneşti" },
    { code: "RO.38.165416", name: "Comuna Pogana" },
    { code: "RO.38.165470", name: "Comuna Puieşti" },
    { code: "RO.38.165611", name: "Comuna Pungeşti" },
    { code: "RO.38.165719", name: "Comuna Rebricea" },
    { code: "RO.38.165817", name: "Comuna Roşieşti" },
    { code: "RO.38.165899", name: "Comuna Soleşti" },
    { code: "RO.38.165979", name: "Comuna Stănileşti" },
    { code: "RO.38.166057", name: "Comuna Ştefan cel Mare" },
    { code: "RO.38.166137", name: "Comuna Şuletea" },
    { code: "RO.38.166182", name: "Comuna Tanacu" },
    { code: "RO.38.166235", name: "Comuna Tăcuta" },
    { code: "RO.38.166315", name: "Comuna Tătărăni" },
    { code: "RO.38.166413", name: "Comuna Todireşti" },
    { code: "RO.38.166529", name: "Comuna Tutova" },
    { code: "RO.38.166636", name: "Comuna Vãleni" },
    { code: "RO.38.166672", name: "Comuna Vetrişoaia" },
    { code: "RO.38.166707", name: "Comuna Viişoara" },
    { code: "RO.38.166770", name: "Comuna Vinderei" },
    { code: "RO.38.166869", name: "Comuna Voineşti" },
    { code: "RO.38.166985", name: "Comuna Vultureşti" },
    { code: "RO.38.167035", name: "Comuna Vutcani" },
    { code: "RO.38.167071", name: "Comuna Zăpodeni" },
    { code: "RO.38.167179", name: "Comuna Zorleni" },
    { code: "RO.38.167222", name: "Comuna Ibăneşti" },
    { code: "RO.38.167231", name: "Comuna Fruntişeni" },
    { code: "RO.38.167240", name: "Comuna Rafaila" },
    { code: "RO.38.167259", name: "Comuna Pogoneşti" },
    { code: "RO.38.167268", name: "Comuna Ciocani" },
    { code: "RO.38.167277", name: "Comuna Cozmeşti" },
    { code: "RO.38.167286", name: "Comuna Dodeşti" },
    { code: "RO.38.167295", name: "Comuna Fereşti" },
    { code: "RO.38.167302", name: "Comuna Muntenii de Sus" },
    { code: "RO.38.167311", name: "Comuna Pochidia" },
    { code: "RO.38.167320", name: "Comuna Puşcaşi" },
  ],
  "RO.39": [
    { code: "RO.39.167473", name: "Municipiul Râmnicu Vâlcea" },
    { code: "RO.39.167641", name: "Oraş Bãile Govora" },
    { code: "RO.39.167696", name: "Oraş Bãile Olãneşti" },
    { code: "RO.39.167794", name: "Oraş Brezoi" },
    { code: "RO.39.167909", name: "Oraş Cãlimãneşti" },
    { code: "RO.39.167981", name: "Municipiul Drãgãşani" },
    { code: "RO.39.168041", name: "Oraş Horezu" },
    { code: "RO.39.168130", name: "Oraş Ocnele Mari" },
    { code: "RO.39.168229", name: "Comuna Alunu" },
    { code: "RO.39.168309", name: "Comuna Amărăşti" },
    { code: "RO.39.168372", name: "Oraş Bãbeni" },
    { code: "RO.39.168452", name: "Oraş Bãlceşti" },
    { code: "RO.39.168559", name: "Comuna Bărbăteşti" },
    { code: "RO.39.168602", name: "Oraş Berbeşti" },
    { code: "RO.39.168675", name: "Comuna Berislăveşti" },
    { code: "RO.39.168755", name: "Comuna Boişoara" },
    { code: "RO.39.168791", name: "Comuna Budeşti" },
    { code: "RO.39.168880", name: "Comuna Bujoreni" },
    { code: "RO.39.168960", name: "Comuna Buneşti" },
    { code: "RO.39.169039", name: "Comuna Cernişoara" },
    { code: "RO.39.169119", name: "Comuna Câineni" },
    { code: "RO.39.169182", name: "Comuna Copăceni" },
    { code: "RO.39.169253", name: "Comuna Costeşti" },
    { code: "RO.39.169306", name: "Comuna Creţeni" },
    { code: "RO.39.169351", name: "Comuna Dăeşti" },
    { code: "RO.39.169404", name: "Comuna Dănicei" },
    { code: "RO.39.169547", name: "Comuna Drăgoeşti" },
    { code: "RO.39.169583", name: "Comuna Făureşti" },
    { code: "RO.39.169681", name: "Comuna Fârtãţeşti" },
    { code: "RO.39.169896", name: "Comuna Frânceşti-Mânăstireni" },
    { code: "RO.39.169994", name: "Comuna Galicea" },
    { code: "RO.39.170097", name: "Comuna Ghioroiu" },
    { code: "RO.39.170168", name: "Comuna Glăvile" },
    { code: "RO.39.170220", name: "Comuna Goleşti" },
    { code: "RO.39.170346", name: "Comuna Grădiştea" },
    { code: "RO.39.170444", name: "Comuna Guşoeni" },
    { code: "RO.39.170514", name: "Comuna Ioneşti" },
    { code: "RO.39.170612", name: "Comuna Laloşu" },
    { code: "RO.39.170685", name: "Comuna Lădeşti" },
    { code: "RO.39.170792", name: "Comuna Lăpuşata" },
    { code: "RO.39.170872", name: "Comuna Livezi" },
    { code: "RO.39.170952", name: "Comuna Lungeşti" },
    { code: "RO.39.171021", name: "Comuna Malaia" },
    { code: "RO.39.171067", name: "Comuna Mateeşti" },
    { code: "RO.39.171101", name: "Comuna Măciuca" },
    { code: "RO.39.171209", name: "Comuna Mădulari-Beica" },
    { code: "RO.39.171272", name: "Comuna Măldăreşti" },
    { code: "RO.39.171325", name: "Comuna Mihăeşti" },
    { code: "RO.39.171469", name: "Comuna Milcoiu" },
    { code: "RO.39.171539", name: "Comuna Muereasca" },
    { code: "RO.39.171628", name: "Comuna Nicolae Bãlcescu" },
    { code: "RO.39.171806", name: "Comuna Olanu" },
    { code: "RO.39.171879", name: "Comuna Orleşti" },
    { code: "RO.39.171931", name: "Comuna Oteşani" },
    { code: "RO.39.171995", name: "Comuna Păuşeşti" },
    { code: "RO.39.172082", name: "Comuna Păuşeşti-Măglaşi" },
    { code: "RO.39.172153", name: "Comuna Perişani" },
    { code: "RO.39.172279", name: "Comuna Pesceana" },
    { code: "RO.39.172340", name: "Comuna Pietrari" },
    { code: "RO.39.172377", name: "Comuna Popeşti" },
    { code: "RO.39.172457", name: "Comuna Prundeni" },
    { code: "RO.39.172509", name: "Comuna Racoviţa" },
    { code: "RO.39.172581", name: "Comuna Roeşti" },
    { code: "RO.39.172698", name: "Comuna Roşiile" },
    { code: "RO.39.172812", name: "Comuna Runcu" },
    { code: "RO.39.172894", name: "Comuna Sălătrucel" },
    { code: "RO.39.172947", name: "Comuna Scundu" },
    { code: "RO.39.172992", name: "Comuna Sineşti" },
    { code: "RO.39.173061", name: "Comuna Slătioara" },
    { code: "RO.39.173132", name: "Comuna Stăneşti" },
    { code: "RO.39.173230", name: "Comuna Stoeneşti" },
    { code: "RO.39.173374", name: "Comuna Stoileşti" },
    { code: "RO.39.173533", name: "Comuna Stroeşti" },
    { code: "RO.39.173597", name: "Comuna Suteşti" },
    { code: "RO.39.173686", name: "Comuna Şirineasa" },
    { code: "RO.39.173748", name: "Comuna Ştefăneşti" },
    { code: "RO.39.173793", name: "Comuna Şuşani" },
    { code: "RO.39.173855", name: "Comuna Tetoiu" },
    { code: "RO.39.173935", name: "Comuna Tomşani" },
    { code: "RO.39.174021", name: "Comuna Vaideeni" },
    { code: "RO.39.174085", name: "Comuna Valea Mare" },
    { code: "RO.39.174156", name: "Comuna Vlădeşti" },
    { code: "RO.39.174218", name: "Comuna Voiceşti" },
    { code: "RO.39.174254", name: "Comuna Voineasa" },
    { code: "RO.39.174290", name: "Comuna Zătreni" },
    { code: "RO.39.174496", name: "Comuna Titeşti" },
    { code: "RO.39.174502", name: "Comuna Diculeşti" },
    { code: "RO.39.174511", name: "Comuna Lăcusteni" },
    { code: "RO.39.174520", name: "Comuna Mitrofani" },
  ],
  "RO.40": [
    { code: "RO.40.174744", name: "Municipiul Focşani" },
    { code: "RO.40.174780", name: "Comuna Câmpineanca" },
    { code: "RO.40.174824", name: "Comuna Goleşti" },
    { code: "RO.40.174860", name: "Municipiul  Adjud" },
    { code: "RO.40.174922", name: "Oraş Mãrãşeşti" },
    { code: "RO.40.175019", name: "Oraş Odobeşti" },
    { code: "RO.40.175055", name: "Oraş Panciu" },
    { code: "RO.40.175126", name: "Comuna Andreiaşu de Jos" },
    { code: "RO.40.175206", name: "Comuna Băleşti" },
    { code: "RO.40.175224", name: "Comuna Bârseşti" },
    { code: "RO.40.175260", name: "Comuna Bogheşti" },
    { code: "RO.40.175368", name: "Comuna Boloteşti" },
    { code: "RO.40.175439", name: "Comuna Bordeşti" },
    { code: "RO.40.175466", name: "Comuna Broşteni" },
    { code: "RO.40.175509", name: "Comuna Chiojdeni" },
    { code: "RO.40.175590", name: "Comuna Ciorăşti" },
    { code: "RO.40.175670", name: "Comuna Câmpuri" },
    { code: "RO.40.175732", name: "Comuna Cârligele" },
    { code: "RO.40.175787", name: "Comuna Corbiţa" },
    { code: "RO.40.175885", name: "Comuna Coteşti" },
    { code: "RO.40.175938", name: "Comună Dumbrăveni" },
    { code: "RO.40.175983", name: "Comuna Dumitreşti" },
    { code: "RO.40.176150", name: "Comuna Fitioneşti" },
    { code: "RO.40.176212", name: "Comuna Garoafa" },
    { code: "RO.40.176301", name: "Comuna Gugeşti" },
    { code: "RO.40.176338", name: "Comuna Gura Caliţei" },
    { code: "RO.40.176445", name: "Comuna Homocea" },
    { code: "RO.40.176506", name: "Comuna Jariştea" },
    { code: "RO.40.176551", name: "Comuna Jitia" },
    { code: "RO.40.176613", name: "Comuna Măicăneşti" },
    { code: "RO.40.176686", name: "Comuna Mera" },
    { code: "RO.40.176748", name: "Comuna Milcovul" },
    { code: "RO.40.176793", name: "Comuna Moviliţa" },
    { code: "RO.40.176855", name: "Comuna Năneşti" },
    { code: "RO.40.176891", name: "Comuna Năruja" },
    { code: "RO.40.176944", name: "Comuna Nereju" },
    { code: "RO.40.177003", name: "Comuna Nistoreşti" },
    { code: "RO.40.177101", name: "Comuna Paltin" },
    { code: "RO.40.177236", name: "Comuna Păuneşti" },
    { code: "RO.40.177263", name: "Comuna Poiana Cristei" },
    { code: "RO.40.177352", name: "Comuna Pufeşti" },
    { code: "RO.40.177405", name: "Comuna Răcoasa" },
    { code: "RO.40.177469", name: "Comuna Reghiu" },
    { code: "RO.40.177557", name: "Comuna Rugineşti" },
    { code: "RO.40.177600", name: "Comuna Sihlea" },
    { code: "RO.40.177655", name: "Comuna Slobozia Bradului" },
    { code: "RO.40.177726", name: "Comuna Slobozia-Ciorăşti" },
    { code: "RO.40.177762", name: "Comuna Soveja" },
    { code: "RO.40.177799", name: "Comuna Străoane" },
    { code: "RO.40.177842", name: "Comuna Suraia" },
    { code: "RO.40.177879", name: "Comuna Tănăsoaia" },
    { code: "RO.40.177986", name: "Comuna Tãtãranu" },
    { code: "RO.40.178046", name: "Comuna Tâmboeşti" },
    { code: "RO.40.178117", name: "Comuna Tulnici" },
    { code: "RO.40.178180", name: "Comuna Ţifeşti" },
    { code: "RO.40.178279", name: "Comuna Urecheşti" },
    { code: "RO.40.178313", name: "Comuna Valea Sării" },
    { code: "RO.40.178377", name: "Comuna Vidra" },
    { code: "RO.40.178475", name: "Comuna Vintileasca" },
    { code: "RO.40.178545", name: "Comuna Vizantea-Livezi" },
    { code: "RO.40.178607", name: "Comuna Vânători" },
    { code: "RO.40.178689", name: "Comuna Vârteşcoiu" },
    { code: "RO.40.178750", name: "Comuna Vrâncioaia" },
    { code: "RO.40.178821", name: "Comuna Vulturu" },
    { code: "RO.40.178885", name: "Comuna Negrileşti" },
    { code: "RO.40.178894", name: "Comuna Ploscuţeni" },
    { code: "RO.40.178901", name: "Comuna Popeşti" },
    { code: "RO.40.178910", name: "Comuna Păuleşti" },
    { code: "RO.40.178929", name: "Comuna Bilieşti" },
    { code: "RO.40.178938", name: "Comuna Gologanu" },
    { code: "RO.40.178947", name: "Comuna Obrejiţa" },
    { code: "RO.40.178956", name: "Comuna Răstoaca" },
    { code: "RO.40.178965", name: "Comuna Spulber" },
  ],
  "RO.41": [
    { code: "RO.41.100610", name: "Municipiul Olteniţa" },
    { code: "RO.41.100638", name: "Comuna Mitreni" },
    { code: "RO.41.101083", name: "Comuna Belciugatele" },
    { code: "RO.41.101458", name: "Oraş Budeşti" },
    { code: "RO.41.101724", name: "Comuna Căscioarele" },
    { code: "RO.41.101804", name: "Comuna Chirnogi" },
    { code: "RO.41.101822", name: "Comuna Chiselet" },
    { code: "RO.41.102419", name: "Comuna Curcani" },
    { code: "RO.41.102838", name: "Comuna Frăsinet" },
    { code: "RO.41.102945", name: "Comuna Frumuşani" },
    { code: "RO.41.103014", name: "Comuna Fundeni" },
    { code: "RO.41.103032", name: "Oraş Fundulea" },
    { code: "RO.41.103568", name: "Comuna Gurbăneşti" },
    { code: "RO.41.103764", name: "Comuna Ileana" },
    { code: "RO.41.104083", name: "Comuna Luica" },
    { code: "RO.41.104181", name: "Comuna Mânăstirea" },
    { code: "RO.41.104323", name: "Comuna Nana" },
    { code: "RO.41.104341", name: "Comuna Nicolae Bălcescu" },
    { code: "RO.41.104635", name: "Comuna Plătăreşti" },
    { code: "RO.41.104751", name: "Comuna Radovanu" },
    { code: "RO.41.104886", name: "Comuna Săruleşti" },
    { code: "RO.41.105222", name: "Comuna Sohatu" },
    { code: "RO.41.105259", name: "Comuna Spanţov" },
    { code: "RO.41.105384", name: "Comuna Şoldanu" },
    { code: "RO.41.105455", name: "Comuna Tãmãdãu Mare" },
    { code: "RO.41.105605", name: "Comuna Ulmeni" },
    { code: "RO.41.105712", name: "Comuna Valea Argovei" },
    { code: "RO.41.105829", name: "Comuna Vasilaţi" },
    { code: "RO.41.179962", name: "Comuna Gălbinaşi" },
    { code: "RO.41.180055", name: "Comuna Crivăţ" },
    { code: "RO.41.92569", name: "Municipiul Călăraşi" },
    { code: "RO.41.92587", name: "Comuna Modelu" },
    { code: "RO.41.92961", name: "Comuna Borcea" },
    { code: "RO.41.93085", name: "Comuna Ciocăneşti" },
    { code: "RO.41.93281", name: "Comuna Cuza Vodă" },
    { code: "RO.41.93325", name: "Comuna Dichiseni" },
    { code: "RO.41.93370", name: "Comuna Dor Mărunt" },
    { code: "RO.41.93441", name: "Comuna Dorobanţu" },
    { code: "RO.41.93487", name: "Comuna Dragalina" },
    { code: "RO.41.93539", name: "Comuna Dragoş Vodă" },
    { code: "RO.41.93664", name: "Comuna Grădiştea" },
    { code: "RO.41.93771", name: "Comuna Independenţa" },
    { code: "RO.41.93815", name: "Comuna Jegălia" },
    { code: "RO.41.93851", name: "Comuna Lehliu" },
    { code: "RO.41.93888", name: "Oraş Lehliu Garã" },
    { code: "RO.41.93931", name: "Comuna Lupşanu" },
    { code: "RO.41.94125", name: "Comuna Alexandru Odobescu" },
    { code: "RO.41.94223", name: "Comuna Perişoru" },
    { code: "RO.41.94312", name: "Comuna Roseţi" },
    { code: "RO.41.94562", name: "Comuna Ştefan Cel Mare" },
    { code: "RO.41.94580", name: "Comuna Ştefan Vodă" },
    { code: "RO.41.94606", name: "Comuna Ulmu" },
    { code: "RO.41.94651", name: "Comuna Unirea" },
    { code: "RO.41.94731", name: "Comuna Vâlcelele" },
    { code: "RO.41.94768", name: "Comuna Vlad Ţepeş" },
  ],
  "RO.42": [
    { code: "RO.42.100521", name: "Municipiul Giurgiu" },
    { code: "RO.42.100549", name: "Comuna Slobozia" },
    { code: "RO.42.100781", name: "Comuna Adunaţii-Copăceni" },
    { code: "RO.42.101001", name: "Comuna Băneasa" },
    { code: "RO.42.101163", name: "Comuna Bolintin Deal" },
    { code: "RO.42.101190", name: "Oraş Bolintin-Vale" },
    { code: "RO.42.101378", name: "Comuna Bucşani" },
    { code: "RO.42.101519", name: "Comuna Bulbucata" },
    { code: "RO.42.101617", name: "Comuna Buturugeni" },
    { code: "RO.42.101662", name: "Comuna Călugăreni" },
    { code: "RO.42.101984", name: "Comuna Clejani" },
    { code: "RO.42.102071", name: "Comuna Colibaşi" },
    { code: "RO.42.102106", name: "Comuna Comana" },
    { code: "RO.42.102348", name: "Comuna Crevedia Mare" },
    { code: "RO.42.102446", name: "Comuna Daia" },
    { code: "RO.42.102794", name: "Comună Floreşti-Stoeneşti" },
    { code: "RO.42.102909", name: "Comuna Frăteşti" },
    { code: "RO.42.103087", name: "Comuna Gãiseni" },
    { code: "RO.42.103194", name: "Comuna Găujani" },
    { code: "RO.42.103238", name: "Comuna Ghimpaţi" },
    { code: "RO.42.103309", name: "Comuna Gogoşari" },
    { code: "RO.42.103354", name: "Comuna Gostinu" },
    { code: "RO.42.103372", name: "Comuna Goştinari" },
    { code: "RO.42.103407", name: "Comuna Grădinari" },
    { code: "RO.42.103470", name: "Comuna Greaca" },
    { code: "RO.42.103639", name: "Comuna Hotarele" },
    { code: "RO.42.103693", name: "Comuna Iepureşti" },
    { code: "RO.42.103899", name: "Comuna Izvoarele" },
    { code: "RO.42.103997", name: "Comuna Joiţa" },
    { code: "RO.42.104047", name: "Comuna Letca Nouă" },
    { code: "RO.42.104118", name: "Comuna Mihai Bravu" },
    { code: "RO.42.104136", name: "Oraş Mihãileşti" },
    { code: "RO.42.104225", name: "Comuna Mârşa" },
    { code: "RO.42.104485", name: "Comuna Ogrezeni" },
    { code: "RO.42.104519", name: "Comuna Oinacu" },
    { code: "RO.42.104680", name: "Comuna Prundu" },
    { code: "RO.42.104715", name: "Comuna Putineiu" },
    { code: "RO.42.104788", name: "Comuna Răsuceni" },
    { code: "RO.42.104831", name: "Comuna Roata De Jos" },
    { code: "RO.42.104975", name: "Comuna Schitu" },
    { code: "RO.42.105106", name: "Comuna Singureni" },
    { code: "RO.42.105295", name: "Comuna Stăneşti" },
    { code: "RO.42.105348", name: "Comuna Stoeneşti" },
    { code: "RO.42.105623", name: "Comuna Ulmi" },
    { code: "RO.42.105776", name: "Comuna Valea Dragului" },
    { code: "RO.42.105874", name: "Comuna Vărăşti" },
    { code: "RO.42.105909", name: "Comuna Vedea" },
    { code: "RO.42.105972", name: "Comuna Vânătorii Mici" },
    { code: "RO.42.154709", name: "Comuna Toporu" },
    { code: "RO.42.179739", name: "Comuna Malu" },
    { code: "RO.42.179748", name: "Comuna Cosoba" },
    { code: "RO.42.179757", name: "Comuna Herăşti" },
    { code: "RO.42.179766", name: "Comuna Isvoarele" },
    { code: "RO.42.179775", name: "Comuna Săbăreni" },
  ],
  "RO.43": [
    { code: "RO.43.100576", name: "Oraş Buftea" },
    { code: "RO.43.100834", name: "Comuna Afumaţi" },
    { code: "RO.43.100969", name: "Comuna Baloteşti" },
    { code: "RO.43.101145", name: "Comuna Berceni" },
    { code: "RO.43.101298", name: "Comuna Brăneşti" },
    { code: "RO.43.101742", name: "Comuna Cernica" },
    { code: "RO.43.101902", name: "Comuna Ciolpani" },
    { code: "RO.43.101957", name: "Comuna Ciorogârla" },
    { code: "RO.43.102035", name: "Comuna Clinceni" },
    { code: "RO.43.102160", name: "Comuna Corbeanca" },
    { code: "RO.43.102213", name: "Comuna Cornetu" },
    { code: "RO.43.102473", name: "Comuna Dascălu Creaţa" },
    { code: "RO.43.102525", name: "Comuna Dărăşti-Ilfov" },
    { code: "RO.43.102543", name: "Comuna 1 Decembrie" },
    { code: "RO.43.102570", name: "Comuna Domneşti" },
    { code: "RO.43.102605", name: "Comuna Dragomireşti-Vale" },
    { code: "RO.43.103130", name: "Comuna Găneasa" },
    { code: "RO.43.103443", name: "Comuna Grădiştea" },
    { code: "RO.43.103513", name: "Comuna Gruiu" },
    { code: "RO.43.104243", name: "Comuna Moara Vlãsiei" },
    { code: "RO.43.104421", name: "Comuna Nuci" },
    { code: "RO.43.104546", name: "Comuna Periş" },
    { code: "RO.43.104582", name: "Comuna Petrăchioaia" },
    { code: "RO.43.105160", name: "Comuna Snagov" },
    { code: "RO.43.105419", name: "Comuna Ştefãneştii De Jos" },
    { code: "RO.43.105570", name: "Comuna Tunari" },
    { code: "RO.43.105936", name: "Comuna Vidra" },
    { code: "RO.43.179221", name: "Oraş Bragadiru" },
    { code: "RO.43.179249", name: "Comuna Chiajna" },
    { code: "RO.43.179285", name: "Oraş Chitila" },
    { code: "RO.43.179310", name: "Comuna Fundeni-Dobroeşti" },
    { code: "RO.43.179347", name: "Comuna Glina" },
    { code: "RO.43.179383", name: "Comuna Jilava" },
    { code: "RO.43.179409", name: "Oraş Mãgurele" },
    { code: "RO.43.179463", name: "Comuna Mogoşoaia" },
    { code: "RO.43.179481", name: "Oraş Otopeni" },
    { code: "RO.43.179515", name: "Oraş Pantelimon" },
    { code: "RO.43.179533", name: "Oraş Popeşti Leordeni" },
    { code: "RO.43.179551", name: "Voluntari City" },
    { code: "RO.43.179588", name: "Comuna Copăceni" },
  ],
  "RS.SE": [
    { code: "RS.SE.0", name: "Belgrade" },
    { code: "RS.SE.10", name: "Podunavlje District" },
    { code: "RS.SE.11", name: "Branicevo" },
    { code: "RS.SE.12", name: "Šumadija" },
    { code: "RS.SE.13", name: "Pomoravlje" },
    { code: "RS.SE.14", name: "Bor" },
    { code: "RS.SE.15", name: "Zaječar" },
    { code: "RS.SE.16", name: "Zlatibor" },
    { code: "RS.SE.17", name: "Morava" },
    { code: "RS.SE.18", name: "Raška" },
    { code: "RS.SE.19", name: "Rasina" },
    { code: "RS.SE.20", name: "Nišava" },
    { code: "RS.SE.21", name: "Toplica" },
    { code: "RS.SE.22", name: "Pirot" },
    { code: "RS.SE.23", name: "Jablanica" },
    { code: "RS.SE.24", name: "Pčinja" },
    { code: "RS.SE.8", name: "Mačva" },
    { code: "RS.SE.9", name: "Kolubara" },
  ],
  "RS.VO": [
    { code: "RS.VO.1", name: "North Bačka" },
    { code: "RS.VO.2", name: "Central Banat" },
    { code: "RS.VO.3", name: "North Banat" },
    { code: "RS.VO.4", name: "South Banat" },
    { code: "RS.VO.5", name: "West Bačka" },
    { code: "RS.VO.6", name: "South Bačka" },
    { code: "RS.VO.7", name: "Srem" },
  ],
  "RU.01": [
    { code: "RU.01.483141", name: "Teuchezhskiy Rayon" },
    { code: "RU.01.493720", name: "Shovgenovskiy Rayon" },
  ],
  "RU.06": [
    { code: "RU.06.473532", name: "Vinogradovskiy Rayon" },
    { code: "RU.06.473668", name: "Vilegodskiy Rayon" },
    { code: "RU.06.475472", name: "Verkhnetoyemskiy Rayon" },
    { code: "RU.06.475937", name: "Vel’skiy Rayon" },
    { code: "RU.06.477891", name: "Ust’yanskiy Rayon" },
    { code: "RU.06.494883", name: "Shenkurskiy Rayon" },
    { code: "RU.06.505262", name: "Primorskiy Rayon" },
    { code: "RU.06.509472", name: "Pinezhskiy Rayon" },
    { code: "RU.06.515237", name: "Onezhskiy Rayon" },
    { code: "RU.06.516645", name: "Nyandomskiy Rayon" },
  ],
  "RU.07": [
    { code: "RU.07.467477", name: "Yenotayevskiy Rayon" },
    { code: "RU.07.472484", name: "Volodarskiy Rayon" },
    { code: "RU.07.505051", name: "Privolzhskiy Rayon" },
  ],
  "RU.08": [
    { code: "RU.08.462622", name: "Zilairskiy Rayon" },
    { code: "RU.08.462646", name: "Zianchurinskiy Rayon" },
    { code: "RU.08.467259", name: "Yermekeyevskiy Rayon" },
    { code: "RU.08.469176", name: "Yanaul’skiy Rayon" },
    { code: "RU.08.479551", name: "Ufimskiy Rayon" },
    { code: "RU.08.479706", name: "Uchalinskiy Rayon" },
    { code: "RU.08.480090", name: "Tuymazinskiy Rayon" },
    { code: "RU.08.484004", name: "Tatyshlinskiy Rayon" },
    { code: "RU.08.487493", name: "Sterlitamakskiy Rayon" },
    { code: "RU.08.487497", name: "Sterlibashevskiy Rayon" },
    { code: "RU.08.495761", name: "Sharanskiy Rayon" },
    { code: "RU.08.499290", name: "Salavatskiy Rayon" },
    { code: "RU.08.516722", name: "Nurimanovskiy Rayon" },
  ],
  "RU.09": [
    { code: "RU.09.469534", name: "Yakovlevskiy Rayon" },
    { code: "RU.09.472424", name: "Volokonovskiy Rayon" },
    { code: "RU.09.473855", name: "Veydelevskiy Rayon" },
    { code: "RU.09.477189", name: "Valuyskiy Rayon" },
    { code: "RU.09.488709", name: "Starooskolsky Urban Okrug" },
    { code: "RU.09.495111", name: "Shebekinskiy Rayon" },
    { code: "RU.09.501124", name: "Roven’skiy Rayon" },
    { code: "RU.09.503055", name: "Rakityanskiy Rayon" },
    { code: "RU.09.504908", name: "Prokhorovskiy Rayon" },
  ],
  "RU.10": [
    { code: "RU.10.462753", name: "Zhukovskiy Rayon" },
    { code: "RU.10.470470", name: "Vygonichskiy Rayon" },
    { code: "RU.10.479010", name: "Unechskiy Rayon" },
    { code: "RU.10.481349", name: "Trubchevskiy Rayon" },
    { code: "RU.10.485815", name: "Suzemskiy Rayon" },
    { code: "RU.10.486147", name: "Surazhskiy Rayon" },
    { code: "RU.10.488848", name: "Starodubskiy Rayon" },
    { code: "RU.10.496244", name: "Sevskiy Rayon" },
    { code: "RU.10.501624", name: "Rognedinskiy Rayon" },
    { code: "RU.10.507867", name: "Pogarskiy Rayon" },
    { code: "RU.10.508648", name: "Pochepskiy Rayon" },
    { code: "RU.10.517267", name: "Novozybkovskiy Rayon" },
  ],
  "RU.12": [
    { code: "RU.12.476248", name: "Vedenskiy Rayon" },
    { code: "RU.12.478580", name: "Urus-Martanovskiy Rayon" },
    { code: "RU.12.494999", name: "Shelkovskiy Rayon" },
    { code: "RU.12.495940", name: "Shalinskiy Rayon" },
    { code: "RU.12.516779", name: "Nozhay-Yurtovskiy Rayon" },
  ],
  "RU.13": [
    { code: "RU.13.475462", name: "Verkhneural’skiy Rayon" },
    { code: "RU.13.498416", name: "Satkinskiy Rayon" },
    { code: "RU.13.516613", name: "Nyazepetrovskiy Rayon" },
  ],
  "RU.16": [
    { code: "RU.16.469048", name: "Yantikovskiy Rayon" },
    { code: "RU.16.469395", name: "Yal’chikskiy Rayon" },
    { code: "RU.16.469804", name: "Yadrinskiy Rayon" },
    { code: "RU.16.470846", name: "Vurnarskiy Rayon" },
    { code: "RU.16.478690", name: "Urmarskiy Rayon" },
    { code: "RU.16.480849", name: "Tsivil’skiy Rayon" },
    { code: "RU.16.493464", name: "Shumerlinskiy Rayon" },
    { code: "RU.16.494919", name: "Shemurshinskiy Rayon" },
    { code: "RU.16.506288", name: "Poretskiy Rayon" },
  ],
  "RU.17": [
    { code: "RU.17.478962", name: "Untsukulsky District" },
    { code: "RU.17.480801", name: "Tsuntinskiy Rayon" },
    { code: "RU.17.480804", name: "Tsumadinskiy Rayon" },
    { code: "RU.17.482588", name: "Tlyaratinskiy Rayon" },
    { code: "RU.17.484288", name: "Tarumovskiy Rayon" },
    { code: "RU.17.484957", name: "Tabasaranskiy Rayon" },
    { code: "RU.17.486360", name: "Suleyman-Stal’skiy Rayon" },
    { code: "RU.17.490031", name: "Shamilsky District" },
    { code: "RU.17.496609", name: "Sergokalinskiy Rayon" },
    { code: "RU.17.500315", name: "Rutul’skiy Rayon" },
  ],
  "RU.19": [
    { code: "RU.19.486197", name: "Sunzhenskiy Rayon" },
  ],
  "RU.21": [
    { code: "RU.21.464107", name: "Zavolzhskiy Rayon" },
    { code: "RU.21.466002", name: "Yuzhskiy Rayon" },
    { code: "RU.21.466254", name: "Yur’yevetskiy Rayon" },
    { code: "RU.21.473787", name: "Vichugskiy Rayon" },
    { code: "RU.21.475550", name: "Verkhnelandekhovskiy Rayon" },
    { code: "RU.21.483136", name: "Teykovskiy Rayon" },
    { code: "RU.21.493203", name: "Shuyskiy Rayon" },
    { code: "RU.21.498203", name: "Savinskiy Rayon" },
    { code: "RU.21.501709", name: "Rodnikovskiy Rayon" },
    { code: "RU.21.504293", name: "Puchezhskiy Rayon" },
    { code: "RU.21.505049", name: "Privolzhskiy Rayon" },
    { code: "RU.21.510322", name: "Pestyakovskiy Rayon" },
    { code: "RU.21.513094", name: "Palekhskiy Rayon" },
  ],
  "RU.22": [
    { code: "RU.22.462156", name: "Zol’skiy Rayon" },
    { code: "RU.22.478559", name: "Urvanskiy Rayon" },
    { code: "RU.22.483273", name: "Terskiy Rayon" },
    { code: "RU.22.490029", name: "Cherekskiy Rayon" },
    { code: "RU.22.504938", name: "Prokhladnenskiy Rayon" },
  ],
  "RU.23": [
    { code: "RU.23.463825", name: "Zelenogradskiy Rayon" },
    { code: "RU.23.492111", name: "Slavskiy Rayon" },
    { code: "RU.23.505596", name: "Pravdinskiy Rayon" },
    { code: "RU.23.507290", name: "Polesskiy Rayon" },
    { code: "RU.23.513394", name: "Ozerskiy Rayon" },
  ],
  "RU.24": [
    { code: "RU.24.466133", name: "Yustinskiy Rayon" },
    { code: "RU.24.468746", name: "Yashkul’skiy Rayon" },
    { code: "RU.24.468775", name: "Yashaltinskiy Rayon" },
    { code: "RU.24.481029", name: "Tselinnyy Rayon" },
    { code: "RU.24.498505", name: "Sarpinskiy Rayon" },
    { code: "RU.24.505020", name: "Priyutnenskiy Rayon" },
    { code: "RU.24.505231", name: "Ketchenerovskiy Rayon" },
    { code: "RU.24.515840", name: "Oktyabr’skiy Rayon" },
  ],
  "RU.25": [
    { code: "RU.25.462752", name: "Zhukovskiy Rayon" },
    { code: "RU.25.462912", name: "Zhizdrinskiy Rayon" },
    { code: "RU.25.466653", name: "Yukhnovskiy Rayon" },
    { code: "RU.25.479106", name: "Ul’yanovskiy Rayon" },
    { code: "RU.25.484282", name: "Tarusskiy Rayon" },
    { code: "RU.25.486662", name: "Sukhinichskiy Rayon" },
    { code: "RU.25.489867", name: "Spas-Demenskiy Rayon" },
    { code: "RU.25.511399", name: "Peremyshl’skiy Rayon" },
  ],
  "RU.27": [
    { code: "RU.27.463884", name: "Zelenchukskiy Rayon" },
    { code: "RU.27.478129", name: "Ust’-Dzhegutinskiy Rayon" },
    { code: "RU.27.478586", name: "Urupskiy Rayon" },
    { code: "RU.27.505340", name: "Prikubanskiy Rayon" },
  ],
  "RU.28": [
    { code: "RU.28.461703", name: "Sortaval’skiy Rayon" },
    { code: "RU.28.486183", name: "Suoyarvskiy Rayon" },
    { code: "RU.28.497924", name: "Segezhskiy Rayon" },
    { code: "RU.28.504259", name: "Pudozhskiy Rayon" },
    { code: "RU.28.504407", name: "Pryazhinskiy Rayon" },
    { code: "RU.28.505244", name: "Prionezhskiy Rayon" },
    { code: "RU.28.509233", name: "Pitkyarantskiy Rayon" },
    { code: "RU.28.515401", name: "Olonetskiy Rayon" },
  ],
  "RU.33": [
    { code: "RU.33.461940", name: "Zuyevskiy Rayon" },
    { code: "RU.33.466268", name: "Yur’yanskiy Rayon" },
    { code: "RU.33.469004", name: "Yaranskiy Rayon" },
    { code: "RU.33.470727", name: "Vyatsko-Polyanskiy Rayon" },
    { code: "RU.33.474372", name: "Verkhoshizhemskiy Rayon" },
    { code: "RU.33.475579", name: "Verkhnekamskiy Rayon" },
    { code: "RU.33.478528", name: "Urzhumskiy Rayon" },
    { code: "RU.33.478994", name: "Uninskiy Rayon" },
    { code: "RU.33.480079", name: "Tuzhinskiy Rayon" },
    { code: "RU.33.485794", name: "Svechinskiy Rayon" },
    { code: "RU.33.486207", name: "Sunskiy Rayon" },
    { code: "RU.33.490023", name: "Sovetskiy Rayon" },
    { code: "RU.33.491877", name: "Slobodskoy Rayon" },
    { code: "RU.33.496196", name: "Shabalinskiy Rayon" },
    { code: "RU.33.498876", name: "Sanchurskiy Rayon" },
    { code: "RU.33.508064", name: "Podosinovskiy Rayon" },
    { code: "RU.33.509182", name: "Pizhanskiy Rayon" },
    { code: "RU.33.514967", name: "Orichevskiy Rayon" },
    { code: "RU.33.515173", name: "Oparinskiy Rayon" },
    { code: "RU.33.515266", name: "Omutninskiy Rayon" },
  ],
  "RU.34": [
    { code: "RU.34.477906", name: "Ust’-Vymskiy Rayon" },
    { code: "RU.34.477941", name: "Ust’-Tsilemskiy Rayon" },
    { code: "RU.34.478049", name: "Ust’-Kulomskiy Rayon" },
    { code: "RU.34.479581", name: "Udorskiy Rayon" },
    { code: "RU.34.481547", name: "Troitsko-Pechorskiy Rayon" },
    { code: "RU.34.485121", name: "Sysol’skiy Rayon" },
    { code: "RU.34.485241", name: "Syktyvdinskiy Rayon" },
    { code: "RU.34.505282", name: "Priluzskiy Rayon" },
  ],
  "RU.37": [
    { code: "RU.37.472883", name: "Vokhomskiy Rayon" },
    { code: "RU.37.486013", name: "Susaninskiy Rayon" },
    { code: "RU.37.486846", name: "Sudislavskiy Rayon" },
    { code: "RU.37.491024", name: "Soligalichskiy Rayon" },
    { code: "RU.37.495704", name: "Shar’inskiy Rayon" },
    { code: "RU.37.503399", name: "Pyshchugskiy Rayon" },
    { code: "RU.37.506693", name: "Ponazyrevskiy Rayon" },
    { code: "RU.37.512246", name: "Pavinskiy Rayon" },
    { code: "RU.37.512574", name: "Parfen’yevskiy Rayon" },
    { code: "RU.37.514056", name: "Ostrovskiy Rayon" },
    { code: "RU.37.515833", name: "Oktyabr’skiy Rayon" },
  ],
  "RU.38": [
    { code: "RU.38.466879", name: "Yeyskiy Rayon" },
    { code: "RU.38.470322", name: "Vyselkovskiy Rayon" },
    { code: "RU.38.478043", name: "Ust’-Labinskiy Rayon" },
    { code: "RU.38.478198", name: "Uspenskiy Rayon" },
    { code: "RU.38.480713", name: "Tuapsinskiy Rayon" },
    { code: "RU.38.482964", name: "Timashevskiy Rayon" },
    { code: "RU.38.483027", name: "Tikhoretskiy Rayon" },
    { code: "RU.38.483660", name: "Temruksky rayon" },
    { code: "RU.38.483882", name: "Tbilisskiy Rayon" },
    { code: "RU.38.488740", name: "Starominskiy Rayon" },
    { code: "RU.38.492095", name: "Slavyansky rayon" },
    { code: "RU.38.495252", name: "Shcherbinovskiy Rayon" },
    { code: "RU.38.496265", name: "Severskiy Rayon" },
    { code: "RU.38.505258", name: "Primorsko-Akhtarskiy Rayon" },
    { code: "RU.38.512021", name: "Pavlovskiy Rayon" },
    { code: "RU.38.513908", name: "Otradnenskiy Rayon" },
  ],
  "RU.41": [
    { code: "RU.41.462166", name: "Zolotukhinskiy Rayon" },
    { code: "RU.41.463342", name: "Zheleznogorskiy Rayon" },
    { code: "RU.41.482808", name: "Timskiy Rayon" },
    { code: "RU.41.486813", name: "Sudzhanskiy Rayon" },
    { code: "RU.41.490026", name: "Sovetskiy Rayon" },
    { code: "RU.41.490969", name: "Solntsevskiy Rayon" },
    { code: "RU.41.495207", name: "Shchigrovskiy Rayon" },
    { code: "RU.41.499888", name: "Ryl’skiy Rayon" },
    { code: "RU.41.505150", name: "Pristenskiy Rayon" },
    { code: "RU.41.506595", name: "Ponyrovskiy Rayon" },
    { code: "RU.41.515838", name: "Oktyabr’skiy Rayon" },
    { code: "RU.41.516399", name: "Oboyanskiy Rayon" },
  ],
  "RU.42": [
    { code: "RU.42.470541", name: "Vyborgskiy Rayon" },
    { code: "RU.42.471099", name: "Vsevolozhskiy Rayon" },
    { code: "RU.42.472350", name: "Volosovskiy Rayon" },
    { code: "RU.42.472711", name: "Volkhovskiy rayon" },
    { code: "RU.42.481965", name: "Tosnenskiy Rayon" },
    { code: "RU.42.483008", name: "Tikhvinskiy Rayon" },
    { code: "RU.42.492167", name: "Slantsevskiy Rayon" },
    { code: "RU.42.508035", name: "Podporozhskiy Rayon" },
  ],
  "RU.43": [
    { code: "RU.43.465724", name: "Zadonskiy Rayon" },
    { code: "RU.43.467976", name: "Yeletskiy Rayon" },
    { code: "RU.43.472303", name: "Volovskiy Rayon" },
    { code: "RU.43.478304", name: "Usmanskiy Rayon" },
    { code: "RU.43.483542", name: "Terbunskiy Rayon" },
    { code: "RU.43.489297", name: "Stanovlyanskiy Rayon" },
  ],
  "RU.45": [
    { code: "RU.45.461915", name: "Zvenigovskiy Rayon" },
    { code: "RU.45.466404", name: "Yurinskiy Rayon" },
    { code: "RU.45.472225", name: "Volzhskiy Rayon" },
    { code: "RU.45.490024", name: "Sovetskiy Rayon" },
    { code: "RU.45.496560", name: "Sernurskiy Rayon" },
    { code: "RU.45.512616", name: "Paran’ginskiy Rayon" },
    { code: "RU.45.514738", name: "Orshanskiy Rayon" },
    { code: "RU.45.517838", name: "Novotor”yal’skiy Rayon" },
  ],
  "RU.46": [
    { code: "RU.46.462020", name: "Zubovo-Polyanskiy Rayon" },
    { code: "RU.46.467756", name: "Yel’nikovskiy Rayon" },
    { code: "RU.46.482117", name: "Torbeyevskiy Rayon" },
    { code: "RU.46.483641", name: "Ten’gushevskiy Rayon" },
    { code: "RU.46.483682", name: "Temnikovskiy Rayon" },
    { code: "RU.46.488637", name: "Staroshaygovskiy Rayon" },
    { code: "RU.46.500298", name: "Ruzayevskiy Rayon" },
    { code: "RU.46.501345", name: "Romodanovskiy Rayon" },
  ],
  "RU.47": [
    { code: "RU.47.464686", name: "Zarayskiy Rayon" },
    { code: "RU.47.465636", name: "Sergiyevo-Posadskiy Rayon" },
    { code: "RU.47.468247", name: "Yegor’yevskiy Rayon" },
    { code: "RU.47.471643", name: "Voskresenskiy Rayon" },
    { code: "RU.47.472430", name: "Volokolamskiy Rayon" },
    { code: "RU.47.484825", name: "Taldomskiy Rayon" },
    { code: "RU.47.486955", name: "Stupinskiy Rayon" },
    { code: "RU.47.490995", name: "Solnechnogorskiy Rayon" },
    { code: "RU.47.495337", name: "Shchëlkovskiy Rayon" },
    { code: "RU.47.495516", name: "Shaturskiy Rayon" },
    { code: "RU.47.496029", name: "Shakhovskoy Rayon" },
    { code: "RU.47.496526", name: "Serpukhovskiy Rayon" },
    { code: "RU.47.496894", name: "Serebryano-Prudskiy Rayon" },
    { code: "RU.47.500285", name: "Ruzskiy Rayon" },
    { code: "RU.47.502966", name: "Ramenskiy Rayon" },
    { code: "RU.47.503964", name: "Pushkinskiy Rayon" },
    { code: "RU.47.508091", name: "Podolsk Urban Okrug" },
    { code: "RU.47.512055", name: "Pavlovo-Posadskiy Rayon" },
    { code: "RU.47.513393", name: "Ozyory Urban Okrug" },
    { code: "RU.47.515022", name: "Orekhovo-Zuyevskiy Rayon" },
    { code: "RU.47.516210", name: "Odintsovskiy Rayon" },
  ],
  "RU.48": [
    { code: "RU.48.471823", name: "Severnyy Administrativnyy Okrug" },
    { code: "RU.48.480141", name: "Severo-Zapadnyy Administrativnyy Okrug" },
    { code: "RU.48.490025", name: "Yuzhnyy Administrativnyy Okrug" },
    { code: "RU.48.490968", name: "Zapadnyy Administrativnyy Okrug" },
  ],
  "RU.49": [
    { code: "RU.49.483272", name: "Terskiy Rayon" },
    { code: "RU.49.511860", name: "Pechengskiy Rayon" },
  ],
  "RU.51": [
    { code: "RU.51.471173", name: "Voznesenskiy Rayon" },
    { code: "RU.51.471642", name: "Voskresenskiy Rayon" },
    { code: "RU.51.471793", name: "Vorotynskiy Rayon" },
    { code: "RU.51.472482", name: "Volodarskiy Rayon" },
    { code: "RU.51.473902", name: "Vetluzhskiy Rayon" },
    { code: "RU.51.476980", name: "Varnavinskiy Rayon" },
    { code: "RU.51.477406", name: "Vadskiy Rayon" },
    { code: "RU.51.477425", name: "Vachskiy Rayon" },
    { code: "RU.51.478751", name: "Urenskiy Rayon" },
    { code: "RU.51.482217", name: "Tonshayevskiy Rayon" },
    { code: "RU.51.482229", name: "Tonkinskiy Rayon" },
    { code: "RU.51.489809", name: "Spasskiy Rayon" },
    { code: "RU.51.490199", name: "Sosnovskiy Rayon" },
    { code: "RU.51.495559", name: "Shatkovskiy Rayon" },
    { code: "RU.51.495765", name: "Sharangskiy Rayon" },
    { code: "RU.51.496799", name: "Sergachskiy Rayon" },
    { code: "RU.51.497983", name: "Sechenovskiy Rayon" },
    { code: "RU.51.508612", name: "Pochinkovskiy Rayon" },
    { code: "RU.51.509537", name: "Pil’ninskiy Rayon" },
    { code: "RU.51.512018", name: "Pavlovskiy Rayon" },
  ],
  "RU.52": [
    { code: "RU.52.472321", name: "Volotovskiy Rayon" },
    { code: "RU.52.477295", name: "Valdayskiy Rayon" },
    { code: "RU.52.488681", name: "Starorusskiy Rayon" },
    { code: "RU.52.491033", name: "Soletskiy Rayon" },
    { code: "RU.52.494364", name: "Shimskiy Rayon" },
    { code: "RU.52.508442", name: "Poddorskiy Rayon" },
    { code: "RU.52.510351", name: "Pestovskiy Rayon" },
    { code: "RU.52.512568", name: "Parfinskiy Rayon" },
    { code: "RU.52.515748", name: "Okulovskiy Rayon" },
  ],
  "RU.55": [
    { code: "RU.55.498707", name: "Saraktashskiy Rayon" },
  ],
  "RU.60": [
    { code: "RU.60.476048", name: "Velikolukskiy Rayon" },
    { code: "RU.60.487109", name: "Strugo-Krasnenskiy Rayon" },
    { code: "RU.60.497999", name: "Sebezhskiy Rayon" },
    { code: "RU.60.503373", name: "Pytalovskiy Rayon" },
    { code: "RU.60.503857", name: "Pustoshkinskiy Rayon" },
    { code: "RU.60.503970", name: "Pushkino-Gorskiy Rayon" },
    { code: "RU.60.504335", name: "Pskovskiy Rayon" },
    { code: "RU.60.506274", name: "Porkhovskiy Rayon" },
    { code: "RU.60.511788", name: "Pechorskiy Rayon" },
    { code: "RU.60.513043", name: "Palkinskiy Rayon" },
    { code: "RU.60.514057", name: "Ostrovskiy Rayon" },
    { code: "RU.60.515157", name: "Opochetskiy Rayon" },
  ],
  "RU.62": [
    { code: "RU.62.465400", name: "Zakharovskiy Rayon" },
    { code: "RU.62.499979", name: "Rybnovskiy Rayon" },
    { code: "RU.62.500058", name: "Ryazanskiy Rayon" },
  ],
  "RU.65": [
    { code: "RU.65.472226", name: "Volzhskiy Rayon" },
  ],
  "RU.66": [
    { code: "RU.66.463424", name: "Primorskiy Rayon" },
    { code: "RU.66.470542", name: "Vyborgskiy Rayon" },
    { code: "RU.66.476815", name: "Vasileostrovskiy Rayon" },
    { code: "RU.66.496477", name: "Sestroretskiy Rayon" },
    { code: "RU.66.510222", name: "Petrogradskiy Rayon" },
  ],
  "RU.67": [
    { code: "RU.67.471644", name: "Voskresenskiy Rayon" },
    { code: "RU.67.472276", name: "Vol’skiy Rayon" },
    { code: "RU.67.490027", name: "Sovetskiy Rayon" },
    { code: "RU.67.498661", name: "Saratovskiy Rayon" },
  ],
  "RU.68": [
    { code: "RU.68.505371", name: "Prigorodnyy Rayon" },
    { code: "RU.68.505586", name: "Pravoberezhnyy Rayon" },
  ],
  "RU.69": [
    { code: "RU.69.479469", name: "Ugranskiy Rayon" },
    { code: "RU.69.499436", name: "Safonovskiy Rayon" },
  ],
  "RU.72": [
    { code: "RU.72.462315", name: "Znamenskiy Rayon" },
    { code: "RU.72.482496", name: "Tokarevskiy Rayon" },
    { code: "RU.72.498933", name: "Sampurskiy Rayon" },
    { code: "RU.72.502790", name: "Rasskazovskiy Rayon" },
  ],
  "RU.73": [
    { code: "RU.73.463834", name: "Zelenodolsky District" },
    { code: "RU.73.465542", name: "Zainskiy Rayon" },
    { code: "RU.73.468080", name: "Yelabuzhskiy Rayon" },
    { code: "RU.73.470163", name: "Vysokogorskiy Rayon" },
    { code: "RU.73.475457", name: "Verkhneuslonskiy Rayon" },
    { code: "RU.73.480620", name: "Tukayevskiy Rayon" },
    { code: "RU.73.483145", name: "Tetyushskiy Rayon" },
    { code: "RU.73.498536", name: "Sarmanovskiy Rayon" },
    { code: "RU.73.499665", name: "Sabinskiy Rayon" },
    { code: "RU.73.499980", name: "Rybno-Slobodskiy Rayon" },
    { code: "RU.73.510344", name: "Pestrechinskiy Rayon" },
    { code: "RU.73.515836", name: "Nurlatskiy Rayon" },
  ],
  "RU.76": [
    { code: "RU.76.464992", name: "Zaokskiy Rayon" },
    { code: "RU.76.468669", name: "Yasnogorskiy Rayon" },
    { code: "RU.76.475878", name: "Venevskiy Rayon" },
    { code: "RU.76.483600", name: "Tëplo-Ogarëvskiy Rayon" },
    { code: "RU.76.485863", name: "Suvorovskiy Rayon" },
  ],
  "RU.77": [
    { code: "RU.77.461999", name: "Zubtsovskiy Rayon" },
    { code: "RU.77.470263", name: "Vyshnevolotskiy Rayon" },
    { code: "RU.77.473942", name: "Ves’yegonskiy Rayon" },
    { code: "RU.77.479584", name: "Udomel’skiy Rayon" },
    { code: "RU.77.481984", name: "Torzhokskiy Rayon" },
    { code: "RU.77.482040", name: "Toropetskiy Rayon" },
    { code: "RU.77.488938", name: "Staritskiy Rayon" },
    { code: "RU.77.489675", name: "Spirovskiy Rayon" },
    { code: "RU.77.497660", name: "Selizharovskiy Rayon" },
    { code: "RU.77.498855", name: "Sandovskiy Rayon" },
    { code: "RU.77.502898", name: "Rameshkovskiy Rayon" },
    { code: "RU.77.511588", name: "Penovskiy Rayon" },
    { code: "RU.77.514249", name: "Ostashkovskiy Rayon" },
  ],
  "RU.80": [
    { code: "RU.80.464067", name: "Zav’yalovskiy Rayon" },
    { code: "RU.80.498681", name: "Sarapul’skiy Rayon" },
  ],
  "RU.81": [
    { code: "RU.81.479105", name: "Ulyanovskiy Rayon" },
    { code: "RU.81.480881", name: "Tsil’ninskiy Rayon" },
    { code: "RU.81.483428", name: "Teren’gul’skiy Rayon" },
    { code: "RU.81.488775", name: "Starokulatkinskiy Rayon" },
    { code: "RU.81.512019", name: "Pavlovskiy Rayon" },
  ],
  "RU.83": [
    { code: "RU.83.466214", name: "Yur’yev-Pol’skiy Rayon" },
    { code: "RU.83.470665", name: "Vyaznikovskiy Rayon" },
    { code: "RU.83.485819", name: "Suzdal’skiy Rayon" },
    { code: "RU.83.486831", name: "Sudogodskiy Rayon" },
    { code: "RU.83.491475", name: "Sobinskiy Rayon" },
    { code: "RU.83.497671", name: "Selivanovskiy Rayon" },
    { code: "RU.83.509702", name: "Petushinskiy Rayon" },
  ],
  "RU.84": [
    { code: "RU.84.462981", name: "Zhirnovskiy Rayon" },
    { code: "RU.84.468037", name: "Yelanskiy Rayon" },
    { code: "RU.84.478543", name: "Uryupinskiy Rayon" },
    { code: "RU.84.485691", name: "Svetloyarskiy Rayon" },
    { code: "RU.84.486070", name: "Surovikinskiy Rayon" },
    { code: "RU.84.488694", name: "Staropoltavskiy Rayon" },
    { code: "RU.84.489635", name: "Sredneakhtubinskiy Rayon" },
    { code: "RU.84.496956", name: "Serafimovichskiy Rayon" },
    { code: "RU.84.500654", name: "Rudnyanskiy Rayon" },
    { code: "RU.84.507965", name: "Kumylzhenskiy Rayon" },
    { code: "RU.84.513041", name: "Pallasovskiy Rayon" },
    { code: "RU.84.515423", name: "Ol’khovskiy Rayon" },
    { code: "RU.84.515839", name: "Oktyabr’skiy Rayon" },
  ],
  "RU.85": [
    { code: "RU.85.469961", name: "Vytegorskiy Rayon" },
    { code: "RU.85.471243", name: "Vozhegodskiy Rayon" },
    { code: "RU.85.472453", name: "Vologodskiy Rayon" },
    { code: "RU.85.474355", name: "Verkhovazhskiy Rayon" },
    { code: "RU.85.476029", name: "Velikoustyugskiy Rayon" },
    { code: "RU.85.476844", name: "Vashkinskiy Rayon" },
    { code: "RU.85.477796", name: "Ustyuzhenskiy Rayon" },
    { code: "RU.85.478053", name: "Ust’-Kubinskiy Rayon" },
    { code: "RU.85.481962", name: "Totemskiy Rayon" },
    { code: "RU.85.484313", name: "Tarnogskiy Rayon" },
    { code: "RU.85.485348", name: "Syamzhenskiy Rayon" },
    { code: "RU.85.491147", name: "Sokol’skiy Rayon" },
    { code: "RU.85.495059", name: "Sheksninskiy Rayon" },
  ],
  "RU.86": [
    { code: "RU.86.472069", name: "Vorob’yevskiy Rayon" },
    { code: "RU.86.475541", name: "Verkhnemamonskiy Rayon" },
    { code: "RU.86.475572", name: "Verkhnekhavskiy Rayon" },
    { code: "RU.86.483318", name: "Ternovskiy Rayon" },
    { code: "RU.86.484722", name: "Talovskiy Rayon" },
    { code: "RU.86.497203", name: "Semilukskiy Rayon" },
    { code: "RU.86.501216", name: "Rossoshanskiy Rayon" },
    { code: "RU.86.502082", name: "Rep’yevskiy Rayon" },
    { code: "RU.86.502892", name: "Ramonskiy Rayon" },
    { code: "RU.86.505805", name: "Povorinskiy Rayon" },
    { code: "RU.86.508393", name: "Podgorenskiy Rayon" },
    { code: "RU.86.510155", name: "Petropavlovskiy Rayon" },
    { code: "RU.86.512020", name: "Pavlovskiy Rayon" },
    { code: "RU.86.512837", name: "Paninskiy Rayon" },
    { code: "RU.86.514196", name: "Ostrogozhskiy Rayon" },
    { code: "RU.86.515526", name: "Ol’khovatskiy Rayon" },
    { code: "RU.86.517749", name: "Novousmanskiy Rayon" },
  ],
  "RU.88": [
    { code: "RU.88.468895", name: "Yaroslavskiy Rayon" },
    { code: "RU.88.479529", name: "Uglichskiy Rayon" },
    { code: "RU.88.480119", name: "Tutayevskiy Rayon" },
    { code: "RU.88.500001", name: "Rybinskiy Rayon" },
    { code: "RU.88.501161", name: "Rostovskiy Rayon" },
    { code: "RU.88.506030", name: "Poshekhonskiy Rayon" },
    { code: "RU.88.510851", name: "Pervomayskiy Rayon" },
    { code: "RU.88.511358", name: "Pereslavskiy Rayon" },
  ],
  "RU.90": [
    { code: "RU.90.466117", name: "Yus’vinskiy Rayon" },
    { code: "RU.90.466348", name: "Yurlinskiy Rayon" },
  ],
  "UA.04": [
    { code: "UA.04.9112939", name: "Ternivs’ka Mis’krada" },
    { code: "UA.04.9112940", name: "Pershotravens’ka Mis’krada" },
    { code: "UA.04.9199698", name: "Ordzhonikidzevs’ka Mis’krada" },
    { code: "UA.04.9199699", name: "Vil’nohirs’ka Mis’krada" },
    { code: "UA.04.9880180", name: "Kryvoriz’ka Mis’krada" },
    { code: "UA.04.9880181", name: "Zhovtovods’ka Mis’krada" },
    { code: "UA.04.9880191", name: "Marhanets’ka Mis’krada" },
  ],
  "UA.05": [
    { code: "UA.05.11886883", name: "Lyman Amalgated Territorial Community" },
    { code: "UA.05.9030862", name: "Kramators’ka Mis’krada" },
    { code: "UA.05.9030864", name: "Druzhkivs’ka Mis’krada" },
    { code: "UA.05.9030869", name: "Mariupol’s’ka Mis’krada" },
    { code: "UA.05.9030870", name: "Bakhmut Municipality" },
    { code: "UA.05.9030974", name: "Kostyantynivs’ka Mis’krada" },
    { code: "UA.05.9030975", name: "Krasnoarmiys’ka Mis’krada" },
    { code: "UA.05.9030976", name: "Dobropil’s’ka Mis’krada" },
    { code: "UA.05.9030978", name: "Selydivs’ka Mis’krada" },
    { code: "UA.05.9030979", name: "Vuhledars’ka Mis’krada" },
    { code: "UA.05.9030980", name: "Dokuchayevs’ka Mis’krada" },
    { code: "UA.05.9030981", name: "Debal’tsivs’ka Mis’krada" },
    { code: "UA.05.9030982", name: "Horlivs’ka Mis’krada" },
    { code: "UA.05.9030983", name: "Torets'k Municipality" },
    { code: "UA.05.9030984", name: "Yenakiyevs’ka Mis’krada" },
    { code: "UA.05.9030985", name: "Myrnohrad Municipality" },
    { code: "UA.05.9030986", name: "Novohrodivs’ka Mis’krada" },
    { code: "UA.05.9030987", name: "Makiyivs’ka Mis’krada" },
  ],
  "UA.06": [
    { code: "UA.06.9522667", name: "Kalus’ka Mis’krada" },
    { code: "UA.06.9523736", name: "Ivano-Frankivs’ka Mis’krada" },
    { code: "UA.06.9524094", name: "Yaremchans’ks Mis’krada" },
    { code: "UA.06.9524095", name: "Bolekhivs’ka Mis’krada" },
    { code: "UA.06.9524109", name: "Burshtyns’ka Mis’krada" },
  ],
  "UA.07": [
    { code: "UA.07.9101597", name: "Lozivs’ka Mis’krada" },
    { code: "UA.07.9114284", name: "Kharkivs’ka Mis’krada" },
    { code: "UA.07.9114317", name: "Chuhuyivs’ka Mis’krada" },
    { code: "UA.07.9115479", name: "Pecheniz’kyy Rayon" },
    { code: "UA.07.9115610", name: "Lyubotyns’ka Mis’krada" },
    { code: "UA.07.9194084", name: "Kup”yans’ka Mis’krada" },
  ],
  "UA.08": [
    { code: "UA.08.9873154", name: "Holoprystans’ka Mis’krada" },
    { code: "UA.08.9873486", name: "Novokakhovs’ka Mis’krada" },
    { code: "UA.08.9873490", name: "Kakhovs’ka Mis’krada" },
    { code: "UA.08.9875813", name: "Khersons’ka Mis’krada" },
  ],
  "UA.09": [
    { code: "UA.09.9532774", name: "Khmel’nyts’ka Mis’krada" },
    { code: "UA.09.9532860", name: "Slavuts’ka Mis’krada" },
    { code: "UA.09.9532887", name: "Starokostyantynivs’ka Mis’krada" },
    { code: "UA.09.9532888", name: "Shepetivs’ka Mis’krada" },
    { code: "UA.09.9532892", name: "Kam”yanets’-Podil’s’ka Mis’krada" },
  ],
  "UA.10": [
    { code: "UA.10.9815163", name: "Oleksandriys’ka Mis’krada" },
    { code: "UA.10.9815215", name: "Svitlovods’ka Mis’krada" },
    { code: "UA.10.9815237", name: "Kirovohrads’ka Mis’krada" },
  ],
  "UA.13": [
    { code: "UA.13.9864787", name: "Kyyevo-Svyatoshyns’kyy Rayon" },
  ],
  "UA.15": [
    { code: "UA.15.9290334", name: "Stryys’ka Mis’krada" },
    { code: "UA.15.9290342", name: "Morshyns’ka Mis’krada" },
    { code: "UA.15.9290363", name: "Sambirs’ka Mis’krada" },
    { code: "UA.15.9290369", name: "Drohobyts’ka Mis’krada" },
    { code: "UA.15.9290402", name: "Boryslavs’ka Mis’krada" },
    { code: "UA.15.9290406", name: "Truskavets’ka Mis’krada" },
    { code: "UA.15.9290763", name: "Chervonohrads’ka Mis’krada" },
    { code: "UA.15.9290764", name: "Novorozdil’s’ka Mis’krada" },
    { code: "UA.15.9290819", name: "L’vivs’ka Mis’krada" },
  ],
  "UA.16": [
    { code: "UA.16.9821289", name: "Pervomays’ka Mis’krada" },
    { code: "UA.16.9821290", name: "Voznesens’ka Mis’krada" },
    { code: "UA.16.9821291", name: "Ochakivs’ka Mis’krada" },
    { code: "UA.16.9821293", name: "Mykolayivs’ka Mis’krada" },
    { code: "UA.16.9821705", name: "Yuzhnoukrayins’ka Mis’krada" },
  ],
  "UA.17": [
    { code: "UA.17.9819414", name: "Bilhorod-Dnistrovs’ka Mis’krada" },
    { code: "UA.17.9819571", name: "Odes’ka Mis’krada" },
    { code: "UA.17.9819573", name: "Kotovs’ka Mis’krada" },
    { code: "UA.17.9820090", name: "Izmayil’s’ka Mis’krada" },
    { code: "UA.17.9821202", name: "Chornomorsk Municipality" },
    { code: "UA.17.9821213", name: "Teplodars’ka Mis’krada" },
    { code: "UA.17.9821216", name: "Yuznens’ka Mis’krada" },
    { code: "UA.17.9821222", name: "Reniys’kyy Rayon" },
  ],
  "UA.18": [
    { code: "UA.18.9877155", name: "Kremenchuts’ka Mis’krada" },
    { code: "UA.18.9877729", name: "Myrhorods’ka Mis’krada" },
    { code: "UA.18.9877730", name: "Komsomol’s’ka Mis’krada" },
    { code: "UA.18.9878697", name: "Lubens’ka Mis’krada" },
  ],
  "UA.19": [
    { code: "UA.19.9288591", name: "Kuznetsovs’ka Mis’krada" },
    { code: "UA.19.9289933", name: "Demydivs’kyy Rayon" },
    { code: "UA.19.9289934", name: "Dubens’ka Mis’krada" },
    { code: "UA.19.9289935", name: "Mlynivs’kyy Rayon" },
    { code: "UA.19.9289947", name: "Ostroz’ka Mis’krada" },
    { code: "UA.19.9289988", name: "Rivnens’ka Mis’krada" },
  ],
  "UA.21": [
    { code: "UA.21.9194082", name: "Okhtyrs’ka Mis’krada" },
    { code: "UA.21.9199696", name: "Hlukhivs’ka Mis’krada" },
    { code: "UA.21.9199697", name: "Sums’ka Mis’krada" },
  ],
  "UA.22": [
    { code: "UA.22.11906063", name: "Kremenets Municipality" },
    { code: "UA.22.9526267", name: "Chortkivs’ka Mis’krada" },
    { code: "UA.22.9526273", name: "Ternopil’s’ka Mis’krada" },
    { code: "UA.22.9526278", name: "Zalishchyts’kyy Rayon" },
    { code: "UA.22.9526289", name: "Pidhayets’kyy Rayon" },
  ],
  "UA.24": [
    { code: "UA.24.9287851", name: "Volodymyr-Volyns’ka Mis’krada" },
    { code: "UA.24.9287853", name: "Kovel’s’ka Mis’krada" },
    { code: "UA.24.9287950", name: "Luts’ka Mis’krada" },
    { code: "UA.24.9289908", name: "Shats’kyy Rayon" },
    { code: "UA.24.9289932", name: "Novovolyns’ka Mis’krada" },
  ],
  "UA.25": [
    { code: "UA.25.9291195", name: "Khusts’ka Mis’krada" },
    { code: "UA.25.9291259", name: "Berehivs’ka Mis’krada" },
    { code: "UA.25.9291276", name: "Uzhhorods’ka Mis’krada" },
    { code: "UA.25.9291277", name: "Chops’ka Mis’krada" },
    { code: "UA.25.9291358", name: "Mukachivs’ka Mis’krada" },
  ],
  "UA.26": [
    { code: "UA.26.9130025", name: "Berdyans’ka Mis’krada" },
    { code: "UA.26.9130026", name: "Melitopol’s’ka Mis’krada" },
    { code: "UA.26.9130027", name: "Velykobilozers’kyy Rayon" },
    { code: "UA.26.9130028", name: "Enerhodars’ka Mis’krada" },
    { code: "UA.26.9130138", name: "Tokmats’ka Mis’krada" },
    { code: "UA.26.9133385", name: "Rozivs’kyy Rayon" },
    { code: "UA.26.9133387", name: "Zaporiz’ka Mis’krada" },
  ],
  "UA.27": [
    { code: "UA.27.12022269", name: "Zhytomyr City Amalgamated Territorial Commmunity" },
  ],
  "UG.C": [
    { code: "UG.C.36", name: "Kalangala District" },
    { code: "UG.C.37", name: "Kampala District" },
    { code: "UG.C.42", name: "Kiboga District" },
    { code: "UG.C.56", name: "Mubende District" },
    { code: "UG.C.61", name: "Rakai District" },
    { code: "UG.C.70", name: "Luwero District" },
    { code: "UG.C.71", name: "Masaka District" },
    { code: "UG.C.73", name: "Nakasongola District" },
    { code: "UG.C.74", name: "Sembabule District" },
    { code: "UG.C.83", name: "Kayunga District" },
    { code: "UG.C.89", name: "Mpigi District" },
    { code: "UG.C.90", name: "Mukono District" },
    { code: "UG.C.96", name: "Wakiso District" },
    { code: "UG.C.D5", name: "Lyantonde District" },
    { code: "UG.C.D8", name: "Mityana District" },
    { code: "UG.C.D9", name: "Nakaseke District" },
    { code: "UG.C.E7", name: "Buikwe District" },
    { code: "UG.C.E8", name: "Bukomansimbi District" },
    { code: "UG.C.F1", name: "Butambala District" },
    { code: "UG.C.F2", name: "Buvuma District" },
    { code: "UG.C.F4", name: "Gomba District" },
    { code: "UG.C.F5", name: "Kalungu District" },
    { code: "UG.C.G1", name: "Kyankwanzi District" },
    { code: "UG.C.G5", name: "Lwengo District" },
    { code: "UG.C.I3", name: "Kyotera" },
  ],
  "UG.E": [
    { code: "UG.E.33", name: "Jinja District" },
    { code: "UG.E.38", name: "Kamuli District" },
    { code: "UG.E.39", name: "Kapchorwa District" },
    { code: "UG.E.46", name: "Kumi District" },
    { code: "UG.E.60", name: "Pallisa District" },
    { code: "UG.E.66", name: "Bugiri District" },
    { code: "UG.E.67", name: "Busia District" },
    { code: "UG.E.69", name: "Katakwi District" },
    { code: "UG.E.76", name: "Tororo District" },
    { code: "UG.E.78", name: "Iganga District" },
    { code: "UG.E.80", name: "Kaberamaido District" },
    { code: "UG.E.86", name: "Mayuge District" },
    { code: "UG.E.87", name: "Mbale District" },
    { code: "UG.E.94", name: "Sironko District" },
    { code: "UG.E.95", name: "Soroti District" },
    { code: "UG.E.B8", name: "Amuria District" },
    { code: "UG.E.C1", name: "Budaka District" },
    { code: "UG.E.C2", name: "Bududa District" },
    { code: "UG.E.C3", name: "Bukedea District" },
    { code: "UG.E.C4", name: "Bukwa District" },
    { code: "UG.E.C6", name: "Butaleja District" },
    { code: "UG.E.D2", name: "Kaliro District" },
    { code: "UG.E.D6", name: "Manafwa District" },
    { code: "UG.E.E1", name: "Namutumba District" },
    { code: "UG.E.E9", name: "Bulambuli District" },
    { code: "UG.E.F3", name: "Buyende District" },
    { code: "UG.E.F6", name: "Kibuku District" },
    { code: "UG.E.F9", name: "Kween District" },
    { code: "UG.E.G4", name: "Luuka District" },
    { code: "UG.E.G7", name: "Namayingo District" },
    { code: "UG.E.G9", name: "Ngora District" },
    { code: "UG.E.H5", name: "Serere District" },
    { code: "UG.E.H9", name: "Butebo" },
    { code: "UG.E.I4", name: "Namisindwa" },
  ],
  "UG.N": [
    { code: "UG.N.26", name: "Apac District" },
    { code: "UG.N.30", name: "Gulu District" },
    { code: "UG.N.45", name: "Kotido District" },
    { code: "UG.N.47", name: "Lira District" },
    { code: "UG.N.58", name: "Nebbi District" },
    { code: "UG.N.65", name: "Adjumani District" },
    { code: "UG.N.72", name: "Moyo District" },
    { code: "UG.N.77", name: "Arua District" },
    { code: "UG.N.84", name: "Kitgum District" },
    { code: "UG.N.88", name: "Moroto District" },
    { code: "UG.N.91", name: "Nakapiripirit District" },
    { code: "UG.N.92", name: "Pader District" },
    { code: "UG.N.97", name: "Yumbe District" },
    { code: "UG.N.B6", name: "Abim District" },
    { code: "UG.N.B7", name: "Amolatar District" },
    { code: "UG.N.B9", name: "Amuru District" },
    { code: "UG.N.C7", name: "Dokolo District" },
    { code: "UG.N.D1", name: "Kaabong District" },
    { code: "UG.N.D4", name: "Koboko District" },
    { code: "UG.N.D7", name: "Maracha District" },
    { code: "UG.N.E2", name: "Oyam District" },
    { code: "UG.N.E3", name: "Agago District" },
    { code: "UG.N.E4", name: "Alebtong District" },
    { code: "UG.N.E5", name: "Amudat District" },
    { code: "UG.N.F8", name: "Kole District" },
    { code: "UG.N.G3", name: "Lamwo District" },
    { code: "UG.N.G8", name: "Napak District" },
    { code: "UG.N.H2", name: "Nwoya District" },
    { code: "UG.N.H3", name: "Otuke District" },
    { code: "UG.N.H7", name: "Zombo District" },
    { code: "UG.N.I5", name: "Omoro" },
    { code: "UG.N.I6", name: "Pakwach" },
  ],
  "UG.W": [
    { code: "UG.W.28", name: "Bundibugyo District" },
    { code: "UG.W.29", name: "Bushenyi District" },
    { code: "UG.W.31", name: "Hoima District" },
    { code: "UG.W.34", name: "Kabale District" },
    { code: "UG.W.40", name: "Kasese District" },
    { code: "UG.W.41", name: "Kibale District" },
    { code: "UG.W.43", name: "Kisoro District" },
    { code: "UG.W.50", name: "Masindi District" },
    { code: "UG.W.52", name: "Mbarara District" },
    { code: "UG.W.59", name: "Ntungamo District" },
    { code: "UG.W.79", name: "Kabarole District" },
    { code: "UG.W.81", name: "Kamwenge District" },
    { code: "UG.W.82", name: "Kanungu District" },
    { code: "UG.W.85", name: "Kyenjojo District" },
    { code: "UG.W.93", name: "Rukungiri District" },
    { code: "UG.W.C5", name: "Bulisa District" },
    { code: "UG.W.C8", name: "Ibanda District" },
    { code: "UG.W.C9", name: "Isingiro District" },
    { code: "UG.W.D3", name: "Kiruhura District" },
    { code: "UG.W.E6", name: "Buhweju District" },
    { code: "UG.W.F7", name: "Kiryandongo District" },
    { code: "UG.W.G2", name: "Kyegegwa District" },
    { code: "UG.W.G6", name: "Mitoma District" },
    { code: "UG.W.H1", name: "Ntoroko District" },
    { code: "UG.W.H4", name: "Rubirizi District" },
    { code: "UG.W.H6", name: "Sheema District" },
    { code: "UG.W.H8", name: "Bunyangabu" },
    { code: "UG.W.I1", name: "Kagadi" },
    { code: "UG.W.I2", name: "Kakumiro" },
    { code: "UG.W.I7", name: "Rubanda" },
    { code: "UG.W.I8", name: "Rukiga" },
  ],
  "US.AK": [
    { code: "US.AK.013", name: "Aleutians East Borough" },
    { code: "US.AK.016", name: "Aleutians West Census Area" },
    { code: "US.AK.020", name: "Anchorage Municipality" },
    { code: "US.AK.050", name: "Bethel Census Area" },
    { code: "US.AK.060", name: "Bristol Bay Borough" },
    { code: "US.AK.068", name: "Denali Borough" },
    { code: "US.AK.070", name: "Dillingham Census Area" },
    { code: "US.AK.090", name: "Fairbanks North Star Borough" },
    { code: "US.AK.100", name: "Haines Borough" },
    { code: "US.AK.105", name: "Hoonah-Angoon Census Area" },
    { code: "US.AK.110", name: "Juneau City and Borough" },
    { code: "US.AK.122", name: "Kenai Peninsula Borough" },
    { code: "US.AK.130", name: "Ketchikan Gateway Borough" },
    { code: "US.AK.150", name: "Kodiak Island Borough" },
    { code: "US.AK.158", name: "Kusilvak Census Area" },
    { code: "US.AK.164", name: "Lake and Peninsula Borough" },
    { code: "US.AK.170", name: "Matanuska-Susitna Borough" },
    { code: "US.AK.180", name: "Nome Census Area" },
    { code: "US.AK.185", name: "North Slope Borough" },
    { code: "US.AK.188", name: "Northwest Arctic Borough" },
    { code: "US.AK.195", name: "Petersburg Borough" },
    { code: "US.AK.198", name: "Prince of Wales-Hyder Census Area, Alaska" },
    { code: "US.AK.220", name: "Sitka City and Borough" },
    { code: "US.AK.230", name: "Skagway Municipality" },
    { code: "US.AK.240", name: "Southeast Fairbanks Census Area" },
    { code: "US.AK.261", name: "Valdez-Cordova Census Area" },
    { code: "US.AK.275", name: "City and Borough of Wrangell" },
    { code: "US.AK.282", name: "Yakutat City and Borough" },
    { code: "US.AK.290", name: "Yukon-Koyukuk Census Area" },
  ],
  "US.AL": [
    { code: "US.AL.001", name: "Autauga County" },
    { code: "US.AL.003", name: "Baldwin County" },
    { code: "US.AL.005", name: "Barbour County" },
    { code: "US.AL.007", name: "Bibb County" },
    { code: "US.AL.009", name: "Blount County" },
    { code: "US.AL.011", name: "Bullock County" },
    { code: "US.AL.013", name: "Butler County" },
    { code: "US.AL.015", name: "Calhoun County" },
    { code: "US.AL.017", name: "Chambers County" },
    { code: "US.AL.019", name: "Cherokee County" },
    { code: "US.AL.021", name: "Chilton County" },
    { code: "US.AL.023", name: "Choctaw County" },
    { code: "US.AL.025", name: "Clarke County" },
    { code: "US.AL.027", name: "Clay County" },
    { code: "US.AL.029", name: "Cleburne County" },
    { code: "US.AL.031", name: "Coffee County" },
    { code: "US.AL.033", name: "Colbert County" },
    { code: "US.AL.035", name: "Conecuh County" },
    { code: "US.AL.037", name: "Coosa County" },
    { code: "US.AL.039", name: "Covington County" },
    { code: "US.AL.041", name: "Crenshaw County" },
    { code: "US.AL.043", name: "Cullman County" },
    { code: "US.AL.045", name: "Dale County" },
    { code: "US.AL.047", name: "Dallas County" },
    { code: "US.AL.049", name: "DeKalb County" },
    { code: "US.AL.051", name: "Elmore County" },
    { code: "US.AL.053", name: "Escambia County" },
    { code: "US.AL.055", name: "Etowah County" },
    { code: "US.AL.057", name: "Fayette County" },
    { code: "US.AL.059", name: "Franklin County" },
    { code: "US.AL.061", name: "Geneva County" },
    { code: "US.AL.063", name: "Greene County" },
    { code: "US.AL.065", name: "Hale County" },
    { code: "US.AL.067", name: "Henry County" },
    { code: "US.AL.069", name: "Houston County" },
    { code: "US.AL.071", name: "Jackson County" },
    { code: "US.AL.073", name: "Jefferson County" },
    { code: "US.AL.075", name: "Lamar County" },
    { code: "US.AL.077", name: "Lauderdale County" },
    { code: "US.AL.079", name: "Lawrence County" },
    { code: "US.AL.081", name: "Lee County" },
    { code: "US.AL.083", name: "Limestone County" },
    { code: "US.AL.085", name: "Lowndes County" },
    { code: "US.AL.087", name: "Macon County" },
    { code: "US.AL.089", name: "Madison County" },
    { code: "US.AL.091", name: "Marengo County" },
    { code: "US.AL.093", name: "Marion County" },
    { code: "US.AL.095", name: "Marshall County" },
    { code: "US.AL.097", name: "Mobile County" },
    { code: "US.AL.099", name: "Monroe County" },
    { code: "US.AL.101", name: "Montgomery County" },
    { code: "US.AL.103", name: "Morgan County" },
    { code: "US.AL.105", name: "Perry County" },
    { code: "US.AL.107", name: "Pickens County" },
    { code: "US.AL.109", name: "Pike County" },
    { code: "US.AL.111", name: "Randolph County" },
    { code: "US.AL.113", name: "Russell County" },
    { code: "US.AL.115", name: "Saint Clair County" },
    { code: "US.AL.117", name: "Shelby County" },
    { code: "US.AL.119", name: "Sumter County" },
    { code: "US.AL.121", name: "Talladega County" },
    { code: "US.AL.123", name: "Tallapoosa County" },
    { code: "US.AL.125", name: "Tuscaloosa County" },
    { code: "US.AL.127", name: "Walker County" },
    { code: "US.AL.129", name: "Washington County" },
    { code: "US.AL.131", name: "Wilcox County" },
    { code: "US.AL.133", name: "Winston County" },
  ],
  "US.AR": [
    { code: "US.AR.001", name: "Arkansas County" },
    { code: "US.AR.003", name: "Ashley County" },
    { code: "US.AR.005", name: "Baxter County" },
    { code: "US.AR.007", name: "Benton County" },
    { code: "US.AR.009", name: "Boone County" },
    { code: "US.AR.011", name: "Bradley County" },
    { code: "US.AR.013", name: "Calhoun County" },
    { code: "US.AR.015", name: "Carroll County" },
    { code: "US.AR.017", name: "Chicot County" },
    { code: "US.AR.019", name: "Clark County" },
    { code: "US.AR.021", name: "Clay County" },
    { code: "US.AR.023", name: "Cleburne County" },
    { code: "US.AR.025", name: "Cleveland County" },
    { code: "US.AR.027", name: "Columbia County" },
    { code: "US.AR.029", name: "Conway County" },
    { code: "US.AR.031", name: "Craighead County" },
    { code: "US.AR.033", name: "Crawford County" },
    { code: "US.AR.035", name: "Crittenden County" },
    { code: "US.AR.037", name: "Cross County" },
    { code: "US.AR.039", name: "Dallas County" },
    { code: "US.AR.041", name: "Desha County" },
    { code: "US.AR.043", name: "Drew County" },
    { code: "US.AR.045", name: "Faulkner County" },
    { code: "US.AR.047", name: "Franklin County" },
    { code: "US.AR.049", name: "Fulton County" },
    { code: "US.AR.051", name: "Garland County" },
    { code: "US.AR.053", name: "Grant County" },
    { code: "US.AR.055", name: "Greene County" },
    { code: "US.AR.057", name: "Hempstead County" },
    { code: "US.AR.059", name: "Hot Spring County" },
    { code: "US.AR.061", name: "Howard County" },
    { code: "US.AR.063", name: "Independence County" },
    { code: "US.AR.065", name: "Izard County" },
    { code: "US.AR.067", name: "Jackson County" },
    { code: "US.AR.069", name: "Jefferson County" },
    { code: "US.AR.071", name: "Johnson County" },
    { code: "US.AR.073", name: "Lafayette County" },
    { code: "US.AR.075", name: "Lawrence County" },
    { code: "US.AR.077", name: "Lee County" },
    { code: "US.AR.079", name: "Lincoln County" },
    { code: "US.AR.081", name: "Little River County" },
    { code: "US.AR.083", name: "Logan County" },
    { code: "US.AR.085", name: "Lonoke County" },
    { code: "US.AR.087", name: "Madison County" },
    { code: "US.AR.089", name: "Marion County" },
    { code: "US.AR.091", name: "Miller County" },
    { code: "US.AR.093", name: "Mississippi County" },
    { code: "US.AR.095", name: "Monroe County" },
    { code: "US.AR.097", name: "Montgomery County" },
    { code: "US.AR.099", name: "Nevada County" },
    { code: "US.AR.101", name: "Newton County" },
    { code: "US.AR.103", name: "Ouachita County" },
    { code: "US.AR.105", name: "Perry County" },
    { code: "US.AR.107", name: "Phillips County" },
    { code: "US.AR.109", name: "Pike County" },
    { code: "US.AR.111", name: "Poinsett County" },
    { code: "US.AR.113", name: "Polk County" },
    { code: "US.AR.115", name: "Pope County" },
    { code: "US.AR.117", name: "Prairie County" },
    { code: "US.AR.119", name: "Pulaski County" },
    { code: "US.AR.121", name: "Randolph County" },
    { code: "US.AR.123", name: "Saint Francis County" },
    { code: "US.AR.125", name: "Saline County" },
    { code: "US.AR.127", name: "Scott County" },
    { code: "US.AR.129", name: "Searcy County" },
    { code: "US.AR.131", name: "Sebastian County" },
    { code: "US.AR.133", name: "Sevier County" },
    { code: "US.AR.135", name: "Sharp County" },
    { code: "US.AR.137", name: "Stone County" },
    { code: "US.AR.139", name: "Union County" },
    { code: "US.AR.141", name: "Van Buren County" },
    { code: "US.AR.143", name: "Washington County" },
    { code: "US.AR.145", name: "White County" },
    { code: "US.AR.147", name: "Woodruff County" },
    { code: "US.AR.149", name: "Yell County" },
  ],
  "US.AZ": [
    { code: "US.AZ.001", name: "Apache County" },
    { code: "US.AZ.003", name: "Cochise County" },
    { code: "US.AZ.005", name: "Coconino County" },
    { code: "US.AZ.007", name: "Gila County" },
    { code: "US.AZ.009", name: "Graham County" },
    { code: "US.AZ.011", name: "Greenlee County" },
    { code: "US.AZ.012", name: "La Paz County" },
    { code: "US.AZ.013", name: "Maricopa County" },
    { code: "US.AZ.015", name: "Mohave County" },
    { code: "US.AZ.017", name: "Navajo County" },
    { code: "US.AZ.019", name: "Pima County" },
    { code: "US.AZ.021", name: "Pinal County" },
    { code: "US.AZ.023", name: "Santa Cruz County" },
    { code: "US.AZ.025", name: "Yavapai County" },
    { code: "US.AZ.027", name: "Yuma County" },
  ],
  "US.CA": [
    { code: "US.CA.001", name: "Alameda County" },
    { code: "US.CA.003", name: "Alpine County" },
    { code: "US.CA.005", name: "Amador County" },
    { code: "US.CA.007", name: "Butte County" },
    { code: "US.CA.009", name: "Calaveras County" },
    { code: "US.CA.011", name: "Colusa County" },
    { code: "US.CA.013", name: "Contra Costa County" },
    { code: "US.CA.015", name: "Del Norte County" },
    { code: "US.CA.017", name: "El Dorado County" },
    { code: "US.CA.019", name: "Fresno County" },
    { code: "US.CA.021", name: "Glenn County" },
    { code: "US.CA.023", name: "Humboldt County" },
    { code: "US.CA.025", name: "Imperial County" },
    { code: "US.CA.027", name: "Inyo County" },
    { code: "US.CA.029", name: "Kern County" },
    { code: "US.CA.031", name: "Kings County" },
    { code: "US.CA.033", name: "Lake County" },
    { code: "US.CA.035", name: "Lassen County" },
    { code: "US.CA.037", name: "Los Angeles County" },
    { code: "US.CA.039", name: "Madera County" },
    { code: "US.CA.041", name: "Marin County" },
    { code: "US.CA.043", name: "Mariposa County" },
    { code: "US.CA.045", name: "Mendocino County" },
    { code: "US.CA.047", name: "Merced County" },
    { code: "US.CA.049", name: "Modoc County" },
    { code: "US.CA.051", name: "Mono County" },
    { code: "US.CA.053", name: "Monterey County" },
    { code: "US.CA.055", name: "Napa County" },
    { code: "US.CA.057", name: "Nevada County" },
    { code: "US.CA.059", name: "Orange County" },
    { code: "US.CA.061", name: "Placer County" },
    { code: "US.CA.063", name: "Plumas County" },
    { code: "US.CA.065", name: "Riverside County" },
    { code: "US.CA.067", name: "Sacramento County" },
    { code: "US.CA.069", name: "San Benito County" },
    { code: "US.CA.071", name: "San Bernardino County" },
    { code: "US.CA.073", name: "San Diego County" },
    { code: "US.CA.075", name: "City and County of San Francisco" },
    { code: "US.CA.077", name: "San Joaquin County" },
    { code: "US.CA.079", name: "San Luis Obispo County" },
    { code: "US.CA.081", name: "San Mateo County" },
    { code: "US.CA.083", name: "Santa Barbara County" },
    { code: "US.CA.085", name: "Santa Clara County" },
    { code: "US.CA.087", name: "Santa Cruz County" },
    { code: "US.CA.089", name: "Shasta County" },
    { code: "US.CA.091", name: "Sierra County" },
    { code: "US.CA.093", name: "Siskiyou County" },
    { code: "US.CA.095", name: "Solano County" },
    { code: "US.CA.097", name: "Sonoma County" },
    { code: "US.CA.099", name: "Stanislaus County" },
    { code: "US.CA.101", name: "Sutter County" },
    { code: "US.CA.103", name: "Tehama County" },
    { code: "US.CA.105", name: "Trinity County" },
    { code: "US.CA.107", name: "Tulare County" },
    { code: "US.CA.109", name: "Tuolumne County" },
    { code: "US.CA.111", name: "Ventura County" },
    { code: "US.CA.113", name: "Yolo County" },
    { code: "US.CA.115", name: "Yuba County" },
  ],
  "US.CO": [
    { code: "US.CO.001", name: "Adams County" },
    { code: "US.CO.003", name: "Alamosa County" },
    { code: "US.CO.005", name: "Arapahoe County" },
    { code: "US.CO.007", name: "Archuleta County" },
    { code: "US.CO.009", name: "Baca County" },
    { code: "US.CO.011", name: "Bent County" },
    { code: "US.CO.013", name: "Boulder County" },
    { code: "US.CO.014", name: "Broomfield County" },
    { code: "US.CO.015", name: "Chaffee County" },
    { code: "US.CO.017", name: "Cheyenne County" },
    { code: "US.CO.019", name: "Clear Creek County" },
    { code: "US.CO.021", name: "Conejos County" },
    { code: "US.CO.023", name: "Costilla County" },
    { code: "US.CO.025", name: "Crowley County" },
    { code: "US.CO.027", name: "Custer County" },
    { code: "US.CO.029", name: "Delta County" },
    { code: "US.CO.031", name: "Denver County" },
    { code: "US.CO.033", name: "Dolores County" },
    { code: "US.CO.035", name: "Douglas County" },
    { code: "US.CO.037", name: "Eagle County" },
    { code: "US.CO.039", name: "Elbert County" },
    { code: "US.CO.041", name: "El Paso County" },
    { code: "US.CO.043", name: "Fremont County" },
    { code: "US.CO.045", name: "Garfield County" },
    { code: "US.CO.047", name: "Gilpin County" },
    { code: "US.CO.049", name: "Grand County" },
    { code: "US.CO.051", name: "Gunnison County" },
    { code: "US.CO.053", name: "Hinsdale County" },
    { code: "US.CO.055", name: "Huerfano County" },
    { code: "US.CO.057", name: "Jackson County" },
    { code: "US.CO.059", name: "Jefferson County" },
    { code: "US.CO.061", name: "Kiowa County" },
    { code: "US.CO.063", name: "Kit Carson County" },
    { code: "US.CO.065", name: "Lake County" },
    { code: "US.CO.067", name: "La Plata County" },
    { code: "US.CO.069", name: "Larimer County" },
    { code: "US.CO.071", name: "Las Animas County" },
    { code: "US.CO.073", name: "Lincoln County" },
    { code: "US.CO.075", name: "Logan County" },
    { code: "US.CO.077", name: "Mesa County" },
    { code: "US.CO.079", name: "Mineral County" },
    { code: "US.CO.081", name: "Moffat County" },
    { code: "US.CO.083", name: "Montezuma County" },
    { code: "US.CO.085", name: "Montrose County" },
    { code: "US.CO.087", name: "Morgan County" },
    { code: "US.CO.089", name: "Otero County" },
    { code: "US.CO.091", name: "Ouray County" },
    { code: "US.CO.093", name: "Park County" },
    { code: "US.CO.095", name: "Phillips County" },
    { code: "US.CO.097", name: "Pitkin County" },
    { code: "US.CO.099", name: "Prowers County" },
    { code: "US.CO.101", name: "Pueblo County" },
    { code: "US.CO.103", name: "Rio Blanco County" },
    { code: "US.CO.105", name: "Rio Grande County" },
    { code: "US.CO.107", name: "Routt County" },
    { code: "US.CO.109", name: "Saguache County" },
    { code: "US.CO.111", name: "San Juan County" },
    { code: "US.CO.113", name: "San Miguel County" },
    { code: "US.CO.115", name: "Sedgwick County" },
    { code: "US.CO.117", name: "Summit County" },
    { code: "US.CO.119", name: "Teller County" },
    { code: "US.CO.121", name: "Washington County" },
    { code: "US.CO.123", name: "Weld County" },
    { code: "US.CO.125", name: "Yuma County" },
  ],
  "US.CT": [
    { code: "US.CT.001", name: "Fairfield County" },
    { code: "US.CT.003", name: "Hartford County" },
    { code: "US.CT.005", name: "Litchfield County" },
    { code: "US.CT.007", name: "Middlesex County" },
    { code: "US.CT.009", name: "New Haven County" },
    { code: "US.CT.011", name: "New London County" },
    { code: "US.CT.013", name: "Tolland County" },
    { code: "US.CT.015", name: "Windham County" },
  ],
  "US.DC": [
    { code: "US.DC.001", name: "Washington County" },
  ],
  "US.DE": [
    { code: "US.DE.001", name: "Kent County" },
    { code: "US.DE.003", name: "New Castle County" },
    { code: "US.DE.005", name: "Sussex County" },
  ],
  "US.FL": [
    { code: "US.FL.001", name: "Alachua County" },
    { code: "US.FL.003", name: "Baker County" },
    { code: "US.FL.005", name: "Bay County" },
    { code: "US.FL.007", name: "Bradford County" },
    { code: "US.FL.009", name: "Brevard County" },
    { code: "US.FL.011", name: "Broward County" },
    { code: "US.FL.013", name: "Calhoun County" },
    { code: "US.FL.015", name: "Charlotte County" },
    { code: "US.FL.017", name: "Citrus County" },
    { code: "US.FL.019", name: "Clay County" },
    { code: "US.FL.021", name: "Collier County" },
    { code: "US.FL.023", name: "Columbia County" },
    { code: "US.FL.027", name: "DeSoto County" },
    { code: "US.FL.029", name: "Dixie County" },
    { code: "US.FL.031", name: "Duval County" },
    { code: "US.FL.033", name: "Escambia County" },
    { code: "US.FL.035", name: "Flagler County" },
    { code: "US.FL.037", name: "Franklin County" },
    { code: "US.FL.039", name: "Gadsden County" },
    { code: "US.FL.041", name: "Gilchrist County" },
    { code: "US.FL.043", name: "Glades County" },
    { code: "US.FL.045", name: "Gulf County" },
    { code: "US.FL.047", name: "Hamilton County" },
    { code: "US.FL.049", name: "Hardee County" },
    { code: "US.FL.051", name: "Hendry County" },
    { code: "US.FL.053", name: "Hernando County" },
    { code: "US.FL.055", name: "Highlands County" },
    { code: "US.FL.057", name: "Hillsborough County" },
    { code: "US.FL.059", name: "Holmes County" },
    { code: "US.FL.061", name: "Indian River County" },
    { code: "US.FL.063", name: "Jackson County" },
    { code: "US.FL.065", name: "Jefferson County" },
    { code: "US.FL.067", name: "Lafayette County" },
    { code: "US.FL.069", name: "Lake County" },
    { code: "US.FL.071", name: "Lee County" },
    { code: "US.FL.073", name: "Leon County" },
    { code: "US.FL.075", name: "Levy County" },
    { code: "US.FL.077", name: "Liberty County" },
    { code: "US.FL.079", name: "Madison County" },
    { code: "US.FL.081", name: "Manatee County" },
    { code: "US.FL.083", name: "Marion County" },
    { code: "US.FL.085", name: "Martin County" },
    { code: "US.FL.086", name: "Miami-Dade County" },
    { code: "US.FL.087", name: "Monroe County" },
    { code: "US.FL.089", name: "Nassau County" },
    { code: "US.FL.091", name: "Okaloosa County" },
    { code: "US.FL.093", name: "Okeechobee County" },
    { code: "US.FL.095", name: "Orange County" },
    { code: "US.FL.097", name: "Osceola County" },
    { code: "US.FL.099", name: "Palm Beach County" },
    { code: "US.FL.101", name: "Pasco County" },
    { code: "US.FL.103", name: "Pinellas County" },
    { code: "US.FL.105", name: "Polk County" },
    { code: "US.FL.107", name: "Putnam County" },
    { code: "US.FL.109", name: "Saint Johns County" },
    { code: "US.FL.111", name: "Saint Lucie County" },
    { code: "US.FL.113", name: "Santa Rosa County" },
    { code: "US.FL.115", name: "Sarasota County" },
    { code: "US.FL.117", name: "Seminole County" },
    { code: "US.FL.119", name: "Sumter County" },
    { code: "US.FL.121", name: "Suwannee County" },
    { code: "US.FL.123", name: "Taylor County" },
    { code: "US.FL.125", name: "Union County" },
    { code: "US.FL.127", name: "Volusia County" },
    { code: "US.FL.129", name: "Wakulla County" },
    { code: "US.FL.131", name: "Walton County" },
    { code: "US.FL.133", name: "Washington County" },
  ],
  "US.GA": [
    { code: "US.GA.001", name: "Appling County" },
    { code: "US.GA.003", name: "Atkinson County" },
    { code: "US.GA.005", name: "Bacon County" },
    { code: "US.GA.007", name: "Baker County" },
    { code: "US.GA.009", name: "Baldwin County" },
    { code: "US.GA.011", name: "Banks County" },
    { code: "US.GA.013", name: "Barrow County" },
    { code: "US.GA.015", name: "Bartow County" },
    { code: "US.GA.017", name: "Ben Hill County" },
    { code: "US.GA.019", name: "Berrien County" },
    { code: "US.GA.021", name: "Bibb County" },
    { code: "US.GA.023", name: "Bleckley County" },
    { code: "US.GA.025", name: "Brantley County" },
    { code: "US.GA.027", name: "Brooks County" },
    { code: "US.GA.029", name: "Bryan County" },
    { code: "US.GA.031", name: "Bulloch County" },
    { code: "US.GA.033", name: "Burke County" },
    { code: "US.GA.035", name: "Butts County" },
    { code: "US.GA.037", name: "Calhoun County" },
    { code: "US.GA.039", name: "Camden County" },
    { code: "US.GA.043", name: "Candler County" },
    { code: "US.GA.045", name: "Carroll County" },
    { code: "US.GA.047", name: "Catoosa County" },
    { code: "US.GA.049", name: "Charlton County" },
    { code: "US.GA.051", name: "Chatham County" },
    { code: "US.GA.053", name: "Chattahoochee County" },
    { code: "US.GA.055", name: "Chattooga County" },
    { code: "US.GA.057", name: "Cherokee County" },
    { code: "US.GA.059", name: "Clarke County" },
    { code: "US.GA.061", name: "Clay County" },
    { code: "US.GA.063", name: "Clayton County" },
    { code: "US.GA.065", name: "Clinch County" },
    { code: "US.GA.067", name: "Cobb County" },
    { code: "US.GA.069", name: "Coffee County" },
    { code: "US.GA.071", name: "Colquitt County" },
    { code: "US.GA.073", name: "Columbia County" },
    { code: "US.GA.075", name: "Cook County" },
    { code: "US.GA.077", name: "Coweta County" },
    { code: "US.GA.079", name: "Crawford County" },
    { code: "US.GA.081", name: "Crisp County" },
    { code: "US.GA.083", name: "Dade County" },
    { code: "US.GA.085", name: "Dawson County" },
    { code: "US.GA.087", name: "Decatur County" },
    { code: "US.GA.089", name: "DeKalb County" },
    { code: "US.GA.091", name: "Dodge County" },
    { code: "US.GA.093", name: "Dooly County" },
    { code: "US.GA.095", name: "Dougherty County" },
    { code: "US.GA.097", name: "Douglas County" },
    { code: "US.GA.099", name: "Early County" },
    { code: "US.GA.101", name: "Echols County" },
    { code: "US.GA.103", name: "Effingham County" },
    { code: "US.GA.105", name: "Elbert County" },
    { code: "US.GA.107", name: "Emanuel County" },
    { code: "US.GA.109", name: "Evans County" },
    { code: "US.GA.111", name: "Fannin County" },
    { code: "US.GA.113", name: "Fayette County" },
    { code: "US.GA.115", name: "Floyd County" },
    { code: "US.GA.117", name: "Forsyth County" },
    { code: "US.GA.119", name: "Franklin County" },
    { code: "US.GA.121", name: "Fulton County" },
    { code: "US.GA.123", name: "Gilmer County" },
    { code: "US.GA.125", name: "Glascock County" },
    { code: "US.GA.127", name: "Glynn County" },
    { code: "US.GA.129", name: "Gordon County" },
    { code: "US.GA.131", name: "Grady County" },
    { code: "US.GA.133", name: "Greene County" },
    { code: "US.GA.135", name: "Gwinnett County" },
    { code: "US.GA.137", name: "Habersham County" },
    { code: "US.GA.139", name: "Hall County" },
    { code: "US.GA.141", name: "Hancock County" },
    { code: "US.GA.143", name: "Haralson County" },
    { code: "US.GA.145", name: "Harris County" },
    { code: "US.GA.147", name: "Hart County" },
    { code: "US.GA.149", name: "Heard County" },
    { code: "US.GA.151", name: "Henry County" },
    { code: "US.GA.153", name: "Houston County" },
    { code: "US.GA.155", name: "Irwin County" },
    { code: "US.GA.157", name: "Jackson County" },
    { code: "US.GA.159", name: "Jasper County" },
    { code: "US.GA.161", name: "Jeff Davis County" },
    { code: "US.GA.163", name: "Jefferson County" },
    { code: "US.GA.165", name: "Jenkins County" },
    { code: "US.GA.167", name: "Johnson County" },
    { code: "US.GA.169", name: "Jones County" },
    { code: "US.GA.171", name: "Lamar County" },
    { code: "US.GA.173", name: "Lanier County" },
    { code: "US.GA.175", name: "Laurens County" },
    { code: "US.GA.177", name: "Lee County" },
    { code: "US.GA.179", name: "Liberty County" },
    { code: "US.GA.181", name: "Lincoln County" },
    { code: "US.GA.183", name: "Long County" },
    { code: "US.GA.185", name: "Lowndes County" },
    { code: "US.GA.187", name: "Lumpkin County" },
    { code: "US.GA.189", name: "McDuffie County" },
    { code: "US.GA.191", name: "McIntosh County" },
    { code: "US.GA.193", name: "Macon County" },
    { code: "US.GA.195", name: "Madison County" },
    { code: "US.GA.197", name: "Marion County" },
    { code: "US.GA.199", name: "Meriwether County" },
    { code: "US.GA.201", name: "Miller County" },
    { code: "US.GA.205", name: "Mitchell County" },
    { code: "US.GA.207", name: "Monroe County" },
    { code: "US.GA.209", name: "Montgomery County" },
    { code: "US.GA.211", name: "Morgan County" },
    { code: "US.GA.213", name: "Murray County" },
    { code: "US.GA.215", name: "Muscogee County" },
    { code: "US.GA.217", name: "Newton County" },
    { code: "US.GA.219", name: "Oconee County" },
    { code: "US.GA.221", name: "Oglethorpe County" },
    { code: "US.GA.223", name: "Paulding County" },
    { code: "US.GA.225", name: "Peach County" },
    { code: "US.GA.227", name: "Pickens County" },
    { code: "US.GA.229", name: "Pierce County" },
    { code: "US.GA.231", name: "Pike County" },
    { code: "US.GA.233", name: "Polk County" },
    { code: "US.GA.235", name: "Pulaski County" },
    { code: "US.GA.237", name: "Putnam County" },
    { code: "US.GA.239", name: "Quitman County" },
    { code: "US.GA.241", name: "Rabun County" },
    { code: "US.GA.243", name: "Randolph County" },
    { code: "US.GA.245", name: "Richmond County" },
    { code: "US.GA.247", name: "Rockdale County" },
    { code: "US.GA.249", name: "Schley County" },
    { code: "US.GA.251", name: "Screven County" },
    { code: "US.GA.253", name: "Seminole County" },
    { code: "US.GA.255", name: "Spalding County" },
    { code: "US.GA.257", name: "Stephens County" },
    { code: "US.GA.259", name: "Stewart County" },
    { code: "US.GA.261", name: "Sumter County" },
    { code: "US.GA.263", name: "Talbot County" },
    { code: "US.GA.265", name: "Taliaferro County" },
    { code: "US.GA.267", name: "Tattnall County" },
    { code: "US.GA.269", name: "Taylor County" },
    { code: "US.GA.271", name: "Telfair County" },
    { code: "US.GA.273", name: "Terrell County" },
    { code: "US.GA.275", name: "Thomas County" },
    { code: "US.GA.277", name: "Tift County" },
    { code: "US.GA.279", name: "Toombs County" },
    { code: "US.GA.281", name: "Towns County" },
    { code: "US.GA.283", name: "Treutlen County" },
    { code: "US.GA.285", name: "Troup County" },
    { code: "US.GA.287", name: "Turner County" },
    { code: "US.GA.289", name: "Twiggs County" },
    { code: "US.GA.291", name: "Union County" },
    { code: "US.GA.293", name: "Upson County" },
    { code: "US.GA.295", name: "Walker County" },
    { code: "US.GA.297", name: "Walton County" },
    { code: "US.GA.299", name: "Ware County" },
    { code: "US.GA.301", name: "Warren County" },
    { code: "US.GA.303", name: "Washington County" },
    { code: "US.GA.305", name: "Wayne County" },
    { code: "US.GA.307", name: "Webster County" },
    { code: "US.GA.309", name: "Wheeler County" },
    { code: "US.GA.311", name: "White County" },
    { code: "US.GA.313", name: "Whitfield County" },
    { code: "US.GA.315", name: "Wilcox County" },
    { code: "US.GA.317", name: "Wilkes County" },
    { code: "US.GA.319", name: "Wilkinson County" },
    { code: "US.GA.321", name: "Worth County" },
  ],
  "US.HI": [
    { code: "US.HI.001", name: "Hawaii County" },
    { code: "US.HI.003", name: "Honolulu County" },
    { code: "US.HI.005", name: "Kalawao County" },
    { code: "US.HI.007", name: "Kauai County" },
    { code: "US.HI.009", name: "Maui County" },
  ],
  "US.IA": [
    { code: "US.IA.001", name: "Adair County" },
    { code: "US.IA.003", name: "Adams County" },
    { code: "US.IA.005", name: "Allamakee County" },
    { code: "US.IA.007", name: "Appanoose County" },
    { code: "US.IA.009", name: "Audubon County" },
    { code: "US.IA.011", name: "Benton County" },
    { code: "US.IA.013", name: "Black Hawk County" },
    { code: "US.IA.015", name: "Boone County" },
    { code: "US.IA.017", name: "Bremer County" },
    { code: "US.IA.019", name: "Buchanan County" },
    { code: "US.IA.021", name: "Buena Vista County" },
    { code: "US.IA.023", name: "Butler County" },
    { code: "US.IA.025", name: "Calhoun County" },
    { code: "US.IA.027", name: "Carroll County" },
    { code: "US.IA.029", name: "Cass County" },
    { code: "US.IA.031", name: "Cedar County" },
    { code: "US.IA.033", name: "Cerro Gordo County" },
    { code: "US.IA.035", name: "Cherokee County" },
    { code: "US.IA.037", name: "Chickasaw County" },
    { code: "US.IA.039", name: "Clarke County" },
    { code: "US.IA.041", name: "Clay County" },
    { code: "US.IA.043", name: "Clayton County" },
    { code: "US.IA.045", name: "Clinton County" },
    { code: "US.IA.047", name: "Crawford County" },
    { code: "US.IA.049", name: "Dallas County" },
    { code: "US.IA.051", name: "Davis County" },
    { code: "US.IA.053", name: "Decatur County" },
    { code: "US.IA.055", name: "Delaware County" },
    { code: "US.IA.057", name: "Des Moines County" },
    { code: "US.IA.059", name: "Dickinson County" },
    { code: "US.IA.061", name: "Dubuque County" },
    { code: "US.IA.063", name: "Emmet County" },
    { code: "US.IA.065", name: "Fayette County" },
    { code: "US.IA.067", name: "Floyd County" },
    { code: "US.IA.069", name: "Franklin County" },
    { code: "US.IA.071", name: "Fremont County" },
    { code: "US.IA.073", name: "Greene County" },
    { code: "US.IA.075", name: "Grundy County" },
    { code: "US.IA.077", name: "Guthrie County" },
    { code: "US.IA.079", name: "Hamilton County" },
    { code: "US.IA.081", name: "Hancock County" },
    { code: "US.IA.083", name: "Hardin County" },
    { code: "US.IA.085", name: "Harrison County" },
    { code: "US.IA.087", name: "Henry County" },
    { code: "US.IA.089", name: "Howard County" },
    { code: "US.IA.091", name: "Humboldt County" },
    { code: "US.IA.093", name: "Ida County" },
    { code: "US.IA.095", name: "Iowa County" },
    { code: "US.IA.097", name: "Jackson County" },
    { code: "US.IA.099", name: "Jasper County" },
    { code: "US.IA.101", name: "Jefferson County" },
    { code: "US.IA.103", name: "Johnson County" },
    { code: "US.IA.105", name: "Jones County" },
    { code: "US.IA.107", name: "Keokuk County" },
    { code: "US.IA.109", name: "Kossuth County" },
    { code: "US.IA.111", name: "Lee County" },
    { code: "US.IA.113", name: "Linn County" },
    { code: "US.IA.115", name: "Louisa County" },
    { code: "US.IA.117", name: "Lucas County" },
    { code: "US.IA.119", name: "Lyon County" },
    { code: "US.IA.121", name: "Madison County" },
    { code: "US.IA.123", name: "Mahaska County" },
    { code: "US.IA.125", name: "Marion County" },
    { code: "US.IA.127", name: "Marshall County" },
    { code: "US.IA.129", name: "Mills County" },
    { code: "US.IA.131", name: "Mitchell County" },
    { code: "US.IA.133", name: "Monona County" },
    { code: "US.IA.135", name: "Monroe County" },
    { code: "US.IA.137", name: "Montgomery County" },
    { code: "US.IA.139", name: "Muscatine County" },
    { code: "US.IA.141", name: "O'Brien County" },
    { code: "US.IA.143", name: "Osceola County" },
    { code: "US.IA.145", name: "Page County" },
    { code: "US.IA.147", name: "Palo Alto County" },
    { code: "US.IA.149", name: "Plymouth County" },
    { code: "US.IA.151", name: "Pocahontas County" },
    { code: "US.IA.153", name: "Polk County" },
    { code: "US.IA.155", name: "Pottawattamie County" },
    { code: "US.IA.157", name: "Poweshiek County" },
    { code: "US.IA.159", name: "Ringgold County" },
    { code: "US.IA.161", name: "Sac County" },
    { code: "US.IA.163", name: "Scott County" },
    { code: "US.IA.165", name: "Shelby County" },
    { code: "US.IA.167", name: "Sioux County" },
    { code: "US.IA.169", name: "Story County" },
    { code: "US.IA.171", name: "Tama County" },
    { code: "US.IA.173", name: "Taylor County" },
    { code: "US.IA.175", name: "Union County" },
    { code: "US.IA.177", name: "Van Buren County" },
    { code: "US.IA.179", name: "Wapello County" },
    { code: "US.IA.181", name: "Warren County" },
    { code: "US.IA.183", name: "Washington County" },
    { code: "US.IA.185", name: "Wayne County" },
    { code: "US.IA.187", name: "Webster County" },
    { code: "US.IA.189", name: "Winnebago County" },
    { code: "US.IA.191", name: "Winneshiek County" },
    { code: "US.IA.193", name: "Woodbury County" },
    { code: "US.IA.195", name: "Worth County" },
    { code: "US.IA.197", name: "Wright County" },
  ],
  "US.ID": [
    { code: "US.ID.001", name: "Ada County" },
    { code: "US.ID.003", name: "Adams County" },
    { code: "US.ID.005", name: "Bannock County" },
    { code: "US.ID.007", name: "Bear Lake County" },
    { code: "US.ID.009", name: "Benewah County" },
    { code: "US.ID.011", name: "Bingham County" },
    { code: "US.ID.013", name: "Blaine County" },
    { code: "US.ID.015", name: "Boise County" },
    { code: "US.ID.017", name: "Bonner County" },
    { code: "US.ID.019", name: "Bonneville County" },
    { code: "US.ID.021", name: "Boundary County" },
    { code: "US.ID.023", name: "Butte County" },
    { code: "US.ID.025", name: "Camas County" },
    { code: "US.ID.027", name: "Canyon County" },
    { code: "US.ID.029", name: "Caribou County" },
    { code: "US.ID.031", name: "Cassia County" },
    { code: "US.ID.033", name: "Clark County" },
    { code: "US.ID.035", name: "Clearwater County" },
    { code: "US.ID.037", name: "Custer County" },
    { code: "US.ID.039", name: "Elmore County" },
    { code: "US.ID.041", name: "Franklin County" },
    { code: "US.ID.043", name: "Fremont County" },
    { code: "US.ID.045", name: "Gem County" },
    { code: "US.ID.047", name: "Gooding County" },
    { code: "US.ID.049", name: "Idaho County" },
    { code: "US.ID.051", name: "Jefferson County" },
    { code: "US.ID.053", name: "Jerome County" },
    { code: "US.ID.055", name: "Kootenai County" },
    { code: "US.ID.057", name: "Latah County" },
    { code: "US.ID.059", name: "Lemhi County" },
    { code: "US.ID.061", name: "Lewis County" },
    { code: "US.ID.063", name: "Lincoln County" },
    { code: "US.ID.065", name: "Madison County" },
    { code: "US.ID.067", name: "Minidoka County" },
    { code: "US.ID.069", name: "Nez Perce County" },
    { code: "US.ID.071", name: "Oneida County" },
    { code: "US.ID.073", name: "Owyhee County" },
    { code: "US.ID.075", name: "Payette County" },
    { code: "US.ID.077", name: "Power County" },
    { code: "US.ID.079", name: "Shoshone County" },
    { code: "US.ID.081", name: "Teton County" },
    { code: "US.ID.083", name: "Twin Falls County" },
    { code: "US.ID.085", name: "Valley County" },
    { code: "US.ID.087", name: "Washington County" },
  ],
  "US.IL": [
    { code: "US.IL.001", name: "Adams County" },
    { code: "US.IL.003", name: "Alexander County" },
    { code: "US.IL.005", name: "Bond County" },
    { code: "US.IL.007", name: "Boone County" },
    { code: "US.IL.009", name: "Brown County" },
    { code: "US.IL.011", name: "Bureau County" },
    { code: "US.IL.013", name: "Calhoun County" },
    { code: "US.IL.015", name: "Carroll County" },
    { code: "US.IL.017", name: "Cass County" },
    { code: "US.IL.019", name: "Champaign County" },
    { code: "US.IL.021", name: "Christian County" },
    { code: "US.IL.023", name: "Clark County" },
    { code: "US.IL.025", name: "Clay County" },
    { code: "US.IL.027", name: "Clinton County" },
    { code: "US.IL.029", name: "Coles County" },
    { code: "US.IL.031", name: "Cook County" },
    { code: "US.IL.033", name: "Crawford County" },
    { code: "US.IL.035", name: "Cumberland County" },
    { code: "US.IL.037", name: "DeKalb County" },
    { code: "US.IL.039", name: "De Witt County" },
    { code: "US.IL.041", name: "Douglas County" },
    { code: "US.IL.043", name: "DuPage County" },
    { code: "US.IL.045", name: "Edgar County" },
    { code: "US.IL.047", name: "Edwards County" },
    { code: "US.IL.049", name: "Effingham County" },
    { code: "US.IL.051", name: "Fayette County" },
    { code: "US.IL.053", name: "Ford County" },
    { code: "US.IL.055", name: "Franklin County" },
    { code: "US.IL.057", name: "Fulton County" },
    { code: "US.IL.059", name: "Gallatin County" },
    { code: "US.IL.061", name: "Greene County" },
    { code: "US.IL.063", name: "Grundy County" },
    { code: "US.IL.065", name: "Hamilton County" },
    { code: "US.IL.067", name: "Hancock County" },
    { code: "US.IL.069", name: "Hardin County" },
    { code: "US.IL.071", name: "Henderson County" },
    { code: "US.IL.073", name: "Henry County" },
    { code: "US.IL.075", name: "Iroquois County" },
    { code: "US.IL.077", name: "Jackson County" },
    { code: "US.IL.079", name: "Jasper County" },
    { code: "US.IL.081", name: "Jefferson County" },
    { code: "US.IL.083", name: "Jersey County" },
    { code: "US.IL.085", name: "Jo Daviess County" },
    { code: "US.IL.087", name: "Johnson County" },
    { code: "US.IL.089", name: "Kane County" },
    { code: "US.IL.091", name: "Kankakee County" },
    { code: "US.IL.093", name: "Kendall County" },
    { code: "US.IL.095", name: "Knox County" },
    { code: "US.IL.097", name: "Lake County" },
    { code: "US.IL.099", name: "LaSalle County" },
    { code: "US.IL.101", name: "Lawrence County" },
    { code: "US.IL.103", name: "Lee County" },
    { code: "US.IL.105", name: "Livingston County" },
    { code: "US.IL.107", name: "Logan County" },
    { code: "US.IL.109", name: "McDonough County" },
    { code: "US.IL.111", name: "McHenry County" },
    { code: "US.IL.113", name: "McLean County" },
    { code: "US.IL.115", name: "Macon County" },
    { code: "US.IL.117", name: "Macoupin County" },
    { code: "US.IL.119", name: "Madison County" },
    { code: "US.IL.121", name: "Marion County" },
    { code: "US.IL.123", name: "Marshall County" },
    { code: "US.IL.125", name: "Mason County" },
    { code: "US.IL.127", name: "Massac County" },
    { code: "US.IL.129", name: "Menard County" },
    { code: "US.IL.131", name: "Mercer County" },
    { code: "US.IL.133", name: "Monroe County" },
    { code: "US.IL.135", name: "Montgomery County" },
    { code: "US.IL.137", name: "Morgan County" },
    { code: "US.IL.139", name: "Moultrie County" },
    { code: "US.IL.141", name: "Ogle County" },
    { code: "US.IL.143", name: "Peoria County" },
    { code: "US.IL.145", name: "Perry County" },
    { code: "US.IL.147", name: "Piatt County" },
    { code: "US.IL.149", name: "Pike County" },
    { code: "US.IL.151", name: "Pope County" },
    { code: "US.IL.153", name: "Pulaski County" },
    { code: "US.IL.155", name: "Putnam County" },
    { code: "US.IL.157", name: "Randolph County" },
    { code: "US.IL.159", name: "Richland County" },
    { code: "US.IL.161", name: "Rock Island County" },
    { code: "US.IL.163", name: "Saint Clair County" },
    { code: "US.IL.165", name: "Saline County" },
    { code: "US.IL.167", name: "Sangamon County" },
    { code: "US.IL.169", name: "Schuyler County" },
    { code: "US.IL.171", name: "Scott County" },
    { code: "US.IL.173", name: "Shelby County" },
    { code: "US.IL.175", name: "Stark County" },
    { code: "US.IL.177", name: "Stephenson County" },
    { code: "US.IL.179", name: "Tazewell County" },
    { code: "US.IL.181", name: "Union County" },
    { code: "US.IL.183", name: "Vermilion County" },
    { code: "US.IL.185", name: "Wabash County" },
    { code: "US.IL.187", name: "Warren County" },
    { code: "US.IL.189", name: "Washington County" },
    { code: "US.IL.191", name: "Wayne County" },
    { code: "US.IL.193", name: "White County" },
    { code: "US.IL.195", name: "Whiteside County" },
    { code: "US.IL.197", name: "Will County" },
    { code: "US.IL.199", name: "Williamson County" },
    { code: "US.IL.201", name: "Winnebago County" },
    { code: "US.IL.203", name: "Woodford County" },
  ],
  "US.IN": [
    { code: "US.IN.001", name: "Adams County" },
    { code: "US.IN.003", name: "Allen County" },
    { code: "US.IN.005", name: "Bartholomew County" },
    { code: "US.IN.007", name: "Benton County" },
    { code: "US.IN.009", name: "Blackford County" },
    { code: "US.IN.011", name: "Boone County" },
    { code: "US.IN.013", name: "Brown County" },
    { code: "US.IN.015", name: "Carroll County" },
    { code: "US.IN.017", name: "Cass County" },
    { code: "US.IN.019", name: "Clark County" },
    { code: "US.IN.021", name: "Clay County" },
    { code: "US.IN.023", name: "Clinton County" },
    { code: "US.IN.025", name: "Crawford County" },
    { code: "US.IN.027", name: "Daviess County" },
    { code: "US.IN.029", name: "Dearborn County" },
    { code: "US.IN.031", name: "Decatur County" },
    { code: "US.IN.033", name: "DeKalb County" },
    { code: "US.IN.035", name: "Delaware County" },
    { code: "US.IN.037", name: "Dubois County" },
    { code: "US.IN.039", name: "Elkhart County" },
    { code: "US.IN.041", name: "Fayette County" },
    { code: "US.IN.043", name: "Floyd County" },
    { code: "US.IN.045", name: "Fountain County" },
    { code: "US.IN.047", name: "Franklin County" },
    { code: "US.IN.049", name: "Fulton County" },
    { code: "US.IN.051", name: "Gibson County" },
    { code: "US.IN.053", name: "Grant County" },
    { code: "US.IN.055", name: "Greene County" },
    { code: "US.IN.057", name: "Hamilton County" },
    { code: "US.IN.059", name: "Hancock County" },
    { code: "US.IN.061", name: "Harrison County" },
    { code: "US.IN.063", name: "Hendricks County" },
    { code: "US.IN.065", name: "Henry County" },
    { code: "US.IN.067", name: "Howard County" },
    { code: "US.IN.069", name: "Huntington County" },
    { code: "US.IN.071", name: "Jackson County" },
    { code: "US.IN.073", name: "Jasper County" },
    { code: "US.IN.075", name: "Jay County" },
    { code: "US.IN.077", name: "Jefferson County" },
    { code: "US.IN.079", name: "Jennings County" },
    { code: "US.IN.081", name: "Johnson County" },
    { code: "US.IN.083", name: "Knox County" },
    { code: "US.IN.085", name: "Kosciusko County" },
    { code: "US.IN.087", name: "LaGrange County" },
    { code: "US.IN.089", name: "Lake County" },
    { code: "US.IN.091", name: "LaPorte County" },
    { code: "US.IN.093", name: "Lawrence County" },
    { code: "US.IN.095", name: "Madison County" },
    { code: "US.IN.097", name: "Marion County" },
    { code: "US.IN.099", name: "Marshall County" },
    { code: "US.IN.101", name: "Martin County" },
    { code: "US.IN.103", name: "Miami County" },
    { code: "US.IN.105", name: "Monroe County" },
    { code: "US.IN.107", name: "Montgomery County" },
    { code: "US.IN.109", name: "Morgan County" },
    { code: "US.IN.111", name: "Newton County" },
    { code: "US.IN.113", name: "Noble County" },
    { code: "US.IN.115", name: "Ohio County" },
    { code: "US.IN.117", name: "Orange County" },
    { code: "US.IN.119", name: "Owen County" },
    { code: "US.IN.121", name: "Parke County" },
    { code: "US.IN.123", name: "Perry County" },
    { code: "US.IN.125", name: "Pike County" },
    { code: "US.IN.127", name: "Porter County" },
    { code: "US.IN.129", name: "Posey County" },
    { code: "US.IN.131", name: "Pulaski County" },
    { code: "US.IN.133", name: "Putnam County" },
    { code: "US.IN.135", name: "Randolph County" },
    { code: "US.IN.137", name: "Ripley County" },
    { code: "US.IN.139", name: "Rush County" },
    { code: "US.IN.141", name: "Saint Joseph County" },
    { code: "US.IN.143", name: "Scott County" },
    { code: "US.IN.145", name: "Shelby County" },
    { code: "US.IN.147", name: "Spencer County" },
    { code: "US.IN.149", name: "Starke County" },
    { code: "US.IN.151", name: "Steuben County" },
    { code: "US.IN.153", name: "Sullivan County" },
    { code: "US.IN.155", name: "Switzerland County" },
    { code: "US.IN.157", name: "Tippecanoe County" },
    { code: "US.IN.159", name: "Tipton County" },
    { code: "US.IN.161", name: "Union County" },
    { code: "US.IN.163", name: "Vanderburgh County" },
    { code: "US.IN.165", name: "Vermillion County" },
    { code: "US.IN.167", name: "Vigo County" },
    { code: "US.IN.169", name: "Wabash County" },
    { code: "US.IN.171", name: "Warren County" },
    { code: "US.IN.173", name: "Warrick County" },
    { code: "US.IN.175", name: "Washington County" },
    { code: "US.IN.177", name: "Wayne County" },
    { code: "US.IN.179", name: "Wells County" },
    { code: "US.IN.181", name: "White County" },
    { code: "US.IN.183", name: "Whitley County" },
  ],
  "US.KS": [
    { code: "US.KS.001", name: "Allen County" },
    { code: "US.KS.003", name: "Anderson County" },
    { code: "US.KS.005", name: "Atchison County" },
    { code: "US.KS.007", name: "Barber County" },
    { code: "US.KS.009", name: "Barton County" },
    { code: "US.KS.011", name: "Bourbon County" },
    { code: "US.KS.013", name: "Brown County" },
    { code: "US.KS.015", name: "Butler County" },
    { code: "US.KS.017", name: "Chase County" },
    { code: "US.KS.019", name: "Chautauqua County" },
    { code: "US.KS.021", name: "Cherokee County" },
    { code: "US.KS.023", name: "Cheyenne County" },
    { code: "US.KS.025", name: "Clark County" },
    { code: "US.KS.027", name: "Clay County" },
    { code: "US.KS.029", name: "Cloud County" },
    { code: "US.KS.031", name: "Coffey County" },
    { code: "US.KS.033", name: "Comanche County" },
    { code: "US.KS.035", name: "Cowley County" },
    { code: "US.KS.037", name: "Crawford County" },
    { code: "US.KS.039", name: "Decatur County" },
    { code: "US.KS.041", name: "Dickinson County" },
    { code: "US.KS.043", name: "Doniphan County" },
    { code: "US.KS.045", name: "Douglas County" },
    { code: "US.KS.047", name: "Edwards County" },
    { code: "US.KS.049", name: "Elk County" },
    { code: "US.KS.051", name: "Ellis County" },
    { code: "US.KS.053", name: "Ellsworth County" },
    { code: "US.KS.055", name: "Finney County" },
    { code: "US.KS.057", name: "Ford County" },
    { code: "US.KS.059", name: "Franklin County" },
    { code: "US.KS.061", name: "Geary County" },
    { code: "US.KS.063", name: "Gove County" },
    { code: "US.KS.065", name: "Graham County" },
    { code: "US.KS.067", name: "Grant County" },
    { code: "US.KS.069", name: "Gray County" },
    { code: "US.KS.071", name: "Greeley County" },
    { code: "US.KS.073", name: "Greenwood County" },
    { code: "US.KS.075", name: "Hamilton County" },
    { code: "US.KS.077", name: "Harper County" },
    { code: "US.KS.079", name: "Harvey County" },
    { code: "US.KS.081", name: "Haskell County" },
    { code: "US.KS.083", name: "Hodgeman County" },
    { code: "US.KS.085", name: "Jackson County" },
    { code: "US.KS.087", name: "Jefferson County" },
    { code: "US.KS.089", name: "Jewell County" },
    { code: "US.KS.091", name: "Johnson County" },
    { code: "US.KS.093", name: "Kearny County" },
    { code: "US.KS.095", name: "Kingman County" },
    { code: "US.KS.097", name: "Kiowa County" },
    { code: "US.KS.099", name: "Labette County" },
    { code: "US.KS.101", name: "Lane County" },
    { code: "US.KS.103", name: "Leavenworth County" },
    { code: "US.KS.105", name: "Lincoln County" },
    { code: "US.KS.107", name: "Linn County" },
    { code: "US.KS.109", name: "Logan County" },
    { code: "US.KS.111", name: "Lyon County" },
    { code: "US.KS.113", name: "McPherson County" },
    { code: "US.KS.115", name: "Marion County" },
    { code: "US.KS.117", name: "Marshall County" },
    { code: "US.KS.119", name: "Meade County" },
    { code: "US.KS.121", name: "Miami County" },
    { code: "US.KS.123", name: "Mitchell County" },
    { code: "US.KS.125", name: "Montgomery County" },
    { code: "US.KS.127", name: "Morris County" },
    { code: "US.KS.129", name: "Morton County" },
    { code: "US.KS.131", name: "Nemaha County" },
    { code: "US.KS.133", name: "Neosho County" },
    { code: "US.KS.135", name: "Ness County" },
    { code: "US.KS.137", name: "Norton County" },
    { code: "US.KS.139", name: "Osage County" },
    { code: "US.KS.141", name: "Osborne County" },
    { code: "US.KS.143", name: "Ottawa County" },
    { code: "US.KS.145", name: "Pawnee County" },
    { code: "US.KS.147", name: "Phillips County" },
    { code: "US.KS.149", name: "Pottawatomie County" },
    { code: "US.KS.151", name: "Pratt County" },
    { code: "US.KS.153", name: "Rawlins County" },
    { code: "US.KS.155", name: "Reno County" },
    { code: "US.KS.157", name: "Republic County" },
    { code: "US.KS.159", name: "Rice County" },
    { code: "US.KS.161", name: "Riley County" },
    { code: "US.KS.163", name: "Rooks County" },
    { code: "US.KS.165", name: "Rush County" },
    { code: "US.KS.167", name: "Russell County" },
    { code: "US.KS.169", name: "Saline County" },
    { code: "US.KS.171", name: "Scott County" },
    { code: "US.KS.173", name: "Sedgwick County" },
    { code: "US.KS.175", name: "Seward County" },
    { code: "US.KS.177", name: "Shawnee County" },
    { code: "US.KS.179", name: "Sheridan County" },
    { code: "US.KS.181", name: "Sherman County" },
    { code: "US.KS.183", name: "Smith County" },
    { code: "US.KS.185", name: "Stafford County" },
    { code: "US.KS.187", name: "Stanton County" },
    { code: "US.KS.189", name: "Stevens County" },
    { code: "US.KS.191", name: "Sumner County" },
    { code: "US.KS.193", name: "Thomas County" },
    { code: "US.KS.195", name: "Trego County" },
    { code: "US.KS.197", name: "Wabaunsee County" },
    { code: "US.KS.199", name: "Wallace County" },
    { code: "US.KS.201", name: "Washington County" },
    { code: "US.KS.203", name: "Wichita County" },
    { code: "US.KS.205", name: "Wilson County" },
    { code: "US.KS.207", name: "Woodson County" },
    { code: "US.KS.209", name: "Wyandotte County" },
  ],
  "US.KY": [
    { code: "US.KY.001", name: "Adair County" },
    { code: "US.KY.003", name: "Allen County" },
    { code: "US.KY.005", name: "Anderson County" },
    { code: "US.KY.007", name: "Ballard County" },
    { code: "US.KY.009", name: "Barren County" },
    { code: "US.KY.011", name: "Bath County" },
    { code: "US.KY.013", name: "Bell County" },
    { code: "US.KY.015", name: "Boone County" },
    { code: "US.KY.017", name: "Bourbon County" },
    { code: "US.KY.019", name: "Boyd County" },
    { code: "US.KY.021", name: "Boyle County" },
    { code: "US.KY.023", name: "Bracken County" },
    { code: "US.KY.025", name: "Breathitt County" },
    { code: "US.KY.027", name: "Breckinridge County" },
    { code: "US.KY.029", name: "Bullitt County" },
    { code: "US.KY.031", name: "Butler County" },
    { code: "US.KY.033", name: "Caldwell County" },
    { code: "US.KY.035", name: "Calloway County" },
    { code: "US.KY.037", name: "Campbell County" },
    { code: "US.KY.039", name: "Carlisle County" },
    { code: "US.KY.041", name: "Carroll County" },
    { code: "US.KY.043", name: "Carter County" },
    { code: "US.KY.045", name: "Casey County" },
    { code: "US.KY.047", name: "Christian County" },
    { code: "US.KY.049", name: "Clark County" },
    { code: "US.KY.051", name: "Clay County" },
    { code: "US.KY.053", name: "Clinton County" },
    { code: "US.KY.055", name: "Crittenden County" },
    { code: "US.KY.057", name: "Cumberland County" },
    { code: "US.KY.059", name: "Daviess County" },
    { code: "US.KY.061", name: "Edmonson County" },
    { code: "US.KY.063", name: "Elliott County" },
    { code: "US.KY.065", name: "Estill County" },
    { code: "US.KY.067", name: "Fayette County" },
    { code: "US.KY.069", name: "Fleming County" },
    { code: "US.KY.071", name: "Floyd County" },
    { code: "US.KY.073", name: "Franklin County" },
    { code: "US.KY.075", name: "Fulton County" },
    { code: "US.KY.077", name: "Gallatin County" },
    { code: "US.KY.079", name: "Garrard County" },
    { code: "US.KY.081", name: "Grant County" },
    { code: "US.KY.083", name: "Graves County" },
    { code: "US.KY.085", name: "Grayson County" },
    { code: "US.KY.087", name: "Green County" },
    { code: "US.KY.089", name: "Greenup County" },
    { code: "US.KY.091", name: "Hancock County" },
    { code: "US.KY.093", name: "Hardin County" },
    { code: "US.KY.095", name: "Harlan County" },
    { code: "US.KY.097", name: "Harrison County" },
    { code: "US.KY.099", name: "Hart County" },
    { code: "US.KY.101", name: "Henderson County" },
    { code: "US.KY.103", name: "Henry County" },
    { code: "US.KY.105", name: "Hickman County" },
    { code: "US.KY.107", name: "Hopkins County" },
    { code: "US.KY.109", name: "Jackson County" },
    { code: "US.KY.111", name: "Jefferson County" },
    { code: "US.KY.113", name: "Jessamine County" },
    { code: "US.KY.115", name: "Johnson County" },
    { code: "US.KY.117", name: "Kenton County" },
    { code: "US.KY.119", name: "Knott County" },
    { code: "US.KY.121", name: "Knox County" },
    { code: "US.KY.123", name: "Larue County" },
    { code: "US.KY.125", name: "Laurel County" },
    { code: "US.KY.127", name: "Lawrence County" },
    { code: "US.KY.129", name: "Lee County" },
    { code: "US.KY.131", name: "Leslie County" },
    { code: "US.KY.133", name: "Letcher County" },
    { code: "US.KY.135", name: "Lewis County" },
    { code: "US.KY.137", name: "Lincoln County" },
    { code: "US.KY.139", name: "Livingston County" },
    { code: "US.KY.141", name: "Logan County" },
    { code: "US.KY.143", name: "Lyon County" },
    { code: "US.KY.145", name: "McCracken County" },
    { code: "US.KY.147", name: "McCreary County" },
    { code: "US.KY.149", name: "McLean County" },
    { code: "US.KY.151", name: "Madison County" },
    { code: "US.KY.153", name: "Magoffin County" },
    { code: "US.KY.155", name: "Marion County" },
    { code: "US.KY.157", name: "Marshall County" },
    { code: "US.KY.159", name: "Martin County" },
    { code: "US.KY.161", name: "Mason County" },
    { code: "US.KY.163", name: "Meade County" },
    { code: "US.KY.165", name: "Menifee County" },
    { code: "US.KY.167", name: "Mercer County" },
    { code: "US.KY.169", name: "Metcalfe County" },
    { code: "US.KY.171", name: "Monroe County" },
    { code: "US.KY.173", name: "Montgomery County" },
    { code: "US.KY.175", name: "Morgan County" },
    { code: "US.KY.177", name: "Muhlenberg County" },
    { code: "US.KY.179", name: "Nelson County" },
    { code: "US.KY.181", name: "Nicholas County" },
    { code: "US.KY.183", name: "Ohio County" },
    { code: "US.KY.185", name: "Oldham County" },
    { code: "US.KY.187", name: "Owen County" },
    { code: "US.KY.189", name: "Owsley County" },
    { code: "US.KY.191", name: "Pendleton County" },
    { code: "US.KY.193", name: "Perry County" },
    { code: "US.KY.195", name: "Pike County" },
    { code: "US.KY.197", name: "Powell County" },
    { code: "US.KY.199", name: "Pulaski County" },
    { code: "US.KY.201", name: "Robertson County" },
    { code: "US.KY.203", name: "Rockcastle County" },
    { code: "US.KY.205", name: "Rowan County" },
    { code: "US.KY.207", name: "Russell County" },
    { code: "US.KY.209", name: "Scott County" },
    { code: "US.KY.211", name: "Shelby County" },
    { code: "US.KY.213", name: "Simpson County" },
    { code: "US.KY.215", name: "Spencer County" },
    { code: "US.KY.217", name: "Taylor County" },
    { code: "US.KY.219", name: "Todd County" },
    { code: "US.KY.221", name: "Trigg County" },
    { code: "US.KY.223", name: "Trimble County" },
    { code: "US.KY.225", name: "Union County" },
    { code: "US.KY.227", name: "Warren County" },
    { code: "US.KY.229", name: "Washington County" },
    { code: "US.KY.231", name: "Wayne County" },
    { code: "US.KY.233", name: "Webster County" },
    { code: "US.KY.235", name: "Whitley County" },
    { code: "US.KY.237", name: "Wolfe County" },
    { code: "US.KY.239", name: "Woodford County" },
  ],
  "US.LA": [
    { code: "US.LA.001", name: "Acadia Parish" },
    { code: "US.LA.003", name: "Allen Parish" },
    { code: "US.LA.005", name: "Ascension Parish" },
    { code: "US.LA.007", name: "Assumption Parish" },
    { code: "US.LA.009", name: "Avoyelles Parish" },
    { code: "US.LA.011", name: "Beauregard Parish" },
    { code: "US.LA.013", name: "Bienville Parish" },
    { code: "US.LA.015", name: "Bossier Parish" },
    { code: "US.LA.017", name: "Caddo Parish" },
    { code: "US.LA.019", name: "Calcasieu Parish" },
    { code: "US.LA.021", name: "Caldwell Parish" },
    { code: "US.LA.023", name: "Cameron Parish" },
    { code: "US.LA.025", name: "Catahoula Parish" },
    { code: "US.LA.027", name: "Claiborne Parish" },
    { code: "US.LA.029", name: "Concordia Parish" },
    { code: "US.LA.031", name: "De Soto Parish" },
    { code: "US.LA.033", name: "East Baton Rouge Parish" },
    { code: "US.LA.035", name: "East Carroll Parish" },
    { code: "US.LA.037", name: "East Feliciana Parish" },
    { code: "US.LA.039", name: "Evangeline Parish" },
    { code: "US.LA.041", name: "Franklin Parish" },
    { code: "US.LA.043", name: "Grant Parish" },
    { code: "US.LA.045", name: "Iberia Parish" },
    { code: "US.LA.047", name: "Iberville Parish" },
    { code: "US.LA.049", name: "Jackson Parish" },
    { code: "US.LA.051", name: "Jefferson Parish" },
    { code: "US.LA.053", name: "Jefferson Davis Parish" },
    { code: "US.LA.055", name: "Lafayette Parish" },
    { code: "US.LA.057", name: "Lafourche Parish" },
    { code: "US.LA.059", name: "La Salle Parish" },
    { code: "US.LA.061", name: "Lincoln Parish" },
    { code: "US.LA.063", name: "Livingston Parish" },
    { code: "US.LA.065", name: "Madison Parish" },
    { code: "US.LA.067", name: "Morehouse Parish" },
    { code: "US.LA.069", name: "Natchitoches Parish" },
    { code: "US.LA.071", name: "Orleans Parish" },
    { code: "US.LA.073", name: "Ouachita Parish" },
    { code: "US.LA.075", name: "Plaquemines Parish" },
    { code: "US.LA.077", name: "Pointe Coupee Parish" },
    { code: "US.LA.079", name: "Rapides Parish" },
    { code: "US.LA.081", name: "Red River Parish" },
    { code: "US.LA.083", name: "Richland Parish" },
    { code: "US.LA.085", name: "Sabine Parish" },
    { code: "US.LA.087", name: "Saint Bernard Parish" },
    { code: "US.LA.089", name: "Saint Charles Parish" },
    { code: "US.LA.091", name: "Saint Helena Parish" },
    { code: "US.LA.093", name: "Saint James Parish" },
    { code: "US.LA.095", name: "Saint John the Baptist Parish" },
    { code: "US.LA.097", name: "Saint Landry Parish" },
    { code: "US.LA.099", name: "Saint Martin Parish" },
    { code: "US.LA.101", name: "Saint Mary Parish" },
    { code: "US.LA.103", name: "Saint Tammany Parish" },
    { code: "US.LA.105", name: "Tangipahoa Parish" },
    { code: "US.LA.107", name: "Tensas Parish" },
    { code: "US.LA.109", name: "Terrebonne Parish" },
    { code: "US.LA.111", name: "Union Parish" },
    { code: "US.LA.113", name: "Vermilion Parish" },
    { code: "US.LA.115", name: "Vernon Parish" },
    { code: "US.LA.117", name: "Washington Parish" },
    { code: "US.LA.119", name: "Webster Parish" },
    { code: "US.LA.121", name: "West Baton Rouge Parish" },
    { code: "US.LA.123", name: "West Carroll Parish" },
    { code: "US.LA.125", name: "West Feliciana Parish" },
    { code: "US.LA.127", name: "Winn Parish" },
  ],
  "US.MA": [
    { code: "US.MA.001", name: "Barnstable County" },
    { code: "US.MA.003", name: "Berkshire County" },
    { code: "US.MA.005", name: "Bristol County" },
    { code: "US.MA.007", name: "Dukes County" },
    { code: "US.MA.009", name: "Essex County" },
    { code: "US.MA.011", name: "Franklin County" },
    { code: "US.MA.013", name: "Hampden County" },
    { code: "US.MA.015", name: "Hampshire County" },
    { code: "US.MA.017", name: "Middlesex County" },
    { code: "US.MA.019", name: "Nantucket County" },
    { code: "US.MA.021", name: "Norfolk County" },
    { code: "US.MA.023", name: "Plymouth County" },
    { code: "US.MA.025", name: "Suffolk County" },
    { code: "US.MA.027", name: "Worcester County" },
  ],
  "US.MD": [
    { code: "US.MD.001", name: "Allegany County" },
    { code: "US.MD.003", name: "Anne Arundel County" },
    { code: "US.MD.005", name: "Baltimore County" },
    { code: "US.MD.009", name: "Calvert County" },
    { code: "US.MD.011", name: "Caroline County" },
    { code: "US.MD.013", name: "Carroll County" },
    { code: "US.MD.015", name: "Cecil County" },
    { code: "US.MD.017", name: "Charles County" },
    { code: "US.MD.019", name: "Dorchester County" },
    { code: "US.MD.021", name: "Frederick County" },
    { code: "US.MD.023", name: "Garrett County" },
    { code: "US.MD.025", name: "Harford County" },
    { code: "US.MD.027", name: "Howard County" },
    { code: "US.MD.029", name: "Kent County" },
    { code: "US.MD.031", name: "Montgomery County" },
    { code: "US.MD.033", name: "Prince George's County" },
    { code: "US.MD.035", name: "Queen Anne's County" },
    { code: "US.MD.037", name: "Saint Mary's County" },
    { code: "US.MD.039", name: "Somerset County" },
    { code: "US.MD.041", name: "Talbot County" },
    { code: "US.MD.043", name: "Washington County" },
    { code: "US.MD.045", name: "Wicomico County" },
    { code: "US.MD.047", name: "Worcester County" },
    { code: "US.MD.510", name: "City of Baltimore" },
  ],
  "US.ME": [
    { code: "US.ME.001", name: "Androscoggin County" },
    { code: "US.ME.003", name: "Aroostook County" },
    { code: "US.ME.005", name: "Cumberland County" },
    { code: "US.ME.007", name: "Franklin County" },
    { code: "US.ME.009", name: "Hancock County" },
    { code: "US.ME.011", name: "Kennebec County" },
    { code: "US.ME.013", name: "Knox County" },
    { code: "US.ME.015", name: "Lincoln County" },
    { code: "US.ME.017", name: "Oxford County" },
    { code: "US.ME.019", name: "Penobscot County" },
    { code: "US.ME.021", name: "Piscataquis County" },
    { code: "US.ME.023", name: "Sagadahoc County" },
    { code: "US.ME.025", name: "Somerset County" },
    { code: "US.ME.027", name: "Waldo County" },
    { code: "US.ME.029", name: "Washington County" },
    { code: "US.ME.031", name: "York County" },
  ],
  "US.MI": [
    { code: "US.MI.001", name: "Alcona County" },
    { code: "US.MI.003", name: "Alger County" },
    { code: "US.MI.005", name: "Allegan County" },
    { code: "US.MI.007", name: "Alpena County" },
    { code: "US.MI.009", name: "Antrim County" },
    { code: "US.MI.011", name: "Arenac County" },
    { code: "US.MI.013", name: "Baraga County" },
    { code: "US.MI.015", name: "Barry County" },
    { code: "US.MI.017", name: "Bay County" },
    { code: "US.MI.019", name: "Benzie County" },
    { code: "US.MI.021", name: "Berrien County" },
    { code: "US.MI.023", name: "Branch County" },
    { code: "US.MI.025", name: "Calhoun County" },
    { code: "US.MI.027", name: "Cass County" },
    { code: "US.MI.029", name: "Charlevoix County" },
    { code: "US.MI.031", name: "Cheboygan County" },
    { code: "US.MI.033", name: "Chippewa County" },
    { code: "US.MI.035", name: "Clare County" },
    { code: "US.MI.037", name: "Clinton County" },
    { code: "US.MI.039", name: "Crawford County" },
    { code: "US.MI.041", name: "Delta County" },
    { code: "US.MI.043", name: "Dickinson County" },
    { code: "US.MI.045", name: "Eaton County" },
    { code: "US.MI.047", name: "Emmet County" },
    { code: "US.MI.049", name: "Genesee County" },
    { code: "US.MI.051", name: "Gladwin County" },
    { code: "US.MI.053", name: "Gogebic County" },
    { code: "US.MI.055", name: "Grand Traverse County" },
    { code: "US.MI.057", name: "Gratiot County" },
    { code: "US.MI.059", name: "Hillsdale County" },
    { code: "US.MI.061", name: "Houghton County" },
    { code: "US.MI.063", name: "Huron County" },
    { code: "US.MI.065", name: "Ingham County" },
    { code: "US.MI.067", name: "Ionia County" },
    { code: "US.MI.069", name: "Iosco County" },
    { code: "US.MI.071", name: "Iron County" },
    { code: "US.MI.073", name: "Isabella County" },
    { code: "US.MI.075", name: "Jackson County" },
    { code: "US.MI.077", name: "Kalamazoo County" },
    { code: "US.MI.079", name: "Kalkaska County" },
    { code: "US.MI.081", name: "Kent County" },
    { code: "US.MI.083", name: "Keweenaw County" },
    { code: "US.MI.085", name: "Lake County" },
    { code: "US.MI.087", name: "Lapeer County" },
    { code: "US.MI.089", name: "Leelanau County" },
    { code: "US.MI.091", name: "Lenawee County" },
    { code: "US.MI.093", name: "Livingston County" },
    { code: "US.MI.095", name: "Luce County" },
    { code: "US.MI.097", name: "Mackinac County" },
    { code: "US.MI.099", name: "Macomb County" },
    { code: "US.MI.101", name: "Manistee County" },
    { code: "US.MI.103", name: "Marquette County" },
    { code: "US.MI.105", name: "Mason County" },
    { code: "US.MI.107", name: "Mecosta County" },
    { code: "US.MI.109", name: "Menominee County" },
    { code: "US.MI.111", name: "Midland County" },
    { code: "US.MI.113", name: "Missaukee County" },
    { code: "US.MI.115", name: "Monroe County" },
    { code: "US.MI.117", name: "Montcalm County" },
    { code: "US.MI.119", name: "Montmorency County" },
    { code: "US.MI.121", name: "Muskegon County" },
    { code: "US.MI.123", name: "Newaygo County" },
    { code: "US.MI.125", name: "Oakland County" },
    { code: "US.MI.127", name: "Oceana County" },
    { code: "US.MI.129", name: "Ogemaw County" },
    { code: "US.MI.131", name: "Ontonagon County" },
    { code: "US.MI.133", name: "Osceola County" },
    { code: "US.MI.135", name: "Oscoda County" },
    { code: "US.MI.137", name: "Otsego County" },
    { code: "US.MI.139", name: "Ottawa County" },
    { code: "US.MI.141", name: "Presque Isle County" },
    { code: "US.MI.143", name: "Roscommon County" },
    { code: "US.MI.145", name: "Saginaw County" },
    { code: "US.MI.147", name: "Saint Clair County" },
    { code: "US.MI.149", name: "Saint Joseph County" },
    { code: "US.MI.151", name: "Sanilac County" },
    { code: "US.MI.153", name: "Schoolcraft County" },
    { code: "US.MI.155", name: "Shiawassee County" },
    { code: "US.MI.157", name: "Tuscola County" },
    { code: "US.MI.159", name: "Van Buren County" },
    { code: "US.MI.161", name: "Washtenaw County" },
    { code: "US.MI.163", name: "Wayne County" },
    { code: "US.MI.165", name: "Wexford County" },
  ],
  "US.MN": [
    { code: "US.MN.001", name: "Aitkin County" },
    { code: "US.MN.003", name: "Anoka County" },
    { code: "US.MN.005", name: "Becker County" },
    { code: "US.MN.007", name: "Beltrami County" },
    { code: "US.MN.009", name: "Benton County" },
    { code: "US.MN.011", name: "Big Stone County" },
    { code: "US.MN.013", name: "Blue Earth County" },
    { code: "US.MN.015", name: "Brown County" },
    { code: "US.MN.017", name: "Carlton County" },
    { code: "US.MN.019", name: "Carver County" },
    { code: "US.MN.021", name: "Cass County" },
    { code: "US.MN.023", name: "Chippewa County" },
    { code: "US.MN.025", name: "Chisago County" },
    { code: "US.MN.027", name: "Clay County" },
    { code: "US.MN.029", name: "Clearwater County" },
    { code: "US.MN.031", name: "Cook County" },
    { code: "US.MN.033", name: "Cottonwood County" },
    { code: "US.MN.035", name: "Crow Wing County" },
    { code: "US.MN.037", name: "Dakota County" },
    { code: "US.MN.039", name: "Dodge County" },
    { code: "US.MN.041", name: "Douglas County" },
    { code: "US.MN.043", name: "Faribault County" },
    { code: "US.MN.045", name: "Fillmore County" },
    { code: "US.MN.047", name: "Freeborn County" },
    { code: "US.MN.049", name: "Goodhue County" },
    { code: "US.MN.051", name: "Grant County" },
    { code: "US.MN.053", name: "Hennepin County" },
    { code: "US.MN.055", name: "Houston County" },
    { code: "US.MN.057", name: "Hubbard County" },
    { code: "US.MN.059", name: "Isanti County" },
    { code: "US.MN.061", name: "Itasca County" },
    { code: "US.MN.063", name: "Jackson County" },
    { code: "US.MN.065", name: "Kanabec County" },
    { code: "US.MN.067", name: "Kandiyohi County" },
    { code: "US.MN.069", name: "Kittson County" },
    { code: "US.MN.071", name: "Koochiching County" },
    { code: "US.MN.073", name: "Lac qui Parle County" },
    { code: "US.MN.075", name: "Lake County" },
    { code: "US.MN.077", name: "Lake of the Woods County" },
    { code: "US.MN.079", name: "Le Sueur County" },
    { code: "US.MN.081", name: "Lincoln County" },
    { code: "US.MN.083", name: "Lyon County" },
    { code: "US.MN.085", name: "McLeod County" },
    { code: "US.MN.087", name: "Mahnomen County" },
    { code: "US.MN.089", name: "Marshall County" },
    { code: "US.MN.091", name: "Martin County" },
    { code: "US.MN.093", name: "Meeker County" },
    { code: "US.MN.095", name: "Mille Lacs County" },
    { code: "US.MN.097", name: "Morrison County" },
    { code: "US.MN.099", name: "Mower County" },
    { code: "US.MN.101", name: "Murray County" },
    { code: "US.MN.103", name: "Nicollet County" },
    { code: "US.MN.105", name: "Nobles County" },
    { code: "US.MN.107", name: "Norman County" },
    { code: "US.MN.109", name: "Olmsted County" },
    { code: "US.MN.111", name: "Otter Tail County" },
    { code: "US.MN.113", name: "Pennington County" },
    { code: "US.MN.115", name: "Pine County" },
    { code: "US.MN.117", name: "Pipestone County" },
    { code: "US.MN.119", name: "Polk County" },
    { code: "US.MN.121", name: "Pope County" },
    { code: "US.MN.123", name: "Ramsey County" },
    { code: "US.MN.125", name: "Red Lake County" },
    { code: "US.MN.127", name: "Redwood County" },
    { code: "US.MN.129", name: "Renville County" },
    { code: "US.MN.131", name: "Rice County" },
    { code: "US.MN.133", name: "Rock County" },
    { code: "US.MN.135", name: "Roseau County" },
    { code: "US.MN.137", name: "Saint Louis County" },
    { code: "US.MN.139", name: "Scott County" },
    { code: "US.MN.141", name: "Sherburne County" },
    { code: "US.MN.143", name: "Sibley County" },
    { code: "US.MN.145", name: "Stearns County" },
    { code: "US.MN.147", name: "Steele County" },
    { code: "US.MN.149", name: "Stevens County" },
    { code: "US.MN.151", name: "Swift County" },
    { code: "US.MN.153", name: "Todd County" },
    { code: "US.MN.155", name: "Traverse County" },
    { code: "US.MN.157", name: "Wabasha County" },
    { code: "US.MN.159", name: "Wadena County" },
    { code: "US.MN.161", name: "Waseca County" },
    { code: "US.MN.163", name: "Washington County" },
    { code: "US.MN.165", name: "Watonwan County" },
    { code: "US.MN.167", name: "Wilkin County" },
    { code: "US.MN.169", name: "Winona County" },
    { code: "US.MN.171", name: "Wright County" },
    { code: "US.MN.173", name: "Yellow Medicine County" },
  ],
  "US.MO": [
    { code: "US.MO.001", name: "Adair County" },
    { code: "US.MO.003", name: "Andrew County" },
    { code: "US.MO.005", name: "Atchison County" },
    { code: "US.MO.007", name: "Audrain County" },
    { code: "US.MO.009", name: "Barry County" },
    { code: "US.MO.011", name: "Barton County" },
    { code: "US.MO.013", name: "Bates County" },
    { code: "US.MO.015", name: "Benton County" },
    { code: "US.MO.017", name: "Bollinger County" },
    { code: "US.MO.019", name: "Boone County" },
    { code: "US.MO.021", name: "Buchanan County" },
    { code: "US.MO.023", name: "Butler County" },
    { code: "US.MO.025", name: "Caldwell County" },
    { code: "US.MO.027", name: "Callaway County" },
    { code: "US.MO.029", name: "Camden County" },
    { code: "US.MO.031", name: "Cape Girardeau County" },
    { code: "US.MO.033", name: "Carroll County" },
    { code: "US.MO.035", name: "Carter County" },
    { code: "US.MO.037", name: "Cass County" },
    { code: "US.MO.039", name: "Cedar County" },
    { code: "US.MO.041", name: "Chariton County" },
    { code: "US.MO.043", name: "Christian County" },
    { code: "US.MO.045", name: "Clark County" },
    { code: "US.MO.047", name: "Clay County" },
    { code: "US.MO.049", name: "Clinton County" },
    { code: "US.MO.051", name: "Cole County" },
    { code: "US.MO.053", name: "Cooper County" },
    { code: "US.MO.055", name: "Crawford County" },
    { code: "US.MO.057", name: "Dade County" },
    { code: "US.MO.059", name: "Dallas County" },
    { code: "US.MO.061", name: "Daviess County" },
    { code: "US.MO.063", name: "DeKalb County" },
    { code: "US.MO.065", name: "Dent County" },
    { code: "US.MO.067", name: "Douglas County" },
    { code: "US.MO.069", name: "Dunklin County" },
    { code: "US.MO.071", name: "Franklin County" },
    { code: "US.MO.073", name: "Gasconade County" },
    { code: "US.MO.075", name: "Gentry County" },
    { code: "US.MO.077", name: "Greene County" },
    { code: "US.MO.079", name: "Grundy County" },
    { code: "US.MO.081", name: "Harrison County" },
    { code: "US.MO.083", name: "Henry County" },
    { code: "US.MO.085", name: "Hickory County" },
    { code: "US.MO.087", name: "Holt County" },
    { code: "US.MO.089", name: "Howard County" },
    { code: "US.MO.091", name: "Howell County" },
    { code: "US.MO.093", name: "Iron County" },
    { code: "US.MO.095", name: "Jackson County" },
    { code: "US.MO.097", name: "Jasper County" },
    { code: "US.MO.099", name: "Jefferson County" },
    { code: "US.MO.101", name: "Johnson County" },
    { code: "US.MO.103", name: "Knox County" },
    { code: "US.MO.105", name: "Laclede County" },
    { code: "US.MO.107", name: "Lafayette County" },
    { code: "US.MO.109", name: "Lawrence County" },
    { code: "US.MO.111", name: "Lewis County" },
    { code: "US.MO.113", name: "Lincoln County" },
    { code: "US.MO.115", name: "Linn County" },
    { code: "US.MO.117", name: "Livingston County" },
    { code: "US.MO.119", name: "McDonald County" },
    { code: "US.MO.121", name: "Macon County" },
    { code: "US.MO.123", name: "Madison County" },
    { code: "US.MO.125", name: "Maries County" },
    { code: "US.MO.127", name: "Marion County" },
    { code: "US.MO.129", name: "Mercer County" },
    { code: "US.MO.131", name: "Miller County" },
    { code: "US.MO.133", name: "Mississippi County" },
    { code: "US.MO.135", name: "Moniteau County" },
    { code: "US.MO.137", name: "Monroe County" },
    { code: "US.MO.139", name: "Montgomery County" },
    { code: "US.MO.141", name: "Morgan County" },
    { code: "US.MO.143", name: "New Madrid County" },
    { code: "US.MO.145", name: "Newton County" },
    { code: "US.MO.147", name: "Nodaway County" },
    { code: "US.MO.149", name: "Oregon County" },
    { code: "US.MO.151", name: "Osage County" },
    { code: "US.MO.153", name: "Ozark County" },
    { code: "US.MO.155", name: "Pemiscot County" },
    { code: "US.MO.157", name: "Perry County" },
    { code: "US.MO.159", name: "Pettis County" },
    { code: "US.MO.161", name: "Phelps County" },
    { code: "US.MO.163", name: "Pike County" },
    { code: "US.MO.165", name: "Platte County" },
    { code: "US.MO.167", name: "Polk County" },
    { code: "US.MO.169", name: "Pulaski County" },
    { code: "US.MO.171", name: "Putnam County" },
    { code: "US.MO.173", name: "Ralls County" },
    { code: "US.MO.175", name: "Randolph County" },
    { code: "US.MO.177", name: "Ray County" },
    { code: "US.MO.179", name: "Reynolds County" },
    { code: "US.MO.181", name: "Ripley County" },
    { code: "US.MO.183", name: "Saint Charles County" },
    { code: "US.MO.185", name: "Saint Clair County" },
    { code: "US.MO.186", name: "Sainte Genevieve County" },
    { code: "US.MO.187", name: "Saint Francois County" },
    { code: "US.MO.189", name: "Saint Louis County" },
    { code: "US.MO.195", name: "Saline County" },
    { code: "US.MO.197", name: "Schuyler County" },
    { code: "US.MO.199", name: "Scotland County" },
    { code: "US.MO.201", name: "Scott County" },
    { code: "US.MO.203", name: "Shannon County" },
    { code: "US.MO.205", name: "Shelby County" },
    { code: "US.MO.207", name: "Stoddard County" },
    { code: "US.MO.209", name: "Stone County" },
    { code: "US.MO.211", name: "Sullivan County" },
    { code: "US.MO.213", name: "Taney County" },
    { code: "US.MO.215", name: "Texas County" },
    { code: "US.MO.217", name: "Vernon County" },
    { code: "US.MO.219", name: "Warren County" },
    { code: "US.MO.221", name: "Washington County" },
    { code: "US.MO.223", name: "Wayne County" },
    { code: "US.MO.225", name: "Webster County" },
    { code: "US.MO.227", name: "Worth County" },
    { code: "US.MO.229", name: "Wright County" },
    { code: "US.MO.510", name: "City of Saint Louis" },
  ],
  "US.MS": [
    { code: "US.MS.001", name: "Adams County" },
    { code: "US.MS.003", name: "Alcorn County" },
    { code: "US.MS.005", name: "Amite County" },
    { code: "US.MS.007", name: "Attala County" },
    { code: "US.MS.009", name: "Benton County" },
    { code: "US.MS.011", name: "Bolivar County" },
    { code: "US.MS.013", name: "Calhoun County" },
    { code: "US.MS.015", name: "Carroll County" },
    { code: "US.MS.017", name: "Chickasaw County" },
    { code: "US.MS.019", name: "Choctaw County" },
    { code: "US.MS.021", name: "Claiborne County" },
    { code: "US.MS.023", name: "Clarke County" },
    { code: "US.MS.025", name: "Clay County" },
    { code: "US.MS.027", name: "Coahoma County" },
    { code: "US.MS.029", name: "Copiah County" },
    { code: "US.MS.031", name: "Covington County" },
    { code: "US.MS.033", name: "De Soto County" },
    { code: "US.MS.035", name: "Forrest County" },
    { code: "US.MS.037", name: "Franklin County" },
    { code: "US.MS.039", name: "George County" },
    { code: "US.MS.041", name: "Greene County" },
    { code: "US.MS.043", name: "Grenada County" },
    { code: "US.MS.045", name: "Hancock County" },
    { code: "US.MS.047", name: "Harrison County" },
    { code: "US.MS.049", name: "Hinds County" },
    { code: "US.MS.051", name: "Holmes County" },
    { code: "US.MS.053", name: "Humphreys County" },
    { code: "US.MS.055", name: "Issaquena County" },
    { code: "US.MS.057", name: "Itawamba County" },
    { code: "US.MS.059", name: "Jackson County" },
    { code: "US.MS.061", name: "Jasper County" },
    { code: "US.MS.063", name: "Jefferson County" },
    { code: "US.MS.065", name: "Jefferson Davis County" },
    { code: "US.MS.067", name: "Jones County" },
    { code: "US.MS.069", name: "Kemper County" },
    { code: "US.MS.071", name: "Lafayette County" },
    { code: "US.MS.073", name: "Lamar County" },
    { code: "US.MS.075", name: "Lauderdale County" },
    { code: "US.MS.077", name: "Lawrence County" },
    { code: "US.MS.079", name: "Leake County" },
    { code: "US.MS.081", name: "Lee County" },
    { code: "US.MS.083", name: "Leflore County" },
    { code: "US.MS.085", name: "Lincoln County" },
    { code: "US.MS.087", name: "Lowndes County" },
    { code: "US.MS.089", name: "Madison County" },
    { code: "US.MS.091", name: "Marion County" },
    { code: "US.MS.093", name: "Marshall County" },
    { code: "US.MS.095", name: "Monroe County" },
    { code: "US.MS.097", name: "Montgomery County" },
    { code: "US.MS.099", name: "Neshoba County" },
    { code: "US.MS.101", name: "Newton County" },
    { code: "US.MS.103", name: "Noxubee County" },
    { code: "US.MS.105", name: "Oktibbeha County" },
    { code: "US.MS.107", name: "Panola County" },
    { code: "US.MS.109", name: "Pearl River County" },
    { code: "US.MS.111", name: "Perry County" },
    { code: "US.MS.113", name: "Pike County" },
    { code: "US.MS.115", name: "Pontotoc County" },
    { code: "US.MS.117", name: "Prentiss County" },
    { code: "US.MS.119", name: "Quitman County" },
    { code: "US.MS.121", name: "Rankin County" },
    { code: "US.MS.123", name: "Scott County" },
    { code: "US.MS.125", name: "Sharkey County" },
    { code: "US.MS.127", name: "Simpson County" },
    { code: "US.MS.129", name: "Smith County" },
    { code: "US.MS.131", name: "Stone County" },
    { code: "US.MS.133", name: "Sunflower County" },
    { code: "US.MS.135", name: "Tallahatchie County" },
    { code: "US.MS.137", name: "Tate County" },
    { code: "US.MS.139", name: "Tippah County" },
    { code: "US.MS.141", name: "Tishomingo County" },
    { code: "US.MS.143", name: "Tunica County" },
    { code: "US.MS.145", name: "Union County" },
    { code: "US.MS.147", name: "Walthall County" },
    { code: "US.MS.149", name: "Warren County" },
    { code: "US.MS.151", name: "Washington County" },
    { code: "US.MS.153", name: "Wayne County" },
    { code: "US.MS.155", name: "Webster County" },
    { code: "US.MS.157", name: "Wilkinson County" },
    { code: "US.MS.159", name: "Winston County" },
    { code: "US.MS.161", name: "Yalobusha County" },
    { code: "US.MS.163", name: "Yazoo County" },
  ],
  "US.MT": [
    { code: "US.MT.001", name: "Beaverhead County" },
    { code: "US.MT.003", name: "Big Horn County" },
    { code: "US.MT.005", name: "Blaine County" },
    { code: "US.MT.007", name: "Broadwater County" },
    { code: "US.MT.009", name: "Carbon County" },
    { code: "US.MT.011", name: "Carter County" },
    { code: "US.MT.013", name: "Cascade County" },
    { code: "US.MT.015", name: "Chouteau County" },
    { code: "US.MT.017", name: "Custer County" },
    { code: "US.MT.019", name: "Daniels County" },
    { code: "US.MT.021", name: "Dawson County" },
    { code: "US.MT.023", name: "Deer Lodge County" },
    { code: "US.MT.025", name: "Fallon County" },
    { code: "US.MT.027", name: "Fergus County" },
    { code: "US.MT.029", name: "Flathead County" },
    { code: "US.MT.031", name: "Gallatin County" },
    { code: "US.MT.033", name: "Garfield County" },
    { code: "US.MT.035", name: "Glacier County" },
    { code: "US.MT.037", name: "Golden Valley County" },
    { code: "US.MT.039", name: "Granite County" },
    { code: "US.MT.041", name: "Hill County" },
    { code: "US.MT.043", name: "Jefferson County" },
    { code: "US.MT.045", name: "Judith Basin County" },
    { code: "US.MT.047", name: "Lake County" },
    { code: "US.MT.049", name: "Lewis and Clark County" },
    { code: "US.MT.051", name: "Liberty County" },
    { code: "US.MT.053", name: "Lincoln County" },
    { code: "US.MT.055", name: "McCone County" },
    { code: "US.MT.057", name: "Madison County" },
    { code: "US.MT.059", name: "Meagher County" },
    { code: "US.MT.061", name: "Mineral County" },
    { code: "US.MT.063", name: "Missoula County" },
    { code: "US.MT.065", name: "Musselshell County" },
    { code: "US.MT.067", name: "Park County" },
    { code: "US.MT.069", name: "Petroleum County" },
    { code: "US.MT.071", name: "Phillips County" },
    { code: "US.MT.073", name: "Pondera County" },
    { code: "US.MT.075", name: "Powder River County" },
    { code: "US.MT.077", name: "Powell County" },
    { code: "US.MT.079", name: "Prairie County" },
    { code: "US.MT.081", name: "Ravalli County" },
    { code: "US.MT.083", name: "Richland County" },
    { code: "US.MT.085", name: "Roosevelt County" },
    { code: "US.MT.087", name: "Rosebud County" },
    { code: "US.MT.089", name: "Sanders County" },
    { code: "US.MT.091", name: "Sheridan County" },
    { code: "US.MT.093", name: "Silver Bow County" },
    { code: "US.MT.095", name: "Stillwater County" },
    { code: "US.MT.097", name: "Sweet Grass County" },
    { code: "US.MT.099", name: "Teton County" },
    { code: "US.MT.101", name: "Toole County" },
    { code: "US.MT.103", name: "Treasure County" },
    { code: "US.MT.105", name: "Valley County" },
    { code: "US.MT.107", name: "Wheatland County" },
    { code: "US.MT.109", name: "Wibaux County" },
    { code: "US.MT.111", name: "Yellowstone County" },
  ],
  "US.NC": [
    { code: "US.NC.001", name: "Alamance County" },
    { code: "US.NC.003", name: "Alexander County" },
    { code: "US.NC.005", name: "Alleghany County" },
    { code: "US.NC.007", name: "Anson County" },
    { code: "US.NC.009", name: "Ashe County" },
    { code: "US.NC.011", name: "Avery County" },
    { code: "US.NC.013", name: "Beaufort County" },
    { code: "US.NC.015", name: "Bertie County" },
    { code: "US.NC.017", name: "Bladen County" },
    { code: "US.NC.019", name: "Brunswick County" },
    { code: "US.NC.021", name: "Buncombe County" },
    { code: "US.NC.023", name: "Burke County" },
    { code: "US.NC.025", name: "Cabarrus County" },
    { code: "US.NC.027", name: "Caldwell County" },
    { code: "US.NC.029", name: "Camden County" },
    { code: "US.NC.031", name: "Carteret County" },
    { code: "US.NC.033", name: "Caswell County" },
    { code: "US.NC.035", name: "Catawba County" },
    { code: "US.NC.037", name: "Chatham County" },
    { code: "US.NC.039", name: "Cherokee County" },
    { code: "US.NC.041", name: "Chowan County" },
    { code: "US.NC.043", name: "Clay County" },
    { code: "US.NC.045", name: "Cleveland County" },
    { code: "US.NC.047", name: "Columbus County" },
    { code: "US.NC.049", name: "Craven County" },
    { code: "US.NC.051", name: "Cumberland County" },
    { code: "US.NC.053", name: "Currituck County" },
    { code: "US.NC.055", name: "Dare County" },
    { code: "US.NC.057", name: "Davidson County" },
    { code: "US.NC.059", name: "Davie County" },
    { code: "US.NC.061", name: "Duplin County" },
    { code: "US.NC.063", name: "Durham County" },
    { code: "US.NC.065", name: "Edgecombe County" },
    { code: "US.NC.067", name: "Forsyth County" },
    { code: "US.NC.069", name: "Franklin County" },
    { code: "US.NC.071", name: "Gaston County" },
    { code: "US.NC.073", name: "Gates County" },
    { code: "US.NC.075", name: "Graham County" },
    { code: "US.NC.077", name: "Granville County" },
    { code: "US.NC.079", name: "Greene County" },
    { code: "US.NC.081", name: "Guilford County" },
    { code: "US.NC.083", name: "Halifax County" },
    { code: "US.NC.085", name: "Harnett County" },
    { code: "US.NC.087", name: "Haywood County" },
    { code: "US.NC.089", name: "Henderson County" },
    { code: "US.NC.091", name: "Hertford County" },
    { code: "US.NC.093", name: "Hoke County" },
    { code: "US.NC.095", name: "Hyde County" },
    { code: "US.NC.097", name: "Iredell County" },
    { code: "US.NC.099", name: "Jackson County" },
    { code: "US.NC.101", name: "Johnston County" },
    { code: "US.NC.103", name: "Jones County" },
    { code: "US.NC.105", name: "Lee County" },
    { code: "US.NC.107", name: "Lenoir County" },
    { code: "US.NC.109", name: "Lincoln County" },
    { code: "US.NC.111", name: "McDowell County" },
    { code: "US.NC.113", name: "Macon County" },
    { code: "US.NC.115", name: "Madison County" },
    { code: "US.NC.117", name: "Martin County" },
    { code: "US.NC.119", name: "Mecklenburg County" },
    { code: "US.NC.121", name: "Mitchell County" },
    { code: "US.NC.123", name: "Montgomery County" },
    { code: "US.NC.125", name: "Moore County" },
    { code: "US.NC.127", name: "Nash County" },
    { code: "US.NC.129", name: "New Hanover County" },
    { code: "US.NC.131", name: "Northampton County" },
    { code: "US.NC.133", name: "Onslow County" },
    { code: "US.NC.135", name: "Orange County" },
    { code: "US.NC.137", name: "Pamlico County" },
    { code: "US.NC.139", name: "Pasquotank County" },
    { code: "US.NC.141", name: "Pender County" },
    { code: "US.NC.143", name: "Perquimans County" },
    { code: "US.NC.145", name: "Person County" },
    { code: "US.NC.147", name: "Pitt County" },
    { code: "US.NC.149", name: "Polk County" },
    { code: "US.NC.151", name: "Randolph County" },
    { code: "US.NC.153", name: "Richmond County" },
    { code: "US.NC.155", name: "Robeson County" },
    { code: "US.NC.157", name: "Rockingham County" },
    { code: "US.NC.159", name: "Rowan County" },
    { code: "US.NC.161", name: "Rutherford County" },
    { code: "US.NC.163", name: "Sampson County" },
    { code: "US.NC.165", name: "Scotland County" },
    { code: "US.NC.167", name: "Stanly County" },
    { code: "US.NC.169", name: "Stokes County" },
    { code: "US.NC.171", name: "Surry County" },
    { code: "US.NC.173", name: "Swain County" },
    { code: "US.NC.175", name: "Transylvania County" },
    { code: "US.NC.177", name: "Tyrrell County" },
    { code: "US.NC.179", name: "Union County" },
    { code: "US.NC.181", name: "Vance County" },
    { code: "US.NC.183", name: "Wake County" },
    { code: "US.NC.185", name: "Warren County" },
    { code: "US.NC.187", name: "Washington County" },
    { code: "US.NC.189", name: "Watauga County" },
    { code: "US.NC.191", name: "Wayne County" },
    { code: "US.NC.193", name: "Wilkes County" },
    { code: "US.NC.195", name: "Wilson County" },
    { code: "US.NC.197", name: "Yadkin County" },
    { code: "US.NC.199", name: "Yancey County" },
  ],
  "US.ND": [
    { code: "US.ND.001", name: "Adams County" },
    { code: "US.ND.003", name: "Barnes County" },
    { code: "US.ND.005", name: "Benson County" },
    { code: "US.ND.007", name: "Billings County" },
    { code: "US.ND.009", name: "Bottineau County" },
    { code: "US.ND.011", name: "Bowman County" },
    { code: "US.ND.013", name: "Burke County" },
    { code: "US.ND.015", name: "Burleigh County" },
    { code: "US.ND.017", name: "Cass County" },
    { code: "US.ND.019", name: "Cavalier County" },
    { code: "US.ND.021", name: "Dickey County" },
    { code: "US.ND.023", name: "Divide County" },
    { code: "US.ND.025", name: "Dunn County" },
    { code: "US.ND.027", name: "Eddy County" },
    { code: "US.ND.029", name: "Emmons County" },
    { code: "US.ND.031", name: "Foster County" },
    { code: "US.ND.033", name: "Golden Valley County" },
    { code: "US.ND.035", name: "Grand Forks County" },
    { code: "US.ND.037", name: "Grant County" },
    { code: "US.ND.039", name: "Griggs County" },
    { code: "US.ND.041", name: "Hettinger County" },
    { code: "US.ND.043", name: "Kidder County" },
    { code: "US.ND.045", name: "LaMoure County" },
    { code: "US.ND.047", name: "Logan County" },
    { code: "US.ND.049", name: "McHenry County" },
    { code: "US.ND.051", name: "McIntosh County" },
    { code: "US.ND.053", name: "McKenzie County" },
    { code: "US.ND.055", name: "McLean County" },
    { code: "US.ND.057", name: "Mercer County" },
    { code: "US.ND.059", name: "Morton County" },
    { code: "US.ND.061", name: "Mountrail County" },
    { code: "US.ND.063", name: "Nelson County" },
    { code: "US.ND.065", name: "Oliver County" },
    { code: "US.ND.067", name: "Pembina County" },
    { code: "US.ND.069", name: "Pierce County" },
    { code: "US.ND.071", name: "Ramsey County" },
    { code: "US.ND.073", name: "Ransom County" },
    { code: "US.ND.075", name: "Renville County" },
    { code: "US.ND.077", name: "Richland County" },
    { code: "US.ND.079", name: "Rolette County" },
    { code: "US.ND.081", name: "Sargent County" },
    { code: "US.ND.083", name: "Sheridan County" },
    { code: "US.ND.085", name: "Sioux County" },
    { code: "US.ND.087", name: "Slope County" },
    { code: "US.ND.089", name: "Stark County" },
    { code: "US.ND.091", name: "Steele County" },
    { code: "US.ND.093", name: "Stutsman County" },
    { code: "US.ND.095", name: "Towner County" },
    { code: "US.ND.097", name: "Traill County" },
    { code: "US.ND.099", name: "Walsh County" },
    { code: "US.ND.101", name: "Ward County" },
    { code: "US.ND.103", name: "Wells County" },
    { code: "US.ND.105", name: "Williams County" },
  ],
  "US.NE": [
    { code: "US.NE.001", name: "Adams County" },
    { code: "US.NE.003", name: "Antelope County" },
    { code: "US.NE.005", name: "Arthur County" },
    { code: "US.NE.007", name: "Banner County" },
    { code: "US.NE.009", name: "Blaine County" },
    { code: "US.NE.011", name: "Boone County" },
    { code: "US.NE.013", name: "Box Butte County" },
    { code: "US.NE.015", name: "Boyd County" },
    { code: "US.NE.017", name: "Brown County" },
    { code: "US.NE.019", name: "Buffalo County" },
    { code: "US.NE.021", name: "Burt County" },
    { code: "US.NE.023", name: "Butler County" },
    { code: "US.NE.025", name: "Cass County" },
    { code: "US.NE.027", name: "Cedar County" },
    { code: "US.NE.029", name: "Chase County" },
    { code: "US.NE.031", name: "Cherry County" },
    { code: "US.NE.033", name: "Cheyenne County" },
    { code: "US.NE.035", name: "Clay County" },
    { code: "US.NE.037", name: "Colfax County" },
    { code: "US.NE.039", name: "Cuming County" },
    { code: "US.NE.041", name: "Custer County" },
    { code: "US.NE.043", name: "Dakota County" },
    { code: "US.NE.045", name: "Dawes County" },
    { code: "US.NE.047", name: "Dawson County" },
    { code: "US.NE.049", name: "Deuel County" },
    { code: "US.NE.051", name: "Dixon County" },
    { code: "US.NE.053", name: "Dodge County" },
    { code: "US.NE.055", name: "Douglas County" },
    { code: "US.NE.057", name: "Dundy County" },
    { code: "US.NE.059", name: "Fillmore County" },
    { code: "US.NE.061", name: "Franklin County" },
    { code: "US.NE.063", name: "Frontier County" },
    { code: "US.NE.065", name: "Furnas County" },
    { code: "US.NE.067", name: "Gage County" },
    { code: "US.NE.069", name: "Garden County" },
    { code: "US.NE.071", name: "Garfield County" },
    { code: "US.NE.073", name: "Gosper County" },
    { code: "US.NE.075", name: "Grant County" },
    { code: "US.NE.077", name: "Greeley County" },
    { code: "US.NE.079", name: "Hall County" },
    { code: "US.NE.081", name: "Hamilton County" },
    { code: "US.NE.083", name: "Harlan County" },
    { code: "US.NE.085", name: "Hayes County" },
    { code: "US.NE.087", name: "Hitchcock County" },
    { code: "US.NE.089", name: "Holt County" },
    { code: "US.NE.091", name: "Hooker County" },
    { code: "US.NE.093", name: "Howard County" },
    { code: "US.NE.095", name: "Jefferson County" },
    { code: "US.NE.097", name: "Johnson County" },
    { code: "US.NE.099", name: "Kearney County" },
    { code: "US.NE.101", name: "Keith County" },
    { code: "US.NE.103", name: "Keya Paha County" },
    { code: "US.NE.105", name: "Kimball County" },
    { code: "US.NE.107", name: "Knox County" },
    { code: "US.NE.109", name: "Lancaster County" },
    { code: "US.NE.111", name: "Lincoln County" },
    { code: "US.NE.113", name: "Logan County" },
    { code: "US.NE.115", name: "Loup County" },
    { code: "US.NE.117", name: "McPherson County" },
    { code: "US.NE.119", name: "Madison County" },
    { code: "US.NE.121", name: "Merrick County" },
    { code: "US.NE.123", name: "Morrill County" },
    { code: "US.NE.125", name: "Nance County" },
    { code: "US.NE.127", name: "Nemaha County" },
    { code: "US.NE.129", name: "Nuckolls County" },
    { code: "US.NE.131", name: "Otoe County" },
    { code: "US.NE.133", name: "Pawnee County" },
    { code: "US.NE.135", name: "Perkins County" },
    { code: "US.NE.137", name: "Phelps County" },
    { code: "US.NE.139", name: "Pierce County" },
    { code: "US.NE.141", name: "Platte County" },
    { code: "US.NE.143", name: "Polk County" },
    { code: "US.NE.145", name: "Red Willow County" },
    { code: "US.NE.147", name: "Richardson County" },
    { code: "US.NE.149", name: "Rock County" },
    { code: "US.NE.151", name: "Saline County" },
    { code: "US.NE.153", name: "Sarpy County" },
    { code: "US.NE.155", name: "Saunders County" },
    { code: "US.NE.157", name: "Scotts Bluff County" },
    { code: "US.NE.159", name: "Seward County" },
    { code: "US.NE.161", name: "Sheridan County" },
    { code: "US.NE.163", name: "Sherman County" },
    { code: "US.NE.165", name: "Sioux County" },
    { code: "US.NE.167", name: "Stanton County" },
    { code: "US.NE.169", name: "Thayer County" },
    { code: "US.NE.171", name: "Thomas County" },
    { code: "US.NE.173", name: "Thurston County" },
    { code: "US.NE.175", name: "Valley County" },
    { code: "US.NE.177", name: "Washington County" },
    { code: "US.NE.179", name: "Wayne County" },
    { code: "US.NE.181", name: "Webster County" },
    { code: "US.NE.183", name: "Wheeler County" },
    { code: "US.NE.185", name: "York County" },
  ],
  "US.NH": [
    { code: "US.NH.001", name: "Belknap County" },
    { code: "US.NH.003", name: "Carroll County" },
    { code: "US.NH.005", name: "Cheshire County" },
    { code: "US.NH.007", name: "Coos County" },
    { code: "US.NH.009", name: "Grafton County" },
    { code: "US.NH.011", name: "Hillsborough County" },
    { code: "US.NH.013", name: "Merrimack County" },
    { code: "US.NH.015", name: "Rockingham County" },
    { code: "US.NH.017", name: "Strafford County" },
    { code: "US.NH.019", name: "Sullivan County" },
  ],
  "US.NJ": [
    { code: "US.NJ.001", name: "Atlantic County" },
    { code: "US.NJ.003", name: "Bergen County" },
    { code: "US.NJ.005", name: "Burlington County" },
    { code: "US.NJ.007", name: "Camden County" },
    { code: "US.NJ.009", name: "Cape May County" },
    { code: "US.NJ.011", name: "Cumberland County" },
    { code: "US.NJ.013", name: "Essex County" },
    { code: "US.NJ.015", name: "Gloucester County" },
    { code: "US.NJ.017", name: "Hudson County" },
    { code: "US.NJ.019", name: "Hunterdon County" },
    { code: "US.NJ.021", name: "Mercer County" },
    { code: "US.NJ.023", name: "Middlesex County" },
    { code: "US.NJ.025", name: "Monmouth County" },
    { code: "US.NJ.027", name: "Morris County" },
    { code: "US.NJ.029", name: "Ocean County" },
    { code: "US.NJ.031", name: "Passaic County" },
    { code: "US.NJ.033", name: "Salem County" },
    { code: "US.NJ.035", name: "Somerset County" },
    { code: "US.NJ.037", name: "Sussex County" },
    { code: "US.NJ.039", name: "Union County" },
    { code: "US.NJ.041", name: "Warren County" },
  ],
  "US.NM": [
    { code: "US.NM.001", name: "Bernalillo County" },
    { code: "US.NM.003", name: "Catron County" },
    { code: "US.NM.005", name: "Chaves County" },
    { code: "US.NM.006", name: "Cibola County" },
    { code: "US.NM.007", name: "Colfax County" },
    { code: "US.NM.009", name: "Curry County" },
    { code: "US.NM.011", name: "De Baca County" },
    { code: "US.NM.013", name: "Doña Ana County" },
    { code: "US.NM.015", name: "Eddy County" },
    { code: "US.NM.017", name: "Grant County" },
    { code: "US.NM.019", name: "Guadalupe County" },
    { code: "US.NM.021", name: "Harding County" },
    { code: "US.NM.023", name: "Hidalgo County" },
    { code: "US.NM.025", name: "Lea County" },
    { code: "US.NM.027", name: "Lincoln County" },
    { code: "US.NM.028", name: "Los Alamos County" },
    { code: "US.NM.029", name: "Luna County" },
    { code: "US.NM.031", name: "McKinley County" },
    { code: "US.NM.033", name: "Mora County" },
    { code: "US.NM.035", name: "Otero County" },
    { code: "US.NM.037", name: "Quay County" },
    { code: "US.NM.039", name: "Rio Arriba County" },
    { code: "US.NM.041", name: "Roosevelt County" },
    { code: "US.NM.043", name: "Sandoval County" },
    { code: "US.NM.045", name: "San Juan County" },
    { code: "US.NM.047", name: "San Miguel County" },
    { code: "US.NM.049", name: "Santa Fe County" },
    { code: "US.NM.051", name: "Sierra County" },
    { code: "US.NM.053", name: "Socorro County" },
    { code: "US.NM.055", name: "Taos County" },
    { code: "US.NM.057", name: "Torrance County" },
    { code: "US.NM.059", name: "Union County" },
    { code: "US.NM.061", name: "Valencia County" },
  ],
  "US.NV": [
    { code: "US.NV.001", name: "Churchill County" },
    { code: "US.NV.003", name: "Clark County" },
    { code: "US.NV.005", name: "Douglas County" },
    { code: "US.NV.007", name: "Elko County" },
    { code: "US.NV.009", name: "Esmeralda County" },
    { code: "US.NV.011", name: "Eureka County" },
    { code: "US.NV.013", name: "Humboldt County" },
    { code: "US.NV.015", name: "Lander County" },
    { code: "US.NV.017", name: "Lincoln County" },
    { code: "US.NV.019", name: "Lyon County" },
    { code: "US.NV.021", name: "Mineral County" },
    { code: "US.NV.023", name: "Nye County" },
    { code: "US.NV.027", name: "Pershing County" },
    { code: "US.NV.029", name: "Storey County" },
    { code: "US.NV.031", name: "Washoe County" },
    { code: "US.NV.033", name: "White Pine County" },
    { code: "US.NV.510", name: "Carson City" },
  ],
  "US.NY": [
    { code: "US.NY.001", name: "Albany County" },
    { code: "US.NY.003", name: "Allegany County" },
    { code: "US.NY.005", name: "Bronx" },
    { code: "US.NY.007", name: "Broome County" },
    { code: "US.NY.009", name: "Cattaraugus County" },
    { code: "US.NY.011", name: "Cayuga County" },
    { code: "US.NY.013", name: "Chautauqua County" },
    { code: "US.NY.015", name: "Chemung County" },
    { code: "US.NY.017", name: "Chenango County" },
    { code: "US.NY.019", name: "Clinton County" },
    { code: "US.NY.021", name: "Columbia County" },
    { code: "US.NY.023", name: "Cortland County" },
    { code: "US.NY.025", name: "Delaware County" },
    { code: "US.NY.027", name: "Dutchess County" },
    { code: "US.NY.029", name: "Erie County" },
    { code: "US.NY.031", name: "Essex County" },
    { code: "US.NY.033", name: "Franklin County" },
    { code: "US.NY.035", name: "Fulton County" },
    { code: "US.NY.037", name: "Genesee County" },
    { code: "US.NY.039", name: "Greene County" },
    { code: "US.NY.041", name: "Hamilton County" },
    { code: "US.NY.043", name: "Herkimer County" },
    { code: "US.NY.045", name: "Jefferson County" },
    { code: "US.NY.047", name: "Kings County" },
    { code: "US.NY.049", name: "Lewis County" },
    { code: "US.NY.051", name: "Livingston County" },
    { code: "US.NY.053", name: "Madison County" },
    { code: "US.NY.055", name: "Monroe County" },
    { code: "US.NY.057", name: "Montgomery County" },
    { code: "US.NY.059", name: "Nassau County" },
    { code: "US.NY.061", name: "New York County" },
    { code: "US.NY.063", name: "Niagara County" },
    { code: "US.NY.065", name: "Oneida County" },
    { code: "US.NY.067", name: "Onondaga County" },
    { code: "US.NY.069", name: "Ontario County" },
    { code: "US.NY.071", name: "Orange County" },
    { code: "US.NY.073", name: "Orleans County" },
    { code: "US.NY.075", name: "Oswego County" },
    { code: "US.NY.077", name: "Otsego County" },
    { code: "US.NY.079", name: "Putnam County" },
    { code: "US.NY.081", name: "Queens County" },
    { code: "US.NY.083", name: "Rensselaer County" },
    { code: "US.NY.085", name: "Richmond County" },
    { code: "US.NY.087", name: "Rockland County" },
    { code: "US.NY.089", name: "St. Lawrence County" },
    { code: "US.NY.091", name: "Saratoga County" },
    { code: "US.NY.093", name: "Schenectady County" },
    { code: "US.NY.095", name: "Schoharie County" },
    { code: "US.NY.097", name: "Schuyler County" },
    { code: "US.NY.099", name: "Seneca County" },
    { code: "US.NY.101", name: "Steuben County" },
    { code: "US.NY.103", name: "Suffolk County" },
    { code: "US.NY.105", name: "Sullivan County" },
    { code: "US.NY.107", name: "Tioga County" },
    { code: "US.NY.109", name: "Tompkins County" },
    { code: "US.NY.111", name: "Ulster County" },
    { code: "US.NY.113", name: "Warren County" },
    { code: "US.NY.115", name: "Washington County" },
    { code: "US.NY.117", name: "Wayne County" },
    { code: "US.NY.119", name: "Westchester County" },
    { code: "US.NY.121", name: "Wyoming County" },
    { code: "US.NY.123", name: "Yates County" },
  ],
  "US.OH": [
    { code: "US.OH.001", name: "Adams County" },
    { code: "US.OH.003", name: "Allen County" },
    { code: "US.OH.005", name: "Ashland County" },
    { code: "US.OH.007", name: "Ashtabula County" },
    { code: "US.OH.009", name: "Athens County" },
    { code: "US.OH.011", name: "Auglaize County" },
    { code: "US.OH.013", name: "Belmont County" },
    { code: "US.OH.015", name: "Brown County" },
    { code: "US.OH.017", name: "Butler County" },
    { code: "US.OH.019", name: "Carroll County" },
    { code: "US.OH.021", name: "Champaign County" },
    { code: "US.OH.023", name: "Clark County" },
    { code: "US.OH.025", name: "Clermont County" },
    { code: "US.OH.027", name: "Clinton County" },
    { code: "US.OH.029", name: "Columbiana County" },
    { code: "US.OH.031", name: "Coshocton County" },
    { code: "US.OH.033", name: "Crawford County" },
    { code: "US.OH.035", name: "Cuyahoga County" },
    { code: "US.OH.037", name: "Darke County" },
    { code: "US.OH.039", name: "Defiance County" },
    { code: "US.OH.041", name: "Delaware County" },
    { code: "US.OH.043", name: "Erie County" },
    { code: "US.OH.045", name: "Fairfield County" },
    { code: "US.OH.047", name: "Fayette County" },
    { code: "US.OH.049", name: "Franklin County" },
    { code: "US.OH.051", name: "Fulton County" },
    { code: "US.OH.053", name: "Gallia County" },
    { code: "US.OH.055", name: "Geauga County" },
    { code: "US.OH.057", name: "Greene County" },
    { code: "US.OH.059", name: "Guernsey County" },
    { code: "US.OH.061", name: "Hamilton County" },
    { code: "US.OH.063", name: "Hancock County" },
    { code: "US.OH.065", name: "Hardin County" },
    { code: "US.OH.067", name: "Harrison County" },
    { code: "US.OH.069", name: "Henry County" },
    { code: "US.OH.071", name: "Highland County" },
    { code: "US.OH.073", name: "Hocking County" },
    { code: "US.OH.075", name: "Holmes County" },
    { code: "US.OH.077", name: "Huron County" },
    { code: "US.OH.079", name: "Jackson County" },
    { code: "US.OH.081", name: "Jefferson County" },
    { code: "US.OH.083", name: "Knox County" },
    { code: "US.OH.085", name: "Lake County" },
    { code: "US.OH.087", name: "Lawrence County" },
    { code: "US.OH.089", name: "Licking County" },
    { code: "US.OH.091", name: "Logan County" },
    { code: "US.OH.093", name: "Lorain County" },
    { code: "US.OH.095", name: "Lucas County" },
    { code: "US.OH.097", name: "Madison County" },
    { code: "US.OH.099", name: "Mahoning County" },
    { code: "US.OH.101", name: "Marion County" },
    { code: "US.OH.103", name: "Medina County" },
    { code: "US.OH.105", name: "Meigs County" },
    { code: "US.OH.107", name: "Mercer County" },
    { code: "US.OH.109", name: "Miami County" },
    { code: "US.OH.111", name: "Monroe County" },
    { code: "US.OH.113", name: "Montgomery County" },
    { code: "US.OH.115", name: "Morgan County" },
    { code: "US.OH.117", name: "Morrow County" },
    { code: "US.OH.119", name: "Muskingum County" },
    { code: "US.OH.121", name: "Noble County" },
    { code: "US.OH.123", name: "Ottawa County" },
    { code: "US.OH.125", name: "Paulding County" },
    { code: "US.OH.127", name: "Perry County" },
    { code: "US.OH.129", name: "Pickaway County" },
    { code: "US.OH.131", name: "Pike County" },
    { code: "US.OH.133", name: "Portage County" },
    { code: "US.OH.135", name: "Preble County" },
    { code: "US.OH.137", name: "Putnam County" },
    { code: "US.OH.139", name: "Richland County" },
    { code: "US.OH.141", name: "Ross County" },
    { code: "US.OH.143", name: "Sandusky County" },
    { code: "US.OH.145", name: "Scioto County" },
    { code: "US.OH.147", name: "Seneca County" },
    { code: "US.OH.149", name: "Shelby County" },
    { code: "US.OH.151", name: "Stark County" },
    { code: "US.OH.153", name: "Summit County" },
    { code: "US.OH.155", name: "Trumbull County" },
    { code: "US.OH.157", name: "Tuscarawas County" },
    { code: "US.OH.159", name: "Union County" },
    { code: "US.OH.161", name: "Van Wert County" },
    { code: "US.OH.163", name: "Vinton County" },
    { code: "US.OH.165", name: "Warren County" },
    { code: "US.OH.167", name: "Washington County" },
    { code: "US.OH.169", name: "Wayne County" },
    { code: "US.OH.171", name: "Williams County" },
    { code: "US.OH.173", name: "Wood County" },
    { code: "US.OH.175", name: "Wyandot County" },
  ],
  "US.OK": [
    { code: "US.OK.001", name: "Adair County" },
    { code: "US.OK.003", name: "Alfalfa County" },
    { code: "US.OK.005", name: "Atoka County" },
    { code: "US.OK.007", name: "Beaver County" },
    { code: "US.OK.009", name: "Beckham County" },
    { code: "US.OK.011", name: "Blaine County" },
    { code: "US.OK.013", name: "Bryan County" },
    { code: "US.OK.015", name: "Caddo County" },
    { code: "US.OK.017", name: "Canadian County" },
    { code: "US.OK.019", name: "Carter County" },
    { code: "US.OK.021", name: "Cherokee County" },
    { code: "US.OK.023", name: "Choctaw County" },
    { code: "US.OK.025", name: "Cimarron County" },
    { code: "US.OK.027", name: "Cleveland County" },
    { code: "US.OK.029", name: "Coal County" },
    { code: "US.OK.031", name: "Comanche County" },
    { code: "US.OK.033", name: "Cotton County" },
    { code: "US.OK.035", name: "Craig County" },
    { code: "US.OK.037", name: "Creek County" },
    { code: "US.OK.039", name: "Custer County" },
    { code: "US.OK.041", name: "Delaware County" },
    { code: "US.OK.043", name: "Dewey County" },
    { code: "US.OK.045", name: "Ellis County" },
    { code: "US.OK.047", name: "Garfield County" },
    { code: "US.OK.049", name: "Garvin County" },
    { code: "US.OK.051", name: "Grady County" },
    { code: "US.OK.053", name: "Grant County" },
    { code: "US.OK.055", name: "Greer County" },
    { code: "US.OK.057", name: "Harmon County" },
    { code: "US.OK.059", name: "Harper County" },
    { code: "US.OK.061", name: "Haskell County" },
    { code: "US.OK.063", name: "Hughes County" },
    { code: "US.OK.065", name: "Jackson County" },
    { code: "US.OK.067", name: "Jefferson County" },
    { code: "US.OK.069", name: "Johnston County" },
    { code: "US.OK.071", name: "Kay County" },
    { code: "US.OK.073", name: "Kingfisher County" },
    { code: "US.OK.075", name: "Kiowa County" },
    { code: "US.OK.077", name: "Latimer County" },
    { code: "US.OK.079", name: "Le Flore County" },
    { code: "US.OK.081", name: "Lincoln County" },
    { code: "US.OK.083", name: "Logan County" },
    { code: "US.OK.085", name: "Love County" },
    { code: "US.OK.087", name: "McClain County" },
    { code: "US.OK.089", name: "McCurtain County" },
    { code: "US.OK.091", name: "McIntosh County" },
    { code: "US.OK.093", name: "Major County" },
    { code: "US.OK.095", name: "Marshall County" },
    { code: "US.OK.097", name: "Mayes County" },
    { code: "US.OK.099", name: "Murray County" },
    { code: "US.OK.101", name: "Muskogee County" },
    { code: "US.OK.103", name: "Noble County" },
    { code: "US.OK.105", name: "Nowata County" },
    { code: "US.OK.107", name: "Okfuskee County" },
    { code: "US.OK.109", name: "Oklahoma County" },
    { code: "US.OK.111", name: "Okmulgee County" },
    { code: "US.OK.113", name: "Osage County" },
    { code: "US.OK.115", name: "Ottawa County" },
    { code: "US.OK.117", name: "Pawnee County" },
    { code: "US.OK.119", name: "Payne County" },
    { code: "US.OK.121", name: "Pittsburg County" },
    { code: "US.OK.123", name: "Pontotoc County" },
    { code: "US.OK.125", name: "Pottawatomie County" },
    { code: "US.OK.127", name: "Pushmataha County" },
    { code: "US.OK.129", name: "Roger Mills County" },
    { code: "US.OK.131", name: "Rogers County" },
    { code: "US.OK.133", name: "Seminole County" },
    { code: "US.OK.135", name: "Sequoyah County" },
    { code: "US.OK.137", name: "Stephens County" },
    { code: "US.OK.139", name: "Texas County" },
    { code: "US.OK.141", name: "Tillman County" },
    { code: "US.OK.143", name: "Tulsa County" },
    { code: "US.OK.145", name: "Wagoner County" },
    { code: "US.OK.147", name: "Washington County" },
    { code: "US.OK.149", name: "Washita County" },
    { code: "US.OK.151", name: "Woods County" },
    { code: "US.OK.153", name: "Woodward County" },
  ],
  "US.OR": [
    { code: "US.OR.001", name: "Baker County" },
    { code: "US.OR.003", name: "Benton County" },
    { code: "US.OR.005", name: "Clackamas County" },
    { code: "US.OR.007", name: "Clatsop County" },
    { code: "US.OR.009", name: "Columbia County" },
    { code: "US.OR.011", name: "Coos County" },
    { code: "US.OR.013", name: "Crook County" },
    { code: "US.OR.015", name: "Curry County" },
    { code: "US.OR.017", name: "Deschutes County" },
    { code: "US.OR.019", name: "Douglas County" },
    { code: "US.OR.021", name: "Gilliam County" },
    { code: "US.OR.023", name: "Grant County" },
    { code: "US.OR.025", name: "Harney County" },
    { code: "US.OR.027", name: "Hood River County" },
    { code: "US.OR.029", name: "Jackson County" },
    { code: "US.OR.031", name: "Jefferson County" },
    { code: "US.OR.033", name: "Josephine County" },
    { code: "US.OR.035", name: "Klamath County" },
    { code: "US.OR.037", name: "Lake County" },
    { code: "US.OR.039", name: "Lane County" },
    { code: "US.OR.041", name: "Lincoln County" },
    { code: "US.OR.043", name: "Linn County" },
    { code: "US.OR.045", name: "Malheur County" },
    { code: "US.OR.047", name: "Marion County" },
    { code: "US.OR.049", name: "Morrow County" },
    { code: "US.OR.051", name: "Multnomah County" },
    { code: "US.OR.053", name: "Polk County" },
    { code: "US.OR.055", name: "Sherman County" },
    { code: "US.OR.057", name: "Tillamook County" },
    { code: "US.OR.059", name: "Umatilla County" },
    { code: "US.OR.061", name: "Union County" },
    { code: "US.OR.063", name: "Wallowa County" },
    { code: "US.OR.065", name: "Wasco County" },
    { code: "US.OR.067", name: "Washington County" },
    { code: "US.OR.069", name: "Wheeler County" },
    { code: "US.OR.071", name: "Yamhill County" },
  ],
  "US.PA": [
    { code: "US.PA.001", name: "Adams County" },
    { code: "US.PA.003", name: "Allegheny County" },
    { code: "US.PA.005", name: "Armstrong County" },
    { code: "US.PA.007", name: "Beaver County" },
    { code: "US.PA.009", name: "Bedford County" },
    { code: "US.PA.011", name: "Berks County" },
    { code: "US.PA.013", name: "Blair County" },
    { code: "US.PA.015", name: "Bradford County" },
    { code: "US.PA.017", name: "Bucks County" },
    { code: "US.PA.019", name: "Butler County" },
    { code: "US.PA.021", name: "Cambria County" },
    { code: "US.PA.023", name: "Cameron County" },
    { code: "US.PA.025", name: "Carbon County" },
    { code: "US.PA.027", name: "Centre County" },
    { code: "US.PA.029", name: "Chester County" },
    { code: "US.PA.031", name: "Clarion County" },
    { code: "US.PA.033", name: "Clearfield County" },
    { code: "US.PA.035", name: "Clinton County" },
    { code: "US.PA.037", name: "Columbia County" },
    { code: "US.PA.039", name: "Crawford County" },
    { code: "US.PA.041", name: "Cumberland County" },
    { code: "US.PA.043", name: "Dauphin County" },
    { code: "US.PA.045", name: "Delaware County" },
    { code: "US.PA.047", name: "Elk County" },
    { code: "US.PA.049", name: "Erie County" },
    { code: "US.PA.051", name: "Fayette County" },
    { code: "US.PA.053", name: "Forest County" },
    { code: "US.PA.055", name: "Franklin County" },
    { code: "US.PA.057", name: "Fulton County" },
    { code: "US.PA.059", name: "Greene County" },
    { code: "US.PA.061", name: "Huntingdon County" },
    { code: "US.PA.063", name: "Indiana County" },
    { code: "US.PA.065", name: "Jefferson County" },
    { code: "US.PA.067", name: "Juniata County" },
    { code: "US.PA.069", name: "Lackawanna County" },
    { code: "US.PA.071", name: "Lancaster County" },
    { code: "US.PA.073", name: "Lawrence County" },
    { code: "US.PA.075", name: "Lebanon County" },
    { code: "US.PA.077", name: "Lehigh County" },
    { code: "US.PA.079", name: "Luzerne County" },
    { code: "US.PA.081", name: "Lycoming County" },
    { code: "US.PA.083", name: "McKean County" },
    { code: "US.PA.085", name: "Mercer County" },
    { code: "US.PA.087", name: "Mifflin County" },
    { code: "US.PA.089", name: "Monroe County" },
    { code: "US.PA.091", name: "Montgomery County" },
    { code: "US.PA.093", name: "Montour County" },
    { code: "US.PA.095", name: "Northampton County" },
    { code: "US.PA.097", name: "Northumberland County" },
    { code: "US.PA.099", name: "Perry County" },
    { code: "US.PA.101", name: "Philadelphia County" },
    { code: "US.PA.103", name: "Pike County" },
    { code: "US.PA.105", name: "Potter County" },
    { code: "US.PA.107", name: "Schuylkill County" },
    { code: "US.PA.109", name: "Snyder County" },
    { code: "US.PA.111", name: "Somerset County" },
    { code: "US.PA.113", name: "Sullivan County" },
    { code: "US.PA.115", name: "Susquehanna County" },
    { code: "US.PA.117", name: "Tioga County" },
    { code: "US.PA.119", name: "Union County" },
    { code: "US.PA.121", name: "Venango County" },
    { code: "US.PA.123", name: "Warren County" },
    { code: "US.PA.125", name: "Washington County" },
    { code: "US.PA.127", name: "Wayne County" },
    { code: "US.PA.129", name: "Westmoreland County" },
    { code: "US.PA.131", name: "Wyoming County" },
    { code: "US.PA.133", name: "York County" },
  ],
  "US.RI": [
    { code: "US.RI.001", name: "Bristol County" },
    { code: "US.RI.003", name: "Kent County" },
    { code: "US.RI.005", name: "Newport County" },
    { code: "US.RI.007", name: "Providence County" },
    { code: "US.RI.009", name: "Washington County" },
  ],
  "US.SC": [
    { code: "US.SC.001", name: "Abbeville County" },
    { code: "US.SC.003", name: "Aiken County" },
    { code: "US.SC.005", name: "Allendale County" },
    { code: "US.SC.007", name: "Anderson County" },
    { code: "US.SC.009", name: "Bamberg County" },
    { code: "US.SC.011", name: "Barnwell County" },
    { code: "US.SC.013", name: "Beaufort County" },
    { code: "US.SC.015", name: "Berkeley County" },
    { code: "US.SC.017", name: "Calhoun County" },
    { code: "US.SC.019", name: "Charleston County" },
    { code: "US.SC.021", name: "Cherokee County" },
    { code: "US.SC.023", name: "Chester County" },
    { code: "US.SC.025", name: "Chesterfield County" },
    { code: "US.SC.027", name: "Clarendon County" },
    { code: "US.SC.029", name: "Colleton County" },
    { code: "US.SC.031", name: "Darlington County" },
    { code: "US.SC.033", name: "Dillon County" },
    { code: "US.SC.035", name: "Dorchester County" },
    { code: "US.SC.037", name: "Edgefield County" },
    { code: "US.SC.039", name: "Fairfield County" },
    { code: "US.SC.041", name: "Florence County" },
    { code: "US.SC.043", name: "Georgetown County" },
    { code: "US.SC.045", name: "Greenville County" },
    { code: "US.SC.047", name: "Greenwood County" },
    { code: "US.SC.049", name: "Hampton County" },
    { code: "US.SC.051", name: "Horry County" },
    { code: "US.SC.053", name: "Jasper County" },
    { code: "US.SC.055", name: "Kershaw County" },
    { code: "US.SC.057", name: "Lancaster County" },
    { code: "US.SC.059", name: "Laurens County" },
    { code: "US.SC.061", name: "Lee County" },
    { code: "US.SC.063", name: "Lexington County" },
    { code: "US.SC.065", name: "McCormick County" },
    { code: "US.SC.067", name: "Marion County" },
    { code: "US.SC.069", name: "Marlboro County" },
    { code: "US.SC.071", name: "Newberry County" },
    { code: "US.SC.073", name: "Oconee County" },
    { code: "US.SC.075", name: "Orangeburg County" },
    { code: "US.SC.077", name: "Pickens County" },
    { code: "US.SC.079", name: "Richland County" },
    { code: "US.SC.081", name: "Saluda County" },
    { code: "US.SC.083", name: "Spartanburg County" },
    { code: "US.SC.085", name: "Sumter County" },
    { code: "US.SC.087", name: "Union County" },
    { code: "US.SC.089", name: "Williamsburg County" },
    { code: "US.SC.091", name: "York County" },
  ],
  "US.SD": [
    { code: "US.SD.003", name: "Aurora County" },
    { code: "US.SD.005", name: "Beadle County" },
    { code: "US.SD.007", name: "Bennett County" },
    { code: "US.SD.009", name: "Bon Homme County" },
    { code: "US.SD.011", name: "Brookings County" },
    { code: "US.SD.013", name: "Brown County" },
    { code: "US.SD.015", name: "Brule County" },
    { code: "US.SD.017", name: "Buffalo County" },
    { code: "US.SD.019", name: "Butte County" },
    { code: "US.SD.021", name: "Campbell County" },
    { code: "US.SD.023", name: "Charles Mix County" },
    { code: "US.SD.025", name: "Clark County" },
    { code: "US.SD.027", name: "Clay County" },
    { code: "US.SD.029", name: "Codington County" },
    { code: "US.SD.031", name: "Corson County" },
    { code: "US.SD.033", name: "Custer County" },
    { code: "US.SD.035", name: "Davison County" },
    { code: "US.SD.037", name: "Day County" },
    { code: "US.SD.039", name: "Deuel County" },
    { code: "US.SD.041", name: "Dewey County" },
    { code: "US.SD.043", name: "Douglas County" },
    { code: "US.SD.045", name: "Edmunds County" },
    { code: "US.SD.047", name: "Fall River County" },
    { code: "US.SD.049", name: "Faulk County" },
    { code: "US.SD.051", name: "Grant County" },
    { code: "US.SD.053", name: "Gregory County" },
    { code: "US.SD.055", name: "Haakon County" },
    { code: "US.SD.057", name: "Hamlin County" },
    { code: "US.SD.059", name: "Hand County" },
    { code: "US.SD.061", name: "Hanson County" },
    { code: "US.SD.063", name: "Harding County" },
    { code: "US.SD.065", name: "Hughes County" },
    { code: "US.SD.067", name: "Hutchinson County" },
    { code: "US.SD.069", name: "Hyde County" },
    { code: "US.SD.071", name: "Jackson County" },
    { code: "US.SD.073", name: "Jerauld County" },
    { code: "US.SD.075", name: "Jones County" },
    { code: "US.SD.077", name: "Kingsbury County" },
    { code: "US.SD.079", name: "Lake County" },
    { code: "US.SD.081", name: "Lawrence County" },
    { code: "US.SD.083", name: "Lincoln County" },
    { code: "US.SD.085", name: "Lyman County" },
    { code: "US.SD.087", name: "McCook County" },
    { code: "US.SD.089", name: "McPherson County" },
    { code: "US.SD.091", name: "Marshall County" },
    { code: "US.SD.093", name: "Meade County" },
    { code: "US.SD.095", name: "Mellette County" },
    { code: "US.SD.097", name: "Miner County" },
    { code: "US.SD.099", name: "Minnehaha County" },
    { code: "US.SD.101", name: "Moody County" },
    { code: "US.SD.102", name: "Oglala Lakota County" },
    { code: "US.SD.103", name: "Pennington County" },
    { code: "US.SD.105", name: "Perkins County" },
    { code: "US.SD.107", name: "Potter County" },
    { code: "US.SD.109", name: "Roberts County" },
    { code: "US.SD.111", name: "Sanborn County" },
    { code: "US.SD.115", name: "Spink County" },
    { code: "US.SD.117", name: "Stanley County" },
    { code: "US.SD.119", name: "Sully County" },
    { code: "US.SD.121", name: "Todd County" },
    { code: "US.SD.123", name: "Tripp County" },
    { code: "US.SD.125", name: "Turner County" },
    { code: "US.SD.127", name: "Union County" },
    { code: "US.SD.129", name: "Walworth County" },
    { code: "US.SD.135", name: "Yankton County" },
    { code: "US.SD.137", name: "Ziebach County" },
  ],
  "US.TN": [
    { code: "US.TN.001", name: "Anderson County" },
    { code: "US.TN.003", name: "Bedford County" },
    { code: "US.TN.005", name: "Benton County" },
    { code: "US.TN.007", name: "Bledsoe County" },
    { code: "US.TN.009", name: "Blount County" },
    { code: "US.TN.011", name: "Bradley County" },
    { code: "US.TN.013", name: "Campbell County" },
    { code: "US.TN.015", name: "Cannon County" },
    { code: "US.TN.017", name: "Carroll County" },
    { code: "US.TN.019", name: "Carter County" },
    { code: "US.TN.021", name: "Cheatham County" },
    { code: "US.TN.023", name: "Chester County" },
    { code: "US.TN.025", name: "Claiborne County" },
    { code: "US.TN.027", name: "Clay County" },
    { code: "US.TN.029", name: "Cocke County" },
    { code: "US.TN.031", name: "Coffee County" },
    { code: "US.TN.033", name: "Crockett County" },
    { code: "US.TN.035", name: "Cumberland County" },
    { code: "US.TN.037", name: "Davidson County" },
    { code: "US.TN.039", name: "Decatur County" },
    { code: "US.TN.041", name: "DeKalb County" },
    { code: "US.TN.043", name: "Dickson County" },
    { code: "US.TN.045", name: "Dyer County" },
    { code: "US.TN.047", name: "Fayette County" },
    { code: "US.TN.049", name: "Fentress County" },
    { code: "US.TN.051", name: "Franklin County" },
    { code: "US.TN.053", name: "Gibson County" },
    { code: "US.TN.055", name: "Giles County" },
    { code: "US.TN.057", name: "Grainger County" },
    { code: "US.TN.059", name: "Greene County" },
    { code: "US.TN.061", name: "Grundy County" },
    { code: "US.TN.063", name: "Hamblen County" },
    { code: "US.TN.065", name: "Hamilton County" },
    { code: "US.TN.067", name: "Hancock County" },
    { code: "US.TN.069", name: "Hardeman County" },
    { code: "US.TN.071", name: "Hardin County" },
    { code: "US.TN.073", name: "Hawkins County" },
    { code: "US.TN.075", name: "Haywood County" },
    { code: "US.TN.077", name: "Henderson County" },
    { code: "US.TN.079", name: "Henry County" },
    { code: "US.TN.081", name: "Hickman County" },
    { code: "US.TN.083", name: "Houston County" },
    { code: "US.TN.085", name: "Humphreys County" },
    { code: "US.TN.087", name: "Jackson County" },
    { code: "US.TN.089", name: "Jefferson County" },
    { code: "US.TN.091", name: "Johnson County" },
    { code: "US.TN.093", name: "Knox County" },
    { code: "US.TN.095", name: "Lake County" },
    { code: "US.TN.097", name: "Lauderdale County" },
    { code: "US.TN.099", name: "Lawrence County" },
    { code: "US.TN.101", name: "Lewis County" },
    { code: "US.TN.103", name: "Lincoln County" },
    { code: "US.TN.105", name: "Loudon County" },
    { code: "US.TN.107", name: "McMinn County" },
    { code: "US.TN.109", name: "McNairy County" },
    { code: "US.TN.111", name: "Macon County" },
    { code: "US.TN.113", name: "Madison County" },
    { code: "US.TN.115", name: "Marion County" },
    { code: "US.TN.117", name: "Marshall County" },
    { code: "US.TN.119", name: "Maury County" },
    { code: "US.TN.121", name: "Meigs County" },
    { code: "US.TN.123", name: "Monroe County" },
    { code: "US.TN.125", name: "Montgomery County" },
    { code: "US.TN.127", name: "Moore County" },
    { code: "US.TN.129", name: "Morgan County" },
    { code: "US.TN.131", name: "Obion County" },
    { code: "US.TN.133", name: "Overton County" },
    { code: "US.TN.135", name: "Perry County" },
    { code: "US.TN.137", name: "Pickett County" },
    { code: "US.TN.139", name: "Polk County" },
    { code: "US.TN.141", name: "Putnam County" },
    { code: "US.TN.143", name: "Rhea County" },
    { code: "US.TN.145", name: "Roane County" },
    { code: "US.TN.147", name: "Robertson County" },
    { code: "US.TN.149", name: "Rutherford County" },
    { code: "US.TN.151", name: "Scott County" },
    { code: "US.TN.153", name: "Sequatchie County" },
    { code: "US.TN.155", name: "Sevier County" },
    { code: "US.TN.157", name: "Shelby County" },
    { code: "US.TN.159", name: "Smith County" },
    { code: "US.TN.161", name: "Stewart County" },
    { code: "US.TN.163", name: "Sullivan County" },
    { code: "US.TN.165", name: "Sumner County" },
    { code: "US.TN.167", name: "Tipton County" },
    { code: "US.TN.169", name: "Trousdale County" },
    { code: "US.TN.171", name: "Unicoi County" },
    { code: "US.TN.173", name: "Union County" },
    { code: "US.TN.175", name: "Van Buren County" },
    { code: "US.TN.177", name: "Warren County" },
    { code: "US.TN.179", name: "Washington County" },
    { code: "US.TN.181", name: "Wayne County" },
    { code: "US.TN.183", name: "Weakley County" },
    { code: "US.TN.185", name: "White County" },
    { code: "US.TN.187", name: "Williamson County" },
    { code: "US.TN.189", name: "Wilson County" },
  ],
  "US.TX": [
    { code: "US.TX.001", name: "Anderson County" },
    { code: "US.TX.003", name: "Andrews County" },
    { code: "US.TX.005", name: "Angelina County" },
    { code: "US.TX.007", name: "Aransas County" },
    { code: "US.TX.009", name: "Archer County" },
    { code: "US.TX.011", name: "Armstrong County" },
    { code: "US.TX.013", name: "Atascosa County" },
    { code: "US.TX.015", name: "Austin County" },
    { code: "US.TX.017", name: "Bailey County" },
    { code: "US.TX.019", name: "Bandera County" },
    { code: "US.TX.021", name: "Bastrop County" },
    { code: "US.TX.023", name: "Baylor County" },
    { code: "US.TX.025", name: "Bee County" },
    { code: "US.TX.027", name: "Bell County" },
    { code: "US.TX.029", name: "Bexar County" },
    { code: "US.TX.031", name: "Blanco County" },
    { code: "US.TX.033", name: "Borden County" },
    { code: "US.TX.035", name: "Bosque County" },
    { code: "US.TX.037", name: "Bowie County" },
    { code: "US.TX.039", name: "Brazoria County" },
    { code: "US.TX.041", name: "Brazos County" },
    { code: "US.TX.043", name: "Brewster County" },
    { code: "US.TX.045", name: "Briscoe County" },
    { code: "US.TX.047", name: "Brooks County" },
    { code: "US.TX.049", name: "Brown County" },
    { code: "US.TX.051", name: "Burleson County" },
    { code: "US.TX.053", name: "Burnet County" },
    { code: "US.TX.055", name: "Caldwell County" },
    { code: "US.TX.057", name: "Calhoun County" },
    { code: "US.TX.059", name: "Callahan County" },
    { code: "US.TX.061", name: "Cameron County" },
    { code: "US.TX.063", name: "Camp County" },
    { code: "US.TX.065", name: "Carson County" },
    { code: "US.TX.067", name: "Cass County" },
    { code: "US.TX.069", name: "Castro County" },
    { code: "US.TX.071", name: "Chambers County" },
    { code: "US.TX.073", name: "Cherokee County" },
    { code: "US.TX.075", name: "Childress County" },
    { code: "US.TX.077", name: "Clay County" },
    { code: "US.TX.079", name: "Cochran County" },
    { code: "US.TX.081", name: "Coke County" },
    { code: "US.TX.083", name: "Coleman County" },
    { code: "US.TX.085", name: "Collin County" },
    { code: "US.TX.087", name: "Collingsworth County" },
    { code: "US.TX.089", name: "Colorado County" },
    { code: "US.TX.091", name: "Comal County" },
    { code: "US.TX.093", name: "Comanche County" },
    { code: "US.TX.095", name: "Concho County" },
    { code: "US.TX.097", name: "Cooke County" },
    { code: "US.TX.099", name: "Coryell County" },
    { code: "US.TX.101", name: "Cottle County" },
    { code: "US.TX.103", name: "Crane County" },
    { code: "US.TX.105", name: "Crockett County" },
    { code: "US.TX.107", name: "Crosby County" },
    { code: "US.TX.109", name: "Culberson County" },
    { code: "US.TX.111", name: "Dallam County" },
    { code: "US.TX.113", name: "Dallas County" },
    { code: "US.TX.115", name: "Dawson County" },
    { code: "US.TX.117", name: "Deaf Smith County" },
    { code: "US.TX.119", name: "Delta County" },
    { code: "US.TX.121", name: "Denton County" },
    { code: "US.TX.123", name: "DeWitt County" },
    { code: "US.TX.125", name: "Dickens County" },
    { code: "US.TX.127", name: "Dimmit County" },
    { code: "US.TX.129", name: "Donley County" },
    { code: "US.TX.131", name: "Duval County" },
    { code: "US.TX.133", name: "Eastland County" },
    { code: "US.TX.135", name: "Ector County" },
    { code: "US.TX.137", name: "Edwards County" },
    { code: "US.TX.139", name: "Ellis County" },
    { code: "US.TX.141", name: "El Paso County" },
    { code: "US.TX.143", name: "Erath County" },
    { code: "US.TX.145", name: "Falls County" },
    { code: "US.TX.147", name: "Fannin County" },
    { code: "US.TX.149", name: "Fayette County" },
    { code: "US.TX.151", name: "Fisher County" },
    { code: "US.TX.153", name: "Floyd County" },
    { code: "US.TX.155", name: "Foard County" },
    { code: "US.TX.157", name: "Fort Bend County" },
    { code: "US.TX.159", name: "Franklin County" },
    { code: "US.TX.161", name: "Freestone County" },
    { code: "US.TX.163", name: "Frio County" },
    { code: "US.TX.165", name: "Gaines County" },
    { code: "US.TX.167", name: "Galveston County" },
    { code: "US.TX.169", name: "Garza County" },
    { code: "US.TX.171", name: "Gillespie County" },
    { code: "US.TX.173", name: "Glasscock County" },
    { code: "US.TX.175", name: "Goliad County" },
    { code: "US.TX.177", name: "Gonzales County" },
    { code: "US.TX.179", name: "Gray County" },
    { code: "US.TX.181", name: "Grayson County" },
    { code: "US.TX.183", name: "Gregg County" },
    { code: "US.TX.185", name: "Grimes County" },
    { code: "US.TX.187", name: "Guadalupe County" },
    { code: "US.TX.189", name: "Hale County" },
    { code: "US.TX.191", name: "Hall County" },
    { code: "US.TX.193", name: "Hamilton County" },
    { code: "US.TX.195", name: "Hansford County" },
    { code: "US.TX.197", name: "Hardeman County" },
    { code: "US.TX.199", name: "Hardin County" },
    { code: "US.TX.201", name: "Harris County" },
    { code: "US.TX.203", name: "Harrison County" },
    { code: "US.TX.205", name: "Hartley County" },
    { code: "US.TX.207", name: "Haskell County" },
    { code: "US.TX.209", name: "Hays County" },
    { code: "US.TX.211", name: "Hemphill County" },
    { code: "US.TX.213", name: "Henderson County" },
    { code: "US.TX.215", name: "Hidalgo County" },
    { code: "US.TX.217", name: "Hill County" },
    { code: "US.TX.219", name: "Hockley County" },
    { code: "US.TX.221", name: "Hood County" },
    { code: "US.TX.223", name: "Hopkins County" },
    { code: "US.TX.225", name: "Houston County" },
    { code: "US.TX.227", name: "Howard County" },
    { code: "US.TX.229", name: "Hudspeth County" },
    { code: "US.TX.231", name: "Hunt County" },
    { code: "US.TX.233", name: "Hutchinson County" },
    { code: "US.TX.235", name: "Irion County" },
    { code: "US.TX.237", name: "Jack County" },
    { code: "US.TX.239", name: "Jackson County" },
    { code: "US.TX.241", name: "Jasper County" },
    { code: "US.TX.243", name: "Jeff Davis County" },
    { code: "US.TX.245", name: "Jefferson County" },
    { code: "US.TX.247", name: "Jim Hogg County" },
    { code: "US.TX.249", name: "Jim Wells County" },
    { code: "US.TX.251", name: "Johnson County" },
    { code: "US.TX.253", name: "Jones County" },
    { code: "US.TX.255", name: "Karnes County" },
    { code: "US.TX.257", name: "Kaufman County" },
    { code: "US.TX.259", name: "Kendall County" },
    { code: "US.TX.261", name: "Kenedy County" },
    { code: "US.TX.263", name: "Kent County" },
    { code: "US.TX.265", name: "Kerr County" },
    { code: "US.TX.267", name: "Kimble County" },
    { code: "US.TX.269", name: "King County" },
    { code: "US.TX.271", name: "Kinney County" },
    { code: "US.TX.273", name: "Kleberg County" },
    { code: "US.TX.275", name: "Knox County" },
    { code: "US.TX.277", name: "Lamar County" },
    { code: "US.TX.279", name: "Lamb County" },
    { code: "US.TX.281", name: "Lampasas County" },
    { code: "US.TX.283", name: "La Salle County" },
    { code: "US.TX.285", name: "Lavaca County" },
    { code: "US.TX.287", name: "Lee County" },
    { code: "US.TX.289", name: "Leon County" },
    { code: "US.TX.291", name: "Liberty County" },
    { code: "US.TX.293", name: "Limestone County" },
    { code: "US.TX.295", name: "Lipscomb County" },
    { code: "US.TX.297", name: "Live Oak County" },
    { code: "US.TX.299", name: "Llano County" },
    { code: "US.TX.301", name: "Loving County" },
    { code: "US.TX.303", name: "Lubbock County" },
    { code: "US.TX.305", name: "Lynn County" },
    { code: "US.TX.307", name: "McCulloch County" },
    { code: "US.TX.309", name: "McLennan County" },
    { code: "US.TX.311", name: "McMullen County" },
    { code: "US.TX.313", name: "Madison County" },
    { code: "US.TX.315", name: "Marion County" },
    { code: "US.TX.317", name: "Martin County" },
    { code: "US.TX.319", name: "Mason County" },
    { code: "US.TX.321", name: "Matagorda County" },
    { code: "US.TX.323", name: "Maverick County" },
    { code: "US.TX.325", name: "Medina County" },
    { code: "US.TX.327", name: "Menard County" },
    { code: "US.TX.329", name: "Midland County" },
    { code: "US.TX.331", name: "Milam County" },
    { code: "US.TX.333", name: "Mills County" },
    { code: "US.TX.335", name: "Mitchell County" },
    { code: "US.TX.337", name: "Montague County" },
    { code: "US.TX.339", name: "Montgomery County" },
    { code: "US.TX.341", name: "Moore County" },
    { code: "US.TX.343", name: "Morris County" },
    { code: "US.TX.345", name: "Motley County" },
    { code: "US.TX.347", name: "Nacogdoches County" },
    { code: "US.TX.349", name: "Navarro County" },
    { code: "US.TX.351", name: "Newton County" },
    { code: "US.TX.353", name: "Nolan County" },
    { code: "US.TX.355", name: "Nueces County" },
    { code: "US.TX.357", name: "Ochiltree County" },
    { code: "US.TX.359", name: "Oldham County" },
    { code: "US.TX.361", name: "Orange County" },
    { code: "US.TX.363", name: "Palo Pinto County" },
    { code: "US.TX.365", name: "Panola County" },
    { code: "US.TX.367", name: "Parker County" },
    { code: "US.TX.369", name: "Parmer County" },
    { code: "US.TX.371", name: "Pecos County" },
    { code: "US.TX.373", name: "Polk County" },
    { code: "US.TX.375", name: "Potter County" },
    { code: "US.TX.377", name: "Presidio County" },
    { code: "US.TX.379", name: "Rains County" },
    { code: "US.TX.381", name: "Randall County" },
    { code: "US.TX.383", name: "Reagan County" },
    { code: "US.TX.385", name: "Real County" },
    { code: "US.TX.387", name: "Red River County" },
    { code: "US.TX.389", name: "Reeves County" },
    { code: "US.TX.391", name: "Refugio County" },
    { code: "US.TX.393", name: "Roberts County" },
    { code: "US.TX.395", name: "Robertson County" },
    { code: "US.TX.397", name: "Rockwall County" },
    { code: "US.TX.399", name: "Runnels County" },
    { code: "US.TX.401", name: "Rusk County" },
    { code: "US.TX.403", name: "Sabine County" },
    { code: "US.TX.405", name: "San Augustine County" },
    { code: "US.TX.407", name: "San Jacinto County" },
    { code: "US.TX.409", name: "San Patricio County" },
    { code: "US.TX.411", name: "San Saba County" },
    { code: "US.TX.413", name: "Schleicher County" },
    { code: "US.TX.415", name: "Scurry County" },
    { code: "US.TX.417", name: "Shackelford County" },
    { code: "US.TX.419", name: "Shelby County" },
    { code: "US.TX.421", name: "Sherman County" },
    { code: "US.TX.423", name: "Smith County" },
    { code: "US.TX.425", name: "Somervell County" },
    { code: "US.TX.427", name: "Starr County" },
    { code: "US.TX.429", name: "Stephens County" },
    { code: "US.TX.431", name: "Sterling County" },
    { code: "US.TX.433", name: "Stonewall County" },
    { code: "US.TX.435", name: "Sutton County" },
    { code: "US.TX.437", name: "Swisher County" },
    { code: "US.TX.439", name: "Tarrant County" },
    { code: "US.TX.441", name: "Taylor County" },
    { code: "US.TX.443", name: "Terrell County" },
    { code: "US.TX.445", name: "Terry County" },
    { code: "US.TX.447", name: "Throckmorton County" },
    { code: "US.TX.449", name: "Titus County" },
    { code: "US.TX.451", name: "Tom Green County" },
    { code: "US.TX.453", name: "Travis County" },
    { code: "US.TX.455", name: "Trinity County" },
    { code: "US.TX.457", name: "Tyler County" },
    { code: "US.TX.459", name: "Upshur County" },
    { code: "US.TX.461", name: "Upton County" },
    { code: "US.TX.463", name: "Uvalde County" },
    { code: "US.TX.465", name: "Val Verde County" },
    { code: "US.TX.467", name: "Van Zandt County" },
    { code: "US.TX.469", name: "Victoria County" },
    { code: "US.TX.471", name: "Walker County" },
    { code: "US.TX.473", name: "Waller County" },
    { code: "US.TX.475", name: "Ward County" },
    { code: "US.TX.477", name: "Washington County" },
    { code: "US.TX.479", name: "Webb County" },
    { code: "US.TX.481", name: "Wharton County" },
    { code: "US.TX.483", name: "Wheeler County" },
    { code: "US.TX.485", name: "Wichita County" },
    { code: "US.TX.487", name: "Wilbarger County" },
    { code: "US.TX.489", name: "Willacy County" },
    { code: "US.TX.491", name: "Williamson County" },
    { code: "US.TX.493", name: "Wilson County" },
    { code: "US.TX.495", name: "Winkler County" },
    { code: "US.TX.497", name: "Wise County" },
    { code: "US.TX.499", name: "Wood County" },
    { code: "US.TX.501", name: "Yoakum County" },
    { code: "US.TX.503", name: "Young County" },
    { code: "US.TX.505", name: "Zapata County" },
    { code: "US.TX.507", name: "Zavala County" },
  ],
  "US.UT": [
    { code: "US.UT.001", name: "Beaver County" },
    { code: "US.UT.003", name: "Box Elder County" },
    { code: "US.UT.005", name: "Cache County" },
    { code: "US.UT.007", name: "Carbon County" },
    { code: "US.UT.009", name: "Daggett County" },
    { code: "US.UT.011", name: "Davis County" },
    { code: "US.UT.013", name: "Duchesne County" },
    { code: "US.UT.015", name: "Emery County" },
    { code: "US.UT.017", name: "Garfield County" },
    { code: "US.UT.019", name: "Grand County" },
    { code: "US.UT.021", name: "Iron County" },
    { code: "US.UT.023", name: "Juab County" },
    { code: "US.UT.025", name: "Kane County" },
    { code: "US.UT.027", name: "Millard County" },
    { code: "US.UT.029", name: "Morgan County" },
    { code: "US.UT.031", name: "Piute County" },
    { code: "US.UT.033", name: "Rich County" },
    { code: "US.UT.035", name: "Salt Lake County" },
    { code: "US.UT.037", name: "San Juan County" },
    { code: "US.UT.039", name: "Sanpete County" },
    { code: "US.UT.041", name: "Sevier County" },
    { code: "US.UT.043", name: "Summit County" },
    { code: "US.UT.045", name: "Tooele County" },
    { code: "US.UT.047", name: "Uintah County" },
    { code: "US.UT.049", name: "Utah County" },
    { code: "US.UT.051", name: "Wasatch County" },
    { code: "US.UT.053", name: "Washington County" },
    { code: "US.UT.055", name: "Wayne County" },
    { code: "US.UT.057", name: "Weber County" },
  ],
  "US.VA": [
    { code: "US.VA.001", name: "Accomack County" },
    { code: "US.VA.003", name: "Albemarle County" },
    { code: "US.VA.005", name: "Alleghany County" },
    { code: "US.VA.007", name: "Amelia County" },
    { code: "US.VA.009", name: "Amherst County" },
    { code: "US.VA.011", name: "Appomattox County" },
    { code: "US.VA.013", name: "Arlington County" },
    { code: "US.VA.015", name: "Augusta County" },
    { code: "US.VA.017", name: "Bath County" },
    { code: "US.VA.019", name: "Bedford County" },
    { code: "US.VA.021", name: "Bland County" },
    { code: "US.VA.023", name: "Botetourt County" },
    { code: "US.VA.025", name: "Brunswick County" },
    { code: "US.VA.027", name: "Buchanan County" },
    { code: "US.VA.029", name: "Buckingham County" },
    { code: "US.VA.031", name: "Campbell County" },
    { code: "US.VA.033", name: "Caroline County" },
    { code: "US.VA.035", name: "Carroll County" },
    { code: "US.VA.036", name: "Charles City County" },
    { code: "US.VA.037", name: "Charlotte County" },
    { code: "US.VA.041", name: "Chesterfield County" },
    { code: "US.VA.043", name: "Clarke County" },
    { code: "US.VA.045", name: "Craig County" },
    { code: "US.VA.047", name: "Culpeper County" },
    { code: "US.VA.049", name: "Cumberland County" },
    { code: "US.VA.051", name: "Dickenson County" },
    { code: "US.VA.053", name: "Dinwiddie County" },
    { code: "US.VA.057", name: "Essex County" },
    { code: "US.VA.059", name: "Fairfax County" },
    { code: "US.VA.061", name: "Fauquier County" },
    { code: "US.VA.063", name: "Floyd County" },
    { code: "US.VA.065", name: "Fluvanna County" },
    { code: "US.VA.067", name: "Franklin County" },
    { code: "US.VA.069", name: "Frederick County" },
    { code: "US.VA.071", name: "Giles County" },
    { code: "US.VA.073", name: "Gloucester County" },
    { code: "US.VA.075", name: "Goochland County" },
    { code: "US.VA.077", name: "Grayson County" },
    { code: "US.VA.079", name: "Greene County" },
    { code: "US.VA.081", name: "Greensville County" },
    { code: "US.VA.083", name: "Halifax County" },
    { code: "US.VA.085", name: "Hanover County" },
    { code: "US.VA.087", name: "Henrico County" },
    { code: "US.VA.089", name: "Henry County" },
    { code: "US.VA.091", name: "Highland County" },
    { code: "US.VA.093", name: "Isle of Wight County" },
    { code: "US.VA.095", name: "James City County" },
    { code: "US.VA.097", name: "King and Queen County" },
    { code: "US.VA.099", name: "King George County" },
    { code: "US.VA.101", name: "King William County" },
    { code: "US.VA.103", name: "Lancaster County" },
    { code: "US.VA.105", name: "Lee County" },
    { code: "US.VA.107", name: "Loudoun County" },
    { code: "US.VA.109", name: "Louisa County" },
    { code: "US.VA.111", name: "Lunenburg County" },
    { code: "US.VA.113", name: "Madison County" },
    { code: "US.VA.115", name: "Mathews County" },
    { code: "US.VA.117", name: "Mecklenburg County" },
    { code: "US.VA.119", name: "Middlesex County" },
    { code: "US.VA.121", name: "Montgomery County" },
    { code: "US.VA.125", name: "Nelson County" },
    { code: "US.VA.127", name: "New Kent County" },
    { code: "US.VA.131", name: "Northampton County" },
    { code: "US.VA.133", name: "Northumberland County" },
    { code: "US.VA.135", name: "Nottoway County" },
    { code: "US.VA.137", name: "Orange County" },
    { code: "US.VA.139", name: "Page County" },
    { code: "US.VA.141", name: "Patrick County" },
    { code: "US.VA.143", name: "Pittsylvania County" },
    { code: "US.VA.145", name: "Powhatan County" },
    { code: "US.VA.147", name: "Prince Edward County" },
    { code: "US.VA.149", name: "Prince George County" },
    { code: "US.VA.153", name: "Prince William County" },
    { code: "US.VA.155", name: "Pulaski County" },
    { code: "US.VA.157", name: "Rappahannock County" },
    { code: "US.VA.159", name: "Richmond County" },
    { code: "US.VA.161", name: "Roanoke County" },
    { code: "US.VA.163", name: "Rockbridge County" },
    { code: "US.VA.165", name: "Rockingham County" },
    { code: "US.VA.167", name: "Russell County" },
    { code: "US.VA.169", name: "Scott County" },
    { code: "US.VA.171", name: "Shenandoah County" },
    { code: "US.VA.173", name: "Smyth County" },
    { code: "US.VA.175", name: "Southampton County" },
    { code: "US.VA.177", name: "Spotsylvania County" },
    { code: "US.VA.179", name: "Stafford County" },
    { code: "US.VA.181", name: "Surry County" },
    { code: "US.VA.183", name: "Sussex County" },
    { code: "US.VA.185", name: "Tazewell County" },
    { code: "US.VA.187", name: "Warren County" },
    { code: "US.VA.191", name: "Washington County" },
    { code: "US.VA.193", name: "Westmoreland County" },
    { code: "US.VA.195", name: "Wise County" },
    { code: "US.VA.197", name: "Wythe County" },
    { code: "US.VA.199", name: "York County" },
    { code: "US.VA.510", name: "City of Alexandria" },
    { code: "US.VA.520", name: "City of Bristol" },
    { code: "US.VA.530", name: "City of Buena Vista" },
    { code: "US.VA.540", name: "City of Charlottesville" },
    { code: "US.VA.550", name: "City of Chesapeake" },
    { code: "US.VA.570", name: "City of Colonial Heights" },
    { code: "US.VA.580", name: "City of Covington" },
    { code: "US.VA.590", name: "City of Danville" },
    { code: "US.VA.595", name: "City of Emporia" },
    { code: "US.VA.600", name: "City of Fairfax" },
    { code: "US.VA.610", name: "City of Falls Church" },
    { code: "US.VA.620", name: "City of Franklin" },
    { code: "US.VA.630", name: "City of Fredericksburg" },
    { code: "US.VA.640", name: "City of Galax" },
    { code: "US.VA.650", name: "City of Hampton" },
    { code: "US.VA.660", name: "City of Harrisonburg" },
    { code: "US.VA.670", name: "City of Hopewell" },
    { code: "US.VA.678", name: "City of Lexington" },
    { code: "US.VA.680", name: "City of Lynchburg" },
    { code: "US.VA.683", name: "City of Manassas" },
    { code: "US.VA.685", name: "City of Manassas Park" },
    { code: "US.VA.690", name: "City of Martinsville" },
    { code: "US.VA.700", name: "City of Newport News" },
    { code: "US.VA.710", name: "City of Norfolk" },
    { code: "US.VA.720", name: "City of Norton" },
    { code: "US.VA.730", name: "City of Petersburg" },
    { code: "US.VA.735", name: "City of Poquoson" },
    { code: "US.VA.740", name: "City of Portsmouth" },
    { code: "US.VA.750", name: "City of Radford" },
    { code: "US.VA.760", name: "City of Richmond" },
    { code: "US.VA.770", name: "City of Roanoke" },
    { code: "US.VA.775", name: "City of Salem" },
    { code: "US.VA.790", name: "City of Staunton" },
    { code: "US.VA.800", name: "City of Suffolk" },
    { code: "US.VA.810", name: "City of Virginia Beach" },
    { code: "US.VA.820", name: "City of Waynesboro" },
    { code: "US.VA.830", name: "City of Williamsburg" },
    { code: "US.VA.840", name: "City of Winchester" },
  ],
  "US.VT": [
    { code: "US.VT.001", name: "Addison County" },
    { code: "US.VT.003", name: "Bennington County" },
    { code: "US.VT.005", name: "Caledonia County" },
    { code: "US.VT.007", name: "Chittenden County" },
    { code: "US.VT.009", name: "Essex County" },
    { code: "US.VT.011", name: "Franklin County" },
    { code: "US.VT.013", name: "Grand Isle County" },
    { code: "US.VT.015", name: "Lamoille County" },
    { code: "US.VT.017", name: "Orange County" },
    { code: "US.VT.019", name: "Orleans County" },
    { code: "US.VT.021", name: "Rutland County" },
    { code: "US.VT.023", name: "Washington County" },
    { code: "US.VT.025", name: "Windham County" },
    { code: "US.VT.027", name: "Windsor County" },
  ],
  "US.WA": [
    { code: "US.WA.001", name: "Adams County" },
    { code: "US.WA.003", name: "Asotin County" },
    { code: "US.WA.005", name: "Benton County" },
    { code: "US.WA.007", name: "Chelan County" },
    { code: "US.WA.009", name: "Clallam County" },
    { code: "US.WA.011", name: "Clark County" },
    { code: "US.WA.013", name: "Columbia County" },
    { code: "US.WA.015", name: "Cowlitz County" },
    { code: "US.WA.017", name: "Douglas County" },
    { code: "US.WA.019", name: "Ferry County" },
    { code: "US.WA.021", name: "Franklin County" },
    { code: "US.WA.023", name: "Garfield County" },
    { code: "US.WA.025", name: "Grant County" },
    { code: "US.WA.027", name: "Grays Harbor County" },
    { code: "US.WA.029", name: "Island County" },
    { code: "US.WA.031", name: "Jefferson County" },
    { code: "US.WA.033", name: "King County" },
    { code: "US.WA.035", name: "Kitsap County" },
    { code: "US.WA.037", name: "Kittitas County" },
    { code: "US.WA.039", name: "Klickitat County" },
    { code: "US.WA.041", name: "Lewis County" },
    { code: "US.WA.043", name: "Lincoln County" },
    { code: "US.WA.045", name: "Mason County" },
    { code: "US.WA.047", name: "Okanogan County" },
    { code: "US.WA.049", name: "Pacific County" },
    { code: "US.WA.051", name: "Pend Oreille County" },
    { code: "US.WA.053", name: "Pierce County" },
    { code: "US.WA.055", name: "San Juan County" },
    { code: "US.WA.057", name: "Skagit County" },
    { code: "US.WA.059", name: "Skamania County" },
    { code: "US.WA.061", name: "Snohomish County" },
    { code: "US.WA.063", name: "Spokane County" },
    { code: "US.WA.065", name: "Stevens County" },
    { code: "US.WA.067", name: "Thurston County" },
    { code: "US.WA.069", name: "Wahkiakum County" },
    { code: "US.WA.071", name: "Walla Walla County" },
    { code: "US.WA.073", name: "Whatcom County" },
    { code: "US.WA.075", name: "Whitman County" },
    { code: "US.WA.077", name: "Yakima County" },
  ],
  "US.WI": [
    { code: "US.WI.001", name: "Adams County" },
    { code: "US.WI.003", name: "Ashland County" },
    { code: "US.WI.005", name: "Barron County" },
    { code: "US.WI.007", name: "Bayfield County" },
    { code: "US.WI.009", name: "Brown County" },
    { code: "US.WI.011", name: "Buffalo County" },
    { code: "US.WI.013", name: "Burnett County" },
    { code: "US.WI.015", name: "Calumet County" },
    { code: "US.WI.017", name: "Chippewa County" },
    { code: "US.WI.019", name: "Clark County" },
    { code: "US.WI.021", name: "Columbia County" },
    { code: "US.WI.023", name: "Crawford County" },
    { code: "US.WI.025", name: "Dane County" },
    { code: "US.WI.027", name: "Dodge County" },
    { code: "US.WI.029", name: "Door County" },
    { code: "US.WI.031", name: "Douglas County" },
    { code: "US.WI.033", name: "Dunn County" },
    { code: "US.WI.035", name: "Eau Claire County" },
    { code: "US.WI.037", name: "Florence County" },
    { code: "US.WI.039", name: "Fond du Lac County" },
    { code: "US.WI.041", name: "Forest County" },
    { code: "US.WI.043", name: "Grant County" },
    { code: "US.WI.045", name: "Green County" },
    { code: "US.WI.047", name: "Green Lake County" },
    { code: "US.WI.049", name: "Iowa County" },
    { code: "US.WI.051", name: "Iron County" },
    { code: "US.WI.053", name: "Jackson County" },
    { code: "US.WI.055", name: "Jefferson County" },
    { code: "US.WI.057", name: "Juneau County" },
    { code: "US.WI.059", name: "Kenosha County" },
    { code: "US.WI.061", name: "Kewaunee County" },
    { code: "US.WI.063", name: "La Crosse County" },
    { code: "US.WI.065", name: "Lafayette County" },
    { code: "US.WI.067", name: "Langlade County" },
    { code: "US.WI.069", name: "Lincoln County" },
    { code: "US.WI.071", name: "Manitowoc County" },
    { code: "US.WI.073", name: "Marathon County" },
    { code: "US.WI.075", name: "Marinette County" },
    { code: "US.WI.077", name: "Marquette County" },
    { code: "US.WI.078", name: "Menominee County" },
    { code: "US.WI.079", name: "Milwaukee County" },
    { code: "US.WI.081", name: "Monroe County" },
    { code: "US.WI.083", name: "Oconto County" },
    { code: "US.WI.085", name: "Oneida County" },
    { code: "US.WI.087", name: "Outagamie County" },
    { code: "US.WI.089", name: "Ozaukee County" },
    { code: "US.WI.091", name: "Pepin County" },
    { code: "US.WI.093", name: "Pierce County" },
    { code: "US.WI.095", name: "Polk County" },
    { code: "US.WI.097", name: "Portage County" },
    { code: "US.WI.099", name: "Price County" },
    { code: "US.WI.101", name: "Racine County" },
    { code: "US.WI.103", name: "Richland County" },
    { code: "US.WI.105", name: "Rock County" },
    { code: "US.WI.107", name: "Rusk County" },
    { code: "US.WI.109", name: "Saint Croix County" },
    { code: "US.WI.111", name: "Sauk County" },
    { code: "US.WI.113", name: "Sawyer County" },
    { code: "US.WI.115", name: "Shawano County" },
    { code: "US.WI.117", name: "Sheboygan County" },
    { code: "US.WI.119", name: "Taylor County" },
    { code: "US.WI.121", name: "Trempealeau County" },
    { code: "US.WI.123", name: "Vernon County" },
    { code: "US.WI.125", name: "Vilas County" },
    { code: "US.WI.127", name: "Walworth County" },
    { code: "US.WI.129", name: "Washburn County" },
    { code: "US.WI.131", name: "Washington County" },
    { code: "US.WI.133", name: "Waukesha County" },
    { code: "US.WI.135", name: "Waupaca County" },
    { code: "US.WI.137", name: "Waushara County" },
    { code: "US.WI.139", name: "Winnebago County" },
    { code: "US.WI.141", name: "Wood County" },
  ],
  "US.WV": [
    { code: "US.WV.001", name: "Barbour County" },
    { code: "US.WV.003", name: "Berkeley County" },
    { code: "US.WV.005", name: "Boone County" },
    { code: "US.WV.007", name: "Braxton County" },
    { code: "US.WV.009", name: "Brooke County" },
    { code: "US.WV.011", name: "Cabell County" },
    { code: "US.WV.013", name: "Calhoun County" },
    { code: "US.WV.015", name: "Clay County" },
    { code: "US.WV.017", name: "Doddridge County" },
    { code: "US.WV.019", name: "Fayette County" },
    { code: "US.WV.021", name: "Gilmer County" },
    { code: "US.WV.023", name: "Grant County" },
    { code: "US.WV.025", name: "Greenbrier County" },
    { code: "US.WV.027", name: "Hampshire County" },
    { code: "US.WV.029", name: "Hancock County" },
    { code: "US.WV.031", name: "Hardy County" },
    { code: "US.WV.033", name: "Harrison County" },
    { code: "US.WV.035", name: "Jackson County" },
    { code: "US.WV.037", name: "Jefferson County" },
    { code: "US.WV.039", name: "Kanawha County" },
    { code: "US.WV.041", name: "Lewis County" },
    { code: "US.WV.043", name: "Lincoln County" },
    { code: "US.WV.045", name: "Logan County" },
    { code: "US.WV.047", name: "McDowell County" },
    { code: "US.WV.049", name: "Marion County" },
    { code: "US.WV.051", name: "Marshall County" },
    { code: "US.WV.053", name: "Mason County" },
    { code: "US.WV.055", name: "Mercer County" },
    { code: "US.WV.057", name: "Mineral County" },
    { code: "US.WV.059", name: "Mingo County" },
    { code: "US.WV.061", name: "Monongalia County" },
    { code: "US.WV.063", name: "Monroe County" },
    { code: "US.WV.065", name: "Morgan County" },
    { code: "US.WV.067", name: "Nicholas County" },
    { code: "US.WV.069", name: "Ohio County" },
    { code: "US.WV.071", name: "Pendleton County" },
    { code: "US.WV.073", name: "Pleasants County" },
    { code: "US.WV.075", name: "Pocahontas County" },
    { code: "US.WV.077", name: "Preston County" },
    { code: "US.WV.079", name: "Putnam County" },
    { code: "US.WV.081", name: "Raleigh County" },
    { code: "US.WV.083", name: "Randolph County" },
    { code: "US.WV.085", name: "Ritchie County" },
    { code: "US.WV.087", name: "Roane County" },
    { code: "US.WV.089", name: "Summers County" },
    { code: "US.WV.091", name: "Taylor County" },
    { code: "US.WV.093", name: "Tucker County" },
    { code: "US.WV.095", name: "Tyler County" },
    { code: "US.WV.097", name: "Upshur County" },
    { code: "US.WV.099", name: "Wayne County" },
    { code: "US.WV.101", name: "Webster County" },
    { code: "US.WV.103", name: "Wetzel County" },
    { code: "US.WV.105", name: "Wirt County" },
    { code: "US.WV.107", name: "Wood County" },
    { code: "US.WV.109", name: "Wyoming County" },
  ],
  "US.WY": [
    { code: "US.WY.001", name: "Albany County" },
    { code: "US.WY.003", name: "Big Horn County" },
    { code: "US.WY.005", name: "Campbell County" },
    { code: "US.WY.007", name: "Carbon County" },
    { code: "US.WY.009", name: "Converse County" },
    { code: "US.WY.011", name: "Crook County" },
    { code: "US.WY.013", name: "Fremont County" },
    { code: "US.WY.015", name: "Goshen County" },
    { code: "US.WY.017", name: "Hot Springs County" },
    { code: "US.WY.019", name: "Johnson County" },
    { code: "US.WY.021", name: "Laramie County" },
    { code: "US.WY.023", name: "Lincoln County" },
    { code: "US.WY.025", name: "Natrona County" },
    { code: "US.WY.027", name: "Niobrara County" },
    { code: "US.WY.029", name: "Park County" },
    { code: "US.WY.031", name: "Platte County" },
    { code: "US.WY.033", name: "Sheridan County" },
    { code: "US.WY.035", name: "Sublette County" },
    { code: "US.WY.037", name: "Sweetwater County" },
    { code: "US.WY.039", name: "Teton County" },
    { code: "US.WY.041", name: "Uinta County" },
    { code: "US.WY.043", name: "Washakie County" },
    { code: "US.WY.045", name: "Weston County" },
  ],
  "UY.01": [
    { code: "UY.01.01", name: "Baltasar Brum" },
    { code: "UY.01.02", name: "Bella Union" },
    { code: "UY.01.03", name: "Tomas Gomensoro" },
  ],
  "UY.02": [
    { code: "UY.02.01", name: "Nicolich" },
    { code: "UY.02.02", name: "Santa Lucia" },
    { code: "UY.02.03", name: "Aguas Corrientes" },
    { code: "UY.02.04", name: "Atlantida" },
    { code: "UY.02.05", name: "Barros Blancos" },
    { code: "UY.02.06", name: "Canelones" },
    { code: "UY.02.07", name: "Los Cerrillos" },
    { code: "UY.02.08", name: "Ciudad De La Costa" },
    { code: "UY.02.09", name: "Empalme Olmos" },
    { code: "UY.02.10", name: "La Floresta" },
    { code: "UY.02.11", name: "La Paz" },
    { code: "UY.02.12", name: "Las Piedras" },
    { code: "UY.02.13", name: "Migues" },
    { code: "UY.02.14", name: "Montes" },
    { code: "UY.02.15", name: "Pando" },
    { code: "UY.02.16", name: "Parque Del Plata" },
    { code: "UY.02.17", name: "Paso Carrasco" },
    { code: "UY.02.18", name: "Progreso" },
    { code: "UY.02.19", name: "Salinas" },
    { code: "UY.02.20", name: "San Antonio" },
    { code: "UY.02.22", name: "San Bautista" },
    { code: "UY.02.23", name: "San Jacinto" },
    { code: "UY.02.24", name: "San Ramon" },
    { code: "UY.02.25", name: "Santa Rosa" },
    { code: "UY.02.26", name: "Sauce" },
    { code: "UY.02.27", name: "Soca" },
    { code: "UY.02.28", name: "Joaquin Suarez" },
    { code: "UY.02.29", name: "Tala" },
    { code: "UY.02.30", name: "Toledo" },
    { code: "UY.02.31", name: "18 De Mayo" },
  ],
  "UY.03": [
    { code: "UY.03.01", name: "Rio Branco" },
    { code: "UY.03.02", name: "Isidoro Noblia" },
    { code: "UY.03.03", name: "Acegua" },
    { code: "UY.03.04", name: "Tupambae" },
    { code: "UY.03.05", name: "Placido Rosas" },
    { code: "UY.03.06", name: "Arevalo" },
    { code: "UY.03.07", name: "Arbolito" },
    { code: "UY.03.08", name: "Ramon Trigo" },
    { code: "UY.03.09", name: "Fraile Muerto" },
  ],
  "UY.04": [
    { code: "UY.04.01", name: "Carmelo" },
    { code: "UY.04.02", name: "Nueva Helvecia" },
    { code: "UY.04.03", name: "Nueva Palmira" },
    { code: "UY.04.04", name: "Rosario" },
    { code: "UY.04.05", name: "Tarariras" },
    { code: "UY.04.06", name: "Juan Lacaze" },
    { code: "UY.04.07", name: "Ombues De Lavalle" },
    { code: "UY.04.08", name: "Florencio Sanchez" },
    { code: "UY.04.09", name: "Colonia Valdense" },
  ],
  "UY.05": [
    { code: "UY.05.01", name: "Sarandí Del Yí" },
    { code: "UY.05.02", name: "Villa Carmen" },
  ],
  "UY.06": [
    { code: "UY.06.01", name: "Ismael Cortinas" },
  ],
  "UY.07": [
    { code: "UY.07.01", name: "Casupá" },
    { code: "UY.07.02", name: "Sarandí Grande" },
    { code: "UY.07.03", name: "Fray Marcos" },
  ],
  "UY.08": [
    { code: "UY.08.01", name: "Jose Pedro Varela" },
    { code: "UY.08.02", name: "Solis De Mataojo" },
    { code: "UY.08.03", name: "Jose Batlle Y Ordoñez" },
  ],
  "UY.09": [
    { code: "UY.09.01", name: "Aiguá" },
    { code: "UY.09.02", name: "Garzón" },
    { code: "UY.09.03", name: "Maldonado" },
    { code: "UY.09.04", name: "Pan De Azucar" },
    { code: "UY.09.05", name: "Piriapolis" },
    { code: "UY.09.06", name: "Punta Del Este" },
    { code: "UY.09.07", name: "San Carlos" },
    { code: "UY.09.08", name: "Solis Grande" },
  ],
  "UY.10": [
    { code: "UY.10.01", name: "Municipio A" },
    { code: "UY.10.02", name: "Municipio B" },
    { code: "UY.10.03", name: "Municipio C" },
    { code: "UY.10.04", name: "Municipio Ch" },
    { code: "UY.10.05", name: "Municipio D" },
    { code: "UY.10.06", name: "Municipio E" },
    { code: "UY.10.07", name: "Municipio F" },
    { code: "UY.10.08", name: "Municipio G" },
  ],
  "UY.11": [
    { code: "UY.11.01", name: "Porvenir" },
    { code: "UY.11.02", name: "Guichon" },
    { code: "UY.11.03", name: "Quebracho" },
    { code: "UY.11.04", name: "Piedras Coloradas" },
    { code: "UY.11.05", name: "Lorenzo Geyres" },
    { code: "UY.11.06", name: "Tambores" },
    { code: "UY.11.07", name: "Chapicuy" },
  ],
  "UY.12": [
    { code: "UY.12.01", name: "Nuevo Berlin" },
    { code: "UY.12.02", name: "Young" },
    { code: "UY.12.03", name: "San Javier" },
  ],
  "UY.13": [
    { code: "UY.13.01", name: "Tranqueras" },
    { code: "UY.13.02", name: "Vichadero" },
    { code: "UY.13.03", name: "Minas De Corrales" },
  ],
  "UY.14": [
    { code: "UY.14.01", name: "Castillos" },
    { code: "UY.14.02", name: "Chuy" },
    { code: "UY.14.03", name: "La Paloma" },
    { code: "UY.14.04", name: "Lascano" },
  ],
  "UY.15": [
    { code: "UY.15.01", name: "Pueblo Belen" },
    { code: "UY.15.02", name: "Villa Constitucion" },
    { code: "UY.15.03", name: "Lavalleja" },
    { code: "UY.15.04", name: "Mataojo" },
    { code: "UY.15.05", name: "San Antonio" },
    { code: "UY.15.06", name: "Rincon De Valentin" },
  ],
  "UY.16": [
    { code: "UY.16.01", name: "Ciudad Del Plata" },
    { code: "UY.16.02", name: "Libertad" },
    { code: "UY.16.03", name: "Ecilda Paullier" },
    { code: "UY.16.04", name: "Rodriguez" },
  ],
  "UY.17": [
    { code: "UY.17.01", name: "Cardona" },
    { code: "UY.17.02", name: "Dolores" },
    { code: "UY.17.03", name: "Jose Enrique Rodo" },
    { code: "UY.17.04", name: "Palmitas" },
  ],
  "UY.18": [
    { code: "UY.18.01", name: "Paso De Los Toros" },
    { code: "UY.18.02", name: "San Gregorio De Polanco" },
    { code: "UY.18.03", name: "Ansina" },
  ],
  "UY.19": [
    { code: "UY.19.01", name: "Santa Clara De Olimar" },
    { code: "UY.19.02", name: "Vergara" },
  ],
  "UZ.01": [
    { code: "UZ.01.1513039", name: "Pakhtaobod Tumani" },
    { code: "UZ.01.1513193", name: "Shahrikhon Tumani" },
    { code: "UZ.01.1513240", name: "Marhamat Tumani" },
    { code: "UZ.01.1513270", name: "Asaka Tumani" },
    { code: "UZ.01.1513363", name: "Qŭrghontepa Tumani" },
    { code: "UZ.01.1513493", name: "Ulug‘nor Tumani" },
    { code: "UZ.01.1513598", name: "Khŭjaobod Tumani" },
    { code: "UZ.01.1513888", name: "Izboskan Tumani" },
    { code: "UZ.01.1514108", name: "Jalolkuduk Tumani" },
    { code: "UZ.01.1514336", name: "Bo‘z Tumani" },
    { code: "UZ.01.1514451", name: "Baliqchi Tumani" },
    { code: "UZ.01.1514584", name: "Andijon Tumani" },
    { code: "UZ.01.1514606", name: "Oltinkŭl Tumani" },
    { code: "UZ.01.1538281", name: "Buloqboshi Tumani" },
    { code: "UZ.01.1538282", name: "Andijon Shahri" },
    { code: "UZ.01.1538283", name: "Asaka Shahri" },
    { code: "UZ.01.1538284", name: "Qorasuw Shahri" },
    { code: "UZ.01.1538285", name: "Khonobod Shahri" },
    { code: "UZ.01.1538286", name: "Shahrikhon Shahri" },
    { code: "UZ.01.7668830", name: "Ulugnar" },
  ],
  "UZ.02": [
    { code: "UZ.02.1215788", name: "Wobkent Tumani" },
    { code: "UZ.02.1215958", name: "Termiz Tumani" },
    { code: "UZ.02.1216048", name: "Jondor Tumani" },
    { code: "UZ.02.1216289", name: "Romiton Tumani" },
    { code: "UZ.02.1217081", name: "Qorakŭl Tumani" },
    { code: "UZ.02.1217179", name: "Kogon Tumani" },
    { code: "UZ.02.1217663", name: "Bukhoro Tumani" },
    { code: "UZ.02.1217905", name: "Olot Tumani" },
    { code: "UZ.02.1346433", name: "Qorovulbozor Tumani" },
    { code: "UZ.02.1346437", name: "Kogon Shahri" },
    { code: "UZ.02.1512837", name: "Shofirkon Tumani" },
    { code: "UZ.02.1513006", name: "Peshku Tumani" },
    { code: "UZ.02.1513982", name: "Ghijduwon Tumani" },
    { code: "UZ.02.1538236", name: "Ghijduwon Shahri" },
    { code: "UZ.02.7668831", name: "Alat" },
  ],
  "UZ.03": [
    { code: "UZ.03.1512318", name: "Yozyovon Tumani" },
    { code: "UZ.03.1512439", name: "O‘zbekiston Tumani" },
    { code: "UZ.03.1512646", name: "Toshloq Tumani" },
    { code: "UZ.03.1512956", name: "Rishton Tumani" },
    { code: "UZ.03.1513272", name: "Uchko‘prik Tumani" },
    { code: "UZ.03.1513329", name: "Quva Tumani" },
    { code: "UZ.03.1513547", name: "Beshariq Tumani" },
    { code: "UZ.03.1514016", name: "Dang‘ara Tumani" },
    { code: "UZ.03.1514017", name: "Farg‘ona Tumani" },
    { code: "UZ.03.1514299", name: "Buvayda Tumani" },
    { code: "UZ.03.1514482", name: "Bag‘dod Tumani" },
    { code: "UZ.03.1514616", name: "Oltiariq Tumani" },
    { code: "UZ.03.1514681", name: "Oxunboboyev Tumani" },
    { code: "UZ.03.1538294", name: "Furqat Tumani" },
    { code: "UZ.03.1538295", name: "So‘x Tumani" },
    { code: "UZ.03.1538296", name: "Farg‘ona Shahri" },
    { code: "UZ.03.1538297", name: "Qo‘qon Shahri" },
    { code: "UZ.03.1538298", name: "Quva Shahri" },
    { code: "UZ.03.1538299", name: "Quvasoy Shahri" },
    { code: "UZ.03.1538300", name: "Marg‘ilon Shahri" },
    { code: "UZ.03.7668818", name: "Altyarik" },
    { code: "UZ.03.7668819", name: "Bagdad" },
    { code: "UZ.03.7668820", name: "Rishtan" },
    { code: "UZ.03.7668842", name: "Yazyavan" },
  ],
  "UZ.05": [
    { code: "UZ.05.1512360", name: "Yangibozor Tumani" },
    { code: "UZ.05.1512367", name: "Yangiariq Tumani" },
    { code: "UZ.05.1512467", name: "Urganch Tumani" },
    { code: "UZ.05.1512818", name: "Showot Tumani" },
    { code: "UZ.05.1513477", name: "Qŭshkŭpir Tumani" },
    { code: "UZ.05.1513603", name: "Khiwa Tumani" },
    { code: "UZ.05.1513610", name: "Hazorasp Tumani" },
    { code: "UZ.05.1513635", name: "Khonqa Tumani" },
    { code: "UZ.05.1513961", name: "Gurlan Tumani" },
    { code: "UZ.05.1514485", name: "Boghot Tumani" },
    { code: "UZ.05.1538226", name: "Urganch Shahri" },
    { code: "UZ.05.1538227", name: "Pitnak Shahri" },
    { code: "UZ.05.1538228", name: "Khiwa Shahri" },
  ],
  "UZ.06": [
    { code: "UZ.06.11611821", name: "Pap District" },
    { code: "UZ.06.1512289", name: "Mingbuloq Tumani" },
    { code: "UZ.06.1512349", name: "Yangiqo‘rg‘on Tumani" },
    { code: "UZ.06.1512448", name: "Uychi Tumani" },
    { code: "UZ.06.1512500", name: "Uchqŭrghon Tumani" },
    { code: "UZ.06.1512548", name: "Tŭraqŭrghon Tumani" },
    { code: "UZ.06.1513021", name: "Pop Tumani" },
    { code: "UZ.06.1513144", name: "Norin Tumani" },
    { code: "UZ.06.1513156", name: "Namangan Tumani" },
    { code: "UZ.06.1513713", name: "Kosonsoy Tumani" },
    { code: "UZ.06.1514190", name: "Chust Tumani" },
    { code: "UZ.06.1538272", name: "Chortoq Tumani" },
    { code: "UZ.06.1538277", name: "Chust Tumani" },
  ],
  "UZ.07": [
    { code: "UZ.07.1216582", name: "Qiziltepa Tumani" },
    { code: "UZ.07.1512504", name: "Uchkuduk District" },
    { code: "UZ.07.1512673", name: "Tomdi Tumani" },
    { code: "UZ.07.1513082", name: "Nurota Tumani" },
    { code: "UZ.07.1513133", name: "Navoiy Tumani" },
    { code: "UZ.07.1513135", name: "Navbahor Tumani" },
    { code: "UZ.07.1513622", name: "Xatirchi Tumani" },
    { code: "UZ.07.1513830", name: "Konimex Tumani" },
    { code: "UZ.07.8714365", name: "Navbakhor Tumani" },
  ],
  "UZ.08": [
    { code: "UZ.08.1215766", name: "Yakkabog‘ Tumani" },
    { code: "UZ.08.1215811", name: "Usmon Yusupov Tumani" },
    { code: "UZ.08.1215855", name: "Kasbi Tumani" },
    { code: "UZ.08.1216186", name: "Shahrisabz Tumani" },
    { code: "UZ.08.1216399", name: "Nishon Tumani" },
    { code: "UZ.08.1216474", name: "Muborak Tumani" },
    { code: "UZ.08.1216786", name: "Kitob Tumani" },
    { code: "UZ.08.1217005", name: "Koson Tumani" },
    { code: "UZ.08.1217013", name: "Qarshi Tumani" },
    { code: "UZ.08.1217142", name: "Qamashi Tumani" },
    { code: "UZ.08.1217259", name: "G‘uzor Tumani" },
    { code: "UZ.08.1217479", name: "Dehqonobod Tumani" },
    { code: "UZ.08.1217538", name: "Chiroqchi Tumani" },
    { code: "UZ.08.1346479", name: "Mirishkor Tumani" },
    { code: "UZ.08.1346481", name: "Qarshi Shahri" },
    { code: "UZ.08.7668833", name: "Mirishkar" },
    { code: "UZ.08.8714362", name: "Kamashi District" },
    { code: "UZ.08.8714363", name: "Guzar District" },
  ],
  "UZ.09": [
    { code: "UZ.09.1512534", name: "To‘rtko‘l Tumani" },
    { code: "UZ.09.1512698", name: "Taxtako‘pir Tumani" },
    { code: "UZ.09.1513732", name: "Qorao‘zak Tumani" },
    { code: "UZ.09.1514037", name: "Ellikqala Tumani" },
    { code: "UZ.09.1514386", name: "Beruniy Tumani" },
    { code: "UZ.09.1514593", name: "Amudaryo Tumani" },
    { code: "UZ.09.601276", name: "Shumanay Tumani" },
    { code: "UZ.09.601292", name: "Nukus Tumani" },
    { code: "UZ.09.601301", name: "Mo’ynoq Tumani" },
    { code: "UZ.09.601309", name: "Qanliko‘l Tumani" },
    { code: "UZ.09.601322", name: "Qo‘ng‘irot Tumani" },
    { code: "UZ.09.601340", name: "Xo‘jayli Tumani" },
    { code: "UZ.09.601347", name: "Kegeyli Tumani" },
    { code: "UZ.09.601394", name: "Chimboy Tumani" },
    { code: "UZ.09.601398", name: "Bo‘zatov Tumani" },
  ],
  "UZ.10": [
    { code: "UZ.10.1215838", name: "Urgut Tumani" },
    { code: "UZ.10.1216079", name: "Nurobod Tumani" },
    { code: "UZ.10.1216266", name: "Samarqand Tumani" },
    { code: "UZ.10.1216337", name: "Payariq Tumani" },
    { code: "UZ.10.1216341", name: "Pastdarg‘om Tumani" },
    { code: "UZ.10.1216354", name: "Paxtachi Tumani" },
    { code: "UZ.10.1216429", name: "Narpay Tumani" },
    { code: "UZ.10.1216987", name: "Kattaqo‘rg‘on Tumani" },
    { code: "UZ.10.1217214", name: "Ishtixon Tumani" },
    { code: "UZ.10.1217412", name: "Jomboy Tumani" },
    { code: "UZ.10.1217655", name: "Bulung‘ur Tumani" },
    { code: "UZ.10.1217960", name: "Oqdaryo Tumani" },
    { code: "UZ.10.1346451", name: "Chelak Tumani" },
    { code: "UZ.10.1346455", name: "Go`zalkent Tumani" },
    { code: "UZ.10.1346462", name: "Toyloq Tumani" },
    { code: "UZ.10.1346463", name: "Samarqand Shahri" },
    { code: "UZ.10.1346465", name: "Oqtosh Shahri" },
    { code: "UZ.10.1346466", name: "Kattaqo‘rg‘on Shahri" },
    { code: "UZ.10.1346467", name: "Urgut Shahri" },
    { code: "UZ.10.1513472", name: "Qo‘shrabot Tumani" },
    { code: "UZ.10.7668834", name: "Pastdargom" },
    { code: "UZ.10.9166490", name: "Toyloq District" },
  ],
  "UZ.12": [
    { code: "UZ.12.1216113", name: "Sho‘rchi Tumani" },
    { code: "UZ.12.1216154", name: "Sherobod Tumani" },
    { code: "UZ.12.1216243", name: "Sariosiyo Tumani" },
    { code: "UZ.12.1216571", name: "Qiziriq Tumani" },
    { code: "UZ.12.1216685", name: "Qumqŭrghon Tumani" },
    { code: "UZ.12.1217341", name: "Muzrabod Tumani" },
    { code: "UZ.12.1217391", name: "Jarqo‘rg‘on Tumani" },
    { code: "UZ.12.1217476", name: "Denov Tumani" },
    { code: "UZ.12.1217733", name: "Boysun Tumani" },
    { code: "UZ.12.1217872", name: "Angor Tumani" },
    { code: "UZ.12.1217894", name: "Oltinsoy Tumani" },
    { code: "UZ.12.1346497", name: "Uzun Tumani" },
    { code: "UZ.12.1346534", name: "Bandikhon Tumani" },
    { code: "UZ.12.1346536", name: "Termiz Shahri" },
    { code: "UZ.12.1346537", name: "Denov Shahri" },
    { code: "UZ.12.1538254", name: "Yangiyŭl Tumani" },
  ],
  "UZ.13": [
    { code: "UZ.13.1512848", name: "Sirgali Tumani" },
    { code: "UZ.13.1512949", name: "Sobir Rahimov Tumani" },
    { code: "UZ.13.1513066", name: "Shaykhontohur Tumani" },
    { code: "UZ.13.1513269", name: "Mirobod Tumani" },
    { code: "UZ.13.1513328", name: "Mirzo Ulug‘bek Tumani" },
    { code: "UZ.13.1513546", name: "Yunusobod Tumani" },
    { code: "UZ.13.1513648", name: "Hamza Tumani" },
    { code: "UZ.13.1514229", name: "Chilonzor Tumani" },
    { code: "UZ.13.1514665", name: "Akmal Ikromow Tumani" },
    { code: "UZ.13.1536760", name: "Bektemir Tumani" },
    { code: "UZ.13.1536761", name: "Yakkasaroy Tumani" },
  ],
  "UZ.14": [
    { code: "UZ.14.1512652", name: "Toshkent Tumani" },
    { code: "UZ.14.1512751", name: "Ŭrta Chirchiq Tumani" },
    { code: "UZ.14.1512985", name: "Piskent Tumani" },
    { code: "UZ.14.1513016", name: "Parkent Tumani" },
    { code: "UZ.14.1513057", name: "Qibray Tumani" },
    { code: "UZ.14.1513498", name: "Yuqori Chirchiq Tumani" },
    { code: "UZ.14.1513860", name: "Zangiota Tumani" },
    { code: "UZ.14.1514010", name: "Quyi Chirchiq Tumani" },
    { code: "UZ.14.1514214", name: "Chinoz Tumani" },
    { code: "UZ.14.1514327", name: "Bŭka Tumani" },
    { code: "UZ.14.1514338", name: "Bŭstonliq Tumani" },
    { code: "UZ.14.1514399", name: "Bekobod Tumani" },
    { code: "UZ.14.1514667", name: "Oqqŭrghon Tumani" },
    { code: "UZ.14.1514687", name: "Ohangaron Tumani" },
    { code: "UZ.14.1538256", name: "Olmaliq Shahri" },
    { code: "UZ.14.1538257", name: "Angren Shahri" },
    { code: "UZ.14.1538258", name: "Ohangaron Shahri" },
    { code: "UZ.14.1538259", name: "Bekobod Shahri" },
    { code: "UZ.14.1538260", name: "Chirchiq Shahri" },
    { code: "UZ.14.1538261", name: "Yangiobod Shahri" },
  ],
  "UZ.15": [
    { code: "UZ.15.1215692", name: "Zomin Tumani" },
    { code: "UZ.15.1217334", name: "G‘allaorol Tumani" },
    { code: "UZ.15.1217778", name: "Baxmal Tumani" },
    { code: "UZ.15.1512277", name: "Zarbdor Tumani" },
    { code: "UZ.15.1513035", name: "Paxtakor Tumani" },
    { code: "UZ.15.1513067", name: "Zafarobod Tumani" },
    { code: "UZ.15.1513202", name: "Mirzachŭl Tumani" },
    { code: "UZ.15.1514024", name: "Forish Tumani" },
    { code: "UZ.15.1514068", name: "Jizzax Tumani" },
    { code: "UZ.15.1514124", name: "Dŭstlik Tumani" },
    { code: "UZ.15.1514555", name: "Arnasoy Tumani" },
    { code: "UZ.15.1538240", name: "Jizzax Shahri" },
  ],
  "UZ.16": [
    { code: "UZ.16.1512404", name: "Sayhunobod Tumani" },
    { code: "UZ.16.1512717", name: "Sirdaryo Tumani" },
    { code: "UZ.16.1513490", name: "Mirzaobod Tumani" },
    { code: "UZ.16.1513618", name: "Khovos Tumani" },
    { code: "UZ.16.1513952", name: "Sharof-Rashidow Tumani" },
    { code: "UZ.16.1513967", name: "Guliston Tumani" },
    { code: "UZ.16.1514430", name: "Boyowut Tumani" },
    { code: "UZ.16.1514705", name: "Oqoltin Tumani" },
    { code: "UZ.16.1538246", name: "Mehnatobod Tumani" },
    { code: "UZ.16.1538249", name: "Guliston Shahri" },
    { code: "UZ.16.1538250", name: "Sirdaryo Shahri" },
    { code: "UZ.16.1538251", name: "Shirin Shahri" },
    { code: "UZ.16.1538252", name: "Yangiyer Shahri" },
    { code: "UZ.16.1538253", name: "Bakht Shahri" },
    { code: "UZ.16.7668840", name: "Bayaut" },
  ],
  "VE.01": [
    { code: "VE.01.0201", name: "Municipio Autónomo Alto Orinoco" },
    { code: "VE.01.0202", name: "Municipio Autónomo Atabapo" },
    { code: "VE.01.0203", name: "Municipio Autónomo Atures" },
    { code: "VE.01.0204", name: "Municipio Autónomo Autana" },
    { code: "VE.01.0205", name: "Municipio Autónomo Maroa" },
    { code: "VE.01.0206", name: "Municipio Autónomo Manapiare" },
    { code: "VE.01.0207", name: "Municipio Autónomo Río Negro" },
  ],
  "VE.02": [
    { code: "VE.02.0301", name: "Municipio Anaco" },
    { code: "VE.02.0302", name: "Municipio Aragua" },
    { code: "VE.02.0303", name: "Municipio Fernando de Peñalver" },
    { code: "VE.02.0304", name: "Municipio Francisco del Carmen Carvajal" },
    { code: "VE.02.0305", name: "Municipio Francisco de Miranda" },
    { code: "VE.02.0306", name: "Municipio Guanta" },
    { code: "VE.02.0307", name: "Municipio Independencia" },
    { code: "VE.02.0308", name: "Municipio Juan Antonio Sotillo" },
    { code: "VE.02.0309", name: "Municipio Juan Manuel Cajigal" },
    { code: "VE.02.0310", name: "Municipio José Gregorio Monagas" },
    { code: "VE.02.0311", name: "Municipio Libertad" },
    { code: "VE.02.0312", name: "Municipio Manuel Ezequiel Bruzual" },
    { code: "VE.02.0313", name: "Municipio Pedro María Freites" },
    { code: "VE.02.0314", name: "Municipio Píritu" },
    { code: "VE.02.0315", name: "Municipio San José de Guanipa" },
    { code: "VE.02.0316", name: "Municipio San Juan de Capistrano" },
    { code: "VE.02.0317", name: "Municipio Santa Ana" },
    { code: "VE.02.0318", name: "Municipio Simón Bolívar" },
    { code: "VE.02.0319", name: "Municipio Simón Rodríguez" },
    { code: "VE.02.0320", name: "Municipio Sir Arthur Mc Gregor" },
    { code: "VE.02.0321", name: "Municipio Turistico Diego Bautista Urbaneja" },
  ],
  "VE.03": [
    { code: "VE.03.0401", name: "Municipio Achaguas" },
    { code: "VE.03.0402", name: "Municipio Biruaca" },
    { code: "VE.03.0403", name: "Municipio Muñoz" },
    { code: "VE.03.0404", name: "Municipio Páez" },
    { code: "VE.03.0405", name: "Municipio Pedro Camejo" },
    { code: "VE.03.0406", name: "Municipio Rómulo Gallegos" },
    { code: "VE.03.0407", name: "Municipio San Fernando" },
  ],
  "VE.04": [
    { code: "VE.04.0501", name: "Municipio Bolívar" },
    { code: "VE.04.0502", name: "Municipio Camatagua" },
    { code: "VE.04.0503", name: "Municipio Girardot" },
    { code: "VE.04.0504", name: "Municipio José Angel Lamas" },
    { code: "VE.04.0505", name: "Municipio José Félix Ribas" },
    { code: "VE.04.0506", name: "Municipio José Rafael Revenga" },
    { code: "VE.04.0507", name: "Municipio Libertador" },
    { code: "VE.04.0508", name: "Municipio Mario Briceño Iragorry" },
    { code: "VE.04.0509", name: "Municipio San Casimiro" },
    { code: "VE.04.0510", name: "Municipio San Sebastián" },
    { code: "VE.04.0511", name: "Municipio Santiago Mariño" },
    { code: "VE.04.0512", name: "Municipio Santos Michelena" },
    { code: "VE.04.0513", name: "Municipio Sucre" },
    { code: "VE.04.0514", name: "Municipio Tovar" },
    { code: "VE.04.0515", name: "Municipio Urdaneta" },
    { code: "VE.04.0516", name: "Municipio Zamora" },
    { code: "VE.04.0517", name: "Municipio Francisco Linares Alcántara" },
    { code: "VE.04.0518", name: "Municipio Ocumare de La Costa de Oro" },
  ],
  "VE.05": [
    { code: "VE.05.0601", name: "Municipio Alberto Arvelo Torrealba" },
    { code: "VE.05.0602", name: "Municipio Antonio José de Sucre" },
    { code: "VE.05.0603", name: "Municipio Arismendi" },
    { code: "VE.05.0604", name: "Municipio Barinas" },
    { code: "VE.05.0605", name: "Municipio Bolívar" },
    { code: "VE.05.0606", name: "Municipio Cruz Paredes" },
    { code: "VE.05.0607", name: "Municipio Ezequiel Zamora" },
    { code: "VE.05.0608", name: "Municipio Obispos" },
    { code: "VE.05.0609", name: "Municipio Pedraza" },
    { code: "VE.05.0610", name: "Municipio Rojas" },
    { code: "VE.05.0611", name: "Municipio Sosa" },
    { code: "VE.05.0612", name: "Municipio Andrés Eloy Blanco" },
  ],
  "VE.06": [
    { code: "VE.06.0701", name: "Municipio Caroní" },
    { code: "VE.06.0702", name: "Municipio Cedeño" },
    { code: "VE.06.0703", name: "Municipio El Callao" },
    { code: "VE.06.0704", name: "Municipio Gran Sabana" },
    { code: "VE.06.0705", name: "Municipio Heres" },
    { code: "VE.06.0706", name: "Municipio Piar" },
    { code: "VE.06.0707", name: "Bolivariano Angostura" },
    { code: "VE.06.0708", name: "Municipio Roscio" },
    { code: "VE.06.0709", name: "Municipio Sifontes" },
    { code: "VE.06.0710", name: "Municipio Sucre" },
    { code: "VE.06.0711", name: "Municipio Padre Pedro Chien" },
  ],
  "VE.07": [
    { code: "VE.07.0801", name: "Municipio Bejuma" },
    { code: "VE.07.0802", name: "Municipio Carlos Arvelo" },
    { code: "VE.07.0803", name: "Municipio Diego Ibarra" },
    { code: "VE.07.0804", name: "Municipio Guacara" },
    { code: "VE.07.0805", name: "Municipio Juan José Mora" },
    { code: "VE.07.0806", name: "Municipio Libertador" },
    { code: "VE.07.0807", name: "Municipio Los Guayos" },
    { code: "VE.07.0808", name: "Municipio Miranda" },
    { code: "VE.07.0809", name: "Municipio Montalbán" },
    { code: "VE.07.0810", name: "Municipio Naguanagua" },
    { code: "VE.07.0811", name: "Municipio Puerto Cabello" },
    { code: "VE.07.0812", name: "Municipio San Diego" },
    { code: "VE.07.0813", name: "Municipio San Joaquín" },
    { code: "VE.07.0814", name: "Municipio Valencia" },
  ],
  "VE.08": [
    { code: "VE.08.0901", name: "Municipio Anzoátegui" },
    { code: "VE.08.0902", name: "Municipio Falcón" },
    { code: "VE.08.0903", name: "Municipio Girardot" },
    { code: "VE.08.0904", name: "Municipio Lima Blanco" },
    { code: "VE.08.0905", name: "Municipio Pao de San Juan Bautista" },
    { code: "VE.08.0906", name: "Municipio Ricaurte" },
    { code: "VE.08.0907", name: "Municipio Rómulo Gallegos" },
    { code: "VE.08.0908", name: "Municipio San Carlos" },
    { code: "VE.08.0909", name: "Municipio Tinaco" },
  ],
  "VE.09": [
    { code: "VE.09.1001", name: "Municipio Antonio Díaz" },
    { code: "VE.09.1002", name: "Municipio Casacoima" },
    { code: "VE.09.1003", name: "Municipio Pedernales" },
    { code: "VE.09.1004", name: "Municipio Tucupita" },
  ],
  "VE.11": [
    { code: "VE.11.1101", name: "Municipio Acosta" },
    { code: "VE.11.1102", name: "Municipio Bolívar" },
    { code: "VE.11.1103", name: "Municipio Buchivacoa" },
    { code: "VE.11.1104", name: "Municipio Cacique Manaure" },
    { code: "VE.11.1105", name: "Municipio Carirubana" },
    { code: "VE.11.1106", name: "Municipio Colina" },
    { code: "VE.11.1107", name: "Municipio Dabajuro" },
    { code: "VE.11.1108", name: "Municipio Democracia" },
    { code: "VE.11.1109", name: "Municipio Falcón" },
    { code: "VE.11.1110", name: "Municipio Federación" },
    { code: "VE.11.1111", name: "Municipio Jacura" },
    { code: "VE.11.1112", name: "Municipio Los Taques" },
    { code: "VE.11.1113", name: "Municipio Mauroa" },
    { code: "VE.11.1114", name: "Municipio Miranda" },
    { code: "VE.11.1115", name: "Municipio Monseñor Iturriza" },
    { code: "VE.11.1116", name: "Municipio Palmasola" },
    { code: "VE.11.1117", name: "Municipio Petit" },
    { code: "VE.11.1118", name: "Municipio Píritu" },
    { code: "VE.11.1119", name: "Municipio San Francisco" },
    { code: "VE.11.1120", name: "Municipio Silva" },
    { code: "VE.11.1121", name: "Municipio Sucre" },
    { code: "VE.11.1122", name: "Municipio Tocópero" },
    { code: "VE.11.1123", name: "Municipio Unión" },
    { code: "VE.11.1124", name: "Municipio Urumaco" },
    { code: "VE.11.1125", name: "Municipio Zamora" },
  ],
  "VE.12": [
    { code: "VE.12.1201", name: "Municipio Camaguán" },
    { code: "VE.12.1202", name: "Municipio Chaguaramas" },
    { code: "VE.12.1203", name: "Municipio El Socorro" },
    { code: "VE.12.1204", name: "Municipio San Gerónimo de Guayabal" },
    { code: "VE.12.1205", name: "Municipio Leonardo Infante" },
    { code: "VE.12.1206", name: "Municipio Las Mercedes" },
    { code: "VE.12.1207", name: "Municipio Julián Mellado" },
    { code: "VE.12.1208", name: "Municipio Francisco de Miranda" },
    { code: "VE.12.1209", name: "Municipio José Tadeo Monagas" },
    { code: "VE.12.1210", name: "Municipio Ortiz" },
    { code: "VE.12.1211", name: "Municipio José Félix Ribas" },
    { code: "VE.12.1212", name: "Municipio Juan Germán Roscio" },
    { code: "VE.12.1213", name: "Municipio San José de Guaribe" },
    { code: "VE.12.1214", name: "Municipio Santa María de Ipire" },
    { code: "VE.12.1215", name: "Municipio Pedro Zaraza" },
  ],
  "VE.13": [
    { code: "VE.13.1301", name: "Municipio Andrés Eloy Blanco" },
    { code: "VE.13.1302", name: "Municipio Crespo" },
    { code: "VE.13.1303", name: "Municipio Iribarren" },
    { code: "VE.13.1304", name: "Municipio Jiménez" },
    { code: "VE.13.1305", name: "Municipio Morán" },
    { code: "VE.13.1306", name: "Municipio Palavecino" },
    { code: "VE.13.1307", name: "Municipio Simón Planas" },
    { code: "VE.13.1308", name: "Municipio Torres" },
    { code: "VE.13.1309", name: "Municipio Urdaneta" },
  ],
  "VE.14": [
    { code: "VE.14.1401", name: "Municipio Alberto Adriani" },
    { code: "VE.14.1402", name: "Municipio Andrés Bello" },
    { code: "VE.14.1403", name: "Municipio Antonio Pinto Salinas" },
    { code: "VE.14.1404", name: "Municipio Aricagua" },
    { code: "VE.14.1405", name: "Municipio Arzobispo Chacón" },
    { code: "VE.14.1406", name: "Municipio Campo Elías" },
    { code: "VE.14.1407", name: "Municipio Caracciolo Parra Olmedo" },
    { code: "VE.14.1408", name: "Municipio Cardenal Quintero" },
    { code: "VE.14.1409", name: "Municipio Guaraque" },
    { code: "VE.14.1410", name: "Municipio Julio César Salas" },
    { code: "VE.14.1411", name: "Municipio Justo Briceño" },
    { code: "VE.14.1412", name: "Municipio Libertador" },
    { code: "VE.14.1413", name: "Municipio Miranda" },
    { code: "VE.14.1414", name: "Municipio Obispo Ramos de Lora" },
    { code: "VE.14.1415", name: "Municipio Padre Noguera" },
    { code: "VE.14.1416", name: "Municipio Pueblo Llano" },
    { code: "VE.14.1417", name: "Municipio Rangel" },
    { code: "VE.14.1418", name: "Municipio Rivas Dávila" },
    { code: "VE.14.1419", name: "Municipio Santos Marquina" },
    { code: "VE.14.1420", name: "Municipio Sucre" },
    { code: "VE.14.1421", name: "Municipio Tovar" },
    { code: "VE.14.1422", name: "Municipio Tulio Febres Cordero" },
    { code: "VE.14.1423", name: "Municipio Zea" },
  ],
  "VE.15": [
    { code: "VE.15.1501", name: "Municipio Acevedo" },
    { code: "VE.15.1502", name: "Municipio Andrés Bello" },
    { code: "VE.15.1503", name: "Municipio Baruta" },
    { code: "VE.15.1504", name: "Municipio Brión" },
    { code: "VE.15.1505", name: "Municipio Buroz" },
    { code: "VE.15.1506", name: "Municipio Carrizal" },
    { code: "VE.15.1507", name: "Municipio Chacao" },
    { code: "VE.15.1508", name: "Municipio Cristóbal Rojas" },
    { code: "VE.15.1509", name: "Municipio El Hatillo" },
    { code: "VE.15.1510", name: "Municipio Guaicaipuro" },
    { code: "VE.15.1511", name: "Municipio Independencia" },
    { code: "VE.15.1512", name: "Municipio Lander" },
    { code: "VE.15.1513", name: "Municipio Los Salias" },
    { code: "VE.15.1514", name: "Municipio Páez" },
    { code: "VE.15.1515", name: "Municipio Paz Castillo" },
    { code: "VE.15.1516", name: "Municipio Pedro Gual" },
    { code: "VE.15.1517", name: "Municipio Plaza" },
    { code: "VE.15.1518", name: "Municipio Simón Bolívar" },
    { code: "VE.15.1519", name: "Municipio Sucre" },
    { code: "VE.15.1520", name: "Municipio Urdaneta" },
    { code: "VE.15.1521", name: "Municipio Zamora" },
  ],
  "VE.16": [
    { code: "VE.16.1601", name: "Municipio Acosta" },
    { code: "VE.16.1602", name: "Municipio Aguasay" },
    { code: "VE.16.1603", name: "Municipio Bolívar" },
    { code: "VE.16.1604", name: "Municipio Caripe" },
    { code: "VE.16.1605", name: "Municipio Cedeño" },
    { code: "VE.16.1606", name: "Municipio Ezequiel Zamora" },
    { code: "VE.16.1607", name: "Municipio Libertador" },
    { code: "VE.16.1608", name: "Municipio Maturín" },
    { code: "VE.16.1609", name: "Municipio Piar" },
    { code: "VE.16.1610", name: "Municipio Punceres" },
    { code: "VE.16.1611", name: "Municipio Santa Bárbara" },
    { code: "VE.16.1612", name: "Municipio Sotillo" },
    { code: "VE.16.1613", name: "Municipio Uracoa" },
  ],
  "VE.17": [
    { code: "VE.17.1701", name: "Municipio Antolín del Campo" },
    { code: "VE.17.1702", name: "Municipio Arismendi" },
    { code: "VE.17.1703", name: "Municipio Díaz" },
    { code: "VE.17.1704", name: "Municipio García" },
    { code: "VE.17.1705", name: "Municipio Gómez" },
    { code: "VE.17.1706", name: "Municipio Maneiro" },
    { code: "VE.17.1707", name: "Municipio Marcano" },
    { code: "VE.17.1708", name: "Municipio Mariño" },
    { code: "VE.17.1709", name: "Municipio Península de Macanao" },
    { code: "VE.17.1710", name: "Municipio Tubores" },
    { code: "VE.17.1711", name: "Municipio Villalba" },
  ],
  "VE.18": [
    { code: "VE.18.1801", name: "Municipio Agua Blanca" },
    { code: "VE.18.1802", name: "Municipio Araure" },
    { code: "VE.18.1803", name: "Municipio Esteller" },
    { code: "VE.18.1804", name: "Municipio Guanare" },
    { code: "VE.18.1805", name: "Municipio Guanarito" },
    { code: "VE.18.1806", name: "Municipio Monseñor José Vicente de Unda" },
    { code: "VE.18.1807", name: "Municipio Ospino" },
    { code: "VE.18.1808", name: "Municipio Páez" },
    { code: "VE.18.1809", name: "Municipio Papelón" },
    { code: "VE.18.1810", name: "Municipio San Genaro de Boconoito" },
    { code: "VE.18.1811", name: "Municipio San Rafael de Onoto" },
    { code: "VE.18.1812", name: "Municipio Santa Rosalía" },
    { code: "VE.18.1813", name: "Municipio Sucre" },
    { code: "VE.18.1814", name: "Municipio Turén" },
  ],
  "VE.19": [
    { code: "VE.19.1901", name: "Municipio Andrés Eloy Blanco" },
    { code: "VE.19.1902", name: "Municipio Andrés Mata" },
    { code: "VE.19.1903", name: "Municipio Arismendi" },
    { code: "VE.19.1904", name: "Municipio Benítez" },
    { code: "VE.19.1905", name: "Municipio Bermúdez" },
    { code: "VE.19.1906", name: "Municipio Bolívar" },
    { code: "VE.19.1907", name: "Municipio Cajigal" },
    { code: "VE.19.1908", name: "Municipio Cruz Salmerón Acosta" },
    { code: "VE.19.1909", name: "Municipio Libertador" },
    { code: "VE.19.1910", name: "Municipio Mariño" },
    { code: "VE.19.1911", name: "Municipio Mejía" },
    { code: "VE.19.1912", name: "Municipio Montes" },
    { code: "VE.19.1913", name: "Municipio Ribero" },
    { code: "VE.19.1914", name: "Municipio Sucre" },
    { code: "VE.19.1915", name: "Municipio Valdez" },
  ],
  "VE.20": [
    { code: "VE.20.2001", name: "Municipio Andrés Bello" },
    { code: "VE.20.2002", name: "Municipio Antonio Rómulo Costa" },
    { code: "VE.20.2003", name: "Municipio Ayacucho" },
    { code: "VE.20.2004", name: "Municipio Bolívar" },
    { code: "VE.20.2005", name: "Municipio Cárdenas" },
    { code: "VE.20.2006", name: "Municipio Córdoba" },
    { code: "VE.20.2007", name: "Municipio Fernández Feo" },
    { code: "VE.20.2008", name: "Municipio Francisco de Miranda" },
    { code: "VE.20.2009", name: "Municipio García de Hevia" },
    { code: "VE.20.2010", name: "Municipio Guásimos" },
    { code: "VE.20.2011", name: "Municipio Independencia" },
    { code: "VE.20.2012", name: "Municipio Jáuregui" },
    { code: "VE.20.2013", name: "Municipio José María Vargas" },
    { code: "VE.20.2014", name: "Municipio Junín" },
    { code: "VE.20.2015", name: "Municipio Libertad" },
    { code: "VE.20.2016", name: "Municipio Libertador" },
    { code: "VE.20.2017", name: "Municipio Lobatera" },
    { code: "VE.20.2018", name: "Municipio Michelena" },
    { code: "VE.20.2019", name: "Municipio Panamericano" },
    { code: "VE.20.2020", name: "Municipio Pedro María Ureña" },
    { code: "VE.20.2021", name: "Municipio Rafael Urdaneta" },
    { code: "VE.20.2022", name: "Municipio Samuel Darío Maldonado" },
    { code: "VE.20.2023", name: "Municipio San Cristóbal" },
    { code: "VE.20.2024", name: "Municipio Seboruco" },
    { code: "VE.20.2025", name: "Municipio Simón Rodríguez" },
    { code: "VE.20.2026", name: "Municipio Sucre" },
    { code: "VE.20.2027", name: "Municipio Torbes" },
    { code: "VE.20.2028", name: "Municipio Uribante" },
    { code: "VE.20.2029", name: "Municipio San Judas Tadeo" },
  ],
  "VE.21": [
    { code: "VE.21.2101", name: "Municipio Andrés Bello" },
    { code: "VE.21.2102", name: "Municipio Boconó" },
    { code: "VE.21.2103", name: "Municipio Bolívar" },
    { code: "VE.21.2104", name: "Municipio Candelaria" },
    { code: "VE.21.2105", name: "Municipio Carache" },
    { code: "VE.21.2106", name: "Municipio Escuque" },
    { code: "VE.21.2107", name: "Municipio José Felipe Márquez Cañizales" },
    { code: "VE.21.2108", name: "Municipio Juan Vicente Campo Elías" },
    { code: "VE.21.2109", name: "Municipio La Ceiba" },
    { code: "VE.21.2110", name: "Municipio Miranda" },
    { code: "VE.21.2111", name: "Municipio Monte Carmelo" },
    { code: "VE.21.2112", name: "Municipio Motatán" },
    { code: "VE.21.2113", name: "Municipio Pampán" },
    { code: "VE.21.2114", name: "Municipio Pampanito" },
    { code: "VE.21.2115", name: "Municipio Rafael Rangel" },
    { code: "VE.21.2116", name: "Municipio San Rafael de Carvajal" },
    { code: "VE.21.2117", name: "Municipio Sucre" },
    { code: "VE.21.2118", name: "Municipio Trujillo" },
    { code: "VE.21.2119", name: "Municipio Urdaneta" },
    { code: "VE.21.2120", name: "Municipio Valera" },
  ],
  "VE.22": [
    { code: "VE.22.2201", name: "Municipio Arístides Bastidas" },
    { code: "VE.22.2202", name: "Municipio Bolívar" },
    { code: "VE.22.2203", name: "Municipio Bruzual" },
    { code: "VE.22.2204", name: "Municipio Cocorote" },
    { code: "VE.22.2205", name: "Municipio Independencia" },
    { code: "VE.22.2206", name: "Municipio José Antonio Páez" },
    { code: "VE.22.2207", name: "Municipio La Trinidad" },
    { code: "VE.22.2208", name: "Municipio Manuel Monge" },
    { code: "VE.22.2209", name: "Municipio Nirgua" },
    { code: "VE.22.2210", name: "Municipio Peña" },
    { code: "VE.22.2211", name: "Municipio San Felipe" },
    { code: "VE.22.2212", name: "Municipio Sucre" },
    { code: "VE.22.2213", name: "Municipio Urachiche" },
    { code: "VE.22.2214", name: "Municipio Veroes" },
  ],
  "VE.23": [
    { code: "VE.23.2301", name: "Municipio Almirante Padilla" },
    { code: "VE.23.2302", name: "Municipio Baralt" },
    { code: "VE.23.2303", name: "Municipio Cabimas" },
    { code: "VE.23.2304", name: "Municipio Catatumbo" },
    { code: "VE.23.2305", name: "Municipio Colón" },
    { code: "VE.23.2306", name: "Municipio Francisco Javier Pulgar" },
    { code: "VE.23.2307", name: "Municipio Jesús Enrique Lossada" },
    { code: "VE.23.2308", name: "Municipio Jesús María Semprún" },
    { code: "VE.23.2309", name: "Municipio La Cañada de Urdaneta" },
    { code: "VE.23.2310", name: "Municipio Lagunillas" },
    { code: "VE.23.2311", name: "Municipio Machiques de Perijá" },
    { code: "VE.23.2312", name: "Municipio Mara" },
    { code: "VE.23.2313", name: "Municipio Maracaibo" },
    { code: "VE.23.2314", name: "Municipio Miranda" },
    { code: "VE.23.2315", name: "Municipio Páez" },
    { code: "VE.23.2316", name: "Municipio Rosario de Perijá" },
    { code: "VE.23.2317", name: "Municipio San Francisco" },
    { code: "VE.23.2318", name: "Municipio Santa Rita" },
    { code: "VE.23.2319", name: "Municipio Simón Bolívar" },
    { code: "VE.23.2320", name: "Municipio Sucre" },
    { code: "VE.23.2321", name: "Municipio Valmore Rodríguez" },
  ],
  "VE.25": [
    { code: "VE.25.0101", name: "Municipio Libertador" },
  ],
  "VE.26": [
    { code: "VE.26.2401", name: "Municipio Vargas" },
  ],
  "VI.010": [
    { code: "VI.010.04600", name: "Anna's Hope Village" },
    { code: "VI.010.20800", name: "Christiansted" },
    { code: "VI.010.31600", name: "East End" },
    { code: "VI.010.38800", name: "Frederiksted" },
    { code: "VI.010.59500", name: "Northcentral" },
    { code: "VI.010.62200", name: "Northwest" },
    { code: "VI.010.71200", name: "Sion Farm" },
    { code: "VI.010.73900", name: "Southcentral" },
    { code: "VI.010.75700", name: "Southwest" },
  ],
  "VI.020": [
    { code: "VI.020.15400", name: "Central" },
    { code: "VI.020.27100", name: "Coral Bay" },
    { code: "VI.020.28900", name: "Cruz Bay" },
    { code: "VI.020.33400", name: "East End" },
  ],
  "VI.030": [
    { code: "VI.030.17200", name: "Charlotte Amalie" },
    { code: "VI.030.34300", name: "East End" },
    { code: "VI.030.61300", name: "Northside" },
    { code: "VI.030.74800", name: "Southside" },
    { code: "VI.030.78400", name: "Tutu" },
    { code: "VI.030.82000", name: "Water Island" },
    { code: "VI.030.82900", name: "West End" },
  ],
  "VN.01": [
    { code: "VN.01.883", name: "Long Xuyên City" },
    { code: "VN.01.884", name: "Thành phố Châu Đốc" },
    { code: "VN.01.886", name: "Huyện An Phú" },
    { code: "VN.01.887", name: "Thị Xã Tân Châu" },
    { code: "VN.01.888", name: "Huyện Phú Tân" },
    { code: "VN.01.889", name: "Huyện Châu Phú" },
    { code: "VN.01.890", name: "Huyện Tịnh Biên" },
    { code: "VN.01.891", name: "Huyện Tri Tôn" },
    { code: "VN.01.892", name: "Huyện Châu Thành" },
    { code: "VN.01.893", name: "Huyện Chợ Mới" },
    { code: "VN.01.894", name: "Huyện Thoại Sơn" },
  ],
  "VN.03": [
    { code: "VN.03.829", name: "Thành Phố Bến Tre" },
    { code: "VN.03.831", name: "Huyện Châu Thành" },
    { code: "VN.03.832", name: "Huyện Chợ Lách" },
    { code: "VN.03.833", name: "Huyện Mỏ Cày Nam" },
    { code: "VN.03.834", name: "Huyện Giồng Trôm" },
    { code: "VN.03.835", name: "Huyện Bình Đại" },
    { code: "VN.03.836", name: "Huyện Ba Tri" },
    { code: "VN.03.837", name: "Huyện Thạnh Phú" },
    { code: "VN.03.838", name: "Huyện Mỏ Cày Bắc" },
  ],
  "VN.05": [
    { code: "VN.05.040", name: "Thành Phố Cao Bằng" },
    { code: "VN.05.042", name: "Huyện Bảo Lâm" },
    { code: "VN.05.043", name: "Huyện Bảo Lac" },
    { code: "VN.05.044", name: "Huyện Thông Nông" },
    { code: "VN.05.045", name: "Huyện Hà Quảng" },
    { code: "VN.05.046", name: "Huyện Trà Lĩnh" },
    { code: "VN.05.047", name: "Huyện Trùng Khánh" },
    { code: "VN.05.048", name: "Huyện Hạ Lang" },
    { code: "VN.05.049", name: "Huyện Quảng Uyên" },
    { code: "VN.05.050", name: "Huyen Phuc Hoa" },
    { code: "VN.05.051", name: "Huyện Hòa An" },
    { code: "VN.05.052", name: "Huyện Nguyên Bình" },
    { code: "VN.05.053", name: "Huyện Thạch An" },
  ],
  "VN.09": [
    { code: "VN.09.866", name: "Thành Phố Cao Lãnh" },
    { code: "VN.09.867", name: "Sa Dec city" },
    { code: "VN.09.868", name: "Thị Xã Hồng Ngự" },
    { code: "VN.09.869", name: "Huyện Tân Hồng" },
    { code: "VN.09.870", name: "Huyện Hồng Ngự" },
    { code: "VN.09.871", name: "Huyện Tam Nông" },
    { code: "VN.09.872", name: "Huyện Tháp Mười" },
    { code: "VN.09.873", name: "Huyện Cao Lãnh" },
    { code: "VN.09.874", name: "Huyện Thanh Bình" },
    { code: "VN.09.875", name: "Huyện Lấp Vò" },
    { code: "VN.09.876", name: "Huyện Lai Vung" },
    { code: "VN.09.877", name: "Huyện Châu Thành" },
  ],
  "VN.13": [
    { code: "VN.13.303", name: "Quận Hồng Bàng" },
    { code: "VN.13.304", name: "Quận Ngô Quyền" },
    { code: "VN.13.305", name: "Quận Lê Chân" },
    { code: "VN.13.306", name: "Quận Hải An" },
    { code: "VN.13.307", name: "Quận Kiến An" },
    { code: "VN.13.308", name: "Quận Đồ Sơn" },
    { code: "VN.13.309", name: "Quận Dương Kinh" },
    { code: "VN.13.311", name: "Huyện Thủy Nguyên" },
    { code: "VN.13.312", name: "Huyện An Dương" },
    { code: "VN.13.313", name: "Huyện An Lão" },
    { code: "VN.13.314", name: "Huyện Kiến Thụy" },
    { code: "VN.13.315", name: "Huyện Tiên Lãng" },
    { code: "VN.13.316", name: "Huyện Vĩnh Bảo" },
    { code: "VN.13.317", name: "Huyện Cát Hải" },
    { code: "VN.13.318", name: "Huyện Bạch Long Vỹ" },
  ],
  "VN.20": [
    { code: "VN.20.760", name: "Quận Một" },
    { code: "VN.20.761", name: "Quận 12" },
    { code: "VN.20.762", name: "Quận Thủ Đức" },
    { code: "VN.20.763", name: "Quận Chín" },
    { code: "VN.20.764", name: "Quận Gò Vấp" },
    { code: "VN.20.765", name: "Quận Bình Thạnh" },
    { code: "VN.20.766", name: "Quận Tân Bình" },
    { code: "VN.20.767", name: "Tân Phú" },
    { code: "VN.20.768", name: "Phu Nhuan" },
    { code: "VN.20.769", name: "Quận Hai" },
    { code: "VN.20.770", name: "Quận Ba" },
    { code: "VN.20.771", name: "Quận Mười" },
    { code: "VN.20.772", name: "Quận Mười Một" },
    { code: "VN.20.773", name: "Quận Bốn" },
    { code: "VN.20.774", name: "Quận Năm" },
    { code: "VN.20.775", name: "Quận Sáu" },
    { code: "VN.20.776", name: "Quận Tám" },
    { code: "VN.20.777", name: "Quận Bình Tân" },
    { code: "VN.20.778", name: "Quận Bảy" },
    { code: "VN.20.783", name: "Huyện Củ Chi" },
    { code: "VN.20.784", name: "Huyện Hóc Môn" },
    { code: "VN.20.785", name: "Huyện Bình Chánh" },
    { code: "VN.20.786", name: "Huyện Nhà Bè" },
    { code: "VN.20.787", name: "Huyện Cần Giờ" },
  ],
  "VN.21": [
    { code: "VN.21.899", name: "Thành Phố Rạch Giá" },
    { code: "VN.21.900", name: "Thị Xã Hà Tiên" },
    { code: "VN.21.902", name: "Kien Luong Town" },
    { code: "VN.21.903", name: "Huyện Hòn Đất" },
    { code: "VN.21.904", name: "Huyện Tân Hiệp" },
    { code: "VN.21.905", name: "Huyện Châu Thành" },
    { code: "VN.21.906", name: "Huyện Giồng Riềng" },
    { code: "VN.21.907", name: "Huyện Gò Quao" },
    { code: "VN.21.908", name: "Huyện An Biên" },
    { code: "VN.21.909", name: "Huyện An Minh" },
    { code: "VN.21.910", name: "Huyện Vĩnh Thuận" },
    { code: "VN.21.911", name: "Huyện Phú Quốc" },
    { code: "VN.21.912", name: "Huyện Kiên Hải" },
    { code: "VN.21.913", name: "Huyện U Minh Thượng" },
    { code: "VN.21.914", name: "Huyện Giang Thành" },
  ],
  "VN.23": [
    { code: "VN.23.672", name: "Thành Phố Đà Lạt" },
    { code: "VN.23.673", name: "Thành Phố Bảo Lộc" },
    { code: "VN.23.674", name: "Đam Rong" },
    { code: "VN.23.675", name: "Huyện Lạc Dương" },
    { code: "VN.23.676", name: "Huyện Lâm Hà" },
    { code: "VN.23.677", name: "Huyện Đơn Dương" },
    { code: "VN.23.678", name: "Huyện Đức Trọng" },
    { code: "VN.23.679", name: "Huyện Di Linh" },
    { code: "VN.23.680", name: "Huyện Bảo Lâm" },
    { code: "VN.23.681", name: "Huyện Đạ Huoai" },
    { code: "VN.23.682", name: "Huyện Đạ Tẻh" },
    { code: "VN.23.683", name: "Huyện Cát Tiên" },
  ],
  "VN.24": [
    { code: "VN.24.794", name: "Thành Phố Tân An" },
    { code: "VN.24.795", name: "Thị Xã Kiến Tường" },
    { code: "VN.24.796", name: "Huyện Tân Hưng" },
    { code: "VN.24.797", name: "Huyện Vĩnh Hưng" },
    { code: "VN.24.798", name: "Huyện Mộc Hóa" },
    { code: "VN.24.799", name: "Huyện Tân Thạnh" },
    { code: "VN.24.800", name: "Huyện Thạnh Hóa" },
    { code: "VN.24.801", name: "Huyện Đức Huệ" },
    { code: "VN.24.802", name: "Huyện Đức Hòa" },
    { code: "VN.24.803", name: "Huyện Bến Lức" },
    { code: "VN.24.804", name: "Huyện Thủ Thừa" },
    { code: "VN.24.805", name: "Huyện Tân Trụ" },
    { code: "VN.24.806", name: "Huyện Cần Đước" },
    { code: "VN.24.807", name: "Huyện Cần Giuộc" },
    { code: "VN.24.808", name: "Huyện Châu Thành" },
  ],
  "VN.30": [
    { code: "VN.30.193", name: "Hạ Long District" },
    { code: "VN.30.194", name: "Thành Phố Móng Cái" },
    { code: "VN.30.195", name: "Cẩm Phả District" },
    { code: "VN.30.196", name: "Thành Phố Uông Bí" },
    { code: "VN.30.198", name: "Huyện Bình Liêu" },
    { code: "VN.30.199", name: "Huyện Tiên Yên" },
    { code: "VN.30.200", name: "Huyện Đầm Hà" },
    { code: "VN.30.201", name: "Huyện Hải Hà" },
    { code: "VN.30.202", name: "Huyện Ba Chẽ" },
    { code: "VN.30.203", name: "Huyện Vân Đồn" },
    { code: "VN.30.204", name: "Huyện Hoành Bồ" },
    { code: "VN.30.205", name: "Huyện Đông Triều" },
    { code: "VN.30.206", name: "Thị Xã Quảng Yên" },
    { code: "VN.30.207", name: "Huyện Cô Tô" },
  ],
  "VN.32": [
    { code: "VN.32.116", name: "Thành Phố Sơn La" },
    { code: "VN.32.118", name: "Huyện Quỳnh Nhai" },
    { code: "VN.32.119", name: "Huyện Thuận Châu" },
    { code: "VN.32.120", name: "Huyện Mường La" },
    { code: "VN.32.121", name: "Huyện Bắc Yên" },
    { code: "VN.32.122", name: "Huyện Phù Yên" },
    { code: "VN.32.123", name: "Huyện Mộc Châu" },
    { code: "VN.32.124", name: "Huyện Yên Châu" },
    { code: "VN.32.125", name: "Huyện Mai Sơn" },
    { code: "VN.32.126", name: "Huyện Sông Mã" },
    { code: "VN.32.127", name: "Huyen Sop Cop" },
    { code: "VN.32.128", name: "Huyện Vân Hồ" },
  ],
  "VN.33": [
    { code: "VN.33.703", name: "Thành Phố Tây Ninh" },
    { code: "VN.33.705", name: "Huyện Tân Biên" },
    { code: "VN.33.706", name: "Huyện Tân Châu" },
    { code: "VN.33.707", name: "Huyện Dương Minh Châu" },
    { code: "VN.33.708", name: "Huyện Châu Thành" },
    { code: "VN.33.709", name: "Huyện Hòa Thành" },
    { code: "VN.33.710", name: "Huyện Gò Dầu" },
    { code: "VN.33.711", name: "Huyện Bến Cầu" },
    { code: "VN.33.712", name: "Huyện Trảng Bàng" },
  ],
  "VN.34": [
    { code: "VN.34.380", name: "Thành Phố Thanh Hóa" },
    { code: "VN.34.381", name: "Thị Xã Bỉm Sơn" },
    { code: "VN.34.382", name: "Thị Xã Sầm Sơn" },
    { code: "VN.34.384", name: "Huyện Mường Lát" },
    { code: "VN.34.385", name: "Huyện Quan Hóa" },
    { code: "VN.34.386", name: "Huyện Bá Thước" },
    { code: "VN.34.387", name: "Huyện Quan Sơn" },
    { code: "VN.34.388", name: "Huyện Lang Chánh" },
    { code: "VN.34.389", name: "Huyện Ngọc Lặc" },
    { code: "VN.34.390", name: "Huyện Cẩm Thủy" },
    { code: "VN.34.391", name: "Huyện Thạch Thành" },
    { code: "VN.34.392", name: "Huyện Hà Trung" },
    { code: "VN.34.393", name: "Huyện Vĩnh Lộc" },
    { code: "VN.34.394", name: "Huyện Yên Định" },
    { code: "VN.34.395", name: "Huyện Thọ Xuân" },
    { code: "VN.34.396", name: "Huyện Thường Xuân" },
    { code: "VN.34.397", name: "Huyện Triệu Sơn" },
    { code: "VN.34.398", name: "Huyện Thiệu Hóa" },
    { code: "VN.34.399", name: "Huyện Hoằng Hóa" },
    { code: "VN.34.400", name: "Huyện Hậu Lộc" },
    { code: "VN.34.401", name: "Huyện Nga Sơn" },
    { code: "VN.34.402", name: "Huyện Như Xuân" },
    { code: "VN.34.403", name: "Huyện Như Thanh" },
    { code: "VN.34.404", name: "Huyện Nông Cống" },
    { code: "VN.34.405", name: "Huyện Đông Sơn" },
    { code: "VN.34.406", name: "Huyện Quảng Xương" },
    { code: "VN.34.407", name: "Huyện Tĩnh Gia" },
  ],
  "VN.35": [
    { code: "VN.35.336", name: "Thành Phố Thái Bình" },
    { code: "VN.35.338", name: "Huyện Quỳnh Phụ" },
    { code: "VN.35.339", name: "Huyện Hưng Hà" },
    { code: "VN.35.340", name: "Huyện Ðông Hưng" },
    { code: "VN.35.341", name: "Huyện Thái Thụy" },
    { code: "VN.35.342", name: "Huyện Tiền Hải" },
    { code: "VN.35.343", name: "Huyện Kiến Xương" },
    { code: "VN.35.344", name: "Huyện Vũ Thư" },
  ],
  "VN.37": [
    { code: "VN.37.815", name: "Thành Phố Mỹ Tho" },
    { code: "VN.37.816", name: "Thị Xã Gò Công" },
    { code: "VN.37.817", name: "Thị Xã Cai Lậy" },
    { code: "VN.37.818", name: "Huyện Tân Phước" },
    { code: "VN.37.819", name: "Huyện Cái Bè" },
    { code: "VN.37.820", name: "Huyện Cai Lậy" },
    { code: "VN.37.821", name: "Huyện Châu Thành" },
    { code: "VN.37.822", name: "Huyện Chợ Gạo" },
    { code: "VN.37.823", name: "Huyện Gò Công Tây" },
    { code: "VN.37.824", name: "Huyện Gò Công Đông" },
    { code: "VN.37.825", name: "Huyện Tân Phú Đông" },
  ],
  "VN.39": [
    { code: "VN.39.178", name: "Thành Phố Lạng Sơn" },
    { code: "VN.39.180", name: "Huyện Tràng Định" },
    { code: "VN.39.181", name: "Huyện Bình Gia" },
    { code: "VN.39.182", name: "Huyện Văn Lãng" },
    { code: "VN.39.183", name: "Huyện Cao Lộc" },
    { code: "VN.39.184", name: "Huyện Vặn Quan" },
    { code: "VN.39.185", name: "Huyện Bắc Sơn" },
    { code: "VN.39.186", name: "Huyện Hũu Lũng" },
    { code: "VN.39.187", name: "Huyện Chi Lăng" },
    { code: "VN.39.188", name: "Huyện Lộc Bình" },
    { code: "VN.39.189", name: "Huyện Đình Lập" },
  ],
  "VN.43": [
    { code: "VN.43.731", name: "Thành Phố Biên Hòa" },
    { code: "VN.43.732", name: "Thị Xã Long Khánh" },
    { code: "VN.43.734", name: "Huyện Tân Phú" },
    { code: "VN.43.735", name: "Huyện Vĩnh Cửu" },
    { code: "VN.43.736", name: "Huyện Định Quán" },
    { code: "VN.43.737", name: "Huyện Trảng Bom" },
    { code: "VN.43.738", name: "Huyện Thống Nhất" },
    { code: "VN.43.739", name: "Huyện Cẩm Mỹ" },
    { code: "VN.43.740", name: "Huyện Long Thành" },
    { code: "VN.43.741", name: "Huyện Xuân Lộc" },
    { code: "VN.43.742", name: "Huyện Nhơn Trạch" },
  ],
  "VN.44": [
    { code: "VN.44.001", name: "Quận Ba Đình" },
    { code: "VN.44.002", name: "Quận Hoàn Kiếm" },
    { code: "VN.44.003", name: "Quận Tây Hồ" },
    { code: "VN.44.004", name: "Quận Long Biên" },
    { code: "VN.44.005", name: "Quận Cầu Giấy" },
    { code: "VN.44.006", name: "Quận Đống Đa" },
    { code: "VN.44.007", name: "Quận Hai BàTrưng" },
    { code: "VN.44.008", name: "Quận Hoàng Mai" },
    { code: "VN.44.009", name: "Quận Thanh Xuân" },
    { code: "VN.44.016", name: "Huyện Sóc Sơn" },
    { code: "VN.44.017", name: "Huyện Đông Anh" },
    { code: "VN.44.018", name: "Huyện Gia Lâm" },
    { code: "VN.44.019", name: "Quận Nam Từ Liêm" },
    { code: "VN.44.020", name: "Huyện Thanh Trì" },
    { code: "VN.44.021", name: "Quận Bắc Từ Liêm" },
    { code: "VN.44.250", name: "Huyện Mê Linh" },
    { code: "VN.44.268", name: "Quận Hà Đông" },
    { code: "VN.44.269", name: "Thị Xã Sơn Tây" },
    { code: "VN.44.271", name: "Huyện Ba Vì" },
    { code: "VN.44.272", name: "Huyện Phúc Thọ" },
    { code: "VN.44.273", name: "Huyện Đan Phượng" },
    { code: "VN.44.274", name: "Huyện Hoài Đức" },
    { code: "VN.44.275", name: "Huyện Quốc Oai" },
    { code: "VN.44.276", name: "Huyện Thạch Thất" },
    { code: "VN.44.277", name: "Huyện Chương Mỹ" },
    { code: "VN.44.278", name: "Huyện Thanh Oai" },
    { code: "VN.44.279", name: "Huyện Thường Tín" },
    { code: "VN.44.280", name: "Huyện Phú Xuyên" },
    { code: "VN.44.281", name: "Huyện Ứng Hòa" },
    { code: "VN.44.282", name: "Huyện Mỹ Đức" },
  ],
  "VN.45": [
    { code: "VN.45.747", name: "Thành Phố Vũng Tàu" },
    { code: "VN.45.748", name: "Thành Phố Bà Rịa" },
    { code: "VN.45.750", name: "Huyện Châu Đức" },
    { code: "VN.45.751", name: "Huyện Xuyên Mộc" },
    { code: "VN.45.752", name: "Huyện Long Điền" },
    { code: "VN.45.753", name: "Huyện Đất Đỏ" },
    { code: "VN.45.754", name: "Huyện Tân Thành" },
    { code: "VN.45.755", name: "Huyện Côn Đảo" },
  ],
  "VN.46": [
    { code: "VN.46.540", name: "Thành Phố Quy Nhơn" },
    { code: "VN.46.542", name: "Huyện An Lão" },
    { code: "VN.46.543", name: "Huyện Hoài Nhơn" },
    { code: "VN.46.544", name: "Huyện Hoài Ân" },
    { code: "VN.46.545", name: "Huyện Phù Mỹ" },
    { code: "VN.46.546", name: "Huyện Vĩnh Thạnh" },
    { code: "VN.46.547", name: "Huyện Tây Sơn" },
    { code: "VN.46.548", name: "Phu Cat District" },
    { code: "VN.46.549", name: "Thị Xã An Nhơn" },
    { code: "VN.46.550", name: "Huyện Tuy Phước" },
    { code: "VN.46.551", name: "Huyện Vân Canh" },
  ],
  "VN.47": [
    { code: "VN.47.593", name: "Thành Phố Phan Thiết" },
    { code: "VN.47.594", name: "Thị Xã La Gi" },
    { code: "VN.47.595", name: "Huyện Tuy Phong" },
    { code: "VN.47.596", name: "Huyện Bắc Bình" },
    { code: "VN.47.597", name: "Huyện Hàm Thuận Bắc" },
    { code: "VN.47.598", name: "Huyện Hàm Thuận Nam" },
    { code: "VN.47.599", name: "Huyện Tánh Linh" },
    { code: "VN.47.600", name: "Huyện Đức Linh" },
    { code: "VN.47.601", name: "Huyện Hàm Tân" },
    { code: "VN.47.602", name: "Huyện Phú Quý" },
  ],
  "VN.49": [
    { code: "VN.49.622", name: "Thành Phố Pleiku" },
    { code: "VN.49.623", name: "Thị Xã An Khê" },
    { code: "VN.49.624", name: "Thị Xã A Yun Pa" },
    { code: "VN.49.625", name: "Huyện KBang" },
    { code: "VN.49.626", name: "Huyện Đak Đoa" },
    { code: "VN.49.627", name: "Huyện Chư Păh" },
    { code: "VN.49.628", name: "Huyện Ia Grai" },
    { code: "VN.49.629", name: "Huyện Mang Yang" },
    { code: "VN.49.630", name: "Huyện Kông Chro" },
    { code: "VN.49.631", name: "Huyện Đức Cơ" },
    { code: "VN.49.632", name: "Huyện Chư Prông" },
    { code: "VN.49.633", name: "Huyện Chư Sê" },
    { code: "VN.49.634", name: "Huyện Đak Pơ" },
    { code: "VN.49.635", name: "Huyện Ia Pa" },
    { code: "VN.49.637", name: "Huyện Krông Pa" },
    { code: "VN.49.638", name: "Huyện Phú Thiện" },
    { code: "VN.49.639", name: "Huyện Chư Pưh" },
  ],
  "VN.50": [
    { code: "VN.50.024", name: "Thành Phố Hà Giang" },
    { code: "VN.50.026", name: "Huyện Đồng Văn" },
    { code: "VN.50.027", name: "Huyện Mèo Vạc" },
    { code: "VN.50.028", name: "Huyện Yên Minh" },
    { code: "VN.50.029", name: "Huyện Quản Bạ" },
    { code: "VN.50.030", name: "Huyện Vị Xuyên" },
    { code: "VN.50.031", name: "Huyện Bắc Mê" },
    { code: "VN.50.032", name: "Huyện Hoàng Su Phì" },
    { code: "VN.50.033", name: "Huyện Xín Mần" },
    { code: "VN.50.034", name: "Huyện Bắc Quang" },
    { code: "VN.50.035", name: "Huyện Quang Bình" },
  ],
  "VN.52": [
    { code: "VN.52.436", name: "Thành Phố Hà Tĩnh" },
    { code: "VN.52.437", name: "Thị Xã Hồng Lĩnh" },
    { code: "VN.52.439", name: "Huyện Hương Sơn" },
    { code: "VN.52.440", name: "Huyện Ðức Thọ" },
    { code: "VN.52.441", name: "Huyện Vũ Quang" },
    { code: "VN.52.442", name: "Huyện Nghi Xuân" },
    { code: "VN.52.443", name: "Huyện Can Lộc" },
    { code: "VN.52.444", name: "Huyện Hương Khê" },
    { code: "VN.52.445", name: "Huyện Thạch Hà" },
    { code: "VN.52.446", name: "Huyện Cẩm Xuyên" },
    { code: "VN.52.447", name: "Huyện Kỳ Anh" },
    { code: "VN.52.448", name: "Huyện Lộc Hà" },
    { code: "VN.52.449", name: "Thị xã Kỳ Anh" },
  ],
  "VN.53": [
    { code: "VN.53.148", name: "Thành Phố Hòa Bình" },
    { code: "VN.53.150", name: "Huyện Đà Bắc" },
    { code: "VN.53.151", name: "Huyện Kỳ Sơn" },
    { code: "VN.53.152", name: "Huyện Lương Sơn" },
    { code: "VN.53.153", name: "Huyện Kim Bôi" },
    { code: "VN.53.154", name: "Huyện Cao Phong" },
    { code: "VN.53.155", name: "Huyện Tân Lạc" },
    { code: "VN.53.156", name: "Huyện Mai Châu" },
    { code: "VN.53.157", name: "Huyện Lạc Sơn" },
    { code: "VN.53.158", name: "Huyện Yên Thủy" },
    { code: "VN.53.159", name: "Huyện Lạc Thủy" },
  ],
  "VN.54": [
    { code: "VN.54.568", name: "Thành Phố Nha Trang" },
    { code: "VN.54.569", name: "Thành Phố Cam Ranh" },
    { code: "VN.54.570", name: "Huyện Cam Lâm" },
    { code: "VN.54.571", name: "Huyện Vạn Ninh" },
    { code: "VN.54.572", name: "Thị Xã Ninh Hòa" },
    { code: "VN.54.573", name: "Huyện Khánh Vĩnh" },
    { code: "VN.54.574", name: "Huyện Diên Khánh" },
    { code: "VN.54.575", name: "Huyện Khánh Sơn" },
    { code: "VN.54.576", name: "Huyện Trường Sa" },
  ],
  "VN.55": [
    { code: "VN.55.608", name: "Thành Phố Kon Tum" },
    { code: "VN.55.610", name: "Huyện Đắk Glei" },
    { code: "VN.55.611", name: "Huyện Ngọc Hồi" },
    { code: "VN.55.612", name: "Huyện Đắk Tô" },
    { code: "VN.55.613", name: "Huyện Kon Plông" },
    { code: "VN.55.614", name: "Huyện Kon Rẫy" },
    { code: "VN.55.615", name: "Huyện Đắk Hà" },
    { code: "VN.55.616", name: "Huyện Sa Thầy" },
    { code: "VN.55.617", name: "Huyện Tu Mơ Rông" },
    { code: "VN.55.618", name: "Huyện Ia H'Drai" },
  ],
  "VN.58": [
    { code: "VN.58.412", name: "Thành Phố Vinh" },
    { code: "VN.58.413", name: "Thị Xã Cửa Lò" },
    { code: "VN.58.414", name: "Thị Xã Thái Hòa" },
    { code: "VN.58.415", name: "Huyện Quế Phong" },
    { code: "VN.58.416", name: "Huyện Quỳ Châu" },
    { code: "VN.58.417", name: "Huyện Kỳ Sơn" },
    { code: "VN.58.418", name: "Huyện Tương Dương" },
    { code: "VN.58.419", name: "Huyện Nghĩa Đàn" },
    { code: "VN.58.420", name: "Huyện Quỳ Hợp" },
    { code: "VN.58.421", name: "Huyện Quỳnh Lưu" },
    { code: "VN.58.422", name: "Huyện Con Cuông" },
    { code: "VN.58.423", name: "Huyện Tân Kỳ" },
    { code: "VN.58.424", name: "Huyện Anh Sơn" },
    { code: "VN.58.425", name: "Huyện Diễn Châu" },
    { code: "VN.58.426", name: "Huyện Yên Thành" },
    { code: "VN.58.427", name: "Huyện Đô Lương" },
    { code: "VN.58.428", name: "Huyện Thanh Chương" },
    { code: "VN.58.429", name: "Huyện Nghi Lộc" },
    { code: "VN.58.430", name: "Huyện Nam Đàn" },
    { code: "VN.58.431", name: "Huyện Hưng Nguyên" },
    { code: "VN.58.432", name: "Thị Xã Hoàng Mai" },
  ],
  "VN.59": [
    { code: "VN.59.369", name: "Thành Phố Ninh Bình" },
    { code: "VN.59.370", name: "Thị Xã Tam Điệp" },
    { code: "VN.59.372", name: "Huyện Nho Quan" },
    { code: "VN.59.373", name: "Huyện Gia Viễn" },
    { code: "VN.59.374", name: "Huyện Hoa Lư" },
    { code: "VN.59.375", name: "Huyện Yên Khánh" },
    { code: "VN.59.376", name: "Huyện Kim Sơn" },
    { code: "VN.59.377", name: "Huyện Yên Mô" },
  ],
  "VN.60": [
    { code: "VN.60.582", name: "Thành Phố Phan Rang-Tháp Chàm" },
    { code: "VN.60.584", name: "Huyen Bac Ai" },
    { code: "VN.60.585", name: "Huyện Ninh Sơn" },
    { code: "VN.60.586", name: "Huyện Ninh Hải" },
    { code: "VN.60.587", name: "Huyện Ninh Phước" },
    { code: "VN.60.588", name: "Huyện Thuận Bắc" },
    { code: "VN.60.589", name: "Huyện Thuận Nam" },
  ],
  "VN.61": [
    { code: "VN.61.555", name: "Thành Phố Tuy Hòa" },
    { code: "VN.61.557", name: "Thị Xã Sông Cầu" },
    { code: "VN.61.558", name: "Huyện Đồng Xuân" },
    { code: "VN.61.559", name: "Huyện Tuy An" },
    { code: "VN.61.560", name: "Huyện Sơn Hòa" },
    { code: "VN.61.561", name: "Huyện Sông Hinh" },
    { code: "VN.61.562", name: "Huyện Tây Hoà" },
    { code: "VN.61.563", name: "Huyện Phú Hoà" },
    { code: "VN.61.564", name: "Huyện Đông Hòa" },
  ],
  "VN.62": [
    { code: "VN.62.450", name: "Thành Phố Đồng Hới" },
    { code: "VN.62.452", name: "Huyện Minh Hóa" },
    { code: "VN.62.453", name: "Huyện Tuyên Hóa" },
    { code: "VN.62.454", name: "Huyện Quảng Trạch" },
    { code: "VN.62.455", name: "Huyện Bố Trạch" },
    { code: "VN.62.456", name: "Huyện Quảng Ninh" },
    { code: "VN.62.457", name: "Huyện Lệ Thủy" },
    { code: "VN.62.458", name: "Thị xã Ba Đồn" },
  ],
  "VN.63": [
    { code: "VN.63.522", name: "Thành Phố Quảng Ngãi" },
    { code: "VN.63.524", name: "Huyện Bình Sơn" },
    { code: "VN.63.525", name: "Huyện Trà Bồng" },
    { code: "VN.63.526", name: "Huyện Tây Trà" },
    { code: "VN.63.527", name: "Huyện Sơn Tịnh" },
    { code: "VN.63.528", name: "Huyện Tư Nghĩa" },
    { code: "VN.63.529", name: "Huyện Sơn Hà" },
    { code: "VN.63.530", name: "Huyện Sơn Tây" },
    { code: "VN.63.531", name: "Huyện Minh Long" },
    { code: "VN.63.532", name: "Huyện Nghĩa Hành" },
    { code: "VN.63.533", name: "Huyện Mộ Đức" },
    { code: "VN.63.534", name: "Huyện Đức Phổ" },
    { code: "VN.63.535", name: "Huyện Ba Tơ" },
    { code: "VN.63.536", name: "Huyện Lý Sơn" },
  ],
  "VN.64": [
    { code: "VN.64.461", name: "Thành Phố Đông Hà" },
    { code: "VN.64.462", name: "Thị Xã Quảng Trị" },
    { code: "VN.64.464", name: "Huyện Vĩnh Linh" },
    { code: "VN.64.465", name: "Huyện Hướng Hóa" },
    { code: "VN.64.466", name: "Huyện Gio Linh" },
    { code: "VN.64.467", name: "Huyện Đa Krông" },
    { code: "VN.64.468", name: "Huyện Cam Lộ" },
    { code: "VN.64.469", name: "Huyện Triệu Phong" },
    { code: "VN.64.470", name: "Huyện Hải Lăng" },
    { code: "VN.64.471", name: "Huyện Cồn Cỏ" },
  ],
  "VN.65": [
    { code: "VN.65.941", name: "Thành Phố Sóc Trăng" },
    { code: "VN.65.942", name: "Huyện Châu Thành" },
    { code: "VN.65.943", name: "Huyện Kế Sách" },
    { code: "VN.65.944", name: "Huyện Mỹ Tú" },
    { code: "VN.65.945", name: "Huyện Cù Lao Dung" },
    { code: "VN.65.946", name: "Huyện Long Phú" },
    { code: "VN.65.947", name: "Huyện Mỹ Xuyên" },
    { code: "VN.65.948", name: "Huyen Nga Nam" },
    { code: "VN.65.949", name: "Huyện Thạnh Trị" },
    { code: "VN.65.950", name: "Thị Xã Vĩnh Châu" },
    { code: "VN.65.951", name: "Huyện Trần Đề" },
  ],
  "VN.66": [
    { code: "VN.66.474", name: "Thành Phố Huế" },
    { code: "VN.66.476", name: "Huyện Phong Điền" },
    { code: "VN.66.477", name: "Huyện Quảng Ðiền" },
    { code: "VN.66.478", name: "Huyện Phú Vang" },
    { code: "VN.66.479", name: "Thị Xã Hương Thủy" },
    { code: "VN.66.480", name: "Thị Xã Hương Trà" },
    { code: "VN.66.481", name: "Huyện A Lưới" },
    { code: "VN.66.482", name: "Huyện Phú Lộc" },
    { code: "VN.66.483", name: "Huyện Nam Đông" },
  ],
  "VN.67": [
    { code: "VN.67.842", name: "Thành Phố Trà Vinh" },
    { code: "VN.67.844", name: "Huyện Càng Long" },
    { code: "VN.67.845", name: "Huyện Cầu Kè" },
    { code: "VN.67.846", name: "Huyện Tiểu Cần" },
    { code: "VN.67.847", name: "Huyện Châu Thành" },
    { code: "VN.67.848", name: "Huyện Cầu Ngang" },
    { code: "VN.67.849", name: "Huyện Trà Cú" },
    { code: "VN.67.850", name: "Huyện Duyên Hải" },
    { code: "VN.67.851", name: "Thị xã Duyên Hải" },
  ],
  "VN.68": [
    { code: "VN.68.070", name: "Thành Phố Tuyên Quang" },
    { code: "VN.68.071", name: "Huyện Lâm Bình" },
    { code: "VN.68.072", name: "Huyện Na Hang" },
    { code: "VN.68.073", name: "Huyện Chiêm Hóa" },
    { code: "VN.68.074", name: "Huyện Hàm Yên" },
    { code: "VN.68.075", name: "Huyện Yên Sơn" },
    { code: "VN.68.076", name: "Huyện Sơn Dương" },
  ],
  "VN.69": [
    { code: "VN.69.855", name: "Thành Phố Vĩnh Long" },
    { code: "VN.69.857", name: "Huyện Long Hồ" },
    { code: "VN.69.858", name: "Huyện Mang Thít" },
    { code: "VN.69.859", name: "Huyện Vũng Liêm" },
    { code: "VN.69.860", name: "Huyện Tam Bình" },
    { code: "VN.69.861", name: "Thị Xã Bình Minh" },
    { code: "VN.69.862", name: "Huyện Trà Ôn" },
    { code: "VN.69.863", name: "Huyện Bình Tân" },
  ],
  "VN.70": [
    { code: "VN.70.132", name: "Thành Phố Yên Bái" },
    { code: "VN.70.133", name: "Thị Xã Nghĩa Lộ" },
    { code: "VN.70.135", name: "Huyện Lục Yên" },
    { code: "VN.70.136", name: "Huyện Văn Yên" },
    { code: "VN.70.137", name: "Huyện Mù Cang Chải" },
    { code: "VN.70.138", name: "Huyện Trấn Yên" },
    { code: "VN.70.139", name: "Huyện Trạm Tấu" },
    { code: "VN.70.140", name: "Huyện Văn Chấn" },
    { code: "VN.70.141", name: "Huyện Yên Bình" },
  ],
  "VN.71": [
    { code: "VN.71.213", name: "Thành phố Bắc Giang" },
    { code: "VN.71.215", name: "Huyện Yên Thế" },
    { code: "VN.71.216", name: "Huyện Tân Yên" },
    { code: "VN.71.217", name: "Huyện Lạng Giang" },
    { code: "VN.71.218", name: "Huyện Lục Nam" },
    { code: "VN.71.219", name: "Huyện Lục Ngạn" },
    { code: "VN.71.220", name: "Huyện Sơn Động" },
    { code: "VN.71.221", name: "Huyện Yên Dũng" },
    { code: "VN.71.222", name: "Huyện Việt Yên" },
    { code: "VN.71.223", name: "Huyện Hiệp Hòa" },
  ],
  "VN.72": [
    { code: "VN.72.058", name: "Thị Xã Bắc Kạn" },
    { code: "VN.72.060", name: "Huyện Pác Nặm" },
    { code: "VN.72.061", name: "Huyện Ba Bể" },
    { code: "VN.72.062", name: "Huyện Ngân Sơn" },
    { code: "VN.72.063", name: "Huyện Bạch Thông" },
    { code: "VN.72.064", name: "Huyện Chợ Đồn" },
    { code: "VN.72.065", name: "Huyện Chợ Mới" },
    { code: "VN.72.066", name: "Huyện Na Rì" },
  ],
  "VN.73": [
    { code: "VN.73.954", name: "Thành phố Bạc Liêu" },
    { code: "VN.73.956", name: "Huyện Hồng Dân" },
    { code: "VN.73.957", name: "Huyện Phước Long" },
    { code: "VN.73.958", name: "Huyện Vĩnh Lợi" },
    { code: "VN.73.959", name: "Huyện Giá Rai" },
    { code: "VN.73.960", name: "Huyện Đông Hải" },
    { code: "VN.73.961", name: "Huyện Hoà Bình" },
  ],
  "VN.74": [
    { code: "VN.74.256", name: "Thành Phố Bắc Ninh" },
    { code: "VN.74.258", name: "Huyện Yên Phong" },
    { code: "VN.74.259", name: "Huyện Quế Võ" },
    { code: "VN.74.260", name: "Huyện Tiên Du" },
    { code: "VN.74.261", name: "Thị Xã Từ Sơn" },
    { code: "VN.74.262", name: "Huyện Thuận Thành" },
    { code: "VN.74.263", name: "Huyện Gia Bình" },
    { code: "VN.74.264", name: "Huyện Lương Tài" },
  ],
  "VN.75": [
    { code: "VN.75.718", name: "Thành Phố Thủ Dầu Một" },
    { code: "VN.75.719", name: "Huyện Bàu Bàng" },
    { code: "VN.75.720", name: "Huyện Dầu Tiêng" },
    { code: "VN.75.721", name: "Thị Xã Bến Cát" },
    { code: "VN.75.722", name: "Phu Giao District" },
    { code: "VN.75.723", name: "Thị Xã Tân Uyên" },
    { code: "VN.75.724", name: "Thị Xã Dĩ An" },
    { code: "VN.75.725", name: "Thị Xã Thuận An" },
    { code: "VN.75.726", name: "Tân Uyên" },
  ],
  "VN.76": [
    { code: "VN.76.688", name: "Thị Xã Phước Long" },
    { code: "VN.76.689", name: "Thị Xã Đồng Xoài" },
    { code: "VN.76.690", name: "Thị Xã Bình Long" },
    { code: "VN.76.691", name: "Huyện Bù Gia Mập" },
    { code: "VN.76.692", name: "Huyện Lộc Ninh" },
    { code: "VN.76.693", name: "Huyện Bù Đốp" },
    { code: "VN.76.694", name: "Huyện Hớn Quản" },
    { code: "VN.76.695", name: "Huyện Đồng Phú" },
    { code: "VN.76.696", name: "Huyện Bù Đăng" },
    { code: "VN.76.697", name: "Huyện Chơn Thành" },
    { code: "VN.76.698", name: "Huyện Phú Riềng" },
  ],
  "VN.77": [
    { code: "VN.77.964", name: "Thành Phố Cà Mau" },
    { code: "VN.77.966", name: "Huyện U Minh" },
    { code: "VN.77.967", name: "Huyện Thới Bình" },
    { code: "VN.77.968", name: "Huyện Trần Văn Thời" },
    { code: "VN.77.969", name: "Huyện Cái Nước" },
    { code: "VN.77.970", name: "Huyện Đầm Dơi" },
    { code: "VN.77.971", name: "Huyen Nam Can" },
    { code: "VN.77.972", name: "Huyện Phú Tân" },
    { code: "VN.77.973", name: "Huyện Ngọc Hiển" },
  ],
  "VN.78": [
    { code: "VN.78.490", name: "Quận Liên Chiểu" },
    { code: "VN.78.491", name: "Quận Thanh Khê" },
    { code: "VN.78.492", name: "Quận Hải Châu" },
    { code: "VN.78.493", name: "Quận Sơn Trà" },
    { code: "VN.78.494", name: "Quận Ngũ Hành Sơn" },
    { code: "VN.78.495", name: "Quận Cẩm Lệ" },
    { code: "VN.78.497", name: "Huyện Hòa Vang" },
    { code: "VN.78.498", name: "Huyện Hoàng Sa" },
  ],
  "VN.79": [
    { code: "VN.79.288", name: "Thành Phố Hải Dương" },
    { code: "VN.79.290", name: "Thị Xã Chí Linh" },
    { code: "VN.79.291", name: "Huyện Nam Sách" },
    { code: "VN.79.292", name: "Huyện Kinh Môn" },
    { code: "VN.79.293", name: "Huyện Kim Thành" },
    { code: "VN.79.294", name: "Huyện Thanh Hà" },
    { code: "VN.79.295", name: "Huyện Cẩm Giàng" },
    { code: "VN.79.296", name: "Huyện Bình Giang" },
    { code: "VN.79.297", name: "Huyện Gia Lộc" },
    { code: "VN.79.298", name: "Huyện Tứ Kỳ" },
    { code: "VN.79.299", name: "Huyện Ninh Giang" },
    { code: "VN.79.300", name: "Huyện Thanh Miện" },
  ],
  "VN.80": [
    { code: "VN.80.347", name: "Thành Phố Phủ Lý" },
    { code: "VN.80.349", name: "Huyện Duy Tiên" },
    { code: "VN.80.350", name: "Huyện Kim Bảng" },
    { code: "VN.80.351", name: "Huyện Thanh Liêm" },
    { code: "VN.80.352", name: "Huyện Bình Lục" },
    { code: "VN.80.353", name: "Huyện Lý Nhân" },
  ],
  "VN.81": [
    { code: "VN.81.323", name: "Thành Phố Hưng Yên" },
    { code: "VN.81.325", name: "Huyện Văn Lâm" },
    { code: "VN.81.326", name: "Huyện Văn Giang" },
    { code: "VN.81.327", name: "Huyện Yên Mỹ" },
    { code: "VN.81.328", name: "Huyện Mỹ Hào" },
    { code: "VN.81.329", name: "Huyện Ân Thi" },
    { code: "VN.81.330", name: "Huyện Khoái Châu" },
    { code: "VN.81.331", name: "Huyện Kim Động" },
    { code: "VN.81.332", name: "Huyện Tiên Lữ" },
    { code: "VN.81.333", name: "Huyện Phù Cừ" },
  ],
  "VN.82": [
    { code: "VN.82.356", name: "Thành Phố Nam Định" },
    { code: "VN.82.358", name: "Huyện Mỹ Lộc" },
    { code: "VN.82.359", name: "Huyện Vụ Bản" },
    { code: "VN.82.360", name: "Huyện Ý Yên" },
    { code: "VN.82.361", name: "Huyện Nghĩa Hưng" },
    { code: "VN.82.362", name: "Huyện Nam Trực" },
    { code: "VN.82.363", name: "Huyện Trực Ninh" },
    { code: "VN.82.364", name: "Huyện Xuân Trường" },
    { code: "VN.82.365", name: "Huyện Giao Thủy" },
    { code: "VN.82.366", name: "Huyện Hải Hậu" },
  ],
  "VN.83": [
    { code: "VN.83.227", name: "Thành Phố Việt Trì" },
    { code: "VN.83.228", name: "Thị xã Phú Thọ" },
    { code: "VN.83.230", name: "Huyện Đoan Hùng" },
    { code: "VN.83.231", name: "Huyện Hạ Hòa" },
    { code: "VN.83.232", name: "Huyện Thanh Ba" },
    { code: "VN.83.233", name: "Huyện Phù Ninh" },
    { code: "VN.83.234", name: "Huyện Yên Lập" },
    { code: "VN.83.235", name: "Huyện Cẩm Khê" },
    { code: "VN.83.236", name: "Huyện Tam Nông" },
    { code: "VN.83.237", name: "Huyen Lam Thao" },
    { code: "VN.83.238", name: "Huyện Thanh Sơn" },
    { code: "VN.83.239", name: "Huyện Thanh Thuỷ" },
    { code: "VN.83.240", name: "Huyện Tân Sơn" },
  ],
  "VN.84": [
    { code: "VN.84.502", name: "Thành Phố Tam Kỳ" },
    { code: "VN.84.503", name: "Thành Phố Hội An" },
    { code: "VN.84.504", name: "Huyện Tây Giang" },
    { code: "VN.84.505", name: "Huyện Đông Giang" },
    { code: "VN.84.506", name: "Huyện Đại Lộc" },
    { code: "VN.84.507", name: "Huyện Điện Bàn" },
    { code: "VN.84.508", name: "Huyện Duy Xuyên" },
    { code: "VN.84.509", name: "Huyện Quế Sơn" },
    { code: "VN.84.510", name: "Huyện Nam Giang" },
    { code: "VN.84.511", name: "Huyện Phước Sơn" },
    { code: "VN.84.512", name: "Huyện Hiệp Đức" },
    { code: "VN.84.513", name: "Huyện Thăng Bình" },
    { code: "VN.84.514", name: "Huyện Tiên Phước" },
    { code: "VN.84.515", name: "Huyện Bắc Trà My" },
    { code: "VN.84.516", name: "Huyện Trà My" },
    { code: "VN.84.517", name: "Huyện Núi Thành" },
    { code: "VN.84.518", name: "Huyện Phú Ninh" },
    { code: "VN.84.519", name: "Huyện Nông Sơn" },
  ],
  "VN.85": [
    { code: "VN.85.164", name: "Thành Phố Thái Nguyên" },
    { code: "VN.85.165", name: "Thị Xã Sông Công" },
    { code: "VN.85.167", name: "Huyện Định Hóa" },
    { code: "VN.85.168", name: "Huyện Phú Lương" },
    { code: "VN.85.169", name: "Huyện Đồng Hỷ" },
    { code: "VN.85.170", name: "Huyện Võ Nhai" },
    { code: "VN.85.171", name: "Huyện Đại Từ" },
    { code: "VN.85.172", name: "Huyện Phổ Yên" },
    { code: "VN.85.173", name: "Huyện Phú Bình" },
  ],
  "VN.86": [
    { code: "VN.86.243", name: "Thành Phố Vĩnh Yên" },
    { code: "VN.86.244", name: "Thị xã Phúc Yên" },
    { code: "VN.86.246", name: "Huyện Lập Thạch" },
    { code: "VN.86.247", name: "Huyện Tam Dương" },
    { code: "VN.86.248", name: "Huyện Tam Đảo" },
    { code: "VN.86.249", name: "Huyện Bình Xuyên" },
    { code: "VN.86.251", name: "Huyện Yên Lạc" },
    { code: "VN.86.252", name: "Huyện Vĩnh Tường" },
    { code: "VN.86.253", name: "Huyện Sông Lô" },
  ],
  "VN.87": [
    { code: "VN.87.916", name: "Quận Ninh Kiều" },
    { code: "VN.87.917", name: "Quận Ô Môn" },
    { code: "VN.87.918", name: "Quận Bình Thủy" },
    { code: "VN.87.919", name: "Cái Răng" },
    { code: "VN.87.923", name: "Quận Thốt Nốt" },
    { code: "VN.87.924", name: "Huyện Vĩnh Thạnh" },
    { code: "VN.87.925", name: "Huyện Cờ Đỏ" },
    { code: "VN.87.926", name: "Huyện Phong Điền" },
    { code: "VN.87.927", name: "Huyện Thới Lai" },
  ],
  "VN.88": [
    { code: "VN.88.643", name: "Thành Phố Buôn Ma Thuột" },
    { code: "VN.88.644", name: "Thị Xã Buôn Hồ" },
    { code: "VN.88.645", name: "Huyện Ea H'Leo" },
    { code: "VN.88.646", name: "Huyện Ea Súp" },
    { code: "VN.88.647", name: "Huyện Buôn Đôn" },
    { code: "VN.88.648", name: "Huyện Cư M’Gar" },
    { code: "VN.88.649", name: "Huyện Krông Búk" },
    { code: "VN.88.650", name: "Huyện Krông Năng" },
    { code: "VN.88.651", name: "Huyện Ea Kar" },
    { code: "VN.88.652", name: "Huyện M’Đrắk" },
    { code: "VN.88.653", name: "Huyện Krông Bông" },
    { code: "VN.88.654", name: "Huyện Krông Păk" },
    { code: "VN.88.655", name: "Huyện Krông Ana" },
    { code: "VN.88.656", name: "Huyện Lắk" },
    { code: "VN.88.657", name: "Huyện Cư Kuin" },
  ],
  "VN.89": [
    { code: "VN.89.105", name: "Thành phố Lai Châu" },
    { code: "VN.89.106", name: "Huyện Tam Đường" },
    { code: "VN.89.107", name: "Huyện Mưòng Tè" },
    { code: "VN.89.108", name: "Huyện Sìn Hồ" },
    { code: "VN.89.109", name: "Huyện Phong Thổ" },
    { code: "VN.89.110", name: "Huyện Than Uyên" },
    { code: "VN.89.111", name: "Huyện Tân Uyên" },
    { code: "VN.89.112", name: "Huyện Nậm Nhùn" },
  ],
  "VN.90": [
    { code: "VN.90.080", name: "Thành Phố Lào Cai" },
    { code: "VN.90.082", name: "Huyện Bát Xát" },
    { code: "VN.90.083", name: "Huyện Mường Khương" },
    { code: "VN.90.084", name: "Huyện Si Ma Cai" },
    { code: "VN.90.085", name: "Huyện Bắc Hà" },
    { code: "VN.90.086", name: "Huyện Bảo Thắng" },
    { code: "VN.90.087", name: "Huyện Bảo Yên" },
    { code: "VN.90.088", name: "Huyện Sa Pa" },
    { code: "VN.90.089", name: "Huyện Văn Bàn" },
  ],
  "VN.91": [
    { code: "VN.91.660", name: "Thị Xã Gia Nghĩa" },
    { code: "VN.91.661", name: "Huyen Dak Glong" },
    { code: "VN.91.662", name: "Huyện Cư Jút" },
    { code: "VN.91.663", name: "Huyện Đắk Mil" },
    { code: "VN.91.664", name: "Huyện Krông Nô" },
    { code: "VN.91.665", name: "Huyen Dak Song" },
    { code: "VN.91.666", name: "Huyện Đắk R’Lấp" },
    { code: "VN.91.667", name: "Huyen Tuy Duc" },
  ],
  "VN.92": [
    { code: "VN.92.094", name: "Thành Phố Điện Biên Phủ" },
    { code: "VN.92.095", name: "Thị Xã Mưòng Lay" },
    { code: "VN.92.096", name: "Huyện Mường Nhé" },
    { code: "VN.92.097", name: "Huyện Mường Chà" },
    { code: "VN.92.098", name: "Huyện Tủa Chùa" },
    { code: "VN.92.099", name: "Huyện Tuần Giáo" },
    { code: "VN.92.100", name: "Huyện Điện Biên" },
    { code: "VN.92.101", name: "Huyện Điện Biên Đông" },
    { code: "VN.92.102", name: "Huyện Mường Ảng" },
    { code: "VN.92.103", name: "Huyện Nậm Pồ" },
  ],
  "VN.93": [
    { code: "VN.93.930", name: "Thành Phố Vị Thanh" },
    { code: "VN.93.931", name: "Thị Xã Ngã Bảy" },
    { code: "VN.93.932", name: "Huyện Châu Thành A" },
    { code: "VN.93.933", name: "Huyện Châu Thành" },
    { code: "VN.93.934", name: "Huyện Phụng Hiệp" },
    { code: "VN.93.935", name: "Vị Thủy District" },
    { code: "VN.93.936", name: "Huyện Long Mỹ" },
    { code: "VN.93.937", name: "Thị xã Long Mỹ" },
  ],
  "WF.98611": [
    { code: "WF.98611.1", name: "Alo" },
  ],
  "WF.98612": [
    { code: "WF.98612.2", name: "Sigave" },
  ],
  "WF.98613": [
    { code: "WF.98613.5", name: "Hahake" },
    { code: "WF.98613.6", name: "Hihifo" },
    { code: "WF.98613.7", name: "Mua" },
  ],
  "WS.01": [
    { code: "WS.01.7669209", name: "Aana Alofi I" },
    { code: "WS.01.7669210", name: "Aana Alofi II" },
    { code: "WS.01.7669212", name: "Aana Alofi III" },
  ],
  "WS.02": [
    { code: "WS.02.7669213", name: "Aiga i le Tai" },
  ],
  "WS.03": [
    { code: "WS.03.4035421", name: "Aleipata Itupa i Lalo" },
    { code: "WS.03.7668017", name: "Aleipata Itupa i Luga" },
    { code: "WS.03.7668018", name: "Lepa" },
  ],
  "WS.10": [
    { code: "WS.10.10629989", name: "Vaimauga East" },
    { code: "WS.10.7669205", name: "Faleata West" },
    { code: "WS.10.7669206", name: "Sagaga le Falefa" },
    { code: "WS.10.7669207", name: "Sagaga Le Usoga" },
    { code: "WS.10.7669208", name: "Leauvaa" },
    { code: "WS.10.7669216", name: "Faleata East" },
    { code: "WS.10.7669218", name: "Vaimauga West" },
  ],
  "XK.10096138": [
    { code: "XK.10096138.03", name: "Komuna e Ferizajt" },
    { code: "XK.10096138.09", name: "Komuna e Kaçanikut" },
    { code: "XK.10096138.23", name: "Opština Štrpce" },
    { code: "XK.10096138.24", name: "Komuna e Shtimes" },
    { code: "XK.10096138.32", name: "Hani i Elezit" },
  ],
  "XK.10096859": [
    { code: "XK.10096859.01", name: "Komuna e Deçanit" },
    { code: "XK.10096859.05", name: "Komuna e Gjakovës" },
    { code: "XK.10096859.22", name: "Orahovac" },
    { code: "XK.10096859.33", name: "Komuna e Junikut" },
  ],
  "XK.10097357": [
    { code: "XK.10097357.06", name: "Komuna e Gjilanit" },
    { code: "XK.10097357.10", name: "Kamenica" },
    { code: "XK.10097357.27", name: "Komuna e Vitisë" },
    { code: "XK.10097357.34", name: "Komuna e Kllokotit" },
    { code: "XK.10097357.36", name: "Komuna e Parteshit" },
    { code: "XK.10097357.37", name: "Komuna e Ranillugut" },
  ],
  "XK.10097358": [
    { code: "XK.10097358.12", name: "Komuna e Leposaviqit" },
    { code: "XK.10097358.15", name: "Komuna e Mitrovicës" },
    { code: "XK.10097358.25", name: "Komuna e Skenderajt" },
    { code: "XK.10097358.28", name: "Vushtrri" },
    { code: "XK.10097358.29", name: "Komuna e Zubin Potokut" },
    { code: "XK.10097358.30", name: "Opština Zvečan" },
    { code: "XK.10097358.38", name: "Mitrovica Veriore" },
  ],
  "XK.10097359": [
    { code: "XK.10097359.08", name: "Komuna e Istogut" },
    { code: "XK.10097359.11", name: "Komuna e Klines" },
    { code: "XK.10097359.18", name: "Komuna e Pejës" },
  ],
  "XK.10097360": [
    { code: "XK.10097360.04", name: "Kosovo Polje" },
    { code: "XK.10097360.07", name: "Komuna e Drenasit" },
    { code: "XK.10097360.13", name: "Lipjan" },
    { code: "XK.10097360.16", name: "Novo Brdo" },
    { code: "XK.10097360.17", name: "Komuna e Obiliqit" },
    { code: "XK.10097360.19", name: "Podujevo" },
    { code: "XK.10097360.20", name: "Komuna e Prishtinës" },
    { code: "XK.10097360.31", name: "Komuna e Graçanicës" },
  ],
  "XK.10097361": [
    { code: "XK.10097361.02", name: "Komuna e Dragashit" },
    { code: "XK.10097361.14", name: "Komuna e Malisheves" },
    { code: "XK.10097361.21", name: "Prizren" },
    { code: "XK.10097361.26", name: "Komuna e Thërandës" },
    { code: "XK.10097361.35", name: "Komuna e Mamushës" },
  ],
  "YE.01": [
    { code: "YE.01.1201", name: "Al Mahfad" },
    { code: "YE.01.1202", name: "Mudiyah" },
    { code: "YE.01.1203", name: "Jayshan" },
    { code: "YE.01.1204", name: "Lawdar" },
    { code: "YE.01.1205", name: "Sibah" },
    { code: "YE.01.1206", name: "Rasad" },
    { code: "YE.01.1207", name: "Sarar" },
    { code: "YE.01.1208", name: "Al Wade'a" },
    { code: "YE.01.1209", name: "Ahwar" },
    { code: "YE.01.1210", name: "Zingibar" },
    { code: "YE.01.1211", name: "Khanfir" },
  ],
  "YE.02": [
    { code: "YE.02.2401", name: "Dar Sad" },
    { code: "YE.02.2402", name: "Ash Shaikh Outhman" },
    { code: "YE.02.2403", name: "Al Mansura" },
    { code: "YE.02.2404", name: "Al Buraiqeh" },
    { code: "YE.02.2405", name: "Attawahi" },
    { code: "YE.02.2406", name: "Al Mualla" },
    { code: "YE.02.2407", name: "Craiter" },
    { code: "YE.02.2408", name: "Khur Maksar" },
  ],
  "YE.03": [
    { code: "YE.03.2801", name: "Shahan" },
    { code: "YE.03.2802", name: "Hat" },
    { code: "YE.03.2803", name: "Hawf" },
    { code: "YE.03.2804", name: "Al Ghaydah" },
    { code: "YE.03.2805", name: "Man'ar" },
    { code: "YE.03.2806", name: "Al Masilah" },
    { code: "YE.03.2807", name: "Sayhut" },
    { code: "YE.03.2808", name: "Qishn" },
    { code: "YE.03.2809", name: "Huswain" },
  ],
  "YE.04": [
    { code: "YE.04.1901", name: "Rumah" },
    { code: "YE.04.1902", name: "Thamud" },
    { code: "YE.04.1903", name: "Al Qaf" },
    { code: "YE.04.1904", name: "Zamakh wa Manwakh" },
    { code: "YE.04.1905", name: "Hagr As Sai'ar" },
    { code: "YE.04.1906", name: "Al Abr" },
    { code: "YE.04.1907", name: "Al Qatn" },
    { code: "YE.04.1908", name: "Shibam" },
    { code: "YE.04.1909", name: "Sah" },
    { code: "YE.04.1910", name: "Sayun" },
    { code: "YE.04.1911", name: "Tarim" },
    { code: "YE.04.1912", name: "As Sawm" },
    { code: "YE.04.1913", name: "Ar Raydah Wa Qusayar" },
    { code: "YE.04.1914", name: "Ad Dis" },
    { code: "YE.04.1915", name: "Ash Shihr" },
    { code: "YE.04.1916", name: "Ghayl Bin Yamin" },
    { code: "YE.04.1917", name: "Ghayl Ba Wazir" },
    { code: "YE.04.1918", name: "Daw'an" },
    { code: "YE.04.1919", name: "Wadi Al Ayn" },
    { code: "YE.04.1920", name: "Rakhyah" },
    { code: "YE.04.1921", name: "Amd" },
    { code: "YE.04.1922", name: "Adh Dhlia'ah" },
    { code: "YE.04.1923", name: "Yabuth" },
    { code: "YE.04.1924", name: "Hajr" },
    { code: "YE.04.1925", name: "Brom Mayfa" },
    { code: "YE.04.1928", name: "Huraidhah" },
    { code: "YE.04.1929", name: "Al Mukalla City" },
    { code: "YE.04.1930", name: "Al Mukalla" },
  ],
  "YE.05": [
    { code: "YE.05.2101", name: "Dhar" },
    { code: "YE.05.2102", name: "Al Talh" },
    { code: "YE.05.2103", name: "Jardan" },
    { code: "YE.05.2104", name: "Arma" },
    { code: "YE.05.2105", name: "Usaylan" },
    { code: "YE.05.2106", name: "Ain" },
    { code: "YE.05.2107", name: "Bayhan" },
    { code: "YE.05.2108", name: "Merkhah Al Ulya" },
    { code: "YE.05.2109", name: "Merkhah As Sufla" },
    { code: "YE.05.2110", name: "Nisab" },
    { code: "YE.05.2111", name: "Hatib" },
    { code: "YE.05.2112", name: "As Said" },
    { code: "YE.05.2113", name: "Ataq" },
    { code: "YE.05.2114", name: "Habban" },
    { code: "YE.05.2115", name: "Ar Rawdah" },
    { code: "YE.05.2116", name: "Mayfa'a" },
    { code: "YE.05.2117", name: "Rudum" },
  ],
  "YE.08": [
    { code: "YE.08.1801", name: "Az Zuhrah" },
    { code: "YE.08.1802", name: "Alluheyah" },
    { code: "YE.08.1803", name: "Kamaran" },
    { code: "YE.08.1804", name: "As Salif" },
    { code: "YE.08.1805", name: "Al Munirah" },
    { code: "YE.08.1806", name: "Al Qanawis" },
    { code: "YE.08.1807", name: "Az Zaydīyah" },
    { code: "YE.08.1808", name: "Al Mighlaf" },
    { code: "YE.08.1809", name: "Ad Dahi" },
    { code: "YE.08.1810", name: "Bājil" },
    { code: "YE.08.1811", name: "Al Hajjaylah" },
    { code: "YE.08.1812", name: "Bura" },
    { code: "YE.08.1813", name: "Al Marawi'ah" },
    { code: "YE.08.1814", name: "Ad Durayhimi" },
    { code: "YE.08.1815", name: "As Sukhnah" },
    { code: "YE.08.1816", name: "Al Mansuriyah" },
    { code: "YE.08.1817", name: "Bayt al Faqīh" },
    { code: "YE.08.1818", name: "Jabal Ra's" },
    { code: "YE.08.1819", name: "Hays" },
    { code: "YE.08.1820", name: "Khawlān" },
    { code: "YE.08.1821", name: "Al Hawak" },
    { code: "YE.08.1822", name: "Al Mina" },
    { code: "YE.08.1823", name: "Al Hali" },
    { code: "YE.08.1824", name: "Zabīd" },
    { code: "YE.08.1825", name: "Al Garrahi" },
    { code: "YE.08.1826", name: "At Tuhayat" },
  ],
  "YE.10": [
    { code: "YE.10.2701", name: "Shibām Kawkabān" },
    { code: "YE.10.2702", name: "Aţ Ţawīlah" },
    { code: "YE.10.2703", name: "Ar Rujum" },
    { code: "YE.10.2704", name: "Al Khabt" },
    { code: "YE.10.2705", name: "Milhan" },
    { code: "YE.10.2706", name: "Hufash" },
    { code: "YE.10.2707", name: "Bani Sa'd" },
    { code: "YE.10.2708", name: "Al Mahwait City" },
    { code: "YE.10.2709", name: "Al Mahwait" },
  ],
  "YE.11": [
    { code: "YE.11.2001", name: "Al Hada" },
    { code: "YE.11.2002", name: "Jahran" },
    { code: "YE.11.2003", name: "Jabal Ash sharq" },
    { code: "YE.11.2004", name: "Maghirib Ans" },
    { code: "YE.11.2005", name: "Utmah" },
    { code: "YE.11.2006", name: "Wusab Al Ali" },
    { code: "YE.11.2007", name: "Wusab As Safil" },
    { code: "YE.11.2008", name: "Madīnat Dhamār" },
    { code: "YE.11.2009", name: "Mayfa'at Anss" },
    { code: "YE.11.2010", name: "‘Ans" },
    { code: "YE.11.2011", name: "Dawran Aness" },
    { code: "YE.11.2012", name: "Al Manar" },
  ],
  "YE.14": [
    { code: "YE.14.2601", name: "Majzar" },
    { code: "YE.14.2602", name: "Raghwan" },
    { code: "YE.14.2603", name: "Medghal" },
    { code: "YE.14.2604", name: "Harib Al Qaramish" },
    { code: "YE.14.2605", name: "Bidbadah" },
    { code: "YE.14.2606", name: "Sirwah" },
    { code: "YE.14.2607", name: "Al Jubah" },
    { code: "YE.14.2608", name: "Rahabah" },
    { code: "YE.14.2609", name: "Ḩarīb" },
    { code: "YE.14.2610", name: "Mahliyah" },
    { code: "YE.14.2611", name: "Al Abdiyah" },
    { code: "YE.14.2612", name: "Marib City" },
    { code: "YE.14.2613", name: "Marib" },
    { code: "YE.14.2614", name: "Jabal Murad" },
  ],
  "YE.15": [
    { code: "YE.15.2201", name: "Baqim" },
    { code: "YE.15.2202", name: "Qatabir" },
    { code: "YE.15.2203", name: "Monabbih" },
    { code: "YE.15.2204", name: "Ghamr" },
    { code: "YE.15.2205", name: "Rāziḩ" },
    { code: "YE.15.2206", name: "Shada'a" },
    { code: "YE.15.2207", name: "Al Dhaher" },
    { code: "YE.15.2208", name: "Haydan" },
    { code: "YE.15.2209", name: "Saqayn" },
    { code: "YE.15.2210", name: "Majz" },
    { code: "YE.15.2211", name: "Saḩār" },
    { code: "YE.15.2212", name: "As Safra" },
    { code: "YE.15.2213", name: "Al Hashwah" },
    { code: "YE.15.2214", name: "Kitaf wa Al Boqe'e" },
    { code: "YE.15.2215", name: "Şa‘dah" },
  ],
  "YE.16": [
    { code: "YE.16.2301", name: "Hamdān" },
    { code: "YE.16.2302", name: "Arhab" },
    { code: "YE.16.2303", name: "Nihm" },
    { code: "YE.16.2304", name: "Bani Hushaysh" },
    { code: "YE.16.2305", name: "Sanhan" },
    { code: "YE.16.2306", name: "Bilad Ar Rus" },
    { code: "YE.16.2307", name: "Bani Matar" },
    { code: "YE.16.2308", name: "Al Haymah Ad Dakhiliyah" },
    { code: "YE.16.2309", name: "Al Haymah Al Kharijiyah" },
    { code: "YE.16.2310", name: "Manakhah" },
    { code: "YE.16.2311", name: "Sa'fan" },
    { code: "YE.16.2312", name: "Khwlan" },
    { code: "YE.16.2313", name: "Attyal" },
    { code: "YE.16.2314", name: "Bani Dhabyan" },
    { code: "YE.16.2315", name: "Al Husn" },
    { code: "YE.16.2316", name: "Jihanah" },
  ],
  "YE.18": [
    { code: "YE.18.3001", name: "Juban" },
    { code: "YE.18.3002", name: "Damt" },
    { code: "YE.18.3003", name: "Qa'atabah" },
    { code: "YE.18.3004", name: "Ash Shu'ayb" },
    { code: "YE.18.3005", name: "Al Hussein" },
    { code: "YE.18.3006", name: "Ad Dhale'e" },
    { code: "YE.18.3007", name: "Jahaf" },
    { code: "YE.18.3008", name: "Al Azariq" },
    { code: "YE.18.3009", name: "Al Husha" },
  ],
  "YE.19": [
    { code: "YE.19.2901", name: "Harf Sufyan" },
    { code: "YE.19.2902", name: "Hooth" },
    { code: "YE.19.2903", name: "Al Ashah" },
    { code: "YE.19.2904", name: "Al Qaflah" },
    { code: "YE.19.2905", name: "Shahārah" },
    { code: "YE.19.2906", name: "Al Madan" },
    { code: "YE.19.2907", name: "Suwayr" },
    { code: "YE.19.2908", name: "Habur Zulaymah" },
    { code: "YE.19.2909", name: "Dhi Bin" },
    { code: "YE.19.2910", name: "Kharif" },
    { code: "YE.19.2911", name: "Raydah" },
    { code: "YE.19.2912", name: "Jabal Iyal Yazid" },
    { code: "YE.19.2913", name: "As Sudah" },
    { code: "YE.19.2914", name: "As Sawd" },
    { code: "YE.19.2915", name: "‘Amrān" },
    { code: "YE.19.2916", name: "Maswar" },
    { code: "YE.19.2917", name: "Thula" },
    { code: "YE.19.2918", name: "Iyal Surayh" },
    { code: "YE.19.2919", name: "Khamir" },
    { code: "YE.19.2920", name: "Bani Suraim" },
  ],
  "YE.20": [
    { code: "YE.20.1401", name: "Na'man" },
    { code: "YE.20.1402", name: "Nati'" },
    { code: "YE.20.1403", name: "Maswarah" },
    { code: "YE.20.1404", name: "As Sawma'ah" },
    { code: "YE.20.1405", name: "Az Zahir" },
    { code: "YE.20.1406", name: "Dhi Na'im" },
    { code: "YE.20.1407", name: "At Taffah" },
    { code: "YE.20.1408", name: "Mukayras" },
    { code: "YE.20.1409", name: "Al Bayda City" },
    { code: "YE.20.1410", name: "Al Bayḑā’" },
    { code: "YE.20.1411", name: "As Sawadiyah" },
    { code: "YE.20.1412", name: "Radman Al Awad" },
    { code: "YE.20.1413", name: "Radā‘" },
    { code: "YE.20.1414", name: "Al Quraishyah" },
    { code: "YE.20.1415", name: "Wald Rabi'" },
    { code: "YE.20.1416", name: "Al A'rsh" },
    { code: "YE.20.1417", name: "Sabah" },
    { code: "YE.20.1418", name: "Ar Ryashyyah" },
    { code: "YE.20.1419", name: "Ash Sharafayn" },
    { code: "YE.20.1420", name: "Al Malagim" },
  ],
  "YE.21": [
    { code: "YE.21.1601", name: "Khabb wa ash Sha'af" },
    { code: "YE.21.1602", name: "Al Humaydat" },
    { code: "YE.21.1603", name: "Al Matammah" },
    { code: "YE.21.1604", name: "Az Zahir" },
    { code: "YE.21.1605", name: "Al Hazm" },
    { code: "YE.21.1606", name: "Al Maton" },
    { code: "YE.21.1607", name: "Al Maslub" },
    { code: "YE.21.1608", name: "Al Ghayl" },
    { code: "YE.21.1609", name: "Al Khalq" },
    { code: "YE.21.1610", name: "Barţ al ‘Anān" },
    { code: "YE.21.1611", name: "Rajuzah" },
    { code: "YE.21.1612", name: "Kharab Al Marashi" },
  ],
  "YE.22": [
    { code: "YE.22.1701", name: "Bakil Al Mir" },
    { code: "YE.22.1702", name: "Harad District" },
    { code: "YE.22.1703", name: "Midi" },
    { code: "YE.22.1704", name: "Abs" },
    { code: "YE.22.1705", name: "Hayran" },
    { code: "YE.22.1706", name: "Mustaba" },
    { code: "YE.22.1707", name: "Kushar" },
    { code: "YE.22.1708", name: "Al Jamimah" },
    { code: "YE.22.1709", name: "Kuhlan Ash Sharaf" },
    { code: "YE.22.1710", name: "Aflah Ash Shawm" },
    { code: "YE.22.1711", name: "Khayran Al Muharraq" },
    { code: "YE.22.1712", name: "Aslem" },
    { code: "YE.22.1713", name: "Qafl Shamer" },
    { code: "YE.22.1714", name: "Aflah Al Yaman" },
    { code: "YE.22.1715", name: "Al Mahabishah" },
    { code: "YE.22.1716", name: "Al Miftah" },
    { code: "YE.22.1717", name: "Al Maghrabah" },
    { code: "YE.22.1718", name: "Kuhlan Affar" },
    { code: "YE.22.1719", name: "Sharas" },
    { code: "YE.22.1720", name: "Mabyan" },
    { code: "YE.22.1721", name: "Ash Shahil" },
    { code: "YE.22.1722", name: "Ku'aydinah" },
    { code: "YE.22.1723", name: "Wadhrah" },
    { code: "YE.22.1724", name: "Bani Qa'is" },
    { code: "YE.22.1725", name: "Ash Shaghadirah" },
    { code: "YE.22.1726", name: "Najrah" },
    { code: "YE.22.1727", name: "Bani Al Awam" },
    { code: "YE.22.1728", name: "Ḩajjah" },
    { code: "YE.22.1729", name: "Hajjah" },
    { code: "YE.22.1730", name: "Washḩah" },
    { code: "YE.22.1731", name: "Qarah" },
  ],
  "YE.23": [
    { code: "YE.23.1101", name: "Al Qafr" },
    { code: "YE.23.1102", name: "Yarīm" },
    { code: "YE.23.1103", name: "Ar Radmah" },
    { code: "YE.23.1104", name: "An Nādirah" },
    { code: "YE.23.1105", name: "Ash Sha'ir" },
    { code: "YE.23.1106", name: "As Saddah" },
    { code: "YE.23.1107", name: "Al Makhādir" },
    { code: "YE.23.1108", name: "Hubaysh" },
    { code: "YE.23.1109", name: "Hazm Al Udayn" },
    { code: "YE.23.1110", name: "Far Al Udayn" },
    { code: "YE.23.1111", name: "Al ‘Udayn" },
    { code: "YE.23.1112", name: "Jiblah" },
    { code: "YE.23.1113", name: "Ba'dan" },
    { code: "YE.23.1114", name: "As Sabrah" },
    { code: "YE.23.1115", name: "As Sayyani" },
    { code: "YE.23.1116", name: "Dhī as Sufāl" },
    { code: "YE.23.1117", name: "Mudhaykhirah" },
    { code: "YE.23.1118", name: "Al Mashannah" },
    { code: "YE.23.1119", name: "Al Dhihar" },
    { code: "YE.23.1120", name: "Ibb" },
  ],
  "YE.24": [
    { code: "YE.24.2501", name: "Al Had" },
    { code: "YE.24.2502", name: "Yafa'a" },
    { code: "YE.24.2503", name: "Al Maflahy" },
    { code: "YE.24.2504", name: "Yahr" },
    { code: "YE.24.2505", name: "Habil Jabr" },
    { code: "YE.24.2506", name: "Halimayn" },
    { code: "YE.24.2507", name: "Radfan" },
    { code: "YE.24.2508", name: "Al Milah" },
    { code: "YE.24.2509", name: "Al Musaymir" },
    { code: "YE.24.2510", name: "Al Qabbaytah" },
    { code: "YE.24.2511", name: "Tur Al Bahah" },
    { code: "YE.24.2512", name: "Al Maqatirah" },
    { code: "YE.24.2513", name: "Al Madaribah Wa Al Arah" },
    { code: "YE.24.2514", name: "Al  Hawtah" },
    { code: "YE.24.2515", name: "Tuban" },
  ],
  "YE.25": [
    { code: "YE.25.1501", name: "Māwīyah" },
    { code: "YE.25.1502", name: "At Ta‘izzīyah" },
    { code: "YE.25.1503", name: "Shara'b As Salam" },
    { code: "YE.25.1504", name: "Shara'b Ar Rawnah" },
    { code: "YE.25.1505", name: "Maqbanah" },
    { code: "YE.25.1506", name: "Al Mukhā’" },
    { code: "YE.25.1507", name: "Dhubab" },
    { code: "YE.25.1508", name: "Mawza" },
    { code: "YE.25.1509", name: "Jabal Habashy" },
    { code: "YE.25.1510", name: "Mashra'a Wa Hadnan" },
    { code: "YE.25.1511", name: "Sabir Al Mawadim" },
    { code: "YE.25.1512", name: "Al Misrakh" },
    { code: "YE.25.1513", name: "Dimnat Khadir" },
    { code: "YE.25.1514", name: "As Silw" },
    { code: "YE.25.1515", name: "Ash Shamayatayn" },
    { code: "YE.25.1516", name: "Al Wazi'iyah" },
    { code: "YE.25.1517", name: "Hayfan" },
    { code: "YE.25.1518", name: "Al Mudhaffar" },
    { code: "YE.25.1519", name: "Al Qahirah" },
    { code: "YE.25.1520", name: "Salh" },
    { code: "YE.25.1521", name: "Al Ma'afer" },
    { code: "YE.25.1522", name: "Al Mawasit" },
    { code: "YE.25.1523", name: "Sama" },
  ],
  "YE.26": [
    { code: "YE.26.1301", name: "Old City" },
    { code: "YE.26.1302", name: "Shu'aub" },
    { code: "YE.26.1303", name: "Az'zal" },
    { code: "YE.26.1304", name: "Assafi'yah" },
    { code: "YE.26.1305", name: "As Sabain" },
    { code: "YE.26.1306", name: "Al Wahdah" },
    { code: "YE.26.1307", name: "At Tahrir" },
    { code: "YE.26.1308", name: "Ma'ain" },
    { code: "YE.26.1309", name: "Ath'thaorah" },
    { code: "YE.26.1310", name: "Bani Al Harith" },
  ],
  "YE.27": [
    { code: "YE.27.3101", name: "Bilad At Ta'am" },
    { code: "YE.27.3102", name: "Al Jabin" },
    { code: "YE.27.3103", name: "As Salafiyah" },
    { code: "YE.27.3104", name: "Kusmah" },
    { code: "YE.27.3105", name: "Al Jafariyah" },
    { code: "YE.27.3106", name: "Mazhar" },
  ],
  "YE.28": [
    { code: "YE.28.1926", name: "Hidaybu" },
    { code: "YE.28.1927", name: "Qulensya Wa Abd Al Kuri" },
  ],
  "ZA.02": [
    { code: "ZA.02.DC21", name: "Ugu District Municipality" },
    { code: "ZA.02.DC22", name: "uMgungundlovu District Municipality" },
    { code: "ZA.02.DC23", name: "uThukela District Municipality" },
    { code: "ZA.02.DC24", name: "uMzinyathi District Municipality" },
    { code: "ZA.02.DC25", name: "Amajuba District Municipality" },
    { code: "ZA.02.DC26", name: "Zululand District Municipality" },
    { code: "ZA.02.DC27", name: "uMkhanyakude District Municipality" },
    { code: "ZA.02.DC28", name: "uThungulu District Municipality" },
    { code: "ZA.02.DC29", name: "iLembe District Municipality" },
    { code: "ZA.02.DC43", name: "Sisonke District Municipality" },
    { code: "ZA.02.ETH", name: "eThekwini Metropolitan Municipality" },
  ],
  "ZA.03": [
    { code: "ZA.03.DC16", name: "Xhariep District Municipality" },
    { code: "ZA.03.DC18", name: "Lejweleputswa District Municipality" },
    { code: "ZA.03.DC19", name: "Thabo Mofutsanyana District Municipality" },
    { code: "ZA.03.DC20", name: "Fezile Dabi District Municipality" },
    { code: "ZA.03.MAN", name: "Mangaung Metropolitan Municipality" },
  ],
  "ZA.05": [
    { code: "ZA.05.BUF", name: "Buffalo City Metropolitan Municipality" },
    { code: "ZA.05.DC10", name: "Sarah Baartman District Municipality" },
    { code: "ZA.05.DC12", name: "Amathole District Municipality" },
    { code: "ZA.05.DC13", name: "Chris Hani District Municipality" },
    { code: "ZA.05.DC14", name: "Joe Gqabi District Municipality" },
    { code: "ZA.05.DC15", name: "OR Tambo District Municipality" },
    { code: "ZA.05.DC44", name: "Alfred Nzo District Municipality" },
    { code: "ZA.05.NMA", name: "Nelson Mandela Bay Metropolitan Municipality" },
  ],
  "ZA.06": [
    { code: "ZA.06.DC42", name: "Sedibeng District Municipality" },
    { code: "ZA.06.DC48", name: "West Rand District Municipality" },
    { code: "ZA.06.EKU", name: "Ekurhuleni Metropolitan Municipality" },
    { code: "ZA.06.JHB", name: "City of Johannesburg Metropolitan Municipality" },
    { code: "ZA.06.TSH", name: "City of Tshwane Metropolitan Municipality" },
  ],
  "ZA.07": [
    { code: "ZA.07.DC30", name: "Gert Sibande District Municipality" },
    { code: "ZA.07.DC31", name: "Nkangala District Municipality" },
    { code: "ZA.07.DC32", name: "Ehlanzeni District" },
  ],
  "ZA.08": [
    { code: "ZA.08.DC45", name: "John Taolo Gaetsewe District Municipality" },
    { code: "ZA.08.DC6", name: "Namakwa District Municipality" },
    { code: "ZA.08.DC7", name: "Pixley ka Seme District Municipality" },
    { code: "ZA.08.DC8", name: "Siyanda District Municipality" },
    { code: "ZA.08.DC9", name: "Frances Baard District Municipality" },
  ],
  "ZA.09": [
    { code: "ZA.09.DC33", name: "Mopani District Municipality" },
    { code: "ZA.09.DC34", name: "Vhembe District Municipality" },
    { code: "ZA.09.DC35", name: "Capricorn District Municipality" },
    { code: "ZA.09.DC36", name: "Waterberg District Municipality" },
    { code: "ZA.09.DC47", name: "Sekhukhune District Municipality" },
  ],
  "ZA.10": [
    { code: "ZA.10.DC37", name: "Bojanala Platinum District Municipality" },
    { code: "ZA.10.DC38", name: "Ngaka Modiri Molema District Municipality" },
    { code: "ZA.10.DC39", name: "Dr Ruth Segomotsi Mompati District Municipality" },
    { code: "ZA.10.DC40", name: "Dr Kenneth Kaunda District Municipality" },
  ],
  "ZA.11": [
    { code: "ZA.11.CPT", name: "City of Cape Town" },
    { code: "ZA.11.DC1", name: "West Coast District Municipality" },
    { code: "ZA.11.DC2", name: "Cape Winelands District Municipality" },
    { code: "ZA.11.DC3", name: "Overberg District Municipality" },
    { code: "ZA.11.DC4", name: "Eden District Municipality" },
    { code: "ZA.11.DC5", name: "Central Karoo District Municipality" },
  ],
  "ZM.01": [
    { code: "ZM.01.10801800", name: "Shangombo" },
    { code: "ZM.01.10814741", name: "Mitete District" },
    { code: "ZM.01.10815319", name: "Sikongo District" },
    { code: "ZM.01.10815320", name: "Limulunga District" },
    { code: "ZM.01.10815321", name: "Nkeyema District" },
    { code: "ZM.01.10815322", name: "Luampa District" },
    { code: "ZM.01.10815323", name: "Nalolo District" },
    { code: "ZM.01.10815324", name: "Sioma District" },
    { code: "ZM.01.10815325", name: "Mulobezi District" },
    { code: "ZM.01.10815326", name: "Mwandi District" },
    { code: "ZM.01.898902", name: "Sesheke District" },
    { code: "ZM.01.898945", name: "Senanga District" },
    { code: "ZM.01.906052", name: "Mongu District" },
    { code: "ZM.01.909482", name: "Lukulu District" },
    { code: "ZM.01.913321", name: "Kaoma District" },
    { code: "ZM.01.915468", name: "Kalabo District" },
  ],
  "ZM.02": [
    { code: "ZM.02.10815856", name: "Ngabwe District" },
    { code: "ZM.02.10815857", name: "Chisamba District" },
    { code: "ZM.02.10815858", name: "Luano District" },
    { code: "ZM.02.10815859", name: "Chitambo District" },
    { code: "ZM.02.8285556", name: "Kapiri-Mposhi District" },
    { code: "ZM.02.8714549", name: "Chibombo District" },
    { code: "ZM.02.898909", name: "Serenje District" },
    { code: "ZM.02.904420", name: "Mumbwa District" },
    { code: "ZM.02.906219", name: "Mkushi District" },
    { code: "ZM.02.916077", name: "Kapiri Mposhi" },
    { code: "ZM.02.916082", name: "Kabwe District" },
  ],
  "ZM.03": [
    { code: "ZM.03.10800895", name: "Mambwe" },
    { code: "ZM.03.10815860", name: "Sinda District" },
    { code: "ZM.03.10815861", name: "Vubwi District" },
    { code: "ZM.03.7732619", name: "Nyimba District" },
    { code: "ZM.03.899821", name: "Petauke District" },
    { code: "ZM.03.909296", name: "Lundazi District" },
    { code: "ZM.03.912053", name: "Katete District" },
    { code: "ZM.03.918699", name: "Chipata District" },
    { code: "ZM.03.921026", name: "Chadiza District" },
  ],
  "ZM.04": [
    { code: "ZM.04.10800891", name: "Chienge" },
    { code: "ZM.04.10800892", name: "Milenge" },
    { code: "ZM.04.10815862", name: "Mwansabombwe District" },
    { code: "ZM.04.10815863", name: "Chipili District" },
    { code: "ZM.04.10815864", name: "Chembe District" },
    { code: "ZM.04.10815865", name: "Lunga District" },
    { code: "ZM.04.175497", name: "Nchelenge District" },
    { code: "ZM.04.176553", name: "Kawambwa District" },
    { code: "ZM.04.899273", name: "Samfya District" },
    { code: "ZM.04.902718", name: "Mwense District" },
    { code: "ZM.04.907767", name: "Mansa District" },
  ],
  "ZM.05": [
    { code: "ZM.05.10800890", name: "Chilubi" },
    { code: "ZM.05.10815866", name: "Nsama District" },
    { code: "ZM.05.175966", name: "Mporokoso District" },
    { code: "ZM.05.176143", name: "Mbala District" },
    { code: "ZM.05.176756", name: "Kaputa District" },
    { code: "ZM.05.8260556", name: "Mpulungu District" },
    { code: "ZM.05.8260557", name: "Mungwi District" },
    { code: "ZM.05.908911", name: "Luwingu District" },
    { code: "ZM.05.912763", name: "Kasama District" },
  ],
  "ZM.06": [
    { code: "ZM.06.10801775", name: "Ikelenge" },
    { code: "ZM.06.10801797", name: "Chavuma" },
    { code: "ZM.06.10801798", name: "Mufumbwe" },
    { code: "ZM.06.10814730", name: "Manyinga District" },
    { code: "ZM.06.895952", name: "Zambezi District" },
    { code: "ZM.06.897041", name: "Solwezi District" },
    { code: "ZM.06.902616", name: "Mwinilunga District" },
    { code: "ZM.06.912623", name: "Kasempa District" },
    { code: "ZM.06.916244", name: "Kabompo District" },
  ],
  "ZM.07": [
    { code: "ZM.07.10815849", name: "Zimba District" },
    { code: "ZM.07.10815850", name: "Pemba District" },
    { code: "ZM.07.10815851", name: "Chikankata District" },
    { code: "ZM.07.7671219", name: "Siavonga District" },
    { code: "ZM.07.8260555", name: "Kazungula District" },
    { code: "ZM.07.8714550", name: "Itezhi-Tezhi District" },
    { code: "ZM.07.901764", name: "Namwala District" },
    { code: "ZM.07.906042", name: "Monze District" },
    { code: "ZM.07.907108", name: "Mazabuka District" },
    { code: "ZM.07.9072525", name: "Sinazongwe District" },
    { code: "ZM.07.910107", name: "Livingstone District" },
    { code: "ZM.07.915082", name: "Kalomo District" },
    { code: "ZM.07.917010", name: "Gwembe District" },
    { code: "ZM.07.917743", name: "Choma District" },
  ],
  "ZM.08": [
    { code: "ZM.08.10801768", name: "Lufwanyama" },
    { code: "ZM.08.8285557", name: "Masaiti District" },
    { code: "ZM.08.901339", name: "Ndola Rural District" },
    { code: "ZM.08.901342", name: "Ndola District" },
    { code: "ZM.08.905389", name: "Mufulira District" },
    { code: "ZM.08.9072524", name: "Mpongwe District" },
    { code: "ZM.08.909857", name: "Luanshya District" },
    { code: "ZM.08.911144", name: "Kitwe District" },
    { code: "ZM.08.914956", name: "Kalulushi District" },
    { code: "ZM.08.919006", name: "Chingola District" },
    { code: "ZM.08.919540", name: "Chililabombwe District" },
  ],
  "ZM.09": [
    { code: "ZM.09.10815852", name: "Chirundu District" },
    { code: "ZM.09.10815853", name: "Shibuyunji District" },
    { code: "ZM.09.10815854", name: "Chilanga District" },
    { code: "ZM.09.10815855", name: "Rufunsa District" },
    { code: "ZM.09.7671220", name: "Kafue district" },
    { code: "ZM.09.7910080", name: "Chongwe District" },
    { code: "ZM.09.909134", name: "Lusaka District" },
    { code: "ZM.09.909886", name: "Luangwa District" },
  ],
  "ZM.10": [
    { code: "ZM.10.11169206", name: "Mafinga" },
    { code: "ZM.10.11169207", name: "Nakonde" },
    { code: "ZM.10.11169209", name: "Shiwang’andu District" },
    { code: "ZM.10.905843", name: "Mpika District" },
    { code: "ZM.10.916666", name: "Isoka District" },
    { code: "ZM.10.918903", name: "Chinsali District" },
    { code: "ZM.10.920896", name: "Chama District" },
  ],
  "ZW.01": [
    { code: "ZW.01.11204515", name: "Mossurize District" },
    { code: "ZW.01.883480", name: "Nyanga District" },
    { code: "ZW.01.884977", name: "Mutasa District" },
    { code: "ZW.01.884978", name: "Mutare District" },
    { code: "ZW.01.887718", name: "Makoni District" },
    { code: "ZW.01.893548", name: "Chipinge District" },
    { code: "ZW.01.893811", name: "Chimanimani District" },
    { code: "ZW.01.894711", name: "Buhera District" },
  ],
  "ZW.02": [
    { code: "ZW.02.8260609", name: "Gokwe South District" },
    { code: "ZW.02.878548", name: "Zvishavane District" },
    { code: "ZW.02.881163", name: "Shurugwi District" },
    { code: "ZW.02.886328", name: "Mberengwa District" },
    { code: "ZW.02.888708", name: "Kwekwe District" },
    { code: "ZW.02.890420", name: "Gweru District" },
    { code: "ZW.02.890981", name: "Gokwe North District" },
    { code: "ZW.02.893405", name: "Chirumanzu District" },
  ],
  "ZW.03": [
    { code: "ZW.03.881344", name: "Shamva District" },
    { code: "ZW.03.882083", name: "Rushinga District" },
    { code: "ZW.03.886383", name: "Mazowe District" },
    { code: "ZW.03.890599", name: "Guruve District" },
    { code: "ZW.03.892597", name: "Mount Darwin" },
    { code: "ZW.03.894459", name: "Centenary District" },
    { code: "ZW.03.895060", name: "Bindura District" },
  ],
  "ZW.04": [
    { code: "ZW.04.10800411", name: "Uzumba-Maramba-Pfungwe District" },
    { code: "ZW.04.879178", name: "Hwedza District" },
    { code: "ZW.04.881519", name: "Seke District" },
    { code: "ZW.04.884926", name: "Mutoko District" },
    { code: "ZW.04.885172", name: "Murehwa District" },
    { code: "ZW.04.885457", name: "Mudzi District" },
    { code: "ZW.04.886989", name: "Marondera District" },
    { code: "ZW.04.890848", name: "Goromonzi District" },
    { code: "ZW.04.894293", name: "Chikomba District" },
  ],
  "ZW.05": [
    { code: "ZW.05.10800410", name: "Zvimba District" },
    { code: "ZW.05.887723", name: "Makonde District" },
    { code: "ZW.05.889214", name: "Kariba District" },
    { code: "ZW.05.889452", name: "Kadoma District" },
    { code: "ZW.05.889953", name: "Hurungwe District" },
    { code: "ZW.05.894238", name: "Chegutu District" },
  ],
  "ZW.06": [
    { code: "ZW.06.10800412", name: "Umguza District" },
    { code: "ZW.06.883763", name: "Tsholotsho District" },
    { code: "ZW.06.884216", name: "Nkayi District" },
    { code: "ZW.06.888223", name: "Lupane District" },
    { code: "ZW.06.889941", name: "Hwange District" },
    { code: "ZW.06.894741", name: "Bubi District" },
    { code: "ZW.06.895055", name: "Binga District" },
  ],
  "ZW.07": [
    { code: "ZW.07.10800403", name: "Bulilima District" },
    { code: "ZW.07.879611", name: "Umzingwane District" },
    { code: "ZW.07.886636", name: "Matobo" },
    { code: "ZW.07.889793", name: "Insiza District" },
    { code: "ZW.07.890515", name: "Gwanda District" },
    { code: "ZW.07.894702", name: "Mangwe District" },
    { code: "ZW.07.895268", name: "Beitbridge District" },
  ],
  "ZW.08": [
    { code: "ZW.08.10172877", name: "Zaka District" },
    { code: "ZW.08.884594", name: "Zaka" },
    { code: "ZW.08.884756", name: "Mwenezi District" },
    { code: "ZW.08.886762", name: "Masvingo District" },
    { code: "ZW.08.890589", name: "Gutu District" },
    { code: "ZW.08.893171", name: "Chivi District" },
    { code: "ZW.08.893482", name: "Chiredzi District" },
    { code: "ZW.08.895080", name: "Bikita District" },
  ],
  "ZW.09": [
    { code: "ZW.09.894700", name: "Bulawayo District" },
  ],
  "ZW.10": [
    { code: "ZW.10.890298", name: "Harare District" },
  ],
};